var _CalRGBCS, _document$currentScri, _GlobalImageCache, _OperatorList, _CipherTransformFactory, _StructTreeRoot;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(codePointIter),
  _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(getContainedChildren);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n112 = 0, F = function F() {}; return { s: F, n: function n() { return _n112 >= r.length ? { done: !0 } : { done: !1, value: r[_n112++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classPrivateFieldLooseBase(e, t) { if (!{}.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance"); return e; }
var id = 0;
function _classPrivateFieldLooseKey(e) { return "__private_" + id++ + "_" + e; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2024 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */
var e = {
    d: function d(t, i) {
      for (var a in i) e.o(i, a) && !e.o(t, a) && Object.defineProperty(t, a, {
        enumerable: !0,
        get: i[a]
      });
    },
    o: function o(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }
  },
  __webpack_exports__ = globalThis.pdfjsWorker = {};
e.d(__webpack_exports__, {
  WorkerMessageHandler: function WorkerMessageHandler() {
    return _WorkerMessageHandler;
  }
});
var t = !("object" != (typeof process === "undefined" ? "undefined" : _typeof(process)) || process + "" != "[object process]" || process.versions.nw || process.versions.electron && process.type && "browser" !== process.type),
  i = [1, 0, 0, 1, 0, 0],
  a = [.001, 0, 0, .001, 0, 0],
  s = 1.35,
  r = .35,
  n = .25925925925925924,
  g = 1,
  o = 2,
  c = 4,
  C = 8,
  h = 16,
  l = 64,
  Q = 128,
  E = 256,
  u = "pdfjs_internal_editor_",
  d = 3,
  f = 9,
  p = 13,
  m = 15,
  y = {
    PRINT: 4,
    MODIFY_CONTENTS: 8,
    COPY: 16,
    MODIFY_ANNOTATIONS: 32,
    FILL_INTERACTIVE_FORMS: 256,
    COPY_FOR_ACCESSIBILITY: 512,
    ASSEMBLE: 1024,
    PRINT_HIGH_QUALITY: 2048
  },
  w = 0,
  D = 4,
  b = 1,
  F = 2,
  S = 3,
  k = 1,
  R = 2,
  N = 3,
  G = 4,
  x = 5,
  U = 6,
  M = 7,
  L = 8,
  H = 9,
  J = 10,
  Y = 11,
  v = 12,
  K = 13,
  T = 14,
  q = 15,
  O = 16,
  W = 17,
  j = 20,
  X = "Group",
  Z = "R",
  V = 1,
  z = 2,
  _ = 4,
  $ = 16,
  AA = 32,
  eA = 128,
  tA = 512,
  iA = 1,
  aA = 2,
  sA = 4096,
  rA = 8192,
  nA = 32768,
  gA = 65536,
  oA = 131072,
  IA = 1048576,
  cA = 2097152,
  CA = 8388608,
  hA = 16777216,
  lA = 1,
  BA = 2,
  QA = 3,
  EA = 4,
  uA = 5,
  dA = {
    E: "Mouse Enter",
    X: "Mouse Exit",
    D: "Mouse Down",
    U: "Mouse Up",
    Fo: "Focus",
    Bl: "Blur",
    PO: "PageOpen",
    PC: "PageClose",
    PV: "PageVisible",
    PI: "PageInvisible",
    K: "Keystroke",
    F: "Format",
    V: "Validate",
    C: "Calculate"
  },
  fA = {
    WC: "WillClose",
    WS: "WillSave",
    DS: "DidSave",
    WP: "WillPrint",
    DP: "DidPrint"
  },
  pA = {
    O: "PageOpen",
    C: "PageClose"
  },
  mA = {
    ERRORS: 0,
    WARNINGS: 1,
    INFOS: 5
  },
  yA = 1,
  wA = 2,
  DA = 3,
  bA = 4,
  FA = 5,
  SA = 6,
  kA = 7,
  RA = 8,
  NA = 9,
  GA = 10,
  xA = 11,
  UA = 12,
  MA = 13,
  LA = 14,
  HA = 15,
  JA = 16,
  YA = 17,
  vA = 18,
  KA = 19,
  TA = 20,
  qA = 21,
  OA = 22,
  PA = 23,
  WA = 24,
  jA = 25,
  XA = 26,
  ZA = 27,
  VA = 28,
  zA = 29,
  _A = 30,
  $A = 31,
  Ae = 32,
  ee = 33,
  te = 34,
  ie = 35,
  ae = 36,
  se = 37,
  re = 38,
  ne = 39,
  ge = 40,
  oe = 41,
  Ie = 42,
  ce = 43,
  Ce = 44,
  he = 45,
  le = 46,
  Be = 47,
  Qe = 48,
  Ee = 49,
  ue = 50,
  de = 51,
  fe = 52,
  pe = 53,
  me = 54,
  ye = 55,
  we = 56,
  De = 57,
  be = 58,
  Fe = 59,
  Se = 60,
  ke = 61,
  Re = 62,
  Ne = 63,
  Ge = 64,
  xe = 65,
  Ue = 66,
  Me = 67,
  Le = 68,
  He = 69,
  Je = 70,
  Ye = 71,
  ve = 72,
  Ke = 73,
  Te = 74,
  qe = 75,
  Oe = 76,
  Pe = 77,
  We = 80,
  je = 81,
  Xe = 83,
  Ze = 84,
  Ve = 85,
  ze = 86,
  _e = 87,
  $e = 88,
  At = 89,
  et = 90,
  tt = 91,
  it = 92,
  at = 93,
  st = 1,
  rt = 2;
var nt = mA.WARNINGS;
function getVerbosityLevel() {
  return nt;
}
function info(e) {
  nt >= mA.INFOS && console.log("Info: ".concat(e));
}
function warn(e) {
  nt >= mA.WARNINGS && console.log("Warning: ".concat(e));
}
function unreachable(e) {
  throw new Error(e);
}
function assert(e, t) {
  e || unreachable(t);
}
function createValidAbsoluteUrl(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!e) return null;
  try {
    if (i && "string" == typeof e) {
      if (i.addDefaultProtocol && e.startsWith("www.")) {
        var _t2 = e.match(/\./g);
        (_t2 === null || _t2 === void 0 ? void 0 : _t2.length) >= 2 && (e = "http://".concat(e));
      }
      if (i.tryConvertEncoding) try {
        e = stringToUTF8String(e);
      } catch (_unused) {}
    }
    var _a2 = t ? new URL(e, t) : new URL(e);
    if (function _isValidProtocol(e) {
      switch (e === null || e === void 0 ? void 0 : e.protocol) {
        case "http:":
        case "https:":
        case "ftp:":
        case "mailto:":
        case "tel:":
          return !0;
        default:
          return !1;
      }
    }(_a2)) return _a2;
  } catch (_unused2) {}
  return null;
}
function shadow(e, t, i) {
  var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  Object.defineProperty(e, t, {
    value: i,
    enumerable: !a,
    configurable: !0,
    writable: !1
  });
  return i;
}
var gt = function BaseExceptionClosure() {
  function BaseException(e, t) {
    this.message = e;
    this.name = t;
  }
  BaseException.prototype = new Error();
  BaseException.constructor = BaseException;
  return BaseException;
}();
var PasswordException = /*#__PURE__*/function (_gt) {
  function PasswordException(e, t) {
    var _this;
    _classCallCheck(this, PasswordException);
    _this = _callSuper(this, PasswordException, [e, "PasswordException"]);
    _this.code = t;
    return _this;
  }
  _inherits(PasswordException, _gt);
  return _createClass(PasswordException);
}(gt);
var UnknownErrorException = /*#__PURE__*/function (_gt2) {
  function UnknownErrorException(e, t) {
    var _this2;
    _classCallCheck(this, UnknownErrorException);
    _this2 = _callSuper(this, UnknownErrorException, [e, "UnknownErrorException"]);
    _this2.details = t;
    return _this2;
  }
  _inherits(UnknownErrorException, _gt2);
  return _createClass(UnknownErrorException);
}(gt);
var InvalidPDFException = /*#__PURE__*/function (_gt3) {
  function InvalidPDFException(e) {
    _classCallCheck(this, InvalidPDFException);
    return _callSuper(this, InvalidPDFException, [e, "InvalidPDFException"]);
  }
  _inherits(InvalidPDFException, _gt3);
  return _createClass(InvalidPDFException);
}(gt);
var MissingPDFException = /*#__PURE__*/function (_gt4) {
  function MissingPDFException(e) {
    _classCallCheck(this, MissingPDFException);
    return _callSuper(this, MissingPDFException, [e, "MissingPDFException"]);
  }
  _inherits(MissingPDFException, _gt4);
  return _createClass(MissingPDFException);
}(gt);
var UnexpectedResponseException = /*#__PURE__*/function (_gt5) {
  function UnexpectedResponseException(e, t) {
    var _this3;
    _classCallCheck(this, UnexpectedResponseException);
    _this3 = _callSuper(this, UnexpectedResponseException, [e, "UnexpectedResponseException"]);
    _this3.status = t;
    return _this3;
  }
  _inherits(UnexpectedResponseException, _gt5);
  return _createClass(UnexpectedResponseException);
}(gt);
var FormatError = /*#__PURE__*/function (_gt6) {
  function FormatError(e) {
    _classCallCheck(this, FormatError);
    return _callSuper(this, FormatError, [e, "FormatError"]);
  }
  _inherits(FormatError, _gt6);
  return _createClass(FormatError);
}(gt);
var AbortException = /*#__PURE__*/function (_gt7) {
  function AbortException(e) {
    _classCallCheck(this, AbortException);
    return _callSuper(this, AbortException, [e, "AbortException"]);
  }
  _inherits(AbortException, _gt7);
  return _createClass(AbortException);
}(gt);
function bytesToString(e) {
  "object" == _typeof(e) && void 0 !== (e === null || e === void 0 ? void 0 : e.length) || unreachable("Invalid argument for bytesToString");
  var t = e.length,
    i = 8192;
  if (t < i) return String.fromCharCode.apply(null, e);
  var a = [];
  for (var _s2 = 0; _s2 < t; _s2 += i) {
    var _r2 = Math.min(_s2 + i, t),
      _n2 = e.subarray(_s2, _r2);
    a.push(String.fromCharCode.apply(null, _n2));
  }
  return a.join("");
}
function stringToBytes(e) {
  "string" != typeof e && unreachable("Invalid argument for stringToBytes");
  var t = e.length,
    i = new Uint8Array(t);
  for (var _a3 = 0; _a3 < t; ++_a3) i[_a3] = 255 & e.charCodeAt(_a3);
  return i;
}
function string32(e) {
  return String.fromCharCode(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, 255 & e);
}
function objectSize(e) {
  return Object.keys(e).length;
}
var FeatureTest = /*#__PURE__*/function () {
  function FeatureTest() {
    _classCallCheck(this, FeatureTest);
  }
  return _createClass(FeatureTest, null, [{
    key: "isLittleEndian",
    get: function get() {
      return shadow(this, "isLittleEndian", function isLittleEndian() {
        var e = new Uint8Array(4);
        e[0] = 1;
        return 1 === new Uint32Array(e.buffer, 0, 1)[0];
      }());
    }
  }, {
    key: "isEvalSupported",
    get: function get() {
      return shadow(this, "isEvalSupported", function isEvalSupported() {
        try {
          new Function("");
          return !0;
        } catch (_unused3) {
          return !1;
        }
      }());
    }
  }, {
    key: "isOffscreenCanvasSupported",
    get: function get() {
      return shadow(this, "isOffscreenCanvasSupported", "undefined" != typeof OffscreenCanvas);
    }
  }, {
    key: "platform",
    get: function get() {
      var _navigator, _navigator2;
      return "undefined" != typeof navigator && "string" == typeof ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.platform) ? shadow(this, "platform", {
        isMac: navigator.platform.includes("Mac"),
        isWindows: navigator.platform.includes("Win"),
        isFirefox: "string" == typeof ((_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.userAgent) && navigator.userAgent.includes("Firefox")
      }) : shadow(this, "platform", {
        isMac: !1,
        isWindows: !1,
        isFirefox: !1
      });
    }
  }, {
    key: "isCSSRoundSupported",
    get: function get() {
      var _globalThis$CSS, _globalThis$CSS$suppo;
      return shadow(this, "isCSSRoundSupported", (_globalThis$CSS = globalThis.CSS) === null || _globalThis$CSS === void 0 || (_globalThis$CSS$suppo = _globalThis$CSS.supports) === null || _globalThis$CSS$suppo === void 0 ? void 0 : _globalThis$CSS$suppo.call(_globalThis$CSS, "width: round(1.5px, 1px)"));
    }
  }]);
}();
var ot = Array.from(Array(256).keys(), function (e) {
  return e.toString(16).padStart(2, "0");
});
var _A2 = /*#__PURE__*/_classPrivateFieldLooseKey("A");
var _e2 = /*#__PURE__*/_classPrivateFieldLooseKey("e");
var Util = /*#__PURE__*/function () {
  function Util() {
    _classCallCheck(this, Util);
  }
  return _createClass(Util, null, [{
    key: "makeHexColor",
    value: function makeHexColor(e, t, i) {
      return "#".concat(ot[e]).concat(ot[t]).concat(ot[i]);
    }
  }, {
    key: "scaleMinMax",
    value: function scaleMinMax(e, t) {
      var i;
      if (e[0]) {
        if (e[0] < 0) {
          i = t[0];
          t[0] = t[2];
          t[2] = i;
        }
        t[0] *= e[0];
        t[2] *= e[0];
        if (e[3] < 0) {
          i = t[1];
          t[1] = t[3];
          t[3] = i;
        }
        t[1] *= e[3];
        t[3] *= e[3];
      } else {
        i = t[0];
        t[0] = t[1];
        t[1] = i;
        i = t[2];
        t[2] = t[3];
        t[3] = i;
        if (e[1] < 0) {
          i = t[1];
          t[1] = t[3];
          t[3] = i;
        }
        t[1] *= e[1];
        t[3] *= e[1];
        if (e[2] < 0) {
          i = t[0];
          t[0] = t[2];
          t[2] = i;
        }
        t[0] *= e[2];
        t[2] *= e[2];
      }
      t[0] += e[4];
      t[1] += e[5];
      t[2] += e[4];
      t[3] += e[5];
    }
  }, {
    key: "transform",
    value: function transform(e, t) {
      return [e[0] * t[0] + e[2] * t[1], e[1] * t[0] + e[3] * t[1], e[0] * t[2] + e[2] * t[3], e[1] * t[2] + e[3] * t[3], e[0] * t[4] + e[2] * t[5] + e[4], e[1] * t[4] + e[3] * t[5] + e[5]];
    }
  }, {
    key: "applyTransform",
    value: function applyTransform(e, t) {
      return [e[0] * t[0] + e[1] * t[2] + t[4], e[0] * t[1] + e[1] * t[3] + t[5]];
    }
  }, {
    key: "applyInverseTransform",
    value: function applyInverseTransform(e, t) {
      var i = t[0] * t[3] - t[1] * t[2];
      return [(e[0] * t[3] - e[1] * t[2] + t[2] * t[5] - t[4] * t[3]) / i, (-e[0] * t[1] + e[1] * t[0] + t[4] * t[1] - t[5] * t[0]) / i];
    }
  }, {
    key: "getAxialAlignedBoundingBox",
    value: function getAxialAlignedBoundingBox(e, t) {
      var i = this.applyTransform(e, t),
        a = this.applyTransform(e.slice(2, 4), t),
        s = this.applyTransform([e[0], e[3]], t),
        r = this.applyTransform([e[2], e[1]], t);
      return [Math.min(i[0], a[0], s[0], r[0]), Math.min(i[1], a[1], s[1], r[1]), Math.max(i[0], a[0], s[0], r[0]), Math.max(i[1], a[1], s[1], r[1])];
    }
  }, {
    key: "inverseTransform",
    value: function inverseTransform(e) {
      var t = e[0] * e[3] - e[1] * e[2];
      return [e[3] / t, -e[1] / t, -e[2] / t, e[0] / t, (e[2] * e[5] - e[4] * e[3]) / t, (e[4] * e[1] - e[5] * e[0]) / t];
    }
  }, {
    key: "singularValueDecompose2dScale",
    value: function singularValueDecompose2dScale(e) {
      var t = [e[0], e[2], e[1], e[3]],
        i = e[0] * t[0] + e[1] * t[2],
        a = e[0] * t[1] + e[1] * t[3],
        s = e[2] * t[0] + e[3] * t[2],
        r = e[2] * t[1] + e[3] * t[3],
        n = (i + r) / 2,
        g = Math.sqrt(Math.pow(i + r, 2) - 4 * (i * r - s * a)) / 2,
        o = n + g || 1,
        c = n - g || 1;
      return [Math.sqrt(o), Math.sqrt(c)];
    }
  }, {
    key: "normalizeRect",
    value: function normalizeRect(e) {
      var t = e.slice(0);
      if (e[0] > e[2]) {
        t[0] = e[2];
        t[2] = e[0];
      }
      if (e[1] > e[3]) {
        t[1] = e[3];
        t[3] = e[1];
      }
      return t;
    }
  }, {
    key: "intersect",
    value: function intersect(e, t) {
      var i = Math.max(Math.min(e[0], e[2]), Math.min(t[0], t[2])),
        a = Math.min(Math.max(e[0], e[2]), Math.max(t[0], t[2]));
      if (i > a) return null;
      var s = Math.max(Math.min(e[1], e[3]), Math.min(t[1], t[3])),
        r = Math.min(Math.max(e[1], e[3]), Math.max(t[1], t[3]));
      return s > r ? null : [i, s, a, r];
    }
  }, {
    key: "bezierBoundingBox",
    value: function bezierBoundingBox(e, t, i, a, s, r, n, g, o) {
      if (o) {
        o[0] = Math.min(o[0], e, n);
        o[1] = Math.min(o[1], t, g);
        o[2] = Math.max(o[2], e, n);
        o[3] = Math.max(o[3], t, g);
      } else o = [Math.min(e, n), Math.min(t, g), Math.max(e, n), Math.max(t, g)];
      _classPrivateFieldLooseBase(this, _e2)[_e2](e, i, s, n, t, a, r, g, 3 * (3 * (i - s) - e + n), 6 * (e - 2 * i + s), 3 * (i - e), o);
      _classPrivateFieldLooseBase(this, _e2)[_e2](e, i, s, n, t, a, r, g, 3 * (3 * (a - r) - t + g), 6 * (t - 2 * a + r), 3 * (a - t), o);
      return o;
    }
  }]);
}();
function _A3(e, t, i, a, s, r, n, g, o, c) {
  if (o <= 0 || o >= 1) return;
  var C = 1 - o,
    h = o * o,
    l = h * o,
    Q = C * (C * (C * e + 3 * o * t) + 3 * h * i) + l * a,
    E = C * (C * (C * s + 3 * o * r) + 3 * h * n) + l * g;
  c[0] = Math.min(c[0], Q);
  c[1] = Math.min(c[1], E);
  c[2] = Math.max(c[2], Q);
  c[3] = Math.max(c[3], E);
}
function _e3(e, t, i, a, s, r, n, g, o, c, C, h) {
  if (Math.abs(o) < 1e-12) {
    Math.abs(c) >= 1e-12 && _classPrivateFieldLooseBase(this, _A2)[_A2](e, t, i, a, s, r, n, g, -C / c, h);
    return;
  }
  var l = Math.pow(c, 2) - 4 * C * o;
  if (l < 0) return;
  var Q = Math.sqrt(l),
    E = 2 * o;
  _classPrivateFieldLooseBase(this, _A2)[_A2](e, t, i, a, s, r, n, g, (-c + Q) / E, h);
  _classPrivateFieldLooseBase(this, _A2)[_A2](e, t, i, a, s, r, n, g, (-c - Q) / E, h);
}
Object.defineProperty(Util, _e2, {
  value: _e3
});
Object.defineProperty(Util, _A2, {
  value: _A3
});
var It = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
function stringToPDFString(e) {
  if (e[0] >= "ï") {
    var _t3;
    if ("þ" === e[0] && "ÿ" === e[1]) {
      _t3 = "utf-16be";
      e.length % 2 == 1 && (e = e.slice(0, -1));
    } else if ("ÿ" === e[0] && "þ" === e[1]) {
      _t3 = "utf-16le";
      e.length % 2 == 1 && (e = e.slice(0, -1));
    } else "ï" === e[0] && "»" === e[1] && "¿" === e[2] && (_t3 = "utf-8");
    if (_t3) try {
      var _i2 = new TextDecoder(_t3, {
          fatal: !0
        }),
        _a4 = stringToBytes(e),
        _s3 = _i2.decode(_a4);
      return _s3.includes("") ? _s3.replaceAll(/\x1b[^\x1b]*(?:\x1b|$)/g, "") : _s3;
    } catch (e) {
      warn("stringToPDFString: \"".concat(e, "\"."));
    }
  }
  var t = [];
  for (var _i3 = 0, _a5 = e.length; _i3 < _a5; _i3++) {
    var _s4 = e.charCodeAt(_i3);
    if (27 === _s4) {
      for (; ++_i3 < _a5 && 27 !== e.charCodeAt(_i3););
      continue;
    }
    var _r3 = It[_s4];
    t.push(_r3 ? String.fromCharCode(_r3) : e.charAt(_i3));
  }
  return t.join("");
}
function stringToUTF8String(e) {
  return decodeURIComponent(escape(e));
}
function utf8StringToString(e) {
  return unescape(encodeURIComponent(e));
}
function isArrayEqual(e, t) {
  if (e.length !== t.length) return !1;
  for (var _i4 = 0, _a6 = e.length; _i4 < _a6; _i4++) if (e[_i4] !== t[_i4]) return !1;
  return !0;
}
function getModificationDate() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  return [e.getUTCFullYear().toString(), (e.getUTCMonth() + 1).toString().padStart(2, "0"), e.getUTCDate().toString().padStart(2, "0"), e.getUTCHours().toString().padStart(2, "0"), e.getUTCMinutes().toString().padStart(2, "0"), e.getUTCSeconds().toString().padStart(2, "0")].join("");
}
var ct = null,
  Ct = null;
var ht = 0,
  lt = 1,
  Bt = 2,
  Qt = 3,
  Et = 4,
  ut = 5,
  dt = 6,
  ft = 7,
  pt = 8;
function toHexUtil(e) {
  return Uint8Array.prototype.toHex ? e.toHex() : Array.from(e, function (e) {
    return ot[e];
  }).join("");
}
var mt = Symbol("CIRCULAR_REF"),
  yt = Symbol("EOF");
var wt = Object.create(null),
  Dt = Object.create(null),
  bt = Object.create(null);
var Name = /*#__PURE__*/function () {
  function Name(e) {
    _classCallCheck(this, Name);
    this.name = e;
  }
  return _createClass(Name, null, [{
    key: "get",
    value: function get(e) {
      var _Dt;
      return (_Dt = Dt)[e] || (_Dt[e] = new Name(e));
    }
  }]);
}();
var Cmd = /*#__PURE__*/function () {
  function Cmd(e) {
    _classCallCheck(this, Cmd);
    this.cmd = e;
  }
  return _createClass(Cmd, null, [{
    key: "get",
    value: function get(e) {
      var _wt;
      return (_wt = wt)[e] || (_wt[e] = new Cmd(e));
    }
  }]);
}();
var Ft = function nonSerializableClosure() {
  return Ft;
};
var Dict = /*#__PURE__*/function () {
  function Dict() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    _classCallCheck(this, Dict);
    this._map = Object.create(null);
    this.xref = e;
    this.objId = null;
    this.suppressEncryption = !1;
    this.__nonSerializable__ = Ft;
  }
  return _createClass(Dict, [{
    key: "assignXref",
    value: function assignXref(e) {
      this.xref = e;
    }
  }, {
    key: "size",
    get: function get() {
      return Object.keys(this._map).length;
    }
  }, {
    key: "get",
    value: function get(e, t, i) {
      var a = this._map[e];
      if (void 0 === a && void 0 !== t) {
        a = this._map[t];
        void 0 === a && void 0 !== i && (a = this._map[i]);
      }
      return a instanceof Ref && this.xref ? this.xref.fetch(a, this.suppressEncryption) : a;
    }
  }, {
    key: "getAsync",
    value: function () {
      var _getAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e, t, i) {
        var a;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              a = this._map[e];
              if (void 0 === a && void 0 !== t) {
                a = this._map[t];
                void 0 === a && void 0 !== i && (a = this._map[i]);
              }
              return _context.abrupt("return", a instanceof Ref && this.xref ? this.xref.fetchAsync(a, this.suppressEncryption) : a);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getAsync(_x, _x2, _x3) {
        return _getAsync.apply(this, arguments);
      }
      return getAsync;
    }()
  }, {
    key: "getArray",
    value: function getArray(e, t, i) {
      var a = this._map[e];
      if (void 0 === a && void 0 !== t) {
        a = this._map[t];
        void 0 === a && void 0 !== i && (a = this._map[i]);
      }
      a instanceof Ref && this.xref && (a = this.xref.fetch(a, this.suppressEncryption));
      if (Array.isArray(a)) {
        a = a.slice();
        for (var _e4 = 0, _t4 = a.length; _e4 < _t4; _e4++) a[_e4] instanceof Ref && this.xref && (a[_e4] = this.xref.fetch(a[_e4], this.suppressEncryption));
      }
      return a;
    }
  }, {
    key: "getRaw",
    value: function getRaw(e) {
      return this._map[e];
    }
  }, {
    key: "getKeys",
    value: function getKeys() {
      return Object.keys(this._map);
    }
  }, {
    key: "getRawValues",
    value: function getRawValues() {
      return Object.values(this._map);
    }
  }, {
    key: "set",
    value: function set(e, t) {
      this._map[e] = t;
    }
  }, {
    key: "has",
    value: function has(e) {
      return void 0 !== this._map[e];
    }
  }, {
    key: "forEach",
    value: function forEach(e) {
      for (var _t5 in this._map) e(_t5, this.get(_t5));
    }
  }, {
    key: "clone",
    value: function clone() {
      var e = new Dict(this.xref);
      var _iterator2 = _createForOfIteratorHelper(this.getKeys()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _t6 = _step2.value;
          e.set(_t6, this.getRaw(_t6));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return e;
    }
  }, {
    key: "delete",
    value: function _delete(e) {
      delete this._map[e];
    }
  }], [{
    key: "empty",
    get: function get() {
      var e = new Dict(null);
      e.set = function (e, t) {
        unreachable("Should not call `set` on the empty dictionary.");
      };
      return shadow(this, "empty", e);
    }
  }, {
    key: "merge",
    value: function merge(_ref) {
      var e = _ref.xref,
        t = _ref.dictArray,
        _ref$mergeSubDicts = _ref.mergeSubDicts,
        i = _ref$mergeSubDicts === void 0 ? !1 : _ref$mergeSubDicts;
      var a = new Dict(e),
        s = new Map();
      var _iterator3 = _createForOfIteratorHelper(t),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _e5 = _step3.value;
          if (_e5 instanceof Dict) for (var _i5 = 0, _Object$entries = Object.entries(_e5._map); _i5 < _Object$entries.length; _i5++) {
            var _ref4 = _Object$entries[_i5];
            var _ref5 = _slicedToArray(_ref4, 2);
            var _t7 = _ref5[0];
            var _a7 = _ref5[1];
            {
              var _e6 = s.get(_t7);
              if (void 0 === _e6) {
                _e6 = [];
                s.set(_t7, _e6);
              } else if (!(i && _a7 instanceof Dict)) continue;
              _e6.push(_a7);
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var _iterator4 = _createForOfIteratorHelper(s),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _ref2 = _step4.value;
          var _ref3 = _slicedToArray(_ref2, 2);
          var _t8 = _ref3[0];
          var _i6 = _ref3[1];
          {
            if (1 === _i6.length || !(_i6[0] instanceof Dict)) {
              a._map[_t8] = _i6[0];
              continue;
            }
            var _s5 = new Dict(e);
            var _iterator5 = _createForOfIteratorHelper(_i6),
              _step5;
            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var _e7 = _step5.value;
                for (var _i7 = 0, _Object$entries2 = Object.entries(_e7._map); _i7 < _Object$entries2.length; _i7++) {
                  var _ref6 = _Object$entries2[_i7];
                  var _ref7 = _slicedToArray(_ref6, 2);
                  var _t9 = _ref7[0];
                  var _i8 = _ref7[1];
                  void 0 === _s5._map[_t9] && (_s5._map[_t9] = _i8);
                }
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
            _s5.size > 0 && (a._map[_t8] = _s5);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      s.clear();
      return a.size > 0 ? a : Dict.empty;
    }
  }]);
}();
var Ref = /*#__PURE__*/function () {
  function Ref(e, t) {
    _classCallCheck(this, Ref);
    this.num = e;
    this.gen = t;
  }
  return _createClass(Ref, [{
    key: "toString",
    value: function toString() {
      return 0 === this.gen ? "".concat(this.num, "R") : "".concat(this.num, "R").concat(this.gen);
    }
  }], [{
    key: "fromString",
    value: function fromString(e) {
      var t = bt[e];
      if (t) return t;
      var i = /^(\d+)R(\d*)$/.exec(e);
      return i && "0" !== i[1] ? bt[e] = new Ref(parseInt(i[1]), i[2] ? parseInt(i[2]) : 0) : null;
    }
  }, {
    key: "get",
    value: function get(e, t) {
      var _bt;
      var i = 0 === t ? "".concat(e, "R") : "".concat(e, "R").concat(t);
      return (_bt = bt)[i] || (_bt[i] = new Ref(e, t));
    }
  }]);
}();
var RefSet = /*#__PURE__*/function () {
  function RefSet() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    _classCallCheck(this, RefSet);
    this._set = new Set(e === null || e === void 0 ? void 0 : e._set);
  }
  return _createClass(RefSet, [{
    key: "has",
    value: function has(e) {
      return this._set.has(e.toString());
    }
  }, {
    key: "put",
    value: function put(e) {
      this._set.add(e.toString());
    }
  }, {
    key: "remove",
    value: function remove(e) {
      this._set.delete(e.toString());
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this._set.values();
    }
  }, {
    key: "clear",
    value: function clear() {
      this._set.clear();
    }
  }]);
}();
var RefSetCache = /*#__PURE__*/function () {
  function RefSetCache() {
    _classCallCheck(this, RefSetCache);
    this._map = new Map();
  }
  return _createClass(RefSetCache, [{
    key: "size",
    get: function get() {
      return this._map.size;
    }
  }, {
    key: "get",
    value: function get(e) {
      return this._map.get(e.toString());
    }
  }, {
    key: "has",
    value: function has(e) {
      return this._map.has(e.toString());
    }
  }, {
    key: "put",
    value: function put(e, t) {
      this._map.set(e.toString(), t);
    }
  }, {
    key: "putAlias",
    value: function putAlias(e, t) {
      this._map.set(e.toString(), this.get(t));
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this._map.values();
    }
  }, {
    key: "clear",
    value: function clear() {
      this._map.clear();
    }
  }, {
    key: "items",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function items() {
      var _iterator6, _step6, _ref8, _ref9, _e8, _t10;
      return _regeneratorRuntime().wrap(function items$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _iterator6 = _createForOfIteratorHelper(this._map);
            _context2.prev = 1;
            _iterator6.s();
          case 3:
            if ((_step6 = _iterator6.n()).done) {
              _context2.next = 12;
              break;
            }
            _ref8 = _step6.value;
            _ref9 = _slicedToArray(_ref8, 2);
            _e8 = _ref9[0];
            _t10 = _ref9[1];
            _context2.next = 10;
            return [Ref.fromString(_e8), _t10];
          case 10:
            _context2.next = 3;
            break;
          case 12:
            _context2.next = 17;
            break;
          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](1);
            _iterator6.e(_context2.t0);
          case 17:
            _context2.prev = 17;
            _iterator6.f();
            return _context2.finish(17);
          case 20:
          case "end":
            return _context2.stop();
        }
      }, items, this, [[1, 14, 17, 20]]);
    })
  }]);
}();
function isName(e, t) {
  return e instanceof Name && (void 0 === t || e.name === t);
}
function isCmd(e, t) {
  return e instanceof Cmd && (void 0 === t || e.cmd === t);
}
function isDict(e, t) {
  return e instanceof Dict && (void 0 === t || isName(e.get("Type"), t));
}
function isRefsEqual(e, t) {
  return e.num === t.num && e.gen === t.gen;
}
var BaseStream = /*#__PURE__*/function () {
  function BaseStream() {
    _classCallCheck(this, BaseStream);
  }
  return _createClass(BaseStream, [{
    key: "length",
    get: function get() {
      unreachable("Abstract getter `length` accessed");
    }
  }, {
    key: "isEmpty",
    get: function get() {
      unreachable("Abstract getter `isEmpty` accessed");
    }
  }, {
    key: "isDataLoaded",
    get: function get() {
      return shadow(this, "isDataLoaded", !0);
    }
  }, {
    key: "getByte",
    value: function getByte() {
      unreachable("Abstract method `getByte` called");
    }
  }, {
    key: "getBytes",
    value: function getBytes(e) {
      unreachable("Abstract method `getBytes` called");
    }
  }, {
    key: "getImageData",
    value: function () {
      var _getImageData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e, t) {
        return _regeneratorRuntime().wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.getBytes(e, t));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this);
      }));
      function getImageData(_x4, _x5) {
        return _getImageData.apply(this, arguments);
      }
      return getImageData;
    }()
  }, {
    key: "asyncGetBytes",
    value: function () {
      var _asyncGetBytes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              unreachable("Abstract method `asyncGetBytes` called");
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee3);
      }));
      function asyncGetBytes() {
        return _asyncGetBytes.apply(this, arguments);
      }
      return asyncGetBytes;
    }()
  }, {
    key: "isAsync",
    get: function get() {
      return !1;
    }
  }, {
    key: "canAsyncDecodeImageFromBuffer",
    get: function get() {
      return !1;
    }
  }, {
    key: "getTransferableImage",
    value: function () {
      var _getTransferableImage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", null);
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee4);
      }));
      function getTransferableImage() {
        return _getTransferableImage.apply(this, arguments);
      }
      return getTransferableImage;
    }()
  }, {
    key: "peekByte",
    value: function peekByte() {
      var e = this.getByte();
      -1 !== e && this.pos--;
      return e;
    }
  }, {
    key: "peekBytes",
    value: function peekBytes(e) {
      var t = this.getBytes(e);
      this.pos -= t.length;
      return t;
    }
  }, {
    key: "getUint16",
    value: function getUint16() {
      var e = this.getByte(),
        t = this.getByte();
      return -1 === e || -1 === t ? -1 : (e << 8) + t;
    }
  }, {
    key: "getInt32",
    value: function getInt32() {
      return (this.getByte() << 24) + (this.getByte() << 16) + (this.getByte() << 8) + this.getByte();
    }
  }, {
    key: "getByteRange",
    value: function getByteRange(e, t) {
      unreachable("Abstract method `getByteRange` called");
    }
  }, {
    key: "getString",
    value: function getString(e) {
      return bytesToString(this.getBytes(e));
    }
  }, {
    key: "skip",
    value: function skip(e) {
      this.pos += e || 1;
    }
  }, {
    key: "reset",
    value: function reset() {
      unreachable("Abstract method `reset` called");
    }
  }, {
    key: "moveStart",
    value: function moveStart() {
      unreachable("Abstract method `moveStart` called");
    }
  }, {
    key: "makeSubStream",
    value: function makeSubStream(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      unreachable("Abstract method `makeSubStream` called");
    }
  }, {
    key: "getBaseStreams",
    value: function getBaseStreams() {
      return null;
    }
  }]);
}();
var St = /^[1-9]\.\d$/;
function getLookupTableFactory(e) {
  var t;
  return function () {
    if (e) {
      t = Object.create(null);
      e(t);
      e = null;
    }
    return t;
  };
}
var MissingDataException = /*#__PURE__*/function (_gt8) {
  function MissingDataException(e, t) {
    var _this4;
    _classCallCheck(this, MissingDataException);
    _this4 = _callSuper(this, MissingDataException, ["Missing data [".concat(e, ", ").concat(t, ")"), "MissingDataException"]);
    _this4.begin = e;
    _this4.end = t;
    return _this4;
  }
  _inherits(MissingDataException, _gt8);
  return _createClass(MissingDataException);
}(gt);
var ParserEOFException = /*#__PURE__*/function (_gt9) {
  function ParserEOFException(e) {
    _classCallCheck(this, ParserEOFException);
    return _callSuper(this, ParserEOFException, [e, "ParserEOFException"]);
  }
  _inherits(ParserEOFException, _gt9);
  return _createClass(ParserEOFException);
}(gt);
var XRefEntryException = /*#__PURE__*/function (_gt10) {
  function XRefEntryException(e) {
    _classCallCheck(this, XRefEntryException);
    return _callSuper(this, XRefEntryException, [e, "XRefEntryException"]);
  }
  _inherits(XRefEntryException, _gt10);
  return _createClass(XRefEntryException);
}(gt);
var XRefParseException = /*#__PURE__*/function (_gt11) {
  function XRefParseException(e) {
    _classCallCheck(this, XRefParseException);
    return _callSuper(this, XRefParseException, [e, "XRefParseException"]);
  }
  _inherits(XRefParseException, _gt11);
  return _createClass(XRefParseException);
}(gt);
function arrayBuffersToBytes(e) {
  var t = e.length;
  if (0 === t) return new Uint8Array(0);
  if (1 === t) return new Uint8Array(e[0]);
  var i = 0;
  for (var _a8 = 0; _a8 < t; _a8++) i += e[_a8].byteLength;
  var a = new Uint8Array(i);
  var s = 0;
  for (var _i9 = 0; _i9 < t; _i9++) {
    var _t11 = new Uint8Array(e[_i9]);
    a.set(_t11, s);
    s += _t11.byteLength;
  }
  return a;
}
function getInheritableProperty(_ref10) {
  var e = _ref10.dict,
    t = _ref10.key,
    _ref10$getArray = _ref10.getArray,
    i = _ref10$getArray === void 0 ? !1 : _ref10$getArray,
    _ref10$stopWhenFound = _ref10.stopWhenFound,
    a = _ref10$stopWhenFound === void 0 ? !0 : _ref10$stopWhenFound;
  var s;
  var r = new RefSet();
  for (; e instanceof Dict && (!e.objId || !r.has(e.objId));) {
    e.objId && r.put(e.objId);
    var _n3 = i ? e.getArray(t) : e.get(t);
    if (void 0 !== _n3) {
      if (a) return _n3;
      (s || (s = [])).push(_n3);
    }
    e = e.get("Parent");
  }
  return s;
}
var kt = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM", "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC", "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"];
function toRomanNumerals(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  assert(Number.isInteger(e) && e > 0, "The number should be a positive integer.");
  var i = [];
  var a;
  for (; e >= 1e3;) {
    e -= 1e3;
    i.push("M");
  }
  a = e / 100 | 0;
  e %= 100;
  i.push(kt[a]);
  a = e / 10 | 0;
  e %= 10;
  i.push(kt[10 + a]);
  i.push(kt[20 + e]);
  var s = i.join("");
  return t ? s.toLowerCase() : s;
}
function log2(e) {
  return e <= 0 ? 0 : Math.ceil(Math.log2(e));
}
function readInt8(e, t) {
  return e[t] << 24 >> 24;
}
function readUint16(e, t) {
  return e[t] << 8 | e[t + 1];
}
function readUint32(e, t) {
  return (e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3]) >>> 0;
}
function isWhiteSpace(e) {
  return 32 === e || 9 === e || 13 === e || 10 === e;
}
function isNumberArray(e, t) {
  return Array.isArray(e) ? (null === t || e.length === t) && e.every(function (e) {
    return "number" == typeof e;
  }) : ArrayBuffer.isView(e) && (0 === e.length || "number" == typeof e[0]) && (null === t || e.length === t);
}
function lookupMatrix(e, t) {
  return isNumberArray(e, 6) ? e : t;
}
function lookupRect(e, t) {
  return isNumberArray(e, 4) ? e : t;
}
function lookupNormalRect(e, t) {
  return isNumberArray(e, 4) ? Util.normalizeRect(e) : t;
}
function parseXFAPath(e) {
  var t = /(.+)\[(\d+)\]$/;
  return e.split(".").map(function (e) {
    var i = e.match(t);
    return i ? {
      name: i[1],
      pos: parseInt(i[2], 10)
    } : {
      name: e,
      pos: 0
    };
  });
}
function escapePDFName(e) {
  var t = [];
  var i = 0;
  for (var _a9 = 0, _s6 = e.length; _a9 < _s6; _a9++) {
    var _s7 = e.charCodeAt(_a9);
    if (_s7 < 33 || _s7 > 126 || 35 === _s7 || 40 === _s7 || 41 === _s7 || 60 === _s7 || 62 === _s7 || 91 === _s7 || 93 === _s7 || 123 === _s7 || 125 === _s7 || 47 === _s7 || 37 === _s7) {
      i < _a9 && t.push(e.substring(i, _a9));
      t.push("#".concat(_s7.toString(16)));
      i = _a9 + 1;
    }
  }
  if (0 === t.length) return e;
  i < e.length && t.push(e.substring(i, e.length));
  return t.join("");
}
function escapeString(e) {
  return e.replaceAll(/([()\\\n\r])/g, function (e) {
    return "\n" === e ? "\\n" : "\r" === e ? "\\r" : "\\".concat(e);
  });
}
function _collectJS(e, t, i, a) {
  if (!e) return;
  var s = null;
  if (e instanceof Ref) {
    if (a.has(e)) return;
    s = e;
    a.put(s);
    e = t.fetch(e);
  }
  if (Array.isArray(e)) {
    var _iterator7 = _createForOfIteratorHelper(e),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var _s8 = _step7.value;
        _collectJS(_s8, t, i, a);
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  } else if (e instanceof Dict) {
    if (isName(e.get("S"), "JavaScript")) {
      var _t12 = e.get("JS");
      var _a10;
      _t12 instanceof BaseStream ? _a10 = _t12.getString() : "string" == typeof _t12 && (_a10 = _t12);
      _a10 && (_a10 = stringToPDFString(_a10).replaceAll("\0", ""));
      _a10 && i.push(_a10);
    }
    _collectJS(e.getRaw("Next"), t, i, a);
  }
  s && a.remove(s);
}
function collectActions(e, t, i) {
  var a = Object.create(null),
    s = getInheritableProperty({
      dict: t,
      key: "AA",
      stopWhenFound: !1
    });
  if (s) for (var _t13 = s.length - 1; _t13 >= 0; _t13--) {
    var _r4 = s[_t13];
    if (_r4 instanceof Dict) {
      var _iterator8 = _createForOfIteratorHelper(_r4.getKeys()),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _t14 = _step8.value;
          var _s9 = i[_t14];
          if (!_s9) continue;
          var _n4 = [];
          _collectJS(_r4.getRaw(_t14), e, _n4, new RefSet());
          _n4.length > 0 && (a[_s9] = _n4);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }
  if (t.has("A")) {
    var _i10 = [];
    _collectJS(t.get("A"), e, _i10, new RefSet());
    _i10.length > 0 && (a.Action = _i10);
  }
  return objectSize(a) > 0 ? a : null;
}
var Rt = {
  60: "&lt;",
  62: "&gt;",
  38: "&amp;",
  34: "&quot;",
  39: "&apos;"
};
function codePointIter(e) {
  var _t15, _i11, _i12;
  return _regeneratorRuntime().wrap(function codePointIter$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        _t15 = 0, _i11 = e.length;
      case 1:
        if (!(_t15 < _i11)) {
          _context6.next = 9;
          break;
        }
        _i12 = e.codePointAt(_t15);
        _i12 > 55295 && (_i12 < 57344 || _i12 > 65533) && _t15++;
        _context6.next = 6;
        return _i12;
      case 6:
        _t15++;
        _context6.next = 1;
        break;
      case 9:
      case "end":
        return _context6.stop();
    }
  }, _marked);
}
function encodeToXmlString(e) {
  var t = [];
  var i = 0;
  for (var _a11 = 0, _s10 = e.length; _a11 < _s10; _a11++) {
    var _s11 = e.codePointAt(_a11);
    if (32 <= _s11 && _s11 <= 126) {
      var _r5 = Rt[_s11];
      if (_r5) {
        i < _a11 && t.push(e.substring(i, _a11));
        t.push(_r5);
        i = _a11 + 1;
      }
    } else {
      i < _a11 && t.push(e.substring(i, _a11));
      t.push("&#x".concat(_s11.toString(16).toUpperCase(), ";"));
      _s11 > 55295 && (_s11 < 57344 || _s11 > 65533) && _a11++;
      i = _a11 + 1;
    }
  }
  if (0 === t.length) return e;
  i < e.length && t.push(e.substring(i, e.length));
  return t.join("");
}
function validateFontName(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  var i = /^("|').*("|')$/.exec(e);
  if (i && i[1] === i[2]) {
    if (new RegExp("[^\\\\]".concat(i[1])).test(e.slice(1, -1))) {
      t && warn("FontFamily contains unescaped ".concat(i[1], ": ").concat(e, "."));
      return !1;
    }
  } else {
    var _iterator9 = _createForOfIteratorHelper(e.split(/[ \t]+/)),
      _step9;
    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var _i13 = _step9.value;
        if (/^(\d|(-(\d|-)))/.test(_i13) || !/^[\w-\\]+$/.test(_i13)) {
          t && warn("FontFamily contains invalid <custom-ident>: ".concat(e, "."));
          return !1;
        }
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  }
  return !0;
}
function validateCSSFont(e) {
  var t = new Set(["100", "200", "300", "400", "500", "600", "700", "800", "900", "1000", "normal", "bold", "bolder", "lighter"]),
    i = e.fontFamily,
    a = e.fontWeight,
    s = e.italicAngle;
  if (!validateFontName(i, !0)) return !1;
  var r = a ? a.toString() : "";
  e.fontWeight = t.has(r) ? r : "400";
  var n = parseFloat(s);
  e.italicAngle = isNaN(n) || n < -90 || n > 90 ? "14" : s.toString();
  return !0;
}
function recoverJsURL(e) {
  var t = new RegExp("^\\s*(" + ["app.launchURL", "window.open", "xfa.host.gotoURL"].join("|").replaceAll(".", "\\.") + ")\\((?:'|\")([^'\"]*)(?:'|\")(?:,\\s*(\\w+)\\)|\\))", "i").exec(e);
  if (t !== null && t !== void 0 && t[2]) {
    var _e9 = t[2];
    var _i14 = !1;
    "true" === t[3] && "app.launchURL" === t[1] && (_i14 = !0);
    return {
      url: _e9,
      newWindow: _i14
    };
  }
  return null;
}
function numberToString(e) {
  if (Number.isInteger(e)) return e.toString();
  var t = Math.round(100 * e);
  return t % 100 == 0 ? (t / 100).toString() : t % 10 == 0 ? e.toFixed(1) : e.toFixed(2);
}
function getNewAnnotationsMap(e) {
  if (!e) return null;
  var t = new Map();
  var _iterator10 = _createForOfIteratorHelper(e),
    _step10;
  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var _ref11 = _step10.value;
      var _ref12 = _slicedToArray(_ref11, 2);
      var _i15 = _ref12[0];
      var _a12 = _ref12[1];
      {
        if (!_i15.startsWith(u)) continue;
        var _e10 = t.get(_a12.pageIndex);
        if (!_e10) {
          _e10 = [];
          t.set(_a12.pageIndex, _e10);
        }
        _e10.push(_a12);
      }
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }
  return t.size > 0 ? t : null;
}
function stringToAsciiOrUTF16BE(e) {
  return function isAscii(e) {
    return /^[\x00-\x7F]*$/.test(e);
  }(e) ? e : stringToUTF16String(e, !0);
}
function stringToUTF16HexString(e) {
  var t = [];
  for (var _i16 = 0, _a13 = e.length; _i16 < _a13; _i16++) {
    var _a14 = e.charCodeAt(_i16);
    t.push(ot[_a14 >> 8 & 255], ot[255 & _a14]);
  }
  return t.join("");
}
function stringToUTF16String(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  var i = [];
  t && i.push("þÿ");
  for (var _t16 = 0, _a15 = e.length; _t16 < _a15; _t16++) {
    var _a16 = e.charCodeAt(_t16);
    i.push(String.fromCharCode(_a16 >> 8 & 255), String.fromCharCode(255 & _a16));
  }
  return i.join("");
}
function _getRotationMatrix(e, t, i) {
  switch (e) {
    case 90:
      return [0, 1, -1, 0, t, 0];
    case 180:
      return [-1, 0, 0, -1, t, i];
    case 270:
      return [0, -1, 1, 0, 0, i];
    default:
      throw new Error("Invalid rotation");
  }
}
function getSizeInBytes(e) {
  return Math.ceil(Math.ceil(Math.log2(1 + e)) / 8);
}
var Stream = /*#__PURE__*/function (_BaseStream) {
  function Stream(e, t, i, a) {
    var _this5;
    _classCallCheck(this, Stream);
    _this5 = _callSuper(this, Stream);
    _this5.bytes = e instanceof Uint8Array ? e : new Uint8Array(e);
    _this5.start = t || 0;
    _this5.pos = _this5.start;
    _this5.end = t + i || _this5.bytes.length;
    _this5.dict = a;
    return _this5;
  }
  _inherits(Stream, _BaseStream);
  return _createClass(Stream, [{
    key: "length",
    get: function get() {
      return this.end - this.start;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return 0 === this.length;
    }
  }, {
    key: "getByte",
    value: function getByte() {
      return this.pos >= this.end ? -1 : this.bytes[this.pos++];
    }
  }, {
    key: "getBytes",
    value: function getBytes(e) {
      var t = this.bytes,
        i = this.pos,
        a = this.end;
      if (!e) return t.subarray(i, a);
      var s = i + e;
      s > a && (s = a);
      this.pos = s;
      return t.subarray(i, s);
    }
  }, {
    key: "getByteRange",
    value: function getByteRange(e, t) {
      e < 0 && (e = 0);
      t > this.end && (t = this.end);
      return this.bytes.subarray(e, t);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.pos = this.start;
    }
  }, {
    key: "moveStart",
    value: function moveStart() {
      this.start = this.pos;
    }
  }, {
    key: "makeSubStream",
    value: function makeSubStream(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return new Stream(this.bytes.buffer, e, t, i);
    }
  }]);
}(BaseStream);
var StringStream = /*#__PURE__*/function (_Stream) {
  function StringStream(e) {
    _classCallCheck(this, StringStream);
    return _callSuper(this, StringStream, [stringToBytes(e)]);
  }
  _inherits(StringStream, _Stream);
  return _createClass(StringStream);
}(Stream);
var NullStream = /*#__PURE__*/function (_Stream2) {
  function NullStream() {
    _classCallCheck(this, NullStream);
    return _callSuper(this, NullStream, [new Uint8Array(0)]);
  }
  _inherits(NullStream, _Stream2);
  return _createClass(NullStream);
}(Stream);
var ChunkedStream = /*#__PURE__*/function (_Stream3) {
  function ChunkedStream(e, t, i) {
    var _this6;
    _classCallCheck(this, ChunkedStream);
    _this6 = _callSuper(this, ChunkedStream, [new Uint8Array(e), 0, e, null]);
    _this6.chunkSize = t;
    _this6._loadedChunks = new Set();
    _this6.numChunks = Math.ceil(e / t);
    _this6.manager = i;
    _this6.progressiveDataLength = 0;
    _this6.lastSuccessfulEnsureByteChunk = -1;
    return _this6;
  }
  _inherits(ChunkedStream, _Stream3);
  return _createClass(ChunkedStream, [{
    key: "getMissingChunks",
    value: function getMissingChunks() {
      var e = [];
      for (var _t17 = 0, _i17 = this.numChunks; _t17 < _i17; ++_t17) this._loadedChunks.has(_t17) || e.push(_t17);
      return e;
    }
  }, {
    key: "numChunksLoaded",
    get: function get() {
      return this._loadedChunks.size;
    }
  }, {
    key: "isDataLoaded",
    get: function get() {
      return this.numChunksLoaded === this.numChunks;
    }
  }, {
    key: "onReceiveData",
    value: function onReceiveData(e, t) {
      var i = this.chunkSize;
      if (e % i != 0) throw new Error("Bad begin offset: ".concat(e));
      var a = e + t.byteLength;
      if (a % i != 0 && a !== this.bytes.length) throw new Error("Bad end offset: ".concat(a));
      this.bytes.set(new Uint8Array(t), e);
      var s = Math.floor(e / i),
        r = Math.floor((a - 1) / i) + 1;
      for (var _e11 = s; _e11 < r; ++_e11) this._loadedChunks.add(_e11);
    }
  }, {
    key: "onReceiveProgressiveData",
    value: function onReceiveProgressiveData(e) {
      var t = this.progressiveDataLength;
      var i = Math.floor(t / this.chunkSize);
      this.bytes.set(new Uint8Array(e), t);
      t += e.byteLength;
      this.progressiveDataLength = t;
      var a = t >= this.end ? this.numChunks : Math.floor(t / this.chunkSize);
      for (var _e12 = i; _e12 < a; ++_e12) this._loadedChunks.add(_e12);
    }
  }, {
    key: "ensureByte",
    value: function ensureByte(e) {
      if (e < this.progressiveDataLength) return;
      var t = Math.floor(e / this.chunkSize);
      if (!(t > this.numChunks) && t !== this.lastSuccessfulEnsureByteChunk) {
        if (!this._loadedChunks.has(t)) throw new MissingDataException(e, e + 1);
        this.lastSuccessfulEnsureByteChunk = t;
      }
    }
  }, {
    key: "ensureRange",
    value: function ensureRange(e, t) {
      if (e >= t) return;
      if (t <= this.progressiveDataLength) return;
      var i = Math.floor(e / this.chunkSize);
      if (i > this.numChunks) return;
      var a = Math.min(Math.floor((t - 1) / this.chunkSize) + 1, this.numChunks);
      for (var _s12 = i; _s12 < a; ++_s12) if (!this._loadedChunks.has(_s12)) throw new MissingDataException(e, t);
    }
  }, {
    key: "nextEmptyChunk",
    value: function nextEmptyChunk(e) {
      var t = this.numChunks;
      for (var _i18 = 0; _i18 < t; ++_i18) {
        var _a17 = (e + _i18) % t;
        if (!this._loadedChunks.has(_a17)) return _a17;
      }
      return null;
    }
  }, {
    key: "hasChunk",
    value: function hasChunk(e) {
      return this._loadedChunks.has(e);
    }
  }, {
    key: "getByte",
    value: function getByte() {
      var e = this.pos;
      if (e >= this.end) return -1;
      e >= this.progressiveDataLength && this.ensureByte(e);
      return this.bytes[this.pos++];
    }
  }, {
    key: "getBytes",
    value: function getBytes(e) {
      var t = this.bytes,
        i = this.pos,
        a = this.end;
      if (!e) {
        a > this.progressiveDataLength && this.ensureRange(i, a);
        return t.subarray(i, a);
      }
      var s = i + e;
      s > a && (s = a);
      s > this.progressiveDataLength && this.ensureRange(i, s);
      this.pos = s;
      return t.subarray(i, s);
    }
  }, {
    key: "getByteRange",
    value: function getByteRange(e, t) {
      e < 0 && (e = 0);
      t > this.end && (t = this.end);
      t > this.progressiveDataLength && this.ensureRange(e, t);
      return this.bytes.subarray(e, t);
    }
  }, {
    key: "makeSubStream",
    value: function makeSubStream(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      t ? e + t > this.progressiveDataLength && this.ensureRange(e, e + t) : e >= this.progressiveDataLength && this.ensureByte(e);
      function ChunkedStreamSubstream() {}
      ChunkedStreamSubstream.prototype = Object.create(this);
      ChunkedStreamSubstream.prototype.getMissingChunks = function () {
        var e = this.chunkSize,
          t = Math.floor(this.start / e),
          i = Math.floor((this.end - 1) / e) + 1,
          a = [];
        for (var _e13 = t; _e13 < i; ++_e13) this._loadedChunks.has(_e13) || a.push(_e13);
        return a;
      };
      Object.defineProperty(ChunkedStreamSubstream.prototype, "isDataLoaded", {
        get: function get() {
          return this.numChunksLoaded === this.numChunks || 0 === this.getMissingChunks().length;
        },
        configurable: !0
      });
      var a = new ChunkedStreamSubstream();
      a.pos = a.start = e;
      a.end = e + t || this.end;
      a.dict = i;
      return a;
    }
  }, {
    key: "getBaseStreams",
    value: function getBaseStreams() {
      return [this];
    }
  }]);
}(Stream);
var ChunkedStreamManager = /*#__PURE__*/function () {
  function ChunkedStreamManager(e, t) {
    _classCallCheck(this, ChunkedStreamManager);
    this.length = t.length;
    this.chunkSize = t.rangeChunkSize;
    this.stream = new ChunkedStream(this.length, this.chunkSize, this);
    this.pdfNetworkStream = e;
    this.disableAutoFetch = t.disableAutoFetch;
    this.msgHandler = t.msgHandler;
    this.currRequestId = 0;
    this._chunksNeededByRequest = new Map();
    this._requestsByChunk = new Map();
    this._promisesByRequest = new Map();
    this.progressiveDataLength = 0;
    this.aborted = !1;
    this._loadedStreamCapability = Promise.withResolvers();
  }
  return _createClass(ChunkedStreamManager, [{
    key: "sendRequest",
    value: function sendRequest(e, t) {
      var _this7 = this;
      var i = this.pdfNetworkStream.getRangeReader(e, t);
      i.isStreamingSupported || (i.onProgress = this.onProgress.bind(this));
      var a = [],
        s = 0;
      return new Promise(function (e, t) {
        var _readChunk = function readChunk(_ref13) {
          var r = _ref13.value,
            n = _ref13.done;
          try {
            if (n) {
              var _t18 = arrayBuffersToBytes(a);
              a = null;
              e(_t18);
              return;
            }
            s += r.byteLength;
            i.isStreamingSupported && _this7.onProgress({
              loaded: s
            });
            a.push(r);
            i.read().then(_readChunk, t);
          } catch (e) {
            t(e);
          }
        };
        i.read().then(_readChunk, t);
      }).then(function (t) {
        _this7.aborted || _this7.onReceiveData({
          chunk: t,
          begin: e
        });
      });
    }
  }, {
    key: "requestAllChunks",
    value: function requestAllChunks() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      if (!e) {
        var _e14 = this.stream.getMissingChunks();
        this._requestChunks(_e14);
      }
      return this._loadedStreamCapability.promise;
    }
  }, {
    key: "_requestChunks",
    value: function _requestChunks(e) {
      var _this8 = this;
      var t = this.currRequestId++,
        i = new Set();
      this._chunksNeededByRequest.set(t, i);
      var _iterator11 = _createForOfIteratorHelper(e),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var _t20 = _step11.value;
          this.stream.hasChunk(_t20) || i.add(_t20);
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      if (0 === i.size) return Promise.resolve();
      var a = Promise.withResolvers();
      this._promisesByRequest.set(t, a);
      var s = [];
      var _iterator12 = _createForOfIteratorHelper(i),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var _e17 = _step12.value;
          var _i20 = this._requestsByChunk.get(_e17);
          if (!_i20) {
            _i20 = [];
            this._requestsByChunk.set(_e17, _i20);
            s.push(_e17);
          }
          _i20.push(t);
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      if (s.length > 0) {
        var _e15 = this.groupChunks(s);
        var _iterator13 = _createForOfIteratorHelper(_e15),
          _step13;
        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var _t19 = _step13.value;
            var _e16 = _t19.beginChunk * this.chunkSize,
              _i19 = Math.min(_t19.endChunk * this.chunkSize, this.length);
            this.sendRequest(_e16, _i19).catch(a.reject);
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
      }
      return a.promise.catch(function (e) {
        if (!_this8.aborted) throw e;
      });
    }
  }, {
    key: "getStream",
    value: function getStream() {
      return this.stream;
    }
  }, {
    key: "requestRange",
    value: function requestRange(e, t) {
      t = Math.min(t, this.length);
      var i = this.getBeginChunk(e),
        a = this.getEndChunk(t),
        s = [];
      for (var _e18 = i; _e18 < a; ++_e18) s.push(_e18);
      return this._requestChunks(s);
    }
  }, {
    key: "requestRanges",
    value: function requestRanges() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var t = [];
      var _iterator14 = _createForOfIteratorHelper(e),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var _i21 = _step14.value;
          var _e19 = this.getBeginChunk(_i21.begin),
            _a18 = this.getEndChunk(_i21.end);
          for (var _i22 = _e19; _i22 < _a18; ++_i22) t.includes(_i22) || t.push(_i22);
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
      t.sort(function (e, t) {
        return e - t;
      });
      return this._requestChunks(t);
    }
  }, {
    key: "groupChunks",
    value: function groupChunks(e) {
      var t = [];
      var i = -1,
        a = -1;
      for (var _s13 = 0, _r6 = e.length; _s13 < _r6; ++_s13) {
        var _r7 = e[_s13];
        i < 0 && (i = _r7);
        if (a >= 0 && a + 1 !== _r7) {
          t.push({
            beginChunk: i,
            endChunk: a + 1
          });
          i = _r7;
        }
        _s13 + 1 === e.length && t.push({
          beginChunk: i,
          endChunk: _r7 + 1
        });
        a = _r7;
      }
      return t;
    }
  }, {
    key: "onProgress",
    value: function onProgress(e) {
      this.msgHandler.send("DocProgress", {
        loaded: this.stream.numChunksLoaded * this.chunkSize + e.loaded,
        total: this.length
      });
    }
  }, {
    key: "onReceiveData",
    value: function onReceiveData(e) {
      var t = e.chunk,
        i = void 0 === e.begin,
        a = i ? this.progressiveDataLength : e.begin,
        s = a + t.byteLength,
        r = Math.floor(a / this.chunkSize),
        n = s < this.length ? Math.floor(s / this.chunkSize) : Math.ceil(s / this.chunkSize);
      if (i) {
        this.stream.onReceiveProgressiveData(t);
        this.progressiveDataLength = s;
      } else this.stream.onReceiveData(a, t);
      this.stream.isDataLoaded && this._loadedStreamCapability.resolve(this.stream);
      var g = [];
      for (var _e20 = r; _e20 < n; ++_e20) {
        var _t21 = this._requestsByChunk.get(_e20);
        if (_t21) {
          this._requestsByChunk.delete(_e20);
          var _iterator15 = _createForOfIteratorHelper(_t21),
            _step15;
          try {
            for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
              var _i23 = _step15.value;
              var _t22 = this._chunksNeededByRequest.get(_i23);
              _t22.has(_e20) && _t22.delete(_e20);
              _t22.size > 0 || g.push(_i23);
            }
          } catch (err) {
            _iterator15.e(err);
          } finally {
            _iterator15.f();
          }
        }
      }
      if (!this.disableAutoFetch && 0 === this._requestsByChunk.size) {
        var _e21;
        if (1 === this.stream.numChunksLoaded) {
          var _t23 = this.stream.numChunks - 1;
          this.stream.hasChunk(_t23) || (_e21 = _t23);
        } else _e21 = this.stream.nextEmptyChunk(n);
        Number.isInteger(_e21) && this._requestChunks([_e21]);
      }
      for (var _i24 = 0, _g = g; _i24 < _g.length; _i24++) {
        var _e22 = _g[_i24];
        var _t24 = this._promisesByRequest.get(_e22);
        this._promisesByRequest.delete(_e22);
        _t24.resolve();
      }
      this.msgHandler.send("DocProgress", {
        loaded: this.stream.numChunksLoaded * this.chunkSize,
        total: this.length
      });
    }
  }, {
    key: "onError",
    value: function onError(e) {
      this._loadedStreamCapability.reject(e);
    }
  }, {
    key: "getBeginChunk",
    value: function getBeginChunk(e) {
      return Math.floor(e / this.chunkSize);
    }
  }, {
    key: "getEndChunk",
    value: function getEndChunk(e) {
      return Math.floor((e - 1) / this.chunkSize) + 1;
    }
  }, {
    key: "abort",
    value: function abort(e) {
      var _this$pdfNetworkStrea;
      this.aborted = !0;
      (_this$pdfNetworkStrea = this.pdfNetworkStream) === null || _this$pdfNetworkStrea === void 0 || _this$pdfNetworkStrea.cancelAllRequests(e);
      var _iterator16 = _createForOfIteratorHelper(this._promisesByRequest.values()),
        _step16;
      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var _t25 = _step16.value;
          _t25.reject(e);
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
    }
  }]);
}();
var ColorSpace = /*#__PURE__*/function () {
  function ColorSpace(e, t) {
    _classCallCheck(this, ColorSpace);
    this.name = e;
    this.numComps = t;
  }
  return _createClass(ColorSpace, [{
    key: "getRgb",
    value: function getRgb(e, t) {
      var i = new Uint8ClampedArray(3);
      this.getRgbItem(e, t, i, 0);
      return i;
    }
  }, {
    key: "getRgbItem",
    value: function getRgbItem(e, t, i, a) {
      unreachable("Should not call ColorSpace.getRgbItem");
    }
  }, {
    key: "getRgbBuffer",
    value: function getRgbBuffer(e, t, i, a, s, r, n) {
      unreachable("Should not call ColorSpace.getRgbBuffer");
    }
  }, {
    key: "getOutputLength",
    value: function getOutputLength(e, t) {
      unreachable("Should not call ColorSpace.getOutputLength");
    }
  }, {
    key: "isPassthrough",
    value: function isPassthrough(e) {
      return !1;
    }
  }, {
    key: "isDefaultDecode",
    value: function isDefaultDecode(e, t) {
      return ColorSpace.isDefaultDecode(e, this.numComps);
    }
  }, {
    key: "fillRgb",
    value: function fillRgb(e, t, i, a, s, r, n, g, o) {
      var c = t * i;
      var C = null;
      var h = 1 << n,
        l = i !== s || t !== a;
      if (this.isPassthrough(n)) C = g;else if (1 === this.numComps && c > h && "DeviceGray" !== this.name && "DeviceRGB" !== this.name) {
        var _t26 = n <= 8 ? new Uint8Array(h) : new Uint16Array(h);
        for (var _e23 = 0; _e23 < h; _e23++) _t26[_e23] = _e23;
        var _i25 = new Uint8ClampedArray(3 * h);
        this.getRgbBuffer(_t26, 0, h, _i25, 0, n, 0);
        if (l) {
          C = new Uint8Array(3 * c);
          var _e24 = 0;
          for (var _t27 = 0; _t27 < c; ++_t27) {
            var _a19 = 3 * g[_t27];
            C[_e24++] = _i25[_a19];
            C[_e24++] = _i25[_a19 + 1];
            C[_e24++] = _i25[_a19 + 2];
          }
        } else {
          var _t28 = 0;
          for (var _a20 = 0; _a20 < c; ++_a20) {
            var _s14 = 3 * g[_a20];
            e[_t28++] = _i25[_s14];
            e[_t28++] = _i25[_s14 + 1];
            e[_t28++] = _i25[_s14 + 2];
            _t28 += o;
          }
        }
      } else if (l) {
        C = new Uint8ClampedArray(3 * c);
        this.getRgbBuffer(g, 0, c, C, 0, n, 0);
      } else this.getRgbBuffer(g, 0, a * r, e, 0, n, o);
      if (C) if (l) !function resizeRgbImage(e, t, i, a, s, r, n) {
        n = 1 !== n ? 0 : n;
        var g = i / s,
          o = a / r;
        var c,
          C = 0;
        var h = new Uint16Array(s),
          l = 3 * i;
        for (var _e25 = 0; _e25 < s; _e25++) h[_e25] = 3 * Math.floor(_e25 * g);
        for (var _i26 = 0; _i26 < r; _i26++) {
          var _a21 = Math.floor(_i26 * o) * l;
          for (var _i27 = 0; _i27 < s; _i27++) {
            c = _a21 + h[_i27];
            t[C++] = e[c++];
            t[C++] = e[c++];
            t[C++] = e[c++];
            C += n;
          }
        }
      }(C, e, t, i, a, s, o);else {
        var _t29 = 0,
          _i28 = 0;
        for (var _s15 = 0, _n5 = a * r; _s15 < _n5; _s15++) {
          e[_t29++] = C[_i28++];
          e[_t29++] = C[_i28++];
          e[_t29++] = C[_i28++];
          _t29 += o;
        }
      }
    }
  }, {
    key: "usesZeroToOneRange",
    get: function get() {
      return shadow(this, "usesZeroToOneRange", !0);
    }
  }], [{
    key: "_cache",
    value: function _cache(e, t, i, a) {
      if (!i) throw new Error('ColorSpace._cache - expected "localColorSpaceCache" argument.');
      if (!a) throw new Error('ColorSpace._cache - expected "parsedColorSpace" argument.');
      var s, r;
      if (e instanceof Ref) {
        r = e;
        e = t.fetch(e);
      }
      e instanceof Name && (s = e.name);
      (s || r) && i.set(s, r, a);
    }
  }, {
    key: "getCached",
    value: function getCached(e, t, i) {
      if (!i) throw new Error('ColorSpace.getCached - expected "localColorSpaceCache" argument.');
      if (e instanceof Ref) {
        var _a22 = i.getByRef(e);
        if (_a22) return _a22;
        try {
          e = t.fetch(e);
        } catch (e) {
          if (e instanceof MissingDataException) throw e;
        }
      }
      if (e instanceof Name) {
        var _t30 = i.getByName(e.name);
        if (_t30) return _t30;
      }
      return null;
    }
  }, {
    key: "parseAsync",
    value: function () {
      var _parseAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref14) {
        var e, t, _ref14$resources, i, a, s, r;
        return _regeneratorRuntime().wrap(function _callee5$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              e = _ref14.cs, t = _ref14.xref, _ref14$resources = _ref14.resources, i = _ref14$resources === void 0 ? null : _ref14$resources, a = _ref14.pdfFunctionFactory, s = _ref14.localColorSpaceCache;
              r = this._parse(e, t, i, a);
              this._cache(e, t, s, r);
              return _context7.abrupt("return", r);
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee5, this);
      }));
      function parseAsync(_x6) {
        return _parseAsync.apply(this, arguments);
      }
      return parseAsync;
    }()
  }, {
    key: "parse",
    value: function parse(_ref15) {
      var e = _ref15.cs,
        t = _ref15.xref,
        _ref15$resources = _ref15.resources,
        i = _ref15$resources === void 0 ? null : _ref15$resources,
        a = _ref15.pdfFunctionFactory,
        s = _ref15.localColorSpaceCache;
      var r = this.getCached(e, t, s);
      if (r) return r;
      var n = this._parse(e, t, i, a);
      this._cache(e, t, s, n);
      return n;
    }
  }, {
    key: "_parse",
    value: function _parse(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var a = arguments.length > 3 ? arguments[3] : undefined;
      if ((e = t.fetchIfRef(e)) instanceof Name) switch (e.name) {
        case "G":
        case "DeviceGray":
          return this.singletons.gray;
        case "RGB":
        case "DeviceRGB":
          return this.singletons.rgb;
        case "DeviceRGBA":
          return this.singletons.rgba;
        case "CMYK":
        case "DeviceCMYK":
          return this.singletons.cmyk;
        case "Pattern":
          return new PatternCS(null);
        default:
          if (i instanceof Dict) {
            var _s16 = i.get("ColorSpace");
            if (_s16 instanceof Dict) {
              var _r8 = _s16.get(e.name);
              if (_r8) {
                if (_r8 instanceof Name) return this._parse(_r8, t, i, a);
                e = _r8;
                break;
              }
            }
          }
          warn("Unrecognized ColorSpace: ".concat(e.name));
          return this.singletons.gray;
      }
      if (Array.isArray(e)) {
        var _s17 = t.fetchIfRef(e[0]).name;
        var _r9, _n6, _g2, _o, _c, _C;
        switch (_s17) {
          case "G":
          case "DeviceGray":
            return this.singletons.gray;
          case "RGB":
          case "DeviceRGB":
            return this.singletons.rgb;
          case "CMYK":
          case "DeviceCMYK":
            return this.singletons.cmyk;
          case "CalGray":
            _r9 = t.fetchIfRef(e[1]);
            _o = _r9.getArray("WhitePoint");
            _c = _r9.getArray("BlackPoint");
            _C = _r9.get("Gamma");
            return new CalGrayCS(_o, _c, _C);
          case "CalRGB":
            _r9 = t.fetchIfRef(e[1]);
            _o = _r9.getArray("WhitePoint");
            _c = _r9.getArray("BlackPoint");
            _C = _r9.getArray("Gamma");
            var _h = _r9.getArray("Matrix");
            return new CalRGBCS(_o, _c, _C, _h);
          case "ICCBased":
            var _l = t.fetchIfRef(e[1]).dict;
            _n6 = _l.get("N");
            var _Q = _l.get("Alternate");
            if (_Q) {
              var _e26 = this._parse(_Q, t, i, a);
              if (_e26.numComps === _n6) return _e26;
              warn("ICCBased color space: Ignoring incorrect /Alternate entry.");
            }
            if (1 === _n6) return this.singletons.gray;
            if (3 === _n6) return this.singletons.rgb;
            if (4 === _n6) return this.singletons.cmyk;
            break;
          case "Pattern":
            _g2 = e[1] || null;
            _g2 && (_g2 = this._parse(_g2, t, i, a));
            return new PatternCS(_g2);
          case "I":
          case "Indexed":
            _g2 = this._parse(e[1], t, i, a);
            var _E = Math.max(0, Math.min(t.fetchIfRef(e[2]), 255)),
              _u = t.fetchIfRef(e[3]);
            return new IndexedCS(_g2, _E, _u);
          case "Separation":
          case "DeviceN":
            var _d = t.fetchIfRef(e[1]);
            _n6 = Array.isArray(_d) ? _d.length : 1;
            _g2 = this._parse(e[2], t, i, a);
            var _f = a.create(e[3]);
            return new AlternateCS(_n6, _g2, _f);
          case "Lab":
            _r9 = t.fetchIfRef(e[1]);
            _o = _r9.getArray("WhitePoint");
            _c = _r9.getArray("BlackPoint");
            var _p = _r9.getArray("Range");
            return new LabCS(_o, _c, _p);
          default:
            warn("Unimplemented ColorSpace object: ".concat(_s17));
            return this.singletons.gray;
        }
      }
      warn("Unrecognized ColorSpace object: ".concat(e));
      return this.singletons.gray;
    }
  }, {
    key: "isDefaultDecode",
    value: function isDefaultDecode(e, t) {
      if (!Array.isArray(e)) return !0;
      if (2 * t !== e.length) {
        warn("The decode map is not the correct length");
        return !0;
      }
      for (var _t31 = 0, _i29 = e.length; _t31 < _i29; _t31 += 2) if (0 !== e[_t31] || 1 !== e[_t31 + 1]) return !1;
      return !0;
    }
  }, {
    key: "singletons",
    get: function get() {
      return shadow(this, "singletons", {
        get gray() {
          return shadow(this, "gray", new DeviceGrayCS());
        },
        get rgb() {
          return shadow(this, "rgb", new DeviceRgbCS());
        },
        get rgba() {
          return shadow(this, "rgba", new DeviceRgbaCS());
        },
        get cmyk() {
          return shadow(this, "cmyk", new DeviceCmykCS());
        }
      });
    }
  }]);
}();
var AlternateCS = /*#__PURE__*/function (_ColorSpace) {
  function AlternateCS(e, t, i) {
    var _this9;
    _classCallCheck(this, AlternateCS);
    _this9 = _callSuper(this, AlternateCS, ["Alternate", e]);
    _this9.base = t;
    _this9.tintFn = i;
    _this9.tmpBuf = new Float32Array(t.numComps);
    return _this9;
  }
  _inherits(AlternateCS, _ColorSpace);
  return _createClass(AlternateCS, [{
    key: "getRgbItem",
    value: function getRgbItem(e, t, i, a) {
      var s = this.tmpBuf;
      this.tintFn(e, t, s, 0);
      this.base.getRgbItem(s, 0, i, a);
    }
  }, {
    key: "getRgbBuffer",
    value: function getRgbBuffer(e, t, i, a, s, r, n) {
      var g = this.tintFn,
        o = this.base,
        c = 1 / ((1 << r) - 1),
        C = o.numComps,
        h = o.usesZeroToOneRange,
        l = (o.isPassthrough(8) || !h) && 0 === n;
      var Q = l ? s : 0;
      var E = l ? a : new Uint8ClampedArray(C * i),
        u = this.numComps,
        d = new Float32Array(u),
        f = new Float32Array(C);
      var p, m;
      for (p = 0; p < i; p++) {
        for (m = 0; m < u; m++) d[m] = e[t++] * c;
        g(d, 0, f, 0);
        if (h) for (m = 0; m < C; m++) E[Q++] = 255 * f[m];else {
          o.getRgbItem(f, 0, E, Q);
          Q += C;
        }
      }
      l || o.getRgbBuffer(E, 0, i, a, s, 8, n);
    }
  }, {
    key: "getOutputLength",
    value: function getOutputLength(e, t) {
      return this.base.getOutputLength(e * this.base.numComps / this.numComps, t);
    }
  }]);
}(ColorSpace);
var PatternCS = /*#__PURE__*/function (_ColorSpace2) {
  function PatternCS(e) {
    var _this10;
    _classCallCheck(this, PatternCS);
    _this10 = _callSuper(this, PatternCS, ["Pattern", null]);
    _this10.base = e;
    return _this10;
  }
  _inherits(PatternCS, _ColorSpace2);
  return _createClass(PatternCS, [{
    key: "isDefaultDecode",
    value: function isDefaultDecode(e, t) {
      unreachable("Should not call PatternCS.isDefaultDecode");
    }
  }]);
}(ColorSpace);
var IndexedCS = /*#__PURE__*/function (_ColorSpace3) {
  function IndexedCS(e, t, i) {
    var _this11;
    _classCallCheck(this, IndexedCS);
    _this11 = _callSuper(this, IndexedCS, ["Indexed", 1]);
    _this11.base = e;
    var a = e.numComps * (t + 1);
    _this11.lookup = new Uint8Array(a);
    if (i instanceof BaseStream) {
      var _e27 = i.getBytes(a);
      _this11.lookup.set(_e27);
    } else {
      if ("string" != typeof i) throw new FormatError("IndexedCS - unrecognized lookup table: ".concat(i));
      for (var _e28 = 0; _e28 < a; ++_e28) _this11.lookup[_e28] = 255 & i.charCodeAt(_e28);
    }
    return _this11;
  }
  _inherits(IndexedCS, _ColorSpace3);
  return _createClass(IndexedCS, [{
    key: "getRgbItem",
    value: function getRgbItem(e, t, i, a) {
      var s = this.base.numComps,
        r = e[t] * s;
      this.base.getRgbBuffer(this.lookup, r, 1, i, a, 8, 0);
    }
  }, {
    key: "getRgbBuffer",
    value: function getRgbBuffer(e, t, i, a, s, r, n) {
      var g = this.base,
        o = g.numComps,
        c = g.getOutputLength(o, n),
        C = this.lookup;
      for (var _r10 = 0; _r10 < i; ++_r10) {
        var _i30 = e[t++] * o;
        g.getRgbBuffer(C, _i30, 1, a, s, 8, n);
        s += c;
      }
    }
  }, {
    key: "getOutputLength",
    value: function getOutputLength(e, t) {
      return this.base.getOutputLength(e * this.base.numComps, t);
    }
  }, {
    key: "isDefaultDecode",
    value: function isDefaultDecode(e, t) {
      if (!Array.isArray(e)) return !0;
      if (2 !== e.length) {
        warn("Decode map length is not correct");
        return !0;
      }
      if (!Number.isInteger(t) || t < 1) {
        warn("Bits per component is not correct");
        return !0;
      }
      return 0 === e[0] && e[1] === (1 << t) - 1;
    }
  }]);
}(ColorSpace);
var DeviceGrayCS = /*#__PURE__*/function (_ColorSpace4) {
  function DeviceGrayCS() {
    _classCallCheck(this, DeviceGrayCS);
    return _callSuper(this, DeviceGrayCS, ["DeviceGray", 1]);
  }
  _inherits(DeviceGrayCS, _ColorSpace4);
  return _createClass(DeviceGrayCS, [{
    key: "getRgbItem",
    value: function getRgbItem(e, t, i, a) {
      var s = 255 * e[t];
      i[a] = i[a + 1] = i[a + 2] = s;
    }
  }, {
    key: "getRgbBuffer",
    value: function getRgbBuffer(e, t, i, a, s, r, n) {
      var g = 255 / ((1 << r) - 1);
      var o = t,
        c = s;
      for (var _t32 = 0; _t32 < i; ++_t32) {
        var _t33 = g * e[o++];
        a[c++] = _t33;
        a[c++] = _t33;
        a[c++] = _t33;
        c += n;
      }
    }
  }, {
    key: "getOutputLength",
    value: function getOutputLength(e, t) {
      return e * (3 + t);
    }
  }]);
}(ColorSpace);
var DeviceRgbCS = /*#__PURE__*/function (_ColorSpace5) {
  function DeviceRgbCS() {
    _classCallCheck(this, DeviceRgbCS);
    return _callSuper(this, DeviceRgbCS, ["DeviceRGB", 3]);
  }
  _inherits(DeviceRgbCS, _ColorSpace5);
  return _createClass(DeviceRgbCS, [{
    key: "getRgbItem",
    value: function getRgbItem(e, t, i, a) {
      i[a] = 255 * e[t];
      i[a + 1] = 255 * e[t + 1];
      i[a + 2] = 255 * e[t + 2];
    }
  }, {
    key: "getRgbBuffer",
    value: function getRgbBuffer(e, t, i, a, s, r, n) {
      if (8 === r && 0 === n) {
        a.set(e.subarray(t, t + 3 * i), s);
        return;
      }
      var g = 255 / ((1 << r) - 1);
      var o = t,
        c = s;
      for (var _t34 = 0; _t34 < i; ++_t34) {
        a[c++] = g * e[o++];
        a[c++] = g * e[o++];
        a[c++] = g * e[o++];
        c += n;
      }
    }
  }, {
    key: "getOutputLength",
    value: function getOutputLength(e, t) {
      return e * (3 + t) / 3 | 0;
    }
  }, {
    key: "isPassthrough",
    value: function isPassthrough(e) {
      return 8 === e;
    }
  }]);
}(ColorSpace);
var DeviceRgbaCS = /*#__PURE__*/function (_ColorSpace6) {
  function DeviceRgbaCS() {
    _classCallCheck(this, DeviceRgbaCS);
    return _callSuper(this, DeviceRgbaCS, ["DeviceRGBA", 4]);
  }
  _inherits(DeviceRgbaCS, _ColorSpace6);
  return _createClass(DeviceRgbaCS, [{
    key: "getOutputLength",
    value: function getOutputLength(e, t) {
      return 4 * e;
    }
  }, {
    key: "isPassthrough",
    value: function isPassthrough(e) {
      return 8 === e;
    }
  }, {
    key: "fillRgb",
    value: function fillRgb(e, t, i, a, s, r, n, g, o) {
      i !== s || t !== a ? function resizeRgbaImage(e, t, i, a, s, r, n) {
        var g = i / s,
          o = a / r;
        var c = 0;
        var C = new Uint16Array(s);
        if (1 === n) {
          for (var _e29 = 0; _e29 < s; _e29++) C[_e29] = Math.floor(_e29 * g);
          var _a23 = new Uint32Array(e.buffer),
            _n7 = new Uint32Array(t.buffer),
            _h2 = FeatureTest.isLittleEndian ? 16777215 : 4294967040;
          for (var _e30 = 0; _e30 < r; _e30++) {
            var _t35 = _a23.subarray(Math.floor(_e30 * o) * i);
            for (var _e31 = 0; _e31 < s; _e31++) _n7[c++] |= _t35[C[_e31]] & _h2;
          }
        } else {
          var _a24 = 4,
            _n8 = i * _a24;
          for (var _e32 = 0; _e32 < s; _e32++) C[_e32] = Math.floor(_e32 * g) * _a24;
          for (var _i31 = 0; _i31 < r; _i31++) {
            var _a25 = e.subarray(Math.floor(_i31 * o) * _n8);
            for (var _e33 = 0; _e33 < s; _e33++) {
              var _i32 = C[_e33];
              t[c++] = _a25[_i32];
              t[c++] = _a25[_i32 + 1];
              t[c++] = _a25[_i32 + 2];
            }
          }
        }
      }(g, e, t, i, a, s, o) : function copyRgbaImage(e, t, i) {
        if (1 === i) {
          var _i33 = new Uint32Array(e.buffer),
            _a26 = new Uint32Array(t.buffer),
            _s18 = FeatureTest.isLittleEndian ? 16777215 : 4294967040;
          for (var _e34 = 0, _t36 = _i33.length; _e34 < _t36; _e34++) _a26[_e34] |= _i33[_e34] & _s18;
        } else {
          var _i34 = 0;
          for (var _a27 = 0, _s19 = e.length; _a27 < _s19; _a27 += 4) {
            t[_i34++] = e[_a27];
            t[_i34++] = e[_a27 + 1];
            t[_i34++] = e[_a27 + 2];
          }
        }
      }(g, e, o);
    }
  }]);
}(ColorSpace);
var _t37 = /*#__PURE__*/_classPrivateFieldLooseKey("t");
var DeviceCmykCS = /*#__PURE__*/function (_ColorSpace7) {
  function DeviceCmykCS() {
    var _this12;
    _classCallCheck(this, DeviceCmykCS);
    _this12 = _callSuper(this, DeviceCmykCS, ["DeviceCMYK", 4]);
    Object.defineProperty(_this12, _t37, {
      value: _t38
    });
    return _this12;
  }
  _inherits(DeviceCmykCS, _ColorSpace7);
  return _createClass(DeviceCmykCS, [{
    key: "getRgbItem",
    value: function getRgbItem(e, t, i, a) {
      _classPrivateFieldLooseBase(this, _t37)[_t37](e, t, 1, i, a);
    }
  }, {
    key: "getRgbBuffer",
    value: function getRgbBuffer(e, t, i, a, s, r, n) {
      var g = 1 / ((1 << r) - 1);
      for (var _r11 = 0; _r11 < i; _r11++) {
        _classPrivateFieldLooseBase(this, _t37)[_t37](e, t, g, a, s);
        t += 4;
        s += 3 + n;
      }
    }
  }, {
    key: "getOutputLength",
    value: function getOutputLength(e, t) {
      return e / 4 * (3 + t) | 0;
    }
  }]);
}(ColorSpace);
function _t38(e, t, i, a, s) {
  var r = e[t] * i,
    n = e[t + 1] * i,
    g = e[t + 2] * i,
    o = e[t + 3] * i;
  a[s] = 255 + r * (-4.387332384609988 * r + 54.48615194189176 * n + 18.82290502165302 * g + 212.25662451639585 * o - 285.2331026137004) + n * (1.7149763477362134 * n - 5.6096736904047315 * g + -17.873870861415444 * o - 5.497006427196366) + g * (-2.5217340131683033 * g - 21.248923337353073 * o + 17.5119270841813) + o * (-21.86122147463605 * o - 189.48180835922747);
  a[s + 1] = 255 + r * (8.841041422036149 * r + 60.118027045597366 * n + 6.871425592049007 * g + 31.159100130055922 * o - 79.2970844816548) + n * (-15.310361306967817 * n + 17.575251261109482 * g + 131.35250912493976 * o - 190.9453302588951) + g * (4.444339102852739 * g + 9.8632861493405 * o - 24.86741582555878) + o * (-20.737325471181034 * o - 187.80453709719578);
  a[s + 2] = 255 + r * (.8842522430003296 * r + 8.078677503112928 * n + 30.89978309703729 * g - .23883238689178934 * o - 14.183576799673286) + n * (10.49593273432072 * n + 63.02378494754052 * g + 50.606957656360734 * o - 112.23884253719248) + g * (.03296041114873217 * g + 115.60384449646641 * o - 193.58209356861505) + o * (-22.33816807309886 * o - 180.12613974708367);
}
var _t39 = /*#__PURE__*/_classPrivateFieldLooseKey("t");
var CalGrayCS = /*#__PURE__*/function (_ColorSpace8) {
  function CalGrayCS(_e35, _t41, _i35) {
    var _this13;
    _classCallCheck(this, CalGrayCS);
    _this13 = _callSuper(this, CalGrayCS, ["CalGray", 1]);
    Object.defineProperty(_this13, _t39, {
      value: _t40
    });
    if (!_e35) throw new FormatError("WhitePoint missing - required for color space CalGray");
    var _e36 = _slicedToArray(_e35, 3);
    _this13.XW = _e36[0];
    _this13.YW = _e36[1];
    _this13.ZW = _e36[2];
    var _ref16 = _t41 || [0, 0, 0];
    var _ref17 = _slicedToArray(_ref16, 3);
    _this13.XB = _ref17[0];
    _this13.YB = _ref17[1];
    _this13.ZB = _ref17[2];
    _this13.G = _i35 || 1;
    if (_this13.XW < 0 || _this13.ZW < 0 || 1 !== _this13.YW) throw new FormatError("Invalid WhitePoint components for ".concat(_this13.name, ", no fallback available"));
    if (_this13.XB < 0 || _this13.YB < 0 || _this13.ZB < 0) {
      info("Invalid BlackPoint for ".concat(_this13.name, ", falling back to default."));
      _this13.XB = _this13.YB = _this13.ZB = 0;
    }
    0 === _this13.XB && 0 === _this13.YB && 0 === _this13.ZB || warn("".concat(_this13.name, ", BlackPoint: XB: ").concat(_this13.XB, ", YB: ").concat(_this13.YB, ", ZB: ").concat(_this13.ZB, ", only default values are supported."));
    if (_this13.G < 1) {
      info("Invalid Gamma: ".concat(_this13.G, " for ").concat(_this13.name, ", falling back to default."));
      _this13.G = 1;
    }
    return _this13;
  }
  _inherits(CalGrayCS, _ColorSpace8);
  return _createClass(CalGrayCS, [{
    key: "getRgbItem",
    value: function getRgbItem(e, t, i, a) {
      _classPrivateFieldLooseBase(this, _t39)[_t39](e, t, i, a, 1);
    }
  }, {
    key: "getRgbBuffer",
    value: function getRgbBuffer(e, t, i, a, s, r, n) {
      var g = 1 / ((1 << r) - 1);
      for (var _r12 = 0; _r12 < i; ++_r12) {
        _classPrivateFieldLooseBase(this, _t39)[_t39](e, t, a, s, g);
        t += 1;
        s += 3 + n;
      }
    }
  }, {
    key: "getOutputLength",
    value: function getOutputLength(e, t) {
      return e * (3 + t);
    }
  }]);
}(ColorSpace);
function _t40(e, t, i, a, s) {
  var r = Math.pow(e[t] * s, this.G),
    n = this.YW * r,
    g = Math.max(295.8 * Math.pow(n, .3333333333333333) - 40.8, 0);
  i[a] = g;
  i[a + 1] = g;
  i[a + 2] = g;
}
var _i36 = /*#__PURE__*/_classPrivateFieldLooseKey("i");
var _a28 = /*#__PURE__*/_classPrivateFieldLooseKey("a");
var _s20 = /*#__PURE__*/_classPrivateFieldLooseKey("s");
var _r13 = /*#__PURE__*/_classPrivateFieldLooseKey("r");
var _n9 = /*#__PURE__*/_classPrivateFieldLooseKey("n");
var _g3 = /*#__PURE__*/_classPrivateFieldLooseKey("g");
var _o2 = /*#__PURE__*/_classPrivateFieldLooseKey("o");
var _I = /*#__PURE__*/_classPrivateFieldLooseKey("I");
var _c2 = /*#__PURE__*/_classPrivateFieldLooseKey("c");
var _C2 = /*#__PURE__*/_classPrivateFieldLooseKey("C");
var _h3 = /*#__PURE__*/_classPrivateFieldLooseKey("h");
var _l2 = /*#__PURE__*/_classPrivateFieldLooseKey("l");
var _B = /*#__PURE__*/_classPrivateFieldLooseKey("B");
var _Q2 = /*#__PURE__*/_classPrivateFieldLooseKey("Q");
var _E2 = /*#__PURE__*/_classPrivateFieldLooseKey("E");
var _u2 = /*#__PURE__*/_classPrivateFieldLooseKey("u");
var _d2 = /*#__PURE__*/_classPrivateFieldLooseKey("d");
var _t42 = /*#__PURE__*/_classPrivateFieldLooseKey("t");
var CalRGBCS = /*#__PURE__*/function (_ColorSpace9) {
  function CalRGBCS(_e37, _t44, _i37, _a29) {
    var _this14;
    _classCallCheck(this, CalRGBCS);
    _this14 = _callSuper(this, CalRGBCS, ["CalRGB", 3]);
    Object.defineProperty(_this14, _t42, {
      value: _t43
    });
    Object.defineProperty(_this14, _d2, {
      value: _d3
    });
    Object.defineProperty(_this14, _u2, {
      value: _u3
    });
    Object.defineProperty(_this14, _E2, {
      value: _E3
    });
    Object.defineProperty(_this14, _Q2, {
      value: _Q3
    });
    Object.defineProperty(_this14, _B, {
      value: _B2
    });
    Object.defineProperty(_this14, _l2, {
      value: _l3
    });
    Object.defineProperty(_this14, _h3, {
      value: _h4
    });
    Object.defineProperty(_this14, _C2, {
      value: _C3
    });
    Object.defineProperty(_this14, _c2, {
      value: _c3
    });
    if (!_e37) throw new FormatError("WhitePoint missing - required for color space CalRGB");
    var _this14$whitePoint = _this14.whitePoint = _e37,
      _this14$whitePoint2 = _slicedToArray(_this14$whitePoint, 3),
      _s21 = _this14$whitePoint2[0],
      _r14 = _this14$whitePoint2[1],
      _n10 = _this14$whitePoint2[2],
      _this14$blackPoint = _this14.blackPoint = _t44 || new Float32Array(3),
      _this14$blackPoint2 = _slicedToArray(_this14$blackPoint, 3),
      _g4 = _this14$blackPoint2[0],
      _o3 = _this14$blackPoint2[1],
      _c4 = _this14$blackPoint2[2];
    var _ref18 = _i37 || new Float32Array([1, 1, 1]);
    var _ref19 = _slicedToArray(_ref18, 3);
    _this14.GR = _ref19[0];
    _this14.GG = _ref19[1];
    _this14.GB = _ref19[2];
    var _ref20 = _a29 || new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]);
    var _ref21 = _slicedToArray(_ref20, 9);
    _this14.MXA = _ref21[0];
    _this14.MYA = _ref21[1];
    _this14.MZA = _ref21[2];
    _this14.MXB = _ref21[3];
    _this14.MYB = _ref21[4];
    _this14.MZB = _ref21[5];
    _this14.MXC = _ref21[6];
    _this14.MYC = _ref21[7];
    _this14.MZC = _ref21[8];
    if (_s21 < 0 || _n10 < 0 || 1 !== _r14) throw new FormatError("Invalid WhitePoint components for ".concat(_this14.name, ", no fallback available"));
    if (_g4 < 0 || _o3 < 0 || _c4 < 0) {
      info("Invalid BlackPoint for ".concat(_this14.name, " [").concat(_g4, ", ").concat(_o3, ", ").concat(_c4, "], falling back to default."));
      _this14.blackPoint = new Float32Array(3);
    }
    if (_this14.GR < 0 || _this14.GG < 0 || _this14.GB < 0) {
      info("Invalid Gamma [".concat(_this14.GR, ", ").concat(_this14.GG, ", ").concat(_this14.GB, "] for ").concat(_this14.name, ", falling back to default."));
      _this14.GR = _this14.GG = _this14.GB = 1;
    }
    return _this14;
  }
  _inherits(CalRGBCS, _ColorSpace9);
  return _createClass(CalRGBCS, [{
    key: "getRgbItem",
    value: function getRgbItem(e, t, i, a) {
      _classPrivateFieldLooseBase(this, _t42)[_t42](e, t, i, a, 1);
    }
  }, {
    key: "getRgbBuffer",
    value: function getRgbBuffer(e, t, i, a, s, r, n) {
      var g = 1 / ((1 << r) - 1);
      for (var _r15 = 0; _r15 < i; ++_r15) {
        _classPrivateFieldLooseBase(this, _t42)[_t42](e, t, a, s, g);
        t += 3;
        s += 3 + n;
      }
    }
  }, {
    key: "getOutputLength",
    value: function getOutputLength(e, t) {
      return e * (3 + t) / 3 | 0;
    }
  }]);
}(ColorSpace);
_CalRGBCS = CalRGBCS;
function _c3(e, t, i) {
  i[0] = e[0] * t[0] + e[1] * t[1] + e[2] * t[2];
  i[1] = e[3] * t[0] + e[4] * t[1] + e[5] * t[2];
  i[2] = e[6] * t[0] + e[7] * t[1] + e[8] * t[2];
}
function _C3(e, t, i) {
  i[0] = 1 * t[0] / e[0];
  i[1] = 1 * t[1] / e[1];
  i[2] = 1 * t[2] / e[2];
}
function _h4(e, t, i) {
  i[0] = .95047 * t[0] / e[0];
  i[1] = 1 * t[1] / e[1];
  i[2] = 1.08883 * t[2] / e[2];
}
function _l3(e) {
  return e <= .0031308 ? _classPrivateFieldLooseBase(this, _B)[_B](0, 1, 12.92 * e) : e >= .99554525 ? 1 : _classPrivateFieldLooseBase(this, _B)[_B](0, 1, 1.055 * Math.pow(e, 1 / 2.4) - .055);
}
function _B2(e, t, i) {
  return Math.max(e, Math.min(t, i));
}
function _Q3(e) {
  return e < 0 ? -_classPrivateFieldLooseBase(this, _Q2)[_Q2](-e) : e > 8 ? Math.pow((e + 16) / 116, 3) : e * _classPrivateFieldLooseBase(_CalRGBCS, _I)[_I];
}
function _E3(e, t, i) {
  if (0 === e[0] && 0 === e[1] && 0 === e[2]) {
    i[0] = t[0];
    i[1] = t[1];
    i[2] = t[2];
    return;
  }
  var a = _classPrivateFieldLooseBase(this, _Q2)[_Q2](0),
    s = (1 - a) / (1 - _classPrivateFieldLooseBase(this, _Q2)[_Q2](e[0])),
    r = 1 - s,
    n = (1 - a) / (1 - _classPrivateFieldLooseBase(this, _Q2)[_Q2](e[1])),
    g = 1 - n,
    o = (1 - a) / (1 - _classPrivateFieldLooseBase(this, _Q2)[_Q2](e[2])),
    c = 1 - o;
  i[0] = t[0] * s + r;
  i[1] = t[1] * n + g;
  i[2] = t[2] * o + c;
}
function _u3(e, t, i) {
  if (1 === e[0] && 1 === e[2]) {
    i[0] = t[0];
    i[1] = t[1];
    i[2] = t[2];
    return;
  }
  var a = i;
  _classPrivateFieldLooseBase(this, _c2)[_c2](_classPrivateFieldLooseBase(_CalRGBCS, _i36)[_i36], t, a);
  var s = _classPrivateFieldLooseBase(_CalRGBCS, _n9)[_n9];
  _classPrivateFieldLooseBase(this, _C2)[_C2](e, a, s);
  _classPrivateFieldLooseBase(this, _c2)[_c2](_classPrivateFieldLooseBase(_CalRGBCS, _a28)[_a28], s, i);
}
function _d3(e, t, i) {
  var a = i;
  _classPrivateFieldLooseBase(this, _c2)[_c2](_classPrivateFieldLooseBase(_CalRGBCS, _i36)[_i36], t, a);
  var s = _classPrivateFieldLooseBase(_CalRGBCS, _n9)[_n9];
  _classPrivateFieldLooseBase(this, _h3)[_h3](e, a, s);
  _classPrivateFieldLooseBase(this, _c2)[_c2](_classPrivateFieldLooseBase(_CalRGBCS, _a28)[_a28], s, i);
}
function _t43(e, t, i, a, s) {
  var r = _classPrivateFieldLooseBase(this, _B)[_B](0, 1, e[t] * s),
    n = _classPrivateFieldLooseBase(this, _B)[_B](0, 1, e[t + 1] * s),
    g = _classPrivateFieldLooseBase(this, _B)[_B](0, 1, e[t + 2] * s),
    o = 1 === r ? 1 : Math.pow(r, this.GR),
    c = 1 === n ? 1 : Math.pow(n, this.GG),
    C = 1 === g ? 1 : Math.pow(g, this.GB),
    h = this.MXA * o + this.MXB * c + this.MXC * C,
    l = this.MYA * o + this.MYB * c + this.MYC * C,
    Q = this.MZA * o + this.MZB * c + this.MZC * C,
    E = _classPrivateFieldLooseBase(_CalRGBCS, _g3)[_g3];
  E[0] = h;
  E[1] = l;
  E[2] = Q;
  var u = _classPrivateFieldLooseBase(_CalRGBCS, _o2)[_o2];
  _classPrivateFieldLooseBase(this, _u2)[_u2](this.whitePoint, E, u);
  var d = _classPrivateFieldLooseBase(_CalRGBCS, _g3)[_g3];
  _classPrivateFieldLooseBase(this, _E2)[_E2](this.blackPoint, u, d);
  var f = _classPrivateFieldLooseBase(_CalRGBCS, _o2)[_o2];
  _classPrivateFieldLooseBase(this, _d2)[_d2](_classPrivateFieldLooseBase(_CalRGBCS, _r13)[_r13], d, f);
  var p = _classPrivateFieldLooseBase(_CalRGBCS, _g3)[_g3];
  _classPrivateFieldLooseBase(this, _c2)[_c2](_classPrivateFieldLooseBase(_CalRGBCS, _s20)[_s20], f, p);
  i[a] = 255 * _classPrivateFieldLooseBase(this, _l2)[_l2](p[0]);
  i[a + 1] = 255 * _classPrivateFieldLooseBase(this, _l2)[_l2](p[1]);
  i[a + 2] = 255 * _classPrivateFieldLooseBase(this, _l2)[_l2](p[2]);
}
Object.defineProperty(CalRGBCS, _i36, {
  writable: true,
  value: new Float32Array([.8951, .2664, -.1614, -.7502, 1.7135, .0367, .0389, -.0685, 1.0296])
});
Object.defineProperty(CalRGBCS, _a28, {
  writable: true,
  value: new Float32Array([.9869929, -.1470543, .1599627, .4323053, .5183603, .0492912, -.0085287, .0400428, .9684867])
});
Object.defineProperty(CalRGBCS, _s20, {
  writable: true,
  value: new Float32Array([3.2404542, -1.5371385, -.4985314, -.969266, 1.8760108, .041556, .0556434, -.2040259, 1.0572252])
});
Object.defineProperty(CalRGBCS, _r13, {
  writable: true,
  value: new Float32Array([1, 1, 1])
});
Object.defineProperty(CalRGBCS, _n9, {
  writable: true,
  value: new Float32Array(3)
});
Object.defineProperty(CalRGBCS, _g3, {
  writable: true,
  value: new Float32Array(3)
});
Object.defineProperty(CalRGBCS, _o2, {
  writable: true,
  value: new Float32Array(3)
});
Object.defineProperty(CalRGBCS, _I, {
  writable: true,
  value: Math.pow(24 / 116, 3) / 8
});
var _f2 = /*#__PURE__*/_classPrivateFieldLooseKey("f");
var _p2 = /*#__PURE__*/_classPrivateFieldLooseKey("p");
var _t45 = /*#__PURE__*/_classPrivateFieldLooseKey("t");
var LabCS = /*#__PURE__*/function (_ColorSpace10) {
  function LabCS(_e38, _t47, _i38) {
    var _this15;
    _classCallCheck(this, LabCS);
    _this15 = _callSuper(this, LabCS, ["Lab", 3]);
    Object.defineProperty(_this15, _t45, {
      value: _t46
    });
    Object.defineProperty(_this15, _p2, {
      value: _p3
    });
    Object.defineProperty(_this15, _f2, {
      value: _f3
    });
    if (!_e38) throw new FormatError("WhitePoint missing - required for color space Lab");
    var _e39 = _slicedToArray(_e38, 3);
    _this15.XW = _e39[0];
    _this15.YW = _e39[1];
    _this15.ZW = _e39[2];
    var _ref22 = _i38 || [-100, 100, -100, 100];
    var _ref23 = _slicedToArray(_ref22, 4);
    _this15.amin = _ref23[0];
    _this15.amax = _ref23[1];
    _this15.bmin = _ref23[2];
    _this15.bmax = _ref23[3];
    var _ref24 = _t47 || [0, 0, 0];
    var _ref25 = _slicedToArray(_ref24, 3);
    _this15.XB = _ref25[0];
    _this15.YB = _ref25[1];
    _this15.ZB = _ref25[2];
    if (_this15.XW < 0 || _this15.ZW < 0 || 1 !== _this15.YW) throw new FormatError("Invalid WhitePoint components, no fallback available");
    if (_this15.XB < 0 || _this15.YB < 0 || _this15.ZB < 0) {
      info("Invalid BlackPoint, falling back to default");
      _this15.XB = _this15.YB = _this15.ZB = 0;
    }
    if (_this15.amin > _this15.amax || _this15.bmin > _this15.bmax) {
      info("Invalid Range, falling back to defaults");
      _this15.amin = -100;
      _this15.amax = 100;
      _this15.bmin = -100;
      _this15.bmax = 100;
    }
    return _this15;
  }
  _inherits(LabCS, _ColorSpace10);
  return _createClass(LabCS, [{
    key: "getRgbItem",
    value: function getRgbItem(e, t, i, a) {
      _classPrivateFieldLooseBase(this, _t45)[_t45](e, t, !1, i, a);
    }
  }, {
    key: "getRgbBuffer",
    value: function getRgbBuffer(e, t, i, a, s, r, n) {
      var g = (1 << r) - 1;
      for (var _r16 = 0; _r16 < i; _r16++) {
        _classPrivateFieldLooseBase(this, _t45)[_t45](e, t, g, a, s);
        t += 3;
        s += 3 + n;
      }
    }
  }, {
    key: "getOutputLength",
    value: function getOutputLength(e, t) {
      return e * (3 + t) / 3 | 0;
    }
  }, {
    key: "isDefaultDecode",
    value: function isDefaultDecode(e, t) {
      return !0;
    }
  }, {
    key: "usesZeroToOneRange",
    get: function get() {
      return shadow(this, "usesZeroToOneRange", !1);
    }
  }]);
}(ColorSpace);
function _f3(e) {
  return e >= 6 / 29 ? Math.pow(e, 3) : 108 / 841 * (e - 4 / 29);
}
function _p3(e, t, i, a) {
  return i + e * (a - i) / t;
}
function _t46(e, t, i, a, s) {
  var r = e[t],
    n = e[t + 1],
    g = e[t + 2];
  if (!1 !== i) {
    r = _classPrivateFieldLooseBase(this, _p2)[_p2](r, i, 0, 100);
    n = _classPrivateFieldLooseBase(this, _p2)[_p2](n, i, this.amin, this.amax);
    g = _classPrivateFieldLooseBase(this, _p2)[_p2](g, i, this.bmin, this.bmax);
  }
  n > this.amax ? n = this.amax : n < this.amin && (n = this.amin);
  g > this.bmax ? g = this.bmax : g < this.bmin && (g = this.bmin);
  var o = (r + 16) / 116,
    c = o + n / 500,
    C = o - g / 200,
    h = this.XW * _classPrivateFieldLooseBase(this, _f2)[_f2](c),
    l = this.YW * _classPrivateFieldLooseBase(this, _f2)[_f2](o),
    Q = this.ZW * _classPrivateFieldLooseBase(this, _f2)[_f2](C);
  var E, u, d;
  if (this.ZW < 1) {
    E = 3.1339 * h + -1.617 * l + -.4906 * Q;
    u = -.9785 * h + 1.916 * l + .0333 * Q;
    d = .072 * h + -.229 * l + 1.4057 * Q;
  } else {
    E = 3.2406 * h + -1.5372 * l + -.4986 * Q;
    u = -.9689 * h + 1.8758 * l + .0415 * Q;
    d = .0557 * h + -.204 * l + 1.057 * Q;
  }
  a[s] = 255 * Math.sqrt(E);
  a[s + 1] = 255 * Math.sqrt(u);
  a[s + 2] = 255 * Math.sqrt(d);
}
function hexToInt(e, t) {
  var i = 0;
  for (var _a30 = 0; _a30 <= t; _a30++) i = i << 8 | e[_a30];
  return i >>> 0;
}
function hexToStr(e, t) {
  return 1 === t ? String.fromCharCode(e[0], e[1]) : 3 === t ? String.fromCharCode(e[0], e[1], e[2], e[3]) : String.fromCharCode.apply(String, _toConsumableArray(e.subarray(0, t + 1)));
}
function addHex(e, t, i) {
  var a = 0;
  for (var _s22 = i; _s22 >= 0; _s22--) {
    a += e[_s22] + t[_s22];
    e[_s22] = 255 & a;
    a >>= 8;
  }
}
function incHex(e, t) {
  var i = 1;
  for (var _a31 = t; _a31 >= 0 && i > 0; _a31--) {
    i += e[_a31];
    e[_a31] = 255 & i;
    i >>= 8;
  }
}
var Nt = 16;
var BinaryCMapStream = /*#__PURE__*/function () {
  function BinaryCMapStream(e) {
    _classCallCheck(this, BinaryCMapStream);
    this.buffer = e;
    this.pos = 0;
    this.end = e.length;
    this.tmpBuf = new Uint8Array(19);
  }
  return _createClass(BinaryCMapStream, [{
    key: "readByte",
    value: function readByte() {
      return this.pos >= this.end ? -1 : this.buffer[this.pos++];
    }
  }, {
    key: "readNumber",
    value: function readNumber() {
      var e,
        t = 0;
      do {
        var _i39 = this.readByte();
        if (_i39 < 0) throw new FormatError("unexpected EOF in bcmap");
        e = !(128 & _i39);
        t = t << 7 | 127 & _i39;
      } while (!e);
      return t;
    }
  }, {
    key: "readSigned",
    value: function readSigned() {
      var e = this.readNumber();
      return 1 & e ? ~(e >>> 1) : e >>> 1;
    }
  }, {
    key: "readHex",
    value: function readHex(e, t) {
      e.set(this.buffer.subarray(this.pos, this.pos + t + 1));
      this.pos += t + 1;
    }
  }, {
    key: "readHexNumber",
    value: function readHexNumber(e, t) {
      var i;
      var a = this.tmpBuf;
      var s = 0;
      do {
        var _e40 = this.readByte();
        if (_e40 < 0) throw new FormatError("unexpected EOF in bcmap");
        i = !(128 & _e40);
        a[s++] = 127 & _e40;
      } while (!i);
      var r = t,
        n = 0,
        g = 0;
      for (; r >= 0;) {
        for (; g < 8 && a.length > 0;) {
          n |= a[--s] << g;
          g += 7;
        }
        e[r] = 255 & n;
        r--;
        n >>= 8;
        g -= 8;
      }
    }
  }, {
    key: "readHexSigned",
    value: function readHexSigned(e, t) {
      this.readHexNumber(e, t);
      var i = 1 & e[t] ? 255 : 0;
      var a = 0;
      for (var _s23 = 0; _s23 <= t; _s23++) {
        a = (1 & a) << 8 | e[_s23];
        e[_s23] = a >> 1 ^ i;
      }
    }
  }, {
    key: "readString",
    value: function readString() {
      var e = this.readNumber(),
        t = new Array(e);
      for (var _i40 = 0; _i40 < e; _i40++) t[_i40] = this.readNumber();
      return String.fromCharCode.apply(String, t);
    }
  }]);
}();
var BinaryCMapReader = /*#__PURE__*/function () {
  function BinaryCMapReader() {
    _classCallCheck(this, BinaryCMapReader);
  }
  return _createClass(BinaryCMapReader, [{
    key: "process",
    value: function () {
      var _process = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e, t, i) {
        var a, s, r, n, g, o, c, C, h, l, _e41, _i41, _s24, _Q4, _E4, _e42, _e43, _e44, _e45, _e46, _e47;
        return _regeneratorRuntime().wrap(function _callee6$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              a = new BinaryCMapStream(e), s = a.readByte();
              t.vertical = !!(1 & s);
              r = null;
              n = new Uint8Array(Nt), g = new Uint8Array(Nt), o = new Uint8Array(Nt), c = new Uint8Array(Nt), C = new Uint8Array(Nt);
            case 4:
              if (!((l = a.readByte()) >= 0)) {
                _context8.next = 60;
                break;
              }
              _e41 = l >> 5;
              if (!(7 === _e41)) {
                _context8.next = 14;
                break;
              }
              _context8.t0 = 31 & l;
              _context8.next = _context8.t0 === 0 ? 10 : _context8.t0 === 1 ? 12 : 13;
              break;
            case 10:
              a.readString();
              return _context8.abrupt("break", 13);
            case 12:
              r = a.readString();
            case 13:
              return _context8.abrupt("continue", 58);
            case 14:
              _i41 = !!(16 & l), _s24 = 15 & l;
              if (!(_s24 + 1 > Nt)) {
                _context8.next = 17;
                break;
              }
              throw new Error("BinaryCMapReader.process: Invalid dataSize.");
            case 17:
              _Q4 = 1, _E4 = a.readNumber();
              _context8.t1 = _e41;
              _context8.next = _context8.t1 === 0 ? 21 : _context8.t1 === 1 ? 27 : _context8.t1 === 2 ? 33 : _context8.t1 === 3 ? 38 : _context8.t1 === 4 ? 45 : _context8.t1 === 5 ? 50 : 57;
              break;
            case 21:
              a.readHex(n, _s24);
              a.readHexNumber(g, _s24);
              addHex(g, n, _s24);
              t.addCodespaceRange(_s24 + 1, hexToInt(n, _s24), hexToInt(g, _s24));
              for (_e42 = 1; _e42 < _E4; _e42++) {
                incHex(g, _s24);
                a.readHexNumber(n, _s24);
                addHex(n, g, _s24);
                a.readHexNumber(g, _s24);
                addHex(g, n, _s24);
                t.addCodespaceRange(_s24 + 1, hexToInt(n, _s24), hexToInt(g, _s24));
              }
              return _context8.abrupt("break", 58);
            case 27:
              a.readHex(n, _s24);
              a.readHexNumber(g, _s24);
              addHex(g, n, _s24);
              a.readNumber();
              for (_e43 = 1; _e43 < _E4; _e43++) {
                incHex(g, _s24);
                a.readHexNumber(n, _s24);
                addHex(n, g, _s24);
                a.readHexNumber(g, _s24);
                addHex(g, n, _s24);
                a.readNumber();
              }
              return _context8.abrupt("break", 58);
            case 33:
              a.readHex(o, _s24);
              h = a.readNumber();
              t.mapOne(hexToInt(o, _s24), h);
              for (_e44 = 1; _e44 < _E4; _e44++) {
                incHex(o, _s24);
                if (!_i41) {
                  a.readHexNumber(C, _s24);
                  addHex(o, C, _s24);
                }
                h = a.readSigned() + (h + 1);
                t.mapOne(hexToInt(o, _s24), h);
              }
              return _context8.abrupt("break", 58);
            case 38:
              a.readHex(n, _s24);
              a.readHexNumber(g, _s24);
              addHex(g, n, _s24);
              h = a.readNumber();
              t.mapCidRange(hexToInt(n, _s24), hexToInt(g, _s24), h);
              for (_e45 = 1; _e45 < _E4; _e45++) {
                incHex(g, _s24);
                if (_i41) n.set(g);else {
                  a.readHexNumber(n, _s24);
                  addHex(n, g, _s24);
                }
                a.readHexNumber(g, _s24);
                addHex(g, n, _s24);
                h = a.readNumber();
                t.mapCidRange(hexToInt(n, _s24), hexToInt(g, _s24), h);
              }
              return _context8.abrupt("break", 58);
            case 45:
              a.readHex(o, _Q4);
              a.readHex(c, _s24);
              t.mapOne(hexToInt(o, _Q4), hexToStr(c, _s24));
              for (_e46 = 1; _e46 < _E4; _e46++) {
                incHex(o, _Q4);
                if (!_i41) {
                  a.readHexNumber(C, _Q4);
                  addHex(o, C, _Q4);
                }
                incHex(c, _s24);
                a.readHexSigned(C, _s24);
                addHex(c, C, _s24);
                t.mapOne(hexToInt(o, _Q4), hexToStr(c, _s24));
              }
              return _context8.abrupt("break", 58);
            case 50:
              a.readHex(n, _Q4);
              a.readHexNumber(g, _Q4);
              addHex(g, n, _Q4);
              a.readHex(c, _s24);
              t.mapBfRange(hexToInt(n, _Q4), hexToInt(g, _Q4), hexToStr(c, _s24));
              for (_e47 = 1; _e47 < _E4; _e47++) {
                incHex(g, _Q4);
                if (_i41) n.set(g);else {
                  a.readHexNumber(n, _Q4);
                  addHex(n, g, _Q4);
                }
                a.readHexNumber(g, _Q4);
                addHex(g, n, _Q4);
                a.readHex(c, _s24);
                t.mapBfRange(hexToInt(n, _Q4), hexToInt(g, _Q4), hexToStr(c, _s24));
              }
              return _context8.abrupt("break", 58);
            case 57:
              throw new Error("BinaryCMapReader.process - unknown type: ".concat(_e41));
            case 58:
              _context8.next = 4;
              break;
            case 60:
              return _context8.abrupt("return", r ? i(r) : t);
            case 61:
            case "end":
              return _context8.stop();
          }
        }, _callee6);
      }));
      function process(_x7, _x8, _x9) {
        return _process.apply(this, arguments);
      }
      return process;
    }()
  }]);
}();
var Gt = new Uint8Array(0);
var DecodeStream = /*#__PURE__*/function (_BaseStream2) {
  function DecodeStream(e) {
    var _this16;
    _classCallCheck(this, DecodeStream);
    _this16 = _callSuper(this, DecodeStream);
    _this16._rawMinBufferLength = e || 0;
    _this16.pos = 0;
    _this16.bufferLength = 0;
    _this16.eof = !1;
    _this16.buffer = Gt;
    _this16.minBufferLength = 512;
    if (e) for (; _this16.minBufferLength < e;) _this16.minBufferLength *= 2;
    return _this16;
  }
  _inherits(DecodeStream, _BaseStream2);
  return _createClass(DecodeStream, [{
    key: "isEmpty",
    get: function get() {
      for (; !this.eof && 0 === this.bufferLength;) this.readBlock();
      return 0 === this.bufferLength;
    }
  }, {
    key: "ensureBuffer",
    value: function ensureBuffer(e) {
      var t = this.buffer;
      if (e <= t.byteLength) return t;
      var i = this.minBufferLength;
      for (; i < e;) i *= 2;
      var a = new Uint8Array(i);
      a.set(t);
      return this.buffer = a;
    }
  }, {
    key: "getByte",
    value: function getByte() {
      var e = this.pos;
      for (; this.bufferLength <= e;) {
        if (this.eof) return -1;
        this.readBlock();
      }
      return this.buffer[this.pos++];
    }
  }, {
    key: "getBytes",
    value: function getBytes(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var i = this.pos;
      var a;
      if (e) {
        this.ensureBuffer(i + e);
        a = i + e;
        for (; !this.eof && this.bufferLength < a;) this.readBlock(t);
        var _s25 = this.bufferLength;
        a > _s25 && (a = _s25);
      } else {
        for (; !this.eof;) this.readBlock(t);
        a = this.bufferLength;
      }
      this.pos = a;
      return this.buffer.subarray(i, a);
    }
  }, {
    key: "getImageData",
    value: function () {
      var _getImageData2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(e) {
        var t,
          i,
          _args9 = arguments;
        return _regeneratorRuntime().wrap(function _callee7$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              t = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : null;
              if (this.canAsyncDecodeImageFromBuffer) {
                _context9.next = 3;
                break;
              }
              return _context9.abrupt("return", this.getBytes(e, t));
            case 3:
              _context9.next = 5;
              return this.stream.asyncGetBytes();
            case 5:
              i = _context9.sent;
              return _context9.abrupt("return", this.decodeImage(i, t));
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee7, this);
      }));
      function getImageData(_x10) {
        return _getImageData2.apply(this, arguments);
      }
      return getImageData;
    }()
  }, {
    key: "reset",
    value: function reset() {
      this.pos = 0;
    }
  }, {
    key: "makeSubStream",
    value: function makeSubStream(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (void 0 === t) for (; !this.eof;) this.readBlock();else {
        var _i42 = e + t;
        for (; this.bufferLength <= _i42 && !this.eof;) this.readBlock();
      }
      return new Stream(this.buffer, e, t, i);
    }
  }, {
    key: "getBaseStreams",
    value: function getBaseStreams() {
      return this.str ? this.str.getBaseStreams() : null;
    }
  }]);
}(BaseStream);
var StreamsSequenceStream = /*#__PURE__*/function (_DecodeStream) {
  function StreamsSequenceStream(e) {
    var _this17;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, StreamsSequenceStream);
    e = e.filter(function (e) {
      return e instanceof BaseStream;
    });
    var i = 0;
    var _iterator17 = _createForOfIteratorHelper(e),
      _step17;
    try {
      for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
        var _t48 = _step17.value;
        i += _t48 instanceof DecodeStream ? _t48._rawMinBufferLength : _t48.length;
      }
    } catch (err) {
      _iterator17.e(err);
    } finally {
      _iterator17.f();
    }
    _this17 = _callSuper(this, StreamsSequenceStream, [i]);
    _this17.streams = e;
    _this17._onError = t;
    return _this17;
  }
  _inherits(StreamsSequenceStream, _DecodeStream);
  return _createClass(StreamsSequenceStream, [{
    key: "readBlock",
    value: function readBlock() {
      var e = this.streams;
      if (0 === e.length) {
        this.eof = !0;
        return;
      }
      var t = e.shift();
      var i;
      try {
        i = t.getBytes();
      } catch (e) {
        if (this._onError) {
          var _t$dict;
          this._onError(e, (_t$dict = t.dict) === null || _t$dict === void 0 ? void 0 : _t$dict.objId);
          return;
        }
        throw e;
      }
      var a = this.bufferLength,
        s = a + i.length;
      this.ensureBuffer(s).set(i, a);
      this.bufferLength = s;
    }
  }, {
    key: "getBaseStreams",
    value: function getBaseStreams() {
      var e = [];
      var _iterator18 = _createForOfIteratorHelper(this.streams),
        _step18;
      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var _t49 = _step18.value;
          var _i43 = _t49.getBaseStreams();
          _i43 && e.push.apply(e, _toConsumableArray(_i43));
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
      return e.length > 0 ? e : null;
    }
  }]);
}(DecodeStream);
var Ascii85Stream = /*#__PURE__*/function (_DecodeStream2) {
  function Ascii85Stream(e, t) {
    var _this18;
    _classCallCheck(this, Ascii85Stream);
    t && (t *= .8);
    _this18 = _callSuper(this, Ascii85Stream, [t]);
    _this18.str = e;
    _this18.dict = e.dict;
    _this18.input = new Uint8Array(5);
    return _this18;
  }
  _inherits(Ascii85Stream, _DecodeStream2);
  return _createClass(Ascii85Stream, [{
    key: "readBlock",
    value: function readBlock() {
      var e = this.str;
      var t = e.getByte();
      for (; isWhiteSpace(t);) t = e.getByte();
      if (-1 === t || 126 === t) {
        this.eof = !0;
        return;
      }
      var i = this.bufferLength;
      var a, s;
      if (122 === t) {
        a = this.ensureBuffer(i + 4);
        for (s = 0; s < 4; ++s) a[i + s] = 0;
        this.bufferLength += 4;
      } else {
        var _r17 = this.input;
        _r17[0] = t;
        for (s = 1; s < 5; ++s) {
          t = e.getByte();
          for (; isWhiteSpace(t);) t = e.getByte();
          _r17[s] = t;
          if (-1 === t || 126 === t) break;
        }
        a = this.ensureBuffer(i + s - 1);
        this.bufferLength += s - 1;
        if (s < 5) {
          for (; s < 5; ++s) _r17[s] = 117;
          this.eof = !0;
        }
        var _n11 = 0;
        for (s = 0; s < 5; ++s) _n11 = 85 * _n11 + (_r17[s] - 33);
        for (s = 3; s >= 0; --s) {
          a[i + s] = 255 & _n11;
          _n11 >>= 8;
        }
      }
    }
  }]);
}(DecodeStream);
var AsciiHexStream = /*#__PURE__*/function (_DecodeStream3) {
  function AsciiHexStream(e, t) {
    var _this19;
    _classCallCheck(this, AsciiHexStream);
    t && (t *= .5);
    _this19 = _callSuper(this, AsciiHexStream, [t]);
    _this19.str = e;
    _this19.dict = e.dict;
    _this19.firstDigit = -1;
    return _this19;
  }
  _inherits(AsciiHexStream, _DecodeStream3);
  return _createClass(AsciiHexStream, [{
    key: "readBlock",
    value: function readBlock() {
      var e = this.str.getBytes(8e3);
      if (!e.length) {
        this.eof = !0;
        return;
      }
      var t = e.length + 1 >> 1,
        i = this.ensureBuffer(this.bufferLength + t);
      var a = this.bufferLength,
        s = this.firstDigit;
      var _iterator19 = _createForOfIteratorHelper(e),
        _step19;
      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var _t50 = _step19.value;
          var _e48 = void 0;
          if (_t50 >= 48 && _t50 <= 57) _e48 = 15 & _t50;else {
            if (!(_t50 >= 65 && _t50 <= 70 || _t50 >= 97 && _t50 <= 102)) {
              if (62 === _t50) {
                this.eof = !0;
                break;
              }
              continue;
            }
            _e48 = 9 + (15 & _t50);
          }
          if (s < 0) s = _e48;else {
            i[a++] = s << 4 | _e48;
            s = -1;
          }
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
      if (s >= 0 && this.eof) {
        i[a++] = s << 4;
        s = -1;
      }
      this.firstDigit = s;
      this.bufferLength = a;
    }
  }]);
}(DecodeStream);
var xt = -1,
  Ut = [[-1, -1], [-1, -1], [7, 8], [7, 7], [6, 6], [6, 6], [6, 5], [6, 5], [4, 0], [4, 0], [4, 0], [4, 0], [4, 0], [4, 0], [4, 0], [4, 0], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2]],
  Mt = [[-1, -1], [12, -2], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [12, 1984], [12, 2048], [12, 2112], [12, 2176], [12, 2240], [12, 2304], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [12, 2368], [12, 2432], [12, 2496], [12, 2560]],
  Lt = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [8, 29], [8, 29], [8, 30], [8, 30], [8, 45], [8, 45], [8, 46], [8, 46], [7, 22], [7, 22], [7, 22], [7, 22], [7, 23], [7, 23], [7, 23], [7, 23], [8, 47], [8, 47], [8, 48], [8, 48], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [7, 20], [7, 20], [7, 20], [7, 20], [8, 33], [8, 33], [8, 34], [8, 34], [8, 35], [8, 35], [8, 36], [8, 36], [8, 37], [8, 37], [8, 38], [8, 38], [7, 19], [7, 19], [7, 19], [7, 19], [8, 31], [8, 31], [8, 32], [8, 32], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [8, 53], [8, 53], [8, 54], [8, 54], [7, 26], [7, 26], [7, 26], [7, 26], [8, 39], [8, 39], [8, 40], [8, 40], [8, 41], [8, 41], [8, 42], [8, 42], [8, 43], [8, 43], [8, 44], [8, 44], [7, 21], [7, 21], [7, 21], [7, 21], [7, 28], [7, 28], [7, 28], [7, 28], [8, 61], [8, 61], [8, 62], [8, 62], [8, 63], [8, 63], [8, 0], [8, 0], [8, 320], [8, 320], [8, 384], [8, 384], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [7, 27], [7, 27], [7, 27], [7, 27], [8, 59], [8, 59], [8, 60], [8, 60], [9, 1472], [9, 1536], [9, 1600], [9, 1728], [7, 18], [7, 18], [7, 18], [7, 18], [7, 24], [7, 24], [7, 24], [7, 24], [8, 49], [8, 49], [8, 50], [8, 50], [8, 51], [8, 51], [8, 52], [8, 52], [7, 25], [7, 25], [7, 25], [7, 25], [8, 55], [8, 55], [8, 56], [8, 56], [8, 57], [8, 57], [8, 58], [8, 58], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [8, 448], [8, 448], [8, 512], [8, 512], [9, 704], [9, 768], [8, 640], [8, 640], [8, 576], [8, 576], [9, 832], [9, 896], [9, 960], [9, 1024], [9, 1088], [9, 1152], [9, 1216], [9, 1280], [9, 1344], [9, 1408], [7, 256], [7, 256], [7, 256], [7, 256], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7]],
  Ht = [[-1, -1], [-1, -1], [12, -2], [12, -2], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [11, 1792], [11, 1792], [12, 1984], [12, 1984], [12, 2048], [12, 2048], [12, 2112], [12, 2112], [12, 2176], [12, 2176], [12, 2240], [12, 2240], [12, 2304], [12, 2304], [11, 1856], [11, 1856], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [11, 1920], [11, 1920], [12, 2368], [12, 2368], [12, 2432], [12, 2432], [12, 2496], [12, 2496], [12, 2560], [12, 2560], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [12, 52], [12, 52], [13, 640], [13, 704], [13, 768], [13, 832], [12, 55], [12, 55], [12, 56], [12, 56], [13, 1280], [13, 1344], [13, 1408], [13, 1472], [12, 59], [12, 59], [12, 60], [12, 60], [13, 1536], [13, 1600], [11, 24], [11, 24], [11, 24], [11, 24], [11, 25], [11, 25], [11, 25], [11, 25], [13, 1664], [13, 1728], [12, 320], [12, 320], [12, 384], [12, 384], [12, 448], [12, 448], [13, 512], [13, 576], [12, 53], [12, 53], [12, 54], [12, 54], [13, 896], [13, 960], [13, 1024], [13, 1088], [13, 1152], [13, 1216], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64]],
  Jt = [[8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [11, 23], [11, 23], [12, 50], [12, 51], [12, 44], [12, 45], [12, 46], [12, 47], [12, 57], [12, 58], [12, 61], [12, 256], [10, 16], [10, 16], [10, 16], [10, 16], [10, 17], [10, 17], [10, 17], [10, 17], [12, 48], [12, 49], [12, 62], [12, 63], [12, 30], [12, 31], [12, 32], [12, 33], [12, 40], [12, 41], [11, 22], [11, 22], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [12, 128], [12, 192], [12, 26], [12, 27], [12, 28], [12, 29], [11, 19], [11, 19], [11, 20], [11, 20], [12, 34], [12, 35], [12, 36], [12, 37], [12, 38], [12, 39], [11, 21], [11, 21], [12, 42], [12, 43], [10, 0], [10, 0], [10, 0], [10, 0], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12]],
  Yt = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [6, 9], [6, 8], [5, 7], [5, 7], [4, 6], [4, 6], [4, 6], [4, 6], [4, 5], [4, 5], [4, 5], [4, 5], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2]];
var CCITTFaxDecoder = /*#__PURE__*/function () {
  function CCITTFaxDecoder(e) {
    var _t$EndOfBlock;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, CCITTFaxDecoder);
    if (!e || "function" != typeof e.next) throw new Error('CCITTFaxDecoder - invalid "source" parameter.');
    this.source = e;
    this.eof = !1;
    this.encoding = t.K || 0;
    this.eoline = t.EndOfLine || !1;
    this.byteAlign = t.EncodedByteAlign || !1;
    this.columns = t.Columns || 1728;
    this.rows = t.Rows || 0;
    this.eoblock = (_t$EndOfBlock = t.EndOfBlock) !== null && _t$EndOfBlock !== void 0 ? _t$EndOfBlock : !0;
    this.black = t.BlackIs1 || !1;
    this.codingLine = new Uint32Array(this.columns + 1);
    this.refLine = new Uint32Array(this.columns + 2);
    this.codingLine[0] = this.columns;
    this.codingPos = 0;
    this.row = 0;
    this.nextLine2D = this.encoding < 0;
    this.inputBits = 0;
    this.inputBuf = 0;
    this.outputBits = 0;
    this.rowsDone = !1;
    var i;
    for (; 0 === (i = this._lookBits(12));) this._eatBits(1);
    1 === i && this._eatBits(12);
    if (this.encoding > 0) {
      this.nextLine2D = !this._lookBits(1);
      this._eatBits(1);
    }
  }
  return _createClass(CCITTFaxDecoder, [{
    key: "readNextChar",
    value: function readNextChar() {
      if (this.eof) return -1;
      var e = this.refLine,
        t = this.codingLine,
        i = this.columns;
      var a, s, r, n, g;
      if (0 === this.outputBits) {
        this.rowsDone && (this.eof = !0);
        if (this.eof) return -1;
        this.err = !1;
        var _r18, _g5, _o4;
        if (this.nextLine2D) {
          for (n = 0; t[n] < i; ++n) e[n] = t[n];
          e[n++] = i;
          e[n] = i;
          t[0] = 0;
          this.codingPos = 0;
          a = 0;
          s = 0;
          for (; t[this.codingPos] < i;) {
            _r18 = this._getTwoDimCode();
            switch (_r18) {
              case 0:
                this._addPixels(e[a + 1], s);
                e[a + 1] < i && (a += 2);
                break;
              case 1:
                _r18 = _g5 = 0;
                if (s) {
                  do {
                    _r18 += _o4 = this._getBlackCode();
                  } while (_o4 >= 64);
                  do {
                    _g5 += _o4 = this._getWhiteCode();
                  } while (_o4 >= 64);
                } else {
                  do {
                    _r18 += _o4 = this._getWhiteCode();
                  } while (_o4 >= 64);
                  do {
                    _g5 += _o4 = this._getBlackCode();
                  } while (_o4 >= 64);
                }
                this._addPixels(t[this.codingPos] + _r18, s);
                t[this.codingPos] < i && this._addPixels(t[this.codingPos] + _g5, 1 ^ s);
                for (; e[a] <= t[this.codingPos] && e[a] < i;) a += 2;
                break;
              case 7:
                this._addPixels(e[a] + 3, s);
                s ^= 1;
                if (t[this.codingPos] < i) {
                  ++a;
                  for (; e[a] <= t[this.codingPos] && e[a] < i;) a += 2;
                }
                break;
              case 5:
                this._addPixels(e[a] + 2, s);
                s ^= 1;
                if (t[this.codingPos] < i) {
                  ++a;
                  for (; e[a] <= t[this.codingPos] && e[a] < i;) a += 2;
                }
                break;
              case 3:
                this._addPixels(e[a] + 1, s);
                s ^= 1;
                if (t[this.codingPos] < i) {
                  ++a;
                  for (; e[a] <= t[this.codingPos] && e[a] < i;) a += 2;
                }
                break;
              case 2:
                this._addPixels(e[a], s);
                s ^= 1;
                if (t[this.codingPos] < i) {
                  ++a;
                  for (; e[a] <= t[this.codingPos] && e[a] < i;) a += 2;
                }
                break;
              case 8:
                this._addPixelsNeg(e[a] - 3, s);
                s ^= 1;
                if (t[this.codingPos] < i) {
                  a > 0 ? --a : ++a;
                  for (; e[a] <= t[this.codingPos] && e[a] < i;) a += 2;
                }
                break;
              case 6:
                this._addPixelsNeg(e[a] - 2, s);
                s ^= 1;
                if (t[this.codingPos] < i) {
                  a > 0 ? --a : ++a;
                  for (; e[a] <= t[this.codingPos] && e[a] < i;) a += 2;
                }
                break;
              case 4:
                this._addPixelsNeg(e[a] - 1, s);
                s ^= 1;
                if (t[this.codingPos] < i) {
                  a > 0 ? --a : ++a;
                  for (; e[a] <= t[this.codingPos] && e[a] < i;) a += 2;
                }
                break;
              case xt:
                this._addPixels(i, 0);
                this.eof = !0;
                break;
              default:
                info("bad 2d code");
                this._addPixels(i, 0);
                this.err = !0;
            }
          }
        } else {
          t[0] = 0;
          this.codingPos = 0;
          s = 0;
          for (; t[this.codingPos] < i;) {
            _r18 = 0;
            if (s) do {
              _r18 += _o4 = this._getBlackCode();
            } while (_o4 >= 64);else do {
              _r18 += _o4 = this._getWhiteCode();
            } while (_o4 >= 64);
            this._addPixels(t[this.codingPos] + _r18, s);
            s ^= 1;
          }
        }
        var _c5 = !1;
        this.byteAlign && (this.inputBits &= -8);
        if (this.eoblock || this.row !== this.rows - 1) {
          _r18 = this._lookBits(12);
          if (this.eoline) for (; _r18 !== xt && 1 !== _r18;) {
            this._eatBits(1);
            _r18 = this._lookBits(12);
          } else for (; 0 === _r18;) {
            this._eatBits(1);
            _r18 = this._lookBits(12);
          }
          if (1 === _r18) {
            this._eatBits(12);
            _c5 = !0;
          } else _r18 === xt && (this.eof = !0);
        } else this.rowsDone = !0;
        if (!this.eof && this.encoding > 0 && !this.rowsDone) {
          this.nextLine2D = !this._lookBits(1);
          this._eatBits(1);
        }
        if (this.eoblock && _c5 && this.byteAlign) {
          _r18 = this._lookBits(12);
          if (1 === _r18) {
            this._eatBits(12);
            if (this.encoding > 0) {
              this._lookBits(1);
              this._eatBits(1);
            }
            if (this.encoding >= 0) for (n = 0; n < 4; ++n) {
              _r18 = this._lookBits(12);
              1 !== _r18 && info("bad rtc code: " + _r18);
              this._eatBits(12);
              if (this.encoding > 0) {
                this._lookBits(1);
                this._eatBits(1);
              }
            }
            this.eof = !0;
          }
        } else if (this.err && this.eoline) {
          for (;;) {
            _r18 = this._lookBits(13);
            if (_r18 === xt) {
              this.eof = !0;
              return -1;
            }
            if (_r18 >> 1 == 1) break;
            this._eatBits(1);
          }
          this._eatBits(12);
          if (this.encoding > 0) {
            this._eatBits(1);
            this.nextLine2D = !(1 & _r18);
          }
        }
        this.outputBits = t[0] > 0 ? t[this.codingPos = 0] : t[this.codingPos = 1];
        this.row++;
      }
      if (this.outputBits >= 8) {
        g = 1 & this.codingPos ? 0 : 255;
        this.outputBits -= 8;
        if (0 === this.outputBits && t[this.codingPos] < i) {
          this.codingPos++;
          this.outputBits = t[this.codingPos] - t[this.codingPos - 1];
        }
      } else {
        r = 8;
        g = 0;
        do {
          if ("number" != typeof this.outputBits) throw new FormatError('Invalid /CCITTFaxDecode data, "outputBits" must be a number.');
          if (this.outputBits > r) {
            g <<= r;
            1 & this.codingPos || (g |= 255 >> 8 - r);
            this.outputBits -= r;
            r = 0;
          } else {
            g <<= this.outputBits;
            1 & this.codingPos || (g |= 255 >> 8 - this.outputBits);
            r -= this.outputBits;
            this.outputBits = 0;
            if (t[this.codingPos] < i) {
              this.codingPos++;
              this.outputBits = t[this.codingPos] - t[this.codingPos - 1];
            } else if (r > 0) {
              g <<= r;
              r = 0;
            }
          }
        } while (r);
      }
      this.black && (g ^= 255);
      return g;
    }
  }, {
    key: "_addPixels",
    value: function _addPixels(e, t) {
      var i = this.codingLine;
      var a = this.codingPos;
      if (e > i[a]) {
        if (e > this.columns) {
          info("row is wrong length");
          this.err = !0;
          e = this.columns;
        }
        1 & a ^ t && ++a;
        i[a] = e;
      }
      this.codingPos = a;
    }
  }, {
    key: "_addPixelsNeg",
    value: function _addPixelsNeg(e, t) {
      var i = this.codingLine;
      var a = this.codingPos;
      if (e > i[a]) {
        if (e > this.columns) {
          info("row is wrong length");
          this.err = !0;
          e = this.columns;
        }
        1 & a ^ t && ++a;
        i[a] = e;
      } else if (e < i[a]) {
        if (e < 0) {
          info("invalid code");
          this.err = !0;
          e = 0;
        }
        for (; a > 0 && e < i[a - 1];) --a;
        i[a] = e;
      }
      this.codingPos = a;
    }
  }, {
    key: "_findTableCode",
    value: function _findTableCode(e, t, i, a) {
      var s = a || 0;
      for (var _a32 = e; _a32 <= t; ++_a32) {
        var _e49 = this._lookBits(_a32);
        if (_e49 === xt) return [!0, 1, !1];
        _a32 < t && (_e49 <<= t - _a32);
        if (!s || _e49 >= s) {
          var _t51 = i[_e49 - s];
          if (_t51[0] === _a32) {
            this._eatBits(_a32);
            return [!0, _t51[1], !0];
          }
        }
      }
      return [!1, 0, !1];
    }
  }, {
    key: "_getTwoDimCode",
    value: function _getTwoDimCode() {
      var e,
        t = 0;
      if (this.eoblock) {
        var _e50;
        t = this._lookBits(7);
        e = Ut[t];
        if (((_e50 = e) === null || _e50 === void 0 ? void 0 : _e50[0]) > 0) {
          this._eatBits(e[0]);
          return e[1];
        }
      } else {
        var _e51 = this._findTableCode(1, 7, Ut);
        if (_e51[0] && _e51[2]) return _e51[1];
      }
      info("Bad two dim code");
      return xt;
    }
  }, {
    key: "_getWhiteCode",
    value: function _getWhiteCode() {
      var e,
        t = 0;
      if (this.eoblock) {
        t = this._lookBits(12);
        if (t === xt) return 1;
        e = t >> 5 == 0 ? Mt[t] : Lt[t >> 3];
        if (e[0] > 0) {
          this._eatBits(e[0]);
          return e[1];
        }
      } else {
        var _e52 = this._findTableCode(1, 9, Lt);
        if (_e52[0]) return _e52[1];
        _e52 = this._findTableCode(11, 12, Mt);
        if (_e52[0]) return _e52[1];
      }
      info("bad white code");
      this._eatBits(1);
      return 1;
    }
  }, {
    key: "_getBlackCode",
    value: function _getBlackCode() {
      var e, t;
      if (this.eoblock) {
        e = this._lookBits(13);
        if (e === xt) return 1;
        t = e >> 7 == 0 ? Ht[e] : e >> 9 == 0 && e >> 7 != 0 ? Jt[(e >> 1) - 64] : Yt[e >> 7];
        if (t[0] > 0) {
          this._eatBits(t[0]);
          return t[1];
        }
      } else {
        var _e53 = this._findTableCode(2, 6, Yt);
        if (_e53[0]) return _e53[1];
        _e53 = this._findTableCode(7, 12, Jt, 64);
        if (_e53[0]) return _e53[1];
        _e53 = this._findTableCode(10, 13, Ht);
        if (_e53[0]) return _e53[1];
      }
      info("bad black code");
      this._eatBits(1);
      return 1;
    }
  }, {
    key: "_lookBits",
    value: function _lookBits(e) {
      var t;
      for (; this.inputBits < e;) {
        if (-1 === (t = this.source.next())) return 0 === this.inputBits ? xt : this.inputBuf << e - this.inputBits & 65535 >> 16 - e;
        this.inputBuf = this.inputBuf << 8 | t;
        this.inputBits += 8;
      }
      return this.inputBuf >> this.inputBits - e & 65535 >> 16 - e;
    }
  }, {
    key: "_eatBits",
    value: function _eatBits(e) {
      (this.inputBits -= e) < 0 && (this.inputBits = 0);
    }
  }]);
}();
var CCITTFaxStream = /*#__PURE__*/function (_DecodeStream4) {
  function CCITTFaxStream(e, t, i) {
    var _this20;
    _classCallCheck(this, CCITTFaxStream);
    _this20 = _callSuper(this, CCITTFaxStream, [t]);
    _this20.str = e;
    _this20.dict = e.dict;
    i instanceof Dict || (i = Dict.empty);
    var a = {
      next: function next() {
        return e.getByte();
      }
    };
    _this20.ccittFaxDecoder = new CCITTFaxDecoder(a, {
      K: i.get("K"),
      EndOfLine: i.get("EndOfLine"),
      EncodedByteAlign: i.get("EncodedByteAlign"),
      Columns: i.get("Columns"),
      Rows: i.get("Rows"),
      EndOfBlock: i.get("EndOfBlock"),
      BlackIs1: i.get("BlackIs1")
    });
    return _this20;
  }
  _inherits(CCITTFaxStream, _DecodeStream4);
  return _createClass(CCITTFaxStream, [{
    key: "readBlock",
    value: function readBlock() {
      for (; !this.eof;) {
        var _e54 = this.ccittFaxDecoder.readNextChar();
        if (-1 === _e54) {
          this.eof = !0;
          return;
        }
        this.ensureBuffer(this.bufferLength + 1);
        this.buffer[this.bufferLength++] = _e54;
      }
    }
  }]);
}(DecodeStream);
var vt = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
  Kt = new Int32Array([3, 4, 5, 6, 7, 8, 9, 10, 65547, 65549, 65551, 65553, 131091, 131095, 131099, 131103, 196643, 196651, 196659, 196667, 262211, 262227, 262243, 262259, 327811, 327843, 327875, 327907, 258, 258, 258]),
  Tt = new Int32Array([1, 2, 3, 4, 65541, 65543, 131081, 131085, 196625, 196633, 262177, 262193, 327745, 327777, 393345, 393409, 459009, 459137, 524801, 525057, 590849, 591361, 657409, 658433, 724993, 727041, 794625, 798721, 868353, 876545]),
  qt = [new Int32Array([459008, 524368, 524304, 524568, 459024, 524400, 524336, 590016, 459016, 524384, 524320, 589984, 524288, 524416, 524352, 590048, 459012, 524376, 524312, 589968, 459028, 524408, 524344, 590032, 459020, 524392, 524328, 59e4, 524296, 524424, 524360, 590064, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590024, 459018, 524388, 524324, 589992, 524292, 524420, 524356, 590056, 459014, 524380, 524316, 589976, 459030, 524412, 524348, 590040, 459022, 524396, 524332, 590008, 524300, 524428, 524364, 590072, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590020, 459017, 524386, 524322, 589988, 524290, 524418, 524354, 590052, 459013, 524378, 524314, 589972, 459029, 524410, 524346, 590036, 459021, 524394, 524330, 590004, 524298, 524426, 524362, 590068, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590028, 459019, 524390, 524326, 589996, 524294, 524422, 524358, 590060, 459015, 524382, 524318, 589980, 459031, 524414, 524350, 590044, 459023, 524398, 524334, 590012, 524302, 524430, 524366, 590076, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590018, 459016, 524385, 524321, 589986, 524289, 524417, 524353, 590050, 459012, 524377, 524313, 589970, 459028, 524409, 524345, 590034, 459020, 524393, 524329, 590002, 524297, 524425, 524361, 590066, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590026, 459018, 524389, 524325, 589994, 524293, 524421, 524357, 590058, 459014, 524381, 524317, 589978, 459030, 524413, 524349, 590042, 459022, 524397, 524333, 590010, 524301, 524429, 524365, 590074, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590022, 459017, 524387, 524323, 589990, 524291, 524419, 524355, 590054, 459013, 524379, 524315, 589974, 459029, 524411, 524347, 590038, 459021, 524395, 524331, 590006, 524299, 524427, 524363, 590070, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590030, 459019, 524391, 524327, 589998, 524295, 524423, 524359, 590062, 459015, 524383, 524319, 589982, 459031, 524415, 524351, 590046, 459023, 524399, 524335, 590014, 524303, 524431, 524367, 590078, 459008, 524368, 524304, 524568, 459024, 524400, 524336, 590017, 459016, 524384, 524320, 589985, 524288, 524416, 524352, 590049, 459012, 524376, 524312, 589969, 459028, 524408, 524344, 590033, 459020, 524392, 524328, 590001, 524296, 524424, 524360, 590065, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590025, 459018, 524388, 524324, 589993, 524292, 524420, 524356, 590057, 459014, 524380, 524316, 589977, 459030, 524412, 524348, 590041, 459022, 524396, 524332, 590009, 524300, 524428, 524364, 590073, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590021, 459017, 524386, 524322, 589989, 524290, 524418, 524354, 590053, 459013, 524378, 524314, 589973, 459029, 524410, 524346, 590037, 459021, 524394, 524330, 590005, 524298, 524426, 524362, 590069, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590029, 459019, 524390, 524326, 589997, 524294, 524422, 524358, 590061, 459015, 524382, 524318, 589981, 459031, 524414, 524350, 590045, 459023, 524398, 524334, 590013, 524302, 524430, 524366, 590077, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590019, 459016, 524385, 524321, 589987, 524289, 524417, 524353, 590051, 459012, 524377, 524313, 589971, 459028, 524409, 524345, 590035, 459020, 524393, 524329, 590003, 524297, 524425, 524361, 590067, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590027, 459018, 524389, 524325, 589995, 524293, 524421, 524357, 590059, 459014, 524381, 524317, 589979, 459030, 524413, 524349, 590043, 459022, 524397, 524333, 590011, 524301, 524429, 524365, 590075, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590023, 459017, 524387, 524323, 589991, 524291, 524419, 524355, 590055, 459013, 524379, 524315, 589975, 459029, 524411, 524347, 590039, 459021, 524395, 524331, 590007, 524299, 524427, 524363, 590071, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590031, 459019, 524391, 524327, 589999, 524295, 524423, 524359, 590063, 459015, 524383, 524319, 589983, 459031, 524415, 524351, 590047, 459023, 524399, 524335, 590015, 524303, 524431, 524367, 590079]), 9],
  Ot = [new Int32Array([327680, 327696, 327688, 327704, 327684, 327700, 327692, 327708, 327682, 327698, 327690, 327706, 327686, 327702, 327694, 0, 327681, 327697, 327689, 327705, 327685, 327701, 327693, 327709, 327683, 327699, 327691, 327707, 327687, 327703, 327695, 0]), 5];
var _m = /*#__PURE__*/_classPrivateFieldLooseKey("m");
var FlateStream = /*#__PURE__*/function (_DecodeStream5) {
  function FlateStream(_e55, t) {
    var _this21;
    _classCallCheck(this, FlateStream);
    _this21 = _callSuper(this, FlateStream, [t]);
    Object.defineProperty(_this21, _m, {
      value: _m2
    });
    _this21.str = _e55;
    _this21.dict = _e55.dict;
    var i = _e55.getByte(),
      a = _e55.getByte();
    if (-1 === i || -1 === a) throw new FormatError("Invalid header in flate stream: ".concat(i, ", ").concat(a));
    if (8 != (15 & i)) throw new FormatError("Unknown compression method in flate stream: ".concat(i, ", ").concat(a));
    if (((i << 8) + a) % 31 != 0) throw new FormatError("Bad FCHECK in flate stream: ".concat(i, ", ").concat(a));
    if (32 & a) throw new FormatError("FDICT bit set in flate stream: ".concat(i, ", ").concat(a));
    _this21.codeSize = 0;
    _this21.codeBuf = 0;
    return _this21;
  }
  _inherits(FlateStream, _DecodeStream5);
  return _createClass(FlateStream, [{
    key: "getImageData",
    value: function () {
      var _getImageData3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e, t) {
        var i;
        return _regeneratorRuntime().wrap(function _callee8$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.asyncGetBytes();
            case 2:
              i = _context10.sent;
              return _context10.abrupt("return", (i === null || i === void 0 ? void 0 : i.subarray(0, e)) || this.getBytes(e));
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee8, this);
      }));
      function getImageData(_x11, _x12) {
        return _getImageData3.apply(this, arguments);
      }
      return getImageData;
    }()
  }, {
    key: "asyncGetBytes",
    value: function () {
      var _asyncGetBytes2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var e, _DecompressionStream, _t52, _i44, _a33, _s26, _r19, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _e56, _n12, _g6, _i45, _s27, _e57;
        return _regeneratorRuntime().wrap(function _callee10$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              this.str.reset();
              e = this.str.getBytes();
              _context12.prev = 2;
              _DecompressionStream = new DecompressionStream("deflate"), _t52 = _DecompressionStream.readable, _i44 = _DecompressionStream.writable, _a33 = _i44.getWriter();
              _context12.next = 6;
              return _a33.ready;
            case 6:
              _a33.write(e).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                return _regeneratorRuntime().wrap(function _callee9$(_context11) {
                  while (1) switch (_context11.prev = _context11.next) {
                    case 0:
                      _context11.next = 2;
                      return _a33.ready;
                    case 2:
                      _context11.next = 4;
                      return _a33.close();
                    case 4:
                    case "end":
                      return _context11.stop();
                  }
                }, _callee9);
              }))).catch(function () {});
              _s26 = [];
              _r19 = 0;
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context12.prev = 11;
              _iterator = _asyncIterator(_t52);
            case 13:
              _context12.next = 15;
              return _iterator.next();
            case 15:
              if (!(_iteratorAbruptCompletion = !(_step = _context12.sent).done)) {
                _context12.next = 22;
                break;
              }
              _e56 = _step.value;
              _s26.push(_e56);
              _r19 += _e56.byteLength;
            case 19:
              _iteratorAbruptCompletion = false;
              _context12.next = 13;
              break;
            case 22:
              _context12.next = 28;
              break;
            case 24:
              _context12.prev = 24;
              _context12.t0 = _context12["catch"](11);
              _didIteratorError = true;
              _iteratorError = _context12.t0;
            case 28:
              _context12.prev = 28;
              _context12.prev = 29;
              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context12.next = 33;
                break;
              }
              _context12.next = 33;
              return _iterator.return();
            case 33:
              _context12.prev = 33;
              if (!_didIteratorError) {
                _context12.next = 36;
                break;
              }
              throw _iteratorError;
            case 36:
              return _context12.finish(33);
            case 37:
              return _context12.finish(28);
            case 38:
              _n12 = new Uint8Array(_r19);
              _g6 = 0;
              for (_i45 = 0, _s27 = _s26; _i45 < _s27.length; _i45++) {
                _e57 = _s27[_i45];
                _n12.set(_e57, _g6);
                _g6 += _e57.byteLength;
              }
              return _context12.abrupt("return", _n12);
            case 44:
              _context12.prev = 44;
              _context12.t1 = _context12["catch"](2);
              this.str = new Stream(e, 2, e.length, this.str.dict);
              this.reset();
              return _context12.abrupt("return", null);
            case 49:
            case "end":
              return _context12.stop();
          }
        }, _callee10, this, [[2, 44], [11, 24, 28, 38], [29,, 33, 37]]);
      }));
      function asyncGetBytes() {
        return _asyncGetBytes2.apply(this, arguments);
      }
      return asyncGetBytes;
    }()
  }, {
    key: "isAsync",
    get: function get() {
      return !0;
    }
  }, {
    key: "getBits",
    value: function getBits(e) {
      var t = this.str;
      var i,
        a = this.codeSize,
        s = this.codeBuf;
      for (; a < e;) {
        if (-1 === (i = t.getByte())) throw new FormatError("Bad encoding in flate stream");
        s |= i << a;
        a += 8;
      }
      i = s & (1 << e) - 1;
      this.codeBuf = s >> e;
      this.codeSize = a -= e;
      return i;
    }
  }, {
    key: "getCode",
    value: function getCode(e) {
      var t = this.str,
        i = e[0],
        a = e[1];
      var s,
        r = this.codeSize,
        n = this.codeBuf;
      for (; r < a && -1 !== (s = t.getByte());) {
        n |= s << r;
        r += 8;
      }
      var g = i[n & (1 << a) - 1],
        o = g >> 16,
        c = 65535 & g;
      if (o < 1 || r < o) throw new FormatError("Bad encoding in flate stream");
      this.codeBuf = n >> o;
      this.codeSize = r - o;
      return c;
    }
  }, {
    key: "generateHuffmanTable",
    value: function generateHuffmanTable(e) {
      var t = e.length;
      var i,
        a = 0;
      for (i = 0; i < t; ++i) e[i] > a && (a = e[i]);
      var s = 1 << a,
        r = new Int32Array(s);
      for (var _n13 = 1, _g7 = 0, _o5 = 2; _n13 <= a; ++_n13, _g7 <<= 1, _o5 <<= 1) for (var _a34 = 0; _a34 < t; ++_a34) if (e[_a34] === _n13) {
        var _e58 = 0,
          _t53 = _g7;
        for (i = 0; i < _n13; ++i) {
          _e58 = _e58 << 1 | 1 & _t53;
          _t53 >>= 1;
        }
        for (i = _e58; i < s; i += _o5) r[i] = _n13 << 16 | _a34;
        ++_g7;
      }
      return [r, a];
    }
  }, {
    key: "readBlock",
    value: function readBlock() {
      var e, t, i;
      var a = this.str;
      try {
        t = this.getBits(3);
      } catch (e) {
        _classPrivateFieldLooseBase(this, _m)[_m](e.message);
        return;
      }
      1 & t && (this.eof = !0);
      t >>= 1;
      if (0 === t) {
        var _t54;
        if (-1 === (_t54 = a.getByte())) {
          _classPrivateFieldLooseBase(this, _m)[_m]("Bad block header in flate stream");
          return;
        }
        var _i46 = _t54;
        if (-1 === (_t54 = a.getByte())) {
          _classPrivateFieldLooseBase(this, _m)[_m]("Bad block header in flate stream");
          return;
        }
        _i46 |= _t54 << 8;
        if (-1 === (_t54 = a.getByte())) {
          _classPrivateFieldLooseBase(this, _m)[_m]("Bad block header in flate stream");
          return;
        }
        var _s28 = _t54;
        if (-1 === (_t54 = a.getByte())) {
          _classPrivateFieldLooseBase(this, _m)[_m]("Bad block header in flate stream");
          return;
        }
        _s28 |= _t54 << 8;
        if (_s28 !== (65535 & ~_i46) && (0 !== _i46 || 0 !== _s28)) throw new FormatError("Bad uncompressed block length in flate stream");
        this.codeBuf = 0;
        this.codeSize = 0;
        var _r20 = this.bufferLength,
          _n14 = _r20 + _i46;
        e = this.ensureBuffer(_n14);
        this.bufferLength = _n14;
        if (0 === _i46) -1 === a.peekByte() && (this.eof = !0);else {
          var _t55 = a.getBytes(_i46);
          e.set(_t55, _r20);
          _t55.length < _i46 && (this.eof = !0);
        }
        return;
      }
      var s, r;
      if (1 === t) {
        s = qt;
        r = Ot;
      } else {
        if (2 !== t) throw new FormatError("Unknown block type in flate stream");
        {
          var _e59 = this.getBits(5) + 257,
            _t56 = this.getBits(5) + 1,
            _a35 = this.getBits(4) + 4,
            _n15 = new Uint8Array(vt.length);
          var _g8;
          for (_g8 = 0; _g8 < _a35; ++_g8) _n15[vt[_g8]] = this.getBits(3);
          var _o6 = this.generateHuffmanTable(_n15);
          i = 0;
          _g8 = 0;
          var _c6 = _e59 + _t56,
            _C4 = new Uint8Array(_c6);
          var h, l, _Q5;
          for (; _g8 < _c6;) {
            var _e60 = this.getCode(_o6);
            if (16 === _e60) {
              h = 2;
              l = 3;
              _Q5 = i;
            } else if (17 === _e60) {
              h = 3;
              l = 3;
              _Q5 = i = 0;
            } else {
              if (18 !== _e60) {
                _C4[_g8++] = i = _e60;
                continue;
              }
              h = 7;
              l = 11;
              _Q5 = i = 0;
            }
            var _t57 = this.getBits(h) + l;
            for (; _t57-- > 0;) _C4[_g8++] = _Q5;
          }
          s = this.generateHuffmanTable(_C4.subarray(0, _e59));
          r = this.generateHuffmanTable(_C4.subarray(_e59, _c6));
        }
      }
      e = this.buffer;
      var n = e ? e.length : 0,
        g = this.bufferLength;
      for (;;) {
        var _t58 = this.getCode(s);
        if (_t58 < 256) {
          if (g + 1 >= n) {
            e = this.ensureBuffer(g + 1);
            n = e.length;
          }
          e[g++] = _t58;
          continue;
        }
        if (256 === _t58) {
          this.bufferLength = g;
          return;
        }
        _t58 -= 257;
        _t58 = Kt[_t58];
        var _a36 = _t58 >> 16;
        _a36 > 0 && (_a36 = this.getBits(_a36));
        i = (65535 & _t58) + _a36;
        _t58 = this.getCode(r);
        _t58 = Tt[_t58];
        _a36 = _t58 >> 16;
        _a36 > 0 && (_a36 = this.getBits(_a36));
        var _o7 = (65535 & _t58) + _a36;
        if (g + i >= n) {
          e = this.ensureBuffer(g + i);
          n = e.length;
        }
        for (var _t59 = 0; _t59 < i; ++_t59, ++g) e[g] = e[g - _o7];
      }
    }
  }]);
}(DecodeStream);
function _m2(e) {
  info(e);
  this.eof = !0;
}
var Pt = [{
  qe: 22017,
  nmps: 1,
  nlps: 1,
  switchFlag: 1
}, {
  qe: 13313,
  nmps: 2,
  nlps: 6,
  switchFlag: 0
}, {
  qe: 6145,
  nmps: 3,
  nlps: 9,
  switchFlag: 0
}, {
  qe: 2753,
  nmps: 4,
  nlps: 12,
  switchFlag: 0
}, {
  qe: 1313,
  nmps: 5,
  nlps: 29,
  switchFlag: 0
}, {
  qe: 545,
  nmps: 38,
  nlps: 33,
  switchFlag: 0
}, {
  qe: 22017,
  nmps: 7,
  nlps: 6,
  switchFlag: 1
}, {
  qe: 21505,
  nmps: 8,
  nlps: 14,
  switchFlag: 0
}, {
  qe: 18433,
  nmps: 9,
  nlps: 14,
  switchFlag: 0
}, {
  qe: 14337,
  nmps: 10,
  nlps: 14,
  switchFlag: 0
}, {
  qe: 12289,
  nmps: 11,
  nlps: 17,
  switchFlag: 0
}, {
  qe: 9217,
  nmps: 12,
  nlps: 18,
  switchFlag: 0
}, {
  qe: 7169,
  nmps: 13,
  nlps: 20,
  switchFlag: 0
}, {
  qe: 5633,
  nmps: 29,
  nlps: 21,
  switchFlag: 0
}, {
  qe: 22017,
  nmps: 15,
  nlps: 14,
  switchFlag: 1
}, {
  qe: 21505,
  nmps: 16,
  nlps: 14,
  switchFlag: 0
}, {
  qe: 20737,
  nmps: 17,
  nlps: 15,
  switchFlag: 0
}, {
  qe: 18433,
  nmps: 18,
  nlps: 16,
  switchFlag: 0
}, {
  qe: 14337,
  nmps: 19,
  nlps: 17,
  switchFlag: 0
}, {
  qe: 13313,
  nmps: 20,
  nlps: 18,
  switchFlag: 0
}, {
  qe: 12289,
  nmps: 21,
  nlps: 19,
  switchFlag: 0
}, {
  qe: 10241,
  nmps: 22,
  nlps: 19,
  switchFlag: 0
}, {
  qe: 9217,
  nmps: 23,
  nlps: 20,
  switchFlag: 0
}, {
  qe: 8705,
  nmps: 24,
  nlps: 21,
  switchFlag: 0
}, {
  qe: 7169,
  nmps: 25,
  nlps: 22,
  switchFlag: 0
}, {
  qe: 6145,
  nmps: 26,
  nlps: 23,
  switchFlag: 0
}, {
  qe: 5633,
  nmps: 27,
  nlps: 24,
  switchFlag: 0
}, {
  qe: 5121,
  nmps: 28,
  nlps: 25,
  switchFlag: 0
}, {
  qe: 4609,
  nmps: 29,
  nlps: 26,
  switchFlag: 0
}, {
  qe: 4353,
  nmps: 30,
  nlps: 27,
  switchFlag: 0
}, {
  qe: 2753,
  nmps: 31,
  nlps: 28,
  switchFlag: 0
}, {
  qe: 2497,
  nmps: 32,
  nlps: 29,
  switchFlag: 0
}, {
  qe: 2209,
  nmps: 33,
  nlps: 30,
  switchFlag: 0
}, {
  qe: 1313,
  nmps: 34,
  nlps: 31,
  switchFlag: 0
}, {
  qe: 1089,
  nmps: 35,
  nlps: 32,
  switchFlag: 0
}, {
  qe: 673,
  nmps: 36,
  nlps: 33,
  switchFlag: 0
}, {
  qe: 545,
  nmps: 37,
  nlps: 34,
  switchFlag: 0
}, {
  qe: 321,
  nmps: 38,
  nlps: 35,
  switchFlag: 0
}, {
  qe: 273,
  nmps: 39,
  nlps: 36,
  switchFlag: 0
}, {
  qe: 133,
  nmps: 40,
  nlps: 37,
  switchFlag: 0
}, {
  qe: 73,
  nmps: 41,
  nlps: 38,
  switchFlag: 0
}, {
  qe: 37,
  nmps: 42,
  nlps: 39,
  switchFlag: 0
}, {
  qe: 21,
  nmps: 43,
  nlps: 40,
  switchFlag: 0
}, {
  qe: 9,
  nmps: 44,
  nlps: 41,
  switchFlag: 0
}, {
  qe: 5,
  nmps: 45,
  nlps: 42,
  switchFlag: 0
}, {
  qe: 1,
  nmps: 45,
  nlps: 43,
  switchFlag: 0
}, {
  qe: 22017,
  nmps: 46,
  nlps: 46,
  switchFlag: 0
}];
var ArithmeticDecoder = /*#__PURE__*/function () {
  function ArithmeticDecoder(e, t, i) {
    _classCallCheck(this, ArithmeticDecoder);
    this.data = e;
    this.bp = t;
    this.dataEnd = i;
    this.chigh = e[t];
    this.clow = 0;
    this.byteIn();
    this.chigh = this.chigh << 7 & 65535 | this.clow >> 9 & 127;
    this.clow = this.clow << 7 & 65535;
    this.ct -= 7;
    this.a = 32768;
  }
  return _createClass(ArithmeticDecoder, [{
    key: "byteIn",
    value: function byteIn() {
      var e = this.data;
      var t = this.bp;
      if (255 === e[t]) {
        if (e[t + 1] > 143) {
          this.clow += 65280;
          this.ct = 8;
        } else {
          t++;
          this.clow += e[t] << 9;
          this.ct = 7;
          this.bp = t;
        }
      } else {
        t++;
        this.clow += t < this.dataEnd ? e[t] << 8 : 65280;
        this.ct = 8;
        this.bp = t;
      }
      if (this.clow > 65535) {
        this.chigh += this.clow >> 16;
        this.clow &= 65535;
      }
    }
  }, {
    key: "readBit",
    value: function readBit(e, t) {
      var i = e[t] >> 1,
        a = 1 & e[t];
      var s = Pt[i],
        r = s.qe;
      var n,
        g = this.a - r;
      if (this.chigh < r) {
        if (g < r) {
          g = r;
          n = a;
          i = s.nmps;
        } else {
          g = r;
          n = 1 ^ a;
          1 === s.switchFlag && (a = n);
          i = s.nlps;
        }
      } else {
        this.chigh -= r;
        if (0 != (32768 & g)) {
          this.a = g;
          return a;
        }
        if (g < r) {
          n = 1 ^ a;
          1 === s.switchFlag && (a = n);
          i = s.nlps;
        } else {
          n = a;
          i = s.nmps;
        }
      }
      do {
        0 === this.ct && this.byteIn();
        g <<= 1;
        this.chigh = this.chigh << 1 & 65535 | this.clow >> 15 & 1;
        this.clow = this.clow << 1 & 65535;
        this.ct--;
      } while (0 == (32768 & g));
      this.a = g;
      e[t] = i << 1 | a;
      return n;
    }
  }]);
}();
var Jbig2Error = /*#__PURE__*/function (_gt12) {
  function Jbig2Error(e) {
    _classCallCheck(this, Jbig2Error);
    return _callSuper(this, Jbig2Error, [e, "Jbig2Error"]);
  }
  _inherits(Jbig2Error, _gt12);
  return _createClass(Jbig2Error);
}(gt);
var ContextCache = /*#__PURE__*/function () {
  function ContextCache() {
    _classCallCheck(this, ContextCache);
  }
  return _createClass(ContextCache, [{
    key: "getContexts",
    value: function getContexts(e) {
      return e in this ? this[e] : this[e] = new Int8Array(65536);
    }
  }]);
}();
var DecodingContext = /*#__PURE__*/function () {
  function DecodingContext(e, t, i) {
    _classCallCheck(this, DecodingContext);
    this.data = e;
    this.start = t;
    this.end = i;
  }
  return _createClass(DecodingContext, [{
    key: "decoder",
    get: function get() {
      return shadow(this, "decoder", new ArithmeticDecoder(this.data, this.start, this.end));
    }
  }, {
    key: "contextCache",
    get: function get() {
      return shadow(this, "contextCache", new ContextCache());
    }
  }]);
}();
var Wt = Math.pow(2, 31) - 1,
  jt = -Math.pow(2, 31);
function decodeInteger(e, t, i) {
  var a = e.getContexts(t);
  var s = 1;
  function readBits(e) {
    var t = 0;
    for (var _r21 = 0; _r21 < e; _r21++) {
      var _e61 = i.readBit(a, s);
      s = s < 256 ? s << 1 | _e61 : 511 & (s << 1 | _e61) | 256;
      t = t << 1 | _e61;
    }
    return t >>> 0;
  }
  var r = readBits(1),
    n = readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(32) + 4436 : readBits(12) + 340 : readBits(8) + 84 : readBits(6) + 20 : readBits(4) + 4 : readBits(2);
  var g;
  0 === r ? g = n : n > 0 && (g = -n);
  return g >= jt && g <= Wt ? g : null;
}
function decodeIAID(e, t, i) {
  var a = e.getContexts("IAID");
  var s = 1;
  for (var _e62 = 0; _e62 < i; _e62++) {
    s = s << 1 | t.readBit(a, s);
  }
  return i < 31 ? s & (1 << i) - 1 : 2147483647 & s;
}
var Xt = ["SymbolDictionary", null, null, null, "IntermediateTextRegion", null, "ImmediateTextRegion", "ImmediateLosslessTextRegion", null, null, null, null, null, null, null, null, "PatternDictionary", null, null, null, "IntermediateHalftoneRegion", null, "ImmediateHalftoneRegion", "ImmediateLosslessHalftoneRegion", null, null, null, null, null, null, null, null, null, null, null, null, "IntermediateGenericRegion", null, "ImmediateGenericRegion", "ImmediateLosslessGenericRegion", "IntermediateGenericRefinementRegion", null, "ImmediateGenericRefinementRegion", "ImmediateLosslessGenericRefinementRegion", null, null, null, null, "PageInformation", "EndOfPage", "EndOfStripe", "EndOfFile", "Profiles", "Tables", null, null, null, null, null, null, null, null, "Extension"],
  Zt = [[{
    x: -1,
    y: -2
  }, {
    x: 0,
    y: -2
  }, {
    x: 1,
    y: -2
  }, {
    x: -2,
    y: -1
  }, {
    x: -1,
    y: -1
  }, {
    x: 0,
    y: -1
  }, {
    x: 1,
    y: -1
  }, {
    x: 2,
    y: -1
  }, {
    x: -4,
    y: 0
  }, {
    x: -3,
    y: 0
  }, {
    x: -2,
    y: 0
  }, {
    x: -1,
    y: 0
  }], [{
    x: -1,
    y: -2
  }, {
    x: 0,
    y: -2
  }, {
    x: 1,
    y: -2
  }, {
    x: 2,
    y: -2
  }, {
    x: -2,
    y: -1
  }, {
    x: -1,
    y: -1
  }, {
    x: 0,
    y: -1
  }, {
    x: 1,
    y: -1
  }, {
    x: 2,
    y: -1
  }, {
    x: -3,
    y: 0
  }, {
    x: -2,
    y: 0
  }, {
    x: -1,
    y: 0
  }], [{
    x: -1,
    y: -2
  }, {
    x: 0,
    y: -2
  }, {
    x: 1,
    y: -2
  }, {
    x: -2,
    y: -1
  }, {
    x: -1,
    y: -1
  }, {
    x: 0,
    y: -1
  }, {
    x: 1,
    y: -1
  }, {
    x: -2,
    y: 0
  }, {
    x: -1,
    y: 0
  }], [{
    x: -3,
    y: -1
  }, {
    x: -2,
    y: -1
  }, {
    x: -1,
    y: -1
  }, {
    x: 0,
    y: -1
  }, {
    x: 1,
    y: -1
  }, {
    x: -4,
    y: 0
  }, {
    x: -3,
    y: 0
  }, {
    x: -2,
    y: 0
  }, {
    x: -1,
    y: 0
  }]],
  Vt = [{
    coding: [{
      x: 0,
      y: -1
    }, {
      x: 1,
      y: -1
    }, {
      x: -1,
      y: 0
    }],
    reference: [{
      x: 0,
      y: -1
    }, {
      x: 1,
      y: -1
    }, {
      x: -1,
      y: 0
    }, {
      x: 0,
      y: 0
    }, {
      x: 1,
      y: 0
    }, {
      x: -1,
      y: 1
    }, {
      x: 0,
      y: 1
    }, {
      x: 1,
      y: 1
    }]
  }, {
    coding: [{
      x: -1,
      y: -1
    }, {
      x: 0,
      y: -1
    }, {
      x: 1,
      y: -1
    }, {
      x: -1,
      y: 0
    }],
    reference: [{
      x: 0,
      y: -1
    }, {
      x: -1,
      y: 0
    }, {
      x: 0,
      y: 0
    }, {
      x: 1,
      y: 0
    }, {
      x: 0,
      y: 1
    }, {
      x: 1,
      y: 1
    }]
  }],
  zt = [39717, 1941, 229, 405],
  _t = [32, 8];
function decodeBitmap(e, t, i, a, s, r, n, g) {
  if (e) {
    return decodeMMRBitmap(new Reader(g.data, g.start, g.end), t, i, !1);
  }
  if (0 === a && !r && !s && 4 === n.length && 3 === n[0].x && -1 === n[0].y && -3 === n[1].x && -1 === n[1].y && 2 === n[2].x && -2 === n[2].y && -2 === n[3].x && -2 === n[3].y) return function decodeBitmapTemplate0(e, t, i) {
    var a = i.decoder,
      s = i.contextCache.getContexts("GB"),
      r = [];
    var n, g, o, c, C, h, l;
    for (g = 0; g < t; g++) {
      C = r[g] = new Uint8Array(e);
      h = g < 1 ? C : r[g - 1];
      l = g < 2 ? C : r[g - 2];
      n = l[0] << 13 | l[1] << 12 | l[2] << 11 | h[0] << 7 | h[1] << 6 | h[2] << 5 | h[3] << 4;
      for (o = 0; o < e; o++) {
        C[o] = c = a.readBit(s, n);
        n = (31735 & n) << 1 | (o + 3 < e ? l[o + 3] << 11 : 0) | (o + 4 < e ? h[o + 4] << 4 : 0) | c;
      }
    }
    return r;
  }(t, i, g);
  var o = !!r,
    c = Zt[a].concat(n);
  c.sort(function (e, t) {
    return e.y - t.y || e.x - t.x;
  });
  var C = c.length,
    h = new Int8Array(C),
    l = new Int8Array(C),
    Q = [];
  var E,
    u,
    d = 0,
    f = 0,
    p = 0,
    m = 0;
  for (u = 0; u < C; u++) {
    h[u] = c[u].x;
    l[u] = c[u].y;
    f = Math.min(f, c[u].x);
    p = Math.max(p, c[u].x);
    m = Math.min(m, c[u].y);
    u < C - 1 && c[u].y === c[u + 1].y && c[u].x === c[u + 1].x - 1 ? d |= 1 << C - 1 - u : Q.push(u);
  }
  var y = Q.length,
    w = new Int8Array(y),
    D = new Int8Array(y),
    b = new Uint16Array(y);
  for (E = 0; E < y; E++) {
    u = Q[E];
    w[E] = c[u].x;
    D[E] = c[u].y;
    b[E] = 1 << C - 1 - u;
  }
  var F = -f,
    S = -m,
    k = t - p,
    R = zt[a];
  var N = new Uint8Array(t);
  var G = [],
    x = g.decoder,
    U = g.contextCache.getContexts("GB");
  var M,
    L,
    H,
    J,
    Y,
    v = 0,
    K = 0;
  for (var _e63 = 0; _e63 < i; _e63++) {
    if (s) {
      v ^= x.readBit(U, R);
      if (v) {
        G.push(N);
        continue;
      }
    }
    N = new Uint8Array(N);
    G.push(N);
    for (M = 0; M < t; M++) {
      if (o && r[_e63][M]) {
        N[M] = 0;
        continue;
      }
      if (M >= F && M < k && _e63 >= S) {
        K = K << 1 & d;
        for (u = 0; u < y; u++) {
          L = _e63 + D[u];
          H = M + w[u];
          J = G[L][H];
          if (J) {
            J = b[u];
            K |= J;
          }
        }
      } else {
        K = 0;
        Y = C - 1;
        for (u = 0; u < C; u++, Y--) {
          H = M + h[u];
          if (H >= 0 && H < t) {
            L = _e63 + l[u];
            if (L >= 0) {
              J = G[L][H];
              J && (K |= J << Y);
            }
          }
        }
      }
      var _i47 = x.readBit(U, K);
      N[M] = _i47;
    }
  }
  return G;
}
function decodeRefinement(e, t, i, a, s, r, n, g, o) {
  var c = Vt[i].coding;
  0 === i && (c = c.concat([g[0]]));
  var C = c.length,
    h = new Int32Array(C),
    l = new Int32Array(C);
  var Q;
  for (Q = 0; Q < C; Q++) {
    h[Q] = c[Q].x;
    l[Q] = c[Q].y;
  }
  var E = Vt[i].reference;
  0 === i && (E = E.concat([g[1]]));
  var u = E.length,
    d = new Int32Array(u),
    f = new Int32Array(u);
  for (Q = 0; Q < u; Q++) {
    d[Q] = E[Q].x;
    f[Q] = E[Q].y;
  }
  var p = a[0].length,
    m = a.length,
    y = _t[i],
    w = [],
    D = o.decoder,
    b = o.contextCache.getContexts("GR");
  var F = 0;
  for (var _i48 = 0; _i48 < t; _i48++) {
    if (n) {
      F ^= D.readBit(b, y);
      if (F) throw new Jbig2Error("prediction is not supported");
    }
    var _t60 = new Uint8Array(e);
    w.push(_t60);
    for (var _n16 = 0; _n16 < e; _n16++) {
      var _g9 = void 0,
        _o8 = void 0,
        _c7 = 0;
      for (Q = 0; Q < C; Q++) {
        _g9 = _i48 + l[Q];
        _o8 = _n16 + h[Q];
        _g9 < 0 || _o8 < 0 || _o8 >= e ? _c7 <<= 1 : _c7 = _c7 << 1 | w[_g9][_o8];
      }
      for (Q = 0; Q < u; Q++) {
        _g9 = _i48 + f[Q] - r;
        _o8 = _n16 + d[Q] - s;
        _g9 < 0 || _g9 >= m || _o8 < 0 || _o8 >= p ? _c7 <<= 1 : _c7 = _c7 << 1 | a[_g9][_o8];
      }
      var _E5 = D.readBit(b, _c7);
      _t60[_n16] = _E5;
    }
  }
  return w;
}
function decodeTextRegion(e, t, i, a, s, r, n, g, o, c, C, h, l, Q, E, u, d, f, p) {
  if (e && t) throw new Jbig2Error("refinement with Huffman is not supported");
  var m = [];
  var y, w;
  for (y = 0; y < a; y++) {
    w = new Uint8Array(i);
    if (s) for (var _e64 = 0; _e64 < i; _e64++) w[_e64] = s;
    m.push(w);
  }
  var D = d.decoder,
    b = d.contextCache;
  var F = e ? -Q.tableDeltaT.decode(p) : -decodeInteger(b, "IADT", D),
    S = 0;
  y = 0;
  for (; y < r;) {
    F += e ? Q.tableDeltaT.decode(p) : decodeInteger(b, "IADT", D);
    S += e ? Q.tableFirstS.decode(p) : decodeInteger(b, "IAFS", D);
    var _a37 = S;
    for (;;) {
      var _s29 = 0;
      n > 1 && (_s29 = e ? p.readBits(f) : decodeInteger(b, "IAIT", D));
      var _r22 = n * F + _s29,
        _S = e ? Q.symbolIDTable.decode(p) : decodeIAID(b, D, o),
        _k = t && (e ? p.readBit() : decodeInteger(b, "IARI", D));
      var _R = g[_S],
        _N = _R[0].length,
        _G = _R.length;
      if (_k) {
        var _e65 = decodeInteger(b, "IARDW", D),
          _t61 = decodeInteger(b, "IARDH", D);
        _N += _e65;
        _G += _t61;
        _R = decodeRefinement(_N, _G, E, _R, (_e65 >> 1) + decodeInteger(b, "IARDX", D), (_t61 >> 1) + decodeInteger(b, "IARDY", D), !1, u, d);
      }
      var _x13 = 0;
      c ? 1 & h ? _x13 = _G - 1 : _a37 += _G - 1 : h > 1 ? _a37 += _N - 1 : _x13 = _N - 1;
      var _U = _r22 - (1 & h ? 0 : _G - 1),
        _M = _a37 - (2 & h ? _N - 1 : 0);
      var _L = void 0,
        _H = void 0,
        _J = void 0;
      if (c) for (_L = 0; _L < _G; _L++) {
        w = m[_M + _L];
        if (!w) continue;
        _J = _R[_L];
        var _e66 = Math.min(i - _U, _N);
        switch (l) {
          case 0:
            for (_H = 0; _H < _e66; _H++) w[_U + _H] |= _J[_H];
            break;
          case 2:
            for (_H = 0; _H < _e66; _H++) w[_U + _H] ^= _J[_H];
            break;
          default:
            throw new Jbig2Error("operator ".concat(l, " is not supported"));
        }
      } else for (_H = 0; _H < _G; _H++) {
        w = m[_U + _H];
        if (w) {
          _J = _R[_H];
          switch (l) {
            case 0:
              for (_L = 0; _L < _N; _L++) w[_M + _L] |= _J[_L];
              break;
            case 2:
              for (_L = 0; _L < _N; _L++) w[_M + _L] ^= _J[_L];
              break;
            default:
              throw new Jbig2Error("operator ".concat(l, " is not supported"));
          }
        }
      }
      y++;
      var _Y = e ? Q.tableDeltaS.decode(p) : decodeInteger(b, "IADS", D);
      if (null === _Y) break;
      _a37 += _x13 + _Y + C;
    }
  }
  return m;
}
function readSegmentHeader(e, t) {
  var i = {};
  i.number = readUint32(e, t);
  var a = e[t + 4],
    s = 63 & a;
  if (!Xt[s]) throw new Jbig2Error("invalid segment type: " + s);
  i.type = s;
  i.typeName = Xt[s];
  i.deferredNonRetain = !!(128 & a);
  var r = !!(64 & a),
    n = e[t + 5];
  var g = n >> 5 & 7;
  var o = [31 & n];
  var c = t + 6;
  if (7 === n) {
    g = 536870911 & readUint32(e, c - 1);
    c += 3;
    var _t62 = g + 7 >> 3;
    o[0] = e[c++];
    for (; --_t62 > 0;) o.push(e[c++]);
  } else if (5 === n || 6 === n) throw new Jbig2Error("invalid referred-to flags");
  i.retainBits = o;
  var C = 4;
  i.number <= 256 ? C = 1 : i.number <= 65536 && (C = 2);
  var h = [];
  var l, Q;
  for (l = 0; l < g; l++) {
    var _t63 = void 0;
    _t63 = 1 === C ? e[c] : 2 === C ? readUint16(e, c) : readUint32(e, c);
    h.push(_t63);
    c += C;
  }
  i.referredTo = h;
  if (r) {
    i.pageAssociation = readUint32(e, c);
    c += 4;
  } else i.pageAssociation = e[c++];
  i.length = readUint32(e, c);
  c += 4;
  if (4294967295 === i.length) {
    if (38 !== s) throw new Jbig2Error("invalid unknown segment length");
    {
      var _t64 = readRegionSegmentInformation(e, c),
        _a38 = !!(1 & e[c + $t]),
        _s30 = 6,
        _r23 = new Uint8Array(_s30);
      if (!_a38) {
        _r23[0] = 255;
        _r23[1] = 172;
      }
      _r23[2] = _t64.height >>> 24 & 255;
      _r23[3] = _t64.height >> 16 & 255;
      _r23[4] = _t64.height >> 8 & 255;
      _r23[5] = 255 & _t64.height;
      for (l = c, Q = e.length; l < Q; l++) {
        var _t65 = 0;
        for (; _t65 < _s30 && _r23[_t65] === e[l + _t65];) _t65++;
        if (_t65 === _s30) {
          i.length = l + _s30;
          break;
        }
      }
      if (4294967295 === i.length) throw new Jbig2Error("segment end was not found");
    }
  }
  i.headerEnd = c;
  return i;
}
function readSegments(e, t, i, a) {
  var s = [];
  var r = i;
  for (; r < a;) {
    var _i49 = readSegmentHeader(t, r);
    r = _i49.headerEnd;
    var _a39 = {
      header: _i49,
      data: t
    };
    if (!e.randomAccess) {
      _a39.start = r;
      r += _i49.length;
      _a39.end = r;
    }
    s.push(_a39);
    if (51 === _i49.type) break;
  }
  if (e.randomAccess) for (var _e67 = 0, _t66 = s.length; _e67 < _t66; _e67++) {
    s[_e67].start = r;
    r += s[_e67].header.length;
    s[_e67].end = r;
  }
  return s;
}
function readRegionSegmentInformation(e, t) {
  return {
    width: readUint32(e, t),
    height: readUint32(e, t + 4),
    x: readUint32(e, t + 8),
    y: readUint32(e, t + 12),
    combinationOperator: 7 & e[t + 16]
  };
}
var $t = 17;
function processSegment(e, t) {
  var i = e.header,
    a = e.data,
    s = e.end;
  var r,
    n,
    g,
    o,
    c = e.start;
  switch (i.type) {
    case 0:
      var _e68 = {},
        _t67 = readUint16(a, c);
      _e68.huffman = !!(1 & _t67);
      _e68.refinement = !!(2 & _t67);
      _e68.huffmanDHSelector = _t67 >> 2 & 3;
      _e68.huffmanDWSelector = _t67 >> 4 & 3;
      _e68.bitmapSizeSelector = _t67 >> 6 & 1;
      _e68.aggregationInstancesSelector = _t67 >> 7 & 1;
      _e68.bitmapCodingContextUsed = !!(256 & _t67);
      _e68.bitmapCodingContextRetained = !!(512 & _t67);
      _e68.template = _t67 >> 10 & 3;
      _e68.refinementTemplate = _t67 >> 12 & 1;
      c += 2;
      if (!_e68.huffman) {
        o = 0 === _e68.template ? 4 : 1;
        n = [];
        for (g = 0; g < o; g++) {
          n.push({
            x: readInt8(a, c),
            y: readInt8(a, c + 1)
          });
          c += 2;
        }
        _e68.at = n;
      }
      if (_e68.refinement && !_e68.refinementTemplate) {
        n = [];
        for (g = 0; g < 2; g++) {
          n.push({
            x: readInt8(a, c),
            y: readInt8(a, c + 1)
          });
          c += 2;
        }
        _e68.refinementAt = n;
      }
      _e68.numberOfExportedSymbols = readUint32(a, c);
      c += 4;
      _e68.numberOfNewSymbols = readUint32(a, c);
      c += 4;
      r = [_e68, i.number, i.referredTo, a, c, s];
      break;
    case 6:
    case 7:
      var _C5 = {};
      _C5.info = readRegionSegmentInformation(a, c);
      c += $t;
      var h = readUint16(a, c);
      c += 2;
      _C5.huffman = !!(1 & h);
      _C5.refinement = !!(2 & h);
      _C5.logStripSize = h >> 2 & 3;
      _C5.stripSize = 1 << _C5.logStripSize;
      _C5.referenceCorner = h >> 4 & 3;
      _C5.transposed = !!(64 & h);
      _C5.combinationOperator = h >> 7 & 3;
      _C5.defaultPixelValue = h >> 9 & 1;
      _C5.dsOffset = h << 17 >> 27;
      _C5.refinementTemplate = h >> 15 & 1;
      if (_C5.huffman) {
        var _e69 = readUint16(a, c);
        c += 2;
        _C5.huffmanFS = 3 & _e69;
        _C5.huffmanDS = _e69 >> 2 & 3;
        _C5.huffmanDT = _e69 >> 4 & 3;
        _C5.huffmanRefinementDW = _e69 >> 6 & 3;
        _C5.huffmanRefinementDH = _e69 >> 8 & 3;
        _C5.huffmanRefinementDX = _e69 >> 10 & 3;
        _C5.huffmanRefinementDY = _e69 >> 12 & 3;
        _C5.huffmanRefinementSizeSelector = !!(16384 & _e69);
      }
      if (_C5.refinement && !_C5.refinementTemplate) {
        n = [];
        for (g = 0; g < 2; g++) {
          n.push({
            x: readInt8(a, c),
            y: readInt8(a, c + 1)
          });
          c += 2;
        }
        _C5.refinementAt = n;
      }
      _C5.numberOfSymbolInstances = readUint32(a, c);
      c += 4;
      r = [_C5, i.referredTo, a, c, s];
      break;
    case 16:
      var l = {},
        _Q6 = a[c++];
      l.mmr = !!(1 & _Q6);
      l.template = _Q6 >> 1 & 3;
      l.patternWidth = a[c++];
      l.patternHeight = a[c++];
      l.maxPatternIndex = readUint32(a, c);
      c += 4;
      r = [l, i.number, a, c, s];
      break;
    case 22:
    case 23:
      var _E6 = {};
      _E6.info = readRegionSegmentInformation(a, c);
      c += $t;
      var _u4 = a[c++];
      _E6.mmr = !!(1 & _u4);
      _E6.template = _u4 >> 1 & 3;
      _E6.enableSkip = !!(8 & _u4);
      _E6.combinationOperator = _u4 >> 4 & 7;
      _E6.defaultPixelValue = _u4 >> 7 & 1;
      _E6.gridWidth = readUint32(a, c);
      c += 4;
      _E6.gridHeight = readUint32(a, c);
      c += 4;
      _E6.gridOffsetX = 4294967295 & readUint32(a, c);
      c += 4;
      _E6.gridOffsetY = 4294967295 & readUint32(a, c);
      c += 4;
      _E6.gridVectorX = readUint16(a, c);
      c += 2;
      _E6.gridVectorY = readUint16(a, c);
      c += 2;
      r = [_E6, i.referredTo, a, c, s];
      break;
    case 38:
    case 39:
      var _d4 = {};
      _d4.info = readRegionSegmentInformation(a, c);
      c += $t;
      var _f4 = a[c++];
      _d4.mmr = !!(1 & _f4);
      _d4.template = _f4 >> 1 & 3;
      _d4.prediction = !!(8 & _f4);
      if (!_d4.mmr) {
        o = 0 === _d4.template ? 4 : 1;
        n = [];
        for (g = 0; g < o; g++) {
          n.push({
            x: readInt8(a, c),
            y: readInt8(a, c + 1)
          });
          c += 2;
        }
        _d4.at = n;
      }
      r = [_d4, a, c, s];
      break;
    case 48:
      var _p4 = {
        width: readUint32(a, c),
        height: readUint32(a, c + 4),
        resolutionX: readUint32(a, c + 8),
        resolutionY: readUint32(a, c + 12)
      };
      4294967295 === _p4.height && delete _p4.height;
      var _m3 = a[c + 16];
      readUint16(a, c + 17);
      _p4.lossless = !!(1 & _m3);
      _p4.refinement = !!(2 & _m3);
      _p4.defaultPixelValue = _m3 >> 2 & 1;
      _p4.combinationOperator = _m3 >> 3 & 3;
      _p4.requiresBuffer = !!(32 & _m3);
      _p4.combinationOperatorOverride = !!(64 & _m3);
      r = [_p4];
      break;
    case 49:
    case 50:
    case 51:
    case 62:
      break;
    case 53:
      r = [i.number, a, c, s];
      break;
    default:
      throw new Jbig2Error("segment type ".concat(i.typeName, "(").concat(i.type, ") is not implemented"));
  }
  var C = "on" + i.typeName;
  C in t && t[C].apply(t, r);
}
function processSegments(e, t) {
  for (var _i50 = 0, _a40 = e.length; _i50 < _a40; _i50++) processSegment(e[_i50], t);
}
var SimpleSegmentVisitor = /*#__PURE__*/function () {
  function SimpleSegmentVisitor() {
    _classCallCheck(this, SimpleSegmentVisitor);
  }
  return _createClass(SimpleSegmentVisitor, [{
    key: "onPageInformation",
    value: function onPageInformation(e) {
      this.currentPageInfo = e;
      var t = e.width + 7 >> 3,
        i = new Uint8ClampedArray(t * e.height);
      e.defaultPixelValue && i.fill(255);
      this.buffer = i;
    }
  }, {
    key: "drawBitmap",
    value: function drawBitmap(e, t) {
      var i = this.currentPageInfo,
        a = e.width,
        s = e.height,
        r = i.width + 7 >> 3,
        n = i.combinationOperatorOverride ? e.combinationOperator : i.combinationOperator,
        g = this.buffer,
        o = 128 >> (7 & e.x);
      var c,
        C,
        h,
        l,
        Q = e.y * r + (e.x >> 3);
      switch (n) {
        case 0:
          for (c = 0; c < s; c++) {
            h = o;
            l = Q;
            for (C = 0; C < a; C++) {
              t[c][C] && (g[l] |= h);
              h >>= 1;
              if (!h) {
                h = 128;
                l++;
              }
            }
            Q += r;
          }
          break;
        case 2:
          for (c = 0; c < s; c++) {
            h = o;
            l = Q;
            for (C = 0; C < a; C++) {
              t[c][C] && (g[l] ^= h);
              h >>= 1;
              if (!h) {
                h = 128;
                l++;
              }
            }
            Q += r;
          }
          break;
        default:
          throw new Jbig2Error("operator ".concat(n, " is not supported"));
      }
    }
  }, {
    key: "onImmediateGenericRegion",
    value: function onImmediateGenericRegion(e, t, i, a) {
      var s = e.info,
        r = new DecodingContext(t, i, a),
        n = decodeBitmap(e.mmr, s.width, s.height, e.template, e.prediction, null, e.at, r);
      this.drawBitmap(s, n);
    }
  }, {
    key: "onImmediateLosslessGenericRegion",
    value: function onImmediateLosslessGenericRegion() {
      this.onImmediateGenericRegion.apply(this, arguments);
    }
  }, {
    key: "onSymbolDictionary",
    value: function onSymbolDictionary(e, t, i, a, s, r) {
      var n, g;
      if (e.huffman) {
        n = function getSymbolDictionaryHuffmanTables(e, t, i) {
          var a,
            s,
            r,
            n,
            g = 0;
          switch (e.huffmanDHSelector) {
            case 0:
            case 1:
              a = getStandardTable(e.huffmanDHSelector + 4);
              break;
            case 3:
              a = getCustomHuffmanTable(g, t, i);
              g++;
              break;
            default:
              throw new Jbig2Error("invalid Huffman DH selector");
          }
          switch (e.huffmanDWSelector) {
            case 0:
            case 1:
              s = getStandardTable(e.huffmanDWSelector + 2);
              break;
            case 3:
              s = getCustomHuffmanTable(g, t, i);
              g++;
              break;
            default:
              throw new Jbig2Error("invalid Huffman DW selector");
          }
          if (e.bitmapSizeSelector) {
            r = getCustomHuffmanTable(g, t, i);
            g++;
          } else r = getStandardTable(1);
          n = e.aggregationInstancesSelector ? getCustomHuffmanTable(g, t, i) : getStandardTable(1);
          return {
            tableDeltaHeight: a,
            tableDeltaWidth: s,
            tableBitmapSize: r,
            tableAggregateInstances: n
          };
        }(e, i, this.customTables);
        g = new Reader(a, s, r);
      }
      var o = this.symbols;
      o || (this.symbols = o = {});
      var c = [];
      var _iterator20 = _createForOfIteratorHelper(i),
        _step20;
      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var _e74 = _step20.value;
          var _t71 = o[_e74];
          _t71 && c.push.apply(c, _toConsumableArray(_t71));
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }
      var C = new DecodingContext(a, s, r);
      o[t] = function decodeSymbolDictionary(e, t, i, a, s, r, n, g, o, c, C, h) {
        if (e && t) throw new Jbig2Error("symbol refinement with Huffman is not supported");
        var l = [];
        var Q = 0,
          E = log2(i.length + a);
        var u = C.decoder,
          d = C.contextCache;
        var f, p;
        if (e) {
          f = getStandardTable(1);
          p = [];
          E = Math.max(E, 1);
        }
        for (; l.length < a;) {
          Q += e ? r.tableDeltaHeight.decode(h) : decodeInteger(d, "IADH", u);
          var _a41 = 0,
            _s31 = 0;
          var _f5 = e ? p.length : 0;
          for (;;) {
            var _f6 = e ? r.tableDeltaWidth.decode(h) : decodeInteger(d, "IADW", u);
            if (null === _f6) break;
            _a41 += _f6;
            _s31 += _a41;
            var _m4 = void 0;
            if (t) {
              var _s32 = decodeInteger(d, "IAAI", u);
              if (_s32 > 1) _m4 = decodeTextRegion(e, t, _a41, Q, 0, _s32, 1, i.concat(l), E, 0, 0, 1, 0, r, o, c, C, 0, h);else {
                var _e70 = decodeIAID(d, u, E),
                  _t68 = decodeInteger(d, "IARDX", u),
                  _s33 = decodeInteger(d, "IARDY", u);
                _m4 = decodeRefinement(_a41, Q, o, _e70 < i.length ? i[_e70] : l[_e70 - i.length], _t68, _s33, !1, c, C);
              }
              l.push(_m4);
            } else if (e) p.push(_a41);else {
              _m4 = decodeBitmap(!1, _a41, Q, n, !1, null, g, C);
              l.push(_m4);
            }
          }
          if (e && !t) {
            var _e71 = r.tableBitmapSize.decode(h);
            h.byteAlign();
            var _t69 = void 0;
            if (0 === _e71) _t69 = readUncompressedBitmap(h, _s31, Q);else {
              var _i51 = h.end,
                _a42 = h.position + _e71;
              h.end = _a42;
              _t69 = decodeMMRBitmap(h, _s31, Q, !1);
              h.end = _i51;
              h.position = _a42;
            }
            var _i52 = p.length;
            if (_f5 === _i52 - 1) l.push(_t69);else {
              var _e72 = void 0,
                _a43 = void 0,
                _s34 = void 0,
                _r24 = void 0,
                _n17 = void 0,
                _g10 = 0;
              for (_e72 = _f5; _e72 < _i52; _e72++) {
                _r24 = p[_e72];
                _s34 = _g10 + _r24;
                _n17 = [];
                for (_a43 = 0; _a43 < Q; _a43++) _n17.push(_t69[_a43].subarray(_g10, _s34));
                l.push(_n17);
                _g10 = _s34;
              }
            }
          }
        }
        var m = [],
          y = [];
        var w,
          D,
          b = !1;
        var F = i.length + a;
        for (; y.length < F;) {
          var _t70 = e ? f.decode(h) : decodeInteger(d, "IAEX", u);
          for (; _t70--;) y.push(b);
          b = !b;
        }
        for (w = 0, D = i.length; w < D; w++) y[w] && m.push(i[w]);
        for (var _e73 = 0; _e73 < a; w++, _e73++) y[w] && m.push(l[_e73]);
        return m;
      }(e.huffman, e.refinement, c, e.numberOfNewSymbols, e.numberOfExportedSymbols, n, e.template, e.at, e.refinementTemplate, e.refinementAt, C, g);
    }
  }, {
    key: "onImmediateTextRegion",
    value: function onImmediateTextRegion(e, t, i, a, s) {
      var r = e.info;
      var n, g;
      var o = this.symbols,
        c = [];
      var _iterator21 = _createForOfIteratorHelper(t),
        _step21;
      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var _e77 = _step21.value;
          var _t74 = o[_e77];
          _t74 && c.push.apply(c, _toConsumableArray(_t74));
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
      var C = log2(c.length);
      if (e.huffman) {
        g = new Reader(i, a, s);
        n = function getTextRegionHuffmanTables(e, t, i, a, s) {
          var r = [];
          for (var _e75 = 0; _e75 <= 34; _e75++) {
            var _t72 = s.readBits(4);
            r.push(new HuffmanLine([_e75, _t72, 0, 0]));
          }
          var n = new HuffmanTable(r, !1);
          r.length = 0;
          for (var _e76 = 0; _e76 < a;) {
            var _t73 = n.decode(s);
            if (_t73 >= 32) {
              var _i53 = void 0,
                _a44 = void 0,
                _n18 = void 0;
              switch (_t73) {
                case 32:
                  if (0 === _e76) throw new Jbig2Error("no previous value in symbol ID table");
                  _a44 = s.readBits(2) + 3;
                  _i53 = r[_e76 - 1].prefixLength;
                  break;
                case 33:
                  _a44 = s.readBits(3) + 3;
                  _i53 = 0;
                  break;
                case 34:
                  _a44 = s.readBits(7) + 11;
                  _i53 = 0;
                  break;
                default:
                  throw new Jbig2Error("invalid code length in symbol ID table");
              }
              for (_n18 = 0; _n18 < _a44; _n18++) {
                r.push(new HuffmanLine([_e76, _i53, 0, 0]));
                _e76++;
              }
            } else {
              r.push(new HuffmanLine([_e76, _t73, 0, 0]));
              _e76++;
            }
          }
          s.byteAlign();
          var g = new HuffmanTable(r, !1);
          var o,
            c,
            C,
            h = 0;
          switch (e.huffmanFS) {
            case 0:
            case 1:
              o = getStandardTable(e.huffmanFS + 6);
              break;
            case 3:
              o = getCustomHuffmanTable(h, t, i);
              h++;
              break;
            default:
              throw new Jbig2Error("invalid Huffman FS selector");
          }
          switch (e.huffmanDS) {
            case 0:
            case 1:
            case 2:
              c = getStandardTable(e.huffmanDS + 8);
              break;
            case 3:
              c = getCustomHuffmanTable(h, t, i);
              h++;
              break;
            default:
              throw new Jbig2Error("invalid Huffman DS selector");
          }
          switch (e.huffmanDT) {
            case 0:
            case 1:
            case 2:
              C = getStandardTable(e.huffmanDT + 11);
              break;
            case 3:
              C = getCustomHuffmanTable(h, t, i);
              h++;
              break;
            default:
              throw new Jbig2Error("invalid Huffman DT selector");
          }
          if (e.refinement) throw new Jbig2Error("refinement with Huffman is not supported");
          return {
            symbolIDTable: g,
            tableFirstS: o,
            tableDeltaS: c,
            tableDeltaT: C
          };
        }(e, t, this.customTables, c.length, g);
      }
      var h = new DecodingContext(i, a, s),
        l = decodeTextRegion(e.huffman, e.refinement, r.width, r.height, e.defaultPixelValue, e.numberOfSymbolInstances, e.stripSize, c, C, e.transposed, e.dsOffset, e.referenceCorner, e.combinationOperator, n, e.refinementTemplate, e.refinementAt, h, e.logStripSize, g);
      this.drawBitmap(r, l);
    }
  }, {
    key: "onImmediateLosslessTextRegion",
    value: function onImmediateLosslessTextRegion() {
      this.onImmediateTextRegion.apply(this, arguments);
    }
  }, {
    key: "onPatternDictionary",
    value: function onPatternDictionary(e, t, i, a, s) {
      var r = this.patterns;
      r || (this.patterns = r = {});
      var n = new DecodingContext(i, a, s);
      r[t] = function decodePatternDictionary(e, t, i, a, s, r) {
        var n = [];
        if (!e) {
          n.push({
            x: -t,
            y: 0
          });
          0 === s && n.push({
            x: -3,
            y: -1
          }, {
            x: 2,
            y: -2
          }, {
            x: -2,
            y: -2
          });
        }
        var g = decodeBitmap(e, (a + 1) * t, i, s, !1, null, n, r),
          o = [];
        for (var _e78 = 0; _e78 <= a; _e78++) {
          var _a45 = [],
            _s35 = t * _e78,
            _r25 = _s35 + t;
          for (var _e79 = 0; _e79 < i; _e79++) _a45.push(g[_e79].subarray(_s35, _r25));
          o.push(_a45);
        }
        return o;
      }(e.mmr, e.patternWidth, e.patternHeight, e.maxPatternIndex, e.template, n);
    }
  }, {
    key: "onImmediateHalftoneRegion",
    value: function onImmediateHalftoneRegion(e, t, i, a, s) {
      var r = this.patterns[t[0]],
        n = e.info,
        g = new DecodingContext(i, a, s),
        o = function decodeHalftoneRegion(e, t, i, a, s, r, n, g, o, c, C, h, l, Q, E) {
          if (n) throw new Jbig2Error("skip is not supported");
          if (0 !== g) throw new Jbig2Error("operator \"".concat(g, "\" is not supported in halftone region"));
          var u = [];
          var d, f, p;
          for (d = 0; d < s; d++) {
            p = new Uint8Array(a);
            if (r) for (f = 0; f < a; f++) p[f] = r;
            u.push(p);
          }
          var m = t.length,
            y = t[0],
            w = y[0].length,
            D = y.length,
            b = log2(m),
            F = [];
          if (!e) {
            F.push({
              x: i <= 1 ? 3 : 2,
              y: -1
            });
            0 === i && F.push({
              x: -3,
              y: -1
            }, {
              x: 2,
              y: -2
            }, {
              x: -2,
              y: -2
            });
          }
          var S = [];
          var k, R, N, G, x, U, M, L, H, J, Y;
          e && (k = new Reader(E.data, E.start, E.end));
          for (d = b - 1; d >= 0; d--) {
            R = e ? decodeMMRBitmap(k, o, c, !0) : decodeBitmap(!1, o, c, i, !1, null, F, E);
            S[d] = R;
          }
          for (N = 0; N < c; N++) for (G = 0; G < o; G++) {
            x = 0;
            U = 0;
            for (f = b - 1; f >= 0; f--) {
              x ^= S[f][N][G];
              U |= x << f;
            }
            M = t[U];
            L = C + N * Q + G * l >> 8;
            H = h + N * l - G * Q >> 8;
            if (L >= 0 && L + w <= a && H >= 0 && H + D <= s) for (d = 0; d < D; d++) {
              Y = u[H + d];
              J = M[d];
              for (f = 0; f < w; f++) Y[L + f] |= J[f];
            } else {
              var _e80 = void 0,
                _t75 = void 0;
              for (d = 0; d < D; d++) {
                _t75 = H + d;
                if (!(_t75 < 0 || _t75 >= s)) {
                  Y = u[_t75];
                  J = M[d];
                  for (f = 0; f < w; f++) {
                    _e80 = L + f;
                    _e80 >= 0 && _e80 < a && (Y[_e80] |= J[f]);
                  }
                }
              }
            }
          }
          return u;
        }(e.mmr, r, e.template, n.width, n.height, e.defaultPixelValue, e.enableSkip, e.combinationOperator, e.gridWidth, e.gridHeight, e.gridOffsetX, e.gridOffsetY, e.gridVectorX, e.gridVectorY, g);
      this.drawBitmap(n, o);
    }
  }, {
    key: "onImmediateLosslessHalftoneRegion",
    value: function onImmediateLosslessHalftoneRegion() {
      this.onImmediateHalftoneRegion.apply(this, arguments);
    }
  }, {
    key: "onTables",
    value: function onTables(e, t, i, a) {
      var s = this.customTables;
      s || (this.customTables = s = {});
      s[e] = function decodeTablesSegment(e, t, i) {
        var a = e[t],
          s = 4294967295 & readUint32(e, t + 1),
          r = 4294967295 & readUint32(e, t + 5),
          n = new Reader(e, t + 9, i),
          g = 1 + (a >> 1 & 7),
          o = 1 + (a >> 4 & 7),
          c = [];
        var C,
          h,
          l = s;
        do {
          C = n.readBits(g);
          h = n.readBits(o);
          c.push(new HuffmanLine([l, C, h, 0]));
          l += 1 << h;
        } while (l < r);
        C = n.readBits(g);
        c.push(new HuffmanLine([s - 1, C, 32, 0, "lower"]));
        C = n.readBits(g);
        c.push(new HuffmanLine([r, C, 32, 0]));
        if (1 & a) {
          C = n.readBits(g);
          c.push(new HuffmanLine([C, 0]));
        }
        return new HuffmanTable(c, !1);
      }(t, i, a);
    }
  }]);
}();
var HuffmanLine = /*#__PURE__*/_createClass(function HuffmanLine(e) {
  _classCallCheck(this, HuffmanLine);
  if (2 === e.length) {
    this.isOOB = !0;
    this.rangeLow = 0;
    this.prefixLength = e[0];
    this.rangeLength = 0;
    this.prefixCode = e[1];
    this.isLowerRange = !1;
  } else {
    this.isOOB = !1;
    this.rangeLow = e[0];
    this.prefixLength = e[1];
    this.rangeLength = e[2];
    this.prefixCode = e[3];
    this.isLowerRange = "lower" === e[4];
  }
});
var HuffmanTreeNode = /*#__PURE__*/function () {
  function HuffmanTreeNode(e) {
    _classCallCheck(this, HuffmanTreeNode);
    this.children = [];
    if (e) {
      this.isLeaf = !0;
      this.rangeLength = e.rangeLength;
      this.rangeLow = e.rangeLow;
      this.isLowerRange = e.isLowerRange;
      this.isOOB = e.isOOB;
    } else this.isLeaf = !1;
  }
  return _createClass(HuffmanTreeNode, [{
    key: "buildTree",
    value: function buildTree(e, t) {
      var i = e.prefixCode >> t & 1;
      if (t <= 0) this.children[i] = new HuffmanTreeNode(e);else {
        var _a46 = this.children[i];
        _a46 || (this.children[i] = _a46 = new HuffmanTreeNode(null));
        _a46.buildTree(e, t - 1);
      }
    }
  }, {
    key: "decodeNode",
    value: function decodeNode(e) {
      if (this.isLeaf) {
        if (this.isOOB) return null;
        var _t76 = e.readBits(this.rangeLength);
        return this.rangeLow + (this.isLowerRange ? -_t76 : _t76);
      }
      var t = this.children[e.readBit()];
      if (!t) throw new Jbig2Error("invalid Huffman data");
      return t.decodeNode(e);
    }
  }]);
}();
var HuffmanTable = /*#__PURE__*/function () {
  function HuffmanTable(e, t) {
    _classCallCheck(this, HuffmanTable);
    t || this.assignPrefixCodes(e);
    this.rootNode = new HuffmanTreeNode(null);
    for (var _t77 = 0, _i54 = e.length; _t77 < _i54; _t77++) {
      var _i55 = e[_t77];
      _i55.prefixLength > 0 && this.rootNode.buildTree(_i55, _i55.prefixLength - 1);
    }
  }
  return _createClass(HuffmanTable, [{
    key: "decode",
    value: function decode(e) {
      return this.rootNode.decodeNode(e);
    }
  }, {
    key: "assignPrefixCodes",
    value: function assignPrefixCodes(e) {
      var t = e.length;
      var i = 0;
      for (var _a47 = 0; _a47 < t; _a47++) i = Math.max(i, e[_a47].prefixLength);
      var a = new Uint32Array(i + 1);
      for (var _i56 = 0; _i56 < t; _i56++) a[e[_i56].prefixLength]++;
      var s,
        r,
        n,
        g = 1,
        o = 0;
      a[0] = 0;
      for (; g <= i;) {
        o = o + a[g - 1] << 1;
        s = o;
        r = 0;
        for (; r < t;) {
          n = e[r];
          if (n.prefixLength === g) {
            n.prefixCode = s;
            s++;
          }
          r++;
        }
        g++;
      }
    }
  }]);
}();
var Ai = {};
function getStandardTable(e) {
  var t,
    i = Ai[e];
  if (i) return i;
  switch (e) {
    case 1:
      t = [[0, 1, 4, 0], [16, 2, 8, 2], [272, 3, 16, 6], [65808, 3, 32, 7]];
      break;
    case 2:
      t = [[0, 1, 0, 0], [1, 2, 0, 2], [2, 3, 0, 6], [3, 4, 3, 14], [11, 5, 6, 30], [75, 6, 32, 62], [6, 63]];
      break;
    case 3:
      t = [[-256, 8, 8, 254], [0, 1, 0, 0], [1, 2, 0, 2], [2, 3, 0, 6], [3, 4, 3, 14], [11, 5, 6, 30], [-257, 8, 32, 255, "lower"], [75, 7, 32, 126], [6, 62]];
      break;
    case 4:
      t = [[1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 0, 6], [4, 4, 3, 14], [12, 5, 6, 30], [76, 5, 32, 31]];
      break;
    case 5:
      t = [[-255, 7, 8, 126], [1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 0, 6], [4, 4, 3, 14], [12, 5, 6, 30], [-256, 7, 32, 127, "lower"], [76, 6, 32, 62]];
      break;
    case 6:
      t = [[-2048, 5, 10, 28], [-1024, 4, 9, 8], [-512, 4, 8, 9], [-256, 4, 7, 10], [-128, 5, 6, 29], [-64, 5, 5, 30], [-32, 4, 5, 11], [0, 2, 7, 0], [128, 3, 7, 2], [256, 3, 8, 3], [512, 4, 9, 12], [1024, 4, 10, 13], [-2049, 6, 32, 62, "lower"], [2048, 6, 32, 63]];
      break;
    case 7:
      t = [[-1024, 4, 9, 8], [-512, 3, 8, 0], [-256, 4, 7, 9], [-128, 5, 6, 26], [-64, 5, 5, 27], [-32, 4, 5, 10], [0, 4, 5, 11], [32, 5, 5, 28], [64, 5, 6, 29], [128, 4, 7, 12], [256, 3, 8, 1], [512, 3, 9, 2], [1024, 3, 10, 3], [-1025, 5, 32, 30, "lower"], [2048, 5, 32, 31]];
      break;
    case 8:
      t = [[-15, 8, 3, 252], [-7, 9, 1, 508], [-5, 8, 1, 253], [-3, 9, 0, 509], [-2, 7, 0, 124], [-1, 4, 0, 10], [0, 2, 1, 0], [2, 5, 0, 26], [3, 6, 0, 58], [4, 3, 4, 4], [20, 6, 1, 59], [22, 4, 4, 11], [38, 4, 5, 12], [70, 5, 6, 27], [134, 5, 7, 28], [262, 6, 7, 60], [390, 7, 8, 125], [646, 6, 10, 61], [-16, 9, 32, 510, "lower"], [1670, 9, 32, 511], [2, 1]];
      break;
    case 9:
      t = [[-31, 8, 4, 252], [-15, 9, 2, 508], [-11, 8, 2, 253], [-7, 9, 1, 509], [-5, 7, 1, 124], [-3, 4, 1, 10], [-1, 3, 1, 2], [1, 3, 1, 3], [3, 5, 1, 26], [5, 6, 1, 58], [7, 3, 5, 4], [39, 6, 2, 59], [43, 4, 5, 11], [75, 4, 6, 12], [139, 5, 7, 27], [267, 5, 8, 28], [523, 6, 8, 60], [779, 7, 9, 125], [1291, 6, 11, 61], [-32, 9, 32, 510, "lower"], [3339, 9, 32, 511], [2, 0]];
      break;
    case 10:
      t = [[-21, 7, 4, 122], [-5, 8, 0, 252], [-4, 7, 0, 123], [-3, 5, 0, 24], [-2, 2, 2, 0], [2, 5, 0, 25], [3, 6, 0, 54], [4, 7, 0, 124], [5, 8, 0, 253], [6, 2, 6, 1], [70, 5, 5, 26], [102, 6, 5, 55], [134, 6, 6, 56], [198, 6, 7, 57], [326, 6, 8, 58], [582, 6, 9, 59], [1094, 6, 10, 60], [2118, 7, 11, 125], [-22, 8, 32, 254, "lower"], [4166, 8, 32, 255], [2, 2]];
      break;
    case 11:
      t = [[1, 1, 0, 0], [2, 2, 1, 2], [4, 4, 0, 12], [5, 4, 1, 13], [7, 5, 1, 28], [9, 5, 2, 29], [13, 6, 2, 60], [17, 7, 2, 122], [21, 7, 3, 123], [29, 7, 4, 124], [45, 7, 5, 125], [77, 7, 6, 126], [141, 7, 32, 127]];
      break;
    case 12:
      t = [[1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 1, 6], [5, 5, 0, 28], [6, 5, 1, 29], [8, 6, 1, 60], [10, 7, 0, 122], [11, 7, 1, 123], [13, 7, 2, 124], [17, 7, 3, 125], [25, 7, 4, 126], [41, 8, 5, 254], [73, 8, 32, 255]];
      break;
    case 13:
      t = [[1, 1, 0, 0], [2, 3, 0, 4], [3, 4, 0, 12], [4, 5, 0, 28], [5, 4, 1, 13], [7, 3, 3, 5], [15, 6, 1, 58], [17, 6, 2, 59], [21, 6, 3, 60], [29, 6, 4, 61], [45, 6, 5, 62], [77, 7, 6, 126], [141, 7, 32, 127]];
      break;
    case 14:
      t = [[-2, 3, 0, 4], [-1, 3, 0, 5], [0, 1, 0, 0], [1, 3, 0, 6], [2, 3, 0, 7]];
      break;
    case 15:
      t = [[-24, 7, 4, 124], [-8, 6, 2, 60], [-4, 5, 1, 28], [-2, 4, 0, 12], [-1, 3, 0, 4], [0, 1, 0, 0], [1, 3, 0, 5], [2, 4, 0, 13], [3, 5, 1, 29], [5, 6, 2, 61], [9, 7, 4, 125], [-25, 7, 32, 126, "lower"], [25, 7, 32, 127]];
      break;
    default:
      throw new Jbig2Error("standard table B.".concat(e, " does not exist"));
  }
  for (var _e81 = 0, _i57 = t.length; _e81 < _i57; _e81++) t[_e81] = new HuffmanLine(t[_e81]);
  i = new HuffmanTable(t, !0);
  Ai[e] = i;
  return i;
}
var Reader = /*#__PURE__*/function () {
  function Reader(e, t, i) {
    _classCallCheck(this, Reader);
    this.data = e;
    this.start = t;
    this.end = i;
    this.position = t;
    this.shift = -1;
    this.currentByte = 0;
  }
  return _createClass(Reader, [{
    key: "readBit",
    value: function readBit() {
      if (this.shift < 0) {
        if (this.position >= this.end) throw new Jbig2Error("end of data while reading bit");
        this.currentByte = this.data[this.position++];
        this.shift = 7;
      }
      var e = this.currentByte >> this.shift & 1;
      this.shift--;
      return e;
    }
  }, {
    key: "readBits",
    value: function readBits(e) {
      var t,
        i = 0;
      for (t = e - 1; t >= 0; t--) i |= this.readBit() << t;
      return i;
    }
  }, {
    key: "byteAlign",
    value: function byteAlign() {
      this.shift = -1;
    }
  }, {
    key: "next",
    value: function next() {
      return this.position >= this.end ? -1 : this.data[this.position++];
    }
  }]);
}();
function getCustomHuffmanTable(e, t, i) {
  var a = 0;
  for (var _s36 = 0, _r26 = t.length; _s36 < _r26; _s36++) {
    var _r27 = i[t[_s36]];
    if (_r27) {
      if (e === a) return _r27;
      a++;
    }
  }
  throw new Jbig2Error("can't find custom Huffman table");
}
function readUncompressedBitmap(e, t, i) {
  var a = [];
  for (var _s37 = 0; _s37 < i; _s37++) {
    var _i58 = new Uint8Array(t);
    a.push(_i58);
    for (var _a48 = 0; _a48 < t; _a48++) _i58[_a48] = e.readBit();
    e.byteAlign();
  }
  return a;
}
function decodeMMRBitmap(e, t, i, a) {
  var s = new CCITTFaxDecoder(e, {
      K: -1,
      Columns: t,
      Rows: i,
      BlackIs1: !0,
      EndOfBlock: a
    }),
    r = [];
  var n,
    g = !1;
  for (var _e82 = 0; _e82 < i; _e82++) {
    var _e83 = new Uint8Array(t);
    r.push(_e83);
    var _i59 = -1;
    for (var _a49 = 0; _a49 < t; _a49++) {
      if (_i59 < 0) {
        n = s.readNextChar();
        if (-1 === n) {
          n = 0;
          g = !0;
        }
        _i59 = 7;
      }
      _e83[_a49] = n >> _i59 & 1;
      _i59--;
    }
  }
  if (a && !g) {
    var _e84 = 5;
    for (var _t78 = 0; _t78 < _e84 && -1 !== s.readNextChar(); _t78++);
  }
  return r;
}
var Jbig2Image = /*#__PURE__*/function () {
  function Jbig2Image() {
    _classCallCheck(this, Jbig2Image);
  }
  return _createClass(Jbig2Image, [{
    key: "parseChunks",
    value: function parseChunks(e) {
      return function parseJbig2Chunks(e) {
        var t = new SimpleSegmentVisitor();
        for (var _i60 = 0, _a50 = e.length; _i60 < _a50; _i60++) {
          var _a51 = e[_i60];
          processSegments(readSegments({}, _a51.data, _a51.start, _a51.end), t);
        }
        return t.buffer;
      }(e);
    }
  }, {
    key: "parse",
    value: function parse(e) {
      throw new Error("Not implemented: Jbig2Image.parse");
    }
  }]);
}();
var Jbig2Stream = /*#__PURE__*/function (_DecodeStream6) {
  function Jbig2Stream(e, t, i) {
    var _this22;
    _classCallCheck(this, Jbig2Stream);
    _this22 = _callSuper(this, Jbig2Stream, [t]);
    _this22.stream = e;
    _this22.dict = e.dict;
    _this22.maybeLength = t;
    _this22.params = i;
    return _this22;
  }
  _inherits(Jbig2Stream, _DecodeStream6);
  return _createClass(Jbig2Stream, [{
    key: "bytes",
    get: function get() {
      return shadow(this, "bytes", this.stream.getBytes(this.maybeLength));
    }
  }, {
    key: "ensureBuffer",
    value: function ensureBuffer(e) {}
  }, {
    key: "readBlock",
    value: function readBlock() {
      this.decodeImage();
    }
  }, {
    key: "decodeImage",
    value: function decodeImage(e) {
      if (this.eof) return this.buffer;
      e || (e = this.bytes);
      var t = new Jbig2Image(),
        i = [];
      if (this.params instanceof Dict) {
        var _e85 = this.params.get("JBIG2Globals");
        if (_e85 instanceof BaseStream) {
          var _t79 = _e85.getBytes();
          i.push({
            data: _t79,
            start: 0,
            end: _t79.length
          });
        }
      }
      i.push({
        data: e,
        start: 0,
        end: e.length
      });
      var a = t.parseChunks(i),
        s = a.length;
      for (var _e86 = 0; _e86 < s; _e86++) a[_e86] ^= 255;
      this.buffer = a;
      this.bufferLength = s;
      this.eof = !0;
      return this.buffer;
    }
  }, {
    key: "canAsyncDecodeImageFromBuffer",
    get: function get() {
      return this.stream.isAsync;
    }
  }]);
}(DecodeStream);
function convertToRGBA(e) {
  switch (e.kind) {
    case b:
      return convertBlackAndWhiteToRGBA(e);
    case F:
      return function convertRGBToRGBA(_ref27) {
        var e = _ref27.src,
          _ref27$srcPos = _ref27.srcPos,
          t = _ref27$srcPos === void 0 ? 0 : _ref27$srcPos,
          i = _ref27.dest,
          _ref27$destPos = _ref27.destPos,
          a = _ref27$destPos === void 0 ? 0 : _ref27$destPos,
          s = _ref27.width,
          r = _ref27.height;
        var n = 0;
        var g = e.length >> 2,
          o = new Uint32Array(e.buffer, t, g);
        if (FeatureTest.isLittleEndian) {
          for (; n < g - 2; n += 3, a += 4) {
            var _e87 = o[n],
              _t80 = o[n + 1],
              _s38 = o[n + 2];
            i[a] = 4278190080 | _e87;
            i[a + 1] = _e87 >>> 24 | _t80 << 8 | 4278190080;
            i[a + 2] = _t80 >>> 16 | _s38 << 16 | 4278190080;
            i[a + 3] = _s38 >>> 8 | 4278190080;
          }
          for (var _t81 = 4 * n, _s39 = e.length; _t81 < _s39; _t81 += 3) i[a++] = e[_t81] | e[_t81 + 1] << 8 | e[_t81 + 2] << 16 | 4278190080;
        } else {
          for (; n < g - 2; n += 3, a += 4) {
            var _e88 = o[n],
              _t82 = o[n + 1],
              _s40 = o[n + 2];
            i[a] = 255 | _e88;
            i[a + 1] = _e88 << 24 | _t82 >>> 8 | 255;
            i[a + 2] = _t82 << 16 | _s40 >>> 16 | 255;
            i[a + 3] = _s40 << 8 | 255;
          }
          for (var _t83 = 4 * n, _s41 = e.length; _t83 < _s41; _t83 += 3) i[a++] = e[_t83] << 24 | e[_t83 + 1] << 16 | e[_t83 + 2] << 8 | 255;
        }
        return {
          srcPos: t,
          destPos: a
        };
      }(e);
  }
  return null;
}
function convertBlackAndWhiteToRGBA(_ref28) {
  var e = _ref28.src,
    _ref28$srcPos = _ref28.srcPos,
    t = _ref28$srcPos === void 0 ? 0 : _ref28$srcPos,
    i = _ref28.dest,
    a = _ref28.width,
    s = _ref28.height,
    _ref28$nonBlackColor = _ref28.nonBlackColor,
    r = _ref28$nonBlackColor === void 0 ? 4294967295 : _ref28$nonBlackColor,
    _ref28$inverseDecode = _ref28.inverseDecode,
    n = _ref28$inverseDecode === void 0 ? !1 : _ref28$inverseDecode;
  var g = FeatureTest.isLittleEndian ? 4278190080 : 255,
    _ref29 = n ? [r, g] : [g, r],
    _ref30 = _slicedToArray(_ref29, 2),
    o = _ref30[0],
    c = _ref30[1],
    C = a >> 3,
    h = 7 & a,
    l = e.length;
  i = new Uint32Array(i.buffer);
  var Q = 0;
  for (var _a52 = 0; _a52 < s; _a52++) {
    for (var _a53 = t + C; t < _a53; t++) {
      var _a54 = t < l ? e[t] : 255;
      i[Q++] = 128 & _a54 ? c : o;
      i[Q++] = 64 & _a54 ? c : o;
      i[Q++] = 32 & _a54 ? c : o;
      i[Q++] = 16 & _a54 ? c : o;
      i[Q++] = 8 & _a54 ? c : o;
      i[Q++] = 4 & _a54 ? c : o;
      i[Q++] = 2 & _a54 ? c : o;
      i[Q++] = 1 & _a54 ? c : o;
    }
    if (0 === h) continue;
    var _a55 = t < l ? e[t++] : 255;
    for (var _e89 = 0; _e89 < h; _e89++) i[Q++] = _a55 & 1 << 7 - _e89 ? c : o;
  }
  return {
    srcPos: t,
    destPos: Q
  };
}
var JpegError = /*#__PURE__*/function (_gt13) {
  function JpegError(e) {
    _classCallCheck(this, JpegError);
    return _callSuper(this, JpegError, [e, "JpegError"]);
  }
  _inherits(JpegError, _gt13);
  return _createClass(JpegError);
}(gt);
var DNLMarkerError = /*#__PURE__*/function (_gt14) {
  function DNLMarkerError(e, t) {
    var _this23;
    _classCallCheck(this, DNLMarkerError);
    _this23 = _callSuper(this, DNLMarkerError, [e, "DNLMarkerError"]);
    _this23.scanLines = t;
    return _this23;
  }
  _inherits(DNLMarkerError, _gt14);
  return _createClass(DNLMarkerError);
}(gt);
var EOIMarkerError = /*#__PURE__*/function (_gt15) {
  function EOIMarkerError(e) {
    _classCallCheck(this, EOIMarkerError);
    return _callSuper(this, EOIMarkerError, [e, "EOIMarkerError"]);
  }
  _inherits(EOIMarkerError, _gt15);
  return _createClass(EOIMarkerError);
}(gt);
var ei = new Uint8Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]),
  ti = 4017,
  ii = 799,
  ai = 3406,
  si = 2276,
  ri = 1567,
  ni = 3784,
  gi = 5793,
  oi = 2896;
function buildHuffmanTable(e, t) {
  var i,
    a,
    s = 0,
    r = 16;
  for (; r > 0 && !e[r - 1];) r--;
  var n = [{
    children: [],
    index: 0
  }];
  var g,
    o = n[0];
  for (i = 0; i < r; i++) {
    for (a = 0; a < e[i]; a++) {
      o = n.pop();
      o.children[o.index] = t[s];
      for (; o.index > 0;) o = n.pop();
      o.index++;
      n.push(o);
      for (; n.length <= i;) {
        n.push(g = {
          children: [],
          index: 0
        });
        o.children[o.index] = g.children;
        o = g;
      }
      s++;
    }
    if (i + 1 < r) {
      n.push(g = {
        children: [],
        index: 0
      });
      o.children[o.index] = g.children;
      o = g;
    }
  }
  return n[0].children;
}
function getBlockBufferOffset(e, t, i) {
  return 64 * ((e.blocksPerLine + 1) * t + i);
}
function decodeScan(e, t, i, a, s, r, n, g, o) {
  var c = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : !1;
  var C = i.mcusPerLine,
    h = i.progressive,
    l = t;
  var Q = 0,
    E = 0;
  function readBit() {
    if (E > 0) {
      E--;
      return Q >> E & 1;
    }
    Q = e[t++];
    if (255 === Q) {
      var _a56 = e[t++];
      if (_a56) {
        if (220 === _a56 && c) {
          var _a57 = readUint16(e, t += 2);
          t += 2;
          if (_a57 > 0 && _a57 !== i.scanLines) throw new DNLMarkerError("Found DNL marker (0xFFDC) while parsing scan data", _a57);
        } else if (217 === _a56) {
          if (c) {
            var _e90 = p * (8 === i.precision ? 8 : 0);
            if (_e90 > 0 && Math.round(i.scanLines / _e90) >= 5) throw new DNLMarkerError("Found EOI marker (0xFFD9) while parsing scan data, possibly caused by incorrect `scanLines` parameter", _e90);
          }
          throw new EOIMarkerError("Found EOI marker (0xFFD9) while parsing scan data");
        }
        throw new JpegError("unexpected marker ".concat((Q << 8 | _a56).toString(16)));
      }
    }
    E = 7;
    return Q >>> 7;
  }
  function decodeHuffman(e) {
    var t = e;
    for (;;) {
      t = t[readBit()];
      switch (_typeof(t)) {
        case "number":
          return t;
        case "object":
          continue;
      }
      throw new JpegError("invalid huffman sequence");
    }
  }
  function receive(e) {
    var t = 0;
    for (; e > 0;) {
      t = t << 1 | readBit();
      e--;
    }
    return t;
  }
  function receiveAndExtend(e) {
    if (1 === e) return 1 === readBit() ? 1 : -1;
    var t = receive(e);
    return t >= 1 << e - 1 ? t : t + (-1 << e) + 1;
  }
  var u = 0;
  var d,
    f = 0;
  var p = 0;
  function decodeMcu(e, t, i, a, s) {
    var r = i % C;
    p = (i / C | 0) * e.v + a;
    var n = r * e.h + s;
    t(e, getBlockBufferOffset(e, p, n));
  }
  function decodeBlock(e, t, i) {
    p = i / e.blocksPerLine | 0;
    var a = i % e.blocksPerLine;
    t(e, getBlockBufferOffset(e, p, a));
  }
  var m = a.length;
  var y, w, D, b, F, S;
  S = h ? 0 === r ? 0 === g ? function decodeDCFirst(e, t) {
    var i = decodeHuffman(e.huffmanTableDC),
      a = 0 === i ? 0 : receiveAndExtend(i) << o;
    e.blockData[t] = e.pred += a;
  } : function decodeDCSuccessive(e, t) {
    e.blockData[t] |= readBit() << o;
  } : 0 === g ? function decodeACFirst(e, t) {
    if (u > 0) {
      u--;
      return;
    }
    var i = r;
    var a = n;
    for (; i <= a;) {
      var _a58 = decodeHuffman(e.huffmanTableAC),
        _s42 = 15 & _a58,
        _r28 = _a58 >> 4;
      if (0 === _s42) {
        if (_r28 < 15) {
          u = receive(_r28) + (1 << _r28) - 1;
          break;
        }
        i += 16;
        continue;
      }
      i += _r28;
      var _n19 = ei[i];
      e.blockData[t + _n19] = receiveAndExtend(_s42) * (1 << o);
      i++;
    }
  } : function decodeACSuccessive(e, t) {
    var i = r;
    var a = n;
    var s,
      g,
      c = 0;
    for (; i <= a;) {
      var _a59 = t + ei[i],
        _r29 = e.blockData[_a59] < 0 ? -1 : 1;
      switch (f) {
        case 0:
          g = decodeHuffman(e.huffmanTableAC);
          s = 15 & g;
          c = g >> 4;
          if (0 === s) {
            if (c < 15) {
              u = receive(c) + (1 << c);
              f = 4;
            } else {
              c = 16;
              f = 1;
            }
          } else {
            if (1 !== s) throw new JpegError("invalid ACn encoding");
            d = receiveAndExtend(s);
            f = c ? 2 : 3;
          }
          continue;
        case 1:
        case 2:
          if (e.blockData[_a59]) e.blockData[_a59] += _r29 * (readBit() << o);else {
            c--;
            0 === c && (f = 2 === f ? 3 : 0);
          }
          break;
        case 3:
          if (e.blockData[_a59]) e.blockData[_a59] += _r29 * (readBit() << o);else {
            e.blockData[_a59] = d << o;
            f = 0;
          }
          break;
        case 4:
          e.blockData[_a59] && (e.blockData[_a59] += _r29 * (readBit() << o));
      }
      i++;
    }
    if (4 === f) {
      u--;
      0 === u && (f = 0);
    }
  } : function decodeBaseline(e, t) {
    var i = decodeHuffman(e.huffmanTableDC),
      a = 0 === i ? 0 : receiveAndExtend(i);
    e.blockData[t] = e.pred += a;
    var s = 1;
    for (; s < 64;) {
      var _i61 = decodeHuffman(e.huffmanTableAC),
        _a60 = 15 & _i61,
        _r30 = _i61 >> 4;
      if (0 === _a60) {
        if (_r30 < 15) break;
        s += 16;
        continue;
      }
      s += _r30;
      var _n20 = ei[s];
      e.blockData[t + _n20] = receiveAndExtend(_a60);
      s++;
    }
  };
  var k,
    R = 0;
  var N = 1 === m ? a[0].blocksPerLine * a[0].blocksPerColumn : C * i.mcusPerColumn;
  var G, x;
  for (; R <= N;) {
    var _i62 = s ? Math.min(N - R, s) : N;
    if (_i62 > 0) {
      for (w = 0; w < m; w++) a[w].pred = 0;
      u = 0;
      if (1 === m) {
        y = a[0];
        for (F = 0; F < _i62; F++) {
          decodeBlock(y, S, R);
          R++;
        }
      } else for (F = 0; F < _i62; F++) {
        for (w = 0; w < m; w++) {
          y = a[w];
          G = y.h;
          x = y.v;
          for (D = 0; D < x; D++) for (b = 0; b < G; b++) decodeMcu(y, S, R, D, b);
        }
        R++;
      }
    }
    E = 0;
    k = findNextFileMarker(e, t);
    if (!k) break;
    if (k.invalid) {
      warn("decodeScan - ".concat(_i62 > 0 ? "unexpected" : "excessive", " MCU data, current marker is: ").concat(k.invalid));
      t = k.offset;
    }
    if (!(k.marker >= 65488 && k.marker <= 65495)) break;
    t += 2;
  }
  return t - l;
}
function quantizeAndInverse(e, t, i) {
  var a = e.quantizationTable,
    s = e.blockData;
  var r, n, g, o, c, C, h, l, Q, E, u, d, f, p, m, y, w;
  if (!a) throw new JpegError("missing required Quantization Table.");
  for (var _e91 = 0; _e91 < 64; _e91 += 8) {
    Q = s[t + _e91];
    E = s[t + _e91 + 1];
    u = s[t + _e91 + 2];
    d = s[t + _e91 + 3];
    f = s[t + _e91 + 4];
    p = s[t + _e91 + 5];
    m = s[t + _e91 + 6];
    y = s[t + _e91 + 7];
    Q *= a[_e91];
    if (0 != (E | u | d | f | p | m | y)) {
      E *= a[_e91 + 1];
      u *= a[_e91 + 2];
      d *= a[_e91 + 3];
      f *= a[_e91 + 4];
      p *= a[_e91 + 5];
      m *= a[_e91 + 6];
      y *= a[_e91 + 7];
      r = gi * Q + 128 >> 8;
      n = gi * f + 128 >> 8;
      g = u;
      o = m;
      c = oi * (E - y) + 128 >> 8;
      l = oi * (E + y) + 128 >> 8;
      C = d << 4;
      h = p << 4;
      r = r + n + 1 >> 1;
      n = r - n;
      w = g * ni + o * ri + 128 >> 8;
      g = g * ri - o * ni + 128 >> 8;
      o = w;
      c = c + h + 1 >> 1;
      h = c - h;
      l = l + C + 1 >> 1;
      C = l - C;
      r = r + o + 1 >> 1;
      o = r - o;
      n = n + g + 1 >> 1;
      g = n - g;
      w = c * si + l * ai + 2048 >> 12;
      c = c * ai - l * si + 2048 >> 12;
      l = w;
      w = C * ii + h * ti + 2048 >> 12;
      C = C * ti - h * ii + 2048 >> 12;
      h = w;
      i[_e91] = r + l;
      i[_e91 + 7] = r - l;
      i[_e91 + 1] = n + h;
      i[_e91 + 6] = n - h;
      i[_e91 + 2] = g + C;
      i[_e91 + 5] = g - C;
      i[_e91 + 3] = o + c;
      i[_e91 + 4] = o - c;
    } else {
      w = gi * Q + 512 >> 10;
      i[_e91] = w;
      i[_e91 + 1] = w;
      i[_e91 + 2] = w;
      i[_e91 + 3] = w;
      i[_e91 + 4] = w;
      i[_e91 + 5] = w;
      i[_e91 + 6] = w;
      i[_e91 + 7] = w;
    }
  }
  for (var _e92 = 0; _e92 < 8; ++_e92) {
    Q = i[_e92];
    E = i[_e92 + 8];
    u = i[_e92 + 16];
    d = i[_e92 + 24];
    f = i[_e92 + 32];
    p = i[_e92 + 40];
    m = i[_e92 + 48];
    y = i[_e92 + 56];
    if (0 != (E | u | d | f | p | m | y)) {
      r = gi * Q + 2048 >> 12;
      n = gi * f + 2048 >> 12;
      g = u;
      o = m;
      c = oi * (E - y) + 2048 >> 12;
      l = oi * (E + y) + 2048 >> 12;
      C = d;
      h = p;
      r = 4112 + (r + n + 1 >> 1);
      n = r - n;
      w = g * ni + o * ri + 2048 >> 12;
      g = g * ri - o * ni + 2048 >> 12;
      o = w;
      c = c + h + 1 >> 1;
      h = c - h;
      l = l + C + 1 >> 1;
      C = l - C;
      r = r + o + 1 >> 1;
      o = r - o;
      n = n + g + 1 >> 1;
      g = n - g;
      w = c * si + l * ai + 2048 >> 12;
      c = c * ai - l * si + 2048 >> 12;
      l = w;
      w = C * ii + h * ti + 2048 >> 12;
      C = C * ti - h * ii + 2048 >> 12;
      h = w;
      Q = r + l;
      y = r - l;
      E = n + h;
      m = n - h;
      u = g + C;
      p = g - C;
      d = o + c;
      f = o - c;
      Q < 16 ? Q = 0 : Q >= 4080 ? Q = 255 : Q >>= 4;
      E < 16 ? E = 0 : E >= 4080 ? E = 255 : E >>= 4;
      u < 16 ? u = 0 : u >= 4080 ? u = 255 : u >>= 4;
      d < 16 ? d = 0 : d >= 4080 ? d = 255 : d >>= 4;
      f < 16 ? f = 0 : f >= 4080 ? f = 255 : f >>= 4;
      p < 16 ? p = 0 : p >= 4080 ? p = 255 : p >>= 4;
      m < 16 ? m = 0 : m >= 4080 ? m = 255 : m >>= 4;
      y < 16 ? y = 0 : y >= 4080 ? y = 255 : y >>= 4;
      s[t + _e92] = Q;
      s[t + _e92 + 8] = E;
      s[t + _e92 + 16] = u;
      s[t + _e92 + 24] = d;
      s[t + _e92 + 32] = f;
      s[t + _e92 + 40] = p;
      s[t + _e92 + 48] = m;
      s[t + _e92 + 56] = y;
    } else {
      w = gi * Q + 8192 >> 14;
      w = w < -2040 ? 0 : w >= 2024 ? 255 : w + 2056 >> 4;
      s[t + _e92] = w;
      s[t + _e92 + 8] = w;
      s[t + _e92 + 16] = w;
      s[t + _e92 + 24] = w;
      s[t + _e92 + 32] = w;
      s[t + _e92 + 40] = w;
      s[t + _e92 + 48] = w;
      s[t + _e92 + 56] = w;
    }
  }
}
function buildComponentData(e, t) {
  var i = t.blocksPerLine,
    a = t.blocksPerColumn,
    s = new Int16Array(64);
  for (var _e93 = 0; _e93 < a; _e93++) for (var _a61 = 0; _a61 < i; _a61++) {
    quantizeAndInverse(t, getBlockBufferOffset(t, _e93, _a61), s);
  }
  return t.blockData;
}
function findNextFileMarker(e, t) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t;
  var a = e.length - 1;
  var s = i < t ? i : t;
  if (t >= a) return null;
  var r = readUint16(e, t);
  if (r >= 65472 && r <= 65534) return {
    invalid: null,
    marker: r,
    offset: t
  };
  var n = readUint16(e, s);
  for (; !(n >= 65472 && n <= 65534);) {
    if (++s >= a) return null;
    n = readUint16(e, s);
  }
  return {
    invalid: r.toString(16),
    marker: n,
    offset: s
  };
}
function prepareComponents(e) {
  var t = Math.ceil(e.samplesPerLine / 8 / e.maxH),
    i = Math.ceil(e.scanLines / 8 / e.maxV);
  var _iterator22 = _createForOfIteratorHelper(e.components),
    _step22;
  try {
    for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
      var _a62 = _step22.value;
      var _s43 = Math.ceil(Math.ceil(e.samplesPerLine / 8) * _a62.h / e.maxH),
        _r31 = Math.ceil(Math.ceil(e.scanLines / 8) * _a62.v / e.maxV),
        _n21 = t * _a62.h,
        _g11 = 64 * (i * _a62.v) * (_n21 + 1);
      _a62.blockData = new Int16Array(_g11);
      _a62.blocksPerLine = _s43;
      _a62.blocksPerColumn = _r31;
    }
  } catch (err) {
    _iterator22.e(err);
  } finally {
    _iterator22.f();
  }
  e.mcusPerLine = t;
  e.mcusPerColumn = i;
}
function readDataBlock(e, t) {
  var i = readUint16(e, t);
  var a = (t += 2) + i - 2;
  var s = findNextFileMarker(e, a, t);
  if (s !== null && s !== void 0 && s.invalid) {
    warn("readDataBlock - incorrect length, current marker is: " + s.invalid);
    a = s.offset;
  }
  var r = e.subarray(t, a);
  return {
    appData: r,
    newOffset: t += r.length
  };
}
function skipData(e, t) {
  var i = readUint16(e, t),
    a = (t += 2) + i - 2,
    s = findNextFileMarker(e, a, t);
  return s !== null && s !== void 0 && s.invalid ? s.offset : a;
}
var JpegImage = /*#__PURE__*/function () {
  function JpegImage() {
    var _ref31 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref31$decodeTransfor = _ref31.decodeTransform,
      e = _ref31$decodeTransfor === void 0 ? null : _ref31$decodeTransfor,
      _ref31$colorTransform = _ref31.colorTransform,
      t = _ref31$colorTransform === void 0 ? -1 : _ref31$colorTransform;
    _classCallCheck(this, JpegImage);
    this._decodeTransform = e;
    this._colorTransform = t;
  }
  return _createClass(JpegImage, [{
    key: "parse",
    value: function parse(e) {
      var _ref32 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref32$dnlScanLines = _ref32.dnlScanLines,
        t = _ref32$dnlScanLines === void 0 ? null : _ref32$dnlScanLines;
      var i,
        a,
        s = 0,
        r = null,
        n = null,
        g = 0;
      var o = [],
        c = [],
        C = [];
      var h = readUint16(e, s);
      s += 2;
      if (65496 !== h) throw new JpegError("SOI not found");
      h = readUint16(e, s);
      s += 2;
      A: for (; 65497 !== h;) {
        var l = void 0,
          _Q7 = void 0,
          _E7 = void 0;
        switch (h) {
          case 65504:
          case 65505:
          case 65506:
          case 65507:
          case 65508:
          case 65509:
          case 65510:
          case 65511:
          case 65512:
          case 65513:
          case 65514:
          case 65515:
          case 65516:
          case 65517:
          case 65518:
          case 65519:
          case 65534:
            var _readDataBlock = readDataBlock(e, s),
              _u5 = _readDataBlock.appData,
              _d5 = _readDataBlock.newOffset;
            s = _d5;
            65504 === h && 74 === _u5[0] && 70 === _u5[1] && 73 === _u5[2] && 70 === _u5[3] && 0 === _u5[4] && (r = {
              version: {
                major: _u5[5],
                minor: _u5[6]
              },
              densityUnits: _u5[7],
              xDensity: _u5[8] << 8 | _u5[9],
              yDensity: _u5[10] << 8 | _u5[11],
              thumbWidth: _u5[12],
              thumbHeight: _u5[13],
              thumbData: _u5.subarray(14, 14 + 3 * _u5[12] * _u5[13])
            });
            65518 === h && 65 === _u5[0] && 100 === _u5[1] && 111 === _u5[2] && 98 === _u5[3] && 101 === _u5[4] && (n = {
              version: _u5[5] << 8 | _u5[6],
              flags0: _u5[7] << 8 | _u5[8],
              flags1: _u5[9] << 8 | _u5[10],
              transformCode: _u5[11]
            });
            break;
          case 65499:
            var _f7 = readUint16(e, s);
            s += 2;
            var _p5 = _f7 + s - 2;
            var _m5 = void 0;
            for (; s < _p5;) {
              var _t84 = e[s++],
                _i63 = new Uint16Array(64);
              if (_t84 >> 4 == 0) for (_Q7 = 0; _Q7 < 64; _Q7++) {
                _m5 = ei[_Q7];
                _i63[_m5] = e[s++];
              } else {
                if (_t84 >> 4 != 1) throw new JpegError("DQT - invalid table spec");
                for (_Q7 = 0; _Q7 < 64; _Q7++) {
                  _m5 = ei[_Q7];
                  _i63[_m5] = readUint16(e, s);
                  s += 2;
                }
              }
              o[15 & _t84] = _i63;
            }
            break;
          case 65472:
          case 65473:
          case 65474:
            if (i) throw new JpegError("Only single frame JPEGs supported");
            s += 2;
            i = {};
            i.extended = 65473 === h;
            i.progressive = 65474 === h;
            i.precision = e[s++];
            var _y = readUint16(e, s);
            s += 2;
            i.scanLines = t || _y;
            i.samplesPerLine = readUint16(e, s);
            s += 2;
            i.components = [];
            i.componentIds = {};
            var _w = e[s++];
            var _D = 0,
              _b = 0;
            for (l = 0; l < _w; l++) {
              var _t85 = e[s],
                _a63 = e[s + 1] >> 4,
                _r32 = 15 & e[s + 1];
              _D < _a63 && (_D = _a63);
              _b < _r32 && (_b = _r32);
              var _n22 = e[s + 2];
              _E7 = i.components.push({
                h: _a63,
                v: _r32,
                quantizationId: _n22,
                quantizationTable: null
              });
              i.componentIds[_t85] = _E7 - 1;
              s += 3;
            }
            i.maxH = _D;
            i.maxV = _b;
            prepareComponents(i);
            break;
          case 65476:
            var _F = readUint16(e, s);
            s += 2;
            for (l = 2; l < _F;) {
              var _t86 = e[s++],
                _i64 = new Uint8Array(16);
              var _a64 = 0;
              for (_Q7 = 0; _Q7 < 16; _Q7++, s++) _a64 += _i64[_Q7] = e[s];
              var _r33 = new Uint8Array(_a64);
              for (_Q7 = 0; _Q7 < _a64; _Q7++, s++) _r33[_Q7] = e[s];
              l += 17 + _a64;
              (_t86 >> 4 == 0 ? C : c)[15 & _t86] = buildHuffmanTable(_i64, _r33);
            }
            break;
          case 65501:
            s += 2;
            a = readUint16(e, s);
            s += 2;
            break;
          case 65498:
            var _S2 = 1 == ++g && !t;
            s += 2;
            var _k2 = e[s++],
              _R2 = [];
            for (l = 0; l < _k2; l++) {
              var _t87 = e[s++],
                _a65 = i.componentIds[_t87],
                _r34 = i.components[_a65];
              _r34.index = _t87;
              var _n23 = e[s++];
              _r34.huffmanTableDC = C[_n23 >> 4];
              _r34.huffmanTableAC = c[15 & _n23];
              _R2.push(_r34);
            }
            var _N2 = e[s++],
              _G2 = e[s++],
              _x14 = e[s++];
            try {
              s += decodeScan(e, s, i, _R2, a, _N2, _G2, _x14 >> 4, 15 & _x14, _S2);
            } catch (t) {
              if (t instanceof DNLMarkerError) {
                warn("".concat(t.message, " -- attempting to re-parse the JPEG image."));
                return this.parse(e, {
                  dnlScanLines: t.scanLines
                });
              }
              if (t instanceof EOIMarkerError) {
                warn("".concat(t.message, " -- ignoring the rest of the image data."));
                break A;
              }
              throw t;
            }
            break;
          case 65500:
            s += 4;
            break;
          case 65535:
            255 !== e[s] && s--;
            break;
          default:
            var _U2 = findNextFileMarker(e, s - 2, s - 3);
            if (_U2 !== null && _U2 !== void 0 && _U2.invalid) {
              warn("JpegImage.parse - unexpected data, current marker is: " + _U2.invalid);
              s = _U2.offset;
              break;
            }
            if (!_U2 || s >= e.length - 1) {
              warn("JpegImage.parse - reached the end of the image data without finding an EOI marker (0xFFD9).");
              break A;
            }
            throw new JpegError("JpegImage.parse - unknown marker: " + h.toString(16));
        }
        h = readUint16(e, s);
        s += 2;
      }
      if (!i) throw new JpegError("JpegImage.parse - no frame data found.");
      this.width = i.samplesPerLine;
      this.height = i.scanLines;
      this.jfif = r;
      this.adobe = n;
      this.components = [];
      var _iterator23 = _createForOfIteratorHelper(i.components),
        _step23;
      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var _e94 = _step23.value;
          var _t88 = o[_e94.quantizationId];
          _t88 && (_e94.quantizationTable = _t88);
          this.components.push({
            index: _e94.index,
            output: buildComponentData(0, _e94),
            scaleX: _e94.h / i.maxH,
            scaleY: _e94.v / i.maxV,
            blocksPerLine: _e94.blocksPerLine,
            blocksPerColumn: _e94.blocksPerColumn
          });
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
      this.numComponents = this.components.length;
    }
  }, {
    key: "_getLinearizedBlockData",
    value: function _getLinearizedBlockData(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var a = this.width / e,
        s = this.height / t;
      var r,
        n,
        g,
        o,
        c,
        C,
        h,
        l,
        Q,
        E,
        u,
        d = 0;
      var f = this.components.length,
        p = e * t * f,
        m = new Uint8ClampedArray(p),
        y = new Uint32Array(e),
        w = 4294967288;
      var D;
      for (h = 0; h < f; h++) {
        r = this.components[h];
        n = r.scaleX * a;
        g = r.scaleY * s;
        d = h;
        u = r.output;
        o = r.blocksPerLine + 1 << 3;
        if (n !== D) {
          for (c = 0; c < e; c++) {
            l = 0 | c * n;
            y[c] = (l & w) << 3 | 7 & l;
          }
          D = n;
        }
        for (C = 0; C < t; C++) {
          l = 0 | C * g;
          E = o * (l & w) | (7 & l) << 3;
          for (c = 0; c < e; c++) {
            m[d] = u[E + y[c]];
            d += f;
          }
        }
      }
      var b = this._decodeTransform;
      i || 4 !== f || b || (b = new Int32Array([-256, 255, -256, 255, -256, 255, -256, 255]));
      if (b) for (h = 0; h < p;) for (l = 0, Q = 0; l < f; l++, h++, Q += 2) m[h] = (m[h] * b[Q] >> 8) + b[Q + 1];
      return m;
    }
  }, {
    key: "_isColorConversionNeeded",
    get: function get() {
      return this.adobe ? !!this.adobe.transformCode : 3 === this.numComponents ? 0 !== this._colorTransform && (82 !== this.components[0].index || 71 !== this.components[1].index || 66 !== this.components[2].index) : 1 === this._colorTransform;
    }
  }, {
    key: "_convertYccToRgb",
    value: function _convertYccToRgb(e) {
      var t, i, a;
      for (var _s44 = 0, _r35 = e.length; _s44 < _r35; _s44 += 3) {
        t = e[_s44];
        i = e[_s44 + 1];
        a = e[_s44 + 2];
        e[_s44] = t - 179.456 + 1.402 * a;
        e[_s44 + 1] = t + 135.459 - .344 * i - .714 * a;
        e[_s44 + 2] = t - 226.816 + 1.772 * i;
      }
      return e;
    }
  }, {
    key: "_convertYccToRgba",
    value: function _convertYccToRgba(e, t) {
      for (var _i65 = 0, _a66 = 0, _s45 = e.length; _i65 < _s45; _i65 += 3, _a66 += 4) {
        var _s46 = e[_i65],
          _r36 = e[_i65 + 1],
          _n24 = e[_i65 + 2];
        t[_a66] = _s46 - 179.456 + 1.402 * _n24;
        t[_a66 + 1] = _s46 + 135.459 - .344 * _r36 - .714 * _n24;
        t[_a66 + 2] = _s46 - 226.816 + 1.772 * _r36;
        t[_a66 + 3] = 255;
      }
      return t;
    }
  }, {
    key: "_convertYcckToRgb",
    value: function _convertYcckToRgb(e) {
      var t,
        i,
        a,
        s,
        r = 0;
      for (var _n25 = 0, _g12 = e.length; _n25 < _g12; _n25 += 4) {
        t = e[_n25];
        i = e[_n25 + 1];
        a = e[_n25 + 2];
        s = e[_n25 + 3];
        e[r++] = i * (-660635669420364e-19 * i + .000437130475926232 * a - 54080610064599e-18 * t + .00048449797120281 * s - .154362151871126) - 122.67195406894 + a * (-.000957964378445773 * a + .000817076911346625 * t - .00477271405408747 * s + 1.53380253221734) + t * (.000961250184130688 * t - .00266257332283933 * s + .48357088451265) + s * (-.000336197177618394 * s + .484791561490776);
        e[r++] = 107.268039397724 + i * (219927104525741e-19 * i - .000640992018297945 * a + .000659397001245577 * t + .000426105652938837 * s - .176491792462875) + a * (-.000778269941513683 * a + .00130872261408275 * t + .000770482631801132 * s - .151051492775562) + t * (.00126935368114843 * t - .00265090189010898 * s + .25802910206845) + s * (-.000318913117588328 * s - .213742400323665);
        e[r++] = i * (-.000570115196973677 * i - 263409051004589e-19 * a + .0020741088115012 * t - .00288260236853442 * s + .814272968359295) - 20.810012546947 + a * (-153496057440975e-19 * a - .000132689043961446 * t + .000560833691242812 * s - .195152027534049) + t * (.00174418132927582 * t - .00255243321439347 * s + .116935020465145) + s * (-.000343531996510555 * s + .24165260232407);
      }
      return e.subarray(0, r);
    }
  }, {
    key: "_convertYcckToRgba",
    value: function _convertYcckToRgba(e) {
      for (var _t89 = 0, _i66 = e.length; _t89 < _i66; _t89 += 4) {
        var _i67 = e[_t89],
          _a67 = e[_t89 + 1],
          _s47 = e[_t89 + 2],
          _r37 = e[_t89 + 3];
        e[_t89] = _a67 * (-660635669420364e-19 * _a67 + .000437130475926232 * _s47 - 54080610064599e-18 * _i67 + .00048449797120281 * _r37 - .154362151871126) - 122.67195406894 + _s47 * (-.000957964378445773 * _s47 + .000817076911346625 * _i67 - .00477271405408747 * _r37 + 1.53380253221734) + _i67 * (.000961250184130688 * _i67 - .00266257332283933 * _r37 + .48357088451265) + _r37 * (-.000336197177618394 * _r37 + .484791561490776);
        e[_t89 + 1] = 107.268039397724 + _a67 * (219927104525741e-19 * _a67 - .000640992018297945 * _s47 + .000659397001245577 * _i67 + .000426105652938837 * _r37 - .176491792462875) + _s47 * (-.000778269941513683 * _s47 + .00130872261408275 * _i67 + .000770482631801132 * _r37 - .151051492775562) + _i67 * (.00126935368114843 * _i67 - .00265090189010898 * _r37 + .25802910206845) + _r37 * (-.000318913117588328 * _r37 - .213742400323665);
        e[_t89 + 2] = _a67 * (-.000570115196973677 * _a67 - 263409051004589e-19 * _s47 + .0020741088115012 * _i67 - .00288260236853442 * _r37 + .814272968359295) - 20.810012546947 + _s47 * (-153496057440975e-19 * _s47 - .000132689043961446 * _i67 + .000560833691242812 * _r37 - .195152027534049) + _i67 * (.00174418132927582 * _i67 - .00255243321439347 * _r37 + .116935020465145) + _r37 * (-.000343531996510555 * _r37 + .24165260232407);
        e[_t89 + 3] = 255;
      }
      return e;
    }
  }, {
    key: "_convertYcckToCmyk",
    value: function _convertYcckToCmyk(e) {
      var t, i, a;
      for (var _s48 = 0, _r38 = e.length; _s48 < _r38; _s48 += 4) {
        t = e[_s48];
        i = e[_s48 + 1];
        a = e[_s48 + 2];
        e[_s48] = 434.456 - t - 1.402 * a;
        e[_s48 + 1] = 119.541 - t + .344 * i + .714 * a;
        e[_s48 + 2] = 481.816 - t - 1.772 * i;
      }
      return e;
    }
  }, {
    key: "_convertCmykToRgb",
    value: function _convertCmykToRgb(e) {
      var t,
        i,
        a,
        s,
        r = 0;
      for (var _n26 = 0, _g13 = e.length; _n26 < _g13; _n26 += 4) {
        t = e[_n26];
        i = e[_n26 + 1];
        a = e[_n26 + 2];
        s = e[_n26 + 3];
        e[r++] = 255 + t * (-6747147073602441e-20 * t + .0008379262121013727 * i + .0002894718188643294 * a + .003264231057537806 * s - 1.1185611867203937) + i * (26374107616089405e-21 * i - 8626949158638572e-20 * a - .0002748769067499491 * s - .02155688794978967) + a * (-3878099212869363e-20 * a - .0003267808279485286 * s + .0686742238595345) - s * (.0003361971776183937 * s + .7430659151342254);
        e[r++] = 255 + t * (.00013596372813588848 * t + .000924537132573585 * i + .00010567359618683593 * a + .0004791864687436512 * s - .3109689587515875) + i * (-.00023545346108370344 * i + .0002702845253534714 * a + .0020200308977307156 * s - .7488052167015494) + a * (6834815998235662e-20 * a + .00015168452363460973 * s - .09751927774728933) - s * (.0003189131175883281 * s + .7364883807733168);
        e[r++] = 255 + t * (13598650411385307e-21 * t + .00012423956175490851 * i + .0004751985097583589 * a - 36729317476630422e-22 * s - .05562186980264034) + i * (.00016141380598724676 * i + .0009692239130725186 * a + .0007782692450036253 * s - .44015232367526463) + a * (5.068882914068769e-7 * a + .0017778369011375071 * s - .7591454649749609) - s * (.0003435319965105553 * s + .7063770186160144);
      }
      return e.subarray(0, r);
    }
  }, {
    key: "_convertCmykToRgba",
    value: function _convertCmykToRgba(e) {
      for (var _t90 = 0, _i68 = e.length; _t90 < _i68; _t90 += 4) {
        var _i69 = e[_t90],
          _a68 = e[_t90 + 1],
          _s49 = e[_t90 + 2],
          _r39 = e[_t90 + 3];
        e[_t90] = 255 + _i69 * (-6747147073602441e-20 * _i69 + .0008379262121013727 * _a68 + .0002894718188643294 * _s49 + .003264231057537806 * _r39 - 1.1185611867203937) + _a68 * (26374107616089405e-21 * _a68 - 8626949158638572e-20 * _s49 - .0002748769067499491 * _r39 - .02155688794978967) + _s49 * (-3878099212869363e-20 * _s49 - .0003267808279485286 * _r39 + .0686742238595345) - _r39 * (.0003361971776183937 * _r39 + .7430659151342254);
        e[_t90 + 1] = 255 + _i69 * (.00013596372813588848 * _i69 + .000924537132573585 * _a68 + .00010567359618683593 * _s49 + .0004791864687436512 * _r39 - .3109689587515875) + _a68 * (-.00023545346108370344 * _a68 + .0002702845253534714 * _s49 + .0020200308977307156 * _r39 - .7488052167015494) + _s49 * (6834815998235662e-20 * _s49 + .00015168452363460973 * _r39 - .09751927774728933) - _r39 * (.0003189131175883281 * _r39 + .7364883807733168);
        e[_t90 + 2] = 255 + _i69 * (13598650411385307e-21 * _i69 + .00012423956175490851 * _a68 + .0004751985097583589 * _s49 - 36729317476630422e-22 * _r39 - .05562186980264034) + _a68 * (.00016141380598724676 * _a68 + .0009692239130725186 * _s49 + .0007782692450036253 * _r39 - .44015232367526463) + _s49 * (5.068882914068769e-7 * _s49 + .0017778369011375071 * _r39 - .7591454649749609) - _r39 * (.0003435319965105553 * _r39 + .7063770186160144);
        e[_t90 + 3] = 255;
      }
      return e;
    }
  }, {
    key: "getData",
    value: function getData(_ref33) {
      var e = _ref33.width,
        t = _ref33.height,
        _ref33$forceRGBA = _ref33.forceRGBA,
        i = _ref33$forceRGBA === void 0 ? !1 : _ref33$forceRGBA,
        _ref33$forceRGB = _ref33.forceRGB,
        a = _ref33$forceRGB === void 0 ? !1 : _ref33$forceRGB,
        _ref33$isSourcePDF = _ref33.isSourcePDF,
        s = _ref33$isSourcePDF === void 0 ? !1 : _ref33$isSourcePDF;
      if (this.numComponents > 4) throw new JpegError("Unsupported color mode");
      var r = this._getLinearizedBlockData(e, t, s);
      if (1 === this.numComponents && (i || a)) {
        var _e95 = r.length * (i ? 4 : 3),
          _t91 = new Uint8ClampedArray(_e95);
        var _a69 = 0;
        if (i) !function grayToRGBA(e, t) {
          if (FeatureTest.isLittleEndian) for (var _i70 = 0, _a70 = e.length; _i70 < _a70; _i70++) t[_i70] = 65793 * e[_i70] | 4278190080;else for (var _i71 = 0, _a71 = e.length; _i71 < _a71; _i71++) t[_i71] = 16843008 * e[_i71] | 255;
        }(r, new Uint32Array(_t91.buffer));else {
          var _iterator24 = _createForOfIteratorHelper(r),
            _step24;
          try {
            for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
              var _e96 = _step24.value;
              _t91[_a69++] = _e96;
              _t91[_a69++] = _e96;
              _t91[_a69++] = _e96;
            }
          } catch (err) {
            _iterator24.e(err);
          } finally {
            _iterator24.f();
          }
        }
        return _t91;
      }
      if (3 === this.numComponents && this._isColorConversionNeeded) {
        if (i) {
          var _e97 = new Uint8ClampedArray(r.length / 3 * 4);
          return this._convertYccToRgba(r, _e97);
        }
        return this._convertYccToRgb(r);
      }
      if (4 === this.numComponents) {
        if (this._isColorConversionNeeded) return i ? this._convertYcckToRgba(r) : a ? this._convertYcckToRgb(r) : this._convertYcckToCmyk(r);
        if (i) return this._convertCmykToRgba(r);
        if (a) return this._convertCmykToRgb(r);
      }
      return r;
    }
  }], [{
    key: "canUseImageDecoder",
    value: function canUseImageDecoder(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      var i = 0,
        a = null,
        s = readUint16(e, i);
      i += 2;
      if (65496 !== s) throw new JpegError("SOI not found");
      s = readUint16(e, i);
      i += 2;
      A: for (; 65497 !== s;) {
        switch (s) {
          case 65472:
          case 65473:
          case 65474:
            a = e[i + 7];
            break A;
          case 65535:
            255 !== e[i] && i--;
        }
        i = skipData(e, i);
        s = readUint16(e, i);
        i += 2;
      }
      return 4 !== a && (3 !== a || 0 !== t);
    }
  }]);
}();
var _y2 = /*#__PURE__*/_classPrivateFieldLooseKey("y");
var JpegStream = /*#__PURE__*/function (_DecodeStream7) {
  function JpegStream(_e98, _t92, _i72) {
    var _this24;
    _classCallCheck(this, JpegStream);
    _this24 = _callSuper(this, JpegStream, [_t92]);
    Object.defineProperty(_this24, _y2, {
      value: _y3
    });
    _this24.stream = _e98;
    _this24.dict = _e98.dict;
    _this24.maybeLength = _t92;
    _this24.params = _i72;
    return _this24;
  }
  _inherits(JpegStream, _DecodeStream7);
  return _createClass(JpegStream, [{
    key: "bytes",
    get: function get() {
      return shadow(this, "bytes", this.stream.getBytes(this.maybeLength));
    }
  }, {
    key: "ensureBuffer",
    value: function ensureBuffer(e) {}
  }, {
    key: "readBlock",
    value: function readBlock() {
      this.decodeImage();
    }
  }, {
    key: "jpegOptions",
    get: function get() {
      var e = {
          decodeTransform: void 0,
          colorTransform: void 0
        },
        t = this.dict.getArray("D", "Decode");
      if ((this.forceRGBA || this.forceRGB) && Array.isArray(t)) {
        var _i73 = this.dict.get("BPC", "BitsPerComponent") || 8,
          _a72 = t.length,
          _s50 = new Int32Array(_a72);
        var _r40 = !1;
        var _n27 = (1 << _i73) - 1;
        for (var _e99 = 0; _e99 < _a72; _e99 += 2) {
          _s50[_e99] = 256 * (t[_e99 + 1] - t[_e99]) | 0;
          _s50[_e99 + 1] = t[_e99] * _n27 | 0;
          256 === _s50[_e99] && 0 === _s50[_e99 + 1] || (_r40 = !0);
        }
        _r40 && (e.decodeTransform = _s50);
      }
      if (this.params instanceof Dict) {
        var _t93 = this.params.get("ColorTransform");
        Number.isInteger(_t93) && (e.colorTransform = _t93);
      }
      return shadow(this, "jpegOptions", e);
    }
  }, {
    key: "decodeImage",
    value: function decodeImage(e) {
      if (this.eof) return this.buffer;
      e = _classPrivateFieldLooseBase(this, _y2)[_y2](e || this.bytes);
      var t = new JpegImage(this.jpegOptions);
      t.parse(e);
      var i = t.getData({
        width: this.drawWidth,
        height: this.drawHeight,
        forceRGBA: this.forceRGBA,
        forceRGB: this.forceRGB,
        isSourcePDF: !0
      });
      this.buffer = i;
      this.bufferLength = i.length;
      this.eof = !0;
      return this.buffer;
    }
  }, {
    key: "canAsyncDecodeImageFromBuffer",
    get: function get() {
      return this.stream.isAsync;
    }
  }, {
    key: "getTransferableImage",
    value: function () {
      var _getTransferableImage2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var e, t, _i74, _a73, _t94;
        return _regeneratorRuntime().wrap(function _callee11$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return JpegStream.canUseImageDecoder;
            case 2:
              if (_context13.sent) {
                _context13.next = 4;
                break;
              }
              return _context13.abrupt("return", null);
            case 4:
              e = this.jpegOptions;
              if (!e.decodeTransform) {
                _context13.next = 7;
                break;
              }
              return _context13.abrupt("return", null);
            case 7:
              _context13.prev = 7;
              _context13.t1 = this.canAsyncDecodeImageFromBuffer;
              if (!_context13.t1) {
                _context13.next = 13;
                break;
              }
              _context13.next = 12;
              return this.stream.asyncGetBytes();
            case 12:
              _context13.t1 = _context13.sent;
            case 13:
              _context13.t0 = _context13.t1;
              if (_context13.t0) {
                _context13.next = 16;
                break;
              }
              _context13.t0 = this.bytes;
            case 16:
              _i74 = _context13.t0;
              if (_i74) {
                _context13.next = 19;
                break;
              }
              return _context13.abrupt("return", null);
            case 19:
              _a73 = _classPrivateFieldLooseBase(this, _y2)[_y2](_i74);
              if (JpegImage.canUseImageDecoder(_a73, e.colorTransform)) {
                _context13.next = 22;
                break;
              }
              return _context13.abrupt("return", null);
            case 22:
              t = new ImageDecoder({
                data: _a73,
                type: "image/jpeg",
                preferAnimation: !1
              });
              _context13.next = 25;
              return t.decode();
            case 25:
              return _context13.abrupt("return", _context13.sent.image);
            case 28:
              _context13.prev = 28;
              _context13.t2 = _context13["catch"](7);
              warn("getTransferableImage - failed: \"".concat(_context13.t2, "\"."));
              return _context13.abrupt("return", null);
            case 32:
              _context13.prev = 32;
              (_t94 = t) === null || _t94 === void 0 || _t94.close();
              return _context13.finish(32);
            case 35:
            case "end":
              return _context13.stop();
          }
        }, _callee11, this, [[7, 28, 32, 35]]);
      }));
      function getTransferableImage() {
        return _getTransferableImage2.apply(this, arguments);
      }
      return getTransferableImage;
    }()
  }], [{
    key: "canUseImageDecoder",
    get: function get() {
      return shadow(this, "canUseImageDecoder", "undefined" == typeof ImageDecoder ? Promise.resolve(!1) : ImageDecoder.isTypeSupported("image/jpeg"));
    }
  }]);
}(DecodeStream);
function _y3(e) {
  for (var _t492 = 0, _i432 = e.length - 1; _t492 < _i432; _t492++) if (255 === e[_t492] && 216 === e[_t492 + 1]) {
    _t492 > 0 && (e = e.subarray(_t492));
    break;
  }
  return e;
}
var Ii,
  ci = (Ii = "undefined" != typeof document ? (_document$currentScri = document.currentScript) === null || _document$currentScri === void 0 ? void 0 : _document$currentScri.src : void 0, function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t,
      i,
      a = e;
    new Promise(function (e, a) {
      t = e;
      i = a;
    });
    a.decode = function (e, _ref34) {
      var _ref34$numComponents = _ref34.numComponents,
        t = _ref34$numComponents === void 0 ? 4 : _ref34$numComponents,
        _ref34$isIndexedColor = _ref34.isIndexedColormap,
        i = _ref34$isIndexedColor === void 0 ? !1 : _ref34$isIndexedColor,
        _ref34$smaskInData = _ref34.smaskInData,
        s = _ref34$smaskInData === void 0 ? !1 : _ref34$smaskInData;
      var r = e.length,
        n = a._malloc(r);
      a.HEAPU8.set(e, n);
      var g = a._jp2_decode(n, r, t > 0 ? t : 0, !!i, !!s);
      a._free(n);
      if (g) {
        var _e100 = a.errorMessages;
        if (_e100) {
          delete a.errorMessages;
          return _e100;
        }
        return "Unknown error";
      }
      var o = a.imageData;
      a.imageData = null;
      return o;
    };
    var s,
      r = Object.assign({}, a),
      n = "./this.program",
      g = "";
    "undefined" != typeof document && document.currentScript && (g = document.currentScript.src);
    Ii && (g = Ii);
    g = g.startsWith("blob:") ? "" : g.substr(0, g.replace(/[?#].*/, "").lastIndexOf("/") + 1);
    var o,
      c,
      C,
      h,
      _l4,
      Q = a.print || console.log.bind(console),
      E = a.printErr || console.error.bind(console);
    Object.assign(a, r);
    r = null;
    a.arguments && a.arguments;
    a.thisProgram && (n = a.thisProgram);
    a.quit && a.quit;
    a.wasmBinary && (o = a.wasmBinary);
    function tryParseAsDataURI(e) {
      if (isDataURI(e)) return function intArrayFromBase64(e) {
        for (var t = atob(e), i = new Uint8Array(t.length), a = 0; a < t.length; ++a) i[a] = t.charCodeAt(a);
        return i;
      }(e.slice(D.length));
    }
    function updateMemoryViews() {
      var e = c.buffer;
      a.HEAP8 = C = new Int8Array(e);
      a.HEAP16 = new Int16Array(e);
      a.HEAPU8 = h = new Uint8Array(e);
      a.HEAPU16 = new Uint16Array(e);
      a.HEAP32 = new Int32Array(e);
      a.HEAPU32 = _l4 = new Uint32Array(e);
      a.HEAPF32 = new Float32Array(e);
      a.HEAPF64 = new Float64Array(e);
    }
    var u,
      d = [],
      f = [],
      p = [],
      m = 0,
      y = null,
      w = null,
      D = "data:application/octet-stream;base64,",
      isDataURI = function isDataURI(e) {
        return e.startsWith(D);
      };
    function instantiateSync(e, t) {
      var i,
        a = function getBinarySync(e) {
          if (e == u && o) return new Uint8Array(o);
          var t = tryParseAsDataURI(e);
          if (t) return t;
          if (s) return s(e);
          throw 'sync fetching of the wasm failed: you can preload it to Module["wasmBinary"] manually, or emcc.py will do that for you when generating HTML (but not JS)';
        }(e);
      i = new WebAssembly.Module(a);
      return [new WebAssembly.Instance(i, t), i];
    }
    var callRuntimeCallbacks = function callRuntimeCallbacks(e) {
      for (; e.length > 0;) e.shift()(a);
    };
    a.noExitRuntime;
    var b,
      growMemory = function growMemory(e) {
        var t = (e - c.buffer.byteLength + 65535) / 65536;
        try {
          c.grow(t);
          updateMemoryViews();
          return 1;
        } catch (e) {}
      },
      F = {},
      _getEnvStrings = function getEnvStrings() {
        if (!_getEnvStrings.strings) {
          var e = {
            USER: "web_user",
            LOGNAME: "web_user",
            PATH: "/",
            PWD: "/",
            HOME: "/home/web_user",
            LANG: ("object" == (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8",
            _: n || "./this.program"
          };
          for (var t in F) void 0 === F[t] ? delete e[t] : e[t] = F[t];
          var i = [];
          for (var t in e) i.push("".concat(t, "=").concat(e[t]));
          _getEnvStrings.strings = i;
        }
        return _getEnvStrings.strings;
      },
      S = [null, [], []],
      k = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0,
      UTF8ArrayToString = function UTF8ArrayToString(e, t, i) {
        for (var a = t + i, s = t; e[s] && !(s >= a);) ++s;
        if (s - t > 16 && e.buffer && k) return k.decode(e.subarray(t, s));
        for (var r = ""; t < s;) {
          var n = e[t++];
          if (128 & n) {
            var g = 63 & e[t++];
            if (192 != (224 & n)) {
              var o = 63 & e[t++];
              if ((n = 224 == (240 & n) ? (15 & n) << 12 | g << 6 | o : (7 & n) << 18 | g << 12 | o << 6 | 63 & e[t++]) < 65536) r += String.fromCharCode(n);else {
                var c = n - 65536;
                r += String.fromCharCode(55296 | c >> 10, 56320 | 1023 & c);
              }
            } else r += String.fromCharCode((31 & n) << 6 | g);
          } else r += String.fromCharCode(n);
        }
        return r;
      },
      printChar = function printChar(e, t) {
        var i = S[e];
        if (0 === t || 10 === t) {
          (1 === e ? Q : E)(UTF8ArrayToString(i, 0));
          i.length = 0;
        } else i.push(t);
      },
      UTF8ToString = function UTF8ToString(e, t) {
        return e ? UTF8ArrayToString(h, e, t) : "";
      },
      R = {
        c: function c(e, t, i) {
          return h.copyWithin(e, t, t + i);
        },
        g: function _copy_pixels_1(e, t) {
          e >>= 2;
          var i = a.imageData = new Uint8ClampedArray(t),
            s = a.HEAP32.subarray(e, e + t);
          i.set(s);
        },
        f: function _copy_pixels_3(e, t, i, s) {
          e >>= 2;
          t >>= 2;
          i >>= 2;
          var r = a.imageData = new Uint8ClampedArray(3 * s),
            n = a.HEAP32.subarray(e, e + s),
            g = a.HEAP32.subarray(t, t + s),
            o = a.HEAP32.subarray(i, i + s);
          for (var _e101 = 0; _e101 < s; _e101++) {
            r[3 * _e101] = n[_e101];
            r[3 * _e101 + 1] = g[_e101];
            r[3 * _e101 + 2] = o[_e101];
          }
        },
        e: function _copy_pixels_4(e, t, i, s, r) {
          e >>= 2;
          t >>= 2;
          i >>= 2;
          s >>= 2;
          var n = a.imageData = new Uint8ClampedArray(4 * r),
            g = a.HEAP32.subarray(e, e + r),
            o = a.HEAP32.subarray(t, t + r),
            c = a.HEAP32.subarray(i, i + r),
            C = a.HEAP32.subarray(s, s + r);
          for (var _e102 = 0; _e102 < r; _e102++) {
            n[4 * _e102] = g[_e102];
            n[4 * _e102 + 1] = o[_e102];
            n[4 * _e102 + 2] = c[_e102];
            n[4 * _e102 + 3] = C[_e102];
          }
        },
        k: function k(e) {
          var t = h.length,
            i = 2147483648;
          if ((e >>>= 0) > i) return !1;
          for (var a, s, r = 1; r <= 4; r *= 2) {
            var n = t * (1 + .2 / r);
            n = Math.min(n, e + 100663296);
            var g = Math.min(i, (a = Math.max(e, n)) + ((s = 65536) - a % s) % s);
            if (growMemory(g)) return !0;
          }
          return !1;
        },
        l: function l(e, t) {
          var i = 0;
          _getEnvStrings().forEach(function (a, s) {
            var r = t + i;
            _l4[e + 4 * s >> 2] = r;
            (function (e, t) {
              for (var i = 0; i < e.length; ++i) C[t++] = e.charCodeAt(i);
              C[t] = 0;
            })(a, r);
            i += a.length + 1;
          });
          return 0;
        },
        m: function m(e, t) {
          var i = _getEnvStrings();
          _l4[e >> 2] = i.length;
          var a = 0;
          i.forEach(function (e) {
            return a += e.length + 1;
          });
          _l4[t >> 2] = a;
          return 0;
        },
        n: function n(e) {
          return 52;
        },
        j: function _fd_seek(e, t, i, a, s) {
          return 70;
        },
        b: function b(e, t, i, a) {
          for (var s = 0, r = 0; r < i; r++) {
            var n = _l4[t >> 2],
              g = _l4[t + 4 >> 2];
            t += 8;
            for (var o = 0; o < g; o++) printChar(e, h[n + o]);
            s += g;
          }
          _l4[a >> 2] = s;
          return 0;
        },
        o: function _gray_to_rgba(e, t) {
          e >>= 2;
          var i = a.imageData = new Uint8ClampedArray(4 * t),
            s = a.HEAP32.subarray(e, e + t);
          for (var _e103 = 0; _e103 < t; _e103++) {
            i[4 * _e103] = i[4 * _e103 + 1] = i[4 * _e103 + 2] = s[_e103];
            i[4 * _e103 + 3] = 255;
          }
        },
        i: function _graya_to_rgba(e, t, i) {
          e >>= 2;
          t >>= 2;
          var s = a.imageData = new Uint8ClampedArray(4 * i),
            r = a.HEAP32.subarray(e, e + i),
            n = a.HEAP32.subarray(t, t + i);
          for (var _e104 = 0; _e104 < i; _e104++) {
            s[4 * _e104] = s[4 * _e104 + 1] = s[4 * _e104 + 2] = r[_e104];
            s[4 * _e104 + 3] = n[_e104];
          }
        },
        d: function _jsPrintWarning(e) {
          var t = UTF8ToString(e);
          (a.warn || console.warn)("OpenJPEG: ".concat(t));
        },
        h: function _rgb_to_rgba(e, t, i, s) {
          e >>= 2;
          t >>= 2;
          i >>= 2;
          var r = a.imageData = new Uint8ClampedArray(4 * s),
            n = a.HEAP32.subarray(e, e + s),
            g = a.HEAP32.subarray(t, t + s),
            o = a.HEAP32.subarray(i, i + s);
          for (var _e105 = 0; _e105 < s; _e105++) {
            r[4 * _e105] = n[_e105];
            r[4 * _e105 + 1] = g[_e105];
            r[4 * _e105 + 2] = o[_e105];
            r[4 * _e105 + 3] = 255;
          }
        },
        a: function _storeErrorMessage(e) {
          var t = UTF8ToString(e);
          a.errorMessages ? a.errorMessages += "\n" + t : a.errorMessages = t;
        }
      },
      N = function createWasm() {
        var e = function getWasmImports() {
          return {
            a: R
          };
        }();
        function receiveInstance(e, t) {
          N = e.exports;
          c = N.p;
          updateMemoryViews();
          !function addOnInit(e) {
            f.unshift(e);
          }(N.q);
          !function removeRunDependency(e, _a$monitorRunDependen) {
            m--;
            (_a$monitorRunDependen = a.monitorRunDependencies) === null || _a$monitorRunDependen === void 0 || _a$monitorRunDependen.call(a, m);
            if (0 == m) {
              if (null !== y) {
                clearInterval(y);
                y = null;
              }
              if (w) {
                var t = w;
                w = null;
                t();
              }
            }
          }();
          return N;
        }
        !function addRunDependency(e, _a$monitorRunDependen2) {
          m++;
          (_a$monitorRunDependen2 = a.monitorRunDependencies) === null || _a$monitorRunDependen2 === void 0 || _a$monitorRunDependen2.call(a, m);
        }();
        if (a.instantiateWasm) try {
          return a.instantiateWasm(e, receiveInstance);
        } catch (e) {
          E("Module.instantiateWasm callback failed with error: ".concat(e));
          i(e);
        }
        u || (u = "data:application/octet-stream;base64,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");
        return receiveInstance(instantiateSync(u, e)[0]);
      }();
    N.q, a._malloc = N.r, a._free = N.s, a._jp2_decode = N.u;
    w = function runCaller() {
      b || run();
      b || (w = runCaller);
    };
    function run() {
      if (!(m > 0)) {
        !function preRun() {
          if (a.preRun) {
            "function" == typeof a.preRun && (a.preRun = [a.preRun]);
            for (; a.preRun.length;) e = a.preRun.shift(), d.unshift(e);
          }
          var e;
          callRuntimeCallbacks(d);
        }();
        if (!(m > 0)) if (a.setStatus) {
          a.setStatus("Running...");
          setTimeout(function () {
            setTimeout(function () {
              a.setStatus("");
            }, 1);
            doRun();
          }, 1);
        } else doRun();
      }
      function doRun() {
        if (!b) {
          b = !0;
          a.calledRun = !0;
          !function initRuntime() {
            callRuntimeCallbacks(f);
          }();
          t(a);
          a.onRuntimeInitialized && a.onRuntimeInitialized();
          !function postRun() {
            if (a.postRun) {
              "function" == typeof a.postRun && (a.postRun = [a.postRun]);
              for (; a.postRun.length;) e = a.postRun.shift(), p.unshift(e);
            }
            var e;
            callRuntimeCallbacks(p);
          }();
        }
      }
    }
    if (a.preInit) {
      "function" == typeof a.preInit && (a.preInit = [a.preInit]);
      for (; a.preInit.length > 0;) a.preInit.pop()();
    }
    run();
    return a;
  });
var Ci = ci;
var JpxError = /*#__PURE__*/function (_gt16) {
  function JpxError(e) {
    _classCallCheck(this, JpxError);
    return _callSuper(this, JpxError, [e, "JpxError"]);
  }
  _inherits(JpxError, _gt16);
  return _createClass(JpxError);
}(gt);
var _w2 = /*#__PURE__*/_classPrivateFieldLooseKey("w");
var JpxImage = /*#__PURE__*/function () {
  function JpxImage() {
    _classCallCheck(this, JpxImage);
  }
  return _createClass(JpxImage, null, [{
    key: "decode",
    value: function decode(e, t) {
      var _classPrivateFieldLoo;
      t || (t = {});
      (_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _w2))[_w2] || (_classPrivateFieldLoo[_w2] = Ci({
        warn: warn
      }));
      var i = _classPrivateFieldLooseBase(this, _w2)[_w2].decode(e, t);
      if ("string" == typeof i) throw new JpxError(i);
      return i;
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      _classPrivateFieldLooseBase(this, _w2)[_w2] = null;
    }
  }, {
    key: "parseImageProperties",
    value: function parseImageProperties(e) {
      var t = e.getByte();
      for (; t >= 0;) {
        var _i75 = t;
        t = e.getByte();
        if (65361 === (_i75 << 8 | t)) {
          e.skip(4);
          var _t95 = e.getInt32() >>> 0,
            _i76 = e.getInt32() >>> 0,
            _a74 = e.getInt32() >>> 0,
            _s51 = e.getInt32() >>> 0;
          e.skip(16);
          return {
            width: _t95 - _a74,
            height: _i76 - _s51,
            bitsPerComponent: 8,
            componentsCount: e.getUint16()
          };
        }
      }
      throw new JpxError("No size marker found in JPX stream");
    }
  }]);
}();
Object.defineProperty(JpxImage, _w2, {
  writable: true,
  value: null
});
var JpxStream = /*#__PURE__*/function (_DecodeStream8) {
  function JpxStream(e, t, i) {
    var _this25;
    _classCallCheck(this, JpxStream);
    _this25 = _callSuper(this, JpxStream, [t]);
    _this25.stream = e;
    _this25.dict = e.dict;
    _this25.maybeLength = t;
    _this25.params = i;
    return _this25;
  }
  _inherits(JpxStream, _DecodeStream8);
  return _createClass(JpxStream, [{
    key: "bytes",
    get: function get() {
      return shadow(this, "bytes", this.stream.getBytes(this.maybeLength));
    }
  }, {
    key: "ensureBuffer",
    value: function ensureBuffer(e) {}
  }, {
    key: "readBlock",
    value: function readBlock(e) {
      this.decodeImage(null, e);
    }
  }, {
    key: "decodeImage",
    value: function decodeImage(e, t) {
      if (this.eof) return this.buffer;
      e || (e = this.bytes);
      this.buffer = JpxImage.decode(e, t);
      this.bufferLength = this.buffer.length;
      this.eof = !0;
      return this.buffer;
    }
  }, {
    key: "canAsyncDecodeImageFromBuffer",
    get: function get() {
      return this.stream.isAsync;
    }
  }]);
}(DecodeStream);
var LZWStream = /*#__PURE__*/function (_DecodeStream9) {
  function LZWStream(e, t, i) {
    var _this26;
    _classCallCheck(this, LZWStream);
    _this26 = _callSuper(this, LZWStream, [t]);
    _this26.str = e;
    _this26.dict = e.dict;
    _this26.cachedData = 0;
    _this26.bitsCached = 0;
    var a = 4096,
      s = {
        earlyChange: i,
        codeLength: 9,
        nextCode: 258,
        dictionaryValues: new Uint8Array(a),
        dictionaryLengths: new Uint16Array(a),
        dictionaryPrevCodes: new Uint16Array(a),
        currentSequence: new Uint8Array(a),
        currentSequenceLength: 0
      };
    for (var _e106 = 0; _e106 < 256; ++_e106) {
      s.dictionaryValues[_e106] = _e106;
      s.dictionaryLengths[_e106] = 1;
    }
    _this26.lzwState = s;
    return _this26;
  }
  _inherits(LZWStream, _DecodeStream9);
  return _createClass(LZWStream, [{
    key: "readBits",
    value: function readBits(e) {
      var t = this.bitsCached,
        i = this.cachedData;
      for (; t < e;) {
        var _e107 = this.str.getByte();
        if (-1 === _e107) {
          this.eof = !0;
          return null;
        }
        i = i << 8 | _e107;
        t += 8;
      }
      this.bitsCached = t -= e;
      this.cachedData = i;
      this.lastCode = null;
      return i >>> t & (1 << e) - 1;
    }
  }, {
    key: "readBlock",
    value: function readBlock() {
      var e,
        t,
        i,
        a = 1024;
      var s = this.lzwState;
      if (!s) return;
      var r = s.earlyChange;
      var n = s.nextCode;
      var g = s.dictionaryValues,
        o = s.dictionaryLengths,
        c = s.dictionaryPrevCodes;
      var C = s.codeLength,
        h = s.prevCode;
      var l = s.currentSequence;
      var Q = s.currentSequenceLength,
        E = 0,
        u = this.bufferLength,
        d = this.ensureBuffer(this.bufferLength + a);
      for (e = 0; e < 512; e++) {
        var _e108 = this.readBits(C),
          _s52 = Q > 0;
        if (_e108 < 256) {
          l[0] = _e108;
          Q = 1;
        } else {
          if (!(_e108 >= 258)) {
            if (256 === _e108) {
              C = 9;
              n = 258;
              Q = 0;
              continue;
            }
            this.eof = !0;
            delete this.lzwState;
            break;
          }
          if (_e108 < n) {
            Q = o[_e108];
            for (t = Q - 1, i = _e108; t >= 0; t--) {
              l[t] = g[i];
              i = c[i];
            }
          } else l[Q++] = l[0];
        }
        if (_s52) {
          c[n] = h;
          o[n] = o[h] + 1;
          g[n] = l[0];
          n++;
          C = n + r & n + r - 1 ? C : 0 | Math.min(Math.log(n + r) / .6931471805599453 + 1, 12);
        }
        h = _e108;
        E += Q;
        if (a < E) {
          do {
            a += 512;
          } while (a < E);
          d = this.ensureBuffer(this.bufferLength + a);
        }
        for (t = 0; t < Q; t++) d[u++] = l[t];
      }
      s.nextCode = n;
      s.codeLength = C;
      s.prevCode = h;
      s.currentSequenceLength = Q;
      this.bufferLength = u;
    }
  }]);
}(DecodeStream);
var PredictorStream = /*#__PURE__*/function (_DecodeStream10) {
  function PredictorStream(e, t, i) {
    var _this27;
    _classCallCheck(this, PredictorStream);
    _this27 = _callSuper(this, PredictorStream, [t]);
    if (!(i instanceof Dict)) return _possibleConstructorReturn(_this27, e);
    var a = _this27.predictor = i.get("Predictor") || 1;
    if (a <= 1) return _possibleConstructorReturn(_this27, e);
    if (2 !== a && (a < 10 || a > 15)) throw new FormatError("Unsupported predictor: ".concat(a));
    _this27.readBlock = 2 === a ? _this27.readBlockTiff : _this27.readBlockPng;
    _this27.str = e;
    _this27.dict = e.dict;
    var s = _this27.colors = i.get("Colors") || 1,
      r = _this27.bits = i.get("BPC", "BitsPerComponent") || 8,
      n = _this27.columns = i.get("Columns") || 1;
    _this27.pixBytes = s * r + 7 >> 3;
    _this27.rowBytes = n * s * r + 7 >> 3;
    return _possibleConstructorReturn(_this27, _this27);
  }
  _inherits(PredictorStream, _DecodeStream10);
  return _createClass(PredictorStream, [{
    key: "readBlockTiff",
    value: function readBlockTiff() {
      var e = this.rowBytes,
        t = this.bufferLength,
        i = this.ensureBuffer(t + e),
        a = this.bits,
        s = this.colors,
        r = this.str.getBytes(e);
      this.eof = !r.length;
      if (this.eof) return;
      var n,
        g = 0,
        o = 0,
        c = 0,
        C = 0,
        h = t;
      if (1 === a && 1 === s) for (n = 0; n < e; ++n) {
        var _e109 = r[n] ^ g;
        _e109 ^= _e109 >> 1;
        _e109 ^= _e109 >> 2;
        _e109 ^= _e109 >> 4;
        g = (1 & _e109) << 7;
        i[h++] = _e109;
      } else if (8 === a) {
        for (n = 0; n < s; ++n) i[h++] = r[n];
        for (; n < e; ++n) {
          i[h] = i[h - s] + r[n];
          h++;
        }
      } else if (16 === a) {
        var _t96 = 2 * s;
        for (n = 0; n < _t96; ++n) i[h++] = r[n];
        for (; n < e; n += 2) {
          var _e110 = ((255 & r[n]) << 8) + (255 & r[n + 1]) + ((255 & i[h - _t96]) << 8) + (255 & i[h - _t96 + 1]);
          i[h++] = _e110 >> 8 & 255;
          i[h++] = 255 & _e110;
        }
      } else {
        var _e111 = new Uint8Array(s + 1),
          _h5 = (1 << a) - 1;
        var l = 0,
          _Q8 = t;
        var _E8 = this.columns;
        for (n = 0; n < _E8; ++n) for (var _t97 = 0; _t97 < s; ++_t97) {
          if (c < a) {
            g = g << 8 | 255 & r[l++];
            c += 8;
          }
          _e111[_t97] = _e111[_t97] + (g >> c - a) & _h5;
          c -= a;
          o = o << a | _e111[_t97];
          C += a;
          if (C >= 8) {
            i[_Q8++] = o >> C - 8 & 255;
            C -= 8;
          }
        }
        C > 0 && (i[_Q8++] = (o << 8 - C) + (g & (1 << 8 - C) - 1));
      }
      this.bufferLength += e;
    }
  }, {
    key: "readBlockPng",
    value: function readBlockPng() {
      var e = this.rowBytes,
        t = this.pixBytes,
        i = this.str.getByte(),
        a = this.str.getBytes(e);
      this.eof = !a.length;
      if (this.eof) return;
      var s = this.bufferLength,
        r = this.ensureBuffer(s + e);
      var n = r.subarray(s - e, s);
      0 === n.length && (n = new Uint8Array(e));
      var g,
        o,
        c,
        C = s;
      switch (i) {
        case 0:
          for (g = 0; g < e; ++g) r[C++] = a[g];
          break;
        case 1:
          for (g = 0; g < t; ++g) r[C++] = a[g];
          for (; g < e; ++g) {
            r[C] = r[C - t] + a[g] & 255;
            C++;
          }
          break;
        case 2:
          for (g = 0; g < e; ++g) r[C++] = n[g] + a[g] & 255;
          break;
        case 3:
          for (g = 0; g < t; ++g) r[C++] = (n[g] >> 1) + a[g];
          for (; g < e; ++g) {
            r[C] = (n[g] + r[C - t] >> 1) + a[g] & 255;
            C++;
          }
          break;
        case 4:
          for (g = 0; g < t; ++g) {
            o = n[g];
            c = a[g];
            r[C++] = o + c;
          }
          for (; g < e; ++g) {
            o = n[g];
            var _e112 = n[g - t],
              _i77 = r[C - t],
              _s53 = _i77 + o - _e112;
            var h = _s53 - _i77;
            h < 0 && (h = -h);
            var l = _s53 - o;
            l < 0 && (l = -l);
            var _Q9 = _s53 - _e112;
            _Q9 < 0 && (_Q9 = -_Q9);
            c = a[g];
            r[C++] = h <= l && h <= _Q9 ? _i77 + c : l <= _Q9 ? o + c : _e112 + c;
          }
          break;
        default:
          throw new FormatError("Unsupported predictor: ".concat(i));
      }
      this.bufferLength += e;
    }
  }]);
}(DecodeStream);
var RunLengthStream = /*#__PURE__*/function (_DecodeStream11) {
  function RunLengthStream(e, t) {
    var _this28;
    _classCallCheck(this, RunLengthStream);
    _this28 = _callSuper(this, RunLengthStream, [t]);
    _this28.str = e;
    _this28.dict = e.dict;
    return _this28;
  }
  _inherits(RunLengthStream, _DecodeStream11);
  return _createClass(RunLengthStream, [{
    key: "readBlock",
    value: function readBlock() {
      var e = this.str.getBytes(2);
      if (!e || e.length < 2 || 128 === e[0]) {
        this.eof = !0;
        return;
      }
      var t,
        i = this.bufferLength,
        a = e[0];
      if (a < 128) {
        t = this.ensureBuffer(i + a + 1);
        t[i++] = e[1];
        if (a > 0) {
          var _e113 = this.str.getBytes(a);
          t.set(_e113, i);
          i += a;
        }
      } else {
        a = 257 - a;
        var _s54 = e[1];
        t = this.ensureBuffer(i + a + 1);
        for (var _e114 = 0; _e114 < a; _e114++) t[i++] = _s54;
      }
      this.bufferLength = i;
    }
  }]);
}(DecodeStream);
var _D2 = /*#__PURE__*/_classPrivateFieldLooseKey("D");
var Parser = /*#__PURE__*/function () {
  function Parser(_ref35) {
    var _e115 = _ref35.lexer,
      _t98 = _ref35.xref,
      _ref35$allowStreams = _ref35.allowStreams,
      _i78 = _ref35$allowStreams === void 0 ? !1 : _ref35$allowStreams,
      _ref35$recoveryMode = _ref35.recoveryMode,
      _a75 = _ref35$recoveryMode === void 0 ? !1 : _ref35$recoveryMode;
    _classCallCheck(this, Parser);
    Object.defineProperty(this, _D2, {
      value: _D3
    });
    this.lexer = _e115;
    this.xref = _t98;
    this.allowStreams = _i78;
    this.recoveryMode = _a75;
    this.imageCache = Object.create(null);
    this._imageId = 0;
    this.refill();
  }
  return _createClass(Parser, [{
    key: "refill",
    value: function refill() {
      this.buf1 = this.lexer.getObj();
      this.buf2 = this.lexer.getObj();
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.buf2 instanceof Cmd && "ID" === this.buf2.cmd) {
        this.buf1 = this.buf2;
        this.buf2 = null;
      } else {
        this.buf1 = this.buf2;
        this.buf2 = this.lexer.getObj();
      }
    }
  }, {
    key: "tryShift",
    value: function tryShift() {
      try {
        this.shift();
        return !0;
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        return !1;
      }
    }
  }, {
    key: "getObj",
    value: function getObj() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var t = this.buf1;
      this.shift();
      if (t instanceof Cmd) switch (t.cmd) {
        case "BI":
          return this.makeInlineImage(e);
        case "[":
          var _i79 = [];
          for (; !isCmd(this.buf1, "]") && this.buf1 !== yt;) _i79.push(this.getObj(e));
          if (this.buf1 === yt) {
            if (this.recoveryMode) return _i79;
            throw new ParserEOFException("End of file inside array.");
          }
          this.shift();
          return _i79;
        case "<<":
          var _a76 = new Dict(this.xref);
          for (; !isCmd(this.buf1, ">>") && this.buf1 !== yt;) {
            if (!(this.buf1 instanceof Name)) {
              info("Malformed dictionary: key must be a name object");
              this.shift();
              continue;
            }
            var _t99 = this.buf1.name;
            this.shift();
            if (this.buf1 === yt) break;
            _a76.set(_t99, this.getObj(e));
          }
          if (this.buf1 === yt) {
            if (this.recoveryMode) return _a76;
            throw new ParserEOFException("End of file inside dictionary.");
          }
          if (isCmd(this.buf2, "stream")) return this.allowStreams ? this.makeStream(_a76, e) : _a76;
          this.shift();
          return _a76;
        default:
          return t;
      }
      if (Number.isInteger(t)) {
        if (Number.isInteger(this.buf1) && isCmd(this.buf2, "R")) {
          var _e116 = Ref.get(t, this.buf1);
          this.shift();
          this.shift();
          return _e116;
        }
        return t;
      }
      return "string" == typeof t && e ? e.decryptString(t) : t;
    }
  }, {
    key: "findDefaultInlineStreamEnd",
    value: function findDefaultInlineStreamEnd(e) {
      var t = this.lexer.knownCommands,
        i = e.pos;
      var a,
        s,
        r = 0;
      for (; -1 !== (a = e.getByte());) if (0 === r) r = 69 === a ? 1 : 0;else if (1 === r) r = 73 === a ? 2 : 0;else if (32 === a || 10 === a || 13 === a) {
        s = e.pos;
        var _i80 = e.peekBytes(15),
          _n28 = _i80.length;
        if (0 === _n28) break;
        for (var _e117 = 0; _e117 < _n28; _e117++) {
          a = _i80[_e117];
          if ((0 !== a || 0 === _i80[_e117 + 1]) && 10 !== a && 13 !== a && (a < 32 || a > 127)) {
            r = 0;
            break;
          }
        }
        if (2 !== r) continue;
        if (!t) {
          warn("findDefaultInlineStreamEnd - `lexer.knownCommands` is undefined.");
          continue;
        }
        var _g14 = new Lexer(new Stream(_i80.slice()), t);
        _g14._hexStringWarn = function () {};
        var _o9 = 0;
        for (;;) {
          var _e118 = _g14.getObj();
          if (_e118 === yt) {
            r = 0;
            break;
          }
          if (_e118 instanceof Cmd) {
            var _i81 = t[_e118.cmd];
            if (!_i81) {
              r = 0;
              break;
            }
            if (_i81.variableArgs ? _o9 <= _i81.numArgs : _o9 === _i81.numArgs) break;
            _o9 = 0;
          } else _o9++;
        }
        if (2 === r) break;
      } else r = 0;
      if (-1 === a) {
        warn("findDefaultInlineStreamEnd: Reached the end of the stream without finding a valid EI marker");
        if (s) {
          warn('... trying to recover by using the last "EI" occurrence.');
          e.skip(-(e.pos - s));
        }
      }
      var n = 4;
      e.skip(-n);
      a = e.peekByte();
      e.skip(n);
      isWhiteSpace(a) || n--;
      return e.pos - n - i;
    }
  }, {
    key: "findDCTDecodeInlineStreamEnd",
    value: function findDCTDecodeInlineStreamEnd(e) {
      var t = e.pos;
      var i,
        a,
        s = !1;
      for (; -1 !== (i = e.getByte());) if (255 === i) {
        switch (e.getByte()) {
          case 0:
            break;
          case 255:
            e.skip(-1);
            break;
          case 217:
            s = !0;
            break;
          case 192:
          case 193:
          case 194:
          case 195:
          case 197:
          case 198:
          case 199:
          case 201:
          case 202:
          case 203:
          case 205:
          case 206:
          case 207:
          case 196:
          case 204:
          case 218:
          case 219:
          case 220:
          case 221:
          case 222:
          case 223:
          case 224:
          case 225:
          case 226:
          case 227:
          case 228:
          case 229:
          case 230:
          case 231:
          case 232:
          case 233:
          case 234:
          case 235:
          case 236:
          case 237:
          case 238:
          case 239:
          case 254:
            a = e.getUint16();
            a > 2 ? e.skip(a - 2) : e.skip(-2);
        }
        if (s) break;
      }
      var r = e.pos - t;
      if (-1 === i) {
        warn("Inline DCTDecode image stream: EOI marker not found, searching for /EI/ instead.");
        e.skip(-r);
        return this.findDefaultInlineStreamEnd(e);
      }
      this.inlineStreamSkipEI(e);
      return r;
    }
  }, {
    key: "findASCII85DecodeInlineStreamEnd",
    value: function findASCII85DecodeInlineStreamEnd(e) {
      var t = e.pos;
      var i;
      for (; -1 !== (i = e.getByte());) if (126 === i) {
        var _t100 = e.pos;
        i = e.peekByte();
        for (; isWhiteSpace(i);) {
          e.skip();
          i = e.peekByte();
        }
        if (62 === i) {
          e.skip();
          break;
        }
        if (e.pos > _t100) {
          var _t101 = e.peekBytes(2);
          if (69 === _t101[0] && 73 === _t101[1]) break;
        }
      }
      var a = e.pos - t;
      if (-1 === i) {
        warn("Inline ASCII85Decode image stream: EOD marker not found, searching for /EI/ instead.");
        e.skip(-a);
        return this.findDefaultInlineStreamEnd(e);
      }
      this.inlineStreamSkipEI(e);
      return a;
    }
  }, {
    key: "findASCIIHexDecodeInlineStreamEnd",
    value: function findASCIIHexDecodeInlineStreamEnd(e) {
      var t = e.pos;
      var i;
      for (; -1 !== (i = e.getByte()) && 62 !== i;);
      var a = e.pos - t;
      if (-1 === i) {
        warn("Inline ASCIIHexDecode image stream: EOD marker not found, searching for /EI/ instead.");
        e.skip(-a);
        return this.findDefaultInlineStreamEnd(e);
      }
      this.inlineStreamSkipEI(e);
      return a;
    }
  }, {
    key: "inlineStreamSkipEI",
    value: function inlineStreamSkipEI(e) {
      var t,
        i = 0;
      for (; -1 !== (t = e.getByte());) if (0 === i) i = 69 === t ? 1 : 0;else if (1 === i) i = 73 === t ? 2 : 0;else if (2 === i) break;
    }
  }, {
    key: "makeInlineImage",
    value: function makeInlineImage(e) {
      var t = this.lexer,
        i = t.stream,
        a = Object.create(null);
      var s;
      for (; !isCmd(this.buf1, "ID") && this.buf1 !== yt;) {
        if (!(this.buf1 instanceof Name)) throw new FormatError("Dictionary key must be a name object");
        var _t102 = this.buf1.name;
        this.shift();
        if (this.buf1 === yt) break;
        a[_t102] = this.getObj(e);
      }
      -1 !== t.beginInlineImagePos && (s = i.pos - t.beginInlineImagePos);
      var r = this.xref.fetchIfRef(a.F || a.Filter);
      var n;
      if (r instanceof Name) n = r.name;else if (Array.isArray(r)) {
        var _e119 = this.xref.fetchIfRef(r[0]);
        _e119 instanceof Name && (n = _e119.name);
      }
      var g = i.pos;
      var o, c;
      switch (n) {
        case "DCT":
        case "DCTDecode":
          o = this.findDCTDecodeInlineStreamEnd(i);
          break;
        case "A85":
        case "ASCII85Decode":
          o = this.findASCII85DecodeInlineStreamEnd(i);
          break;
        case "AHx":
        case "ASCIIHexDecode":
          o = this.findASCIIHexDecodeInlineStreamEnd(i);
          break;
        default:
          o = this.findDefaultInlineStreamEnd(i);
      }
      if (o < 1e3 && s > 0) {
        var _e120 = i.pos;
        i.pos = t.beginInlineImagePos;
        c = function getInlineImageCacheKey(e) {
          var t = [],
            i = e.length;
          var a = 0;
          for (; a < i - 1;) t.push(e[a++] << 8 | e[a++]);
          a < i && t.push(e[a]);
          return i + "_" + String.fromCharCode.apply(null, t);
        }(i.getBytes(s + o));
        i.pos = _e120;
        var _a77 = this.imageCache[c];
        if (void 0 !== _a77) {
          this.buf2 = Cmd.get("EI");
          this.shift();
          _a77.reset();
          return _a77;
        }
      }
      var C = new Dict(this.xref);
      for (var _e121 in a) C.set(_e121, a[_e121]);
      var h = i.makeSubStream(g, o, C);
      e && (h = e.createStream(h, o));
      h = this.filter(h, C, o);
      h.dict = C;
      if (void 0 !== c) {
        h.cacheKey = "inline_img_" + ++this._imageId;
        this.imageCache[c] = h;
      }
      this.buf2 = Cmd.get("EI");
      this.shift();
      return h;
    }
  }, {
    key: "makeStream",
    value: function makeStream(e, t) {
      var i = this.lexer;
      var a = i.stream;
      i.skipToNextLine();
      var s = a.pos - 1;
      var r = e.get("Length");
      if (!Number.isInteger(r)) {
        info("Bad length \"".concat(r && r.toString(), "\" in stream."));
        r = 0;
      }
      a.pos = s + r;
      i.nextChar();
      if (this.tryShift() && isCmd(this.buf2, "endstream")) this.shift();else {
        r = _classPrivateFieldLooseBase(this, _D2)[_D2](s);
        if (r < 0) throw new FormatError("Missing endstream command.");
        i.nextChar();
        this.shift();
        this.shift();
      }
      this.shift();
      a = a.makeSubStream(s, r, e);
      t && (a = t.createStream(a, r));
      a = this.filter(a, e, r);
      a.dict = e;
      return a;
    }
  }, {
    key: "filter",
    value: function filter(e, t, i) {
      var a = t.get("F", "Filter"),
        s = t.get("DP", "DecodeParms");
      if (a instanceof Name) {
        Array.isArray(s) && warn("/DecodeParms should not be an Array, when /Filter is a Name.");
        return this.makeFilter(e, a.name, i, s);
      }
      var r = i;
      if (Array.isArray(a)) {
        var _t103 = a,
          _i82 = s;
        for (var _n29 = 0, _g15 = _t103.length; _n29 < _g15; ++_n29) {
          a = this.xref.fetchIfRef(_t103[_n29]);
          if (!(a instanceof Name)) throw new FormatError("Bad filter name \"".concat(a, "\""));
          s = null;
          Array.isArray(_i82) && _n29 in _i82 && (s = this.xref.fetchIfRef(_i82[_n29]));
          e = this.makeFilter(e, a.name, r, s);
          r = null;
        }
      }
      return e;
    }
  }, {
    key: "makeFilter",
    value: function makeFilter(e, t, i, a) {
      if (0 === i) {
        warn("Empty \"".concat(t, "\" stream."));
        return new NullStream();
      }
      try {
        switch (t) {
          case "Fl":
          case "FlateDecode":
            return a ? new PredictorStream(new FlateStream(e, i), i, a) : new FlateStream(e, i);
          case "LZW":
          case "LZWDecode":
            var _t104 = 1;
            if (a) {
              a.has("EarlyChange") && (_t104 = a.get("EarlyChange"));
              return new PredictorStream(new LZWStream(e, i, _t104), i, a);
            }
            return new LZWStream(e, i, _t104);
          case "DCT":
          case "DCTDecode":
            return new JpegStream(e, i, a);
          case "JPX":
          case "JPXDecode":
            return new JpxStream(e, i, a);
          case "A85":
          case "ASCII85Decode":
            return new Ascii85Stream(e, i);
          case "AHx":
          case "ASCIIHexDecode":
            return new AsciiHexStream(e, i);
          case "CCF":
          case "CCITTFaxDecode":
            return new CCITTFaxStream(e, i, a);
          case "RL":
          case "RunLengthDecode":
            return new RunLengthStream(e, i);
          case "JBIG2Decode":
            return new Jbig2Stream(e, i, a);
        }
        warn("Filter \"".concat(t, "\" is not supported."));
        return e;
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        warn("Invalid stream: \"".concat(e, "\""));
        return new NullStream();
      }
    }
  }]);
}();
function _D3(e) {
  var t = this.lexer.stream;
  t.pos = e;
  var i = new Uint8Array([101, 110, 100]),
    a = i.length,
    s = [new Uint8Array([115, 116, 114, 101, 97, 109]), new Uint8Array([115, 116, 101, 97, 109]), new Uint8Array([115, 116, 114, 101, 97])],
    r = 9 - a;
  for (; t.pos < t.end;) {
    var n = t.peekBytes(2048),
      _g83 = n.length - 9;
    if (_g83 <= 0) break;
    var _o59 = 0;
    for (; _o59 < _g83;) {
      var _g84 = 0;
      for (; _g84 < a && n[_o59 + _g84] === i[_g84];) _g84++;
      if (_g84 >= a) {
        var _a329 = !1;
        var _iterator234 = _createForOfIteratorHelper(s),
          _step234;
        try {
          for (_iterator234.s(); !(_step234 = _iterator234.n()).done;) {
            var _e664 = _step234.value;
            var _t493 = _e664.length;
            var _s221 = 0;
            for (; _s221 < _t493 && n[_o59 + _g84 + _s221] === _e664[_s221];) _s221++;
            if (_s221 >= r) {
              _a329 = !0;
              break;
            }
            if (_s221 >= _t493) {
              if (isWhiteSpace(n[_o59 + _g84 + _s221])) {
                info("Found \"".concat(bytesToString([].concat(_toConsumableArray(i), _toConsumableArray(_e664))), "\" when searching for endstream command."));
                _a329 = !0;
              }
              break;
            }
          }
        } catch (err) {
          _iterator234.e(err);
        } finally {
          _iterator234.f();
        }
        if (_a329) {
          t.pos += _o59;
          return t.pos - e;
        }
      }
      _o59++;
    }
    t.pos += _g83;
  }
  return -1;
}
var hi = [1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0, 2, 2, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
function toHexDigit(e) {
  return e >= 48 && e <= 57 ? 15 & e : e >= 65 && e <= 70 || e >= 97 && e <= 102 ? 9 + (15 & e) : -1;
}
var Lexer = /*#__PURE__*/function () {
  function Lexer(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, Lexer);
    this.stream = e;
    this.nextChar();
    this.strBuf = [];
    this.knownCommands = t;
    this._hexStringNumWarn = 0;
    this.beginInlineImagePos = -1;
  }
  return _createClass(Lexer, [{
    key: "nextChar",
    value: function nextChar() {
      return this.currentChar = this.stream.getByte();
    }
  }, {
    key: "peekChar",
    value: function peekChar() {
      return this.stream.peekByte();
    }
  }, {
    key: "getNumber",
    value: function getNumber() {
      var e = this.currentChar,
        t = !1,
        i = 0,
        a = 1;
      if (45 === e) {
        a = -1;
        e = this.nextChar();
        45 === e && (e = this.nextChar());
      } else 43 === e && (e = this.nextChar());
      if (10 === e || 13 === e) do {
        e = this.nextChar();
      } while (10 === e || 13 === e);
      if (46 === e) {
        i = 10;
        e = this.nextChar();
      }
      if (e < 48 || e > 57) {
        var _t105 = "Invalid number: ".concat(String.fromCharCode(e), " (charCode ").concat(e, ")");
        if (isWhiteSpace(e) || -1 === e) {
          info("Lexer.getNumber - \"".concat(_t105, "\"."));
          return 0;
        }
        throw new FormatError(_t105);
      }
      var s = e - 48,
        r = 0,
        n = 1;
      for (; (e = this.nextChar()) >= 0;) if (e >= 48 && e <= 57) {
        var _a78 = e - 48;
        if (t) r = 10 * r + _a78;else {
          0 !== i && (i *= 10);
          s = 10 * s + _a78;
        }
      } else if (46 === e) {
        if (0 !== i) break;
        i = 1;
      } else if (45 === e) warn("Badly formatted number: minus sign in the middle");else {
        if (69 !== e && 101 !== e) break;
        e = this.peekChar();
        if (43 === e || 45 === e) {
          n = 45 === e ? -1 : 1;
          this.nextChar();
        } else if (e < 48 || e > 57) break;
        t = !0;
      }
      0 !== i && (s /= i);
      t && (s *= Math.pow(10, n * r));
      return a * s;
    }
  }, {
    key: "getString",
    value: function getString() {
      var e = 1,
        t = !1;
      var i = this.strBuf;
      i.length = 0;
      var a = this.nextChar();
      for (;;) {
        var _s55 = !1;
        switch (0 | a) {
          case -1:
            warn("Unterminated string");
            t = !0;
            break;
          case 40:
            ++e;
            i.push("(");
            break;
          case 41:
            if (0 == --e) {
              this.nextChar();
              t = !0;
            } else i.push(")");
            break;
          case 92:
            a = this.nextChar();
            switch (a) {
              case -1:
                warn("Unterminated string");
                t = !0;
                break;
              case 110:
                i.push("\n");
                break;
              case 114:
                i.push("\r");
                break;
              case 116:
                i.push("\t");
                break;
              case 98:
                i.push("\b");
                break;
              case 102:
                i.push("\f");
                break;
              case 92:
              case 40:
              case 41:
                i.push(String.fromCharCode(a));
                break;
              case 48:
              case 49:
              case 50:
              case 51:
              case 52:
              case 53:
              case 54:
              case 55:
                var _e122 = 15 & a;
                a = this.nextChar();
                _s55 = !0;
                if (a >= 48 && a <= 55) {
                  _e122 = (_e122 << 3) + (15 & a);
                  a = this.nextChar();
                  if (a >= 48 && a <= 55) {
                    _s55 = !1;
                    _e122 = (_e122 << 3) + (15 & a);
                  }
                }
                i.push(String.fromCharCode(_e122));
                break;
              case 13:
                10 === this.peekChar() && this.nextChar();
                break;
              case 10:
                break;
              default:
                i.push(String.fromCharCode(a));
            }
            break;
          default:
            i.push(String.fromCharCode(a));
        }
        if (t) break;
        _s55 || (a = this.nextChar());
      }
      return i.join("");
    }
  }, {
    key: "getName",
    value: function getName() {
      var e, t;
      var i = this.strBuf;
      i.length = 0;
      for (; (e = this.nextChar()) >= 0 && !hi[e];) if (35 === e) {
        e = this.nextChar();
        if (hi[e]) {
          warn("Lexer_getName: NUMBER SIGN (#) should be followed by a hexadecimal number.");
          i.push("#");
          break;
        }
        var _a79 = toHexDigit(e);
        if (-1 !== _a79) {
          t = e;
          e = this.nextChar();
          var _s56 = toHexDigit(e);
          if (-1 === _s56) {
            warn("Lexer_getName: Illegal digit (".concat(String.fromCharCode(e), ") in hexadecimal number."));
            i.push("#", String.fromCharCode(t));
            if (hi[e]) break;
            i.push(String.fromCharCode(e));
            continue;
          }
          i.push(String.fromCharCode(_a79 << 4 | _s56));
        } else i.push("#", String.fromCharCode(e));
      } else i.push(String.fromCharCode(e));
      i.length > 127 && warn("Name token is longer than allowed by the spec: ".concat(i.length));
      return Name.get(i.join(""));
    }
  }, {
    key: "_hexStringWarn",
    value: function _hexStringWarn(e) {
      5 != this._hexStringNumWarn++ ? this._hexStringNumWarn > 5 || warn("getHexString - ignoring invalid character: ".concat(e)) : warn("getHexString - ignoring additional invalid characters.");
    }
  }, {
    key: "getHexString",
    value: function getHexString() {
      var e = this.strBuf;
      e.length = 0;
      var t = this.currentChar,
        i = -1,
        a = -1;
      this._hexStringNumWarn = 0;
      for (;;) {
        if (t < 0) {
          warn("Unterminated hex string");
          break;
        }
        if (62 === t) {
          this.nextChar();
          break;
        }
        if (1 !== hi[t]) {
          a = toHexDigit(t);
          if (-1 === a) this._hexStringWarn(t);else if (-1 === i) i = a;else {
            e.push(String.fromCharCode(i << 4 | a));
            i = -1;
          }
          t = this.nextChar();
        } else t = this.nextChar();
      }
      -1 !== i && e.push(String.fromCharCode(i << 4));
      return e.join("");
    }
  }, {
    key: "getObj",
    value: function getObj() {
      var e = !1,
        t = this.currentChar;
      for (;;) {
        if (t < 0) return yt;
        if (e) 10 !== t && 13 !== t || (e = !1);else if (37 === t) e = !0;else if (1 !== hi[t]) break;
        t = this.nextChar();
      }
      switch (0 | t) {
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
        case 43:
        case 45:
        case 46:
          return this.getNumber();
        case 40:
          return this.getString();
        case 47:
          return this.getName();
        case 91:
          this.nextChar();
          return Cmd.get("[");
        case 93:
          this.nextChar();
          return Cmd.get("]");
        case 60:
          t = this.nextChar();
          if (60 === t) {
            this.nextChar();
            return Cmd.get("<<");
          }
          return this.getHexString();
        case 62:
          t = this.nextChar();
          if (62 === t) {
            this.nextChar();
            return Cmd.get(">>");
          }
          return Cmd.get(">");
        case 123:
          this.nextChar();
          return Cmd.get("{");
        case 125:
          this.nextChar();
          return Cmd.get("}");
        case 41:
          this.nextChar();
          throw new FormatError("Illegal character: ".concat(t));
      }
      var i = String.fromCharCode(t);
      if (t < 32 || t > 127) {
        var _e123 = this.peekChar();
        if (_e123 >= 32 && _e123 <= 127) {
          this.nextChar();
          return Cmd.get(i);
        }
      }
      var a = this.knownCommands;
      var s = void 0 !== (a === null || a === void 0 ? void 0 : a[i]);
      for (; (t = this.nextChar()) >= 0 && !hi[t];) {
        var _e124 = i + String.fromCharCode(t);
        if (s && void 0 === a[_e124]) break;
        if (128 === i.length) throw new FormatError("Command token too long: ".concat(i.length));
        i = _e124;
        s = void 0 !== (a === null || a === void 0 ? void 0 : a[i]);
      }
      if ("true" === i) return !0;
      if ("false" === i) return !1;
      if ("null" === i) return null;
      "BI" === i && (this.beginInlineImagePos = this.stream.pos);
      return Cmd.get(i);
    }
  }, {
    key: "skipToNextLine",
    value: function skipToNextLine() {
      var e = this.currentChar;
      for (; e >= 0;) {
        if (13 === e) {
          e = this.nextChar();
          10 === e && this.nextChar();
          break;
        }
        if (10 === e) {
          this.nextChar();
          break;
        }
        e = this.nextChar();
      }
    }
  }]);
}();
var Linearization = /*#__PURE__*/function () {
  function Linearization() {
    _classCallCheck(this, Linearization);
  }
  return _createClass(Linearization, null, [{
    key: "create",
    value: function create(e) {
      function getInt(e, t) {
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        var a = e.get(t);
        if (Number.isInteger(a) && (i ? a >= 0 : a > 0)) return a;
        throw new Error("The \"".concat(t, "\" parameter in the linearization dictionary is invalid."));
      }
      var t = new Parser({
          lexer: new Lexer(e),
          xref: null
        }),
        i = t.getObj(),
        a = t.getObj(),
        s = t.getObj(),
        r = t.getObj();
      var n, g;
      if (!(Number.isInteger(i) && Number.isInteger(a) && isCmd(s, "obj") && r instanceof Dict && "number" == typeof (n = r.get("Linearized")) && n > 0)) return null;
      if ((g = getInt(r, "L")) !== e.length) throw new Error('The "L" parameter in the linearization dictionary does not equal the stream length.');
      return {
        length: g,
        hints: function getHints(e) {
          var t = e.get("H");
          var i;
          if (Array.isArray(t) && (2 === (i = t.length) || 4 === i)) {
            for (var _e125 = 0; _e125 < i; _e125++) {
              var _i83 = t[_e125];
              if (!(Number.isInteger(_i83) && _i83 > 0)) throw new Error("Hint (".concat(_e125, ") in the linearization dictionary is invalid."));
            }
            return t;
          }
          throw new Error("Hint array in the linearization dictionary is invalid.");
        }(r),
        objectNumberFirst: getInt(r, "O"),
        endFirst: getInt(r, "E"),
        numPages: getInt(r, "N"),
        mainXRefEntriesOffset: getInt(r, "T"),
        pageFirst: r.has("P") ? getInt(r, "P", !0) : 0
      };
    }
  }]);
}();
var li = ["Adobe-GB1-UCS2", "Adobe-CNS1-UCS2", "Adobe-Japan1-UCS2", "Adobe-Korea1-UCS2", "78-EUC-H", "78-EUC-V", "78-H", "78-RKSJ-H", "78-RKSJ-V", "78-V", "78ms-RKSJ-H", "78ms-RKSJ-V", "83pv-RKSJ-H", "90ms-RKSJ-H", "90ms-RKSJ-V", "90msp-RKSJ-H", "90msp-RKSJ-V", "90pv-RKSJ-H", "90pv-RKSJ-V", "Add-H", "Add-RKSJ-H", "Add-RKSJ-V", "Add-V", "Adobe-CNS1-0", "Adobe-CNS1-1", "Adobe-CNS1-2", "Adobe-CNS1-3", "Adobe-CNS1-4", "Adobe-CNS1-5", "Adobe-CNS1-6", "Adobe-GB1-0", "Adobe-GB1-1", "Adobe-GB1-2", "Adobe-GB1-3", "Adobe-GB1-4", "Adobe-GB1-5", "Adobe-Japan1-0", "Adobe-Japan1-1", "Adobe-Japan1-2", "Adobe-Japan1-3", "Adobe-Japan1-4", "Adobe-Japan1-5", "Adobe-Japan1-6", "Adobe-Korea1-0", "Adobe-Korea1-1", "Adobe-Korea1-2", "B5-H", "B5-V", "B5pc-H", "B5pc-V", "CNS-EUC-H", "CNS-EUC-V", "CNS1-H", "CNS1-V", "CNS2-H", "CNS2-V", "ETHK-B5-H", "ETHK-B5-V", "ETen-B5-H", "ETen-B5-V", "ETenms-B5-H", "ETenms-B5-V", "EUC-H", "EUC-V", "Ext-H", "Ext-RKSJ-H", "Ext-RKSJ-V", "Ext-V", "GB-EUC-H", "GB-EUC-V", "GB-H", "GB-V", "GBK-EUC-H", "GBK-EUC-V", "GBK2K-H", "GBK2K-V", "GBKp-EUC-H", "GBKp-EUC-V", "GBT-EUC-H", "GBT-EUC-V", "GBT-H", "GBT-V", "GBTpc-EUC-H", "GBTpc-EUC-V", "GBpc-EUC-H", "GBpc-EUC-V", "H", "HKdla-B5-H", "HKdla-B5-V", "HKdlb-B5-H", "HKdlb-B5-V", "HKgccs-B5-H", "HKgccs-B5-V", "HKm314-B5-H", "HKm314-B5-V", "HKm471-B5-H", "HKm471-B5-V", "HKscs-B5-H", "HKscs-B5-V", "Hankaku", "Hiragana", "KSC-EUC-H", "KSC-EUC-V", "KSC-H", "KSC-Johab-H", "KSC-Johab-V", "KSC-V", "KSCms-UHC-H", "KSCms-UHC-HW-H", "KSCms-UHC-HW-V", "KSCms-UHC-V", "KSCpc-EUC-H", "KSCpc-EUC-V", "Katakana", "NWP-H", "NWP-V", "RKSJ-H", "RKSJ-V", "Roman", "UniCNS-UCS2-H", "UniCNS-UCS2-V", "UniCNS-UTF16-H", "UniCNS-UTF16-V", "UniCNS-UTF32-H", "UniCNS-UTF32-V", "UniCNS-UTF8-H", "UniCNS-UTF8-V", "UniGB-UCS2-H", "UniGB-UCS2-V", "UniGB-UTF16-H", "UniGB-UTF16-V", "UniGB-UTF32-H", "UniGB-UTF32-V", "UniGB-UTF8-H", "UniGB-UTF8-V", "UniJIS-UCS2-H", "UniJIS-UCS2-HW-H", "UniJIS-UCS2-HW-V", "UniJIS-UCS2-V", "UniJIS-UTF16-H", "UniJIS-UTF16-V", "UniJIS-UTF32-H", "UniJIS-UTF32-V", "UniJIS-UTF8-H", "UniJIS-UTF8-V", "UniJIS2004-UTF16-H", "UniJIS2004-UTF16-V", "UniJIS2004-UTF32-H", "UniJIS2004-UTF32-V", "UniJIS2004-UTF8-H", "UniJIS2004-UTF8-V", "UniJISPro-UCS2-HW-V", "UniJISPro-UCS2-V", "UniJISPro-UTF8-V", "UniJISX0213-UTF32-H", "UniJISX0213-UTF32-V", "UniJISX02132004-UTF32-H", "UniJISX02132004-UTF32-V", "UniKS-UCS2-H", "UniKS-UCS2-V", "UniKS-UTF16-H", "UniKS-UTF16-V", "UniKS-UTF32-H", "UniKS-UTF32-V", "UniKS-UTF8-H", "UniKS-UTF8-V", "V", "WP-Symbol"],
  Bi = Math.pow(2, 24) - 1;
var CMap = /*#__PURE__*/function () {
  function CMap() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    _classCallCheck(this, CMap);
    this.codespaceRanges = [[], [], [], []];
    this.numCodespaceRanges = 0;
    this._map = [];
    this.name = "";
    this.vertical = !1;
    this.useCMap = null;
    this.builtInCMap = e;
  }
  return _createClass(CMap, [{
    key: "addCodespaceRange",
    value: function addCodespaceRange(e, t, i) {
      this.codespaceRanges[e - 1].push(t, i);
      this.numCodespaceRanges++;
    }
  }, {
    key: "mapCidRange",
    value: function mapCidRange(e, t, i) {
      if (t - e > Bi) throw new Error("mapCidRange - ignoring data above MAX_MAP_RANGE.");
      for (; e <= t;) this._map[e++] = i++;
    }
  }, {
    key: "mapBfRange",
    value: function mapBfRange(e, t, i) {
      if (t - e > Bi) throw new Error("mapBfRange - ignoring data above MAX_MAP_RANGE.");
      var a = i.length - 1;
      for (; e <= t;) {
        this._map[e++] = i;
        var _t106 = i.charCodeAt(a) + 1;
        _t106 > 255 ? i = i.substring(0, a - 1) + String.fromCharCode(i.charCodeAt(a - 1) + 1) + "\0" : i = i.substring(0, a) + String.fromCharCode(_t106);
      }
    }
  }, {
    key: "mapBfRangeToArray",
    value: function mapBfRangeToArray(e, t, i) {
      if (t - e > Bi) throw new Error("mapBfRangeToArray - ignoring data above MAX_MAP_RANGE.");
      var a = i.length;
      var s = 0;
      for (; e <= t && s < a;) {
        this._map[e] = i[s++];
        ++e;
      }
    }
  }, {
    key: "mapOne",
    value: function mapOne(e, t) {
      this._map[e] = t;
    }
  }, {
    key: "lookup",
    value: function lookup(e) {
      return this._map[e];
    }
  }, {
    key: "contains",
    value: function contains(e) {
      return void 0 !== this._map[e];
    }
  }, {
    key: "forEach",
    value: function forEach(e) {
      var t = this._map,
        i = t.length;
      if (i <= 65536) for (var _a80 = 0; _a80 < i; _a80++) void 0 !== t[_a80] && e(_a80, t[_a80]);else for (var _i84 in t) e(_i84, t[_i84]);
    }
  }, {
    key: "charCodeOf",
    value: function charCodeOf(e) {
      var t = this._map;
      if (t.length <= 65536) return t.indexOf(e);
      for (var _i85 in t) if (t[_i85] === e) return 0 | _i85;
      return -1;
    }
  }, {
    key: "getMap",
    value: function getMap() {
      return this._map;
    }
  }, {
    key: "readCharCode",
    value: function readCharCode(e, t, i) {
      var a = 0;
      var s = this.codespaceRanges;
      for (var _r41 = 0, _n30 = s.length; _r41 < _n30; _r41++) {
        a = (a << 8 | e.charCodeAt(t + _r41)) >>> 0;
        var _n31 = s[_r41];
        for (var _e126 = 0, _t107 = _n31.length; _e126 < _t107;) {
          var _t108 = _n31[_e126++],
            _s57 = _n31[_e126++];
          if (a >= _t108 && a <= _s57) {
            i.charcode = a;
            i.length = _r41 + 1;
            return;
          }
        }
      }
      i.charcode = 0;
      i.length = 1;
    }
  }, {
    key: "getCharCodeLength",
    value: function getCharCodeLength(e) {
      var t = this.codespaceRanges;
      for (var _i86 = 0, _a81 = t.length; _i86 < _a81; _i86++) {
        var _a82 = t[_i86];
        for (var _t109 = 0, _s58 = _a82.length; _t109 < _s58;) {
          var _s59 = _a82[_t109++],
            _r42 = _a82[_t109++];
          if (e >= _s59 && e <= _r42) return _i86 + 1;
        }
      }
      return 1;
    }
  }, {
    key: "length",
    get: function get() {
      return this._map.length;
    }
  }, {
    key: "isIdentityCMap",
    get: function get() {
      if ("Identity-H" !== this.name && "Identity-V" !== this.name) return !1;
      if (65536 !== this._map.length) return !1;
      for (var _e127 = 0; _e127 < 65536; _e127++) if (this._map[_e127] !== _e127) return !1;
      return !0;
    }
  }]);
}();
var IdentityCMap = /*#__PURE__*/function (_CMap) {
  function IdentityCMap(e, t) {
    var _this29;
    _classCallCheck(this, IdentityCMap);
    _this29 = _callSuper(this, IdentityCMap);
    _this29.vertical = e;
    _this29.addCodespaceRange(t, 0, 65535);
    return _this29;
  }
  _inherits(IdentityCMap, _CMap);
  return _createClass(IdentityCMap, [{
    key: "mapCidRange",
    value: function mapCidRange(e, t, i) {
      unreachable("should not call mapCidRange");
    }
  }, {
    key: "mapBfRange",
    value: function mapBfRange(e, t, i) {
      unreachable("should not call mapBfRange");
    }
  }, {
    key: "mapBfRangeToArray",
    value: function mapBfRangeToArray(e, t, i) {
      unreachable("should not call mapBfRangeToArray");
    }
  }, {
    key: "mapOne",
    value: function mapOne(e, t) {
      unreachable("should not call mapCidOne");
    }
  }, {
    key: "lookup",
    value: function lookup(e) {
      return Number.isInteger(e) && e <= 65535 ? e : void 0;
    }
  }, {
    key: "contains",
    value: function contains(e) {
      return Number.isInteger(e) && e <= 65535;
    }
  }, {
    key: "forEach",
    value: function forEach(e) {
      for (var t = 0; t <= 65535; t++) e(t, t);
    }
  }, {
    key: "charCodeOf",
    value: function charCodeOf(e) {
      return Number.isInteger(e) && e <= 65535 ? e : -1;
    }
  }, {
    key: "getMap",
    value: function getMap() {
      var e = new Array(65536);
      for (var t = 0; t <= 65535; t++) e[t] = t;
      return e;
    }
  }, {
    key: "length",
    get: function get() {
      return 65536;
    }
  }, {
    key: "isIdentityCMap",
    get: function get() {
      unreachable("should not access .isIdentityCMap");
    }
  }]);
}(CMap);
function strToInt(e) {
  var t = 0;
  for (var _i87 = 0; _i87 < e.length; _i87++) t = t << 8 | e.charCodeAt(_i87);
  return t >>> 0;
}
function expectString(e) {
  if ("string" != typeof e) throw new FormatError("Malformed CMap: expected string.");
}
function expectInt(e) {
  if (!Number.isInteger(e)) throw new FormatError("Malformed CMap: expected int.");
}
function parseBfChar(e, t) {
  for (;;) {
    var _i88 = t.getObj();
    if (_i88 === yt) break;
    if (isCmd(_i88, "endbfchar")) return;
    expectString(_i88);
    var _a83 = strToInt(_i88);
    _i88 = t.getObj();
    expectString(_i88);
    var _s60 = _i88;
    e.mapOne(_a83, _s60);
  }
}
function parseBfRange(e, t) {
  for (;;) {
    var _i89 = t.getObj();
    if (_i89 === yt) break;
    if (isCmd(_i89, "endbfrange")) return;
    expectString(_i89);
    var _a84 = strToInt(_i89);
    _i89 = t.getObj();
    expectString(_i89);
    var _s61 = strToInt(_i89);
    _i89 = t.getObj();
    if (Number.isInteger(_i89) || "string" == typeof _i89) {
      var _t110 = Number.isInteger(_i89) ? String.fromCharCode(_i89) : _i89;
      e.mapBfRange(_a84, _s61, _t110);
    } else {
      if (!isCmd(_i89, "[")) break;
      {
        _i89 = t.getObj();
        var _r43 = [];
        for (; !isCmd(_i89, "]") && _i89 !== yt;) {
          _r43.push(_i89);
          _i89 = t.getObj();
        }
        e.mapBfRangeToArray(_a84, _s61, _r43);
      }
    }
  }
  throw new FormatError("Invalid bf range.");
}
function parseCidChar(e, t) {
  for (;;) {
    var _i90 = t.getObj();
    if (_i90 === yt) break;
    if (isCmd(_i90, "endcidchar")) return;
    expectString(_i90);
    var _a85 = strToInt(_i90);
    _i90 = t.getObj();
    expectInt(_i90);
    var _s62 = _i90;
    e.mapOne(_a85, _s62);
  }
}
function parseCidRange(e, t) {
  for (;;) {
    var _i91 = t.getObj();
    if (_i91 === yt) break;
    if (isCmd(_i91, "endcidrange")) return;
    expectString(_i91);
    var _a86 = strToInt(_i91);
    _i91 = t.getObj();
    expectString(_i91);
    var _s63 = strToInt(_i91);
    _i91 = t.getObj();
    expectInt(_i91);
    var _r44 = _i91;
    e.mapCidRange(_a86, _s63, _r44);
  }
}
function parseCodespaceRange(e, t) {
  for (;;) {
    var _i92 = t.getObj();
    if (_i92 === yt) break;
    if (isCmd(_i92, "endcodespacerange")) return;
    if ("string" != typeof _i92) break;
    var _a87 = strToInt(_i92);
    _i92 = t.getObj();
    if ("string" != typeof _i92) break;
    var _s64 = strToInt(_i92);
    e.addCodespaceRange(_i92.length, _a87, _s64);
  }
  throw new FormatError("Invalid codespace range.");
}
function parseWMode(e, t) {
  var i = t.getObj();
  Number.isInteger(i) && (e.vertical = !!i);
}
function parseCMapName(e, t) {
  var i = t.getObj();
  i instanceof Name && (e.name = i.name);
}
function parseCMap(_x15, _x16, _x17, _x18) {
  return _parseCMap.apply(this, arguments);
}
function _parseCMap() {
  _parseCMap = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee104(e, t, i, a) {
    var s, r, _i433;
    return _regeneratorRuntime().wrap(function _callee104$(_context116) {
      while (1) switch (_context116.prev = _context116.next) {
        case 0:
          _context116.prev = 0;
          _i433 = t.getObj();
          if (!(_i433 === yt)) {
            _context116.next = 4;
            break;
          }
          return _context116.abrupt("break", 35);
        case 4:
          if (!(_i433 instanceof Name)) {
            _context116.next = 9;
            break;
          }
          "WMode" === _i433.name ? parseWMode(e, t) : "CMapName" === _i433.name && parseCMapName(e, t);
          s = _i433;
          _context116.next = 25;
          break;
        case 9:
          if (!(_i433 instanceof Cmd)) {
            _context116.next = 25;
            break;
          }
          _context116.t0 = _i433.cmd;
          _context116.next = _context116.t0 === "endcmap" ? 13 : _context116.t0 === "usecmap" ? 14 : _context116.t0 === "begincodespacerange" ? 16 : _context116.t0 === "beginbfchar" ? 18 : _context116.t0 === "begincidchar" ? 20 : _context116.t0 === "beginbfrange" ? 22 : _context116.t0 === "begincidrange" ? 24 : 25;
          break;
        case 13:
          return _context116.abrupt("break", 35);
        case 14:
          s instanceof Name && (r = s.name);
          return _context116.abrupt("break", 25);
        case 16:
          parseCodespaceRange(e, t);
          return _context116.abrupt("break", 25);
        case 18:
          parseBfChar(e, t);
          return _context116.abrupt("break", 25);
        case 20:
          parseCidChar(e, t);
          return _context116.abrupt("break", 25);
        case 22:
          parseBfRange(e, t);
          return _context116.abrupt("break", 25);
        case 24:
          parseCidRange(e, t);
        case 25:
          _context116.next = 33;
          break;
        case 27:
          _context116.prev = 27;
          _context116.t1 = _context116["catch"](0);
          if (!(_context116.t1 instanceof MissingDataException)) {
            _context116.next = 31;
            break;
          }
          throw _context116.t1;
        case 31:
          warn("Invalid cMap data: " + _context116.t1);
          return _context116.abrupt("continue", 33);
        case 33:
          _context116.next = 0;
          break;
        case 35:
          !a && r && (a = r);
          return _context116.abrupt("return", a ? extendCMap(e, i, a) : e);
        case 37:
        case "end":
          return _context116.stop();
      }
    }, _callee104, null, [[0, 27]]);
  }));
  return _parseCMap.apply(this, arguments);
}
function extendCMap(_x19, _x20, _x21) {
  return _extendCMap.apply(this, arguments);
}
function _extendCMap() {
  _extendCMap = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee105(e, t, i) {
    var _t494, _i434;
    return _regeneratorRuntime().wrap(function _callee105$(_context117) {
      while (1) switch (_context117.prev = _context117.next) {
        case 0:
          _context117.next = 2;
          return createBuiltInCMap(i, t);
        case 2:
          e.useCMap = _context117.sent;
          if (0 === e.numCodespaceRanges) {
            _t494 = e.useCMap.codespaceRanges;
            for (_i434 = 0; _i434 < _t494.length; _i434++) e.codespaceRanges[_i434] = _t494[_i434].slice();
            e.numCodespaceRanges = e.useCMap.numCodespaceRanges;
          }
          e.useCMap.forEach(function (t, i) {
            e.contains(t) || e.mapOne(t, e.useCMap.lookup(t));
          });
          return _context117.abrupt("return", e);
        case 6:
        case "end":
          return _context117.stop();
      }
    }, _callee105);
  }));
  return _extendCMap.apply(this, arguments);
}
function createBuiltInCMap(_x22, _x23) {
  return _createBuiltInCMap.apply(this, arguments);
}
function _createBuiltInCMap() {
  _createBuiltInCMap = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee106(e, t) {
    var _yield$t, i, a, s, r;
    return _regeneratorRuntime().wrap(function _callee106$(_context118) {
      while (1) switch (_context118.prev = _context118.next) {
        case 0:
          if (!("Identity-H" === e)) {
            _context118.next = 2;
            break;
          }
          return _context118.abrupt("return", new IdentityCMap(!1, 2));
        case 2:
          if (!("Identity-V" === e)) {
            _context118.next = 4;
            break;
          }
          return _context118.abrupt("return", new IdentityCMap(!0, 2));
        case 4:
          if (li.includes(e)) {
            _context118.next = 6;
            break;
          }
          throw new Error("Unknown CMap name: " + e);
        case 6:
          if (t) {
            _context118.next = 8;
            break;
          }
          throw new Error("Built-in CMap parameters are not provided.");
        case 8:
          _context118.next = 10;
          return t(e);
        case 10:
          _yield$t = _context118.sent;
          i = _yield$t.cMapData;
          a = _yield$t.isCompressed;
          s = new CMap(!0);
          if (!a) {
            _context118.next = 16;
            break;
          }
          return _context118.abrupt("return", new BinaryCMapReader().process(i, s, function (e) {
            return extendCMap(s, t, e);
          }));
        case 16:
          r = new Lexer(new Stream(i));
          return _context118.abrupt("return", parseCMap(s, r, t, null));
        case 18:
        case "end":
          return _context118.stop();
      }
    }, _callee106);
  }));
  return _createBuiltInCMap.apply(this, arguments);
}
var CMapFactory = /*#__PURE__*/function () {
  function CMapFactory() {
    _classCallCheck(this, CMapFactory);
  }
  return _createClass(CMapFactory, null, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(_ref36) {
        var e, t, i, _a88;
        return _regeneratorRuntime().wrap(function _callee12$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              e = _ref36.encoding, t = _ref36.fetchBuiltInCMap, i = _ref36.useCMap;
              if (!(e instanceof Name)) {
                _context14.next = 3;
                break;
              }
              return _context14.abrupt("return", createBuiltInCMap(e.name, t));
            case 3:
              if (!(e instanceof BaseStream)) {
                _context14.next = 8;
                break;
              }
              _context14.next = 6;
              return parseCMap(new CMap(), new Lexer(e), t, i);
            case 6:
              _a88 = _context14.sent;
              return _context14.abrupt("return", _a88.isIdentityCMap ? createBuiltInCMap(_a88.name, t) : _a88);
            case 8:
              throw new Error("Encoding required.");
            case 9:
            case "end":
              return _context14.stop();
          }
        }, _callee12);
      }));
      function create(_x24) {
        return _create.apply(this, arguments);
      }
      return create;
    }()
  }]);
}();
var Qi = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron"],
  Ei = [".notdef", "space", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"],
  ui = [".notdef", "space", "dollaroldstyle", "dollarsuperior", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "hyphensuperior", "colonmonetary", "onefitted", "rupiah", "centoldstyle", "figuredash", "hypheninferior", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior"],
  di = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "", "", "", "isuperior", "", "", "lsuperior", "msuperior", "nsuperior", "osuperior", "", "", "rsuperior", "ssuperior", "tsuperior", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdownsmall", "centoldstyle", "Lslashsmall", "", "", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "", "Dotaccentsmall", "", "", "Macronsmall", "", "", "figuredash", "hypheninferior", "", "", "Ogoneksmall", "Ringsmall", "Cedillasmall", "", "", "", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"],
  fi = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "centoldstyle", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "", "threequartersemdash", "", "questionsmall", "", "", "", "", "Ethsmall", "", "", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "", "", "", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hypheninferior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "asuperior", "centsuperior", "", "", "", "", "Aacutesmall", "Agravesmall", "Acircumflexsmall", "Adieresissmall", "Atildesmall", "Aringsmall", "Ccedillasmall", "Eacutesmall", "Egravesmall", "Ecircumflexsmall", "Edieresissmall", "Iacutesmall", "Igravesmall", "Icircumflexsmall", "Idieresissmall", "Ntildesmall", "Oacutesmall", "Ogravesmall", "Ocircumflexsmall", "Odieresissmall", "Otildesmall", "Uacutesmall", "Ugravesmall", "Ucircumflexsmall", "Udieresissmall", "", "eightsuperior", "fourinferior", "threeinferior", "sixinferior", "eightinferior", "seveninferior", "Scaronsmall", "", "centinferior", "twoinferior", "", "Dieresissmall", "", "Caronsmall", "osuperior", "fiveinferior", "", "commainferior", "periodinferior", "Yacutesmall", "", "dollarinferior", "", "", "Thornsmall", "", "nineinferior", "zeroinferior", "Zcaronsmall", "AEsmall", "Oslashsmall", "questiondownsmall", "oneinferior", "Lslashsmall", "", "", "", "", "", "", "Cedillasmall", "", "", "", "", "", "OEsmall", "figuredash", "hyphensuperior", "", "", "", "", "exclamdownsmall", "", "Ydieresissmall", "", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "ninesuperior", "zerosuperior", "", "esuperior", "rsuperior", "tsuperior", "", "", "isuperior", "ssuperior", "dsuperior", "", "", "", "", "", "lsuperior", "Ogoneksmall", "Brevesmall", "Macronsmall", "bsuperior", "nsuperior", "msuperior", "commasuperior", "periodsuperior", "Dotaccentsmall", "Ringsmall", "", "", "", ""],
  pi = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "space", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron"],
  mi = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "", "endash", "dagger", "daggerdbl", "periodcentered", "", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "", "questiondown", "", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "", "ring", "cedilla", "", "hungarumlaut", "ogonek", "caron", "emdash", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "AE", "", "ordfeminine", "", "", "", "", "Lslash", "Oslash", "OE", "ordmasculine", "", "", "", "", "", "ae", "", "", "", "dotlessi", "", "", "lslash", "oslash", "oe", "germandbls", "", "", "", ""],
  yi = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "bullet", "Euro", "bullet", "quotesinglbase", "florin", "quotedblbase", "ellipsis", "dagger", "daggerdbl", "circumflex", "perthousand", "Scaron", "guilsinglleft", "OE", "bullet", "Zcaron", "bullet", "bullet", "quoteleft", "quoteright", "quotedblleft", "quotedblright", "bullet", "endash", "emdash", "tilde", "trademark", "scaron", "guilsinglright", "oe", "bullet", "zcaron", "Ydieresis", "space", "exclamdown", "cent", "sterling", "currency", "yen", "brokenbar", "section", "dieresis", "copyright", "ordfeminine", "guillemotleft", "logicalnot", "hyphen", "registered", "macron", "degree", "plusminus", "twosuperior", "threesuperior", "acute", "mu", "paragraph", "periodcentered", "cedilla", "onesuperior", "ordmasculine", "guillemotright", "onequarter", "onehalf", "threequarters", "questiondown", "Agrave", "Aacute", "Acircumflex", "Atilde", "Adieresis", "Aring", "AE", "Ccedilla", "Egrave", "Eacute", "Ecircumflex", "Edieresis", "Igrave", "Iacute", "Icircumflex", "Idieresis", "Eth", "Ntilde", "Ograve", "Oacute", "Ocircumflex", "Otilde", "Odieresis", "multiply", "Oslash", "Ugrave", "Uacute", "Ucircumflex", "Udieresis", "Yacute", "Thorn", "germandbls", "agrave", "aacute", "acircumflex", "atilde", "adieresis", "aring", "ae", "ccedilla", "egrave", "eacute", "ecircumflex", "edieresis", "igrave", "iacute", "icircumflex", "idieresis", "eth", "ntilde", "ograve", "oacute", "ocircumflex", "otilde", "odieresis", "divide", "oslash", "ugrave", "uacute", "ucircumflex", "udieresis", "yacute", "thorn", "ydieresis"],
  wi = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "universal", "numbersign", "existential", "percent", "ampersand", "suchthat", "parenleft", "parenright", "asteriskmath", "plus", "comma", "minus", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "congruent", "Alpha", "Beta", "Chi", "Delta", "Epsilon", "Phi", "Gamma", "Eta", "Iota", "theta1", "Kappa", "Lambda", "Mu", "Nu", "Omicron", "Pi", "Theta", "Rho", "Sigma", "Tau", "Upsilon", "sigma1", "Omega", "Xi", "Psi", "Zeta", "bracketleft", "therefore", "bracketright", "perpendicular", "underscore", "radicalex", "alpha", "beta", "chi", "delta", "epsilon", "phi", "gamma", "eta", "iota", "phi1", "kappa", "lambda", "mu", "nu", "omicron", "pi", "theta", "rho", "sigma", "tau", "upsilon", "omega1", "omega", "xi", "psi", "zeta", "braceleft", "bar", "braceright", "similar", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "Euro", "Upsilon1", "minute", "lessequal", "fraction", "infinity", "florin", "club", "diamond", "heart", "spade", "arrowboth", "arrowleft", "arrowup", "arrowright", "arrowdown", "degree", "plusminus", "second", "greaterequal", "multiply", "proportional", "partialdiff", "bullet", "divide", "notequal", "equivalence", "approxequal", "ellipsis", "arrowvertex", "arrowhorizex", "carriagereturn", "aleph", "Ifraktur", "Rfraktur", "weierstrass", "circlemultiply", "circleplus", "emptyset", "intersection", "union", "propersuperset", "reflexsuperset", "notsubset", "propersubset", "reflexsubset", "element", "notelement", "angle", "gradient", "registerserif", "copyrightserif", "trademarkserif", "product", "radical", "dotmath", "logicalnot", "logicaland", "logicalor", "arrowdblboth", "arrowdblleft", "arrowdblup", "arrowdblright", "arrowdbldown", "lozenge", "angleleft", "registersans", "copyrightsans", "trademarksans", "summation", "parenlefttp", "parenleftex", "parenleftbt", "bracketlefttp", "bracketleftex", "bracketleftbt", "bracelefttp", "braceleftmid", "braceleftbt", "braceex", "", "angleright", "integral", "integraltp", "integralex", "integralbt", "parenrighttp", "parenrightex", "parenrightbt", "bracketrighttp", "bracketrightex", "bracketrightbt", "bracerighttp", "bracerightmid", "bracerightbt", ""],
  Di = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "a1", "a2", "a202", "a3", "a4", "a5", "a119", "a118", "a117", "a11", "a12", "a13", "a14", "a15", "a16", "a105", "a17", "a18", "a19", "a20", "a21", "a22", "a23", "a24", "a25", "a26", "a27", "a28", "a6", "a7", "a8", "a9", "a10", "a29", "a30", "a31", "a32", "a33", "a34", "a35", "a36", "a37", "a38", "a39", "a40", "a41", "a42", "a43", "a44", "a45", "a46", "a47", "a48", "a49", "a50", "a51", "a52", "a53", "a54", "a55", "a56", "a57", "a58", "a59", "a60", "a61", "a62", "a63", "a64", "a65", "a66", "a67", "a68", "a69", "a70", "a71", "a72", "a73", "a74", "a203", "a75", "a204", "a76", "a77", "a78", "a79", "a81", "a82", "a83", "a84", "a97", "a98", "a99", "a100", "", "a89", "a90", "a93", "a94", "a91", "a92", "a205", "a85", "a206", "a86", "a87", "a88", "a95", "a96", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "a101", "a102", "a103", "a104", "a106", "a107", "a108", "a112", "a111", "a110", "a109", "a120", "a121", "a122", "a123", "a124", "a125", "a126", "a127", "a128", "a129", "a130", "a131", "a132", "a133", "a134", "a135", "a136", "a137", "a138", "a139", "a140", "a141", "a142", "a143", "a144", "a145", "a146", "a147", "a148", "a149", "a150", "a151", "a152", "a153", "a154", "a155", "a156", "a157", "a158", "a159", "a160", "a161", "a163", "a164", "a196", "a165", "a192", "a166", "a167", "a168", "a169", "a170", "a171", "a172", "a173", "a162", "a174", "a175", "a176", "a177", "a178", "a179", "a193", "a180", "a199", "a181", "a200", "a182", "", "a201", "a183", "a184", "a197", "a185", "a194", "a198", "a186", "a195", "a187", "a188", "a189", "a190", "a191", ""];
function getEncoding(e) {
  switch (e) {
    case "WinAnsiEncoding":
      return yi;
    case "StandardEncoding":
      return mi;
    case "MacRomanEncoding":
      return pi;
    case "SymbolSetEncoding":
      return wi;
    case "ZapfDingbatsEncoding":
      return Di;
    case "ExpertEncoding":
      return di;
    case "MacExpertEncoding":
      return fi;
    default:
      return null;
  }
}
var bi = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall", "001.000", "001.001", "001.002", "001.003", "Black", "Bold", "Book", "Light", "Medium", "Regular", "Roman", "Semibold"],
  Fi = 391,
  Si = [null, {
    id: "hstem",
    min: 2,
    stackClearing: !0,
    stem: !0
  }, null, {
    id: "vstem",
    min: 2,
    stackClearing: !0,
    stem: !0
  }, {
    id: "vmoveto",
    min: 1,
    stackClearing: !0
  }, {
    id: "rlineto",
    min: 2,
    resetStack: !0
  }, {
    id: "hlineto",
    min: 1,
    resetStack: !0
  }, {
    id: "vlineto",
    min: 1,
    resetStack: !0
  }, {
    id: "rrcurveto",
    min: 6,
    resetStack: !0
  }, null, {
    id: "callsubr",
    min: 1,
    undefStack: !0
  }, {
    id: "return",
    min: 0,
    undefStack: !0
  }, null, null, {
    id: "endchar",
    min: 0,
    stackClearing: !0
  }, null, null, null, {
    id: "hstemhm",
    min: 2,
    stackClearing: !0,
    stem: !0
  }, {
    id: "hintmask",
    min: 0,
    stackClearing: !0
  }, {
    id: "cntrmask",
    min: 0,
    stackClearing: !0
  }, {
    id: "rmoveto",
    min: 2,
    stackClearing: !0
  }, {
    id: "hmoveto",
    min: 1,
    stackClearing: !0
  }, {
    id: "vstemhm",
    min: 2,
    stackClearing: !0,
    stem: !0
  }, {
    id: "rcurveline",
    min: 8,
    resetStack: !0
  }, {
    id: "rlinecurve",
    min: 8,
    resetStack: !0
  }, {
    id: "vvcurveto",
    min: 4,
    resetStack: !0
  }, {
    id: "hhcurveto",
    min: 4,
    resetStack: !0
  }, null, {
    id: "callgsubr",
    min: 1,
    undefStack: !0
  }, {
    id: "vhcurveto",
    min: 4,
    resetStack: !0
  }, {
    id: "hvcurveto",
    min: 4,
    resetStack: !0
  }],
  ki = [null, null, null, {
    id: "and",
    min: 2,
    stackDelta: -1
  }, {
    id: "or",
    min: 2,
    stackDelta: -1
  }, {
    id: "not",
    min: 1,
    stackDelta: 0
  }, null, null, null, {
    id: "abs",
    min: 1,
    stackDelta: 0
  }, {
    id: "add",
    min: 2,
    stackDelta: -1,
    stackFn: function stackFn(e, t) {
      e[t - 2] = e[t - 2] + e[t - 1];
    }
  }, {
    id: "sub",
    min: 2,
    stackDelta: -1,
    stackFn: function stackFn(e, t) {
      e[t - 2] = e[t - 2] - e[t - 1];
    }
  }, {
    id: "div",
    min: 2,
    stackDelta: -1,
    stackFn: function stackFn(e, t) {
      e[t - 2] = e[t - 2] / e[t - 1];
    }
  }, null, {
    id: "neg",
    min: 1,
    stackDelta: 0,
    stackFn: function stackFn(e, t) {
      e[t - 1] = -e[t - 1];
    }
  }, {
    id: "eq",
    min: 2,
    stackDelta: -1
  }, null, null, {
    id: "drop",
    min: 1,
    stackDelta: -1
  }, null, {
    id: "put",
    min: 2,
    stackDelta: -2
  }, {
    id: "get",
    min: 1,
    stackDelta: 0
  }, {
    id: "ifelse",
    min: 4,
    stackDelta: -3
  }, {
    id: "random",
    min: 0,
    stackDelta: 1
  }, {
    id: "mul",
    min: 2,
    stackDelta: -1,
    stackFn: function stackFn(e, t) {
      e[t - 2] = e[t - 2] * e[t - 1];
    }
  }, null, {
    id: "sqrt",
    min: 1,
    stackDelta: 0
  }, {
    id: "dup",
    min: 1,
    stackDelta: 1
  }, {
    id: "exch",
    min: 2,
    stackDelta: 0
  }, {
    id: "index",
    min: 2,
    stackDelta: 0
  }, {
    id: "roll",
    min: 3,
    stackDelta: -2
  }, null, null, null, {
    id: "hflex",
    min: 7,
    resetStack: !0
  }, {
    id: "flex",
    min: 13,
    resetStack: !0
  }, {
    id: "hflex1",
    min: 9,
    resetStack: !0
  }, {
    id: "flex1",
    min: 11,
    resetStack: !0
  }];
var CFFParser = /*#__PURE__*/function () {
  function CFFParser(e, t, i) {
    _classCallCheck(this, CFFParser);
    this.bytes = e.getBytes();
    this.properties = t;
    this.seacAnalysisEnabled = !!i;
  }
  return _createClass(CFFParser, [{
    key: "parse",
    value: function parse() {
      var e = this.properties,
        t = new CFF();
      this.cff = t;
      var i = this.parseHeader(),
        a = this.parseIndex(i.endPos),
        s = this.parseIndex(a.endPos),
        r = this.parseIndex(s.endPos),
        n = this.parseIndex(r.endPos),
        g = this.parseDict(s.obj.get(0)),
        o = this.createDict(CFFTopDict, g, t.strings);
      t.header = i.obj;
      t.names = this.parseNameIndex(a.obj);
      t.strings = this.parseStringIndex(r.obj);
      t.topDict = o;
      t.globalSubrIndex = n.obj;
      this.parsePrivateDict(t.topDict);
      t.isCIDFont = o.hasName("ROS");
      var c = o.getByName("CharStrings"),
        C = this.parseIndex(c).obj,
        h = o.getByName("FontMatrix");
      h && (e.fontMatrix = h);
      var l = o.getByName("FontBBox");
      if (l) {
        e.ascent = Math.max(l[3], l[1]);
        e.descent = Math.min(l[1], l[3]);
        e.ascentScaled = !0;
      }
      var Q, E;
      if (t.isCIDFont) {
        var _e128 = this.parseIndex(o.getByName("FDArray")).obj;
        for (var _i93 = 0, _a89 = _e128.count; _i93 < _a89; ++_i93) {
          var _a90 = _e128.get(_i93),
            _s65 = this.createDict(CFFTopDict, this.parseDict(_a90), t.strings);
          this.parsePrivateDict(_s65);
          t.fdArray.push(_s65);
        }
        E = null;
        Q = this.parseCharsets(o.getByName("charset"), C.count, t.strings, !0);
        t.fdSelect = this.parseFDSelect(o.getByName("FDSelect"), C.count);
      } else {
        Q = this.parseCharsets(o.getByName("charset"), C.count, t.strings, !1);
        E = this.parseEncoding(o.getByName("Encoding"), e, t.strings, Q.charset);
      }
      t.charset = Q;
      t.encoding = E;
      var u = this.parseCharStrings({
        charStrings: C,
        localSubrIndex: o.privateDict.subrsIndex,
        globalSubrIndex: n.obj,
        fdSelect: t.fdSelect,
        fdArray: t.fdArray,
        privateDict: o.privateDict
      });
      t.charStrings = u.charStrings;
      t.seacs = u.seacs;
      t.widths = u.widths;
      return t;
    }
  }, {
    key: "parseHeader",
    value: function parseHeader() {
      var e = this.bytes;
      var t = e.length;
      var i = 0;
      for (; i < t && 1 !== e[i];) ++i;
      if (i >= t) throw new FormatError("Invalid CFF header");
      if (0 !== i) {
        info("cff data is shifted");
        e = e.subarray(i);
        this.bytes = e;
      }
      var a = e[0],
        s = e[1],
        r = e[2],
        n = e[3];
      return {
        obj: new CFFHeader(a, s, r, n),
        endPos: r
      };
    }
  }, {
    key: "parseDict",
    value: function parseDict(e) {
      var t = 0;
      function parseOperand() {
        var i = e[t++];
        if (30 === i) return function parseFloatOperand() {
          var i = "";
          var a = 15,
            s = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "E", "E-", null, "-"],
            r = e.length;
          for (; t < r;) {
            var _r45 = e[t++],
              _n32 = _r45 >> 4,
              _g16 = 15 & _r45;
            if (_n32 === a) break;
            i += s[_n32];
            if (_g16 === a) break;
            i += s[_g16];
          }
          return parseFloat(i);
        }();
        if (28 === i) {
          i = e[t++];
          i = (i << 24 | e[t++] << 16) >> 16;
          return i;
        }
        if (29 === i) {
          i = e[t++];
          i = i << 8 | e[t++];
          i = i << 8 | e[t++];
          i = i << 8 | e[t++];
          return i;
        }
        if (i >= 32 && i <= 246) return i - 139;
        if (i >= 247 && i <= 250) return 256 * (i - 247) + e[t++] + 108;
        if (i >= 251 && i <= 254) return -256 * (i - 251) - e[t++] - 108;
        warn('CFFParser_parseDict: "' + i + '" is a reserved command.');
        return NaN;
      }
      var i = [];
      var a = [];
      t = 0;
      var s = e.length;
      for (; t < s;) {
        var _s66 = e[t];
        if (_s66 <= 21) {
          12 === _s66 && (_s66 = _s66 << 8 | e[++t]);
          a.push([_s66, i]);
          i = [];
          ++t;
        } else i.push(parseOperand());
      }
      return a;
    }
  }, {
    key: "parseIndex",
    value: function parseIndex(e) {
      var t = new CFFIndex(),
        i = this.bytes,
        a = i[e++] << 8 | i[e++],
        s = [];
      var r,
        n,
        g = e;
      if (0 !== a) {
        var _t111 = i[e++],
          _o10 = e + (a + 1) * _t111 - 1;
        for (r = 0, n = a + 1; r < n; ++r) {
          var _a91 = 0;
          for (var _s67 = 0; _s67 < _t111; ++_s67) {
            _a91 <<= 8;
            _a91 += i[e++];
          }
          s.push(_o10 + _a91);
        }
        g = s[a];
      }
      for (r = 0, n = s.length - 1; r < n; ++r) {
        var _e129 = s[r],
          _a92 = s[r + 1];
        t.add(i.subarray(_e129, _a92));
      }
      return {
        obj: t,
        endPos: g
      };
    }
  }, {
    key: "parseNameIndex",
    value: function parseNameIndex(e) {
      var t = [];
      for (var _i94 = 0, _a93 = e.count; _i94 < _a93; ++_i94) {
        var _a94 = e.get(_i94);
        t.push(bytesToString(_a94));
      }
      return t;
    }
  }, {
    key: "parseStringIndex",
    value: function parseStringIndex(e) {
      var t = new CFFStrings();
      for (var _i95 = 0, _a95 = e.count; _i95 < _a95; ++_i95) {
        var _a96 = e.get(_i95);
        t.add(bytesToString(_a96));
      }
      return t;
    }
  }, {
    key: "createDict",
    value: function createDict(e, t, i) {
      var a = new e(i);
      var _iterator25 = _createForOfIteratorHelper(t),
        _step25;
      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var _ref37 = _step25.value;
          var _ref38 = _slicedToArray(_ref37, 2);
          var _e130 = _ref38[0];
          var _i96 = _ref38[1];
          a.setByKey(_e130, _i96);
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
      return a;
    }
  }, {
    key: "parseCharString",
    value: function parseCharString(e, t, i, a) {
      if (!t || e.callDepth > 10) return !1;
      var s = e.stackSize;
      var r = e.stack;
      var n = t.length;
      for (var _g17 = 0; _g17 < n;) {
        var _o11 = t[_g17++];
        var _c8 = null;
        if (12 === _o11) {
          var _e131 = t[_g17++];
          if (0 === _e131) {
            t[_g17 - 2] = 139;
            t[_g17 - 1] = 22;
            s = 0;
          } else _c8 = ki[_e131];
        } else if (28 === _o11) {
          r[s] = (t[_g17] << 24 | t[_g17 + 1] << 16) >> 16;
          _g17 += 2;
          s++;
        } else if (14 === _o11) {
          if (s >= 4) {
            s -= 4;
            if (this.seacAnalysisEnabled) {
              e.seac = r.slice(s, s + 4);
              return !1;
            }
          }
          _c8 = Si[_o11];
        } else if (_o11 >= 32 && _o11 <= 246) {
          r[s] = _o11 - 139;
          s++;
        } else if (_o11 >= 247 && _o11 <= 254) {
          r[s] = _o11 < 251 ? (_o11 - 247 << 8) + t[_g17] + 108 : -(_o11 - 251 << 8) - t[_g17] - 108;
          _g17++;
          s++;
        } else if (255 === _o11) {
          r[s] = (t[_g17] << 24 | t[_g17 + 1] << 16 | t[_g17 + 2] << 8 | t[_g17 + 3]) / 65536;
          _g17 += 4;
          s++;
        } else if (19 === _o11 || 20 === _o11) {
          e.hints += s >> 1;
          if (0 === e.hints) {
            t.copyWithin(_g17 - 1, _g17, -1);
            _g17 -= 1;
            n -= 1;
            continue;
          }
          _g17 += e.hints + 7 >> 3;
          s %= 2;
          _c8 = Si[_o11];
        } else {
          if (10 === _o11 || 29 === _o11) {
            var _t112 = 10 === _o11 ? i : a;
            if (!_t112) {
              _c8 = Si[_o11];
              warn("Missing subrsIndex for " + _c8.id);
              return !1;
            }
            var _n33 = 32768;
            _t112.count < 1240 ? _n33 = 107 : _t112.count < 33900 && (_n33 = 1131);
            var _g18 = r[--s] + _n33;
            if (_g18 < 0 || _g18 >= _t112.count || isNaN(_g18)) {
              _c8 = Si[_o11];
              warn("Out of bounds subrIndex for " + _c8.id);
              return !1;
            }
            e.stackSize = s;
            e.callDepth++;
            if (!this.parseCharString(e, _t112.get(_g18), i, a)) return !1;
            e.callDepth--;
            s = e.stackSize;
            continue;
          }
          if (11 === _o11) {
            e.stackSize = s;
            return !0;
          }
          if (0 === _o11 && _g17 === t.length) {
            t[_g17 - 1] = 14;
            _c8 = Si[14];
          } else {
            if (9 === _o11) {
              t.copyWithin(_g17 - 1, _g17, -1);
              _g17 -= 1;
              n -= 1;
              continue;
            }
            _c8 = Si[_o11];
          }
        }
        if (_c8) {
          if (_c8.stem) {
            e.hints += s >> 1;
            if (3 === _o11 || 23 === _o11) e.hasVStems = !0;else if (e.hasVStems && (1 === _o11 || 18 === _o11)) {
              warn("CFF stem hints are in wrong order");
              t[_g17 - 1] = 1 === _o11 ? 3 : 23;
            }
          }
          if ("min" in _c8 && !e.undefStack && s < _c8.min) {
            warn("Not enough parameters for " + _c8.id + "; actual: " + s + ", expected: " + _c8.min);
            if (0 === s) {
              t[_g17 - 1] = 14;
              return !0;
            }
            return !1;
          }
          if (e.firstStackClearing && _c8.stackClearing) {
            e.firstStackClearing = !1;
            s -= _c8.min;
            s >= 2 && _c8.stem ? s %= 2 : s > 1 && warn("Found too many parameters for stack-clearing command");
            s > 0 && (e.width = r[s - 1]);
          }
          if ("stackDelta" in _c8) {
            "stackFn" in _c8 && _c8.stackFn(r, s);
            s += _c8.stackDelta;
          } else if (_c8.stackClearing) s = 0;else if (_c8.resetStack) {
            s = 0;
            e.undefStack = !1;
          } else if (_c8.undefStack) {
            s = 0;
            e.undefStack = !0;
            e.firstStackClearing = !1;
          }
        }
      }
      n < t.length && t.fill(14, n);
      e.stackSize = s;
      return !0;
    }
  }, {
    key: "parseCharStrings",
    value: function parseCharStrings(_ref39) {
      var e = _ref39.charStrings,
        t = _ref39.localSubrIndex,
        i = _ref39.globalSubrIndex,
        a = _ref39.fdSelect,
        s = _ref39.fdArray,
        r = _ref39.privateDict;
      var n = [],
        g = [],
        o = e.count;
      for (var _c9 = 0; _c9 < o; _c9++) {
        var _o12 = e.get(_c9),
          _C6 = {
            callDepth: 0,
            stackSize: 0,
            stack: [],
            undefStack: !0,
            hints: 0,
            firstStackClearing: !0,
            seac: null,
            width: null,
            hasVStems: !1
          };
        var h = !0,
          l = null,
          _Q10 = r;
        if (a && s.length) {
          var _e132 = a.getFDIndex(_c9);
          if (-1 === _e132) {
            warn("Glyph index is not in fd select.");
            h = !1;
          }
          if (_e132 >= s.length) {
            warn("Invalid fd index for glyph index.");
            h = !1;
          }
          if (h) {
            _Q10 = s[_e132].privateDict;
            l = _Q10.subrsIndex;
          }
        } else t && (l = t);
        h && (h = this.parseCharString(_C6, _o12, l, i));
        if (null !== _C6.width) {
          var _e133 = _Q10.getByName("nominalWidthX");
          g[_c9] = _e133 + _C6.width;
        } else {
          var _e134 = _Q10.getByName("defaultWidthX");
          g[_c9] = _e134;
        }
        null !== _C6.seac && (n[_c9] = _C6.seac);
        h || e.set(_c9, new Uint8Array([14]));
      }
      return {
        charStrings: e,
        seacs: n,
        widths: g
      };
    }
  }, {
    key: "emptyPrivateDictionary",
    value: function emptyPrivateDictionary(e) {
      var t = this.createDict(CFFPrivateDict, [], e.strings);
      e.setByKey(18, [0, 0]);
      e.privateDict = t;
    }
  }, {
    key: "parsePrivateDict",
    value: function parsePrivateDict(e) {
      if (!e.hasName("Private")) {
        this.emptyPrivateDictionary(e);
        return;
      }
      var t = e.getByName("Private");
      if (!Array.isArray(t) || 2 !== t.length) {
        e.removeByName("Private");
        return;
      }
      var i = t[0],
        a = t[1];
      if (0 === i || a >= this.bytes.length) {
        this.emptyPrivateDictionary(e);
        return;
      }
      var s = a + i,
        r = this.bytes.subarray(a, s),
        n = this.parseDict(r),
        g = this.createDict(CFFPrivateDict, n, e.strings);
      e.privateDict = g;
      0 === g.getByName("ExpansionFactor") && g.setByName("ExpansionFactor", .06);
      if (!g.getByName("Subrs")) return;
      var o = g.getByName("Subrs"),
        c = a + o;
      if (0 === o || c >= this.bytes.length) {
        this.emptyPrivateDictionary(e);
        return;
      }
      var C = this.parseIndex(c);
      g.subrsIndex = C.obj;
    }
  }, {
    key: "parseCharsets",
    value: function parseCharsets(e, t, i, a) {
      if (0 === e) return new CFFCharset(!0, Gi.ISO_ADOBE, Qi);
      if (1 === e) return new CFFCharset(!0, Gi.EXPERT, Ei);
      if (2 === e) return new CFFCharset(!0, Gi.EXPERT_SUBSET, ui);
      var s = this.bytes,
        r = e,
        n = s[e++],
        g = [a ? 0 : ".notdef"];
      var o, c, C;
      t -= 1;
      switch (n) {
        case 0:
          for (C = 0; C < t; C++) {
            o = s[e++] << 8 | s[e++];
            g.push(a ? o : i.get(o));
          }
          break;
        case 1:
          for (; g.length <= t;) {
            o = s[e++] << 8 | s[e++];
            c = s[e++];
            for (C = 0; C <= c; C++) g.push(a ? o++ : i.get(o++));
          }
          break;
        case 2:
          for (; g.length <= t;) {
            o = s[e++] << 8 | s[e++];
            c = s[e++] << 8 | s[e++];
            for (C = 0; C <= c; C++) g.push(a ? o++ : i.get(o++));
          }
          break;
        default:
          throw new FormatError("Unknown charset format");
      }
      var h = e,
        l = s.subarray(r, h);
      return new CFFCharset(!1, n, g, l);
    }
  }, {
    key: "parseEncoding",
    value: function parseEncoding(e, t, i, a) {
      var s = Object.create(null),
        r = this.bytes;
      var n,
        g,
        o,
        c = !1,
        C = null;
      if (0 === e || 1 === e) {
        c = !0;
        n = e;
        var _t113 = e ? di : mi;
        for (g = 0, o = a.length; g < o; g++) {
          var _e135 = _t113.indexOf(a[g]);
          -1 !== _e135 && (s[_e135] = g);
        }
      } else {
        var _t114 = e;
        n = r[e++];
        switch (127 & n) {
          case 0:
            var _t115 = r[e++];
            for (g = 1; g <= _t115; g++) s[r[e++]] = g;
            break;
          case 1:
            var _i97 = r[e++];
            var _a97 = 1;
            for (g = 0; g < _i97; g++) {
              var _t116 = r[e++],
                _i98 = r[e++];
              for (var _e136 = _t116; _e136 <= _t116 + _i98; _e136++) s[_e136] = _a97++;
            }
            break;
          default:
            throw new FormatError("Unknown encoding format: ".concat(n, " in CFF"));
        }
        var _o13 = e;
        if (128 & n) {
          r[_t114] &= 127;
          !function readSupplement() {
            var t = r[e++];
            for (g = 0; g < t; g++) {
              var _t117 = r[e++],
                _n34 = (r[e++] << 8) + (255 & r[e++]);
              s[_t117] = a.indexOf(i.get(_n34));
            }
          }();
        }
        C = r.subarray(_t114, _o13);
      }
      n &= 127;
      return new CFFEncoding(c, n, s, C);
    }
  }, {
    key: "parseFDSelect",
    value: function parseFDSelect(e, t) {
      var i = this.bytes,
        a = i[e++],
        s = [];
      var r;
      switch (a) {
        case 0:
          for (r = 0; r < t; ++r) {
            var _t118 = i[e++];
            s.push(_t118);
          }
          break;
        case 3:
          var _n35 = i[e++] << 8 | i[e++];
          for (r = 0; r < _n35; ++r) {
            var _t119 = i[e++] << 8 | i[e++];
            if (0 === r && 0 !== _t119) {
              warn("parseFDSelect: The first range must have a first GID of 0 -- trying to recover.");
              _t119 = 0;
            }
            var _a98 = i[e++],
              _n36 = i[e] << 8 | i[e + 1];
            for (var _e137 = _t119; _e137 < _n36; ++_e137) s.push(_a98);
          }
          e += 2;
          break;
        default:
          throw new FormatError("parseFDSelect: Unknown format \"".concat(a, "\"."));
      }
      if (s.length !== t) throw new FormatError("parseFDSelect: Invalid font data.");
      return new CFFFDSelect(a, s);
    }
  }]);
}();
var CFF = /*#__PURE__*/function () {
  function CFF() {
    _classCallCheck(this, CFF);
    this.header = null;
    this.names = [];
    this.topDict = null;
    this.strings = new CFFStrings();
    this.globalSubrIndex = null;
    this.encoding = null;
    this.charset = null;
    this.charStrings = null;
    this.fdArray = [];
    this.fdSelect = null;
    this.isCIDFont = !1;
  }
  return _createClass(CFF, [{
    key: "duplicateFirstGlyph",
    value: function duplicateFirstGlyph() {
      if (this.charStrings.count >= 65535) {
        warn("Not enough space in charstrings to duplicate first glyph.");
        return;
      }
      var e = this.charStrings.get(0);
      this.charStrings.add(e);
      this.isCIDFont && this.fdSelect.fdSelect.push(this.fdSelect.fdSelect[0]);
    }
  }, {
    key: "hasGlyphId",
    value: function hasGlyphId(e) {
      if (e < 0 || e >= this.charStrings.count) return !1;
      return this.charStrings.get(e).length > 0;
    }
  }]);
}();
var CFFHeader = /*#__PURE__*/_createClass(function CFFHeader(e, t, i, a) {
  _classCallCheck(this, CFFHeader);
  this.major = e;
  this.minor = t;
  this.hdrSize = i;
  this.offSize = a;
});
var CFFStrings = /*#__PURE__*/function () {
  function CFFStrings() {
    _classCallCheck(this, CFFStrings);
    this.strings = [];
  }
  return _createClass(CFFStrings, [{
    key: "get",
    value: function get(e) {
      return e >= 0 && e <= 390 ? bi[e] : e - Fi <= this.strings.length ? this.strings[e - Fi] : bi[0];
    }
  }, {
    key: "getSID",
    value: function getSID(e) {
      var t = bi.indexOf(e);
      if (-1 !== t) return t;
      t = this.strings.indexOf(e);
      return -1 !== t ? t + Fi : -1;
    }
  }, {
    key: "add",
    value: function add(e) {
      this.strings.push(e);
    }
  }, {
    key: "count",
    get: function get() {
      return this.strings.length;
    }
  }]);
}();
var CFFIndex = /*#__PURE__*/function () {
  function CFFIndex() {
    _classCallCheck(this, CFFIndex);
    this.objects = [];
    this.length = 0;
  }
  return _createClass(CFFIndex, [{
    key: "add",
    value: function add(e) {
      this.length += e.length;
      this.objects.push(e);
    }
  }, {
    key: "set",
    value: function set(e, t) {
      this.length += t.length - this.objects[e].length;
      this.objects[e] = t;
    }
  }, {
    key: "get",
    value: function get(e) {
      return this.objects[e];
    }
  }, {
    key: "count",
    get: function get() {
      return this.objects.length;
    }
  }]);
}();
var CFFDict = /*#__PURE__*/function () {
  function CFFDict(e, t) {
    _classCallCheck(this, CFFDict);
    this.keyToNameMap = e.keyToNameMap;
    this.nameToKeyMap = e.nameToKeyMap;
    this.defaults = e.defaults;
    this.types = e.types;
    this.opcodes = e.opcodes;
    this.order = e.order;
    this.strings = t;
    this.values = Object.create(null);
  }
  return _createClass(CFFDict, [{
    key: "setByKey",
    value: function setByKey(e, t) {
      if (!(e in this.keyToNameMap)) return !1;
      if (0 === t.length) return !0;
      var _iterator26 = _createForOfIteratorHelper(t),
        _step26;
      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var _i99 = _step26.value;
          if (isNaN(_i99)) {
            warn("Invalid CFFDict value: \"".concat(t, "\" for key \"").concat(e, "\"."));
            return !0;
          }
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
      var i = this.types[e];
      "num" !== i && "sid" !== i && "offset" !== i || (t = t[0]);
      this.values[e] = t;
      return !0;
    }
  }, {
    key: "setByName",
    value: function setByName(e, t) {
      if (!(e in this.nameToKeyMap)) throw new FormatError("Invalid dictionary name \"".concat(e, "\""));
      this.values[this.nameToKeyMap[e]] = t;
    }
  }, {
    key: "hasName",
    value: function hasName(e) {
      return this.nameToKeyMap[e] in this.values;
    }
  }, {
    key: "getByName",
    value: function getByName(e) {
      if (!(e in this.nameToKeyMap)) throw new FormatError("Invalid dictionary name ".concat(e, "\""));
      var t = this.nameToKeyMap[e];
      return t in this.values ? this.values[t] : this.defaults[t];
    }
  }, {
    key: "removeByName",
    value: function removeByName(e) {
      delete this.values[this.nameToKeyMap[e]];
    }
  }], [{
    key: "createTables",
    value: function createTables(e) {
      var t = {
        keyToNameMap: {},
        nameToKeyMap: {},
        defaults: {},
        types: {},
        opcodes: {},
        order: []
      };
      var _iterator27 = _createForOfIteratorHelper(e),
        _step27;
      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var _i100 = _step27.value;
          var _e138 = Array.isArray(_i100[0]) ? (_i100[0][0] << 8) + _i100[0][1] : _i100[0];
          t.keyToNameMap[_e138] = _i100[1];
          t.nameToKeyMap[_i100[1]] = _e138;
          t.types[_e138] = _i100[2];
          t.defaults[_e138] = _i100[3];
          t.opcodes[_e138] = Array.isArray(_i100[0]) ? _i100[0] : [_i100[0]];
          t.order.push(_e138);
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
      return t;
    }
  }]);
}();
var Ri = [[[12, 30], "ROS", ["sid", "sid", "num"], null], [[12, 20], "SyntheticBase", "num", null], [0, "version", "sid", null], [1, "Notice", "sid", null], [[12, 0], "Copyright", "sid", null], [2, "FullName", "sid", null], [3, "FamilyName", "sid", null], [4, "Weight", "sid", null], [[12, 1], "isFixedPitch", "num", 0], [[12, 2], "ItalicAngle", "num", 0], [[12, 3], "UnderlinePosition", "num", -100], [[12, 4], "UnderlineThickness", "num", 50], [[12, 5], "PaintType", "num", 0], [[12, 6], "CharstringType", "num", 2], [[12, 7], "FontMatrix", ["num", "num", "num", "num", "num", "num"], [.001, 0, 0, .001, 0, 0]], [13, "UniqueID", "num", null], [5, "FontBBox", ["num", "num", "num", "num"], [0, 0, 0, 0]], [[12, 8], "StrokeWidth", "num", 0], [14, "XUID", "array", null], [15, "charset", "offset", 0], [16, "Encoding", "offset", 0], [17, "CharStrings", "offset", 0], [18, "Private", ["offset", "offset"], null], [[12, 21], "PostScript", "sid", null], [[12, 22], "BaseFontName", "sid", null], [[12, 23], "BaseFontBlend", "delta", null], [[12, 31], "CIDFontVersion", "num", 0], [[12, 32], "CIDFontRevision", "num", 0], [[12, 33], "CIDFontType", "num", 0], [[12, 34], "CIDCount", "num", 8720], [[12, 35], "UIDBase", "num", null], [[12, 37], "FDSelect", "offset", null], [[12, 36], "FDArray", "offset", null], [[12, 38], "FontName", "sid", null]];
var CFFTopDict = /*#__PURE__*/function (_CFFDict) {
  function CFFTopDict(e) {
    var _this30;
    _classCallCheck(this, CFFTopDict);
    _this30 = _callSuper(this, CFFTopDict, [CFFTopDict.tables, e]);
    _this30.privateDict = null;
    return _this30;
  }
  _inherits(CFFTopDict, _CFFDict);
  return _createClass(CFFTopDict, null, [{
    key: "tables",
    get: function get() {
      return shadow(this, "tables", this.createTables(Ri));
    }
  }]);
}(CFFDict);
var Ni = [[6, "BlueValues", "delta", null], [7, "OtherBlues", "delta", null], [8, "FamilyBlues", "delta", null], [9, "FamilyOtherBlues", "delta", null], [[12, 9], "BlueScale", "num", .039625], [[12, 10], "BlueShift", "num", 7], [[12, 11], "BlueFuzz", "num", 1], [10, "StdHW", "num", null], [11, "StdVW", "num", null], [[12, 12], "StemSnapH", "delta", null], [[12, 13], "StemSnapV", "delta", null], [[12, 14], "ForceBold", "num", 0], [[12, 17], "LanguageGroup", "num", 0], [[12, 18], "ExpansionFactor", "num", .06], [[12, 19], "initialRandomSeed", "num", 0], [20, "defaultWidthX", "num", 0], [21, "nominalWidthX", "num", 0], [19, "Subrs", "offset", null]];
var CFFPrivateDict = /*#__PURE__*/function (_CFFDict2) {
  function CFFPrivateDict(e) {
    var _this31;
    _classCallCheck(this, CFFPrivateDict);
    _this31 = _callSuper(this, CFFPrivateDict, [CFFPrivateDict.tables, e]);
    _this31.subrsIndex = null;
    return _this31;
  }
  _inherits(CFFPrivateDict, _CFFDict2);
  return _createClass(CFFPrivateDict, null, [{
    key: "tables",
    get: function get() {
      return shadow(this, "tables", this.createTables(Ni));
    }
  }]);
}(CFFDict);
var Gi = {
  ISO_ADOBE: 0,
  EXPERT: 1,
  EXPERT_SUBSET: 2
};
var CFFCharset = /*#__PURE__*/_createClass(function CFFCharset(e, t, i, a) {
  _classCallCheck(this, CFFCharset);
  this.predefined = e;
  this.format = t;
  this.charset = i;
  this.raw = a;
});
var CFFEncoding = /*#__PURE__*/_createClass(function CFFEncoding(e, t, i, a) {
  _classCallCheck(this, CFFEncoding);
  this.predefined = e;
  this.format = t;
  this.encoding = i;
  this.raw = a;
});
var CFFFDSelect = /*#__PURE__*/function () {
  function CFFFDSelect(e, t) {
    _classCallCheck(this, CFFFDSelect);
    this.format = e;
    this.fdSelect = t;
  }
  return _createClass(CFFFDSelect, [{
    key: "getFDIndex",
    value: function getFDIndex(e) {
      return e < 0 || e >= this.fdSelect.length ? -1 : this.fdSelect[e];
    }
  }]);
}();
var CFFOffsetTracker = /*#__PURE__*/function () {
  function CFFOffsetTracker() {
    _classCallCheck(this, CFFOffsetTracker);
    this.offsets = Object.create(null);
  }
  return _createClass(CFFOffsetTracker, [{
    key: "isTracking",
    value: function isTracking(e) {
      return e in this.offsets;
    }
  }, {
    key: "track",
    value: function track(e, t) {
      if (e in this.offsets) throw new FormatError("Already tracking location of ".concat(e));
      this.offsets[e] = t;
    }
  }, {
    key: "offset",
    value: function offset(e) {
      for (var t in this.offsets) this.offsets[t] += e;
    }
  }, {
    key: "setEntryLocation",
    value: function setEntryLocation(e, t, i) {
      if (!(e in this.offsets)) throw new FormatError("Not tracking location of ".concat(e));
      var a = i.data,
        s = this.offsets[e];
      for (var _e139 = 0, _i101 = t.length; _e139 < _i101; ++_e139) {
        var _i102 = 5 * _e139 + s,
          _r46 = _i102 + 1,
          _n37 = _i102 + 2,
          _g19 = _i102 + 3,
          _o14 = _i102 + 4;
        if (29 !== a[_i102] || 0 !== a[_r46] || 0 !== a[_n37] || 0 !== a[_g19] || 0 !== a[_o14]) throw new FormatError("writing to an offset that is not empty");
        var _c10 = t[_e139];
        a[_i102] = 29;
        a[_r46] = _c10 >> 24 & 255;
        a[_n37] = _c10 >> 16 & 255;
        a[_g19] = _c10 >> 8 & 255;
        a[_o14] = 255 & _c10;
      }
    }
  }]);
}();
var CFFCompiler = /*#__PURE__*/function () {
  function CFFCompiler(e) {
    _classCallCheck(this, CFFCompiler);
    this.cff = e;
  }
  return _createClass(CFFCompiler, [{
    key: "compile",
    value: function compile() {
      var e = this.cff,
        t = {
          data: [],
          length: 0,
          add: function add(e) {
            try {
              var _this$data;
              (_this$data = this.data).push.apply(_this$data, _toConsumableArray(e));
            } catch (_unused5) {
              this.data = this.data.concat(e);
            }
            this.length = this.data.length;
          }
        },
        i = this.compileHeader(e.header);
      t.add(i);
      var a = this.compileNameIndex(e.names);
      t.add(a);
      if (e.isCIDFont && e.topDict.hasName("FontMatrix")) {
        var _t120 = e.topDict.getByName("FontMatrix");
        e.topDict.removeByName("FontMatrix");
        var _iterator28 = _createForOfIteratorHelper(e.fdArray),
          _step28;
        try {
          for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
            var _i103 = _step28.value;
            var _e140 = _t120.slice(0);
            _i103.hasName("FontMatrix") && (_e140 = Util.transform(_e140, _i103.getByName("FontMatrix")));
            _i103.setByName("FontMatrix", _e140);
          }
        } catch (err) {
          _iterator28.e(err);
        } finally {
          _iterator28.f();
        }
      }
      var s = e.topDict.getByName("XUID");
      (s === null || s === void 0 ? void 0 : s.length) > 16 && e.topDict.removeByName("XUID");
      e.topDict.setByName("charset", 0);
      var r = this.compileTopDicts([e.topDict], t.length, e.isCIDFont);
      t.add(r.output);
      var n = r.trackers[0],
        g = this.compileStringIndex(e.strings.strings);
      t.add(g);
      var o = this.compileIndex(e.globalSubrIndex);
      t.add(o);
      if (e.encoding && e.topDict.hasName("Encoding")) if (e.encoding.predefined) n.setEntryLocation("Encoding", [e.encoding.format], t);else {
        var _i104 = this.compileEncoding(e.encoding);
        n.setEntryLocation("Encoding", [t.length], t);
        t.add(_i104);
      }
      var c = this.compileCharset(e.charset, e.charStrings.count, e.strings, e.isCIDFont);
      n.setEntryLocation("charset", [t.length], t);
      t.add(c);
      var C = this.compileCharStrings(e.charStrings);
      n.setEntryLocation("CharStrings", [t.length], t);
      t.add(C);
      if (e.isCIDFont) {
        n.setEntryLocation("FDSelect", [t.length], t);
        var _i105 = this.compileFDSelect(e.fdSelect);
        t.add(_i105);
        r = this.compileTopDicts(e.fdArray, t.length, !0);
        n.setEntryLocation("FDArray", [t.length], t);
        t.add(r.output);
        var _a99 = r.trackers;
        this.compilePrivateDicts(e.fdArray, _a99, t);
      }
      this.compilePrivateDicts([e.topDict], [n], t);
      t.add([0]);
      return t.data;
    }
  }, {
    key: "encodeNumber",
    value: function encodeNumber(e) {
      return Number.isInteger(e) ? this.encodeInteger(e) : this.encodeFloat(e);
    }
  }, {
    key: "encodeFloat",
    value: function encodeFloat(e) {
      var t = e.toString();
      var i = CFFCompiler.EncodeFloatRegExp.exec(t);
      if (i) {
        var _a100 = parseFloat("1e" + ((i[2] ? +i[2] : 0) + i[1].length));
        t = (Math.round(e * _a100) / _a100).toString();
      }
      var a,
        s,
        r = "";
      for (a = 0, s = t.length; a < s; ++a) {
        var _e141 = t[a];
        r += "e" === _e141 ? "-" === t[++a] ? "c" : "b" : "." === _e141 ? "a" : "-" === _e141 ? "e" : _e141;
      }
      r += 1 & r.length ? "f" : "ff";
      var n = [30];
      for (a = 0, s = r.length; a < s; a += 2) n.push(parseInt(r.substring(a, a + 2), 16));
      return n;
    }
  }, {
    key: "encodeInteger",
    value: function encodeInteger(e) {
      var t;
      t = e >= -107 && e <= 107 ? [e + 139] : e >= 108 && e <= 1131 ? [247 + ((e -= 108) >> 8), 255 & e] : e >= -1131 && e <= -108 ? [251 + ((e = -e - 108) >> 8), 255 & e] : e >= -32768 && e <= 32767 ? [28, e >> 8 & 255, 255 & e] : [29, e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, 255 & e];
      return t;
    }
  }, {
    key: "compileHeader",
    value: function compileHeader(e) {
      return [e.major, e.minor, 4, e.offSize];
    }
  }, {
    key: "compileNameIndex",
    value: function compileNameIndex(e) {
      var t = new CFFIndex();
      var _iterator29 = _createForOfIteratorHelper(e),
        _step29;
      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var _i106 = _step29.value;
          var _e142 = Math.min(_i106.length, 127);
          var _a101 = new Array(_e142);
          for (var _t121 = 0; _t121 < _e142; _t121++) {
            var _e143 = _i106[_t121];
            (_e143 < "!" || _e143 > "~" || "[" === _e143 || "]" === _e143 || "(" === _e143 || ")" === _e143 || "{" === _e143 || "}" === _e143 || "<" === _e143 || ">" === _e143 || "/" === _e143 || "%" === _e143) && (_e143 = "_");
            _a101[_t121] = _e143;
          }
          _a101 = _a101.join("");
          "" === _a101 && (_a101 = "Bad_Font_Name");
          t.add(stringToBytes(_a101));
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
      return this.compileIndex(t);
    }
  }, {
    key: "compileTopDicts",
    value: function compileTopDicts(e, t, i) {
      var a = [];
      var s = new CFFIndex();
      var _iterator30 = _createForOfIteratorHelper(e),
        _step30;
      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var _r47 = _step30.value;
          if (i) {
            _r47.removeByName("CIDFontVersion");
            _r47.removeByName("CIDFontRevision");
            _r47.removeByName("CIDFontType");
            _r47.removeByName("CIDCount");
            _r47.removeByName("UIDBase");
          }
          var _e144 = new CFFOffsetTracker(),
            _n38 = this.compileDict(_r47, _e144);
          a.push(_e144);
          s.add(_n38);
          _e144.offset(t);
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
      s = this.compileIndex(s, a);
      return {
        trackers: a,
        output: s
      };
    }
  }, {
    key: "compilePrivateDicts",
    value: function compilePrivateDicts(e, t, i) {
      for (var _a102 = 0, _s68 = e.length; _a102 < _s68; ++_a102) {
        var _s69 = e[_a102],
          _r48 = _s69.privateDict;
        if (!_r48 || !_s69.hasName("Private")) throw new FormatError("There must be a private dictionary.");
        var _n39 = new CFFOffsetTracker(),
          _g20 = this.compileDict(_r48, _n39);
        var _o15 = i.length;
        _n39.offset(_o15);
        _g20.length || (_o15 = 0);
        t[_a102].setEntryLocation("Private", [_g20.length, _o15], i);
        i.add(_g20);
        if (_r48.subrsIndex && _r48.hasName("Subrs")) {
          var _e145 = this.compileIndex(_r48.subrsIndex);
          _n39.setEntryLocation("Subrs", [_g20.length], i);
          i.add(_e145);
        }
      }
    }
  }, {
    key: "compileDict",
    value: function compileDict(e, t) {
      var i = [];
      var _iterator31 = _createForOfIteratorHelper(e.order),
        _step31;
      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
          var _a103 = _step31.value;
          if (!(_a103 in e.values)) continue;
          var _s70 = e.values[_a103],
            _r49 = e.types[_a103];
          Array.isArray(_r49) || (_r49 = [_r49]);
          Array.isArray(_s70) || (_s70 = [_s70]);
          if (0 !== _s70.length) {
            for (var _n40 = 0, _g21 = _r49.length; _n40 < _g21; ++_n40) {
              var _g22 = _r49[_n40],
                _o16 = _s70[_n40];
              switch (_g22) {
                case "num":
                case "sid":
                  i.push.apply(i, _toConsumableArray(this.encodeNumber(_o16)));
                  break;
                case "offset":
                  var _r50 = e.keyToNameMap[_a103];
                  t.isTracking(_r50) || t.track(_r50, i.length);
                  i.push(29, 0, 0, 0, 0);
                  break;
                case "array":
                case "delta":
                  i.push.apply(i, _toConsumableArray(this.encodeNumber(_o16)));
                  for (var _e146 = 1, _t122 = _s70.length; _e146 < _t122; ++_e146) i.push.apply(i, _toConsumableArray(this.encodeNumber(_s70[_e146])));
                  break;
                default:
                  throw new FormatError("Unknown data type of ".concat(_g22));
              }
            }
            i.push.apply(i, _toConsumableArray(e.opcodes[_a103]));
          }
        }
      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }
      return i;
    }
  }, {
    key: "compileStringIndex",
    value: function compileStringIndex(e) {
      var t = new CFFIndex();
      var _iterator32 = _createForOfIteratorHelper(e),
        _step32;
      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var _i107 = _step32.value;
          t.add(stringToBytes(_i107));
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
      return this.compileIndex(t);
    }
  }, {
    key: "compileCharStrings",
    value: function compileCharStrings(e) {
      var t = new CFFIndex();
      for (var _i108 = 0; _i108 < e.count; _i108++) {
        var _a104 = e.get(_i108);
        0 !== _a104.length ? t.add(_a104) : t.add(new Uint8Array([139, 14]));
      }
      return this.compileIndex(t);
    }
  }, {
    key: "compileCharset",
    value: function compileCharset(e, t, i, a) {
      var s;
      var r = t - 1;
      if (a) s = new Uint8Array([2, 0, 0, r >> 8 & 255, 255 & r]);else {
        s = new Uint8Array(1 + 2 * r);
        s[0] = 0;
        var _t123 = 0;
        var _a105 = e.charset.length;
        var _n41 = !1;
        for (var _r51 = 1; _r51 < s.length; _r51 += 2) {
          var _g23 = 0;
          if (_t123 < _a105) {
            var _a106 = e.charset[_t123++];
            _g23 = i.getSID(_a106);
            if (-1 === _g23) {
              _g23 = 0;
              if (!_n41) {
                _n41 = !0;
                warn("Couldn't find ".concat(_a106, " in CFF strings"));
              }
            }
          }
          s[_r51] = _g23 >> 8 & 255;
          s[_r51 + 1] = 255 & _g23;
        }
      }
      return this.compileTypedArray(s);
    }
  }, {
    key: "compileEncoding",
    value: function compileEncoding(e) {
      return this.compileTypedArray(e.raw);
    }
  }, {
    key: "compileFDSelect",
    value: function compileFDSelect(e) {
      var t = e.format;
      var i, a;
      switch (t) {
        case 0:
          i = new Uint8Array(1 + e.fdSelect.length);
          i[0] = t;
          for (a = 0; a < e.fdSelect.length; a++) i[a + 1] = e.fdSelect[a];
          break;
        case 3:
          var _s71 = 0;
          var _r52 = e.fdSelect[0];
          var _n42 = [t, 0, 0, _s71 >> 8 & 255, 255 & _s71, _r52];
          for (a = 1; a < e.fdSelect.length; a++) {
            var _t124 = e.fdSelect[a];
            if (_t124 !== _r52) {
              _n42.push(a >> 8 & 255, 255 & a, _t124);
              _r52 = _t124;
            }
          }
          var _g24 = (_n42.length - 3) / 3;
          _n42[1] = _g24 >> 8 & 255;
          _n42[2] = 255 & _g24;
          _n42.push(a >> 8 & 255, 255 & a);
          i = new Uint8Array(_n42);
      }
      return this.compileTypedArray(i);
    }
  }, {
    key: "compileTypedArray",
    value: function compileTypedArray(e) {
      return Array.from(e);
    }
  }, {
    key: "compileIndex",
    value: function compileIndex(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var i = e.objects,
        a = i.length;
      if (0 === a) return [0, 0];
      var s = [a >> 8 & 255, 255 & a];
      var r,
        n,
        g = 1;
      for (r = 0; r < a; ++r) g += i[r].length;
      n = g < 256 ? 1 : g < 65536 ? 2 : g < 16777216 ? 3 : 4;
      s.push(n);
      var o = 1;
      for (r = 0; r < a + 1; r++) {
        1 === n ? s.push(255 & o) : 2 === n ? s.push(o >> 8 & 255, 255 & o) : 3 === n ? s.push(o >> 16 & 255, o >> 8 & 255, 255 & o) : s.push(o >>> 24 & 255, o >> 16 & 255, o >> 8 & 255, 255 & o);
        i[r] && (o += i[r].length);
      }
      for (r = 0; r < a; r++) {
        t[r] && t[r].offset(s.length);
        s.push.apply(s, _toConsumableArray(i[r]));
      }
      return s;
    }
  }], [{
    key: "EncodeFloatRegExp",
    get: function get() {
      return shadow(this, "EncodeFloatRegExp", /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/);
    }
  }]);
}();
var xi = getLookupTableFactory(function (e) {
    e.A = 65;
    e.AE = 198;
    e.AEacute = 508;
    e.AEmacron = 482;
    e.AEsmall = 63462;
    e.Aacute = 193;
    e.Aacutesmall = 63457;
    e.Abreve = 258;
    e.Abreveacute = 7854;
    e.Abrevecyrillic = 1232;
    e.Abrevedotbelow = 7862;
    e.Abrevegrave = 7856;
    e.Abrevehookabove = 7858;
    e.Abrevetilde = 7860;
    e.Acaron = 461;
    e.Acircle = 9398;
    e.Acircumflex = 194;
    e.Acircumflexacute = 7844;
    e.Acircumflexdotbelow = 7852;
    e.Acircumflexgrave = 7846;
    e.Acircumflexhookabove = 7848;
    e.Acircumflexsmall = 63458;
    e.Acircumflextilde = 7850;
    e.Acute = 63177;
    e.Acutesmall = 63412;
    e.Acyrillic = 1040;
    e.Adblgrave = 512;
    e.Adieresis = 196;
    e.Adieresiscyrillic = 1234;
    e.Adieresismacron = 478;
    e.Adieresissmall = 63460;
    e.Adotbelow = 7840;
    e.Adotmacron = 480;
    e.Agrave = 192;
    e.Agravesmall = 63456;
    e.Ahookabove = 7842;
    e.Aiecyrillic = 1236;
    e.Ainvertedbreve = 514;
    e.Alpha = 913;
    e.Alphatonos = 902;
    e.Amacron = 256;
    e.Amonospace = 65313;
    e.Aogonek = 260;
    e.Aring = 197;
    e.Aringacute = 506;
    e.Aringbelow = 7680;
    e.Aringsmall = 63461;
    e.Asmall = 63329;
    e.Atilde = 195;
    e.Atildesmall = 63459;
    e.Aybarmenian = 1329;
    e.B = 66;
    e.Bcircle = 9399;
    e.Bdotaccent = 7682;
    e.Bdotbelow = 7684;
    e.Becyrillic = 1041;
    e.Benarmenian = 1330;
    e.Beta = 914;
    e.Bhook = 385;
    e.Blinebelow = 7686;
    e.Bmonospace = 65314;
    e.Brevesmall = 63220;
    e.Bsmall = 63330;
    e.Btopbar = 386;
    e.C = 67;
    e.Caarmenian = 1342;
    e.Cacute = 262;
    e.Caron = 63178;
    e.Caronsmall = 63221;
    e.Ccaron = 268;
    e.Ccedilla = 199;
    e.Ccedillaacute = 7688;
    e.Ccedillasmall = 63463;
    e.Ccircle = 9400;
    e.Ccircumflex = 264;
    e.Cdot = 266;
    e.Cdotaccent = 266;
    e.Cedillasmall = 63416;
    e.Chaarmenian = 1353;
    e.Cheabkhasiancyrillic = 1212;
    e.Checyrillic = 1063;
    e.Chedescenderabkhasiancyrillic = 1214;
    e.Chedescendercyrillic = 1206;
    e.Chedieresiscyrillic = 1268;
    e.Cheharmenian = 1347;
    e.Chekhakassiancyrillic = 1227;
    e.Cheverticalstrokecyrillic = 1208;
    e.Chi = 935;
    e.Chook = 391;
    e.Circumflexsmall = 63222;
    e.Cmonospace = 65315;
    e.Coarmenian = 1361;
    e.Csmall = 63331;
    e.D = 68;
    e.DZ = 497;
    e.DZcaron = 452;
    e.Daarmenian = 1332;
    e.Dafrican = 393;
    e.Dcaron = 270;
    e.Dcedilla = 7696;
    e.Dcircle = 9401;
    e.Dcircumflexbelow = 7698;
    e.Dcroat = 272;
    e.Ddotaccent = 7690;
    e.Ddotbelow = 7692;
    e.Decyrillic = 1044;
    e.Deicoptic = 1006;
    e.Delta = 8710;
    e.Deltagreek = 916;
    e.Dhook = 394;
    e.Dieresis = 63179;
    e.DieresisAcute = 63180;
    e.DieresisGrave = 63181;
    e.Dieresissmall = 63400;
    e.Digammagreek = 988;
    e.Djecyrillic = 1026;
    e.Dlinebelow = 7694;
    e.Dmonospace = 65316;
    e.Dotaccentsmall = 63223;
    e.Dslash = 272;
    e.Dsmall = 63332;
    e.Dtopbar = 395;
    e.Dz = 498;
    e.Dzcaron = 453;
    e.Dzeabkhasiancyrillic = 1248;
    e.Dzecyrillic = 1029;
    e.Dzhecyrillic = 1039;
    e.E = 69;
    e.Eacute = 201;
    e.Eacutesmall = 63465;
    e.Ebreve = 276;
    e.Ecaron = 282;
    e.Ecedillabreve = 7708;
    e.Echarmenian = 1333;
    e.Ecircle = 9402;
    e.Ecircumflex = 202;
    e.Ecircumflexacute = 7870;
    e.Ecircumflexbelow = 7704;
    e.Ecircumflexdotbelow = 7878;
    e.Ecircumflexgrave = 7872;
    e.Ecircumflexhookabove = 7874;
    e.Ecircumflexsmall = 63466;
    e.Ecircumflextilde = 7876;
    e.Ecyrillic = 1028;
    e.Edblgrave = 516;
    e.Edieresis = 203;
    e.Edieresissmall = 63467;
    e.Edot = 278;
    e.Edotaccent = 278;
    e.Edotbelow = 7864;
    e.Efcyrillic = 1060;
    e.Egrave = 200;
    e.Egravesmall = 63464;
    e.Eharmenian = 1335;
    e.Ehookabove = 7866;
    e.Eightroman = 8551;
    e.Einvertedbreve = 518;
    e.Eiotifiedcyrillic = 1124;
    e.Elcyrillic = 1051;
    e.Elevenroman = 8554;
    e.Emacron = 274;
    e.Emacronacute = 7702;
    e.Emacrongrave = 7700;
    e.Emcyrillic = 1052;
    e.Emonospace = 65317;
    e.Encyrillic = 1053;
    e.Endescendercyrillic = 1186;
    e.Eng = 330;
    e.Enghecyrillic = 1188;
    e.Enhookcyrillic = 1223;
    e.Eogonek = 280;
    e.Eopen = 400;
    e.Epsilon = 917;
    e.Epsilontonos = 904;
    e.Ercyrillic = 1056;
    e.Ereversed = 398;
    e.Ereversedcyrillic = 1069;
    e.Escyrillic = 1057;
    e.Esdescendercyrillic = 1194;
    e.Esh = 425;
    e.Esmall = 63333;
    e.Eta = 919;
    e.Etarmenian = 1336;
    e.Etatonos = 905;
    e.Eth = 208;
    e.Ethsmall = 63472;
    e.Etilde = 7868;
    e.Etildebelow = 7706;
    e.Euro = 8364;
    e.Ezh = 439;
    e.Ezhcaron = 494;
    e.Ezhreversed = 440;
    e.F = 70;
    e.Fcircle = 9403;
    e.Fdotaccent = 7710;
    e.Feharmenian = 1366;
    e.Feicoptic = 996;
    e.Fhook = 401;
    e.Fitacyrillic = 1138;
    e.Fiveroman = 8548;
    e.Fmonospace = 65318;
    e.Fourroman = 8547;
    e.Fsmall = 63334;
    e.G = 71;
    e.GBsquare = 13191;
    e.Gacute = 500;
    e.Gamma = 915;
    e.Gammaafrican = 404;
    e.Gangiacoptic = 1002;
    e.Gbreve = 286;
    e.Gcaron = 486;
    e.Gcedilla = 290;
    e.Gcircle = 9404;
    e.Gcircumflex = 284;
    e.Gcommaaccent = 290;
    e.Gdot = 288;
    e.Gdotaccent = 288;
    e.Gecyrillic = 1043;
    e.Ghadarmenian = 1346;
    e.Ghemiddlehookcyrillic = 1172;
    e.Ghestrokecyrillic = 1170;
    e.Gheupturncyrillic = 1168;
    e.Ghook = 403;
    e.Gimarmenian = 1331;
    e.Gjecyrillic = 1027;
    e.Gmacron = 7712;
    e.Gmonospace = 65319;
    e.Grave = 63182;
    e.Gravesmall = 63328;
    e.Gsmall = 63335;
    e.Gsmallhook = 667;
    e.Gstroke = 484;
    e.H = 72;
    e.H18533 = 9679;
    e.H18543 = 9642;
    e.H18551 = 9643;
    e.H22073 = 9633;
    e.HPsquare = 13259;
    e.Haabkhasiancyrillic = 1192;
    e.Hadescendercyrillic = 1202;
    e.Hardsigncyrillic = 1066;
    e.Hbar = 294;
    e.Hbrevebelow = 7722;
    e.Hcedilla = 7720;
    e.Hcircle = 9405;
    e.Hcircumflex = 292;
    e.Hdieresis = 7718;
    e.Hdotaccent = 7714;
    e.Hdotbelow = 7716;
    e.Hmonospace = 65320;
    e.Hoarmenian = 1344;
    e.Horicoptic = 1e3;
    e.Hsmall = 63336;
    e.Hungarumlaut = 63183;
    e.Hungarumlautsmall = 63224;
    e.Hzsquare = 13200;
    e.I = 73;
    e.IAcyrillic = 1071;
    e.IJ = 306;
    e.IUcyrillic = 1070;
    e.Iacute = 205;
    e.Iacutesmall = 63469;
    e.Ibreve = 300;
    e.Icaron = 463;
    e.Icircle = 9406;
    e.Icircumflex = 206;
    e.Icircumflexsmall = 63470;
    e.Icyrillic = 1030;
    e.Idblgrave = 520;
    e.Idieresis = 207;
    e.Idieresisacute = 7726;
    e.Idieresiscyrillic = 1252;
    e.Idieresissmall = 63471;
    e.Idot = 304;
    e.Idotaccent = 304;
    e.Idotbelow = 7882;
    e.Iebrevecyrillic = 1238;
    e.Iecyrillic = 1045;
    e.Ifraktur = 8465;
    e.Igrave = 204;
    e.Igravesmall = 63468;
    e.Ihookabove = 7880;
    e.Iicyrillic = 1048;
    e.Iinvertedbreve = 522;
    e.Iishortcyrillic = 1049;
    e.Imacron = 298;
    e.Imacroncyrillic = 1250;
    e.Imonospace = 65321;
    e.Iniarmenian = 1339;
    e.Iocyrillic = 1025;
    e.Iogonek = 302;
    e.Iota = 921;
    e.Iotaafrican = 406;
    e.Iotadieresis = 938;
    e.Iotatonos = 906;
    e.Ismall = 63337;
    e.Istroke = 407;
    e.Itilde = 296;
    e.Itildebelow = 7724;
    e.Izhitsacyrillic = 1140;
    e.Izhitsadblgravecyrillic = 1142;
    e.J = 74;
    e.Jaarmenian = 1345;
    e.Jcircle = 9407;
    e.Jcircumflex = 308;
    e.Jecyrillic = 1032;
    e.Jheharmenian = 1355;
    e.Jmonospace = 65322;
    e.Jsmall = 63338;
    e.K = 75;
    e.KBsquare = 13189;
    e.KKsquare = 13261;
    e.Kabashkircyrillic = 1184;
    e.Kacute = 7728;
    e.Kacyrillic = 1050;
    e.Kadescendercyrillic = 1178;
    e.Kahookcyrillic = 1219;
    e.Kappa = 922;
    e.Kastrokecyrillic = 1182;
    e.Kaverticalstrokecyrillic = 1180;
    e.Kcaron = 488;
    e.Kcedilla = 310;
    e.Kcircle = 9408;
    e.Kcommaaccent = 310;
    e.Kdotbelow = 7730;
    e.Keharmenian = 1364;
    e.Kenarmenian = 1343;
    e.Khacyrillic = 1061;
    e.Kheicoptic = 998;
    e.Khook = 408;
    e.Kjecyrillic = 1036;
    e.Klinebelow = 7732;
    e.Kmonospace = 65323;
    e.Koppacyrillic = 1152;
    e.Koppagreek = 990;
    e.Ksicyrillic = 1134;
    e.Ksmall = 63339;
    e.L = 76;
    e.LJ = 455;
    e.LL = 63167;
    e.Lacute = 313;
    e.Lambda = 923;
    e.Lcaron = 317;
    e.Lcedilla = 315;
    e.Lcircle = 9409;
    e.Lcircumflexbelow = 7740;
    e.Lcommaaccent = 315;
    e.Ldot = 319;
    e.Ldotaccent = 319;
    e.Ldotbelow = 7734;
    e.Ldotbelowmacron = 7736;
    e.Liwnarmenian = 1340;
    e.Lj = 456;
    e.Ljecyrillic = 1033;
    e.Llinebelow = 7738;
    e.Lmonospace = 65324;
    e.Lslash = 321;
    e.Lslashsmall = 63225;
    e.Lsmall = 63340;
    e.M = 77;
    e.MBsquare = 13190;
    e.Macron = 63184;
    e.Macronsmall = 63407;
    e.Macute = 7742;
    e.Mcircle = 9410;
    e.Mdotaccent = 7744;
    e.Mdotbelow = 7746;
    e.Menarmenian = 1348;
    e.Mmonospace = 65325;
    e.Msmall = 63341;
    e.Mturned = 412;
    e.Mu = 924;
    e.N = 78;
    e.NJ = 458;
    e.Nacute = 323;
    e.Ncaron = 327;
    e.Ncedilla = 325;
    e.Ncircle = 9411;
    e.Ncircumflexbelow = 7754;
    e.Ncommaaccent = 325;
    e.Ndotaccent = 7748;
    e.Ndotbelow = 7750;
    e.Nhookleft = 413;
    e.Nineroman = 8552;
    e.Nj = 459;
    e.Njecyrillic = 1034;
    e.Nlinebelow = 7752;
    e.Nmonospace = 65326;
    e.Nowarmenian = 1350;
    e.Nsmall = 63342;
    e.Ntilde = 209;
    e.Ntildesmall = 63473;
    e.Nu = 925;
    e.O = 79;
    e.OE = 338;
    e.OEsmall = 63226;
    e.Oacute = 211;
    e.Oacutesmall = 63475;
    e.Obarredcyrillic = 1256;
    e.Obarreddieresiscyrillic = 1258;
    e.Obreve = 334;
    e.Ocaron = 465;
    e.Ocenteredtilde = 415;
    e.Ocircle = 9412;
    e.Ocircumflex = 212;
    e.Ocircumflexacute = 7888;
    e.Ocircumflexdotbelow = 7896;
    e.Ocircumflexgrave = 7890;
    e.Ocircumflexhookabove = 7892;
    e.Ocircumflexsmall = 63476;
    e.Ocircumflextilde = 7894;
    e.Ocyrillic = 1054;
    e.Odblacute = 336;
    e.Odblgrave = 524;
    e.Odieresis = 214;
    e.Odieresiscyrillic = 1254;
    e.Odieresissmall = 63478;
    e.Odotbelow = 7884;
    e.Ogoneksmall = 63227;
    e.Ograve = 210;
    e.Ogravesmall = 63474;
    e.Oharmenian = 1365;
    e.Ohm = 8486;
    e.Ohookabove = 7886;
    e.Ohorn = 416;
    e.Ohornacute = 7898;
    e.Ohorndotbelow = 7906;
    e.Ohorngrave = 7900;
    e.Ohornhookabove = 7902;
    e.Ohorntilde = 7904;
    e.Ohungarumlaut = 336;
    e.Oi = 418;
    e.Oinvertedbreve = 526;
    e.Omacron = 332;
    e.Omacronacute = 7762;
    e.Omacrongrave = 7760;
    e.Omega = 8486;
    e.Omegacyrillic = 1120;
    e.Omegagreek = 937;
    e.Omegaroundcyrillic = 1146;
    e.Omegatitlocyrillic = 1148;
    e.Omegatonos = 911;
    e.Omicron = 927;
    e.Omicrontonos = 908;
    e.Omonospace = 65327;
    e.Oneroman = 8544;
    e.Oogonek = 490;
    e.Oogonekmacron = 492;
    e.Oopen = 390;
    e.Oslash = 216;
    e.Oslashacute = 510;
    e.Oslashsmall = 63480;
    e.Osmall = 63343;
    e.Ostrokeacute = 510;
    e.Otcyrillic = 1150;
    e.Otilde = 213;
    e.Otildeacute = 7756;
    e.Otildedieresis = 7758;
    e.Otildesmall = 63477;
    e.P = 80;
    e.Pacute = 7764;
    e.Pcircle = 9413;
    e.Pdotaccent = 7766;
    e.Pecyrillic = 1055;
    e.Peharmenian = 1354;
    e.Pemiddlehookcyrillic = 1190;
    e.Phi = 934;
    e.Phook = 420;
    e.Pi = 928;
    e.Piwrarmenian = 1363;
    e.Pmonospace = 65328;
    e.Psi = 936;
    e.Psicyrillic = 1136;
    e.Psmall = 63344;
    e.Q = 81;
    e.Qcircle = 9414;
    e.Qmonospace = 65329;
    e.Qsmall = 63345;
    e.R = 82;
    e.Raarmenian = 1356;
    e.Racute = 340;
    e.Rcaron = 344;
    e.Rcedilla = 342;
    e.Rcircle = 9415;
    e.Rcommaaccent = 342;
    e.Rdblgrave = 528;
    e.Rdotaccent = 7768;
    e.Rdotbelow = 7770;
    e.Rdotbelowmacron = 7772;
    e.Reharmenian = 1360;
    e.Rfraktur = 8476;
    e.Rho = 929;
    e.Ringsmall = 63228;
    e.Rinvertedbreve = 530;
    e.Rlinebelow = 7774;
    e.Rmonospace = 65330;
    e.Rsmall = 63346;
    e.Rsmallinverted = 641;
    e.Rsmallinvertedsuperior = 694;
    e.S = 83;
    e.SF010000 = 9484;
    e.SF020000 = 9492;
    e.SF030000 = 9488;
    e.SF040000 = 9496;
    e.SF050000 = 9532;
    e.SF060000 = 9516;
    e.SF070000 = 9524;
    e.SF080000 = 9500;
    e.SF090000 = 9508;
    e.SF100000 = 9472;
    e.SF110000 = 9474;
    e.SF190000 = 9569;
    e.SF200000 = 9570;
    e.SF210000 = 9558;
    e.SF220000 = 9557;
    e.SF230000 = 9571;
    e.SF240000 = 9553;
    e.SF250000 = 9559;
    e.SF260000 = 9565;
    e.SF270000 = 9564;
    e.SF280000 = 9563;
    e.SF360000 = 9566;
    e.SF370000 = 9567;
    e.SF380000 = 9562;
    e.SF390000 = 9556;
    e.SF400000 = 9577;
    e.SF410000 = 9574;
    e.SF420000 = 9568;
    e.SF430000 = 9552;
    e.SF440000 = 9580;
    e.SF450000 = 9575;
    e.SF460000 = 9576;
    e.SF470000 = 9572;
    e.SF480000 = 9573;
    e.SF490000 = 9561;
    e.SF500000 = 9560;
    e.SF510000 = 9554;
    e.SF520000 = 9555;
    e.SF530000 = 9579;
    e.SF540000 = 9578;
    e.Sacute = 346;
    e.Sacutedotaccent = 7780;
    e.Sampigreek = 992;
    e.Scaron = 352;
    e.Scarondotaccent = 7782;
    e.Scaronsmall = 63229;
    e.Scedilla = 350;
    e.Schwa = 399;
    e.Schwacyrillic = 1240;
    e.Schwadieresiscyrillic = 1242;
    e.Scircle = 9416;
    e.Scircumflex = 348;
    e.Scommaaccent = 536;
    e.Sdotaccent = 7776;
    e.Sdotbelow = 7778;
    e.Sdotbelowdotaccent = 7784;
    e.Seharmenian = 1357;
    e.Sevenroman = 8550;
    e.Shaarmenian = 1351;
    e.Shacyrillic = 1064;
    e.Shchacyrillic = 1065;
    e.Sheicoptic = 994;
    e.Shhacyrillic = 1210;
    e.Shimacoptic = 1004;
    e.Sigma = 931;
    e.Sixroman = 8549;
    e.Smonospace = 65331;
    e.Softsigncyrillic = 1068;
    e.Ssmall = 63347;
    e.Stigmagreek = 986;
    e.T = 84;
    e.Tau = 932;
    e.Tbar = 358;
    e.Tcaron = 356;
    e.Tcedilla = 354;
    e.Tcircle = 9417;
    e.Tcircumflexbelow = 7792;
    e.Tcommaaccent = 354;
    e.Tdotaccent = 7786;
    e.Tdotbelow = 7788;
    e.Tecyrillic = 1058;
    e.Tedescendercyrillic = 1196;
    e.Tenroman = 8553;
    e.Tetsecyrillic = 1204;
    e.Theta = 920;
    e.Thook = 428;
    e.Thorn = 222;
    e.Thornsmall = 63486;
    e.Threeroman = 8546;
    e.Tildesmall = 63230;
    e.Tiwnarmenian = 1359;
    e.Tlinebelow = 7790;
    e.Tmonospace = 65332;
    e.Toarmenian = 1337;
    e.Tonefive = 444;
    e.Tonesix = 388;
    e.Tonetwo = 423;
    e.Tretroflexhook = 430;
    e.Tsecyrillic = 1062;
    e.Tshecyrillic = 1035;
    e.Tsmall = 63348;
    e.Twelveroman = 8555;
    e.Tworoman = 8545;
    e.U = 85;
    e.Uacute = 218;
    e.Uacutesmall = 63482;
    e.Ubreve = 364;
    e.Ucaron = 467;
    e.Ucircle = 9418;
    e.Ucircumflex = 219;
    e.Ucircumflexbelow = 7798;
    e.Ucircumflexsmall = 63483;
    e.Ucyrillic = 1059;
    e.Udblacute = 368;
    e.Udblgrave = 532;
    e.Udieresis = 220;
    e.Udieresisacute = 471;
    e.Udieresisbelow = 7794;
    e.Udieresiscaron = 473;
    e.Udieresiscyrillic = 1264;
    e.Udieresisgrave = 475;
    e.Udieresismacron = 469;
    e.Udieresissmall = 63484;
    e.Udotbelow = 7908;
    e.Ugrave = 217;
    e.Ugravesmall = 63481;
    e.Uhookabove = 7910;
    e.Uhorn = 431;
    e.Uhornacute = 7912;
    e.Uhorndotbelow = 7920;
    e.Uhorngrave = 7914;
    e.Uhornhookabove = 7916;
    e.Uhorntilde = 7918;
    e.Uhungarumlaut = 368;
    e.Uhungarumlautcyrillic = 1266;
    e.Uinvertedbreve = 534;
    e.Ukcyrillic = 1144;
    e.Umacron = 362;
    e.Umacroncyrillic = 1262;
    e.Umacrondieresis = 7802;
    e.Umonospace = 65333;
    e.Uogonek = 370;
    e.Upsilon = 933;
    e.Upsilon1 = 978;
    e.Upsilonacutehooksymbolgreek = 979;
    e.Upsilonafrican = 433;
    e.Upsilondieresis = 939;
    e.Upsilondieresishooksymbolgreek = 980;
    e.Upsilonhooksymbol = 978;
    e.Upsilontonos = 910;
    e.Uring = 366;
    e.Ushortcyrillic = 1038;
    e.Usmall = 63349;
    e.Ustraightcyrillic = 1198;
    e.Ustraightstrokecyrillic = 1200;
    e.Utilde = 360;
    e.Utildeacute = 7800;
    e.Utildebelow = 7796;
    e.V = 86;
    e.Vcircle = 9419;
    e.Vdotbelow = 7806;
    e.Vecyrillic = 1042;
    e.Vewarmenian = 1358;
    e.Vhook = 434;
    e.Vmonospace = 65334;
    e.Voarmenian = 1352;
    e.Vsmall = 63350;
    e.Vtilde = 7804;
    e.W = 87;
    e.Wacute = 7810;
    e.Wcircle = 9420;
    e.Wcircumflex = 372;
    e.Wdieresis = 7812;
    e.Wdotaccent = 7814;
    e.Wdotbelow = 7816;
    e.Wgrave = 7808;
    e.Wmonospace = 65335;
    e.Wsmall = 63351;
    e.X = 88;
    e.Xcircle = 9421;
    e.Xdieresis = 7820;
    e.Xdotaccent = 7818;
    e.Xeharmenian = 1341;
    e.Xi = 926;
    e.Xmonospace = 65336;
    e.Xsmall = 63352;
    e.Y = 89;
    e.Yacute = 221;
    e.Yacutesmall = 63485;
    e.Yatcyrillic = 1122;
    e.Ycircle = 9422;
    e.Ycircumflex = 374;
    e.Ydieresis = 376;
    e.Ydieresissmall = 63487;
    e.Ydotaccent = 7822;
    e.Ydotbelow = 7924;
    e.Yericyrillic = 1067;
    e.Yerudieresiscyrillic = 1272;
    e.Ygrave = 7922;
    e.Yhook = 435;
    e.Yhookabove = 7926;
    e.Yiarmenian = 1349;
    e.Yicyrillic = 1031;
    e.Yiwnarmenian = 1362;
    e.Ymonospace = 65337;
    e.Ysmall = 63353;
    e.Ytilde = 7928;
    e.Yusbigcyrillic = 1130;
    e.Yusbigiotifiedcyrillic = 1132;
    e.Yuslittlecyrillic = 1126;
    e.Yuslittleiotifiedcyrillic = 1128;
    e.Z = 90;
    e.Zaarmenian = 1334;
    e.Zacute = 377;
    e.Zcaron = 381;
    e.Zcaronsmall = 63231;
    e.Zcircle = 9423;
    e.Zcircumflex = 7824;
    e.Zdot = 379;
    e.Zdotaccent = 379;
    e.Zdotbelow = 7826;
    e.Zecyrillic = 1047;
    e.Zedescendercyrillic = 1176;
    e.Zedieresiscyrillic = 1246;
    e.Zeta = 918;
    e.Zhearmenian = 1338;
    e.Zhebrevecyrillic = 1217;
    e.Zhecyrillic = 1046;
    e.Zhedescendercyrillic = 1174;
    e.Zhedieresiscyrillic = 1244;
    e.Zlinebelow = 7828;
    e.Zmonospace = 65338;
    e.Zsmall = 63354;
    e.Zstroke = 437;
    e.a = 97;
    e.aabengali = 2438;
    e.aacute = 225;
    e.aadeva = 2310;
    e.aagujarati = 2694;
    e.aagurmukhi = 2566;
    e.aamatragurmukhi = 2622;
    e.aarusquare = 13059;
    e.aavowelsignbengali = 2494;
    e.aavowelsigndeva = 2366;
    e.aavowelsigngujarati = 2750;
    e.abbreviationmarkarmenian = 1375;
    e.abbreviationsigndeva = 2416;
    e.abengali = 2437;
    e.abopomofo = 12570;
    e.abreve = 259;
    e.abreveacute = 7855;
    e.abrevecyrillic = 1233;
    e.abrevedotbelow = 7863;
    e.abrevegrave = 7857;
    e.abrevehookabove = 7859;
    e.abrevetilde = 7861;
    e.acaron = 462;
    e.acircle = 9424;
    e.acircumflex = 226;
    e.acircumflexacute = 7845;
    e.acircumflexdotbelow = 7853;
    e.acircumflexgrave = 7847;
    e.acircumflexhookabove = 7849;
    e.acircumflextilde = 7851;
    e.acute = 180;
    e.acutebelowcmb = 791;
    e.acutecmb = 769;
    e.acutecomb = 769;
    e.acutedeva = 2388;
    e.acutelowmod = 719;
    e.acutetonecmb = 833;
    e.acyrillic = 1072;
    e.adblgrave = 513;
    e.addakgurmukhi = 2673;
    e.adeva = 2309;
    e.adieresis = 228;
    e.adieresiscyrillic = 1235;
    e.adieresismacron = 479;
    e.adotbelow = 7841;
    e.adotmacron = 481;
    e.ae = 230;
    e.aeacute = 509;
    e.aekorean = 12624;
    e.aemacron = 483;
    e.afii00208 = 8213;
    e.afii08941 = 8356;
    e.afii10017 = 1040;
    e.afii10018 = 1041;
    e.afii10019 = 1042;
    e.afii10020 = 1043;
    e.afii10021 = 1044;
    e.afii10022 = 1045;
    e.afii10023 = 1025;
    e.afii10024 = 1046;
    e.afii10025 = 1047;
    e.afii10026 = 1048;
    e.afii10027 = 1049;
    e.afii10028 = 1050;
    e.afii10029 = 1051;
    e.afii10030 = 1052;
    e.afii10031 = 1053;
    e.afii10032 = 1054;
    e.afii10033 = 1055;
    e.afii10034 = 1056;
    e.afii10035 = 1057;
    e.afii10036 = 1058;
    e.afii10037 = 1059;
    e.afii10038 = 1060;
    e.afii10039 = 1061;
    e.afii10040 = 1062;
    e.afii10041 = 1063;
    e.afii10042 = 1064;
    e.afii10043 = 1065;
    e.afii10044 = 1066;
    e.afii10045 = 1067;
    e.afii10046 = 1068;
    e.afii10047 = 1069;
    e.afii10048 = 1070;
    e.afii10049 = 1071;
    e.afii10050 = 1168;
    e.afii10051 = 1026;
    e.afii10052 = 1027;
    e.afii10053 = 1028;
    e.afii10054 = 1029;
    e.afii10055 = 1030;
    e.afii10056 = 1031;
    e.afii10057 = 1032;
    e.afii10058 = 1033;
    e.afii10059 = 1034;
    e.afii10060 = 1035;
    e.afii10061 = 1036;
    e.afii10062 = 1038;
    e.afii10063 = 63172;
    e.afii10064 = 63173;
    e.afii10065 = 1072;
    e.afii10066 = 1073;
    e.afii10067 = 1074;
    e.afii10068 = 1075;
    e.afii10069 = 1076;
    e.afii10070 = 1077;
    e.afii10071 = 1105;
    e.afii10072 = 1078;
    e.afii10073 = 1079;
    e.afii10074 = 1080;
    e.afii10075 = 1081;
    e.afii10076 = 1082;
    e.afii10077 = 1083;
    e.afii10078 = 1084;
    e.afii10079 = 1085;
    e.afii10080 = 1086;
    e.afii10081 = 1087;
    e.afii10082 = 1088;
    e.afii10083 = 1089;
    e.afii10084 = 1090;
    e.afii10085 = 1091;
    e.afii10086 = 1092;
    e.afii10087 = 1093;
    e.afii10088 = 1094;
    e.afii10089 = 1095;
    e.afii10090 = 1096;
    e.afii10091 = 1097;
    e.afii10092 = 1098;
    e.afii10093 = 1099;
    e.afii10094 = 1100;
    e.afii10095 = 1101;
    e.afii10096 = 1102;
    e.afii10097 = 1103;
    e.afii10098 = 1169;
    e.afii10099 = 1106;
    e.afii10100 = 1107;
    e.afii10101 = 1108;
    e.afii10102 = 1109;
    e.afii10103 = 1110;
    e.afii10104 = 1111;
    e.afii10105 = 1112;
    e.afii10106 = 1113;
    e.afii10107 = 1114;
    e.afii10108 = 1115;
    e.afii10109 = 1116;
    e.afii10110 = 1118;
    e.afii10145 = 1039;
    e.afii10146 = 1122;
    e.afii10147 = 1138;
    e.afii10148 = 1140;
    e.afii10192 = 63174;
    e.afii10193 = 1119;
    e.afii10194 = 1123;
    e.afii10195 = 1139;
    e.afii10196 = 1141;
    e.afii10831 = 63175;
    e.afii10832 = 63176;
    e.afii10846 = 1241;
    e.afii299 = 8206;
    e.afii300 = 8207;
    e.afii301 = 8205;
    e.afii57381 = 1642;
    e.afii57388 = 1548;
    e.afii57392 = 1632;
    e.afii57393 = 1633;
    e.afii57394 = 1634;
    e.afii57395 = 1635;
    e.afii57396 = 1636;
    e.afii57397 = 1637;
    e.afii57398 = 1638;
    e.afii57399 = 1639;
    e.afii57400 = 1640;
    e.afii57401 = 1641;
    e.afii57403 = 1563;
    e.afii57407 = 1567;
    e.afii57409 = 1569;
    e.afii57410 = 1570;
    e.afii57411 = 1571;
    e.afii57412 = 1572;
    e.afii57413 = 1573;
    e.afii57414 = 1574;
    e.afii57415 = 1575;
    e.afii57416 = 1576;
    e.afii57417 = 1577;
    e.afii57418 = 1578;
    e.afii57419 = 1579;
    e.afii57420 = 1580;
    e.afii57421 = 1581;
    e.afii57422 = 1582;
    e.afii57423 = 1583;
    e.afii57424 = 1584;
    e.afii57425 = 1585;
    e.afii57426 = 1586;
    e.afii57427 = 1587;
    e.afii57428 = 1588;
    e.afii57429 = 1589;
    e.afii57430 = 1590;
    e.afii57431 = 1591;
    e.afii57432 = 1592;
    e.afii57433 = 1593;
    e.afii57434 = 1594;
    e.afii57440 = 1600;
    e.afii57441 = 1601;
    e.afii57442 = 1602;
    e.afii57443 = 1603;
    e.afii57444 = 1604;
    e.afii57445 = 1605;
    e.afii57446 = 1606;
    e.afii57448 = 1608;
    e.afii57449 = 1609;
    e.afii57450 = 1610;
    e.afii57451 = 1611;
    e.afii57452 = 1612;
    e.afii57453 = 1613;
    e.afii57454 = 1614;
    e.afii57455 = 1615;
    e.afii57456 = 1616;
    e.afii57457 = 1617;
    e.afii57458 = 1618;
    e.afii57470 = 1607;
    e.afii57505 = 1700;
    e.afii57506 = 1662;
    e.afii57507 = 1670;
    e.afii57508 = 1688;
    e.afii57509 = 1711;
    e.afii57511 = 1657;
    e.afii57512 = 1672;
    e.afii57513 = 1681;
    e.afii57514 = 1722;
    e.afii57519 = 1746;
    e.afii57534 = 1749;
    e.afii57636 = 8362;
    e.afii57645 = 1470;
    e.afii57658 = 1475;
    e.afii57664 = 1488;
    e.afii57665 = 1489;
    e.afii57666 = 1490;
    e.afii57667 = 1491;
    e.afii57668 = 1492;
    e.afii57669 = 1493;
    e.afii57670 = 1494;
    e.afii57671 = 1495;
    e.afii57672 = 1496;
    e.afii57673 = 1497;
    e.afii57674 = 1498;
    e.afii57675 = 1499;
    e.afii57676 = 1500;
    e.afii57677 = 1501;
    e.afii57678 = 1502;
    e.afii57679 = 1503;
    e.afii57680 = 1504;
    e.afii57681 = 1505;
    e.afii57682 = 1506;
    e.afii57683 = 1507;
    e.afii57684 = 1508;
    e.afii57685 = 1509;
    e.afii57686 = 1510;
    e.afii57687 = 1511;
    e.afii57688 = 1512;
    e.afii57689 = 1513;
    e.afii57690 = 1514;
    e.afii57694 = 64298;
    e.afii57695 = 64299;
    e.afii57700 = 64331;
    e.afii57705 = 64287;
    e.afii57716 = 1520;
    e.afii57717 = 1521;
    e.afii57718 = 1522;
    e.afii57723 = 64309;
    e.afii57793 = 1460;
    e.afii57794 = 1461;
    e.afii57795 = 1462;
    e.afii57796 = 1467;
    e.afii57797 = 1464;
    e.afii57798 = 1463;
    e.afii57799 = 1456;
    e.afii57800 = 1458;
    e.afii57801 = 1457;
    e.afii57802 = 1459;
    e.afii57803 = 1474;
    e.afii57804 = 1473;
    e.afii57806 = 1465;
    e.afii57807 = 1468;
    e.afii57839 = 1469;
    e.afii57841 = 1471;
    e.afii57842 = 1472;
    e.afii57929 = 700;
    e.afii61248 = 8453;
    e.afii61289 = 8467;
    e.afii61352 = 8470;
    e.afii61573 = 8236;
    e.afii61574 = 8237;
    e.afii61575 = 8238;
    e.afii61664 = 8204;
    e.afii63167 = 1645;
    e.afii64937 = 701;
    e.agrave = 224;
    e.agujarati = 2693;
    e.agurmukhi = 2565;
    e.ahiragana = 12354;
    e.ahookabove = 7843;
    e.aibengali = 2448;
    e.aibopomofo = 12574;
    e.aideva = 2320;
    e.aiecyrillic = 1237;
    e.aigujarati = 2704;
    e.aigurmukhi = 2576;
    e.aimatragurmukhi = 2632;
    e.ainarabic = 1593;
    e.ainfinalarabic = 65226;
    e.aininitialarabic = 65227;
    e.ainmedialarabic = 65228;
    e.ainvertedbreve = 515;
    e.aivowelsignbengali = 2504;
    e.aivowelsigndeva = 2376;
    e.aivowelsigngujarati = 2760;
    e.akatakana = 12450;
    e.akatakanahalfwidth = 65393;
    e.akorean = 12623;
    e.alef = 1488;
    e.alefarabic = 1575;
    e.alefdageshhebrew = 64304;
    e.aleffinalarabic = 65166;
    e.alefhamzaabovearabic = 1571;
    e.alefhamzaabovefinalarabic = 65156;
    e.alefhamzabelowarabic = 1573;
    e.alefhamzabelowfinalarabic = 65160;
    e.alefhebrew = 1488;
    e.aleflamedhebrew = 64335;
    e.alefmaddaabovearabic = 1570;
    e.alefmaddaabovefinalarabic = 65154;
    e.alefmaksuraarabic = 1609;
    e.alefmaksurafinalarabic = 65264;
    e.alefmaksurainitialarabic = 65267;
    e.alefmaksuramedialarabic = 65268;
    e.alefpatahhebrew = 64302;
    e.alefqamatshebrew = 64303;
    e.aleph = 8501;
    e.allequal = 8780;
    e.alpha = 945;
    e.alphatonos = 940;
    e.amacron = 257;
    e.amonospace = 65345;
    e.ampersand = 38;
    e.ampersandmonospace = 65286;
    e.ampersandsmall = 63270;
    e.amsquare = 13250;
    e.anbopomofo = 12578;
    e.angbopomofo = 12580;
    e.angbracketleft = 12296;
    e.angbracketright = 12297;
    e.angkhankhuthai = 3674;
    e.angle = 8736;
    e.anglebracketleft = 12296;
    e.anglebracketleftvertical = 65087;
    e.anglebracketright = 12297;
    e.anglebracketrightvertical = 65088;
    e.angleleft = 9001;
    e.angleright = 9002;
    e.angstrom = 8491;
    e.anoteleia = 903;
    e.anudattadeva = 2386;
    e.anusvarabengali = 2434;
    e.anusvaradeva = 2306;
    e.anusvaragujarati = 2690;
    e.aogonek = 261;
    e.apaatosquare = 13056;
    e.aparen = 9372;
    e.apostrophearmenian = 1370;
    e.apostrophemod = 700;
    e.apple = 63743;
    e.approaches = 8784;
    e.approxequal = 8776;
    e.approxequalorimage = 8786;
    e.approximatelyequal = 8773;
    e.araeaekorean = 12686;
    e.araeakorean = 12685;
    e.arc = 8978;
    e.arighthalfring = 7834;
    e.aring = 229;
    e.aringacute = 507;
    e.aringbelow = 7681;
    e.arrowboth = 8596;
    e.arrowdashdown = 8675;
    e.arrowdashleft = 8672;
    e.arrowdashright = 8674;
    e.arrowdashup = 8673;
    e.arrowdblboth = 8660;
    e.arrowdbldown = 8659;
    e.arrowdblleft = 8656;
    e.arrowdblright = 8658;
    e.arrowdblup = 8657;
    e.arrowdown = 8595;
    e.arrowdownleft = 8601;
    e.arrowdownright = 8600;
    e.arrowdownwhite = 8681;
    e.arrowheaddownmod = 709;
    e.arrowheadleftmod = 706;
    e.arrowheadrightmod = 707;
    e.arrowheadupmod = 708;
    e.arrowhorizex = 63719;
    e.arrowleft = 8592;
    e.arrowleftdbl = 8656;
    e.arrowleftdblstroke = 8653;
    e.arrowleftoverright = 8646;
    e.arrowleftwhite = 8678;
    e.arrowright = 8594;
    e.arrowrightdblstroke = 8655;
    e.arrowrightheavy = 10142;
    e.arrowrightoverleft = 8644;
    e.arrowrightwhite = 8680;
    e.arrowtableft = 8676;
    e.arrowtabright = 8677;
    e.arrowup = 8593;
    e.arrowupdn = 8597;
    e.arrowupdnbse = 8616;
    e.arrowupdownbase = 8616;
    e.arrowupleft = 8598;
    e.arrowupleftofdown = 8645;
    e.arrowupright = 8599;
    e.arrowupwhite = 8679;
    e.arrowvertex = 63718;
    e.asciicircum = 94;
    e.asciicircummonospace = 65342;
    e.asciitilde = 126;
    e.asciitildemonospace = 65374;
    e.ascript = 593;
    e.ascriptturned = 594;
    e.asmallhiragana = 12353;
    e.asmallkatakana = 12449;
    e.asmallkatakanahalfwidth = 65383;
    e.asterisk = 42;
    e.asteriskaltonearabic = 1645;
    e.asteriskarabic = 1645;
    e.asteriskmath = 8727;
    e.asteriskmonospace = 65290;
    e.asterisksmall = 65121;
    e.asterism = 8258;
    e.asuperior = 63209;
    e.asymptoticallyequal = 8771;
    e.at = 64;
    e.atilde = 227;
    e.atmonospace = 65312;
    e.atsmall = 65131;
    e.aturned = 592;
    e.aubengali = 2452;
    e.aubopomofo = 12576;
    e.audeva = 2324;
    e.augujarati = 2708;
    e.augurmukhi = 2580;
    e.aulengthmarkbengali = 2519;
    e.aumatragurmukhi = 2636;
    e.auvowelsignbengali = 2508;
    e.auvowelsigndeva = 2380;
    e.auvowelsigngujarati = 2764;
    e.avagrahadeva = 2365;
    e.aybarmenian = 1377;
    e.ayin = 1506;
    e.ayinaltonehebrew = 64288;
    e.ayinhebrew = 1506;
    e.b = 98;
    e.babengali = 2476;
    e.backslash = 92;
    e.backslashmonospace = 65340;
    e.badeva = 2348;
    e.bagujarati = 2732;
    e.bagurmukhi = 2604;
    e.bahiragana = 12400;
    e.bahtthai = 3647;
    e.bakatakana = 12496;
    e.bar = 124;
    e.barmonospace = 65372;
    e.bbopomofo = 12549;
    e.bcircle = 9425;
    e.bdotaccent = 7683;
    e.bdotbelow = 7685;
    e.beamedsixteenthnotes = 9836;
    e.because = 8757;
    e.becyrillic = 1073;
    e.beharabic = 1576;
    e.behfinalarabic = 65168;
    e.behinitialarabic = 65169;
    e.behiragana = 12409;
    e.behmedialarabic = 65170;
    e.behmeeminitialarabic = 64671;
    e.behmeemisolatedarabic = 64520;
    e.behnoonfinalarabic = 64621;
    e.bekatakana = 12505;
    e.benarmenian = 1378;
    e.bet = 1489;
    e.beta = 946;
    e.betasymbolgreek = 976;
    e.betdagesh = 64305;
    e.betdageshhebrew = 64305;
    e.bethebrew = 1489;
    e.betrafehebrew = 64332;
    e.bhabengali = 2477;
    e.bhadeva = 2349;
    e.bhagujarati = 2733;
    e.bhagurmukhi = 2605;
    e.bhook = 595;
    e.bihiragana = 12403;
    e.bikatakana = 12499;
    e.bilabialclick = 664;
    e.bindigurmukhi = 2562;
    e.birusquare = 13105;
    e.blackcircle = 9679;
    e.blackdiamond = 9670;
    e.blackdownpointingtriangle = 9660;
    e.blackleftpointingpointer = 9668;
    e.blackleftpointingtriangle = 9664;
    e.blacklenticularbracketleft = 12304;
    e.blacklenticularbracketleftvertical = 65083;
    e.blacklenticularbracketright = 12305;
    e.blacklenticularbracketrightvertical = 65084;
    e.blacklowerlefttriangle = 9699;
    e.blacklowerrighttriangle = 9698;
    e.blackrectangle = 9644;
    e.blackrightpointingpointer = 9658;
    e.blackrightpointingtriangle = 9654;
    e.blacksmallsquare = 9642;
    e.blacksmilingface = 9787;
    e.blacksquare = 9632;
    e.blackstar = 9733;
    e.blackupperlefttriangle = 9700;
    e.blackupperrighttriangle = 9701;
    e.blackuppointingsmalltriangle = 9652;
    e.blackuppointingtriangle = 9650;
    e.blank = 9251;
    e.blinebelow = 7687;
    e.block = 9608;
    e.bmonospace = 65346;
    e.bobaimaithai = 3610;
    e.bohiragana = 12412;
    e.bokatakana = 12508;
    e.bparen = 9373;
    e.bqsquare = 13251;
    e.braceex = 63732;
    e.braceleft = 123;
    e.braceleftbt = 63731;
    e.braceleftmid = 63730;
    e.braceleftmonospace = 65371;
    e.braceleftsmall = 65115;
    e.bracelefttp = 63729;
    e.braceleftvertical = 65079;
    e.braceright = 125;
    e.bracerightbt = 63742;
    e.bracerightmid = 63741;
    e.bracerightmonospace = 65373;
    e.bracerightsmall = 65116;
    e.bracerighttp = 63740;
    e.bracerightvertical = 65080;
    e.bracketleft = 91;
    e.bracketleftbt = 63728;
    e.bracketleftex = 63727;
    e.bracketleftmonospace = 65339;
    e.bracketlefttp = 63726;
    e.bracketright = 93;
    e.bracketrightbt = 63739;
    e.bracketrightex = 63738;
    e.bracketrightmonospace = 65341;
    e.bracketrighttp = 63737;
    e.breve = 728;
    e.brevebelowcmb = 814;
    e.brevecmb = 774;
    e.breveinvertedbelowcmb = 815;
    e.breveinvertedcmb = 785;
    e.breveinverteddoublecmb = 865;
    e.bridgebelowcmb = 810;
    e.bridgeinvertedbelowcmb = 826;
    e.brokenbar = 166;
    e.bstroke = 384;
    e.bsuperior = 63210;
    e.btopbar = 387;
    e.buhiragana = 12406;
    e.bukatakana = 12502;
    e.bullet = 8226;
    e.bulletinverse = 9688;
    e.bulletoperator = 8729;
    e.bullseye = 9678;
    e.c = 99;
    e.caarmenian = 1390;
    e.cabengali = 2458;
    e.cacute = 263;
    e.cadeva = 2330;
    e.cagujarati = 2714;
    e.cagurmukhi = 2586;
    e.calsquare = 13192;
    e.candrabindubengali = 2433;
    e.candrabinducmb = 784;
    e.candrabindudeva = 2305;
    e.candrabindugujarati = 2689;
    e.capslock = 8682;
    e.careof = 8453;
    e.caron = 711;
    e.caronbelowcmb = 812;
    e.caroncmb = 780;
    e.carriagereturn = 8629;
    e.cbopomofo = 12568;
    e.ccaron = 269;
    e.ccedilla = 231;
    e.ccedillaacute = 7689;
    e.ccircle = 9426;
    e.ccircumflex = 265;
    e.ccurl = 597;
    e.cdot = 267;
    e.cdotaccent = 267;
    e.cdsquare = 13253;
    e.cedilla = 184;
    e.cedillacmb = 807;
    e.cent = 162;
    e.centigrade = 8451;
    e.centinferior = 63199;
    e.centmonospace = 65504;
    e.centoldstyle = 63394;
    e.centsuperior = 63200;
    e.chaarmenian = 1401;
    e.chabengali = 2459;
    e.chadeva = 2331;
    e.chagujarati = 2715;
    e.chagurmukhi = 2587;
    e.chbopomofo = 12564;
    e.cheabkhasiancyrillic = 1213;
    e.checkmark = 10003;
    e.checyrillic = 1095;
    e.chedescenderabkhasiancyrillic = 1215;
    e.chedescendercyrillic = 1207;
    e.chedieresiscyrillic = 1269;
    e.cheharmenian = 1395;
    e.chekhakassiancyrillic = 1228;
    e.cheverticalstrokecyrillic = 1209;
    e.chi = 967;
    e.chieuchacirclekorean = 12919;
    e.chieuchaparenkorean = 12823;
    e.chieuchcirclekorean = 12905;
    e.chieuchkorean = 12618;
    e.chieuchparenkorean = 12809;
    e.chochangthai = 3594;
    e.chochanthai = 3592;
    e.chochingthai = 3593;
    e.chochoethai = 3596;
    e.chook = 392;
    e.cieucacirclekorean = 12918;
    e.cieucaparenkorean = 12822;
    e.cieuccirclekorean = 12904;
    e.cieuckorean = 12616;
    e.cieucparenkorean = 12808;
    e.cieucuparenkorean = 12828;
    e.circle = 9675;
    e.circlecopyrt = 169;
    e.circlemultiply = 8855;
    e.circleot = 8857;
    e.circleplus = 8853;
    e.circlepostalmark = 12342;
    e.circlewithlefthalfblack = 9680;
    e.circlewithrighthalfblack = 9681;
    e.circumflex = 710;
    e.circumflexbelowcmb = 813;
    e.circumflexcmb = 770;
    e.clear = 8999;
    e.clickalveolar = 450;
    e.clickdental = 448;
    e.clicklateral = 449;
    e.clickretroflex = 451;
    e.club = 9827;
    e.clubsuitblack = 9827;
    e.clubsuitwhite = 9831;
    e.cmcubedsquare = 13220;
    e.cmonospace = 65347;
    e.cmsquaredsquare = 13216;
    e.coarmenian = 1409;
    e.colon = 58;
    e.colonmonetary = 8353;
    e.colonmonospace = 65306;
    e.colonsign = 8353;
    e.colonsmall = 65109;
    e.colontriangularhalfmod = 721;
    e.colontriangularmod = 720;
    e.comma = 44;
    e.commaabovecmb = 787;
    e.commaaboverightcmb = 789;
    e.commaaccent = 63171;
    e.commaarabic = 1548;
    e.commaarmenian = 1373;
    e.commainferior = 63201;
    e.commamonospace = 65292;
    e.commareversedabovecmb = 788;
    e.commareversedmod = 701;
    e.commasmall = 65104;
    e.commasuperior = 63202;
    e.commaturnedabovecmb = 786;
    e.commaturnedmod = 699;
    e.compass = 9788;
    e.congruent = 8773;
    e.contourintegral = 8750;
    e.control = 8963;
    e.controlACK = 6;
    e.controlBEL = 7;
    e.controlBS = 8;
    e.controlCAN = 24;
    e.controlCR = 13;
    e.controlDC1 = 17;
    e.controlDC2 = 18;
    e.controlDC3 = 19;
    e.controlDC4 = 20;
    e.controlDEL = 127;
    e.controlDLE = 16;
    e.controlEM = 25;
    e.controlENQ = 5;
    e.controlEOT = 4;
    e.controlESC = 27;
    e.controlETB = 23;
    e.controlETX = 3;
    e.controlFF = 12;
    e.controlFS = 28;
    e.controlGS = 29;
    e.controlHT = 9;
    e.controlLF = 10;
    e.controlNAK = 21;
    e.controlNULL = 0;
    e.controlRS = 30;
    e.controlSI = 15;
    e.controlSO = 14;
    e.controlSOT = 2;
    e.controlSTX = 1;
    e.controlSUB = 26;
    e.controlSYN = 22;
    e.controlUS = 31;
    e.controlVT = 11;
    e.copyright = 169;
    e.copyrightsans = 63721;
    e.copyrightserif = 63193;
    e.cornerbracketleft = 12300;
    e.cornerbracketlefthalfwidth = 65378;
    e.cornerbracketleftvertical = 65089;
    e.cornerbracketright = 12301;
    e.cornerbracketrighthalfwidth = 65379;
    e.cornerbracketrightvertical = 65090;
    e.corporationsquare = 13183;
    e.cosquare = 13255;
    e.coverkgsquare = 13254;
    e.cparen = 9374;
    e.cruzeiro = 8354;
    e.cstretched = 663;
    e.curlyand = 8911;
    e.curlyor = 8910;
    e.currency = 164;
    e.cyrBreve = 63185;
    e.cyrFlex = 63186;
    e.cyrbreve = 63188;
    e.cyrflex = 63189;
    e.d = 100;
    e.daarmenian = 1380;
    e.dabengali = 2470;
    e.dadarabic = 1590;
    e.dadeva = 2342;
    e.dadfinalarabic = 65214;
    e.dadinitialarabic = 65215;
    e.dadmedialarabic = 65216;
    e.dagesh = 1468;
    e.dageshhebrew = 1468;
    e.dagger = 8224;
    e.daggerdbl = 8225;
    e.dagujarati = 2726;
    e.dagurmukhi = 2598;
    e.dahiragana = 12384;
    e.dakatakana = 12480;
    e.dalarabic = 1583;
    e.dalet = 1491;
    e.daletdagesh = 64307;
    e.daletdageshhebrew = 64307;
    e.dalethebrew = 1491;
    e.dalfinalarabic = 65194;
    e.dammaarabic = 1615;
    e.dammalowarabic = 1615;
    e.dammatanaltonearabic = 1612;
    e.dammatanarabic = 1612;
    e.danda = 2404;
    e.dargahebrew = 1447;
    e.dargalefthebrew = 1447;
    e.dasiapneumatacyrilliccmb = 1157;
    e.dblGrave = 63187;
    e.dblanglebracketleft = 12298;
    e.dblanglebracketleftvertical = 65085;
    e.dblanglebracketright = 12299;
    e.dblanglebracketrightvertical = 65086;
    e.dblarchinvertedbelowcmb = 811;
    e.dblarrowleft = 8660;
    e.dblarrowright = 8658;
    e.dbldanda = 2405;
    e.dblgrave = 63190;
    e.dblgravecmb = 783;
    e.dblintegral = 8748;
    e.dbllowline = 8215;
    e.dbllowlinecmb = 819;
    e.dbloverlinecmb = 831;
    e.dblprimemod = 698;
    e.dblverticalbar = 8214;
    e.dblverticallineabovecmb = 782;
    e.dbopomofo = 12553;
    e.dbsquare = 13256;
    e.dcaron = 271;
    e.dcedilla = 7697;
    e.dcircle = 9427;
    e.dcircumflexbelow = 7699;
    e.dcroat = 273;
    e.ddabengali = 2465;
    e.ddadeva = 2337;
    e.ddagujarati = 2721;
    e.ddagurmukhi = 2593;
    e.ddalarabic = 1672;
    e.ddalfinalarabic = 64393;
    e.dddhadeva = 2396;
    e.ddhabengali = 2466;
    e.ddhadeva = 2338;
    e.ddhagujarati = 2722;
    e.ddhagurmukhi = 2594;
    e.ddotaccent = 7691;
    e.ddotbelow = 7693;
    e.decimalseparatorarabic = 1643;
    e.decimalseparatorpersian = 1643;
    e.decyrillic = 1076;
    e.degree = 176;
    e.dehihebrew = 1453;
    e.dehiragana = 12391;
    e.deicoptic = 1007;
    e.dekatakana = 12487;
    e.deleteleft = 9003;
    e.deleteright = 8998;
    e.delta = 948;
    e.deltaturned = 397;
    e.denominatorminusonenumeratorbengali = 2552;
    e.dezh = 676;
    e.dhabengali = 2471;
    e.dhadeva = 2343;
    e.dhagujarati = 2727;
    e.dhagurmukhi = 2599;
    e.dhook = 599;
    e.dialytikatonos = 901;
    e.dialytikatonoscmb = 836;
    e.diamond = 9830;
    e.diamondsuitwhite = 9826;
    e.dieresis = 168;
    e.dieresisacute = 63191;
    e.dieresisbelowcmb = 804;
    e.dieresiscmb = 776;
    e.dieresisgrave = 63192;
    e.dieresistonos = 901;
    e.dihiragana = 12386;
    e.dikatakana = 12482;
    e.dittomark = 12291;
    e.divide = 247;
    e.divides = 8739;
    e.divisionslash = 8725;
    e.djecyrillic = 1106;
    e.dkshade = 9619;
    e.dlinebelow = 7695;
    e.dlsquare = 13207;
    e.dmacron = 273;
    e.dmonospace = 65348;
    e.dnblock = 9604;
    e.dochadathai = 3598;
    e.dodekthai = 3604;
    e.dohiragana = 12393;
    e.dokatakana = 12489;
    e.dollar = 36;
    e.dollarinferior = 63203;
    e.dollarmonospace = 65284;
    e.dollaroldstyle = 63268;
    e.dollarsmall = 65129;
    e.dollarsuperior = 63204;
    e.dong = 8363;
    e.dorusquare = 13094;
    e.dotaccent = 729;
    e.dotaccentcmb = 775;
    e.dotbelowcmb = 803;
    e.dotbelowcomb = 803;
    e.dotkatakana = 12539;
    e.dotlessi = 305;
    e.dotlessj = 63166;
    e.dotlessjstrokehook = 644;
    e.dotmath = 8901;
    e.dottedcircle = 9676;
    e.doubleyodpatah = 64287;
    e.doubleyodpatahhebrew = 64287;
    e.downtackbelowcmb = 798;
    e.downtackmod = 725;
    e.dparen = 9375;
    e.dsuperior = 63211;
    e.dtail = 598;
    e.dtopbar = 396;
    e.duhiragana = 12389;
    e.dukatakana = 12485;
    e.dz = 499;
    e.dzaltone = 675;
    e.dzcaron = 454;
    e.dzcurl = 677;
    e.dzeabkhasiancyrillic = 1249;
    e.dzecyrillic = 1109;
    e.dzhecyrillic = 1119;
    e.e = 101;
    e.eacute = 233;
    e.earth = 9793;
    e.ebengali = 2447;
    e.ebopomofo = 12572;
    e.ebreve = 277;
    e.ecandradeva = 2317;
    e.ecandragujarati = 2701;
    e.ecandravowelsigndeva = 2373;
    e.ecandravowelsigngujarati = 2757;
    e.ecaron = 283;
    e.ecedillabreve = 7709;
    e.echarmenian = 1381;
    e.echyiwnarmenian = 1415;
    e.ecircle = 9428;
    e.ecircumflex = 234;
    e.ecircumflexacute = 7871;
    e.ecircumflexbelow = 7705;
    e.ecircumflexdotbelow = 7879;
    e.ecircumflexgrave = 7873;
    e.ecircumflexhookabove = 7875;
    e.ecircumflextilde = 7877;
    e.ecyrillic = 1108;
    e.edblgrave = 517;
    e.edeva = 2319;
    e.edieresis = 235;
    e.edot = 279;
    e.edotaccent = 279;
    e.edotbelow = 7865;
    e.eegurmukhi = 2575;
    e.eematragurmukhi = 2631;
    e.efcyrillic = 1092;
    e.egrave = 232;
    e.egujarati = 2703;
    e.eharmenian = 1383;
    e.ehbopomofo = 12573;
    e.ehiragana = 12360;
    e.ehookabove = 7867;
    e.eibopomofo = 12575;
    e.eight = 56;
    e.eightarabic = 1640;
    e.eightbengali = 2542;
    e.eightcircle = 9319;
    e.eightcircleinversesansserif = 10129;
    e.eightdeva = 2414;
    e.eighteencircle = 9329;
    e.eighteenparen = 9349;
    e.eighteenperiod = 9369;
    e.eightgujarati = 2798;
    e.eightgurmukhi = 2670;
    e.eighthackarabic = 1640;
    e.eighthangzhou = 12328;
    e.eighthnotebeamed = 9835;
    e.eightideographicparen = 12839;
    e.eightinferior = 8328;
    e.eightmonospace = 65304;
    e.eightoldstyle = 63288;
    e.eightparen = 9339;
    e.eightperiod = 9359;
    e.eightpersian = 1784;
    e.eightroman = 8567;
    e.eightsuperior = 8312;
    e.eightthai = 3672;
    e.einvertedbreve = 519;
    e.eiotifiedcyrillic = 1125;
    e.ekatakana = 12456;
    e.ekatakanahalfwidth = 65396;
    e.ekonkargurmukhi = 2676;
    e.ekorean = 12628;
    e.elcyrillic = 1083;
    e.element = 8712;
    e.elevencircle = 9322;
    e.elevenparen = 9342;
    e.elevenperiod = 9362;
    e.elevenroman = 8570;
    e.ellipsis = 8230;
    e.ellipsisvertical = 8942;
    e.emacron = 275;
    e.emacronacute = 7703;
    e.emacrongrave = 7701;
    e.emcyrillic = 1084;
    e.emdash = 8212;
    e.emdashvertical = 65073;
    e.emonospace = 65349;
    e.emphasismarkarmenian = 1371;
    e.emptyset = 8709;
    e.enbopomofo = 12579;
    e.encyrillic = 1085;
    e.endash = 8211;
    e.endashvertical = 65074;
    e.endescendercyrillic = 1187;
    e.eng = 331;
    e.engbopomofo = 12581;
    e.enghecyrillic = 1189;
    e.enhookcyrillic = 1224;
    e.enspace = 8194;
    e.eogonek = 281;
    e.eokorean = 12627;
    e.eopen = 603;
    e.eopenclosed = 666;
    e.eopenreversed = 604;
    e.eopenreversedclosed = 606;
    e.eopenreversedhook = 605;
    e.eparen = 9376;
    e.epsilon = 949;
    e.epsilontonos = 941;
    e.equal = 61;
    e.equalmonospace = 65309;
    e.equalsmall = 65126;
    e.equalsuperior = 8316;
    e.equivalence = 8801;
    e.erbopomofo = 12582;
    e.ercyrillic = 1088;
    e.ereversed = 600;
    e.ereversedcyrillic = 1101;
    e.escyrillic = 1089;
    e.esdescendercyrillic = 1195;
    e.esh = 643;
    e.eshcurl = 646;
    e.eshortdeva = 2318;
    e.eshortvowelsigndeva = 2374;
    e.eshreversedloop = 426;
    e.eshsquatreversed = 645;
    e.esmallhiragana = 12359;
    e.esmallkatakana = 12455;
    e.esmallkatakanahalfwidth = 65386;
    e.estimated = 8494;
    e.esuperior = 63212;
    e.eta = 951;
    e.etarmenian = 1384;
    e.etatonos = 942;
    e.eth = 240;
    e.etilde = 7869;
    e.etildebelow = 7707;
    e.etnahtafoukhhebrew = 1425;
    e.etnahtafoukhlefthebrew = 1425;
    e.etnahtahebrew = 1425;
    e.etnahtalefthebrew = 1425;
    e.eturned = 477;
    e.eukorean = 12641;
    e.euro = 8364;
    e.evowelsignbengali = 2503;
    e.evowelsigndeva = 2375;
    e.evowelsigngujarati = 2759;
    e.exclam = 33;
    e.exclamarmenian = 1372;
    e.exclamdbl = 8252;
    e.exclamdown = 161;
    e.exclamdownsmall = 63393;
    e.exclammonospace = 65281;
    e.exclamsmall = 63265;
    e.existential = 8707;
    e.ezh = 658;
    e.ezhcaron = 495;
    e.ezhcurl = 659;
    e.ezhreversed = 441;
    e.ezhtail = 442;
    e.f = 102;
    e.fadeva = 2398;
    e.fagurmukhi = 2654;
    e.fahrenheit = 8457;
    e.fathaarabic = 1614;
    e.fathalowarabic = 1614;
    e.fathatanarabic = 1611;
    e.fbopomofo = 12552;
    e.fcircle = 9429;
    e.fdotaccent = 7711;
    e.feharabic = 1601;
    e.feharmenian = 1414;
    e.fehfinalarabic = 65234;
    e.fehinitialarabic = 65235;
    e.fehmedialarabic = 65236;
    e.feicoptic = 997;
    e.female = 9792;
    e.ff = 64256;
    e.f_f = 64256;
    e.ffi = 64259;
    e.f_f_i = 64259;
    e.ffl = 64260;
    e.f_f_l = 64260;
    e.fi = 64257;
    e.f_i = 64257;
    e.fifteencircle = 9326;
    e.fifteenparen = 9346;
    e.fifteenperiod = 9366;
    e.figuredash = 8210;
    e.filledbox = 9632;
    e.filledrect = 9644;
    e.finalkaf = 1498;
    e.finalkafdagesh = 64314;
    e.finalkafdageshhebrew = 64314;
    e.finalkafhebrew = 1498;
    e.finalmem = 1501;
    e.finalmemhebrew = 1501;
    e.finalnun = 1503;
    e.finalnunhebrew = 1503;
    e.finalpe = 1507;
    e.finalpehebrew = 1507;
    e.finaltsadi = 1509;
    e.finaltsadihebrew = 1509;
    e.firsttonechinese = 713;
    e.fisheye = 9673;
    e.fitacyrillic = 1139;
    e.five = 53;
    e.fivearabic = 1637;
    e.fivebengali = 2539;
    e.fivecircle = 9316;
    e.fivecircleinversesansserif = 10126;
    e.fivedeva = 2411;
    e.fiveeighths = 8541;
    e.fivegujarati = 2795;
    e.fivegurmukhi = 2667;
    e.fivehackarabic = 1637;
    e.fivehangzhou = 12325;
    e.fiveideographicparen = 12836;
    e.fiveinferior = 8325;
    e.fivemonospace = 65301;
    e.fiveoldstyle = 63285;
    e.fiveparen = 9336;
    e.fiveperiod = 9356;
    e.fivepersian = 1781;
    e.fiveroman = 8564;
    e.fivesuperior = 8309;
    e.fivethai = 3669;
    e.fl = 64258;
    e.f_l = 64258;
    e.florin = 402;
    e.fmonospace = 65350;
    e.fmsquare = 13209;
    e.fofanthai = 3615;
    e.fofathai = 3613;
    e.fongmanthai = 3663;
    e.forall = 8704;
    e.four = 52;
    e.fourarabic = 1636;
    e.fourbengali = 2538;
    e.fourcircle = 9315;
    e.fourcircleinversesansserif = 10125;
    e.fourdeva = 2410;
    e.fourgujarati = 2794;
    e.fourgurmukhi = 2666;
    e.fourhackarabic = 1636;
    e.fourhangzhou = 12324;
    e.fourideographicparen = 12835;
    e.fourinferior = 8324;
    e.fourmonospace = 65300;
    e.fournumeratorbengali = 2551;
    e.fouroldstyle = 63284;
    e.fourparen = 9335;
    e.fourperiod = 9355;
    e.fourpersian = 1780;
    e.fourroman = 8563;
    e.foursuperior = 8308;
    e.fourteencircle = 9325;
    e.fourteenparen = 9345;
    e.fourteenperiod = 9365;
    e.fourthai = 3668;
    e.fourthtonechinese = 715;
    e.fparen = 9377;
    e.fraction = 8260;
    e.franc = 8355;
    e.g = 103;
    e.gabengali = 2455;
    e.gacute = 501;
    e.gadeva = 2327;
    e.gafarabic = 1711;
    e.gaffinalarabic = 64403;
    e.gafinitialarabic = 64404;
    e.gafmedialarabic = 64405;
    e.gagujarati = 2711;
    e.gagurmukhi = 2583;
    e.gahiragana = 12364;
    e.gakatakana = 12460;
    e.gamma = 947;
    e.gammalatinsmall = 611;
    e.gammasuperior = 736;
    e.gangiacoptic = 1003;
    e.gbopomofo = 12557;
    e.gbreve = 287;
    e.gcaron = 487;
    e.gcedilla = 291;
    e.gcircle = 9430;
    e.gcircumflex = 285;
    e.gcommaaccent = 291;
    e.gdot = 289;
    e.gdotaccent = 289;
    e.gecyrillic = 1075;
    e.gehiragana = 12370;
    e.gekatakana = 12466;
    e.geometricallyequal = 8785;
    e.gereshaccenthebrew = 1436;
    e.gereshhebrew = 1523;
    e.gereshmuqdamhebrew = 1437;
    e.germandbls = 223;
    e.gershayimaccenthebrew = 1438;
    e.gershayimhebrew = 1524;
    e.getamark = 12307;
    e.ghabengali = 2456;
    e.ghadarmenian = 1394;
    e.ghadeva = 2328;
    e.ghagujarati = 2712;
    e.ghagurmukhi = 2584;
    e.ghainarabic = 1594;
    e.ghainfinalarabic = 65230;
    e.ghaininitialarabic = 65231;
    e.ghainmedialarabic = 65232;
    e.ghemiddlehookcyrillic = 1173;
    e.ghestrokecyrillic = 1171;
    e.gheupturncyrillic = 1169;
    e.ghhadeva = 2394;
    e.ghhagurmukhi = 2650;
    e.ghook = 608;
    e.ghzsquare = 13203;
    e.gihiragana = 12366;
    e.gikatakana = 12462;
    e.gimarmenian = 1379;
    e.gimel = 1490;
    e.gimeldagesh = 64306;
    e.gimeldageshhebrew = 64306;
    e.gimelhebrew = 1490;
    e.gjecyrillic = 1107;
    e.glottalinvertedstroke = 446;
    e.glottalstop = 660;
    e.glottalstopinverted = 662;
    e.glottalstopmod = 704;
    e.glottalstopreversed = 661;
    e.glottalstopreversedmod = 705;
    e.glottalstopreversedsuperior = 740;
    e.glottalstopstroke = 673;
    e.glottalstopstrokereversed = 674;
    e.gmacron = 7713;
    e.gmonospace = 65351;
    e.gohiragana = 12372;
    e.gokatakana = 12468;
    e.gparen = 9378;
    e.gpasquare = 13228;
    e.gradient = 8711;
    e.grave = 96;
    e.gravebelowcmb = 790;
    e.gravecmb = 768;
    e.gravecomb = 768;
    e.gravedeva = 2387;
    e.gravelowmod = 718;
    e.gravemonospace = 65344;
    e.gravetonecmb = 832;
    e.greater = 62;
    e.greaterequal = 8805;
    e.greaterequalorless = 8923;
    e.greatermonospace = 65310;
    e.greaterorequivalent = 8819;
    e.greaterorless = 8823;
    e.greateroverequal = 8807;
    e.greatersmall = 65125;
    e.gscript = 609;
    e.gstroke = 485;
    e.guhiragana = 12368;
    e.guillemotleft = 171;
    e.guillemotright = 187;
    e.guilsinglleft = 8249;
    e.guilsinglright = 8250;
    e.gukatakana = 12464;
    e.guramusquare = 13080;
    e.gysquare = 13257;
    e.h = 104;
    e.haabkhasiancyrillic = 1193;
    e.haaltonearabic = 1729;
    e.habengali = 2489;
    e.hadescendercyrillic = 1203;
    e.hadeva = 2361;
    e.hagujarati = 2745;
    e.hagurmukhi = 2617;
    e.haharabic = 1581;
    e.hahfinalarabic = 65186;
    e.hahinitialarabic = 65187;
    e.hahiragana = 12399;
    e.hahmedialarabic = 65188;
    e.haitusquare = 13098;
    e.hakatakana = 12495;
    e.hakatakanahalfwidth = 65418;
    e.halantgurmukhi = 2637;
    e.hamzaarabic = 1569;
    e.hamzalowarabic = 1569;
    e.hangulfiller = 12644;
    e.hardsigncyrillic = 1098;
    e.harpoonleftbarbup = 8636;
    e.harpoonrightbarbup = 8640;
    e.hasquare = 13258;
    e.hatafpatah = 1458;
    e.hatafpatah16 = 1458;
    e.hatafpatah23 = 1458;
    e.hatafpatah2f = 1458;
    e.hatafpatahhebrew = 1458;
    e.hatafpatahnarrowhebrew = 1458;
    e.hatafpatahquarterhebrew = 1458;
    e.hatafpatahwidehebrew = 1458;
    e.hatafqamats = 1459;
    e.hatafqamats1b = 1459;
    e.hatafqamats28 = 1459;
    e.hatafqamats34 = 1459;
    e.hatafqamatshebrew = 1459;
    e.hatafqamatsnarrowhebrew = 1459;
    e.hatafqamatsquarterhebrew = 1459;
    e.hatafqamatswidehebrew = 1459;
    e.hatafsegol = 1457;
    e.hatafsegol17 = 1457;
    e.hatafsegol24 = 1457;
    e.hatafsegol30 = 1457;
    e.hatafsegolhebrew = 1457;
    e.hatafsegolnarrowhebrew = 1457;
    e.hatafsegolquarterhebrew = 1457;
    e.hatafsegolwidehebrew = 1457;
    e.hbar = 295;
    e.hbopomofo = 12559;
    e.hbrevebelow = 7723;
    e.hcedilla = 7721;
    e.hcircle = 9431;
    e.hcircumflex = 293;
    e.hdieresis = 7719;
    e.hdotaccent = 7715;
    e.hdotbelow = 7717;
    e.he = 1492;
    e.heart = 9829;
    e.heartsuitblack = 9829;
    e.heartsuitwhite = 9825;
    e.hedagesh = 64308;
    e.hedageshhebrew = 64308;
    e.hehaltonearabic = 1729;
    e.heharabic = 1607;
    e.hehebrew = 1492;
    e.hehfinalaltonearabic = 64423;
    e.hehfinalalttwoarabic = 65258;
    e.hehfinalarabic = 65258;
    e.hehhamzaabovefinalarabic = 64421;
    e.hehhamzaaboveisolatedarabic = 64420;
    e.hehinitialaltonearabic = 64424;
    e.hehinitialarabic = 65259;
    e.hehiragana = 12408;
    e.hehmedialaltonearabic = 64425;
    e.hehmedialarabic = 65260;
    e.heiseierasquare = 13179;
    e.hekatakana = 12504;
    e.hekatakanahalfwidth = 65421;
    e.hekutaarusquare = 13110;
    e.henghook = 615;
    e.herutusquare = 13113;
    e.het = 1495;
    e.hethebrew = 1495;
    e.hhook = 614;
    e.hhooksuperior = 689;
    e.hieuhacirclekorean = 12923;
    e.hieuhaparenkorean = 12827;
    e.hieuhcirclekorean = 12909;
    e.hieuhkorean = 12622;
    e.hieuhparenkorean = 12813;
    e.hihiragana = 12402;
    e.hikatakana = 12498;
    e.hikatakanahalfwidth = 65419;
    e.hiriq = 1460;
    e.hiriq14 = 1460;
    e.hiriq21 = 1460;
    e.hiriq2d = 1460;
    e.hiriqhebrew = 1460;
    e.hiriqnarrowhebrew = 1460;
    e.hiriqquarterhebrew = 1460;
    e.hiriqwidehebrew = 1460;
    e.hlinebelow = 7830;
    e.hmonospace = 65352;
    e.hoarmenian = 1392;
    e.hohipthai = 3627;
    e.hohiragana = 12411;
    e.hokatakana = 12507;
    e.hokatakanahalfwidth = 65422;
    e.holam = 1465;
    e.holam19 = 1465;
    e.holam26 = 1465;
    e.holam32 = 1465;
    e.holamhebrew = 1465;
    e.holamnarrowhebrew = 1465;
    e.holamquarterhebrew = 1465;
    e.holamwidehebrew = 1465;
    e.honokhukthai = 3630;
    e.hookabovecomb = 777;
    e.hookcmb = 777;
    e.hookpalatalizedbelowcmb = 801;
    e.hookretroflexbelowcmb = 802;
    e.hoonsquare = 13122;
    e.horicoptic = 1001;
    e.horizontalbar = 8213;
    e.horncmb = 795;
    e.hotsprings = 9832;
    e.house = 8962;
    e.hparen = 9379;
    e.hsuperior = 688;
    e.hturned = 613;
    e.huhiragana = 12405;
    e.huiitosquare = 13107;
    e.hukatakana = 12501;
    e.hukatakanahalfwidth = 65420;
    e.hungarumlaut = 733;
    e.hungarumlautcmb = 779;
    e.hv = 405;
    e.hyphen = 45;
    e.hypheninferior = 63205;
    e.hyphenmonospace = 65293;
    e.hyphensmall = 65123;
    e.hyphensuperior = 63206;
    e.hyphentwo = 8208;
    e.i = 105;
    e.iacute = 237;
    e.iacyrillic = 1103;
    e.ibengali = 2439;
    e.ibopomofo = 12583;
    e.ibreve = 301;
    e.icaron = 464;
    e.icircle = 9432;
    e.icircumflex = 238;
    e.icyrillic = 1110;
    e.idblgrave = 521;
    e.ideographearthcircle = 12943;
    e.ideographfirecircle = 12939;
    e.ideographicallianceparen = 12863;
    e.ideographiccallparen = 12858;
    e.ideographiccentrecircle = 12965;
    e.ideographicclose = 12294;
    e.ideographiccomma = 12289;
    e.ideographiccommaleft = 65380;
    e.ideographiccongratulationparen = 12855;
    e.ideographiccorrectcircle = 12963;
    e.ideographicearthparen = 12847;
    e.ideographicenterpriseparen = 12861;
    e.ideographicexcellentcircle = 12957;
    e.ideographicfestivalparen = 12864;
    e.ideographicfinancialcircle = 12950;
    e.ideographicfinancialparen = 12854;
    e.ideographicfireparen = 12843;
    e.ideographichaveparen = 12850;
    e.ideographichighcircle = 12964;
    e.ideographiciterationmark = 12293;
    e.ideographiclaborcircle = 12952;
    e.ideographiclaborparen = 12856;
    e.ideographicleftcircle = 12967;
    e.ideographiclowcircle = 12966;
    e.ideographicmedicinecircle = 12969;
    e.ideographicmetalparen = 12846;
    e.ideographicmoonparen = 12842;
    e.ideographicnameparen = 12852;
    e.ideographicperiod = 12290;
    e.ideographicprintcircle = 12958;
    e.ideographicreachparen = 12867;
    e.ideographicrepresentparen = 12857;
    e.ideographicresourceparen = 12862;
    e.ideographicrightcircle = 12968;
    e.ideographicsecretcircle = 12953;
    e.ideographicselfparen = 12866;
    e.ideographicsocietyparen = 12851;
    e.ideographicspace = 12288;
    e.ideographicspecialparen = 12853;
    e.ideographicstockparen = 12849;
    e.ideographicstudyparen = 12859;
    e.ideographicsunparen = 12848;
    e.ideographicsuperviseparen = 12860;
    e.ideographicwaterparen = 12844;
    e.ideographicwoodparen = 12845;
    e.ideographiczero = 12295;
    e.ideographmetalcircle = 12942;
    e.ideographmooncircle = 12938;
    e.ideographnamecircle = 12948;
    e.ideographsuncircle = 12944;
    e.ideographwatercircle = 12940;
    e.ideographwoodcircle = 12941;
    e.ideva = 2311;
    e.idieresis = 239;
    e.idieresisacute = 7727;
    e.idieresiscyrillic = 1253;
    e.idotbelow = 7883;
    e.iebrevecyrillic = 1239;
    e.iecyrillic = 1077;
    e.ieungacirclekorean = 12917;
    e.ieungaparenkorean = 12821;
    e.ieungcirclekorean = 12903;
    e.ieungkorean = 12615;
    e.ieungparenkorean = 12807;
    e.igrave = 236;
    e.igujarati = 2695;
    e.igurmukhi = 2567;
    e.ihiragana = 12356;
    e.ihookabove = 7881;
    e.iibengali = 2440;
    e.iicyrillic = 1080;
    e.iideva = 2312;
    e.iigujarati = 2696;
    e.iigurmukhi = 2568;
    e.iimatragurmukhi = 2624;
    e.iinvertedbreve = 523;
    e.iishortcyrillic = 1081;
    e.iivowelsignbengali = 2496;
    e.iivowelsigndeva = 2368;
    e.iivowelsigngujarati = 2752;
    e.ij = 307;
    e.ikatakana = 12452;
    e.ikatakanahalfwidth = 65394;
    e.ikorean = 12643;
    e.ilde = 732;
    e.iluyhebrew = 1452;
    e.imacron = 299;
    e.imacroncyrillic = 1251;
    e.imageorapproximatelyequal = 8787;
    e.imatragurmukhi = 2623;
    e.imonospace = 65353;
    e.increment = 8710;
    e.infinity = 8734;
    e.iniarmenian = 1387;
    e.integral = 8747;
    e.integralbottom = 8993;
    e.integralbt = 8993;
    e.integralex = 63733;
    e.integraltop = 8992;
    e.integraltp = 8992;
    e.intersection = 8745;
    e.intisquare = 13061;
    e.invbullet = 9688;
    e.invcircle = 9689;
    e.invsmileface = 9787;
    e.iocyrillic = 1105;
    e.iogonek = 303;
    e.iota = 953;
    e.iotadieresis = 970;
    e.iotadieresistonos = 912;
    e.iotalatin = 617;
    e.iotatonos = 943;
    e.iparen = 9380;
    e.irigurmukhi = 2674;
    e.ismallhiragana = 12355;
    e.ismallkatakana = 12451;
    e.ismallkatakanahalfwidth = 65384;
    e.issharbengali = 2554;
    e.istroke = 616;
    e.isuperior = 63213;
    e.iterationhiragana = 12445;
    e.iterationkatakana = 12541;
    e.itilde = 297;
    e.itildebelow = 7725;
    e.iubopomofo = 12585;
    e.iucyrillic = 1102;
    e.ivowelsignbengali = 2495;
    e.ivowelsigndeva = 2367;
    e.ivowelsigngujarati = 2751;
    e.izhitsacyrillic = 1141;
    e.izhitsadblgravecyrillic = 1143;
    e.j = 106;
    e.jaarmenian = 1393;
    e.jabengali = 2460;
    e.jadeva = 2332;
    e.jagujarati = 2716;
    e.jagurmukhi = 2588;
    e.jbopomofo = 12560;
    e.jcaron = 496;
    e.jcircle = 9433;
    e.jcircumflex = 309;
    e.jcrossedtail = 669;
    e.jdotlessstroke = 607;
    e.jecyrillic = 1112;
    e.jeemarabic = 1580;
    e.jeemfinalarabic = 65182;
    e.jeeminitialarabic = 65183;
    e.jeemmedialarabic = 65184;
    e.jeharabic = 1688;
    e.jehfinalarabic = 64395;
    e.jhabengali = 2461;
    e.jhadeva = 2333;
    e.jhagujarati = 2717;
    e.jhagurmukhi = 2589;
    e.jheharmenian = 1403;
    e.jis = 12292;
    e.jmonospace = 65354;
    e.jparen = 9381;
    e.jsuperior = 690;
    e.k = 107;
    e.kabashkircyrillic = 1185;
    e.kabengali = 2453;
    e.kacute = 7729;
    e.kacyrillic = 1082;
    e.kadescendercyrillic = 1179;
    e.kadeva = 2325;
    e.kaf = 1499;
    e.kafarabic = 1603;
    e.kafdagesh = 64315;
    e.kafdageshhebrew = 64315;
    e.kaffinalarabic = 65242;
    e.kafhebrew = 1499;
    e.kafinitialarabic = 65243;
    e.kafmedialarabic = 65244;
    e.kafrafehebrew = 64333;
    e.kagujarati = 2709;
    e.kagurmukhi = 2581;
    e.kahiragana = 12363;
    e.kahookcyrillic = 1220;
    e.kakatakana = 12459;
    e.kakatakanahalfwidth = 65398;
    e.kappa = 954;
    e.kappasymbolgreek = 1008;
    e.kapyeounmieumkorean = 12657;
    e.kapyeounphieuphkorean = 12676;
    e.kapyeounpieupkorean = 12664;
    e.kapyeounssangpieupkorean = 12665;
    e.karoriisquare = 13069;
    e.kashidaautoarabic = 1600;
    e.kashidaautonosidebearingarabic = 1600;
    e.kasmallkatakana = 12533;
    e.kasquare = 13188;
    e.kasraarabic = 1616;
    e.kasratanarabic = 1613;
    e.kastrokecyrillic = 1183;
    e.katahiraprolongmarkhalfwidth = 65392;
    e.kaverticalstrokecyrillic = 1181;
    e.kbopomofo = 12558;
    e.kcalsquare = 13193;
    e.kcaron = 489;
    e.kcedilla = 311;
    e.kcircle = 9434;
    e.kcommaaccent = 311;
    e.kdotbelow = 7731;
    e.keharmenian = 1412;
    e.kehiragana = 12369;
    e.kekatakana = 12465;
    e.kekatakanahalfwidth = 65401;
    e.kenarmenian = 1391;
    e.kesmallkatakana = 12534;
    e.kgreenlandic = 312;
    e.khabengali = 2454;
    e.khacyrillic = 1093;
    e.khadeva = 2326;
    e.khagujarati = 2710;
    e.khagurmukhi = 2582;
    e.khaharabic = 1582;
    e.khahfinalarabic = 65190;
    e.khahinitialarabic = 65191;
    e.khahmedialarabic = 65192;
    e.kheicoptic = 999;
    e.khhadeva = 2393;
    e.khhagurmukhi = 2649;
    e.khieukhacirclekorean = 12920;
    e.khieukhaparenkorean = 12824;
    e.khieukhcirclekorean = 12906;
    e.khieukhkorean = 12619;
    e.khieukhparenkorean = 12810;
    e.khokhaithai = 3586;
    e.khokhonthai = 3589;
    e.khokhuatthai = 3587;
    e.khokhwaithai = 3588;
    e.khomutthai = 3675;
    e.khook = 409;
    e.khorakhangthai = 3590;
    e.khzsquare = 13201;
    e.kihiragana = 12365;
    e.kikatakana = 12461;
    e.kikatakanahalfwidth = 65399;
    e.kiroguramusquare = 13077;
    e.kiromeetorusquare = 13078;
    e.kirosquare = 13076;
    e.kiyeokacirclekorean = 12910;
    e.kiyeokaparenkorean = 12814;
    e.kiyeokcirclekorean = 12896;
    e.kiyeokkorean = 12593;
    e.kiyeokparenkorean = 12800;
    e.kiyeoksioskorean = 12595;
    e.kjecyrillic = 1116;
    e.klinebelow = 7733;
    e.klsquare = 13208;
    e.kmcubedsquare = 13222;
    e.kmonospace = 65355;
    e.kmsquaredsquare = 13218;
    e.kohiragana = 12371;
    e.kohmsquare = 13248;
    e.kokaithai = 3585;
    e.kokatakana = 12467;
    e.kokatakanahalfwidth = 65402;
    e.kooposquare = 13086;
    e.koppacyrillic = 1153;
    e.koreanstandardsymbol = 12927;
    e.koroniscmb = 835;
    e.kparen = 9382;
    e.kpasquare = 13226;
    e.ksicyrillic = 1135;
    e.ktsquare = 13263;
    e.kturned = 670;
    e.kuhiragana = 12367;
    e.kukatakana = 12463;
    e.kukatakanahalfwidth = 65400;
    e.kvsquare = 13240;
    e.kwsquare = 13246;
    e.l = 108;
    e.labengali = 2482;
    e.lacute = 314;
    e.ladeva = 2354;
    e.lagujarati = 2738;
    e.lagurmukhi = 2610;
    e.lakkhangyaothai = 3653;
    e.lamaleffinalarabic = 65276;
    e.lamalefhamzaabovefinalarabic = 65272;
    e.lamalefhamzaaboveisolatedarabic = 65271;
    e.lamalefhamzabelowfinalarabic = 65274;
    e.lamalefhamzabelowisolatedarabic = 65273;
    e.lamalefisolatedarabic = 65275;
    e.lamalefmaddaabovefinalarabic = 65270;
    e.lamalefmaddaaboveisolatedarabic = 65269;
    e.lamarabic = 1604;
    e.lambda = 955;
    e.lambdastroke = 411;
    e.lamed = 1500;
    e.lameddagesh = 64316;
    e.lameddageshhebrew = 64316;
    e.lamedhebrew = 1500;
    e.lamfinalarabic = 65246;
    e.lamhahinitialarabic = 64714;
    e.laminitialarabic = 65247;
    e.lamjeeminitialarabic = 64713;
    e.lamkhahinitialarabic = 64715;
    e.lamlamhehisolatedarabic = 65010;
    e.lammedialarabic = 65248;
    e.lammeemhahinitialarabic = 64904;
    e.lammeeminitialarabic = 64716;
    e.largecircle = 9711;
    e.lbar = 410;
    e.lbelt = 620;
    e.lbopomofo = 12556;
    e.lcaron = 318;
    e.lcedilla = 316;
    e.lcircle = 9435;
    e.lcircumflexbelow = 7741;
    e.lcommaaccent = 316;
    e.ldot = 320;
    e.ldotaccent = 320;
    e.ldotbelow = 7735;
    e.ldotbelowmacron = 7737;
    e.leftangleabovecmb = 794;
    e.lefttackbelowcmb = 792;
    e.less = 60;
    e.lessequal = 8804;
    e.lessequalorgreater = 8922;
    e.lessmonospace = 65308;
    e.lessorequivalent = 8818;
    e.lessorgreater = 8822;
    e.lessoverequal = 8806;
    e.lesssmall = 65124;
    e.lezh = 622;
    e.lfblock = 9612;
    e.lhookretroflex = 621;
    e.lira = 8356;
    e.liwnarmenian = 1388;
    e.lj = 457;
    e.ljecyrillic = 1113;
    e.ll = 63168;
    e.lladeva = 2355;
    e.llagujarati = 2739;
    e.llinebelow = 7739;
    e.llladeva = 2356;
    e.llvocalicbengali = 2529;
    e.llvocalicdeva = 2401;
    e.llvocalicvowelsignbengali = 2531;
    e.llvocalicvowelsigndeva = 2403;
    e.lmiddletilde = 619;
    e.lmonospace = 65356;
    e.lmsquare = 13264;
    e.lochulathai = 3628;
    e.logicaland = 8743;
    e.logicalnot = 172;
    e.logicalnotreversed = 8976;
    e.logicalor = 8744;
    e.lolingthai = 3621;
    e.longs = 383;
    e.lowlinecenterline = 65102;
    e.lowlinecmb = 818;
    e.lowlinedashed = 65101;
    e.lozenge = 9674;
    e.lparen = 9383;
    e.lslash = 322;
    e.lsquare = 8467;
    e.lsuperior = 63214;
    e.ltshade = 9617;
    e.luthai = 3622;
    e.lvocalicbengali = 2444;
    e.lvocalicdeva = 2316;
    e.lvocalicvowelsignbengali = 2530;
    e.lvocalicvowelsigndeva = 2402;
    e.lxsquare = 13267;
    e.m = 109;
    e.mabengali = 2478;
    e.macron = 175;
    e.macronbelowcmb = 817;
    e.macroncmb = 772;
    e.macronlowmod = 717;
    e.macronmonospace = 65507;
    e.macute = 7743;
    e.madeva = 2350;
    e.magujarati = 2734;
    e.magurmukhi = 2606;
    e.mahapakhhebrew = 1444;
    e.mahapakhlefthebrew = 1444;
    e.mahiragana = 12414;
    e.maichattawalowleftthai = 63637;
    e.maichattawalowrightthai = 63636;
    e.maichattawathai = 3659;
    e.maichattawaupperleftthai = 63635;
    e.maieklowleftthai = 63628;
    e.maieklowrightthai = 63627;
    e.maiekthai = 3656;
    e.maiekupperleftthai = 63626;
    e.maihanakatleftthai = 63620;
    e.maihanakatthai = 3633;
    e.maitaikhuleftthai = 63625;
    e.maitaikhuthai = 3655;
    e.maitholowleftthai = 63631;
    e.maitholowrightthai = 63630;
    e.maithothai = 3657;
    e.maithoupperleftthai = 63629;
    e.maitrilowleftthai = 63634;
    e.maitrilowrightthai = 63633;
    e.maitrithai = 3658;
    e.maitriupperleftthai = 63632;
    e.maiyamokthai = 3654;
    e.makatakana = 12510;
    e.makatakanahalfwidth = 65423;
    e.male = 9794;
    e.mansyonsquare = 13127;
    e.maqafhebrew = 1470;
    e.mars = 9794;
    e.masoracirclehebrew = 1455;
    e.masquare = 13187;
    e.mbopomofo = 12551;
    e.mbsquare = 13268;
    e.mcircle = 9436;
    e.mcubedsquare = 13221;
    e.mdotaccent = 7745;
    e.mdotbelow = 7747;
    e.meemarabic = 1605;
    e.meemfinalarabic = 65250;
    e.meeminitialarabic = 65251;
    e.meemmedialarabic = 65252;
    e.meemmeeminitialarabic = 64721;
    e.meemmeemisolatedarabic = 64584;
    e.meetorusquare = 13133;
    e.mehiragana = 12417;
    e.meizierasquare = 13182;
    e.mekatakana = 12513;
    e.mekatakanahalfwidth = 65426;
    e.mem = 1502;
    e.memdagesh = 64318;
    e.memdageshhebrew = 64318;
    e.memhebrew = 1502;
    e.menarmenian = 1396;
    e.merkhahebrew = 1445;
    e.merkhakefulahebrew = 1446;
    e.merkhakefulalefthebrew = 1446;
    e.merkhalefthebrew = 1445;
    e.mhook = 625;
    e.mhzsquare = 13202;
    e.middledotkatakanahalfwidth = 65381;
    e.middot = 183;
    e.mieumacirclekorean = 12914;
    e.mieumaparenkorean = 12818;
    e.mieumcirclekorean = 12900;
    e.mieumkorean = 12609;
    e.mieumpansioskorean = 12656;
    e.mieumparenkorean = 12804;
    e.mieumpieupkorean = 12654;
    e.mieumsioskorean = 12655;
    e.mihiragana = 12415;
    e.mikatakana = 12511;
    e.mikatakanahalfwidth = 65424;
    e.minus = 8722;
    e.minusbelowcmb = 800;
    e.minuscircle = 8854;
    e.minusmod = 727;
    e.minusplus = 8723;
    e.minute = 8242;
    e.miribaarusquare = 13130;
    e.mirisquare = 13129;
    e.mlonglegturned = 624;
    e.mlsquare = 13206;
    e.mmcubedsquare = 13219;
    e.mmonospace = 65357;
    e.mmsquaredsquare = 13215;
    e.mohiragana = 12418;
    e.mohmsquare = 13249;
    e.mokatakana = 12514;
    e.mokatakanahalfwidth = 65427;
    e.molsquare = 13270;
    e.momathai = 3617;
    e.moverssquare = 13223;
    e.moverssquaredsquare = 13224;
    e.mparen = 9384;
    e.mpasquare = 13227;
    e.mssquare = 13235;
    e.msuperior = 63215;
    e.mturned = 623;
    e.mu = 181;
    e.mu1 = 181;
    e.muasquare = 13186;
    e.muchgreater = 8811;
    e.muchless = 8810;
    e.mufsquare = 13196;
    e.mugreek = 956;
    e.mugsquare = 13197;
    e.muhiragana = 12416;
    e.mukatakana = 12512;
    e.mukatakanahalfwidth = 65425;
    e.mulsquare = 13205;
    e.multiply = 215;
    e.mumsquare = 13211;
    e.munahhebrew = 1443;
    e.munahlefthebrew = 1443;
    e.musicalnote = 9834;
    e.musicalnotedbl = 9835;
    e.musicflatsign = 9837;
    e.musicsharpsign = 9839;
    e.mussquare = 13234;
    e.muvsquare = 13238;
    e.muwsquare = 13244;
    e.mvmegasquare = 13241;
    e.mvsquare = 13239;
    e.mwmegasquare = 13247;
    e.mwsquare = 13245;
    e.n = 110;
    e.nabengali = 2472;
    e.nabla = 8711;
    e.nacute = 324;
    e.nadeva = 2344;
    e.nagujarati = 2728;
    e.nagurmukhi = 2600;
    e.nahiragana = 12394;
    e.nakatakana = 12490;
    e.nakatakanahalfwidth = 65413;
    e.napostrophe = 329;
    e.nasquare = 13185;
    e.nbopomofo = 12555;
    e.nbspace = 160;
    e.ncaron = 328;
    e.ncedilla = 326;
    e.ncircle = 9437;
    e.ncircumflexbelow = 7755;
    e.ncommaaccent = 326;
    e.ndotaccent = 7749;
    e.ndotbelow = 7751;
    e.nehiragana = 12397;
    e.nekatakana = 12493;
    e.nekatakanahalfwidth = 65416;
    e.newsheqelsign = 8362;
    e.nfsquare = 13195;
    e.ngabengali = 2457;
    e.ngadeva = 2329;
    e.ngagujarati = 2713;
    e.ngagurmukhi = 2585;
    e.ngonguthai = 3591;
    e.nhiragana = 12435;
    e.nhookleft = 626;
    e.nhookretroflex = 627;
    e.nieunacirclekorean = 12911;
    e.nieunaparenkorean = 12815;
    e.nieuncieuckorean = 12597;
    e.nieuncirclekorean = 12897;
    e.nieunhieuhkorean = 12598;
    e.nieunkorean = 12596;
    e.nieunpansioskorean = 12648;
    e.nieunparenkorean = 12801;
    e.nieunsioskorean = 12647;
    e.nieuntikeutkorean = 12646;
    e.nihiragana = 12395;
    e.nikatakana = 12491;
    e.nikatakanahalfwidth = 65414;
    e.nikhahitleftthai = 63641;
    e.nikhahitthai = 3661;
    e.nine = 57;
    e.ninearabic = 1641;
    e.ninebengali = 2543;
    e.ninecircle = 9320;
    e.ninecircleinversesansserif = 10130;
    e.ninedeva = 2415;
    e.ninegujarati = 2799;
    e.ninegurmukhi = 2671;
    e.ninehackarabic = 1641;
    e.ninehangzhou = 12329;
    e.nineideographicparen = 12840;
    e.nineinferior = 8329;
    e.ninemonospace = 65305;
    e.nineoldstyle = 63289;
    e.nineparen = 9340;
    e.nineperiod = 9360;
    e.ninepersian = 1785;
    e.nineroman = 8568;
    e.ninesuperior = 8313;
    e.nineteencircle = 9330;
    e.nineteenparen = 9350;
    e.nineteenperiod = 9370;
    e.ninethai = 3673;
    e.nj = 460;
    e.njecyrillic = 1114;
    e.nkatakana = 12531;
    e.nkatakanahalfwidth = 65437;
    e.nlegrightlong = 414;
    e.nlinebelow = 7753;
    e.nmonospace = 65358;
    e.nmsquare = 13210;
    e.nnabengali = 2467;
    e.nnadeva = 2339;
    e.nnagujarati = 2723;
    e.nnagurmukhi = 2595;
    e.nnnadeva = 2345;
    e.nohiragana = 12398;
    e.nokatakana = 12494;
    e.nokatakanahalfwidth = 65417;
    e.nonbreakingspace = 160;
    e.nonenthai = 3603;
    e.nonuthai = 3609;
    e.noonarabic = 1606;
    e.noonfinalarabic = 65254;
    e.noonghunnaarabic = 1722;
    e.noonghunnafinalarabic = 64415;
    e.nooninitialarabic = 65255;
    e.noonjeeminitialarabic = 64722;
    e.noonjeemisolatedarabic = 64587;
    e.noonmedialarabic = 65256;
    e.noonmeeminitialarabic = 64725;
    e.noonmeemisolatedarabic = 64590;
    e.noonnoonfinalarabic = 64653;
    e.notcontains = 8716;
    e.notelement = 8713;
    e.notelementof = 8713;
    e.notequal = 8800;
    e.notgreater = 8815;
    e.notgreaternorequal = 8817;
    e.notgreaternorless = 8825;
    e.notidentical = 8802;
    e.notless = 8814;
    e.notlessnorequal = 8816;
    e.notparallel = 8742;
    e.notprecedes = 8832;
    e.notsubset = 8836;
    e.notsucceeds = 8833;
    e.notsuperset = 8837;
    e.nowarmenian = 1398;
    e.nparen = 9385;
    e.nssquare = 13233;
    e.nsuperior = 8319;
    e.ntilde = 241;
    e.nu = 957;
    e.nuhiragana = 12396;
    e.nukatakana = 12492;
    e.nukatakanahalfwidth = 65415;
    e.nuktabengali = 2492;
    e.nuktadeva = 2364;
    e.nuktagujarati = 2748;
    e.nuktagurmukhi = 2620;
    e.numbersign = 35;
    e.numbersignmonospace = 65283;
    e.numbersignsmall = 65119;
    e.numeralsigngreek = 884;
    e.numeralsignlowergreek = 885;
    e.numero = 8470;
    e.nun = 1504;
    e.nundagesh = 64320;
    e.nundageshhebrew = 64320;
    e.nunhebrew = 1504;
    e.nvsquare = 13237;
    e.nwsquare = 13243;
    e.nyabengali = 2462;
    e.nyadeva = 2334;
    e.nyagujarati = 2718;
    e.nyagurmukhi = 2590;
    e.o = 111;
    e.oacute = 243;
    e.oangthai = 3629;
    e.obarred = 629;
    e.obarredcyrillic = 1257;
    e.obarreddieresiscyrillic = 1259;
    e.obengali = 2451;
    e.obopomofo = 12571;
    e.obreve = 335;
    e.ocandradeva = 2321;
    e.ocandragujarati = 2705;
    e.ocandravowelsigndeva = 2377;
    e.ocandravowelsigngujarati = 2761;
    e.ocaron = 466;
    e.ocircle = 9438;
    e.ocircumflex = 244;
    e.ocircumflexacute = 7889;
    e.ocircumflexdotbelow = 7897;
    e.ocircumflexgrave = 7891;
    e.ocircumflexhookabove = 7893;
    e.ocircumflextilde = 7895;
    e.ocyrillic = 1086;
    e.odblacute = 337;
    e.odblgrave = 525;
    e.odeva = 2323;
    e.odieresis = 246;
    e.odieresiscyrillic = 1255;
    e.odotbelow = 7885;
    e.oe = 339;
    e.oekorean = 12634;
    e.ogonek = 731;
    e.ogonekcmb = 808;
    e.ograve = 242;
    e.ogujarati = 2707;
    e.oharmenian = 1413;
    e.ohiragana = 12362;
    e.ohookabove = 7887;
    e.ohorn = 417;
    e.ohornacute = 7899;
    e.ohorndotbelow = 7907;
    e.ohorngrave = 7901;
    e.ohornhookabove = 7903;
    e.ohorntilde = 7905;
    e.ohungarumlaut = 337;
    e.oi = 419;
    e.oinvertedbreve = 527;
    e.okatakana = 12458;
    e.okatakanahalfwidth = 65397;
    e.okorean = 12631;
    e.olehebrew = 1451;
    e.omacron = 333;
    e.omacronacute = 7763;
    e.omacrongrave = 7761;
    e.omdeva = 2384;
    e.omega = 969;
    e.omega1 = 982;
    e.omegacyrillic = 1121;
    e.omegalatinclosed = 631;
    e.omegaroundcyrillic = 1147;
    e.omegatitlocyrillic = 1149;
    e.omegatonos = 974;
    e.omgujarati = 2768;
    e.omicron = 959;
    e.omicrontonos = 972;
    e.omonospace = 65359;
    e.one = 49;
    e.onearabic = 1633;
    e.onebengali = 2535;
    e.onecircle = 9312;
    e.onecircleinversesansserif = 10122;
    e.onedeva = 2407;
    e.onedotenleader = 8228;
    e.oneeighth = 8539;
    e.onefitted = 63196;
    e.onegujarati = 2791;
    e.onegurmukhi = 2663;
    e.onehackarabic = 1633;
    e.onehalf = 189;
    e.onehangzhou = 12321;
    e.oneideographicparen = 12832;
    e.oneinferior = 8321;
    e.onemonospace = 65297;
    e.onenumeratorbengali = 2548;
    e.oneoldstyle = 63281;
    e.oneparen = 9332;
    e.oneperiod = 9352;
    e.onepersian = 1777;
    e.onequarter = 188;
    e.oneroman = 8560;
    e.onesuperior = 185;
    e.onethai = 3665;
    e.onethird = 8531;
    e.oogonek = 491;
    e.oogonekmacron = 493;
    e.oogurmukhi = 2579;
    e.oomatragurmukhi = 2635;
    e.oopen = 596;
    e.oparen = 9386;
    e.openbullet = 9702;
    e.option = 8997;
    e.ordfeminine = 170;
    e.ordmasculine = 186;
    e.orthogonal = 8735;
    e.oshortdeva = 2322;
    e.oshortvowelsigndeva = 2378;
    e.oslash = 248;
    e.oslashacute = 511;
    e.osmallhiragana = 12361;
    e.osmallkatakana = 12457;
    e.osmallkatakanahalfwidth = 65387;
    e.ostrokeacute = 511;
    e.osuperior = 63216;
    e.otcyrillic = 1151;
    e.otilde = 245;
    e.otildeacute = 7757;
    e.otildedieresis = 7759;
    e.oubopomofo = 12577;
    e.overline = 8254;
    e.overlinecenterline = 65098;
    e.overlinecmb = 773;
    e.overlinedashed = 65097;
    e.overlinedblwavy = 65100;
    e.overlinewavy = 65099;
    e.overscore = 175;
    e.ovowelsignbengali = 2507;
    e.ovowelsigndeva = 2379;
    e.ovowelsigngujarati = 2763;
    e.p = 112;
    e.paampssquare = 13184;
    e.paasentosquare = 13099;
    e.pabengali = 2474;
    e.pacute = 7765;
    e.padeva = 2346;
    e.pagedown = 8671;
    e.pageup = 8670;
    e.pagujarati = 2730;
    e.pagurmukhi = 2602;
    e.pahiragana = 12401;
    e.paiyannoithai = 3631;
    e.pakatakana = 12497;
    e.palatalizationcyrilliccmb = 1156;
    e.palochkacyrillic = 1216;
    e.pansioskorean = 12671;
    e.paragraph = 182;
    e.parallel = 8741;
    e.parenleft = 40;
    e.parenleftaltonearabic = 64830;
    e.parenleftbt = 63725;
    e.parenleftex = 63724;
    e.parenleftinferior = 8333;
    e.parenleftmonospace = 65288;
    e.parenleftsmall = 65113;
    e.parenleftsuperior = 8317;
    e.parenlefttp = 63723;
    e.parenleftvertical = 65077;
    e.parenright = 41;
    e.parenrightaltonearabic = 64831;
    e.parenrightbt = 63736;
    e.parenrightex = 63735;
    e.parenrightinferior = 8334;
    e.parenrightmonospace = 65289;
    e.parenrightsmall = 65114;
    e.parenrightsuperior = 8318;
    e.parenrighttp = 63734;
    e.parenrightvertical = 65078;
    e.partialdiff = 8706;
    e.paseqhebrew = 1472;
    e.pashtahebrew = 1433;
    e.pasquare = 13225;
    e.patah = 1463;
    e.patah11 = 1463;
    e.patah1d = 1463;
    e.patah2a = 1463;
    e.patahhebrew = 1463;
    e.patahnarrowhebrew = 1463;
    e.patahquarterhebrew = 1463;
    e.patahwidehebrew = 1463;
    e.pazerhebrew = 1441;
    e.pbopomofo = 12550;
    e.pcircle = 9439;
    e.pdotaccent = 7767;
    e.pe = 1508;
    e.pecyrillic = 1087;
    e.pedagesh = 64324;
    e.pedageshhebrew = 64324;
    e.peezisquare = 13115;
    e.pefinaldageshhebrew = 64323;
    e.peharabic = 1662;
    e.peharmenian = 1402;
    e.pehebrew = 1508;
    e.pehfinalarabic = 64343;
    e.pehinitialarabic = 64344;
    e.pehiragana = 12410;
    e.pehmedialarabic = 64345;
    e.pekatakana = 12506;
    e.pemiddlehookcyrillic = 1191;
    e.perafehebrew = 64334;
    e.percent = 37;
    e.percentarabic = 1642;
    e.percentmonospace = 65285;
    e.percentsmall = 65130;
    e.period = 46;
    e.periodarmenian = 1417;
    e.periodcentered = 183;
    e.periodhalfwidth = 65377;
    e.periodinferior = 63207;
    e.periodmonospace = 65294;
    e.periodsmall = 65106;
    e.periodsuperior = 63208;
    e.perispomenigreekcmb = 834;
    e.perpendicular = 8869;
    e.perthousand = 8240;
    e.peseta = 8359;
    e.pfsquare = 13194;
    e.phabengali = 2475;
    e.phadeva = 2347;
    e.phagujarati = 2731;
    e.phagurmukhi = 2603;
    e.phi = 966;
    e.phi1 = 981;
    e.phieuphacirclekorean = 12922;
    e.phieuphaparenkorean = 12826;
    e.phieuphcirclekorean = 12908;
    e.phieuphkorean = 12621;
    e.phieuphparenkorean = 12812;
    e.philatin = 632;
    e.phinthuthai = 3642;
    e.phisymbolgreek = 981;
    e.phook = 421;
    e.phophanthai = 3614;
    e.phophungthai = 3612;
    e.phosamphaothai = 3616;
    e.pi = 960;
    e.pieupacirclekorean = 12915;
    e.pieupaparenkorean = 12819;
    e.pieupcieuckorean = 12662;
    e.pieupcirclekorean = 12901;
    e.pieupkiyeokkorean = 12658;
    e.pieupkorean = 12610;
    e.pieupparenkorean = 12805;
    e.pieupsioskiyeokkorean = 12660;
    e.pieupsioskorean = 12612;
    e.pieupsiostikeutkorean = 12661;
    e.pieupthieuthkorean = 12663;
    e.pieuptikeutkorean = 12659;
    e.pihiragana = 12404;
    e.pikatakana = 12500;
    e.pisymbolgreek = 982;
    e.piwrarmenian = 1411;
    e.planckover2pi = 8463;
    e.planckover2pi1 = 8463;
    e.plus = 43;
    e.plusbelowcmb = 799;
    e.pluscircle = 8853;
    e.plusminus = 177;
    e.plusmod = 726;
    e.plusmonospace = 65291;
    e.plussmall = 65122;
    e.plussuperior = 8314;
    e.pmonospace = 65360;
    e.pmsquare = 13272;
    e.pohiragana = 12413;
    e.pointingindexdownwhite = 9759;
    e.pointingindexleftwhite = 9756;
    e.pointingindexrightwhite = 9758;
    e.pointingindexupwhite = 9757;
    e.pokatakana = 12509;
    e.poplathai = 3611;
    e.postalmark = 12306;
    e.postalmarkface = 12320;
    e.pparen = 9387;
    e.precedes = 8826;
    e.prescription = 8478;
    e.primemod = 697;
    e.primereversed = 8245;
    e.product = 8719;
    e.projective = 8965;
    e.prolongedkana = 12540;
    e.propellor = 8984;
    e.propersubset = 8834;
    e.propersuperset = 8835;
    e.proportion = 8759;
    e.proportional = 8733;
    e.psi = 968;
    e.psicyrillic = 1137;
    e.psilipneumatacyrilliccmb = 1158;
    e.pssquare = 13232;
    e.puhiragana = 12407;
    e.pukatakana = 12503;
    e.pvsquare = 13236;
    e.pwsquare = 13242;
    e.q = 113;
    e.qadeva = 2392;
    e.qadmahebrew = 1448;
    e.qafarabic = 1602;
    e.qaffinalarabic = 65238;
    e.qafinitialarabic = 65239;
    e.qafmedialarabic = 65240;
    e.qamats = 1464;
    e.qamats10 = 1464;
    e.qamats1a = 1464;
    e.qamats1c = 1464;
    e.qamats27 = 1464;
    e.qamats29 = 1464;
    e.qamats33 = 1464;
    e.qamatsde = 1464;
    e.qamatshebrew = 1464;
    e.qamatsnarrowhebrew = 1464;
    e.qamatsqatanhebrew = 1464;
    e.qamatsqatannarrowhebrew = 1464;
    e.qamatsqatanquarterhebrew = 1464;
    e.qamatsqatanwidehebrew = 1464;
    e.qamatsquarterhebrew = 1464;
    e.qamatswidehebrew = 1464;
    e.qarneyparahebrew = 1439;
    e.qbopomofo = 12561;
    e.qcircle = 9440;
    e.qhook = 672;
    e.qmonospace = 65361;
    e.qof = 1511;
    e.qofdagesh = 64327;
    e.qofdageshhebrew = 64327;
    e.qofhebrew = 1511;
    e.qparen = 9388;
    e.quarternote = 9833;
    e.qubuts = 1467;
    e.qubuts18 = 1467;
    e.qubuts25 = 1467;
    e.qubuts31 = 1467;
    e.qubutshebrew = 1467;
    e.qubutsnarrowhebrew = 1467;
    e.qubutsquarterhebrew = 1467;
    e.qubutswidehebrew = 1467;
    e.question = 63;
    e.questionarabic = 1567;
    e.questionarmenian = 1374;
    e.questiondown = 191;
    e.questiondownsmall = 63423;
    e.questiongreek = 894;
    e.questionmonospace = 65311;
    e.questionsmall = 63295;
    e.quotedbl = 34;
    e.quotedblbase = 8222;
    e.quotedblleft = 8220;
    e.quotedblmonospace = 65282;
    e.quotedblprime = 12318;
    e.quotedblprimereversed = 12317;
    e.quotedblright = 8221;
    e.quoteleft = 8216;
    e.quoteleftreversed = 8219;
    e.quotereversed = 8219;
    e.quoteright = 8217;
    e.quoterightn = 329;
    e.quotesinglbase = 8218;
    e.quotesingle = 39;
    e.quotesinglemonospace = 65287;
    e.r = 114;
    e.raarmenian = 1404;
    e.rabengali = 2480;
    e.racute = 341;
    e.radeva = 2352;
    e.radical = 8730;
    e.radicalex = 63717;
    e.radoverssquare = 13230;
    e.radoverssquaredsquare = 13231;
    e.radsquare = 13229;
    e.rafe = 1471;
    e.rafehebrew = 1471;
    e.ragujarati = 2736;
    e.ragurmukhi = 2608;
    e.rahiragana = 12425;
    e.rakatakana = 12521;
    e.rakatakanahalfwidth = 65431;
    e.ralowerdiagonalbengali = 2545;
    e.ramiddlediagonalbengali = 2544;
    e.ramshorn = 612;
    e.ratio = 8758;
    e.rbopomofo = 12566;
    e.rcaron = 345;
    e.rcedilla = 343;
    e.rcircle = 9441;
    e.rcommaaccent = 343;
    e.rdblgrave = 529;
    e.rdotaccent = 7769;
    e.rdotbelow = 7771;
    e.rdotbelowmacron = 7773;
    e.referencemark = 8251;
    e.reflexsubset = 8838;
    e.reflexsuperset = 8839;
    e.registered = 174;
    e.registersans = 63720;
    e.registerserif = 63194;
    e.reharabic = 1585;
    e.reharmenian = 1408;
    e.rehfinalarabic = 65198;
    e.rehiragana = 12428;
    e.rekatakana = 12524;
    e.rekatakanahalfwidth = 65434;
    e.resh = 1512;
    e.reshdageshhebrew = 64328;
    e.reshhebrew = 1512;
    e.reversedtilde = 8765;
    e.reviahebrew = 1431;
    e.reviamugrashhebrew = 1431;
    e.revlogicalnot = 8976;
    e.rfishhook = 638;
    e.rfishhookreversed = 639;
    e.rhabengali = 2525;
    e.rhadeva = 2397;
    e.rho = 961;
    e.rhook = 637;
    e.rhookturned = 635;
    e.rhookturnedsuperior = 693;
    e.rhosymbolgreek = 1009;
    e.rhotichookmod = 734;
    e.rieulacirclekorean = 12913;
    e.rieulaparenkorean = 12817;
    e.rieulcirclekorean = 12899;
    e.rieulhieuhkorean = 12608;
    e.rieulkiyeokkorean = 12602;
    e.rieulkiyeoksioskorean = 12649;
    e.rieulkorean = 12601;
    e.rieulmieumkorean = 12603;
    e.rieulpansioskorean = 12652;
    e.rieulparenkorean = 12803;
    e.rieulphieuphkorean = 12607;
    e.rieulpieupkorean = 12604;
    e.rieulpieupsioskorean = 12651;
    e.rieulsioskorean = 12605;
    e.rieulthieuthkorean = 12606;
    e.rieultikeutkorean = 12650;
    e.rieulyeorinhieuhkorean = 12653;
    e.rightangle = 8735;
    e.righttackbelowcmb = 793;
    e.righttriangle = 8895;
    e.rihiragana = 12426;
    e.rikatakana = 12522;
    e.rikatakanahalfwidth = 65432;
    e.ring = 730;
    e.ringbelowcmb = 805;
    e.ringcmb = 778;
    e.ringhalfleft = 703;
    e.ringhalfleftarmenian = 1369;
    e.ringhalfleftbelowcmb = 796;
    e.ringhalfleftcentered = 723;
    e.ringhalfright = 702;
    e.ringhalfrightbelowcmb = 825;
    e.ringhalfrightcentered = 722;
    e.rinvertedbreve = 531;
    e.rittorusquare = 13137;
    e.rlinebelow = 7775;
    e.rlongleg = 636;
    e.rlonglegturned = 634;
    e.rmonospace = 65362;
    e.rohiragana = 12429;
    e.rokatakana = 12525;
    e.rokatakanahalfwidth = 65435;
    e.roruathai = 3619;
    e.rparen = 9389;
    e.rrabengali = 2524;
    e.rradeva = 2353;
    e.rragurmukhi = 2652;
    e.rreharabic = 1681;
    e.rrehfinalarabic = 64397;
    e.rrvocalicbengali = 2528;
    e.rrvocalicdeva = 2400;
    e.rrvocalicgujarati = 2784;
    e.rrvocalicvowelsignbengali = 2500;
    e.rrvocalicvowelsigndeva = 2372;
    e.rrvocalicvowelsigngujarati = 2756;
    e.rsuperior = 63217;
    e.rtblock = 9616;
    e.rturned = 633;
    e.rturnedsuperior = 692;
    e.ruhiragana = 12427;
    e.rukatakana = 12523;
    e.rukatakanahalfwidth = 65433;
    e.rupeemarkbengali = 2546;
    e.rupeesignbengali = 2547;
    e.rupiah = 63197;
    e.ruthai = 3620;
    e.rvocalicbengali = 2443;
    e.rvocalicdeva = 2315;
    e.rvocalicgujarati = 2699;
    e.rvocalicvowelsignbengali = 2499;
    e.rvocalicvowelsigndeva = 2371;
    e.rvocalicvowelsigngujarati = 2755;
    e.s = 115;
    e.sabengali = 2488;
    e.sacute = 347;
    e.sacutedotaccent = 7781;
    e.sadarabic = 1589;
    e.sadeva = 2360;
    e.sadfinalarabic = 65210;
    e.sadinitialarabic = 65211;
    e.sadmedialarabic = 65212;
    e.sagujarati = 2744;
    e.sagurmukhi = 2616;
    e.sahiragana = 12373;
    e.sakatakana = 12469;
    e.sakatakanahalfwidth = 65403;
    e.sallallahoualayhewasallamarabic = 65018;
    e.samekh = 1505;
    e.samekhdagesh = 64321;
    e.samekhdageshhebrew = 64321;
    e.samekhhebrew = 1505;
    e.saraaathai = 3634;
    e.saraaethai = 3649;
    e.saraaimaimalaithai = 3652;
    e.saraaimaimuanthai = 3651;
    e.saraamthai = 3635;
    e.saraathai = 3632;
    e.saraethai = 3648;
    e.saraiileftthai = 63622;
    e.saraiithai = 3637;
    e.saraileftthai = 63621;
    e.saraithai = 3636;
    e.saraothai = 3650;
    e.saraueeleftthai = 63624;
    e.saraueethai = 3639;
    e.saraueleftthai = 63623;
    e.sarauethai = 3638;
    e.sarauthai = 3640;
    e.sarauuthai = 3641;
    e.sbopomofo = 12569;
    e.scaron = 353;
    e.scarondotaccent = 7783;
    e.scedilla = 351;
    e.schwa = 601;
    e.schwacyrillic = 1241;
    e.schwadieresiscyrillic = 1243;
    e.schwahook = 602;
    e.scircle = 9442;
    e.scircumflex = 349;
    e.scommaaccent = 537;
    e.sdotaccent = 7777;
    e.sdotbelow = 7779;
    e.sdotbelowdotaccent = 7785;
    e.seagullbelowcmb = 828;
    e.second = 8243;
    e.secondtonechinese = 714;
    e.section = 167;
    e.seenarabic = 1587;
    e.seenfinalarabic = 65202;
    e.seeninitialarabic = 65203;
    e.seenmedialarabic = 65204;
    e.segol = 1462;
    e.segol13 = 1462;
    e.segol1f = 1462;
    e.segol2c = 1462;
    e.segolhebrew = 1462;
    e.segolnarrowhebrew = 1462;
    e.segolquarterhebrew = 1462;
    e.segoltahebrew = 1426;
    e.segolwidehebrew = 1462;
    e.seharmenian = 1405;
    e.sehiragana = 12379;
    e.sekatakana = 12475;
    e.sekatakanahalfwidth = 65406;
    e.semicolon = 59;
    e.semicolonarabic = 1563;
    e.semicolonmonospace = 65307;
    e.semicolonsmall = 65108;
    e.semivoicedmarkkana = 12444;
    e.semivoicedmarkkanahalfwidth = 65439;
    e.sentisquare = 13090;
    e.sentosquare = 13091;
    e.seven = 55;
    e.sevenarabic = 1639;
    e.sevenbengali = 2541;
    e.sevencircle = 9318;
    e.sevencircleinversesansserif = 10128;
    e.sevendeva = 2413;
    e.seveneighths = 8542;
    e.sevengujarati = 2797;
    e.sevengurmukhi = 2669;
    e.sevenhackarabic = 1639;
    e.sevenhangzhou = 12327;
    e.sevenideographicparen = 12838;
    e.seveninferior = 8327;
    e.sevenmonospace = 65303;
    e.sevenoldstyle = 63287;
    e.sevenparen = 9338;
    e.sevenperiod = 9358;
    e.sevenpersian = 1783;
    e.sevenroman = 8566;
    e.sevensuperior = 8311;
    e.seventeencircle = 9328;
    e.seventeenparen = 9348;
    e.seventeenperiod = 9368;
    e.seventhai = 3671;
    e.sfthyphen = 173;
    e.shaarmenian = 1399;
    e.shabengali = 2486;
    e.shacyrillic = 1096;
    e.shaddaarabic = 1617;
    e.shaddadammaarabic = 64609;
    e.shaddadammatanarabic = 64606;
    e.shaddafathaarabic = 64608;
    e.shaddakasraarabic = 64610;
    e.shaddakasratanarabic = 64607;
    e.shade = 9618;
    e.shadedark = 9619;
    e.shadelight = 9617;
    e.shademedium = 9618;
    e.shadeva = 2358;
    e.shagujarati = 2742;
    e.shagurmukhi = 2614;
    e.shalshelethebrew = 1427;
    e.shbopomofo = 12565;
    e.shchacyrillic = 1097;
    e.sheenarabic = 1588;
    e.sheenfinalarabic = 65206;
    e.sheeninitialarabic = 65207;
    e.sheenmedialarabic = 65208;
    e.sheicoptic = 995;
    e.sheqel = 8362;
    e.sheqelhebrew = 8362;
    e.sheva = 1456;
    e.sheva115 = 1456;
    e.sheva15 = 1456;
    e.sheva22 = 1456;
    e.sheva2e = 1456;
    e.shevahebrew = 1456;
    e.shevanarrowhebrew = 1456;
    e.shevaquarterhebrew = 1456;
    e.shevawidehebrew = 1456;
    e.shhacyrillic = 1211;
    e.shimacoptic = 1005;
    e.shin = 1513;
    e.shindagesh = 64329;
    e.shindageshhebrew = 64329;
    e.shindageshshindot = 64300;
    e.shindageshshindothebrew = 64300;
    e.shindageshsindot = 64301;
    e.shindageshsindothebrew = 64301;
    e.shindothebrew = 1473;
    e.shinhebrew = 1513;
    e.shinshindot = 64298;
    e.shinshindothebrew = 64298;
    e.shinsindot = 64299;
    e.shinsindothebrew = 64299;
    e.shook = 642;
    e.sigma = 963;
    e.sigma1 = 962;
    e.sigmafinal = 962;
    e.sigmalunatesymbolgreek = 1010;
    e.sihiragana = 12375;
    e.sikatakana = 12471;
    e.sikatakanahalfwidth = 65404;
    e.siluqhebrew = 1469;
    e.siluqlefthebrew = 1469;
    e.similar = 8764;
    e.sindothebrew = 1474;
    e.siosacirclekorean = 12916;
    e.siosaparenkorean = 12820;
    e.sioscieuckorean = 12670;
    e.sioscirclekorean = 12902;
    e.sioskiyeokkorean = 12666;
    e.sioskorean = 12613;
    e.siosnieunkorean = 12667;
    e.siosparenkorean = 12806;
    e.siospieupkorean = 12669;
    e.siostikeutkorean = 12668;
    e.six = 54;
    e.sixarabic = 1638;
    e.sixbengali = 2540;
    e.sixcircle = 9317;
    e.sixcircleinversesansserif = 10127;
    e.sixdeva = 2412;
    e.sixgujarati = 2796;
    e.sixgurmukhi = 2668;
    e.sixhackarabic = 1638;
    e.sixhangzhou = 12326;
    e.sixideographicparen = 12837;
    e.sixinferior = 8326;
    e.sixmonospace = 65302;
    e.sixoldstyle = 63286;
    e.sixparen = 9337;
    e.sixperiod = 9357;
    e.sixpersian = 1782;
    e.sixroman = 8565;
    e.sixsuperior = 8310;
    e.sixteencircle = 9327;
    e.sixteencurrencydenominatorbengali = 2553;
    e.sixteenparen = 9347;
    e.sixteenperiod = 9367;
    e.sixthai = 3670;
    e.slash = 47;
    e.slashmonospace = 65295;
    e.slong = 383;
    e.slongdotaccent = 7835;
    e.smileface = 9786;
    e.smonospace = 65363;
    e.sofpasuqhebrew = 1475;
    e.softhyphen = 173;
    e.softsigncyrillic = 1100;
    e.sohiragana = 12381;
    e.sokatakana = 12477;
    e.sokatakanahalfwidth = 65407;
    e.soliduslongoverlaycmb = 824;
    e.solidusshortoverlaycmb = 823;
    e.sorusithai = 3625;
    e.sosalathai = 3624;
    e.sosothai = 3595;
    e.sosuathai = 3626;
    e.space = 32;
    e.spacehackarabic = 32;
    e.spade = 9824;
    e.spadesuitblack = 9824;
    e.spadesuitwhite = 9828;
    e.sparen = 9390;
    e.squarebelowcmb = 827;
    e.squarecc = 13252;
    e.squarecm = 13213;
    e.squarediagonalcrosshatchfill = 9641;
    e.squarehorizontalfill = 9636;
    e.squarekg = 13199;
    e.squarekm = 13214;
    e.squarekmcapital = 13262;
    e.squareln = 13265;
    e.squarelog = 13266;
    e.squaremg = 13198;
    e.squaremil = 13269;
    e.squaremm = 13212;
    e.squaremsquared = 13217;
    e.squareorthogonalcrosshatchfill = 9638;
    e.squareupperlefttolowerrightfill = 9639;
    e.squareupperrighttolowerleftfill = 9640;
    e.squareverticalfill = 9637;
    e.squarewhitewithsmallblack = 9635;
    e.srsquare = 13275;
    e.ssabengali = 2487;
    e.ssadeva = 2359;
    e.ssagujarati = 2743;
    e.ssangcieuckorean = 12617;
    e.ssanghieuhkorean = 12677;
    e.ssangieungkorean = 12672;
    e.ssangkiyeokkorean = 12594;
    e.ssangnieunkorean = 12645;
    e.ssangpieupkorean = 12611;
    e.ssangsioskorean = 12614;
    e.ssangtikeutkorean = 12600;
    e.ssuperior = 63218;
    e.sterling = 163;
    e.sterlingmonospace = 65505;
    e.strokelongoverlaycmb = 822;
    e.strokeshortoverlaycmb = 821;
    e.subset = 8834;
    e.subsetnotequal = 8842;
    e.subsetorequal = 8838;
    e.succeeds = 8827;
    e.suchthat = 8715;
    e.suhiragana = 12377;
    e.sukatakana = 12473;
    e.sukatakanahalfwidth = 65405;
    e.sukunarabic = 1618;
    e.summation = 8721;
    e.sun = 9788;
    e.superset = 8835;
    e.supersetnotequal = 8843;
    e.supersetorequal = 8839;
    e.svsquare = 13276;
    e.syouwaerasquare = 13180;
    e.t = 116;
    e.tabengali = 2468;
    e.tackdown = 8868;
    e.tackleft = 8867;
    e.tadeva = 2340;
    e.tagujarati = 2724;
    e.tagurmukhi = 2596;
    e.taharabic = 1591;
    e.tahfinalarabic = 65218;
    e.tahinitialarabic = 65219;
    e.tahiragana = 12383;
    e.tahmedialarabic = 65220;
    e.taisyouerasquare = 13181;
    e.takatakana = 12479;
    e.takatakanahalfwidth = 65408;
    e.tatweelarabic = 1600;
    e.tau = 964;
    e.tav = 1514;
    e.tavdages = 64330;
    e.tavdagesh = 64330;
    e.tavdageshhebrew = 64330;
    e.tavhebrew = 1514;
    e.tbar = 359;
    e.tbopomofo = 12554;
    e.tcaron = 357;
    e.tccurl = 680;
    e.tcedilla = 355;
    e.tcheharabic = 1670;
    e.tchehfinalarabic = 64379;
    e.tchehinitialarabic = 64380;
    e.tchehmedialarabic = 64381;
    e.tcircle = 9443;
    e.tcircumflexbelow = 7793;
    e.tcommaaccent = 355;
    e.tdieresis = 7831;
    e.tdotaccent = 7787;
    e.tdotbelow = 7789;
    e.tecyrillic = 1090;
    e.tedescendercyrillic = 1197;
    e.teharabic = 1578;
    e.tehfinalarabic = 65174;
    e.tehhahinitialarabic = 64674;
    e.tehhahisolatedarabic = 64524;
    e.tehinitialarabic = 65175;
    e.tehiragana = 12390;
    e.tehjeeminitialarabic = 64673;
    e.tehjeemisolatedarabic = 64523;
    e.tehmarbutaarabic = 1577;
    e.tehmarbutafinalarabic = 65172;
    e.tehmedialarabic = 65176;
    e.tehmeeminitialarabic = 64676;
    e.tehmeemisolatedarabic = 64526;
    e.tehnoonfinalarabic = 64627;
    e.tekatakana = 12486;
    e.tekatakanahalfwidth = 65411;
    e.telephone = 8481;
    e.telephoneblack = 9742;
    e.telishagedolahebrew = 1440;
    e.telishaqetanahebrew = 1449;
    e.tencircle = 9321;
    e.tenideographicparen = 12841;
    e.tenparen = 9341;
    e.tenperiod = 9361;
    e.tenroman = 8569;
    e.tesh = 679;
    e.tet = 1496;
    e.tetdagesh = 64312;
    e.tetdageshhebrew = 64312;
    e.tethebrew = 1496;
    e.tetsecyrillic = 1205;
    e.tevirhebrew = 1435;
    e.tevirlefthebrew = 1435;
    e.thabengali = 2469;
    e.thadeva = 2341;
    e.thagujarati = 2725;
    e.thagurmukhi = 2597;
    e.thalarabic = 1584;
    e.thalfinalarabic = 65196;
    e.thanthakhatlowleftthai = 63640;
    e.thanthakhatlowrightthai = 63639;
    e.thanthakhatthai = 3660;
    e.thanthakhatupperleftthai = 63638;
    e.theharabic = 1579;
    e.thehfinalarabic = 65178;
    e.thehinitialarabic = 65179;
    e.thehmedialarabic = 65180;
    e.thereexists = 8707;
    e.therefore = 8756;
    e.theta = 952;
    e.theta1 = 977;
    e.thetasymbolgreek = 977;
    e.thieuthacirclekorean = 12921;
    e.thieuthaparenkorean = 12825;
    e.thieuthcirclekorean = 12907;
    e.thieuthkorean = 12620;
    e.thieuthparenkorean = 12811;
    e.thirteencircle = 9324;
    e.thirteenparen = 9344;
    e.thirteenperiod = 9364;
    e.thonangmonthothai = 3601;
    e.thook = 429;
    e.thophuthaothai = 3602;
    e.thorn = 254;
    e.thothahanthai = 3607;
    e.thothanthai = 3600;
    e.thothongthai = 3608;
    e.thothungthai = 3606;
    e.thousandcyrillic = 1154;
    e.thousandsseparatorarabic = 1644;
    e.thousandsseparatorpersian = 1644;
    e.three = 51;
    e.threearabic = 1635;
    e.threebengali = 2537;
    e.threecircle = 9314;
    e.threecircleinversesansserif = 10124;
    e.threedeva = 2409;
    e.threeeighths = 8540;
    e.threegujarati = 2793;
    e.threegurmukhi = 2665;
    e.threehackarabic = 1635;
    e.threehangzhou = 12323;
    e.threeideographicparen = 12834;
    e.threeinferior = 8323;
    e.threemonospace = 65299;
    e.threenumeratorbengali = 2550;
    e.threeoldstyle = 63283;
    e.threeparen = 9334;
    e.threeperiod = 9354;
    e.threepersian = 1779;
    e.threequarters = 190;
    e.threequartersemdash = 63198;
    e.threeroman = 8562;
    e.threesuperior = 179;
    e.threethai = 3667;
    e.thzsquare = 13204;
    e.tihiragana = 12385;
    e.tikatakana = 12481;
    e.tikatakanahalfwidth = 65409;
    e.tikeutacirclekorean = 12912;
    e.tikeutaparenkorean = 12816;
    e.tikeutcirclekorean = 12898;
    e.tikeutkorean = 12599;
    e.tikeutparenkorean = 12802;
    e.tilde = 732;
    e.tildebelowcmb = 816;
    e.tildecmb = 771;
    e.tildecomb = 771;
    e.tildedoublecmb = 864;
    e.tildeoperator = 8764;
    e.tildeoverlaycmb = 820;
    e.tildeverticalcmb = 830;
    e.timescircle = 8855;
    e.tipehahebrew = 1430;
    e.tipehalefthebrew = 1430;
    e.tippigurmukhi = 2672;
    e.titlocyrilliccmb = 1155;
    e.tiwnarmenian = 1407;
    e.tlinebelow = 7791;
    e.tmonospace = 65364;
    e.toarmenian = 1385;
    e.tohiragana = 12392;
    e.tokatakana = 12488;
    e.tokatakanahalfwidth = 65412;
    e.tonebarextrahighmod = 741;
    e.tonebarextralowmod = 745;
    e.tonebarhighmod = 742;
    e.tonebarlowmod = 744;
    e.tonebarmidmod = 743;
    e.tonefive = 445;
    e.tonesix = 389;
    e.tonetwo = 424;
    e.tonos = 900;
    e.tonsquare = 13095;
    e.topatakthai = 3599;
    e.tortoiseshellbracketleft = 12308;
    e.tortoiseshellbracketleftsmall = 65117;
    e.tortoiseshellbracketleftvertical = 65081;
    e.tortoiseshellbracketright = 12309;
    e.tortoiseshellbracketrightsmall = 65118;
    e.tortoiseshellbracketrightvertical = 65082;
    e.totaothai = 3605;
    e.tpalatalhook = 427;
    e.tparen = 9391;
    e.trademark = 8482;
    e.trademarksans = 63722;
    e.trademarkserif = 63195;
    e.tretroflexhook = 648;
    e.triagdn = 9660;
    e.triaglf = 9668;
    e.triagrt = 9658;
    e.triagup = 9650;
    e.ts = 678;
    e.tsadi = 1510;
    e.tsadidagesh = 64326;
    e.tsadidageshhebrew = 64326;
    e.tsadihebrew = 1510;
    e.tsecyrillic = 1094;
    e.tsere = 1461;
    e.tsere12 = 1461;
    e.tsere1e = 1461;
    e.tsere2b = 1461;
    e.tserehebrew = 1461;
    e.tserenarrowhebrew = 1461;
    e.tserequarterhebrew = 1461;
    e.tserewidehebrew = 1461;
    e.tshecyrillic = 1115;
    e.tsuperior = 63219;
    e.ttabengali = 2463;
    e.ttadeva = 2335;
    e.ttagujarati = 2719;
    e.ttagurmukhi = 2591;
    e.tteharabic = 1657;
    e.ttehfinalarabic = 64359;
    e.ttehinitialarabic = 64360;
    e.ttehmedialarabic = 64361;
    e.tthabengali = 2464;
    e.tthadeva = 2336;
    e.tthagujarati = 2720;
    e.tthagurmukhi = 2592;
    e.tturned = 647;
    e.tuhiragana = 12388;
    e.tukatakana = 12484;
    e.tukatakanahalfwidth = 65410;
    e.tusmallhiragana = 12387;
    e.tusmallkatakana = 12483;
    e.tusmallkatakanahalfwidth = 65391;
    e.twelvecircle = 9323;
    e.twelveparen = 9343;
    e.twelveperiod = 9363;
    e.twelveroman = 8571;
    e.twentycircle = 9331;
    e.twentyhangzhou = 21316;
    e.twentyparen = 9351;
    e.twentyperiod = 9371;
    e.two = 50;
    e.twoarabic = 1634;
    e.twobengali = 2536;
    e.twocircle = 9313;
    e.twocircleinversesansserif = 10123;
    e.twodeva = 2408;
    e.twodotenleader = 8229;
    e.twodotleader = 8229;
    e.twodotleadervertical = 65072;
    e.twogujarati = 2792;
    e.twogurmukhi = 2664;
    e.twohackarabic = 1634;
    e.twohangzhou = 12322;
    e.twoideographicparen = 12833;
    e.twoinferior = 8322;
    e.twomonospace = 65298;
    e.twonumeratorbengali = 2549;
    e.twooldstyle = 63282;
    e.twoparen = 9333;
    e.twoperiod = 9353;
    e.twopersian = 1778;
    e.tworoman = 8561;
    e.twostroke = 443;
    e.twosuperior = 178;
    e.twothai = 3666;
    e.twothirds = 8532;
    e.u = 117;
    e.uacute = 250;
    e.ubar = 649;
    e.ubengali = 2441;
    e.ubopomofo = 12584;
    e.ubreve = 365;
    e.ucaron = 468;
    e.ucircle = 9444;
    e.ucircumflex = 251;
    e.ucircumflexbelow = 7799;
    e.ucyrillic = 1091;
    e.udattadeva = 2385;
    e.udblacute = 369;
    e.udblgrave = 533;
    e.udeva = 2313;
    e.udieresis = 252;
    e.udieresisacute = 472;
    e.udieresisbelow = 7795;
    e.udieresiscaron = 474;
    e.udieresiscyrillic = 1265;
    e.udieresisgrave = 476;
    e.udieresismacron = 470;
    e.udotbelow = 7909;
    e.ugrave = 249;
    e.ugujarati = 2697;
    e.ugurmukhi = 2569;
    e.uhiragana = 12358;
    e.uhookabove = 7911;
    e.uhorn = 432;
    e.uhornacute = 7913;
    e.uhorndotbelow = 7921;
    e.uhorngrave = 7915;
    e.uhornhookabove = 7917;
    e.uhorntilde = 7919;
    e.uhungarumlaut = 369;
    e.uhungarumlautcyrillic = 1267;
    e.uinvertedbreve = 535;
    e.ukatakana = 12454;
    e.ukatakanahalfwidth = 65395;
    e.ukcyrillic = 1145;
    e.ukorean = 12636;
    e.umacron = 363;
    e.umacroncyrillic = 1263;
    e.umacrondieresis = 7803;
    e.umatragurmukhi = 2625;
    e.umonospace = 65365;
    e.underscore = 95;
    e.underscoredbl = 8215;
    e.underscoremonospace = 65343;
    e.underscorevertical = 65075;
    e.underscorewavy = 65103;
    e.union = 8746;
    e.universal = 8704;
    e.uogonek = 371;
    e.uparen = 9392;
    e.upblock = 9600;
    e.upperdothebrew = 1476;
    e.upsilon = 965;
    e.upsilondieresis = 971;
    e.upsilondieresistonos = 944;
    e.upsilonlatin = 650;
    e.upsilontonos = 973;
    e.uptackbelowcmb = 797;
    e.uptackmod = 724;
    e.uragurmukhi = 2675;
    e.uring = 367;
    e.ushortcyrillic = 1118;
    e.usmallhiragana = 12357;
    e.usmallkatakana = 12453;
    e.usmallkatakanahalfwidth = 65385;
    e.ustraightcyrillic = 1199;
    e.ustraightstrokecyrillic = 1201;
    e.utilde = 361;
    e.utildeacute = 7801;
    e.utildebelow = 7797;
    e.uubengali = 2442;
    e.uudeva = 2314;
    e.uugujarati = 2698;
    e.uugurmukhi = 2570;
    e.uumatragurmukhi = 2626;
    e.uuvowelsignbengali = 2498;
    e.uuvowelsigndeva = 2370;
    e.uuvowelsigngujarati = 2754;
    e.uvowelsignbengali = 2497;
    e.uvowelsigndeva = 2369;
    e.uvowelsigngujarati = 2753;
    e.v = 118;
    e.vadeva = 2357;
    e.vagujarati = 2741;
    e.vagurmukhi = 2613;
    e.vakatakana = 12535;
    e.vav = 1493;
    e.vavdagesh = 64309;
    e.vavdagesh65 = 64309;
    e.vavdageshhebrew = 64309;
    e.vavhebrew = 1493;
    e.vavholam = 64331;
    e.vavholamhebrew = 64331;
    e.vavvavhebrew = 1520;
    e.vavyodhebrew = 1521;
    e.vcircle = 9445;
    e.vdotbelow = 7807;
    e.vecyrillic = 1074;
    e.veharabic = 1700;
    e.vehfinalarabic = 64363;
    e.vehinitialarabic = 64364;
    e.vehmedialarabic = 64365;
    e.vekatakana = 12537;
    e.venus = 9792;
    e.verticalbar = 124;
    e.verticallineabovecmb = 781;
    e.verticallinebelowcmb = 809;
    e.verticallinelowmod = 716;
    e.verticallinemod = 712;
    e.vewarmenian = 1406;
    e.vhook = 651;
    e.vikatakana = 12536;
    e.viramabengali = 2509;
    e.viramadeva = 2381;
    e.viramagujarati = 2765;
    e.visargabengali = 2435;
    e.visargadeva = 2307;
    e.visargagujarati = 2691;
    e.vmonospace = 65366;
    e.voarmenian = 1400;
    e.voicediterationhiragana = 12446;
    e.voicediterationkatakana = 12542;
    e.voicedmarkkana = 12443;
    e.voicedmarkkanahalfwidth = 65438;
    e.vokatakana = 12538;
    e.vparen = 9393;
    e.vtilde = 7805;
    e.vturned = 652;
    e.vuhiragana = 12436;
    e.vukatakana = 12532;
    e.w = 119;
    e.wacute = 7811;
    e.waekorean = 12633;
    e.wahiragana = 12431;
    e.wakatakana = 12527;
    e.wakatakanahalfwidth = 65436;
    e.wakorean = 12632;
    e.wasmallhiragana = 12430;
    e.wasmallkatakana = 12526;
    e.wattosquare = 13143;
    e.wavedash = 12316;
    e.wavyunderscorevertical = 65076;
    e.wawarabic = 1608;
    e.wawfinalarabic = 65262;
    e.wawhamzaabovearabic = 1572;
    e.wawhamzaabovefinalarabic = 65158;
    e.wbsquare = 13277;
    e.wcircle = 9446;
    e.wcircumflex = 373;
    e.wdieresis = 7813;
    e.wdotaccent = 7815;
    e.wdotbelow = 7817;
    e.wehiragana = 12433;
    e.weierstrass = 8472;
    e.wekatakana = 12529;
    e.wekorean = 12638;
    e.weokorean = 12637;
    e.wgrave = 7809;
    e.whitebullet = 9702;
    e.whitecircle = 9675;
    e.whitecircleinverse = 9689;
    e.whitecornerbracketleft = 12302;
    e.whitecornerbracketleftvertical = 65091;
    e.whitecornerbracketright = 12303;
    e.whitecornerbracketrightvertical = 65092;
    e.whitediamond = 9671;
    e.whitediamondcontainingblacksmalldiamond = 9672;
    e.whitedownpointingsmalltriangle = 9663;
    e.whitedownpointingtriangle = 9661;
    e.whiteleftpointingsmalltriangle = 9667;
    e.whiteleftpointingtriangle = 9665;
    e.whitelenticularbracketleft = 12310;
    e.whitelenticularbracketright = 12311;
    e.whiterightpointingsmalltriangle = 9657;
    e.whiterightpointingtriangle = 9655;
    e.whitesmallsquare = 9643;
    e.whitesmilingface = 9786;
    e.whitesquare = 9633;
    e.whitestar = 9734;
    e.whitetelephone = 9743;
    e.whitetortoiseshellbracketleft = 12312;
    e.whitetortoiseshellbracketright = 12313;
    e.whiteuppointingsmalltriangle = 9653;
    e.whiteuppointingtriangle = 9651;
    e.wihiragana = 12432;
    e.wikatakana = 12528;
    e.wikorean = 12639;
    e.wmonospace = 65367;
    e.wohiragana = 12434;
    e.wokatakana = 12530;
    e.wokatakanahalfwidth = 65382;
    e.won = 8361;
    e.wonmonospace = 65510;
    e.wowaenthai = 3623;
    e.wparen = 9394;
    e.wring = 7832;
    e.wsuperior = 695;
    e.wturned = 653;
    e.wynn = 447;
    e.x = 120;
    e.xabovecmb = 829;
    e.xbopomofo = 12562;
    e.xcircle = 9447;
    e.xdieresis = 7821;
    e.xdotaccent = 7819;
    e.xeharmenian = 1389;
    e.xi = 958;
    e.xmonospace = 65368;
    e.xparen = 9395;
    e.xsuperior = 739;
    e.y = 121;
    e.yaadosquare = 13134;
    e.yabengali = 2479;
    e.yacute = 253;
    e.yadeva = 2351;
    e.yaekorean = 12626;
    e.yagujarati = 2735;
    e.yagurmukhi = 2607;
    e.yahiragana = 12420;
    e.yakatakana = 12516;
    e.yakatakanahalfwidth = 65428;
    e.yakorean = 12625;
    e.yamakkanthai = 3662;
    e.yasmallhiragana = 12419;
    e.yasmallkatakana = 12515;
    e.yasmallkatakanahalfwidth = 65388;
    e.yatcyrillic = 1123;
    e.ycircle = 9448;
    e.ycircumflex = 375;
    e.ydieresis = 255;
    e.ydotaccent = 7823;
    e.ydotbelow = 7925;
    e.yeharabic = 1610;
    e.yehbarreearabic = 1746;
    e.yehbarreefinalarabic = 64431;
    e.yehfinalarabic = 65266;
    e.yehhamzaabovearabic = 1574;
    e.yehhamzaabovefinalarabic = 65162;
    e.yehhamzaaboveinitialarabic = 65163;
    e.yehhamzaabovemedialarabic = 65164;
    e.yehinitialarabic = 65267;
    e.yehmedialarabic = 65268;
    e.yehmeeminitialarabic = 64733;
    e.yehmeemisolatedarabic = 64600;
    e.yehnoonfinalarabic = 64660;
    e.yehthreedotsbelowarabic = 1745;
    e.yekorean = 12630;
    e.yen = 165;
    e.yenmonospace = 65509;
    e.yeokorean = 12629;
    e.yeorinhieuhkorean = 12678;
    e.yerahbenyomohebrew = 1450;
    e.yerahbenyomolefthebrew = 1450;
    e.yericyrillic = 1099;
    e.yerudieresiscyrillic = 1273;
    e.yesieungkorean = 12673;
    e.yesieungpansioskorean = 12675;
    e.yesieungsioskorean = 12674;
    e.yetivhebrew = 1434;
    e.ygrave = 7923;
    e.yhook = 436;
    e.yhookabove = 7927;
    e.yiarmenian = 1397;
    e.yicyrillic = 1111;
    e.yikorean = 12642;
    e.yinyang = 9775;
    e.yiwnarmenian = 1410;
    e.ymonospace = 65369;
    e.yod = 1497;
    e.yoddagesh = 64313;
    e.yoddageshhebrew = 64313;
    e.yodhebrew = 1497;
    e.yodyodhebrew = 1522;
    e.yodyodpatahhebrew = 64287;
    e.yohiragana = 12424;
    e.yoikorean = 12681;
    e.yokatakana = 12520;
    e.yokatakanahalfwidth = 65430;
    e.yokorean = 12635;
    e.yosmallhiragana = 12423;
    e.yosmallkatakana = 12519;
    e.yosmallkatakanahalfwidth = 65390;
    e.yotgreek = 1011;
    e.yoyaekorean = 12680;
    e.yoyakorean = 12679;
    e.yoyakthai = 3618;
    e.yoyingthai = 3597;
    e.yparen = 9396;
    e.ypogegrammeni = 890;
    e.ypogegrammenigreekcmb = 837;
    e.yr = 422;
    e.yring = 7833;
    e.ysuperior = 696;
    e.ytilde = 7929;
    e.yturned = 654;
    e.yuhiragana = 12422;
    e.yuikorean = 12684;
    e.yukatakana = 12518;
    e.yukatakanahalfwidth = 65429;
    e.yukorean = 12640;
    e.yusbigcyrillic = 1131;
    e.yusbigiotifiedcyrillic = 1133;
    e.yuslittlecyrillic = 1127;
    e.yuslittleiotifiedcyrillic = 1129;
    e.yusmallhiragana = 12421;
    e.yusmallkatakana = 12517;
    e.yusmallkatakanahalfwidth = 65389;
    e.yuyekorean = 12683;
    e.yuyeokorean = 12682;
    e.yyabengali = 2527;
    e.yyadeva = 2399;
    e.z = 122;
    e.zaarmenian = 1382;
    e.zacute = 378;
    e.zadeva = 2395;
    e.zagurmukhi = 2651;
    e.zaharabic = 1592;
    e.zahfinalarabic = 65222;
    e.zahinitialarabic = 65223;
    e.zahiragana = 12374;
    e.zahmedialarabic = 65224;
    e.zainarabic = 1586;
    e.zainfinalarabic = 65200;
    e.zakatakana = 12470;
    e.zaqefgadolhebrew = 1429;
    e.zaqefqatanhebrew = 1428;
    e.zarqahebrew = 1432;
    e.zayin = 1494;
    e.zayindagesh = 64310;
    e.zayindageshhebrew = 64310;
    e.zayinhebrew = 1494;
    e.zbopomofo = 12567;
    e.zcaron = 382;
    e.zcircle = 9449;
    e.zcircumflex = 7825;
    e.zcurl = 657;
    e.zdot = 380;
    e.zdotaccent = 380;
    e.zdotbelow = 7827;
    e.zecyrillic = 1079;
    e.zedescendercyrillic = 1177;
    e.zedieresiscyrillic = 1247;
    e.zehiragana = 12380;
    e.zekatakana = 12476;
    e.zero = 48;
    e.zeroarabic = 1632;
    e.zerobengali = 2534;
    e.zerodeva = 2406;
    e.zerogujarati = 2790;
    e.zerogurmukhi = 2662;
    e.zerohackarabic = 1632;
    e.zeroinferior = 8320;
    e.zeromonospace = 65296;
    e.zerooldstyle = 63280;
    e.zeropersian = 1776;
    e.zerosuperior = 8304;
    e.zerothai = 3664;
    e.zerowidthjoiner = 65279;
    e.zerowidthnonjoiner = 8204;
    e.zerowidthspace = 8203;
    e.zeta = 950;
    e.zhbopomofo = 12563;
    e.zhearmenian = 1386;
    e.zhebrevecyrillic = 1218;
    e.zhecyrillic = 1078;
    e.zhedescendercyrillic = 1175;
    e.zhedieresiscyrillic = 1245;
    e.zihiragana = 12376;
    e.zikatakana = 12472;
    e.zinorhebrew = 1454;
    e.zlinebelow = 7829;
    e.zmonospace = 65370;
    e.zohiragana = 12382;
    e.zokatakana = 12478;
    e.zparen = 9397;
    e.zretroflexhook = 656;
    e.zstroke = 438;
    e.zuhiragana = 12378;
    e.zukatakana = 12474;
    e[".notdef"] = 0;
    e.angbracketleftbig = 9001;
    e.angbracketleftBig = 9001;
    e.angbracketleftbigg = 9001;
    e.angbracketleftBigg = 9001;
    e.angbracketrightBig = 9002;
    e.angbracketrightbig = 9002;
    e.angbracketrightBigg = 9002;
    e.angbracketrightbigg = 9002;
    e.arrowhookleft = 8618;
    e.arrowhookright = 8617;
    e.arrowlefttophalf = 8636;
    e.arrowleftbothalf = 8637;
    e.arrownortheast = 8599;
    e.arrownorthwest = 8598;
    e.arrowrighttophalf = 8640;
    e.arrowrightbothalf = 8641;
    e.arrowsoutheast = 8600;
    e.arrowsouthwest = 8601;
    e.backslashbig = 8726;
    e.backslashBig = 8726;
    e.backslashBigg = 8726;
    e.backslashbigg = 8726;
    e.bardbl = 8214;
    e.bracehtipdownleft = 65079;
    e.bracehtipdownright = 65079;
    e.bracehtipupleft = 65080;
    e.bracehtipupright = 65080;
    e.braceleftBig = 123;
    e.braceleftbig = 123;
    e.braceleftbigg = 123;
    e.braceleftBigg = 123;
    e.bracerightBig = 125;
    e.bracerightbig = 125;
    e.bracerightbigg = 125;
    e.bracerightBigg = 125;
    e.bracketleftbig = 91;
    e.bracketleftBig = 91;
    e.bracketleftbigg = 91;
    e.bracketleftBigg = 91;
    e.bracketrightBig = 93;
    e.bracketrightbig = 93;
    e.bracketrightbigg = 93;
    e.bracketrightBigg = 93;
    e.ceilingleftbig = 8968;
    e.ceilingleftBig = 8968;
    e.ceilingleftBigg = 8968;
    e.ceilingleftbigg = 8968;
    e.ceilingrightbig = 8969;
    e.ceilingrightBig = 8969;
    e.ceilingrightbigg = 8969;
    e.ceilingrightBigg = 8969;
    e.circledotdisplay = 8857;
    e.circledottext = 8857;
    e.circlemultiplydisplay = 8855;
    e.circlemultiplytext = 8855;
    e.circleplusdisplay = 8853;
    e.circleplustext = 8853;
    e.contintegraldisplay = 8750;
    e.contintegraltext = 8750;
    e.coproductdisplay = 8720;
    e.coproducttext = 8720;
    e.floorleftBig = 8970;
    e.floorleftbig = 8970;
    e.floorleftbigg = 8970;
    e.floorleftBigg = 8970;
    e.floorrightbig = 8971;
    e.floorrightBig = 8971;
    e.floorrightBigg = 8971;
    e.floorrightbigg = 8971;
    e.hatwide = 770;
    e.hatwider = 770;
    e.hatwidest = 770;
    e.intercal = 7488;
    e.integraldisplay = 8747;
    e.integraltext = 8747;
    e.intersectiondisplay = 8898;
    e.intersectiontext = 8898;
    e.logicalanddisplay = 8743;
    e.logicalandtext = 8743;
    e.logicalordisplay = 8744;
    e.logicalortext = 8744;
    e.parenleftBig = 40;
    e.parenleftbig = 40;
    e.parenleftBigg = 40;
    e.parenleftbigg = 40;
    e.parenrightBig = 41;
    e.parenrightbig = 41;
    e.parenrightBigg = 41;
    e.parenrightbigg = 41;
    e.prime = 8242;
    e.productdisplay = 8719;
    e.producttext = 8719;
    e.radicalbig = 8730;
    e.radicalBig = 8730;
    e.radicalBigg = 8730;
    e.radicalbigg = 8730;
    e.radicalbt = 8730;
    e.radicaltp = 8730;
    e.radicalvertex = 8730;
    e.slashbig = 47;
    e.slashBig = 47;
    e.slashBigg = 47;
    e.slashbigg = 47;
    e.summationdisplay = 8721;
    e.summationtext = 8721;
    e.tildewide = 732;
    e.tildewider = 732;
    e.tildewidest = 732;
    e.uniondisplay = 8899;
    e.unionmultidisplay = 8846;
    e.unionmultitext = 8846;
    e.unionsqdisplay = 8852;
    e.unionsqtext = 8852;
    e.uniontext = 8899;
    e.vextenddouble = 8741;
    e.vextendsingle = 8739;
  }),
  Mi = getLookupTableFactory(function (e) {
    e.space = 32;
    e.a1 = 9985;
    e.a2 = 9986;
    e.a202 = 9987;
    e.a3 = 9988;
    e.a4 = 9742;
    e.a5 = 9990;
    e.a119 = 9991;
    e.a118 = 9992;
    e.a117 = 9993;
    e.a11 = 9755;
    e.a12 = 9758;
    e.a13 = 9996;
    e.a14 = 9997;
    e.a15 = 9998;
    e.a16 = 9999;
    e.a105 = 1e4;
    e.a17 = 10001;
    e.a18 = 10002;
    e.a19 = 10003;
    e.a20 = 10004;
    e.a21 = 10005;
    e.a22 = 10006;
    e.a23 = 10007;
    e.a24 = 10008;
    e.a25 = 10009;
    e.a26 = 10010;
    e.a27 = 10011;
    e.a28 = 10012;
    e.a6 = 10013;
    e.a7 = 10014;
    e.a8 = 10015;
    e.a9 = 10016;
    e.a10 = 10017;
    e.a29 = 10018;
    e.a30 = 10019;
    e.a31 = 10020;
    e.a32 = 10021;
    e.a33 = 10022;
    e.a34 = 10023;
    e.a35 = 9733;
    e.a36 = 10025;
    e.a37 = 10026;
    e.a38 = 10027;
    e.a39 = 10028;
    e.a40 = 10029;
    e.a41 = 10030;
    e.a42 = 10031;
    e.a43 = 10032;
    e.a44 = 10033;
    e.a45 = 10034;
    e.a46 = 10035;
    e.a47 = 10036;
    e.a48 = 10037;
    e.a49 = 10038;
    e.a50 = 10039;
    e.a51 = 10040;
    e.a52 = 10041;
    e.a53 = 10042;
    e.a54 = 10043;
    e.a55 = 10044;
    e.a56 = 10045;
    e.a57 = 10046;
    e.a58 = 10047;
    e.a59 = 10048;
    e.a60 = 10049;
    e.a61 = 10050;
    e.a62 = 10051;
    e.a63 = 10052;
    e.a64 = 10053;
    e.a65 = 10054;
    e.a66 = 10055;
    e.a67 = 10056;
    e.a68 = 10057;
    e.a69 = 10058;
    e.a70 = 10059;
    e.a71 = 9679;
    e.a72 = 10061;
    e.a73 = 9632;
    e.a74 = 10063;
    e.a203 = 10064;
    e.a75 = 10065;
    e.a204 = 10066;
    e.a76 = 9650;
    e.a77 = 9660;
    e.a78 = 9670;
    e.a79 = 10070;
    e.a81 = 9687;
    e.a82 = 10072;
    e.a83 = 10073;
    e.a84 = 10074;
    e.a97 = 10075;
    e.a98 = 10076;
    e.a99 = 10077;
    e.a100 = 10078;
    e.a101 = 10081;
    e.a102 = 10082;
    e.a103 = 10083;
    e.a104 = 10084;
    e.a106 = 10085;
    e.a107 = 10086;
    e.a108 = 10087;
    e.a112 = 9827;
    e.a111 = 9830;
    e.a110 = 9829;
    e.a109 = 9824;
    e.a120 = 9312;
    e.a121 = 9313;
    e.a122 = 9314;
    e.a123 = 9315;
    e.a124 = 9316;
    e.a125 = 9317;
    e.a126 = 9318;
    e.a127 = 9319;
    e.a128 = 9320;
    e.a129 = 9321;
    e.a130 = 10102;
    e.a131 = 10103;
    e.a132 = 10104;
    e.a133 = 10105;
    e.a134 = 10106;
    e.a135 = 10107;
    e.a136 = 10108;
    e.a137 = 10109;
    e.a138 = 10110;
    e.a139 = 10111;
    e.a140 = 10112;
    e.a141 = 10113;
    e.a142 = 10114;
    e.a143 = 10115;
    e.a144 = 10116;
    e.a145 = 10117;
    e.a146 = 10118;
    e.a147 = 10119;
    e.a148 = 10120;
    e.a149 = 10121;
    e.a150 = 10122;
    e.a151 = 10123;
    e.a152 = 10124;
    e.a153 = 10125;
    e.a154 = 10126;
    e.a155 = 10127;
    e.a156 = 10128;
    e.a157 = 10129;
    e.a158 = 10130;
    e.a159 = 10131;
    e.a160 = 10132;
    e.a161 = 8594;
    e.a163 = 8596;
    e.a164 = 8597;
    e.a196 = 10136;
    e.a165 = 10137;
    e.a192 = 10138;
    e.a166 = 10139;
    e.a167 = 10140;
    e.a168 = 10141;
    e.a169 = 10142;
    e.a170 = 10143;
    e.a171 = 10144;
    e.a172 = 10145;
    e.a173 = 10146;
    e.a162 = 10147;
    e.a174 = 10148;
    e.a175 = 10149;
    e.a176 = 10150;
    e.a177 = 10151;
    e.a178 = 10152;
    e.a179 = 10153;
    e.a193 = 10154;
    e.a180 = 10155;
    e.a199 = 10156;
    e.a181 = 10157;
    e.a200 = 10158;
    e.a182 = 10159;
    e.a201 = 10161;
    e.a183 = 10162;
    e.a184 = 10163;
    e.a197 = 10164;
    e.a185 = 10165;
    e.a194 = 10166;
    e.a198 = 10167;
    e.a186 = 10168;
    e.a195 = 10169;
    e.a187 = 10170;
    e.a188 = 10171;
    e.a189 = 10172;
    e.a190 = 10173;
    e.a191 = 10174;
    e.a89 = 10088;
    e.a90 = 10089;
    e.a93 = 10090;
    e.a94 = 10091;
    e.a91 = 10092;
    e.a92 = 10093;
    e.a205 = 10094;
    e.a85 = 10095;
    e.a206 = 10096;
    e.a86 = 10097;
    e.a87 = 10098;
    e.a88 = 10099;
    e.a95 = 10100;
    e.a96 = 10101;
    e[".notdef"] = 0;
  }),
  Hi = getLookupTableFactory(function (e) {
    e[63721] = 169;
    e[63193] = 169;
    e[63720] = 174;
    e[63194] = 174;
    e[63722] = 8482;
    e[63195] = 8482;
    e[63729] = 9127;
    e[63730] = 9128;
    e[63731] = 9129;
    e[63740] = 9131;
    e[63741] = 9132;
    e[63742] = 9133;
    e[63726] = 9121;
    e[63727] = 9122;
    e[63728] = 9123;
    e[63737] = 9124;
    e[63738] = 9125;
    e[63739] = 9126;
    e[63723] = 9115;
    e[63724] = 9116;
    e[63725] = 9117;
    e[63734] = 9118;
    e[63735] = 9119;
    e[63736] = 9120;
  });
function getUnicodeForGlyph(e, t) {
  var i = t[e];
  if (void 0 !== i) return i;
  if (!e) return -1;
  if ("u" === e[0]) {
    var _t125 = e.length;
    var _a107;
    if (7 === _t125 && "n" === e[1] && "i" === e[2]) _a107 = e.substring(3);else {
      if (!(_t125 >= 5 && _t125 <= 7)) return -1;
      _a107 = e.substring(1);
    }
    if (_a107 === _a107.toUpperCase()) {
      i = parseInt(_a107, 16);
      if (i >= 0) return i;
    }
  }
  return -1;
}
var Ji = [[0, 127], [128, 255], [256, 383], [384, 591], [592, 687, 7424, 7551, 7552, 7615], [688, 767, 42752, 42783], [768, 879, 7616, 7679], [880, 1023], [11392, 11519], [1024, 1279, 1280, 1327, 11744, 11775, 42560, 42655], [1328, 1423], [1424, 1535], [42240, 42559], [1536, 1791, 1872, 1919], [1984, 2047], [2304, 2431], [2432, 2559], [2560, 2687], [2688, 2815], [2816, 2943], [2944, 3071], [3072, 3199], [3200, 3327], [3328, 3455], [3584, 3711], [3712, 3839], [4256, 4351, 11520, 11567], [6912, 7039], [4352, 4607], [7680, 7935, 11360, 11391, 42784, 43007], [7936, 8191], [8192, 8303, 11776, 11903], [8304, 8351], [8352, 8399], [8400, 8447], [8448, 8527], [8528, 8591], [8592, 8703, 10224, 10239, 10496, 10623, 11008, 11263], [8704, 8959, 10752, 11007, 10176, 10223, 10624, 10751], [8960, 9215], [9216, 9279], [9280, 9311], [9312, 9471], [9472, 9599], [9600, 9631], [9632, 9727], [9728, 9983], [9984, 10175], [12288, 12351], [12352, 12447], [12448, 12543, 12784, 12799], [12544, 12591, 12704, 12735], [12592, 12687], [43072, 43135], [12800, 13055], [13056, 13311], [44032, 55215], [55296, 57343], [67840, 67871], [19968, 40959, 11904, 12031, 12032, 12255, 12272, 12287, 13312, 19903, 131072, 173791, 12688, 12703], [57344, 63743], [12736, 12783, 63744, 64255, 194560, 195103], [64256, 64335], [64336, 65023], [65056, 65071], [65040, 65055], [65104, 65135], [65136, 65279], [65280, 65519], [65520, 65535], [3840, 4095], [1792, 1871], [1920, 1983], [3456, 3583], [4096, 4255], [4608, 4991, 4992, 5023, 11648, 11743], [5024, 5119], [5120, 5759], [5760, 5791], [5792, 5887], [6016, 6143], [6144, 6319], [10240, 10495], [40960, 42127], [5888, 5919, 5920, 5951, 5952, 5983, 5984, 6015], [66304, 66351], [66352, 66383], [66560, 66639], [118784, 119039, 119040, 119295, 119296, 119375], [119808, 120831], [1044480, 1048573], [65024, 65039, 917760, 917999], [917504, 917631], [6400, 6479], [6480, 6527], [6528, 6623], [6656, 6687], [11264, 11359], [11568, 11647], [19904, 19967], [43008, 43055], [65536, 65663, 65664, 65791, 65792, 65855], [65856, 65935], [66432, 66463], [66464, 66527], [66640, 66687], [66688, 66735], [67584, 67647], [68096, 68191], [119552, 119647], [73728, 74751, 74752, 74879], [119648, 119679], [7040, 7103], [7168, 7247], [7248, 7295], [43136, 43231], [43264, 43311], [43312, 43359], [43520, 43615], [65936, 65999], [66e3, 66047], [66208, 66271, 66176, 66207, 67872, 67903], [127024, 127135, 126976, 127023]];
function getUnicodeRangeFor(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
  if (-1 !== t) {
    var _i109 = Ji[t];
    for (var _a108 = 0, _s72 = _i109.length; _a108 < _s72; _a108 += 2) if (e >= _i109[_a108] && e <= _i109[_a108 + 1]) return t;
  }
  for (var _t126 = 0, _i110 = Ji.length; _t126 < _i110; _t126++) {
    var _i111 = Ji[_t126];
    for (var _a109 = 0, _s73 = _i111.length; _a109 < _s73; _a109 += 2) if (e >= _i111[_a109] && e <= _i111[_a109 + 1]) return _t126;
  }
  return -1;
}
var Yi = new RegExp("^(\\s)|(\\p{Mn})|(\\p{Cf})$", "u"),
  vi = new Map();
var Ki = !0,
  Ti = 1,
  qi = 2,
  Oi = 4,
  Pi = 32,
  Wi = [".notdef", ".null", "nonmarkingreturn", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "nonbreakingspace", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "Lslash", "lslash", "Scaron", "scaron", "Zcaron", "zcaron", "brokenbar", "Eth", "eth", "Yacute", "yacute", "Thorn", "thorn", "minus", "multiply", "onesuperior", "twosuperior", "threesuperior", "onehalf", "onequarter", "threequarters", "franc", "Gbreve", "gbreve", "Idotaccent", "Scedilla", "scedilla", "Cacute", "cacute", "Ccaron", "ccaron", "dcroat"];
function recoverGlyphName(e, t) {
  if (void 0 !== t[e]) return e;
  var i = getUnicodeForGlyph(e, t);
  if (-1 !== i) for (var _e147 in t) if (t[_e147] === i) return _e147;
  info("Unable to recover a standard glyph name for: " + e);
  return e;
}
function type1FontGlyphMapping(e, t, i) {
  var a = Object.create(null);
  var s, r, n;
  var g = !!(e.flags & Oi);
  if (e.isInternalFont) {
    n = t;
    for (r = 0; r < n.length; r++) {
      s = i.indexOf(n[r]);
      a[r] = s >= 0 ? s : 0;
    }
  } else if (e.baseEncodingName) {
    n = getEncoding(e.baseEncodingName);
    for (r = 0; r < n.length; r++) {
      s = i.indexOf(n[r]);
      a[r] = s >= 0 ? s : 0;
    }
  } else if (g) for (r in t) a[r] = t[r];else {
    n = mi;
    for (r = 0; r < n.length; r++) {
      s = i.indexOf(n[r]);
      a[r] = s >= 0 ? s : 0;
    }
  }
  var o = e.differences;
  var c;
  if (o) for (r in o) {
    var _e148 = o[r];
    s = i.indexOf(_e148);
    if (-1 === s) {
      c || (c = xi());
      var _t127 = recoverGlyphName(_e148, c);
      _t127 !== _e148 && (s = i.indexOf(_t127));
    }
    a[r] = s >= 0 ? s : 0;
  }
  return a;
}
function normalizeFontName(e) {
  return e.replaceAll(/[,_]/g, "-").replaceAll(/\s/g, "");
}
var ji = getLookupTableFactory(function (e) {
    e[8211] = 65074;
    e[8212] = 65073;
    e[8229] = 65072;
    e[8230] = 65049;
    e[12289] = 65041;
    e[12290] = 65042;
    e[12296] = 65087;
    e[12297] = 65088;
    e[12298] = 65085;
    e[12299] = 65086;
    e[12300] = 65089;
    e[12301] = 65090;
    e[12302] = 65091;
    e[12303] = 65092;
    e[12304] = 65083;
    e[12305] = 65084;
    e[12308] = 65081;
    e[12309] = 65082;
    e[12310] = 65047;
    e[12311] = 65048;
    e[65103] = 65076;
    e[65281] = 65045;
    e[65288] = 65077;
    e[65289] = 65078;
    e[65292] = 65040;
    e[65306] = 65043;
    e[65307] = 65044;
    e[65311] = 65046;
    e[65339] = 65095;
    e[65341] = 65096;
    e[65343] = 65075;
    e[65371] = 65079;
    e[65373] = 65080;
  }),
  Xi = getLookupTableFactory(function (e) {
    e["Times-Roman"] = "Times-Roman";
    e.Helvetica = "Helvetica";
    e.Courier = "Courier";
    e.Symbol = "Symbol";
    e["Times-Bold"] = "Times-Bold";
    e["Helvetica-Bold"] = "Helvetica-Bold";
    e["Courier-Bold"] = "Courier-Bold";
    e.ZapfDingbats = "ZapfDingbats";
    e["Times-Italic"] = "Times-Italic";
    e["Helvetica-Oblique"] = "Helvetica-Oblique";
    e["Courier-Oblique"] = "Courier-Oblique";
    e["Times-BoldItalic"] = "Times-BoldItalic";
    e["Helvetica-BoldOblique"] = "Helvetica-BoldOblique";
    e["Courier-BoldOblique"] = "Courier-BoldOblique";
    e.ArialNarrow = "Helvetica";
    e["ArialNarrow-Bold"] = "Helvetica-Bold";
    e["ArialNarrow-BoldItalic"] = "Helvetica-BoldOblique";
    e["ArialNarrow-Italic"] = "Helvetica-Oblique";
    e.ArialBlack = "Helvetica";
    e["ArialBlack-Bold"] = "Helvetica-Bold";
    e["ArialBlack-BoldItalic"] = "Helvetica-BoldOblique";
    e["ArialBlack-Italic"] = "Helvetica-Oblique";
    e["Arial-Black"] = "Helvetica";
    e["Arial-Black-Bold"] = "Helvetica-Bold";
    e["Arial-Black-BoldItalic"] = "Helvetica-BoldOblique";
    e["Arial-Black-Italic"] = "Helvetica-Oblique";
    e.Arial = "Helvetica";
    e["Arial-Bold"] = "Helvetica-Bold";
    e["Arial-BoldItalic"] = "Helvetica-BoldOblique";
    e["Arial-Italic"] = "Helvetica-Oblique";
    e.ArialMT = "Helvetica";
    e["Arial-BoldItalicMT"] = "Helvetica-BoldOblique";
    e["Arial-BoldMT"] = "Helvetica-Bold";
    e["Arial-ItalicMT"] = "Helvetica-Oblique";
    e["Arial-BoldItalicMT-BoldItalic"] = "Helvetica-BoldOblique";
    e["Arial-BoldMT-Bold"] = "Helvetica-Bold";
    e["Arial-ItalicMT-Italic"] = "Helvetica-Oblique";
    e.ArialUnicodeMS = "Helvetica";
    e["ArialUnicodeMS-Bold"] = "Helvetica-Bold";
    e["ArialUnicodeMS-BoldItalic"] = "Helvetica-BoldOblique";
    e["ArialUnicodeMS-Italic"] = "Helvetica-Oblique";
    e["Courier-BoldItalic"] = "Courier-BoldOblique";
    e["Courier-Italic"] = "Courier-Oblique";
    e.CourierNew = "Courier";
    e["CourierNew-Bold"] = "Courier-Bold";
    e["CourierNew-BoldItalic"] = "Courier-BoldOblique";
    e["CourierNew-Italic"] = "Courier-Oblique";
    e["CourierNewPS-BoldItalicMT"] = "Courier-BoldOblique";
    e["CourierNewPS-BoldMT"] = "Courier-Bold";
    e["CourierNewPS-ItalicMT"] = "Courier-Oblique";
    e.CourierNewPSMT = "Courier";
    e["Helvetica-BoldItalic"] = "Helvetica-BoldOblique";
    e["Helvetica-Italic"] = "Helvetica-Oblique";
    e["Symbol-Bold"] = "Symbol";
    e["Symbol-BoldItalic"] = "Symbol";
    e["Symbol-Italic"] = "Symbol";
    e.TimesNewRoman = "Times-Roman";
    e["TimesNewRoman-Bold"] = "Times-Bold";
    e["TimesNewRoman-BoldItalic"] = "Times-BoldItalic";
    e["TimesNewRoman-Italic"] = "Times-Italic";
    e.TimesNewRomanPS = "Times-Roman";
    e["TimesNewRomanPS-Bold"] = "Times-Bold";
    e["TimesNewRomanPS-BoldItalic"] = "Times-BoldItalic";
    e["TimesNewRomanPS-BoldItalicMT"] = "Times-BoldItalic";
    e["TimesNewRomanPS-BoldMT"] = "Times-Bold";
    e["TimesNewRomanPS-Italic"] = "Times-Italic";
    e["TimesNewRomanPS-ItalicMT"] = "Times-Italic";
    e.TimesNewRomanPSMT = "Times-Roman";
    e["TimesNewRomanPSMT-Bold"] = "Times-Bold";
    e["TimesNewRomanPSMT-BoldItalic"] = "Times-BoldItalic";
    e["TimesNewRomanPSMT-Italic"] = "Times-Italic";
  }),
  Zi = getLookupTableFactory(function (e) {
    e.Courier = "FoxitFixed.pfb";
    e["Courier-Bold"] = "FoxitFixedBold.pfb";
    e["Courier-BoldOblique"] = "FoxitFixedBoldItalic.pfb";
    e["Courier-Oblique"] = "FoxitFixedItalic.pfb";
    e.Helvetica = "LiberationSans-Regular.ttf";
    e["Helvetica-Bold"] = "LiberationSans-Bold.ttf";
    e["Helvetica-BoldOblique"] = "LiberationSans-BoldItalic.ttf";
    e["Helvetica-Oblique"] = "LiberationSans-Italic.ttf";
    e["Times-Roman"] = "FoxitSerif.pfb";
    e["Times-Bold"] = "FoxitSerifBold.pfb";
    e["Times-BoldItalic"] = "FoxitSerifBoldItalic.pfb";
    e["Times-Italic"] = "FoxitSerifItalic.pfb";
    e.Symbol = "FoxitSymbol.pfb";
    e.ZapfDingbats = "FoxitDingbats.pfb";
    e["LiberationSans-Regular"] = "LiberationSans-Regular.ttf";
    e["LiberationSans-Bold"] = "LiberationSans-Bold.ttf";
    e["LiberationSans-Italic"] = "LiberationSans-Italic.ttf";
    e["LiberationSans-BoldItalic"] = "LiberationSans-BoldItalic.ttf";
  }),
  Vi = getLookupTableFactory(function (e) {
    e.Calibri = "Helvetica";
    e["Calibri-Bold"] = "Helvetica-Bold";
    e["Calibri-BoldItalic"] = "Helvetica-BoldOblique";
    e["Calibri-Italic"] = "Helvetica-Oblique";
    e.CenturyGothic = "Helvetica";
    e["CenturyGothic-Bold"] = "Helvetica-Bold";
    e["CenturyGothic-BoldItalic"] = "Helvetica-BoldOblique";
    e["CenturyGothic-Italic"] = "Helvetica-Oblique";
    e.ComicSansMS = "Comic Sans MS";
    e["ComicSansMS-Bold"] = "Comic Sans MS-Bold";
    e["ComicSansMS-BoldItalic"] = "Comic Sans MS-BoldItalic";
    e["ComicSansMS-Italic"] = "Comic Sans MS-Italic";
    e.GillSansMT = "Helvetica";
    e["GillSansMT-Bold"] = "Helvetica-Bold";
    e["GillSansMT-BoldItalic"] = "Helvetica-BoldOblique";
    e["GillSansMT-Italic"] = "Helvetica-Oblique";
    e.Impact = "Helvetica";
    e["ItcSymbol-Bold"] = "Helvetica-Bold";
    e["ItcSymbol-BoldItalic"] = "Helvetica-BoldOblique";
    e["ItcSymbol-Book"] = "Helvetica";
    e["ItcSymbol-BookItalic"] = "Helvetica-Oblique";
    e["ItcSymbol-Medium"] = "Helvetica";
    e["ItcSymbol-MediumItalic"] = "Helvetica-Oblique";
    e.LucidaConsole = "Courier";
    e["LucidaConsole-Bold"] = "Courier-Bold";
    e["LucidaConsole-BoldItalic"] = "Courier-BoldOblique";
    e["LucidaConsole-Italic"] = "Courier-Oblique";
    e["LucidaSans-Demi"] = "Helvetica-Bold";
    e["MS-Gothic"] = "MS Gothic";
    e["MS-Gothic-Bold"] = "MS Gothic-Bold";
    e["MS-Gothic-BoldItalic"] = "MS Gothic-BoldItalic";
    e["MS-Gothic-Italic"] = "MS Gothic-Italic";
    e["MS-Mincho"] = "MS Mincho";
    e["MS-Mincho-Bold"] = "MS Mincho-Bold";
    e["MS-Mincho-BoldItalic"] = "MS Mincho-BoldItalic";
    e["MS-Mincho-Italic"] = "MS Mincho-Italic";
    e["MS-PGothic"] = "MS PGothic";
    e["MS-PGothic-Bold"] = "MS PGothic-Bold";
    e["MS-PGothic-BoldItalic"] = "MS PGothic-BoldItalic";
    e["MS-PGothic-Italic"] = "MS PGothic-Italic";
    e["MS-PMincho"] = "MS PMincho";
    e["MS-PMincho-Bold"] = "MS PMincho-Bold";
    e["MS-PMincho-BoldItalic"] = "MS PMincho-BoldItalic";
    e["MS-PMincho-Italic"] = "MS PMincho-Italic";
    e.NuptialScript = "Times-Italic";
    e.SegoeUISymbol = "Helvetica";
  }),
  zi = getLookupTableFactory(function (e) {
    e["Adobe Jenson"] = !0;
    e["Adobe Text"] = !0;
    e.Albertus = !0;
    e.Aldus = !0;
    e.Alexandria = !0;
    e.Algerian = !0;
    e["American Typewriter"] = !0;
    e.Antiqua = !0;
    e.Apex = !0;
    e.Arno = !0;
    e.Aster = !0;
    e.Aurora = !0;
    e.Baskerville = !0;
    e.Bell = !0;
    e.Bembo = !0;
    e["Bembo Schoolbook"] = !0;
    e.Benguiat = !0;
    e["Berkeley Old Style"] = !0;
    e["Bernhard Modern"] = !0;
    e["Berthold City"] = !0;
    e.Bodoni = !0;
    e["Bauer Bodoni"] = !0;
    e["Book Antiqua"] = !0;
    e.Bookman = !0;
    e["Bordeaux Roman"] = !0;
    e["Californian FB"] = !0;
    e.Calisto = !0;
    e.Calvert = !0;
    e.Capitals = !0;
    e.Cambria = !0;
    e.Cartier = !0;
    e.Caslon = !0;
    e.Catull = !0;
    e.Centaur = !0;
    e["Century Old Style"] = !0;
    e["Century Schoolbook"] = !0;
    e.Chaparral = !0;
    e["Charis SIL"] = !0;
    e.Cheltenham = !0;
    e["Cholla Slab"] = !0;
    e.Clarendon = !0;
    e.Clearface = !0;
    e.Cochin = !0;
    e.Colonna = !0;
    e["Computer Modern"] = !0;
    e["Concrete Roman"] = !0;
    e.Constantia = !0;
    e["Cooper Black"] = !0;
    e.Corona = !0;
    e.Ecotype = !0;
    e.Egyptienne = !0;
    e.Elephant = !0;
    e.Excelsior = !0;
    e.Fairfield = !0;
    e["FF Scala"] = !0;
    e.Folkard = !0;
    e.Footlight = !0;
    e.FreeSerif = !0;
    e["Friz Quadrata"] = !0;
    e.Garamond = !0;
    e.Gentium = !0;
    e.Georgia = !0;
    e.Gloucester = !0;
    e["Goudy Old Style"] = !0;
    e["Goudy Schoolbook"] = !0;
    e["Goudy Pro Font"] = !0;
    e.Granjon = !0;
    e["Guardian Egyptian"] = !0;
    e.Heather = !0;
    e.Hercules = !0;
    e["High Tower Text"] = !0;
    e.Hiroshige = !0;
    e["Hoefler Text"] = !0;
    e["Humana Serif"] = !0;
    e.Imprint = !0;
    e["Ionic No. 5"] = !0;
    e.Janson = !0;
    e.Joanna = !0;
    e.Korinna = !0;
    e.Lexicon = !0;
    e.LiberationSerif = !0;
    e["Liberation Serif"] = !0;
    e["Linux Libertine"] = !0;
    e.Literaturnaya = !0;
    e.Lucida = !0;
    e["Lucida Bright"] = !0;
    e.Melior = !0;
    e.Memphis = !0;
    e.Miller = !0;
    e.Minion = !0;
    e.Modern = !0;
    e["Mona Lisa"] = !0;
    e["Mrs Eaves"] = !0;
    e["MS Serif"] = !0;
    e["Museo Slab"] = !0;
    e["New York"] = !0;
    e["Nimbus Roman"] = !0;
    e["NPS Rawlinson Roadway"] = !0;
    e.NuptialScript = !0;
    e.Palatino = !0;
    e.Perpetua = !0;
    e.Plantin = !0;
    e["Plantin Schoolbook"] = !0;
    e.Playbill = !0;
    e["Poor Richard"] = !0;
    e["Rawlinson Roadway"] = !0;
    e.Renault = !0;
    e.Requiem = !0;
    e.Rockwell = !0;
    e.Roman = !0;
    e["Rotis Serif"] = !0;
    e.Sabon = !0;
    e.Scala = !0;
    e.Seagull = !0;
    e.Sistina = !0;
    e.Souvenir = !0;
    e.STIX = !0;
    e["Stone Informal"] = !0;
    e["Stone Serif"] = !0;
    e.Sylfaen = !0;
    e.Times = !0;
    e.Trajan = !0;
    e["Trinité"] = !0;
    e["Trump Mediaeval"] = !0;
    e.Utopia = !0;
    e["Vale Type"] = !0;
    e["Bitstream Vera"] = !0;
    e["Vera Serif"] = !0;
    e.Versailles = !0;
    e.Wanted = !0;
    e.Weiss = !0;
    e["Wide Latin"] = !0;
    e.Windsor = !0;
    e.XITS = !0;
  }),
  _i = getLookupTableFactory(function (e) {
    e.Dingbats = !0;
    e.Symbol = !0;
    e.ZapfDingbats = !0;
    e.Wingdings = !0;
    e["Wingdings-Bold"] = !0;
    e["Wingdings-Regular"] = !0;
  }),
  $i = getLookupTableFactory(function (e) {
    e[2] = 10;
    e[3] = 32;
    e[4] = 33;
    e[5] = 34;
    e[6] = 35;
    e[7] = 36;
    e[8] = 37;
    e[9] = 38;
    e[10] = 39;
    e[11] = 40;
    e[12] = 41;
    e[13] = 42;
    e[14] = 43;
    e[15] = 44;
    e[16] = 45;
    e[17] = 46;
    e[18] = 47;
    e[19] = 48;
    e[20] = 49;
    e[21] = 50;
    e[22] = 51;
    e[23] = 52;
    e[24] = 53;
    e[25] = 54;
    e[26] = 55;
    e[27] = 56;
    e[28] = 57;
    e[29] = 58;
    e[30] = 894;
    e[31] = 60;
    e[32] = 61;
    e[33] = 62;
    e[34] = 63;
    e[35] = 64;
    e[36] = 65;
    e[37] = 66;
    e[38] = 67;
    e[39] = 68;
    e[40] = 69;
    e[41] = 70;
    e[42] = 71;
    e[43] = 72;
    e[44] = 73;
    e[45] = 74;
    e[46] = 75;
    e[47] = 76;
    e[48] = 77;
    e[49] = 78;
    e[50] = 79;
    e[51] = 80;
    e[52] = 81;
    e[53] = 82;
    e[54] = 83;
    e[55] = 84;
    e[56] = 85;
    e[57] = 86;
    e[58] = 87;
    e[59] = 88;
    e[60] = 89;
    e[61] = 90;
    e[62] = 91;
    e[63] = 92;
    e[64] = 93;
    e[65] = 94;
    e[66] = 95;
    e[67] = 96;
    e[68] = 97;
    e[69] = 98;
    e[70] = 99;
    e[71] = 100;
    e[72] = 101;
    e[73] = 102;
    e[74] = 103;
    e[75] = 104;
    e[76] = 105;
    e[77] = 106;
    e[78] = 107;
    e[79] = 108;
    e[80] = 109;
    e[81] = 110;
    e[82] = 111;
    e[83] = 112;
    e[84] = 113;
    e[85] = 114;
    e[86] = 115;
    e[87] = 116;
    e[88] = 117;
    e[89] = 118;
    e[90] = 119;
    e[91] = 120;
    e[92] = 121;
    e[93] = 122;
    e[94] = 123;
    e[95] = 124;
    e[96] = 125;
    e[97] = 126;
    e[98] = 196;
    e[99] = 197;
    e[100] = 199;
    e[101] = 201;
    e[102] = 209;
    e[103] = 214;
    e[104] = 220;
    e[105] = 225;
    e[106] = 224;
    e[107] = 226;
    e[108] = 228;
    e[109] = 227;
    e[110] = 229;
    e[111] = 231;
    e[112] = 233;
    e[113] = 232;
    e[114] = 234;
    e[115] = 235;
    e[116] = 237;
    e[117] = 236;
    e[118] = 238;
    e[119] = 239;
    e[120] = 241;
    e[121] = 243;
    e[122] = 242;
    e[123] = 244;
    e[124] = 246;
    e[125] = 245;
    e[126] = 250;
    e[127] = 249;
    e[128] = 251;
    e[129] = 252;
    e[130] = 8224;
    e[131] = 176;
    e[132] = 162;
    e[133] = 163;
    e[134] = 167;
    e[135] = 8226;
    e[136] = 182;
    e[137] = 223;
    e[138] = 174;
    e[139] = 169;
    e[140] = 8482;
    e[141] = 180;
    e[142] = 168;
    e[143] = 8800;
    e[144] = 198;
    e[145] = 216;
    e[146] = 8734;
    e[147] = 177;
    e[148] = 8804;
    e[149] = 8805;
    e[150] = 165;
    e[151] = 181;
    e[152] = 8706;
    e[153] = 8721;
    e[154] = 8719;
    e[156] = 8747;
    e[157] = 170;
    e[158] = 186;
    e[159] = 8486;
    e[160] = 230;
    e[161] = 248;
    e[162] = 191;
    e[163] = 161;
    e[164] = 172;
    e[165] = 8730;
    e[166] = 402;
    e[167] = 8776;
    e[168] = 8710;
    e[169] = 171;
    e[170] = 187;
    e[171] = 8230;
    e[179] = 8220;
    e[180] = 8221;
    e[181] = 8216;
    e[182] = 8217;
    e[200] = 193;
    e[203] = 205;
    e[207] = 211;
    e[210] = 218;
    e[223] = 711;
    e[224] = 321;
    e[225] = 322;
    e[226] = 352;
    e[227] = 353;
    e[228] = 381;
    e[229] = 382;
    e[233] = 221;
    e[234] = 253;
    e[252] = 263;
    e[253] = 268;
    e[254] = 269;
    e[258] = 258;
    e[260] = 260;
    e[261] = 261;
    e[265] = 280;
    e[266] = 281;
    e[267] = 282;
    e[268] = 283;
    e[269] = 313;
    e[275] = 323;
    e[276] = 324;
    e[278] = 328;
    e[283] = 344;
    e[284] = 345;
    e[285] = 346;
    e[286] = 347;
    e[292] = 367;
    e[295] = 377;
    e[296] = 378;
    e[298] = 380;
    e[305] = 963;
    e[306] = 964;
    e[307] = 966;
    e[308] = 8215;
    e[309] = 8252;
    e[310] = 8319;
    e[311] = 8359;
    e[312] = 8592;
    e[313] = 8593;
    e[337] = 9552;
    e[493] = 1039;
    e[494] = 1040;
    e[672] = 1488;
    e[673] = 1489;
    e[674] = 1490;
    e[675] = 1491;
    e[676] = 1492;
    e[677] = 1493;
    e[678] = 1494;
    e[679] = 1495;
    e[680] = 1496;
    e[681] = 1497;
    e[682] = 1498;
    e[683] = 1499;
    e[684] = 1500;
    e[685] = 1501;
    e[686] = 1502;
    e[687] = 1503;
    e[688] = 1504;
    e[689] = 1505;
    e[690] = 1506;
    e[691] = 1507;
    e[692] = 1508;
    e[693] = 1509;
    e[694] = 1510;
    e[695] = 1511;
    e[696] = 1512;
    e[697] = 1513;
    e[698] = 1514;
    e[705] = 1524;
    e[706] = 8362;
    e[710] = 64288;
    e[711] = 64298;
    e[759] = 1617;
    e[761] = 1776;
    e[763] = 1778;
    e[775] = 1652;
    e[777] = 1764;
    e[778] = 1780;
    e[779] = 1781;
    e[780] = 1782;
    e[782] = 771;
    e[783] = 64726;
    e[786] = 8363;
    e[788] = 8532;
    e[790] = 768;
    e[791] = 769;
    e[792] = 768;
    e[795] = 803;
    e[797] = 64336;
    e[798] = 64337;
    e[799] = 64342;
    e[800] = 64343;
    e[801] = 64344;
    e[802] = 64345;
    e[803] = 64362;
    e[804] = 64363;
    e[805] = 64364;
    e[2424] = 7821;
    e[2425] = 7822;
    e[2426] = 7823;
    e[2427] = 7824;
    e[2428] = 7825;
    e[2429] = 7826;
    e[2430] = 7827;
    e[2433] = 7682;
    e[2678] = 8045;
    e[2679] = 8046;
    e[2830] = 1552;
    e[2838] = 686;
    e[2840] = 751;
    e[2842] = 753;
    e[2843] = 754;
    e[2844] = 755;
    e[2846] = 757;
    e[2856] = 767;
    e[2857] = 848;
    e[2858] = 849;
    e[2862] = 853;
    e[2863] = 854;
    e[2864] = 855;
    e[2865] = 861;
    e[2866] = 862;
    e[2906] = 7460;
    e[2908] = 7462;
    e[2909] = 7463;
    e[2910] = 7464;
    e[2912] = 7466;
    e[2913] = 7467;
    e[2914] = 7468;
    e[2916] = 7470;
    e[2917] = 7471;
    e[2918] = 7472;
    e[2920] = 7474;
    e[2921] = 7475;
    e[2922] = 7476;
    e[2924] = 7478;
    e[2925] = 7479;
    e[2926] = 7480;
    e[2928] = 7482;
    e[2929] = 7483;
    e[2930] = 7484;
    e[2932] = 7486;
    e[2933] = 7487;
    e[2934] = 7488;
    e[2936] = 7490;
    e[2937] = 7491;
    e[2938] = 7492;
    e[2940] = 7494;
    e[2941] = 7495;
    e[2942] = 7496;
    e[2944] = 7498;
    e[2946] = 7500;
    e[2948] = 7502;
    e[2950] = 7504;
    e[2951] = 7505;
    e[2952] = 7506;
    e[2954] = 7508;
    e[2955] = 7509;
    e[2956] = 7510;
    e[2958] = 7512;
    e[2959] = 7513;
    e[2960] = 7514;
    e[2962] = 7516;
    e[2963] = 7517;
    e[2964] = 7518;
    e[2966] = 7520;
    e[2967] = 7521;
    e[2968] = 7522;
    e[2970] = 7524;
    e[2971] = 7525;
    e[2972] = 7526;
    e[2974] = 7528;
    e[2975] = 7529;
    e[2976] = 7530;
    e[2978] = 1537;
    e[2979] = 1538;
    e[2980] = 1539;
    e[2982] = 1549;
    e[2983] = 1551;
    e[2984] = 1552;
    e[2986] = 1554;
    e[2987] = 1555;
    e[2988] = 1556;
    e[2990] = 1623;
    e[2991] = 1624;
    e[2995] = 1775;
    e[2999] = 1791;
    e[3002] = 64290;
    e[3003] = 64291;
    e[3004] = 64292;
    e[3006] = 64294;
    e[3007] = 64295;
    e[3008] = 64296;
    e[3011] = 1900;
    e[3014] = 8223;
    e[3015] = 8244;
    e[3017] = 7532;
    e[3018] = 7533;
    e[3019] = 7534;
    e[3075] = 7590;
    e[3076] = 7591;
    e[3079] = 7594;
    e[3080] = 7595;
    e[3083] = 7598;
    e[3084] = 7599;
    e[3087] = 7602;
    e[3088] = 7603;
    e[3091] = 7606;
    e[3092] = 7607;
    e[3095] = 7610;
    e[3096] = 7611;
    e[3099] = 7614;
    e[3100] = 7615;
    e[3103] = 7618;
    e[3104] = 7619;
    e[3107] = 8337;
    e[3108] = 8338;
    e[3116] = 1884;
    e[3119] = 1885;
    e[3120] = 1885;
    e[3123] = 1886;
    e[3124] = 1886;
    e[3127] = 1887;
    e[3128] = 1887;
    e[3131] = 1888;
    e[3132] = 1888;
    e[3135] = 1889;
    e[3136] = 1889;
    e[3139] = 1890;
    e[3140] = 1890;
    e[3143] = 1891;
    e[3144] = 1891;
    e[3147] = 1892;
    e[3148] = 1892;
    e[3153] = 580;
    e[3154] = 581;
    e[3157] = 584;
    e[3158] = 585;
    e[3161] = 588;
    e[3162] = 589;
    e[3165] = 891;
    e[3166] = 892;
    e[3169] = 1274;
    e[3170] = 1275;
    e[3173] = 1278;
    e[3174] = 1279;
    e[3181] = 7622;
    e[3182] = 7623;
    e[3282] = 11799;
    e[3316] = 578;
    e[3379] = 42785;
    e[3393] = 1159;
    e[3416] = 8377;
  }),
  Aa = getLookupTableFactory(function (e) {
    e[227] = 322;
    e[264] = 261;
    e[291] = 346;
  }),
  ea = getLookupTableFactory(function (e) {
    e[1] = 32;
    e[4] = 65;
    e[5] = 192;
    e[6] = 193;
    e[9] = 196;
    e[17] = 66;
    e[18] = 67;
    e[21] = 268;
    e[24] = 68;
    e[28] = 69;
    e[29] = 200;
    e[30] = 201;
    e[32] = 282;
    e[38] = 70;
    e[39] = 71;
    e[44] = 72;
    e[47] = 73;
    e[48] = 204;
    e[49] = 205;
    e[58] = 74;
    e[60] = 75;
    e[62] = 76;
    e[68] = 77;
    e[69] = 78;
    e[75] = 79;
    e[76] = 210;
    e[80] = 214;
    e[87] = 80;
    e[89] = 81;
    e[90] = 82;
    e[92] = 344;
    e[94] = 83;
    e[97] = 352;
    e[100] = 84;
    e[104] = 85;
    e[109] = 220;
    e[115] = 86;
    e[116] = 87;
    e[121] = 88;
    e[122] = 89;
    e[124] = 221;
    e[127] = 90;
    e[129] = 381;
    e[258] = 97;
    e[259] = 224;
    e[260] = 225;
    e[263] = 228;
    e[268] = 261;
    e[271] = 98;
    e[272] = 99;
    e[273] = 263;
    e[275] = 269;
    e[282] = 100;
    e[286] = 101;
    e[287] = 232;
    e[288] = 233;
    e[290] = 283;
    e[295] = 281;
    e[296] = 102;
    e[336] = 103;
    e[346] = 104;
    e[349] = 105;
    e[350] = 236;
    e[351] = 237;
    e[361] = 106;
    e[364] = 107;
    e[367] = 108;
    e[371] = 322;
    e[373] = 109;
    e[374] = 110;
    e[381] = 111;
    e[382] = 242;
    e[383] = 243;
    e[386] = 246;
    e[393] = 112;
    e[395] = 113;
    e[396] = 114;
    e[398] = 345;
    e[400] = 115;
    e[401] = 347;
    e[403] = 353;
    e[410] = 116;
    e[437] = 117;
    e[442] = 252;
    e[448] = 118;
    e[449] = 119;
    e[454] = 120;
    e[455] = 121;
    e[457] = 253;
    e[460] = 122;
    e[462] = 382;
    e[463] = 380;
    e[853] = 44;
    e[855] = 58;
    e[856] = 46;
    e[876] = 47;
    e[878] = 45;
    e[882] = 45;
    e[894] = 40;
    e[895] = 41;
    e[896] = 91;
    e[897] = 93;
    e[923] = 64;
    e[1004] = 48;
    e[1005] = 49;
    e[1006] = 50;
    e[1007] = 51;
    e[1008] = 52;
    e[1009] = 53;
    e[1010] = 54;
    e[1011] = 55;
    e[1012] = 56;
    e[1013] = 57;
    e[1081] = 37;
    e[1085] = 43;
    e[1086] = 45;
  });
function getStandardFontName(e) {
  var t = normalizeFontName(e);
  return Xi()[t];
}
function isKnownFontName(e) {
  var t = normalizeFontName(e);
  return !!(Xi()[t] || Vi()[t] || zi()[t] || _i()[t]);
}
var ToUnicodeMap = /*#__PURE__*/function () {
  function ToUnicodeMap() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _classCallCheck(this, ToUnicodeMap);
    this._map = e;
  }
  return _createClass(ToUnicodeMap, [{
    key: "length",
    get: function get() {
      return this._map.length;
    }
  }, {
    key: "forEach",
    value: function forEach(e) {
      for (var t in this._map) e(t, this._map[t].charCodeAt(0));
    }
  }, {
    key: "has",
    value: function has(e) {
      return void 0 !== this._map[e];
    }
  }, {
    key: "get",
    value: function get(e) {
      return this._map[e];
    }
  }, {
    key: "charCodeOf",
    value: function charCodeOf(e) {
      var t = this._map;
      if (t.length <= 65536) return t.indexOf(e);
      for (var _i112 in t) if (t[_i112] === e) return 0 | _i112;
      return -1;
    }
  }, {
    key: "amend",
    value: function amend(e) {
      for (var t in e) this._map[t] = e[t];
    }
  }]);
}();
var IdentityToUnicodeMap = /*#__PURE__*/function () {
  function IdentityToUnicodeMap(e, t) {
    _classCallCheck(this, IdentityToUnicodeMap);
    this.firstChar = e;
    this.lastChar = t;
  }
  return _createClass(IdentityToUnicodeMap, [{
    key: "length",
    get: function get() {
      return this.lastChar + 1 - this.firstChar;
    }
  }, {
    key: "forEach",
    value: function forEach(e) {
      for (var t = this.firstChar, _i113 = this.lastChar; t <= _i113; t++) e(t, t);
    }
  }, {
    key: "has",
    value: function has(e) {
      return this.firstChar <= e && e <= this.lastChar;
    }
  }, {
    key: "get",
    value: function get(e) {
      if (this.firstChar <= e && e <= this.lastChar) return String.fromCharCode(e);
    }
  }, {
    key: "charCodeOf",
    value: function charCodeOf(e) {
      return Number.isInteger(e) && e >= this.firstChar && e <= this.lastChar ? e : -1;
    }
  }, {
    key: "amend",
    value: function amend(e) {
      unreachable("Should not call amend()");
    }
  }]);
}();
var CFFFont = /*#__PURE__*/function () {
  function CFFFont(e, t) {
    _classCallCheck(this, CFFFont);
    this.properties = t;
    var i = new CFFParser(e, t, Ki);
    this.cff = i.parse();
    this.cff.duplicateFirstGlyph();
    var a = new CFFCompiler(this.cff);
    this.seacs = this.cff.seacs;
    try {
      this.data = a.compile();
    } catch (_unused6) {
      warn("Failed to compile font " + t.loadedName);
      this.data = e;
    }
    this._createBuiltInEncoding();
  }
  return _createClass(CFFFont, [{
    key: "numGlyphs",
    get: function get() {
      return this.cff.charStrings.count;
    }
  }, {
    key: "getCharset",
    value: function getCharset() {
      return this.cff.charset.charset;
    }
  }, {
    key: "getGlyphMapping",
    value: function getGlyphMapping() {
      var e = this.cff,
        t = this.properties,
        i = t.cidToGidMap,
        a = t.cMap,
        s = e.charset.charset;
      var r, n;
      if (t.composite) {
        var _t128, _g25;
        if ((i === null || i === void 0 ? void 0 : i.length) > 0) {
          _t128 = Object.create(null);
          for (var _e149 = 0, _a110 = i.length; _e149 < _a110; _e149++) {
            var _a111 = i[_e149];
            void 0 !== _a111 && (_t128[_a111] = _e149);
          }
        }
        r = Object.create(null);
        if (e.isCIDFont) for (n = 0; n < s.length; n++) {
          var _t129;
          var _e150 = s[n];
          _g25 = a.charCodeOf(_e150);
          void 0 !== ((_t129 = _t128) === null || _t129 === void 0 ? void 0 : _t129[_g25]) && (_g25 = _t128[_g25]);
          r[_g25] = n;
        } else for (n = 0; n < e.charStrings.count; n++) {
          _g25 = a.charCodeOf(n);
          r[_g25] = n;
        }
        return r;
      }
      var g = e.encoding ? e.encoding.encoding : null;
      t.isInternalFont && (g = t.defaultEncoding);
      r = type1FontGlyphMapping(t, g, s);
      return r;
    }
  }, {
    key: "hasGlyphId",
    value: function hasGlyphId(e) {
      return this.cff.hasGlyphId(e);
    }
  }, {
    key: "_createBuiltInEncoding",
    value: function _createBuiltInEncoding() {
      var _this$cff = this.cff,
        e = _this$cff.charset,
        t = _this$cff.encoding;
      if (!e || !t) return;
      var i = e.charset,
        a = t.encoding,
        s = [];
      for (var _e151 in a) {
        var _t130 = a[_e151];
        if (_t130 >= 0) {
          var _a112 = i[_t130];
          _a112 && (s[_e151] = _a112);
        }
      }
      s.length > 0 && (this.properties.builtInEncoding = s);
    }
  }]);
}();
function getUint32(e, t) {
  return (e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3]) >>> 0;
}
function getUint16(e, t) {
  return e[t] << 8 | e[t + 1];
}
function getInt16(e, t) {
  return (e[t] << 24 | e[t + 1] << 16) >> 16;
}
function getInt8(e, t) {
  return e[t] << 24 >> 24;
}
function getFloat214(e, t) {
  return getInt16(e, t) / 16384;
}
function getSubroutineBias(e) {
  var t = e.length;
  var i = 32768;
  t < 1240 ? i = 107 : t < 33900 && (i = 1131);
  return i;
}
function parseCmap(e, t, i) {
  var a = 1 === getUint16(e, t + 2) ? getUint32(e, t + 8) : getUint32(e, t + 16),
    s = getUint16(e, t + a);
  var r, n, g;
  if (4 === s) {
    getUint16(e, t + a + 2);
    var _i114 = getUint16(e, t + a + 6) >> 1;
    n = t + a + 14;
    r = [];
    for (g = 0; g < _i114; g++, n += 2) r[g] = {
      end: getUint16(e, n)
    };
    n += 2;
    for (g = 0; g < _i114; g++, n += 2) r[g].start = getUint16(e, n);
    for (g = 0; g < _i114; g++, n += 2) r[g].idDelta = getUint16(e, n);
    for (g = 0; g < _i114; g++, n += 2) {
      var _t131 = getUint16(e, n);
      if (0 !== _t131) {
        r[g].ids = [];
        for (var _i115 = 0, _a113 = r[g].end - r[g].start + 1; _i115 < _a113; _i115++) {
          r[g].ids[_i115] = getUint16(e, n + _t131);
          _t131 += 2;
        }
      }
    }
    return r;
  }
  if (12 === s) {
    var _i116 = getUint32(e, t + a + 12);
    n = t + a + 16;
    r = [];
    for (g = 0; g < _i116; g++) {
      t = getUint32(e, n);
      r.push({
        start: t,
        end: getUint32(e, n + 4),
        idDelta: getUint32(e, n + 8) - t
      });
      n += 12;
    }
    return r;
  }
  throw new FormatError("unsupported cmap: ".concat(s));
}
function parseCff(e, t, i, a) {
  var _s$topDict$privateDic, _s$globalSubrIndex;
  var s = new CFFParser(new Stream(e, t, i - t), {}, a).parse();
  return {
    glyphs: s.charStrings.objects,
    subrs: (_s$topDict$privateDic = s.topDict.privateDict) === null || _s$topDict$privateDic === void 0 || (_s$topDict$privateDic = _s$topDict$privateDic.subrsIndex) === null || _s$topDict$privateDic === void 0 ? void 0 : _s$topDict$privateDic.objects,
    gsubrs: (_s$globalSubrIndex = s.globalSubrIndex) === null || _s$globalSubrIndex === void 0 ? void 0 : _s$globalSubrIndex.objects,
    isCFFCIDFont: s.isCIDFont,
    fdSelect: s.fdSelect,
    fdArray: s.fdArray
  };
}
function lookupCmap(e, t) {
  var i = t.codePointAt(0);
  var a = 0,
    s = 0,
    r = e.length - 1;
  for (; s < r;) {
    var _t132 = s + r + 1 >> 1;
    i < e[_t132].start ? r = _t132 - 1 : s = _t132;
  }
  e[s].start <= i && i <= e[s].end && (a = e[s].idDelta + (e[s].ids ? e[s].ids[i - e[s].start] : i) & 65535);
  return {
    charCode: i,
    glyphId: a
  };
}
function compileGlyf(e, t, i) {
  function moveTo(e, i) {
    t.add(lt, [e, i]);
  }
  function lineTo(e, i) {
    t.add(Bt, [e, i]);
  }
  function quadraticCurveTo(e, i, a, s) {
    t.add(Qt, [e, i, a, s]);
  }
  var a = 0;
  var s = getInt16(e, a);
  var r,
    n = 0,
    g = 0;
  a += 10;
  if (s < 0) do {
    r = getUint16(e, a);
    var _s74 = getUint16(e, a + 2);
    a += 4;
    var _o17 = void 0,
      _c11 = void 0;
    if (1 & r) {
      if (2 & r) {
        _o17 = getInt16(e, a);
        _c11 = getInt16(e, a + 2);
      } else {
        _o17 = getUint16(e, a);
        _c11 = getUint16(e, a + 2);
      }
      a += 4;
    } else if (2 & r) {
      _o17 = getInt8(e, a++);
      _c11 = getInt8(e, a++);
    } else {
      _o17 = e[a++];
      _c11 = e[a++];
    }
    if (2 & r) {
      n = _o17;
      g = _c11;
    } else {
      n = 0;
      g = 0;
    }
    var _C7 = 1,
      h = 1,
      l = 0,
      _Q11 = 0;
    if (8 & r) {
      _C7 = h = getFloat214(e, a);
      a += 2;
    } else if (64 & r) {
      _C7 = getFloat214(e, a);
      h = getFloat214(e, a + 2);
      a += 4;
    } else if (128 & r) {
      _C7 = getFloat214(e, a);
      l = getFloat214(e, a + 2);
      _Q11 = getFloat214(e, a + 4);
      h = getFloat214(e, a + 6);
      a += 8;
    }
    var _E9 = i.glyphs[_s74];
    if (_E9) {
      t.add(ut);
      t.add(ft, [_C7, l, _Q11, h, n, g]);
      compileGlyf(_E9, t, i);
      t.add(Et);
    }
  } while (32 & r);else {
    var _t133 = [];
    var _i117, _o18;
    for (_i117 = 0; _i117 < s; _i117++) {
      _t133.push(getUint16(e, a));
      a += 2;
    }
    a += 2 + getUint16(e, a);
    var _c12 = _t133.at(-1) + 1,
      _C8 = [];
    for (; _C8.length < _c12;) {
      r = e[a++];
      var _t134 = 1;
      8 & r && (_t134 += e[a++]);
      for (; _t134-- > 0;) _C8.push({
        flags: r
      });
    }
    for (_i117 = 0; _i117 < _c12; _i117++) {
      switch (18 & _C8[_i117].flags) {
        case 0:
          n += getInt16(e, a);
          a += 2;
          break;
        case 2:
          n -= e[a++];
          break;
        case 18:
          n += e[a++];
      }
      _C8[_i117].x = n;
    }
    for (_i117 = 0; _i117 < _c12; _i117++) {
      switch (36 & _C8[_i117].flags) {
        case 0:
          g += getInt16(e, a);
          a += 2;
          break;
        case 4:
          g -= e[a++];
          break;
        case 36:
          g += e[a++];
      }
      _C8[_i117].y = g;
    }
    var _h6 = 0;
    for (a = 0; a < s; a++) {
      var _e152 = _t133[a],
        _s75 = _C8.slice(_h6, _e152 + 1);
      if (1 & _s75[0].flags) _s75.push(_s75[0]);else if (1 & _s75.at(-1).flags) _s75.unshift(_s75.at(-1));else {
        var _e153 = {
          flags: 1,
          x: (_s75[0].x + _s75.at(-1).x) / 2,
          y: (_s75[0].y + _s75.at(-1).y) / 2
        };
        _s75.unshift(_e153);
        _s75.push(_e153);
      }
      moveTo(_s75[0].x, _s75[0].y);
      for (_i117 = 1, _o18 = _s75.length; _i117 < _o18; _i117++) if (1 & _s75[_i117].flags) lineTo(_s75[_i117].x, _s75[_i117].y);else if (1 & _s75[_i117 + 1].flags) {
        quadraticCurveTo(_s75[_i117].x, _s75[_i117].y, _s75[_i117 + 1].x, _s75[_i117 + 1].y);
        _i117++;
      } else quadraticCurveTo(_s75[_i117].x, _s75[_i117].y, (_s75[_i117].x + _s75[_i117 + 1].x) / 2, (_s75[_i117].y + _s75[_i117 + 1].y) / 2);
      _h6 = _e152 + 1;
    }
  }
}
function compileCharString(e, t, i, a) {
  function moveTo(e, i) {
    t.add(lt, [e, i]);
  }
  function lineTo(e, i) {
    t.add(Bt, [e, i]);
  }
  function bezierCurveTo(e, i, a, s, r, n) {
    t.add(ht, [e, i, a, s, r, n]);
  }
  var s = [];
  var r = 0,
    n = 0,
    g = 0;
  !function parse(e) {
    var o = 0;
    for (; o < e.length;) {
      var _c13 = void 0,
        _C9 = void 0,
        h = void 0,
        l = void 0,
        _Q12 = void 0,
        _E10 = void 0,
        _u6 = void 0,
        _d6 = void 0,
        _f8 = void 0,
        _p6 = !1,
        _m6 = e[o++];
      switch (_m6) {
        case 1:
        case 3:
        case 18:
        case 23:
          g += s.length >> 1;
          _p6 = !0;
          break;
        case 4:
          n += s.pop();
          moveTo(r, n);
          _p6 = !0;
          break;
        case 5:
          for (; s.length > 0;) {
            r += s.shift();
            n += s.shift();
            lineTo(r, n);
          }
          break;
        case 6:
          for (; s.length > 0;) {
            r += s.shift();
            lineTo(r, n);
            if (0 === s.length) break;
            n += s.shift();
            lineTo(r, n);
          }
          break;
        case 7:
          for (; s.length > 0;) {
            n += s.shift();
            lineTo(r, n);
            if (0 === s.length) break;
            r += s.shift();
            lineTo(r, n);
          }
          break;
        case 8:
          for (; s.length > 0;) {
            _c13 = r + s.shift();
            h = n + s.shift();
            _C9 = _c13 + s.shift();
            l = h + s.shift();
            r = _C9 + s.shift();
            n = l + s.shift();
            bezierCurveTo(_c13, h, _C9, l, r, n);
          }
          break;
        case 10:
          _d6 = s.pop();
          _f8 = null;
          if (i.isCFFCIDFont) {
            var _e154 = i.fdSelect.getFDIndex(a);
            if (_e154 >= 0 && _e154 < i.fdArray.length) {
              var _t135$privateDict;
              var _t135 = i.fdArray[_e154];
              var _a114 = void 0;
              ((_t135$privateDict = _t135.privateDict) === null || _t135$privateDict === void 0 ? void 0 : _t135$privateDict.subrsIndex) && (_a114 = _t135.privateDict.subrsIndex.objects);
              if (_a114) {
                _d6 += getSubroutineBias(_a114);
                _f8 = _a114[_d6];
              }
            } else warn("Invalid fd index for glyph index.");
          } else _f8 = i.subrs[_d6 + i.subrsBias];
          _f8 && parse(_f8);
          break;
        case 11:
          return;
        case 12:
          _m6 = e[o++];
          switch (_m6) {
            case 34:
              _c13 = r + s.shift();
              _C9 = _c13 + s.shift();
              _Q12 = n + s.shift();
              r = _C9 + s.shift();
              bezierCurveTo(_c13, n, _C9, _Q12, r, _Q12);
              _c13 = r + s.shift();
              _C9 = _c13 + s.shift();
              r = _C9 + s.shift();
              bezierCurveTo(_c13, _Q12, _C9, n, r, n);
              break;
            case 35:
              _c13 = r + s.shift();
              h = n + s.shift();
              _C9 = _c13 + s.shift();
              l = h + s.shift();
              r = _C9 + s.shift();
              n = l + s.shift();
              bezierCurveTo(_c13, h, _C9, l, r, n);
              _c13 = r + s.shift();
              h = n + s.shift();
              _C9 = _c13 + s.shift();
              l = h + s.shift();
              r = _C9 + s.shift();
              n = l + s.shift();
              bezierCurveTo(_c13, h, _C9, l, r, n);
              s.pop();
              break;
            case 36:
              _c13 = r + s.shift();
              _Q12 = n + s.shift();
              _C9 = _c13 + s.shift();
              _E10 = _Q12 + s.shift();
              r = _C9 + s.shift();
              bezierCurveTo(_c13, _Q12, _C9, _E10, r, _E10);
              _c13 = r + s.shift();
              _C9 = _c13 + s.shift();
              _u6 = _E10 + s.shift();
              r = _C9 + s.shift();
              bezierCurveTo(_c13, _E10, _C9, _u6, r, n);
              break;
            case 37:
              var _e155 = r,
                _t136 = n;
              _c13 = r + s.shift();
              h = n + s.shift();
              _C9 = _c13 + s.shift();
              l = h + s.shift();
              r = _C9 + s.shift();
              n = l + s.shift();
              bezierCurveTo(_c13, h, _C9, l, r, n);
              _c13 = r + s.shift();
              h = n + s.shift();
              _C9 = _c13 + s.shift();
              l = h + s.shift();
              r = _C9;
              n = l;
              Math.abs(r - _e155) > Math.abs(n - _t136) ? r += s.shift() : n += s.shift();
              bezierCurveTo(_c13, h, _C9, l, r, n);
              break;
            default:
              throw new FormatError("unknown operator: 12 ".concat(_m6));
          }
          break;
        case 14:
          if (s.length >= 4) {
            var _e156 = s.pop(),
              _a115 = s.pop();
            n = s.pop();
            r = s.pop();
            t.add(ut);
            t.add(pt, [r, n]);
            var _g26 = lookupCmap(i.cmap, String.fromCharCode(i.glyphNameMap[mi[_e156]]));
            compileCharString(i.glyphs[_g26.glyphId], t, i, _g26.glyphId);
            t.add(Et);
            _g26 = lookupCmap(i.cmap, String.fromCharCode(i.glyphNameMap[mi[_a115]]));
            compileCharString(i.glyphs[_g26.glyphId], t, i, _g26.glyphId);
          }
          return;
        case 19:
        case 20:
          g += s.length >> 1;
          o += g + 7 >> 3;
          _p6 = !0;
          break;
        case 21:
          n += s.pop();
          r += s.pop();
          moveTo(r, n);
          _p6 = !0;
          break;
        case 22:
          r += s.pop();
          moveTo(r, n);
          _p6 = !0;
          break;
        case 24:
          for (; s.length > 2;) {
            _c13 = r + s.shift();
            h = n + s.shift();
            _C9 = _c13 + s.shift();
            l = h + s.shift();
            r = _C9 + s.shift();
            n = l + s.shift();
            bezierCurveTo(_c13, h, _C9, l, r, n);
          }
          r += s.shift();
          n += s.shift();
          lineTo(r, n);
          break;
        case 25:
          for (; s.length > 6;) {
            r += s.shift();
            n += s.shift();
            lineTo(r, n);
          }
          _c13 = r + s.shift();
          h = n + s.shift();
          _C9 = _c13 + s.shift();
          l = h + s.shift();
          r = _C9 + s.shift();
          n = l + s.shift();
          bezierCurveTo(_c13, h, _C9, l, r, n);
          break;
        case 26:
          s.length % 2 && (r += s.shift());
          for (; s.length > 0;) {
            _c13 = r;
            h = n + s.shift();
            _C9 = _c13 + s.shift();
            l = h + s.shift();
            r = _C9;
            n = l + s.shift();
            bezierCurveTo(_c13, h, _C9, l, r, n);
          }
          break;
        case 27:
          s.length % 2 && (n += s.shift());
          for (; s.length > 0;) {
            _c13 = r + s.shift();
            h = n;
            _C9 = _c13 + s.shift();
            l = h + s.shift();
            r = _C9 + s.shift();
            n = l;
            bezierCurveTo(_c13, h, _C9, l, r, n);
          }
          break;
        case 28:
          s.push((e[o] << 24 | e[o + 1] << 16) >> 16);
          o += 2;
          break;
        case 29:
          _d6 = s.pop() + i.gsubrsBias;
          _f8 = i.gsubrs[_d6];
          _f8 && parse(_f8);
          break;
        case 30:
          for (; s.length > 0;) {
            _c13 = r;
            h = n + s.shift();
            _C9 = _c13 + s.shift();
            l = h + s.shift();
            r = _C9 + s.shift();
            n = l + (1 === s.length ? s.shift() : 0);
            bezierCurveTo(_c13, h, _C9, l, r, n);
            if (0 === s.length) break;
            _c13 = r + s.shift();
            h = n;
            _C9 = _c13 + s.shift();
            l = h + s.shift();
            n = l + s.shift();
            r = _C9 + (1 === s.length ? s.shift() : 0);
            bezierCurveTo(_c13, h, _C9, l, r, n);
          }
          break;
        case 31:
          for (; s.length > 0;) {
            _c13 = r + s.shift();
            h = n;
            _C9 = _c13 + s.shift();
            l = h + s.shift();
            n = l + s.shift();
            r = _C9 + (1 === s.length ? s.shift() : 0);
            bezierCurveTo(_c13, h, _C9, l, r, n);
            if (0 === s.length) break;
            _c13 = r;
            h = n + s.shift();
            _C9 = _c13 + s.shift();
            l = h + s.shift();
            r = _C9 + s.shift();
            n = l + (1 === s.length ? s.shift() : 0);
            bezierCurveTo(_c13, h, _C9, l, r, n);
          }
          break;
        default:
          if (_m6 < 32) throw new FormatError("unknown operator: ".concat(_m6));
          if (_m6 < 247) s.push(_m6 - 139);else if (_m6 < 251) s.push(256 * (_m6 - 247) + e[o++] + 108);else if (_m6 < 255) s.push(256 * -(_m6 - 251) - e[o++] - 108);else {
            s.push((e[o] << 24 | e[o + 1] << 16 | e[o + 2] << 8 | e[o + 3]) / 65536);
            o += 4;
          }
      }
      _p6 && (s.length = 0);
    }
  }(e);
}
var ta = [];
var Commands = /*#__PURE__*/function () {
  function Commands() {
    _classCallCheck(this, Commands);
    this.cmds = [];
  }
  return _createClass(Commands, [{
    key: "add",
    value: function add(e, t) {
      var _this$cmds;
      if (t) {
        if (isNumberArray(t, null)) (_this$cmds = this.cmds).push.apply(_this$cmds, [e].concat(_toConsumableArray(t)));else {
          var _this$cmds2;
          warn("Commands.add - \"".concat(e, "\" has at least one non-number arg: \"").concat(t, "\"."));
          var _i118 = t.map(function (e) {
            return "number" == typeof e ? e : 0;
          });
          (_this$cmds2 = this.cmds).push.apply(_this$cmds2, [e].concat(_toConsumableArray(_i118)));
        }
      } else this.cmds.push(e);
    }
  }]);
}();
var CompiledFont = /*#__PURE__*/function () {
  function CompiledFont(e) {
    _classCallCheck(this, CompiledFont);
    this.fontMatrix = e;
    this.compiledGlyphs = Object.create(null);
    this.compiledCharCodeToGlyphId = Object.create(null);
  }
  return _createClass(CompiledFont, [{
    key: "getPathJs",
    value: function getPathJs(e) {
      var _this$compiledCharCod, _this$compiledCharCod2;
      var _lookupCmap = lookupCmap(this.cmap, e),
        t = _lookupCmap.charCode,
        i = _lookupCmap.glyphId;
      var a,
        s = this.compiledGlyphs[i];
      if (!s) {
        try {
          s = this.compileGlyph(this.glyphs[i], i);
        } catch (e) {
          s = ta;
          a = e;
        }
        this.compiledGlyphs[i] = s;
      }
      (_this$compiledCharCod2 = (_this$compiledCharCod = this.compiledCharCodeToGlyphId)[t]) !== null && _this$compiledCharCod2 !== void 0 ? _this$compiledCharCod2 : _this$compiledCharCod[t] = i;
      if (a) throw a;
      return s;
    }
  }, {
    key: "compileGlyph",
    value: function compileGlyph(e, t) {
      if (!e || 0 === e.length || 14 === e[0]) return ta;
      var i = this.fontMatrix;
      if (this.isCFFCIDFont) {
        var _e157 = this.fdSelect.getFDIndex(t);
        if (_e157 >= 0 && _e157 < this.fdArray.length) {
          i = this.fdArray[_e157].getByName("FontMatrix") || a;
        } else warn("Invalid fd index for glyph index.");
      }
      var s = new Commands();
      s.add(ut);
      s.add(ft, i.slice());
      s.add(dt);
      this.compileGlyphImpl(e, s, t);
      s.add(Et);
      return s.cmds;
    }
  }, {
    key: "compileGlyphImpl",
    value: function compileGlyphImpl() {
      unreachable("Children classes should implement this.");
    }
  }, {
    key: "hasBuiltPath",
    value: function hasBuiltPath(e) {
      var _lookupCmap2 = lookupCmap(this.cmap, e),
        t = _lookupCmap2.charCode,
        i = _lookupCmap2.glyphId;
      return void 0 !== this.compiledGlyphs[i] && void 0 !== this.compiledCharCodeToGlyphId[t];
    }
  }]);
}();
var TrueTypeCompiled = /*#__PURE__*/function (_CompiledFont) {
  function TrueTypeCompiled(e, t, i) {
    var _this32;
    _classCallCheck(this, TrueTypeCompiled);
    _this32 = _callSuper(this, TrueTypeCompiled, [i || [488e-6, 0, 0, 488e-6, 0, 0]]);
    _this32.glyphs = e;
    _this32.cmap = t;
    return _this32;
  }
  _inherits(TrueTypeCompiled, _CompiledFont);
  return _createClass(TrueTypeCompiled, [{
    key: "compileGlyphImpl",
    value: function compileGlyphImpl(e, t) {
      compileGlyf(e, t, this);
    }
  }]);
}(CompiledFont);
var Type2Compiled = /*#__PURE__*/function (_CompiledFont2) {
  function Type2Compiled(e, t, i, a) {
    var _this33;
    _classCallCheck(this, Type2Compiled);
    _this33 = _callSuper(this, Type2Compiled, [i || [.001, 0, 0, .001, 0, 0]]);
    _this33.glyphs = e.glyphs;
    _this33.gsubrs = e.gsubrs || [];
    _this33.subrs = e.subrs || [];
    _this33.cmap = t;
    _this33.glyphNameMap = a || xi();
    _this33.gsubrsBias = getSubroutineBias(_this33.gsubrs);
    _this33.subrsBias = getSubroutineBias(_this33.subrs);
    _this33.isCFFCIDFont = e.isCFFCIDFont;
    _this33.fdSelect = e.fdSelect;
    _this33.fdArray = e.fdArray;
    return _this33;
  }
  _inherits(Type2Compiled, _CompiledFont2);
  return _createClass(Type2Compiled, [{
    key: "compileGlyphImpl",
    value: function compileGlyphImpl(e, t, i) {
      compileCharString(e, t, this, i);
    }
  }]);
}(CompiledFont);
var FontRendererFactory = /*#__PURE__*/function () {
  function FontRendererFactory() {
    _classCallCheck(this, FontRendererFactory);
  }
  return _createClass(FontRendererFactory, null, [{
    key: "create",
    value: function create(e, t) {
      var i = new Uint8Array(e.data);
      var a, s, r, n, g, o;
      var c = getUint16(i, 4);
      for (var _e158 = 0, _C10 = 12; _e158 < c; _e158++, _C10 += 16) {
        var _e159 = bytesToString(i.subarray(_C10, _C10 + 4)),
          _c14 = getUint32(i, _C10 + 8),
          h = getUint32(i, _C10 + 12);
        switch (_e159) {
          case "cmap":
            a = parseCmap(i, _c14);
            break;
          case "glyf":
            s = i.subarray(_c14, _c14 + h);
            break;
          case "loca":
            r = i.subarray(_c14, _c14 + h);
            break;
          case "head":
            o = getUint16(i, _c14 + 18);
            g = getUint16(i, _c14 + 50);
            break;
          case "CFF ":
            n = parseCff(i, _c14, _c14 + h, t);
        }
      }
      if (s) {
        var _t137 = o ? [1 / o, 0, 0, 1 / o, 0, 0] : e.fontMatrix;
        return new TrueTypeCompiled(function parseGlyfTable(e, t, i) {
          var a, s;
          if (i) {
            a = 4;
            s = getUint32;
          } else {
            a = 2;
            s = function s(e, t) {
              return 2 * getUint16(e, t);
            };
          }
          var r = [];
          var n = s(t, 0);
          for (var _i119 = a; _i119 < t.length; _i119 += a) {
            var _a116 = s(t, _i119);
            r.push(e.subarray(n, _a116));
            n = _a116;
          }
          return r;
        }(s, r, g), a, _t137);
      }
      return new Type2Compiled(n, a, e.fontMatrix, e.glyphNameMap);
    }
  }]);
}();
var ia = getLookupTableFactory(function (e) {
    e.Courier = 600;
    e["Courier-Bold"] = 600;
    e["Courier-BoldOblique"] = 600;
    e["Courier-Oblique"] = 600;
    e.Helvetica = getLookupTableFactory(function (e) {
      e.space = 278;
      e.exclam = 278;
      e.quotedbl = 355;
      e.numbersign = 556;
      e.dollar = 556;
      e.percent = 889;
      e.ampersand = 667;
      e.quoteright = 222;
      e.parenleft = 333;
      e.parenright = 333;
      e.asterisk = 389;
      e.plus = 584;
      e.comma = 278;
      e.hyphen = 333;
      e.period = 278;
      e.slash = 278;
      e.zero = 556;
      e.one = 556;
      e.two = 556;
      e.three = 556;
      e.four = 556;
      e.five = 556;
      e.six = 556;
      e.seven = 556;
      e.eight = 556;
      e.nine = 556;
      e.colon = 278;
      e.semicolon = 278;
      e.less = 584;
      e.equal = 584;
      e.greater = 584;
      e.question = 556;
      e.at = 1015;
      e.A = 667;
      e.B = 667;
      e.C = 722;
      e.D = 722;
      e.E = 667;
      e.F = 611;
      e.G = 778;
      e.H = 722;
      e.I = 278;
      e.J = 500;
      e.K = 667;
      e.L = 556;
      e.M = 833;
      e.N = 722;
      e.O = 778;
      e.P = 667;
      e.Q = 778;
      e.R = 722;
      e.S = 667;
      e.T = 611;
      e.U = 722;
      e.V = 667;
      e.W = 944;
      e.X = 667;
      e.Y = 667;
      e.Z = 611;
      e.bracketleft = 278;
      e.backslash = 278;
      e.bracketright = 278;
      e.asciicircum = 469;
      e.underscore = 556;
      e.quoteleft = 222;
      e.a = 556;
      e.b = 556;
      e.c = 500;
      e.d = 556;
      e.e = 556;
      e.f = 278;
      e.g = 556;
      e.h = 556;
      e.i = 222;
      e.j = 222;
      e.k = 500;
      e.l = 222;
      e.m = 833;
      e.n = 556;
      e.o = 556;
      e.p = 556;
      e.q = 556;
      e.r = 333;
      e.s = 500;
      e.t = 278;
      e.u = 556;
      e.v = 500;
      e.w = 722;
      e.x = 500;
      e.y = 500;
      e.z = 500;
      e.braceleft = 334;
      e.bar = 260;
      e.braceright = 334;
      e.asciitilde = 584;
      e.exclamdown = 333;
      e.cent = 556;
      e.sterling = 556;
      e.fraction = 167;
      e.yen = 556;
      e.florin = 556;
      e.section = 556;
      e.currency = 556;
      e.quotesingle = 191;
      e.quotedblleft = 333;
      e.guillemotleft = 556;
      e.guilsinglleft = 333;
      e.guilsinglright = 333;
      e.fi = 500;
      e.fl = 500;
      e.endash = 556;
      e.dagger = 556;
      e.daggerdbl = 556;
      e.periodcentered = 278;
      e.paragraph = 537;
      e.bullet = 350;
      e.quotesinglbase = 222;
      e.quotedblbase = 333;
      e.quotedblright = 333;
      e.guillemotright = 556;
      e.ellipsis = 1e3;
      e.perthousand = 1e3;
      e.questiondown = 611;
      e.grave = 333;
      e.acute = 333;
      e.circumflex = 333;
      e.tilde = 333;
      e.macron = 333;
      e.breve = 333;
      e.dotaccent = 333;
      e.dieresis = 333;
      e.ring = 333;
      e.cedilla = 333;
      e.hungarumlaut = 333;
      e.ogonek = 333;
      e.caron = 333;
      e.emdash = 1e3;
      e.AE = 1e3;
      e.ordfeminine = 370;
      e.Lslash = 556;
      e.Oslash = 778;
      e.OE = 1e3;
      e.ordmasculine = 365;
      e.ae = 889;
      e.dotlessi = 278;
      e.lslash = 222;
      e.oslash = 611;
      e.oe = 944;
      e.germandbls = 611;
      e.Idieresis = 278;
      e.eacute = 556;
      e.abreve = 556;
      e.uhungarumlaut = 556;
      e.ecaron = 556;
      e.Ydieresis = 667;
      e.divide = 584;
      e.Yacute = 667;
      e.Acircumflex = 667;
      e.aacute = 556;
      e.Ucircumflex = 722;
      e.yacute = 500;
      e.scommaaccent = 500;
      e.ecircumflex = 556;
      e.Uring = 722;
      e.Udieresis = 722;
      e.aogonek = 556;
      e.Uacute = 722;
      e.uogonek = 556;
      e.Edieresis = 667;
      e.Dcroat = 722;
      e.commaaccent = 250;
      e.copyright = 737;
      e.Emacron = 667;
      e.ccaron = 500;
      e.aring = 556;
      e.Ncommaaccent = 722;
      e.lacute = 222;
      e.agrave = 556;
      e.Tcommaaccent = 611;
      e.Cacute = 722;
      e.atilde = 556;
      e.Edotaccent = 667;
      e.scaron = 500;
      e.scedilla = 500;
      e.iacute = 278;
      e.lozenge = 471;
      e.Rcaron = 722;
      e.Gcommaaccent = 778;
      e.ucircumflex = 556;
      e.acircumflex = 556;
      e.Amacron = 667;
      e.rcaron = 333;
      e.ccedilla = 500;
      e.Zdotaccent = 611;
      e.Thorn = 667;
      e.Omacron = 778;
      e.Racute = 722;
      e.Sacute = 667;
      e.dcaron = 643;
      e.Umacron = 722;
      e.uring = 556;
      e.threesuperior = 333;
      e.Ograve = 778;
      e.Agrave = 667;
      e.Abreve = 667;
      e.multiply = 584;
      e.uacute = 556;
      e.Tcaron = 611;
      e.partialdiff = 476;
      e.ydieresis = 500;
      e.Nacute = 722;
      e.icircumflex = 278;
      e.Ecircumflex = 667;
      e.adieresis = 556;
      e.edieresis = 556;
      e.cacute = 500;
      e.nacute = 556;
      e.umacron = 556;
      e.Ncaron = 722;
      e.Iacute = 278;
      e.plusminus = 584;
      e.brokenbar = 260;
      e.registered = 737;
      e.Gbreve = 778;
      e.Idotaccent = 278;
      e.summation = 600;
      e.Egrave = 667;
      e.racute = 333;
      e.omacron = 556;
      e.Zacute = 611;
      e.Zcaron = 611;
      e.greaterequal = 549;
      e.Eth = 722;
      e.Ccedilla = 722;
      e.lcommaaccent = 222;
      e.tcaron = 317;
      e.eogonek = 556;
      e.Uogonek = 722;
      e.Aacute = 667;
      e.Adieresis = 667;
      e.egrave = 556;
      e.zacute = 500;
      e.iogonek = 222;
      e.Oacute = 778;
      e.oacute = 556;
      e.amacron = 556;
      e.sacute = 500;
      e.idieresis = 278;
      e.Ocircumflex = 778;
      e.Ugrave = 722;
      e.Delta = 612;
      e.thorn = 556;
      e.twosuperior = 333;
      e.Odieresis = 778;
      e.mu = 556;
      e.igrave = 278;
      e.ohungarumlaut = 556;
      e.Eogonek = 667;
      e.dcroat = 556;
      e.threequarters = 834;
      e.Scedilla = 667;
      e.lcaron = 299;
      e.Kcommaaccent = 667;
      e.Lacute = 556;
      e.trademark = 1e3;
      e.edotaccent = 556;
      e.Igrave = 278;
      e.Imacron = 278;
      e.Lcaron = 556;
      e.onehalf = 834;
      e.lessequal = 549;
      e.ocircumflex = 556;
      e.ntilde = 556;
      e.Uhungarumlaut = 722;
      e.Eacute = 667;
      e.emacron = 556;
      e.gbreve = 556;
      e.onequarter = 834;
      e.Scaron = 667;
      e.Scommaaccent = 667;
      e.Ohungarumlaut = 778;
      e.degree = 400;
      e.ograve = 556;
      e.Ccaron = 722;
      e.ugrave = 556;
      e.radical = 453;
      e.Dcaron = 722;
      e.rcommaaccent = 333;
      e.Ntilde = 722;
      e.otilde = 556;
      e.Rcommaaccent = 722;
      e.Lcommaaccent = 556;
      e.Atilde = 667;
      e.Aogonek = 667;
      e.Aring = 667;
      e.Otilde = 778;
      e.zdotaccent = 500;
      e.Ecaron = 667;
      e.Iogonek = 278;
      e.kcommaaccent = 500;
      e.minus = 584;
      e.Icircumflex = 278;
      e.ncaron = 556;
      e.tcommaaccent = 278;
      e.logicalnot = 584;
      e.odieresis = 556;
      e.udieresis = 556;
      e.notequal = 549;
      e.gcommaaccent = 556;
      e.eth = 556;
      e.zcaron = 500;
      e.ncommaaccent = 556;
      e.onesuperior = 333;
      e.imacron = 278;
      e.Euro = 556;
    });
    e["Helvetica-Bold"] = getLookupTableFactory(function (e) {
      e.space = 278;
      e.exclam = 333;
      e.quotedbl = 474;
      e.numbersign = 556;
      e.dollar = 556;
      e.percent = 889;
      e.ampersand = 722;
      e.quoteright = 278;
      e.parenleft = 333;
      e.parenright = 333;
      e.asterisk = 389;
      e.plus = 584;
      e.comma = 278;
      e.hyphen = 333;
      e.period = 278;
      e.slash = 278;
      e.zero = 556;
      e.one = 556;
      e.two = 556;
      e.three = 556;
      e.four = 556;
      e.five = 556;
      e.six = 556;
      e.seven = 556;
      e.eight = 556;
      e.nine = 556;
      e.colon = 333;
      e.semicolon = 333;
      e.less = 584;
      e.equal = 584;
      e.greater = 584;
      e.question = 611;
      e.at = 975;
      e.A = 722;
      e.B = 722;
      e.C = 722;
      e.D = 722;
      e.E = 667;
      e.F = 611;
      e.G = 778;
      e.H = 722;
      e.I = 278;
      e.J = 556;
      e.K = 722;
      e.L = 611;
      e.M = 833;
      e.N = 722;
      e.O = 778;
      e.P = 667;
      e.Q = 778;
      e.R = 722;
      e.S = 667;
      e.T = 611;
      e.U = 722;
      e.V = 667;
      e.W = 944;
      e.X = 667;
      e.Y = 667;
      e.Z = 611;
      e.bracketleft = 333;
      e.backslash = 278;
      e.bracketright = 333;
      e.asciicircum = 584;
      e.underscore = 556;
      e.quoteleft = 278;
      e.a = 556;
      e.b = 611;
      e.c = 556;
      e.d = 611;
      e.e = 556;
      e.f = 333;
      e.g = 611;
      e.h = 611;
      e.i = 278;
      e.j = 278;
      e.k = 556;
      e.l = 278;
      e.m = 889;
      e.n = 611;
      e.o = 611;
      e.p = 611;
      e.q = 611;
      e.r = 389;
      e.s = 556;
      e.t = 333;
      e.u = 611;
      e.v = 556;
      e.w = 778;
      e.x = 556;
      e.y = 556;
      e.z = 500;
      e.braceleft = 389;
      e.bar = 280;
      e.braceright = 389;
      e.asciitilde = 584;
      e.exclamdown = 333;
      e.cent = 556;
      e.sterling = 556;
      e.fraction = 167;
      e.yen = 556;
      e.florin = 556;
      e.section = 556;
      e.currency = 556;
      e.quotesingle = 238;
      e.quotedblleft = 500;
      e.guillemotleft = 556;
      e.guilsinglleft = 333;
      e.guilsinglright = 333;
      e.fi = 611;
      e.fl = 611;
      e.endash = 556;
      e.dagger = 556;
      e.daggerdbl = 556;
      e.periodcentered = 278;
      e.paragraph = 556;
      e.bullet = 350;
      e.quotesinglbase = 278;
      e.quotedblbase = 500;
      e.quotedblright = 500;
      e.guillemotright = 556;
      e.ellipsis = 1e3;
      e.perthousand = 1e3;
      e.questiondown = 611;
      e.grave = 333;
      e.acute = 333;
      e.circumflex = 333;
      e.tilde = 333;
      e.macron = 333;
      e.breve = 333;
      e.dotaccent = 333;
      e.dieresis = 333;
      e.ring = 333;
      e.cedilla = 333;
      e.hungarumlaut = 333;
      e.ogonek = 333;
      e.caron = 333;
      e.emdash = 1e3;
      e.AE = 1e3;
      e.ordfeminine = 370;
      e.Lslash = 611;
      e.Oslash = 778;
      e.OE = 1e3;
      e.ordmasculine = 365;
      e.ae = 889;
      e.dotlessi = 278;
      e.lslash = 278;
      e.oslash = 611;
      e.oe = 944;
      e.germandbls = 611;
      e.Idieresis = 278;
      e.eacute = 556;
      e.abreve = 556;
      e.uhungarumlaut = 611;
      e.ecaron = 556;
      e.Ydieresis = 667;
      e.divide = 584;
      e.Yacute = 667;
      e.Acircumflex = 722;
      e.aacute = 556;
      e.Ucircumflex = 722;
      e.yacute = 556;
      e.scommaaccent = 556;
      e.ecircumflex = 556;
      e.Uring = 722;
      e.Udieresis = 722;
      e.aogonek = 556;
      e.Uacute = 722;
      e.uogonek = 611;
      e.Edieresis = 667;
      e.Dcroat = 722;
      e.commaaccent = 250;
      e.copyright = 737;
      e.Emacron = 667;
      e.ccaron = 556;
      e.aring = 556;
      e.Ncommaaccent = 722;
      e.lacute = 278;
      e.agrave = 556;
      e.Tcommaaccent = 611;
      e.Cacute = 722;
      e.atilde = 556;
      e.Edotaccent = 667;
      e.scaron = 556;
      e.scedilla = 556;
      e.iacute = 278;
      e.lozenge = 494;
      e.Rcaron = 722;
      e.Gcommaaccent = 778;
      e.ucircumflex = 611;
      e.acircumflex = 556;
      e.Amacron = 722;
      e.rcaron = 389;
      e.ccedilla = 556;
      e.Zdotaccent = 611;
      e.Thorn = 667;
      e.Omacron = 778;
      e.Racute = 722;
      e.Sacute = 667;
      e.dcaron = 743;
      e.Umacron = 722;
      e.uring = 611;
      e.threesuperior = 333;
      e.Ograve = 778;
      e.Agrave = 722;
      e.Abreve = 722;
      e.multiply = 584;
      e.uacute = 611;
      e.Tcaron = 611;
      e.partialdiff = 494;
      e.ydieresis = 556;
      e.Nacute = 722;
      e.icircumflex = 278;
      e.Ecircumflex = 667;
      e.adieresis = 556;
      e.edieresis = 556;
      e.cacute = 556;
      e.nacute = 611;
      e.umacron = 611;
      e.Ncaron = 722;
      e.Iacute = 278;
      e.plusminus = 584;
      e.brokenbar = 280;
      e.registered = 737;
      e.Gbreve = 778;
      e.Idotaccent = 278;
      e.summation = 600;
      e.Egrave = 667;
      e.racute = 389;
      e.omacron = 611;
      e.Zacute = 611;
      e.Zcaron = 611;
      e.greaterequal = 549;
      e.Eth = 722;
      e.Ccedilla = 722;
      e.lcommaaccent = 278;
      e.tcaron = 389;
      e.eogonek = 556;
      e.Uogonek = 722;
      e.Aacute = 722;
      e.Adieresis = 722;
      e.egrave = 556;
      e.zacute = 500;
      e.iogonek = 278;
      e.Oacute = 778;
      e.oacute = 611;
      e.amacron = 556;
      e.sacute = 556;
      e.idieresis = 278;
      e.Ocircumflex = 778;
      e.Ugrave = 722;
      e.Delta = 612;
      e.thorn = 611;
      e.twosuperior = 333;
      e.Odieresis = 778;
      e.mu = 611;
      e.igrave = 278;
      e.ohungarumlaut = 611;
      e.Eogonek = 667;
      e.dcroat = 611;
      e.threequarters = 834;
      e.Scedilla = 667;
      e.lcaron = 400;
      e.Kcommaaccent = 722;
      e.Lacute = 611;
      e.trademark = 1e3;
      e.edotaccent = 556;
      e.Igrave = 278;
      e.Imacron = 278;
      e.Lcaron = 611;
      e.onehalf = 834;
      e.lessequal = 549;
      e.ocircumflex = 611;
      e.ntilde = 611;
      e.Uhungarumlaut = 722;
      e.Eacute = 667;
      e.emacron = 556;
      e.gbreve = 611;
      e.onequarter = 834;
      e.Scaron = 667;
      e.Scommaaccent = 667;
      e.Ohungarumlaut = 778;
      e.degree = 400;
      e.ograve = 611;
      e.Ccaron = 722;
      e.ugrave = 611;
      e.radical = 549;
      e.Dcaron = 722;
      e.rcommaaccent = 389;
      e.Ntilde = 722;
      e.otilde = 611;
      e.Rcommaaccent = 722;
      e.Lcommaaccent = 611;
      e.Atilde = 722;
      e.Aogonek = 722;
      e.Aring = 722;
      e.Otilde = 778;
      e.zdotaccent = 500;
      e.Ecaron = 667;
      e.Iogonek = 278;
      e.kcommaaccent = 556;
      e.minus = 584;
      e.Icircumflex = 278;
      e.ncaron = 611;
      e.tcommaaccent = 333;
      e.logicalnot = 584;
      e.odieresis = 611;
      e.udieresis = 611;
      e.notequal = 549;
      e.gcommaaccent = 611;
      e.eth = 611;
      e.zcaron = 500;
      e.ncommaaccent = 611;
      e.onesuperior = 333;
      e.imacron = 278;
      e.Euro = 556;
    });
    e["Helvetica-BoldOblique"] = getLookupTableFactory(function (e) {
      e.space = 278;
      e.exclam = 333;
      e.quotedbl = 474;
      e.numbersign = 556;
      e.dollar = 556;
      e.percent = 889;
      e.ampersand = 722;
      e.quoteright = 278;
      e.parenleft = 333;
      e.parenright = 333;
      e.asterisk = 389;
      e.plus = 584;
      e.comma = 278;
      e.hyphen = 333;
      e.period = 278;
      e.slash = 278;
      e.zero = 556;
      e.one = 556;
      e.two = 556;
      e.three = 556;
      e.four = 556;
      e.five = 556;
      e.six = 556;
      e.seven = 556;
      e.eight = 556;
      e.nine = 556;
      e.colon = 333;
      e.semicolon = 333;
      e.less = 584;
      e.equal = 584;
      e.greater = 584;
      e.question = 611;
      e.at = 975;
      e.A = 722;
      e.B = 722;
      e.C = 722;
      e.D = 722;
      e.E = 667;
      e.F = 611;
      e.G = 778;
      e.H = 722;
      e.I = 278;
      e.J = 556;
      e.K = 722;
      e.L = 611;
      e.M = 833;
      e.N = 722;
      e.O = 778;
      e.P = 667;
      e.Q = 778;
      e.R = 722;
      e.S = 667;
      e.T = 611;
      e.U = 722;
      e.V = 667;
      e.W = 944;
      e.X = 667;
      e.Y = 667;
      e.Z = 611;
      e.bracketleft = 333;
      e.backslash = 278;
      e.bracketright = 333;
      e.asciicircum = 584;
      e.underscore = 556;
      e.quoteleft = 278;
      e.a = 556;
      e.b = 611;
      e.c = 556;
      e.d = 611;
      e.e = 556;
      e.f = 333;
      e.g = 611;
      e.h = 611;
      e.i = 278;
      e.j = 278;
      e.k = 556;
      e.l = 278;
      e.m = 889;
      e.n = 611;
      e.o = 611;
      e.p = 611;
      e.q = 611;
      e.r = 389;
      e.s = 556;
      e.t = 333;
      e.u = 611;
      e.v = 556;
      e.w = 778;
      e.x = 556;
      e.y = 556;
      e.z = 500;
      e.braceleft = 389;
      e.bar = 280;
      e.braceright = 389;
      e.asciitilde = 584;
      e.exclamdown = 333;
      e.cent = 556;
      e.sterling = 556;
      e.fraction = 167;
      e.yen = 556;
      e.florin = 556;
      e.section = 556;
      e.currency = 556;
      e.quotesingle = 238;
      e.quotedblleft = 500;
      e.guillemotleft = 556;
      e.guilsinglleft = 333;
      e.guilsinglright = 333;
      e.fi = 611;
      e.fl = 611;
      e.endash = 556;
      e.dagger = 556;
      e.daggerdbl = 556;
      e.periodcentered = 278;
      e.paragraph = 556;
      e.bullet = 350;
      e.quotesinglbase = 278;
      e.quotedblbase = 500;
      e.quotedblright = 500;
      e.guillemotright = 556;
      e.ellipsis = 1e3;
      e.perthousand = 1e3;
      e.questiondown = 611;
      e.grave = 333;
      e.acute = 333;
      e.circumflex = 333;
      e.tilde = 333;
      e.macron = 333;
      e.breve = 333;
      e.dotaccent = 333;
      e.dieresis = 333;
      e.ring = 333;
      e.cedilla = 333;
      e.hungarumlaut = 333;
      e.ogonek = 333;
      e.caron = 333;
      e.emdash = 1e3;
      e.AE = 1e3;
      e.ordfeminine = 370;
      e.Lslash = 611;
      e.Oslash = 778;
      e.OE = 1e3;
      e.ordmasculine = 365;
      e.ae = 889;
      e.dotlessi = 278;
      e.lslash = 278;
      e.oslash = 611;
      e.oe = 944;
      e.germandbls = 611;
      e.Idieresis = 278;
      e.eacute = 556;
      e.abreve = 556;
      e.uhungarumlaut = 611;
      e.ecaron = 556;
      e.Ydieresis = 667;
      e.divide = 584;
      e.Yacute = 667;
      e.Acircumflex = 722;
      e.aacute = 556;
      e.Ucircumflex = 722;
      e.yacute = 556;
      e.scommaaccent = 556;
      e.ecircumflex = 556;
      e.Uring = 722;
      e.Udieresis = 722;
      e.aogonek = 556;
      e.Uacute = 722;
      e.uogonek = 611;
      e.Edieresis = 667;
      e.Dcroat = 722;
      e.commaaccent = 250;
      e.copyright = 737;
      e.Emacron = 667;
      e.ccaron = 556;
      e.aring = 556;
      e.Ncommaaccent = 722;
      e.lacute = 278;
      e.agrave = 556;
      e.Tcommaaccent = 611;
      e.Cacute = 722;
      e.atilde = 556;
      e.Edotaccent = 667;
      e.scaron = 556;
      e.scedilla = 556;
      e.iacute = 278;
      e.lozenge = 494;
      e.Rcaron = 722;
      e.Gcommaaccent = 778;
      e.ucircumflex = 611;
      e.acircumflex = 556;
      e.Amacron = 722;
      e.rcaron = 389;
      e.ccedilla = 556;
      e.Zdotaccent = 611;
      e.Thorn = 667;
      e.Omacron = 778;
      e.Racute = 722;
      e.Sacute = 667;
      e.dcaron = 743;
      e.Umacron = 722;
      e.uring = 611;
      e.threesuperior = 333;
      e.Ograve = 778;
      e.Agrave = 722;
      e.Abreve = 722;
      e.multiply = 584;
      e.uacute = 611;
      e.Tcaron = 611;
      e.partialdiff = 494;
      e.ydieresis = 556;
      e.Nacute = 722;
      e.icircumflex = 278;
      e.Ecircumflex = 667;
      e.adieresis = 556;
      e.edieresis = 556;
      e.cacute = 556;
      e.nacute = 611;
      e.umacron = 611;
      e.Ncaron = 722;
      e.Iacute = 278;
      e.plusminus = 584;
      e.brokenbar = 280;
      e.registered = 737;
      e.Gbreve = 778;
      e.Idotaccent = 278;
      e.summation = 600;
      e.Egrave = 667;
      e.racute = 389;
      e.omacron = 611;
      e.Zacute = 611;
      e.Zcaron = 611;
      e.greaterequal = 549;
      e.Eth = 722;
      e.Ccedilla = 722;
      e.lcommaaccent = 278;
      e.tcaron = 389;
      e.eogonek = 556;
      e.Uogonek = 722;
      e.Aacute = 722;
      e.Adieresis = 722;
      e.egrave = 556;
      e.zacute = 500;
      e.iogonek = 278;
      e.Oacute = 778;
      e.oacute = 611;
      e.amacron = 556;
      e.sacute = 556;
      e.idieresis = 278;
      e.Ocircumflex = 778;
      e.Ugrave = 722;
      e.Delta = 612;
      e.thorn = 611;
      e.twosuperior = 333;
      e.Odieresis = 778;
      e.mu = 611;
      e.igrave = 278;
      e.ohungarumlaut = 611;
      e.Eogonek = 667;
      e.dcroat = 611;
      e.threequarters = 834;
      e.Scedilla = 667;
      e.lcaron = 400;
      e.Kcommaaccent = 722;
      e.Lacute = 611;
      e.trademark = 1e3;
      e.edotaccent = 556;
      e.Igrave = 278;
      e.Imacron = 278;
      e.Lcaron = 611;
      e.onehalf = 834;
      e.lessequal = 549;
      e.ocircumflex = 611;
      e.ntilde = 611;
      e.Uhungarumlaut = 722;
      e.Eacute = 667;
      e.emacron = 556;
      e.gbreve = 611;
      e.onequarter = 834;
      e.Scaron = 667;
      e.Scommaaccent = 667;
      e.Ohungarumlaut = 778;
      e.degree = 400;
      e.ograve = 611;
      e.Ccaron = 722;
      e.ugrave = 611;
      e.radical = 549;
      e.Dcaron = 722;
      e.rcommaaccent = 389;
      e.Ntilde = 722;
      e.otilde = 611;
      e.Rcommaaccent = 722;
      e.Lcommaaccent = 611;
      e.Atilde = 722;
      e.Aogonek = 722;
      e.Aring = 722;
      e.Otilde = 778;
      e.zdotaccent = 500;
      e.Ecaron = 667;
      e.Iogonek = 278;
      e.kcommaaccent = 556;
      e.minus = 584;
      e.Icircumflex = 278;
      e.ncaron = 611;
      e.tcommaaccent = 333;
      e.logicalnot = 584;
      e.odieresis = 611;
      e.udieresis = 611;
      e.notequal = 549;
      e.gcommaaccent = 611;
      e.eth = 611;
      e.zcaron = 500;
      e.ncommaaccent = 611;
      e.onesuperior = 333;
      e.imacron = 278;
      e.Euro = 556;
    });
    e["Helvetica-Oblique"] = getLookupTableFactory(function (e) {
      e.space = 278;
      e.exclam = 278;
      e.quotedbl = 355;
      e.numbersign = 556;
      e.dollar = 556;
      e.percent = 889;
      e.ampersand = 667;
      e.quoteright = 222;
      e.parenleft = 333;
      e.parenright = 333;
      e.asterisk = 389;
      e.plus = 584;
      e.comma = 278;
      e.hyphen = 333;
      e.period = 278;
      e.slash = 278;
      e.zero = 556;
      e.one = 556;
      e.two = 556;
      e.three = 556;
      e.four = 556;
      e.five = 556;
      e.six = 556;
      e.seven = 556;
      e.eight = 556;
      e.nine = 556;
      e.colon = 278;
      e.semicolon = 278;
      e.less = 584;
      e.equal = 584;
      e.greater = 584;
      e.question = 556;
      e.at = 1015;
      e.A = 667;
      e.B = 667;
      e.C = 722;
      e.D = 722;
      e.E = 667;
      e.F = 611;
      e.G = 778;
      e.H = 722;
      e.I = 278;
      e.J = 500;
      e.K = 667;
      e.L = 556;
      e.M = 833;
      e.N = 722;
      e.O = 778;
      e.P = 667;
      e.Q = 778;
      e.R = 722;
      e.S = 667;
      e.T = 611;
      e.U = 722;
      e.V = 667;
      e.W = 944;
      e.X = 667;
      e.Y = 667;
      e.Z = 611;
      e.bracketleft = 278;
      e.backslash = 278;
      e.bracketright = 278;
      e.asciicircum = 469;
      e.underscore = 556;
      e.quoteleft = 222;
      e.a = 556;
      e.b = 556;
      e.c = 500;
      e.d = 556;
      e.e = 556;
      e.f = 278;
      e.g = 556;
      e.h = 556;
      e.i = 222;
      e.j = 222;
      e.k = 500;
      e.l = 222;
      e.m = 833;
      e.n = 556;
      e.o = 556;
      e.p = 556;
      e.q = 556;
      e.r = 333;
      e.s = 500;
      e.t = 278;
      e.u = 556;
      e.v = 500;
      e.w = 722;
      e.x = 500;
      e.y = 500;
      e.z = 500;
      e.braceleft = 334;
      e.bar = 260;
      e.braceright = 334;
      e.asciitilde = 584;
      e.exclamdown = 333;
      e.cent = 556;
      e.sterling = 556;
      e.fraction = 167;
      e.yen = 556;
      e.florin = 556;
      e.section = 556;
      e.currency = 556;
      e.quotesingle = 191;
      e.quotedblleft = 333;
      e.guillemotleft = 556;
      e.guilsinglleft = 333;
      e.guilsinglright = 333;
      e.fi = 500;
      e.fl = 500;
      e.endash = 556;
      e.dagger = 556;
      e.daggerdbl = 556;
      e.periodcentered = 278;
      e.paragraph = 537;
      e.bullet = 350;
      e.quotesinglbase = 222;
      e.quotedblbase = 333;
      e.quotedblright = 333;
      e.guillemotright = 556;
      e.ellipsis = 1e3;
      e.perthousand = 1e3;
      e.questiondown = 611;
      e.grave = 333;
      e.acute = 333;
      e.circumflex = 333;
      e.tilde = 333;
      e.macron = 333;
      e.breve = 333;
      e.dotaccent = 333;
      e.dieresis = 333;
      e.ring = 333;
      e.cedilla = 333;
      e.hungarumlaut = 333;
      e.ogonek = 333;
      e.caron = 333;
      e.emdash = 1e3;
      e.AE = 1e3;
      e.ordfeminine = 370;
      e.Lslash = 556;
      e.Oslash = 778;
      e.OE = 1e3;
      e.ordmasculine = 365;
      e.ae = 889;
      e.dotlessi = 278;
      e.lslash = 222;
      e.oslash = 611;
      e.oe = 944;
      e.germandbls = 611;
      e.Idieresis = 278;
      e.eacute = 556;
      e.abreve = 556;
      e.uhungarumlaut = 556;
      e.ecaron = 556;
      e.Ydieresis = 667;
      e.divide = 584;
      e.Yacute = 667;
      e.Acircumflex = 667;
      e.aacute = 556;
      e.Ucircumflex = 722;
      e.yacute = 500;
      e.scommaaccent = 500;
      e.ecircumflex = 556;
      e.Uring = 722;
      e.Udieresis = 722;
      e.aogonek = 556;
      e.Uacute = 722;
      e.uogonek = 556;
      e.Edieresis = 667;
      e.Dcroat = 722;
      e.commaaccent = 250;
      e.copyright = 737;
      e.Emacron = 667;
      e.ccaron = 500;
      e.aring = 556;
      e.Ncommaaccent = 722;
      e.lacute = 222;
      e.agrave = 556;
      e.Tcommaaccent = 611;
      e.Cacute = 722;
      e.atilde = 556;
      e.Edotaccent = 667;
      e.scaron = 500;
      e.scedilla = 500;
      e.iacute = 278;
      e.lozenge = 471;
      e.Rcaron = 722;
      e.Gcommaaccent = 778;
      e.ucircumflex = 556;
      e.acircumflex = 556;
      e.Amacron = 667;
      e.rcaron = 333;
      e.ccedilla = 500;
      e.Zdotaccent = 611;
      e.Thorn = 667;
      e.Omacron = 778;
      e.Racute = 722;
      e.Sacute = 667;
      e.dcaron = 643;
      e.Umacron = 722;
      e.uring = 556;
      e.threesuperior = 333;
      e.Ograve = 778;
      e.Agrave = 667;
      e.Abreve = 667;
      e.multiply = 584;
      e.uacute = 556;
      e.Tcaron = 611;
      e.partialdiff = 476;
      e.ydieresis = 500;
      e.Nacute = 722;
      e.icircumflex = 278;
      e.Ecircumflex = 667;
      e.adieresis = 556;
      e.edieresis = 556;
      e.cacute = 500;
      e.nacute = 556;
      e.umacron = 556;
      e.Ncaron = 722;
      e.Iacute = 278;
      e.plusminus = 584;
      e.brokenbar = 260;
      e.registered = 737;
      e.Gbreve = 778;
      e.Idotaccent = 278;
      e.summation = 600;
      e.Egrave = 667;
      e.racute = 333;
      e.omacron = 556;
      e.Zacute = 611;
      e.Zcaron = 611;
      e.greaterequal = 549;
      e.Eth = 722;
      e.Ccedilla = 722;
      e.lcommaaccent = 222;
      e.tcaron = 317;
      e.eogonek = 556;
      e.Uogonek = 722;
      e.Aacute = 667;
      e.Adieresis = 667;
      e.egrave = 556;
      e.zacute = 500;
      e.iogonek = 222;
      e.Oacute = 778;
      e.oacute = 556;
      e.amacron = 556;
      e.sacute = 500;
      e.idieresis = 278;
      e.Ocircumflex = 778;
      e.Ugrave = 722;
      e.Delta = 612;
      e.thorn = 556;
      e.twosuperior = 333;
      e.Odieresis = 778;
      e.mu = 556;
      e.igrave = 278;
      e.ohungarumlaut = 556;
      e.Eogonek = 667;
      e.dcroat = 556;
      e.threequarters = 834;
      e.Scedilla = 667;
      e.lcaron = 299;
      e.Kcommaaccent = 667;
      e.Lacute = 556;
      e.trademark = 1e3;
      e.edotaccent = 556;
      e.Igrave = 278;
      e.Imacron = 278;
      e.Lcaron = 556;
      e.onehalf = 834;
      e.lessequal = 549;
      e.ocircumflex = 556;
      e.ntilde = 556;
      e.Uhungarumlaut = 722;
      e.Eacute = 667;
      e.emacron = 556;
      e.gbreve = 556;
      e.onequarter = 834;
      e.Scaron = 667;
      e.Scommaaccent = 667;
      e.Ohungarumlaut = 778;
      e.degree = 400;
      e.ograve = 556;
      e.Ccaron = 722;
      e.ugrave = 556;
      e.radical = 453;
      e.Dcaron = 722;
      e.rcommaaccent = 333;
      e.Ntilde = 722;
      e.otilde = 556;
      e.Rcommaaccent = 722;
      e.Lcommaaccent = 556;
      e.Atilde = 667;
      e.Aogonek = 667;
      e.Aring = 667;
      e.Otilde = 778;
      e.zdotaccent = 500;
      e.Ecaron = 667;
      e.Iogonek = 278;
      e.kcommaaccent = 500;
      e.minus = 584;
      e.Icircumflex = 278;
      e.ncaron = 556;
      e.tcommaaccent = 278;
      e.logicalnot = 584;
      e.odieresis = 556;
      e.udieresis = 556;
      e.notequal = 549;
      e.gcommaaccent = 556;
      e.eth = 556;
      e.zcaron = 500;
      e.ncommaaccent = 556;
      e.onesuperior = 333;
      e.imacron = 278;
      e.Euro = 556;
    });
    e.Symbol = getLookupTableFactory(function (e) {
      e.space = 250;
      e.exclam = 333;
      e.universal = 713;
      e.numbersign = 500;
      e.existential = 549;
      e.percent = 833;
      e.ampersand = 778;
      e.suchthat = 439;
      e.parenleft = 333;
      e.parenright = 333;
      e.asteriskmath = 500;
      e.plus = 549;
      e.comma = 250;
      e.minus = 549;
      e.period = 250;
      e.slash = 278;
      e.zero = 500;
      e.one = 500;
      e.two = 500;
      e.three = 500;
      e.four = 500;
      e.five = 500;
      e.six = 500;
      e.seven = 500;
      e.eight = 500;
      e.nine = 500;
      e.colon = 278;
      e.semicolon = 278;
      e.less = 549;
      e.equal = 549;
      e.greater = 549;
      e.question = 444;
      e.congruent = 549;
      e.Alpha = 722;
      e.Beta = 667;
      e.Chi = 722;
      e.Delta = 612;
      e.Epsilon = 611;
      e.Phi = 763;
      e.Gamma = 603;
      e.Eta = 722;
      e.Iota = 333;
      e.theta1 = 631;
      e.Kappa = 722;
      e.Lambda = 686;
      e.Mu = 889;
      e.Nu = 722;
      e.Omicron = 722;
      e.Pi = 768;
      e.Theta = 741;
      e.Rho = 556;
      e.Sigma = 592;
      e.Tau = 611;
      e.Upsilon = 690;
      e.sigma1 = 439;
      e.Omega = 768;
      e.Xi = 645;
      e.Psi = 795;
      e.Zeta = 611;
      e.bracketleft = 333;
      e.therefore = 863;
      e.bracketright = 333;
      e.perpendicular = 658;
      e.underscore = 500;
      e.radicalex = 500;
      e.alpha = 631;
      e.beta = 549;
      e.chi = 549;
      e.delta = 494;
      e.epsilon = 439;
      e.phi = 521;
      e.gamma = 411;
      e.eta = 603;
      e.iota = 329;
      e.phi1 = 603;
      e.kappa = 549;
      e.lambda = 549;
      e.mu = 576;
      e.nu = 521;
      e.omicron = 549;
      e.pi = 549;
      e.theta = 521;
      e.rho = 549;
      e.sigma = 603;
      e.tau = 439;
      e.upsilon = 576;
      e.omega1 = 713;
      e.omega = 686;
      e.xi = 493;
      e.psi = 686;
      e.zeta = 494;
      e.braceleft = 480;
      e.bar = 200;
      e.braceright = 480;
      e.similar = 549;
      e.Euro = 750;
      e.Upsilon1 = 620;
      e.minute = 247;
      e.lessequal = 549;
      e.fraction = 167;
      e.infinity = 713;
      e.florin = 500;
      e.club = 753;
      e.diamond = 753;
      e.heart = 753;
      e.spade = 753;
      e.arrowboth = 1042;
      e.arrowleft = 987;
      e.arrowup = 603;
      e.arrowright = 987;
      e.arrowdown = 603;
      e.degree = 400;
      e.plusminus = 549;
      e.second = 411;
      e.greaterequal = 549;
      e.multiply = 549;
      e.proportional = 713;
      e.partialdiff = 494;
      e.bullet = 460;
      e.divide = 549;
      e.notequal = 549;
      e.equivalence = 549;
      e.approxequal = 549;
      e.ellipsis = 1e3;
      e.arrowvertex = 603;
      e.arrowhorizex = 1e3;
      e.carriagereturn = 658;
      e.aleph = 823;
      e.Ifraktur = 686;
      e.Rfraktur = 795;
      e.weierstrass = 987;
      e.circlemultiply = 768;
      e.circleplus = 768;
      e.emptyset = 823;
      e.intersection = 768;
      e.union = 768;
      e.propersuperset = 713;
      e.reflexsuperset = 713;
      e.notsubset = 713;
      e.propersubset = 713;
      e.reflexsubset = 713;
      e.element = 713;
      e.notelement = 713;
      e.angle = 768;
      e.gradient = 713;
      e.registerserif = 790;
      e.copyrightserif = 790;
      e.trademarkserif = 890;
      e.product = 823;
      e.radical = 549;
      e.dotmath = 250;
      e.logicalnot = 713;
      e.logicaland = 603;
      e.logicalor = 603;
      e.arrowdblboth = 1042;
      e.arrowdblleft = 987;
      e.arrowdblup = 603;
      e.arrowdblright = 987;
      e.arrowdbldown = 603;
      e.lozenge = 494;
      e.angleleft = 329;
      e.registersans = 790;
      e.copyrightsans = 790;
      e.trademarksans = 786;
      e.summation = 713;
      e.parenlefttp = 384;
      e.parenleftex = 384;
      e.parenleftbt = 384;
      e.bracketlefttp = 384;
      e.bracketleftex = 384;
      e.bracketleftbt = 384;
      e.bracelefttp = 494;
      e.braceleftmid = 494;
      e.braceleftbt = 494;
      e.braceex = 494;
      e.angleright = 329;
      e.integral = 274;
      e.integraltp = 686;
      e.integralex = 686;
      e.integralbt = 686;
      e.parenrighttp = 384;
      e.parenrightex = 384;
      e.parenrightbt = 384;
      e.bracketrighttp = 384;
      e.bracketrightex = 384;
      e.bracketrightbt = 384;
      e.bracerighttp = 494;
      e.bracerightmid = 494;
      e.bracerightbt = 494;
      e.apple = 790;
    });
    e["Times-Roman"] = getLookupTableFactory(function (e) {
      e.space = 250;
      e.exclam = 333;
      e.quotedbl = 408;
      e.numbersign = 500;
      e.dollar = 500;
      e.percent = 833;
      e.ampersand = 778;
      e.quoteright = 333;
      e.parenleft = 333;
      e.parenright = 333;
      e.asterisk = 500;
      e.plus = 564;
      e.comma = 250;
      e.hyphen = 333;
      e.period = 250;
      e.slash = 278;
      e.zero = 500;
      e.one = 500;
      e.two = 500;
      e.three = 500;
      e.four = 500;
      e.five = 500;
      e.six = 500;
      e.seven = 500;
      e.eight = 500;
      e.nine = 500;
      e.colon = 278;
      e.semicolon = 278;
      e.less = 564;
      e.equal = 564;
      e.greater = 564;
      e.question = 444;
      e.at = 921;
      e.A = 722;
      e.B = 667;
      e.C = 667;
      e.D = 722;
      e.E = 611;
      e.F = 556;
      e.G = 722;
      e.H = 722;
      e.I = 333;
      e.J = 389;
      e.K = 722;
      e.L = 611;
      e.M = 889;
      e.N = 722;
      e.O = 722;
      e.P = 556;
      e.Q = 722;
      e.R = 667;
      e.S = 556;
      e.T = 611;
      e.U = 722;
      e.V = 722;
      e.W = 944;
      e.X = 722;
      e.Y = 722;
      e.Z = 611;
      e.bracketleft = 333;
      e.backslash = 278;
      e.bracketright = 333;
      e.asciicircum = 469;
      e.underscore = 500;
      e.quoteleft = 333;
      e.a = 444;
      e.b = 500;
      e.c = 444;
      e.d = 500;
      e.e = 444;
      e.f = 333;
      e.g = 500;
      e.h = 500;
      e.i = 278;
      e.j = 278;
      e.k = 500;
      e.l = 278;
      e.m = 778;
      e.n = 500;
      e.o = 500;
      e.p = 500;
      e.q = 500;
      e.r = 333;
      e.s = 389;
      e.t = 278;
      e.u = 500;
      e.v = 500;
      e.w = 722;
      e.x = 500;
      e.y = 500;
      e.z = 444;
      e.braceleft = 480;
      e.bar = 200;
      e.braceright = 480;
      e.asciitilde = 541;
      e.exclamdown = 333;
      e.cent = 500;
      e.sterling = 500;
      e.fraction = 167;
      e.yen = 500;
      e.florin = 500;
      e.section = 500;
      e.currency = 500;
      e.quotesingle = 180;
      e.quotedblleft = 444;
      e.guillemotleft = 500;
      e.guilsinglleft = 333;
      e.guilsinglright = 333;
      e.fi = 556;
      e.fl = 556;
      e.endash = 500;
      e.dagger = 500;
      e.daggerdbl = 500;
      e.periodcentered = 250;
      e.paragraph = 453;
      e.bullet = 350;
      e.quotesinglbase = 333;
      e.quotedblbase = 444;
      e.quotedblright = 444;
      e.guillemotright = 500;
      e.ellipsis = 1e3;
      e.perthousand = 1e3;
      e.questiondown = 444;
      e.grave = 333;
      e.acute = 333;
      e.circumflex = 333;
      e.tilde = 333;
      e.macron = 333;
      e.breve = 333;
      e.dotaccent = 333;
      e.dieresis = 333;
      e.ring = 333;
      e.cedilla = 333;
      e.hungarumlaut = 333;
      e.ogonek = 333;
      e.caron = 333;
      e.emdash = 1e3;
      e.AE = 889;
      e.ordfeminine = 276;
      e.Lslash = 611;
      e.Oslash = 722;
      e.OE = 889;
      e.ordmasculine = 310;
      e.ae = 667;
      e.dotlessi = 278;
      e.lslash = 278;
      e.oslash = 500;
      e.oe = 722;
      e.germandbls = 500;
      e.Idieresis = 333;
      e.eacute = 444;
      e.abreve = 444;
      e.uhungarumlaut = 500;
      e.ecaron = 444;
      e.Ydieresis = 722;
      e.divide = 564;
      e.Yacute = 722;
      e.Acircumflex = 722;
      e.aacute = 444;
      e.Ucircumflex = 722;
      e.yacute = 500;
      e.scommaaccent = 389;
      e.ecircumflex = 444;
      e.Uring = 722;
      e.Udieresis = 722;
      e.aogonek = 444;
      e.Uacute = 722;
      e.uogonek = 500;
      e.Edieresis = 611;
      e.Dcroat = 722;
      e.commaaccent = 250;
      e.copyright = 760;
      e.Emacron = 611;
      e.ccaron = 444;
      e.aring = 444;
      e.Ncommaaccent = 722;
      e.lacute = 278;
      e.agrave = 444;
      e.Tcommaaccent = 611;
      e.Cacute = 667;
      e.atilde = 444;
      e.Edotaccent = 611;
      e.scaron = 389;
      e.scedilla = 389;
      e.iacute = 278;
      e.lozenge = 471;
      e.Rcaron = 667;
      e.Gcommaaccent = 722;
      e.ucircumflex = 500;
      e.acircumflex = 444;
      e.Amacron = 722;
      e.rcaron = 333;
      e.ccedilla = 444;
      e.Zdotaccent = 611;
      e.Thorn = 556;
      e.Omacron = 722;
      e.Racute = 667;
      e.Sacute = 556;
      e.dcaron = 588;
      e.Umacron = 722;
      e.uring = 500;
      e.threesuperior = 300;
      e.Ograve = 722;
      e.Agrave = 722;
      e.Abreve = 722;
      e.multiply = 564;
      e.uacute = 500;
      e.Tcaron = 611;
      e.partialdiff = 476;
      e.ydieresis = 500;
      e.Nacute = 722;
      e.icircumflex = 278;
      e.Ecircumflex = 611;
      e.adieresis = 444;
      e.edieresis = 444;
      e.cacute = 444;
      e.nacute = 500;
      e.umacron = 500;
      e.Ncaron = 722;
      e.Iacute = 333;
      e.plusminus = 564;
      e.brokenbar = 200;
      e.registered = 760;
      e.Gbreve = 722;
      e.Idotaccent = 333;
      e.summation = 600;
      e.Egrave = 611;
      e.racute = 333;
      e.omacron = 500;
      e.Zacute = 611;
      e.Zcaron = 611;
      e.greaterequal = 549;
      e.Eth = 722;
      e.Ccedilla = 667;
      e.lcommaaccent = 278;
      e.tcaron = 326;
      e.eogonek = 444;
      e.Uogonek = 722;
      e.Aacute = 722;
      e.Adieresis = 722;
      e.egrave = 444;
      e.zacute = 444;
      e.iogonek = 278;
      e.Oacute = 722;
      e.oacute = 500;
      e.amacron = 444;
      e.sacute = 389;
      e.idieresis = 278;
      e.Ocircumflex = 722;
      e.Ugrave = 722;
      e.Delta = 612;
      e.thorn = 500;
      e.twosuperior = 300;
      e.Odieresis = 722;
      e.mu = 500;
      e.igrave = 278;
      e.ohungarumlaut = 500;
      e.Eogonek = 611;
      e.dcroat = 500;
      e.threequarters = 750;
      e.Scedilla = 556;
      e.lcaron = 344;
      e.Kcommaaccent = 722;
      e.Lacute = 611;
      e.trademark = 980;
      e.edotaccent = 444;
      e.Igrave = 333;
      e.Imacron = 333;
      e.Lcaron = 611;
      e.onehalf = 750;
      e.lessequal = 549;
      e.ocircumflex = 500;
      e.ntilde = 500;
      e.Uhungarumlaut = 722;
      e.Eacute = 611;
      e.emacron = 444;
      e.gbreve = 500;
      e.onequarter = 750;
      e.Scaron = 556;
      e.Scommaaccent = 556;
      e.Ohungarumlaut = 722;
      e.degree = 400;
      e.ograve = 500;
      e.Ccaron = 667;
      e.ugrave = 500;
      e.radical = 453;
      e.Dcaron = 722;
      e.rcommaaccent = 333;
      e.Ntilde = 722;
      e.otilde = 500;
      e.Rcommaaccent = 667;
      e.Lcommaaccent = 611;
      e.Atilde = 722;
      e.Aogonek = 722;
      e.Aring = 722;
      e.Otilde = 722;
      e.zdotaccent = 444;
      e.Ecaron = 611;
      e.Iogonek = 333;
      e.kcommaaccent = 500;
      e.minus = 564;
      e.Icircumflex = 333;
      e.ncaron = 500;
      e.tcommaaccent = 278;
      e.logicalnot = 564;
      e.odieresis = 500;
      e.udieresis = 500;
      e.notequal = 549;
      e.gcommaaccent = 500;
      e.eth = 500;
      e.zcaron = 444;
      e.ncommaaccent = 500;
      e.onesuperior = 300;
      e.imacron = 278;
      e.Euro = 500;
    });
    e["Times-Bold"] = getLookupTableFactory(function (e) {
      e.space = 250;
      e.exclam = 333;
      e.quotedbl = 555;
      e.numbersign = 500;
      e.dollar = 500;
      e.percent = 1e3;
      e.ampersand = 833;
      e.quoteright = 333;
      e.parenleft = 333;
      e.parenright = 333;
      e.asterisk = 500;
      e.plus = 570;
      e.comma = 250;
      e.hyphen = 333;
      e.period = 250;
      e.slash = 278;
      e.zero = 500;
      e.one = 500;
      e.two = 500;
      e.three = 500;
      e.four = 500;
      e.five = 500;
      e.six = 500;
      e.seven = 500;
      e.eight = 500;
      e.nine = 500;
      e.colon = 333;
      e.semicolon = 333;
      e.less = 570;
      e.equal = 570;
      e.greater = 570;
      e.question = 500;
      e.at = 930;
      e.A = 722;
      e.B = 667;
      e.C = 722;
      e.D = 722;
      e.E = 667;
      e.F = 611;
      e.G = 778;
      e.H = 778;
      e.I = 389;
      e.J = 500;
      e.K = 778;
      e.L = 667;
      e.M = 944;
      e.N = 722;
      e.O = 778;
      e.P = 611;
      e.Q = 778;
      e.R = 722;
      e.S = 556;
      e.T = 667;
      e.U = 722;
      e.V = 722;
      e.W = 1e3;
      e.X = 722;
      e.Y = 722;
      e.Z = 667;
      e.bracketleft = 333;
      e.backslash = 278;
      e.bracketright = 333;
      e.asciicircum = 581;
      e.underscore = 500;
      e.quoteleft = 333;
      e.a = 500;
      e.b = 556;
      e.c = 444;
      e.d = 556;
      e.e = 444;
      e.f = 333;
      e.g = 500;
      e.h = 556;
      e.i = 278;
      e.j = 333;
      e.k = 556;
      e.l = 278;
      e.m = 833;
      e.n = 556;
      e.o = 500;
      e.p = 556;
      e.q = 556;
      e.r = 444;
      e.s = 389;
      e.t = 333;
      e.u = 556;
      e.v = 500;
      e.w = 722;
      e.x = 500;
      e.y = 500;
      e.z = 444;
      e.braceleft = 394;
      e.bar = 220;
      e.braceright = 394;
      e.asciitilde = 520;
      e.exclamdown = 333;
      e.cent = 500;
      e.sterling = 500;
      e.fraction = 167;
      e.yen = 500;
      e.florin = 500;
      e.section = 500;
      e.currency = 500;
      e.quotesingle = 278;
      e.quotedblleft = 500;
      e.guillemotleft = 500;
      e.guilsinglleft = 333;
      e.guilsinglright = 333;
      e.fi = 556;
      e.fl = 556;
      e.endash = 500;
      e.dagger = 500;
      e.daggerdbl = 500;
      e.periodcentered = 250;
      e.paragraph = 540;
      e.bullet = 350;
      e.quotesinglbase = 333;
      e.quotedblbase = 500;
      e.quotedblright = 500;
      e.guillemotright = 500;
      e.ellipsis = 1e3;
      e.perthousand = 1e3;
      e.questiondown = 500;
      e.grave = 333;
      e.acute = 333;
      e.circumflex = 333;
      e.tilde = 333;
      e.macron = 333;
      e.breve = 333;
      e.dotaccent = 333;
      e.dieresis = 333;
      e.ring = 333;
      e.cedilla = 333;
      e.hungarumlaut = 333;
      e.ogonek = 333;
      e.caron = 333;
      e.emdash = 1e3;
      e.AE = 1e3;
      e.ordfeminine = 300;
      e.Lslash = 667;
      e.Oslash = 778;
      e.OE = 1e3;
      e.ordmasculine = 330;
      e.ae = 722;
      e.dotlessi = 278;
      e.lslash = 278;
      e.oslash = 500;
      e.oe = 722;
      e.germandbls = 556;
      e.Idieresis = 389;
      e.eacute = 444;
      e.abreve = 500;
      e.uhungarumlaut = 556;
      e.ecaron = 444;
      e.Ydieresis = 722;
      e.divide = 570;
      e.Yacute = 722;
      e.Acircumflex = 722;
      e.aacute = 500;
      e.Ucircumflex = 722;
      e.yacute = 500;
      e.scommaaccent = 389;
      e.ecircumflex = 444;
      e.Uring = 722;
      e.Udieresis = 722;
      e.aogonek = 500;
      e.Uacute = 722;
      e.uogonek = 556;
      e.Edieresis = 667;
      e.Dcroat = 722;
      e.commaaccent = 250;
      e.copyright = 747;
      e.Emacron = 667;
      e.ccaron = 444;
      e.aring = 500;
      e.Ncommaaccent = 722;
      e.lacute = 278;
      e.agrave = 500;
      e.Tcommaaccent = 667;
      e.Cacute = 722;
      e.atilde = 500;
      e.Edotaccent = 667;
      e.scaron = 389;
      e.scedilla = 389;
      e.iacute = 278;
      e.lozenge = 494;
      e.Rcaron = 722;
      e.Gcommaaccent = 778;
      e.ucircumflex = 556;
      e.acircumflex = 500;
      e.Amacron = 722;
      e.rcaron = 444;
      e.ccedilla = 444;
      e.Zdotaccent = 667;
      e.Thorn = 611;
      e.Omacron = 778;
      e.Racute = 722;
      e.Sacute = 556;
      e.dcaron = 672;
      e.Umacron = 722;
      e.uring = 556;
      e.threesuperior = 300;
      e.Ograve = 778;
      e.Agrave = 722;
      e.Abreve = 722;
      e.multiply = 570;
      e.uacute = 556;
      e.Tcaron = 667;
      e.partialdiff = 494;
      e.ydieresis = 500;
      e.Nacute = 722;
      e.icircumflex = 278;
      e.Ecircumflex = 667;
      e.adieresis = 500;
      e.edieresis = 444;
      e.cacute = 444;
      e.nacute = 556;
      e.umacron = 556;
      e.Ncaron = 722;
      e.Iacute = 389;
      e.plusminus = 570;
      e.brokenbar = 220;
      e.registered = 747;
      e.Gbreve = 778;
      e.Idotaccent = 389;
      e.summation = 600;
      e.Egrave = 667;
      e.racute = 444;
      e.omacron = 500;
      e.Zacute = 667;
      e.Zcaron = 667;
      e.greaterequal = 549;
      e.Eth = 722;
      e.Ccedilla = 722;
      e.lcommaaccent = 278;
      e.tcaron = 416;
      e.eogonek = 444;
      e.Uogonek = 722;
      e.Aacute = 722;
      e.Adieresis = 722;
      e.egrave = 444;
      e.zacute = 444;
      e.iogonek = 278;
      e.Oacute = 778;
      e.oacute = 500;
      e.amacron = 500;
      e.sacute = 389;
      e.idieresis = 278;
      e.Ocircumflex = 778;
      e.Ugrave = 722;
      e.Delta = 612;
      e.thorn = 556;
      e.twosuperior = 300;
      e.Odieresis = 778;
      e.mu = 556;
      e.igrave = 278;
      e.ohungarumlaut = 500;
      e.Eogonek = 667;
      e.dcroat = 556;
      e.threequarters = 750;
      e.Scedilla = 556;
      e.lcaron = 394;
      e.Kcommaaccent = 778;
      e.Lacute = 667;
      e.trademark = 1e3;
      e.edotaccent = 444;
      e.Igrave = 389;
      e.Imacron = 389;
      e.Lcaron = 667;
      e.onehalf = 750;
      e.lessequal = 549;
      e.ocircumflex = 500;
      e.ntilde = 556;
      e.Uhungarumlaut = 722;
      e.Eacute = 667;
      e.emacron = 444;
      e.gbreve = 500;
      e.onequarter = 750;
      e.Scaron = 556;
      e.Scommaaccent = 556;
      e.Ohungarumlaut = 778;
      e.degree = 400;
      e.ograve = 500;
      e.Ccaron = 722;
      e.ugrave = 556;
      e.radical = 549;
      e.Dcaron = 722;
      e.rcommaaccent = 444;
      e.Ntilde = 722;
      e.otilde = 500;
      e.Rcommaaccent = 722;
      e.Lcommaaccent = 667;
      e.Atilde = 722;
      e.Aogonek = 722;
      e.Aring = 722;
      e.Otilde = 778;
      e.zdotaccent = 444;
      e.Ecaron = 667;
      e.Iogonek = 389;
      e.kcommaaccent = 556;
      e.minus = 570;
      e.Icircumflex = 389;
      e.ncaron = 556;
      e.tcommaaccent = 333;
      e.logicalnot = 570;
      e.odieresis = 500;
      e.udieresis = 556;
      e.notequal = 549;
      e.gcommaaccent = 500;
      e.eth = 500;
      e.zcaron = 444;
      e.ncommaaccent = 556;
      e.onesuperior = 300;
      e.imacron = 278;
      e.Euro = 500;
    });
    e["Times-BoldItalic"] = getLookupTableFactory(function (e) {
      e.space = 250;
      e.exclam = 389;
      e.quotedbl = 555;
      e.numbersign = 500;
      e.dollar = 500;
      e.percent = 833;
      e.ampersand = 778;
      e.quoteright = 333;
      e.parenleft = 333;
      e.parenright = 333;
      e.asterisk = 500;
      e.plus = 570;
      e.comma = 250;
      e.hyphen = 333;
      e.period = 250;
      e.slash = 278;
      e.zero = 500;
      e.one = 500;
      e.two = 500;
      e.three = 500;
      e.four = 500;
      e.five = 500;
      e.six = 500;
      e.seven = 500;
      e.eight = 500;
      e.nine = 500;
      e.colon = 333;
      e.semicolon = 333;
      e.less = 570;
      e.equal = 570;
      e.greater = 570;
      e.question = 500;
      e.at = 832;
      e.A = 667;
      e.B = 667;
      e.C = 667;
      e.D = 722;
      e.E = 667;
      e.F = 667;
      e.G = 722;
      e.H = 778;
      e.I = 389;
      e.J = 500;
      e.K = 667;
      e.L = 611;
      e.M = 889;
      e.N = 722;
      e.O = 722;
      e.P = 611;
      e.Q = 722;
      e.R = 667;
      e.S = 556;
      e.T = 611;
      e.U = 722;
      e.V = 667;
      e.W = 889;
      e.X = 667;
      e.Y = 611;
      e.Z = 611;
      e.bracketleft = 333;
      e.backslash = 278;
      e.bracketright = 333;
      e.asciicircum = 570;
      e.underscore = 500;
      e.quoteleft = 333;
      e.a = 500;
      e.b = 500;
      e.c = 444;
      e.d = 500;
      e.e = 444;
      e.f = 333;
      e.g = 500;
      e.h = 556;
      e.i = 278;
      e.j = 278;
      e.k = 500;
      e.l = 278;
      e.m = 778;
      e.n = 556;
      e.o = 500;
      e.p = 500;
      e.q = 500;
      e.r = 389;
      e.s = 389;
      e.t = 278;
      e.u = 556;
      e.v = 444;
      e.w = 667;
      e.x = 500;
      e.y = 444;
      e.z = 389;
      e.braceleft = 348;
      e.bar = 220;
      e.braceright = 348;
      e.asciitilde = 570;
      e.exclamdown = 389;
      e.cent = 500;
      e.sterling = 500;
      e.fraction = 167;
      e.yen = 500;
      e.florin = 500;
      e.section = 500;
      e.currency = 500;
      e.quotesingle = 278;
      e.quotedblleft = 500;
      e.guillemotleft = 500;
      e.guilsinglleft = 333;
      e.guilsinglright = 333;
      e.fi = 556;
      e.fl = 556;
      e.endash = 500;
      e.dagger = 500;
      e.daggerdbl = 500;
      e.periodcentered = 250;
      e.paragraph = 500;
      e.bullet = 350;
      e.quotesinglbase = 333;
      e.quotedblbase = 500;
      e.quotedblright = 500;
      e.guillemotright = 500;
      e.ellipsis = 1e3;
      e.perthousand = 1e3;
      e.questiondown = 500;
      e.grave = 333;
      e.acute = 333;
      e.circumflex = 333;
      e.tilde = 333;
      e.macron = 333;
      e.breve = 333;
      e.dotaccent = 333;
      e.dieresis = 333;
      e.ring = 333;
      e.cedilla = 333;
      e.hungarumlaut = 333;
      e.ogonek = 333;
      e.caron = 333;
      e.emdash = 1e3;
      e.AE = 944;
      e.ordfeminine = 266;
      e.Lslash = 611;
      e.Oslash = 722;
      e.OE = 944;
      e.ordmasculine = 300;
      e.ae = 722;
      e.dotlessi = 278;
      e.lslash = 278;
      e.oslash = 500;
      e.oe = 722;
      e.germandbls = 500;
      e.Idieresis = 389;
      e.eacute = 444;
      e.abreve = 500;
      e.uhungarumlaut = 556;
      e.ecaron = 444;
      e.Ydieresis = 611;
      e.divide = 570;
      e.Yacute = 611;
      e.Acircumflex = 667;
      e.aacute = 500;
      e.Ucircumflex = 722;
      e.yacute = 444;
      e.scommaaccent = 389;
      e.ecircumflex = 444;
      e.Uring = 722;
      e.Udieresis = 722;
      e.aogonek = 500;
      e.Uacute = 722;
      e.uogonek = 556;
      e.Edieresis = 667;
      e.Dcroat = 722;
      e.commaaccent = 250;
      e.copyright = 747;
      e.Emacron = 667;
      e.ccaron = 444;
      e.aring = 500;
      e.Ncommaaccent = 722;
      e.lacute = 278;
      e.agrave = 500;
      e.Tcommaaccent = 611;
      e.Cacute = 667;
      e.atilde = 500;
      e.Edotaccent = 667;
      e.scaron = 389;
      e.scedilla = 389;
      e.iacute = 278;
      e.lozenge = 494;
      e.Rcaron = 667;
      e.Gcommaaccent = 722;
      e.ucircumflex = 556;
      e.acircumflex = 500;
      e.Amacron = 667;
      e.rcaron = 389;
      e.ccedilla = 444;
      e.Zdotaccent = 611;
      e.Thorn = 611;
      e.Omacron = 722;
      e.Racute = 667;
      e.Sacute = 556;
      e.dcaron = 608;
      e.Umacron = 722;
      e.uring = 556;
      e.threesuperior = 300;
      e.Ograve = 722;
      e.Agrave = 667;
      e.Abreve = 667;
      e.multiply = 570;
      e.uacute = 556;
      e.Tcaron = 611;
      e.partialdiff = 494;
      e.ydieresis = 444;
      e.Nacute = 722;
      e.icircumflex = 278;
      e.Ecircumflex = 667;
      e.adieresis = 500;
      e.edieresis = 444;
      e.cacute = 444;
      e.nacute = 556;
      e.umacron = 556;
      e.Ncaron = 722;
      e.Iacute = 389;
      e.plusminus = 570;
      e.brokenbar = 220;
      e.registered = 747;
      e.Gbreve = 722;
      e.Idotaccent = 389;
      e.summation = 600;
      e.Egrave = 667;
      e.racute = 389;
      e.omacron = 500;
      e.Zacute = 611;
      e.Zcaron = 611;
      e.greaterequal = 549;
      e.Eth = 722;
      e.Ccedilla = 667;
      e.lcommaaccent = 278;
      e.tcaron = 366;
      e.eogonek = 444;
      e.Uogonek = 722;
      e.Aacute = 667;
      e.Adieresis = 667;
      e.egrave = 444;
      e.zacute = 389;
      e.iogonek = 278;
      e.Oacute = 722;
      e.oacute = 500;
      e.amacron = 500;
      e.sacute = 389;
      e.idieresis = 278;
      e.Ocircumflex = 722;
      e.Ugrave = 722;
      e.Delta = 612;
      e.thorn = 500;
      e.twosuperior = 300;
      e.Odieresis = 722;
      e.mu = 576;
      e.igrave = 278;
      e.ohungarumlaut = 500;
      e.Eogonek = 667;
      e.dcroat = 500;
      e.threequarters = 750;
      e.Scedilla = 556;
      e.lcaron = 382;
      e.Kcommaaccent = 667;
      e.Lacute = 611;
      e.trademark = 1e3;
      e.edotaccent = 444;
      e.Igrave = 389;
      e.Imacron = 389;
      e.Lcaron = 611;
      e.onehalf = 750;
      e.lessequal = 549;
      e.ocircumflex = 500;
      e.ntilde = 556;
      e.Uhungarumlaut = 722;
      e.Eacute = 667;
      e.emacron = 444;
      e.gbreve = 500;
      e.onequarter = 750;
      e.Scaron = 556;
      e.Scommaaccent = 556;
      e.Ohungarumlaut = 722;
      e.degree = 400;
      e.ograve = 500;
      e.Ccaron = 667;
      e.ugrave = 556;
      e.radical = 549;
      e.Dcaron = 722;
      e.rcommaaccent = 389;
      e.Ntilde = 722;
      e.otilde = 500;
      e.Rcommaaccent = 667;
      e.Lcommaaccent = 611;
      e.Atilde = 667;
      e.Aogonek = 667;
      e.Aring = 667;
      e.Otilde = 722;
      e.zdotaccent = 389;
      e.Ecaron = 667;
      e.Iogonek = 389;
      e.kcommaaccent = 500;
      e.minus = 606;
      e.Icircumflex = 389;
      e.ncaron = 556;
      e.tcommaaccent = 278;
      e.logicalnot = 606;
      e.odieresis = 500;
      e.udieresis = 556;
      e.notequal = 549;
      e.gcommaaccent = 500;
      e.eth = 500;
      e.zcaron = 389;
      e.ncommaaccent = 556;
      e.onesuperior = 300;
      e.imacron = 278;
      e.Euro = 500;
    });
    e["Times-Italic"] = getLookupTableFactory(function (e) {
      e.space = 250;
      e.exclam = 333;
      e.quotedbl = 420;
      e.numbersign = 500;
      e.dollar = 500;
      e.percent = 833;
      e.ampersand = 778;
      e.quoteright = 333;
      e.parenleft = 333;
      e.parenright = 333;
      e.asterisk = 500;
      e.plus = 675;
      e.comma = 250;
      e.hyphen = 333;
      e.period = 250;
      e.slash = 278;
      e.zero = 500;
      e.one = 500;
      e.two = 500;
      e.three = 500;
      e.four = 500;
      e.five = 500;
      e.six = 500;
      e.seven = 500;
      e.eight = 500;
      e.nine = 500;
      e.colon = 333;
      e.semicolon = 333;
      e.less = 675;
      e.equal = 675;
      e.greater = 675;
      e.question = 500;
      e.at = 920;
      e.A = 611;
      e.B = 611;
      e.C = 667;
      e.D = 722;
      e.E = 611;
      e.F = 611;
      e.G = 722;
      e.H = 722;
      e.I = 333;
      e.J = 444;
      e.K = 667;
      e.L = 556;
      e.M = 833;
      e.N = 667;
      e.O = 722;
      e.P = 611;
      e.Q = 722;
      e.R = 611;
      e.S = 500;
      e.T = 556;
      e.U = 722;
      e.V = 611;
      e.W = 833;
      e.X = 611;
      e.Y = 556;
      e.Z = 556;
      e.bracketleft = 389;
      e.backslash = 278;
      e.bracketright = 389;
      e.asciicircum = 422;
      e.underscore = 500;
      e.quoteleft = 333;
      e.a = 500;
      e.b = 500;
      e.c = 444;
      e.d = 500;
      e.e = 444;
      e.f = 278;
      e.g = 500;
      e.h = 500;
      e.i = 278;
      e.j = 278;
      e.k = 444;
      e.l = 278;
      e.m = 722;
      e.n = 500;
      e.o = 500;
      e.p = 500;
      e.q = 500;
      e.r = 389;
      e.s = 389;
      e.t = 278;
      e.u = 500;
      e.v = 444;
      e.w = 667;
      e.x = 444;
      e.y = 444;
      e.z = 389;
      e.braceleft = 400;
      e.bar = 275;
      e.braceright = 400;
      e.asciitilde = 541;
      e.exclamdown = 389;
      e.cent = 500;
      e.sterling = 500;
      e.fraction = 167;
      e.yen = 500;
      e.florin = 500;
      e.section = 500;
      e.currency = 500;
      e.quotesingle = 214;
      e.quotedblleft = 556;
      e.guillemotleft = 500;
      e.guilsinglleft = 333;
      e.guilsinglright = 333;
      e.fi = 500;
      e.fl = 500;
      e.endash = 500;
      e.dagger = 500;
      e.daggerdbl = 500;
      e.periodcentered = 250;
      e.paragraph = 523;
      e.bullet = 350;
      e.quotesinglbase = 333;
      e.quotedblbase = 556;
      e.quotedblright = 556;
      e.guillemotright = 500;
      e.ellipsis = 889;
      e.perthousand = 1e3;
      e.questiondown = 500;
      e.grave = 333;
      e.acute = 333;
      e.circumflex = 333;
      e.tilde = 333;
      e.macron = 333;
      e.breve = 333;
      e.dotaccent = 333;
      e.dieresis = 333;
      e.ring = 333;
      e.cedilla = 333;
      e.hungarumlaut = 333;
      e.ogonek = 333;
      e.caron = 333;
      e.emdash = 889;
      e.AE = 889;
      e.ordfeminine = 276;
      e.Lslash = 556;
      e.Oslash = 722;
      e.OE = 944;
      e.ordmasculine = 310;
      e.ae = 667;
      e.dotlessi = 278;
      e.lslash = 278;
      e.oslash = 500;
      e.oe = 667;
      e.germandbls = 500;
      e.Idieresis = 333;
      e.eacute = 444;
      e.abreve = 500;
      e.uhungarumlaut = 500;
      e.ecaron = 444;
      e.Ydieresis = 556;
      e.divide = 675;
      e.Yacute = 556;
      e.Acircumflex = 611;
      e.aacute = 500;
      e.Ucircumflex = 722;
      e.yacute = 444;
      e.scommaaccent = 389;
      e.ecircumflex = 444;
      e.Uring = 722;
      e.Udieresis = 722;
      e.aogonek = 500;
      e.Uacute = 722;
      e.uogonek = 500;
      e.Edieresis = 611;
      e.Dcroat = 722;
      e.commaaccent = 250;
      e.copyright = 760;
      e.Emacron = 611;
      e.ccaron = 444;
      e.aring = 500;
      e.Ncommaaccent = 667;
      e.lacute = 278;
      e.agrave = 500;
      e.Tcommaaccent = 556;
      e.Cacute = 667;
      e.atilde = 500;
      e.Edotaccent = 611;
      e.scaron = 389;
      e.scedilla = 389;
      e.iacute = 278;
      e.lozenge = 471;
      e.Rcaron = 611;
      e.Gcommaaccent = 722;
      e.ucircumflex = 500;
      e.acircumflex = 500;
      e.Amacron = 611;
      e.rcaron = 389;
      e.ccedilla = 444;
      e.Zdotaccent = 556;
      e.Thorn = 611;
      e.Omacron = 722;
      e.Racute = 611;
      e.Sacute = 500;
      e.dcaron = 544;
      e.Umacron = 722;
      e.uring = 500;
      e.threesuperior = 300;
      e.Ograve = 722;
      e.Agrave = 611;
      e.Abreve = 611;
      e.multiply = 675;
      e.uacute = 500;
      e.Tcaron = 556;
      e.partialdiff = 476;
      e.ydieresis = 444;
      e.Nacute = 667;
      e.icircumflex = 278;
      e.Ecircumflex = 611;
      e.adieresis = 500;
      e.edieresis = 444;
      e.cacute = 444;
      e.nacute = 500;
      e.umacron = 500;
      e.Ncaron = 667;
      e.Iacute = 333;
      e.plusminus = 675;
      e.brokenbar = 275;
      e.registered = 760;
      e.Gbreve = 722;
      e.Idotaccent = 333;
      e.summation = 600;
      e.Egrave = 611;
      e.racute = 389;
      e.omacron = 500;
      e.Zacute = 556;
      e.Zcaron = 556;
      e.greaterequal = 549;
      e.Eth = 722;
      e.Ccedilla = 667;
      e.lcommaaccent = 278;
      e.tcaron = 300;
      e.eogonek = 444;
      e.Uogonek = 722;
      e.Aacute = 611;
      e.Adieresis = 611;
      e.egrave = 444;
      e.zacute = 389;
      e.iogonek = 278;
      e.Oacute = 722;
      e.oacute = 500;
      e.amacron = 500;
      e.sacute = 389;
      e.idieresis = 278;
      e.Ocircumflex = 722;
      e.Ugrave = 722;
      e.Delta = 612;
      e.thorn = 500;
      e.twosuperior = 300;
      e.Odieresis = 722;
      e.mu = 500;
      e.igrave = 278;
      e.ohungarumlaut = 500;
      e.Eogonek = 611;
      e.dcroat = 500;
      e.threequarters = 750;
      e.Scedilla = 500;
      e.lcaron = 300;
      e.Kcommaaccent = 667;
      e.Lacute = 556;
      e.trademark = 980;
      e.edotaccent = 444;
      e.Igrave = 333;
      e.Imacron = 333;
      e.Lcaron = 611;
      e.onehalf = 750;
      e.lessequal = 549;
      e.ocircumflex = 500;
      e.ntilde = 500;
      e.Uhungarumlaut = 722;
      e.Eacute = 611;
      e.emacron = 444;
      e.gbreve = 500;
      e.onequarter = 750;
      e.Scaron = 500;
      e.Scommaaccent = 500;
      e.Ohungarumlaut = 722;
      e.degree = 400;
      e.ograve = 500;
      e.Ccaron = 667;
      e.ugrave = 500;
      e.radical = 453;
      e.Dcaron = 722;
      e.rcommaaccent = 389;
      e.Ntilde = 667;
      e.otilde = 500;
      e.Rcommaaccent = 611;
      e.Lcommaaccent = 556;
      e.Atilde = 611;
      e.Aogonek = 611;
      e.Aring = 611;
      e.Otilde = 722;
      e.zdotaccent = 389;
      e.Ecaron = 611;
      e.Iogonek = 333;
      e.kcommaaccent = 444;
      e.minus = 675;
      e.Icircumflex = 333;
      e.ncaron = 500;
      e.tcommaaccent = 278;
      e.logicalnot = 675;
      e.odieresis = 500;
      e.udieresis = 500;
      e.notequal = 549;
      e.gcommaaccent = 500;
      e.eth = 500;
      e.zcaron = 389;
      e.ncommaaccent = 500;
      e.onesuperior = 300;
      e.imacron = 278;
      e.Euro = 500;
    });
    e.ZapfDingbats = getLookupTableFactory(function (e) {
      e.space = 278;
      e.a1 = 974;
      e.a2 = 961;
      e.a202 = 974;
      e.a3 = 980;
      e.a4 = 719;
      e.a5 = 789;
      e.a119 = 790;
      e.a118 = 791;
      e.a117 = 690;
      e.a11 = 960;
      e.a12 = 939;
      e.a13 = 549;
      e.a14 = 855;
      e.a15 = 911;
      e.a16 = 933;
      e.a105 = 911;
      e.a17 = 945;
      e.a18 = 974;
      e.a19 = 755;
      e.a20 = 846;
      e.a21 = 762;
      e.a22 = 761;
      e.a23 = 571;
      e.a24 = 677;
      e.a25 = 763;
      e.a26 = 760;
      e.a27 = 759;
      e.a28 = 754;
      e.a6 = 494;
      e.a7 = 552;
      e.a8 = 537;
      e.a9 = 577;
      e.a10 = 692;
      e.a29 = 786;
      e.a30 = 788;
      e.a31 = 788;
      e.a32 = 790;
      e.a33 = 793;
      e.a34 = 794;
      e.a35 = 816;
      e.a36 = 823;
      e.a37 = 789;
      e.a38 = 841;
      e.a39 = 823;
      e.a40 = 833;
      e.a41 = 816;
      e.a42 = 831;
      e.a43 = 923;
      e.a44 = 744;
      e.a45 = 723;
      e.a46 = 749;
      e.a47 = 790;
      e.a48 = 792;
      e.a49 = 695;
      e.a50 = 776;
      e.a51 = 768;
      e.a52 = 792;
      e.a53 = 759;
      e.a54 = 707;
      e.a55 = 708;
      e.a56 = 682;
      e.a57 = 701;
      e.a58 = 826;
      e.a59 = 815;
      e.a60 = 789;
      e.a61 = 789;
      e.a62 = 707;
      e.a63 = 687;
      e.a64 = 696;
      e.a65 = 689;
      e.a66 = 786;
      e.a67 = 787;
      e.a68 = 713;
      e.a69 = 791;
      e.a70 = 785;
      e.a71 = 791;
      e.a72 = 873;
      e.a73 = 761;
      e.a74 = 762;
      e.a203 = 762;
      e.a75 = 759;
      e.a204 = 759;
      e.a76 = 892;
      e.a77 = 892;
      e.a78 = 788;
      e.a79 = 784;
      e.a81 = 438;
      e.a82 = 138;
      e.a83 = 277;
      e.a84 = 415;
      e.a97 = 392;
      e.a98 = 392;
      e.a99 = 668;
      e.a100 = 668;
      e.a89 = 390;
      e.a90 = 390;
      e.a93 = 317;
      e.a94 = 317;
      e.a91 = 276;
      e.a92 = 276;
      e.a205 = 509;
      e.a85 = 509;
      e.a206 = 410;
      e.a86 = 410;
      e.a87 = 234;
      e.a88 = 234;
      e.a95 = 334;
      e.a96 = 334;
      e.a101 = 732;
      e.a102 = 544;
      e.a103 = 544;
      e.a104 = 910;
      e.a106 = 667;
      e.a107 = 760;
      e.a108 = 760;
      e.a112 = 776;
      e.a111 = 595;
      e.a110 = 694;
      e.a109 = 626;
      e.a120 = 788;
      e.a121 = 788;
      e.a122 = 788;
      e.a123 = 788;
      e.a124 = 788;
      e.a125 = 788;
      e.a126 = 788;
      e.a127 = 788;
      e.a128 = 788;
      e.a129 = 788;
      e.a130 = 788;
      e.a131 = 788;
      e.a132 = 788;
      e.a133 = 788;
      e.a134 = 788;
      e.a135 = 788;
      e.a136 = 788;
      e.a137 = 788;
      e.a138 = 788;
      e.a139 = 788;
      e.a140 = 788;
      e.a141 = 788;
      e.a142 = 788;
      e.a143 = 788;
      e.a144 = 788;
      e.a145 = 788;
      e.a146 = 788;
      e.a147 = 788;
      e.a148 = 788;
      e.a149 = 788;
      e.a150 = 788;
      e.a151 = 788;
      e.a152 = 788;
      e.a153 = 788;
      e.a154 = 788;
      e.a155 = 788;
      e.a156 = 788;
      e.a157 = 788;
      e.a158 = 788;
      e.a159 = 788;
      e.a160 = 894;
      e.a161 = 838;
      e.a163 = 1016;
      e.a164 = 458;
      e.a196 = 748;
      e.a165 = 924;
      e.a192 = 748;
      e.a166 = 918;
      e.a167 = 927;
      e.a168 = 928;
      e.a169 = 928;
      e.a170 = 834;
      e.a171 = 873;
      e.a172 = 828;
      e.a173 = 924;
      e.a162 = 924;
      e.a174 = 917;
      e.a175 = 930;
      e.a176 = 931;
      e.a177 = 463;
      e.a178 = 883;
      e.a179 = 836;
      e.a193 = 836;
      e.a180 = 867;
      e.a199 = 867;
      e.a181 = 696;
      e.a200 = 696;
      e.a182 = 874;
      e.a201 = 874;
      e.a183 = 760;
      e.a184 = 946;
      e.a197 = 771;
      e.a185 = 865;
      e.a194 = 771;
      e.a198 = 888;
      e.a186 = 967;
      e.a195 = 888;
      e.a187 = 831;
      e.a188 = 873;
      e.a189 = 927;
      e.a190 = 970;
      e.a191 = 918;
    });
  }),
  aa = getLookupTableFactory(function (e) {
    e.Courier = {
      ascent: 629,
      descent: -157,
      capHeight: 562,
      xHeight: -426
    };
    e["Courier-Bold"] = {
      ascent: 629,
      descent: -157,
      capHeight: 562,
      xHeight: 439
    };
    e["Courier-Oblique"] = {
      ascent: 629,
      descent: -157,
      capHeight: 562,
      xHeight: 426
    };
    e["Courier-BoldOblique"] = {
      ascent: 629,
      descent: -157,
      capHeight: 562,
      xHeight: 426
    };
    e.Helvetica = {
      ascent: 718,
      descent: -207,
      capHeight: 718,
      xHeight: 523
    };
    e["Helvetica-Bold"] = {
      ascent: 718,
      descent: -207,
      capHeight: 718,
      xHeight: 532
    };
    e["Helvetica-Oblique"] = {
      ascent: 718,
      descent: -207,
      capHeight: 718,
      xHeight: 523
    };
    e["Helvetica-BoldOblique"] = {
      ascent: 718,
      descent: -207,
      capHeight: 718,
      xHeight: 532
    };
    e["Times-Roman"] = {
      ascent: 683,
      descent: -217,
      capHeight: 662,
      xHeight: 450
    };
    e["Times-Bold"] = {
      ascent: 683,
      descent: -217,
      capHeight: 676,
      xHeight: 461
    };
    e["Times-Italic"] = {
      ascent: 683,
      descent: -217,
      capHeight: 653,
      xHeight: 441
    };
    e["Times-BoldItalic"] = {
      ascent: 683,
      descent: -217,
      capHeight: 669,
      xHeight: 462
    };
    e.Symbol = {
      ascent: Math.NaN,
      descent: Math.NaN,
      capHeight: Math.NaN,
      xHeight: Math.NaN
    };
    e.ZapfDingbats = {
      ascent: Math.NaN,
      descent: Math.NaN,
      capHeight: Math.NaN,
      xHeight: Math.NaN
    };
  });
var GlyfTable = /*#__PURE__*/function () {
  function GlyfTable(_ref40) {
    var e = _ref40.glyfTable,
      t = _ref40.isGlyphLocationsLong,
      i = _ref40.locaTable,
      a = _ref40.numGlyphs;
    _classCallCheck(this, GlyfTable);
    this.glyphs = [];
    var s = new DataView(i.buffer, i.byteOffset, i.byteLength),
      r = new DataView(e.buffer, e.byteOffset, e.byteLength),
      n = t ? 4 : 2;
    var g = t ? s.getUint32(0) : 2 * s.getUint16(0),
      o = 0;
    for (var _e160 = 0; _e160 < a; _e160++) {
      o += n;
      var _e161 = t ? s.getUint32(o) : 2 * s.getUint16(o);
      if (_e161 === g) {
        this.glyphs.push(new Glyph({}));
        continue;
      }
      var _i120 = Glyph.parse(g, r);
      this.glyphs.push(_i120);
      g = _e161;
    }
  }
  return _createClass(GlyfTable, [{
    key: "getSize",
    value: function getSize() {
      return this.glyphs.reduce(function (e, t) {
        return e + (t.getSize() + 3 & -4);
      }, 0);
    }
  }, {
    key: "write",
    value: function write() {
      var e = this.getSize(),
        t = new DataView(new ArrayBuffer(e)),
        i = e > 131070,
        a = i ? 4 : 2,
        s = new DataView(new ArrayBuffer((this.glyphs.length + 1) * a));
      i ? s.setUint32(0, 0) : s.setUint16(0, 0);
      var r = 0,
        n = 0;
      var _iterator33 = _createForOfIteratorHelper(this.glyphs),
        _step33;
      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var _e162 = _step33.value;
          r += _e162.write(r, t);
          r = r + 3 & -4;
          n += a;
          i ? s.setUint32(n, r) : s.setUint16(n, r >> 1);
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }
      return {
        isLocationLong: i,
        loca: new Uint8Array(s.buffer),
        glyf: new Uint8Array(t.buffer)
      };
    }
  }, {
    key: "scale",
    value: function scale(e) {
      for (var t = 0, _i121 = this.glyphs.length; t < _i121; t++) this.glyphs[t].scale(e[t]);
    }
  }]);
}();
var Glyph = /*#__PURE__*/function () {
  function Glyph(_ref41) {
    var _ref41$header = _ref41.header,
      e = _ref41$header === void 0 ? null : _ref41$header,
      _ref41$simple = _ref41.simple,
      t = _ref41$simple === void 0 ? null : _ref41$simple,
      _ref41$composites = _ref41.composites,
      i = _ref41$composites === void 0 ? null : _ref41$composites;
    _classCallCheck(this, Glyph);
    this.header = e;
    this.simple = t;
    this.composites = i;
  }
  return _createClass(Glyph, [{
    key: "getSize",
    value: function getSize() {
      if (!this.header) return 0;
      var e = this.simple ? this.simple.getSize() : this.composites.reduce(function (e, t) {
        return e + t.getSize();
      }, 0);
      return this.header.getSize() + e;
    }
  }, {
    key: "write",
    value: function write(e, t) {
      if (!this.header) return 0;
      var i = e;
      e += this.header.write(e, t);
      if (this.simple) e += this.simple.write(e, t);else {
        var _iterator34 = _createForOfIteratorHelper(this.composites),
          _step34;
        try {
          for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
            var _i122 = _step34.value;
            e += _i122.write(e, t);
          }
        } catch (err) {
          _iterator34.e(err);
        } finally {
          _iterator34.f();
        }
      }
      return e - i;
    }
  }, {
    key: "scale",
    value: function scale(e) {
      if (!this.header) return;
      var t = (this.header.xMin + this.header.xMax) / 2;
      this.header.scale(t, e);
      if (this.simple) this.simple.scale(t, e);else {
        var _iterator35 = _createForOfIteratorHelper(this.composites),
          _step35;
        try {
          for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
            var _i123 = _step35.value;
            _i123.scale(t, e);
          }
        } catch (err) {
          _iterator35.e(err);
        } finally {
          _iterator35.f();
        }
      }
    }
  }], [{
    key: "parse",
    value: function parse(e, t) {
      var _GlyphHeader$parse = GlyphHeader.parse(e, t),
        _GlyphHeader$parse2 = _slicedToArray(_GlyphHeader$parse, 2),
        i = _GlyphHeader$parse2[0],
        a = _GlyphHeader$parse2[1];
      e += i;
      if (a.numberOfContours < 0) {
        var _i124 = [];
        for (;;) {
          var _CompositeGlyph$parse = CompositeGlyph.parse(e, t),
            _CompositeGlyph$parse2 = _slicedToArray(_CompositeGlyph$parse, 2),
            _a117 = _CompositeGlyph$parse2[0],
            _s76 = _CompositeGlyph$parse2[1];
          e += _a117;
          _i124.push(_s76);
          if (!(32 & _s76.flags)) break;
        }
        return new Glyph({
          header: a,
          composites: _i124
        });
      }
      var s = SimpleGlyph.parse(e, t, a.numberOfContours);
      return new Glyph({
        header: a,
        simple: s
      });
    }
  }]);
}();
var GlyphHeader = /*#__PURE__*/function () {
  function GlyphHeader(_ref42) {
    var e = _ref42.numberOfContours,
      t = _ref42.xMin,
      i = _ref42.yMin,
      a = _ref42.xMax,
      s = _ref42.yMax;
    _classCallCheck(this, GlyphHeader);
    this.numberOfContours = e;
    this.xMin = t;
    this.yMin = i;
    this.xMax = a;
    this.yMax = s;
  }
  return _createClass(GlyphHeader, [{
    key: "getSize",
    value: function getSize() {
      return 10;
    }
  }, {
    key: "write",
    value: function write(e, t) {
      t.setInt16(e, this.numberOfContours);
      t.setInt16(e + 2, this.xMin);
      t.setInt16(e + 4, this.yMin);
      t.setInt16(e + 6, this.xMax);
      t.setInt16(e + 8, this.yMax);
      return 10;
    }
  }, {
    key: "scale",
    value: function scale(e, t) {
      this.xMin = Math.round(e + (this.xMin - e) * t);
      this.xMax = Math.round(e + (this.xMax - e) * t);
    }
  }], [{
    key: "parse",
    value: function parse(e, t) {
      return [10, new GlyphHeader({
        numberOfContours: t.getInt16(e),
        xMin: t.getInt16(e + 2),
        yMin: t.getInt16(e + 4),
        xMax: t.getInt16(e + 6),
        yMax: t.getInt16(e + 8)
      })];
    }
  }]);
}();
var Contour = /*#__PURE__*/_createClass(function Contour(_ref43) {
  var e = _ref43.flags,
    t = _ref43.xCoordinates,
    i = _ref43.yCoordinates;
  _classCallCheck(this, Contour);
  this.xCoordinates = t;
  this.yCoordinates = i;
  this.flags = e;
});
var SimpleGlyph = /*#__PURE__*/function () {
  function SimpleGlyph(_ref44) {
    var e = _ref44.contours,
      t = _ref44.instructions;
    _classCallCheck(this, SimpleGlyph);
    this.contours = e;
    this.instructions = t;
  }
  return _createClass(SimpleGlyph, [{
    key: "getSize",
    value: function getSize() {
      var e = 2 * this.contours.length + 2 + this.instructions.length,
        t = 0,
        i = 0;
      var _iterator36 = _createForOfIteratorHelper(this.contours),
        _step36;
      try {
        for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
          var _a118 = _step36.value;
          e += _a118.flags.length;
          for (var _s77 = 0, _r53 = _a118.xCoordinates.length; _s77 < _r53; _s77++) {
            var _r54 = _a118.xCoordinates[_s77],
              _n43 = _a118.yCoordinates[_s77];
            var _g27 = Math.abs(_r54 - t);
            _g27 > 255 ? e += 2 : _g27 > 0 && (e += 1);
            t = _r54;
            _g27 = Math.abs(_n43 - i);
            _g27 > 255 ? e += 2 : _g27 > 0 && (e += 1);
            i = _n43;
          }
        }
      } catch (err) {
        _iterator36.e(err);
      } finally {
        _iterator36.f();
      }
      return e;
    }
  }, {
    key: "write",
    value: function write(e, t) {
      var i = e,
        a = [],
        s = [],
        r = [];
      var n = 0,
        g = 0;
      var _iterator37 = _createForOfIteratorHelper(this.contours),
        _step37;
      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var _i129 = _step37.value;
          for (var _e163 = 0, _t138 = _i129.xCoordinates.length; _e163 < _t138; _e163++) {
            var _t139 = _i129.flags[_e163];
            var _o19 = _i129.xCoordinates[_e163];
            var _c15 = _o19 - n;
            if (0 === _c15) {
              _t139 |= 16;
              a.push(0);
            } else {
              var _e164 = Math.abs(_c15);
              if (_e164 <= 255) {
                _t139 |= _c15 >= 0 ? 18 : 2;
                a.push(_e164);
              } else a.push(_c15);
            }
            n = _o19;
            var _C11 = _i129.yCoordinates[_e163];
            _c15 = _C11 - g;
            if (0 === _c15) {
              _t139 |= 32;
              s.push(0);
            } else {
              var _e165 = Math.abs(_c15);
              if (_e165 <= 255) {
                _t139 |= _c15 >= 0 ? 36 : 4;
                s.push(_e165);
              } else s.push(_c15);
            }
            g = _C11;
            r.push(_t139);
          }
          t.setUint16(e, a.length - 1);
          e += 2;
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
      t.setUint16(e, this.instructions.length);
      e += 2;
      if (this.instructions.length) {
        new Uint8Array(t.buffer, 0, t.buffer.byteLength).set(this.instructions, e);
        e += this.instructions.length;
      }
      for (var _i125 = 0, _r55 = r; _i125 < _r55.length; _i125++) {
        var _i126 = _r55[_i125];
        t.setUint8(e++, _i126);
      }
      for (var _i127 = 0, _s78 = a.length; _i127 < _s78; _i127++) {
        var _s79 = a[_i127],
          _n44 = r[_i127];
        if (2 & _n44) t.setUint8(e++, _s79);else if (!(16 & _n44)) {
          t.setInt16(e, _s79);
          e += 2;
        }
      }
      for (var _i128 = 0, _a119 = s.length; _i128 < _a119; _i128++) {
        var _a120 = s[_i128],
          _n45 = r[_i128];
        if (4 & _n45) t.setUint8(e++, _a120);else if (!(32 & _n45)) {
          t.setInt16(e, _a120);
          e += 2;
        }
      }
      return e - i;
    }
  }, {
    key: "scale",
    value: function scale(e, t) {
      var _iterator38 = _createForOfIteratorHelper(this.contours),
        _step38;
      try {
        for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
          var _i130 = _step38.value;
          if (0 !== _i130.xCoordinates.length) for (var _a121 = 0, _s80 = _i130.xCoordinates.length; _a121 < _s80; _a121++) _i130.xCoordinates[_a121] = Math.round(e + (_i130.xCoordinates[_a121] - e) * t);
        }
      } catch (err) {
        _iterator38.e(err);
      } finally {
        _iterator38.f();
      }
    }
  }], [{
    key: "parse",
    value: function parse(e, t, i) {
      var a = [];
      for (var _s81 = 0; _s81 < i; _s81++) {
        var _i131 = t.getUint16(e);
        e += 2;
        a.push(_i131);
      }
      var s = a[i - 1] + 1,
        r = t.getUint16(e);
      e += 2;
      var n = new Uint8Array(t).slice(e, e + r);
      e += r;
      var g = [];
      for (var _i132 = 0; _i132 < s; e++, _i132++) {
        var _a122 = t.getUint8(e);
        g.push(_a122);
        if (8 & _a122) {
          var _s82 = t.getUint8(++e);
          _a122 ^= 8;
          for (var _e166 = 0; _e166 < _s82; _e166++) g.push(_a122);
          _i132 += _s82;
        }
      }
      var o = [];
      var c = [],
        C = [],
        h = [];
      var l = [];
      var Q = 0,
        E = 0;
      for (var _i133 = 0; _i133 < s; _i133++) {
        var _s83 = g[_i133];
        if (2 & _s83) {
          var _i134 = t.getUint8(e++);
          E += 16 & _s83 ? _i134 : -_i134;
          c.push(E);
        } else if (16 & _s83) c.push(E);else {
          E += t.getInt16(e);
          e += 2;
          c.push(E);
        }
        if (a[Q] === _i133) {
          Q++;
          o.push(c);
          c = [];
        }
      }
      E = 0;
      Q = 0;
      for (var _i135 = 0; _i135 < s; _i135++) {
        var _s84 = g[_i135];
        if (4 & _s84) {
          var _i136 = t.getUint8(e++);
          E += 32 & _s84 ? _i136 : -_i136;
          C.push(E);
        } else if (32 & _s84) C.push(E);else {
          E += t.getInt16(e);
          e += 2;
          C.push(E);
        }
        h.push(1 & _s84 | 64 & _s84);
        if (a[Q] === _i135) {
          c = o[Q];
          Q++;
          l.push(new Contour({
            flags: h,
            xCoordinates: c,
            yCoordinates: C
          }));
          C = [];
          h = [];
        }
      }
      return new SimpleGlyph({
        contours: l,
        instructions: n
      });
    }
  }]);
}();
var CompositeGlyph = /*#__PURE__*/function () {
  function CompositeGlyph(_ref45) {
    var e = _ref45.flags,
      t = _ref45.glyphIndex,
      i = _ref45.argument1,
      a = _ref45.argument2,
      s = _ref45.transf,
      r = _ref45.instructions;
    _classCallCheck(this, CompositeGlyph);
    this.flags = e;
    this.glyphIndex = t;
    this.argument1 = i;
    this.argument2 = a;
    this.transf = s;
    this.instructions = r;
  }
  return _createClass(CompositeGlyph, [{
    key: "getSize",
    value: function getSize() {
      var e = 4 + 2 * this.transf.length;
      256 & this.flags && (e += 2 + this.instructions.length);
      e += 2;
      2 & this.flags ? this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127 || (e += 2) : this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255 || (e += 2);
      return e;
    }
  }, {
    key: "write",
    value: function write(e, t) {
      var i = e;
      2 & this.flags ? this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127 || (this.flags |= 1) : this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255 || (this.flags |= 1);
      t.setUint16(e, this.flags);
      t.setUint16(e + 2, this.glyphIndex);
      e += 4;
      if (1 & this.flags) {
        if (2 & this.flags) {
          t.setInt16(e, this.argument1);
          t.setInt16(e + 2, this.argument2);
        } else {
          t.setUint16(e, this.argument1);
          t.setUint16(e + 2, this.argument2);
        }
        e += 4;
      } else {
        t.setUint8(e, this.argument1);
        t.setUint8(e + 1, this.argument2);
        e += 2;
      }
      if (256 & this.flags) {
        t.setUint16(e, this.instructions.length);
        e += 2;
        if (this.instructions.length) {
          new Uint8Array(t.buffer, 0, t.buffer.byteLength).set(this.instructions, e);
          e += this.instructions.length;
        }
      }
      return e - i;
    }
  }, {
    key: "scale",
    value: function scale(e, t) {}
  }], [{
    key: "parse",
    value: function parse(e, t) {
      var i = e,
        a = [];
      var s = t.getUint16(e);
      var r = t.getUint16(e + 2);
      e += 4;
      var n, g;
      if (1 & s) {
        if (2 & s) {
          n = t.getInt16(e);
          g = t.getInt16(e + 2);
        } else {
          n = t.getUint16(e);
          g = t.getUint16(e + 2);
        }
        e += 4;
        s ^= 1;
      } else {
        if (2 & s) {
          n = t.getInt8(e);
          g = t.getInt8(e + 1);
        } else {
          n = t.getUint8(e);
          g = t.getUint8(e + 1);
        }
        e += 2;
      }
      if (8 & s) {
        a.push(t.getUint16(e));
        e += 2;
      } else if (64 & s) {
        a.push(t.getUint16(e), t.getUint16(e + 2));
        e += 4;
      } else if (128 & s) {
        a.push(t.getUint16(e), t.getUint16(e + 2), t.getUint16(e + 4), t.getUint16(e + 6));
        e += 8;
      }
      var o = null;
      if (256 & s) {
        var _i137 = t.getUint16(e);
        e += 2;
        o = new Uint8Array(t).slice(e, e + _i137);
        e += _i137;
      }
      return [e - i, new CompositeGlyph({
        flags: s,
        glyphIndex: r,
        argument1: n,
        argument2: g,
        transf: a,
        instructions: o
      })];
    }
  }]);
}();
function writeInt16(e, t, i) {
  e[t] = i >> 8 & 255;
  e[t + 1] = 255 & i;
}
function writeInt32(e, t, i) {
  e[t] = i >> 24 & 255;
  e[t + 1] = i >> 16 & 255;
  e[t + 2] = i >> 8 & 255;
  e[t + 3] = 255 & i;
}
function writeData(e, t, i) {
  if (i instanceof Uint8Array) e.set(i, t);else if ("string" == typeof i) for (var _a123 = 0, _s85 = i.length; _a123 < _s85; _a123++) e[t++] = 255 & i.charCodeAt(_a123);else {
    var _iterator39 = _createForOfIteratorHelper(i),
      _step39;
    try {
      for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
        var _a124 = _step39.value;
        e[t++] = 255 & _a124;
      }
    } catch (err) {
      _iterator39.e(err);
    } finally {
      _iterator39.f();
    }
  }
}
var OpenTypeFileBuilder = /*#__PURE__*/function () {
  function OpenTypeFileBuilder(e) {
    _classCallCheck(this, OpenTypeFileBuilder);
    this.sfnt = e;
    this.tables = Object.create(null);
  }
  return _createClass(OpenTypeFileBuilder, [{
    key: "toArray",
    value: function toArray() {
      var e = this.sfnt;
      var t = this.tables,
        i = Object.keys(t);
      i.sort();
      var a = i.length;
      var s,
        r,
        n,
        g,
        o,
        c = 12 + 16 * a;
      var C = [c];
      for (s = 0; s < a; s++) {
        g = t[i[s]];
        c += (g.length + 3 & -4) >>> 0;
        C.push(c);
      }
      var h = new Uint8Array(c);
      for (s = 0; s < a; s++) {
        g = t[i[s]];
        writeData(h, C[s], g);
      }
      "true" === e && (e = string32(65536));
      h[0] = 255 & e.charCodeAt(0);
      h[1] = 255 & e.charCodeAt(1);
      h[2] = 255 & e.charCodeAt(2);
      h[3] = 255 & e.charCodeAt(3);
      writeInt16(h, 4, a);
      var l = OpenTypeFileBuilder.getSearchParams(a, 16);
      writeInt16(h, 6, l.range);
      writeInt16(h, 8, l.entry);
      writeInt16(h, 10, l.rangeShift);
      c = 12;
      for (s = 0; s < a; s++) {
        o = i[s];
        h[c] = 255 & o.charCodeAt(0);
        h[c + 1] = 255 & o.charCodeAt(1);
        h[c + 2] = 255 & o.charCodeAt(2);
        h[c + 3] = 255 & o.charCodeAt(3);
        var _e167 = 0;
        for (r = C[s], n = C[s + 1]; r < n; r += 4) {
          _e167 = _e167 + readUint32(h, r) >>> 0;
        }
        writeInt32(h, c + 4, _e167);
        writeInt32(h, c + 8, C[s]);
        writeInt32(h, c + 12, t[o].length);
        c += 16;
      }
      return h;
    }
  }, {
    key: "addTable",
    value: function addTable(e, t) {
      if (e in this.tables) throw new Error("Table " + e + " already exists");
      this.tables[e] = t;
    }
  }], [{
    key: "getSearchParams",
    value: function getSearchParams(e, t) {
      var i = 1,
        a = 0;
      for (; (i ^ e) > i;) {
        i <<= 1;
        a++;
      }
      var s = i * t;
      return {
        range: s,
        entry: a,
        rangeShift: t * e - s
      };
    }
  }]);
}();
var sa = [4],
  ra = [5],
  na = [6],
  ga = [7],
  oa = [8],
  Ia = [12, 35],
  ca = [14],
  Ca = [21],
  ha = [22],
  la = [30],
  Ba = [31];
var Type1CharString = /*#__PURE__*/function () {
  function Type1CharString() {
    _classCallCheck(this, Type1CharString);
    this.width = 0;
    this.lsb = 0;
    this.flexing = !1;
    this.output = [];
    this.stack = [];
  }
  return _createClass(Type1CharString, [{
    key: "convert",
    value: function convert(e, t, i) {
      var a = e.length;
      var s,
        r,
        n,
        g = !1;
      for (var _o20 = 0; _o20 < a; _o20++) {
        var _a125 = e[_o20];
        if (_a125 < 32) {
          12 === _a125 && (_a125 = (_a125 << 8) + e[++_o20]);
          switch (_a125) {
            case 1:
            case 3:
            case 9:
            case 3072:
            case 3073:
            case 3074:
            case 3105:
              this.stack = [];
              break;
            case 4:
              if (this.flexing) {
                if (this.stack.length < 1) {
                  g = !0;
                  break;
                }
                var _e168 = this.stack.pop();
                this.stack.push(0, _e168);
                break;
              }
              g = this.executeCommand(1, sa);
              break;
            case 5:
              g = this.executeCommand(2, ra);
              break;
            case 6:
              g = this.executeCommand(1, na);
              break;
            case 7:
              g = this.executeCommand(1, ga);
              break;
            case 8:
              g = this.executeCommand(6, oa);
              break;
            case 10:
              if (this.stack.length < 1) {
                g = !0;
                break;
              }
              n = this.stack.pop();
              if (!t[n]) {
                g = !0;
                break;
              }
              g = this.convert(t[n], t, i);
              break;
            case 11:
              return g;
            case 13:
              if (this.stack.length < 2) {
                g = !0;
                break;
              }
              s = this.stack.pop();
              r = this.stack.pop();
              this.lsb = r;
              this.width = s;
              this.stack.push(s, r);
              g = this.executeCommand(2, ha);
              break;
            case 14:
              this.output.push(ca[0]);
              break;
            case 21:
              if (this.flexing) break;
              g = this.executeCommand(2, Ca);
              break;
            case 22:
              if (this.flexing) {
                this.stack.push(0);
                break;
              }
              g = this.executeCommand(1, ha);
              break;
            case 30:
              g = this.executeCommand(4, la);
              break;
            case 31:
              g = this.executeCommand(4, Ba);
              break;
            case 3078:
              if (i) {
                var _e169 = this.stack.at(-5);
                this.seac = this.stack.splice(-4, 4);
                this.seac[0] += this.lsb - _e169;
                g = this.executeCommand(0, ca);
              } else g = this.executeCommand(4, ca);
              break;
            case 3079:
              if (this.stack.length < 4) {
                g = !0;
                break;
              }
              this.stack.pop();
              s = this.stack.pop();
              var _e170 = this.stack.pop();
              r = this.stack.pop();
              this.lsb = r;
              this.width = s;
              this.stack.push(s, r, _e170);
              g = this.executeCommand(3, Ca);
              break;
            case 3084:
              if (this.stack.length < 2) {
                g = !0;
                break;
              }
              var _o21 = this.stack.pop(),
                _c16 = this.stack.pop();
              this.stack.push(_c16 / _o21);
              break;
            case 3088:
              if (this.stack.length < 2) {
                g = !0;
                break;
              }
              n = this.stack.pop();
              var _C12 = this.stack.pop();
              if (0 === n && 3 === _C12) {
                var _e171 = this.stack.splice(-17, 17);
                this.stack.push(_e171[2] + _e171[0], _e171[3] + _e171[1], _e171[4], _e171[5], _e171[6], _e171[7], _e171[8], _e171[9], _e171[10], _e171[11], _e171[12], _e171[13], _e171[14]);
                g = this.executeCommand(13, Ia, !0);
                this.flexing = !1;
                this.stack.push(_e171[15], _e171[16]);
              } else 1 === n && 0 === _C12 && (this.flexing = !0);
              break;
            case 3089:
              break;
            default:
              warn('Unknown type 1 charstring command of "' + _a125 + '"');
          }
          if (g) break;
        } else {
          _a125 <= 246 ? _a125 -= 139 : _a125 = _a125 <= 250 ? 256 * (_a125 - 247) + e[++_o20] + 108 : _a125 <= 254 ? -256 * (_a125 - 251) - e[++_o20] - 108 : (255 & e[++_o20]) << 24 | (255 & e[++_o20]) << 16 | (255 & e[++_o20]) << 8 | (255 & e[++_o20]) << 0;
          this.stack.push(_a125);
        }
      }
      return g;
    }
  }, {
    key: "executeCommand",
    value: function executeCommand(e, t, i) {
      var _this$output;
      var a = this.stack.length;
      if (e > a) return !0;
      var s = a - e;
      for (var _e172 = s; _e172 < a; _e172++) {
        var _t140 = this.stack[_e172];
        if (Number.isInteger(_t140)) this.output.push(28, _t140 >> 8 & 255, 255 & _t140);else {
          _t140 = 65536 * _t140 | 0;
          this.output.push(255, _t140 >> 24 & 255, _t140 >> 16 & 255, _t140 >> 8 & 255, 255 & _t140);
        }
      }
      (_this$output = this.output).push.apply(_this$output, _toConsumableArray(t));
      i ? this.stack.splice(s, e) : this.stack.length = 0;
      return !1;
    }
  }]);
}();
function isHexDigit(e) {
  return e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102;
}
function decrypt(e, t, i) {
  if (i >= e.length) return new Uint8Array(0);
  var a,
    s,
    r = 0 | t;
  for (a = 0; a < i; a++) r = 52845 * (e[a] + r) + 22719 & 65535;
  var n = e.length - i,
    g = new Uint8Array(n);
  for (a = i, s = 0; s < n; a++, s++) {
    var _t141 = e[a];
    g[s] = _t141 ^ r >> 8;
    r = 52845 * (_t141 + r) + 22719 & 65535;
  }
  return g;
}
function isSpecial(e) {
  return 47 === e || 91 === e || 93 === e || 123 === e || 125 === e || 40 === e || 41 === e;
}
var Type1Parser = /*#__PURE__*/function () {
  function Type1Parser(e, t, i) {
    _classCallCheck(this, Type1Parser);
    if (t) {
      var _t142 = e.getBytes(),
        _i138 = !((isHexDigit(_t142[0]) || isWhiteSpace(_t142[0])) && isHexDigit(_t142[1]) && isHexDigit(_t142[2]) && isHexDigit(_t142[3]) && isHexDigit(_t142[4]) && isHexDigit(_t142[5]) && isHexDigit(_t142[6]) && isHexDigit(_t142[7]));
      e = new Stream(_i138 ? decrypt(_t142, 55665, 4) : function decryptAscii(e, t, i) {
        var a = 0 | t;
        var s = e.length,
          r = new Uint8Array(s >>> 1);
        var n, g;
        for (n = 0, g = 0; n < s; n++) {
          var _t143 = e[n];
          if (!isHexDigit(_t143)) continue;
          n++;
          var _i139 = void 0;
          for (; n < s && !isHexDigit(_i139 = e[n]);) n++;
          if (n < s) {
            var _e173 = parseInt(String.fromCharCode(_t143, _i139), 16);
            r[g++] = _e173 ^ a >> 8;
            a = 52845 * (_e173 + a) + 22719 & 65535;
          }
        }
        return r.slice(i, g);
      }(_t142, 55665, 4));
    }
    this.seacAnalysisEnabled = !!i;
    this.stream = e;
    this.nextChar();
  }
  return _createClass(Type1Parser, [{
    key: "readNumberArray",
    value: function readNumberArray() {
      this.getToken();
      var e = [];
      for (;;) {
        var t = this.getToken();
        if (null === t || "]" === t || "}" === t) break;
        e.push(parseFloat(t || 0));
      }
      return e;
    }
  }, {
    key: "readNumber",
    value: function readNumber() {
      var e = this.getToken();
      return parseFloat(e || 0);
    }
  }, {
    key: "readInt",
    value: function readInt() {
      var e = this.getToken();
      return 0 | parseInt(e || 0, 10);
    }
  }, {
    key: "readBoolean",
    value: function readBoolean() {
      return "true" === this.getToken() ? 1 : 0;
    }
  }, {
    key: "nextChar",
    value: function nextChar() {
      return this.currentChar = this.stream.getByte();
    }
  }, {
    key: "prevChar",
    value: function prevChar() {
      this.stream.skip(-2);
      return this.currentChar = this.stream.getByte();
    }
  }, {
    key: "getToken",
    value: function getToken() {
      var e = !1,
        t = this.currentChar;
      for (;;) {
        if (-1 === t) return null;
        if (e) 10 !== t && 13 !== t || (e = !1);else if (37 === t) e = !0;else if (!isWhiteSpace(t)) break;
        t = this.nextChar();
      }
      if (isSpecial(t)) {
        this.nextChar();
        return String.fromCharCode(t);
      }
      var i = "";
      do {
        i += String.fromCharCode(t);
        t = this.nextChar();
      } while (t >= 0 && !isWhiteSpace(t) && !isSpecial(t));
      return i;
    }
  }, {
    key: "readCharStrings",
    value: function readCharStrings(e, t) {
      return -1 === t ? e : decrypt(e, 4330, t);
    }
  }, {
    key: "extractFontProgram",
    value: function extractFontProgram(e) {
      var t = this.stream,
        i = [],
        a = [],
        s = Object.create(null);
      s.lenIV = 4;
      var r = {
        subrs: [],
        charstrings: [],
        properties: {
          privateData: s
        }
      };
      var n, g, o, c;
      for (; null !== (n = this.getToken());) if ("/" === n) {
        n = this.getToken();
        switch (n) {
          case "CharStrings":
            this.getToken();
            this.getToken();
            this.getToken();
            this.getToken();
            for (;;) {
              n = this.getToken();
              if (null === n || "end" === n) break;
              if ("/" !== n) continue;
              var _e174 = this.getToken();
              g = this.readInt();
              this.getToken();
              o = g > 0 ? t.getBytes(g) : new Uint8Array(0);
              c = r.properties.privateData.lenIV;
              var _i140 = this.readCharStrings(o, c);
              this.nextChar();
              n = this.getToken();
              "noaccess" === n ? this.getToken() : "/" === n && this.prevChar();
              a.push({
                glyph: _e174,
                encoded: _i140
              });
            }
            break;
          case "Subrs":
            this.readInt();
            this.getToken();
            for (; "dup" === this.getToken();) {
              var _e175 = this.readInt();
              g = this.readInt();
              this.getToken();
              o = g > 0 ? t.getBytes(g) : new Uint8Array(0);
              c = r.properties.privateData.lenIV;
              var _a126 = this.readCharStrings(o, c);
              this.nextChar();
              n = this.getToken();
              "noaccess" === n && this.getToken();
              i[_e175] = _a126;
            }
            break;
          case "BlueValues":
          case "OtherBlues":
          case "FamilyBlues":
          case "FamilyOtherBlues":
            var _e176 = this.readNumberArray();
            _e176.length > 0 && _e176.length, 0;
            break;
          case "StemSnapH":
          case "StemSnapV":
            r.properties.privateData[n] = this.readNumberArray();
            break;
          case "StdHW":
          case "StdVW":
            r.properties.privateData[n] = this.readNumberArray()[0];
            break;
          case "BlueShift":
          case "lenIV":
          case "BlueFuzz":
          case "BlueScale":
          case "LanguageGroup":
            r.properties.privateData[n] = this.readNumber();
            break;
          case "ExpansionFactor":
            r.properties.privateData[n] = this.readNumber() || .06;
            break;
          case "ForceBold":
            r.properties.privateData[n] = this.readBoolean();
        }
      }
      for (var _i141 = 0, _a127 = a; _i141 < _a127.length; _i141++) {
        var _ref46 = _a127[_i141];
        var _t144 = _ref46.encoded;
        var _s86 = _ref46.glyph;
        {
          var _a128 = new Type1CharString(),
            _n46 = _a128.convert(_t144, i, this.seacAnalysisEnabled);
          var _g28 = _a128.output;
          _n46 && (_g28 = [14]);
          var _o22 = {
            glyphName: _s86,
            charstring: _g28,
            width: _a128.width,
            lsb: _a128.lsb,
            seac: _a128.seac
          };
          ".notdef" === _s86 ? r.charstrings.unshift(_o22) : r.charstrings.push(_o22);
          if (e.builtInEncoding) {
            var _t145 = e.builtInEncoding.indexOf(_s86);
            _t145 > -1 && void 0 === e.widths[_t145] && _t145 >= e.firstChar && _t145 <= e.lastChar && (e.widths[_t145] = _a128.width);
          }
        }
      }
      return r;
    }
  }, {
    key: "extractFontHeader",
    value: function extractFontHeader(e) {
      var t;
      for (; null !== (t = this.getToken());) if ("/" === t) {
        t = this.getToken();
        switch (t) {
          case "FontMatrix":
            var _i142 = this.readNumberArray();
            e.fontMatrix = _i142;
            break;
          case "Encoding":
            var _a129 = this.getToken();
            var _s87 = void 0;
            if (/^\d+$/.test(_a129)) {
              _s87 = [];
              var _e177 = 0 | parseInt(_a129, 10);
              this.getToken();
              for (var _i143 = 0; _i143 < _e177; _i143++) {
                t = this.getToken();
                for (; "dup" !== t && "def" !== t;) {
                  t = this.getToken();
                  if (null === t) return;
                }
                if ("def" === t) break;
                var _e178 = this.readInt();
                this.getToken();
                var _i144 = this.getToken();
                _s87[_e178] = _i144;
                this.getToken();
              }
            } else _s87 = getEncoding(_a129);
            e.builtInEncoding = _s87;
            break;
          case "FontBBox":
            var _r56 = this.readNumberArray();
            e.ascent = Math.max(_r56[3], _r56[1]);
            e.descent = Math.min(_r56[1], _r56[3]);
            e.ascentScaled = !0;
        }
      }
    }
  }]);
}();
function findBlock(e, t, i) {
  var a = e.length,
    s = t.length,
    r = a - s;
  var n = i,
    g = !1;
  for (; n < r;) {
    var _i145 = 0;
    for (; _i145 < s && e[n + _i145] === t[_i145];) _i145++;
    if (_i145 >= s) {
      n += _i145;
      for (; n < a && isWhiteSpace(e[n]);) n++;
      g = !0;
      break;
    }
    n++;
  }
  return {
    found: g,
    length: n
  };
}
var Type1Font = /*#__PURE__*/function () {
  function Type1Font(e, t, i) {
    _classCallCheck(this, Type1Font);
    var a = i.length1,
      s = i.length2,
      r = t.peekBytes(6);
    var n = 128 === r[0] && 1 === r[1];
    if (n) {
      t.skip(6);
      a = r[5] << 24 | r[4] << 16 | r[3] << 8 | r[2];
    }
    var g = function getHeaderBlock(e, t) {
      var i = [101, 101, 120, 101, 99],
        a = e.pos;
      var s, r, n, g;
      try {
        s = e.getBytes(t);
        r = s.length;
      } catch (_unused7) {}
      if (r === t) {
        n = findBlock(s, i, t - 2 * i.length);
        if (n.found && n.length === t) return {
          stream: new Stream(s),
          length: t
        };
      }
      warn('Invalid "Length1" property in Type1 font -- trying to recover.');
      e.pos = a;
      for (;;) {
        n = findBlock(e.peekBytes(2048), i, 0);
        if (0 === n.length) break;
        e.pos += n.length;
        if (n.found) {
          g = e.pos - a;
          break;
        }
      }
      e.pos = a;
      if (g) return {
        stream: new Stream(e.getBytes(g)),
        length: g
      };
      warn('Unable to recover "Length1" property in Type1 font -- using as is.');
      return {
        stream: new Stream(e.getBytes(t)),
        length: t
      };
    }(t, a);
    new Type1Parser(g.stream, !1, Ki).extractFontHeader(i);
    if (n) {
      r = t.getBytes(6);
      s = r[5] << 24 | r[4] << 16 | r[3] << 8 | r[2];
    }
    var o = function getEexecBlock(e, t) {
        var i = e.getBytes();
        if (0 === i.length) throw new FormatError("getEexecBlock - no font program found.");
        return {
          stream: new Stream(i),
          length: i.length
        };
      }(t),
      c = new Type1Parser(o.stream, !0, Ki).extractFontProgram(i);
    for (var _e179 in c.properties) i[_e179] = c.properties[_e179];
    var C = c.charstrings,
      h = this.getType2Charstrings(C),
      l = this.getType2Subrs(c.subrs);
    this.charstrings = C;
    this.data = this.wrap(e, h, this.charstrings, l, i);
    this.seacs = this.getSeacs(c.charstrings);
  }
  return _createClass(Type1Font, [{
    key: "numGlyphs",
    get: function get() {
      return this.charstrings.length + 1;
    }
  }, {
    key: "getCharset",
    value: function getCharset() {
      var e = [".notdef"];
      var _iterator40 = _createForOfIteratorHelper(this.charstrings),
        _step40;
      try {
        for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
          var _ref47 = _step40.value;
          var t = _ref47.glyphName;
          e.push(t);
        }
      } catch (err) {
        _iterator40.e(err);
      } finally {
        _iterator40.f();
      }
      return e;
    }
  }, {
    key: "getGlyphMapping",
    value: function getGlyphMapping(e) {
      var t = this.charstrings;
      if (e.composite) {
        var _i146 = Object.create(null);
        for (var _a130 = 0, _s88 = t.length; _a130 < _s88; _a130++) {
          _i146[e.cMap.charCodeOf(_a130)] = _a130 + 1;
        }
        return _i146;
      }
      var i = [".notdef"];
      var a, s;
      for (s = 0; s < t.length; s++) i.push(t[s].glyphName);
      var r = e.builtInEncoding;
      if (r) {
        a = Object.create(null);
        for (var _e180 in r) {
          s = i.indexOf(r[_e180]);
          s >= 0 && (a[_e180] = s);
        }
      }
      return type1FontGlyphMapping(e, a, i);
    }
  }, {
    key: "hasGlyphId",
    value: function hasGlyphId(e) {
      if (e < 0 || e >= this.numGlyphs) return !1;
      if (0 === e) return !0;
      return this.charstrings[e - 1].charstring.length > 0;
    }
  }, {
    key: "getSeacs",
    value: function getSeacs(e) {
      var t = [];
      for (var _i147 = 0, _a131 = e.length; _i147 < _a131; _i147++) {
        var _a132 = e[_i147];
        _a132.seac && (t[_i147 + 1] = _a132.seac);
      }
      return t;
    }
  }, {
    key: "getType2Charstrings",
    value: function getType2Charstrings(e) {
      var t = [];
      var _iterator41 = _createForOfIteratorHelper(e),
        _step41;
      try {
        for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
          var _i148 = _step41.value;
          t.push(_i148.charstring);
        }
      } catch (err) {
        _iterator41.e(err);
      } finally {
        _iterator41.f();
      }
      return t;
    }
  }, {
    key: "getType2Subrs",
    value: function getType2Subrs(e) {
      var t = 0;
      var i = e.length;
      t = i < 1133 ? 107 : i < 33769 ? 1131 : 32768;
      var a = [];
      var s;
      for (s = 0; s < t; s++) a.push([11]);
      for (s = 0; s < i; s++) a.push(e[s]);
      return a;
    }
  }, {
    key: "wrap",
    value: function wrap(e, t, i, a, s) {
      var r = new CFF();
      r.header = new CFFHeader(1, 0, 4, 4);
      r.names = [e];
      var n = new CFFTopDict();
      n.setByName("version", 391);
      n.setByName("Notice", 392);
      n.setByName("FullName", 393);
      n.setByName("FamilyName", 394);
      n.setByName("Weight", 395);
      n.setByName("Encoding", null);
      n.setByName("FontMatrix", s.fontMatrix);
      n.setByName("FontBBox", s.bbox);
      n.setByName("charset", null);
      n.setByName("CharStrings", null);
      n.setByName("Private", null);
      r.topDict = n;
      var g = new CFFStrings();
      g.add("Version 0.11");
      g.add("See original notice");
      g.add(e);
      g.add(e);
      g.add("Medium");
      r.strings = g;
      r.globalSubrIndex = new CFFIndex();
      var o = t.length,
        c = [".notdef"];
      var C, h;
      for (C = 0; C < o; C++) {
        var _e181 = i[C].glyphName;
        -1 === bi.indexOf(_e181) && g.add(_e181);
        c.push(_e181);
      }
      r.charset = new CFFCharset(!1, 0, c);
      var l = new CFFIndex();
      l.add([139, 14]);
      for (C = 0; C < o; C++) l.add(t[C]);
      r.charStrings = l;
      var Q = new CFFPrivateDict();
      Q.setByName("Subrs", null);
      var E = ["BlueValues", "OtherBlues", "FamilyBlues", "FamilyOtherBlues", "StemSnapH", "StemSnapV", "BlueShift", "BlueFuzz", "BlueScale", "LanguageGroup", "ExpansionFactor", "ForceBold", "StdHW", "StdVW"];
      for (C = 0, h = E.length; C < h; C++) {
        var _e182 = E[C];
        if (!(_e182 in s.privateData)) continue;
        var _t146 = s.privateData[_e182];
        if (Array.isArray(_t146)) for (var _e183 = _t146.length - 1; _e183 > 0; _e183--) _t146[_e183] -= _t146[_e183 - 1];
        Q.setByName(_e182, _t146);
      }
      r.topDict.privateDict = Q;
      var u = new CFFIndex();
      for (C = 0, h = a.length; C < h; C++) u.add(a[C]);
      Q.subrsIndex = u;
      return new CFFCompiler(r).compile();
    }
  }]);
}();
var Qa = [[57344, 63743], [1048576, 1114109]],
  Ea = 1e3,
  ua = ["ascent", "bbox", "black", "bold", "charProcOperatorList", "composite", "cssFontInfo", "data", "defaultVMetrics", "defaultWidth", "descent", "fallbackName", "fontMatrix", "isInvalidPDFjsFont", "isType3Font", "italic", "loadedName", "mimetype", "missingFile", "name", "remeasure", "subtype", "systemFontInfo", "type", "vertical"],
  da = ["cMap", "defaultEncoding", "differences", "isMonospace", "isSerifFont", "isSymbolicFont", "seacMap", "toFontChar", "toUnicode", "vmetrics", "widths"];
function adjustWidths(e) {
  if (!e.fontMatrix) return;
  if (e.fontMatrix[0] === a[0]) return;
  var t = .001 / e.fontMatrix[0],
    i = e.widths;
  for (var _e184 in i) i[_e184] *= t;
  e.defaultWidth *= t;
}
function amendFallbackToUnicode(e) {
  if (!e.fallbackToUnicode) return;
  if (e.toUnicode instanceof IdentityToUnicodeMap) return;
  var t = [];
  for (var _i149 in e.fallbackToUnicode) e.toUnicode.has(_i149) || (t[_i149] = e.fallbackToUnicode[_i149]);
  t.length > 0 && e.toUnicode.amend(t);
}
var fonts_Glyph = /*#__PURE__*/function () {
  function fonts_Glyph(e, t, i, a, s, r, n, g, o) {
    _classCallCheck(this, fonts_Glyph);
    this.originalCharCode = e;
    this.fontChar = t;
    this.unicode = i;
    this.accent = a;
    this.width = s;
    this.vmetric = r;
    this.operatorListId = n;
    this.isSpace = g;
    this.isInFont = o;
  }
  return _createClass(fonts_Glyph, [{
    key: "category",
    get: function get() {
      return shadow(this, "category", function getCharUnicodeCategory(e) {
        var t = vi.get(e);
        if (t) return t;
        var i = e.match(Yi),
          a = {
            isWhitespace: !!(i !== null && i !== void 0 && i[1]),
            isZeroWidthDiacritic: !!(i !== null && i !== void 0 && i[2]),
            isInvisibleFormatMark: !!(i !== null && i !== void 0 && i[3])
          };
        vi.set(e, a);
        return a;
      }(this.unicode), !0);
    }
  }]);
}();
function int16(e, t) {
  return (e << 8) + t;
}
function writeSignedInt16(e, t, i) {
  e[t + 1] = i;
  e[t] = i >>> 8;
}
function signedInt16(e, t) {
  var i = (e << 8) + t;
  return 32768 & i ? i - 65536 : i;
}
function string16(e) {
  return String.fromCharCode(e >> 8 & 255, 255 & e);
}
function safeString16(e) {
  e > 32767 ? e = 32767 : e < -32768 && (e = -32768);
  return String.fromCharCode(e >> 8 & 255, 255 & e);
}
function isTrueTypeCollectionFile(e) {
  return "ttcf" === bytesToString(e.peekBytes(4));
}
function getFontFileType(e, _ref48) {
  var t = _ref48.type,
    i = _ref48.subtype,
    a = _ref48.composite;
  var s, r;
  if (function isTrueTypeFile(e) {
    var t = e.peekBytes(4);
    return 65536 === readUint32(t, 0) || "true" === bytesToString(t);
  }(e) || isTrueTypeCollectionFile(e)) s = a ? "CIDFontType2" : "TrueType";else if (function isOpenTypeFile(e) {
    return "OTTO" === bytesToString(e.peekBytes(4));
  }(e)) s = a ? "CIDFontType2" : "OpenType";else if (function isType1File(e) {
    var t = e.peekBytes(2);
    return 37 === t[0] && 33 === t[1] || 128 === t[0] && 1 === t[1];
  }(e)) s = a ? "CIDFontType0" : "MMType1" === t ? "MMType1" : "Type1";else if (function isCFFFile(e) {
    var t = e.peekBytes(4);
    return t[0] >= 1 && t[3] >= 1 && t[3] <= 4;
  }(e)) {
    if (a) {
      s = "CIDFontType0";
      r = "CIDFontType0C";
    } else {
      s = "MMType1" === t ? "MMType1" : "Type1";
      r = "Type1C";
    }
  } else {
    warn("getFontFileType: Unable to detect correct font file Type/Subtype.");
    s = t;
    r = i;
  }
  return [s, r];
}
function applyStandardFontGlyphMap(e, t) {
  for (var _i150 in t) e[+_i150] = t[_i150];
}
function buildToFontChar(e, t, i) {
  var a = [];
  var s;
  for (var _i151 = 0, _r57 = e.length; _i151 < _r57; _i151++) {
    s = getUnicodeForGlyph(e[_i151], t);
    -1 !== s && (a[_i151] = s);
  }
  for (var _e185 in i) {
    s = getUnicodeForGlyph(i[_e185], t);
    -1 !== s && (a[+_e185] = s);
  }
  return a;
}
function isMacNameRecord(e) {
  return 1 === e.platform && 0 === e.encoding && 0 === e.language;
}
function isWinNameRecord(e) {
  return 3 === e.platform && 1 === e.encoding && 1033 === e.language;
}
function convertCidString(e, t) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  switch (t.length) {
    case 1:
      return t.charCodeAt(0);
    case 2:
      return t.charCodeAt(0) << 8 | t.charCodeAt(1);
  }
  var a = "Unsupported CID string (charCode ".concat(e, "): \"").concat(t, "\".");
  if (i) throw new FormatError(a);
  warn(a);
  return t;
}
function adjustMapping(e, t, i, a) {
  var s = Object.create(null),
    r = new Map(),
    n = [],
    g = new Set();
  var o = 0;
  var c = Qa[o][0],
    C = Qa[o][1];
  for (var l in e) {
    var _Q13 = e[l];
    if (!t(_Q13)) continue;
    if (c > C) {
      o++;
      if (o >= Qa.length) {
        warn("Ran out of space in font private use area.");
        break;
      }
      c = Qa[o][0];
      C = Qa[o][1];
    }
    var _E11 = c++;
    0 === _Q13 && (_Q13 = i);
    var _u7 = a.get(l);
    "string" == typeof _u7 && (_u7 = _u7.codePointAt(0));
    if (_u7 && !(h = _u7, Qa[0][0] <= h && h <= Qa[0][1] || Qa[1][0] <= h && h <= Qa[1][1]) && !g.has(_Q13)) {
      r.set(_u7, _Q13);
      g.add(_Q13);
    }
    s[_E11] = _Q13;
    n[l] = _E11;
  }
  var h;
  return {
    toFontChar: n,
    charCodeToGlyphId: s,
    toUnicodeExtraMap: r,
    nextAvailableFontCharCode: c
  };
}
function createCmapTable(e, t, i) {
  var a = function getRanges(e, t, i) {
      var a = [];
      for (var _t147 in e) e[_t147] >= i || a.push({
        fontCharCode: 0 | _t147,
        glyphId: e[_t147]
      });
      if (t) {
        var _iterator42 = _createForOfIteratorHelper(t),
          _step42;
        try {
          for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
            var _ref49 = _step42.value;
            var _ref50 = _slicedToArray(_ref49, 2);
            var _e186 = _ref50[0];
            var _s89 = _ref50[1];
            _s89 >= i || a.push({
              fontCharCode: _e186,
              glyphId: _s89
            });
          }
        } catch (err) {
          _iterator42.e(err);
        } finally {
          _iterator42.f();
        }
      }
      0 === a.length && a.push({
        fontCharCode: 0,
        glyphId: 0
      });
      a.sort(function fontGetRangesSort(e, t) {
        return e.fontCharCode - t.fontCharCode;
      });
      var s = [],
        r = a.length;
      for (var _e187 = 0; _e187 < r;) {
        var _t148 = a[_e187].fontCharCode,
          _i152 = [a[_e187].glyphId];
        ++_e187;
        var _n47 = _t148;
        for (; _e187 < r && _n47 + 1 === a[_e187].fontCharCode;) {
          _i152.push(a[_e187].glyphId);
          ++_n47;
          ++_e187;
          if (65535 === _n47) break;
        }
        s.push([_t148, _n47, _i152]);
      }
      return s;
    }(e, t, i),
    s = a.at(-1)[1] > 65535 ? 2 : 1;
  var r,
    n,
    g,
    o,
    c = "\0\0" + string16(s) + "\0\0" + string32(4 + 8 * s);
  for (r = a.length - 1; r >= 0 && !(a[r][0] <= 65535); --r);
  var C = r + 1;
  a[r][0] < 65535 && 65535 === a[r][1] && (a[r][1] = 65534);
  var h = a[r][1] < 65535 ? 1 : 0,
    l = C + h,
    Q = OpenTypeFileBuilder.getSearchParams(l, 2);
  var E,
    u,
    d,
    f,
    p = "",
    m = "",
    y = "",
    w = "",
    D = "",
    b = 0;
  for (r = 0, n = C; r < n; r++) {
    E = a[r];
    u = E[0];
    d = E[1];
    p += string16(u);
    m += string16(d);
    f = E[2];
    var _e188 = !0;
    for (g = 1, o = f.length; g < o; ++g) if (f[g] !== f[g - 1] + 1) {
      _e188 = !1;
      break;
    }
    if (_e188) {
      y += string16(f[0] - u & 65535);
      w += string16(0);
    } else {
      var _e189 = 2 * (l - r) + 2 * b;
      b += d - u + 1;
      y += string16(0);
      w += string16(_e189);
      for (g = 0, o = f.length; g < o; ++g) D += string16(f[g]);
    }
  }
  if (h > 0) {
    m += "ÿÿ";
    p += "ÿÿ";
    y += "\0";
    w += "\0\0";
  }
  var F = "\0\0" + string16(2 * l) + string16(Q.range) + string16(Q.entry) + string16(Q.rangeShift) + m + "\0\0" + p + y + w + D;
  var S = "",
    k = "";
  if (s > 1) {
    c += "\0\0\n" + string32(4 + 8 * s + 4 + F.length);
    S = "";
    for (r = 0, n = a.length; r < n; r++) {
      E = a[r];
      u = E[0];
      f = E[2];
      var _e190 = f[0];
      for (g = 1, o = f.length; g < o; ++g) if (f[g] !== f[g - 1] + 1) {
        d = E[0] + g - 1;
        S += string32(u) + string32(d) + string32(_e190);
        u = d + 1;
        _e190 = f[g];
      }
      S += string32(u) + string32(E[1]) + string32(_e190);
    }
    k = "\0\f\0\0" + string32(S.length + 16) + "\0\0\0\0" + string32(S.length / 12);
  }
  return c + "\0" + string16(F.length + 4) + F + k + S;
}
function createOS2Table(e, t, i) {
  i || (i = {
    unitsPerEm: 0,
    yMax: 0,
    yMin: 0,
    ascent: 0,
    descent: 0
  });
  var a = 0,
    s = 0,
    r = 0,
    n = 0,
    g = null,
    o = 0,
    c = -1;
  if (t) {
    for (var _e191 in t) {
      _e191 |= 0;
      (g > _e191 || !g) && (g = _e191);
      o < _e191 && (o = _e191);
      c = getUnicodeRangeFor(_e191, c);
      if (c < 32) a |= 1 << c;else if (c < 64) s |= 1 << c - 32;else if (c < 96) r |= 1 << c - 64;else {
        if (!(c < 123)) throw new FormatError("Unicode ranges Bits > 123 are reserved for internal usage");
        n |= 1 << c - 96;
      }
    }
    o > 65535 && (o = 65535);
  } else {
    g = 0;
    o = 255;
  }
  var C = e.bbox || [0, 0, 0, 0],
    h = i.unitsPerEm || (e.fontMatrix ? 1 / Math.max.apply(Math, _toConsumableArray(e.fontMatrix.slice(0, 4).map(Math.abs))) : 1e3),
    l = e.ascentScaled ? 1 : h / Ea,
    Q = i.ascent || Math.round(l * (e.ascent || C[3]));
  var E = i.descent || Math.round(l * (e.descent || C[1]));
  E > 0 && e.descent > 0 && C[1] < 0 && (E = -E);
  var u = i.yMax || Q,
    d = -i.yMin || -E;
  return "\0$ô\0\0\0»\0\0\0»\0\0ß\x001\0\0\0\0" + String.fromCharCode(e.fixedPitch ? 9 : 0) + "\0\0\0\0\0\0" + string32(a) + string32(s) + string32(r) + string32(n) + "*21*" + string16(e.italicAngle ? 1 : 0) + string16(g || e.firstChar) + string16(o || e.lastChar) + string16(Q) + string16(E) + "\0d" + string16(u) + string16(d) + "\0\0\0\0\0\0\0\0" + string16(e.xHeight) + string16(e.capHeight) + string16(0) + string16(g || e.firstChar) + "\0";
}
function createPostTable(e) {
  return "\0\0\0" + string32(Math.floor(65536 * e.italicAngle)) + "\0\0\0\0" + string32(e.fixedPitch ? 1 : 0) + "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
}
function createPostscriptName(e) {
  return e.replaceAll(/[^\x21-\x7E]|[[\](){}<>/%]/g, "").slice(0, 63);
}
function createNameTable(e, t) {
  t || (t = [[], []]);
  var i = [t[0][0] || "Original licence", t[0][1] || e, t[0][2] || "Unknown", t[0][3] || "uniqueID", t[0][4] || e, t[0][5] || "Version 0.11", t[0][6] || createPostscriptName(e), t[0][7] || "Unknown", t[0][8] || "Unknown", t[0][9] || "Unknown"],
    a = [];
  var s, r, n, g, o;
  for (s = 0, r = i.length; s < r; s++) {
    o = t[1][s] || i[s];
    var _e192 = [];
    for (n = 0, g = o.length; n < g; n++) _e192.push(string16(o.charCodeAt(n)));
    a.push(_e192.join(""));
  }
  var c = [i, a],
    C = ["\0", "\0"],
    h = ["\0\0", "\0"],
    l = ["\0\0", "\t"],
    Q = i.length * C.length;
  var E = "\0\0" + string16(Q) + string16(12 * Q + 6),
    u = 0;
  for (s = 0, r = C.length; s < r; s++) {
    var _e193 = c[s];
    for (n = 0, g = _e193.length; n < g; n++) {
      o = _e193[n];
      E += C[s] + h[s] + l[s] + string16(n) + string16(o.length) + string16(u);
      u += o.length;
    }
  }
  E += i.join("") + a.join("");
  return E;
}
var Font = /*#__PURE__*/function () {
  function Font(e, t, i) {
    var _this$systemFontInfo;
    _classCallCheck(this, Font);
    this.name = e;
    this.psName = null;
    this.mimetype = null;
    this.disableFontFace = !1;
    this.loadedName = i.loadedName;
    this.isType3Font = i.isType3Font;
    this.missingFile = !1;
    this.cssFontInfo = i.cssFontInfo;
    this._charsCache = Object.create(null);
    this._glyphCache = Object.create(null);
    var a = !!(i.flags & qi);
    if (!a && !i.isSimulatedFlags) {
      var _t149 = e.replaceAll(/[,_]/g, "-").split("-", 1)[0],
        _i153 = zi();
      var _iterator43 = _createForOfIteratorHelper(_t149.split("+")),
        _step43;
      try {
        for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
          var _e194 = _step43.value;
          if (_i153[_e194]) {
            a = !0;
            break;
          }
        }
      } catch (err) {
        _iterator43.e(err);
      } finally {
        _iterator43.f();
      }
    }
    this.isSerifFont = a;
    this.isSymbolicFont = !!(i.flags & Oi);
    this.isMonospace = !!(i.flags & Ti);
    var s = i.type,
      r = i.subtype;
    this.type = s;
    this.subtype = r;
    this.systemFontInfo = i.systemFontInfo;
    var n = e.match(/^InvalidPDFjsFont_(.*)_\d+$/);
    this.isInvalidPDFjsFont = !!n;
    this.isInvalidPDFjsFont ? this.fallbackName = n[1] : this.isMonospace ? this.fallbackName = "monospace" : this.isSerifFont ? this.fallbackName = "serif" : this.fallbackName = "sans-serif";
    if ((_this$systemFontInfo = this.systemFontInfo) !== null && _this$systemFontInfo !== void 0 && _this$systemFontInfo.guessFallback) {
      this.systemFontInfo.guessFallback = !1;
      this.systemFontInfo.css += ",".concat(this.fallbackName);
    }
    this.differences = i.differences;
    this.widths = i.widths;
    this.defaultWidth = i.defaultWidth;
    this.composite = i.composite;
    this.cMap = i.cMap;
    this.capHeight = i.capHeight / Ea;
    this.ascent = i.ascent / Ea;
    this.descent = i.descent / Ea;
    this.lineHeight = this.ascent - this.descent;
    this.fontMatrix = i.fontMatrix;
    this.bbox = i.bbox;
    this.defaultEncoding = i.defaultEncoding;
    this.toUnicode = i.toUnicode;
    this.toFontChar = [];
    if ("Type3" === i.type) {
      for (var _e195 = 0; _e195 < 256; _e195++) this.toFontChar[_e195] = this.differences[_e195] || i.defaultEncoding[_e195];
      return;
    }
    this.cidEncoding = i.cidEncoding || "";
    this.vertical = !!i.vertical;
    if (this.vertical) {
      this.vmetrics = i.vmetrics;
      this.defaultVMetrics = i.defaultVMetrics;
    }
    if (!t || t.isEmpty) {
      t && warn('Font file is empty in "' + e + '" (' + this.loadedName + ")");
      this.fallbackToSystemFont(i);
      return;
    }
    var _getFontFileType = getFontFileType(t, i);
    var _getFontFileType2 = _slicedToArray(_getFontFileType, 2);
    s = _getFontFileType2[0];
    r = _getFontFileType2[1];
    s === this.type && r === this.subtype || info("Inconsistent font file Type/SubType, expected: ".concat(this.type, "/").concat(this.subtype, " but found: ").concat(s, "/").concat(r, "."));
    var g;
    try {
      switch (s) {
        case "MMType1":
          info("MMType1 font (" + e + "), falling back to Type1.");
        case "Type1":
        case "CIDFontType0":
          this.mimetype = "font/opentype";
          var _a133 = "Type1C" === r || "CIDFontType0C" === r ? new CFFFont(t, i) : new Type1Font(e, t, i);
          adjustWidths(i);
          g = this.convert(e, _a133, i);
          break;
        case "OpenType":
        case "TrueType":
        case "CIDFontType2":
          this.mimetype = "font/opentype";
          g = this.checkAndRepair(e, t, i);
          if (this.isOpenType) {
            adjustWidths(i);
            s = "OpenType";
          }
          break;
        default:
          throw new FormatError("Font ".concat(s, " is not supported"));
      }
    } catch (e) {
      warn(e);
      this.fallbackToSystemFont(i);
      return;
    }
    amendFallbackToUnicode(i);
    this.data = g;
    this.type = s;
    this.subtype = r;
    this.fontMatrix = i.fontMatrix;
    this.widths = i.widths;
    this.defaultWidth = i.defaultWidth;
    this.toUnicode = i.toUnicode;
    this.seacMap = i.seacMap;
  }
  return _createClass(Font, [{
    key: "renderer",
    get: function get() {
      return shadow(this, "renderer", FontRendererFactory.create(this, Ki));
    }
  }, {
    key: "exportData",
    value: function exportData() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = e ? [].concat(ua, da) : ua,
        i = Object.create(null);
      var a, s;
      var _iterator44 = _createForOfIteratorHelper(t),
        _step44;
      try {
        for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
          a = _step44.value;
          s = this[a];
          void 0 !== s && (i[a] = s);
        }
      } catch (err) {
        _iterator44.e(err);
      } finally {
        _iterator44.f();
      }
      return i;
    }
  }, {
    key: "fallbackToSystemFont",
    value: function fallbackToSystemFont(e) {
      var _this34 = this;
      this.missingFile = !0;
      var t = this.name,
        i = this.type;
      var a = normalizeFontName(t);
      var s = Xi(),
        r = Vi(),
        n = !!s[a],
        g = !(!r[a] || !s[r[a]]);
      a = s[a] || r[a] || a;
      var o = aa()[a];
      if (o) {
        isNaN(this.ascent) && (this.ascent = o.ascent / Ea);
        isNaN(this.descent) && (this.descent = o.descent / Ea);
        isNaN(this.capHeight) && (this.capHeight = o.capHeight / Ea);
      }
      this.bold = /bold/gi.test(a);
      this.italic = /oblique|italic/gi.test(a);
      this.black = /Black/g.test(t);
      var c = /Narrow/g.test(t);
      this.remeasure = (!n || c) && Object.keys(this.widths).length > 0;
      if ((n || g) && "CIDFontType2" === i && this.cidEncoding.startsWith("Identity-")) {
        var _i154 = e.cidToGidMap,
          _a134 = [];
        applyStandardFontGlyphMap(_a134, $i());
        /Arial-?Black/i.test(t) ? applyStandardFontGlyphMap(_a134, Aa()) : /Calibri/i.test(t) && applyStandardFontGlyphMap(_a134, ea());
        if (_i154) {
          for (var _e196 in _a134) {
            var _t150 = _a134[_e196];
            void 0 !== _i154[_t150] && (_a134[+_e196] = _i154[_t150]);
          }
          _i154.length !== this.toUnicode.length && e.hasIncludedToUnicodeMap && this.toUnicode instanceof IdentityToUnicodeMap && this.toUnicode.forEach(function (e, t) {
            var s = _a134[e];
            void 0 === _i154[s] && (_a134[+e] = t);
          });
        }
        this.toUnicode instanceof IdentityToUnicodeMap || this.toUnicode.forEach(function (e, t) {
          _a134[+e] = t;
        });
        this.toFontChar = _a134;
        this.toUnicode = new ToUnicodeMap(_a134);
      } else if (/Symbol/i.test(a)) this.toFontChar = buildToFontChar(wi, xi(), this.differences);else if (/Dingbats/i.test(a)) this.toFontChar = buildToFontChar(Di, Mi(), this.differences);else if (n || g) {
        var _e197 = buildToFontChar(this.defaultEncoding, xi(), this.differences);
        "CIDFontType2" !== i || this.cidEncoding.startsWith("Identity-") || this.toUnicode instanceof IdentityToUnicodeMap || this.toUnicode.forEach(function (t, i) {
          _e197[+t] = i;
        });
        this.toFontChar = _e197;
      } else {
        var _e198 = xi(),
          _i155 = [];
        this.toUnicode.forEach(function (t, a) {
          if (!_this34.composite) {
            var _i156 = getUnicodeForGlyph(_this34.differences[t] || _this34.defaultEncoding[t], _e198);
            -1 !== _i156 && (a = _i156);
          }
          _i155[+t] = a;
        });
        this.composite && this.toUnicode instanceof IdentityToUnicodeMap && /Tahoma|Verdana/i.test(t) && applyStandardFontGlyphMap(_i155, $i());
        this.toFontChar = _i155;
      }
      amendFallbackToUnicode(e);
      this.loadedName = a.split("-", 1)[0];
    }
  }, {
    key: "checkAndRepair",
    value: function checkAndRepair(e, t, i) {
      var _i$scaleFactors, _this$cssFontInfo;
      var a = ["OS/2", "cmap", "head", "hhea", "hmtx", "maxp", "name", "post", "loca", "glyf", "fpgm", "prep", "cvt ", "CFF "];
      function readTables(e, t) {
        var i = Object.create(null);
        i["OS/2"] = null;
        i.cmap = null;
        i.head = null;
        i.hhea = null;
        i.hmtx = null;
        i.maxp = null;
        i.name = null;
        i.post = null;
        for (var _s90 = 0; _s90 < t; _s90++) {
          var _t151 = readTableEntry(e);
          a.includes(_t151.tag) && 0 !== _t151.length && (i[_t151.tag] = _t151);
        }
        return i;
      }
      function readTableEntry(e) {
        var t = e.getString(4),
          i = e.getInt32() >>> 0,
          a = e.getInt32() >>> 0,
          s = e.getInt32() >>> 0,
          r = e.pos;
        e.pos = e.start || 0;
        e.skip(a);
        var n = e.getBytes(s);
        e.pos = r;
        if ("head" === t) {
          n[8] = n[9] = n[10] = n[11] = 0;
          n[17] |= 32;
        }
        return {
          tag: t,
          checksum: i,
          length: s,
          offset: a,
          data: n
        };
      }
      function readOpenTypeHeader(e) {
        return {
          version: e.getString(4),
          numTables: e.getUint16(),
          searchRange: e.getUint16(),
          entrySelector: e.getUint16(),
          rangeShift: e.getUint16()
        };
      }
      function sanitizeGlyph(e, t, i, a, s, r) {
        var n = {
          length: 0,
          sizeOfInstructions: 0
        };
        if (t < 0 || t >= e.length || i > e.length || i - t <= 12) return n;
        var g = e.subarray(t, i),
          o = signedInt16(g[2], g[3]),
          c = signedInt16(g[4], g[5]),
          C = signedInt16(g[6], g[7]),
          h = signedInt16(g[8], g[9]);
        if (o > C) {
          writeSignedInt16(g, 2, C);
          writeSignedInt16(g, 6, o);
        }
        if (c > h) {
          writeSignedInt16(g, 4, h);
          writeSignedInt16(g, 8, c);
        }
        var l = signedInt16(g[0], g[1]);
        if (l < 0) {
          if (l < -1) return n;
          a.set(g, s);
          n.length = g.length;
          return n;
        }
        var Q,
          E = 10,
          u = 0;
        for (Q = 0; Q < l; Q++) {
          u = (g[E] << 8 | g[E + 1]) + 1;
          E += 2;
        }
        var d = E,
          f = g[E] << 8 | g[E + 1];
        n.sizeOfInstructions = f;
        E += 2 + f;
        var p = E;
        var m = 0;
        for (Q = 0; Q < u; Q++) {
          var _e199 = g[E++];
          192 & _e199 && (g[E - 1] = 63 & _e199);
          var _t152 = 2;
          2 & _e199 ? _t152 = 1 : 16 & _e199 && (_t152 = 0);
          var _i157 = 2;
          4 & _e199 ? _i157 = 1 : 32 & _e199 && (_i157 = 0);
          var _a135 = _t152 + _i157;
          m += _a135;
          if (8 & _e199) {
            var _e200 = g[E++];
            0 === _e200 && (g[E - 1] ^= 8);
            Q += _e200;
            m += _e200 * _a135;
          }
        }
        if (0 === m) return n;
        var y = E + m;
        if (y > g.length) return n;
        if (!r && f > 0) {
          a.set(g.subarray(0, d), s);
          a.set([0, 0], s + d);
          a.set(g.subarray(p, y), s + d + 2);
          y -= f;
          g.length - y > 3 && (y = y + 3 & -4);
          n.length = y;
          return n;
        }
        if (g.length - y > 3) {
          y = y + 3 & -4;
          a.set(g.subarray(0, y), s);
          n.length = y;
          return n;
        }
        a.set(g, s);
        n.length = g.length;
        return n;
      }
      function readNameTable(e) {
        var i = (t.start || 0) + e.offset;
        t.pos = i;
        var a = [[], []],
          s = [],
          r = e.length,
          n = i + r;
        if (0 !== t.getUint16() || r < 6) return [a, s];
        var g = t.getUint16(),
          o = t.getUint16();
        var c, C;
        for (c = 0; c < g && t.pos + 12 <= n; c++) {
          var _e201 = {
            platform: t.getUint16(),
            encoding: t.getUint16(),
            language: t.getUint16(),
            name: t.getUint16(),
            length: t.getUint16(),
            offset: t.getUint16()
          };
          (isMacNameRecord(_e201) || isWinNameRecord(_e201)) && s.push(_e201);
        }
        for (c = 0, C = s.length; c < C; c++) {
          var _e202 = s[c];
          if (_e202.length <= 0) continue;
          var _r58 = i + o + _e202.offset;
          if (_r58 + _e202.length > n) continue;
          t.pos = _r58;
          var _g29 = _e202.name;
          if (_e202.encoding) {
            var _i158 = "";
            for (var _a136 = 0, _s91 = _e202.length; _a136 < _s91; _a136 += 2) _i158 += String.fromCharCode(t.getUint16());
            a[1][_g29] = _i158;
          } else a[0][_g29] = t.getString(_e202.length);
        }
        return [a, s];
      }
      var s = [0, 0, 0, 0, 0, 0, 0, 0, -2, -2, -2, -2, 0, 0, -2, -5, -1, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, -1, -1, 1, -1, -999, 0, 1, 0, -1, -2, 0, -1, -2, -1, -1, 0, -1, -1, 0, 0, -999, -999, -1, -1, -1, -1, -2, -999, -2, -2, -999, 0, -2, -2, 0, 0, -2, 0, -2, 0, 0, 0, -2, -1, -1, 1, 1, 0, 0, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, 0, -999, -1, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -2, -999, -999, -999, -999, -999, -1, -1, -2, -2, 0, 0, 0, 0, -1, -1, -999, -2, -2, 0, 0, -1, -2, -2, 0, 0, 0, -1, -1, -1, -2];
      function sanitizeTTProgram(e, t) {
        var i,
          a,
          r,
          n,
          g,
          o = e.data,
          c = 0,
          C = 0,
          h = 0;
        var l = [],
          Q = [],
          E = [];
        var u = t.tooComplexToFollowFunctions,
          d = !1,
          f = 0,
          p = 0;
        for (var _e203 = o.length; c < _e203;) {
          var _e204 = o[c++];
          if (64 === _e204) {
            a = o[c++];
            if (d || p) c += a;else for (i = 0; i < a; i++) l.push(o[c++]);
          } else if (65 === _e204) {
            a = o[c++];
            if (d || p) c += 2 * a;else for (i = 0; i < a; i++) {
              r = o[c++];
              l.push(r << 8 | o[c++]);
            }
          } else if (176 == (248 & _e204)) {
            a = _e204 - 176 + 1;
            if (d || p) c += a;else for (i = 0; i < a; i++) l.push(o[c++]);
          } else if (184 == (248 & _e204)) {
            a = _e204 - 184 + 1;
            if (d || p) c += 2 * a;else for (i = 0; i < a; i++) {
              r = o[c++];
              l.push(signedInt16(r, o[c++]));
            }
          } else if (43 !== _e204 || u) {
            if (44 !== _e204 || u) {
              if (45 === _e204) {
                if (d) {
                  d = !1;
                  C = c;
                } else {
                  g = Q.pop();
                  if (!g) {
                    warn("TT: ENDF bad stack");
                    t.hintsValid = !1;
                    return;
                  }
                  n = E.pop();
                  o = g.data;
                  c = g.i;
                  t.functionsStackDeltas[n] = l.length - g.stackTop;
                }
              } else if (137 === _e204) {
                if (d || p) {
                  warn("TT: nested IDEFs not allowed");
                  u = !0;
                }
                d = !0;
                h = c;
              } else if (88 === _e204) ++f;else if (27 === _e204) p = f;else if (89 === _e204) {
                p === f && (p = 0);
                --f;
              } else if (28 === _e204 && !d && !p) {
                var _e205 = l.at(-1);
                _e205 > 0 && (c += _e205 - 1);
              }
            } else {
              if (d || p) {
                warn("TT: nested FDEFs not allowed");
                u = !0;
              }
              d = !0;
              h = c;
              n = l.pop();
              t.functionsDefined[n] = {
                data: o,
                i: c
              };
            }
          } else if (!d && !p) {
            n = l.at(-1);
            if (isNaN(n)) info("TT: CALL empty stack (or invalid entry).");else {
              t.functionsUsed[n] = !0;
              if (n in t.functionsStackDeltas) {
                var _e206 = l.length + t.functionsStackDeltas[n];
                if (_e206 < 0) {
                  warn("TT: CALL invalid functions stack delta.");
                  t.hintsValid = !1;
                  return;
                }
                l.length = _e206;
              } else if (n in t.functionsDefined && !E.includes(n)) {
                Q.push({
                  data: o,
                  i: c,
                  stackTop: l.length - 1
                });
                E.push(n);
                g = t.functionsDefined[n];
                if (!g) {
                  warn("TT: CALL non-existent function");
                  t.hintsValid = !1;
                  return;
                }
                o = g.data;
                c = g.i;
              }
            }
          }
          if (!d && !p) {
            var _t153 = 0;
            _e204 <= 142 ? _t153 = s[_e204] : _e204 >= 192 && _e204 <= 223 ? _t153 = -1 : _e204 >= 224 && (_t153 = -2);
            if (_e204 >= 113 && _e204 <= 117) {
              a = l.pop();
              isNaN(a) || (_t153 = 2 * -a);
            }
            for (; _t153 < 0 && l.length > 0;) {
              l.pop();
              _t153++;
            }
            for (; _t153 > 0;) {
              l.push(NaN);
              _t153--;
            }
          }
        }
        t.tooComplexToFollowFunctions = u;
        var m = [o];
        c > o.length && m.push(new Uint8Array(c - o.length));
        if (h > C) {
          warn("TT: complementing a missing function tail");
          m.push(new Uint8Array([34, 45]));
        }
        !function foldTTTable(e, t) {
          if (t.length > 1) {
            var _i159,
              _a137,
              _s92 = 0;
            for (_i159 = 0, _a137 = t.length; _i159 < _a137; _i159++) _s92 += t[_i159].length;
            _s92 = _s92 + 3 & -4;
            var _r59 = new Uint8Array(_s92);
            var _n48 = 0;
            for (_i159 = 0, _a137 = t.length; _i159 < _a137; _i159++) {
              _r59.set(t[_i159], _n48);
              _n48 += t[_i159].length;
            }
            e.data = _r59;
            e.length = _s92;
          }
        }(e, m);
      }
      var r, n, g, o;
      if (isTrueTypeCollectionFile(t = new Stream(new Uint8Array(t.getBytes())))) {
        var _e207 = function readTrueTypeCollectionData(e, t) {
          var _readTrueTypeCollecti = function readTrueTypeCollectionHeader(e) {
              var t = e.getString(4);
              assert("ttcf" === t, "Must be a TrueType Collection font.");
              var i = e.getUint16(),
                a = e.getUint16(),
                s = e.getInt32() >>> 0,
                r = [];
              for (var _t154 = 0; _t154 < s; _t154++) r.push(e.getInt32() >>> 0);
              var n = {
                ttcTag: t,
                majorVersion: i,
                minorVersion: a,
                numFonts: s,
                offsetTable: r
              };
              switch (i) {
                case 1:
                  return n;
                case 2:
                  n.dsigTag = e.getInt32() >>> 0;
                  n.dsigLength = e.getInt32() >>> 0;
                  n.dsigOffset = e.getInt32() >>> 0;
                  return n;
              }
              throw new FormatError("Invalid TrueType Collection majorVersion: ".concat(i, "."));
            }(e),
            i = _readTrueTypeCollecti.numFonts,
            a = _readTrueTypeCollecti.offsetTable,
            s = t.split("+");
          var r;
          for (var _n49 = 0; _n49 < i; _n49++) {
            e.pos = (e.start || 0) + a[_n49];
            var _i160 = readOpenTypeHeader(e),
              _g30 = readTables(e, _i160.numTables);
            if (!_g30.name) throw new FormatError('TrueType Collection font must contain a "name" table.');
            var _readNameTable = readNameTable(_g30.name),
              _readNameTable2 = _slicedToArray(_readNameTable, 1),
              _o23 = _readNameTable2[0];
            for (var _e208 = 0, _a138 = _o23.length; _e208 < _a138; _e208++) for (var _a139 = 0, _n50 = _o23[_e208].length; _a139 < _n50; _a139++) {
              var _o23$_e208$_a;
              var _n51 = (_o23$_e208$_a = _o23[_e208][_a139]) === null || _o23$_e208$_a === void 0 ? void 0 : _o23$_e208$_a.replaceAll(/\s/g, "");
              if (_n51) {
                if (_n51 === t) return {
                  header: _i160,
                  tables: _g30
                };
                if (!(s.length < 2)) {
                  var _iterator45 = _createForOfIteratorHelper(s),
                    _step45;
                  try {
                    for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
                      var _e209 = _step45.value;
                      _n51 === _e209 && (r = {
                        name: _e209,
                        header: _i160,
                        tables: _g30
                      });
                    }
                  } catch (err) {
                    _iterator45.e(err);
                  } finally {
                    _iterator45.f();
                  }
                }
              }
            }
          }
          if (r) {
            warn("TrueType Collection does not contain \"".concat(t, "\" font, falling back to \"").concat(r.name, "\" font instead."));
            return {
              header: r.header,
              tables: r.tables
            };
          }
          throw new FormatError("TrueType Collection does not contain \"".concat(t, "\" font."));
        }(t, this.name);
        r = _e207.header;
        n = _e207.tables;
      } else {
        r = readOpenTypeHeader(t);
        n = readTables(t, r.numTables);
      }
      var c = !n["CFF "];
      if (c) {
        if (!n.loca) throw new FormatError('Required "loca" table is not found');
        if (!n.glyf) {
          warn('Required "glyf" table is not found -- trying to recover.');
          n.glyf = {
            tag: "glyf",
            data: new Uint8Array(0)
          };
        }
        this.isOpenType = !1;
      } else {
        var _i$cidToGidMap;
        var _t155 = i.composite && (((_i$cidToGidMap = i.cidToGidMap) === null || _i$cidToGidMap === void 0 ? void 0 : _i$cidToGidMap.length) > 0 || !(i.cMap instanceof IdentityCMap));
        if ("OTTO" === r.version && !_t155 || !n.head || !n.hhea || !n.maxp || !n.post) {
          o = new Stream(n["CFF "].data);
          g = new CFFFont(o, i);
          adjustWidths(i);
          return this.convert(e, g, i);
        }
        delete n.glyf;
        delete n.loca;
        delete n.fpgm;
        delete n.prep;
        delete n["cvt "];
        this.isOpenType = !0;
      }
      if (!n.maxp) throw new FormatError('Required "maxp" table is not found');
      t.pos = (t.start || 0) + n.maxp.offset;
      var C = t.getInt32();
      var h = t.getUint16();
      if (65536 !== C && 20480 !== C) {
        if (6 === n.maxp.length) C = 20480;else {
          if (!(n.maxp.length >= 32)) throw new FormatError('"maxp" table has a wrong version number');
          C = 65536;
        }
        !function writeUint32(e, t, i) {
          e[t + 3] = 255 & i;
          e[t + 2] = i >>> 8;
          e[t + 1] = i >>> 16;
          e[t] = i >>> 24;
        }(n.maxp.data, 0, C);
      }
      if (((_i$scaleFactors = i.scaleFactors) === null || _i$scaleFactors === void 0 ? void 0 : _i$scaleFactors.length) === h && c) {
        var _e210 = i.scaleFactors,
          _t156 = int16(n.head.data[50], n.head.data[51]),
          _a140 = new GlyfTable({
            glyfTable: n.glyf.data,
            isGlyphLocationsLong: _t156,
            locaTable: n.loca.data,
            numGlyphs: h
          });
        _a140.scale(_e210);
        var _a140$write = _a140.write(),
          _s93 = _a140$write.glyf,
          _r60 = _a140$write.loca,
          _g31 = _a140$write.isLocationLong;
        n.glyf.data = _s93;
        n.loca.data = _r60;
        if (_g31 !== !!_t156) {
          n.head.data[50] = 0;
          n.head.data[51] = _g31 ? 1 : 0;
        }
        var _o24 = n.hmtx.data;
        for (var _t157 = 0; _t157 < h; _t157++) {
          var _i161 = 4 * _t157,
            _a141 = Math.round(_e210[_t157] * int16(_o24[_i161], _o24[_i161 + 1]));
          _o24[_i161] = _a141 >> 8 & 255;
          _o24[_i161 + 1] = 255 & _a141;
          writeSignedInt16(_o24, _i161 + 2, Math.round(_e210[_t157] * signedInt16(_o24[_i161 + 2], _o24[_i161 + 3])));
        }
      }
      var l = h + 1,
        Q = !0;
      if (l > 65535) {
        Q = !1;
        l = h;
        warn("Not enough space in glyfs to duplicate first glyph.");
      }
      var E = 0,
        u = 0;
      if (C >= 65536 && n.maxp.length >= 32) {
        t.pos += 8;
        if (t.getUint16() > 2) {
          n.maxp.data[14] = 0;
          n.maxp.data[15] = 2;
        }
        t.pos += 4;
        E = t.getUint16();
        t.pos += 4;
        u = t.getUint16();
      }
      n.maxp.data[4] = l >> 8;
      n.maxp.data[5] = 255 & l;
      var d = function sanitizeTTPrograms(e, t, i, a) {
        var s = {
          functionsDefined: [],
          functionsUsed: [],
          functionsStackDeltas: [],
          tooComplexToFollowFunctions: !1,
          hintsValid: !0
        };
        e && sanitizeTTProgram(e, s);
        t && sanitizeTTProgram(t, s);
        e && function checkInvalidFunctions(e, t) {
          if (!e.tooComplexToFollowFunctions) if (e.functionsDefined.length > t) {
            warn("TT: more functions defined than expected");
            e.hintsValid = !1;
          } else for (var _i162 = 0, _a142 = e.functionsUsed.length; _i162 < _a142; _i162++) {
            if (_i162 > t) {
              warn("TT: invalid function id: " + _i162);
              e.hintsValid = !1;
              return;
            }
            if (e.functionsUsed[_i162] && !e.functionsDefined[_i162]) {
              warn("TT: undefined function: " + _i162);
              e.hintsValid = !1;
              return;
            }
          }
        }(s, a);
        if (i && 1 & i.length) {
          var _e211 = new Uint8Array(i.length + 1);
          _e211.set(i.data);
          i.data = _e211;
        }
        return s.hintsValid;
      }(n.fpgm, n.prep, n["cvt "], E);
      if (!d) {
        delete n.fpgm;
        delete n.prep;
        delete n["cvt "];
      }
      !function sanitizeMetrics(e, t, i, a, s, r) {
        if (!t) {
          i && (i.data = null);
          return;
        }
        e.pos = (e.start || 0) + t.offset;
        e.pos += 4;
        e.pos += 2;
        e.pos += 2;
        e.pos += 2;
        e.pos += 2;
        e.pos += 2;
        e.pos += 2;
        e.pos += 2;
        e.pos += 2;
        e.pos += 2;
        var n = e.getUint16();
        e.pos += 8;
        e.pos += 2;
        var g = e.getUint16();
        if (0 !== n) {
          if (!(2 & int16(a.data[44], a.data[45]))) {
            t.data[22] = 0;
            t.data[23] = 0;
          }
        }
        if (g > s) {
          info("The numOfMetrics (".concat(g, ") should not be greater than the numGlyphs (").concat(s, ")."));
          g = s;
          t.data[34] = (65280 & g) >> 8;
          t.data[35] = 255 & g;
        }
        var o = s - g - (i.length - 4 * g >> 1);
        if (o > 0) {
          var _e212 = new Uint8Array(i.length + 2 * o);
          _e212.set(i.data);
          if (r) {
            _e212[i.length] = i.data[2];
            _e212[i.length + 1] = i.data[3];
          }
          i.data = _e212;
        }
      }(t, n.hhea, n.hmtx, n.head, l, Q);
      if (!n.head) throw new FormatError('Required "head" table is not found');
      !function sanitizeHead(e, t, i) {
        var a = e.data,
          s = function int32(e, t, i, a) {
            return (e << 24) + (t << 16) + (i << 8) + a;
          }(a[0], a[1], a[2], a[3]);
        if (s >> 16 != 1) {
          info("Attempting to fix invalid version in head table: " + s);
          a[0] = 0;
          a[1] = 1;
          a[2] = 0;
          a[3] = 0;
        }
        var r = int16(a[50], a[51]);
        if (r < 0 || r > 1) {
          info("Attempting to fix invalid indexToLocFormat in head table: " + r);
          var _e213 = t + 1;
          if (i === _e213 << 1) {
            a[50] = 0;
            a[51] = 0;
          } else {
            if (i !== _e213 << 2) throw new FormatError("Could not fix indexToLocFormat: " + r);
            a[50] = 0;
            a[51] = 1;
          }
        }
      }(n.head, h, c ? n.loca.length : 0);
      var f = Object.create(null);
      if (c) {
        var _e214 = int16(n.head.data[50], n.head.data[51]),
          _t158 = function sanitizeGlyphLocations(e, t, i, a, s, r, n) {
            var g, o, c;
            if (a) {
              g = 4;
              o = function fontItemDecodeLong(e, t) {
                return e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3];
              };
              c = function fontItemEncodeLong(e, t, i) {
                e[t] = i >>> 24 & 255;
                e[t + 1] = i >> 16 & 255;
                e[t + 2] = i >> 8 & 255;
                e[t + 3] = 255 & i;
              };
            } else {
              g = 2;
              o = function fontItemDecode(e, t) {
                return e[t] << 9 | e[t + 1] << 1;
              };
              c = function fontItemEncode(e, t, i) {
                e[t] = i >> 9 & 255;
                e[t + 1] = i >> 1 & 255;
              };
            }
            var C = r ? i + 1 : i,
              h = g * (1 + C),
              l = new Uint8Array(h);
            l.set(e.data.subarray(0, h));
            e.data = l;
            var Q = t.data,
              E = Q.length,
              u = new Uint8Array(E);
            var d, f;
            var p = [];
            for (d = 0, f = 0; d < i + 1; d++, f += g) {
              var _e215 = o(l, f);
              _e215 > E && (_e215 = E);
              p.push({
                index: d,
                offset: _e215,
                endOffset: 0
              });
            }
            p.sort(function (e, t) {
              return e.offset - t.offset;
            });
            for (d = 0; d < i; d++) p[d].endOffset = p[d + 1].offset;
            p.sort(function (e, t) {
              return e.index - t.index;
            });
            for (d = 0; d < i; d++) {
              var _p$d = p[d],
                _e216 = _p$d.offset,
                _t159 = _p$d.endOffset;
              if (0 !== _e216 || 0 !== _t159) break;
              var _i163 = p[d + 1].offset;
              if (0 !== _i163) {
                p[d].endOffset = _i163;
                break;
              }
            }
            var m = p.at(-2);
            0 !== m.offset && 0 === m.endOffset && (m.endOffset = E);
            var y = Object.create(null);
            var w = 0;
            c(l, 0, w);
            for (d = 0, f = g; d < i; d++, f += g) {
              var _e217 = sanitizeGlyph(Q, p[d].offset, p[d].endOffset, u, w, s),
                _t160 = _e217.length;
              0 === _t160 && (y[d] = !0);
              _e217.sizeOfInstructions > n && (n = _e217.sizeOfInstructions);
              w += _t160;
              c(l, f, w);
            }
            if (0 === w) {
              var _e218 = new Uint8Array([0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 49, 0]);
              for (d = 0, f = g; d < C; d++, f += g) c(l, f, _e218.length);
              t.data = _e218;
            } else if (r) {
              var _i164 = o(l, g);
              if (u.length > _i164 + w) t.data = u.subarray(0, _i164 + w);else {
                t.data = new Uint8Array(_i164 + w);
                t.data.set(u.subarray(0, w));
              }
              t.data.set(u.subarray(0, _i164), w);
              c(e.data, l.length - g, w + _i164);
            } else t.data = u.subarray(0, w);
            return {
              missingGlyphs: y,
              maxSizeOfInstructions: n
            };
          }(n.loca, n.glyf, h, _e214, d, Q, u);
        f = _t158.missingGlyphs;
        if (C >= 65536 && n.maxp.length >= 32) {
          n.maxp.data[26] = _t158.maxSizeOfInstructions >> 8;
          n.maxp.data[27] = 255 & _t158.maxSizeOfInstructions;
        }
      }
      if (!n.hhea) throw new FormatError('Required "hhea" table is not found');
      if (0 === n.hhea.data[10] && 0 === n.hhea.data[11]) {
        n.hhea.data[10] = 255;
        n.hhea.data[11] = 255;
      }
      var p = {
        unitsPerEm: int16(n.head.data[18], n.head.data[19]),
        yMax: signedInt16(n.head.data[42], n.head.data[43]),
        yMin: signedInt16(n.head.data[38], n.head.data[39]),
        ascent: signedInt16(n.hhea.data[4], n.hhea.data[5]),
        descent: signedInt16(n.hhea.data[6], n.hhea.data[7]),
        lineGap: signedInt16(n.hhea.data[8], n.hhea.data[9])
      };
      this.ascent = p.ascent / p.unitsPerEm;
      this.descent = p.descent / p.unitsPerEm;
      this.lineGap = p.lineGap / p.unitsPerEm;
      if ((_this$cssFontInfo = this.cssFontInfo) !== null && _this$cssFontInfo !== void 0 && _this$cssFontInfo.lineHeight) {
        this.lineHeight = this.cssFontInfo.metrics.lineHeight;
        this.lineGap = this.cssFontInfo.metrics.lineGap;
      } else this.lineHeight = this.ascent - this.descent + this.lineGap;
      n.post && function readPostScriptTable(e, i, a) {
        var s = (t.start || 0) + e.offset;
        t.pos = s;
        var r = s + e.length,
          n = t.getInt32();
        t.skip(28);
        var g,
          o,
          c = !0;
        switch (n) {
          case 65536:
            g = Wi;
            break;
          case 131072:
            var _e219 = t.getUint16();
            if (_e219 !== a) {
              c = !1;
              break;
            }
            var _s94 = [];
            for (o = 0; o < _e219; ++o) {
              var _e220 = t.getUint16();
              if (_e220 >= 32768) {
                c = !1;
                break;
              }
              _s94.push(_e220);
            }
            if (!c) break;
            var _C13 = [],
              _h7 = [];
            for (; t.pos < r;) {
              var _e221 = t.getByte();
              _h7.length = _e221;
              for (o = 0; o < _e221; ++o) _h7[o] = String.fromCharCode(t.getByte());
              _C13.push(_h7.join(""));
            }
            g = [];
            for (o = 0; o < _e219; ++o) {
              var _e222 = _s94[o];
              _e222 < 258 ? g.push(Wi[_e222]) : g.push(_C13[_e222 - 258]);
            }
            break;
          case 196608:
            break;
          default:
            warn("Unknown/unsupported post table version " + n);
            c = !1;
            i.defaultEncoding && (g = i.defaultEncoding);
        }
        i.glyphNames = g;
        return c;
      }(n.post, i, h);
      n.post = {
        tag: "post",
        data: createPostTable(i)
      };
      var m = Object.create(null);
      function hasGlyph(e) {
        return !f[e];
      }
      if (i.composite) {
        var _e223 = i.cidToGidMap || [],
          _t161 = 0 === _e223.length;
        i.cMap.forEach(function (i, a) {
          "string" == typeof a && (a = convertCidString(i, a, !0));
          if (a > 65535) throw new FormatError("Max size of CID is 65,535");
          var s = -1;
          _t161 ? s = a : void 0 !== _e223[a] && (s = _e223[a]);
          s >= 0 && s < h && hasGlyph(s) && (m[i] = s);
        });
      } else {
        var _e224 = function readCmapTable(e, t, i, a) {
            if (!e) {
              warn("No cmap table available.");
              return {
                platformId: -1,
                encodingId: -1,
                mappings: [],
                hasShortCmap: !1
              };
            }
            var s,
              r = (t.start || 0) + e.offset;
            t.pos = r;
            t.skip(2);
            var n = t.getUint16();
            var g,
              o = !1;
            for (var _e225 = 0; _e225 < n; _e225++) {
              var _g32, _g33;
              var _s96 = t.getUint16(),
                _r62 = t.getUint16(),
                _c17 = t.getInt32() >>> 0;
              var _C14 = !1;
              if (((_g32 = g) === null || _g32 === void 0 ? void 0 : _g32.platformId) !== _s96 || ((_g33 = g) === null || _g33 === void 0 ? void 0 : _g33.encodingId) !== _r62) {
                if (0 !== _s96 || 0 !== _r62 && 1 !== _r62 && 3 !== _r62) {
                  if (1 === _s96 && 0 === _r62) _C14 = !0;else if (3 !== _s96 || 1 !== _r62 || !a && g) {
                    if (i && 3 === _s96 && 0 === _r62) {
                      _C14 = !0;
                      var _i165 = !0;
                      if (_e225 < n - 1) {
                        var _e226 = t.peekBytes(2);
                        int16(_e226[0], _e226[1]) < _s96 && (_i165 = !1);
                      }
                      _i165 && (o = !0);
                    }
                  } else {
                    _C14 = !0;
                    i || (o = !0);
                  }
                } else _C14 = !0;
                _C14 && (g = {
                  platformId: _s96,
                  encodingId: _r62,
                  offset: _c17
                });
                if (o) break;
              }
            }
            g && (t.pos = r + g.offset);
            if (!g || -1 === t.peekByte()) {
              warn("Could not find a preferred cmap table.");
              return {
                platformId: -1,
                encodingId: -1,
                mappings: [],
                hasShortCmap: !1
              };
            }
            var c = t.getUint16();
            var C = !1;
            var h = [];
            var l, Q;
            if (0 === c) {
              t.skip(4);
              for (l = 0; l < 256; l++) {
                var _e227 = t.getByte();
                _e227 && h.push({
                  charCode: l,
                  glyphId: _e227
                });
              }
              C = !0;
            } else if (2 === c) {
              t.skip(4);
              var _e228 = [];
              var _i166 = 0;
              for (var _a144 = 0; _a144 < 256; _a144++) {
                var _a145 = t.getUint16() >> 3;
                _e228.push(_a145);
                _i166 = Math.max(_a145, _i166);
              }
              var _a146 = [];
              for (var _e229 = 0; _e229 <= _i166; _e229++) _a146.push({
                firstCode: t.getUint16(),
                entryCount: t.getUint16(),
                idDelta: signedInt16(t.getByte(), t.getByte()),
                idRangePos: t.pos + t.getUint16()
              });
              for (var _i167 = 0; _i167 < 256; _i167++) if (0 === _e228[_i167]) {
                t.pos = _a146[0].idRangePos + 2 * _i167;
                Q = t.getUint16();
                h.push({
                  charCode: _i167,
                  glyphId: Q
                });
              } else {
                var _s97 = _a146[_e228[_i167]];
                for (l = 0; l < _s97.entryCount; l++) {
                  var _e230 = (_i167 << 8) + l + _s97.firstCode;
                  t.pos = _s97.idRangePos + 2 * l;
                  Q = t.getUint16();
                  0 !== Q && (Q = (Q + _s97.idDelta) % 65536);
                  h.push({
                    charCode: _e230,
                    glyphId: Q
                  });
                }
              }
            } else if (4 === c) {
              t.skip(4);
              var _e231 = t.getUint16() >> 1;
              t.skip(6);
              var _i168 = [];
              var _a147;
              for (_a147 = 0; _a147 < _e231; _a147++) _i168.push({
                end: t.getUint16()
              });
              t.skip(2);
              for (_a147 = 0; _a147 < _e231; _a147++) _i168[_a147].start = t.getUint16();
              for (_a147 = 0; _a147 < _e231; _a147++) _i168[_a147].delta = t.getUint16();
              var _n52,
                _g34 = 0;
              for (_a147 = 0; _a147 < _e231; _a147++) {
                s = _i168[_a147];
                var _r63 = t.getUint16();
                if (_r63) {
                  _n52 = (_r63 >> 1) - (_e231 - _a147);
                  s.offsetIndex = _n52;
                  _g34 = Math.max(_g34, _n52 + s.end - s.start + 1);
                } else s.offsetIndex = -1;
              }
              var _o25 = [];
              for (l = 0; l < _g34; l++) _o25.push(t.getUint16());
              for (_a147 = 0; _a147 < _e231; _a147++) {
                s = _i168[_a147];
                r = s.start;
                var _e232 = s.end,
                  _t162 = s.delta;
                _n52 = s.offsetIndex;
                for (l = r; l <= _e232; l++) if (65535 !== l) {
                  Q = _n52 < 0 ? l : _o25[_n52 + l - r];
                  Q = Q + _t162 & 65535;
                  h.push({
                    charCode: l,
                    glyphId: Q
                  });
                }
              }
            } else if (6 === c) {
              t.skip(4);
              var _e233 = t.getUint16(),
                _i169 = t.getUint16();
              for (l = 0; l < _i169; l++) {
                Q = t.getUint16();
                var _i170 = _e233 + l;
                h.push({
                  charCode: _i170,
                  glyphId: Q
                });
              }
            } else {
              if (12 !== c) {
                warn("cmap table has unsupported format: " + c);
                return {
                  platformId: -1,
                  encodingId: -1,
                  mappings: [],
                  hasShortCmap: !1
                };
              }
              {
                t.skip(10);
                var _e234 = t.getInt32() >>> 0;
                for (l = 0; l < _e234; l++) {
                  var _e235 = t.getInt32() >>> 0,
                    _i171 = t.getInt32() >>> 0;
                  var _a148 = t.getInt32() >>> 0;
                  for (var _t163 = _e235; _t163 <= _i171; _t163++) h.push({
                    charCode: _t163,
                    glyphId: _a148++
                  });
                }
              }
            }
            h.sort(function (e, t) {
              return e.charCode - t.charCode;
            });
            for (var _e236 = 1; _e236 < h.length; _e236++) if (h[_e236 - 1].charCode === h[_e236].charCode) {
              h.splice(_e236, 1);
              _e236--;
            }
            return {
              platformId: g.platformId,
              encodingId: g.encodingId,
              mappings: h,
              hasShortCmap: C
            };
          }(n.cmap, t, this.isSymbolicFont, i.hasEncoding),
          _a143 = _e224.platformId,
          _s95 = _e224.encodingId,
          _r61 = _e224.mappings;
        var _g35 = [],
          _o26 = !1;
        !i.hasEncoding || "MacRomanEncoding" !== i.baseEncodingName && "WinAnsiEncoding" !== i.baseEncodingName || (_g35 = getEncoding(i.baseEncodingName));
        if (i.hasEncoding && !this.isSymbolicFont && (3 === _a143 && 1 === _s95 || 1 === _a143 && 0 === _s95)) {
          var _e237 = xi();
          for (var _t164 = 0; _t164 < 256; _t164++) {
            var _n53 = void 0;
            _n53 = void 0 !== this.differences[_t164] ? this.differences[_t164] : _g35.length && "" !== _g35[_t164] ? _g35[_t164] : mi[_t164];
            if (!_n53) continue;
            var _o27 = recoverGlyphName(_n53, _e237);
            var _c18 = void 0;
            3 === _a143 && 1 === _s95 ? _c18 = _e237[_o27] : 1 === _a143 && 0 === _s95 && (_c18 = pi.indexOf(_o27));
            if (void 0 === _c18) {
              if (!i.glyphNames && i.hasIncludedToUnicodeMap && !(this.toUnicode instanceof IdentityToUnicodeMap)) {
                var _e238 = this.toUnicode.get(_t164);
                _e238 && (_c18 = _e238.codePointAt(0));
              }
              if (void 0 === _c18) continue;
            }
            var _iterator46 = _createForOfIteratorHelper(_r61),
              _step46;
            try {
              for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
                var _e239 = _step46.value;
                if (_e239.charCode === _c18) {
                  m[_t164] = _e239.glyphId;
                  break;
                }
              }
            } catch (err) {
              _iterator46.e(err);
            } finally {
              _iterator46.f();
            }
          }
        } else if (0 === _a143) {
          var _iterator47 = _createForOfIteratorHelper(_r61),
            _step47;
          try {
            for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
              var _e240 = _step47.value;
              m[_e240.charCode] = _e240.glyphId;
            }
          } catch (err) {
            _iterator47.e(err);
          } finally {
            _iterator47.f();
          }
          _o26 = !0;
        } else if (3 === _a143 && 0 === _s95) {
          var _iterator48 = _createForOfIteratorHelper(_r61),
            _step48;
          try {
            for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
              var _e241 = _step48.value;
              var _t165 = _e241.charCode;
              _t165 >= 61440 && _t165 <= 61695 && (_t165 &= 255);
              m[_t165] = _e241.glyphId;
            }
          } catch (err) {
            _iterator48.e(err);
          } finally {
            _iterator48.f();
          }
        } else {
          var _iterator49 = _createForOfIteratorHelper(_r61),
            _step49;
          try {
            for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
              var _e242 = _step49.value;
              m[_e242.charCode] = _e242.glyphId;
            }
          } catch (err) {
            _iterator49.e(err);
          } finally {
            _iterator49.f();
          }
        }
        if (i.glyphNames && (_g35.length || this.differences.length)) for (var _e243 = 0; _e243 < 256; ++_e243) {
          if (!_o26 && void 0 !== m[_e243]) continue;
          var _t166 = this.differences[_e243] || _g35[_e243];
          if (!_t166) continue;
          var _a149 = i.glyphNames.indexOf(_t166);
          _a149 > 0 && hasGlyph(_a149) && (m[_e243] = _a149);
        }
      }
      0 === m.length && (m[0] = 0);
      var y = l - 1;
      Q || (y = 0);
      if (!i.cssFontInfo) {
        var _e244 = adjustMapping(m, hasGlyph, y, this.toUnicode);
        this.toFontChar = _e244.toFontChar;
        n.cmap = {
          tag: "cmap",
          data: createCmapTable(_e244.charCodeToGlyphId, _e244.toUnicodeExtraMap, l)
        };
        n["OS/2"] && function validateOS2Table(e, t) {
          t.pos = (t.start || 0) + e.offset;
          var i = t.getUint16();
          t.skip(60);
          var a = t.getUint16();
          if (i < 4 && 768 & a) return !1;
          if (t.getUint16() > t.getUint16()) return !1;
          t.skip(6);
          if (0 === t.getUint16()) return !1;
          e.data[8] = e.data[9] = 0;
          return !0;
        }(n["OS/2"], t) || (n["OS/2"] = {
          tag: "OS/2",
          data: createOS2Table(i, _e244.charCodeToGlyphId, p)
        });
      }
      if (!c) try {
        o = new Stream(n["CFF "].data);
        g = new CFFParser(o, i, Ki).parse();
        g.duplicateFirstGlyph();
        var _e245 = new CFFCompiler(g);
        n["CFF "].data = _e245.compile();
      } catch (_unused8) {
        warn("Failed to compile font " + i.loadedName);
      }
      if (n.name) {
        var _readNameTable3 = readNameTable(n.name),
          _readNameTable4 = _slicedToArray(_readNameTable3, 2),
          _t167 = _readNameTable4[0],
          _a150 = _readNameTable4[1];
        n.name.data = createNameTable(e, _t167);
        this.psName = _t167[0][6] || null;
        i.composite || function adjustTrueTypeToUnicode(e, t, i) {
          if (e.isInternalFont) return;
          if (e.hasIncludedToUnicodeMap) return;
          if (e.hasEncoding) return;
          if (e.toUnicode instanceof IdentityToUnicodeMap) return;
          if (!t) return;
          if (0 === i.length) return;
          if (e.defaultEncoding === yi) return;
          var _iterator50 = _createForOfIteratorHelper(i),
            _step50;
          try {
            for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
              var _e247 = _step50.value;
              if (!isWinNameRecord(_e247)) return;
            }
          } catch (err) {
            _iterator50.e(err);
          } finally {
            _iterator50.f();
          }
          var a = yi,
            s = [],
            r = xi();
          for (var _e246 in a) {
            var _t168 = a[_e246];
            if ("" === _t168) continue;
            var _i172 = r[_t168];
            void 0 !== _i172 && (s[_e246] = String.fromCharCode(_i172));
          }
          s.length > 0 && e.toUnicode.amend(s);
        }(i, this.isSymbolicFont, _a150);
      } else n.name = {
        tag: "name",
        data: createNameTable(this.name)
      };
      var w = new OpenTypeFileBuilder(r.version);
      for (var _e248 in n) w.addTable(_e248, n[_e248].data);
      return w.toArray();
    }
  }, {
    key: "convert",
    value: function convert(e, t, i) {
      i.fixedPitch = !1;
      i.builtInEncoding && function adjustType1ToUnicode(e, t) {
        if (e.isInternalFont) return;
        if (e.hasIncludedToUnicodeMap) return;
        if (t === e.defaultEncoding) return;
        if (e.toUnicode instanceof IdentityToUnicodeMap) return;
        var i = [],
          a = xi();
        for (var _s98 in t) {
          if (e.hasEncoding && (e.baseEncodingName || void 0 !== e.differences[_s98])) continue;
          var _r64 = getUnicodeForGlyph(t[_s98], a);
          -1 !== _r64 && (i[_s98] = String.fromCharCode(_r64));
        }
        i.length > 0 && e.toUnicode.amend(i);
      }(i, i.builtInEncoding);
      var s = 1;
      t instanceof CFFFont && (s = t.numGlyphs - 1);
      var r = t.getGlyphMapping(i);
      var n = null,
        g = r,
        o = null;
      if (!i.cssFontInfo) {
        n = adjustMapping(r, t.hasGlyphId.bind(t), s, this.toUnicode);
        this.toFontChar = n.toFontChar;
        g = n.charCodeToGlyphId;
        o = n.toUnicodeExtraMap;
      }
      var c = t.numGlyphs;
      function getCharCodes(e, t) {
        var i = null;
        for (var _a151 in e) t === e[_a151] && (i || (i = [])).push(0 | _a151);
        return i;
      }
      function createCharCode(e, t) {
        for (var _i173 in e) if (t === e[_i173]) return 0 | _i173;
        n.charCodeToGlyphId[n.nextAvailableFontCharCode] = t;
        return n.nextAvailableFontCharCode++;
      }
      var C = t.seacs;
      if (n && C !== null && C !== void 0 && C.length) {
        var _e249 = i.fontMatrix || a,
          _s99 = t.getCharset(),
          _g36 = Object.create(null);
        for (var _t169 in C) {
          _t169 |= 0;
          var _i174 = C[_t169],
            _a152 = mi[_i174[2]],
            _o28 = mi[_i174[3]],
            _c19 = _s99.indexOf(_a152),
            _h8 = _s99.indexOf(_o28);
          if (_c19 < 0 || _h8 < 0) continue;
          var _l5 = {
              x: _i174[0] * _e249[0] + _i174[1] * _e249[2] + _e249[4],
              y: _i174[0] * _e249[1] + _i174[1] * _e249[3] + _e249[5]
            },
            _Q14 = getCharCodes(r, _t169);
          if (_Q14) {
            var _iterator51 = _createForOfIteratorHelper(_Q14),
              _step51;
            try {
              for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
                var _e250 = _step51.value;
                var _t170 = n.charCodeToGlyphId,
                  _i175 = createCharCode(_t170, _c19),
                  _a153 = createCharCode(_t170, _h8);
                _g36[_e250] = {
                  baseFontCharCode: _i175,
                  accentFontCharCode: _a153,
                  accentOffset: _l5
                };
              }
            } catch (err) {
              _iterator51.e(err);
            } finally {
              _iterator51.f();
            }
          }
        }
        i.seacMap = _g36;
      }
      var h = i.fontMatrix ? 1 / Math.max.apply(Math, _toConsumableArray(i.fontMatrix.slice(0, 4).map(Math.abs))) : 1e3,
        l = new OpenTypeFileBuilder("OTTO");
      l.addTable("CFF ", t.data);
      l.addTable("OS/2", createOS2Table(i, g));
      l.addTable("cmap", createCmapTable(g, o, c));
      l.addTable("head", "\0\0\0\0\0\0\0\0\0\0_<õ\0\0" + safeString16(h) + "\0\0\0\0\v~'\0\0\0\0\v~'\0\0" + safeString16(i.descent) + "ÿ" + safeString16(i.ascent) + string16(i.italicAngle ? 2 : 0) + "\0\0\0\0\0\0\0");
      l.addTable("hhea", "\0\0\0" + safeString16(i.ascent) + safeString16(i.descent) + "\0\0ÿÿ\0\0\0\0\0\0" + safeString16(i.capHeight) + safeString16(Math.tan(i.italicAngle) * i.xHeight) + "\0\0\0\0\0\0\0\0\0\0\0\0" + string16(c));
      l.addTable("hmtx", function fontFieldsHmtx() {
        var e = t.charstrings,
          i = t.cff ? t.cff.widths : null;
        var a = "\0\0\0\0";
        for (var _t171 = 1, _s100 = c; _t171 < _s100; _t171++) {
          var _s101 = 0;
          if (e) {
            var _i176 = e[_t171 - 1];
            _s101 = "width" in _i176 ? _i176.width : 0;
          } else i && (_s101 = Math.ceil(i[_t171] || 0));
          a += string16(_s101) + string16(0);
        }
        return a;
      }());
      l.addTable("maxp", "\0\0P\0" + string16(c));
      l.addTable("name", createNameTable(e));
      l.addTable("post", createPostTable(i));
      return l.toArray();
    }
  }, {
    key: "_spaceWidth",
    get: function get() {
      var e = ["space", "minus", "one", "i", "I"];
      var t;
      for (var _i177 = 0, _e251 = e; _i177 < _e251.length; _i177++) {
        var _i178 = _e251[_i177];
        if (_i178 in this.widths) {
          t = this.widths[_i178];
          break;
        }
        var _e252 = xi()[_i178];
        var _a154 = 0;
        if (this.composite && this.cMap.contains(_e252)) {
          _a154 = this.cMap.lookup(_e252);
          "string" == typeof _a154 && (_a154 = convertCidString(_e252, _a154));
        }
        !_a154 && this.toUnicode && (_a154 = this.toUnicode.charCodeOf(_e252));
        _a154 <= 0 && (_a154 = _e252);
        t = this.widths[_a154];
        if (t) break;
      }
      return shadow(this, "_spaceWidth", t || this.defaultWidth);
    }
  }, {
    key: "_charToGlyph",
    value: function _charToGlyph(e) {
      var _r65, _this$cMap, _this$vmetrics, _this$seacMap;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i,
        a,
        s,
        r = this._glyphCache[e];
      if (((_r65 = r) === null || _r65 === void 0 ? void 0 : _r65.isSpace) === t) return r;
      var n = e;
      if ((_this$cMap = this.cMap) !== null && _this$cMap !== void 0 && _this$cMap.contains(e)) {
        n = this.cMap.lookup(e);
        "string" == typeof n && (n = convertCidString(e, n));
      }
      a = this.widths[n];
      "number" != typeof a && (a = this.defaultWidth);
      var g = (_this$vmetrics = this.vmetrics) === null || _this$vmetrics === void 0 ? void 0 : _this$vmetrics[n];
      var o = this.toUnicode.get(e) || e;
      "number" == typeof o && (o = String.fromCharCode(o));
      var c = void 0 !== this.toFontChar[e];
      i = this.toFontChar[e] || e;
      if (this.missingFile) {
        var _t172 = this.differences[e] || this.defaultEncoding[e];
        if ((".notdef" === _t172 || "" === _t172) && "Type1" === this.type) {
          i = 32;
          if ("" === _t172) {
            a || (a = this._spaceWidth);
            o = String.fromCharCode(i);
          }
        }
        i = function mapSpecialUnicodeValues(e) {
          return e >= 65520 && e <= 65535 ? 0 : e >= 62976 && e <= 63743 ? Hi()[e] || e : 173 === e ? 45 : e;
        }(i);
      }
      this.isType3Font && (s = i);
      var C = null;
      if ((_this$seacMap = this.seacMap) !== null && _this$seacMap !== void 0 && _this$seacMap[e]) {
        c = !0;
        var _t173 = this.seacMap[e];
        i = _t173.baseFontCharCode;
        C = {
          fontChar: String.fromCodePoint(_t173.accentFontCharCode),
          offset: _t173.accentOffset
        };
      }
      var h = "";
      "number" == typeof i && (i <= 1114111 ? h = String.fromCodePoint(i) : warn("charToGlyph - invalid fontCharCode: ".concat(i)));
      if (this.missingFile && this.vertical && 1 === h.length) {
        var _e253 = ji()[h.charCodeAt(0)];
        _e253 && (h = o = String.fromCharCode(_e253));
      }
      r = new fonts_Glyph(e, h, o, C, a, g, s, t, c);
      return this._glyphCache[e] = r;
    }
  }, {
    key: "charsToGlyphs",
    value: function charsToGlyphs(e) {
      var t = this._charsCache[e];
      if (t) return t;
      t = [];
      if (this.cMap) {
        var _i179 = Object.create(null),
          _a155 = e.length;
        var _s102 = 0;
        for (; _s102 < _a155;) {
          this.cMap.readCharCode(e, _s102, _i179);
          var _a156 = _i179.charcode,
            _r66 = _i179.length;
          _s102 += _r66;
          var _n54 = this._charToGlyph(_a156, 1 === _r66 && 32 === e.charCodeAt(_s102 - 1));
          t.push(_n54);
        }
      } else for (var _i180 = 0, _a157 = e.length; _i180 < _a157; ++_i180) {
        var _a158 = e.charCodeAt(_i180),
          _s103 = this._charToGlyph(_a158, 32 === _a158);
        t.push(_s103);
      }
      return this._charsCache[e] = t;
    }
  }, {
    key: "getCharPositions",
    value: function getCharPositions(e) {
      var t = [];
      if (this.cMap) {
        var _i181 = Object.create(null);
        var _a159 = 0;
        for (; _a159 < e.length;) {
          this.cMap.readCharCode(e, _a159, _i181);
          var _s104 = _i181.length;
          t.push([_a159, _a159 + _s104]);
          _a159 += _s104;
        }
      } else for (var _i182 = 0, _a160 = e.length; _i182 < _a160; ++_i182) t.push([_i182, _i182 + 1]);
      return t;
    }
  }, {
    key: "glyphCacheValues",
    get: function get() {
      return Object.values(this._glyphCache);
    }
  }, {
    key: "encodeString",
    value: function encodeString(e) {
      var _this35 = this;
      var t = [],
        i = [],
        hasCurrentBufErrors = function hasCurrentBufErrors() {
          return t.length % 2 == 1;
        },
        a = this.toUnicode instanceof IdentityToUnicodeMap ? function (e) {
          return _this35.toUnicode.charCodeOf(e);
        } : function (e) {
          return _this35.toUnicode.charCodeOf(String.fromCodePoint(e));
        };
      for (var _s105 = 0, _r67 = e.length; _s105 < _r67; _s105++) {
        var _r68 = e.codePointAt(_s105);
        _r68 > 55295 && (_r68 < 57344 || _r68 > 65533) && _s105++;
        if (this.toUnicode) {
          var _e254 = a(_r68);
          if (-1 !== _e254) {
            if (hasCurrentBufErrors()) {
              t.push(i.join(""));
              i.length = 0;
            }
            for (var _t174 = (this.cMap ? this.cMap.getCharCodeLength(_e254) : 1) - 1; _t174 >= 0; _t174--) i.push(String.fromCharCode(_e254 >> 8 * _t174 & 255));
            continue;
          }
        }
        if (!hasCurrentBufErrors()) {
          t.push(i.join(""));
          i.length = 0;
        }
        i.push(String.fromCodePoint(_r68));
      }
      t.push(i.join(""));
      return t;
    }
  }]);
}();
var ErrorFont = /*#__PURE__*/function () {
  function ErrorFont(e) {
    _classCallCheck(this, ErrorFont);
    this.error = e;
    this.loadedName = "g_font_error";
    this.missingFile = !0;
  }
  return _createClass(ErrorFont, [{
    key: "charsToGlyphs",
    value: function charsToGlyphs() {
      return [];
    }
  }, {
    key: "encodeString",
    value: function encodeString(e) {
      return [e];
    }
  }, {
    key: "exportData",
    value: function exportData() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return {
        error: this.error
      };
    }
  }]);
}();
var fa = 2,
  pa = 3,
  ma = 4,
  ya = 5,
  wa = 6,
  Da = 7;
var Pattern = /*#__PURE__*/function () {
  function Pattern() {
    _classCallCheck(this, Pattern);
    unreachable("Cannot initialize Pattern.");
  }
  return _createClass(Pattern, null, [{
    key: "parseShading",
    value: function parseShading(e, t, i, a, s) {
      var r = e instanceof BaseStream ? e.dict : e,
        n = r.get("ShadingType");
      try {
        switch (n) {
          case fa:
          case pa:
            return new RadialAxialShading(r, t, i, a, s);
          case ma:
          case ya:
          case wa:
          case Da:
            return new MeshShading(e, t, i, a, s);
          default:
            throw new FormatError("Unsupported ShadingType: " + n);
        }
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        warn(e);
        return new DummyShading();
      }
    }
  }]);
}();
var BaseShading = /*#__PURE__*/function () {
  function BaseShading() {
    _classCallCheck(this, BaseShading);
  }
  return _createClass(BaseShading, [{
    key: "getIR",
    value: function getIR() {
      unreachable("Abstract method `getIR` called.");
    }
  }]);
}();
BaseShading.SMALL_NUMBER = 1e-6;
var RadialAxialShading = /*#__PURE__*/function (_BaseShading2) {
  function RadialAxialShading(e, t, i, a, s) {
    var _c20, _c21, _l6, _l7;
    var _this36;
    _classCallCheck(this, RadialAxialShading);
    _this36 = _callSuper(this, RadialAxialShading);
    _this36.shadingType = e.get("ShadingType");
    var r = 0;
    _this36.shadingType === fa ? r = 4 : _this36.shadingType === pa && (r = 6);
    _this36.coordsArr = e.getArray("Coords");
    if (!isNumberArray(_this36.coordsArr, r)) throw new FormatError("RadialAxialShading: Invalid /Coords array.");
    var n = ColorSpace.parse({
      cs: e.getRaw("CS") || e.getRaw("ColorSpace"),
      xref: t,
      resources: i,
      pdfFunctionFactory: a,
      localColorSpaceCache: s
    });
    _this36.bbox = lookupNormalRect(e.getArray("BBox"), null);
    var g = 0,
      o = 1;
    var c = e.getArray("Domain");
    isNumberArray(c, 2) && (_c20 = c, _c21 = _slicedToArray(_c20, 2), g = _c21[0], o = _c21[1], _c20);
    var C = !1,
      h = !1;
    var l = e.getArray("Extend");
    (function isBooleanArray(e, t) {
      return Array.isArray(e) && (null === t || e.length === t) && e.every(function (e) {
        return "boolean" == typeof e;
      });
    })(l, 2) && (_l6 = l, _l7 = _slicedToArray(_l6, 2), C = _l7[0], h = _l7[1], _l6);
    if (!(_this36.shadingType !== pa || C && h)) {
      var _this36$coordsArr = _slicedToArray(_this36.coordsArr, 6),
        _e255 = _this36$coordsArr[0],
        _t175 = _this36$coordsArr[1],
        _i183 = _this36$coordsArr[2],
        _a161 = _this36$coordsArr[3],
        _s106 = _this36$coordsArr[4],
        _r69 = _this36$coordsArr[5],
        _n55 = Math.hypot(_e255 - _a161, _t175 - _s106);
      _i183 <= _r69 + _n55 && _r69 <= _i183 + _n55 && warn("Unsupported radial gradient.");
    }
    _this36.extendStart = C;
    _this36.extendEnd = h;
    var Q = e.getRaw("Function"),
      E = a.createFromArray(Q),
      u = (o - g) / 840,
      d = _this36.colorStops = [];
    if (g >= o || u <= 0) {
      info("Bad shading domain.");
      return _possibleConstructorReturn(_this36);
    }
    var f = new Float32Array(n.numComps),
      p = new Float32Array(1);
    var m,
      y = 0;
    p[0] = g;
    E(p, 0, f, 0);
    var w = n.getRgb(f, 0);
    var D = Util.makeHexColor(w[0], w[1], w[2]);
    d.push([0, D]);
    var b = 1;
    p[0] = g + u;
    E(p, 0, f, 0);
    var F = n.getRgb(f, 0),
      S = F[0] - w[0] + 1,
      k = F[1] - w[1] + 1,
      R = F[2] - w[2] + 1,
      N = F[0] - w[0] - 1,
      G = F[1] - w[1] - 1,
      x = F[2] - w[2] - 1;
    for (var _e256 = 2; _e256 < 840; _e256++) {
      p[0] = g + _e256 * u;
      E(p, 0, f, 0);
      m = n.getRgb(f, 0);
      var _t176 = _e256 - y;
      S = Math.min(S, (m[0] - w[0] + 1) / _t176);
      k = Math.min(k, (m[1] - w[1] + 1) / _t176);
      R = Math.min(R, (m[2] - w[2] + 1) / _t176);
      N = Math.max(N, (m[0] - w[0] - 1) / _t176);
      G = Math.max(G, (m[1] - w[1] - 1) / _t176);
      x = Math.max(x, (m[2] - w[2] - 1) / _t176);
      if (!(N <= S && G <= k && x <= R)) {
        var _e257 = Util.makeHexColor(F[0], F[1], F[2]);
        d.push([b / 840, _e257]);
        S = m[0] - F[0] + 1;
        k = m[1] - F[1] + 1;
        R = m[2] - F[2] + 1;
        N = m[0] - F[0] - 1;
        G = m[1] - F[1] - 1;
        x = m[2] - F[2] - 1;
        y = b;
        w = F;
      }
      b = _e256;
      F = m;
    }
    var U = Util.makeHexColor(F[0], F[1], F[2]);
    d.push([1, U]);
    var M = "transparent";
    if (e.has("Background")) {
      m = n.getRgb(e.get("Background"), 0);
      M = Util.makeHexColor(m[0], m[1], m[2]);
    }
    if (!C) {
      d.unshift([0, M]);
      d[1][0] += BaseShading.SMALL_NUMBER;
    }
    if (!h) {
      d.at(-1)[0] -= BaseShading.SMALL_NUMBER;
      d.push([1, M]);
    }
    _this36.colorStops = d;
    return _this36;
  }
  _inherits(RadialAxialShading, _BaseShading2);
  return _createClass(RadialAxialShading, [{
    key: "getIR",
    value: function getIR() {
      var e = this.coordsArr,
        t = this.shadingType;
      var i, a, s, r, n;
      if (t === fa) {
        a = [e[0], e[1]];
        s = [e[2], e[3]];
        r = null;
        n = null;
        i = "axial";
      } else if (t === pa) {
        a = [e[0], e[1]];
        s = [e[3], e[4]];
        r = e[2];
        n = e[5];
        i = "radial";
      } else unreachable("getPattern type unknown: ".concat(t));
      return ["RadialAxial", i, this.bbox, this.colorStops, a, s, r, n];
    }
  }]);
}(BaseShading);
var MeshStreamReader = /*#__PURE__*/function () {
  function MeshStreamReader(e, t) {
    _classCallCheck(this, MeshStreamReader);
    this.stream = e;
    this.context = t;
    this.buffer = 0;
    this.bufferLength = 0;
    var i = t.numComps;
    this.tmpCompsBuf = new Float32Array(i);
    var a = t.colorSpace.numComps;
    this.tmpCsCompsBuf = t.colorFn ? new Float32Array(a) : this.tmpCompsBuf;
  }
  return _createClass(MeshStreamReader, [{
    key: "hasData",
    get: function get() {
      if (this.stream.end) return this.stream.pos < this.stream.end;
      if (this.bufferLength > 0) return !0;
      var e = this.stream.getByte();
      if (e < 0) return !1;
      this.buffer = e;
      this.bufferLength = 8;
      return !0;
    }
  }, {
    key: "readBits",
    value: function readBits(e) {
      var t = this.buffer,
        i = this.bufferLength;
      if (32 === e) {
        if (0 === i) return (this.stream.getByte() << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte()) >>> 0;
        t = t << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte();
        var _e258 = this.stream.getByte();
        this.buffer = _e258 & (1 << i) - 1;
        return (t << 8 - i | (255 & _e258) >> i) >>> 0;
      }
      if (8 === e && 0 === i) return this.stream.getByte();
      for (; i < e;) {
        t = t << 8 | this.stream.getByte();
        i += 8;
      }
      i -= e;
      this.bufferLength = i;
      this.buffer = t & (1 << i) - 1;
      return t >> i;
    }
  }, {
    key: "align",
    value: function align() {
      this.buffer = 0;
      this.bufferLength = 0;
    }
  }, {
    key: "readFlag",
    value: function readFlag() {
      return this.readBits(this.context.bitsPerFlag);
    }
  }, {
    key: "readCoordinate",
    value: function readCoordinate() {
      var e = this.context.bitsPerCoordinate,
        t = this.readBits(e),
        i = this.readBits(e),
        a = this.context.decode,
        s = e < 32 ? 1 / ((1 << e) - 1) : 2.3283064365386963e-10;
      return [t * s * (a[1] - a[0]) + a[0], i * s * (a[3] - a[2]) + a[2]];
    }
  }, {
    key: "readComponents",
    value: function readComponents() {
      var e = this.context.numComps,
        t = this.context.bitsPerComponent,
        i = t < 32 ? 1 / ((1 << t) - 1) : 2.3283064365386963e-10,
        a = this.context.decode,
        s = this.tmpCompsBuf;
      for (var _r70 = 0, _n56 = 4; _r70 < e; _r70++, _n56 += 2) {
        var _e259 = this.readBits(t);
        s[_r70] = _e259 * i * (a[_n56 + 1] - a[_n56]) + a[_n56];
      }
      var r = this.tmpCsCompsBuf;
      this.context.colorFn && this.context.colorFn(s, 0, r, 0);
      return this.context.colorSpace.getRgb(r, 0);
    }
  }]);
}();
var ba = Object.create(null);
function getB(e) {
  var _ba;
  return (_ba = ba)[e] || (_ba[e] = function buildB(e) {
    var t = [];
    for (var _i184 = 0; _i184 <= e; _i184++) {
      var _a162 = _i184 / e,
        _s107 = 1 - _a162;
      t.push(new Float32Array([Math.pow(_s107, 3), 3 * _a162 * Math.pow(_s107, 2), 3 * Math.pow(_a162, 2) * _s107, Math.pow(_a162, 3)]));
    }
    return t;
  }(e));
}
var MeshShading = /*#__PURE__*/function (_BaseShading3) {
  function MeshShading(e, t, i, a, s) {
    var _this37;
    _classCallCheck(this, MeshShading);
    _this37 = _callSuper(this, MeshShading);
    if (!(e instanceof BaseStream)) throw new FormatError("Mesh data is not a stream");
    var r = e.dict;
    _this37.shadingType = r.get("ShadingType");
    _this37.bbox = lookupNormalRect(r.getArray("BBox"), null);
    var n = ColorSpace.parse({
      cs: r.getRaw("CS") || r.getRaw("ColorSpace"),
      xref: t,
      resources: i,
      pdfFunctionFactory: a,
      localColorSpaceCache: s
    });
    _this37.background = r.has("Background") ? n.getRgb(r.get("Background"), 0) : null;
    var g = r.getRaw("Function"),
      o = g ? a.createFromArray(g) : null;
    _this37.coords = [];
    _this37.colors = [];
    _this37.figures = [];
    var c = {
        bitsPerCoordinate: r.get("BitsPerCoordinate"),
        bitsPerComponent: r.get("BitsPerComponent"),
        bitsPerFlag: r.get("BitsPerFlag"),
        decode: r.getArray("Decode"),
        colorFn: o,
        colorSpace: n,
        numComps: o ? 1 : n.numComps
      },
      C = new MeshStreamReader(e, c);
    var h = !1;
    switch (_this37.shadingType) {
      case ma:
        _this37._decodeType4Shading(C);
        break;
      case ya:
        var _e260 = 0 | r.get("VerticesPerRow");
        if (_e260 < 2) throw new FormatError("Invalid VerticesPerRow");
        _this37._decodeType5Shading(C, _e260);
        break;
      case wa:
        _this37._decodeType6Shading(C);
        h = !0;
        break;
      case Da:
        _this37._decodeType7Shading(C);
        h = !0;
        break;
      default:
        unreachable("Unsupported mesh type.");
    }
    if (h) {
      _this37._updateBounds();
      for (var _e261 = 0, _t177 = _this37.figures.length; _e261 < _t177; _e261++) _this37._buildFigureFromPatch(_e261);
    }
    _this37._updateBounds();
    _this37._packData();
    return _this37;
  }
  _inherits(MeshShading, _BaseShading3);
  return _createClass(MeshShading, [{
    key: "_decodeType4Shading",
    value: function _decodeType4Shading(e) {
      var t = this.coords,
        i = this.colors,
        a = [],
        s = [];
      var r = 0;
      for (; e.hasData;) {
        var _n57 = e.readFlag(),
          _g37 = e.readCoordinate(),
          _o29 = e.readComponents();
        if (0 === r) {
          if (!(0 <= _n57 && _n57 <= 2)) throw new FormatError("Unknown type4 flag");
          switch (_n57) {
            case 0:
              r = 3;
              break;
            case 1:
              s.push(s.at(-2), s.at(-1));
              r = 1;
              break;
            case 2:
              s.push(s.at(-3), s.at(-1));
              r = 1;
          }
          a.push(_n57);
        }
        s.push(t.length);
        t.push(_g37);
        i.push(_o29);
        r--;
        e.align();
      }
      this.figures.push({
        type: "triangles",
        coords: new Int32Array(s),
        colors: new Int32Array(s)
      });
    }
  }, {
    key: "_decodeType5Shading",
    value: function _decodeType5Shading(e, t) {
      var i = this.coords,
        a = this.colors,
        s = [];
      for (; e.hasData;) {
        var _t178 = e.readCoordinate(),
          _r71 = e.readComponents();
        s.push(i.length);
        i.push(_t178);
        a.push(_r71);
      }
      this.figures.push({
        type: "lattice",
        coords: new Int32Array(s),
        colors: new Int32Array(s),
        verticesPerRow: t
      });
    }
  }, {
    key: "_decodeType6Shading",
    value: function _decodeType6Shading(e) {
      var t = this.coords,
        i = this.colors,
        a = new Int32Array(16),
        s = new Int32Array(4);
      for (; e.hasData;) {
        var _r72 = e.readFlag();
        if (!(0 <= _r72 && _r72 <= 3)) throw new FormatError("Unknown type6 flag");
        var _n58 = t.length;
        for (var _i185 = 0, _a163 = 0 !== _r72 ? 8 : 12; _i185 < _a163; _i185++) t.push(e.readCoordinate());
        var _g38 = i.length;
        for (var _t179 = 0, _a164 = 0 !== _r72 ? 2 : 4; _t179 < _a164; _t179++) i.push(e.readComponents());
        var _o30 = void 0,
          _c22 = void 0,
          _C15 = void 0,
          h = void 0;
        switch (_r72) {
          case 0:
            a[12] = _n58 + 3;
            a[13] = _n58 + 4;
            a[14] = _n58 + 5;
            a[15] = _n58 + 6;
            a[8] = _n58 + 2;
            a[11] = _n58 + 7;
            a[4] = _n58 + 1;
            a[7] = _n58 + 8;
            a[0] = _n58;
            a[1] = _n58 + 11;
            a[2] = _n58 + 10;
            a[3] = _n58 + 9;
            s[2] = _g38 + 1;
            s[3] = _g38 + 2;
            s[0] = _g38;
            s[1] = _g38 + 3;
            break;
          case 1:
            _o30 = a[12];
            _c22 = a[13];
            _C15 = a[14];
            h = a[15];
            a[12] = h;
            a[13] = _n58 + 0;
            a[14] = _n58 + 1;
            a[15] = _n58 + 2;
            a[8] = _C15;
            a[11] = _n58 + 3;
            a[4] = _c22;
            a[7] = _n58 + 4;
            a[0] = _o30;
            a[1] = _n58 + 7;
            a[2] = _n58 + 6;
            a[3] = _n58 + 5;
            _o30 = s[2];
            _c22 = s[3];
            s[2] = _c22;
            s[3] = _g38;
            s[0] = _o30;
            s[1] = _g38 + 1;
            break;
          case 2:
            _o30 = a[15];
            _c22 = a[11];
            a[12] = a[3];
            a[13] = _n58 + 0;
            a[14] = _n58 + 1;
            a[15] = _n58 + 2;
            a[8] = a[7];
            a[11] = _n58 + 3;
            a[4] = _c22;
            a[7] = _n58 + 4;
            a[0] = _o30;
            a[1] = _n58 + 7;
            a[2] = _n58 + 6;
            a[3] = _n58 + 5;
            _o30 = s[3];
            s[2] = s[1];
            s[3] = _g38;
            s[0] = _o30;
            s[1] = _g38 + 1;
            break;
          case 3:
            a[12] = a[0];
            a[13] = _n58 + 0;
            a[14] = _n58 + 1;
            a[15] = _n58 + 2;
            a[8] = a[1];
            a[11] = _n58 + 3;
            a[4] = a[2];
            a[7] = _n58 + 4;
            a[0] = a[3];
            a[1] = _n58 + 7;
            a[2] = _n58 + 6;
            a[3] = _n58 + 5;
            s[2] = s[0];
            s[3] = _g38;
            s[0] = s[1];
            s[1] = _g38 + 1;
        }
        a[5] = t.length;
        t.push([(-4 * t[a[0]][0] - t[a[15]][0] + 6 * (t[a[4]][0] + t[a[1]][0]) - 2 * (t[a[12]][0] + t[a[3]][0]) + 3 * (t[a[13]][0] + t[a[7]][0])) / 9, (-4 * t[a[0]][1] - t[a[15]][1] + 6 * (t[a[4]][1] + t[a[1]][1]) - 2 * (t[a[12]][1] + t[a[3]][1]) + 3 * (t[a[13]][1] + t[a[7]][1])) / 9]);
        a[6] = t.length;
        t.push([(-4 * t[a[3]][0] - t[a[12]][0] + 6 * (t[a[2]][0] + t[a[7]][0]) - 2 * (t[a[0]][0] + t[a[15]][0]) + 3 * (t[a[4]][0] + t[a[14]][0])) / 9, (-4 * t[a[3]][1] - t[a[12]][1] + 6 * (t[a[2]][1] + t[a[7]][1]) - 2 * (t[a[0]][1] + t[a[15]][1]) + 3 * (t[a[4]][1] + t[a[14]][1])) / 9]);
        a[9] = t.length;
        t.push([(-4 * t[a[12]][0] - t[a[3]][0] + 6 * (t[a[8]][0] + t[a[13]][0]) - 2 * (t[a[0]][0] + t[a[15]][0]) + 3 * (t[a[11]][0] + t[a[1]][0])) / 9, (-4 * t[a[12]][1] - t[a[3]][1] + 6 * (t[a[8]][1] + t[a[13]][1]) - 2 * (t[a[0]][1] + t[a[15]][1]) + 3 * (t[a[11]][1] + t[a[1]][1])) / 9]);
        a[10] = t.length;
        t.push([(-4 * t[a[15]][0] - t[a[0]][0] + 6 * (t[a[11]][0] + t[a[14]][0]) - 2 * (t[a[12]][0] + t[a[3]][0]) + 3 * (t[a[2]][0] + t[a[8]][0])) / 9, (-4 * t[a[15]][1] - t[a[0]][1] + 6 * (t[a[11]][1] + t[a[14]][1]) - 2 * (t[a[12]][1] + t[a[3]][1]) + 3 * (t[a[2]][1] + t[a[8]][1])) / 9]);
        this.figures.push({
          type: "patch",
          coords: new Int32Array(a),
          colors: new Int32Array(s)
        });
      }
    }
  }, {
    key: "_decodeType7Shading",
    value: function _decodeType7Shading(e) {
      var t = this.coords,
        i = this.colors,
        a = new Int32Array(16),
        s = new Int32Array(4);
      for (; e.hasData;) {
        var _r73 = e.readFlag();
        if (!(0 <= _r73 && _r73 <= 3)) throw new FormatError("Unknown type7 flag");
        var _n59 = t.length;
        for (var _i186 = 0, _a165 = 0 !== _r73 ? 12 : 16; _i186 < _a165; _i186++) t.push(e.readCoordinate());
        var _g39 = i.length;
        for (var _t180 = 0, _a166 = 0 !== _r73 ? 2 : 4; _t180 < _a166; _t180++) i.push(e.readComponents());
        var _o31 = void 0,
          _c23 = void 0,
          _C16 = void 0,
          h = void 0;
        switch (_r73) {
          case 0:
            a[12] = _n59 + 3;
            a[13] = _n59 + 4;
            a[14] = _n59 + 5;
            a[15] = _n59 + 6;
            a[8] = _n59 + 2;
            a[9] = _n59 + 13;
            a[10] = _n59 + 14;
            a[11] = _n59 + 7;
            a[4] = _n59 + 1;
            a[5] = _n59 + 12;
            a[6] = _n59 + 15;
            a[7] = _n59 + 8;
            a[0] = _n59;
            a[1] = _n59 + 11;
            a[2] = _n59 + 10;
            a[3] = _n59 + 9;
            s[2] = _g39 + 1;
            s[3] = _g39 + 2;
            s[0] = _g39;
            s[1] = _g39 + 3;
            break;
          case 1:
            _o31 = a[12];
            _c23 = a[13];
            _C16 = a[14];
            h = a[15];
            a[12] = h;
            a[13] = _n59 + 0;
            a[14] = _n59 + 1;
            a[15] = _n59 + 2;
            a[8] = _C16;
            a[9] = _n59 + 9;
            a[10] = _n59 + 10;
            a[11] = _n59 + 3;
            a[4] = _c23;
            a[5] = _n59 + 8;
            a[6] = _n59 + 11;
            a[7] = _n59 + 4;
            a[0] = _o31;
            a[1] = _n59 + 7;
            a[2] = _n59 + 6;
            a[3] = _n59 + 5;
            _o31 = s[2];
            _c23 = s[3];
            s[2] = _c23;
            s[3] = _g39;
            s[0] = _o31;
            s[1] = _g39 + 1;
            break;
          case 2:
            _o31 = a[15];
            _c23 = a[11];
            a[12] = a[3];
            a[13] = _n59 + 0;
            a[14] = _n59 + 1;
            a[15] = _n59 + 2;
            a[8] = a[7];
            a[9] = _n59 + 9;
            a[10] = _n59 + 10;
            a[11] = _n59 + 3;
            a[4] = _c23;
            a[5] = _n59 + 8;
            a[6] = _n59 + 11;
            a[7] = _n59 + 4;
            a[0] = _o31;
            a[1] = _n59 + 7;
            a[2] = _n59 + 6;
            a[3] = _n59 + 5;
            _o31 = s[3];
            s[2] = s[1];
            s[3] = _g39;
            s[0] = _o31;
            s[1] = _g39 + 1;
            break;
          case 3:
            a[12] = a[0];
            a[13] = _n59 + 0;
            a[14] = _n59 + 1;
            a[15] = _n59 + 2;
            a[8] = a[1];
            a[9] = _n59 + 9;
            a[10] = _n59 + 10;
            a[11] = _n59 + 3;
            a[4] = a[2];
            a[5] = _n59 + 8;
            a[6] = _n59 + 11;
            a[7] = _n59 + 4;
            a[0] = a[3];
            a[1] = _n59 + 7;
            a[2] = _n59 + 6;
            a[3] = _n59 + 5;
            s[2] = s[0];
            s[3] = _g39;
            s[0] = s[1];
            s[1] = _g39 + 1;
        }
        this.figures.push({
          type: "patch",
          coords: new Int32Array(a),
          colors: new Int32Array(s)
        });
      }
    }
  }, {
    key: "_buildFigureFromPatch",
    value: function _buildFigureFromPatch(e) {
      var t = this.figures[e];
      assert("patch" === t.type, "Unexpected patch mesh figure");
      var i = this.coords,
        a = this.colors,
        s = t.coords,
        r = t.colors,
        n = Math.min(i[s[0]][0], i[s[3]][0], i[s[12]][0], i[s[15]][0]),
        g = Math.min(i[s[0]][1], i[s[3]][1], i[s[12]][1], i[s[15]][1]),
        o = Math.max(i[s[0]][0], i[s[3]][0], i[s[12]][0], i[s[15]][0]),
        c = Math.max(i[s[0]][1], i[s[3]][1], i[s[12]][1], i[s[15]][1]);
      var C = Math.ceil((o - n) * MeshShading.TRIANGLE_DENSITY / (this.bounds[2] - this.bounds[0]));
      C = Math.max(MeshShading.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MeshShading.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, C));
      var h = Math.ceil((c - g) * MeshShading.TRIANGLE_DENSITY / (this.bounds[3] - this.bounds[1]));
      h = Math.max(MeshShading.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MeshShading.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, h));
      var l = C + 1,
        Q = new Int32Array((h + 1) * l),
        E = new Int32Array((h + 1) * l);
      var u = 0;
      var d = new Uint8Array(3),
        f = new Uint8Array(3),
        p = a[r[0]],
        m = a[r[1]],
        y = a[r[2]],
        w = a[r[3]],
        D = getB(h),
        b = getB(C);
      for (var _e262 = 0; _e262 <= h; _e262++) {
        d[0] = (p[0] * (h - _e262) + y[0] * _e262) / h | 0;
        d[1] = (p[1] * (h - _e262) + y[1] * _e262) / h | 0;
        d[2] = (p[2] * (h - _e262) + y[2] * _e262) / h | 0;
        f[0] = (m[0] * (h - _e262) + w[0] * _e262) / h | 0;
        f[1] = (m[1] * (h - _e262) + w[1] * _e262) / h | 0;
        f[2] = (m[2] * (h - _e262) + w[2] * _e262) / h | 0;
        for (var _t181 = 0; _t181 <= C; _t181++, u++) {
          if (!(0 !== _e262 && _e262 !== h || 0 !== _t181 && _t181 !== C)) continue;
          var _r74 = 0,
            _n60 = 0,
            _g40 = 0;
          for (var _a167 = 0; _a167 <= 3; _a167++) for (var _o32 = 0; _o32 <= 3; _o32++, _g40++) {
            var _c24 = D[_e262][_a167] * b[_t181][_o32];
            _r74 += i[s[_g40]][0] * _c24;
            _n60 += i[s[_g40]][1] * _c24;
          }
          Q[u] = i.length;
          i.push([_r74, _n60]);
          E[u] = a.length;
          var _o33 = new Uint8Array(3);
          _o33[0] = (d[0] * (C - _t181) + f[0] * _t181) / C | 0;
          _o33[1] = (d[1] * (C - _t181) + f[1] * _t181) / C | 0;
          _o33[2] = (d[2] * (C - _t181) + f[2] * _t181) / C | 0;
          a.push(_o33);
        }
      }
      Q[0] = s[0];
      E[0] = r[0];
      Q[C] = s[3];
      E[C] = r[1];
      Q[l * h] = s[12];
      E[l * h] = r[2];
      Q[l * h + C] = s[15];
      E[l * h + C] = r[3];
      this.figures[e] = {
        type: "lattice",
        coords: Q,
        colors: E,
        verticesPerRow: l
      };
    }
  }, {
    key: "_updateBounds",
    value: function _updateBounds() {
      var e = this.coords[0][0],
        t = this.coords[0][1],
        i = e,
        a = t;
      for (var _s108 = 1, _r75 = this.coords.length; _s108 < _r75; _s108++) {
        var _r76 = this.coords[_s108][0],
          _n61 = this.coords[_s108][1];
        e = e > _r76 ? _r76 : e;
        t = t > _n61 ? _n61 : t;
        i = i < _r76 ? _r76 : i;
        a = a < _n61 ? _n61 : a;
      }
      this.bounds = [e, t, i, a];
    }
  }, {
    key: "_packData",
    value: function _packData() {
      var e, t, i, a;
      var s = this.coords,
        r = new Float32Array(2 * s.length);
      for (e = 0, i = 0, t = s.length; e < t; e++) {
        var _t182 = s[e];
        r[i++] = _t182[0];
        r[i++] = _t182[1];
      }
      this.coords = r;
      var n = this.colors,
        g = new Uint8Array(3 * n.length);
      for (e = 0, i = 0, t = n.length; e < t; e++) {
        var _t183 = n[e];
        g[i++] = _t183[0];
        g[i++] = _t183[1];
        g[i++] = _t183[2];
      }
      this.colors = g;
      var o = this.figures;
      for (e = 0, t = o.length; e < t; e++) {
        var _t184 = o[e],
          _s109 = _t184.coords,
          _r77 = _t184.colors;
        for (i = 0, a = _s109.length; i < a; i++) {
          _s109[i] *= 2;
          _r77[i] *= 3;
        }
      }
    }
  }, {
    key: "getIR",
    value: function getIR() {
      var e = this.bounds;
      if (e[2] - e[0] == 0 || e[3] - e[1] == 0) throw new FormatError("Invalid MeshShading bounds: [".concat(e, "]."));
      return ["Mesh", this.shadingType, this.coords, this.colors, this.figures, e, this.bbox, this.background];
    }
  }]);
}(BaseShading);
MeshShading.MIN_SPLIT_PATCH_CHUNKS_AMOUNT = 3;
MeshShading.MAX_SPLIT_PATCH_CHUNKS_AMOUNT = 20;
MeshShading.TRIANGLE_DENSITY = 20;
var DummyShading = /*#__PURE__*/function (_BaseShading4) {
  function DummyShading() {
    _classCallCheck(this, DummyShading);
    return _callSuper(this, DummyShading, arguments);
  }
  _inherits(DummyShading, _BaseShading4);
  return _createClass(DummyShading, [{
    key: "getIR",
    value: function getIR() {
      return ["Dummy"];
    }
  }]);
}(BaseShading);
function getTilingPatternIR(e, t, a) {
  var s = lookupMatrix(t.getArray("Matrix"), i),
    r = lookupNormalRect(t.getArray("BBox"), null);
  if (!r || r[2] - r[0] == 0 || r[3] - r[1] == 0) throw new FormatError("Invalid getTilingPatternIR /BBox array.");
  var n = t.get("XStep");
  if ("number" != typeof n) throw new FormatError("Invalid getTilingPatternIR /XStep value.");
  var g = t.get("YStep");
  if ("number" != typeof g) throw new FormatError("Invalid getTilingPatternIR /YStep value.");
  var o = t.get("PaintType");
  if (!Number.isInteger(o)) throw new FormatError("Invalid getTilingPatternIR /PaintType value.");
  var c = t.get("TilingType");
  if (!Number.isInteger(c)) throw new FormatError("Invalid getTilingPatternIR /TilingType value.");
  return ["TilingPattern", a, e, s, r, n, g, o, c];
}
var Fa = [1.3877, 1, 1, 1, .97801, .92482, .89552, .91133, .81988, .97566, .98152, .93548, .93548, 1.2798, .85284, .92794, 1, .96134, 1.54657, .91133, .91133, .91133, .91133, .91133, .91133, .91133, .91133, .91133, .91133, .82845, .82845, .85284, .85284, .85284, .75859, .92138, .83908, .7762, .73293, .87289, .73133, .7514, .81921, .87356, .95958, .59526, .75727, .69225, 1.04924, .9121, .86943, .79795, .88198, .77958, .70864, .81055, .90399, .88653, .96017, .82577, .77892, .78257, .97507, 1.54657, .97507, .85284, .89552, .90176, .88762, .8785, .75241, .8785, .90518, .95015, .77618, .8785, .88401, .91916, .86304, .88401, .91488, .8785, .8801, .8785, .8785, .91343, .7173, 1.04106, .8785, .85075, .95794, .82616, .85162, .79492, .88331, 1.69808, .88331, .85284, .97801, .89552, .91133, .89552, .91133, 1.7801, .89552, 1.24487, 1.13254, 1.12401, .96839, .85284, .68787, .70645, .85592, .90747, 1.01466, 1.0088, .90323, 1, 1.07463, 1, .91056, .75806, 1.19118, .96839, .78864, .82845, .84133, .75859, .83908, .83908, .83908, .83908, .83908, .83908, .77539, .73293, .73133, .73133, .73133, .73133, .95958, .95958, .95958, .95958, .88506, .9121, .86943, .86943, .86943, .86943, .86943, .85284, .87508, .90399, .90399, .90399, .90399, .77892, .79795, .90807, .88762, .88762, .88762, .88762, .88762, .88762, .8715, .75241, .90518, .90518, .90518, .90518, .88401, .88401, .88401, .88401, .8785, .8785, .8801, .8801, .8801, .8801, .8801, .90747, .89049, .8785, .8785, .8785, .8785, .85162, .8785, .85162, .83908, .88762, .83908, .88762, .83908, .88762, .73293, .75241, .73293, .75241, .73293, .75241, .73293, .75241, .87289, .83016, .88506, .93125, .73133, .90518, .73133, .90518, .73133, .90518, .73133, .90518, .73133, .90518, .81921, .77618, .81921, .77618, .81921, .77618, 1, 1, .87356, .8785, .91075, .89608, .95958, .88401, .95958, .88401, .95958, .88401, .95958, .88401, .95958, .88401, .76229, .90167, .59526, .91916, 1, 1, .86304, .69225, .88401, 1, 1, .70424, .79468, .91926, .88175, .70823, .94903, .9121, .8785, 1, 1, .9121, .8785, .87802, .88656, .8785, .86943, .8801, .86943, .8801, .86943, .8801, .87402, .89291, .77958, .91343, 1, 1, .77958, .91343, .70864, .7173, .70864, .7173, .70864, .7173, .70864, .7173, 1, 1, .81055, .75841, .81055, 1.06452, .90399, .8785, .90399, .8785, .90399, .8785, .90399, .8785, .90399, .8785, .90399, .8785, .96017, .95794, .77892, .85162, .77892, .78257, .79492, .78257, .79492, .78257, .79492, .9297, .56892, .83908, .88762, .77539, .8715, .87508, .89049, 1, 1, .81055, 1.04106, 1.20528, 1.20528, 1, 1.15543, .70674, .98387, .94721, 1.33431, 1.45894, .95161, 1.06303, .83908, .80352, .57184, .6965, .56289, .82001, .56029, .81235, 1.02988, .83908, .7762, .68156, .80367, .73133, .78257, .87356, .86943, .95958, .75727, .89019, 1.04924, .9121, .7648, .86943, .87356, .79795, .78275, .81055, .77892, .9762, .82577, .99819, .84896, .95958, .77892, .96108, 1.01407, .89049, 1.02988, .94211, .96108, .8936, .84021, .87842, .96399, .79109, .89049, 1.00813, 1.02988, .86077, .87445, .92099, .84723, .86513, .8801, .75638, .85714, .78216, .79586, .87965, .94211, .97747, .78287, .97926, .84971, 1.02988, .94211, .8801, .94211, .84971, .73133, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .90264, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .90518, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .90548, 1, 1, 1, 1, 1, 1, .96017, .95794, .96017, .95794, .96017, .95794, .77892, .85162, 1, 1, .89552, .90527, 1, .90363, .92794, .92794, .92794, .92794, .87012, .87012, .87012, .89552, .89552, 1.42259, .71143, 1.06152, 1, 1, 1.03372, 1.03372, .97171, 1.4956, 2.2807, .93835, .83406, .91133, .84107, .91133, 1, 1, 1, .72021, 1, 1.23108, .83489, .88525, .88525, .81499, .90527, 1.81055, .90527, 1.81055, 1.31006, 1.53711, .94434, 1.08696, 1, .95018, .77192, .85284, .90747, 1.17534, .69825, .9716, 1.37077, .90747, .90747, .85356, .90747, .90747, 1.44947, .85284, .8941, .8941, .70572, .8, .70572, .70572, .70572, .70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .99862, .99862, 1, 1, 1, 1, 1, 1.08004, .91027, 1, 1, 1, .99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .90727, .90727, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  Sa = {
    lineHeight: 1.2207,
    lineGap: .2207
  },
  ka = [1.3877, 1, 1, 1, .97801, .92482, .89552, .91133, .81988, .97566, .98152, .93548, .93548, 1.2798, .85284, .92794, 1, .96134, 1.56239, .91133, .91133, .91133, .91133, .91133, .91133, .91133, .91133, .91133, .91133, .82845, .82845, .85284, .85284, .85284, .75859, .92138, .83908, .7762, .71805, .87289, .73133, .7514, .81921, .87356, .95958, .59526, .75727, .69225, 1.04924, .90872, .85938, .79795, .87068, .77958, .69766, .81055, .90399, .88653, .96068, .82577, .77892, .78257, .97507, 1.529, .97507, .85284, .89552, .90176, .94908, .86411, .74012, .86411, .88323, .95015, .86411, .86331, .88401, .91916, .86304, .88401, .9039, .86331, .86331, .86411, .86411, .90464, .70852, 1.04106, .86331, .84372, .95794, .82616, .84548, .79492, .88331, 1.69808, .88331, .85284, .97801, .89552, .91133, .89552, .91133, 1.7801, .89552, 1.24487, 1.13254, 1.19129, .96839, .85284, .68787, .70645, .85592, .90747, 1.01466, 1.0088, .90323, 1, 1.07463, 1, .91056, .75806, 1.19118, .96839, .78864, .82845, .84133, .75859, .83908, .83908, .83908, .83908, .83908, .83908, .77539, .71805, .73133, .73133, .73133, .73133, .95958, .95958, .95958, .95958, .88506, .90872, .85938, .85938, .85938, .85938, .85938, .85284, .87068, .90399, .90399, .90399, .90399, .77892, .79795, .90807, .94908, .94908, .94908, .94908, .94908, .94908, .85887, .74012, .88323, .88323, .88323, .88323, .88401, .88401, .88401, .88401, .8785, .86331, .86331, .86331, .86331, .86331, .86331, .90747, .89049, .86331, .86331, .86331, .86331, .84548, .86411, .84548, .83908, .94908, .83908, .94908, .83908, .94908, .71805, .74012, .71805, .74012, .71805, .74012, .71805, .74012, .87289, .79538, .88506, .92726, .73133, .88323, .73133, .88323, .73133, .88323, .73133, .88323, .73133, .88323, .81921, .86411, .81921, .86411, .81921, .86411, 1, 1, .87356, .86331, .91075, .8777, .95958, .88401, .95958, .88401, .95958, .88401, .95958, .88401, .95958, .88401, .76467, .90167, .59526, .91916, 1, 1, .86304, .69225, .88401, 1, 1, .70424, .77312, .91926, .88175, .70823, .94903, .90872, .86331, 1, 1, .90872, .86331, .86906, .88116, .86331, .85938, .86331, .85938, .86331, .85938, .86331, .87402, .86549, .77958, .90464, 1, 1, .77958, .90464, .69766, .70852, .69766, .70852, .69766, .70852, .69766, .70852, 1, 1, .81055, .75841, .81055, 1.06452, .90399, .86331, .90399, .86331, .90399, .86331, .90399, .86331, .90399, .86331, .90399, .86331, .96068, .95794, .77892, .84548, .77892, .78257, .79492, .78257, .79492, .78257, .79492, .9297, .56892, .83908, .94908, .77539, .85887, .87068, .89049, 1, 1, .81055, 1.04106, 1.20528, 1.20528, 1, 1.15543, .70088, .98387, .94721, 1.33431, 1.45894, .95161, 1.48387, .83908, .80352, .57118, .6965, .56347, .79179, .55853, .80346, 1.02988, .83908, .7762, .67174, .86036, .73133, .78257, .87356, .86441, .95958, .75727, .89019, 1.04924, .90872, .74889, .85938, .87891, .79795, .7957, .81055, .77892, .97447, .82577, .97466, .87179, .95958, .77892, .94252, .95612, .8753, 1.02988, .92733, .94252, .87411, .84021, .8728, .95612, .74081, .8753, 1.02189, 1.02988, .84814, .87445, .91822, .84723, .85668, .86331, .81344, .87581, .76422, .82046, .96057, .92733, .99375, .78022, .95452, .86015, 1.02988, .92733, .86331, .92733, .86015, .73133, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .90631, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .88323, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .85174, 1, 1, 1, 1, 1, 1, .96068, .95794, .96068, .95794, .96068, .95794, .77892, .84548, 1, 1, .89552, .90527, 1, .90363, .92794, .92794, .92794, .89807, .87012, .87012, .87012, .89552, .89552, 1.42259, .71094, 1.06152, 1, 1, 1.03372, 1.03372, .97171, 1.4956, 2.2807, .92972, .83406, .91133, .83326, .91133, 1, 1, 1, .72021, 1, 1.23108, .83489, .88525, .88525, .81499, .90616, 1.81055, .90527, 1.81055, 1.3107, 1.53711, .94434, 1.08696, 1, .95018, .77192, .85284, .90747, 1.17534, .69825, .9716, 1.37077, .90747, .90747, .85356, .90747, .90747, 1.44947, .85284, .8941, .8941, .70572, .8, .70572, .70572, .70572, .70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .99862, .99862, 1, 1, 1, 1, 1, 1.08004, .91027, 1, 1, 1, .99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .90727, .90727, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  Ra = {
    lineHeight: 1.2207,
    lineGap: .2207
  },
  Na = [1.3877, 1, 1, 1, 1.17223, 1.1293, .89552, .91133, .80395, 1.02269, 1.15601, .91056, .91056, 1.2798, .85284, .89807, 1, .90861, 1.39543, .91133, .91133, .91133, .91133, .91133, .91133, .91133, .91133, .91133, .91133, .96309, .96309, .85284, .85284, .85284, .83319, .88071, .8675, .81552, .72346, .85193, .73206, .7522, .81105, .86275, .90685, .6377, .77892, .75593, 1.02638, .89249, .84118, .77452, .85374, .75186, .67789, .79776, .88844, .85066, .94309, .77818, .7306, .76659, 1.10369, 1.38313, 1.10369, 1.06139, .89552, .8739, .9245, .9245, .83203, .9245, .85865, 1.09842, .9245, .9245, 1.03297, 1.07692, .90918, 1.03297, .94959, .9245, .92274, .9245, .9245, 1.02933, .77832, 1.20562, .9245, .8916, .98986, .86621, .89453, .79004, .94152, 1.77256, .94152, .85284, .97801, .89552, .91133, .89552, .91133, 1.91729, .89552, 1.17889, 1.13254, 1.16359, .92098, .85284, .68787, .71353, .84737, .90747, 1.0088, 1.0044, .87683, 1, 1.09091, 1, .92229, .739, 1.15642, .92098, .76288, .80504, .80972, .75859, .8675, .8675, .8675, .8675, .8675, .8675, .76318, .72346, .73206, .73206, .73206, .73206, .90685, .90685, .90685, .90685, .86477, .89249, .84118, .84118, .84118, .84118, .84118, .85284, .84557, .88844, .88844, .88844, .88844, .7306, .77452, .86331, .9245, .9245, .9245, .9245, .9245, .9245, .84843, .83203, .85865, .85865, .85865, .85865, .82601, .82601, .82601, .82601, .94469, .9245, .92274, .92274, .92274, .92274, .92274, .90747, .86651, .9245, .9245, .9245, .9245, .89453, .9245, .89453, .8675, .9245, .8675, .9245, .8675, .9245, .72346, .83203, .72346, .83203, .72346, .83203, .72346, .83203, .85193, .8875, .86477, .99034, .73206, .85865, .73206, .85865, .73206, .85865, .73206, .85865, .73206, .85865, .81105, .9245, .81105, .9245, .81105, .9245, 1, 1, .86275, .9245, .90872, .93591, .90685, .82601, .90685, .82601, .90685, .82601, .90685, 1.03297, .90685, .82601, .77896, 1.05611, .6377, 1.07692, 1, 1, .90918, .75593, 1.03297, 1, 1, .76032, .9375, .98156, .93407, .77261, 1.11429, .89249, .9245, 1, 1, .89249, .9245, .92534, .86698, .9245, .84118, .92274, .84118, .92274, .84118, .92274, .8667, .86291, .75186, 1.02933, 1, 1, .75186, 1.02933, .67789, .77832, .67789, .77832, .67789, .77832, .67789, .77832, 1, 1, .79776, .97655, .79776, 1.23023, .88844, .9245, .88844, .9245, .88844, .9245, .88844, .9245, .88844, .9245, .88844, .9245, .94309, .98986, .7306, .89453, .7306, .76659, .79004, .76659, .79004, .76659, .79004, 1.09231, .54873, .8675, .9245, .76318, .84843, .84557, .86651, 1, 1, .79776, 1.20562, 1.18622, 1.18622, 1, 1.1437, .67009, .96334, .93695, 1.35191, 1.40909, .95161, 1.48387, .8675, .90861, .6192, .7363, .64824, .82411, .56321, .85696, 1.23516, .8675, .81552, .7286, .84134, .73206, .76659, .86275, .84369, .90685, .77892, .85871, 1.02638, .89249, .75828, .84118, .85984, .77452, .76466, .79776, .7306, .90782, .77818, .903, .87291, .90685, .7306, .99058, 1.03667, .94635, 1.23516, .9849, .99058, .92393, .8916, .942, 1.03667, .75026, .94635, 1.0297, 1.23516, .90918, .94048, .98217, .89746, .84153, .92274, .82507, .88832, .84438, .88178, 1.03525, .9849, 1.00225, .78086, .97248, .89404, 1.23516, .9849, .92274, .9849, .89404, .73206, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .89693, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .85865, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .90933, 1, 1, 1, 1, 1, 1, .94309, .98986, .94309, .98986, .94309, .98986, .7306, .89453, 1, 1, .89552, .90527, 1, .90186, 1.12308, 1.12308, 1.12308, 1.12308, 1.2566, 1.2566, 1.2566, .89552, .89552, 1.42259, .68994, 1.03809, 1, 1, 1.0176, 1.0176, 1.11523, 1.4956, 2.01462, .97858, .82616, .91133, .83437, .91133, 1, 1, 1, .70508, 1, 1.23108, .79801, .84426, .84426, .774, .90572, 1.81055, .90749, 1.81055, 1.28809, 1.55469, .94434, 1.07806, 1, .97094, .7589, .85284, .90747, 1.19658, .69825, .97622, 1.33512, .90747, .90747, .85284, .90747, .90747, 1.44947, .85284, .8941, .8941, .70572, .8, .70572, .70572, .70572, .70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .99862, .99862, 1, 1, 1, 1, 1, 1.0336, .91027, 1, 1, 1, .99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05859, 1.05859, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  Ga = {
    lineHeight: 1.2207,
    lineGap: .2207
  },
  xa = [1.3877, 1, 1, 1, 1.17223, 1.1293, .89552, .91133, .80395, 1.02269, 1.15601, .91056, .91056, 1.2798, .85284, .89807, 1, .90861, 1.39016, .91133, .91133, .91133, .91133, .91133, .91133, .91133, .91133, .91133, .91133, .96309, .96309, .85284, .85284, .85284, .83319, .88071, .8675, .81552, .73834, .85193, .73206, .7522, .81105, .86275, .90685, .6377, .77892, .75593, 1.02638, .89385, .85122, .77452, .86503, .75186, .68887, .79776, .88844, .85066, .94258, .77818, .7306, .76659, 1.10369, 1.39016, 1.10369, 1.06139, .89552, .8739, .86128, .94469, .8457, .94469, .89464, 1.09842, .84636, .94469, 1.03297, 1.07692, .90918, 1.03297, .95897, .94469, .9482, .94469, .94469, 1.04692, .78223, 1.20562, .94469, .90332, .98986, .86621, .90527, .79004, .94152, 1.77256, .94152, .85284, .97801, .89552, .91133, .89552, .91133, 1.91729, .89552, 1.17889, 1.13254, 1.08707, .92098, .85284, .68787, .71353, .84737, .90747, 1.0088, 1.0044, .87683, 1, 1.09091, 1, .92229, .739, 1.15642, .92098, .76288, .80504, .80972, .75859, .8675, .8675, .8675, .8675, .8675, .8675, .76318, .73834, .73206, .73206, .73206, .73206, .90685, .90685, .90685, .90685, .86477, .89385, .85122, .85122, .85122, .85122, .85122, .85284, .85311, .88844, .88844, .88844, .88844, .7306, .77452, .86331, .86128, .86128, .86128, .86128, .86128, .86128, .8693, .8457, .89464, .89464, .89464, .89464, .82601, .82601, .82601, .82601, .94469, .94469, .9482, .9482, .9482, .9482, .9482, .90747, .86651, .94469, .94469, .94469, .94469, .90527, .94469, .90527, .8675, .86128, .8675, .86128, .8675, .86128, .73834, .8457, .73834, .8457, .73834, .8457, .73834, .8457, .85193, .92454, .86477, .9921, .73206, .89464, .73206, .89464, .73206, .89464, .73206, .89464, .73206, .89464, .81105, .84636, .81105, .84636, .81105, .84636, 1, 1, .86275, .94469, .90872, .95786, .90685, .82601, .90685, .82601, .90685, .82601, .90685, 1.03297, .90685, .82601, .77741, 1.05611, .6377, 1.07692, 1, 1, .90918, .75593, 1.03297, 1, 1, .76032, .90452, .98156, 1.11842, .77261, 1.11429, .89385, .94469, 1, 1, .89385, .94469, .95877, .86901, .94469, .85122, .9482, .85122, .9482, .85122, .9482, .8667, .90016, .75186, 1.04692, 1, 1, .75186, 1.04692, .68887, .78223, .68887, .78223, .68887, .78223, .68887, .78223, 1, 1, .79776, .92188, .79776, 1.23023, .88844, .94469, .88844, .94469, .88844, .94469, .88844, .94469, .88844, .94469, .88844, .94469, .94258, .98986, .7306, .90527, .7306, .76659, .79004, .76659, .79004, .76659, .79004, 1.09231, .54873, .8675, .86128, .76318, .8693, .85311, .86651, 1, 1, .79776, 1.20562, 1.18622, 1.18622, 1, 1.1437, .67742, .96334, .93695, 1.35191, 1.40909, .95161, 1.48387, .86686, .90861, .62267, .74359, .65649, .85498, .56963, .88254, 1.23516, .8675, .81552, .75443, .84503, .73206, .76659, .86275, .85122, .90685, .77892, .85746, 1.02638, .89385, .75657, .85122, .86275, .77452, .74171, .79776, .7306, .95165, .77818, .89772, .88831, .90685, .7306, .98142, 1.02191, .96576, 1.23516, .99018, .98142, .9236, .89258, .94035, 1.02191, .78848, .96576, .9561, 1.23516, .90918, .92578, .95424, .89746, .83969, .9482, .80113, .89442, .85208, .86155, .98022, .99018, 1.00452, .81209, .99247, .89181, 1.23516, .99018, .9482, .99018, .89181, .73206, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .88844, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .89464, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .96766, 1, 1, 1, 1, 1, 1, .94258, .98986, .94258, .98986, .94258, .98986, .7306, .90527, 1, 1, .89552, .90527, 1, .90186, 1.12308, 1.12308, 1.12308, 1.12308, 1.2566, 1.2566, 1.2566, .89552, .89552, 1.42259, .69043, 1.03809, 1, 1, 1.0176, 1.0176, 1.11523, 1.4956, 2.01462, .99331, .82616, .91133, .84286, .91133, 1, 1, 1, .70508, 1, 1.23108, .79801, .84426, .84426, .774, .90527, 1.81055, .90527, 1.81055, 1.28809, 1.55469, .94434, 1.07806, 1, .97094, .7589, .85284, .90747, 1.19658, .69825, .97622, 1.33512, .90747, .90747, .85356, .90747, .90747, 1.44947, .85284, .8941, .8941, .70572, .8, .70572, .70572, .70572, .70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .99862, .99862, 1, 1, 1, 1, 1, 1.0336, .91027, 1, 1, 1, .99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05859, 1.05859, 1, 1, 1, 1.07185, .99413, .96334, 1.08065, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  Ua = {
    lineHeight: 1.2207,
    lineGap: .2207
  },
  Ma = [.76116, 1, 1, 1.0006, .99998, .99974, .99973, .99973, .99982, .99977, 1.00087, .99998, .99998, .99959, 1.00003, 1.0006, .99998, 1.0006, 1.0006, .99973, .99973, .99973, .99973, .99973, .99973, .99973, .99973, .99973, .99973, .99998, 1, 1.00003, 1.00003, 1.00003, 1.00026, .9999, .99977, .99977, .99977, .99977, 1.00001, 1.00026, 1.00022, .99977, 1.0006, .99973, .99977, 1.00026, .99999, .99977, 1.00022, 1.00001, 1.00022, .99977, 1.00001, 1.00026, .99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, .99998, 1.0006, .99998, 1.00003, .99973, .99998, .99973, 1.00026, .99973, 1.00026, .99973, .99998, 1.00026, 1.00026, 1.0006, 1.0006, .99973, 1.0006, .99982, 1.00026, 1.00026, 1.00026, 1.00026, .99959, .99973, .99998, 1.00026, .99973, 1.00022, .99973, .99973, 1, .99959, 1.00077, .99959, 1.00003, .99998, .99973, .99973, .99973, .99973, 1.00077, .99973, .99998, 1.00025, .99968, .99973, 1.00003, 1.00025, .60299, 1.00024, 1.06409, 1, 1, .99998, 1, .99973, 1.0006, .99998, 1, .99936, .99973, 1.00002, 1.00002, 1.00002, 1.00026, .99977, .99977, .99977, .99977, .99977, .99977, 1, .99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, .99977, .99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, .99977, .99977, .99977, .99977, 1.00001, 1.00001, 1.00026, .99973, .99973, .99973, .99973, .99973, .99973, .99982, .99973, .99973, .99973, .99973, .99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.06409, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, .99973, 1.00026, .99973, .99977, .99973, .99977, .99973, .99977, .99973, .99977, .99973, .99977, .99973, .99977, .99973, .99977, .99973, .99977, 1.03374, .99977, 1.00026, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, .99977, 1.00026, .99977, 1.00026, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.00042, .99973, .99973, 1.0006, .99977, .99973, .99973, 1.00026, 1.0006, 1.00026, 1.0006, 1.00026, 1.03828, 1.00026, .99999, 1.00026, 1.0006, .99977, 1.00026, .99977, 1.00026, .99977, 1.00026, .9993, .9998, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1, 1.00016, .99977, .99959, .99977, .99959, .99977, .99959, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, 1.00026, .99998, 1.00026, .8121, 1.00026, .99998, .99977, 1.00026, .99977, 1.00026, .99977, 1.00026, .99977, 1.00026, .99977, 1.00026, .99977, 1.00026, 1.00016, 1.00022, 1.00001, .99973, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 1.0006, .99973, .99977, .99973, 1, .99982, 1.00022, 1.00026, 1.00001, .99973, 1.00026, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, 1.00034, .99977, 1, .99997, 1.00026, 1.00078, 1.00036, .99973, 1.00013, 1.0006, .99977, .99977, .99988, .85148, 1.00001, 1.00026, .99977, 1.00022, 1.0006, .99977, 1.00001, .99999, .99977, 1.00069, 1.00022, .99977, 1.00001, .99984, 1.00026, 1.00001, 1.00024, 1.00001, .9999, 1, 1.0006, 1.00001, 1.00041, .99962, 1.00026, 1.0006, .99995, 1.00041, .99942, .99973, .99927, 1.00082, .99902, 1.00026, 1.00087, 1.0006, 1.00069, .99973, .99867, .99973, .9993, 1.00026, 1.00049, 1.00056, 1, .99988, .99935, .99995, .99954, 1.00055, .99945, 1.00032, 1.0006, .99995, 1.00026, .99995, 1.00032, 1.00001, 1.00008, .99971, 1.00019, .9994, 1.00001, 1.0006, 1.00044, .99973, 1.00023, 1.00047, 1, .99942, .99561, .99989, 1.00035, .99977, 1.00035, .99977, 1.00019, .99944, 1.00001, 1.00021, .99926, 1.00035, 1.00035, .99942, 1.00048, .99999, .99977, 1.00022, 1.00035, 1.00001, .99977, 1.00026, .99989, 1.00057, 1.00001, .99936, 1.00052, 1.00012, .99996, 1.00043, 1, 1.00035, .9994, .99976, 1.00035, .99973, 1.00052, 1.00041, 1.00119, 1.00037, .99973, 1.00002, .99986, 1.00041, 1.00041, .99902, .9996, 1.00034, .99999, 1.00026, .99999, 1.00026, .99973, 1.00052, .99973, 1, .99973, 1.00041, 1.00075, .9994, 1.0003, .99999, 1, 1.00041, .99955, 1, .99915, .99973, .99973, 1.00026, 1.00119, .99955, .99973, 1.0006, .99911, 1.0006, 1.00026, .99972, 1.00026, .99902, 1.00041, .99973, .99999, 1, 1, 1.00038, 1.0005, 1.00016, 1.00022, 1.00016, 1.00022, 1.00016, 1.00022, 1.00001, .99973, 1, 1, .99973, 1, 1, .99955, 1.0006, 1.0006, 1.0006, 1.0006, 1, 1, 1, .99973, .99973, .99972, 1, 1, 1.00106, .99999, .99998, .99998, .99999, .99998, 1.66475, 1, .99973, .99973, 1.00023, .99973, .99971, 1.00047, 1.00023, 1, .99991, .99984, 1.00002, 1.00002, 1.00002, 1.00002, 1, 1, 1, 1, 1, 1, 1, .99972, 1, 1.20985, 1.39713, 1.00003, 1.00031, 1.00015, 1, .99561, 1.00027, 1.00031, 1.00031, .99915, 1.00031, 1.00031, .99999, 1.00003, .99999, .99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, .99999, 1, .99861, .99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, .99972, .99999, .99999, .99999, .99999, 1.40483, 1, .99977, 1.00054, 1, 1, .99953, .99962, 1.00042, .9995, 1, 1, 1, 1, 1, 1, 1, 1, .99998, .99998, .99998, .99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  La = {
    lineHeight: 1.2,
    lineGap: .2
  },
  Ha = [.76116, 1, 1, 1.0006, .99998, .99974, .99973, .99973, .99982, .99977, 1.00087, .99998, .99998, .99959, 1.00003, 1.0006, .99998, 1.0006, 1.0006, .99973, .99973, .99973, .99973, .99973, .99973, .99973, .99973, .99973, .99973, .99998, 1, 1.00003, 1.00003, 1.00003, 1.00026, .9999, .99977, .99977, .99977, .99977, 1.00001, 1.00026, 1.00022, .99977, 1.0006, .99973, .99977, 1.00026, .99999, .99977, 1.00022, 1.00001, 1.00022, .99977, 1.00001, 1.00026, .99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, .99998, 1.0006, .99998, 1.00003, .99973, .99998, .99973, 1.00026, .99973, 1.00026, .99973, .99998, 1.00026, 1.00026, 1.0006, 1.0006, .99973, 1.0006, .99982, 1.00026, 1.00026, 1.00026, 1.00026, .99959, .99973, .99998, 1.00026, .99973, 1.00022, .99973, .99973, 1, .99959, 1.00077, .99959, 1.00003, .99998, .99973, .99973, .99973, .99973, 1.00077, .99973, .99998, 1.00025, .99968, .99973, 1.00003, 1.00025, .60299, 1.00024, 1.06409, 1, 1, .99998, 1, .99973, 1.0006, .99998, 1, .99936, .99973, 1.00002, 1.00002, 1.00002, 1.00026, .99977, .99977, .99977, .99977, .99977, .99977, 1, .99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, .99977, .99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, .99977, .99977, .99977, .99977, 1.00001, 1.00001, 1.00026, .99973, .99973, .99973, .99973, .99973, .99973, .99982, .99973, .99973, .99973, .99973, .99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.06409, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, .99973, 1.00026, .99973, .99977, .99973, .99977, .99973, .99977, .99973, .99977, .99973, .99977, .99973, .99977, .99973, .99977, .99973, .99977, 1.0044, .99977, 1.00026, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, .99977, 1.00026, .99977, 1.00026, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, .99971, .99973, .99973, 1.0006, .99977, .99973, .99973, 1.00026, 1.0006, 1.00026, 1.0006, 1.00026, 1.01011, 1.00026, .99999, 1.00026, 1.0006, .99977, 1.00026, .99977, 1.00026, .99977, 1.00026, .9993, .9998, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1, 1.00016, .99977, .99959, .99977, .99959, .99977, .99959, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, 1.00026, .99998, 1.00026, .8121, 1.00026, .99998, .99977, 1.00026, .99977, 1.00026, .99977, 1.00026, .99977, 1.00026, .99977, 1.00026, .99977, 1.00026, 1.00016, 1.00022, 1.00001, .99973, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 1.0006, .99973, .99977, .99973, 1, .99982, 1.00022, 1.00026, 1.00001, .99973, 1.00026, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99977, 1, 1, 1.00026, .99969, .99972, .99981, .9998, 1.0006, .99977, .99977, 1.00022, .91155, 1.00001, 1.00026, .99977, 1.00022, 1.0006, .99977, 1.00001, .99999, .99977, .99966, 1.00022, 1.00032, 1.00001, .99944, 1.00026, 1.00001, .99968, 1.00001, 1.00047, 1, 1.0006, 1.00001, .99981, 1.00101, 1.00026, 1.0006, .99948, .99981, 1.00064, .99973, .99942, 1.00101, 1.00061, 1.00026, 1.00069, 1.0006, 1.00014, .99973, 1.01322, .99973, 1.00065, 1.00026, 1.00012, .99923, 1, 1.00064, 1.00076, .99948, 1.00055, 1.00063, 1.00007, .99943, 1.0006, .99948, 1.00026, .99948, .99943, 1.00001, 1.00001, 1.00029, 1.00038, 1.00035, 1.00001, 1.0006, 1.0006, .99973, .99978, 1.00001, 1.00057, .99989, .99967, .99964, .99967, .99977, .99999, .99977, 1.00038, .99977, 1.00001, .99973, 1.00066, .99967, .99967, 1.00041, .99998, .99999, .99977, 1.00022, .99967, 1.00001, .99977, 1.00026, .99964, 1.00031, 1.00001, .99999, .99999, 1, 1.00023, 1, 1, .99999, 1.00035, 1.00001, .99999, .99973, .99977, .99999, 1.00058, .99973, .99973, .99955, .9995, 1.00026, 1.00026, 1.00032, .99989, 1.00034, .99999, 1.00026, 1.00026, 1.00026, .99973, .45998, .99973, 1.00026, .99973, 1.00001, .99999, .99982, .99994, .99996, 1, 1.00042, 1.00044, 1.00029, 1.00023, .99973, .99973, 1.00026, .99949, 1.00002, .99973, 1.0006, 1.0006, 1.0006, .99975, 1.00026, 1.00026, 1.00032, .98685, .99973, 1.00026, 1, 1, .99966, 1.00044, 1.00016, 1.00022, 1.00016, 1.00022, 1.00016, 1.00022, 1.00001, .99973, 1, 1, .99973, 1, 1, .99955, 1.0006, 1.0006, 1.0006, 1.0006, 1, 1, 1, .99973, .99973, .99972, 1, 1, 1.00106, .99999, .99998, .99998, .99999, .99998, 1.66475, 1, .99973, .99973, 1, .99973, .99971, .99978, 1, 1, .99991, .99984, 1.00002, 1.00002, 1.00002, 1.00002, 1.00098, 1, 1, 1, 1.00049, 1, 1, .99972, 1, 1.20985, 1.39713, 1.00003, 1.00031, 1.00015, 1, .99561, 1.00027, 1.00031, 1.00031, .99915, 1.00031, 1.00031, .99999, 1.00003, .99999, .99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, .99999, 1, .99861, .99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, .99972, .99999, .99999, .99999, .99999, 1.40483, 1, .99977, 1.00054, 1, 1, .99953, .99962, 1.00042, .9995, 1, 1, 1, 1, 1, 1, 1, 1, .99998, .99998, .99998, .99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  Ja = {
    lineHeight: 1.35,
    lineGap: .2
  },
  Ya = [.76116, 1, 1, 1.0006, 1.0006, 1.00006, .99973, .99973, .99982, 1.00001, 1.00043, .99998, .99998, .99959, 1.00003, 1.0006, .99998, 1.0006, 1.0006, .99973, .99973, .99973, .99973, .99973, .99973, .99973, .99973, .99973, .99973, 1.0006, 1, 1.00003, 1.00003, 1.00003, .99973, .99987, 1.00001, 1.00001, .99977, .99977, 1.00001, 1.00026, 1.00022, .99977, 1.0006, 1, 1.00001, .99973, .99999, .99977, 1.00022, 1.00001, 1.00022, .99977, 1.00001, 1.00026, .99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 1.0006, 1.0006, 1.0006, .99949, .99973, .99998, .99973, .99973, 1, .99973, .99973, 1.0006, .99973, .99973, .99924, .99924, 1, .99924, .99999, .99973, .99973, .99973, .99973, .99998, 1, 1.0006, .99973, 1, .99977, 1, 1, 1, 1.00005, 1.0009, 1.00005, 1.00003, .99998, .99973, .99973, .99973, .99973, 1.0009, .99973, .99998, 1.00025, .99968, .99973, 1.00003, 1.00025, .60299, 1.00024, 1.06409, 1, 1, .99998, 1, .9998, 1.0006, .99998, 1, .99936, .99973, 1.00002, 1.00002, 1.00002, 1.00026, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1, .99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, .99977, .99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, .99977, .99977, .99977, .99977, 1.00001, 1.00001, 1.00026, .99973, .99973, .99973, .99973, .99973, .99973, .99982, 1, .99973, .99973, .99973, .99973, 1.0006, 1.0006, 1.0006, 1.0006, .99973, .99973, .99973, .99973, .99973, .99973, .99973, 1.06409, 1.00026, .99973, .99973, .99973, .99973, 1, .99973, 1, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, .99977, 1, .99977, 1, .99977, 1, .99977, 1, .99977, 1.0288, .99977, .99973, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, 1.00022, .99973, 1.00022, .99973, 1.00022, .99973, 1.00022, .99973, .99977, .99973, .99977, .99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, .99924, 1.0006, 1.0006, .99946, 1.00034, 1, .99924, 1.00001, 1, 1, .99973, .99924, .99973, .99924, .99973, 1.06311, .99973, 1.00024, .99973, .99924, .99977, .99973, .99977, .99973, .99977, .99973, 1.00041, .9998, .99973, 1.00022, .99973, 1.00022, .99973, 1.00022, .99973, 1, 1.00016, .99977, .99998, .99977, .99998, .99977, .99998, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00026, 1.0006, 1.00026, .89547, 1.00026, 1.0006, .99977, .99973, .99977, .99973, .99977, .99973, .99977, .99973, .99977, .99973, .99977, .99973, 1.00016, .99977, 1.00001, 1, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, .99924, .99973, 1.00001, .99973, 1, .99982, 1.00022, 1.00026, 1.00001, 1, 1.00026, 1.0006, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, 1.00001, 1, 1.00054, .99977, 1.00084, 1.00007, .99973, 1.00013, .99924, 1.00001, 1.00001, .99945, .91221, 1.00001, 1.00026, .99977, 1.00022, 1.0006, 1.00001, 1.00001, .99999, .99977, .99933, 1.00022, 1.00054, 1.00001, 1.00065, 1.00026, 1.00001, 1.0001, 1.00001, 1.00052, 1, 1.0006, 1.00001, .99945, .99897, .99968, .99924, 1.00036, .99945, .99949, 1, 1.0006, .99897, .99918, .99968, .99911, .99924, 1, .99962, 1.01487, 1, 1.0005, .99973, 1.00012, 1.00043, 1, .99995, .99994, 1.00036, .99947, 1.00019, 1.00063, 1.00025, .99924, 1.00036, .99973, 1.00036, 1.00025, 1.00001, 1.00001, 1.00027, 1.0001, 1.00068, 1.00001, 1.0006, 1.0006, 1, 1.00008, .99957, .99972, .9994, .99954, .99975, 1.00051, 1.00001, 1.00019, 1.00001, 1.0001, .99986, 1.00001, 1.00001, 1.00038, .99954, .99954, .9994, 1.00066, .99999, .99977, 1.00022, 1.00054, 1.00001, .99977, 1.00026, .99975, 1.0001, 1.00001, .99993, .9995, .99955, 1.00016, .99978, .99974, 1.00019, 1.00022, .99955, 1.00053, .99973, 1.00089, 1.00005, .99967, 1.00048, .99973, 1.00002, 1.00034, .99973, .99973, .99964, 1.00006, 1.00066, .99947, .99973, .98894, .99973, 1, .44898, 1, .99946, 1, 1.00039, 1.00082, .99991, .99991, .99985, 1.00022, 1.00023, 1.00061, 1.00006, .99966, .99973, .99973, .99973, 1.00019, 1.0008, 1, .99924, .99924, .99924, .99983, 1.00044, .99973, .99964, .98332, 1, .99973, 1, 1, .99962, .99895, 1.00016, .99977, 1.00016, .99977, 1.00016, .99977, 1.00001, 1, 1, 1, .99973, 1, 1, .99955, .99924, .99924, .99924, .99924, .99998, .99998, .99998, .99973, .99973, .99972, 1, 1, 1.00267, .99999, .99998, .99998, 1, .99998, 1.66475, 1, .99973, .99973, 1.00023, .99973, 1.00423, .99925, .99999, 1, .99991, .99984, 1.00002, 1.00002, 1.00002, 1.00002, 1.00049, 1, 1.00245, 1, 1, 1, 1, .96329, 1, 1.20985, 1.39713, 1.00003, .8254, 1.00015, 1, 1.00035, 1.00027, 1.00031, 1.00031, 1.00003, 1.00031, 1.00031, .99999, 1.00003, .99999, .99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, .99999, 1, .99861, .99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, .95317, .99999, .99999, .99999, .99999, 1.40483, 1, .99977, 1.00054, 1, 1, .99953, .99962, 1.00042, .9995, 1, 1, 1, 1, 1, 1, 1, 1, .99998, .99998, .99998, .99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  va = {
    lineHeight: 1.35,
    lineGap: .2
  },
  Ka = [.76116, 1, 1, 1.0006, 1.0006, 1.00006, .99973, .99973, .99982, 1.00001, 1.00043, .99998, .99998, .99959, 1.00003, 1.0006, .99998, 1.0006, 1.0006, .99973, .99973, .99973, .99973, .99973, .99973, .99973, .99973, .99973, .99973, 1.0006, 1, 1.00003, 1.00003, 1.00003, .99973, .99987, 1.00001, 1.00001, .99977, .99977, 1.00001, 1.00026, 1.00022, .99977, 1.0006, 1, 1.00001, .99973, .99999, .99977, 1.00022, 1.00001, 1.00022, .99977, 1.00001, 1.00026, .99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 1.0006, 1.0006, 1.0006, .99949, .99973, .99998, .99973, .99973, 1, .99973, .99973, 1.0006, .99973, .99973, .99924, .99924, 1, .99924, .99999, .99973, .99973, .99973, .99973, .99998, 1, 1.0006, .99973, 1, .99977, 1, 1, 1, 1.00005, 1.0009, 1.00005, 1.00003, .99998, .99973, .99973, .99973, .99973, 1.0009, .99973, .99998, 1.00025, .99968, .99973, 1.00003, 1.00025, .60299, 1.00024, 1.06409, 1, 1, .99998, 1, .9998, 1.0006, .99998, 1, .99936, .99973, 1.00002, 1.00002, 1.00002, 1.00026, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1, .99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, .99977, .99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, .99977, .99977, .99977, .99977, 1.00001, 1.00001, 1.00026, .99973, .99973, .99973, .99973, .99973, .99973, .99982, 1, .99973, .99973, .99973, .99973, 1.0006, 1.0006, 1.0006, 1.0006, .99973, .99973, .99973, .99973, .99973, .99973, .99973, 1.06409, 1.00026, .99973, .99973, .99973, .99973, 1, .99973, 1, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, .99977, 1, .99977, 1, .99977, 1, .99977, 1, .99977, 1.04596, .99977, .99973, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, 1.00001, .99973, 1.00022, .99973, 1.00022, .99973, 1.00022, .99973, 1.00022, .99973, .99977, .99973, .99977, .99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, .99924, 1.0006, 1.0006, 1.00019, 1.00034, 1, .99924, 1.00001, 1, 1, .99973, .99924, .99973, .99924, .99973, 1.02572, .99973, 1.00005, .99973, .99924, .99977, .99973, .99977, .99973, .99977, .99973, .99999, .9998, .99973, 1.00022, .99973, 1.00022, .99973, 1.00022, .99973, 1, 1.00016, .99977, .99998, .99977, .99998, .99977, .99998, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00026, 1.0006, 1.00026, .84533, 1.00026, 1.0006, .99977, .99973, .99977, .99973, .99977, .99973, .99977, .99973, .99977, .99973, .99977, .99973, 1.00016, .99977, 1.00001, 1, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, .99924, .99973, 1.00001, .99973, 1, .99982, 1.00022, 1.00026, 1.00001, 1, 1.00026, 1.0006, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99998, .99928, 1, .99977, 1.00013, 1.00055, .99947, .99945, .99941, .99924, 1.00001, 1.00001, 1.0004, .91621, 1.00001, 1.00026, .99977, 1.00022, 1.0006, 1.00001, 1.00005, .99999, .99977, 1.00015, 1.00022, .99977, 1.00001, .99973, 1.00026, 1.00001, 1.00019, 1.00001, .99946, 1, 1.0006, 1.00001, .99978, 1.00045, .99973, .99924, 1.00023, .99978, .99966, 1, 1.00065, 1.00045, 1.00019, .99973, .99973, .99924, 1, 1, .96499, 1, 1.00055, .99973, 1.00008, 1.00027, 1, .9997, .99995, 1.00023, .99933, 1.00019, 1.00015, 1.00031, .99924, 1.00023, .99973, 1.00023, 1.00031, 1.00001, .99928, 1.00029, 1.00092, 1.00035, 1.00001, 1.0006, 1.0006, 1, .99988, .99975, 1, 1.00082, .99561, .9996, 1.00035, 1.00001, .99962, 1.00001, 1.00092, .99964, 1.00001, .99963, .99999, 1.00035, 1.00035, 1.00082, .99962, .99999, .99977, 1.00022, 1.00035, 1.00001, .99977, 1.00026, .9996, .99967, 1.00001, 1.00034, 1.00074, 1.00054, 1.00053, 1.00063, .99971, .99962, 1.00035, .99975, .99977, .99973, 1.00043, .99953, 1.0007, .99915, .99973, 1.00008, .99892, 1.00073, 1.00073, 1.00114, .99915, 1.00073, .99955, .99973, 1.00092, .99973, 1, .99998, 1, 1.0003, 1, 1.00043, 1.00001, .99969, 1.0003, 1, 1.00035, 1.00001, .9995, 1, 1.00092, .99973, .99973, .99973, 1.0007, .9995, 1, .99924, 1.0006, .99924, .99972, 1.00062, .99973, 1.00114, 1.00073, 1, .99955, 1, 1, 1.00047, .99968, 1.00016, .99977, 1.00016, .99977, 1.00016, .99977, 1.00001, 1, 1, 1, .99973, 1, 1, .99955, .99924, .99924, .99924, .99924, .99998, .99998, .99998, .99973, .99973, .99972, 1, 1, 1.00267, .99999, .99998, .99998, 1, .99998, 1.66475, 1, .99973, .99973, 1.00023, .99973, .99971, .99925, 1.00023, 1, .99991, .99984, 1.00002, 1.00002, 1.00002, 1.00002, 1, 1, 1, 1, 1, 1, 1, .96329, 1, 1.20985, 1.39713, 1.00003, .8254, 1.00015, 1, 1.00035, 1.00027, 1.00031, 1.00031, .99915, 1.00031, 1.00031, .99999, 1.00003, .99999, .99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, .99999, 1, .99861, .99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, .95317, .99999, .99999, .99999, .99999, 1.40483, 1, .99977, 1.00054, 1, 1, .99953, .99962, 1.00042, .9995, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  Ta = {
    lineHeight: 1.2,
    lineGap: .2
  },
  qa = [365, 0, 333, 278, 333, 474, 556, 556, 889, 722, 238, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 333, 333, 584, 584, 584, 611, 975, 722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 333, 278, 333, 584, 556, 333, 556, 611, 556, 611, 556, 333, 611, 611, 278, 278, 556, 278, 889, 611, 611, 611, 611, 389, 556, 333, 611, 556, 778, 556, 556, 500, 389, 280, 389, 584, 333, 556, 556, 556, 556, 280, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 556, 278, 333, 333, 365, 556, 834, 834, 834, 611, 722, 722, 722, 722, 722, 722, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 556, 556, 556, 556, 556, 278, 278, 278, 278, 611, 611, 611, 611, 611, 611, 611, 549, 611, 611, 611, 611, 611, 556, 611, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 719, 722, 611, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 611, 778, 611, 778, 611, 778, 611, 722, 611, 722, 611, 278, 278, 278, 278, 278, 278, 278, 278, 278, 278, 785, 556, 556, 278, 722, 556, 556, 611, 278, 611, 278, 611, 385, 611, 479, 611, 278, 722, 611, 722, 611, 722, 611, 708, 723, 611, 778, 611, 778, 611, 778, 611, 1e3, 944, 722, 389, 722, 389, 722, 389, 667, 556, 667, 556, 667, 556, 667, 556, 611, 333, 611, 479, 611, 333, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 944, 778, 667, 556, 667, 611, 500, 611, 500, 611, 500, 278, 556, 722, 556, 1e3, 889, 778, 611, 667, 556, 611, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 465, 722, 333, 853, 906, 474, 825, 927, 838, 278, 722, 722, 601, 719, 667, 611, 722, 778, 278, 722, 667, 833, 722, 644, 778, 722, 667, 600, 611, 667, 821, 667, 809, 802, 278, 667, 615, 451, 611, 278, 582, 615, 610, 556, 606, 475, 460, 611, 541, 278, 558, 556, 612, 556, 445, 611, 766, 619, 520, 684, 446, 582, 715, 576, 753, 845, 278, 582, 611, 582, 845, 667, 669, 885, 567, 711, 667, 278, 276, 556, 1094, 1062, 875, 610, 722, 622, 719, 722, 719, 722, 567, 712, 667, 904, 626, 719, 719, 610, 702, 833, 722, 778, 719, 667, 722, 611, 622, 854, 667, 730, 703, 1005, 1019, 870, 979, 719, 711, 1031, 719, 556, 618, 615, 417, 635, 556, 709, 497, 615, 615, 500, 635, 740, 604, 611, 604, 611, 556, 490, 556, 875, 556, 615, 581, 833, 844, 729, 854, 615, 552, 854, 583, 556, 556, 611, 417, 552, 556, 278, 281, 278, 969, 906, 611, 500, 615, 556, 604, 778, 611, 487, 447, 944, 778, 944, 778, 944, 778, 667, 556, 333, 333, 556, 1e3, 1e3, 552, 278, 278, 278, 278, 500, 500, 500, 556, 556, 350, 1e3, 1e3, 240, 479, 333, 333, 604, 333, 167, 396, 556, 556, 1094, 556, 885, 489, 1115, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 722, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 611, 611, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 333, 333, 333, 333, 333, 333, 333, 333],
  Oa = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  Pa = [365, 0, 333, 278, 333, 474, 556, 556, 889, 722, 238, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 333, 333, 584, 584, 584, 611, 975, 722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 333, 278, 333, 584, 556, 333, 556, 611, 556, 611, 556, 333, 611, 611, 278, 278, 556, 278, 889, 611, 611, 611, 611, 389, 556, 333, 611, 556, 778, 556, 556, 500, 389, 280, 389, 584, 333, 556, 556, 556, 556, 280, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 556, 278, 333, 333, 365, 556, 834, 834, 834, 611, 722, 722, 722, 722, 722, 722, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 556, 556, 556, 556, 556, 278, 278, 278, 278, 611, 611, 611, 611, 611, 611, 611, 549, 611, 611, 611, 611, 611, 556, 611, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 740, 722, 611, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 611, 778, 611, 778, 611, 778, 611, 722, 611, 722, 611, 278, 278, 278, 278, 278, 278, 278, 278, 278, 278, 782, 556, 556, 278, 722, 556, 556, 611, 278, 611, 278, 611, 396, 611, 479, 611, 278, 722, 611, 722, 611, 722, 611, 708, 723, 611, 778, 611, 778, 611, 778, 611, 1e3, 944, 722, 389, 722, 389, 722, 389, 667, 556, 667, 556, 667, 556, 667, 556, 611, 333, 611, 479, 611, 333, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 944, 778, 667, 556, 667, 611, 500, 611, 500, 611, 500, 278, 556, 722, 556, 1e3, 889, 778, 611, 667, 556, 611, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 722, 333, 854, 906, 473, 844, 930, 847, 278, 722, 722, 610, 671, 667, 611, 722, 778, 278, 722, 667, 833, 722, 657, 778, 718, 667, 590, 611, 667, 822, 667, 829, 781, 278, 667, 620, 479, 611, 278, 591, 620, 621, 556, 610, 479, 492, 611, 558, 278, 566, 556, 603, 556, 450, 611, 712, 605, 532, 664, 409, 591, 704, 578, 773, 834, 278, 591, 611, 591, 834, 667, 667, 886, 614, 719, 667, 278, 278, 556, 1094, 1042, 854, 622, 719, 677, 719, 722, 708, 722, 614, 722, 667, 927, 643, 719, 719, 615, 687, 833, 722, 778, 719, 667, 722, 611, 677, 781, 667, 729, 708, 979, 989, 854, 1e3, 708, 719, 1042, 729, 556, 619, 604, 534, 618, 556, 736, 510, 611, 611, 507, 622, 740, 604, 611, 611, 611, 556, 889, 556, 885, 556, 646, 583, 889, 935, 707, 854, 594, 552, 865, 589, 556, 556, 611, 469, 563, 556, 278, 278, 278, 969, 906, 611, 507, 619, 556, 611, 778, 611, 575, 467, 944, 778, 944, 778, 944, 778, 667, 556, 333, 333, 556, 1e3, 1e3, 552, 278, 278, 278, 278, 500, 500, 500, 556, 556, 350, 1e3, 1e3, 240, 479, 333, 333, 604, 333, 167, 396, 556, 556, 1104, 556, 885, 516, 1146, 1e3, 768, 600, 834, 834, 834, 834, 999, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 722, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 611, 611, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 333, 333, 333, 333, 333, 333, 333, 333],
  Wa = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  ja = [365, 0, 333, 278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584, 584, 556, 1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278, 278, 278, 469, 556, 333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222, 500, 222, 833, 556, 556, 556, 556, 333, 500, 278, 556, 500, 722, 500, 500, 500, 334, 260, 334, 584, 333, 556, 556, 556, 556, 260, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 537, 278, 333, 333, 365, 556, 834, 834, 834, 611, 667, 667, 667, 667, 667, 667, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 500, 556, 556, 556, 556, 278, 278, 278, 278, 556, 556, 556, 556, 556, 556, 556, 549, 611, 556, 556, 556, 556, 500, 556, 500, 667, 556, 667, 556, 667, 556, 722, 500, 722, 500, 722, 500, 722, 500, 722, 625, 722, 556, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 556, 778, 556, 778, 556, 778, 556, 722, 556, 722, 556, 278, 278, 278, 278, 278, 278, 278, 222, 278, 278, 733, 444, 500, 222, 667, 500, 500, 556, 222, 556, 222, 556, 281, 556, 400, 556, 222, 722, 556, 722, 556, 722, 556, 615, 723, 556, 778, 556, 778, 556, 778, 556, 1e3, 944, 722, 333, 722, 333, 722, 333, 667, 500, 667, 500, 667, 500, 667, 500, 611, 278, 611, 354, 611, 278, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 944, 722, 667, 500, 667, 611, 500, 611, 500, 611, 500, 222, 556, 667, 556, 1e3, 889, 778, 611, 667, 500, 611, 278, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 667, 278, 789, 846, 389, 794, 865, 775, 222, 667, 667, 570, 671, 667, 611, 722, 778, 278, 667, 667, 833, 722, 648, 778, 725, 667, 600, 611, 667, 837, 667, 831, 761, 278, 667, 570, 439, 555, 222, 550, 570, 571, 500, 556, 439, 463, 555, 542, 222, 500, 492, 548, 500, 447, 556, 670, 573, 486, 603, 374, 550, 652, 546, 728, 779, 222, 550, 556, 550, 779, 667, 667, 843, 544, 708, 667, 278, 278, 500, 1066, 982, 844, 589, 715, 639, 724, 667, 651, 667, 544, 704, 667, 917, 614, 715, 715, 589, 686, 833, 722, 778, 725, 667, 722, 611, 639, 795, 667, 727, 673, 920, 923, 805, 886, 651, 694, 1022, 682, 556, 562, 522, 493, 553, 556, 688, 465, 556, 556, 472, 564, 686, 550, 556, 556, 556, 500, 833, 500, 835, 500, 572, 518, 830, 851, 621, 736, 526, 492, 752, 534, 556, 556, 556, 378, 496, 500, 222, 222, 222, 910, 828, 556, 472, 565, 500, 556, 778, 556, 492, 339, 944, 722, 944, 722, 944, 722, 667, 500, 333, 333, 556, 1e3, 1e3, 552, 222, 222, 222, 222, 333, 333, 333, 556, 556, 350, 1e3, 1e3, 188, 354, 333, 333, 500, 333, 167, 365, 556, 556, 1094, 556, 885, 323, 1083, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 998, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 719, 274, 549, 549, 584, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 500, 500, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 294, 294, 324, 324, 316, 328, 398, 285],
  Xa = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  Za = [365, 0, 333, 278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584, 584, 556, 1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278, 278, 278, 469, 556, 333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222, 500, 222, 833, 556, 556, 556, 556, 333, 500, 278, 556, 500, 722, 500, 500, 500, 334, 260, 334, 584, 333, 556, 556, 556, 556, 260, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 537, 278, 333, 333, 365, 556, 834, 834, 834, 611, 667, 667, 667, 667, 667, 667, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 500, 556, 556, 556, 556, 278, 278, 278, 278, 556, 556, 556, 556, 556, 556, 556, 549, 611, 556, 556, 556, 556, 500, 556, 500, 667, 556, 667, 556, 667, 556, 722, 500, 722, 500, 722, 500, 722, 500, 722, 615, 722, 556, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 556, 778, 556, 778, 556, 778, 556, 722, 556, 722, 556, 278, 278, 278, 278, 278, 278, 278, 222, 278, 278, 735, 444, 500, 222, 667, 500, 500, 556, 222, 556, 222, 556, 292, 556, 334, 556, 222, 722, 556, 722, 556, 722, 556, 604, 723, 556, 778, 556, 778, 556, 778, 556, 1e3, 944, 722, 333, 722, 333, 722, 333, 667, 500, 667, 500, 667, 500, 667, 500, 611, 278, 611, 375, 611, 278, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 944, 722, 667, 500, 667, 611, 500, 611, 500, 611, 500, 222, 556, 667, 556, 1e3, 889, 778, 611, 667, 500, 611, 278, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 667, 278, 784, 838, 384, 774, 855, 752, 222, 667, 667, 551, 668, 667, 611, 722, 778, 278, 667, 668, 833, 722, 650, 778, 722, 667, 618, 611, 667, 798, 667, 835, 748, 278, 667, 578, 446, 556, 222, 547, 578, 575, 500, 557, 446, 441, 556, 556, 222, 500, 500, 576, 500, 448, 556, 690, 569, 482, 617, 395, 547, 648, 525, 713, 781, 222, 547, 556, 547, 781, 667, 667, 865, 542, 719, 667, 278, 278, 500, 1057, 1010, 854, 583, 722, 635, 719, 667, 656, 667, 542, 677, 667, 923, 604, 719, 719, 583, 656, 833, 722, 778, 719, 667, 722, 611, 635, 760, 667, 740, 667, 917, 938, 792, 885, 656, 719, 1010, 722, 556, 573, 531, 365, 583, 556, 669, 458, 559, 559, 438, 583, 688, 552, 556, 542, 556, 500, 458, 500, 823, 500, 573, 521, 802, 823, 625, 719, 521, 510, 750, 542, 556, 556, 556, 365, 510, 500, 222, 278, 222, 906, 812, 556, 438, 559, 500, 552, 778, 556, 489, 411, 944, 722, 944, 722, 944, 722, 667, 500, 333, 333, 556, 1e3, 1e3, 552, 222, 222, 222, 222, 333, 333, 333, 556, 556, 350, 1e3, 1e3, 188, 354, 333, 333, 500, 333, 167, 365, 556, 556, 1094, 556, 885, 323, 1073, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 719, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 500, 500, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 294, 294, 324, 324, 316, 328, 398, 285],
  Va = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  za = [1.36898, 1, 1, .72706, .80479, .83734, .98894, .99793, .9897, .93884, .86209, .94292, .94292, 1.16661, 1.02058, .93582, .96694, .93582, 1.19137, .99793, .99793, .99793, .99793, .99793, .99793, .99793, .99793, .99793, .99793, .78076, .78076, 1.02058, 1.02058, 1.02058, .72851, .78966, .90838, .83637, .82391, .96376, .80061, .86275, .8768, .95407, 1.0258, .73901, .85022, .83655, 1.0156, .95546, .92179, .87107, .92179, .82114, .8096, .89713, .94438, .95353, .94083, .91905, .90406, .9446, .94292, 1.18777, .94292, 1.02058, .89903, .90088, .94938, .97898, .81093, .97571, .94938, 1.024, .9577, .95933, .98621, 1.0474, .97455, .98981, .9672, .95933, .9446, .97898, .97407, .97646, .78036, 1.10208, .95442, .95298, .97579, .9332, .94039, .938, .80687, 1.01149, .80687, 1.02058, .80479, .99793, .99793, .99793, .99793, 1.01149, 1.00872, .90088, .91882, 1.0213, .8361, 1.02058, .62295, .54324, .89022, 1.08595, 1, 1, .90088, 1, .97455, .93582, .90088, 1, 1.05686, .8361, .99642, .99642, .99642, .72851, .90838, .90838, .90838, .90838, .90838, .90838, .868, .82391, .80061, .80061, .80061, .80061, 1.0258, 1.0258, 1.0258, 1.0258, .97484, .95546, .92179, .92179, .92179, .92179, .92179, 1.02058, .92179, .94438, .94438, .94438, .94438, .90406, .86958, .98225, .94938, .94938, .94938, .94938, .94938, .94938, .9031, .81093, .94938, .94938, .94938, .94938, .98621, .98621, .98621, .98621, .93969, .95933, .9446, .9446, .9446, .9446, .9446, 1.08595, .9446, .95442, .95442, .95442, .95442, .94039, .97898, .94039, .90838, .94938, .90838, .94938, .90838, .94938, .82391, .81093, .82391, .81093, .82391, .81093, .82391, .81093, .96376, .84313, .97484, .97571, .80061, .94938, .80061, .94938, .80061, .94938, .80061, .94938, .80061, .94938, .8768, .9577, .8768, .9577, .8768, .9577, 1, 1, .95407, .95933, .97069, .95933, 1.0258, .98621, 1.0258, .98621, 1.0258, .98621, 1.0258, .98621, 1.0258, .98621, .887, 1.01591, .73901, 1.0474, 1, 1, .97455, .83655, .98981, 1, 1, .83655, .73977, .83655, .73903, .84638, 1.033, .95546, .95933, 1, 1, .95546, .95933, .8271, .95417, .95933, .92179, .9446, .92179, .9446, .92179, .9446, .936, .91964, .82114, .97646, 1, 1, .82114, .97646, .8096, .78036, .8096, .78036, 1, 1, .8096, .78036, 1, 1, .89713, .77452, .89713, 1.10208, .94438, .95442, .94438, .95442, .94438, .95442, .94438, .95442, .94438, .95442, .94438, .95442, .94083, .97579, .90406, .94039, .90406, .9446, .938, .9446, .938, .9446, .938, 1, .99793, .90838, .94938, .868, .9031, .92179, .9446, 1, 1, .89713, 1.10208, .90088, .90088, .90088, .90088, .90088, .90088, .90088, .90088, .90088, .90989, .9358, .91945, .83181, .75261, .87992, .82976, .96034, .83689, .97268, 1.0078, .90838, .83637, .8019, .90157, .80061, .9446, .95407, .92436, 1.0258, .85022, .97153, 1.0156, .95546, .89192, .92179, .92361, .87107, .96318, .89713, .93704, .95638, .91905, .91709, .92796, 1.0258, .93704, .94836, 1.0373, .95933, 1.0078, .95871, .94836, .96174, .92601, .9498, .98607, .95776, .95933, 1.05453, 1.0078, .98275, .9314, .95617, .91701, 1.05993, .9446, .78367, .9553, 1, .86832, 1.0128, .95871, .99394, .87548, .96361, .86774, 1.0078, .95871, .9446, .95871, .86774, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .94083, .97579, .94083, .97579, .94083, .97579, .90406, .94039, .96694, 1, .89903, 1, 1, 1, .93582, .93582, .93582, 1, .908, .908, .918, .94219, .94219, .96544, 1, 1.285, 1, 1, .81079, .81079, 1, 1, .74854, 1, 1, 1, 1, .99793, 1, 1, 1, .65, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.17173, 1, .80535, .76169, 1.02058, 1.0732, 1.05486, 1, 1, 1.30692, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.16161, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  _a = {
    lineHeight: 1.2,
    lineGap: .2
  },
  $a = [1.36898, 1, 1, .66227, .80779, .81625, .97276, .97276, .97733, .92222, .83266, .94292, .94292, 1.16148, 1.02058, .93582, .96694, .93582, 1.17337, .97276, .97276, .97276, .97276, .97276, .97276, .97276, .97276, .97276, .97276, .78076, .78076, 1.02058, 1.02058, 1.02058, .71541, .76813, .85576, .80591, .80729, .94299, .77512, .83655, .86523, .92222, .98621, .71743, .81698, .79726, .98558, .92222, .90637, .83809, .90637, .80729, .76463, .86275, .90699, .91605, .9154, .85308, .85458, .90531, .94292, 1.21296, .94292, 1.02058, .89903, 1.18616, .99613, .91677, .78216, .91677, .90083, .98796, .9135, .92168, .95381, .98981, .95298, .95381, .93459, .92168, .91513, .92004, .91677, .95077, .748, 1.04502, .91677, .92061, .94236, .89544, .89364, .9, .80687, .8578, .80687, 1.02058, .80779, .97276, .97276, .97276, .97276, .8578, .99973, 1.18616, .91339, 1.08074, .82891, 1.02058, .55509, .71526, .89022, 1.08595, 1, 1, 1.18616, 1, .96736, .93582, 1.18616, 1, 1.04864, .82711, .99043, .99043, .99043, .71541, .85576, .85576, .85576, .85576, .85576, .85576, .845, .80729, .77512, .77512, .77512, .77512, .98621, .98621, .98621, .98621, .95961, .92222, .90637, .90637, .90637, .90637, .90637, 1.02058, .90251, .90699, .90699, .90699, .90699, .85458, .83659, .94951, .99613, .99613, .99613, .99613, .99613, .99613, .85811, .78216, .90083, .90083, .90083, .90083, .95381, .95381, .95381, .95381, .9135, .92168, .91513, .91513, .91513, .91513, .91513, 1.08595, .91677, .91677, .91677, .91677, .91677, .89364, .92332, .89364, .85576, .99613, .85576, .99613, .85576, .99613, .80729, .78216, .80729, .78216, .80729, .78216, .80729, .78216, .94299, .76783, .95961, .91677, .77512, .90083, .77512, .90083, .77512, .90083, .77512, .90083, .77512, .90083, .86523, .9135, .86523, .9135, .86523, .9135, 1, 1, .92222, .92168, .92222, .92168, .98621, .95381, .98621, .95381, .98621, .95381, .98621, .95381, .98621, .95381, .86036, .97096, .71743, .98981, 1, 1, .95298, .79726, .95381, 1, 1, .79726, .6894, .79726, .74321, .81691, 1.0006, .92222, .92168, 1, 1, .92222, .92168, .79464, .92098, .92168, .90637, .91513, .90637, .91513, .90637, .91513, .909, .87514, .80729, .95077, 1, 1, .80729, .95077, .76463, .748, .76463, .748, 1, 1, .76463, .748, 1, 1, .86275, .72651, .86275, 1.04502, .90699, .91677, .90699, .91677, .90699, .91677, .90699, .91677, .90699, .91677, .90699, .91677, .9154, .94236, .85458, .89364, .85458, .90531, .9, .90531, .9, .90531, .9, 1, .97276, .85576, .99613, .845, .85811, .90251, .91677, 1, 1, .86275, 1.04502, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.00899, 1.30628, .85576, .80178, .66862, .7927, .69323, .88127, .72459, .89711, .95381, .85576, .80591, .7805, .94729, .77512, .90531, .92222, .90637, .98621, .81698, .92655, .98558, .92222, .85359, .90637, .90976, .83809, .94523, .86275, .83509, .93157, .85308, .83392, .92346, .98621, .83509, .92886, .91324, .92168, .95381, .90646, .92886, .90557, .86847, .90276, .91324, .86842, .92168, .99531, .95381, .9224, .85408, .92699, .86847, 1.0051, .91513, .80487, .93481, 1, .88159, 1.05214, .90646, .97355, .81539, .89398, .85923, .95381, .90646, .91513, .90646, .85923, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .9154, .94236, .9154, .94236, .9154, .94236, .85458, .89364, .96694, 1, .89903, 1, 1, 1, .91782, .91782, .91782, 1, .896, .896, .896, .9332, .9332, .95973, 1, 1.26, 1, 1, .80479, .80178, 1, 1, .85633, 1, 1, 1, 1, .97276, 1, 1, 1, .698, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.14542, 1, .79199, .78694, 1.02058, 1.03493, 1.05486, 1, 1, 1.23026, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.20006, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  As = {
    lineHeight: 1.2,
    lineGap: .2
  },
  es = [1.36898, 1, 1, .65507, .84943, .85639, .88465, .88465, .86936, .88307, .86948, .85283, .85283, 1.06383, 1.02058, .75945, .9219, .75945, 1.17337, .88465, .88465, .88465, .88465, .88465, .88465, .88465, .88465, .88465, .88465, .75945, .75945, 1.02058, 1.02058, 1.02058, .69046, .70926, .85158, .77812, .76852, .89591, .70466, .76125, .80094, .86822, .83864, .728, .77212, .79475, .93637, .87514, .8588, .76013, .8588, .72421, .69866, .77598, .85991, .80811, .87832, .78112, .77512, .8562, 1.0222, 1.18417, 1.0222, 1.27014, .89903, 1.15012, .93859, .94399, .846, .94399, .81453, 1.0186, .94219, .96017, 1.03075, 1.02175, .912, 1.03075, .96998, .96017, .93859, .94399, .94399, .95493, .746, 1.12658, .94578, .91, .979, .882, .882, .83, .85034, .83537, .85034, 1.02058, .70869, .88465, .88465, .88465, .88465, .83537, .90083, 1.15012, .9161, .94565, .73541, 1.02058, .53609, .69353, .79519, 1.08595, 1, 1, 1.15012, 1, .91974, .75945, 1.15012, 1, .9446, .73361, .9005, .9005, .9005, .62864, .85158, .85158, .85158, .85158, .85158, .85158, .773, .76852, .70466, .70466, .70466, .70466, .83864, .83864, .83864, .83864, .90561, .87514, .8588, .8588, .8588, .8588, .8588, 1.02058, .85751, .85991, .85991, .85991, .85991, .77512, .76013, .88075, .93859, .93859, .93859, .93859, .93859, .93859, .8075, .846, .81453, .81453, .81453, .81453, .82424, .82424, .82424, .82424, .9278, .96017, .93859, .93859, .93859, .93859, .93859, 1.08595, .8562, .94578, .94578, .94578, .94578, .882, .94578, .882, .85158, .93859, .85158, .93859, .85158, .93859, .76852, .846, .76852, .846, .76852, .846, .76852, .846, .89591, .8544, .90561, .94399, .70466, .81453, .70466, .81453, .70466, .81453, .70466, .81453, .70466, .81453, .80094, .94219, .80094, .94219, .80094, .94219, 1, 1, .86822, .96017, .86822, .96017, .83864, .82424, .83864, .82424, .83864, .82424, .83864, 1.03075, .83864, .82424, .81402, 1.02738, .728, 1.02175, 1, 1, .912, .79475, 1.03075, 1, 1, .79475, .83911, .79475, .66266, .80553, 1.06676, .87514, .96017, 1, 1, .87514, .96017, .86865, .87396, .96017, .8588, .93859, .8588, .93859, .8588, .93859, .867, .84759, .72421, .95493, 1, 1, .72421, .95493, .69866, .746, .69866, .746, 1, 1, .69866, .746, 1, 1, .77598, .88417, .77598, 1.12658, .85991, .94578, .85991, .94578, .85991, .94578, .85991, .94578, .85991, .94578, .85991, .94578, .87832, .979, .77512, .882, .77512, .8562, .83, .8562, .83, .8562, .83, 1, .88465, .85158, .93859, .773, .8075, .85751, .8562, 1, 1, .77598, 1.12658, 1.15012, 1.15012, 1.15012, 1.15012, 1.15012, 1.15313, 1.15012, 1.15012, 1.15012, 1.08106, 1.03901, .85158, .77025, .62264, .7646, .65351, .86026, .69461, .89947, 1.03075, .85158, .77812, .76449, .88836, .70466, .8562, .86822, .8588, .83864, .77212, .85308, .93637, .87514, .82352, .8588, .85701, .76013, .89058, .77598, .8156, .82565, .78112, .77899, .89386, .83864, .8156, .9486, .92388, .96186, 1.03075, .91123, .9486, .93298, .878, .93942, .92388, .84596, .96186, .95119, 1.03075, .922, .88787, .95829, .88, .93559, .93859, .78815, .93758, 1, .89217, 1.03737, .91123, .93969, .77487, .85769, .86799, 1.03075, .91123, .93859, .91123, .86799, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .87832, .979, .87832, .979, .87832, .979, .77512, .882, .9219, 1, .89903, 1, 1, 1, .87321, .87321, .87321, 1, 1.027, 1.027, 1.027, .86847, .86847, .79121, 1, 1.124, 1, 1, .73572, .73572, 1, 1, .85034, 1, 1, 1, 1, .88465, 1, 1, 1, .669, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.04828, 1, .74948, .75187, 1.02058, .98391, 1.02119, 1, 1, 1.06233, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05233, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  ts = {
    lineHeight: 1.2,
    lineGap: .2
  },
  is = [1.36898, 1, 1, .76305, .82784, .94935, .89364, .92241, .89073, .90706, .98472, .85283, .85283, 1.0664, 1.02058, .74505, .9219, .74505, 1.23456, .92241, .92241, .92241, .92241, .92241, .92241, .92241, .92241, .92241, .92241, .74505, .74505, 1.02058, 1.02058, 1.02058, .73002, .72601, .91755, .8126, .80314, .92222, .73764, .79726, .83051, .90284, .86023, .74, .8126, .84869, .96518, .91115, .8858, .79761, .8858, .74498, .73914, .81363, .89591, .83659, .89633, .85608, .8111, .90531, 1.0222, 1.22736, 1.0222, 1.27014, .89903, .90088, .86667, 1.0231, .896, 1.01411, .90083, 1.05099, 1.00512, .99793, 1.05326, 1.09377, .938, 1.06226, 1.00119, .99793, .98714, 1.0231, 1.01231, .98196, .792, 1.19137, .99074, .962, 1.01915, .926, .942, .856, .85034, .92006, .85034, 1.02058, .69067, .92241, .92241, .92241, .92241, .92006, .9332, .90088, .91882, .93484, .75339, 1.02058, .56866, .54324, .79519, 1.08595, 1, 1, .90088, 1, .95325, .74505, .90088, 1, .97198, .75339, .91009, .91009, .91009, .66466, .91755, .91755, .91755, .91755, .91755, .91755, .788, .80314, .73764, .73764, .73764, .73764, .86023, .86023, .86023, .86023, .92915, .91115, .8858, .8858, .8858, .8858, .8858, 1.02058, .8858, .89591, .89591, .89591, .89591, .8111, .79611, .89713, .86667, .86667, .86667, .86667, .86667, .86667, .86936, .896, .90083, .90083, .90083, .90083, .84224, .84224, .84224, .84224, .97276, .99793, .98714, .98714, .98714, .98714, .98714, 1.08595, .89876, .99074, .99074, .99074, .99074, .942, 1.0231, .942, .91755, .86667, .91755, .86667, .91755, .86667, .80314, .896, .80314, .896, .80314, .896, .80314, .896, .92222, .93372, .92915, 1.01411, .73764, .90083, .73764, .90083, .73764, .90083, .73764, .90083, .73764, .90083, .83051, 1.00512, .83051, 1.00512, .83051, 1.00512, 1, 1, .90284, .99793, .90976, .99793, .86023, .84224, .86023, .84224, .86023, .84224, .86023, 1.05326, .86023, .84224, .82873, 1.07469, .74, 1.09377, 1, 1, .938, .84869, 1.06226, 1, 1, .84869, .83704, .84869, .81441, .85588, 1.08927, .91115, .99793, 1, 1, .91115, .99793, .91887, .90991, .99793, .8858, .98714, .8858, .98714, .8858, .98714, .894, .91434, .74498, .98196, 1, 1, .74498, .98196, .73914, .792, .73914, .792, 1, 1, .73914, .792, 1, 1, .81363, .904, .81363, 1.19137, .89591, .99074, .89591, .99074, .89591, .99074, .89591, .99074, .89591, .99074, .89591, .99074, .89633, 1.01915, .8111, .942, .8111, .90531, .856, .90531, .856, .90531, .856, 1, .92241, .91755, .86667, .788, .86936, .8858, .89876, 1, 1, .81363, 1.19137, .90088, .90088, .90088, .90088, .90088, .90088, .90088, .90088, .90088, .90388, 1.03901, .92138, .78105, .7154, .86169, .80513, .94007, .82528, .98612, 1.06226, .91755, .8126, .81884, .92819, .73764, .90531, .90284, .8858, .86023, .8126, .91172, .96518, .91115, .83089, .8858, .87791, .79761, .89297, .81363, .88157, .89992, .85608, .81992, .94307, .86023, .88157, .95308, .98699, .99793, 1.06226, .95817, .95308, .97358, .928, .98088, .98699, .92761, .99793, .96017, 1.06226, .986, .944, .95978, .938, .96705, .98714, .80442, .98972, 1, .89762, 1.04552, .95817, .99007, .87064, .91879, .88888, 1.06226, .95817, .98714, .95817, .88888, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .89633, 1.01915, .89633, 1.01915, .89633, 1.01915, .8111, .942, .9219, 1, .89903, 1, 1, 1, .93173, .93173, .93173, 1, 1.06304, 1.06304, 1.06904, .89903, .89903, .80549, 1, 1.156, 1, 1, .76575, .76575, 1, 1, .72458, 1, 1, 1, 1, .92241, 1, 1, 1, .619, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.07257, 1, .74705, .71119, 1.02058, 1.024, 1.02119, 1, 1, 1.1536, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05638, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  as = {
    lineHeight: 1.2,
    lineGap: .2
  },
  ss = [1.76738, 1, 1, .99297, .9824, 1.04016, 1.06497, 1.03424, .97529, 1.17647, 1.23203, 1.1085, 1.1085, 1.16939, 1.2107, .9754, 1.21408, .9754, 1.59578, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, .81378, .81378, 1.2107, 1.2107, 1.2107, .71703, .97847, .97363, .88776, .8641, 1.02096, .79795, .85132, .914, 1.06085, 1.1406, .8007, .89858, .83693, 1.14889, 1.09398, .97489, .92094, .97489, .90399, .84041, .95923, 1.00135, 1, 1.06467, .98243, .90996, .99361, 1.1085, 1.56942, 1.1085, 1.2107, .74627, .94282, .96752, 1.01519, .86304, 1.01359, .97278, 1.15103, 1.01359, .98561, 1.02285, 1.02285, 1.00527, 1.02285, 1.0302, .99041, 1.0008, 1.01519, 1.01359, 1.02258, .79104, 1.16862, .99041, .97454, 1.02511, .99298, .96752, .95801, .94856, 1.16579, .94856, 1.2107, .9824, 1.03424, 1.03424, 1, 1.03424, 1.16579, .8727, 1.3871, 1.18622, 1.10818, 1.04478, 1.2107, 1.18622, .75155, .94994, 1.28826, 1.21408, 1.21408, .91056, 1, .91572, .9754, .64663, 1.18328, 1.24866, 1.04478, 1.14169, 1.15749, 1.17389, .71703, .97363, .97363, .97363, .97363, .97363, .97363, .93506, .8641, .79795, .79795, .79795, .79795, 1.1406, 1.1406, 1.1406, 1.1406, 1.02096, 1.09398, .97426, .97426, .97426, .97426, .97426, 1.2107, .97489, 1.00135, 1.00135, 1.00135, 1.00135, .90996, .92094, 1.02798, .96752, .96752, .96752, .96752, .96752, .96752, .93136, .86304, .97278, .97278, .97278, .97278, 1.02285, 1.02285, 1.02285, 1.02285, .97122, .99041, 1, 1, 1, 1, 1, 1.28826, 1.0008, .99041, .99041, .99041, .99041, .96752, 1.01519, .96752, .97363, .96752, .97363, .96752, .97363, .96752, .8641, .86304, .8641, .86304, .8641, .86304, .8641, .86304, 1.02096, 1.03057, 1.02096, 1.03517, .79795, .97278, .79795, .97278, .79795, .97278, .79795, .97278, .79795, .97278, .914, 1.01359, .914, 1.01359, .914, 1.01359, 1, 1, 1.06085, .98561, 1.06085, 1.00879, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, .97138, 1.08692, .8007, 1.02285, 1, 1, 1.00527, .83693, 1.02285, 1, 1, .83693, .9455, .83693, .90418, .83693, 1.13005, 1.09398, .99041, 1, 1, 1.09398, .99041, .96692, 1.09251, .99041, .97489, 1.0008, .97489, 1.0008, .97489, 1.0008, .93994, .97931, .90399, 1.02258, 1, 1, .90399, 1.02258, .84041, .79104, .84041, .79104, .84041, .79104, .84041, .79104, 1, 1, .95923, 1.07034, .95923, 1.16862, 1.00135, .99041, 1.00135, .99041, 1.00135, .99041, 1.00135, .99041, 1.00135, .99041, 1.00135, .99041, 1.06467, 1.02511, .90996, .96752, .90996, .99361, .95801, .99361, .95801, .99361, .95801, 1.07733, 1.03424, .97363, .96752, .93506, .93136, .97489, 1.0008, 1, 1, .95923, 1.16862, 1.15103, 1.15103, 1.01173, 1.03959, .75953, .81378, .79912, 1.15103, 1.21994, .95161, .87815, 1.01149, .81525, .7676, .98167, 1.01134, 1.02546, .84097, 1.03089, 1.18102, .97363, .88776, .85134, .97826, .79795, .99361, 1.06085, .97489, 1.1406, .89858, 1.0388, 1.14889, 1.09398, .86039, .97489, 1.0595, .92094, .94793, .95923, .90996, .99346, .98243, 1.02112, .95493, 1.1406, .90996, 1.03574, 1.02597, 1.0008, 1.18102, 1.06628, 1.03574, 1.0192, 1.01932, 1.00886, .97531, 1.0106, 1.0008, 1.13189, 1.18102, 1.02277, .98683, 1.0016, .99561, 1.07237, 1.0008, .90434, .99921, .93803, .8965, 1.23085, 1.06628, 1.04983, .96268, 1.0499, .98439, 1.18102, 1.06628, 1.0008, 1.06628, .98439, .79795, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.09466, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .97278, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.02065, 1, 1, 1, 1, 1, 1, 1.06467, 1.02511, 1.06467, 1.02511, 1.06467, 1.02511, .90996, .96752, 1, 1.21408, .89903, 1, 1, .75155, 1.04394, 1.04394, 1.04394, 1.04394, .98633, .98633, .98633, .73047, .73047, 1.20642, .91211, 1.25635, 1.222, 1.02956, 1.03372, 1.03372, .96039, 1.24633, 1, 1.12454, .93503, 1.03424, 1.19687, 1.03424, 1, 1, 1, .771, 1, 1, 1.15749, 1.15749, 1.15749, 1.10948, .86279, .94434, .86279, .94434, .86182, 1, 1, 1.16897, 1, .96085, .90137, 1.2107, 1.18416, 1.13973, .69825, .9716, 2.10339, 1.29004, 1.29004, 1.21172, 1.29004, 1.29004, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, .99862, .99862, 1, .87025, .87025, .87025, .87025, 1.18874, 1.42603, 1, 1.42603, 1.42603, .99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.09193, 1.09193, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  rs = {
    lineHeight: 1.33008,
    lineGap: 0
  },
  ns = [1.76738, 1, 1, .98946, 1.03959, 1.04016, 1.02809, 1.036, .97639, 1.10953, 1.23203, 1.11144, 1.11144, 1.16939, 1.21237, .9754, 1.21261, .9754, 1.59754, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, .81378, .81378, 1.21237, 1.21237, 1.21237, .73541, .97847, .97363, .89723, .87897, 1.0426, .79429, .85292, .91149, 1.05815, 1.1406, .79631, .90128, .83853, 1.04396, 1.10615, .97552, .94436, .97552, .88641, .80527, .96083, 1.00135, 1, 1.06777, .9817, .91142, .99361, 1.11144, 1.57293, 1.11144, 1.21237, .74627, 1.31818, 1.06585, .97042, .83055, .97042, .93503, 1.1261, .97042, .97922, 1.14236, .94552, 1.01054, 1.14236, 1.02471, .97922, .94165, .97042, .97042, 1.0276, .78929, 1.1261, .97922, .95874, 1.02197, .98507, .96752, .97168, .95107, 1.16579, .95107, 1.21237, 1.03959, 1.036, 1.036, 1, 1.036, 1.16579, .87357, 1.31818, 1.18754, 1.26781, 1.05356, 1.21237, 1.18622, .79487, .94994, 1.29004, 1.24047, 1.24047, 1.31818, 1, .91484, .9754, 1.31818, 1.1349, 1.24866, 1.05356, 1.13934, 1.15574, 1.17389, .73541, .97363, .97363, .97363, .97363, .97363, .97363, .94385, .87897, .79429, .79429, .79429, .79429, 1.1406, 1.1406, 1.1406, 1.1406, 1.0426, 1.10615, .97552, .97552, .97552, .97552, .97552, 1.21237, .97552, 1.00135, 1.00135, 1.00135, 1.00135, .91142, .94436, .98721, 1.06585, 1.06585, 1.06585, 1.06585, 1.06585, 1.06585, .96705, .83055, .93503, .93503, .93503, .93503, 1.14236, 1.14236, 1.14236, 1.14236, .93125, .97922, .94165, .94165, .94165, .94165, .94165, 1.29004, .94165, .97922, .97922, .97922, .97922, .96752, .97042, .96752, .97363, 1.06585, .97363, 1.06585, .97363, 1.06585, .87897, .83055, .87897, .83055, .87897, .83055, .87897, .83055, 1.0426, 1.0033, 1.0426, .97042, .79429, .93503, .79429, .93503, .79429, .93503, .79429, .93503, .79429, .93503, .91149, .97042, .91149, .97042, .91149, .97042, 1, 1, 1.05815, .97922, 1.05815, .97922, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, .97441, 1.04302, .79631, 1.01582, 1, 1, 1.01054, .83853, 1.14236, 1, 1, .83853, 1.09125, .83853, .90418, .83853, 1.19508, 1.10615, .97922, 1, 1, 1.10615, .97922, 1.01034, 1.10466, .97922, .97552, .94165, .97552, .94165, .97552, .94165, .91602, .91981, .88641, 1.0276, 1, 1, .88641, 1.0276, .80527, .78929, .80527, .78929, .80527, .78929, .80527, .78929, 1, 1, .96083, 1.05403, .95923, 1.16862, 1.00135, .97922, 1.00135, .97922, 1.00135, .97922, 1.00135, .97922, 1.00135, .97922, 1.00135, .97922, 1.06777, 1.02197, .91142, .96752, .91142, .99361, .97168, .99361, .97168, .99361, .97168, 1.23199, 1.036, .97363, 1.06585, .94385, .96705, .97552, .94165, 1, 1, .96083, 1.1261, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, .95161, 1.27126, 1.00811, .83284, .77702, .99137, .95253, 1.0347, .86142, 1.07205, 1.14236, .97363, .89723, .86869, 1.09818, .79429, .99361, 1.05815, .97552, 1.1406, .90128, 1.06662, 1.04396, 1.10615, .84918, .97552, 1.04694, .94436, .98015, .96083, .91142, 1.00356, .9817, 1.01945, .98999, 1.1406, .91142, 1.04961, .9898, 1.00639, 1.14236, 1.07514, 1.04961, .99607, 1.02897, 1.008, .9898, .95134, 1.00639, 1.11121, 1.14236, 1.00518, .97981, 1.02186, 1, 1.08578, .94165, .99314, .98387, .93028, .93377, 1.35125, 1.07514, 1.10687, .93491, 1.04232, 1.00351, 1.14236, 1.07514, .94165, 1.07514, 1.00351, .79429, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.09097, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .93503, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .96609, 1, 1, 1, 1, 1, 1, 1.06777, 1.02197, 1.06777, 1.02197, 1.06777, 1.02197, .91142, .96752, 1, 1.21261, .89903, 1, 1, .75155, 1.04745, 1.04745, 1.04745, 1.04394, .98633, .98633, .98633, .72959, .72959, 1.20502, .91406, 1.26514, 1.222, 1.02956, 1.03372, 1.03372, .96039, 1.24633, 1, 1.09125, .93327, 1.03336, 1.16541, 1.036, 1, 1, 1, .771, 1, 1, 1.15574, 1.15574, 1.15574, 1.15574, .86364, .94434, .86279, .94434, .86224, 1, 1, 1.16798, 1, .96085, .90068, 1.21237, 1.18416, 1.13904, .69825, .9716, 2.10339, 1.29004, 1.29004, 1.21339, 1.29004, 1.29004, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, .99862, .99862, 1, .87025, .87025, .87025, .87025, 1.18775, 1.42603, 1, 1.42603, 1.42603, .99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.13269, 1.13269, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  gs = {
    lineHeight: 1.33008,
    lineGap: 0
  },
  os = [1.76738, 1, 1, .98946, 1.14763, 1.05365, 1.06234, .96927, .92586, 1.15373, 1.18414, .91349, .91349, 1.07403, 1.17308, .78383, 1.20088, .78383, 1.42531, .96927, .96927, .96927, .96927, .96927, .96927, .96927, .96927, .96927, .96927, .78383, .78383, 1.17308, 1.17308, 1.17308, .77349, .94565, .94729, .85944, .88506, .9858, .74817, .80016, .88449, .98039, .95782, .69238, .89898, .83231, .98183, 1.03989, .96924, .86237, .96924, .80595, .74524, .86091, .95402, .94143, .98448, .8858, .83089, .93285, 1.0949, 1.39016, 1.0949, 1.45994, .74627, 1.04839, .97454, .97454, .87207, .97454, .87533, 1.06151, .97454, 1.00176, 1.16484, 1.08132, .98047, 1.16484, 1.02989, 1.01054, .96225, .97454, .97454, 1.06598, .79004, 1.16344, 1.00351, .94629, .9973, .91016, .96777, .9043, .91082, .92481, .91082, 1.17308, .95748, .96927, .96927, 1, .96927, .92481, .80597, 1.04839, 1.23393, 1.1781, .9245, 1.17308, 1.20808, .63218, .94261, 1.24822, 1.09971, 1.09971, 1.04839, 1, .85273, .78032, 1.04839, 1.09971, 1.22326, .9245, 1.09836, 1.13525, 1.15222, .70424, .94729, .94729, .94729, .94729, .94729, .94729, .85498, .88506, .74817, .74817, .74817, .74817, .95782, .95782, .95782, .95782, .9858, 1.03989, .96924, .96924, .96924, .96924, .96924, 1.17308, .96924, .95402, .95402, .95402, .95402, .83089, .86237, .88409, .97454, .97454, .97454, .97454, .97454, .97454, .92916, .87207, .87533, .87533, .87533, .87533, .93146, .93146, .93146, .93146, .93854, 1.01054, .96225, .96225, .96225, .96225, .96225, 1.24822, .8761, 1.00351, 1.00351, 1.00351, 1.00351, .96777, .97454, .96777, .94729, .97454, .94729, .97454, .94729, .97454, .88506, .87207, .88506, .87207, .88506, .87207, .88506, .87207, .9858, .95391, .9858, .97454, .74817, .87533, .74817, .87533, .74817, .87533, .74817, .87533, .74817, .87533, .88449, .97454, .88449, .97454, .88449, .97454, 1, 1, .98039, 1.00176, .98039, 1.00176, .95782, .93146, .95782, .93146, .95782, .93146, .95782, 1.16484, .95782, .93146, .84421, 1.12761, .69238, 1.08132, 1, 1, .98047, .83231, 1.16484, 1, 1, .84723, 1.04861, .84723, .78755, .83231, 1.23736, 1.03989, 1.01054, 1, 1, 1.03989, 1.01054, .9857, 1.03849, 1.01054, .96924, .96225, .96924, .96225, .96924, .96225, .92383, .90171, .80595, 1.06598, 1, 1, .80595, 1.06598, .74524, .79004, .74524, .79004, .74524, .79004, .74524, .79004, 1, 1, .86091, 1.02759, .85771, 1.16344, .95402, 1.00351, .95402, 1.00351, .95402, 1.00351, .95402, 1.00351, .95402, 1.00351, .95402, 1.00351, .98448, .9973, .83089, .96777, .83089, .93285, .9043, .93285, .9043, .93285, .9043, 1.31868, .96927, .94729, .97454, .85498, .92916, .96924, .8761, 1, 1, .86091, 1.16344, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, .81965, .81965, .94729, .78032, .71022, .90883, .84171, .99877, .77596, 1.05734, 1.2, .94729, .85944, .82791, .9607, .74817, .93285, .98039, .96924, .95782, .89898, .98316, .98183, 1.03989, .78614, .96924, .97642, .86237, .86075, .86091, .83089, .90082, .8858, .97296, 1.01284, .95782, .83089, 1.0976, 1.04, 1.03342, 1.2, 1.0675, 1.0976, .98205, 1.03809, 1.05097, 1.04, .95364, 1.03342, 1.05401, 1.2, 1.02148, 1.0119, 1.04724, 1.0127, 1.02732, .96225, .8965, .97783, .93574, .94818, 1.30679, 1.0675, 1.11826, .99821, 1.0557, 1.0326, 1.2, 1.0675, .96225, 1.0675, 1.0326, .74817, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.03754, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .87533, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .98705, 1, 1, 1, 1, 1, 1, .98448, .9973, .98448, .9973, .98448, .9973, .83089, .96777, 1, 1.20088, .89903, 1, 1, .75155, .94945, .94945, .94945, .94945, 1.12317, 1.12317, 1.12317, .67603, .67603, 1.15621, .73584, 1.21191, 1.22135, 1.06483, .94868, .94868, .95996, 1.24633, 1, 1.07497, .87709, .96927, 1.01473, .96927, 1, 1, 1, .77295, 1, 1, 1.09836, 1.09836, 1.09836, 1.01522, .86321, .94434, .8649, .94434, .86182, 1, 1, 1.083, 1, .91578, .86438, 1.17308, 1.18416, 1.14589, .69825, .97622, 1.96791, 1.24822, 1.24822, 1.17308, 1.24822, 1.24822, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, .99862, .99862, 1, .87025, .87025, .87025, .87025, 1.17984, 1.42603, 1, 1.42603, 1.42603, .99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.10742, 1.10742, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  Is = {
    lineHeight: 1.33008,
    lineGap: 0
  },
  cs = [1.76738, 1, 1, .98594, 1.02285, 1.10454, 1.06234, .96927, .92037, 1.19985, 1.2046, .90616, .90616, 1.07152, 1.1714, .78032, 1.20088, .78032, 1.40246, .96927, .96927, .96927, .96927, .96927, .96927, .96927, .96927, .96927, .96927, .78032, .78032, 1.1714, 1.1714, 1.1714, .80597, .94084, .96706, .85944, .85734, .97093, .75842, .79936, .88198, .9831, .95782, .71387, .86969, .84636, 1.07796, 1.03584, .96924, .83968, .96924, .82826, .79649, .85771, .95132, .93119, .98965, .88433, .8287, .93365, 1.08612, 1.3638, 1.08612, 1.45786, .74627, .80499, .91484, 1.05707, .92383, 1.05882, .9403, 1.12654, 1.05882, 1.01756, 1.09011, 1.09011, .99414, 1.09011, 1.034, 1.01756, 1.05356, 1.05707, 1.05882, 1.04399, .84863, 1.21968, 1.01756, .95801, 1.00068, .91797, .96777, .9043, .90351, .92105, .90351, 1.1714, .85337, .96927, .96927, .99912, .96927, .92105, .80597, 1.2434, 1.20808, 1.05937, .90957, 1.1714, 1.20808, .75155, .94261, 1.24644, 1.09971, 1.09971, .84751, 1, .85273, .78032, .61584, 1.05425, 1.17914, .90957, 1.08665, 1.11593, 1.14169, .73381, .96706, .96706, .96706, .96706, .96706, .96706, .86035, .85734, .75842, .75842, .75842, .75842, .95782, .95782, .95782, .95782, .97093, 1.03584, .96924, .96924, .96924, .96924, .96924, 1.1714, .96924, .95132, .95132, .95132, .95132, .8287, .83968, .89049, .91484, .91484, .91484, .91484, .91484, .91484, .93575, .92383, .9403, .9403, .9403, .9403, .8717, .8717, .8717, .8717, 1.00527, 1.01756, 1.05356, 1.05356, 1.05356, 1.05356, 1.05356, 1.24644, .95923, 1.01756, 1.01756, 1.01756, 1.01756, .96777, 1.05707, .96777, .96706, .91484, .96706, .91484, .96706, .91484, .85734, .92383, .85734, .92383, .85734, .92383, .85734, .92383, .97093, 1.0969, .97093, 1.05882, .75842, .9403, .75842, .9403, .75842, .9403, .75842, .9403, .75842, .9403, .88198, 1.05882, .88198, 1.05882, .88198, 1.05882, 1, 1, .9831, 1.01756, .9831, 1.01756, .95782, .8717, .95782, .8717, .95782, .8717, .95782, 1.09011, .95782, .8717, .84784, 1.11551, .71387, 1.09011, 1, 1, .99414, .84636, 1.09011, 1, 1, .84636, 1.0536, .84636, .94298, .84636, 1.23297, 1.03584, 1.01756, 1, 1, 1.03584, 1.01756, 1.00323, 1.03444, 1.01756, .96924, 1.05356, .96924, 1.05356, .96924, 1.05356, .93066, .98293, .82826, 1.04399, 1, 1, .82826, 1.04399, .79649, .84863, .79649, .84863, .79649, .84863, .79649, .84863, 1, 1, .85771, 1.17318, .85771, 1.21968, .95132, 1.01756, .95132, 1.01756, .95132, 1.01756, .95132, 1.01756, .95132, 1.01756, .95132, 1.01756, .98965, 1.00068, .8287, .96777, .8287, .93365, .9043, .93365, .9043, .93365, .9043, 1.08571, .96927, .96706, .91484, .86035, .93575, .96924, .95923, 1, 1, .85771, 1.21968, 1.11437, 1.11437, .93109, .91202, .60411, .84164, .55572, 1.01173, .97361, .81818, .81818, .96635, .78032, .72727, .92366, .98601, 1.03405, .77968, 1.09799, 1.2, .96706, .85944, .85638, .96491, .75842, .93365, .9831, .96924, .95782, .86969, .94152, 1.07796, 1.03584, .78437, .96924, .98715, .83968, .83491, .85771, .8287, .94492, .88433, .9287, 1.0098, .95782, .8287, 1.0625, .98248, 1.03424, 1.2, 1.01071, 1.0625, .95246, 1.03809, 1.04912, .98248, 1.00221, 1.03424, 1.05443, 1.2, 1.04785, .99609, 1.00169, 1.05176, .99346, 1.05356, .9087, 1.03004, .95542, .93117, 1.23362, 1.01071, 1.07831, 1.02512, 1.05205, 1.03502, 1.2, 1.01071, 1.05356, 1.01071, 1.03502, .75842, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.03719, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, .9403, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.04021, 1, 1, 1, 1, 1, 1, .98965, 1.00068, .98965, 1.00068, .98965, 1.00068, .8287, .96777, 1, 1.20088, .89903, 1, 1, .75155, 1.03077, 1.03077, 1.03077, 1.03077, 1.13196, 1.13196, 1.13196, .67428, .67428, 1.16039, .73291, 1.20996, 1.22135, 1.06483, .94868, .94868, .95996, 1.24633, 1, 1.07497, .87796, .96927, 1.01518, .96927, 1, 1, 1, .77295, 1, 1, 1.10539, 1.10539, 1.11358, 1.06967, .86279, .94434, .86279, .94434, .86182, 1, 1, 1.083, 1, .91578, .86507, 1.1714, 1.18416, 1.14589, .69825, .97622, 1.9697, 1.24822, 1.24822, 1.17238, 1.24822, 1.24822, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, .99862, .99862, 1, .87025, .87025, .87025, .87025, 1.18083, 1.42603, 1, 1.42603, 1.42603, .99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.10938, 1.10938, 1, 1, 1, 1.05425, 1.09971, 1.09971, 1.09971, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  Cs = {
    lineHeight: 1.33008,
    lineGap: 0
  },
  hs = getLookupTableFactory(function (e) {
    e["MyriadPro-Regular"] = e["PdfJS-Fallback-Regular"] = {
      name: "LiberationSans-Regular",
      factors: is,
      baseWidths: Za,
      baseMapping: Va,
      metrics: as
    };
    e["MyriadPro-Bold"] = e["PdfJS-Fallback-Bold"] = {
      name: "LiberationSans-Bold",
      factors: za,
      baseWidths: qa,
      baseMapping: Oa,
      metrics: _a
    };
    e["MyriadPro-It"] = e["MyriadPro-Italic"] = e["PdfJS-Fallback-Italic"] = {
      name: "LiberationSans-Italic",
      factors: es,
      baseWidths: ja,
      baseMapping: Xa,
      metrics: ts
    };
    e["MyriadPro-BoldIt"] = e["MyriadPro-BoldItalic"] = e["PdfJS-Fallback-BoldItalic"] = {
      name: "LiberationSans-BoldItalic",
      factors: $a,
      baseWidths: Pa,
      baseMapping: Wa,
      metrics: As
    };
    e.ArialMT = e.Arial = e["Arial-Regular"] = {
      name: "LiberationSans-Regular",
      baseWidths: Za,
      baseMapping: Va
    };
    e["Arial-BoldMT"] = e["Arial-Bold"] = {
      name: "LiberationSans-Bold",
      baseWidths: qa,
      baseMapping: Oa
    };
    e["Arial-ItalicMT"] = e["Arial-Italic"] = {
      name: "LiberationSans-Italic",
      baseWidths: ja,
      baseMapping: Xa
    };
    e["Arial-BoldItalicMT"] = e["Arial-BoldItalic"] = {
      name: "LiberationSans-BoldItalic",
      baseWidths: Pa,
      baseMapping: Wa
    };
    e["Calibri-Regular"] = {
      name: "LiberationSans-Regular",
      factors: xa,
      baseWidths: Za,
      baseMapping: Va,
      metrics: Ua
    };
    e["Calibri-Bold"] = {
      name: "LiberationSans-Bold",
      factors: Fa,
      baseWidths: qa,
      baseMapping: Oa,
      metrics: Sa
    };
    e["Calibri-Italic"] = {
      name: "LiberationSans-Italic",
      factors: Na,
      baseWidths: ja,
      baseMapping: Xa,
      metrics: Ga
    };
    e["Calibri-BoldItalic"] = {
      name: "LiberationSans-BoldItalic",
      factors: ka,
      baseWidths: Pa,
      baseMapping: Wa,
      metrics: Ra
    };
    e["Segoeui-Regular"] = {
      name: "LiberationSans-Regular",
      factors: cs,
      baseWidths: Za,
      baseMapping: Va,
      metrics: Cs
    };
    e["Segoeui-Bold"] = {
      name: "LiberationSans-Bold",
      factors: ss,
      baseWidths: qa,
      baseMapping: Oa,
      metrics: rs
    };
    e["Segoeui-Italic"] = {
      name: "LiberationSans-Italic",
      factors: os,
      baseWidths: ja,
      baseMapping: Xa,
      metrics: Is
    };
    e["Segoeui-BoldItalic"] = {
      name: "LiberationSans-BoldItalic",
      factors: ns,
      baseWidths: Pa,
      baseMapping: Wa,
      metrics: gs
    };
    e["Helvetica-Regular"] = e.Helvetica = {
      name: "LiberationSans-Regular",
      factors: Ka,
      baseWidths: Za,
      baseMapping: Va,
      metrics: Ta
    };
    e["Helvetica-Bold"] = {
      name: "LiberationSans-Bold",
      factors: Ma,
      baseWidths: qa,
      baseMapping: Oa,
      metrics: La
    };
    e["Helvetica-Italic"] = {
      name: "LiberationSans-Italic",
      factors: Ya,
      baseWidths: ja,
      baseMapping: Xa,
      metrics: va
    };
    e["Helvetica-BoldItalic"] = {
      name: "LiberationSans-BoldItalic",
      factors: Ha,
      baseWidths: Pa,
      baseMapping: Wa,
      metrics: Ja
    };
  });
function getXfaFontName(e) {
  var t = normalizeFontName(e);
  return hs()[t];
}
function getXfaFontDict(e) {
  var t = function getXfaFontWidths(e) {
      var t = getXfaFontName(e);
      if (!t) return null;
      var i = t.baseWidths,
        a = t.baseMapping,
        s = t.factors,
        r = s ? i.map(function (e, t) {
          return e * s[t];
        }) : i;
      var n,
        g = -2;
      var o = [];
      var _iterator52 = _createForOfIteratorHelper(a.map(function (e, t) {
          return [e, t];
        }).sort(function (_ref53, _ref54) {
          var _ref55 = _slicedToArray(_ref53, 1),
            e = _ref55[0];
          var _ref56 = _slicedToArray(_ref54, 1),
            t = _ref56[0];
          return e - t;
        })),
        _step52;
      try {
        for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
          var _ref51 = _step52.value;
          var _ref52 = _slicedToArray(_ref51, 2);
          var _e263 = _ref52[0];
          var _t185 = _ref52[1];
          if (-1 !== _e263) if (_e263 === g + 1) {
            n.push(r[_t185]);
            g += 1;
          } else {
            g = _e263;
            n = [r[_t185]];
            o.push(_e263, n);
          }
        }
      } catch (err) {
        _iterator52.e(err);
      } finally {
        _iterator52.f();
      }
      return o;
    }(e),
    i = new Dict(null);
  i.set("BaseFont", Name.get(e));
  i.set("Type", Name.get("Font"));
  i.set("Subtype", Name.get("CIDFontType2"));
  i.set("Encoding", Name.get("Identity-H"));
  i.set("CIDToGIDMap", Name.get("Identity"));
  i.set("W", t);
  i.set("FirstChar", t[0]);
  i.set("LastChar", t.at(-2) + t.at(-1).length - 1);
  var a = new Dict(null);
  i.set("FontDescriptor", a);
  var s = new Dict(null);
  s.set("Ordering", "Identity");
  s.set("Registry", "Adobe");
  s.set("Supplement", 0);
  i.set("CIDSystemInfo", s);
  return i;
}
var PostScriptParser = /*#__PURE__*/function () {
  function PostScriptParser(e) {
    _classCallCheck(this, PostScriptParser);
    this.lexer = e;
    this.operators = [];
    this.token = null;
    this.prev = null;
  }
  return _createClass(PostScriptParser, [{
    key: "nextToken",
    value: function nextToken() {
      this.prev = this.token;
      this.token = this.lexer.getToken();
    }
  }, {
    key: "accept",
    value: function accept(e) {
      if (this.token.type === e) {
        this.nextToken();
        return !0;
      }
      return !1;
    }
  }, {
    key: "expect",
    value: function expect(e) {
      if (this.accept(e)) return !0;
      throw new FormatError("Unexpected symbol: found ".concat(this.token.type, " expected ").concat(e, "."));
    }
  }, {
    key: "parse",
    value: function parse() {
      this.nextToken();
      this.expect(ls.LBRACE);
      this.parseBlock();
      this.expect(ls.RBRACE);
      return this.operators;
    }
  }, {
    key: "parseBlock",
    value: function parseBlock() {
      for (;;) if (this.accept(ls.NUMBER)) this.operators.push(this.prev.value);else if (this.accept(ls.OPERATOR)) this.operators.push(this.prev.value);else {
        if (!this.accept(ls.LBRACE)) return;
        this.parseCondition();
      }
    }
  }, {
    key: "parseCondition",
    value: function parseCondition() {
      var e = this.operators.length;
      this.operators.push(null, null);
      this.parseBlock();
      this.expect(ls.RBRACE);
      if (this.accept(ls.IF)) {
        this.operators[e] = this.operators.length;
        this.operators[e + 1] = "jz";
      } else {
        if (!this.accept(ls.LBRACE)) throw new FormatError("PS Function: error parsing conditional.");
        {
          var t = this.operators.length;
          this.operators.push(null, null);
          var _i187 = this.operators.length;
          this.parseBlock();
          this.expect(ls.RBRACE);
          this.expect(ls.IFELSE);
          this.operators[t] = this.operators.length;
          this.operators[t + 1] = "j";
          this.operators[e] = _i187;
          this.operators[e + 1] = "jz";
        }
      }
    }
  }]);
}();
var ls = {
  LBRACE: 0,
  RBRACE: 1,
  NUMBER: 2,
  OPERATOR: 3,
  IF: 4,
  IFELSE: 5
};
var PostScriptToken = /*#__PURE__*/function () {
  function PostScriptToken(e, t) {
    _classCallCheck(this, PostScriptToken);
    this.type = e;
    this.value = t;
  }
  return _createClass(PostScriptToken, null, [{
    key: "opCache",
    get: function get() {
      return shadow(this, "opCache", Object.create(null));
    }
  }, {
    key: "getOperator",
    value: function getOperator(e) {
      var _PostScriptToken$opCa;
      return (_PostScriptToken$opCa = PostScriptToken.opCache)[e] || (_PostScriptToken$opCa[e] = new PostScriptToken(ls.OPERATOR, e));
    }
  }, {
    key: "LBRACE",
    get: function get() {
      return shadow(this, "LBRACE", new PostScriptToken(ls.LBRACE, "{"));
    }
  }, {
    key: "RBRACE",
    get: function get() {
      return shadow(this, "RBRACE", new PostScriptToken(ls.RBRACE, "}"));
    }
  }, {
    key: "IF",
    get: function get() {
      return shadow(this, "IF", new PostScriptToken(ls.IF, "IF"));
    }
  }, {
    key: "IFELSE",
    get: function get() {
      return shadow(this, "IFELSE", new PostScriptToken(ls.IFELSE, "IFELSE"));
    }
  }]);
}();
var PostScriptLexer = /*#__PURE__*/function () {
  function PostScriptLexer(e) {
    _classCallCheck(this, PostScriptLexer);
    this.stream = e;
    this.nextChar();
    this.strBuf = [];
  }
  return _createClass(PostScriptLexer, [{
    key: "nextChar",
    value: function nextChar() {
      return this.currentChar = this.stream.getByte();
    }
  }, {
    key: "getToken",
    value: function getToken() {
      var e = !1,
        t = this.currentChar;
      for (;;) {
        if (t < 0) return yt;
        if (e) 10 !== t && 13 !== t || (e = !1);else if (37 === t) e = !0;else if (!isWhiteSpace(t)) break;
        t = this.nextChar();
      }
      switch (0 | t) {
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
        case 43:
        case 45:
        case 46:
          return new PostScriptToken(ls.NUMBER, this.getNumber());
        case 123:
          this.nextChar();
          return PostScriptToken.LBRACE;
        case 125:
          this.nextChar();
          return PostScriptToken.RBRACE;
      }
      var i = this.strBuf;
      i.length = 0;
      i[0] = String.fromCharCode(t);
      for (; (t = this.nextChar()) >= 0 && (t >= 65 && t <= 90 || t >= 97 && t <= 122);) i.push(String.fromCharCode(t));
      var a = i.join("");
      switch (a.toLowerCase()) {
        case "if":
          return PostScriptToken.IF;
        case "ifelse":
          return PostScriptToken.IFELSE;
        default:
          return PostScriptToken.getOperator(a);
      }
    }
  }, {
    key: "getNumber",
    value: function getNumber() {
      var e = this.currentChar;
      var t = this.strBuf;
      t.length = 0;
      t[0] = String.fromCharCode(e);
      for (; (e = this.nextChar()) >= 0 && (e >= 48 && e <= 57 || 45 === e || 46 === e);) t.push(String.fromCharCode(e));
      var i = parseFloat(t.join(""));
      if (isNaN(i)) throw new FormatError("Invalid floating point number: ".concat(i));
      return i;
    }
  }]);
}();
var BaseLocalCache = /*#__PURE__*/function () {
  function BaseLocalCache(e) {
    _classCallCheck(this, BaseLocalCache);
    this._onlyRefs = !0 === (e === null || e === void 0 ? void 0 : e.onlyRefs);
    if (!this._onlyRefs) {
      this._nameRefMap = new Map();
      this._imageMap = new Map();
    }
    this._imageCache = new RefSetCache();
  }
  return _createClass(BaseLocalCache, [{
    key: "getByName",
    value: function getByName(e) {
      this._onlyRefs && unreachable("Should not call `getByName` method.");
      var t = this._nameRefMap.get(e);
      return t ? this.getByRef(t) : this._imageMap.get(e) || null;
    }
  }, {
    key: "getByRef",
    value: function getByRef(e) {
      return this._imageCache.get(e) || null;
    }
  }, {
    key: "set",
    value: function set(e, t, i) {
      unreachable("Abstract method `set` called.");
    }
  }]);
}();
var LocalImageCache = /*#__PURE__*/function (_BaseLocalCache) {
  function LocalImageCache() {
    _classCallCheck(this, LocalImageCache);
    return _callSuper(this, LocalImageCache, arguments);
  }
  _inherits(LocalImageCache, _BaseLocalCache);
  return _createClass(LocalImageCache, [{
    key: "set",
    value: function set(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var i = arguments.length > 2 ? arguments[2] : undefined;
      if ("string" != typeof e) throw new Error('LocalImageCache.set - expected "name" argument.');
      if (t) {
        if (this._imageCache.has(t)) return;
        this._nameRefMap.set(e, t);
        this._imageCache.put(t, i);
      } else this._imageMap.has(e) || this._imageMap.set(e, i);
    }
  }]);
}(BaseLocalCache);
var LocalColorSpaceCache = /*#__PURE__*/function (_BaseLocalCache2) {
  function LocalColorSpaceCache() {
    _classCallCheck(this, LocalColorSpaceCache);
    return _callSuper(this, LocalColorSpaceCache, arguments);
  }
  _inherits(LocalColorSpaceCache, _BaseLocalCache2);
  return _createClass(LocalColorSpaceCache, [{
    key: "set",
    value: function set() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var i = arguments.length > 2 ? arguments[2] : undefined;
      if ("string" != typeof e && !t) throw new Error('LocalColorSpaceCache.set - expected "name" and/or "ref" argument.');
      if (t) {
        if (this._imageCache.has(t)) return;
        null !== e && this._nameRefMap.set(e, t);
        this._imageCache.put(t, i);
      } else this._imageMap.has(e) || this._imageMap.set(e, i);
    }
  }]);
}(BaseLocalCache);
var LocalFunctionCache = /*#__PURE__*/function (_BaseLocalCache3) {
  function LocalFunctionCache(e) {
    _classCallCheck(this, LocalFunctionCache);
    return _callSuper(this, LocalFunctionCache, [{
      onlyRefs: !0
    }]);
  }
  _inherits(LocalFunctionCache, _BaseLocalCache3);
  return _createClass(LocalFunctionCache, [{
    key: "set",
    value: function set() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var t = arguments.length > 1 ? arguments[1] : undefined;
      var i = arguments.length > 2 ? arguments[2] : undefined;
      if (!t) throw new Error('LocalFunctionCache.set - expected "ref" argument.');
      this._imageCache.has(t) || this._imageCache.put(t, i);
    }
  }]);
}(BaseLocalCache);
var LocalGStateCache = /*#__PURE__*/function (_BaseLocalCache4) {
  function LocalGStateCache() {
    _classCallCheck(this, LocalGStateCache);
    return _callSuper(this, LocalGStateCache, arguments);
  }
  _inherits(LocalGStateCache, _BaseLocalCache4);
  return _createClass(LocalGStateCache, [{
    key: "set",
    value: function set(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var i = arguments.length > 2 ? arguments[2] : undefined;
      if ("string" != typeof e) throw new Error('LocalGStateCache.set - expected "name" argument.');
      if (t) {
        if (this._imageCache.has(t)) return;
        this._nameRefMap.set(e, t);
        this._imageCache.put(t, i);
      } else this._imageMap.has(e) || this._imageMap.set(e, i);
    }
  }]);
}(BaseLocalCache);
var LocalTilingPatternCache = /*#__PURE__*/function (_BaseLocalCache5) {
  function LocalTilingPatternCache(e) {
    _classCallCheck(this, LocalTilingPatternCache);
    return _callSuper(this, LocalTilingPatternCache, [{
      onlyRefs: !0
    }]);
  }
  _inherits(LocalTilingPatternCache, _BaseLocalCache5);
  return _createClass(LocalTilingPatternCache, [{
    key: "set",
    value: function set() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var t = arguments.length > 1 ? arguments[1] : undefined;
      var i = arguments.length > 2 ? arguments[2] : undefined;
      if (!t) throw new Error('LocalTilingPatternCache.set - expected "ref" argument.');
      this._imageCache.has(t) || this._imageCache.put(t, i);
    }
  }]);
}(BaseLocalCache);
var RegionalImageCache = /*#__PURE__*/function (_BaseLocalCache6) {
  function RegionalImageCache(e) {
    _classCallCheck(this, RegionalImageCache);
    return _callSuper(this, RegionalImageCache, [{
      onlyRefs: !0
    }]);
  }
  _inherits(RegionalImageCache, _BaseLocalCache6);
  return _createClass(RegionalImageCache, [{
    key: "set",
    value: function set() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var t = arguments.length > 1 ? arguments[1] : undefined;
      var i = arguments.length > 2 ? arguments[2] : undefined;
      if (!t) throw new Error('RegionalImageCache.set - expected "ref" argument.');
      this._imageCache.has(t) || this._imageCache.put(t, i);
    }
  }]);
}(BaseLocalCache);
var _b2 = /*#__PURE__*/_classPrivateFieldLooseKey("b");
var _F2 = /*#__PURE__*/_classPrivateFieldLooseKey("F");
var _S3 = /*#__PURE__*/_classPrivateFieldLooseKey("S");
var GlobalImageCache = /*#__PURE__*/function () {
  function GlobalImageCache() {
    _classCallCheck(this, GlobalImageCache);
    Object.defineProperty(this, _S3, {
      get: _get_S,
      set: void 0
    });
    Object.defineProperty(this, _F2, {
      get: _get_F,
      set: void 0
    });
    Object.defineProperty(this, _b2, {
      writable: true,
      value: new RefSet()
    });
    this._refCache = new RefSetCache();
    this._imageCache = new RefSetCache();
  }
  return _createClass(GlobalImageCache, [{
    key: "shouldCache",
    value: function shouldCache(e, t) {
      var i = this._refCache.get(e);
      if (!i) {
        i = new Set();
        this._refCache.put(e, i);
      }
      i.add(t);
      return !(i.size < GlobalImageCache.NUM_PAGES_THRESHOLD) && !(!this._imageCache.has(e) && _classPrivateFieldLooseBase(this, _S3)[_S3]);
    }
  }, {
    key: "addDecodeFailed",
    value: function addDecodeFailed(e) {
      _classPrivateFieldLooseBase(this, _b2)[_b2].put(e);
    }
  }, {
    key: "hasDecodeFailed",
    value: function hasDecodeFailed(e) {
      return _classPrivateFieldLooseBase(this, _b2)[_b2].has(e);
    }
  }, {
    key: "addByteSize",
    value: function addByteSize(e, t) {
      var i = this._imageCache.get(e);
      i && (i.byteSize || (i.byteSize = t));
    }
  }, {
    key: "getData",
    value: function getData(e, t) {
      var i = this._refCache.get(e);
      if (!i) return null;
      if (i.size < GlobalImageCache.NUM_PAGES_THRESHOLD) return null;
      var a = this._imageCache.get(e);
      if (!a) return null;
      i.add(t);
      return a;
    }
  }, {
    key: "setData",
    value: function setData(e, t) {
      if (!this._refCache.has(e)) throw new Error('GlobalImageCache.setData - expected "shouldCache" to have been called.');
      this._imageCache.has(e) || (_classPrivateFieldLooseBase(this, _S3)[_S3] ? warn("GlobalImageCache.setData - cache limit reached.") : this._imageCache.put(e, t));
    }
  }, {
    key: "clear",
    value: function clear() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      if (!e) {
        _classPrivateFieldLooseBase(this, _b2)[_b2].clear();
        this._refCache.clear();
      }
      this._imageCache.clear();
    }
  }]);
}();
_GlobalImageCache = GlobalImageCache;
function _get_F() {
  var e = 0;
  var _iterator235 = _createForOfIteratorHelper(this._imageCache),
    _step235;
  try {
    for (_iterator235.s(); !(_step235 = _iterator235.n()).done;) {
      var _t495 = _step235.value;
      e += _t495.byteSize;
    }
  } catch (err) {
    _iterator235.e(err);
  } finally {
    _iterator235.f();
  }
  return e;
}
function _get_S() {
  return !(this._imageCache.size < _GlobalImageCache.MIN_IMAGES_TO_CACHE) && !(_classPrivateFieldLooseBase(this, _F2)[_F2] < _GlobalImageCache.MAX_BYTE_SIZE);
}
GlobalImageCache.NUM_PAGES_THRESHOLD = 2;
GlobalImageCache.MIN_IMAGES_TO_CACHE = 10;
GlobalImageCache.MAX_BYTE_SIZE = 5e7;
var PDFFunctionFactory = /*#__PURE__*/function () {
  function PDFFunctionFactory(_ref57) {
    var e = _ref57.xref,
      _ref57$isEvalSupporte = _ref57.isEvalSupported,
      t = _ref57$isEvalSupporte === void 0 ? !0 : _ref57$isEvalSupporte;
    _classCallCheck(this, PDFFunctionFactory);
    this.xref = e;
    this.isEvalSupported = !1 !== t;
  }
  return _createClass(PDFFunctionFactory, [{
    key: "create",
    value: function create(e) {
      var t = this.getCached(e);
      if (t) return t;
      var i = PDFFunction.parse({
        xref: this.xref,
        isEvalSupported: this.isEvalSupported,
        fn: e instanceof Ref ? this.xref.fetch(e) : e
      });
      this._cache(e, i);
      return i;
    }
  }, {
    key: "createFromArray",
    value: function createFromArray(e) {
      var t = this.getCached(e);
      if (t) return t;
      var i = PDFFunction.parseArray({
        xref: this.xref,
        isEvalSupported: this.isEvalSupported,
        fnObj: e instanceof Ref ? this.xref.fetch(e) : e
      });
      this._cache(e, i);
      return i;
    }
  }, {
    key: "getCached",
    value: function getCached(e) {
      var _e$dict;
      var t;
      e instanceof Ref ? t = e : e instanceof Dict ? t = e.objId : e instanceof BaseStream && (t = (_e$dict = e.dict) === null || _e$dict === void 0 ? void 0 : _e$dict.objId);
      if (t) {
        var _e264 = this._localFunctionCache.getByRef(t);
        if (_e264) return _e264;
      }
      return null;
    }
  }, {
    key: "_cache",
    value: function _cache(e, t) {
      var _e$dict2;
      if (!t) throw new Error('PDFFunctionFactory._cache - expected "parsedFunction" argument.');
      var i;
      e instanceof Ref ? i = e : e instanceof Dict ? i = e.objId : e instanceof BaseStream && (i = (_e$dict2 = e.dict) === null || _e$dict2 === void 0 ? void 0 : _e$dict2.objId);
      i && this._localFunctionCache.set(null, i, t);
    }
  }, {
    key: "_localFunctionCache",
    get: function get() {
      return shadow(this, "_localFunctionCache", new LocalFunctionCache());
    }
  }]);
}();
function toNumberArray(e) {
  return Array.isArray(e) ? isNumberArray(e, null) ? e : e.map(function (e) {
    return +e;
  }) : null;
}
var PDFFunction = /*#__PURE__*/function () {
  function PDFFunction() {
    _classCallCheck(this, PDFFunction);
  }
  return _createClass(PDFFunction, null, [{
    key: "getSampleArray",
    value: function getSampleArray(e, t, i, a) {
      var s,
        r,
        n = 1;
      for (s = 0, r = e.length; s < r; s++) n *= e[s];
      n *= t;
      var g = new Array(n);
      var o = 0,
        c = 0;
      var C = 1 / (Math.pow(2, i) - 1),
        h = a.getBytes((n * i + 7) / 8);
      var l = 0;
      for (s = 0; s < n; s++) {
        for (; o < i;) {
          c <<= 8;
          c |= h[l++];
          o += 8;
        }
        o -= i;
        g[s] = (c >> o) * C;
        c &= (1 << o) - 1;
      }
      return g;
    }
  }, {
    key: "parse",
    value: function parse(_ref58) {
      var e = _ref58.xref,
        t = _ref58.isEvalSupported,
        i = _ref58.fn;
      var a = i.dict || i;
      switch (a.get("FunctionType")) {
        case 0:
          return this.constructSampled({
            xref: e,
            isEvalSupported: t,
            fn: i,
            dict: a
          });
        case 1:
          break;
        case 2:
          return this.constructInterpolated({
            xref: e,
            isEvalSupported: t,
            dict: a
          });
        case 3:
          return this.constructStiched({
            xref: e,
            isEvalSupported: t,
            dict: a
          });
        case 4:
          return this.constructPostScript({
            xref: e,
            isEvalSupported: t,
            fn: i,
            dict: a
          });
      }
      throw new FormatError("Unknown type of function");
    }
  }, {
    key: "parseArray",
    value: function parseArray(_ref59) {
      var e = _ref59.xref,
        t = _ref59.isEvalSupported,
        i = _ref59.fnObj;
      if (!Array.isArray(i)) return this.parse({
        xref: e,
        isEvalSupported: t,
        fn: i
      });
      var a = [];
      var _iterator53 = _createForOfIteratorHelper(i),
        _step53;
      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var _s110 = _step53.value;
          a.push(this.parse({
            xref: e,
            isEvalSupported: t,
            fn: e.fetchIfRef(_s110)
          }));
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }
      return function (e, t, i, s) {
        for (var _r78 = 0, _n62 = a.length; _r78 < _n62; _r78++) a[_r78](e, t, i, s + _r78);
      };
    }
  }, {
    key: "constructSampled",
    value: function constructSampled(_ref60) {
      var e = _ref60.xref,
        t = _ref60.isEvalSupported,
        i = _ref60.fn,
        a = _ref60.dict;
      function toMultiArray(e) {
        var t = e.length,
          i = [];
        var a = 0;
        for (var _s111 = 0; _s111 < t; _s111 += 2) i[a++] = [e[_s111], e[_s111 + 1]];
        return i;
      }
      function interpolate(e, t, i, a, s) {
        return a + (s - a) / (i - t) * (e - t);
      }
      var s = toNumberArray(a.getArray("Domain")),
        r = toNumberArray(a.getArray("Range"));
      if (!s || !r) throw new FormatError("No domain or range");
      var n = s.length / 2,
        g = r.length / 2;
      s = toMultiArray(s);
      r = toMultiArray(r);
      var o = toNumberArray(a.getArray("Size")),
        c = a.get("BitsPerSample"),
        C = a.get("Order") || 1;
      1 !== C && info("No support for cubic spline interpolation: " + C);
      var h = toNumberArray(a.getArray("Encode"));
      if (h) h = toMultiArray(h);else {
        h = [];
        for (var _e265 = 0; _e265 < n; ++_e265) h.push([0, o[_e265] - 1]);
      }
      var l = toNumberArray(a.getArray("Decode"));
      l = l ? toMultiArray(l) : r;
      var Q = this.getSampleArray(o, g, c, i);
      return function constructSampledFn(e, t, i, a) {
        var c = 1 << n,
          C = new Float64Array(c),
          E = new Uint32Array(c);
        var u, d;
        for (d = 0; d < c; d++) C[d] = 1;
        var f = g,
          p = 1;
        for (u = 0; u < n; ++u) {
          var _i188 = s[u][0],
            _a168 = s[u][1];
          var _r79 = interpolate(Math.min(Math.max(e[t + u], _i188), _a168), _i188, _a168, h[u][0], h[u][1]);
          var _n63 = o[u];
          _r79 = Math.min(Math.max(_r79, 0), _n63 - 1);
          var _g41 = _r79 < _n63 - 1 ? Math.floor(_r79) : _r79 - 1,
            _l8 = _g41 + 1 - _r79,
            _Q15 = _r79 - _g41,
            _m7 = _g41 * f,
            _y4 = _m7 + f;
          for (d = 0; d < c; d++) if (d & p) {
            C[d] *= _Q15;
            E[d] += _y4;
          } else {
            C[d] *= _l8;
            E[d] += _m7;
          }
          f *= _n63;
          p <<= 1;
        }
        for (d = 0; d < g; ++d) {
          var _e266 = 0;
          for (u = 0; u < c; u++) _e266 += Q[E[u] + d] * C[u];
          _e266 = interpolate(_e266, 0, 1, l[d][0], l[d][1]);
          i[a + d] = Math.min(Math.max(_e266, r[d][0]), r[d][1]);
        }
      };
    }
  }, {
    key: "constructInterpolated",
    value: function constructInterpolated(_ref61) {
      var e = _ref61.xref,
        t = _ref61.isEvalSupported,
        i = _ref61.dict;
      var a = toNumberArray(i.getArray("C0")) || [0],
        s = toNumberArray(i.getArray("C1")) || [1],
        r = i.get("N"),
        n = [];
      for (var _e267 = 0, _t186 = a.length; _e267 < _t186; ++_e267) n.push(s[_e267] - a[_e267]);
      var g = n.length;
      return function constructInterpolatedFn(e, t, i, s) {
        var o = 1 === r ? e[t] : Math.pow(e[t], r);
        for (var _e268 = 0; _e268 < g; ++_e268) i[s + _e268] = a[_e268] + o * n[_e268];
      };
    }
  }, {
    key: "constructStiched",
    value: function constructStiched(_ref62) {
      var e = _ref62.xref,
        t = _ref62.isEvalSupported,
        i = _ref62.dict;
      var a = toNumberArray(i.getArray("Domain"));
      if (!a) throw new FormatError("No domain");
      if (1 !== a.length / 2) throw new FormatError("Bad domain for stiched function");
      var s = [];
      var _iterator54 = _createForOfIteratorHelper(i.get("Functions")),
        _step54;
      try {
        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
          var _a169 = _step54.value;
          s.push(this.parse({
            xref: e,
            isEvalSupported: t,
            fn: e.fetchIfRef(_a169)
          }));
        }
      } catch (err) {
        _iterator54.e(err);
      } finally {
        _iterator54.f();
      }
      var r = toNumberArray(i.getArray("Bounds")),
        n = toNumberArray(i.getArray("Encode")),
        g = new Float32Array(1);
      return function constructStichedFn(e, t, i, o) {
        var c = function constructStichedFromIRClip(e, t, i) {
            e > i ? e = i : e < t && (e = t);
            return e;
          }(e[t], a[0], a[1]),
          C = r.length;
        var h;
        for (h = 0; h < C && !(c < r[h]); ++h);
        var l = a[0];
        h > 0 && (l = r[h - 1]);
        var Q = a[1];
        h < r.length && (Q = r[h]);
        var E = n[2 * h],
          u = n[2 * h + 1];
        g[0] = l === Q ? E : E + (c - l) * (u - E) / (Q - l);
        s[h](g, 0, i, o);
      };
    }
  }, {
    key: "constructPostScript",
    value: function constructPostScript(_ref63) {
      var e = _ref63.xref,
        t = _ref63.isEvalSupported,
        i = _ref63.fn,
        a = _ref63.dict;
      var s = toNumberArray(a.getArray("Domain")),
        r = toNumberArray(a.getArray("Range"));
      if (!s) throw new FormatError("No domain.");
      if (!r) throw new FormatError("No range.");
      var n = new PostScriptLexer(i),
        g = new PostScriptParser(n).parse();
      if (t && FeatureTest.isEvalSupported) {
        var _e269 = new PostScriptCompiler().compile(g, s, r);
        if (_e269) return new Function("src", "srcOffset", "dest", "destOffset", _e269);
      }
      info("Unable to compile PS function");
      var o = r.length >> 1,
        c = s.length >> 1,
        C = new PostScriptEvaluator(g),
        h = Object.create(null);
      var l = 8192;
      var Q = new Float32Array(c);
      return function constructPostScriptFn(e, t, i, a) {
        var s,
          n,
          g = "";
        var E = Q;
        for (s = 0; s < c; s++) {
          n = e[t + s];
          E[s] = n;
          g += n + "_";
        }
        var u = h[g];
        if (void 0 !== u) {
          i.set(u, a);
          return;
        }
        var d = new Float32Array(o),
          f = C.execute(E),
          p = f.length - o;
        for (s = 0; s < o; s++) {
          n = f[p + s];
          var _e270 = r[2 * s];
          if (n < _e270) n = _e270;else {
            _e270 = r[2 * s + 1];
            n > _e270 && (n = _e270);
          }
          d[s] = n;
        }
        if (l > 0) {
          l--;
          h[g] = d;
        }
        i.set(d, a);
      };
    }
  }]);
}();
function isPDFFunction(e) {
  var t;
  if (e instanceof Dict) t = e;else {
    if (!(e instanceof BaseStream)) return !1;
    t = e.dict;
  }
  return t.has("FunctionType");
}
var PostScriptStack = /*#__PURE__*/function () {
  function PostScriptStack(e) {
    _classCallCheck(this, PostScriptStack);
    this.stack = e ? Array.from(e) : [];
  }
  return _createClass(PostScriptStack, [{
    key: "push",
    value: function push(e) {
      if (this.stack.length >= PostScriptStack.MAX_STACK_SIZE) throw new Error("PostScript function stack overflow.");
      this.stack.push(e);
    }
  }, {
    key: "pop",
    value: function pop() {
      if (this.stack.length <= 0) throw new Error("PostScript function stack underflow.");
      return this.stack.pop();
    }
  }, {
    key: "copy",
    value: function copy(e) {
      if (this.stack.length + e >= PostScriptStack.MAX_STACK_SIZE) throw new Error("PostScript function stack overflow.");
      var t = this.stack;
      for (var _i189 = t.length - e, _a170 = e - 1; _a170 >= 0; _a170--, _i189++) t.push(t[_i189]);
    }
  }, {
    key: "index",
    value: function index(e) {
      this.push(this.stack[this.stack.length - e - 1]);
    }
  }, {
    key: "roll",
    value: function roll(e, t) {
      var i = this.stack,
        a = i.length - e,
        s = i.length - 1,
        r = a + (t - Math.floor(t / e) * e);
      for (var _e271 = a, _t187 = s; _e271 < _t187; _e271++, _t187--) {
        var _a171 = i[_e271];
        i[_e271] = i[_t187];
        i[_t187] = _a171;
      }
      for (var _e272 = a, _t188 = r - 1; _e272 < _t188; _e272++, _t188--) {
        var _a172 = i[_e272];
        i[_e272] = i[_t188];
        i[_t188] = _a172;
      }
      for (var _e273 = r, _t189 = s; _e273 < _t189; _e273++, _t189--) {
        var _a173 = i[_e273];
        i[_e273] = i[_t189];
        i[_t189] = _a173;
      }
    }
  }]);
}();
PostScriptStack.MAX_STACK_SIZE = 100;
var PostScriptEvaluator = /*#__PURE__*/function () {
  function PostScriptEvaluator(e) {
    _classCallCheck(this, PostScriptEvaluator);
    this.operators = e;
  }
  return _createClass(PostScriptEvaluator, [{
    key: "execute",
    value: function execute(e) {
      var t = new PostScriptStack(e);
      var i = 0;
      var a = this.operators,
        s = a.length;
      var r, n, g;
      for (; i < s;) {
        r = a[i++];
        if ("number" != typeof r) switch (r) {
          case "jz":
            g = t.pop();
            n = t.pop();
            n || (i = g);
            break;
          case "j":
            n = t.pop();
            i = n;
            break;
          case "abs":
            n = t.pop();
            t.push(Math.abs(n));
            break;
          case "add":
            g = t.pop();
            n = t.pop();
            t.push(n + g);
            break;
          case "and":
            g = t.pop();
            n = t.pop();
            "boolean" == typeof n && "boolean" == typeof g ? t.push(n && g) : t.push(n & g);
            break;
          case "atan":
            g = t.pop();
            n = t.pop();
            n = Math.atan2(n, g) / Math.PI * 180;
            n < 0 && (n += 360);
            t.push(n);
            break;
          case "bitshift":
            g = t.pop();
            n = t.pop();
            n > 0 ? t.push(n << g) : t.push(n >> g);
            break;
          case "ceiling":
            n = t.pop();
            t.push(Math.ceil(n));
            break;
          case "copy":
            n = t.pop();
            t.copy(n);
            break;
          case "cos":
            n = t.pop();
            t.push(Math.cos(n % 360 / 180 * Math.PI));
            break;
          case "cvi":
            n = 0 | t.pop();
            t.push(n);
            break;
          case "cvr":
            break;
          case "div":
            g = t.pop();
            n = t.pop();
            t.push(n / g);
            break;
          case "dup":
            t.copy(1);
            break;
          case "eq":
            g = t.pop();
            n = t.pop();
            t.push(n === g);
            break;
          case "exch":
            t.roll(2, 1);
            break;
          case "exp":
            g = t.pop();
            n = t.pop();
            t.push(Math.pow(n, g));
            break;
          case "false":
            t.push(!1);
            break;
          case "floor":
            n = t.pop();
            t.push(Math.floor(n));
            break;
          case "ge":
            g = t.pop();
            n = t.pop();
            t.push(n >= g);
            break;
          case "gt":
            g = t.pop();
            n = t.pop();
            t.push(n > g);
            break;
          case "idiv":
            g = t.pop();
            n = t.pop();
            t.push(n / g | 0);
            break;
          case "index":
            n = t.pop();
            t.index(n);
            break;
          case "le":
            g = t.pop();
            n = t.pop();
            t.push(n <= g);
            break;
          case "ln":
            n = t.pop();
            t.push(Math.log(n));
            break;
          case "log":
            n = t.pop();
            t.push(Math.log10(n));
            break;
          case "lt":
            g = t.pop();
            n = t.pop();
            t.push(n < g);
            break;
          case "mod":
            g = t.pop();
            n = t.pop();
            t.push(n % g);
            break;
          case "mul":
            g = t.pop();
            n = t.pop();
            t.push(n * g);
            break;
          case "ne":
            g = t.pop();
            n = t.pop();
            t.push(n !== g);
            break;
          case "neg":
            n = t.pop();
            t.push(-n);
            break;
          case "not":
            n = t.pop();
            "boolean" == typeof n ? t.push(!n) : t.push(~n);
            break;
          case "or":
            g = t.pop();
            n = t.pop();
            "boolean" == typeof n && "boolean" == typeof g ? t.push(n || g) : t.push(n | g);
            break;
          case "pop":
            t.pop();
            break;
          case "roll":
            g = t.pop();
            n = t.pop();
            t.roll(n, g);
            break;
          case "round":
            n = t.pop();
            t.push(Math.round(n));
            break;
          case "sin":
            n = t.pop();
            t.push(Math.sin(n % 360 / 180 * Math.PI));
            break;
          case "sqrt":
            n = t.pop();
            t.push(Math.sqrt(n));
            break;
          case "sub":
            g = t.pop();
            n = t.pop();
            t.push(n - g);
            break;
          case "true":
            t.push(!0);
            break;
          case "truncate":
            n = t.pop();
            n = n < 0 ? Math.ceil(n) : Math.floor(n);
            t.push(n);
            break;
          case "xor":
            g = t.pop();
            n = t.pop();
            "boolean" == typeof n && "boolean" == typeof g ? t.push(n !== g) : t.push(n ^ g);
            break;
          default:
            throw new FormatError("Unknown operator ".concat(r));
        } else t.push(r);
      }
      return t.stack;
    }
  }]);
}();
var AstNode = /*#__PURE__*/function () {
  function AstNode(e) {
    _classCallCheck(this, AstNode);
    this.type = e;
  }
  return _createClass(AstNode, [{
    key: "visit",
    value: function visit(e) {
      unreachable("abstract method");
    }
  }]);
}();
var AstArgument = /*#__PURE__*/function (_AstNode) {
  function AstArgument(e, t, i) {
    var _this38;
    _classCallCheck(this, AstArgument);
    _this38 = _callSuper(this, AstArgument, ["args"]);
    _this38.index = e;
    _this38.min = t;
    _this38.max = i;
    return _this38;
  }
  _inherits(AstArgument, _AstNode);
  return _createClass(AstArgument, [{
    key: "visit",
    value: function visit(e) {
      e.visitArgument(this);
    }
  }]);
}(AstNode);
var AstLiteral = /*#__PURE__*/function (_AstNode2) {
  function AstLiteral(e) {
    var _this39;
    _classCallCheck(this, AstLiteral);
    _this39 = _callSuper(this, AstLiteral, ["literal"]);
    _this39.number = e;
    _this39.min = e;
    _this39.max = e;
    return _this39;
  }
  _inherits(AstLiteral, _AstNode2);
  return _createClass(AstLiteral, [{
    key: "visit",
    value: function visit(e) {
      e.visitLiteral(this);
    }
  }]);
}(AstNode);
var AstBinaryOperation = /*#__PURE__*/function (_AstNode3) {
  function AstBinaryOperation(e, t, i, a, s) {
    var _this40;
    _classCallCheck(this, AstBinaryOperation);
    _this40 = _callSuper(this, AstBinaryOperation, ["binary"]);
    _this40.op = e;
    _this40.arg1 = t;
    _this40.arg2 = i;
    _this40.min = a;
    _this40.max = s;
    return _this40;
  }
  _inherits(AstBinaryOperation, _AstNode3);
  return _createClass(AstBinaryOperation, [{
    key: "visit",
    value: function visit(e) {
      e.visitBinaryOperation(this);
    }
  }]);
}(AstNode);
var AstMin = /*#__PURE__*/function (_AstNode4) {
  function AstMin(e, t) {
    var _this41;
    _classCallCheck(this, AstMin);
    _this41 = _callSuper(this, AstMin, ["max"]);
    _this41.arg = e;
    _this41.min = e.min;
    _this41.max = t;
    return _this41;
  }
  _inherits(AstMin, _AstNode4);
  return _createClass(AstMin, [{
    key: "visit",
    value: function visit(e) {
      e.visitMin(this);
    }
  }]);
}(AstNode);
var AstVariable = /*#__PURE__*/function (_AstNode5) {
  function AstVariable(e, t, i) {
    var _this42;
    _classCallCheck(this, AstVariable);
    _this42 = _callSuper(this, AstVariable, ["var"]);
    _this42.index = e;
    _this42.min = t;
    _this42.max = i;
    return _this42;
  }
  _inherits(AstVariable, _AstNode5);
  return _createClass(AstVariable, [{
    key: "visit",
    value: function visit(e) {
      e.visitVariable(this);
    }
  }]);
}(AstNode);
var AstVariableDefinition = /*#__PURE__*/function (_AstNode6) {
  function AstVariableDefinition(e, t) {
    var _this43;
    _classCallCheck(this, AstVariableDefinition);
    _this43 = _callSuper(this, AstVariableDefinition, ["definition"]);
    _this43.variable = e;
    _this43.arg = t;
    return _this43;
  }
  _inherits(AstVariableDefinition, _AstNode6);
  return _createClass(AstVariableDefinition, [{
    key: "visit",
    value: function visit(e) {
      e.visitVariableDefinition(this);
    }
  }]);
}(AstNode);
var ExpressionBuilderVisitor = /*#__PURE__*/function () {
  function ExpressionBuilderVisitor() {
    _classCallCheck(this, ExpressionBuilderVisitor);
    this.parts = [];
  }
  return _createClass(ExpressionBuilderVisitor, [{
    key: "visitArgument",
    value: function visitArgument(e) {
      this.parts.push("Math.max(", e.min, ", Math.min(", e.max, ", src[srcOffset + ", e.index, "]))");
    }
  }, {
    key: "visitVariable",
    value: function visitVariable(e) {
      this.parts.push("v", e.index);
    }
  }, {
    key: "visitLiteral",
    value: function visitLiteral(e) {
      this.parts.push(e.number);
    }
  }, {
    key: "visitBinaryOperation",
    value: function visitBinaryOperation(e) {
      this.parts.push("(");
      e.arg1.visit(this);
      this.parts.push(" ", e.op, " ");
      e.arg2.visit(this);
      this.parts.push(")");
    }
  }, {
    key: "visitVariableDefinition",
    value: function visitVariableDefinition(e) {
      this.parts.push("var ");
      e.variable.visit(this);
      this.parts.push(" = ");
      e.arg.visit(this);
      this.parts.push(";");
    }
  }, {
    key: "visitMin",
    value: function visitMin(e) {
      this.parts.push("Math.min(");
      e.arg.visit(this);
      this.parts.push(", ", e.max, ")");
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.parts.join("");
    }
  }]);
}();
function buildAddOperation(e, t) {
  return "literal" === t.type && 0 === t.number ? e : "literal" === e.type && 0 === e.number ? t : "literal" === t.type && "literal" === e.type ? new AstLiteral(e.number + t.number) : new AstBinaryOperation("+", e, t, e.min + t.min, e.max + t.max);
}
function buildMulOperation(e, t) {
  if ("literal" === t.type) {
    if (0 === t.number) return new AstLiteral(0);
    if (1 === t.number) return e;
    if ("literal" === e.type) return new AstLiteral(e.number * t.number);
  }
  if ("literal" === e.type) {
    if (0 === e.number) return new AstLiteral(0);
    if (1 === e.number) return t;
  }
  var i = Math.min(e.min * t.min, e.min * t.max, e.max * t.min, e.max * t.max),
    a = Math.max(e.min * t.min, e.min * t.max, e.max * t.min, e.max * t.max);
  return new AstBinaryOperation("*", e, t, i, a);
}
function buildSubOperation(e, t) {
  if ("literal" === t.type) {
    if (0 === t.number) return e;
    if ("literal" === e.type) return new AstLiteral(e.number - t.number);
  }
  return "binary" === t.type && "-" === t.op && "literal" === e.type && 1 === e.number && "literal" === t.arg1.type && 1 === t.arg1.number ? t.arg2 : new AstBinaryOperation("-", e, t, e.min - t.max, e.max - t.min);
}
function buildMinOperation(e, t) {
  return e.min >= t ? new AstLiteral(t) : e.max <= t ? e : new AstMin(e, t);
}
var PostScriptCompiler = /*#__PURE__*/function () {
  function PostScriptCompiler() {
    _classCallCheck(this, PostScriptCompiler);
  }
  return _createClass(PostScriptCompiler, [{
    key: "compile",
    value: function compile(e, t, i) {
      var a = [],
        s = [],
        r = t.length >> 1,
        n = i.length >> 1;
      var g,
        o,
        c,
        C,
        h,
        l,
        Q,
        E,
        u = 0;
      for (var _e274 = 0; _e274 < r; _e274++) a.push(new AstArgument(_e274, t[2 * _e274], t[2 * _e274 + 1]));
      for (var _t190 = 0, _i190 = e.length; _t190 < _i190; _t190++) {
        E = e[_t190];
        if ("number" != typeof E) switch (E) {
          case "add":
            if (a.length < 2) return null;
            C = a.pop();
            c = a.pop();
            a.push(buildAddOperation(c, C));
            break;
          case "cvr":
            if (a.length < 1) return null;
            break;
          case "mul":
            if (a.length < 2) return null;
            C = a.pop();
            c = a.pop();
            a.push(buildMulOperation(c, C));
            break;
          case "sub":
            if (a.length < 2) return null;
            C = a.pop();
            c = a.pop();
            a.push(buildSubOperation(c, C));
            break;
          case "exch":
            if (a.length < 2) return null;
            h = a.pop();
            l = a.pop();
            a.push(h, l);
            break;
          case "pop":
            if (a.length < 1) return null;
            a.pop();
            break;
          case "index":
            if (a.length < 1) return null;
            c = a.pop();
            if ("literal" !== c.type) return null;
            g = c.number;
            if (g < 0 || !Number.isInteger(g) || a.length < g) return null;
            h = a[a.length - g - 1];
            if ("literal" === h.type || "var" === h.type) {
              a.push(h);
              break;
            }
            Q = new AstVariable(u++, h.min, h.max);
            a[a.length - g - 1] = Q;
            a.push(Q);
            s.push(new AstVariableDefinition(Q, h));
            break;
          case "dup":
            if (a.length < 1) return null;
            if ("number" == typeof e[_t190 + 1] && "gt" === e[_t190 + 2] && e[_t190 + 3] === _t190 + 7 && "jz" === e[_t190 + 4] && "pop" === e[_t190 + 5] && e[_t190 + 6] === e[_t190 + 1]) {
              c = a.pop();
              a.push(buildMinOperation(c, e[_t190 + 1]));
              _t190 += 6;
              break;
            }
            h = a.at(-1);
            if ("literal" === h.type || "var" === h.type) {
              a.push(h);
              break;
            }
            Q = new AstVariable(u++, h.min, h.max);
            a[a.length - 1] = Q;
            a.push(Q);
            s.push(new AstVariableDefinition(Q, h));
            break;
          case "roll":
            if (a.length < 2) return null;
            C = a.pop();
            c = a.pop();
            if ("literal" !== C.type || "literal" !== c.type) return null;
            o = C.number;
            g = c.number;
            if (g <= 0 || !Number.isInteger(g) || !Number.isInteger(o) || a.length < g) return null;
            o = (o % g + g) % g;
            if (0 === o) break;
            a.push.apply(a, _toConsumableArray(a.splice(a.length - g, g - o)));
            break;
          default:
            return null;
        } else a.push(new AstLiteral(E));
      }
      if (a.length !== n) return null;
      var d = [];
      for (var _i191 = 0, _s112 = s; _i191 < _s112.length; _i191++) {
        var _e275 = _s112[_i191];
        var _t191 = new ExpressionBuilderVisitor();
        _e275.visit(_t191);
        d.push(_t191.toString());
      }
      for (var _e276 = 0, _t192 = a.length; _e276 < _t192; _e276++) {
        var _t193 = a[_e276],
          _s113 = new ExpressionBuilderVisitor();
        _t193.visit(_s113);
        var _r80 = i[2 * _e276],
          _n64 = i[2 * _e276 + 1],
          _g42 = [_s113.toString()];
        if (_r80 > _t193.min) {
          _g42.unshift("Math.max(", _r80, ", ");
          _g42.push(")");
        }
        if (_n64 < _t193.max) {
          _g42.unshift("Math.min(", _n64, ", ");
          _g42.push(")");
        }
        _g42.unshift("dest[destOffset + ", _e276, "] = ");
        _g42.push(";");
        d.push(_g42.join(""));
      }
      return d.join("\n");
    }
  }]);
}();
var Bs = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "ON", "ON", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "ON", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "ON", "ET", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "L", "ON", "ON", "BN", "ON", "ON", "ET", "ET", "EN", "EN", "ON", "L", "ON", "ON", "ON", "EN", "L", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L"],
  Qs = ["AN", "AN", "AN", "AN", "AN", "AN", "ON", "ON", "AL", "ET", "ET", "AL", "CS", "AL", "ON", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "ON", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL"];
function isOdd(e) {
  return 0 != (1 & e);
}
function isEven(e) {
  return 0 == (1 & e);
}
function findUnequal(e, t, i) {
  var a, s;
  for (a = t, s = e.length; a < s; ++a) if (e[a] !== i) return a;
  return a;
}
function setValues(e, t, i, a) {
  for (var _s114 = t; _s114 < i; ++_s114) e[_s114] = a;
}
function reverseValues(e, t, i) {
  for (var _a174 = t, _s115 = i - 1; _a174 < _s115; ++_a174, --_s115) {
    var _t194 = e[_a174];
    e[_a174] = e[_s115];
    e[_s115] = _t194;
  }
}
function createBidiText(e, t) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var a = "ltr";
  i ? a = "ttb" : t || (a = "rtl");
  return {
    str: e,
    dir: a
  };
}
var Es = [],
  us = [];
function bidi(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var a = !0;
  var s = e.length;
  if (0 === s || i) return createBidiText(e, a, i);
  Es.length = s;
  us.length = s;
  var r,
    n,
    g = 0;
  for (r = 0; r < s; ++r) {
    Es[r] = e.charAt(r);
    var _t195 = e.charCodeAt(r);
    var _i192 = "L";
    if (_t195 <= 255) _i192 = Bs[_t195];else if (1424 <= _t195 && _t195 <= 1524) _i192 = "R";else if (1536 <= _t195 && _t195 <= 1791) {
      _i192 = Qs[255 & _t195];
      _i192 || warn("Bidi: invalid Unicode character " + _t195.toString(16));
    } else (1792 <= _t195 && _t195 <= 2220 || 64336 <= _t195 && _t195 <= 65023 || 65136 <= _t195 && _t195 <= 65279) && (_i192 = "AL");
    "R" !== _i192 && "AL" !== _i192 && "AN" !== _i192 || g++;
    us[r] = _i192;
  }
  if (0 === g) {
    a = !0;
    return createBidiText(e, a);
  }
  if (-1 === t) if (g / s < .3 && s > 4) {
    a = !0;
    t = 0;
  } else {
    a = !1;
    t = 1;
  }
  var o = [];
  for (r = 0; r < s; ++r) o[r] = t;
  var c = isOdd(t) ? "R" : "L",
    C = c,
    h = C;
  var l,
    Q = C;
  for (r = 0; r < s; ++r) "NSM" === us[r] ? us[r] = Q : Q = us[r];
  Q = C;
  for (r = 0; r < s; ++r) {
    l = us[r];
    "EN" === l ? us[r] = "AL" === Q ? "AN" : "EN" : "R" !== l && "L" !== l && "AL" !== l || (Q = l);
  }
  for (r = 0; r < s; ++r) {
    l = us[r];
    "AL" === l && (us[r] = "R");
  }
  for (r = 1; r < s - 1; ++r) {
    "ES" === us[r] && "EN" === us[r - 1] && "EN" === us[r + 1] && (us[r] = "EN");
    "CS" !== us[r] || "EN" !== us[r - 1] && "AN" !== us[r - 1] || us[r + 1] !== us[r - 1] || (us[r] = us[r - 1]);
  }
  for (r = 0; r < s; ++r) if ("EN" === us[r]) {
    for (var _e277 = r - 1; _e277 >= 0 && "ET" === us[_e277]; --_e277) us[_e277] = "EN";
    for (var _e278 = r + 1; _e278 < s && "ET" === us[_e278]; ++_e278) us[_e278] = "EN";
  }
  for (r = 0; r < s; ++r) {
    l = us[r];
    "WS" !== l && "ES" !== l && "ET" !== l && "CS" !== l || (us[r] = "ON");
  }
  Q = C;
  for (r = 0; r < s; ++r) {
    l = us[r];
    "EN" === l ? us[r] = "L" === Q ? "L" : "EN" : "R" !== l && "L" !== l || (Q = l);
  }
  for (r = 0; r < s; ++r) if ("ON" === us[r]) {
    var _e279 = findUnequal(us, r + 1, "ON");
    var _t196 = C;
    r > 0 && (_t196 = us[r - 1]);
    var _i193 = h;
    _e279 + 1 < s && (_i193 = us[_e279 + 1]);
    "L" !== _t196 && (_t196 = "R");
    "L" !== _i193 && (_i193 = "R");
    _t196 === _i193 && setValues(us, r, _e279, _t196);
    r = _e279 - 1;
  }
  for (r = 0; r < s; ++r) "ON" === us[r] && (us[r] = c);
  for (r = 0; r < s; ++r) {
    l = us[r];
    isEven(o[r]) ? "R" === l ? o[r] += 1 : "AN" !== l && "EN" !== l || (o[r] += 2) : "L" !== l && "AN" !== l && "EN" !== l || (o[r] += 1);
  }
  var E,
    u = -1,
    d = 99;
  for (r = 0, n = o.length; r < n; ++r) {
    E = o[r];
    u < E && (u = E);
    d > E && isOdd(E) && (d = E);
  }
  for (E = u; E >= d; --E) {
    var _e280 = -1;
    for (r = 0, n = o.length; r < n; ++r) if (o[r] < E) {
      if (_e280 >= 0) {
        reverseValues(Es, _e280, r);
        _e280 = -1;
      }
    } else _e280 < 0 && (_e280 = r);
    _e280 >= 0 && reverseValues(Es, _e280, o.length);
  }
  for (r = 0, n = Es.length; r < n; ++r) {
    var _e281 = Es[r];
    "<" !== _e281 && ">" !== _e281 || (Es[r] = "");
  }
  return createBidiText(Es.join(""), a);
}
var ds = {
    style: "normal",
    weight: "normal"
  },
  fs = {
    style: "normal",
    weight: "bold"
  },
  ps = {
    style: "italic",
    weight: "normal"
  },
  ms = {
    style: "italic",
    weight: "bold"
  },
  ys = new Map([["Times-Roman", {
    local: ["Times New Roman", "Times-Roman", "Times", "Liberation Serif", "Nimbus Roman", "Nimbus Roman L", "Tinos", "Thorndale", "TeX Gyre Termes", "FreeSerif", "Linux Libertine O", "Libertinus Serif", "DejaVu Serif", "Bitstream Vera Serif", "Ubuntu"],
    style: ds,
    ultimate: "serif"
  }], ["Times-Bold", {
    alias: "Times-Roman",
    style: fs,
    ultimate: "serif"
  }], ["Times-Italic", {
    alias: "Times-Roman",
    style: ps,
    ultimate: "serif"
  }], ["Times-BoldItalic", {
    alias: "Times-Roman",
    style: ms,
    ultimate: "serif"
  }], ["Helvetica", {
    local: ["Helvetica", "Helvetica Neue", "Arial", "Arial Nova", "Liberation Sans", "Arimo", "Nimbus Sans", "Nimbus Sans L", "A030", "TeX Gyre Heros", "FreeSans", "DejaVu Sans", "Albany", "Bitstream Vera Sans", "Arial Unicode MS", "Microsoft Sans Serif", "Apple Symbols", "Cantarell"],
    path: "LiberationSans-Regular.ttf",
    style: ds,
    ultimate: "sans-serif"
  }], ["Helvetica-Bold", {
    alias: "Helvetica",
    path: "LiberationSans-Bold.ttf",
    style: fs,
    ultimate: "sans-serif"
  }], ["Helvetica-Oblique", {
    alias: "Helvetica",
    path: "LiberationSans-Italic.ttf",
    style: ps,
    ultimate: "sans-serif"
  }], ["Helvetica-BoldOblique", {
    alias: "Helvetica",
    path: "LiberationSans-BoldItalic.ttf",
    style: ms,
    ultimate: "sans-serif"
  }], ["Courier", {
    local: ["Courier", "Courier New", "Liberation Mono", "Nimbus Mono", "Nimbus Mono L", "Cousine", "Cumberland", "TeX Gyre Cursor", "FreeMono", "Linux Libertine Mono O", "Libertinus Mono"],
    style: ds,
    ultimate: "monospace"
  }], ["Courier-Bold", {
    alias: "Courier",
    style: fs,
    ultimate: "monospace"
  }], ["Courier-Oblique", {
    alias: "Courier",
    style: ps,
    ultimate: "monospace"
  }], ["Courier-BoldOblique", {
    alias: "Courier",
    style: ms,
    ultimate: "monospace"
  }], ["ArialBlack", {
    local: ["Arial Black"],
    style: {
      style: "normal",
      weight: "900"
    },
    fallback: "Helvetica-Bold"
  }], ["ArialBlack-Bold", {
    alias: "ArialBlack"
  }], ["ArialBlack-Italic", {
    alias: "ArialBlack",
    style: {
      style: "italic",
      weight: "900"
    },
    fallback: "Helvetica-BoldOblique"
  }], ["ArialBlack-BoldItalic", {
    alias: "ArialBlack-Italic"
  }], ["ArialNarrow", {
    local: ["Arial Narrow", "Liberation Sans Narrow", "Helvetica Condensed", "Nimbus Sans Narrow", "TeX Gyre Heros Cn"],
    style: ds,
    fallback: "Helvetica"
  }], ["ArialNarrow-Bold", {
    alias: "ArialNarrow",
    style: fs,
    fallback: "Helvetica-Bold"
  }], ["ArialNarrow-Italic", {
    alias: "ArialNarrow",
    style: ps,
    fallback: "Helvetica-Oblique"
  }], ["ArialNarrow-BoldItalic", {
    alias: "ArialNarrow",
    style: ms,
    fallback: "Helvetica-BoldOblique"
  }], ["Calibri", {
    local: ["Calibri", "Carlito"],
    style: ds,
    fallback: "Helvetica"
  }], ["Calibri-Bold", {
    alias: "Calibri",
    style: fs,
    fallback: "Helvetica-Bold"
  }], ["Calibri-Italic", {
    alias: "Calibri",
    style: ps,
    fallback: "Helvetica-Oblique"
  }], ["Calibri-BoldItalic", {
    alias: "Calibri",
    style: ms,
    fallback: "Helvetica-BoldOblique"
  }], ["Wingdings", {
    local: ["Wingdings", "URW Dingbats"],
    style: ds
  }], ["Wingdings-Regular", {
    alias: "Wingdings"
  }], ["Wingdings-Bold", {
    alias: "Wingdings"
  }]]),
  ws = new Map([["Arial-Black", "ArialBlack"]]);
function getFamilyName(e) {
  var t = new Set(["thin", "extralight", "ultralight", "demilight", "semilight", "light", "book", "regular", "normal", "medium", "demibold", "semibold", "bold", "extrabold", "ultrabold", "black", "heavy", "extrablack", "ultrablack", "roman", "italic", "oblique", "ultracondensed", "extracondensed", "condensed", "semicondensed", "normal", "semiexpanded", "expanded", "extraexpanded", "ultraexpanded", "bolditalic"]);
  return e.split(/[- ,+]+/g).filter(function (e) {
    return !t.has(e.toLowerCase());
  }).join(" ");
}
function generateFont(_ref64, n, g) {
  var e = _ref64.alias,
    t = _ref64.local,
    i = _ref64.path,
    a = _ref64.fallback,
    s = _ref64.style,
    r = _ref64.ultimate;
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
  var c = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
  var C = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
  var h = {
    style: null,
    ultimate: null
  };
  if (t) {
    var _e282 = C ? " ".concat(C) : "";
    var _iterator55 = _createForOfIteratorHelper(t),
      _step55;
    try {
      for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
        var _i194 = _step55.value;
        n.push("local(".concat(_i194).concat(_e282, ")"));
      }
    } catch (err) {
      _iterator55.e(err);
    } finally {
      _iterator55.f();
    }
  }
  if (e) {
    var _t197 = ys.get(e),
      _r81 = C || function getStyleToAppend(e) {
        switch (e) {
          case fs:
            return "Bold";
          case ps:
            return "Italic";
          case ms:
            return "Bold Italic";
          default:
            if ("bold" === (e === null || e === void 0 ? void 0 : e.weight)) return "Bold";
            if ("italic" === (e === null || e === void 0 ? void 0 : e.style)) return "Italic";
        }
        return "";
      }(s);
    Object.assign(h, generateFont(_t197, n, g, o && !a, c && !i, _r81));
  }
  s && (h.style = s);
  r && (h.ultimate = r);
  if (o && a) {
    var _e283 = ys.get(a),
      _generateFont = generateFont(_e283, n, g, o, c && !i, C),
      _t198 = _generateFont.ultimate;
    h.ultimate || (h.ultimate = _t198);
  }
  c && i && g && n.push("url(".concat(g).concat(i, ")"));
  return h;
}
function getFontSubstitution(e, t, i, a, s, r) {
  if (a.startsWith("InvalidPDFjsFont_")) return null;
  "TrueType" !== r && "Type1" !== r || !/^[A-Z]{6}\+/.test(a) || (a = a.slice(7));
  var n = a = normalizeFontName(a);
  var g = e.get(n);
  if (g) return g;
  var o = ys.get(a);
  if (!o) {
    var _iterator56 = _createForOfIteratorHelper(ws),
      _step56;
    try {
      for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
        var _ref65 = _step56.value;
        var _ref66 = _slicedToArray(_ref65, 2);
        var _e284 = _ref66[0];
        var _t199 = _ref66[1];
        if (a.startsWith(_e284)) {
          a = "".concat(_t199).concat(a.substring(_e284.length));
          o = ys.get(a);
          break;
        }
      }
    } catch (err) {
      _iterator56.e(err);
    } finally {
      _iterator56.f();
    }
  }
  var c = !1;
  if (!o) {
    o = ys.get(s);
    c = !0;
  }
  var C = "".concat(t.getDocId(), "_s").concat(t.createFontId());
  if (!o) {
    if (!validateFontName(a)) {
      warn("Cannot substitute the font because of its name: ".concat(a));
      e.set(n, null);
      return null;
    }
    var _t200 = /bold/gi.test(a),
      _i195 = /oblique|italic/gi.test(a),
      _s116 = _t200 && _i195 && ms || _t200 && fs || _i195 && ps || ds;
    g = {
      css: "\"".concat(getFamilyName(a), "\",").concat(C),
      guessFallback: !0,
      loadedName: C,
      baseFontName: a,
      src: "local(".concat(a, ")"),
      style: _s116
    };
    e.set(n, g);
    return g;
  }
  var h = [];
  c && validateFontName(a) && h.push("local(".concat(a, ")"));
  var _generateFont2 = generateFont(o, h, i),
    l = _generateFont2.style,
    Q = _generateFont2.ultimate,
    E = null === Q,
    u = E ? "" : ",".concat(Q);
  g = {
    css: "\"".concat(getFamilyName(a), "\",").concat(C).concat(u),
    guessFallback: E,
    loadedName: C,
    baseFontName: a,
    src: h.join(","),
    style: l
  };
  e.set(n, g);
  return g;
}
var _k3 = /*#__PURE__*/_classPrivateFieldLooseKey("k");
var _R3 = /*#__PURE__*/_classPrivateFieldLooseKey("R");
var ImageResizer = /*#__PURE__*/function () {
  function ImageResizer(e, t) {
    _classCallCheck(this, ImageResizer);
    this._imgData = e;
    this._isMask = t;
  }
  return _createClass(ImageResizer, [{
    key: "_createImage",
    value: function () {
      var _createImage2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this44 = this;
        var e, t, i, a, s, r, n, g, o, c, C, h, l, Q, E, u, d, _iterator57, _step57, _e285, _t201, _i196, _a175;
        return _regeneratorRuntime().wrap(function _callee13$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              e = this._encodeBMP();
              _context15.next = 3;
              return ImageResizer.canUseImageDecoder;
            case 3:
              if (!_context15.sent) {
                _context15.next = 8;
                break;
              }
              t = new ImageDecoder({
                data: e,
                type: "image/bmp",
                preferAnimation: !1,
                transfer: [e.buffer]
              });
              i = t.decode().catch(function (e) {
                warn("BMP image decoding failed: ".concat(e));
                return createImageBitmap(new Blob([_this44._encodeBMP().buffer], {
                  type: "image/bmp"
                }));
              }).finally(function () {
                t.close();
              });
              _context15.next = 9;
              break;
            case 8:
              i = createImageBitmap(new Blob([e.buffer], {
                type: "image/bmp"
              }));
            case 9:
              a = ImageResizer.MAX_AREA, s = ImageResizer.MAX_DIM, r = this._imgData, n = r.width, g = r.height, o = Math.max(n / s, g / s, Math.sqrt(n * g / a)), c = Math.max(o, 2), C = Math.round(10 * (o + 1.25)) / 10 / c, h = Math.floor(Math.log2(C)), l = new Array(h + 2).fill(2);
              l[0] = c;
              l.splice(-1, 1, C / (1 << h));
              Q = n, E = g;
              _context15.next = 15;
              return i;
            case 15:
              u = _context15.sent;
              d = u.image || u;
              _iterator57 = _createForOfIteratorHelper(l);
              try {
                for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
                  _e285 = _step57.value;
                  _t201 = Q, _i196 = E;
                  Q = Math.floor(Q / _e285) - 1;
                  E = Math.floor(E / _e285) - 1;
                  _a175 = new OffscreenCanvas(Q, E);
                  _a175.getContext("2d").drawImage(d, 0, 0, _t201, _i196, 0, 0, Q, E);
                  d.close();
                  d = _a175.transferToImageBitmap();
                }
              } catch (err) {
                _iterator57.e(err);
              } finally {
                _iterator57.f();
              }
              r.data = null;
              r.bitmap = d;
              r.width = Q;
              r.height = E;
              return _context15.abrupt("return", r);
            case 24:
            case "end":
              return _context15.stop();
          }
        }, _callee13, this);
      }));
      function _createImage() {
        return _createImage2.apply(this, arguments);
      }
      return _createImage;
    }()
  }, {
    key: "_encodeBMP",
    value: function _encodeBMP() {
      var _this$_imgData = this._imgData,
        e = _this$_imgData.width,
        t = _this$_imgData.height,
        i = _this$_imgData.kind;
      var a,
        s = this._imgData.data,
        r = new Uint8Array(0),
        n = r,
        g = 0;
      switch (i) {
        case b:
          {
            a = 1;
            r = new Uint8Array(this._isMask ? [255, 255, 255, 255, 0, 0, 0, 0] : [0, 0, 0, 0, 255, 255, 255, 255]);
            var _i197 = e + 7 >> 3,
              _n65 = _i197 + 3 & -4;
            if (_i197 !== _n65) {
              var _e286 = new Uint8Array(_n65 * t);
              var _a176 = 0;
              for (var _r82 = 0, _g43 = t * _i197; _r82 < _g43; _r82 += _i197, _a176 += _n65) _e286.set(s.subarray(_r82, _r82 + _i197), _a176);
              s = _e286;
            }
            break;
          }
        case F:
          a = 24;
          if (3 & e) {
            var _i198 = 3 * e,
              _a177 = _i198 + 3 & -4,
              _r83 = _a177 - _i198,
              _n66 = new Uint8Array(_a177 * t);
            var _g44 = 0;
            for (var _e287 = 0, _a178 = t * _i198; _e287 < _a178; _e287 += _i198) {
              var _t202 = s.subarray(_e287, _e287 + _i198);
              for (var _e288 = 0; _e288 < _i198; _e288 += 3) {
                _n66[_g44++] = _t202[_e288 + 2];
                _n66[_g44++] = _t202[_e288 + 1];
                _n66[_g44++] = _t202[_e288];
              }
              _g44 += _r83;
            }
            s = _n66;
          } else for (var _e289 = 0, _t203 = s.length; _e289 < _t203; _e289 += 3) {
            var _t204 = s[_e289];
            s[_e289] = s[_e289 + 2];
            s[_e289 + 2] = _t204;
          }
          break;
        case S:
          a = 32;
          g = 3;
          n = new Uint8Array(68);
          var _i199 = new DataView(n.buffer);
          if (FeatureTest.isLittleEndian) {
            _i199.setUint32(0, 255, !0);
            _i199.setUint32(4, 65280, !0);
            _i199.setUint32(8, 16711680, !0);
            _i199.setUint32(12, 4278190080, !0);
          } else {
            _i199.setUint32(0, 4278190080, !0);
            _i199.setUint32(4, 16711680, !0);
            _i199.setUint32(8, 65280, !0);
            _i199.setUint32(12, 255, !0);
          }
          break;
        default:
          throw new Error("invalid format");
      }
      var o = 0;
      var c = 40 + n.length,
        C = 14 + c + r.length + s.length,
        h = new Uint8Array(C),
        l = new DataView(h.buffer);
      l.setUint16(o, 19778, !0);
      o += 2;
      l.setUint32(o, C, !0);
      o += 4;
      l.setUint32(o, 0, !0);
      o += 4;
      l.setUint32(o, 14 + c + r.length, !0);
      o += 4;
      l.setUint32(o, c, !0);
      o += 4;
      l.setInt32(o, e, !0);
      o += 4;
      l.setInt32(o, -t, !0);
      o += 4;
      l.setUint16(o, 1, !0);
      o += 2;
      l.setUint16(o, a, !0);
      o += 2;
      l.setUint32(o, g, !0);
      o += 4;
      l.setUint32(o, 0, !0);
      o += 4;
      l.setInt32(o, 0, !0);
      o += 4;
      l.setInt32(o, 0, !0);
      o += 4;
      l.setUint32(o, r.length / 4, !0);
      o += 4;
      l.setUint32(o, 0, !0);
      o += 4;
      h.set(n, o);
      o += n.length;
      h.set(r, o);
      o += r.length;
      h.set(s, o);
      return h;
    }
  }], [{
    key: "canUseImageDecoder",
    get: function get() {
      return shadow(this, "canUseImageDecoder", _classPrivateFieldLooseBase(this, _R3)[_R3] || "undefined" == typeof ImageDecoder ? Promise.resolve(!1) : ImageDecoder.isTypeSupported("image/bmp"));
    }
  }, {
    key: "needsToBeResized",
    value: function needsToBeResized(e, t) {
      if (e <= _classPrivateFieldLooseBase(this, _k3)[_k3] && t <= _classPrivateFieldLooseBase(this, _k3)[_k3]) return !1;
      var i = this.MAX_DIM;
      if (e > i || t > i) return !0;
      var a = e * t;
      if (this._hasMaxArea) return a > this.MAX_AREA;
      if (a < Math.pow(_classPrivateFieldLooseBase(this, _k3)[_k3], 2)) return !1;
      if (this._areGoodDims(e, t)) {
        _classPrivateFieldLooseBase(this, _k3)[_k3] = Math.max(_classPrivateFieldLooseBase(this, _k3)[_k3], Math.floor(Math.sqrt(e * t)));
        return !1;
      }
      _classPrivateFieldLooseBase(this, _k3)[_k3] = this._guessMax(_classPrivateFieldLooseBase(this, _k3)[_k3], i, 128, 0);
      return a > (this.MAX_AREA = Math.pow(_classPrivateFieldLooseBase(this, _k3)[_k3], 2));
    }
  }, {
    key: "MAX_DIM",
    get: function get() {
      return shadow(this, "MAX_DIM", this._guessMax(2048, 65537, 0, 1));
    }
  }, {
    key: "MAX_AREA",
    get: function get() {
      this._hasMaxArea = !0;
      return shadow(this, "MAX_AREA", Math.pow(this._guessMax(_classPrivateFieldLooseBase(this, _k3)[_k3], this.MAX_DIM, 128, 0), 2));
    },
    set: function set(e) {
      if (e >= 0) {
        this._hasMaxArea = !0;
        shadow(this, "MAX_AREA", e);
      }
    }
  }, {
    key: "setMaxArea",
    value: function setMaxArea(e) {
      this._hasMaxArea || (this.MAX_AREA = e >> 2);
    }
  }, {
    key: "setOptions",
    value: function setOptions(e) {
      var _e$maxArea, _e$isChrome;
      this.setMaxArea((_e$maxArea = e.maxArea) !== null && _e$maxArea !== void 0 ? _e$maxArea : -1);
      _classPrivateFieldLooseBase(this, _R3)[_R3] = (_e$isChrome = e.isChrome) !== null && _e$isChrome !== void 0 ? _e$isChrome : !1;
    }
  }, {
    key: "_areGoodDims",
    value: function _areGoodDims(e, t) {
      try {
        var i = new OffscreenCanvas(e, t),
          _a179 = i.getContext("2d");
        _a179.fillRect(0, 0, 1, 1);
        var _s117 = _a179.getImageData(0, 0, 1, 1).data[3];
        i.width = i.height = 1;
        return 0 !== _s117;
      } catch (_unused9) {
        return !1;
      }
    }
  }, {
    key: "_guessMax",
    value: function _guessMax(e, t, i, a) {
      for (; e + i + 1 < t;) {
        var _i200 = Math.floor((e + t) / 2),
          _s118 = a || _i200;
        this._areGoodDims(_i200, _s118) ? e = _i200 : t = _i200;
      }
      return e;
    }
  }, {
    key: "createImage",
    value: function () {
      var _createImage3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(e) {
        var t,
          _args16 = arguments;
        return _regeneratorRuntime().wrap(function _callee14$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              t = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : !1;
              return _context16.abrupt("return", new ImageResizer(e, t)._createImage());
            case 2:
            case "end":
              return _context16.stop();
          }
        }, _callee14);
      }));
      function createImage(_x25) {
        return _createImage3.apply(this, arguments);
      }
      return createImage;
    }()
  }]);
}();
Object.defineProperty(ImageResizer, _k3, {
  writable: true,
  value: 2048
});
Object.defineProperty(ImageResizer, _R3, {
  writable: true,
  value: !1
});
var Ds = 3285377520,
  bs = 4294901760,
  Fs = 65535;
var MurmurHash3_64 = /*#__PURE__*/function () {
  function MurmurHash3_64(e) {
    _classCallCheck(this, MurmurHash3_64);
    this.h1 = e ? 4294967295 & e : Ds;
    this.h2 = e ? 4294967295 & e : Ds;
  }
  return _createClass(MurmurHash3_64, [{
    key: "update",
    value: function update(e) {
      var t, i;
      if ("string" == typeof e) {
        t = new Uint8Array(2 * e.length);
        i = 0;
        for (var _a180 = 0, _s119 = e.length; _a180 < _s119; _a180++) {
          var _s120 = e.charCodeAt(_a180);
          if (_s120 <= 255) t[i++] = _s120;else {
            t[i++] = _s120 >>> 8;
            t[i++] = 255 & _s120;
          }
        }
      } else {
        if (!ArrayBuffer.isView(e)) throw new Error("Invalid data format, must be a string or TypedArray.");
        t = e.slice();
        i = t.byteLength;
      }
      var a = i >> 2,
        s = i - 4 * a,
        r = new Uint32Array(t.buffer, 0, a);
      var n = 0,
        g = 0,
        o = this.h1,
        c = this.h2;
      var C = 3432918353,
        h = 461845907,
        l = 11601,
        Q = 13715;
      for (var _e290 = 0; _e290 < a; _e290++) if (1 & _e290) {
        n = r[_e290];
        n = n * C & bs | n * l & Fs;
        n = n << 15 | n >>> 17;
        n = n * h & bs | n * Q & Fs;
        o ^= n;
        o = o << 13 | o >>> 19;
        o = 5 * o + 3864292196;
      } else {
        g = r[_e290];
        g = g * C & bs | g * l & Fs;
        g = g << 15 | g >>> 17;
        g = g * h & bs | g * Q & Fs;
        c ^= g;
        c = c << 13 | c >>> 19;
        c = 5 * c + 3864292196;
      }
      n = 0;
      switch (s) {
        case 3:
          n ^= t[4 * a + 2] << 16;
        case 2:
          n ^= t[4 * a + 1] << 8;
        case 1:
          n ^= t[4 * a];
          n = n * C & bs | n * l & Fs;
          n = n << 15 | n >>> 17;
          n = n * h & bs | n * Q & Fs;
          1 & a ? o ^= n : c ^= n;
      }
      this.h1 = o;
      this.h2 = c;
    }
  }, {
    key: "hexdigest",
    value: function hexdigest() {
      var e = this.h1,
        t = this.h2;
      e ^= t >>> 1;
      e = 3981806797 * e & bs | 36045 * e & Fs;
      t = 4283543511 * t & bs | (2950163797 * (t << 16 | e >>> 16) & bs) >>> 16;
      e ^= t >>> 1;
      e = 444984403 * e & bs | 60499 * e & Fs;
      t = 3301882366 * t & bs | (3120437893 * (t << 16 | e >>> 16) & bs) >>> 16;
      e ^= t >>> 1;
      return (e >>> 0).toString(16).padStart(8, "0") + (t >>> 0).toString(16).padStart(8, "0");
    }
  }]);
}();
function addState(e, t, i, a, s) {
  var r = e;
  for (var _e291 = 0, _i201 = t.length - 1; _e291 < _i201; _e291++) {
    var _r84;
    var _i202 = t[_e291];
    r = (_r84 = r)[_i202] || (_r84[_i202] = []);
  }
  r[t.at(-1)] = {
    checkFn: i,
    iterateFn: a,
    processFn: s
  };
}
var Ss = [];
addState(Ss, [GA, UA, ze, xA], null, function iterateInlineImageGroup(e, t) {
  var i = e.fnArray,
    a = (t - (e.iCurr - 3)) % 4;
  switch (a) {
    case 0:
      return i[t] === GA;
    case 1:
      return i[t] === UA;
    case 2:
      return i[t] === ze;
    case 3:
      return i[t] === xA;
  }
  throw new Error("iterateInlineImageGroup - invalid pos: ".concat(a));
}, function foundInlineImageGroup(e, t) {
  var i = e.fnArray,
    a = e.argsArray,
    s = e.iCurr,
    r = s - 3,
    n = s - 2,
    g = s - 1,
    o = Math.min(Math.floor((t - r) / 4), 200);
  if (o < 10) return t - (t - r) % 4;
  var c = 0;
  var C = [];
  var h = 0,
    l = 1,
    Q = 1;
  for (var _e292 = 0; _e292 < o; _e292++) {
    var _t205 = a[n + (_e292 << 2)],
      _i203 = a[g + (_e292 << 2)][0];
    if (l + _i203.width > 1e3) {
      c = Math.max(c, l);
      Q += h + 2;
      l = 0;
      h = 0;
    }
    C.push({
      transform: _t205,
      x: l,
      y: Q,
      w: _i203.width,
      h: _i203.height
    });
    l += _i203.width + 2;
    h = Math.max(h, _i203.height);
  }
  var E = Math.max(c, l) + 1,
    u = Q + h + 1,
    d = new Uint8Array(E * u * 4),
    f = E << 2;
  for (var _e293 = 0; _e293 < o; _e293++) {
    var _t206 = a[g + (_e293 << 2)][0].data,
      _i204 = C[_e293].w << 2;
    var _s121 = 0,
      _r85 = C[_e293].x + C[_e293].y * E << 2;
    d.set(_t206.subarray(0, _i204), _r85 - f);
    for (var _a181 = 0, _n67 = C[_e293].h; _a181 < _n67; _a181++) {
      d.set(_t206.subarray(_s121, _s121 + _i204), _r85);
      _s121 += _i204;
      _r85 += f;
    }
    d.set(_t206.subarray(_s121 - _i204, _s121), _r85);
    for (; _r85 >= 0;) {
      _t206[_r85 - 4] = _t206[_r85];
      _t206[_r85 - 3] = _t206[_r85 + 1];
      _t206[_r85 - 2] = _t206[_r85 + 2];
      _t206[_r85 - 1] = _t206[_r85 + 3];
      _t206[_r85 + _i204] = _t206[_r85 + _i204 - 4];
      _t206[_r85 + _i204 + 1] = _t206[_r85 + _i204 - 3];
      _t206[_r85 + _i204 + 2] = _t206[_r85 + _i204 - 2];
      _t206[_r85 + _i204 + 3] = _t206[_r85 + _i204 - 1];
      _r85 -= f;
    }
  }
  var p = {
    width: E,
    height: u
  };
  if (e.isOffscreenCanvasSupported) {
    var _e294 = new OffscreenCanvas(E, u);
    _e294.getContext("2d").putImageData(new ImageData(new Uint8ClampedArray(d.buffer), E, u), 0, 0);
    p.bitmap = _e294.transferToImageBitmap();
    p.data = null;
  } else {
    p.kind = S;
    p.data = d;
  }
  i.splice(r, 4 * o, _e);
  a.splice(r, 4 * o, [p, C]);
  return r + 1;
});
addState(Ss, [GA, UA, Xe, xA], null, function iterateImageMaskGroup(e, t) {
  var i = e.fnArray,
    a = (t - (e.iCurr - 3)) % 4;
  switch (a) {
    case 0:
      return i[t] === GA;
    case 1:
      return i[t] === UA;
    case 2:
      return i[t] === Xe;
    case 3:
      return i[t] === xA;
  }
  throw new Error("iterateImageMaskGroup - invalid pos: ".concat(a));
}, function foundImageMaskGroup(e, t) {
  var i = e.fnArray,
    a = e.argsArray,
    s = e.iCurr,
    r = s - 3,
    n = s - 2,
    g = s - 1;
  var o = Math.floor((t - r) / 4);
  if (o < 10) return t - (t - r) % 4;
  var c,
    C,
    h = !1;
  var l = a[g][0],
    Q = a[n][0],
    E = a[n][1],
    u = a[n][2],
    d = a[n][3];
  if (E === u) {
    h = !0;
    c = n + 4;
    var _e295 = g + 4;
    for (var _t207 = 1; _t207 < o; _t207++, c += 4, _e295 += 4) {
      C = a[c];
      if (a[_e295][0] !== l || C[0] !== Q || C[1] !== E || C[2] !== u || C[3] !== d) {
        _t207 < 10 ? h = !1 : o = _t207;
        break;
      }
    }
  }
  if (h) {
    o = Math.min(o, 1e3);
    var _e296 = new Float32Array(2 * o);
    c = n;
    for (var _t208 = 0; _t208 < o; _t208++, c += 4) {
      C = a[c];
      _e296[_t208 << 1] = C[4];
      _e296[1 + (_t208 << 1)] = C[5];
    }
    i.splice(r, 4 * o, At);
    a.splice(r, 4 * o, [l, Q, E, u, d, _e296]);
  } else {
    o = Math.min(o, 100);
    var _e297 = [];
    for (var _t209 = 0; _t209 < o; _t209++) {
      C = a[n + (_t209 << 2)];
      var _i205 = a[g + (_t209 << 2)][0];
      _e297.push({
        data: _i205.data,
        width: _i205.width,
        height: _i205.height,
        interpolate: _i205.interpolate,
        count: _i205.count,
        transform: C
      });
    }
    i.splice(r, 4 * o, Ze);
    a.splice(r, 4 * o, [_e297]);
  }
  return r + 1;
});
addState(Ss, [GA, UA, Ve, xA], function (e) {
  var t = e.argsArray,
    i = e.iCurr - 2;
  return 0 === t[i][1] && 0 === t[i][2];
}, function iterateImageGroup(e, t) {
  var i = e.fnArray,
    a = e.argsArray,
    s = (t - (e.iCurr - 3)) % 4;
  switch (s) {
    case 0:
      return i[t] === GA;
    case 1:
      if (i[t] !== UA) return !1;
      var _s122 = e.iCurr - 2,
        _r86 = a[_s122][0],
        _n68 = a[_s122][3];
      return a[t][0] === _r86 && 0 === a[t][1] && 0 === a[t][2] && a[t][3] === _n68;
    case 2:
      if (i[t] !== Ve) return !1;
      var _g45 = a[e.iCurr - 1][0];
      return a[t][0] === _g45;
    case 3:
      return i[t] === xA;
  }
  throw new Error("iterateImageGroup - invalid pos: ".concat(s));
}, function (e, t) {
  var i = e.fnArray,
    a = e.argsArray,
    s = e.iCurr,
    r = s - 3,
    n = s - 2,
    g = a[s - 1][0],
    o = a[n][0],
    c = a[n][3],
    C = Math.min(Math.floor((t - r) / 4), 1e3);
  if (C < 3) return t - (t - r) % 4;
  var h = new Float32Array(2 * C);
  var l = n;
  for (var _e298 = 0; _e298 < C; _e298++, l += 4) {
    var _t210 = a[l];
    h[_e298 << 1] = _t210[4];
    h[1 + (_e298 << 1)] = _t210[5];
  }
  var Q = [g, o, c, h];
  i.splice(r, 4 * C, $e);
  a.splice(r, 4 * C, Q);
  return r + 1;
});
addState(Ss, [$A, se, Ie, Ce, Ae], null, function iterateShowTextGroup(e, t) {
  var i = e.fnArray,
    a = e.argsArray,
    s = (t - (e.iCurr - 4)) % 5;
  switch (s) {
    case 0:
      return i[t] === $A;
    case 1:
      return i[t] === se;
    case 2:
      return i[t] === Ie;
    case 3:
      if (i[t] !== Ce) return !1;
      var _s123 = e.iCurr - 3,
        _r87 = a[_s123][0],
        _n69 = a[_s123][1];
      return a[t][0] === _r87 && a[t][1] === _n69;
    case 4:
      return i[t] === Ae;
  }
  throw new Error("iterateShowTextGroup - invalid pos: ".concat(s));
}, function (e, t) {
  var i = e.fnArray,
    a = e.argsArray,
    s = e.iCurr,
    r = s - 4,
    n = s - 3,
    g = s - 2,
    o = s - 1,
    c = s,
    C = a[n][0],
    h = a[n][1];
  var l = Math.min(Math.floor((t - r) / 5), 1e3);
  if (l < 3) return t - (t - r) % 5;
  var Q = r;
  if (r >= 4 && i[r - 4] === i[n] && i[r - 3] === i[g] && i[r - 2] === i[o] && i[r - 1] === i[c] && a[r - 4][0] === C && a[r - 4][1] === h) {
    l++;
    Q -= 5;
  }
  var E = Q + 4;
  for (var _e299 = 1; _e299 < l; _e299++) {
    i.splice(E, 3);
    a.splice(E, 3);
    E += 2;
  }
  return E + 1;
});
var NullOptimizer = /*#__PURE__*/function () {
  function NullOptimizer(e) {
    _classCallCheck(this, NullOptimizer);
    this.queue = e;
  }
  return _createClass(NullOptimizer, [{
    key: "_optimize",
    value: function _optimize() {}
  }, {
    key: "push",
    value: function push(e, t) {
      this.queue.fnArray.push(e);
      this.queue.argsArray.push(t);
      this._optimize();
    }
  }, {
    key: "flush",
    value: function flush() {}
  }, {
    key: "reset",
    value: function reset() {}
  }]);
}();
var QueueOptimizer = /*#__PURE__*/function (_NullOptimizer) {
  function QueueOptimizer(e) {
    var _this45;
    _classCallCheck(this, QueueOptimizer);
    _this45 = _callSuper(this, QueueOptimizer, [e]);
    _this45.state = null;
    _this45.context = {
      iCurr: 0,
      fnArray: e.fnArray,
      argsArray: e.argsArray,
      isOffscreenCanvasSupported: !1
    };
    _this45.match = null;
    _this45.lastProcessed = 0;
    return _this45;
  }
  _inherits(QueueOptimizer, _NullOptimizer);
  return _createClass(QueueOptimizer, [{
    key: "isOffscreenCanvasSupported",
    set: function set(e) {
      this.context.isOffscreenCanvasSupported = e;
    }
  }, {
    key: "_optimize",
    value: function _optimize() {
      var e = this.queue.fnArray;
      var t = this.lastProcessed,
        i = e.length,
        a = this.state,
        s = this.match;
      if (!a && !s && t + 1 === i && !Ss[e[t]]) {
        this.lastProcessed = i;
        return;
      }
      var r = this.context;
      for (; t < i;) {
        if (s) {
          if ((0, s.iterateFn)(r, t)) {
            t++;
            continue;
          }
          t = (0, s.processFn)(r, t + 1);
          i = e.length;
          s = null;
          a = null;
          if (t >= i) break;
        }
        a = (a || Ss)[e[t]];
        if (a && !Array.isArray(a)) {
          r.iCurr = t;
          t++;
          if (!a.checkFn || (0, a.checkFn)(r)) {
            s = a;
            a = null;
          } else a = null;
        } else t++;
      }
      this.state = a;
      this.match = s;
      this.lastProcessed = t;
    }
  }, {
    key: "flush",
    value: function flush() {
      for (; this.match;) {
        var _e300 = this.queue.fnArray.length;
        this.lastProcessed = (0, this.match.processFn)(this.context, _e300);
        this.match = null;
        this.state = null;
        this._optimize();
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.state = null;
      this.match = null;
      this.lastProcessed = 0;
    }
  }]);
}(NullOptimizer);
var OperatorList = /*#__PURE__*/function () {
  function OperatorList() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var t = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, OperatorList);
    this._streamSink = t;
    this.fnArray = [];
    this.argsArray = [];
    this.optimizer = !t || e & E ? new NullOptimizer(this) : new QueueOptimizer(this);
    this.dependencies = new Set();
    this._totalLength = 0;
    this.weight = 0;
    this._resolved = t ? null : Promise.resolve();
  }
  return _createClass(OperatorList, [{
    key: "isOffscreenCanvasSupported",
    set: function set(e) {
      this.optimizer.isOffscreenCanvasSupported = e;
    }
  }, {
    key: "length",
    get: function get() {
      return this.argsArray.length;
    }
  }, {
    key: "ready",
    get: function get() {
      return this._resolved || this._streamSink.ready;
    }
  }, {
    key: "totalLength",
    get: function get() {
      return this._totalLength + this.length;
    }
  }, {
    key: "addOp",
    value: function addOp(e, t) {
      this.optimizer.push(e, t);
      this.weight++;
      this._streamSink && (this.weight >= OperatorList.CHUNK_SIZE || this.weight >= OperatorList.CHUNK_SIZE_ABOUT && (e === xA || e === Ae)) && this.flush();
    }
  }, {
    key: "addImageOps",
    value: function addImageOps(e, t, i) {
      void 0 !== i && this.addOp(Je, ["OC", i]);
      this.addOp(e, t);
      void 0 !== i && this.addOp(Ye, []);
    }
  }, {
    key: "addDependency",
    value: function addDependency(e) {
      if (!this.dependencies.has(e)) {
        this.dependencies.add(e);
        this.addOp(yA, [e]);
      }
    }
  }, {
    key: "addDependencies",
    value: function addDependencies(e) {
      var _iterator58 = _createForOfIteratorHelper(e),
        _step58;
      try {
        for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
          var t = _step58.value;
          this.addDependency(t);
        }
      } catch (err) {
        _iterator58.e(err);
      } finally {
        _iterator58.f();
      }
    }
  }, {
    key: "addOpList",
    value: function addOpList(e) {
      if (e instanceof OperatorList) {
        var _iterator59 = _createForOfIteratorHelper(e.dependencies),
          _step59;
        try {
          for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
            var _t211 = _step59.value;
            this.dependencies.add(_t211);
          }
        } catch (err) {
          _iterator59.e(err);
        } finally {
          _iterator59.f();
        }
        for (var t = 0, i = e.length; t < i; t++) this.addOp(e.fnArray[t], e.argsArray[t]);
      } else warn('addOpList - ignoring invalid "opList" parameter.');
    }
  }, {
    key: "getIR",
    value: function getIR() {
      return {
        fnArray: this.fnArray,
        argsArray: this.argsArray,
        length: this.length
      };
    }
  }, {
    key: "_transfers",
    get: function get() {
      var _t212$data;
      var e = [],
        t = this.fnArray,
        i = this.argsArray,
        a = this.length;
      for (var _s124 = 0; _s124 < a; _s124++) switch (t[_s124]) {
        case ze:
        case _e:
        case Xe:
          var _t212 = i[_s124][0];
          !_t212.cached && ((_t212$data = _t212.data) === null || _t212$data === void 0 ? void 0 : _t212$data.buffer) instanceof ArrayBuffer && e.push(_t212.data.buffer);
      }
      return e;
    }
  }, {
    key: "flush",
    value: function flush() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.optimizer.flush();
      var i = this.length;
      this._totalLength += i;
      this._streamSink.enqueue({
        fnArray: this.fnArray,
        argsArray: this.argsArray,
        lastChunk: e,
        separateAnnots: t,
        length: i
      }, 1, this._transfers);
      this.dependencies.clear();
      this.fnArray.length = 0;
      this.argsArray.length = 0;
      this.weight = 0;
      this.optimizer.reset();
    }
  }]);
}();
_OperatorList = OperatorList;
OperatorList.CHUNK_SIZE = 1e3;
OperatorList.CHUNK_SIZE_ABOUT = _OperatorList.CHUNK_SIZE - 5;
function decodeAndClamp(e, t, i, a) {
  (e = t + e * i) < 0 ? e = 0 : e > a && (e = a);
  return e;
}
function resizeImageMask(e, t, i, a, s, r) {
  var n = s * r;
  var g;
  g = t <= 8 ? new Uint8Array(n) : t <= 16 ? new Uint16Array(n) : new Uint32Array(n);
  var o = i / s,
    c = a / r;
  var C,
    h,
    l,
    Q,
    E = 0;
  var u = new Uint16Array(s),
    d = i;
  for (C = 0; C < s; C++) u[C] = Math.floor(C * o);
  for (C = 0; C < r; C++) {
    l = Math.floor(C * c) * d;
    for (h = 0; h < s; h++) {
      Q = l + u[h];
      g[E++] = e[Q];
    }
  }
  return g;
}
var _N3 = /*#__PURE__*/_classPrivateFieldLooseKey("N");
var PDFImage = /*#__PURE__*/function () {
  function PDFImage(_ref67) {
    var _e301 = _ref67.xref,
      _t213 = _ref67.res,
      _i206 = _ref67.image,
      _ref67$isInline = _ref67.isInline,
      a = _ref67$isInline === void 0 ? !1 : _ref67$isInline,
      _ref67$smask = _ref67.smask,
      s = _ref67$smask === void 0 ? null : _ref67$smask,
      _ref67$mask = _ref67.mask,
      r = _ref67$mask === void 0 ? null : _ref67$mask,
      _ref67$isMask = _ref67.isMask,
      n = _ref67$isMask === void 0 ? !1 : _ref67$isMask,
      g = _ref67.pdfFunctionFactory,
      o = _ref67.localColorSpaceCache;
    _classCallCheck(this, PDFImage);
    Object.defineProperty(this, _N3, {
      value: _N4
    });
    this.image = _i206;
    var c = _i206.dict,
      C = c.get("F", "Filter");
    var h;
    if (C instanceof Name) h = C.name;else if (Array.isArray(C)) {
      var t = _e301.fetchIfRef(C[0]);
      t instanceof Name && (h = t.name);
    }
    switch (h) {
      case "JPXDecode":
        var _JpxImage$parseImageP = JpxImage.parseImageProperties(_i206.stream);
        _i206.width = _JpxImage$parseImageP.width;
        _i206.height = _JpxImage$parseImageP.height;
        _i206.numComps = _JpxImage$parseImageP.componentsCount;
        _i206.bitsPerComponent = _JpxImage$parseImageP.bitsPerComponent;
        _i206.stream.reset();
        this.jpxDecoderOptions = {
          numComponents: 0,
          isIndexedColormap: !1,
          smaskInData: c.has("SMaskInData")
        };
        break;
      case "JBIG2Decode":
        _i206.bitsPerComponent = 1;
        _i206.numComps = 1;
    }
    var l = c.get("W", "Width"),
      Q = c.get("H", "Height");
    if (Number.isInteger(_i206.width) && _i206.width > 0 && Number.isInteger(_i206.height) && _i206.height > 0 && (_i206.width !== l || _i206.height !== Q)) {
      warn("PDFImage - using the Width/Height of the image data, rather than the image dictionary.");
      l = _i206.width;
      Q = _i206.height;
    }
    if (l < 1 || Q < 1) throw new FormatError("Invalid image width: ".concat(l, " or height: ").concat(Q));
    this.width = l;
    this.height = Q;
    this.interpolate = c.get("I", "Interpolate");
    this.imageMask = c.get("IM", "ImageMask") || !1;
    this.matte = c.get("Matte") || !1;
    var E = _i206.bitsPerComponent;
    if (!E) {
      E = c.get("BPC", "BitsPerComponent");
      if (!E) {
        if (!this.imageMask) throw new FormatError("Bits per component missing in image: ".concat(this.imageMask));
        E = 1;
      }
    }
    this.bpc = E;
    if (!this.imageMask) {
      var _this$jpxDecoderOptio;
      var _s125 = c.getRaw("CS") || c.getRaw("ColorSpace");
      var _r88 = !!_s125;
      if (_r88) ((_this$jpxDecoderOptio = this.jpxDecoderOptions) === null || _this$jpxDecoderOptio === void 0 ? void 0 : _this$jpxDecoderOptio.smaskInData) && (_s125 = Name.get("DeviceRGBA"));else if (this.jpxDecoderOptions) _s125 = Name.get("DeviceRGBA");else switch (_i206.numComps) {
        case 1:
          _s125 = Name.get("DeviceGray");
          break;
        case 3:
          _s125 = Name.get("DeviceRGB");
          break;
        case 4:
          _s125 = Name.get("DeviceCMYK");
          break;
        default:
          throw new Error("Images with ".concat(_i206.numComps, " color components not supported."));
      }
      this.colorSpace = ColorSpace.parse({
        cs: _s125,
        xref: _e301,
        resources: a ? _t213 : null,
        pdfFunctionFactory: g,
        localColorSpaceCache: o
      });
      this.numComps = this.colorSpace.numComps;
      if (this.jpxDecoderOptions) {
        this.jpxDecoderOptions.numComponents = _r88 ? this.numComp : 0;
        this.jpxDecoderOptions.isIndexedColormap = "Indexed" === this.colorSpace.name;
      }
    }
    this.decode = c.getArray("D", "Decode");
    this.needsDecode = !1;
    if (this.decode && (this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode, E) || n && !ColorSpace.isDefaultDecode(this.decode, 1))) {
      var _this$colorSpace;
      this.needsDecode = !0;
      var _e302 = (1 << E) - 1;
      this.decodeCoefficients = [];
      this.decodeAddends = [];
      var _t214 = "Indexed" === ((_this$colorSpace = this.colorSpace) === null || _this$colorSpace === void 0 ? void 0 : _this$colorSpace.name);
      for (var i = 0, _a182 = 0; i < this.decode.length; i += 2, ++_a182) {
        var _s126 = this.decode[i],
          _r89 = this.decode[i + 1];
        this.decodeCoefficients[_a182] = _t214 ? (_r89 - _s126) / _e302 : _r89 - _s126;
        this.decodeAddends[_a182] = _t214 ? _s126 : _e302 * _s126;
      }
    }
    if (s) this.smask = new PDFImage({
      xref: _e301,
      res: _t213,
      image: s,
      isInline: a,
      pdfFunctionFactory: g,
      localColorSpaceCache: o
    });else if (r) if (r instanceof BaseStream) {
      r.dict.get("IM", "ImageMask") ? this.mask = new PDFImage({
        xref: _e301,
        res: _t213,
        image: r,
        isInline: a,
        isMask: !0,
        pdfFunctionFactory: g,
        localColorSpaceCache: o
      }) : warn("Ignoring /Mask in image without /ImageMask.");
    } else this.mask = r;
  }
  return _createClass(PDFImage, [{
    key: "drawWidth",
    get: function get() {
      var _this$smask, _this$mask;
      return Math.max(this.width, ((_this$smask = this.smask) === null || _this$smask === void 0 ? void 0 : _this$smask.width) || 0, ((_this$mask = this.mask) === null || _this$mask === void 0 ? void 0 : _this$mask.width) || 0);
    }
  }, {
    key: "drawHeight",
    get: function get() {
      var _this$smask2, _this$mask2;
      return Math.max(this.height, ((_this$smask2 = this.smask) === null || _this$smask2 === void 0 ? void 0 : _this$smask2.height) || 0, ((_this$mask2 = this.mask) === null || _this$mask2 === void 0 ? void 0 : _this$mask2.height) || 0);
    }
  }, {
    key: "decodeBuffer",
    value: function decodeBuffer(e) {
      var t = this.bpc,
        i = this.numComps,
        a = this.decodeAddends,
        s = this.decodeCoefficients,
        r = (1 << t) - 1;
      var n, g;
      if (1 === t) {
        for (n = 0, g = e.length; n < g; n++) e[n] = +!e[n];
        return;
      }
      var o = 0;
      for (n = 0, g = this.width * this.height; n < g; n++) for (var _t215 = 0; _t215 < i; _t215++) {
        e[o] = decodeAndClamp(e[o], a[_t215], s[_t215], r);
        o++;
      }
    }
  }, {
    key: "getComponents",
    value: function getComponents(e) {
      var t = this.bpc;
      if (8 === t) return e;
      var i = this.width,
        a = this.height,
        s = this.numComps,
        r = i * a * s;
      var n,
        g = 0;
      n = t <= 8 ? new Uint8Array(r) : t <= 16 ? new Uint16Array(r) : new Uint32Array(r);
      var o = i * s,
        c = (1 << t) - 1;
      var C,
        h,
        l = 0;
      if (1 === t) {
        var _t216, _i207, _s127;
        for (var _r90 = 0; _r90 < a; _r90++) {
          _i207 = l + (-8 & o);
          _s127 = l + o;
          for (; l < _i207;) {
            h = e[g++];
            n[l] = h >> 7 & 1;
            n[l + 1] = h >> 6 & 1;
            n[l + 2] = h >> 5 & 1;
            n[l + 3] = h >> 4 & 1;
            n[l + 4] = h >> 3 & 1;
            n[l + 5] = h >> 2 & 1;
            n[l + 6] = h >> 1 & 1;
            n[l + 7] = 1 & h;
            l += 8;
          }
          if (l < _s127) {
            h = e[g++];
            _t216 = 128;
            for (; l < _s127;) {
              n[l++] = +!!(h & _t216);
              _t216 >>= 1;
            }
          }
        }
      } else {
        var _i208 = 0;
        h = 0;
        for (l = 0, C = r; l < C; ++l) {
          if (l % o == 0) {
            h = 0;
            _i208 = 0;
          }
          for (; _i208 < t;) {
            h = h << 8 | e[g++];
            _i208 += 8;
          }
          var _a183 = _i208 - t;
          var _s128 = h >> _a183;
          _s128 < 0 ? _s128 = 0 : _s128 > c && (_s128 = c);
          n[l] = _s128;
          h &= (1 << _a183) - 1;
          _i208 = _a183;
        }
      }
      return n;
    }
  }, {
    key: "fillOpacity",
    value: function () {
      var _fillOpacity = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(e, t, i, a, s) {
        var r, n, g, o, c, C, h, l, _e303, _t217, _i209, _e304, _a184;
        return _regeneratorRuntime().wrap(function _callee15$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              r = this.smask, n = this.mask;
              if (!r) {
                _context17.next = 10;
                break;
              }
              o = r.width;
              c = r.height;
              g = new Uint8ClampedArray(o * c);
              _context17.next = 7;
              return r.fillGrayBuffer(g);
            case 7:
              o === t && c === i || (g = resizeImageMask(g, r.bpc, o, c, t, i));
              _context17.next = 43;
              break;
            case 10:
              if (!n) {
                _context17.next = 43;
                break;
              }
              if (!(n instanceof PDFImage)) {
                _context17.next = 22;
                break;
              }
              o = n.width;
              c = n.height;
              g = new Uint8ClampedArray(o * c);
              n.numComps = 1;
              _context17.next = 18;
              return n.fillGrayBuffer(g);
            case 18:
              for (C = 0, h = o * c; C < h; ++C) g[C] = 255 - g[C];
              o === t && c === i || (g = resizeImageMask(g, n.bpc, o, c, t, i));
              _context17.next = 43;
              break;
            case 22:
              if (Array.isArray(n)) {
                _context17.next = 24;
                break;
              }
              throw new FormatError("Unknown mask format.");
            case 24:
              g = new Uint8ClampedArray(t * i);
              _e303 = this.numComps;
              C = 0, h = t * i;
            case 27:
              if (!(C < h)) {
                _context17.next = 43;
                break;
              }
              _t217 = 0;
              _i209 = C * _e303;
              l = 0;
            case 31:
              if (!(l < _e303)) {
                _context17.next = 39;
                break;
              }
              _e304 = s[_i209 + l], _a184 = 2 * l;
              if (!(_e304 < n[_a184] || _e304 > n[_a184 + 1])) {
                _context17.next = 36;
                break;
              }
              _t217 = 255;
              return _context17.abrupt("break", 39);
            case 36:
              ++l;
              _context17.next = 31;
              break;
            case 39:
              g[C] = _t217;
            case 40:
              ++C;
              _context17.next = 27;
              break;
            case 43:
              if (g) for (C = 0, l = 3, h = t * a; C < h; ++C, l += 4) e[l] = g[C];else for (C = 0, l = 3, h = t * a; C < h; ++C, l += 4) e[l] = 255;
            case 44:
            case "end":
              return _context17.stop();
          }
        }, _callee15, this);
      }));
      function fillOpacity(_x26, _x27, _x28, _x29, _x30) {
        return _fillOpacity.apply(this, arguments);
      }
      return fillOpacity;
    }()
  }, {
    key: "undoPreblend",
    value: function undoPreblend(e, t, i) {
      var _this$smask3;
      var a = (_this$smask3 = this.smask) === null || _this$smask3 === void 0 ? void 0 : _this$smask3.matte;
      if (!a) return;
      var s = this.colorSpace.getRgb(a, 0),
        r = s[0],
        n = s[1],
        g = s[2],
        o = t * i * 4;
      for (var _t218 = 0; _t218 < o; _t218 += 4) {
        var _i210 = e[_t218 + 3];
        if (0 === _i210) {
          e[_t218] = 255;
          e[_t218 + 1] = 255;
          e[_t218 + 2] = 255;
          continue;
        }
        var _a185 = 255 / _i210;
        e[_t218] = (e[_t218] - r) * _a185 + r;
        e[_t218 + 1] = (e[_t218 + 1] - n) * _a185 + n;
        e[_t218 + 2] = (e[_t218 + 2] - g) * _a185 + g;
      }
    }
  }, {
    key: "createImageData",
    value: function () {
      var _createImageData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var e,
          t,
          i,
          a,
          s,
          r,
          n,
          g,
          o,
          c,
          C,
          _e305,
          _e306,
          _r91,
          _o34,
          _t219,
          _e307,
          _i211,
          _e308,
          _t220,
          _t221,
          _s129,
          h,
          l,
          Q,
          E,
          u,
          d,
          f,
          p,
          m,
          _args18 = arguments;
        return _regeneratorRuntime().wrap(function _callee16$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              e = _args18.length > 0 && _args18[0] !== undefined ? _args18[0] : !1;
              t = _args18.length > 1 && _args18[1] !== undefined ? _args18[1] : !1;
              i = this.drawWidth, a = this.drawHeight, s = {
                width: i,
                height: a,
                interpolate: this.interpolate,
                kind: 0,
                data: null
              }, r = this.numComps, n = this.width, g = this.height, o = this.bpc, c = n * r * o + 7 >> 3, C = t && ImageResizer.needsToBeResized(i, a);
              if (!(!this.smask && !this.mask && "DeviceRGBA" === this.colorSpace.name)) {
                _context18.next = 9;
                break;
              }
              s.kind = S;
              _context18.next = 7;
              return this.getImageBytes(g * n * 4, {});
            case 7:
              _e305 = s.data = _context18.sent;
              return _context18.abrupt("return", t ? C ? ImageResizer.createImage(s, !1) : this.createBitmap(S, i, a, _e305) : s);
            case 9:
              if (e) {
                _context18.next = 61;
                break;
              }
              "DeviceGray" === this.colorSpace.name && 1 === o ? _e306 = b : "DeviceRGB" !== this.colorSpace.name || 8 !== o || this.needsDecode || (_e306 = F);
              if (!(_e306 && !this.smask && !this.mask && i === n && a === g)) {
                _context18.next = 26;
                break;
              }
              _context18.next = 14;
              return _classPrivateFieldLooseBase(this, _N3)[_N3](n, g);
            case 14:
              _r91 = _context18.sent;
              if (!_r91) {
                _context18.next = 17;
                break;
              }
              return _context18.abrupt("return", _r91);
            case 17:
              _context18.next = 19;
              return this.getImageBytes(g * c, {});
            case 19:
              _o34 = _context18.sent;
              if (!t) {
                _context18.next = 22;
                break;
              }
              return _context18.abrupt("return", C ? ImageResizer.createImage({
                data: _o34,
                kind: _e306,
                width: i,
                height: a,
                interpolate: this.interpolate
              }, this.needsDecode) : this.createBitmap(_e306, n, g, _o34));
            case 22:
              s.kind = _e306;
              s.data = _o34;
              if (this.needsDecode) {
                assert(_e306 === b, "PDFImage.createImageData: The image must be grayscale.");
                _t219 = s.data;
                for (_e307 = 0, _i211 = _t219.length; _e307 < _i211; _e307++) _t219[_e307] ^= 255;
              }
              return _context18.abrupt("return", s);
            case 26:
              if (!(this.image instanceof JpegStream && !this.smask && !this.mask && !this.needsDecode)) {
                _context18.next = 61;
                break;
              }
              _e308 = g * c;
              if (!(t && !C)) {
                _context18.next = 52;
                break;
              }
              _t220 = !1;
              _context18.t0 = this.colorSpace.name;
              _context18.next = _context18.t0 === "DeviceGray" ? 33 : _context18.t0 === "DeviceRGB" ? 36 : _context18.t0 === "DeviceCMYK" ? 39 : 40;
              break;
            case 33:
              _e308 *= 4;
              _t220 = !0;
              return _context18.abrupt("break", 40);
            case 36:
              _e308 = _e308 / 3 * 4;
              _t220 = !0;
              return _context18.abrupt("break", 40);
            case 39:
              _t220 = !0;
            case 40:
              if (!_t220) {
                _context18.next = 50;
                break;
              }
              _context18.next = 43;
              return _classPrivateFieldLooseBase(this, _N3)[_N3](i, a);
            case 43:
              _t221 = _context18.sent;
              if (!_t221) {
                _context18.next = 46;
                break;
              }
              return _context18.abrupt("return", _t221);
            case 46:
              _context18.next = 48;
              return this.getImageBytes(_e308, {
                drawWidth: i,
                drawHeight: a,
                forceRGBA: !0
              });
            case 48:
              _s129 = _context18.sent;
              return _context18.abrupt("return", this.createBitmap(S, i, a, _s129));
            case 50:
              _context18.next = 61;
              break;
            case 52:
              _context18.t1 = this.colorSpace.name;
              _context18.next = _context18.t1 === "DeviceGray" ? 55 : _context18.t1 === "DeviceRGB" ? 56 : _context18.t1 === "DeviceCMYK" ? 56 : 61;
              break;
            case 55:
              _e308 *= 3;
            case 56:
              s.kind = F;
              _context18.next = 59;
              return this.getImageBytes(_e308, {
                drawWidth: i,
                drawHeight: a,
                forceRGB: !0
              });
            case 59:
              s.data = _context18.sent;
              return _context18.abrupt("return", C ? ImageResizer.createImage(s) : s);
            case 61:
              _context18.next = 63;
              return this.getImageBytes(g * c, {
                internal: !0
              });
            case 63:
              h = _context18.sent;
              l = 0 | h.length / c * a / g;
              Q = this.getComponents(h);
              if (t && !C) {
                d = new OffscreenCanvas(i, a);
                f = d.getContext("2d");
                p = f.createImageData(i, a);
                m = p.data;
              }
              s.kind = S;
              if (!(e || this.smask || this.mask)) {
                _context18.next = 76;
                break;
              }
              t && !C || (m = new Uint8ClampedArray(i * a * 4));
              E = 1;
              u = !0;
              _context18.next = 74;
              return this.fillOpacity(m, i, a, l, Q);
            case 74:
              _context18.next = 78;
              break;
            case 76:
              if (!t || C) {
                s.kind = F;
                m = new Uint8ClampedArray(i * a * 3);
                E = 0;
              } else {
                new Uint32Array(m.buffer).fill(FeatureTest.isLittleEndian ? 4278190080 : 255);
                E = 1;
              }
              u = !1;
            case 78:
              this.needsDecode && this.decodeBuffer(Q);
              this.colorSpace.fillRgb(m, n, g, i, a, l, o, Q, E);
              u && this.undoPreblend(m, i, l);
              if (!(t && !C)) {
                _context18.next = 84;
                break;
              }
              f.putImageData(p, 0, 0);
              return _context18.abrupt("return", {
                data: null,
                width: i,
                height: a,
                bitmap: d.transferToImageBitmap(),
                interpolate: this.interpolate
              });
            case 84:
              s.data = m;
              return _context18.abrupt("return", C ? ImageResizer.createImage(s) : s);
            case 86:
            case "end":
              return _context18.stop();
          }
        }, _callee16, this);
      }));
      function createImageData() {
        return _createImageData.apply(this, arguments);
      }
      return createImageData;
    }()
  }, {
    key: "fillGrayBuffer",
    value: function () {
      var _fillGrayBuffer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17(e) {
        var t, i, a, s, r, n, g, o, c, C;
        return _regeneratorRuntime().wrap(function _callee17$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              t = this.numComps;
              if (!(1 !== t)) {
                _context19.next = 3;
                break;
              }
              throw new FormatError("Reading gray scale from a color image: ".concat(t));
            case 3:
              i = this.width;
              a = this.height;
              s = this.bpc;
              r = i * t * s + 7 >> 3;
              _context19.next = 9;
              return this.getImageBytes(a * r, {
                internal: !0
              });
            case 9:
              n = _context19.sent;
              g = this.getComponents(n);
              if (!(1 === s)) {
                _context19.next = 15;
                break;
              }
              c = i * a;
              if (this.needsDecode) for (o = 0; o < c; ++o) e[o] = g[o] - 1 & 255;else for (o = 0; o < c; ++o) e[o] = 255 & -g[o];
              return _context19.abrupt("return");
            case 15:
              this.needsDecode && this.decodeBuffer(g);
              c = i * a;
              C = 255 / ((1 << s) - 1);
              for (o = 0; o < c; ++o) e[o] = C * g[o];
            case 19:
            case "end":
              return _context19.stop();
          }
        }, _callee17, this);
      }));
      function fillGrayBuffer(_x31) {
        return _fillGrayBuffer.apply(this, arguments);
      }
      return fillGrayBuffer;
    }()
  }, {
    key: "createBitmap",
    value: function createBitmap(e, t, i, a) {
      var s = new OffscreenCanvas(t, i),
        r = s.getContext("2d");
      var n;
      if (e === S) n = new ImageData(a, t, i);else {
        n = r.createImageData(t, i);
        convertToRGBA({
          kind: e,
          src: a,
          dest: new Uint32Array(n.data.buffer),
          width: t,
          height: i,
          inverseDecode: this.needsDecode
        });
      }
      r.putImageData(n, 0, 0);
      return {
        data: null,
        width: t,
        height: i,
        bitmap: s.transferToImageBitmap(),
        interpolate: this.interpolate
      };
    }
  }, {
    key: "getImageBytes",
    value: function () {
      var _getImageBytes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18(e, _ref68) {
        var t, i, _ref68$forceRGBA, a, _ref68$forceRGB, s, _ref68$internal, r, n;
        return _regeneratorRuntime().wrap(function _callee18$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              t = _ref68.drawWidth, i = _ref68.drawHeight, _ref68$forceRGBA = _ref68.forceRGBA, a = _ref68$forceRGBA === void 0 ? !1 : _ref68$forceRGBA, _ref68$forceRGB = _ref68.forceRGB, s = _ref68$forceRGB === void 0 ? !1 : _ref68$forceRGB, _ref68$internal = _ref68.internal, r = _ref68$internal === void 0 ? !1 : _ref68$internal;
              this.image.reset();
              this.image.drawWidth = t || this.width;
              this.image.drawHeight = i || this.height;
              this.image.forceRGBA = !!a;
              this.image.forceRGB = !!s;
              _context20.next = 8;
              return this.image.getImageData(e, this.jpxDecoderOptions);
            case 8:
              n = _context20.sent;
              if (!(r || this.image instanceof DecodeStream)) {
                _context20.next = 11;
                break;
              }
              return _context20.abrupt("return", n);
            case 11:
              assert(n instanceof Uint8Array, 'PDFImage.getImageBytes: Unsupported "imageBytes" type.');
              return _context20.abrupt("return", new Uint8Array(n));
            case 13:
            case "end":
              return _context20.stop();
          }
        }, _callee18, this);
      }));
      function getImageBytes(_x32, _x33) {
        return _getImageBytes.apply(this, arguments);
      }
      return getImageBytes;
    }()
  }], [{
    key: "buildImage",
    value: function () {
      var _buildImage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19(_ref69) {
        var e, t, i, _ref69$isInline, a, s, r, n, g, o, c, C;
        return _regeneratorRuntime().wrap(function _callee19$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              e = _ref69.xref, t = _ref69.res, i = _ref69.image, _ref69$isInline = _ref69.isInline, a = _ref69$isInline === void 0 ? !1 : _ref69$isInline, s = _ref69.pdfFunctionFactory, r = _ref69.localColorSpaceCache;
              n = i;
              g = null, o = null;
              c = i.dict.get("SMask"), C = i.dict.get("Mask");
              c ? c instanceof BaseStream ? g = c : warn("Unsupported /SMask format.") : C && (C instanceof BaseStream || Array.isArray(C) ? o = C : warn("Unsupported /Mask format."));
              return _context21.abrupt("return", new PDFImage({
                xref: e,
                res: t,
                image: n,
                isInline: a,
                smask: g,
                mask: o,
                pdfFunctionFactory: s,
                localColorSpaceCache: r
              }));
            case 6:
            case "end":
              return _context21.stop();
          }
        }, _callee19);
      }));
      function buildImage(_x34) {
        return _buildImage.apply(this, arguments);
      }
      return buildImage;
    }()
  }, {
    key: "createRawMask",
    value: function createRawMask(_ref70) {
      var e = _ref70.imgArray,
        t = _ref70.width,
        i = _ref70.height,
        a = _ref70.imageIsFromDecodeStream,
        s = _ref70.inverseDecode,
        r = _ref70.interpolate;
      var n = (t + 7 >> 3) * i,
        g = e.byteLength;
      var o, c;
      if (!a || s && !(n === g)) {
        if (s) {
          o = new Uint8Array(n);
          o.set(e);
          o.fill(255, g);
        } else o = new Uint8Array(e);
      } else o = e;
      if (s) for (c = 0; c < g; c++) o[c] ^= 255;
      return {
        data: o,
        width: t,
        height: i,
        interpolate: r
      };
    }
  }, {
    key: "createMask",
    value: function () {
      var _createMask = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20(_ref71) {
        var e, t, i, a, s, r, _ref71$isOffscreenCan, n, g, _a186, _a187, _n70, _g46;
        return _regeneratorRuntime().wrap(function _callee20$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              e = _ref71.imgArray, t = _ref71.width, i = _ref71.height, a = _ref71.imageIsFromDecodeStream, s = _ref71.inverseDecode, r = _ref71.interpolate, _ref71$isOffscreenCan = _ref71.isOffscreenCanvasSupported, n = _ref71$isOffscreenCan === void 0 ? !1 : _ref71$isOffscreenCan;
              g = 1 === t && 1 === i && s === (0 === e.length || !!(128 & e[0]));
              if (!g) {
                _context22.next = 4;
                break;
              }
              return _context22.abrupt("return", {
                isSingleOpaquePixel: g
              });
            case 4:
              if (!n) {
                _context22.next = 13;
                break;
              }
              if (!ImageResizer.needsToBeResized(t, i)) {
                _context22.next = 9;
                break;
              }
              _a186 = new Uint8ClampedArray(t * i * 4);
              convertBlackAndWhiteToRGBA({
                src: e,
                dest: _a186,
                width: t,
                height: i,
                nonBlackColor: 0,
                inverseDecode: s
              });
              return _context22.abrupt("return", ImageResizer.createImage({
                kind: S,
                data: _a186,
                width: t,
                height: i,
                interpolate: r
              }));
            case 9:
              _a187 = new OffscreenCanvas(t, i), _n70 = _a187.getContext("2d"), _g46 = _n70.createImageData(t, i);
              convertBlackAndWhiteToRGBA({
                src: e,
                dest: _g46.data,
                width: t,
                height: i,
                nonBlackColor: 0,
                inverseDecode: s
              });
              _n70.putImageData(_g46, 0, 0);
              return _context22.abrupt("return", {
                data: null,
                width: t,
                height: i,
                interpolate: r,
                bitmap: _a187.transferToImageBitmap()
              });
            case 13:
              return _context22.abrupt("return", this.createRawMask({
                imgArray: e,
                width: t,
                height: i,
                inverseDecode: s,
                imageIsFromDecodeStream: a,
                interpolate: r
              }));
            case 14:
            case "end":
              return _context22.stop();
          }
        }, _callee20, this);
      }));
      function createMask(_x35) {
        return _createMask.apply(this, arguments);
      }
      return createMask;
    }()
  }]);
}();
function _N4(_x209, _x210) {
  return _N6.apply(this, arguments);
}
function _N6() {
  _N6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee117(e, t) {
    var i;
    return _regeneratorRuntime().wrap(function _callee117$(_context129) {
      while (1) switch (_context129.prev = _context129.next) {
        case 0:
          _context129.next = 2;
          return this.image.getTransferableImage();
        case 2:
          i = _context129.sent;
          return _context129.abrupt("return", i ? {
            data: null,
            width: e,
            height: t,
            bitmap: i,
            interpolate: this.interpolate
          } : null);
        case 4:
        case "end":
          return _context129.stop();
      }
    }, _callee117, this);
  }));
  return _N6.apply(this, arguments);
}
var ks = Object.freeze({
    maxImageSize: -1,
    disableFontFace: !1,
    ignoreErrors: !1,
    isEvalSupported: !0,
    isOffscreenCanvasSupported: !1,
    isChrome: !1,
    canvasMaxAreaInBytes: -1,
    fontExtraProperties: !1,
    useSystemFonts: !0,
    cMapUrl: null,
    standardFontDataUrl: null
  }),
  Rs = 1,
  Ns = 2,
  Gs = Promise.resolve();
function normalizeBlendMode(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  if (Array.isArray(e)) {
    var _iterator60 = _createForOfIteratorHelper(e),
      _step60;
    try {
      for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
        var _t222 = _step60.value;
        var _e309 = normalizeBlendMode(_t222, !0);
        if (_e309) return _e309;
      }
    } catch (err) {
      _iterator60.e(err);
    } finally {
      _iterator60.f();
    }
    warn("Unsupported blend mode Array: ".concat(e));
    return "source-over";
  }
  if (!(e instanceof Name)) return t ? null : "source-over";
  switch (e.name) {
    case "Normal":
    case "Compatible":
      return "source-over";
    case "Multiply":
      return "multiply";
    case "Screen":
      return "screen";
    case "Overlay":
      return "overlay";
    case "Darken":
      return "darken";
    case "Lighten":
      return "lighten";
    case "ColorDodge":
      return "color-dodge";
    case "ColorBurn":
      return "color-burn";
    case "HardLight":
      return "hard-light";
    case "SoftLight":
      return "soft-light";
    case "Difference":
      return "difference";
    case "Exclusion":
      return "exclusion";
    case "Hue":
      return "hue";
    case "Saturation":
      return "saturation";
    case "Color":
      return "color";
    case "Luminosity":
      return "luminosity";
  }
  if (t) return null;
  warn("Unsupported blend mode: ".concat(e.name));
  return "source-over";
}
function addLocallyCachedImageOps(e, t) {
  var _t$args$;
  t.objId && e.addDependency(t.objId);
  e.addImageOps(t.fn, t.args, t.optionalContent);
  t.fn === Xe && ((_t$args$ = t.args[0]) === null || _t$args$ === void 0 ? void 0 : _t$args$.count) > 0 && t.args[0].count++;
}
var TimeSlotManager = /*#__PURE__*/function () {
  function TimeSlotManager() {
    _classCallCheck(this, TimeSlotManager);
    this.reset();
  }
  return _createClass(TimeSlotManager, [{
    key: "check",
    value: function check() {
      if (++this.checked < TimeSlotManager.CHECK_TIME_EVERY) return !1;
      this.checked = 0;
      return this.endTime <= Date.now();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.endTime = Date.now() + TimeSlotManager.TIME_SLOT_DURATION_MS;
      this.checked = 0;
    }
  }]);
}();
TimeSlotManager.TIME_SLOT_DURATION_MS = 20;
TimeSlotManager.CHECK_TIME_EVERY = 100;
var PartialEvaluator = /*#__PURE__*/function () {
  function PartialEvaluator(_ref72) {
    var e = _ref72.xref,
      t = _ref72.handler,
      i = _ref72.pageIndex,
      a = _ref72.idFactory,
      s = _ref72.fontCache,
      r = _ref72.builtInCMapCache,
      n = _ref72.standardFontDataCache,
      g = _ref72.globalImageCache,
      o = _ref72.systemFontCache,
      _ref72$options = _ref72.options,
      c = _ref72$options === void 0 ? null : _ref72$options;
    _classCallCheck(this, PartialEvaluator);
    this.xref = e;
    this.handler = t;
    this.pageIndex = i;
    this.idFactory = a;
    this.fontCache = s;
    this.builtInCMapCache = r;
    this.standardFontDataCache = n;
    this.globalImageCache = g;
    this.systemFontCache = o;
    this.options = c || ks;
    this.type3FontRefs = null;
    this._regionalImageCache = new RegionalImageCache();
    this._fetchBuiltInCMapBound = this.fetchBuiltInCMap.bind(this);
    ImageResizer.setOptions({
      isChrome: this.options.isChrome,
      maxArea: this.options.canvasMaxAreaInBytes
    });
  }
  return _createClass(PartialEvaluator, [{
    key: "_pdfFunctionFactory",
    get: function get() {
      return shadow(this, "_pdfFunctionFactory", new PDFFunctionFactory({
        xref: this.xref,
        isEvalSupported: this.options.isEvalSupported
      }));
    }
  }, {
    key: "parsingType3Font",
    get: function get() {
      return !!this.type3FontRefs;
    }
  }, {
    key: "clone",
    value: function clone() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var t = Object.create(this);
      t.options = Object.assign(Object.create(null), this.options, e);
      return t;
    }
  }, {
    key: "hasBlendModes",
    value: function hasBlendModes(e, t) {
      if (!(e instanceof Dict)) return !1;
      if (e.objId && t.has(e.objId)) return !1;
      var i = new RefSet(t);
      e.objId && i.put(e.objId);
      var a = [e],
        s = this.xref;
      for (; a.length;) {
        var _e310 = a.shift(),
          _t223 = _e310.get("ExtGState");
        if (_t223 instanceof Dict) {
          var _iterator61 = _createForOfIteratorHelper(_t223.getRawValues()),
            _step61;
          try {
            for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
              var _e311 = _step61.value;
              if (_e311 instanceof Ref) {
                if (i.has(_e311)) continue;
                try {
                  _e311 = s.fetch(_e311);
                } catch (t) {
                  i.put(_e311);
                  info("hasBlendModes - ignoring ExtGState: \"".concat(t, "\"."));
                  continue;
                }
              }
              if (!(_e311 instanceof Dict)) continue;
              _e311.objId && i.put(_e311.objId);
              var _t224 = _e311.get("BM");
              if (_t224 instanceof Name) {
                if ("Normal" !== _t224.name) return !0;
              } else if (void 0 !== _t224 && Array.isArray(_t224)) {
                var _iterator62 = _createForOfIteratorHelper(_t224),
                  _step62;
                try {
                  for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
                    var _e312 = _step62.value;
                    if (_e312 instanceof Name && "Normal" !== _e312.name) return !0;
                  }
                } catch (err) {
                  _iterator62.e(err);
                } finally {
                  _iterator62.f();
                }
              }
            }
          } catch (err) {
            _iterator61.e(err);
          } finally {
            _iterator61.f();
          }
        }
        var _r92 = _e310.get("XObject");
        if (_r92 instanceof Dict) {
          var _iterator63 = _createForOfIteratorHelper(_r92.getRawValues()),
            _step63;
          try {
            for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
              var _e313 = _step63.value;
              if (_e313 instanceof Ref) {
                if (i.has(_e313)) continue;
                try {
                  _e313 = s.fetch(_e313);
                } catch (t) {
                  i.put(_e313);
                  info("hasBlendModes - ignoring XObject: \"".concat(t, "\"."));
                  continue;
                }
              }
              if (!(_e313 instanceof BaseStream)) continue;
              _e313.dict.objId && i.put(_e313.dict.objId);
              var _t225 = _e313.dict.get("Resources");
              if (_t225 instanceof Dict && (!_t225.objId || !i.has(_t225.objId))) {
                a.push(_t225);
                _t225.objId && i.put(_t225.objId);
              }
            }
          } catch (err) {
            _iterator63.e(err);
          } finally {
            _iterator63.f();
          }
        }
      }
      var _iterator64 = _createForOfIteratorHelper(i),
        _step64;
      try {
        for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
          var _e314 = _step64.value;
          t.put(_e314);
        }
      } catch (err) {
        _iterator64.e(err);
      } finally {
        _iterator64.f();
      }
      return !1;
    }
  }, {
    key: "fetchBuiltInCMap",
    value: function () {
      var _fetchBuiltInCMap = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21(e) {
        var t, i, _t226, _a188;
        return _regeneratorRuntime().wrap(function _callee21$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              t = this.builtInCMapCache.get(e);
              if (!t) {
                _context23.next = 3;
                break;
              }
              return _context23.abrupt("return", t);
            case 3:
              if (!(null !== this.options.cMapUrl)) {
                _context23.next = 19;
                break;
              }
              _t226 = "".concat(this.options.cMapUrl).concat(e, ".bcmap");
              _context23.next = 7;
              return fetch(_t226);
            case 7:
              _a188 = _context23.sent;
              if (_a188.ok) {
                _context23.next = 10;
                break;
              }
              throw new Error("fetchBuiltInCMap: failed to fetch file \"".concat(_t226, "\" with \"").concat(_a188.statusText, "\"."));
            case 10:
              _context23.t0 = Uint8Array;
              _context23.next = 13;
              return _a188.arrayBuffer();
            case 13:
              _context23.t1 = _context23.sent;
              _context23.t2 = new _context23.t0(_context23.t1);
              _context23.t3 = !0;
              i = {
                cMapData: _context23.t2,
                isCompressed: _context23.t3
              };
              _context23.next = 22;
              break;
            case 19:
              _context23.next = 21;
              return this.handler.sendWithPromise("FetchBuiltInCMap", {
                name: e
              });
            case 21:
              i = _context23.sent;
            case 22:
              this.builtInCMapCache.set(e, i);
              return _context23.abrupt("return", i);
            case 24:
            case "end":
              return _context23.stop();
          }
        }, _callee21, this);
      }));
      function fetchBuiltInCMap(_x36) {
        return _fetchBuiltInCMap.apply(this, arguments);
      }
      return fetchBuiltInCMap;
    }()
  }, {
    key: "fetchStandardFontData",
    value: function () {
      var _fetchStandardFontData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22(e) {
        var t, i, a, _e315, _t227;
        return _regeneratorRuntime().wrap(function _callee22$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              t = this.standardFontDataCache.get(e);
              if (!t) {
                _context24.next = 3;
                break;
              }
              return _context24.abrupt("return", new Stream(t));
            case 3:
              if (!(this.options.useSystemFonts && "Symbol" !== e && "ZapfDingbats" !== e)) {
                _context24.next = 5;
                break;
              }
              return _context24.abrupt("return", null);
            case 5:
              i = Zi()[e];
              if (!(null !== this.options.standardFontDataUrl)) {
                _context24.next = 22;
                break;
              }
              _e315 = "".concat(this.options.standardFontDataUrl).concat(i);
              _context24.next = 10;
              return fetch(_e315);
            case 10:
              _t227 = _context24.sent;
              if (!_t227.ok) {
                _context24.next = 19;
                break;
              }
              _context24.t0 = Uint8Array;
              _context24.next = 15;
              return _t227.arrayBuffer();
            case 15:
              _context24.t1 = _context24.sent;
              a = new _context24.t0(_context24.t1);
              _context24.next = 20;
              break;
            case 19:
              warn("fetchStandardFontData: failed to fetch file \"".concat(_e315, "\" with \"").concat(_t227.statusText, "\"."));
            case 20:
              _context24.next = 31;
              break;
            case 22:
              _context24.prev = 22;
              _context24.next = 25;
              return this.handler.sendWithPromise("FetchStandardFontData", {
                filename: i
              });
            case 25:
              a = _context24.sent;
              _context24.next = 31;
              break;
            case 28:
              _context24.prev = 28;
              _context24.t2 = _context24["catch"](22);
              warn("fetchStandardFontData: failed to fetch file \"".concat(i, "\" with \"").concat(_context24.t2, "\"."));
            case 31:
              if (a) {
                _context24.next = 33;
                break;
              }
              return _context24.abrupt("return", null);
            case 33:
              this.standardFontDataCache.set(e, a);
              return _context24.abrupt("return", new Stream(a));
            case 35:
            case "end":
              return _context24.stop();
          }
        }, _callee22, this, [[22, 28]]);
      }));
      function fetchStandardFontData(_x37) {
        return _fetchStandardFontData.apply(this, arguments);
      }
      return fetchStandardFontData;
    }()
  }, {
    key: "buildFormXObject",
    value: function () {
      var _buildFormXObject = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23(e, t, i, a, s, r, n) {
        var g, o, c, C, h, l, _t228, _i212, _a189, Q;
        return _regeneratorRuntime().wrap(function _callee23$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              g = t.dict, o = lookupMatrix(g.getArray("Matrix"), null), c = lookupNormalRect(g.getArray("BBox"), null);
              _context25.t0 = g.has("OC");
              if (!_context25.t0) {
                _context25.next = 6;
                break;
              }
              _context25.next = 5;
              return this.parseMarkedContentProps(g.get("OC"), e);
            case 5:
              C = _context25.sent;
            case 6:
              void 0 !== C && a.addOp(Je, ["OC", C]);
              l = g.get("Group");
              if (!l) {
                _context25.next = 24;
                break;
              }
              h = {
                matrix: o,
                bbox: c,
                smask: i,
                isolated: !1,
                knockout: !1
              };
              _t228 = null;
              if (!isName(l.get("S"), "Transparency")) {
                _context25.next = 22;
                break;
              }
              h.isolated = l.get("I") || !1;
              h.knockout = l.get("K") || !1;
              if (!l.has("CS")) {
                _context25.next = 22;
                break;
              }
              _i212 = l.getRaw("CS"), _a189 = ColorSpace.getCached(_i212, this.xref, n);
              _context25.t1 = _a189;
              if (_context25.t1) {
                _context25.next = 21;
                break;
              }
              _context25.next = 20;
              return this.parseColorSpace({
                cs: _i212,
                resources: e,
                localColorSpaceCache: n
              });
            case 20:
              _context25.t1 = _context25.sent;
            case 21:
              _t228 = _context25.t1;
            case 22:
              if (i !== null && i !== void 0 && i.backdrop) {
                _t228 || (_t228 = ColorSpace.singletons.rgb);
                i.backdrop = _t228.getRgb(i.backdrop, 0);
              }
              a.addOp(Oe, [h]);
            case 24:
              Q = l ? [o, null] : [o, c];
              a.addOp(Te, Q);
              _context25.next = 28;
              return this.getOperatorList({
                stream: t,
                task: s,
                resources: g.get("Resources") || e,
                operatorList: a,
                initialState: r
              });
            case 28:
              a.addOp(qe, []);
              l && a.addOp(Pe, [h]);
              void 0 !== C && a.addOp(Ye, []);
            case 31:
            case "end":
              return _context25.stop();
          }
        }, _callee23, this);
      }));
      function buildFormXObject(_x38, _x39, _x40, _x41, _x42, _x43, _x44) {
        return _buildFormXObject.apply(this, arguments);
      }
      return buildFormXObject;
    }()
  }, {
    key: "_sendImgData",
    value: function _sendImgData(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var a = t ? [t.bitmap || t.data.buffer] : null;
      return this.parsingType3Font || i ? this.handler.send("commonobj", [e, "Image", t], a) : this.handler.send("obj", [e, this.pageIndex, "Image", t], a);
    }
  }, {
    key: "buildPaintImageXObject",
    value: function () {
      var _buildPaintImageXObject = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25(_ref73) {
        var _this46 = this;
        var e, t, _ref73$isInline, i, a, s, r, n, g, o, c, C, h, _e316, l, Q, E, _e317, _i213, _n71, _h9, _e318, _e319, _u8, _e320, _s130, _t229, u, d, _e321, _e322;
        return _regeneratorRuntime().wrap(function _callee25$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              e = _ref73.resources, t = _ref73.image, _ref73$isInline = _ref73.isInline, i = _ref73$isInline === void 0 ? !1 : _ref73$isInline, a = _ref73.operatorList, s = _ref73.cacheKey, r = _ref73.localImageCache, n = _ref73.localColorSpaceCache;
              g = t.dict, o = g.objId, c = g.get("W", "Width"), C = g.get("H", "Height");
              if (!(!c || "number" != typeof c || !C || "number" != typeof C)) {
                _context27.next = 5;
                break;
              }
              warn("Image dimensions are missing, or not numbers.");
              return _context27.abrupt("return");
            case 5:
              h = this.options.maxImageSize;
              if (!(-1 !== h && c * C > h)) {
                _context27.next = 12;
                break;
              }
              _e316 = "Image exceeded maximum allowed size and was removed.";
              if (!this.options.ignoreErrors) {
                _context27.next = 11;
                break;
              }
              warn(_e316);
              return _context27.abrupt("return");
            case 11:
              throw new Error(_e316);
            case 12:
              _context27.t0 = g.has("OC");
              if (!_context27.t0) {
                _context27.next = 17;
                break;
              }
              _context27.next = 16;
              return this.parseMarkedContentProps(g.get("OC"), e);
            case 16:
              l = _context27.sent;
            case 17:
              if (!(g.get("IM", "ImageMask") || !1)) {
                _context27.next = 41;
                break;
              }
              _e317 = g.get("I", "Interpolate"), _i213 = c + 7 >> 3, _n71 = t.getBytes(_i213 * C), _h9 = g.getArray("D", "Decode");
              if (!this.parsingType3Font) {
                _context27.next = 26;
                break;
              }
              Q = PDFImage.createRawMask({
                imgArray: _n71,
                width: c,
                height: C,
                imageIsFromDecodeStream: t instanceof DecodeStream,
                inverseDecode: (_h9 === null || _h9 === void 0 ? void 0 : _h9[0]) > 0,
                interpolate: _e317
              });
              Q.cached = !!s;
              E = [Q];
              a.addImageOps(Xe, E, l);
              if (s) {
                _e318 = {
                  fn: Xe,
                  args: E,
                  optionalContent: l
                };
                r.set(s, o, _e318);
                o && this._regionalImageCache.set(null, o, _e318);
              }
              return _context27.abrupt("return");
            case 26:
              _context27.next = 28;
              return PDFImage.createMask({
                imgArray: _n71,
                width: c,
                height: C,
                imageIsFromDecodeStream: t instanceof DecodeStream,
                inverseDecode: (_h9 === null || _h9 === void 0 ? void 0 : _h9[0]) > 0,
                interpolate: _e317,
                isOffscreenCanvasSupported: this.options.isOffscreenCanvasSupported
              });
            case 28:
              Q = _context27.sent;
              if (!Q.isSingleOpaquePixel) {
                _context27.next = 33;
                break;
              }
              a.addImageOps(et, [], l);
              if (s) {
                _e319 = {
                  fn: et,
                  args: [],
                  optionalContent: l
                };
                r.set(s, o, _e319);
                o && this._regionalImageCache.set(null, o, _e319);
              }
              return _context27.abrupt("return");
            case 33:
              _u8 = "mask_".concat(this.idFactory.createObjId());
              a.addDependency(_u8);
              Q.dataLen = Q.bitmap ? Q.width * Q.height * 4 : Q.data.length;
              this._sendImgData(_u8, Q);
              E = [{
                data: _u8,
                width: Q.width,
                height: Q.height,
                interpolate: Q.interpolate,
                count: 1
              }];
              a.addImageOps(Xe, E, l);
              if (s) {
                _e320 = {
                  objId: _u8,
                  fn: Xe,
                  args: E,
                  optionalContent: l
                };
                r.set(s, o, _e320);
                o && this._regionalImageCache.set(null, o, _e320);
              }
              return _context27.abrupt("return");
            case 41:
              if (!(i && c + C < 200 && !g.has("SMask") && !g.has("Mask"))) {
                _context27.next = 58;
                break;
              }
              _context27.prev = 42;
              _s130 = new PDFImage({
                xref: this.xref,
                res: e,
                image: t,
                isInline: i,
                pdfFunctionFactory: this._pdfFunctionFactory,
                localColorSpaceCache: n
              });
              _context27.next = 46;
              return _s130.createImageData(!0, !1);
            case 46:
              Q = _context27.sent;
              a.isOffscreenCanvasSupported = this.options.isOffscreenCanvasSupported;
              a.addImageOps(ze, [Q], l);
              _context27.next = 57;
              break;
            case 51:
              _context27.prev = 51;
              _context27.t1 = _context27["catch"](42);
              _t229 = "Unable to decode inline image: \"".concat(_context27.t1, "\".");
              if (this.options.ignoreErrors) {
                _context27.next = 56;
                break;
              }
              throw new Error(_t229);
            case 56:
              warn(_t229);
            case 57:
              return _context27.abrupt("return");
            case 58:
              u = "img_".concat(this.idFactory.createObjId()), d = !1;
              if (this.parsingType3Font) u = "".concat(this.idFactory.getDocId(), "_type3_").concat(u);else if (s && o) {
                d = this.globalImageCache.shouldCache(o, this.pageIndex);
                if (d) {
                  assert(!i, "Cannot cache an inline image globally.");
                  u = "".concat(this.idFactory.getDocId(), "_").concat(u);
                }
              }
              a.addDependency(u);
              E = [u, c, C];
              a.addImageOps(Ve, E, l);
              if (!d) {
                _context27.next = 76;
                break;
              }
              if (!this.globalImageCache.hasDecodeFailed(o)) {
                _context27.next = 68;
                break;
              }
              this.globalImageCache.setData(o, {
                objId: u,
                fn: Ve,
                args: E,
                optionalContent: l,
                byteSize: 0
              });
              this._sendImgData(u, null, d);
              return _context27.abrupt("return");
            case 68:
              if (!(c * C > 25e4 || g.has("SMask") || g.has("Mask"))) {
                _context27.next = 76;
                break;
              }
              _context27.next = 71;
              return this.handler.sendWithPromise("commonobj", [u, "CopyLocalImage", {
                imageRef: o
              }]);
            case 71:
              _e321 = _context27.sent;
              if (!_e321) {
                _context27.next = 76;
                break;
              }
              this.globalImageCache.setData(o, {
                objId: u,
                fn: Ve,
                args: E,
                optionalContent: l,
                byteSize: 0
              });
              this.globalImageCache.addByteSize(o, _e321);
              return _context27.abrupt("return");
            case 76:
              PDFImage.buildImage({
                xref: this.xref,
                res: e,
                image: t,
                isInline: i,
                pdfFunctionFactory: this._pdfFunctionFactory,
                localColorSpaceCache: n
              }).then(/*#__PURE__*/function () {
                var _ref74 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24(e) {
                  return _regeneratorRuntime().wrap(function _callee24$(_context26) {
                    while (1) switch (_context26.prev = _context26.next) {
                      case 0:
                        _context26.next = 2;
                        return e.createImageData(!1, _this46.options.isOffscreenCanvasSupported);
                      case 2:
                        Q = _context26.sent;
                        Q.dataLen = Q.bitmap ? Q.width * Q.height * 4 : Q.data.length;
                        Q.ref = o;
                        d && _this46.globalImageCache.addByteSize(o, Q.dataLen);
                        return _context26.abrupt("return", _this46._sendImgData(u, Q, d));
                      case 7:
                      case "end":
                        return _context26.stop();
                    }
                  }, _callee24);
                }));
                return function (_x46) {
                  return _ref74.apply(this, arguments);
                };
              }()).catch(function (e) {
                warn("Unable to decode image \"".concat(u, "\": \"").concat(e, "\"."));
                o && _this46.globalImageCache.addDecodeFailed(o);
                return _this46._sendImgData(u, null, d);
              });
              if (s) {
                _e322 = {
                  objId: u,
                  fn: Ve,
                  args: E,
                  optionalContent: l
                };
                r.set(s, o, _e322);
                if (o) {
                  this._regionalImageCache.set(null, o, _e322);
                  d && this.globalImageCache.setData(o, {
                    objId: u,
                    fn: Ve,
                    args: E,
                    optionalContent: l,
                    byteSize: 0
                  });
                }
              }
            case 78:
            case "end":
              return _context27.stop();
          }
        }, _callee25, this, [[42, 51]]);
      }));
      function buildPaintImageXObject(_x45) {
        return _buildPaintImageXObject.apply(this, arguments);
      }
      return buildPaintImageXObject;
    }()
  }, {
    key: "handleSMask",
    value: function handleSMask(e, t, i, a, s, r) {
      var n = e.get("G"),
        g = {
          subtype: e.get("S").name,
          backdrop: e.get("BC")
        },
        o = e.get("TR");
      if (isPDFFunction(o)) {
        var _e323 = this._pdfFunctionFactory.create(o),
          _t230 = new Uint8Array(256),
          _i214 = new Float32Array(1);
        for (var _a190 = 0; _a190 < 256; _a190++) {
          _i214[0] = _a190 / 255;
          _e323(_i214, 0, _i214, 0);
          _t230[_a190] = 255 * _i214[0] | 0;
        }
        g.transferMap = _t230;
      }
      return this.buildFormXObject(t, n, g, i, a, s.state.clone(), r);
    }
  }, {
    key: "handleTransferFunction",
    value: function handleTransferFunction(e) {
      var t;
      if (Array.isArray(e)) t = e;else {
        if (!isPDFFunction(e)) return null;
        t = [e];
      }
      var i = [];
      var a = 0,
        s = 0;
      var _iterator65 = _createForOfIteratorHelper(t),
        _step65;
      try {
        for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
          var _e324 = _step65.value;
          var _t231 = this.xref.fetchIfRef(_e324);
          a++;
          if (isName(_t231, "Identity")) {
            i.push(null);
            continue;
          }
          if (!isPDFFunction(_t231)) return null;
          var _r93 = this._pdfFunctionFactory.create(_t231),
            _n72 = new Uint8Array(256),
            g = new Float32Array(1);
          for (var _e325 = 0; _e325 < 256; _e325++) {
            g[0] = _e325 / 255;
            _r93(g, 0, g, 0);
            _n72[_e325] = 255 * g[0] | 0;
          }
          i.push(_n72);
          s++;
        }
      } catch (err) {
        _iterator65.e(err);
      } finally {
        _iterator65.f();
      }
      return 1 !== a && 4 !== a || 0 === s ? null : i;
    }
  }, {
    key: "handleTilingType",
    value: function handleTilingType(e, t, i, a, s, r, n, g) {
      var _this47 = this;
      var o = new OperatorList(),
        c = Dict.merge({
          xref: this.xref,
          dictArray: [s.get("Resources"), i]
        });
      return this.getOperatorList({
        stream: a,
        task: n,
        resources: c,
        operatorList: o
      }).then(function () {
        var i = o.getIR(),
          a = getTilingPatternIR(i, s, t);
        r.addDependencies(o.dependencies);
        r.addOp(e, a);
        s.objId && g.set(null, s.objId, {
          operatorListIR: i,
          dict: s
        });
      }).catch(function (e) {
        if (!(e instanceof AbortException)) {
          if (!_this47.options.ignoreErrors) throw e;
          warn("handleTilingType - ignoring pattern: \"".concat(e, "\"."));
        }
      });
    }
  }, {
    key: "handleSetFont",
    value: function () {
      var _handleSetFont = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26(e, t, i, a, s, r) {
        var n,
          g,
          o,
          c,
          _args28 = arguments;
        return _regeneratorRuntime().wrap(function _callee26$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              n = _args28.length > 6 && _args28[6] !== undefined ? _args28[6] : null;
              g = _args28.length > 7 && _args28[7] !== undefined ? _args28[7] : null;
              o = (t === null || t === void 0 ? void 0 : t[0]) instanceof Name ? t[0].name : null;
              _context28.next = 5;
              return this.loadFont(o, i, e, n, g);
            case 5:
              c = _context28.sent;
              if (!c.font.isType3Font) {
                _context28.next = 16;
                break;
              }
              _context28.prev = 7;
              _context28.next = 10;
              return c.loadType3Data(this, e, s);
            case 10:
              a.addDependencies(c.type3Dependencies);
              _context28.next = 16;
              break;
            case 13:
              _context28.prev = 13;
              _context28.t0 = _context28["catch"](7);
              c = new TranslatedFont({
                loadedName: "g_font_error",
                font: new ErrorFont("Type3 font load error: ".concat(_context28.t0)),
                dict: c.font,
                evaluatorOptions: this.options
              });
            case 16:
              r.font = c.font;
              c.send(this.handler);
              return _context28.abrupt("return", c.loadedName);
            case 19:
            case "end":
              return _context28.stop();
          }
        }, _callee26, this, [[7, 13]]);
      }));
      function handleSetFont(_x47, _x48, _x49, _x50, _x51, _x52) {
        return _handleSetFont.apply(this, arguments);
      }
      return handleSetFont;
    }()
  }, {
    key: "handleText",
    value: function handleText(e, t) {
      var i = t.font,
        a = i.charsToGlyphs(e);
      if (i.data) {
        (!!(t.textRenderingMode & D) || "Pattern" === t.fillColorSpace.name || i.disableFontFace || this.options.disableFontFace) && PartialEvaluator.buildFontPaths(i, a, this.handler, this.options);
      }
      return a;
    }
  }, {
    key: "ensureStateFont",
    value: function ensureStateFont(e) {
      if (e.font) return;
      var t = new FormatError("Missing setFont (Tf) operator before text rendering operator.");
      if (!this.options.ignoreErrors) throw t;
      warn("ensureStateFont: \"".concat(t, "\"."));
    }
  }, {
    key: "setGState",
    value: function () {
      var _setGState = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28(_ref75) {
        var _this48 = this;
        var e, t, i, a, s, r, n, g, o, c, C, h, _iterator66, _step66, _loop;
        return _regeneratorRuntime().wrap(function _callee28$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              e = _ref75.resources, t = _ref75.gState, i = _ref75.operatorList, a = _ref75.cacheKey, s = _ref75.task, r = _ref75.stateManager, n = _ref75.localGStateCache, g = _ref75.localColorSpaceCache;
              o = t.objId;
              c = !0;
              C = [];
              h = Promise.resolve();
              _iterator66 = _createForOfIteratorHelper(t.getKeys());
              _context30.prev = 6;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
                var a, n, _t232;
                return _regeneratorRuntime().wrap(function _callee27$(_context29) {
                  while (1) switch (_context29.prev = _context29.next) {
                    case 0:
                      a = _step66.value;
                      n = t.get(a);
                      _context29.t0 = a;
                      _context29.next = _context29.t0 === "Type" ? 5 : _context29.t0 === "LW" ? 6 : _context29.t0 === "LC" ? 6 : _context29.t0 === "LJ" ? 6 : _context29.t0 === "ML" ? 6 : _context29.t0 === "D" ? 6 : _context29.t0 === "RI" ? 6 : _context29.t0 === "FL" ? 6 : _context29.t0 === "CA" ? 6 : _context29.t0 === "ca" ? 6 : _context29.t0 === "Font" ? 8 : _context29.t0 === "BM" ? 11 : _context29.t0 === "SMask" ? 13 : _context29.t0 === "TR" ? 18 : _context29.t0 === "OP" ? 21 : _context29.t0 === "op" ? 21 : _context29.t0 === "OPM" ? 21 : _context29.t0 === "BG" ? 21 : _context29.t0 === "BG2" ? 21 : _context29.t0 === "UCR" ? 21 : _context29.t0 === "UCR2" ? 21 : _context29.t0 === "TR2" ? 21 : _context29.t0 === "HT" ? 21 : _context29.t0 === "SM" ? 21 : _context29.t0 === "SA" ? 21 : _context29.t0 === "AIS" ? 21 : _context29.t0 === "TK" ? 21 : 23;
                      break;
                    case 5:
                      return _context29.abrupt("break", 24);
                    case 6:
                      C.push([a, n]);
                      return _context29.abrupt("break", 24);
                    case 8:
                      c = !1;
                      h = h.then(function () {
                        return _this48.handleSetFont(e, null, n[0], i, s, r.state).then(function (e) {
                          i.addDependency(e);
                          C.push([a, [e, n[1]]]);
                        });
                      });
                      return _context29.abrupt("break", 24);
                    case 11:
                      C.push([a, normalizeBlendMode(n)]);
                      return _context29.abrupt("break", 24);
                    case 13:
                      if (!isName(n, "None")) {
                        _context29.next = 16;
                        break;
                      }
                      C.push([a, !1]);
                      return _context29.abrupt("break", 24);
                    case 16:
                      if (n instanceof Dict) {
                        c = !1;
                        h = h.then(function () {
                          return _this48.handleSMask(n, e, i, s, r, g);
                        });
                        C.push([a, !0]);
                      } else warn("Unsupported SMask type");
                      return _context29.abrupt("break", 24);
                    case 18:
                      _t232 = _this48.handleTransferFunction(n);
                      C.push([a, _t232]);
                      return _context29.abrupt("break", 24);
                    case 21:
                      info("graphic state operator " + a);
                      return _context29.abrupt("break", 24);
                    case 23:
                      info("Unknown graphic state operator " + a);
                    case 24:
                    case "end":
                      return _context29.stop();
                  }
                }, _callee27);
              });
              _iterator66.s();
            case 9:
              if ((_step66 = _iterator66.n()).done) {
                _context30.next = 13;
                break;
              }
              return _context30.delegateYield(_loop(), "t0", 11);
            case 11:
              _context30.next = 9;
              break;
            case 13:
              _context30.next = 18;
              break;
            case 15:
              _context30.prev = 15;
              _context30.t1 = _context30["catch"](6);
              _iterator66.e(_context30.t1);
            case 18:
              _context30.prev = 18;
              _iterator66.f();
              return _context30.finish(18);
            case 21:
              _context30.next = 23;
              return h;
            case 23:
              C.length > 0 && i.addOp(NA, [C]);
              c && n.set(a, o, C);
            case 25:
            case "end":
              return _context30.stop();
          }
        }, _callee28, null, [[6, 15, 18, 21]]);
      }));
      function setGState(_x53) {
        return _setGState.apply(this, arguments);
      }
      return setGState;
    }()
  }, {
    key: "loadFont",
    value: function loadFont(e, t, i) {
      var _this49 = this,
        _l9;
      var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var errorFont = /*#__PURE__*/function () {
        var _ref76 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
          return _regeneratorRuntime().wrap(function _callee29$(_context31) {
            while (1) switch (_context31.prev = _context31.next) {
              case 0:
                return _context31.abrupt("return", new TranslatedFont({
                  loadedName: "g_font_error",
                  font: new ErrorFont("Font \"".concat(e, "\" is not available.")),
                  dict: t,
                  evaluatorOptions: _this49.options
                }));
              case 1:
              case "end":
                return _context31.stop();
            }
          }, _callee29);
        }));
        return function errorFont() {
          return _ref76.apply(this, arguments);
        };
      }();
      var r;
      if (t) t instanceof Ref && (r = t);else {
        var _t233 = i.get("Font");
        _t233 && (r = _t233.getRaw(e));
      }
      if (r) {
        var _this$type3FontRefs;
        if ((_this$type3FontRefs = this.type3FontRefs) !== null && _this$type3FontRefs !== void 0 && _this$type3FontRefs.has(r)) return errorFont();
        if (this.fontCache.has(r)) return this.fontCache.get(r);
        try {
          t = this.xref.fetchIfRef(r);
        } catch (e) {
          warn("loadFont - lookup failed: \"".concat(e, "\"."));
        }
      }
      if (!(t instanceof Dict)) {
        if (!this.options.ignoreErrors && !this.parsingType3Font) {
          warn("Font \"".concat(e, "\" is not available."));
          return errorFont();
        }
        warn("Font \"".concat(e, "\" is not available -- attempting to fallback to a default font."));
        t = a || PartialEvaluator.fallbackFontDict;
      }
      if (t.cacheKey && this.fontCache.has(t.cacheKey)) return this.fontCache.get(t.cacheKey);
      var _Promise$withResolver = Promise.withResolvers(),
        n = _Promise$withResolver.promise,
        g = _Promise$withResolver.resolve;
      var o;
      try {
        o = this.preEvaluateFont(t);
        o.cssFontInfo = s;
      } catch (e) {
        warn("loadFont - preEvaluateFont failed: \"".concat(e, "\"."));
        return errorFont();
      }
      var _o35 = o,
        c = _o35.descriptor,
        C = _o35.hash,
        h = r instanceof Ref;
      var l;
      if (C && c instanceof Dict) {
        var _e326 = c.fontAliases || (c.fontAliases = Object.create(null));
        if (_e326[C]) {
          var _t234 = _e326[C].aliasRef;
          if (h && _t234 && this.fontCache.has(_t234)) {
            this.fontCache.putAlias(r, _t234);
            return this.fontCache.get(r);
          }
        } else _e326[C] = {
          fontID: this.idFactory.createFontId()
        };
        h && (_e326[C].aliasRef = r);
        l = _e326[C].fontID;
      } else l = this.idFactory.createFontId();
      assert((_l9 = l) === null || _l9 === void 0 ? void 0 : _l9.startsWith("f"), 'The "fontID" must be (correctly) defined.');
      if (h) this.fontCache.put(r, n);else {
        t.cacheKey = "cacheKey_".concat(l);
        this.fontCache.put(t.cacheKey, n);
      }
      t.loadedName = "".concat(this.idFactory.getDocId(), "_").concat(l);
      this.translateFont(o).then(function (e) {
        g(new TranslatedFont({
          loadedName: t.loadedName,
          font: e,
          dict: t,
          evaluatorOptions: _this49.options
        }));
      }).catch(function (e) {
        warn("loadFont - translateFont failed: \"".concat(e, "\"."));
        g(new TranslatedFont({
          loadedName: t.loadedName,
          font: new ErrorFont(e instanceof Error ? e.message : e),
          dict: t,
          evaluatorOptions: _this49.options
        }));
      });
      return n;
    }
  }, {
    key: "buildPath",
    value: function buildPath(e, t, i) {
      var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var s = e.length - 1;
      i || (i = []);
      if (s < 0 || e.fnArray[s] !== tt) {
        if (a) {
          warn("Encountered path operator \"".concat(t, "\" inside of a text object."));
          e.addOp(GA, null);
        }
        var _s131;
        switch (t) {
          case KA:
            var _e327 = i[0] + i[2],
              _t235 = i[1] + i[3];
            _s131 = [Math.min(i[0], _e327), Math.min(i[1], _t235), Math.max(i[0], _e327), Math.max(i[1], _t235)];
            break;
          case MA:
          case LA:
            _s131 = [i[0], i[1], i[0], i[1]];
            break;
          default:
            _s131 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
        }
        e.addOp(tt, [[t], i, _s131]);
        a && e.addOp(xA, null);
      } else {
        var _a191$;
        var _a191 = e.argsArray[s];
        _a191[0].push(t);
        (_a191$ = _a191[1]).push.apply(_a191$, _toConsumableArray(i));
        var _r94 = _a191[2];
        switch (t) {
          case KA:
            var _e328 = i[0] + i[2],
              _t236 = i[1] + i[3];
            _r94[0] = Math.min(_r94[0], i[0], _e328);
            _r94[1] = Math.min(_r94[1], i[1], _t236);
            _r94[2] = Math.max(_r94[2], i[0], _e328);
            _r94[3] = Math.max(_r94[3], i[1], _t236);
            break;
          case MA:
          case LA:
            _r94[0] = Math.min(_r94[0], i[0]);
            _r94[1] = Math.min(_r94[1], i[1]);
            _r94[2] = Math.max(_r94[2], i[0]);
            _r94[3] = Math.max(_r94[3], i[1]);
        }
      }
    }
  }, {
    key: "parseColorSpace",
    value: function parseColorSpace(_ref77) {
      var _this50 = this;
      var e = _ref77.cs,
        t = _ref77.resources,
        i = _ref77.localColorSpaceCache;
      return ColorSpace.parseAsync({
        cs: e,
        xref: this.xref,
        resources: t,
        pdfFunctionFactory: this._pdfFunctionFactory,
        localColorSpaceCache: i
      }).catch(function (e) {
        if (e instanceof AbortException) return null;
        if (_this50.options.ignoreErrors) {
          warn("parseColorSpace - ignoring ColorSpace: \"".concat(e, "\"."));
          return null;
        }
        throw e;
      });
    }
  }, {
    key: "parseShading",
    value: function parseShading(_ref78) {
      var e = _ref78.shading,
        t = _ref78.resources,
        i = _ref78.localColorSpaceCache,
        a = _ref78.localShadingPatternCache;
      var s,
        r = a.get(e);
      if (r) return r;
      try {
        s = Pattern.parseShading(e, this.xref, t, this._pdfFunctionFactory, i).getIR();
      } catch (t) {
        if (t instanceof AbortException) return null;
        if (this.options.ignoreErrors) {
          warn("parseShading - ignoring shading: \"".concat(t, "\"."));
          a.set(e, null);
          return null;
        }
        throw t;
      }
      r = "pattern_".concat(this.idFactory.createObjId());
      this.parsingType3Font && (r = "".concat(this.idFactory.getDocId(), "_type3_").concat(r));
      a.set(e, r);
      this.parsingType3Font ? this.handler.send("commonobj", [r, "Pattern", s]) : this.handler.send("obj", [r, this.pageIndex, "Pattern", s]);
      return r;
    }
  }, {
    key: "handleColorN",
    value: function handleColorN(e, t, i, a, s, r, n, g, o, c) {
      var C = i.pop();
      if (C instanceof Name) {
        var h = s.getRaw(C.name),
          l = h instanceof Ref && o.getByRef(h);
        if (l) try {
          var _s132 = a.base ? a.base.getRgb(i, 0) : null,
            _r95 = getTilingPatternIR(l.operatorListIR, l.dict, _s132);
          e.addOp(t, _r95);
          return;
        } catch (_unused10) {}
        var Q = this.xref.fetchIfRef(h);
        if (Q) {
          var _s133 = Q instanceof BaseStream ? Q.dict : Q,
            _C17 = _s133.get("PatternType");
          if (_C17 === Rs) {
            var _g47 = a.base ? a.base.getRgb(i, 0) : null;
            return this.handleTilingType(t, _g47, r, Q, _s133, e, n, o);
          }
          if (_C17 === Ns) {
            var _i215 = _s133.get("Shading"),
              _a192 = this.parseShading({
                shading: _i215,
                resources: r,
                localColorSpaceCache: g,
                localShadingPatternCache: c
              });
            if (_a192) {
              var _i216 = lookupMatrix(_s133.getArray("Matrix"), null);
              e.addOp(t, ["Shading", _a192, _i216]);
            }
            return;
          }
          throw new FormatError("Unknown PatternType: ".concat(_C17));
        }
      }
      throw new FormatError("Unknown PatternName: ".concat(C));
    }
  }, {
    key: "_parseVisibilityExpression",
    value: function _parseVisibilityExpression(e, t, i) {
      if (++t > 10) {
        warn("Visibility expression is too deeply nested");
        return;
      }
      var a = e.length,
        s = this.xref.fetchIfRef(e[0]);
      if (!(a < 2) && s instanceof Name) {
        switch (s.name) {
          case "And":
          case "Or":
          case "Not":
            i.push(s.name);
            break;
          default:
            warn("Invalid operator ".concat(s.name, " in visibility expression"));
            return;
        }
        for (var _s134 = 1; _s134 < a; _s134++) {
          var _a193 = e[_s134],
            _r96 = this.xref.fetchIfRef(_a193);
          if (Array.isArray(_r96)) {
            var _e329 = [];
            i.push(_e329);
            this._parseVisibilityExpression(_r96, t, _e329);
          } else _a193 instanceof Ref && i.push(_a193.toString());
        }
      } else warn("Invalid visibility expression");
    }
  }, {
    key: "parseMarkedContentProps",
    value: function () {
      var _parseMarkedContentProps = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee30(e, t) {
        var _i$get;
        var i, a, _e330, _t237, _t238, _e331, _iterator67, _step67, _i217;
        return _regeneratorRuntime().wrap(function _callee30$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              if (!(e instanceof Name)) {
                _context32.next = 4;
                break;
              }
              i = t.get("Properties").get(e.name);
              _context32.next = 7;
              break;
            case 4:
              if (e instanceof Dict) {
                _context32.next = 6;
                break;
              }
              throw new FormatError("Optional content properties malformed.");
            case 6:
              i = e;
            case 7:
              a = (_i$get = i.get("Type")) === null || _i$get === void 0 ? void 0 : _i$get.name;
              if (!("OCG" === a)) {
                _context32.next = 10;
                break;
              }
              return _context32.abrupt("return", {
                type: a,
                id: i.objId
              });
            case 10:
              if (!("OCMD" === a)) {
                _context32.next = 24;
                break;
              }
              _e330 = i.get("VE");
              if (!Array.isArray(_e330)) {
                _context32.next = 17;
                break;
              }
              _t237 = [];
              this._parseVisibilityExpression(_e330, 0, _t237);
              if (!(_t237.length > 0)) {
                _context32.next = 17;
                break;
              }
              return _context32.abrupt("return", {
                type: "OCMD",
                expression: _t237
              });
            case 17:
              _t238 = i.get("OCGs");
              if (!(Array.isArray(_t238) || _t238 instanceof Dict)) {
                _context32.next = 22;
                break;
              }
              _e331 = [];
              if (Array.isArray(_t238)) {
                _iterator67 = _createForOfIteratorHelper(_t238);
                try {
                  for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
                    _i217 = _step67.value;
                    _e331.push(_i217.toString());
                  }
                } catch (err) {
                  _iterator67.e(err);
                } finally {
                  _iterator67.f();
                }
              } else _e331.push(_t238.objId);
              return _context32.abrupt("return", {
                type: a,
                ids: _e331,
                policy: i.get("P") instanceof Name ? i.get("P").name : null,
                expression: null
              });
            case 22:
              if (!(_t238 instanceof Ref)) {
                _context32.next = 24;
                break;
              }
              return _context32.abrupt("return", {
                type: a,
                id: _t238.toString()
              });
            case 24:
              return _context32.abrupt("return", null);
            case 25:
            case "end":
              return _context32.stop();
          }
        }, _callee30, this);
      }));
      function parseMarkedContentProps(_x54, _x55) {
        return _parseMarkedContentProps.apply(this, arguments);
      }
      return parseMarkedContentProps;
    }()
  }, {
    key: "getOperatorList",
    value: function getOperatorList(_ref79) {
      var _this51 = this;
      var e = _ref79.stream,
        t = _ref79.task,
        i = _ref79.resources,
        a = _ref79.operatorList,
        _ref79$initialState = _ref79.initialState,
        s = _ref79$initialState === void 0 ? null : _ref79$initialState,
        _ref79$fallbackFontDi = _ref79.fallbackFontDict,
        r = _ref79$fallbackFontDi === void 0 ? null : _ref79$fallbackFontDi;
      i || (i = Dict.empty);
      s || (s = new EvalState());
      if (!a) throw new Error('getOperatorList: missing "operatorList" parameter');
      var n = this,
        g = this.xref;
      var o = !1;
      var c = new LocalImageCache(),
        C = new LocalColorSpaceCache(),
        h = new LocalGStateCache(),
        l = new LocalTilingPatternCache(),
        Q = new Map(),
        E = i.get("XObject") || Dict.empty,
        u = i.get("Pattern") || Dict.empty,
        d = new StateManager(s),
        f = new EvaluatorPreprocessor(e, g, d),
        p = new TimeSlotManager();
      function closePendingRestoreOPS(e) {
        for (var _e332 = 0, _t239 = f.savedStatesDepth; _e332 < _t239; _e332++) a.addOp(xA, []);
      }
      return new Promise(function promiseBody(e, s) {
        var next = function next(t) {
          Promise.all([t, a.ready]).then(function () {
            try {
              promiseBody(e, s);
            } catch (e) {
              s(e);
            }
          }, s);
        };
        t.ensureNotTerminated();
        p.reset();
        var m = {};
        var y, w, D, b, F, S;
        for (; !(y = p.check());) {
          m.args = null;
          if (!f.read(m)) break;
          var _e333 = m.args,
            _s135 = m.fn;
          switch (0 | _s135) {
            case Ue:
              S = _e333[0] instanceof Name;
              F = _e333[0].name;
              if (S) {
                var _t240 = c.getByName(F);
                if (_t240) {
                  addLocallyCachedImageOps(a, _t240);
                  _e333 = null;
                  continue;
                }
              }
              next(new Promise(function (e, s) {
                if (!S) throw new FormatError("XObject must be referred to by name.");
                var r = E.getRaw(F);
                if (r instanceof Ref) {
                  var _t241 = c.getByRef(r) || n._regionalImageCache.getByRef(r);
                  if (_t241) {
                    addLocallyCachedImageOps(a, _t241);
                    e();
                    return;
                  }
                  var _i218 = n.globalImageCache.getData(r, n.pageIndex);
                  if (_i218) {
                    a.addDependency(_i218.objId);
                    a.addImageOps(_i218.fn, _i218.args, _i218.optionalContent);
                    e();
                    return;
                  }
                  r = g.fetch(r);
                }
                if (!(r instanceof BaseStream)) throw new FormatError("XObject should be a stream");
                var o = r.dict.get("Subtype");
                if (!(o instanceof Name)) throw new FormatError("XObject should have a Name subtype");
                if ("Form" !== o.name) {
                  if ("Image" !== o.name) {
                    if ("PS" !== o.name) throw new FormatError("Unhandled XObject subtype ".concat(o.name));
                    info("Ignored XObject subtype PS");
                    e();
                  } else n.buildPaintImageXObject({
                    resources: i,
                    image: r,
                    operatorList: a,
                    cacheKey: F,
                    localImageCache: c,
                    localColorSpaceCache: C
                  }).then(e, s);
                } else {
                  d.save();
                  n.buildFormXObject(i, r, null, a, t, d.state.clone(), C).then(function () {
                    d.restore();
                    e();
                  }, s);
                }
              }).catch(function (e) {
                if (!(e instanceof AbortException)) {
                  if (!n.options.ignoreErrors) throw e;
                  warn("getOperatorList - ignoring XObject: \"".concat(e, "\"."));
                }
              }));
              return;
            case se:
              var k = _e333[1];
              next(n.handleSetFont(i, _e333, null, a, t, d.state, r).then(function (e) {
                a.addDependency(e);
                a.addOp(se, [e, k]);
              }));
              return;
            case $A:
              o = !0;
              break;
            case Ae:
              o = !1;
              break;
            case xe:
              var R = _e333[0].cacheKey;
              if (R) {
                var _t242 = c.getByName(R);
                if (_t242) {
                  addLocallyCachedImageOps(a, _t242);
                  _e333 = null;
                  continue;
                }
              }
              next(n.buildPaintImageXObject({
                resources: i,
                image: _e333[0],
                isInline: !0,
                operatorList: a,
                cacheKey: R,
                localImageCache: c,
                localColorSpaceCache: C
              }));
              return;
            case Ce:
              if (!d.state.font) {
                n.ensureStateFont(d.state);
                continue;
              }
              _e333[0] = n.handleText(_e333[0], d.state);
              break;
            case he:
              if (!d.state.font) {
                n.ensureStateFont(d.state);
                continue;
              }
              var N = [],
                G = d.state;
              var _iterator68 = _createForOfIteratorHelper(_e333[0]),
                _step68;
              try {
                for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
                  var _N5;
                  var _t243 = _step68.value;
                  "string" == typeof _t243 ? (_N5 = N).push.apply(_N5, _toConsumableArray(n.handleText(_t243, G))) : "number" == typeof _t243 && N.push(_t243);
                }
              } catch (err) {
                _iterator68.e(err);
              } finally {
                _iterator68.f();
              }
              _e333[0] = N;
              _s135 = Ce;
              break;
            case le:
              if (!d.state.font) {
                n.ensureStateFont(d.state);
                continue;
              }
              a.addOp(ce);
              _e333[0] = n.handleText(_e333[0], d.state);
              _s135 = Ce;
              break;
            case Be:
              if (!d.state.font) {
                n.ensureStateFont(d.state);
                continue;
              }
              a.addOp(ce);
              a.addOp(te, [_e333.shift()]);
              a.addOp(ee, [_e333.shift()]);
              _e333[0] = n.handleText(_e333[0], d.state);
              _s135 = Ce;
              break;
            case re:
              d.state.textRenderingMode = _e333[0];
              break;
            case de:
              {
                var _t244 = ColorSpace.getCached(_e333[0], g, C);
                if (_t244) {
                  d.state.fillColorSpace = _t244;
                  continue;
                }
                next(n.parseColorSpace({
                  cs: _e333[0],
                  resources: i,
                  localColorSpaceCache: C
                }).then(function (e) {
                  d.state.fillColorSpace = e || ColorSpace.singletons.gray;
                }));
                return;
              }
            case ue:
              {
                var _t245 = ColorSpace.getCached(_e333[0], g, C);
                if (_t245) {
                  d.state.strokeColorSpace = _t245;
                  continue;
                }
                next(n.parseColorSpace({
                  cs: _e333[0],
                  resources: i,
                  localColorSpaceCache: C
                }).then(function (e) {
                  d.state.strokeColorSpace = e || ColorSpace.singletons.gray;
                }));
                return;
              }
            case me:
              b = d.state.fillColorSpace;
              _e333 = b.getRgb(_e333, 0);
              _s135 = Fe;
              break;
            case fe:
              b = d.state.strokeColorSpace;
              _e333 = b.getRgb(_e333, 0);
              _s135 = be;
              break;
            case De:
              d.state.fillColorSpace = ColorSpace.singletons.gray;
              _e333 = ColorSpace.singletons.gray.getRgb(_e333, 0);
              _s135 = Fe;
              break;
            case we:
              d.state.strokeColorSpace = ColorSpace.singletons.gray;
              _e333 = ColorSpace.singletons.gray.getRgb(_e333, 0);
              _s135 = be;
              break;
            case ke:
              d.state.fillColorSpace = ColorSpace.singletons.cmyk;
              _e333 = ColorSpace.singletons.cmyk.getRgb(_e333, 0);
              _s135 = Fe;
              break;
            case Se:
              d.state.strokeColorSpace = ColorSpace.singletons.cmyk;
              _e333 = ColorSpace.singletons.cmyk.getRgb(_e333, 0);
              _s135 = be;
              break;
            case Fe:
              d.state.fillColorSpace = ColorSpace.singletons.rgb;
              _e333 = ColorSpace.singletons.rgb.getRgb(_e333, 0);
              break;
            case be:
              d.state.strokeColorSpace = ColorSpace.singletons.rgb;
              _e333 = ColorSpace.singletons.rgb.getRgb(_e333, 0);
              break;
            case ye:
              b = d.state.patternFillColorSpace;
              if (!b) {
                if (isNumberArray(_e333, null)) {
                  _e333 = ColorSpace.singletons.gray.getRgb(_e333, 0);
                  _s135 = Fe;
                  break;
                }
                _e333 = [];
                _s135 = at;
                break;
              }
              if ("Pattern" === b.name) {
                next(n.handleColorN(a, ye, _e333, b, u, i, t, C, l, Q));
                return;
              }
              _e333 = b.getRgb(_e333, 0);
              _s135 = Fe;
              break;
            case pe:
              b = d.state.patternStrokeColorSpace;
              if (!b) {
                if (isNumberArray(_e333, null)) {
                  _e333 = ColorSpace.singletons.gray.getRgb(_e333, 0);
                  _s135 = be;
                  break;
                }
                _e333 = [];
                _s135 = it;
                break;
              }
              if ("Pattern" === b.name) {
                next(n.handleColorN(a, pe, _e333, b, u, i, t, C, l, Q));
                return;
              }
              _e333 = b.getRgb(_e333, 0);
              _s135 = be;
              break;
            case Re:
              var _f9 = void 0;
              try {
                var _t246 = i.get("Shading");
                if (!_t246) throw new FormatError("No shading resource found");
                _f9 = _t246.get(_e333[0].name);
                if (!_f9) throw new FormatError("No shading object found");
              } catch (e) {
                if (e instanceof AbortException) continue;
                if (n.options.ignoreErrors) {
                  warn("getOperatorList - ignoring Shading: \"".concat(e, "\"."));
                  continue;
                }
                throw e;
              }
              var _p7 = n.parseShading({
                shading: _f9,
                resources: i,
                localColorSpaceCache: C,
                localShadingPatternCache: Q
              });
              if (!_p7) continue;
              _e333 = [_p7];
              _s135 = Re;
              break;
            case NA:
              S = _e333[0] instanceof Name;
              F = _e333[0].name;
              if (S) {
                var _t247 = h.getByName(F);
                if (_t247) {
                  _t247.length > 0 && a.addOp(NA, [_t247]);
                  _e333 = null;
                  continue;
                }
              }
              next(new Promise(function (e, s) {
                if (!S) throw new FormatError("GState must be referred to by name.");
                var r = i.get("ExtGState");
                if (!(r instanceof Dict)) throw new FormatError("ExtGState should be a dictionary.");
                var g = r.get(F);
                if (!(g instanceof Dict)) throw new FormatError("GState should be a dictionary.");
                n.setGState({
                  resources: i,
                  gState: g,
                  operatorList: a,
                  cacheKey: F,
                  task: t,
                  stateManager: d,
                  localGStateCache: h,
                  localColorSpaceCache: C
                }).then(e, s);
              }).catch(function (e) {
                if (!(e instanceof AbortException)) {
                  if (!n.options.ignoreErrors) throw e;
                  warn("getOperatorList - ignoring ExtGState: \"".concat(e, "\"."));
                }
              }));
              return;
            case MA:
            case LA:
            case HA:
            case JA:
            case YA:
            case vA:
            case KA:
              n.buildPath(a, _s135, _e333, o);
              continue;
            case Me:
            case Le:
            case ve:
            case Ke:
              continue;
            case Je:
              if (!(_e333[0] instanceof Name)) {
                warn("Expected name for beginMarkedContentProps arg0=".concat(_e333[0]));
                a.addOp(Je, ["OC", null]);
                continue;
              }
              if ("OC" === _e333[0].name) {
                next(n.parseMarkedContentProps(_e333[1], i).then(function (e) {
                  a.addOp(Je, ["OC", e]);
                }).catch(function (e) {
                  if (!(e instanceof AbortException)) {
                    if (!n.options.ignoreErrors) throw e;
                    warn("getOperatorList - ignoring beginMarkedContentProps: \"".concat(e, "\"."));
                    a.addOp(Je, ["OC", null]);
                  }
                }));
                return;
              }
              _e333 = [_e333[0].name, _e333[1] instanceof Dict ? _e333[1].get("MCID") : null];
              break;
            default:
              if (null !== _e333) {
                for (w = 0, D = _e333.length; w < D && !(_e333[w] instanceof Dict); w++);
                if (w < D) {
                  warn("getOperatorList - ignoring operator: " + _s135);
                  continue;
                }
              }
          }
          a.addOp(_s135, _e333);
        }
        if (y) next(Gs);else {
          closePendingRestoreOPS();
          e();
        }
      }).catch(function (e) {
        if (!(e instanceof AbortException)) {
          if (!_this51.options.ignoreErrors) throw e;
          warn("getOperatorList - ignoring errors during \"".concat(t.name, "\" task: \"").concat(e, "\"."));
          closePendingRestoreOPS();
        }
      });
    }
  }, {
    key: "getTextContent",
    value: function getTextContent(_ref80) {
      var _this52 = this;
      var e = _ref80.stream,
        t = _ref80.task,
        s = _ref80.resources,
        _ref80$stateManager = _ref80.stateManager,
        r = _ref80$stateManager === void 0 ? null : _ref80$stateManager,
        _ref80$includeMarkedC = _ref80.includeMarkedContent,
        n = _ref80$includeMarkedC === void 0 ? !1 : _ref80$includeMarkedC,
        g = _ref80.sink,
        _ref80$seenStyles = _ref80.seenStyles,
        o = _ref80$seenStyles === void 0 ? new Set() : _ref80$seenStyles,
        c = _ref80.viewBox,
        _ref80$lang = _ref80.lang,
        C = _ref80$lang === void 0 ? null : _ref80$lang,
        _ref80$markedContentD = _ref80.markedContentData,
        h = _ref80$markedContentD === void 0 ? null : _ref80$markedContentD,
        _ref80$disableNormali = _ref80.disableNormalization,
        l = _ref80$disableNormali === void 0 ? !1 : _ref80$disableNormali,
        _ref80$keepWhiteSpace = _ref80.keepWhiteSpace,
        Q = _ref80$keepWhiteSpace === void 0 ? !1 : _ref80$keepWhiteSpace;
      s || (s = Dict.empty);
      r || (r = new StateManager(new TextState()));
      n && (h || (h = {
        level: 0
      }));
      var E = {
          items: [],
          styles: Object.create(null),
          lang: C
        },
        u = {
          initialized: !1,
          str: [],
          totalWidth: 0,
          totalHeight: 0,
          width: 0,
          height: 0,
          vertical: !1,
          prevTransform: null,
          textAdvanceScale: 0,
          spaceInFlowMin: 0,
          spaceInFlowMax: 0,
          trackingSpaceMin: 1 / 0,
          negativeSpaceMax: -1 / 0,
          notASpace: -1 / 0,
          transform: null,
          fontName: null,
          hasEOL: !1
        },
        d = [" ", " "];
      var f = 0;
      function saveLastChar(e) {
        var t = (f + 1) % 2,
          i = " " !== d[f] && " " === d[t];
        d[f] = e;
        f = t;
        return !Q && i;
      }
      function shouldAddWhitepsace() {
        return !Q && " " !== d[f] && " " === d[(f + 1) % 2];
      }
      function resetLastChars() {
        d[0] = d[1] = " ";
        f = 0;
      }
      var p = this,
        m = this.xref,
        y = [];
      var w = null;
      var D = new LocalImageCache(),
        b = new LocalGStateCache(),
        F = new EvaluatorPreprocessor(e, m, r);
      var S;
      function pushWhitespace(_ref81) {
        var _ref81$width = _ref81.width,
          e = _ref81$width === void 0 ? 0 : _ref81$width,
          _ref81$height = _ref81.height,
          t = _ref81$height === void 0 ? 0 : _ref81$height,
          _ref81$transform = _ref81.transform,
          i = _ref81$transform === void 0 ? u.prevTransform : _ref81$transform,
          _ref81$fontName = _ref81.fontName,
          a = _ref81$fontName === void 0 ? u.fontName : _ref81$fontName;
        E.items.push({
          str: " ",
          dir: "ltr",
          width: e,
          height: t,
          transform: i,
          fontName: a,
          hasEOL: !1
        });
      }
      function getCurrentTextTransform() {
        var e = S.font,
          t = [S.fontSize * S.textHScale, 0, 0, S.fontSize, 0, S.textRise];
        if (e.isType3Font && (S.fontSize <= 1 || e.isCharBBox) && !isArrayEqual(S.fontMatrix, a)) {
          var _i219 = e.bbox[3] - e.bbox[1];
          _i219 > 0 && (t[3] *= _i219 * S.fontMatrix[3]);
        }
        return Util.transform(S.ctm, Util.transform(S.textMatrix, t));
      }
      function ensureTextContentItem() {
        if (u.initialized) return u;
        var _S4 = S,
          e = _S4.font,
          t = _S4.loadedName;
        if (!o.has(t)) {
          o.add(t);
          E.styles[t] = {
            fontFamily: e.fallbackName,
            ascent: e.ascent,
            descent: e.descent,
            vertical: e.vertical
          };
          if (p.options.fontExtraProperties && e.systemFontInfo) {
            var _i220 = E.styles[t];
            _i220.fontSubstitution = e.systemFontInfo.css;
            _i220.fontSubstitutionLoadedName = e.systemFontInfo.loadedName;
          }
        }
        u.fontName = t;
        var i = u.transform = getCurrentTextTransform();
        if (e.vertical) {
          u.width = u.totalWidth = Math.hypot(i[0], i[1]);
          u.height = u.totalHeight = 0;
          u.vertical = !0;
        } else {
          u.width = u.totalWidth = 0;
          u.height = u.totalHeight = Math.hypot(i[2], i[3]);
          u.vertical = !1;
        }
        var a = Math.hypot(S.textLineMatrix[0], S.textLineMatrix[1]),
          s = Math.hypot(S.ctm[0], S.ctm[1]);
        u.textAdvanceScale = s * a;
        var _S5 = S,
          r = _S5.fontSize;
        u.trackingSpaceMin = .102 * r;
        u.notASpace = .03 * r;
        u.negativeSpaceMax = -.2 * r;
        u.spaceInFlowMin = .102 * r;
        u.spaceInFlowMax = .6 * r;
        u.hasEOL = !1;
        u.initialized = !0;
        return u;
      }
      function updateAdvanceScale() {
        if (!u.initialized) return;
        var e = Math.hypot(S.textLineMatrix[0], S.textLineMatrix[1]),
          t = Math.hypot(S.ctm[0], S.ctm[1]) * e;
        if (t !== u.textAdvanceScale) {
          if (u.vertical) {
            u.totalHeight += u.height * u.textAdvanceScale;
            u.height = 0;
          } else {
            u.totalWidth += u.width * u.textAdvanceScale;
            u.width = 0;
          }
          u.textAdvanceScale = t;
        }
      }
      function runBidiTransform(e) {
        var t = e.str.join("");
        l || (t = function normalizeUnicode(e) {
          if (!ct) {
            ct = /([\xA0\xB5\u037E\u0EB3\u2000-\u200A\u202F\u2126\uFB00-\uFB04\uFB06\uFB20-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBA1\uFBA4-\uFBA9\uFBAE-\uFBB1\uFBD3-\uFBDC\uFBDE-\uFBE7\uFBEA-\uFBF8\uFBFC\uFBFD\uFC00-\uFC5D\uFC64-\uFCF1\uFCF5-\uFD3D\uFD88\uFDF4\uFDFA\uFDFB\uFE71\uFE77\uFE79\uFE7B\uFE7D]+)|(\uFB05+)/g;
            Ct = new Map([["ﬅ", "ſt"]]);
          }
          return e.replaceAll(ct, function (e, t, i) {
            return t ? t.normalize("NFKC") : Ct.get(i);
          });
        }(t));
        var i = bidi(t, -1, e.vertical);
        return {
          str: i.str,
          dir: i.dir,
          width: Math.abs(e.totalWidth),
          height: Math.abs(e.totalHeight),
          transform: e.transform,
          fontName: e.fontName,
          hasEOL: e.hasEOL
        };
      }
      function handleSetFont(_x56, _x57) {
        return _handleSetFont2.apply(this, arguments);
      }
      function _handleSetFont2() {
        _handleSetFont2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee31(e, i) {
          var r;
          return _regeneratorRuntime().wrap(function _callee31$(_context33) {
            while (1) switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return p.loadFont(e, i, s);
              case 2:
                r = _context33.sent;
                if (!r.font.isType3Font) {
                  _context33.next = 11;
                  break;
                }
                _context33.prev = 4;
                _context33.next = 7;
                return r.loadType3Data(p, s, t);
              case 7:
                _context33.next = 11;
                break;
              case 9:
                _context33.prev = 9;
                _context33.t0 = _context33["catch"](4);
              case 11:
                S.loadedName = r.loadedName;
                S.font = r.font;
                S.fontMatrix = r.font.fontMatrix || a;
              case 14:
              case "end":
                return _context33.stop();
            }
          }, _callee31, null, [[4, 9]]);
        }));
        return _handleSetFont2.apply(this, arguments);
      }
      function applyInverseRotation(e, t, i) {
        var a = Math.hypot(i[0], i[1]);
        return [(i[0] * e + i[1] * t) / a, (i[2] * e + i[3] * t) / a];
      }
      function compareWithLastPosition(e) {
        var _S$font;
        var t = getCurrentTextTransform();
        var i = t[4],
          a = t[5];
        if ((_S$font = S.font) !== null && _S$font !== void 0 && _S$font.vertical) {
          if (i < c[0] || i > c[2] || a + e < c[1] || a > c[3]) return !1;
        } else if (i + e < c[0] || i > c[2] || a < c[1] || a > c[3]) return !1;
        if (!S.font || !u.prevTransform) return !0;
        var s = u.prevTransform[4],
          r = u.prevTransform[5];
        if (s === i && r === a) return !0;
        var n = -1;
        t[0] && 0 === t[1] && 0 === t[2] ? n = t[0] > 0 ? 0 : 180 : t[1] && 0 === t[0] && 0 === t[3] && (n = t[1] > 0 ? 90 : 270);
        switch (n) {
          case 0:
            break;
          case 90:
            var _ref82 = [a, i];
            i = _ref82[0];
            a = _ref82[1];
            var _ref83 = [r, s];
            s = _ref83[0];
            r = _ref83[1];
            break;
          case 180:
            var _ref84 = [-i, -a, -s, -r];
            i = _ref84[0];
            a = _ref84[1];
            s = _ref84[2];
            r = _ref84[3];
            break;
          case 270:
            var _ref85 = [-a, -i];
            i = _ref85[0];
            a = _ref85[1];
            var _ref86 = [-r, -s];
            s = _ref86[0];
            r = _ref86[1];
            break;
          default:
            var _applyInverseRotation = applyInverseRotation(i, a, t);
            var _applyInverseRotation2 = _slicedToArray(_applyInverseRotation, 2);
            i = _applyInverseRotation2[0];
            a = _applyInverseRotation2[1];
            var _applyInverseRotation3 = applyInverseRotation(s, r, u.prevTransform);
            var _applyInverseRotation4 = _slicedToArray(_applyInverseRotation3, 2);
            s = _applyInverseRotation4[0];
            r = _applyInverseRotation4[1];
        }
        if (S.font.vertical) {
          var _e334 = (r - a) / u.textAdvanceScale,
            _t248 = i - s,
            _n73 = Math.sign(u.height);
          if (_e334 < _n73 * u.negativeSpaceMax) {
            if (Math.abs(_t248) > .5 * u.width) {
              appendEOL();
              return !0;
            }
            resetLastChars();
            flushTextContentItem();
            return !0;
          }
          if (Math.abs(_t248) > u.width) {
            appendEOL();
            return !0;
          }
          _e334 <= _n73 * u.notASpace && resetLastChars();
          if (_e334 <= _n73 * u.trackingSpaceMin) {
            if (shouldAddWhitepsace()) {
              resetLastChars();
              flushTextContentItem();
              pushWhitespace({
                height: Math.abs(_e334)
              });
            } else u.height += _e334;
          } else if (!addFakeSpaces(_e334, u.prevTransform, _n73)) if (0 === u.str.length) {
            resetLastChars();
            pushWhitespace({
              height: Math.abs(_e334)
            });
          } else u.height += _e334;
          Math.abs(_t248) > .25 * u.width && flushTextContentItem();
          return !0;
        }
        var g = (i - s) / u.textAdvanceScale,
          o = a - r,
          C = Math.sign(u.width);
        if (g < C * u.negativeSpaceMax) {
          if (Math.abs(o) > .5 * u.height) {
            appendEOL();
            return !0;
          }
          resetLastChars();
          flushTextContentItem();
          return !0;
        }
        if (Math.abs(o) > u.height) {
          appendEOL();
          return !0;
        }
        g <= C * u.notASpace && resetLastChars();
        if (g <= C * u.trackingSpaceMin) {
          if (shouldAddWhitepsace()) {
            resetLastChars();
            flushTextContentItem();
            pushWhitespace({
              width: Math.abs(g)
            });
          } else u.width += g;
        } else if (!addFakeSpaces(g, u.prevTransform, C)) if (0 === u.str.length) {
          resetLastChars();
          pushWhitespace({
            width: Math.abs(g)
          });
        } else u.width += g;
        Math.abs(o) > .25 * u.height && flushTextContentItem();
        return !0;
      }
      function buildTextContentItem(_ref87) {
        var e = _ref87.chars,
          t = _ref87.extraSpacing;
        var i = S.font;
        if (!e) {
          var _e335 = S.charSpacing + t;
          _e335 && (i.vertical ? S.translateTextMatrix(0, -_e335) : S.translateTextMatrix(_e335 * S.textHScale, 0));
          Q && compareWithLastPosition(0);
          return;
        }
        var a = i.charsToGlyphs(e),
          s = S.fontMatrix[0] * S.fontSize;
        for (var _e336 = 0, _r97 = a.length; _e336 < _r97; _e336++) {
          var _n74 = a[_e336],
            _g48 = _n74.category;
          if (_g48.isInvisibleFormatMark) continue;
          var _o36 = S.charSpacing + (_e336 + 1 === _r97 ? t : 0),
            _c25 = _n74.width;
          i.vertical && (_c25 = _n74.vmetric ? _n74.vmetric[0] : -_c25);
          var _C18 = _c25 * s;
          if (!Q && _g48.isWhitespace) {
            if (i.vertical) {
              _o36 += -_C18 + S.wordSpacing;
              S.translateTextMatrix(0, -_o36);
            } else {
              _o36 += _C18 + S.wordSpacing;
              S.translateTextMatrix(_o36 * S.textHScale, 0);
            }
            saveLastChar(" ");
            continue;
          }
          if (!_g48.isZeroWidthDiacritic && !compareWithLastPosition(_C18)) {
            i.vertical ? S.translateTextMatrix(0, _C18) : S.translateTextMatrix(_C18 * S.textHScale, 0);
            continue;
          }
          var _h10 = ensureTextContentItem();
          _g48.isZeroWidthDiacritic && (_C18 = 0);
          if (i.vertical) {
            S.translateTextMatrix(0, _C18);
            _C18 = Math.abs(_C18);
            _h10.height += _C18;
          } else {
            _C18 *= S.textHScale;
            S.translateTextMatrix(_C18, 0);
            _h10.width += _C18;
          }
          _C18 && (_h10.prevTransform = getCurrentTextTransform());
          var _l10 = _n74.unicode;
          saveLastChar(_l10) && _h10.str.push(" ");
          _h10.str.push(_l10);
          _o36 && (i.vertical ? S.translateTextMatrix(0, -_o36) : S.translateTextMatrix(_o36 * S.textHScale, 0));
        }
      }
      function appendEOL() {
        resetLastChars();
        if (u.initialized) {
          u.hasEOL = !0;
          flushTextContentItem();
        } else E.items.push({
          str: "",
          dir: "ltr",
          width: 0,
          height: 0,
          transform: getCurrentTextTransform(),
          fontName: S.loadedName,
          hasEOL: !0
        });
      }
      function addFakeSpaces(e, t, i) {
        if (i * u.spaceInFlowMin <= e && e <= i * u.spaceInFlowMax) {
          if (u.initialized) {
            resetLastChars();
            u.str.push(" ");
          }
          return !1;
        }
        var a = u.fontName;
        var s = 0;
        if (u.vertical) {
          s = e;
          e = 0;
        }
        flushTextContentItem();
        resetLastChars();
        pushWhitespace({
          width: Math.abs(e),
          height: Math.abs(s),
          transform: t || getCurrentTextTransform(),
          fontName: a
        });
        return !0;
      }
      function flushTextContentItem() {
        if (u.initialized && u.str) {
          u.vertical ? u.totalHeight += u.height * u.textAdvanceScale : u.totalWidth += u.width * u.textAdvanceScale;
          E.items.push(runBidiTransform(u));
          u.initialized = !1;
          u.str.length = 0;
        }
      }
      function enqueueChunk() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        var t = E.items.length;
        if (0 !== t && !(e && t < 10)) {
          g.enqueue(E, t);
          E.items = [];
          E.styles = Object.create(null);
        }
      }
      var k = new TimeSlotManager();
      return new Promise(function promiseBody(e, a) {
        var next = function next(t) {
          enqueueChunk(!0);
          Promise.all([t, g.ready]).then(function () {
            try {
              promiseBody(e, a);
            } catch (e) {
              a(e);
            }
          }, a);
        };
        t.ensureNotTerminated();
        k.reset();
        var u = {};
        var d,
          f = [];
        for (; !(d = k.check());) {
          f.length = 0;
          u.args = f;
          if (!F.read(u)) break;
          var _e337 = S;
          S = r.state;
          var _a194 = u.fn;
          f = u.args;
          switch (0 | a) {
            case se:
              var R = f[0].name,
                N = f[1];
              if (S.font && R === S.fontName && N === S.fontSize) break;
              flushTextContentItem();
              S.fontName = R;
              S.fontSize = N;
              next(handleSetFont(R, null));
              return;
            case ne:
              S.textRise = f[0];
              break;
            case ie:
              S.textHScale = f[0] / 100;
              break;
            case ae:
              S.leading = f[0];
              break;
            case ge:
              S.translateTextLineMatrix(f[0], f[1]);
              S.textMatrix = S.textLineMatrix.slice();
              break;
            case oe:
              S.leading = -f[1];
              S.translateTextLineMatrix(f[0], f[1]);
              S.textMatrix = S.textLineMatrix.slice();
              break;
            case ce:
              S.carriageReturn();
              break;
            case Ie:
              S.setTextMatrix(f[0], f[1], f[2], f[3], f[4], f[5]);
              S.setTextLineMatrix(f[0], f[1], f[2], f[3], f[4], f[5]);
              updateAdvanceScale();
              break;
            case ee:
              S.charSpacing = f[0];
              break;
            case te:
              S.wordSpacing = f[0];
              break;
            case $A:
              S.textMatrix = i.slice();
              S.textLineMatrix = i.slice();
              break;
            case he:
              if (!r.state.font) {
                p.ensureStateFont(r.state);
                continue;
              }
              var _a195 = (S.font.vertical ? 1 : -1) * S.fontSize / 1e3,
                _u9 = f[0];
              for (var _e338 = 0, _t249 = _u9.length; _e338 < _t249; _e338++) {
                var _t250 = _u9[_e338];
                if ("string" == typeof _t250) y.push(_t250);else if ("number" == typeof _t250 && 0 !== _t250) {
                  var _e339 = y.join("");
                  y.length = 0;
                  buildTextContentItem({
                    chars: _e339,
                    extraSpacing: _t250 * _a195
                  });
                }
              }
              if (y.length > 0) {
                var _e340 = y.join("");
                y.length = 0;
                buildTextContentItem({
                  chars: _e340,
                  extraSpacing: 0
                });
              }
              break;
            case Ce:
              if (!r.state.font) {
                p.ensureStateFont(r.state);
                continue;
              }
              buildTextContentItem({
                chars: f[0],
                extraSpacing: 0
              });
              break;
            case le:
              if (!r.state.font) {
                p.ensureStateFont(r.state);
                continue;
              }
              S.carriageReturn();
              buildTextContentItem({
                chars: f[0],
                extraSpacing: 0
              });
              break;
            case Be:
              if (!r.state.font) {
                p.ensureStateFont(r.state);
                continue;
              }
              S.wordSpacing = f[0];
              S.charSpacing = f[1];
              S.carriageReturn();
              buildTextContentItem({
                chars: f[2],
                extraSpacing: 0
              });
              break;
            case Ue:
              flushTextContentItem();
              w || (w = s.get("XObject") || Dict.empty);
              var G = f[0] instanceof Name,
                x = f[0].name;
              if (G && D.getByName(x)) break;
              next(new Promise(function (e, i) {
                if (!G) throw new FormatError("XObject must be referred to by name.");
                var a = w.getRaw(x);
                if (a instanceof Ref) {
                  if (D.getByRef(a)) {
                    e();
                    return;
                  }
                  if (p.globalImageCache.getData(a, p.pageIndex)) {
                    e();
                    return;
                  }
                  a = m.fetch(a);
                }
                if (!(a instanceof BaseStream)) throw new FormatError("XObject should be a stream");
                var E = a.dict.get("Subtype");
                if (!(E instanceof Name)) throw new FormatError("XObject should have a Name subtype");
                if ("Form" !== E.name) {
                  D.set(x, a.dict.objId, !0);
                  e();
                  return;
                }
                var u = r.state.clone(),
                  d = new StateManager(u),
                  f = lookupMatrix(a.dict.getArray("Matrix"), null);
                f && d.transform(f);
                enqueueChunk();
                var y = {
                  enqueueInvoked: !1,
                  enqueue: function enqueue(e, t) {
                    this.enqueueInvoked = !0;
                    g.enqueue(e, t);
                  },
                  get desiredSize() {
                    return g.desiredSize;
                  },
                  get ready() {
                    return g.ready;
                  }
                };
                p.getTextContent({
                  stream: a,
                  task: t,
                  resources: a.dict.get("Resources") || s,
                  stateManager: d,
                  includeMarkedContent: n,
                  sink: y,
                  seenStyles: o,
                  viewBox: c,
                  lang: C,
                  markedContentData: h,
                  disableNormalization: l,
                  keepWhiteSpace: Q
                }).then(function () {
                  y.enqueueInvoked || D.set(x, a.dict.objId, !0);
                  e();
                }, i);
              }).catch(function (e) {
                if (!(e instanceof AbortException)) {
                  if (!p.options.ignoreErrors) throw e;
                  warn("getTextContent - ignoring XObject: \"".concat(e, "\"."));
                }
              }));
              return;
            case NA:
              G = f[0] instanceof Name;
              x = f[0].name;
              if (G && b.getByName(x)) break;
              next(new Promise(function (e, t) {
                if (!G) throw new FormatError("GState must be referred to by name.");
                var i = s.get("ExtGState");
                if (!(i instanceof Dict)) throw new FormatError("ExtGState should be a dictionary.");
                var a = i.get(x);
                if (!(a instanceof Dict)) throw new FormatError("GState should be a dictionary.");
                var r = a.get("Font");
                if (r) {
                  flushTextContentItem();
                  S.fontName = null;
                  S.fontSize = r[1];
                  handleSetFont(null, r[0]).then(e, t);
                } else {
                  b.set(x, a.objId, !0);
                  e();
                }
              }).catch(function (e) {
                if (!(e instanceof AbortException)) {
                  if (!p.options.ignoreErrors) throw e;
                  warn("getTextContent - ignoring ExtGState: \"".concat(e, "\"."));
                }
              }));
              return;
            case He:
              flushTextContentItem();
              if (n) {
                h.level++;
                E.items.push({
                  type: "beginMarkedContent",
                  tag: f[0] instanceof Name ? f[0].name : null
                });
              }
              break;
            case Je:
              flushTextContentItem();
              if (n) {
                h.level++;
                var _e341 = null;
                f[1] instanceof Dict && (_e341 = f[1].get("MCID"));
                E.items.push({
                  type: "beginMarkedContentProps",
                  id: Number.isInteger(_e341) ? "".concat(p.idFactory.getPageObjId(), "_mc").concat(_e341) : null,
                  tag: f[0] instanceof Name ? f[0].name : null
                });
              }
              break;
            case Ye:
              flushTextContentItem();
              if (n) {
                if (0 === h.level) break;
                h.level--;
                E.items.push({
                  type: "endMarkedContent"
                });
              }
              break;
            case xA:
              !_e337 || _e337.font === S.font && _e337.fontSize === S.fontSize && _e337.fontName === S.fontName || flushTextContentItem();
          }
          if (E.items.length >= g.desiredSize) {
            d = !0;
            break;
          }
        }
        if (d) next(Gs);else {
          flushTextContentItem();
          enqueueChunk();
          e();
        }
      }).catch(function (e) {
        if (!(e instanceof AbortException)) {
          if (!_this52.options.ignoreErrors) throw e;
          warn("getTextContent - ignoring errors during \"".concat(t.name, "\" task: \"").concat(e, "\"."));
          flushTextContentItem();
          enqueueChunk();
        }
      });
    }
  }, {
    key: "extractDataStructures",
    value: function () {
      var _extractDataStructures = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee32(e, t) {
        var i, a, s, _i221, _t251, r, n, g, _e342, _t252, _iterator69, _step69, _a196, _e343, _e344, o, c, _e345, _i222, C;
        return _regeneratorRuntime().wrap(function _callee32$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              i = this.xref;
              s = this.readToUnicode(t.toUnicode);
              if (!t.composite) {
                _context34.next = 15;
                break;
              }
              _i221 = e.get("CIDSystemInfo");
              _i221 instanceof Dict && (t.cidSystemInfo = {
                registry: stringToPDFString(_i221.get("Registry")),
                ordering: stringToPDFString(_i221.get("Ordering")),
                supplement: _i221.get("Supplement")
              });
              _context34.prev = 5;
              _t251 = e.get("CIDToGIDMap");
              _t251 instanceof BaseStream && (a = _t251.getBytes());
              _context34.next = 15;
              break;
            case 10:
              _context34.prev = 10;
              _context34.t0 = _context34["catch"](5);
              if (this.options.ignoreErrors) {
                _context34.next = 14;
                break;
              }
              throw _context34.t0;
            case 14:
              warn("extractDataStructures - ignoring CIDToGIDMap data: \"".concat(_context34.t0, "\"."));
            case 15:
              r = [];
              g = null;
              if (!e.has("Encoding")) {
                _context34.next = 59;
                break;
              }
              n = e.get("Encoding");
              if (!(n instanceof Dict)) {
                _context34.next = 50;
                break;
              }
              g = n.get("BaseEncoding");
              g = g instanceof Name ? g.name : null;
              if (!n.has("Differences")) {
                _context34.next = 48;
                break;
              }
              _e342 = n.get("Differences");
              _t252 = 0;
              _iterator69 = _createForOfIteratorHelper(_e342);
              _context34.prev = 26;
              _iterator69.s();
            case 28:
              if ((_step69 = _iterator69.n()).done) {
                _context34.next = 40;
                break;
              }
              _a196 = _step69.value;
              _e343 = i.fetchIfRef(_a196);
              if (!("number" == typeof _e343)) {
                _context34.next = 35;
                break;
              }
              _t252 = _e343;
              _context34.next = 38;
              break;
            case 35:
              if (_e343 instanceof Name) {
                _context34.next = 37;
                break;
              }
              throw new FormatError("Invalid entry in 'Differences' array: ".concat(_e343));
            case 37:
              r[_t252++] = _e343.name;
            case 38:
              _context34.next = 28;
              break;
            case 40:
              _context34.next = 45;
              break;
            case 42:
              _context34.prev = 42;
              _context34.t1 = _context34["catch"](26);
              _iterator69.e(_context34.t1);
            case 45:
              _context34.prev = 45;
              _iterator69.f();
              return _context34.finish(45);
            case 48:
              _context34.next = 58;
              break;
            case 50:
              if (!(n instanceof Name)) {
                _context34.next = 54;
                break;
              }
              g = n.name;
              _context34.next = 58;
              break;
            case 54:
              _e344 = "Encoding is not a Name nor a Dict";
              if (this.options.ignoreErrors) {
                _context34.next = 57;
                break;
              }
              throw new FormatError(_e344);
            case 57:
              warn(_e344);
            case 58:
              "MacRomanEncoding" !== g && "MacExpertEncoding" !== g && "WinAnsiEncoding" !== g && (g = null);
            case 59:
              o = !t.file || t.isInternalFont, c = _i()[t.name];
              g && o && c && (g = null);
              if (g) t.defaultEncoding = getEncoding(g);else {
                _e345 = !!(t.flags & Oi), _i222 = !!(t.flags & Pi);
                n = mi;
                "TrueType" !== t.type || _i222 || (n = yi);
                if (_e345 || c) {
                  n = pi;
                  o && (/Symbol/i.test(t.name) ? n = wi : /Dingbats/i.test(t.name) ? n = Di : /Wingdings/i.test(t.name) && (n = yi));
                }
                t.defaultEncoding = n;
              }
              t.differences = r;
              t.baseEncodingName = g;
              t.hasEncoding = !!g || r.length > 0;
              t.dict = e;
              _context34.next = 68;
              return s;
            case 68:
              t.toUnicode = _context34.sent;
              _context34.next = 71;
              return this.buildToUnicode(t);
            case 71:
              C = _context34.sent;
              t.toUnicode = C;
              a && (t.cidToGidMap = this.readCidToGidMap(a, C));
              return _context34.abrupt("return", t);
            case 75:
            case "end":
              return _context34.stop();
          }
        }, _callee32, this, [[5, 10], [26, 42, 45, 48]]);
      }));
      function extractDataStructures(_x58, _x59) {
        return _extractDataStructures.apply(this, arguments);
      }
      return extractDataStructures;
    }()
  }, {
    key: "_simpleFontToUnicode",
    value: function _simpleFontToUnicode(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      assert(!e.composite, "Must be a simple font.");
      var i = [],
        a = e.defaultEncoding.slice(),
        s = e.baseEncodingName,
        r = e.differences;
      for (var _e346 in r) {
        var _t253 = r[_e346];
        ".notdef" !== _t253 && (a[_e346] = _t253);
      }
      var n = xi();
      for (var _r98 in a) {
        var g = a[_r98];
        if ("" === g) continue;
        var o = n[g];
        if (void 0 !== o) {
          i[_r98] = String.fromCharCode(o);
          continue;
        }
        var c = 0;
        switch (g[0]) {
          case "G":
            3 === g.length && (c = parseInt(g.substring(1), 16));
            break;
          case "g":
            5 === g.length && (c = parseInt(g.substring(1), 16));
            break;
          case "C":
          case "c":
            if (g.length >= 3 && g.length <= 4) {
              var _i223 = g.substring(1);
              if (t) {
                c = parseInt(_i223, 16);
                break;
              }
              c = +_i223;
              if (Number.isNaN(c) && Number.isInteger(parseInt(_i223, 16))) return this._simpleFontToUnicode(e, !0);
            }
            break;
          case "u":
            o = getUnicodeForGlyph(g, n);
            -1 !== o && (c = o);
            break;
          default:
            switch (g) {
              case "f_h":
              case "f_t":
              case "T_h":
                i[_r98] = g.replaceAll("_", "");
                continue;
            }
        }
        if (c > 0 && c <= 1114111 && Number.isInteger(c)) {
          if (s && c === +_r98) {
            var _e347 = getEncoding(s);
            if (_e347 && (g = _e347[_r98])) {
              i[_r98] = String.fromCharCode(n[g]);
              continue;
            }
          }
          i[_r98] = String.fromCodePoint(c);
        }
      }
      return i;
    }
  }, {
    key: "buildToUnicode",
    value: function () {
      var _buildToUnicode = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee33(e) {
        var _e$toUnicode, _e$cidSystemInfo;
        var _e$cidSystemInfo2, t, _i224, _a197, _s136, _r99, _n75;
        return _regeneratorRuntime().wrap(function _callee33$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              e.hasIncludedToUnicodeMap = ((_e$toUnicode = e.toUnicode) === null || _e$toUnicode === void 0 ? void 0 : _e$toUnicode.length) > 0;
              if (!e.hasIncludedToUnicodeMap) {
                _context35.next = 4;
                break;
              }
              !e.composite && e.hasEncoding && (e.fallbackToUnicode = this._simpleFontToUnicode(e));
              return _context35.abrupt("return", e.toUnicode);
            case 4:
              if (e.composite) {
                _context35.next = 6;
                break;
              }
              return _context35.abrupt("return", new ToUnicodeMap(this._simpleFontToUnicode(e)));
            case 6:
              if (!(e.composite && (e.cMap.builtInCMap && !(e.cMap instanceof IdentityCMap) || "Adobe" === ((_e$cidSystemInfo = e.cidSystemInfo) === null || _e$cidSystemInfo === void 0 ? void 0 : _e$cidSystemInfo.registry) && ("GB1" === e.cidSystemInfo.ordering || "CNS1" === e.cidSystemInfo.ordering || "Japan1" === e.cidSystemInfo.ordering || "Korea1" === e.cidSystemInfo.ordering)))) {
                _context35.next = 18;
                break;
              }
              _e$cidSystemInfo2 = e.cidSystemInfo;
              t = _e$cidSystemInfo2.registry;
              _i224 = _e$cidSystemInfo2.ordering;
              _a197 = Name.get("".concat(t, "-").concat(_i224, "-UCS2"));
              _context35.next = 13;
              return CMapFactory.create({
                encoding: _a197,
                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                useCMap: null
              });
            case 13:
              _s136 = _context35.sent;
              _r99 = [];
              _n75 = [];
              e.cMap.forEach(function (e, t) {
                if (t > 65535) throw new FormatError("Max size of CID is 65,535");
                var i = _s136.lookup(t);
                if (i) {
                  _n75.length = 0;
                  for (var _e348 = 0, _t254 = i.length; _e348 < _t254; _e348 += 2) _n75.push((i.charCodeAt(_e348) << 8) + i.charCodeAt(_e348 + 1));
                  _r99[e] = String.fromCharCode.apply(String, _n75);
                }
              });
              return _context35.abrupt("return", new ToUnicodeMap(_r99));
            case 18:
              return _context35.abrupt("return", new IdentityToUnicodeMap(e.firstChar, e.lastChar));
            case 19:
            case "end":
              return _context35.stop();
          }
        }, _callee33, this);
      }));
      function buildToUnicode(_x60) {
        return _buildToUnicode.apply(this, arguments);
      }
      return buildToUnicode;
    }()
  }, {
    key: "readToUnicode",
    value: function () {
      var _readToUnicode = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee34(e) {
        var t, _t255, _i225;
        return _regeneratorRuntime().wrap(function _callee34$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              if (e) {
                _context36.next = 2;
                break;
              }
              return _context36.abrupt("return", null);
            case 2:
              if (!(e instanceof Name)) {
                _context36.next = 7;
                break;
              }
              _context36.next = 5;
              return CMapFactory.create({
                encoding: e,
                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                useCMap: null
              });
            case 5:
              t = _context36.sent;
              return _context36.abrupt("return", t instanceof IdentityCMap ? new IdentityToUnicodeMap(0, 65535) : new ToUnicodeMap(t.getMap()));
            case 7:
              if (!(e instanceof BaseStream)) {
                _context36.next = 27;
                break;
              }
              _context36.prev = 8;
              _context36.next = 11;
              return CMapFactory.create({
                encoding: e,
                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                useCMap: null
              });
            case 11:
              _t255 = _context36.sent;
              if (!(_t255 instanceof IdentityCMap)) {
                _context36.next = 14;
                break;
              }
              return _context36.abrupt("return", new IdentityToUnicodeMap(0, 65535));
            case 14:
              _i225 = new Array(_t255.length);
              _t255.forEach(function (e, t) {
                if ("number" == typeof t) {
                  _i225[e] = String.fromCodePoint(t);
                  return;
                }
                t.length % 2 != 0 && (t = "\0" + t);
                var a = [];
                for (var _e349 = 0; _e349 < t.length; _e349 += 2) {
                  var _i226 = t.charCodeAt(_e349) << 8 | t.charCodeAt(_e349 + 1);
                  if (55296 != (63488 & _i226)) {
                    a.push(_i226);
                    continue;
                  }
                  _e349 += 2;
                  var _s137 = t.charCodeAt(_e349) << 8 | t.charCodeAt(_e349 + 1);
                  a.push(((1023 & _i226) << 10) + (1023 & _s137) + 65536);
                }
                _i225[e] = String.fromCodePoint.apply(String, a);
              });
              return _context36.abrupt("return", new ToUnicodeMap(_i225));
            case 19:
              _context36.prev = 19;
              _context36.t0 = _context36["catch"](8);
              if (!(_context36.t0 instanceof AbortException)) {
                _context36.next = 23;
                break;
              }
              return _context36.abrupt("return", null);
            case 23:
              if (!this.options.ignoreErrors) {
                _context36.next = 26;
                break;
              }
              warn("readToUnicode - ignoring ToUnicode data: \"".concat(_context36.t0, "\"."));
              return _context36.abrupt("return", null);
            case 26:
              throw _context36.t0;
            case 27:
              return _context36.abrupt("return", null);
            case 28:
            case "end":
              return _context36.stop();
          }
        }, _callee34, this, [[8, 19]]);
      }));
      function readToUnicode(_x61) {
        return _readToUnicode.apply(this, arguments);
      }
      return readToUnicode;
    }()
  }, {
    key: "readCidToGidMap",
    value: function readCidToGidMap(e, t) {
      var i = [];
      for (var _a198 = 0, _s138 = e.length; _a198 < _s138; _a198++) {
        var _s139 = e[_a198++] << 8 | e[_a198],
          _r100 = _a198 >> 1;
        (0 !== _s139 || t.has(_r100)) && (i[_r100] = _s139);
      }
      return i;
    }
  }, {
    key: "extractWidths",
    value: function extractWidths(e, t, i) {
      var a = this.xref;
      var s = [],
        r = 0;
      var n = [];
      var g;
      if (i.composite) {
        var _t256 = e.get("DW");
        r = "number" == typeof _t256 ? Math.ceil(_t256) : 1e3;
        var _o37 = e.get("W");
        if (Array.isArray(_o37)) for (var _e350 = 0, _t257 = _o37.length; _e350 < _t257; _e350++) {
          var _t258 = a.fetchIfRef(_o37[_e350++]);
          if (!Number.isInteger(_t258)) break;
          var _i227 = a.fetchIfRef(_o37[_e350]);
          if (Array.isArray(_i227)) {
            var _iterator70 = _createForOfIteratorHelper(_i227),
              _step70;
            try {
              for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
                var _e351 = _step70.value;
                var _i228 = a.fetchIfRef(_e351);
                "number" == typeof _i228 && (s[_t258] = _i228);
                _t258++;
              }
            } catch (err) {
              _iterator70.e(err);
            } finally {
              _iterator70.f();
            }
          } else {
            if (!Number.isInteger(_i227)) break;
            {
              var _r101 = a.fetchIfRef(_o37[++_e350]);
              if ("number" != typeof _r101) continue;
              for (var _e352 = _t258; _e352 <= _i227; _e352++) s[_e352] = _r101;
            }
          }
        }
        if (i.vertical) {
          var _t259 = e.getArray("DW2");
          var _i229 = isNumberArray(_t259, 2) ? _t259 : [880, -1e3];
          g = [_i229[1], .5 * r, _i229[0]];
          _i229 = e.get("W2");
          if (Array.isArray(_i229)) for (var _e353 = 0, _t260 = _i229.length; _e353 < _t260; _e353++) {
            var _t261 = a.fetchIfRef(_i229[_e353++]);
            if (!Number.isInteger(_t261)) break;
            var _s140 = a.fetchIfRef(_i229[_e353]);
            if (Array.isArray(_s140)) for (var _e354 = 0, _i230 = _s140.length; _e354 < _i230; _e354++) {
              var _i231 = [a.fetchIfRef(_s140[_e354++]), a.fetchIfRef(_s140[_e354++]), a.fetchIfRef(_s140[_e354])];
              isNumberArray(_i231, null) && (n[_t261] = _i231);
              _t261++;
            } else {
              if (!Number.isInteger(_s140)) break;
              {
                var _r102 = [a.fetchIfRef(_i229[++_e353]), a.fetchIfRef(_i229[++_e353]), a.fetchIfRef(_i229[++_e353])];
                if (!isNumberArray(_r102, null)) continue;
                for (var _e355 = _t261; _e355 <= _s140; _e355++) n[_e355] = _r102;
              }
            }
          }
        }
      } else {
        var _n76 = e.get("Widths");
        if (Array.isArray(_n76)) {
          var _e356 = i.firstChar;
          var _iterator71 = _createForOfIteratorHelper(_n76),
            _step71;
          try {
            for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
              var _t262 = _step71.value;
              var _i232 = a.fetchIfRef(_t262);
              "number" == typeof _i232 && (s[_e356] = _i232);
              _e356++;
            }
          } catch (err) {
            _iterator71.e(err);
          } finally {
            _iterator71.f();
          }
          var _g49 = t.get("MissingWidth");
          r = "number" == typeof _g49 ? _g49 : 0;
        } else {
          var _t263 = e.get("BaseFont");
          if (_t263 instanceof Name) {
            var _e357 = this.getBaseFontMetrics(_t263.name);
            s = this.buildCharCodeToWidth(_e357.widths, i);
            r = _e357.defaultWidth;
          }
        }
      }
      var o = !0,
        c = r;
      for (var _e358 in s) {
        var _t264 = s[_e358];
        if (_t264) if (c) {
          if (c !== _t264) {
            o = !1;
            break;
          }
        } else c = _t264;
      }
      o ? i.flags |= Ti : i.flags &= ~Ti;
      i.defaultWidth = r;
      i.widths = s;
      i.defaultVMetrics = g;
      i.vmetrics = n;
    }
  }, {
    key: "isSerifFont",
    value: function isSerifFont(e) {
      var t = e.split("-", 1)[0];
      return t in zi() || /serif/gi.test(t);
    }
  }, {
    key: "getBaseFontMetrics",
    value: function getBaseFontMetrics(e) {
      var t = 0,
        i = Object.create(null),
        a = !1;
      var s = Xi()[e] || e;
      var r = ia();
      s in r || (s = this.isSerifFont(e) ? "Times-Roman" : "Helvetica");
      var n = r[s];
      if ("number" == typeof n) {
        t = n;
        a = !0;
      } else i = n();
      return {
        defaultWidth: t,
        monospace: a,
        widths: i
      };
    }
  }, {
    key: "buildCharCodeToWidth",
    value: function buildCharCodeToWidth(e, t) {
      var i = Object.create(null),
        a = t.differences,
        s = t.defaultEncoding;
      for (var _t265 = 0; _t265 < 256; _t265++) _t265 in a && e[a[_t265]] ? i[_t265] = e[a[_t265]] : _t265 in s && e[s[_t265]] && (i[_t265] = e[s[_t265]]);
      return i;
    }
  }, {
    key: "preEvaluateFont",
    value: function preEvaluateFont(e) {
      var t = e;
      var i = e.get("Subtype");
      if (!(i instanceof Name)) throw new FormatError("invalid font Subtype");
      var a,
        s = !1;
      if ("Type0" === i.name) {
        var _t266 = e.get("DescendantFonts");
        if (!_t266) throw new FormatError("Descendant fonts are not specified");
        if (!((e = Array.isArray(_t266) ? this.xref.fetchIfRef(_t266[0]) : _t266) instanceof Dict)) throw new FormatError("Descendant font is not a dictionary.");
        i = e.get("Subtype");
        if (!(i instanceof Name)) throw new FormatError("invalid font Subtype");
        s = !0;
      }
      var r = e.get("FirstChar");
      Number.isInteger(r) || (r = 0);
      var n = e.get("LastChar");
      Number.isInteger(n) || (n = s ? 65535 : 255);
      var g = e.get("FontDescriptor"),
        o = e.get("ToUnicode") || t.get("ToUnicode");
      if (g) {
        a = new MurmurHash3_64();
        var _i233 = t.getRaw("Encoding");
        if (_i233 instanceof Name) a.update(_i233.name);else if (_i233 instanceof Ref) a.update(_i233.toString());else if (_i233 instanceof Dict) {
          var _iterator72 = _createForOfIteratorHelper(_i233.getRawValues()),
            _step72;
          try {
            for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
              var _e359 = _step72.value;
              if (_e359 instanceof Name) a.update(_e359.name);else if (_e359 instanceof Ref) a.update(_e359.toString());else if (Array.isArray(_e359)) {
                var _t267 = _e359.length,
                  _i234 = new Array(_t267);
                for (var _a199 = 0; _a199 < _t267; _a199++) {
                  var _t268 = _e359[_a199];
                  _t268 instanceof Name ? _i234[_a199] = _t268.name : ("number" == typeof _t268 || _t268 instanceof Ref) && (_i234[_a199] = _t268.toString());
                }
                a.update(_i234.join());
              }
            }
          } catch (err) {
            _iterator72.e(err);
          } finally {
            _iterator72.f();
          }
        }
        a.update("".concat(r, "-").concat(n));
        if (o instanceof BaseStream) {
          var _e360 = o.str || o,
            _t269 = _e360.buffer ? new Uint8Array(_e360.buffer.buffer, 0, _e360.bufferLength) : new Uint8Array(_e360.bytes.buffer, _e360.start, _e360.end - _e360.start);
          a.update(_t269);
        } else o instanceof Name && a.update(o.name);
        var _g50 = e.get("Widths") || t.get("Widths");
        if (Array.isArray(_g50)) {
          var _e361 = [];
          var _iterator73 = _createForOfIteratorHelper(_g50),
            _step73;
          try {
            for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
              var _t270 = _step73.value;
              ("number" == typeof _t270 || _t270 instanceof Ref) && _e361.push(_t270.toString());
            }
          } catch (err) {
            _iterator73.e(err);
          } finally {
            _iterator73.f();
          }
          a.update(_e361.join());
        }
        if (s) {
          a.update("compositeFont");
          var _i235 = e.get("W") || t.get("W");
          if (Array.isArray(_i235)) {
            var _e362 = [];
            var _iterator74 = _createForOfIteratorHelper(_i235),
              _step74;
            try {
              for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
                var _t271 = _step74.value;
                if ("number" == typeof _t271 || _t271 instanceof Ref) _e362.push(_t271.toString());else if (Array.isArray(_t271)) {
                  var _i236 = [];
                  var _iterator75 = _createForOfIteratorHelper(_t271),
                    _step75;
                  try {
                    for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
                      var _e363 = _step75.value;
                      ("number" == typeof _e363 || _e363 instanceof Ref) && _i236.push(_e363.toString());
                    }
                  } catch (err) {
                    _iterator75.e(err);
                  } finally {
                    _iterator75.f();
                  }
                  _e362.push("[".concat(_i236.join(), "]"));
                }
              }
            } catch (err) {
              _iterator74.e(err);
            } finally {
              _iterator74.f();
            }
            a.update(_e362.join());
          }
          var _s141 = e.getRaw("CIDToGIDMap") || t.getRaw("CIDToGIDMap");
          _s141 instanceof Name ? a.update(_s141.name) : _s141 instanceof Ref ? a.update(_s141.toString()) : _s141 instanceof BaseStream && a.update(_s141.peekBytes());
        }
      }
      return {
        descriptor: g,
        dict: e,
        baseDict: t,
        composite: s,
        type: i.name,
        firstChar: r,
        lastChar: n,
        toUnicode: o,
        hash: a ? a.hexdigest() : ""
      };
    }
  }, {
    key: "translateFont",
    value: function () {
      var _translateFont = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee35(_ref88) {
        var _h12, _l12;
        var e, t, i, s, r, n, g, o, c, C, _e364, _a200, _s142, _c26, _h11, _l11, _Q16, _E12, _u10, _e365, _t272, _iterator76, _step76, _i237, _a201, _i238, h, l, Q, E, u, d, f, p, m, y, w, D, _e366, _e367, _e368, b, F, S, k, R, N, G, x, U, _e369, _t273, M;
        return _regeneratorRuntime().wrap(function _callee35$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              e = _ref88.descriptor, t = _ref88.dict, i = _ref88.baseDict, s = _ref88.composite, r = _ref88.type, n = _ref88.firstChar, g = _ref88.lastChar, o = _ref88.toUnicode, c = _ref88.cssFontInfo;
              C = "Type3" === r;
              if (e) {
                _context37.next = 24;
                break;
              }
              if (C) {
                _context37.next = 21;
                break;
              }
              _e364 = t.get("BaseFont");
              if (_e364 instanceof Name) {
                _context37.next = 7;
                break;
              }
              throw new FormatError("Base font is not specified");
            case 7:
              _e364 = _e364.name.replaceAll(/[,_]/g, "-");
              _a200 = this.getBaseFontMetrics(_e364), _s142 = _e364.split("-", 1)[0], _c26 = (this.isSerifFont(_s142) ? qi : 0) | (_a200.monospace ? Ti : 0) | (_i()[_s142] ? Oi : Pi), _h11 = {
                type: r,
                name: _e364,
                loadedName: i.loadedName,
                systemFontInfo: null,
                widths: _a200.widths,
                defaultWidth: _a200.defaultWidth,
                isSimulatedFlags: !0,
                flags: _c26,
                firstChar: n,
                lastChar: g,
                toUnicode: o,
                xHeight: 0,
                capHeight: 0,
                italicAngle: 0,
                isType3Font: C
              }, _l11 = t.get("Widths"), _Q16 = getStandardFontName(_e364);
              _E12 = null;
              if (!_Q16) {
                _context37.next = 15;
                break;
              }
              _context37.next = 13;
              return this.fetchStandardFontData(_Q16);
            case 13:
              _E12 = _context37.sent;
              _h11.isInternalFont = !!_E12;
            case 15:
              !_h11.isInternalFont && this.options.useSystemFonts && (_h11.systemFontInfo = getFontSubstitution(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, _e364, _Q16, r));
              _context37.next = 18;
              return this.extractDataStructures(t, _h11);
            case 18:
              _u10 = _context37.sent;
              if (Array.isArray(_l11)) {
                _e365 = [];
                _t272 = n;
                _iterator76 = _createForOfIteratorHelper(_l11);
                try {
                  for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
                    _i237 = _step76.value;
                    _a201 = this.xref.fetchIfRef(_i237);
                    "number" == typeof _a201 && (_e365[_t272] = _a201);
                    _t272++;
                  }
                } catch (err) {
                  _iterator76.e(err);
                } finally {
                  _iterator76.f();
                }
                _u10.widths = _e365;
              } else _u10.widths = this.buildCharCodeToWidth(_a200.widths, _u10);
              return _context37.abrupt("return", new Font(_e364, _E12, _u10));
            case 21:
              _i238 = lookupNormalRect(t.getArray("FontBBox"), [0, 0, 0, 0]);
              (e = new Dict(null)).set("FontName", Name.get(r));
              e.set("FontBBox", _i238);
            case 24:
              h = e.get("FontName"), l = t.get("BaseFont");
              "string" == typeof h && (h = Name.get(h));
              "string" == typeof l && (l = Name.get(l));
              Q = (_h12 = h) === null || _h12 === void 0 ? void 0 : _h12.name, E = (_l12 = l) === null || _l12 === void 0 ? void 0 : _l12.name;
              if (!C && Q !== E) {
                info("The FontDescriptor's FontName is \"".concat(Q, "\" but should be the same as the Font's BaseFont \"").concat(E, "\"."));
                Q && E && (E.startsWith(Q) || !isKnownFontName(Q) && isKnownFontName(E)) && (h = null);
              }
              h || (h = l);
              if (h instanceof Name) {
                _context37.next = 32;
                break;
              }
              throw new FormatError("invalid font name");
            case 32:
              _context37.prev = 32;
              u = e.get("FontFile", "FontFile2", "FontFile3");
              if (!u) {
                _context37.next = 39;
                break;
              }
              if (u instanceof BaseStream) {
                _context37.next = 37;
                break;
              }
              throw new FormatError("FontFile should be a stream");
            case 37:
              if (!u.isEmpty) {
                _context37.next = 39;
                break;
              }
              throw new FormatError("FontFile is empty");
            case 39:
              _context37.next = 47;
              break;
            case 41:
              _context37.prev = 41;
              _context37.t0 = _context37["catch"](32);
              if (this.options.ignoreErrors) {
                _context37.next = 45;
                break;
              }
              throw _context37.t0;
            case 45:
              warn("translateFont - fetching \"".concat(h.name, "\" font file: \"").concat(_context37.t0, "\"."));
              u = null;
            case 47:
              y = !1, w = null, D = null;
              if (!u) {
                _context37.next = 52;
                break;
              }
              if (u.dict) {
                _e366 = u.dict.get("Subtype");
                _e366 instanceof Name && (d = _e366.name);
                f = u.dict.get("Length1");
                p = u.dict.get("Length2");
                m = u.dict.get("Length3");
              }
              _context37.next = 74;
              break;
            case 52:
              if (!c) {
                _context37.next = 66;
                break;
              }
              _e367 = getXfaFontName(h.name);
              if (!_e367) {
                _context37.next = 64;
                break;
              }
              c.fontFamily = "".concat(c.fontFamily, "-PdfJS-XFA");
              c.metrics = _e367.metrics || null;
              w = _e367.factors || null;
              _context37.next = 60;
              return this.fetchStandardFontData(_e367.name);
            case 60:
              u = _context37.sent;
              y = !!u;
              i = t = getXfaFontDict(h.name);
              s = !0;
            case 64:
              _context37.next = 74;
              break;
            case 66:
              if (C) {
                _context37.next = 74;
                break;
              }
              _e368 = getStandardFontName(h.name);
              if (!_e368) {
                _context37.next = 73;
                break;
              }
              _context37.next = 71;
              return this.fetchStandardFontData(_e368);
            case 71:
              u = _context37.sent;
              y = !!u;
            case 73:
              !y && this.options.useSystemFonts && (D = getFontSubstitution(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, h.name, _e368, r));
            case 74:
              b = lookupMatrix(t.getArray("FontMatrix"), a), F = lookupNormalRect(e.getArray("FontBBox") || t.getArray("FontBBox"), void 0);
              S = e.get("Ascent");
              "number" != typeof S && (S = void 0);
              k = e.get("Descent");
              "number" != typeof k && (k = void 0);
              R = e.get("XHeight");
              "number" != typeof R && (R = 0);
              N = e.get("CapHeight");
              "number" != typeof N && (N = 0);
              G = e.get("Flags");
              Number.isInteger(G) || (G = 0);
              x = e.get("ItalicAngle");
              "number" != typeof x && (x = 0);
              U = {
                type: r,
                name: h.name,
                subtype: d,
                file: u,
                length1: f,
                length2: p,
                length3: m,
                isInternalFont: y,
                loadedName: i.loadedName,
                composite: s,
                fixedPitch: !1,
                fontMatrix: b,
                firstChar: n,
                lastChar: g,
                toUnicode: o,
                bbox: F,
                ascent: S,
                descent: k,
                xHeight: R,
                capHeight: N,
                flags: G,
                italicAngle: x,
                isType3Font: C,
                cssFontInfo: c,
                scaleFactors: w,
                systemFontInfo: D
              };
              if (!s) {
                _context37.next = 96;
                break;
              }
              _e369 = i.get("Encoding");
              _e369 instanceof Name && (U.cidEncoding = _e369.name);
              _context37.next = 93;
              return CMapFactory.create({
                encoding: _e369,
                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                useCMap: null
              });
            case 93:
              _t273 = _context37.sent;
              U.cMap = _t273;
              U.vertical = U.cMap.vertical;
            case 96:
              _context37.next = 98;
              return this.extractDataStructures(t, U);
            case 98:
              M = _context37.sent;
              this.extractWidths(t, e, M);
              return _context37.abrupt("return", new Font(h.name, u, M));
            case 101:
            case "end":
              return _context37.stop();
          }
        }, _callee35, this, [[32, 41]]);
      }));
      function translateFont(_x62) {
        return _translateFont.apply(this, arguments);
      }
      return translateFont;
    }()
  }], [{
    key: "buildFontPaths",
    value: function buildFontPaths(e, t, i, a) {
      function buildPath(t) {
        var s = "".concat(e.loadedName, "_path_").concat(t);
        try {
          if (e.renderer.hasBuiltPath(t)) return;
          i.send("commonobj", [s, "FontPath", e.renderer.getPathJs(t)]);
        } catch (e) {
          if (a.ignoreErrors) {
            warn("buildFontPaths - ignoring ".concat(s, " glyph: \"").concat(e, "\"."));
            return;
          }
          throw e;
        }
      }
      var _iterator77 = _createForOfIteratorHelper(t),
        _step77;
      try {
        for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
          var _e370 = _step77.value;
          buildPath(_e370.fontChar);
          var _t274 = _e370.accent;
          (_t274 === null || _t274 === void 0 ? void 0 : _t274.fontChar) && buildPath(_t274.fontChar);
        }
      } catch (err) {
        _iterator77.e(err);
      } finally {
        _iterator77.f();
      }
    }
  }, {
    key: "fallbackFontDict",
    get: function get() {
      var e = new Dict();
      e.set("BaseFont", Name.get("Helvetica"));
      e.set("Type", Name.get("FallbackType"));
      e.set("Subtype", Name.get("FallbackType"));
      e.set("Encoding", Name.get("WinAnsiEncoding"));
      return shadow(this, "fallbackFontDict", e);
    }
  }]);
}();
var TranslatedFont = /*#__PURE__*/function () {
  function TranslatedFont(_ref89) {
    var e = _ref89.loadedName,
      t = _ref89.font,
      i = _ref89.dict,
      a = _ref89.evaluatorOptions;
    _classCallCheck(this, TranslatedFont);
    this.loadedName = e;
    this.font = t;
    this.dict = i;
    this._evaluatorOptions = a || ks;
    this.type3Loaded = null;
    this.type3Dependencies = t.isType3Font ? new Set() : null;
    this.sent = !1;
  }
  return _createClass(TranslatedFont, [{
    key: "send",
    value: function send(e) {
      if (!this.sent) {
        this.sent = !0;
        e.send("commonobj", [this.loadedName, "Font", this.font.exportData(this._evaluatorOptions.fontExtraProperties)]);
      }
    }
  }, {
    key: "fallback",
    value: function fallback(e) {
      if (this.font.data) {
        this.font.disableFontFace = !0;
        PartialEvaluator.buildFontPaths(this.font, this.font.glyphCacheValues, e, this._evaluatorOptions);
      }
    }
  }, {
    key: "loadType3Data",
    value: function loadType3Data(e, t, i) {
      var _this53 = this;
      if (this.type3Loaded) return this.type3Loaded;
      if (!this.font.isType3Font) throw new Error("Must be a Type3 font.");
      var a = e.clone({
          ignoreErrors: !1
        }),
        s = new RefSet(e.type3FontRefs);
      this.dict.objId && !s.has(this.dict.objId) && s.put(this.dict.objId);
      a.type3FontRefs = s;
      var r = this.font,
        n = this.type3Dependencies;
      var g = Promise.resolve();
      var o = this.dict.get("CharProcs"),
        c = this.dict.get("Resources") || t,
        C = Object.create(null),
        h = Util.normalizeRect(r.bbox || [0, 0, 0, 0]),
        l = h[2] - h[0],
        Q = h[3] - h[1],
        E = Math.hypot(l, Q);
      var _iterator78 = _createForOfIteratorHelper(o.getKeys()),
        _step78;
      try {
        var _loop2 = function _loop2() {
          var e = _step78.value;
          g = g.then(function () {
            var t = o.get(e),
              s = new OperatorList();
            return a.getOperatorList({
              stream: t,
              task: i,
              resources: c,
              operatorList: s
            }).then(function () {
              s.fnArray[0] === Ee && _this53._removeType3ColorOperators(s, E);
              C[e] = s.getIR();
              var _iterator79 = _createForOfIteratorHelper(s.dependencies),
                _step79;
              try {
                for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
                  var _e371 = _step79.value;
                  n.add(_e371);
                }
              } catch (err) {
                _iterator79.e(err);
              } finally {
                _iterator79.f();
              }
            }).catch(function (t) {
              warn("Type3 font resource \"".concat(e, "\" is not available."));
              var i = new OperatorList();
              C[e] = i.getIR();
            });
          });
        };
        for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator78.e(err);
      } finally {
        _iterator78.f();
      }
      this.type3Loaded = g.then(function () {
        r.charProcOperatorList = C;
        if (_this53._bbox) {
          r.isCharBBox = !0;
          r.bbox = _this53._bbox;
        }
      });
      return this.type3Loaded;
    }
  }, {
    key: "_removeType3ColorOperators",
    value: function _removeType3ColorOperators(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NaN;
      var i = Util.normalizeRect(e.argsArray[0].slice(2)),
        a = i[2] - i[0],
        s = i[3] - i[1],
        r = Math.hypot(a, s);
      if (0 === a || 0 === s) {
        e.fnArray.splice(0, 1);
        e.argsArray.splice(0, 1);
      } else if (0 === t || Math.round(r / t) >= 10) {
        this._bbox || (this._bbox = [1 / 0, 1 / 0, -1 / 0, -1 / 0]);
        this._bbox[0] = Math.min(this._bbox[0], i[0]);
        this._bbox[1] = Math.min(this._bbox[1], i[1]);
        this._bbox[2] = Math.max(this._bbox[2], i[2]);
        this._bbox[3] = Math.max(this._bbox[3], i[3]);
      }
      var n = 0,
        g = e.length;
      for (; n < g;) {
        switch (e.fnArray[n]) {
          case Ee:
            break;
          case ue:
          case de:
          case fe:
          case pe:
          case me:
          case ye:
          case we:
          case De:
          case be:
          case Fe:
          case Se:
          case ke:
          case Re:
          case kA:
            e.fnArray.splice(n, 1);
            e.argsArray.splice(n, 1);
            g--;
            continue;
          case NA:
            var _e$argsArray$n = _slicedToArray(e.argsArray[n], 1),
              _t275 = _e$argsArray$n[0];
            var _i239 = 0,
              _a202 = _t275.length;
            for (; _i239 < _a202;) {
              var _t275$_i = _slicedToArray(_t275[_i239], 1),
                _e372 = _t275$_i[0];
              switch (_e372) {
                case "TR":
                case "TR2":
                case "HT":
                case "BG":
                case "BG2":
                case "UCR":
                case "UCR2":
                  _t275.splice(_i239, 1);
                  _a202--;
                  continue;
              }
              _i239++;
            }
        }
        n++;
      }
    }
  }]);
}();
var StateManager = /*#__PURE__*/function () {
  function StateManager() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new EvalState();
    _classCallCheck(this, StateManager);
    this.state = e;
    this.stateStack = [];
  }
  return _createClass(StateManager, [{
    key: "save",
    value: function save() {
      var e = this.state;
      this.stateStack.push(this.state);
      this.state = e.clone();
    }
  }, {
    key: "restore",
    value: function restore() {
      var e = this.stateStack.pop();
      e && (this.state = e);
    }
  }, {
    key: "transform",
    value: function transform(e) {
      this.state.ctm = Util.transform(this.state.ctm, e);
    }
  }]);
}();
var TextState = /*#__PURE__*/function () {
  function TextState() {
    _classCallCheck(this, TextState);
    this.ctm = new Float32Array(i);
    this.fontName = null;
    this.fontSize = 0;
    this.loadedName = null;
    this.font = null;
    this.fontMatrix = a;
    this.textMatrix = i.slice();
    this.textLineMatrix = i.slice();
    this.charSpacing = 0;
    this.wordSpacing = 0;
    this.leading = 0;
    this.textHScale = 1;
    this.textRise = 0;
  }
  return _createClass(TextState, [{
    key: "setTextMatrix",
    value: function setTextMatrix(e, t, i, a, s, r) {
      var n = this.textMatrix;
      n[0] = e;
      n[1] = t;
      n[2] = i;
      n[3] = a;
      n[4] = s;
      n[5] = r;
    }
  }, {
    key: "setTextLineMatrix",
    value: function setTextLineMatrix(e, t, i, a, s, r) {
      var n = this.textLineMatrix;
      n[0] = e;
      n[1] = t;
      n[2] = i;
      n[3] = a;
      n[4] = s;
      n[5] = r;
    }
  }, {
    key: "translateTextMatrix",
    value: function translateTextMatrix(e, t) {
      var i = this.textMatrix;
      i[4] = i[0] * e + i[2] * t + i[4];
      i[5] = i[1] * e + i[3] * t + i[5];
    }
  }, {
    key: "translateTextLineMatrix",
    value: function translateTextLineMatrix(e, t) {
      var i = this.textLineMatrix;
      i[4] = i[0] * e + i[2] * t + i[4];
      i[5] = i[1] * e + i[3] * t + i[5];
    }
  }, {
    key: "carriageReturn",
    value: function carriageReturn() {
      this.translateTextLineMatrix(0, -this.leading);
      this.textMatrix = this.textLineMatrix.slice();
    }
  }, {
    key: "clone",
    value: function clone() {
      var e = Object.create(this);
      e.textMatrix = this.textMatrix.slice();
      e.textLineMatrix = this.textLineMatrix.slice();
      e.fontMatrix = this.fontMatrix.slice();
      return e;
    }
  }]);
}();
var EvalState = /*#__PURE__*/function () {
  function EvalState() {
    _classCallCheck(this, EvalState);
    this.ctm = new Float32Array(i);
    this.font = null;
    this.textRenderingMode = w;
    this._fillColorSpace = ColorSpace.singletons.gray;
    this._strokeColorSpace = ColorSpace.singletons.gray;
    this.patternFillColorSpace = null;
    this.patternStrokeColorSpace = null;
  }
  return _createClass(EvalState, [{
    key: "fillColorSpace",
    get: function get() {
      return this._fillColorSpace;
    },
    set: function set(e) {
      this._fillColorSpace = this.patternFillColorSpace = e;
    }
  }, {
    key: "strokeColorSpace",
    get: function get() {
      return this._strokeColorSpace;
    },
    set: function set(e) {
      this._strokeColorSpace = this.patternStrokeColorSpace = e;
    }
  }, {
    key: "clone",
    value: function clone() {
      return Object.create(this);
    }
  }]);
}();
var EvaluatorPreprocessor = /*#__PURE__*/function () {
  function EvaluatorPreprocessor(e, t) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new StateManager();
    _classCallCheck(this, EvaluatorPreprocessor);
    this.parser = new Parser({
      lexer: new Lexer(e, EvaluatorPreprocessor.opMap),
      xref: t
    });
    this.stateManager = i;
    this.nonProcessedArgs = [];
    this._isPathOp = !1;
    this._numInvalidPathOPS = 0;
  }
  return _createClass(EvaluatorPreprocessor, [{
    key: "savedStatesDepth",
    get: function get() {
      return this.stateManager.stateStack.length;
    }
  }, {
    key: "read",
    value: function read(e) {
      var t = e.args;
      for (;;) {
        var _i240 = this.parser.getObj();
        if (_i240 instanceof Cmd) {
          var _a203 = _i240.cmd,
            _s143 = EvaluatorPreprocessor.opMap[_a203];
          if (!_s143) {
            warn("Unknown command \"".concat(_a203, "\"."));
            continue;
          }
          var _r103 = _s143.id,
            _n77 = _s143.numArgs;
          var g = null !== t ? t.length : 0;
          this._isPathOp || (this._numInvalidPathOPS = 0);
          this._isPathOp = _r103 >= MA && _r103 <= VA;
          if (_s143.variableArgs) g > _n77 && info("Command ".concat(_a203, ": expected [0, ").concat(_n77, "] args, but received ").concat(g, " args."));else {
            if (g !== _n77) {
              var _e373 = this.nonProcessedArgs;
              for (; g > _n77;) {
                _e373.push(t.shift());
                g--;
              }
              for (; g < _n77 && 0 !== _e373.length;) {
                null === t && (t = []);
                t.unshift(_e373.pop());
                g++;
              }
            }
            if (g < _n77) {
              var _e374 = "command ".concat(_a203, ": expected ").concat(_n77, " args, but received ").concat(g, " args.");
              if (this._isPathOp && ++this._numInvalidPathOPS > EvaluatorPreprocessor.MAX_INVALID_PATH_OPS) throw new FormatError("Invalid ".concat(_e374));
              warn("Skipping ".concat(_e374));
              null !== t && (t.length = 0);
              continue;
            }
          }
          this.preprocessCommand(_r103, t);
          e.fn = _r103;
          e.args = t;
          return !0;
        }
        if (_i240 === yt) return !1;
        if (null !== _i240) {
          null === t && (t = []);
          t.push(_i240);
          if (t.length > 33) throw new FormatError("Too many arguments");
        }
      }
    }
  }, {
    key: "preprocessCommand",
    value: function preprocessCommand(e, t) {
      switch (0 | e) {
        case GA:
          this.stateManager.save();
          break;
        case xA:
          this.stateManager.restore();
          break;
        case UA:
          this.stateManager.transform(t);
      }
    }
  }], [{
    key: "opMap",
    get: function get() {
      return shadow(this, "opMap", Object.assign(Object.create(null), {
        w: {
          id: wA,
          numArgs: 1,
          variableArgs: !1
        },
        J: {
          id: DA,
          numArgs: 1,
          variableArgs: !1
        },
        j: {
          id: bA,
          numArgs: 1,
          variableArgs: !1
        },
        M: {
          id: FA,
          numArgs: 1,
          variableArgs: !1
        },
        d: {
          id: SA,
          numArgs: 2,
          variableArgs: !1
        },
        ri: {
          id: kA,
          numArgs: 1,
          variableArgs: !1
        },
        i: {
          id: RA,
          numArgs: 1,
          variableArgs: !1
        },
        gs: {
          id: NA,
          numArgs: 1,
          variableArgs: !1
        },
        q: {
          id: GA,
          numArgs: 0,
          variableArgs: !1
        },
        Q: {
          id: xA,
          numArgs: 0,
          variableArgs: !1
        },
        cm: {
          id: UA,
          numArgs: 6,
          variableArgs: !1
        },
        m: {
          id: MA,
          numArgs: 2,
          variableArgs: !1
        },
        l: {
          id: LA,
          numArgs: 2,
          variableArgs: !1
        },
        c: {
          id: HA,
          numArgs: 6,
          variableArgs: !1
        },
        v: {
          id: JA,
          numArgs: 4,
          variableArgs: !1
        },
        y: {
          id: YA,
          numArgs: 4,
          variableArgs: !1
        },
        h: {
          id: vA,
          numArgs: 0,
          variableArgs: !1
        },
        re: {
          id: KA,
          numArgs: 4,
          variableArgs: !1
        },
        S: {
          id: TA,
          numArgs: 0,
          variableArgs: !1
        },
        s: {
          id: qA,
          numArgs: 0,
          variableArgs: !1
        },
        f: {
          id: OA,
          numArgs: 0,
          variableArgs: !1
        },
        F: {
          id: OA,
          numArgs: 0,
          variableArgs: !1
        },
        "f*": {
          id: PA,
          numArgs: 0,
          variableArgs: !1
        },
        B: {
          id: WA,
          numArgs: 0,
          variableArgs: !1
        },
        "B*": {
          id: jA,
          numArgs: 0,
          variableArgs: !1
        },
        b: {
          id: XA,
          numArgs: 0,
          variableArgs: !1
        },
        "b*": {
          id: ZA,
          numArgs: 0,
          variableArgs: !1
        },
        n: {
          id: VA,
          numArgs: 0,
          variableArgs: !1
        },
        W: {
          id: zA,
          numArgs: 0,
          variableArgs: !1
        },
        "W*": {
          id: _A,
          numArgs: 0,
          variableArgs: !1
        },
        BT: {
          id: $A,
          numArgs: 0,
          variableArgs: !1
        },
        ET: {
          id: Ae,
          numArgs: 0,
          variableArgs: !1
        },
        Tc: {
          id: ee,
          numArgs: 1,
          variableArgs: !1
        },
        Tw: {
          id: te,
          numArgs: 1,
          variableArgs: !1
        },
        Tz: {
          id: ie,
          numArgs: 1,
          variableArgs: !1
        },
        TL: {
          id: ae,
          numArgs: 1,
          variableArgs: !1
        },
        Tf: {
          id: se,
          numArgs: 2,
          variableArgs: !1
        },
        Tr: {
          id: re,
          numArgs: 1,
          variableArgs: !1
        },
        Ts: {
          id: ne,
          numArgs: 1,
          variableArgs: !1
        },
        Td: {
          id: ge,
          numArgs: 2,
          variableArgs: !1
        },
        TD: {
          id: oe,
          numArgs: 2,
          variableArgs: !1
        },
        Tm: {
          id: Ie,
          numArgs: 6,
          variableArgs: !1
        },
        "T*": {
          id: ce,
          numArgs: 0,
          variableArgs: !1
        },
        Tj: {
          id: Ce,
          numArgs: 1,
          variableArgs: !1
        },
        TJ: {
          id: he,
          numArgs: 1,
          variableArgs: !1
        },
        "'": {
          id: le,
          numArgs: 1,
          variableArgs: !1
        },
        '"': {
          id: Be,
          numArgs: 3,
          variableArgs: !1
        },
        d0: {
          id: Qe,
          numArgs: 2,
          variableArgs: !1
        },
        d1: {
          id: Ee,
          numArgs: 6,
          variableArgs: !1
        },
        CS: {
          id: ue,
          numArgs: 1,
          variableArgs: !1
        },
        cs: {
          id: de,
          numArgs: 1,
          variableArgs: !1
        },
        SC: {
          id: fe,
          numArgs: 4,
          variableArgs: !0
        },
        SCN: {
          id: pe,
          numArgs: 33,
          variableArgs: !0
        },
        sc: {
          id: me,
          numArgs: 4,
          variableArgs: !0
        },
        scn: {
          id: ye,
          numArgs: 33,
          variableArgs: !0
        },
        G: {
          id: we,
          numArgs: 1,
          variableArgs: !1
        },
        g: {
          id: De,
          numArgs: 1,
          variableArgs: !1
        },
        RG: {
          id: be,
          numArgs: 3,
          variableArgs: !1
        },
        rg: {
          id: Fe,
          numArgs: 3,
          variableArgs: !1
        },
        K: {
          id: Se,
          numArgs: 4,
          variableArgs: !1
        },
        k: {
          id: ke,
          numArgs: 4,
          variableArgs: !1
        },
        sh: {
          id: Re,
          numArgs: 1,
          variableArgs: !1
        },
        BI: {
          id: Ne,
          numArgs: 0,
          variableArgs: !1
        },
        ID: {
          id: Ge,
          numArgs: 0,
          variableArgs: !1
        },
        EI: {
          id: xe,
          numArgs: 1,
          variableArgs: !1
        },
        Do: {
          id: Ue,
          numArgs: 1,
          variableArgs: !1
        },
        MP: {
          id: Me,
          numArgs: 1,
          variableArgs: !1
        },
        DP: {
          id: Le,
          numArgs: 2,
          variableArgs: !1
        },
        BMC: {
          id: He,
          numArgs: 1,
          variableArgs: !1
        },
        BDC: {
          id: Je,
          numArgs: 2,
          variableArgs: !1
        },
        EMC: {
          id: Ye,
          numArgs: 0,
          variableArgs: !1
        },
        BX: {
          id: ve,
          numArgs: 0,
          variableArgs: !1
        },
        EX: {
          id: Ke,
          numArgs: 0,
          variableArgs: !1
        },
        BM: null,
        BD: null,
        true: null,
        fa: null,
        fal: null,
        fals: null,
        false: null,
        nu: null,
        nul: null,
        null: null
      }));
    }
  }]);
}();
EvaluatorPreprocessor.MAX_INVALID_PATH_OPS = 10;
var DefaultAppearanceEvaluator = /*#__PURE__*/function (_EvaluatorPreprocesso) {
  function DefaultAppearanceEvaluator(e) {
    _classCallCheck(this, DefaultAppearanceEvaluator);
    return _callSuper(this, DefaultAppearanceEvaluator, [new StringStream(e)]);
  }
  _inherits(DefaultAppearanceEvaluator, _EvaluatorPreprocesso);
  return _createClass(DefaultAppearanceEvaluator, [{
    key: "parse",
    value: function parse() {
      var e = {
          fn: 0,
          args: []
        },
        t = {
          fontSize: 0,
          fontName: "",
          fontColor: new Uint8ClampedArray(3)
        };
      try {
        for (;;) {
          e.args.length = 0;
          if (!this.read(e)) break;
          if (0 !== this.savedStatesDepth) continue;
          var _i241 = e.fn,
            _a204 = e.args;
          switch (0 | i) {
            case se:
              var _a205 = _slicedToArray(_a204, 2),
                _e375 = _a205[0],
                _i242 = _a205[1];
              _e375 instanceof Name && (t.fontName = _e375.name);
              "number" == typeof _i242 && _i242 > 0 && (t.fontSize = _i242);
              break;
            case Fe:
              ColorSpace.singletons.rgb.getRgbItem(_a204, 0, t.fontColor, 0);
              break;
            case De:
              ColorSpace.singletons.gray.getRgbItem(_a204, 0, t.fontColor, 0);
              break;
            case ke:
              ColorSpace.singletons.cmyk.getRgbItem(_a204, 0, t.fontColor, 0);
          }
        }
      } catch (e) {
        warn("parseDefaultAppearance - ignoring errors: \"".concat(e, "\"."));
      }
      return t;
    }
  }]);
}(EvaluatorPreprocessor);
function parseDefaultAppearance(e) {
  return new DefaultAppearanceEvaluator(e).parse();
}
var AppearanceStreamEvaluator = /*#__PURE__*/function (_EvaluatorPreprocesso2) {
  function AppearanceStreamEvaluator(e, t, i) {
    var _e$dict3;
    var _this54;
    _classCallCheck(this, AppearanceStreamEvaluator);
    _this54 = _callSuper(this, AppearanceStreamEvaluator, [e]);
    _this54.stream = e;
    _this54.evaluatorOptions = t;
    _this54.xref = i;
    _this54.resources = (_e$dict3 = e.dict) === null || _e$dict3 === void 0 ? void 0 : _e$dict3.get("Resources");
    return _this54;
  }
  _inherits(AppearanceStreamEvaluator, _EvaluatorPreprocesso2);
  return _createClass(AppearanceStreamEvaluator, [{
    key: "parse",
    value: function parse() {
      var e = {
        fn: 0,
        args: []
      };
      var t = {
          scaleFactor: 1,
          fontSize: 0,
          fontName: "",
          fontColor: new Uint8ClampedArray(3),
          fillColorSpace: ColorSpace.singletons.gray
        },
        i = !1;
      var a = [];
      try {
        for (;;) {
          e.args.length = 0;
          if (i || !this.read(e)) break;
          var _s144 = e.fn,
            _r104 = e.args;
          switch (0 | s) {
            case GA:
              a.push({
                scaleFactor: t.scaleFactor,
                fontSize: t.fontSize,
                fontName: t.fontName,
                fontColor: t.fontColor.slice(),
                fillColorSpace: t.fillColorSpace
              });
              break;
            case xA:
              t = a.pop() || t;
              break;
            case Ie:
              t.scaleFactor *= Math.hypot(_r104[0], _r104[1]);
              break;
            case se:
              var _r105 = _slicedToArray(_r104, 2),
                _e376 = _r105[0],
                _s145 = _r105[1];
              _e376 instanceof Name && (t.fontName = _e376.name);
              "number" == typeof _s145 && _s145 > 0 && (t.fontSize = _s145 * t.scaleFactor);
              break;
            case de:
              t.fillColorSpace = ColorSpace.parse({
                cs: _r104[0],
                xref: this.xref,
                resources: this.resources,
                pdfFunctionFactory: this._pdfFunctionFactory,
                localColorSpaceCache: this._localColorSpaceCache
              });
              break;
            case me:
              t.fillColorSpace.getRgbItem(_r104, 0, t.fontColor, 0);
              break;
            case Fe:
              ColorSpace.singletons.rgb.getRgbItem(_r104, 0, t.fontColor, 0);
              break;
            case De:
              ColorSpace.singletons.gray.getRgbItem(_r104, 0, t.fontColor, 0);
              break;
            case ke:
              ColorSpace.singletons.cmyk.getRgbItem(_r104, 0, t.fontColor, 0);
              break;
            case Ce:
            case he:
            case le:
            case Be:
              i = !0;
          }
        }
      } catch (e) {
        warn("parseAppearanceStream - ignoring errors: \"".concat(e, "\"."));
      }
      this.stream.reset();
      delete t.scaleFactor;
      delete t.fillColorSpace;
      return t;
    }
  }, {
    key: "_localColorSpaceCache",
    get: function get() {
      return shadow(this, "_localColorSpaceCache", new LocalColorSpaceCache());
    }
  }, {
    key: "_pdfFunctionFactory",
    get: function get() {
      return shadow(this, "_pdfFunctionFactory", new PDFFunctionFactory({
        xref: this.xref,
        isEvalSupported: this.evaluatorOptions.isEvalSupported
      }));
    }
  }]);
}(EvaluatorPreprocessor);
function getPdfColor(e, t) {
  if (e[0] === e[1] && e[1] === e[2]) {
    return "".concat(numberToString(e[0] / 255), " ").concat(t ? "g" : "G");
  }
  return Array.from(e, function (e) {
    return numberToString(e / 255);
  }).join(" ") + " " + (t ? "rg" : "RG");
}
var FakeUnicodeFont = /*#__PURE__*/function () {
  function FakeUnicodeFont(e, t) {
    _classCallCheck(this, FakeUnicodeFont);
    this.xref = e;
    this.widths = null;
    this.firstChar = 1 / 0;
    this.lastChar = -1 / 0;
    this.fontFamily = t;
    var i = new OffscreenCanvas(1, 1);
    this.ctxMeasure = i.getContext("2d", {
      willReadFrequently: !0
    });
    FakeUnicodeFont._fontNameId || (FakeUnicodeFont._fontNameId = 1);
    this.fontName = Name.get("InvalidPDFjsFont_".concat(t, "_").concat(FakeUnicodeFont._fontNameId++));
  }
  return _createClass(FakeUnicodeFont, [{
    key: "fontDescriptorRef",
    get: function get() {
      if (!FakeUnicodeFont._fontDescriptorRef) {
        var _e377 = new Dict(this.xref);
        _e377.set("Type", Name.get("FontDescriptor"));
        _e377.set("FontName", this.fontName);
        _e377.set("FontFamily", "MyriadPro Regular");
        _e377.set("FontBBox", [0, 0, 0, 0]);
        _e377.set("FontStretch", Name.get("Normal"));
        _e377.set("FontWeight", 400);
        _e377.set("ItalicAngle", 0);
        FakeUnicodeFont._fontDescriptorRef = this.xref.getNewPersistentRef(_e377);
      }
      return FakeUnicodeFont._fontDescriptorRef;
    }
  }, {
    key: "descendantFontRef",
    get: function get() {
      var e = new Dict(this.xref);
      e.set("BaseFont", this.fontName);
      e.set("Type", Name.get("Font"));
      e.set("Subtype", Name.get("CIDFontType0"));
      e.set("CIDToGIDMap", Name.get("Identity"));
      e.set("FirstChar", this.firstChar);
      e.set("LastChar", this.lastChar);
      e.set("FontDescriptor", this.fontDescriptorRef);
      e.set("DW", 1e3);
      var t = [],
        i = _toConsumableArray(this.widths.entries()).sort();
      var a = null,
        s = null;
      var _iterator80 = _createForOfIteratorHelper(i),
        _step80;
      try {
        for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
          var _ref90 = _step80.value;
          var _ref91 = _slicedToArray(_ref90, 2);
          var _e378 = _ref91[0];
          var _r106 = _ref91[1];
          if (a) {
            if (_e378 === a + s.length) s.push(_r106);else {
              t.push(a, s);
              a = _e378;
              s = [_r106];
            }
          } else {
            a = _e378;
            s = [_r106];
          }
        }
      } catch (err) {
        _iterator80.e(err);
      } finally {
        _iterator80.f();
      }
      a && t.push(a, s);
      e.set("W", t);
      var r = new Dict(this.xref);
      r.set("Ordering", "Identity");
      r.set("Registry", "Adobe");
      r.set("Supplement", 0);
      e.set("CIDSystemInfo", r);
      return this.xref.getNewPersistentRef(e);
    }
  }, {
    key: "baseFontRef",
    get: function get() {
      var e = new Dict(this.xref);
      e.set("BaseFont", this.fontName);
      e.set("Type", Name.get("Font"));
      e.set("Subtype", Name.get("Type0"));
      e.set("Encoding", Name.get("Identity-H"));
      e.set("DescendantFonts", [this.descendantFontRef]);
      e.set("ToUnicode", Name.get("Identity-H"));
      return this.xref.getNewPersistentRef(e);
    }
  }, {
    key: "resources",
    get: function get() {
      var e = new Dict(this.xref),
        t = new Dict(this.xref);
      t.set(this.fontName.name, this.baseFontRef);
      e.set("Font", t);
      return e;
    }
  }, {
    key: "_createContext",
    value: function _createContext() {
      this.widths = new Map();
      this.ctxMeasure.font = "1000px ".concat(this.fontFamily);
      return this.ctxMeasure;
    }
  }, {
    key: "createFontResources",
    value: function createFontResources(e) {
      var t = this._createContext();
      var _iterator81 = _createForOfIteratorHelper(e.split(/\r\n?|\n/)),
        _step81;
      try {
        for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
          var _i243 = _step81.value;
          var _iterator82 = _createForOfIteratorHelper(_i243.split("")),
            _step82;
          try {
            for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
              var _e379 = _step82.value;
              var _i244 = _e379.charCodeAt(0);
              if (this.widths.has(_i244)) continue;
              var _a206 = t.measureText(_e379),
                _s146 = Math.ceil(_a206.width);
              this.widths.set(_i244, _s146);
              this.firstChar = Math.min(_i244, this.firstChar);
              this.lastChar = Math.max(_i244, this.lastChar);
            }
          } catch (err) {
            _iterator82.e(err);
          } finally {
            _iterator82.f();
          }
        }
      } catch (err) {
        _iterator81.e(err);
      } finally {
        _iterator81.f();
      }
      return this.resources;
    }
  }, {
    key: "createAppearance",
    value: function createAppearance(e, t, i, a, n, g) {
      var _ref92;
      var o = this._createContext(),
        c = [];
      var C = -1 / 0;
      var _iterator83 = _createForOfIteratorHelper(e.split(/\r\n?|\n/)),
        _step83;
      try {
        for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
          var _t278 = _step83.value;
          c.push(_t278);
          var _e383 = o.measureText(_t278).width;
          C = Math.max(C, _e383);
          var _iterator84 = _createForOfIteratorHelper(codePointIter(_t278)),
            _step84;
          try {
            for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
              var _e384 = _step84.value;
              var _t279 = String.fromCodePoint(_e384);
              var _i246 = this.widths.get(_e384);
              if (void 0 === _i246) {
                var _a207 = o.measureText(_t279);
                _i246 = Math.ceil(_a207.width);
                this.widths.set(_e384, _i246);
                this.firstChar = Math.min(_e384, this.firstChar);
                this.lastChar = Math.max(_e384, this.lastChar);
              }
            }
          } catch (err) {
            _iterator84.e(err);
          } finally {
            _iterator84.f();
          }
        }
      } catch (err) {
        _iterator83.e(err);
      } finally {
        _iterator83.f();
      }
      C *= a / 1e3;
      var _t276 = _slicedToArray(t, 4),
        h = _t276[0],
        l = _t276[1],
        Q = _t276[2],
        E = _t276[3];
      var u = Q - h,
        d = E - l;
      i % 180 != 0 && (_ref92 = [d, u], u = _ref92[0], d = _ref92[1], _ref92);
      var f = 1;
      C > u && (f = u / C);
      var p = 1;
      var m = s * a,
        y = r * a,
        w = m * c.length;
      w > d && (p = d / w);
      var D = a * Math.min(f, p),
        b = ["q", "0 0 ".concat(numberToString(u), " ").concat(numberToString(d), " re W n"), "BT", "1 0 0 1 0 ".concat(numberToString(d + y), " Tm 0 Tc ").concat(getPdfColor(n, !0)), "/".concat(this.fontName.name, " ").concat(numberToString(D), " Tf")],
        F = this.resources;
      if (1 !== (g = "number" == typeof g && g >= 0 && g <= 1 ? g : 1)) {
        b.push("/R0 gs");
        var _e380 = new Dict(this.xref),
          _t277 = new Dict(this.xref);
        _t277.set("ca", g);
        _t277.set("CA", g);
        _t277.set("Type", Name.get("ExtGState"));
        _e380.set("R0", _t277);
        F.set("ExtGState", _e380);
      }
      var S = numberToString(m);
      for (var _i245 = 0, _c27 = c; _i245 < _c27.length; _i245++) {
        var _e381 = _c27[_i245];
        b.push("0 -".concat(S, " Td <").concat(stringToUTF16HexString(_e381), "> Tj"));
      }
      b.push("ET", "Q");
      var k = b.join("\n"),
        R = new Dict(this.xref);
      R.set("Subtype", Name.get("Form"));
      R.set("Type", Name.get("XObject"));
      R.set("BBox", [0, 0, u, d]);
      R.set("Length", k.length);
      R.set("Resources", F);
      if (i) {
        var _e382 = _getRotationMatrix(i, u, d);
        R.set("Matrix", _e382);
      }
      var N = new StringStream(k);
      N.dict = R;
      return N;
    }
  }], [{
    key: "getFirstPositionInfo",
    value: function getFirstPositionInfo(e, t, i) {
      var _ref93;
      var _e385 = _slicedToArray(e, 4),
        a = _e385[0],
        n = _e385[1],
        g = _e385[2],
        o = _e385[3];
      var c = g - a,
        C = o - n;
      t % 180 != 0 && (_ref93 = [C, c], c = _ref93[0], C = _ref93[1], _ref93);
      var h = s * i;
      return {
        coords: [0, C + r * i - h],
        bbox: [0, 0, c, C],
        matrix: 0 !== t ? _getRotationMatrix(t, C, h) : void 0
      };
    }
  }]);
}();
var NameOrNumberTree = /*#__PURE__*/function () {
  function NameOrNumberTree(e, t, i) {
    _classCallCheck(this, NameOrNumberTree);
    this.root = e;
    this.xref = t;
    this._type = i;
  }
  return _createClass(NameOrNumberTree, [{
    key: "getAll",
    value: function getAll() {
      var e = new Map();
      if (!this.root) return e;
      var t = this.xref,
        i = new RefSet();
      i.put(this.root);
      var a = [this.root];
      for (; a.length > 0;) {
        var _s147 = t.fetchIfRef(a.shift());
        if (!(_s147 instanceof Dict)) continue;
        if (_s147.has("Kids")) {
          var _e386 = _s147.get("Kids");
          if (!Array.isArray(_e386)) continue;
          var _iterator85 = _createForOfIteratorHelper(_e386),
            _step85;
          try {
            for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
              var _t280 = _step85.value;
              if (i.has(_t280)) throw new FormatError("Duplicate entry in \"".concat(this._type, "\" tree."));
              a.push(_t280);
              i.put(_t280);
            }
          } catch (err) {
            _iterator85.e(err);
          } finally {
            _iterator85.f();
          }
          continue;
        }
        var _r107 = _s147.get(this._type);
        if (Array.isArray(_r107)) for (var _i247 = 0, _a208 = _r107.length; _i247 < _a208; _i247 += 2) e.set(t.fetchIfRef(_r107[_i247]), t.fetchIfRef(_r107[_i247 + 1]));
      }
      return e;
    }
  }, {
    key: "getRaw",
    value: function getRaw(e) {
      if (!this.root) return null;
      var t = this.xref;
      var i = t.fetchIfRef(this.root),
        a = 0;
      for (; i.has("Kids");) {
        if (++a > 10) {
          warn("Search depth limit reached for \"".concat(this._type, "\" tree."));
          return null;
        }
        var _s148 = i.get("Kids");
        if (!Array.isArray(_s148)) return null;
        var _r108 = 0,
          _n78 = _s148.length - 1;
        for (; _r108 <= _n78;) {
          var _a209 = _r108 + _n78 >> 1,
            g = t.fetchIfRef(_s148[_a209]),
            o = g.get("Limits");
          if (e < t.fetchIfRef(o[0])) _n78 = _a209 - 1;else {
            if (!(e > t.fetchIfRef(o[1]))) {
              i = g;
              break;
            }
            _r108 = _a209 + 1;
          }
        }
        if (_r108 > _n78) return null;
      }
      var s = i.get(this._type);
      if (Array.isArray(s)) {
        var _i248 = 0,
          _a210 = s.length - 2;
        for (; _i248 <= _a210;) {
          var _r109 = _i248 + _a210 >> 1,
            _n79 = _r109 + (1 & _r109),
            _g51 = t.fetchIfRef(s[_n79]);
          if (e < _g51) _a210 = _n79 - 2;else {
            if (!(e > _g51)) return s[_n79 + 1];
            _i248 = _n79 + 2;
          }
        }
      }
      return null;
    }
  }, {
    key: "get",
    value: function get(e) {
      return this.xref.fetchIfRef(this.getRaw(e));
    }
  }]);
}();
var NameTree = /*#__PURE__*/function (_NameOrNumberTree) {
  function NameTree(e, t) {
    _classCallCheck(this, NameTree);
    return _callSuper(this, NameTree, [e, t, "Names"]);
  }
  _inherits(NameTree, _NameOrNumberTree);
  return _createClass(NameTree);
}(NameOrNumberTree);
var NumberTree = /*#__PURE__*/function (_NameOrNumberTree2) {
  function NumberTree(e, t) {
    _classCallCheck(this, NumberTree);
    return _callSuper(this, NumberTree, [e, t, "Nums"]);
  }
  _inherits(NumberTree, _NameOrNumberTree2);
  return _createClass(NumberTree);
}(NameOrNumberTree);
function clearGlobalCaches() {
  !function clearPatternCaches() {
    ba = Object.create(null);
  }();
  !function clearPrimitiveCaches() {
    wt = Object.create(null);
    Dt = Object.create(null);
    bt = Object.create(null);
  }();
  !function clearUnicodeCaches() {
    vi.clear();
  }();
  JpxImage.cleanup();
}
function pickPlatformItem(e) {
  return e instanceof Dict ? e.has("UF") ? e.get("UF") : e.has("F") ? e.get("F") : e.has("Unix") ? e.get("Unix") : e.has("Mac") ? e.get("Mac") : e.has("DOS") ? e.get("DOS") : null : null;
}
var _G3 = /*#__PURE__*/_classPrivateFieldLooseKey("G");
var FileSpec = /*#__PURE__*/function () {
  function FileSpec(e, t) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    _classCallCheck(this, FileSpec);
    Object.defineProperty(this, _G3, {
      writable: true,
      value: !1
    });
    if (e instanceof Dict) {
      this.xref = t;
      this.root = e;
      e.has("FS") && (this.fs = e.get("FS"));
      e.has("RF") && warn("Related file specifications are not supported");
      i || (e.has("EF") ? _classPrivateFieldLooseBase(this, _G3)[_G3] = !0 : warn("Non-embedded file specifications are not supported"));
    }
  }
  return _createClass(FileSpec, [{
    key: "filename",
    get: function get() {
      var e = "";
      var t = pickPlatformItem(this.root);
      t && "string" == typeof t && (e = stringToPDFString(t).replaceAll("\\\\", "\\").replaceAll("\\/", "/").replaceAll("\\", "/"));
      return shadow(this, "filename", e || "unnamed");
    }
  }, {
    key: "content",
    get: function get() {
      var _this$root;
      if (!_classPrivateFieldLooseBase(this, _G3)[_G3]) return null;
      this._contentRef || (this._contentRef = pickPlatformItem((_this$root = this.root) === null || _this$root === void 0 ? void 0 : _this$root.get("EF")));
      var e = null;
      if (this._contentRef) {
        var t = this.xref.fetchIfRef(this._contentRef);
        t instanceof BaseStream ? e = t.getBytes() : warn("Embedded file specification points to non-existing/invalid content");
      } else warn("Embedded file specification does not have any content");
      return e;
    }
  }, {
    key: "description",
    get: function get() {
      var _this$root2;
      var e = "";
      var t = (_this$root2 = this.root) === null || _this$root2 === void 0 ? void 0 : _this$root2.get("Desc");
      t && "string" == typeof t && (e = stringToPDFString(t));
      return shadow(this, "description", e);
    }
  }, {
    key: "serializable",
    get: function get() {
      return {
        rawFilename: this.filename,
        filename: (e = this.filename, e.substring(e.lastIndexOf("/") + 1)),
        content: this.content,
        description: this.description
      };
      var e;
    }
  }]);
}();
var xs = 0,
  Us = -2,
  Ms = -3,
  Ls = -4,
  Hs = -5,
  Js = -6,
  Ys = -9;
function isWhitespace(e, t) {
  var i = e[t];
  return " " === i || "\n" === i || "\r" === i || "\t" === i;
}
var XMLParserBase = /*#__PURE__*/function () {
  function XMLParserBase() {
    _classCallCheck(this, XMLParserBase);
  }
  return _createClass(XMLParserBase, [{
    key: "_resolveEntities",
    value: function _resolveEntities(e) {
      var _this55 = this;
      return e.replaceAll(/&([^;]+);/g, function (e, t) {
        if ("#x" === t.substring(0, 2)) return String.fromCodePoint(parseInt(t.substring(2), 16));
        if ("#" === t.substring(0, 1)) return String.fromCodePoint(parseInt(t.substring(1), 10));
        switch (t) {
          case "lt":
            return "<";
          case "gt":
            return ">";
          case "amp":
            return "&";
          case "quot":
            return '"';
          case "apos":
            return "'";
        }
        return _this55.onResolveEntity(t);
      });
    }
  }, {
    key: "_parseContent",
    value: function _parseContent(e, t) {
      var i = [];
      var a = t;
      function skipWs() {
        for (; a < e.length && isWhitespace(e, a);) ++a;
      }
      for (; a < e.length && !isWhitespace(e, a) && ">" !== e[a] && "/" !== e[a];) ++a;
      var s = e.substring(t, a);
      skipWs();
      for (; a < e.length && ">" !== e[a] && "/" !== e[a] && "?" !== e[a];) {
        skipWs();
        var _t281 = "",
          _s149 = "";
        for (; a < e.length && !isWhitespace(e, a) && "=" !== e[a];) {
          _t281 += e[a];
          ++a;
        }
        skipWs();
        if ("=" !== e[a]) return null;
        ++a;
        skipWs();
        var _r110 = e[a];
        if ('"' !== _r110 && "'" !== _r110) return null;
        var _n80 = e.indexOf(_r110, ++a);
        if (_n80 < 0) return null;
        _s149 = e.substring(a, _n80);
        i.push({
          name: _t281,
          value: this._resolveEntities(_s149)
        });
        a = _n80 + 1;
        skipWs();
      }
      return {
        name: s,
        attributes: i,
        parsed: a - t
      };
    }
  }, {
    key: "_parseProcessingInstruction",
    value: function _parseProcessingInstruction(e, t) {
      var i = t;
      for (; i < e.length && !isWhitespace(e, i) && ">" !== e[i] && "?" !== e[i] && "/" !== e[i];) ++i;
      var a = e.substring(t, i);
      !function skipWs() {
        for (; i < e.length && isWhitespace(e, i);) ++i;
      }();
      var s = i;
      for (; i < e.length && ("?" !== e[i] || ">" !== e[i + 1]);) ++i;
      return {
        name: a,
        value: e.substring(s, i),
        parsed: i - t
      };
    }
  }, {
    key: "parseXml",
    value: function parseXml(e) {
      var t = 0;
      for (; t < e.length;) {
        var _i249 = t;
        if ("<" === e[t]) {
          ++_i249;
          var _t282 = void 0;
          switch (e[_i249]) {
            case "/":
              ++_i249;
              _t282 = e.indexOf(">", _i249);
              if (_t282 < 0) {
                this.onError(Ys);
                return;
              }
              this.onEndElement(e.substring(_i249, _t282));
              _i249 = _t282 + 1;
              break;
            case "?":
              ++_i249;
              var _a211 = this._parseProcessingInstruction(e, _i249);
              if ("?>" !== e.substring(_i249 + _a211.parsed, _i249 + _a211.parsed + 2)) {
                this.onError(Ms);
                return;
              }
              this.onPi(_a211.name, _a211.value);
              _i249 += _a211.parsed + 2;
              break;
            case "!":
              if ("--" === e.substring(_i249 + 1, _i249 + 3)) {
                _t282 = e.indexOf("--\x3e", _i249 + 3);
                if (_t282 < 0) {
                  this.onError(Hs);
                  return;
                }
                this.onComment(e.substring(_i249 + 3, _t282));
                _i249 = _t282 + 3;
              } else if ("[CDATA[" === e.substring(_i249 + 1, _i249 + 8)) {
                _t282 = e.indexOf("]]>", _i249 + 8);
                if (_t282 < 0) {
                  this.onError(Us);
                  return;
                }
                this.onCdata(e.substring(_i249 + 8, _t282));
                _i249 = _t282 + 3;
              } else {
                if ("DOCTYPE" !== e.substring(_i249 + 1, _i249 + 8)) {
                  this.onError(Js);
                  return;
                }
                {
                  var _a212 = e.indexOf("[", _i249 + 8);
                  var _s150 = !1;
                  _t282 = e.indexOf(">", _i249 + 8);
                  if (_t282 < 0) {
                    this.onError(Ls);
                    return;
                  }
                  if (_a212 > 0 && _t282 > _a212) {
                    _t282 = e.indexOf("]>", _i249 + 8);
                    if (_t282 < 0) {
                      this.onError(Ls);
                      return;
                    }
                    _s150 = !0;
                  }
                  var _r111 = e.substring(_i249 + 8, _t282 + (_s150 ? 1 : 0));
                  this.onDoctype(_r111);
                  _i249 = _t282 + (_s150 ? 2 : 1);
                }
              }
              break;
            default:
              var _s151 = this._parseContent(e, _i249);
              if (null === _s151) {
                this.onError(Js);
                return;
              }
              var _r112 = !1;
              if ("/>" === e.substring(_i249 + _s151.parsed, _i249 + _s151.parsed + 2)) _r112 = !0;else if (">" !== e.substring(_i249 + _s151.parsed, _i249 + _s151.parsed + 1)) {
                this.onError(Ys);
                return;
              }
              this.onBeginElement(_s151.name, _s151.attributes, _r112);
              _i249 += _s151.parsed + (_r112 ? 2 : 1);
          }
        } else {
          for (; _i249 < e.length && "<" !== e[_i249];) _i249++;
          var _a213 = e.substring(t, _i249);
          this.onText(this._resolveEntities(_a213));
        }
        t = _i249;
      }
    }
  }, {
    key: "onResolveEntity",
    value: function onResolveEntity(e) {
      return "&".concat(e, ";");
    }
  }, {
    key: "onPi",
    value: function onPi(e, t) {}
  }, {
    key: "onComment",
    value: function onComment(e) {}
  }, {
    key: "onCdata",
    value: function onCdata(e) {}
  }, {
    key: "onDoctype",
    value: function onDoctype(e) {}
  }, {
    key: "onText",
    value: function onText(e) {}
  }, {
    key: "onBeginElement",
    value: function onBeginElement(e, t, i) {}
  }, {
    key: "onEndElement",
    value: function onEndElement(e) {}
  }, {
    key: "onError",
    value: function onError(e) {}
  }]);
}();
var SimpleDOMNode = /*#__PURE__*/function () {
  function SimpleDOMNode(e, t) {
    _classCallCheck(this, SimpleDOMNode);
    this.nodeName = e;
    this.nodeValue = t;
    Object.defineProperty(this, "parentNode", {
      value: null,
      writable: !0
    });
  }
  return _createClass(SimpleDOMNode, [{
    key: "firstChild",
    get: function get() {
      var _this$childNodes;
      return (_this$childNodes = this.childNodes) === null || _this$childNodes === void 0 ? void 0 : _this$childNodes[0];
    }
  }, {
    key: "nextSibling",
    get: function get() {
      var e = this.parentNode.childNodes;
      if (!e) return;
      var t = e.indexOf(this);
      return -1 !== t ? e[t + 1] : void 0;
    }
  }, {
    key: "textContent",
    get: function get() {
      return this.childNodes ? this.childNodes.map(function (e) {
        return e.textContent;
      }).join("") : this.nodeValue || "";
    }
  }, {
    key: "children",
    get: function get() {
      return this.childNodes || [];
    }
  }, {
    key: "hasChildNodes",
    value: function hasChildNodes() {
      var _this$childNodes2;
      return ((_this$childNodes2 = this.childNodes) === null || _this$childNodes2 === void 0 ? void 0 : _this$childNodes2.length) > 0;
    }
  }, {
    key: "searchNode",
    value: function searchNode(e, t) {
      if (t >= e.length) return this;
      var i = e[t];
      if (i.name.startsWith("#") && t < e.length - 1) return this.searchNode(e, t + 1);
      var a = [];
      var s = this;
      for (;;) {
        var _s$childNodes;
        if (i.name === s.nodeName) {
          if (0 !== i.pos) {
            if (0 === a.length) return null;
            {
              var _a$pop = a.pop(),
                _a$pop2 = _slicedToArray(_a$pop, 1),
                _r113 = _a$pop2[0];
              var _n81 = 0;
              var _iterator86 = _createForOfIteratorHelper(_r113.childNodes),
                _step86;
              try {
                for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
                  var _a214 = _step86.value;
                  if (i.name === _a214.nodeName) {
                    if (_n81 === i.pos) return _a214.searchNode(e, t + 1);
                    _n81++;
                  }
                }
              } catch (err) {
                _iterator86.e(err);
              } finally {
                _iterator86.f();
              }
              return s.searchNode(e, t + 1);
            }
          }
          {
            var _i250 = s.searchNode(e, t + 1);
            if (null !== _i250) return _i250;
          }
        }
        if (((_s$childNodes = s.childNodes) === null || _s$childNodes === void 0 ? void 0 : _s$childNodes.length) > 0) {
          a.push([s, 0]);
          s = s.childNodes[0];
        } else {
          if (0 === a.length) return null;
          for (; 0 !== a.length;) {
            var _a$pop3 = a.pop(),
              _a$pop4 = _slicedToArray(_a$pop3, 2),
              _e387 = _a$pop4[0],
              _t283 = _a$pop4[1],
              _i251 = _t283 + 1;
            if (_i251 < _e387.childNodes.length) {
              a.push([_e387, _i251]);
              s = _e387.childNodes[_i251];
              break;
            }
          }
          if (0 === a.length) return null;
        }
      }
    }
  }, {
    key: "dump",
    value: function dump(e) {
      if ("#text" !== this.nodeName) {
        e.push("<".concat(this.nodeName));
        if (this.attributes) {
          var _iterator87 = _createForOfIteratorHelper(this.attributes),
            _step87;
          try {
            for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
              var t = _step87.value;
              e.push(" ".concat(t.name, "=\"").concat(encodeToXmlString(t.value), "\""));
            }
          } catch (err) {
            _iterator87.e(err);
          } finally {
            _iterator87.f();
          }
        }
        if (this.hasChildNodes()) {
          e.push(">");
          var _iterator88 = _createForOfIteratorHelper(this.childNodes),
            _step88;
          try {
            for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
              var _t284 = _step88.value;
              _t284.dump(e);
            }
          } catch (err) {
            _iterator88.e(err);
          } finally {
            _iterator88.f();
          }
          e.push("</".concat(this.nodeName, ">"));
        } else this.nodeValue ? e.push(">".concat(encodeToXmlString(this.nodeValue), "</").concat(this.nodeName, ">")) : e.push("/>");
      } else e.push(encodeToXmlString(this.nodeValue));
    }
  }]);
}();
var SimpleXMLParser = /*#__PURE__*/function (_XMLParserBase) {
  function SimpleXMLParser(_ref94) {
    var _this56;
    var _ref94$hasAttributes = _ref94.hasAttributes,
      e = _ref94$hasAttributes === void 0 ? !1 : _ref94$hasAttributes,
      _ref94$lowerCaseName = _ref94.lowerCaseName,
      t = _ref94$lowerCaseName === void 0 ? !1 : _ref94$lowerCaseName;
    _classCallCheck(this, SimpleXMLParser);
    _this56 = _callSuper(this, SimpleXMLParser);
    _this56._currentFragment = null;
    _this56._stack = null;
    _this56._errorCode = xs;
    _this56._hasAttributes = e;
    _this56._lowerCaseName = t;
    return _this56;
  }
  _inherits(SimpleXMLParser, _XMLParserBase);
  return _createClass(SimpleXMLParser, [{
    key: "parseFromString",
    value: function parseFromString(e) {
      this._currentFragment = [];
      this._stack = [];
      this._errorCode = xs;
      this.parseXml(e);
      if (this._errorCode !== xs) return;
      var _this$_currentFragmen = _slicedToArray(this._currentFragment, 1),
        t = _this$_currentFragmen[0];
      return t ? {
        documentElement: t
      } : void 0;
    }
  }, {
    key: "onText",
    value: function onText(e) {
      if (function isWhitespaceString(e) {
        for (var _t285 = 0, _i252 = e.length; _t285 < _i252; _t285++) if (!isWhitespace(e, _t285)) return !1;
        return !0;
      }(e)) return;
      var t = new SimpleDOMNode("#text", e);
      this._currentFragment.push(t);
    }
  }, {
    key: "onCdata",
    value: function onCdata(e) {
      var t = new SimpleDOMNode("#text", e);
      this._currentFragment.push(t);
    }
  }, {
    key: "onBeginElement",
    value: function onBeginElement(e, t, i) {
      this._lowerCaseName && (e = e.toLowerCase());
      var a = new SimpleDOMNode(e);
      a.childNodes = [];
      this._hasAttributes && (a.attributes = t);
      this._currentFragment.push(a);
      if (!i) {
        this._stack.push(this._currentFragment);
        this._currentFragment = a.childNodes;
      }
    }
  }, {
    key: "onEndElement",
    value: function onEndElement(e) {
      this._currentFragment = this._stack.pop() || [];
      var t = this._currentFragment.at(-1);
      if (!t) return null;
      var _iterator89 = _createForOfIteratorHelper(t.childNodes),
        _step89;
      try {
        for (_iterator89.s(); !(_step89 = _iterator89.n()).done;) {
          var _e388 = _step89.value;
          _e388.parentNode = t;
        }
      } catch (err) {
        _iterator89.e(err);
      } finally {
        _iterator89.f();
      }
      return t;
    }
  }, {
    key: "onError",
    value: function onError(e) {
      this._errorCode = e;
    }
  }]);
}(XMLParserBase);
var MetadataParser = /*#__PURE__*/function () {
  function MetadataParser(e) {
    _classCallCheck(this, MetadataParser);
    e = this._repair(e);
    var t = new SimpleXMLParser({
      lowerCaseName: !0
    }).parseFromString(e);
    this._metadataMap = new Map();
    this._data = e;
    t && this._parse(t);
  }
  return _createClass(MetadataParser, [{
    key: "_repair",
    value: function _repair(e) {
      return e.replace(/^[^<]+/, "").replaceAll(/>\\376\\377([^<]+)/g, function (e, t) {
        var i = t.replaceAll(/\\([0-3])([0-7])([0-7])/g, function (e, t, i, a) {
            return String.fromCharCode(64 * t + 8 * i + 1 * a);
          }).replaceAll(/&(amp|apos|gt|lt|quot);/g, function (e, t) {
            switch (t) {
              case "amp":
                return "&";
              case "apos":
                return "'";
              case "gt":
                return ">";
              case "lt":
                return "<";
              case "quot":
                return '"';
            }
            throw new Error("_repair: ".concat(t, " isn't defined."));
          }),
          a = [">"];
        for (var _e389 = 0, _t286 = i.length; _e389 < _t286; _e389 += 2) {
          var _t287 = 256 * i.charCodeAt(_e389) + i.charCodeAt(_e389 + 1);
          _t287 >= 32 && _t287 < 127 && 60 !== _t287 && 62 !== _t287 && 38 !== _t287 ? a.push(String.fromCharCode(_t287)) : a.push("&#x" + (65536 + _t287).toString(16).substring(1) + ";");
        }
        return a.join("");
      });
    }
  }, {
    key: "_getSequence",
    value: function _getSequence(e) {
      var t = e.nodeName;
      return "rdf:bag" !== t && "rdf:seq" !== t && "rdf:alt" !== t ? null : e.childNodes.filter(function (e) {
        return "rdf:li" === e.nodeName;
      });
    }
  }, {
    key: "_parseArray",
    value: function _parseArray(e) {
      if (!e.hasChildNodes()) return;
      var _e$childNodes = _slicedToArray(e.childNodes, 1),
        t = _e$childNodes[0],
        i = this._getSequence(t) || [];
      this._metadataMap.set(e.nodeName, i.map(function (e) {
        return e.textContent.trim();
      }));
    }
  }, {
    key: "_parse",
    value: function _parse(e) {
      var t = e.documentElement;
      if ("rdf:rdf" !== t.nodeName) {
        t = t.firstChild;
        for (; t && "rdf:rdf" !== t.nodeName;) t = t.nextSibling;
      }
      if (t && "rdf:rdf" === t.nodeName && t.hasChildNodes()) {
        var _iterator90 = _createForOfIteratorHelper(t.childNodes),
          _step90;
        try {
          for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
            var _e390 = _step90.value;
            if ("rdf:description" === _e390.nodeName) {
              var _iterator91 = _createForOfIteratorHelper(_e390.childNodes),
                _step91;
              try {
                for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
                  var _t288 = _step91.value;
                  var _e391 = _t288.nodeName;
                  switch (_e391) {
                    case "#text":
                      continue;
                    case "dc:creator":
                    case "dc:subject":
                      this._parseArray(_t288);
                      continue;
                  }
                  this._metadataMap.set(_e391, _t288.textContent.trim());
                }
              } catch (err) {
                _iterator91.e(err);
              } finally {
                _iterator91.f();
              }
            }
          }
        } catch (err) {
          _iterator90.e(err);
        } finally {
          _iterator90.f();
        }
      }
    }
  }, {
    key: "serializable",
    get: function get() {
      return {
        parsedData: this._metadataMap,
        rawData: this._data
      };
    }
  }]);
}();
var DecryptStream = /*#__PURE__*/function (_DecodeStream12) {
  function DecryptStream(e, t, i) {
    var _this57;
    _classCallCheck(this, DecryptStream);
    _this57 = _callSuper(this, DecryptStream, [t]);
    _this57.str = e;
    _this57.dict = e.dict;
    _this57.decrypt = i;
    _this57.nextChunk = null;
    _this57.initialized = !1;
    return _this57;
  }
  _inherits(DecryptStream, _DecodeStream12);
  return _createClass(DecryptStream, [{
    key: "readBlock",
    value: function readBlock() {
      var _this$nextChunk;
      var e;
      if (this.initialized) e = this.nextChunk;else {
        e = this.str.getBytes(512);
        this.initialized = !0;
      }
      if (!e || 0 === e.length) {
        this.eof = !0;
        return;
      }
      this.nextChunk = this.str.getBytes(512);
      var t = ((_this$nextChunk = this.nextChunk) === null || _this$nextChunk === void 0 ? void 0 : _this$nextChunk.length) > 0;
      e = (0, this.decrypt)(e, !t);
      var i = this.bufferLength,
        a = i + e.length;
      this.ensureBuffer(a).set(e, i);
      this.bufferLength = a;
    }
  }]);
}(DecodeStream);
var ARCFourCipher = /*#__PURE__*/function () {
  function ARCFourCipher(e) {
    _classCallCheck(this, ARCFourCipher);
    this.a = 0;
    this.b = 0;
    var t = new Uint8Array(256),
      i = e.length;
    for (var _e392 = 0; _e392 < 256; ++_e392) t[_e392] = _e392;
    for (var _a215 = 0, _s152 = 0; _a215 < 256; ++_a215) {
      var _r114 = t[_a215];
      _s152 = _s152 + _r114 + e[_a215 % i] & 255;
      t[_a215] = t[_s152];
      t[_s152] = _r114;
    }
    this.s = t;
  }
  return _createClass(ARCFourCipher, [{
    key: "encryptBlock",
    value: function encryptBlock(e) {
      var t = this.a,
        i = this.b;
      var a = this.s,
        s = e.length,
        r = new Uint8Array(s);
      for (var _n82 = 0; _n82 < s; ++_n82) {
        t = t + 1 & 255;
        var _s153 = a[t];
        i = i + _s153 & 255;
        var g = a[i];
        a[t] = g;
        a[i] = _s153;
        r[_n82] = e[_n82] ^ a[_s153 + g & 255];
      }
      this.a = t;
      this.b = i;
      return r;
    }
  }, {
    key: "decryptBlock",
    value: function decryptBlock(e) {
      return this.encryptBlock(e);
    }
  }, {
    key: "encrypt",
    value: function encrypt(e) {
      return this.encryptBlock(e);
    }
  }]);
}();
var vs = function calculateMD5Closure() {
  var e = new Uint8Array([7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21]),
    t = new Int32Array([-680876936, -389564586, 606105819, -1044525330, -176418897, 1200080426, -1473231341, -45705983, 1770035416, -1958414417, -42063, -1990404162, 1804603682, -40341101, -1502002290, 1236535329, -165796510, -1069501632, 643717713, -373897302, -701558691, 38016083, -660478335, -405537848, 568446438, -1019803690, -187363961, 1163531501, -1444681467, -51403784, 1735328473, -1926607734, -378558, -2022574463, 1839030562, -35309556, -1530992060, 1272893353, -155497632, -1094730640, 681279174, -358537222, -722521979, 76029189, -640364487, -421815835, 530742520, -995338651, -198630844, 1126891415, -1416354905, -57434055, 1700485571, -1894986606, -1051523, -2054922799, 1873313359, -30611744, -1560198380, 1309151649, -145523070, -1120210379, 718787259, -343485551]);
  return function hash(i, a, s) {
    var r = 1732584193,
      n = -271733879,
      g = -1732584194,
      o = 271733878;
    var c = s + 72 & -64,
      C = new Uint8Array(c);
    var h, l;
    for (h = 0; h < s; ++h) C[h] = i[a++];
    C[h++] = 128;
    var Q = c - 8;
    for (; h < Q;) C[h++] = 0;
    C[h++] = s << 3 & 255;
    C[h++] = s >> 5 & 255;
    C[h++] = s >> 13 & 255;
    C[h++] = s >> 21 & 255;
    C[h++] = s >>> 29 & 255;
    C[h++] = 0;
    C[h++] = 0;
    C[h++] = 0;
    var E = new Int32Array(16);
    for (h = 0; h < c;) {
      for (l = 0; l < 16; ++l, h += 4) E[l] = C[h] | C[h + 1] << 8 | C[h + 2] << 16 | C[h + 3] << 24;
      var _i253 = void 0,
        _a216 = void 0,
        _s154 = r,
        _c28 = n,
        _Q17 = g,
        u = o;
      for (l = 0; l < 64; ++l) {
        if (l < 16) {
          _i253 = _c28 & _Q17 | ~_c28 & u;
          _a216 = l;
        } else if (l < 32) {
          _i253 = u & _c28 | ~u & _Q17;
          _a216 = 5 * l + 1 & 15;
        } else if (l < 48) {
          _i253 = _c28 ^ _Q17 ^ u;
          _a216 = 3 * l + 5 & 15;
        } else {
          _i253 = _Q17 ^ (_c28 | ~u);
          _a216 = 7 * l & 15;
        }
        var _r115 = u,
          _n83 = _s154 + _i253 + t[l] + E[_a216] | 0,
          _g52 = e[l];
        u = _Q17;
        _Q17 = _c28;
        _c28 = _c28 + (_n83 << _g52 | _n83 >>> 32 - _g52) | 0;
        _s154 = _r115;
      }
      r = r + _s154 | 0;
      n = n + _c28 | 0;
      g = g + _Q17 | 0;
      o = o + u | 0;
    }
    return new Uint8Array([255 & r, r >> 8 & 255, r >> 16 & 255, r >>> 24 & 255, 255 & n, n >> 8 & 255, n >> 16 & 255, n >>> 24 & 255, 255 & g, g >> 8 & 255, g >> 16 & 255, g >>> 24 & 255, 255 & o, o >> 8 & 255, o >> 16 & 255, o >>> 24 & 255]);
  };
}();
var Word64 = /*#__PURE__*/function () {
  function Word64(e, t) {
    _classCallCheck(this, Word64);
    this.high = 0 | e;
    this.low = 0 | t;
  }
  return _createClass(Word64, [{
    key: "and",
    value: function and(e) {
      this.high &= e.high;
      this.low &= e.low;
    }
  }, {
    key: "xor",
    value: function xor(e) {
      this.high ^= e.high;
      this.low ^= e.low;
    }
  }, {
    key: "or",
    value: function or(e) {
      this.high |= e.high;
      this.low |= e.low;
    }
  }, {
    key: "shiftRight",
    value: function shiftRight(e) {
      if (e >= 32) {
        this.low = this.high >>> e - 32 | 0;
        this.high = 0;
      } else {
        this.low = this.low >>> e | this.high << 32 - e;
        this.high = this.high >>> e | 0;
      }
    }
  }, {
    key: "shiftLeft",
    value: function shiftLeft(e) {
      if (e >= 32) {
        this.high = this.low << e - 32;
        this.low = 0;
      } else {
        this.high = this.high << e | this.low >>> 32 - e;
        this.low <<= e;
      }
    }
  }, {
    key: "rotateRight",
    value: function rotateRight(e) {
      var t, i;
      if (32 & e) {
        i = this.low;
        t = this.high;
      } else {
        t = this.low;
        i = this.high;
      }
      e &= 31;
      this.low = t >>> e | i << 32 - e;
      this.high = i >>> e | t << 32 - e;
    }
  }, {
    key: "not",
    value: function not() {
      this.high = ~this.high;
      this.low = ~this.low;
    }
  }, {
    key: "add",
    value: function add(e) {
      var t = (this.low >>> 0) + (e.low >>> 0);
      var i = (this.high >>> 0) + (e.high >>> 0);
      t > 4294967295 && (i += 1);
      this.low = 0 | t;
      this.high = 0 | i;
    }
  }, {
    key: "copyTo",
    value: function copyTo(e, t) {
      e[t] = this.high >>> 24 & 255;
      e[t + 1] = this.high >> 16 & 255;
      e[t + 2] = this.high >> 8 & 255;
      e[t + 3] = 255 & this.high;
      e[t + 4] = this.low >>> 24 & 255;
      e[t + 5] = this.low >> 16 & 255;
      e[t + 6] = this.low >> 8 & 255;
      e[t + 7] = 255 & this.low;
    }
  }, {
    key: "assign",
    value: function assign(e) {
      this.high = e.high;
      this.low = e.low;
    }
  }]);
}();
var Ks = function calculateSHA256Closure() {
    function rotr(e, t) {
      return e >>> t | e << 32 - t;
    }
    function ch(e, t, i) {
      return e & t ^ ~e & i;
    }
    function maj(e, t, i) {
      return e & t ^ e & i ^ t & i;
    }
    function sigma(e) {
      return rotr(e, 2) ^ rotr(e, 13) ^ rotr(e, 22);
    }
    function sigmaPrime(e) {
      return rotr(e, 6) ^ rotr(e, 11) ^ rotr(e, 25);
    }
    function littleSigma(e) {
      return rotr(e, 7) ^ rotr(e, 18) ^ e >>> 3;
    }
    var e = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
    return function hash(t, i, a) {
      var s = 1779033703,
        r = 3144134277,
        n = 1013904242,
        g = 2773480762,
        o = 1359893119,
        c = 2600822924,
        C = 528734635,
        h = 1541459225;
      var l = 64 * Math.ceil((a + 9) / 64),
        Q = new Uint8Array(l);
      var E, u;
      for (E = 0; E < a; ++E) Q[E] = t[i++];
      Q[E++] = 128;
      var d = l - 8;
      for (; E < d;) Q[E++] = 0;
      Q[E++] = 0;
      Q[E++] = 0;
      Q[E++] = 0;
      Q[E++] = a >>> 29 & 255;
      Q[E++] = a >> 21 & 255;
      Q[E++] = a >> 13 & 255;
      Q[E++] = a >> 5 & 255;
      Q[E++] = a << 3 & 255;
      var f = new Uint32Array(64);
      for (E = 0; E < l;) {
        for (u = 0; u < 16; ++u) {
          f[u] = Q[E] << 24 | Q[E + 1] << 16 | Q[E + 2] << 8 | Q[E + 3];
          E += 4;
        }
        for (u = 16; u < 64; ++u) f[u] = (rotr(p = f[u - 2], 17) ^ rotr(p, 19) ^ p >>> 10) + f[u - 7] + littleSigma(f[u - 15]) + f[u - 16] | 0;
        var _t289 = void 0,
          _i254 = void 0,
          _a217 = s,
          _l13 = r,
          _d7 = n,
          m = g,
          _y5 = o,
          _w3 = c,
          _D4 = C,
          _b3 = h;
        for (u = 0; u < 64; ++u) {
          _t289 = _b3 + sigmaPrime(_y5) + ch(_y5, _w3, _D4) + e[u] + f[u];
          _i254 = sigma(_a217) + maj(_a217, _l13, _d7);
          _b3 = _D4;
          _D4 = _w3;
          _w3 = _y5;
          _y5 = m + _t289 | 0;
          m = _d7;
          _d7 = _l13;
          _l13 = _a217;
          _a217 = _t289 + _i254 | 0;
        }
        s = s + _a217 | 0;
        r = r + _l13 | 0;
        n = n + _d7 | 0;
        g = g + m | 0;
        o = o + _y5 | 0;
        c = c + _w3 | 0;
        C = C + _D4 | 0;
        h = h + _b3 | 0;
      }
      var p;
      return new Uint8Array([s >> 24 & 255, s >> 16 & 255, s >> 8 & 255, 255 & s, r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, 255 & r, n >> 24 & 255, n >> 16 & 255, n >> 8 & 255, 255 & n, g >> 24 & 255, g >> 16 & 255, g >> 8 & 255, 255 & g, o >> 24 & 255, o >> 16 & 255, o >> 8 & 255, 255 & o, c >> 24 & 255, c >> 16 & 255, c >> 8 & 255, 255 & c, C >> 24 & 255, C >> 16 & 255, C >> 8 & 255, 255 & C, h >> 24 & 255, h >> 16 & 255, h >> 8 & 255, 255 & h]);
    };
  }(),
  Ts = function calculateSHA512Closure() {
    function ch(e, t, i, a, s) {
      e.assign(t);
      e.and(i);
      s.assign(t);
      s.not();
      s.and(a);
      e.xor(s);
    }
    function maj(e, t, i, a, s) {
      e.assign(t);
      e.and(i);
      s.assign(t);
      s.and(a);
      e.xor(s);
      s.assign(i);
      s.and(a);
      e.xor(s);
    }
    function sigma(e, t, i) {
      e.assign(t);
      e.rotateRight(28);
      i.assign(t);
      i.rotateRight(34);
      e.xor(i);
      i.assign(t);
      i.rotateRight(39);
      e.xor(i);
    }
    function sigmaPrime(e, t, i) {
      e.assign(t);
      e.rotateRight(14);
      i.assign(t);
      i.rotateRight(18);
      e.xor(i);
      i.assign(t);
      i.rotateRight(41);
      e.xor(i);
    }
    function littleSigma(e, t, i) {
      e.assign(t);
      e.rotateRight(1);
      i.assign(t);
      i.rotateRight(8);
      e.xor(i);
      i.assign(t);
      i.shiftRight(7);
      e.xor(i);
    }
    function littleSigmaPrime(e, t, i) {
      e.assign(t);
      e.rotateRight(19);
      i.assign(t);
      i.rotateRight(61);
      e.xor(i);
      i.assign(t);
      i.shiftRight(6);
      e.xor(i);
    }
    var e = [new Word64(1116352408, 3609767458), new Word64(1899447441, 602891725), new Word64(3049323471, 3964484399), new Word64(3921009573, 2173295548), new Word64(961987163, 4081628472), new Word64(1508970993, 3053834265), new Word64(2453635748, 2937671579), new Word64(2870763221, 3664609560), new Word64(3624381080, 2734883394), new Word64(310598401, 1164996542), new Word64(607225278, 1323610764), new Word64(1426881987, 3590304994), new Word64(1925078388, 4068182383), new Word64(2162078206, 991336113), new Word64(2614888103, 633803317), new Word64(3248222580, 3479774868), new Word64(3835390401, 2666613458), new Word64(4022224774, 944711139), new Word64(264347078, 2341262773), new Word64(604807628, 2007800933), new Word64(770255983, 1495990901), new Word64(1249150122, 1856431235), new Word64(1555081692, 3175218132), new Word64(1996064986, 2198950837), new Word64(2554220882, 3999719339), new Word64(2821834349, 766784016), new Word64(2952996808, 2566594879), new Word64(3210313671, 3203337956), new Word64(3336571891, 1034457026), new Word64(3584528711, 2466948901), new Word64(113926993, 3758326383), new Word64(338241895, 168717936), new Word64(666307205, 1188179964), new Word64(773529912, 1546045734), new Word64(1294757372, 1522805485), new Word64(1396182291, 2643833823), new Word64(1695183700, 2343527390), new Word64(1986661051, 1014477480), new Word64(2177026350, 1206759142), new Word64(2456956037, 344077627), new Word64(2730485921, 1290863460), new Word64(2820302411, 3158454273), new Word64(3259730800, 3505952657), new Word64(3345764771, 106217008), new Word64(3516065817, 3606008344), new Word64(3600352804, 1432725776), new Word64(4094571909, 1467031594), new Word64(275423344, 851169720), new Word64(430227734, 3100823752), new Word64(506948616, 1363258195), new Word64(659060556, 3750685593), new Word64(883997877, 3785050280), new Word64(958139571, 3318307427), new Word64(1322822218, 3812723403), new Word64(1537002063, 2003034995), new Word64(1747873779, 3602036899), new Word64(1955562222, 1575990012), new Word64(2024104815, 1125592928), new Word64(2227730452, 2716904306), new Word64(2361852424, 442776044), new Word64(2428436474, 593698344), new Word64(2756734187, 3733110249), new Word64(3204031479, 2999351573), new Word64(3329325298, 3815920427), new Word64(3391569614, 3928383900), new Word64(3515267271, 566280711), new Word64(3940187606, 3454069534), new Word64(4118630271, 4000239992), new Word64(116418474, 1914138554), new Word64(174292421, 2731055270), new Word64(289380356, 3203993006), new Word64(460393269, 320620315), new Word64(685471733, 587496836), new Word64(852142971, 1086792851), new Word64(1017036298, 365543100), new Word64(1126000580, 2618297676), new Word64(1288033470, 3409855158), new Word64(1501505948, 4234509866), new Word64(1607167915, 987167468), new Word64(1816402316, 1246189591)];
    return function hash(t, i, a) {
      var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var r, n, g, o, c, C, h, l;
      if (s) {
        r = new Word64(3418070365, 3238371032);
        n = new Word64(1654270250, 914150663);
        g = new Word64(2438529370, 812702999);
        o = new Word64(355462360, 4144912697);
        c = new Word64(1731405415, 4290775857);
        C = new Word64(2394180231, 1750603025);
        h = new Word64(3675008525, 1694076839);
        l = new Word64(1203062813, 3204075428);
      } else {
        r = new Word64(1779033703, 4089235720);
        n = new Word64(3144134277, 2227873595);
        g = new Word64(1013904242, 4271175723);
        o = new Word64(2773480762, 1595750129);
        c = new Word64(1359893119, 2917565137);
        C = new Word64(2600822924, 725511199);
        h = new Word64(528734635, 4215389547);
        l = new Word64(1541459225, 327033209);
      }
      var Q = 128 * Math.ceil((a + 17) / 128),
        E = new Uint8Array(Q);
      var u, d;
      for (u = 0; u < a; ++u) E[u] = t[i++];
      E[u++] = 128;
      var f = Q - 16;
      for (; u < f;) E[u++] = 0;
      E[u++] = 0;
      E[u++] = 0;
      E[u++] = 0;
      E[u++] = 0;
      E[u++] = 0;
      E[u++] = 0;
      E[u++] = 0;
      E[u++] = 0;
      E[u++] = 0;
      E[u++] = 0;
      E[u++] = 0;
      E[u++] = a >>> 29 & 255;
      E[u++] = a >> 21 & 255;
      E[u++] = a >> 13 & 255;
      E[u++] = a >> 5 & 255;
      E[u++] = a << 3 & 255;
      var p = new Array(80);
      for (u = 0; u < 80; u++) p[u] = new Word64(0, 0);
      var m = new Word64(0, 0),
        y = new Word64(0, 0),
        w = new Word64(0, 0),
        D = new Word64(0, 0),
        b = new Word64(0, 0),
        F = new Word64(0, 0),
        S = new Word64(0, 0),
        k = new Word64(0, 0);
      var R = new Word64(0, 0),
        N = new Word64(0, 0),
        G = new Word64(0, 0),
        x = new Word64(0, 0);
      var U, M;
      for (u = 0; u < Q;) {
        for (d = 0; d < 16; ++d) {
          p[d].high = E[u] << 24 | E[u + 1] << 16 | E[u + 2] << 8 | E[u + 3];
          p[d].low = E[u + 4] << 24 | E[u + 5] << 16 | E[u + 6] << 8 | E[u + 7];
          u += 8;
        }
        for (d = 16; d < 80; ++d) {
          U = p[d];
          littleSigmaPrime(U, p[d - 2], x);
          U.add(p[d - 7]);
          littleSigma(G, p[d - 15], x);
          U.add(G);
          U.add(p[d - 16]);
        }
        m.assign(r);
        y.assign(n);
        w.assign(g);
        D.assign(o);
        b.assign(c);
        F.assign(C);
        S.assign(h);
        k.assign(l);
        for (d = 0; d < 80; ++d) {
          R.assign(k);
          sigmaPrime(G, b, x);
          R.add(G);
          ch(G, b, F, S, x);
          R.add(G);
          R.add(e[d]);
          R.add(p[d]);
          sigma(N, m, x);
          maj(G, m, y, w, x);
          N.add(G);
          U = k;
          k = S;
          S = F;
          F = b;
          D.add(R);
          b = D;
          D = w;
          w = y;
          y = m;
          U.assign(R);
          U.add(N);
          m = U;
        }
        r.add(m);
        n.add(y);
        g.add(w);
        o.add(D);
        c.add(b);
        C.add(F);
        h.add(S);
        l.add(k);
      }
      if (s) {
        M = new Uint8Array(48);
        r.copyTo(M, 0);
        n.copyTo(M, 8);
        g.copyTo(M, 16);
        o.copyTo(M, 24);
        c.copyTo(M, 32);
        C.copyTo(M, 40);
      } else {
        M = new Uint8Array(64);
        r.copyTo(M, 0);
        n.copyTo(M, 8);
        g.copyTo(M, 16);
        o.copyTo(M, 24);
        c.copyTo(M, 32);
        C.copyTo(M, 40);
        h.copyTo(M, 48);
        l.copyTo(M, 56);
      }
      return M;
    };
  }();
var NullCipher = /*#__PURE__*/function () {
  function NullCipher() {
    _classCallCheck(this, NullCipher);
  }
  return _createClass(NullCipher, [{
    key: "decryptBlock",
    value: function decryptBlock(e) {
      return e;
    }
  }, {
    key: "encrypt",
    value: function encrypt(e) {
      return e;
    }
  }]);
}();
var AESBaseCipher = /*#__PURE__*/function () {
  function AESBaseCipher() {
    _classCallCheck(this, AESBaseCipher);
    this._s = new Uint8Array([99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22]);
    this._inv_s = new Uint8Array([82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125]);
    this._mix = new Uint32Array([0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795]);
    this._mixCol = new Uint8Array(256);
    for (var _e393 = 0; _e393 < 256; _e393++) this._mixCol[_e393] = _e393 < 128 ? _e393 << 1 : _e393 << 1 ^ 27;
    this.buffer = new Uint8Array(16);
    this.bufferPosition = 0;
  }
  return _createClass(AESBaseCipher, [{
    key: "_expandKey",
    value: function _expandKey(e) {
      unreachable("Cannot call `_expandKey` on the base class");
    }
  }, {
    key: "_decrypt",
    value: function _decrypt(e, t) {
      var i, a, s;
      var r = new Uint8Array(16);
      r.set(e);
      for (var _e394 = 0, _i255 = this._keySize; _e394 < 16; ++_e394, ++_i255) r[_e394] ^= t[_i255];
      for (var _e395 = this._cyclesOfRepetition - 1; _e395 >= 1; --_e395) {
        i = r[13];
        r[13] = r[9];
        r[9] = r[5];
        r[5] = r[1];
        r[1] = i;
        i = r[14];
        a = r[10];
        r[14] = r[6];
        r[10] = r[2];
        r[6] = i;
        r[2] = a;
        i = r[15];
        a = r[11];
        s = r[7];
        r[15] = r[3];
        r[11] = i;
        r[7] = a;
        r[3] = s;
        for (var _e396 = 0; _e396 < 16; ++_e396) r[_e396] = this._inv_s[r[_e396]];
        for (var _i256 = 0, _a218 = 16 * _e395; _i256 < 16; ++_i256, ++_a218) r[_i256] ^= t[_a218];
        for (var _e397 = 0; _e397 < 16; _e397 += 4) {
          var _t290 = this._mix[r[_e397]],
            _a219 = this._mix[r[_e397 + 1]],
            _s155 = this._mix[r[_e397 + 2]],
            _n84 = this._mix[r[_e397 + 3]];
          i = _t290 ^ _a219 >>> 8 ^ _a219 << 24 ^ _s155 >>> 16 ^ _s155 << 16 ^ _n84 >>> 24 ^ _n84 << 8;
          r[_e397] = i >>> 24 & 255;
          r[_e397 + 1] = i >> 16 & 255;
          r[_e397 + 2] = i >> 8 & 255;
          r[_e397 + 3] = 255 & i;
        }
      }
      i = r[13];
      r[13] = r[9];
      r[9] = r[5];
      r[5] = r[1];
      r[1] = i;
      i = r[14];
      a = r[10];
      r[14] = r[6];
      r[10] = r[2];
      r[6] = i;
      r[2] = a;
      i = r[15];
      a = r[11];
      s = r[7];
      r[15] = r[3];
      r[11] = i;
      r[7] = a;
      r[3] = s;
      for (var _e398 = 0; _e398 < 16; ++_e398) {
        r[_e398] = this._inv_s[r[_e398]];
        r[_e398] ^= t[_e398];
      }
      return r;
    }
  }, {
    key: "_encrypt",
    value: function _encrypt(e, t) {
      var i = this._s;
      var a, s, r;
      var n = new Uint8Array(16);
      n.set(e);
      for (var _e399 = 0; _e399 < 16; ++_e399) n[_e399] ^= t[_e399];
      for (var _e400 = 1; _e400 < this._cyclesOfRepetition; _e400++) {
        for (var _e401 = 0; _e401 < 16; ++_e401) n[_e401] = i[n[_e401]];
        r = n[1];
        n[1] = n[5];
        n[5] = n[9];
        n[9] = n[13];
        n[13] = r;
        r = n[2];
        s = n[6];
        n[2] = n[10];
        n[6] = n[14];
        n[10] = r;
        n[14] = s;
        r = n[3];
        s = n[7];
        a = n[11];
        n[3] = n[15];
        n[7] = r;
        n[11] = s;
        n[15] = a;
        for (var _e402 = 0; _e402 < 16; _e402 += 4) {
          var _t291 = n[_e402 + 0],
            _i257 = n[_e402 + 1],
            _s156 = n[_e402 + 2],
            _r116 = n[_e402 + 3];
          a = _t291 ^ _i257 ^ _s156 ^ _r116;
          n[_e402 + 0] ^= a ^ this._mixCol[_t291 ^ _i257];
          n[_e402 + 1] ^= a ^ this._mixCol[_i257 ^ _s156];
          n[_e402 + 2] ^= a ^ this._mixCol[_s156 ^ _r116];
          n[_e402 + 3] ^= a ^ this._mixCol[_r116 ^ _t291];
        }
        for (var _i258 = 0, _a220 = 16 * _e400; _i258 < 16; ++_i258, ++_a220) n[_i258] ^= t[_a220];
      }
      for (var _e403 = 0; _e403 < 16; ++_e403) n[_e403] = i[n[_e403]];
      r = n[1];
      n[1] = n[5];
      n[5] = n[9];
      n[9] = n[13];
      n[13] = r;
      r = n[2];
      s = n[6];
      n[2] = n[10];
      n[6] = n[14];
      n[10] = r;
      n[14] = s;
      r = n[3];
      s = n[7];
      a = n[11];
      n[3] = n[15];
      n[7] = r;
      n[11] = s;
      n[15] = a;
      for (var _e404 = 0, _i259 = this._keySize; _e404 < 16; ++_e404, ++_i259) n[_e404] ^= t[_i259];
      return n;
    }
  }, {
    key: "_decryptBlock2",
    value: function _decryptBlock2(e, t) {
      var i = e.length;
      var a = this.buffer,
        s = this.bufferPosition;
      var r = [];
      var n = this.iv;
      for (var _t292 = 0; _t292 < i; ++_t292) {
        a[s] = e[_t292];
        ++s;
        if (s < 16) continue;
        var _i260 = this._decrypt(a, this._key);
        for (var _e405 = 0; _e405 < 16; ++_e405) _i260[_e405] ^= n[_e405];
        n = a;
        r.push(_i260);
        a = new Uint8Array(16);
        s = 0;
      }
      this.buffer = a;
      this.bufferLength = s;
      this.iv = n;
      if (0 === r.length) return new Uint8Array(0);
      var g = 16 * r.length;
      if (t) {
        var _e406 = r.at(-1);
        var _t293 = _e406[15];
        if (_t293 <= 16) {
          for (var _i261 = 15, _a221 = 16 - _t293; _i261 >= _a221; --_i261) if (_e406[_i261] !== _t293) {
            _t293 = 0;
            break;
          }
          g -= _t293;
          r[r.length - 1] = _e406.subarray(0, 16 - _t293);
        }
      }
      var o = new Uint8Array(g);
      for (var _e407 = 0, _t294 = 0, _i262 = r.length; _e407 < _i262; ++_e407, _t294 += 16) o.set(r[_e407], _t294);
      return o;
    }
  }, {
    key: "decryptBlock",
    value: function decryptBlock(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var a = e.length,
        s = this.buffer;
      var r = this.bufferPosition;
      if (i) this.iv = i;else {
        for (var _t295 = 0; r < 16 && _t295 < a; ++_t295, ++r) s[r] = e[_t295];
        if (r < 16) {
          this.bufferLength = r;
          return new Uint8Array(0);
        }
        this.iv = s;
        e = e.subarray(16);
      }
      this.buffer = new Uint8Array(16);
      this.bufferLength = 0;
      this.decryptBlock = this._decryptBlock2;
      return this.decryptBlock(e, t);
    }
  }, {
    key: "encrypt",
    value: function encrypt(e, t) {
      var i = e.length;
      var a = this.buffer,
        s = this.bufferPosition;
      var r = [];
      t || (t = new Uint8Array(16));
      for (var _n85 = 0; _n85 < i; ++_n85) {
        a[s] = e[_n85];
        ++s;
        if (s < 16) continue;
        for (var _e408 = 0; _e408 < 16; ++_e408) a[_e408] ^= t[_e408];
        var _i263 = this._encrypt(a, this._key);
        t = _i263;
        r.push(_i263);
        a = new Uint8Array(16);
        s = 0;
      }
      this.buffer = a;
      this.bufferLength = s;
      this.iv = t;
      if (0 === r.length) return new Uint8Array(0);
      var n = 16 * r.length,
        g = new Uint8Array(n);
      for (var _e409 = 0, _t296 = 0, _i264 = r.length; _e409 < _i264; ++_e409, _t296 += 16) g.set(r[_e409], _t296);
      return g;
    }
  }]);
}();
var AES128Cipher = /*#__PURE__*/function (_AESBaseCipher) {
  function AES128Cipher(e) {
    var _this58;
    _classCallCheck(this, AES128Cipher);
    _this58 = _callSuper(this, AES128Cipher);
    _this58._cyclesOfRepetition = 10;
    _this58._keySize = 160;
    _this58._rcon = new Uint8Array([141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141]);
    _this58._key = _this58._expandKey(e);
    return _this58;
  }
  _inherits(AES128Cipher, _AESBaseCipher);
  return _createClass(AES128Cipher, [{
    key: "_expandKey",
    value: function _expandKey(e) {
      var t = this._s,
        i = this._rcon,
        a = new Uint8Array(176);
      a.set(e);
      for (var _e410 = 16, _s157 = 1; _e410 < 176; ++_s157) {
        var _r117 = a[_e410 - 3],
          _n86 = a[_e410 - 2],
          g = a[_e410 - 1],
          o = a[_e410 - 4];
        _r117 = t[_r117];
        _n86 = t[_n86];
        g = t[g];
        o = t[o];
        _r117 ^= i[_s157];
        for (var _t297 = 0; _t297 < 4; ++_t297) {
          a[_e410] = _r117 ^= a[_e410 - 16];
          _e410++;
          a[_e410] = _n86 ^= a[_e410 - 16];
          _e410++;
          a[_e410] = g ^= a[_e410 - 16];
          _e410++;
          a[_e410] = o ^= a[_e410 - 16];
          _e410++;
        }
      }
      return a;
    }
  }]);
}(AESBaseCipher);
var AES256Cipher = /*#__PURE__*/function (_AESBaseCipher2) {
  function AES256Cipher(e) {
    var _this59;
    _classCallCheck(this, AES256Cipher);
    _this59 = _callSuper(this, AES256Cipher);
    _this59._cyclesOfRepetition = 14;
    _this59._keySize = 224;
    _this59._key = _this59._expandKey(e);
    return _this59;
  }
  _inherits(AES256Cipher, _AESBaseCipher2);
  return _createClass(AES256Cipher, [{
    key: "_expandKey",
    value: function _expandKey(e) {
      var t = this._s,
        i = new Uint8Array(240);
      i.set(e);
      var a,
        s,
        r,
        n,
        g = 1;
      for (var _e411 = 32, o = 1; _e411 < 240; ++o) {
        if (_e411 % 32 == 16) {
          a = t[a];
          s = t[s];
          r = t[r];
          n = t[n];
        } else if (_e411 % 32 == 0) {
          a = i[_e411 - 3];
          s = i[_e411 - 2];
          r = i[_e411 - 1];
          n = i[_e411 - 4];
          a = t[a];
          s = t[s];
          r = t[r];
          n = t[n];
          a ^= g;
          (g <<= 1) >= 256 && (g = 255 & (27 ^ g));
        }
        for (var _t298 = 0; _t298 < 4; ++_t298) {
          i[_e411] = a ^= i[_e411 - 32];
          _e411++;
          i[_e411] = s ^= i[_e411 - 32];
          _e411++;
          i[_e411] = r ^= i[_e411 - 32];
          _e411++;
          i[_e411] = n ^= i[_e411 - 32];
          _e411++;
        }
      }
      return i;
    }
  }]);
}(AESBaseCipher);
var PDF17 = /*#__PURE__*/function () {
  function PDF17() {
    _classCallCheck(this, PDF17);
  }
  return _createClass(PDF17, [{
    key: "checkOwnerPassword",
    value: function checkOwnerPassword(e, t, i, a) {
      var s = new Uint8Array(e.length + 56);
      s.set(e, 0);
      s.set(t, e.length);
      s.set(i, e.length + t.length);
      return isArrayEqual(Ks(s, 0, s.length), a);
    }
  }, {
    key: "checkUserPassword",
    value: function checkUserPassword(e, t, i) {
      var a = new Uint8Array(e.length + 8);
      a.set(e, 0);
      a.set(t, e.length);
      return isArrayEqual(Ks(a, 0, a.length), i);
    }
  }, {
    key: "getOwnerKey",
    value: function getOwnerKey(e, t, i, a) {
      var s = new Uint8Array(e.length + 56);
      s.set(e, 0);
      s.set(t, e.length);
      s.set(i, e.length + t.length);
      var r = Ks(s, 0, s.length);
      return new AES256Cipher(r).decryptBlock(a, !1, new Uint8Array(16));
    }
  }, {
    key: "getUserKey",
    value: function getUserKey(e, t, i) {
      var a = new Uint8Array(e.length + 8);
      a.set(e, 0);
      a.set(t, e.length);
      var s = Ks(a, 0, a.length);
      return new AES256Cipher(s).decryptBlock(i, !1, new Uint8Array(16));
    }
  }]);
}();
var PDF20 = /*#__PURE__*/function () {
  function PDF20() {
    _classCallCheck(this, PDF20);
  }
  return _createClass(PDF20, [{
    key: "_hash",
    value: function _hash(e, t, i) {
      var a = Ks(t, 0, t.length).subarray(0, 32),
        s = [0],
        r = 0;
      for (; r < 64 || s.at(-1) > r - 32;) {
        var _t299 = e.length + a.length + i.length,
          c = new Uint8Array(_t299);
        var C = 0;
        c.set(e, C);
        C += e.length;
        c.set(a, C);
        C += a.length;
        c.set(i, C);
        var h = new Uint8Array(64 * _t299);
        for (var _e412 = 0, _i265 = 0; _e412 < 64; _e412++, _i265 += _t299) h.set(c, _i265);
        s = new AES128Cipher(a.subarray(0, 16)).encrypt(h, a.subarray(16, 32));
        var l = s.slice(0, 16).reduce(function (e, t) {
          return e + t;
        }, 0) % 3;
        0 === l ? a = Ks(s, 0, s.length) : 1 === l ? a = (n = s, g = 0, o = s.length, Ts(n, g, o, !0)) : 2 === l && (a = Ts(s, 0, s.length));
        r++;
      }
      var n, g, o;
      return a.subarray(0, 32);
    }
  }, {
    key: "checkOwnerPassword",
    value: function checkOwnerPassword(e, t, i, a) {
      var s = new Uint8Array(e.length + 56);
      s.set(e, 0);
      s.set(t, e.length);
      s.set(i, e.length + t.length);
      return isArrayEqual(this._hash(e, s, i), a);
    }
  }, {
    key: "checkUserPassword",
    value: function checkUserPassword(e, t, i) {
      var a = new Uint8Array(e.length + 8);
      a.set(e, 0);
      a.set(t, e.length);
      return isArrayEqual(this._hash(e, a, []), i);
    }
  }, {
    key: "getOwnerKey",
    value: function getOwnerKey(e, t, i, a) {
      var s = new Uint8Array(e.length + 56);
      s.set(e, 0);
      s.set(t, e.length);
      s.set(i, e.length + t.length);
      var r = this._hash(e, s, i);
      return new AES256Cipher(r).decryptBlock(a, !1, new Uint8Array(16));
    }
  }, {
    key: "getUserKey",
    value: function getUserKey(e, t, i) {
      var a = new Uint8Array(e.length + 8);
      a.set(e, 0);
      a.set(t, e.length);
      var s = this._hash(e, a, []);
      return new AES256Cipher(s).decryptBlock(i, !1, new Uint8Array(16));
    }
  }]);
}();
var CipherTransform = /*#__PURE__*/function () {
  function CipherTransform(e, t) {
    _classCallCheck(this, CipherTransform);
    this.StringCipherConstructor = e;
    this.StreamCipherConstructor = t;
  }
  return _createClass(CipherTransform, [{
    key: "createStream",
    value: function createStream(e, t) {
      var i = new this.StreamCipherConstructor();
      return new DecryptStream(e, t, function cipherTransformDecryptStream(e, t) {
        return i.decryptBlock(e, t);
      });
    }
  }, {
    key: "decryptString",
    value: function decryptString(e) {
      var t = new this.StringCipherConstructor();
      var i = stringToBytes(e);
      i = t.decryptBlock(i, !0);
      return bytesToString(i);
    }
  }, {
    key: "encryptString",
    value: function encryptString(e) {
      var t = new this.StringCipherConstructor();
      if (t instanceof AESBaseCipher) {
        var _i266 = 16 - e.length % 16;
        e += String.fromCharCode(_i266).repeat(_i266);
        var _a222 = new Uint8Array(16);
        if ("undefined" != typeof crypto) crypto.getRandomValues(_a222);else for (var _e413 = 0; _e413 < 16; _e413++) _a222[_e413] = Math.floor(256 * Math.random());
        var _s158 = stringToBytes(e);
        _s158 = t.encrypt(_s158, _a222);
        var _r118 = new Uint8Array(16 + _s158.length);
        _r118.set(_a222);
        _r118.set(_s158, 16);
        return bytesToString(_r118);
      }
      var i = stringToBytes(e);
      i = t.encrypt(i);
      return bytesToString(i);
    }
  }]);
}();
var _x63 = /*#__PURE__*/_classPrivateFieldLooseKey("x");
var _U3 = /*#__PURE__*/_classPrivateFieldLooseKey("U");
var _M2 = /*#__PURE__*/_classPrivateFieldLooseKey("M");
var _L2 = /*#__PURE__*/_classPrivateFieldLooseKey("L");
var _H2 = /*#__PURE__*/_classPrivateFieldLooseKey("H");
var _J2 = /*#__PURE__*/_classPrivateFieldLooseKey("J");
var CipherTransformFactory = /*#__PURE__*/function () {
  function CipherTransformFactory(_e414, _t300, _i267) {
    _classCallCheck(this, CipherTransformFactory);
    Object.defineProperty(this, _J2, {
      value: _J3
    });
    Object.defineProperty(this, _H2, {
      value: _H3
    });
    Object.defineProperty(this, _L2, {
      value: _L3
    });
    Object.defineProperty(this, _M2, {
      value: _M3
    });
    Object.defineProperty(this, _U3, {
      value: _U4
    });
    var _a223 = _e414.get("Filter");
    if (!isName(_a223, "Standard")) throw new FormatError("unknown encryption method");
    this.filterName = _a223.name;
    this.dict = _e414;
    var _s159 = _e414.get("V");
    if (!Number.isInteger(_s159) || 1 !== _s159 && 2 !== _s159 && 4 !== _s159 && 5 !== _s159) throw new FormatError("unsupported encryption algorithm");
    this.algorithm = _s159;
    var _r119 = _e414.get("Length");
    if (!_r119) if (_s159 <= 3) _r119 = 40;else {
      var t = _e414.get("CF"),
        _i268 = _e414.get("StmF");
      if (t instanceof Dict && _i268 instanceof Name) {
        t.suppressEncryption = !0;
        var _e415 = t.get(_i268.name);
        _r119 = (_e415 === null || _e415 === void 0 ? void 0 : _e415.get("Length")) || 128;
        _r119 < 40 && (_r119 <<= 3);
      }
    }
    if (!Number.isInteger(_r119) || _r119 < 40 || _r119 % 8 != 0) throw new FormatError("invalid key length");
    var _n87 = stringToBytes(_e414.get("O")),
      _g53 = stringToBytes(_e414.get("U")),
      _o38 = _n87.subarray(0, 32),
      _c29 = _g53.subarray(0, 32),
      _C19 = _e414.get("P"),
      _h13 = _e414.get("R"),
      _l14 = (4 === _s159 || 5 === _s159) && !1 !== _e414.get("EncryptMetadata");
    this.encryptMetadata = _l14;
    var _Q18 = stringToBytes(_t300);
    var _E13, _u11;
    if (_i267) {
      if (6 === _h13) try {
        _i267 = utf8StringToString(_i267);
      } catch (_unused12) {
        warn("CipherTransformFactory: Unable to convert UTF8 encoded password.");
      }
      _E13 = stringToBytes(_i267);
    }
    if (5 !== _s159) _u11 = _classPrivateFieldLooseBase(this, _M2)[_M2](_Q18, _E13, _o38, _c29, _C19, _h13, _r119, _l14);else {
      var _t301 = _n87.subarray(32, 40),
        _i269 = _n87.subarray(40, 48),
        _a224 = _g53.subarray(0, 48),
        _s160 = _g53.subarray(32, 40),
        _r120 = _g53.subarray(40, 48),
        C = stringToBytes(_e414.get("OE")),
        l = stringToBytes(_e414.get("UE")),
        Q = stringToBytes(_e414.get("Perms"));
      _u11 = _classPrivateFieldLooseBase(this, _U3)[_U3](_h13, _E13, _o38, _t301, _i269, _a224, _c29, _s160, _r120, C, l, Q);
    }
    if (!_u11 && !_i267) throw new PasswordException("No password given", st);
    if (!_u11 && _i267) {
      var _e416 = _classPrivateFieldLooseBase(this, _L2)[_L2](_E13, _o38, _h13, _r119);
      _u11 = _classPrivateFieldLooseBase(this, _M2)[_M2](_Q18, _e416, _o38, _c29, _C19, _h13, _r119, _l14);
    }
    if (!_u11) throw new PasswordException("Incorrect Password", rt);
    this.encryptionKey = _u11;
    if (_s159 >= 4) {
      var _t302 = _e414.get("CF");
      _t302 instanceof Dict && (_t302.suppressEncryption = !0);
      this.cf = _t302;
      this.stmf = _e414.get("StmF") || Name.get("Identity");
      this.strf = _e414.get("StrF") || Name.get("Identity");
      this.eff = _e414.get("EFF") || this.stmf;
    }
  }
  return _createClass(CipherTransformFactory, [{
    key: "createCipherTransform",
    value: function createCipherTransform(e, t) {
      if (4 === this.algorithm || 5 === this.algorithm) return new CipherTransform(_classPrivateFieldLooseBase(this, _J2)[_J2](this.cf, this.strf, e, t, this.encryptionKey), _classPrivateFieldLooseBase(this, _J2)[_J2](this.cf, this.stmf, e, t, this.encryptionKey));
      var i = _classPrivateFieldLooseBase(this, _H2)[_H2](e, t, this.encryptionKey, !1),
        cipherConstructor = function cipherConstructor() {
          return new ARCFourCipher(i);
        };
      return new CipherTransform(cipherConstructor, cipherConstructor);
    }
  }]);
}();
_CipherTransformFactory = CipherTransformFactory;
function _U4(e, t, i, a, s, r, n, g, o, c, C, h) {
  if (t) {
    var _e665 = Math.min(127, t.length);
    t = t.subarray(0, _e665);
  } else t = [];
  var l = 6 === e ? new PDF20() : new PDF17();
  return l.checkUserPassword(t, g, n) ? l.getUserKey(t, o, C) : t.length && l.checkOwnerPassword(t, a, r, i) ? l.getOwnerKey(t, s, r, c) : null;
}
function _M3(e, t, i, a, s, r, n, g) {
  var o = 40 + i.length + e.length,
    c = new Uint8Array(o);
  var C,
    h,
    l = 0;
  if (t) {
    h = Math.min(32, t.length);
    for (; l < h; ++l) c[l] = t[l];
  }
  C = 0;
  for (; l < 32;) c[l++] = _classPrivateFieldLooseBase(_CipherTransformFactory, _x63)[_x63][C++];
  for (C = 0, h = i.length; C < h; ++C) c[l++] = i[C];
  c[l++] = 255 & s;
  c[l++] = s >> 8 & 255;
  c[l++] = s >> 16 & 255;
  c[l++] = s >>> 24 & 255;
  for (C = 0, h = e.length; C < h; ++C) c[l++] = e[C];
  if (r >= 4 && !g) {
    c[l++] = 255;
    c[l++] = 255;
    c[l++] = 255;
    c[l++] = 255;
  }
  var Q = vs(c, 0, l);
  var E = n >> 3;
  if (r >= 3) for (C = 0; C < 50; ++C) Q = vs(Q, 0, E);
  var u = Q.subarray(0, E);
  var d, f;
  if (r >= 3) {
    for (l = 0; l < 32; ++l) c[l] = _classPrivateFieldLooseBase(_CipherTransformFactory, _x63)[_x63][l];
    for (C = 0, h = e.length; C < h; ++C) c[l++] = e[C];
    d = new ARCFourCipher(u);
    f = d.encryptBlock(vs(c, 0, l));
    h = u.length;
    var _t496 = new Uint8Array(h);
    for (C = 1; C <= 19; ++C) {
      for (var _e666 = 0; _e666 < h; ++_e666) _t496[_e666] = u[_e666] ^ C;
      d = new ARCFourCipher(_t496);
      f = d.encryptBlock(f);
    }
    for (C = 0, h = f.length; C < h; ++C) if (a[C] !== f[C]) return null;
  } else {
    d = new ARCFourCipher(u);
    f = d.encryptBlock(_classPrivateFieldLooseBase(_CipherTransformFactory, _x63)[_x63]);
    for (C = 0, h = f.length; C < h; ++C) if (a[C] !== f[C]) return null;
  }
  return u;
}
function _L3(e, t, i, a) {
  var s = new Uint8Array(32);
  var r = 0;
  var n = Math.min(32, e.length);
  for (; r < n; ++r) s[r] = e[r];
  var g = 0;
  for (; r < 32;) s[r++] = _classPrivateFieldLooseBase(_CipherTransformFactory, _x63)[_x63][g++];
  var o = vs(s, 0, r);
  var c = a >> 3;
  if (i >= 3) for (g = 0; g < 50; ++g) o = vs(o, 0, o.length);
  var C, h;
  if (i >= 3) {
    h = t;
    var _e667 = new Uint8Array(c);
    for (g = 19; g >= 0; g--) {
      for (var _t497 = 0; _t497 < c; ++_t497) _e667[_t497] = o[_t497] ^ g;
      C = new ARCFourCipher(_e667);
      h = C.encryptBlock(h);
    }
  } else {
    C = new ARCFourCipher(o.subarray(0, c));
    h = C.encryptBlock(t);
  }
  return h;
}
function _H3(e, t, i) {
  var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  var s = new Uint8Array(i.length + 9),
    r = i.length;
  var n;
  for (n = 0; n < r; ++n) s[n] = i[n];
  s[n++] = 255 & e;
  s[n++] = e >> 8 & 255;
  s[n++] = e >> 16 & 255;
  s[n++] = 255 & t;
  s[n++] = t >> 8 & 255;
  if (a) {
    s[n++] = 115;
    s[n++] = 65;
    s[n++] = 108;
    s[n++] = 84;
  }
  return vs(s, 0, n).subarray(0, Math.min(i.length + 5, 16));
}
function _J3(e, t, i, a, s) {
  if (!(t instanceof Name)) throw new FormatError("Invalid crypt filter name.");
  var r = this,
    n = e.get(t.name),
    g = n === null || n === void 0 ? void 0 : n.get("CFM");
  if (!g || "None" === g.name) return function () {
    return new NullCipher();
  };
  if ("V2" === g.name) return function () {
    return new ARCFourCipher(_classPrivateFieldLooseBase(r, _H2)[_H2](i, a, s, !1));
  };
  if ("AESV2" === g.name) return function () {
    return new AES128Cipher(_classPrivateFieldLooseBase(r, _H2)[_H2](i, a, s, !0));
  };
  if ("AESV3" === g.name) return function () {
    return new AES256Cipher(s);
  };
  throw new FormatError("Unknown crypto method");
}
Object.defineProperty(CipherTransformFactory, _x63, {
  writable: true,
  value: new Uint8Array([40, 191, 78, 94, 78, 117, 138, 65, 100, 0, 78, 86, 255, 250, 1, 8, 46, 46, 0, 182, 208, 104, 62, 128, 47, 12, 169, 254, 100, 83, 105, 122])
});
function writeObject(_x64, _x65, _x66, _x67) {
  return _writeObject.apply(this, arguments);
}
function _writeObject() {
  _writeObject = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee107(e, t, i, _ref95) {
    var _ref95$encrypt, a, s;
    return _regeneratorRuntime().wrap(function _callee107$(_context119) {
      while (1) switch (_context119.prev = _context119.next) {
        case 0:
          _ref95$encrypt = _ref95.encrypt, a = _ref95$encrypt === void 0 ? null : _ref95$encrypt;
          s = a === null || a === void 0 ? void 0 : a.createCipherTransform(e.num, e.gen);
          i.push("".concat(e.num, " ").concat(e.gen, " obj\n"));
          if (!(t instanceof Dict)) {
            _context119.next = 8;
            break;
          }
          _context119.next = 6;
          return writeDict(t, i, s);
        case 6:
          _context119.next = 17;
          break;
        case 8:
          if (!(t instanceof BaseStream)) {
            _context119.next = 13;
            break;
          }
          _context119.next = 11;
          return writeStream(t, i, s);
        case 11:
          _context119.next = 17;
          break;
        case 13:
          _context119.t0 = Array.isArray(t) || ArrayBuffer.isView(t);
          if (!_context119.t0) {
            _context119.next = 17;
            break;
          }
          _context119.next = 17;
          return writeArray(t, i, s);
        case 17:
          i.push("\nendobj\n");
        case 18:
        case "end":
          return _context119.stop();
      }
    }, _callee107);
  }));
  return _writeObject.apply(this, arguments);
}
function writeDict(_x68, _x69, _x70) {
  return _writeDict.apply(this, arguments);
}
function _writeDict() {
  _writeDict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee108(e, t, i) {
    var _iterator236, _step236, _a330;
    return _regeneratorRuntime().wrap(function _callee108$(_context120) {
      while (1) switch (_context120.prev = _context120.next) {
        case 0:
          t.push("<<");
          _iterator236 = _createForOfIteratorHelper(e.getKeys());
          _context120.prev = 2;
          _iterator236.s();
        case 4:
          if ((_step236 = _iterator236.n()).done) {
            _context120.next = 11;
            break;
          }
          _a330 = _step236.value;
          t.push(" /".concat(escapePDFName(_a330), " "));
          _context120.next = 9;
          return writeValue(e.getRaw(_a330), t, i);
        case 9:
          _context120.next = 4;
          break;
        case 11:
          _context120.next = 16;
          break;
        case 13:
          _context120.prev = 13;
          _context120.t0 = _context120["catch"](2);
          _iterator236.e(_context120.t0);
        case 16:
          _context120.prev = 16;
          _iterator236.f();
          return _context120.finish(16);
        case 19:
          t.push(">>");
        case 20:
        case "end":
          return _context120.stop();
      }
    }, _callee108, null, [[2, 13, 16, 19]]);
  }));
  return _writeDict.apply(this, arguments);
}
function writeStream(_x71, _x72, _x73) {
  return _writeStream.apply(this, arguments);
}
function _writeStream() {
  _writeStream = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee110(e, t, i) {
    var a, s, _yield$Promise$all13, _yield$Promise$all14, r, n, g, _e668, _t498, _i435, _o60, _c33, o;
    return _regeneratorRuntime().wrap(function _callee110$(_context122) {
      while (1) switch (_context122.prev = _context122.next) {
        case 0:
          a = e.getBytes();
          s = e.dict;
          _context122.next = 4;
          return Promise.all([s.getAsync("Filter"), s.getAsync("DecodeParms")]);
        case 4:
          _yield$Promise$all13 = _context122.sent;
          _yield$Promise$all14 = _slicedToArray(_yield$Promise$all13, 2);
          r = _yield$Promise$all14[0];
          n = _yield$Promise$all14[1];
          _context122.t0 = isName;
          if (!Array.isArray(r)) {
            _context122.next = 15;
            break;
          }
          _context122.next = 12;
          return s.xref.fetchIfRefAsync(r[0]);
        case 12:
          _context122.t1 = _context122.sent;
          _context122.next = 16;
          break;
        case 15:
          _context122.t1 = r;
        case 16:
          _context122.t2 = _context122.t1;
          g = (0, _context122.t0)(_context122.t2, "FlateDecode");
          if (!(a.length >= 256 || g)) {
            _context122.next = 36;
            break;
          }
          _context122.prev = 19;
          _e668 = new CompressionStream("deflate"), _t498 = _e668.writable.getWriter();
          _context122.next = 23;
          return _t498.ready;
        case 23:
          _t498.write(a).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee109() {
            return _regeneratorRuntime().wrap(function _callee109$(_context121) {
              while (1) switch (_context121.prev = _context121.next) {
                case 0:
                  _context121.next = 2;
                  return _t498.ready;
                case 2:
                  _context121.next = 4;
                  return _t498.close();
                case 4:
                case "end":
                  return _context121.stop();
              }
            }, _callee109);
          }))).catch(function () {});
          _context122.next = 26;
          return new Response(_e668.readable).arrayBuffer();
        case 26:
          _i435 = _context122.sent;
          a = new Uint8Array(_i435);
          if (r) {
            if (!g) {
              _o60 = Array.isArray(r) ? [Name.get("FlateDecode")].concat(_toConsumableArray(r)) : [Name.get("FlateDecode"), r];
              n && (_c33 = Array.isArray(n) ? [null].concat(_toConsumableArray(n)) : [null, n]);
            }
          } else _o60 = Name.get("FlateDecode");
          _o60 && s.set("Filter", _o60);
          _c33 && s.set("DecodeParms", _c33);
          _context122.next = 36;
          break;
        case 33:
          _context122.prev = 33;
          _context122.t3 = _context122["catch"](19);
          info("writeStream - cannot compress data: \"".concat(_context122.t3, "\"."));
        case 36:
          o = bytesToString(a);
          i && (o = i.encryptString(o));
          s.set("Length", o.length);
          _context122.next = 41;
          return writeDict(s, t, i);
        case 41:
          t.push(" stream\n", o, "\nendstream");
        case 42:
        case "end":
          return _context122.stop();
      }
    }, _callee110, null, [[19, 33]]);
  }));
  return _writeStream.apply(this, arguments);
}
function writeArray(_x74, _x75, _x76) {
  return _writeArray.apply(this, arguments);
}
function _writeArray() {
  _writeArray = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee111(e, t, i) {
    var a, _iterator237, _step237, s;
    return _regeneratorRuntime().wrap(function _callee111$(_context123) {
      while (1) switch (_context123.prev = _context123.next) {
        case 0:
          t.push("[");
          a = !0;
          _iterator237 = _createForOfIteratorHelper(e);
          _context123.prev = 3;
          _iterator237.s();
        case 5:
          if ((_step237 = _iterator237.n()).done) {
            _context123.next = 12;
            break;
          }
          s = _step237.value;
          a ? a = !1 : t.push(" ");
          _context123.next = 10;
          return writeValue(s, t, i);
        case 10:
          _context123.next = 5;
          break;
        case 12:
          _context123.next = 17;
          break;
        case 14:
          _context123.prev = 14;
          _context123.t0 = _context123["catch"](3);
          _iterator237.e(_context123.t0);
        case 17:
          _context123.prev = 17;
          _iterator237.f();
          return _context123.finish(17);
        case 20:
          t.push("]");
        case 21:
        case "end":
          return _context123.stop();
      }
    }, _callee111, null, [[3, 14, 17, 20]]);
  }));
  return _writeArray.apply(this, arguments);
}
function writeValue(_x77, _x78, _x79) {
  return _writeValue.apply(this, arguments);
}
function _writeValue() {
  _writeValue = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee112(e, t, i) {
    return _regeneratorRuntime().wrap(function _callee112$(_context124) {
      while (1) switch (_context124.prev = _context124.next) {
        case 0:
          if (!(e instanceof Name)) {
            _context124.next = 4;
            break;
          }
          t.push("/".concat(escapePDFName(e.name)));
          _context124.next = 37;
          break;
        case 4:
          if (!(e instanceof Ref)) {
            _context124.next = 8;
            break;
          }
          t.push("".concat(e.num, " ").concat(e.gen, " R"));
          _context124.next = 37;
          break;
        case 8:
          if (!(Array.isArray(e) || ArrayBuffer.isView(e))) {
            _context124.next = 13;
            break;
          }
          _context124.next = 11;
          return writeArray(e, t, i);
        case 11:
          _context124.next = 37;
          break;
        case 13:
          if (!("string" == typeof e)) {
            _context124.next = 18;
            break;
          }
          i && (e = i.encryptString(e));
          t.push("(".concat(escapeString(e), ")"));
          _context124.next = 37;
          break;
        case 18:
          if (!("number" == typeof e)) {
            _context124.next = 22;
            break;
          }
          t.push(numberToString(e));
          _context124.next = 37;
          break;
        case 22:
          if (!("boolean" == typeof e)) {
            _context124.next = 26;
            break;
          }
          t.push(e.toString());
          _context124.next = 37;
          break;
        case 26:
          if (!(e instanceof Dict)) {
            _context124.next = 31;
            break;
          }
          _context124.next = 29;
          return writeDict(e, t, i);
        case 29:
          _context124.next = 37;
          break;
        case 31:
          if (!(e instanceof BaseStream)) {
            _context124.next = 36;
            break;
          }
          _context124.next = 34;
          return writeStream(e, t, i);
        case 34:
          _context124.next = 37;
          break;
        case 36:
          null === e ? t.push("null") : warn("Unhandled value in writer: ".concat(_typeof(e), ", please file a bug."));
        case 37:
        case "end":
          return _context124.stop();
      }
    }, _callee112);
  }));
  return _writeValue.apply(this, arguments);
}
function writeInt(e, t, i, a) {
  for (var _s161 = t + i - 1; _s161 > i - 1; _s161--) {
    a[_s161] = 255 & e;
    e >>= 8;
  }
  return i + t;
}
function writeString(e, t, i) {
  for (var _a225 = 0, _s162 = e.length; _a225 < _s162; _a225++) i[t + _a225] = 255 & e.charCodeAt(_a225);
}
function updateXFA(_ref96) {
  var e = _ref96.xfaData,
    t = _ref96.xfaDatasetsRef,
    i = _ref96.newRefs,
    a = _ref96.xref;
  if (null === e) {
    e = function writeXFADataForAcroform(e, t) {
      var i = new SimpleXMLParser({
        hasAttributes: !0
      }).parseFromString(e);
      var _iterator92 = _createForOfIteratorHelper(t),
        _step92;
      try {
        for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
          var _ref97 = _step92.value;
          var _e417 = _ref97.xfa;
          {
            if (!_e417) continue;
            var _t303 = _e417.path,
              _a226 = _e417.value;
            if (!_t303) continue;
            var _s163 = parseXFAPath(_t303);
            var _r121 = i.documentElement.searchNode(_s163, 0);
            !_r121 && _s163.length > 1 && (_r121 = i.documentElement.searchNode([_s163.at(-1)], 0));
            _r121 ? _r121.childNodes = Array.isArray(_a226) ? _a226.map(function (e) {
              return new SimpleDOMNode("value", e);
            }) : [new SimpleDOMNode("#text", _a226)] : warn("Node not found for path: ".concat(_t303));
          }
        }
      } catch (err) {
        _iterator92.e(err);
      } finally {
        _iterator92.f();
      }
      var a = [];
      i.documentElement.dump(a);
      return a.join("");
    }(a.fetchIfRef(t).getString(), i);
  }
  var s = a.encrypt;
  if (s) {
    e = s.createCipherTransform(t.num, t.gen).encryptString(e);
  }
  var r = "".concat(t.num, " ").concat(t.gen, " obj\n<< /Type /EmbeddedFile /Length ").concat(e.length, ">>\nstream\n") + e + "\nendstream\nendobj\n";
  i.push({
    ref: t,
    data: r
  });
}
function getIndexes(e) {
  var t = [];
  var _iterator93 = _createForOfIteratorHelper(e),
    _step93;
  try {
    for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
      var _ref98 = _step93.value;
      var _i270 = _ref98.ref;
      _i270.num === t.at(-2) + t.at(-1) ? t[t.length - 1] += 1 : t.push(_i270.num, 1);
    }
  } catch (err) {
    _iterator93.e(err);
  } finally {
    _iterator93.f();
  }
  return t;
}
function computeIDs(e, t, i) {
  if (Array.isArray(t.fileIds) && t.fileIds.length > 0) {
    var _a227 = function computeMD5(e, t) {
      var i = Math.floor(Date.now() / 1e3),
        a = t.filename || "",
        s = [i.toString(), a, e.toString()];
      var r = s.reduce(function (e, t) {
        return e + t.length;
      }, 0);
      for (var _i271 = 0, _Object$values = Object.values(t.info); _i271 < _Object$values.length; _i271++) {
        var _e418 = _Object$values[_i271];
        s.push(_e418);
        r += _e418.length;
      }
      var n = new Uint8Array(r);
      var g = 0;
      for (var _i272 = 0, _s164 = s; _i272 < _s164.length; _i272++) {
        var _e419 = _s164[_i272];
        writeString(_e419, g, n);
        g += _e419.length;
      }
      return bytesToString(vs(n));
    }(e, t);
    i.set("ID", [t.fileIds[0], _a227]);
  }
}
function incrementalUpdate(_x80) {
  return _incrementalUpdate.apply(this, arguments);
}
function _incrementalUpdate() {
  _incrementalUpdate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee116(_ref99) {
    var e, t, i, _ref99$xref, a, _ref99$hasXfa, s, _ref99$xfaDatasetsRef, r, _ref99$hasXfaDatasets, n, g, _ref99$acroFormRef, o, _ref99$acroForm, c, _ref99$xfaData, C, _ref99$useXrefStream, h, l, Q, E, u, _iterator238, _step238, _ref233, _e674, d, f, p, _i439, _l16, _e673;
    return _regeneratorRuntime().wrap(function _callee116$(_context128) {
      while (1) switch (_context128.prev = _context128.next) {
        case 0:
          e = _ref99.originalData, t = _ref99.xrefInfo, i = _ref99.newRefs, _ref99$xref = _ref99.xref, a = _ref99$xref === void 0 ? null : _ref99$xref, _ref99$hasXfa = _ref99.hasXfa, s = _ref99$hasXfa === void 0 ? !1 : _ref99$hasXfa, _ref99$xfaDatasetsRef = _ref99.xfaDatasetsRef, r = _ref99$xfaDatasetsRef === void 0 ? null : _ref99$xfaDatasetsRef, _ref99$hasXfaDatasets = _ref99.hasXfaDatasetsEntry, n = _ref99$hasXfaDatasets === void 0 ? !1 : _ref99$hasXfaDatasets, g = _ref99.needAppearances, _ref99$acroFormRef = _ref99.acroFormRef, o = _ref99$acroFormRef === void 0 ? null : _ref99$acroFormRef, _ref99$acroForm = _ref99.acroForm, c = _ref99$acroForm === void 0 ? null : _ref99$acroForm, _ref99$xfaData = _ref99.xfaData, C = _ref99$xfaData === void 0 ? null : _ref99$xfaData, _ref99$useXrefStream = _ref99.useXrefStream, h = _ref99$useXrefStream === void 0 ? !1 : _ref99$useXrefStream;
          _context128.next = 3;
          return function () {
            var _updateAcroform = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee113(_ref232) {
              var e, t, i, a, s, r, n, g, o, _e669, c;
              return _regeneratorRuntime().wrap(function _callee113$(_context125) {
                while (1) switch (_context125.prev = _context125.next) {
                  case 0:
                    e = _ref232.xref, t = _ref232.acroForm, i = _ref232.acroFormRef, a = _ref232.hasXfa, s = _ref232.hasXfaDatasetsEntry, r = _ref232.xfaDatasetsRef, n = _ref232.needAppearances, g = _ref232.newRefs;
                    !a || s || r || warn("XFA - Cannot save it");
                    if (!(!n && (!a || !r || s))) {
                      _context125.next = 4;
                      break;
                    }
                    return _context125.abrupt("return");
                  case 4:
                    o = t.clone();
                    if (a && !s) {
                      _e669 = t.get("XFA").slice();
                      _e669.splice(2, 0, "datasets");
                      _e669.splice(3, 0, r);
                      o.set("XFA", _e669);
                    }
                    n && o.set("NeedAppearances", !0);
                    c = [];
                    _context125.next = 10;
                    return writeObject(i, o, c, e);
                  case 10:
                    g.push({
                      ref: i,
                      data: c.join("")
                    });
                  case 11:
                  case "end":
                    return _context125.stop();
                }
              }, _callee113);
            }));
            function updateAcroform(_x211) {
              return _updateAcroform.apply(this, arguments);
            }
            return updateAcroform;
          }()({
            xref: a,
            acroForm: c,
            acroFormRef: o,
            hasXfa: s,
            hasXfaDatasetsEntry: n,
            xfaDatasetsRef: r,
            needAppearances: g,
            newRefs: i
          });
        case 3:
          s && updateXFA({
            xfaData: C,
            xfaDatasetsRef: r,
            newRefs: i,
            xref: a
          });
          l = [];
          Q = e.length;
          E = e.at(-1);
          if (10 !== E && 13 !== E) {
            l.push("\n");
            Q += 1;
          }
          u = function getTrailerDict(e, t, i) {
            var a = new Dict(null);
            a.set("Prev", e.startXRef);
            var s = e.newRef;
            if (i) {
              t.push({
                ref: s,
                data: ""
              });
              a.set("Size", s.num + 1);
              a.set("Type", Name.get("XRef"));
            } else a.set("Size", s.num);
            null !== e.rootRef && a.set("Root", e.rootRef);
            null !== e.infoRef && a.set("Info", e.infoRef);
            null !== e.encryptRef && a.set("Encrypt", e.encryptRef);
            return a;
          }(t, i, h);
          i = i.sort(function (e, t) {
            return e.ref.num - t.ref.num;
          });
          _iterator238 = _createForOfIteratorHelper(i);
          try {
            for (_iterator238.s(); !(_step238 = _iterator238.n()).done;) {
              _ref233 = _step238.value;
              _e674 = _ref233.data;
              null !== _e674 && l.push(_e674);
            }
          } catch (err) {
            _iterator238.e(err);
          } finally {
            _iterator238.f();
          }
          _context128.next = 14;
          return h ? function () {
            var _getXRefStreamTable = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee114(e, t, i, a, s) {
              var r, n, g, _iterator239, _step239, _ref234, _e671, _a331, _i438, o, c, C, h, l, _i436, _r170, _ref235, _ref236, _e670, _t499, _i437;
              return _regeneratorRuntime().wrap(function _callee114$(_context126) {
                while (1) switch (_context126.prev = _context126.next) {
                  case 0:
                    r = [];
                    n = 0, g = 0;
                    _iterator239 = _createForOfIteratorHelper(i);
                    try {
                      for (_iterator239.s(); !(_step239 = _iterator239.n()).done;) {
                        _ref234 = _step239.value;
                        _e671 = _ref234.ref;
                        _a331 = _ref234.data;
                        {
                          _i438 = void 0;
                          n = Math.max(n, t);
                          if (null !== _a331) {
                            _i438 = Math.min(_e671.gen, 65535);
                            r.push([1, t, _i438]);
                            t += _a331.length;
                          } else {
                            _i438 = Math.min(_e671.gen + 1, 65535);
                            r.push([0, 0, _i438]);
                          }
                          g = Math.max(g, _i438);
                        }
                      }
                    } catch (err) {
                      _iterator239.e(err);
                    } finally {
                      _iterator239.f();
                    }
                    a.set("Index", getIndexes(i));
                    o = [1, getSizeInBytes(n), getSizeInBytes(g)];
                    a.set("W", o);
                    computeIDs(t, e, a);
                    c = o.reduce(function (e, t) {
                      return e + t;
                    }, 0), C = new Uint8Array(c * r.length), h = new Stream(C);
                    h.dict = a;
                    l = 0;
                    for (_i436 = 0, _r170 = r; _i436 < _r170.length; _i436++) {
                      _ref235 = _r170[_i436];
                      _ref236 = _slicedToArray(_ref235, 3);
                      _e670 = _ref236[0];
                      _t499 = _ref236[1];
                      _i437 = _ref236[2];
                      l = writeInt(_e670, o[0], l, C);
                      l = writeInt(_t499, o[1], l, C);
                      l = writeInt(_i437, o[2], l, C);
                    }
                    _context126.next = 14;
                    return writeObject(e.newRef, h, s, {});
                  case 14:
                    s.push("startxref\n", t.toString(), "\n%%EOF\n");
                  case 15:
                  case "end":
                    return _context126.stop();
                }
              }, _callee114);
            }));
            function getXRefStreamTable(_x212, _x213, _x214, _x215, _x216) {
              return _getXRefStreamTable.apply(this, arguments);
            }
            return getXRefStreamTable;
          }()(t, Q, i, u, l) : function () {
            var _getXRefTable = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee115(e, t, i, a, s) {
              var r, n, _iterator240, _step240, _ref237, _e672, _a332;
              return _regeneratorRuntime().wrap(function _callee115$(_context127) {
                while (1) switch (_context127.prev = _context127.next) {
                  case 0:
                    s.push("xref\n");
                    r = getIndexes(i);
                    n = 0;
                    _iterator240 = _createForOfIteratorHelper(i);
                    try {
                      for (_iterator240.s(); !(_step240 = _iterator240.n()).done;) {
                        _ref237 = _step240.value;
                        _e672 = _ref237.ref;
                        _a332 = _ref237.data;
                        if (_e672.num === r[n]) {
                          s.push("".concat(r[n], " ").concat(r[n + 1], "\n"));
                          n += 2;
                        }
                        if (null !== _a332) {
                          s.push("".concat(t.toString().padStart(10, "0"), " ").concat(Math.min(_e672.gen, 65535).toString().padStart(5, "0"), " n\r\n"));
                          t += _a332.length;
                        } else s.push("0000000000 ".concat(Math.min(_e672.gen + 1, 65535).toString().padStart(5, "0"), " f\r\n"));
                      }
                    } catch (err) {
                      _iterator240.e(err);
                    } finally {
                      _iterator240.f();
                    }
                    computeIDs(t, e, a);
                    s.push("trailer\n");
                    _context127.next = 9;
                    return writeDict(a, s);
                  case 9:
                    s.push("\nstartxref\n", t.toString(), "\n%%EOF\n");
                  case 10:
                  case "end":
                    return _context127.stop();
                }
              }, _callee115);
            }));
            function getXRefTable(_x217, _x218, _x219, _x220, _x221) {
              return _getXRefTable.apply(this, arguments);
            }
            return getXRefTable;
          }()(t, Q, i, u, l);
        case 14:
          d = l.reduce(function (e, t) {
            return e + t.length;
          }, e.length), f = new Uint8Array(d);
          f.set(e);
          p = e.length;
          for (_i439 = 0, _l16 = l; _i439 < _l16.length; _i439++) {
            _e673 = _l16[_i439];
            writeString(_e673, p, f);
            p += _e673.length;
          }
          return _context128.abrupt("return", f);
        case 19:
        case "end":
          return _context128.stop();
      }
    }, _callee116);
  }));
  return _incrementalUpdate.apply(this, arguments);
}
var qs = 1,
  Os = 2,
  Ws = 3,
  js = 4,
  Xs = 5;
var _Y2 = /*#__PURE__*/_classPrivateFieldLooseKey("Y");
var _v = /*#__PURE__*/_classPrivateFieldLooseKey("v");
var _T = /*#__PURE__*/_classPrivateFieldLooseKey("T");
var _K = /*#__PURE__*/_classPrivateFieldLooseKey("K");
var _q = /*#__PURE__*/_classPrivateFieldLooseKey("q");
var StructTreeRoot = /*#__PURE__*/function () {
  function StructTreeRoot(_e420, _t304) {
    _classCallCheck(this, StructTreeRoot);
    Object.defineProperty(this, _Y2, {
      value: _Y3
    });
    this.dict = _e420;
    this.ref = _t304 instanceof Ref ? _t304 : null;
    this.roleMap = new Map();
    this.structParentIds = null;
  }
  return _createClass(StructTreeRoot, [{
    key: "init",
    value: function init() {
      this.readRoleMap();
    }
  }, {
    key: "addAnnotationIdToPage",
    value: function addAnnotationIdToPage(e, t) {
      _classPrivateFieldLooseBase(this, _Y2)[_Y2](e, t, js);
    }
  }, {
    key: "readRoleMap",
    value: function readRoleMap() {
      var _this60 = this;
      var e = this.dict.get("RoleMap");
      e instanceof Dict && e.forEach(function (e, t) {
        t instanceof Name && _this60.roleMap.set(e, t.name);
      });
    }
  }, {
    key: "canUpdateStructTree",
    value: function () {
      var _canUpdateStructTree = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee36(_ref100) {
        var e, t, i, a, s, r, n, _iterator94, _step94, _t306, _yield$e$getPage, _i273, _a228, g, _iterator95, _step95, _ref101, _ref102, _t307, _s165, _yield$e$getPage2, _i274, _iterator98, _step98, _e422$accessibilityDa, _e422, _iterator96, _step96, _e421, _iterator97, _step97, _t305;
        return _regeneratorRuntime().wrap(function _callee36$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              e = _ref100.pdfManager, t = _ref100.xref, i = _ref100.newAnnotationsByPage;
              if (this.ref) {
                _context38.next = 4;
                break;
              }
              warn("Cannot update the struct tree: no root reference.");
              return _context38.abrupt("return", !1);
            case 4:
              a = this.dict.get("ParentTreeNextKey");
              if (!(!Number.isInteger(a) || a < 0)) {
                _context38.next = 8;
                break;
              }
              warn("Cannot update the struct tree: invalid next key.");
              return _context38.abrupt("return", !1);
            case 8:
              s = this.dict.get("ParentTree");
              if (s instanceof Dict) {
                _context38.next = 12;
                break;
              }
              warn("Cannot update the struct tree: ParentTree isn't a dict.");
              return _context38.abrupt("return", !1);
            case 12:
              r = s.get("Nums");
              if (Array.isArray(r)) {
                _context38.next = 16;
                break;
              }
              warn("Cannot update the struct tree: nums isn't an array.");
              return _context38.abrupt("return", !1);
            case 16:
              n = new NumberTree(s, t);
              _iterator94 = _createForOfIteratorHelper(i.keys());
              _context38.prev = 18;
              _iterator94.s();
            case 20:
              if ((_step94 = _iterator94.n()).done) {
                _context38.next = 34;
                break;
              }
              _t306 = _step94.value;
              _context38.next = 24;
              return e.getPage(_t306);
            case 24:
              _yield$e$getPage = _context38.sent;
              _i273 = _yield$e$getPage.pageDict;
              if (_i273.has("StructParents")) {
                _context38.next = 28;
                break;
              }
              return _context38.abrupt("continue", 32);
            case 28:
              _a228 = _i273.get("StructParents");
              if (!(!Number.isInteger(_a228) || !Array.isArray(n.get(_a228)))) {
                _context38.next = 32;
                break;
              }
              warn("Cannot save the struct tree: page ".concat(_t306, " has a wrong id."));
              return _context38.abrupt("return", !1);
            case 32:
              _context38.next = 20;
              break;
            case 34:
              _context38.next = 39;
              break;
            case 36:
              _context38.prev = 36;
              _context38.t0 = _context38["catch"](18);
              _iterator94.e(_context38.t0);
            case 39:
              _context38.prev = 39;
              _iterator94.f();
              return _context38.finish(39);
            case 42:
              g = !0;
              _iterator95 = _createForOfIteratorHelper(i);
              _context38.prev = 44;
              _iterator95.s();
            case 46:
              if ((_step95 = _iterator95.n()).done) {
                _context38.next = 60;
                break;
              }
              _ref101 = _step95.value;
              _ref102 = _slicedToArray(_ref101, 2);
              _t307 = _ref102[0];
              _s165 = _ref102[1];
              _context38.next = 53;
              return e.getPage(_t307);
            case 53:
              _yield$e$getPage2 = _context38.sent;
              _i274 = _yield$e$getPage2.pageDict;
              _classPrivateFieldLooseBase(StructTreeRoot, _K)[_K]({
                elements: _s165,
                xref: this.dict.xref,
                pageDict: _i274,
                numberTree: n
              });
              _iterator98 = _createForOfIteratorHelper(_s165);
              try {
                for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
                  _e422 = _step98.value;
                  if ((_e422$accessibilityDa = _e422.accessibilityData) !== null && _e422$accessibilityDa !== void 0 && _e422$accessibilityDa.type) {
                    _e422.accessibilityData.structParent >= 0 || (_e422.parentTreeId = a++);
                    g = !1;
                  }
                }
              } catch (err) {
                _iterator98.e(err);
              } finally {
                _iterator98.f();
              }
            case 58:
              _context38.next = 46;
              break;
            case 60:
              _context38.next = 65;
              break;
            case 62:
              _context38.prev = 62;
              _context38.t1 = _context38["catch"](44);
              _iterator95.e(_context38.t1);
            case 65:
              _context38.prev = 65;
              _iterator95.f();
              return _context38.finish(65);
            case 68:
              if (!g) {
                _context38.next = 72;
                break;
              }
              _iterator96 = _createForOfIteratorHelper(i.values());
              try {
                for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
                  _e421 = _step96.value;
                  _iterator97 = _createForOfIteratorHelper(_e421);
                  try {
                    for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
                      _t305 = _step97.value;
                      delete _t305.parentTreeId;
                      delete _t305.structTreeParent;
                    }
                  } catch (err) {
                    _iterator97.e(err);
                  } finally {
                    _iterator97.f();
                  }
                }
              } catch (err) {
                _iterator96.e(err);
              } finally {
                _iterator96.f();
              }
              return _context38.abrupt("return", !1);
            case 72:
              return _context38.abrupt("return", !0);
            case 73:
            case "end":
              return _context38.stop();
          }
        }, _callee36, this, [[18, 36, 39, 42], [44, 62, 65, 68]]);
      }));
      function canUpdateStructTree(_x81) {
        return _canUpdateStructTree.apply(this, arguments);
      }
      return canUpdateStructTree;
    }()
  }, {
    key: "updateStructureTree",
    value: function () {
      var _updateStructureTree = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee37(_ref103) {
        var e, t, i, a, s, r, n, g, o, c, C, h, l, _iterator99, _step99, _ref104, _ref105, _e423, _t308;
        return _regeneratorRuntime().wrap(function _callee37$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              e = _ref103.newAnnotationsByPage, t = _ref103.pdfManager, i = _ref103.newRefs;
              a = this.dict.xref, s = this.dict.clone(), r = this.ref, n = new RefSetCache();
              n.put(r, s);
              o = s.getRaw("ParentTree");
              if (o instanceof Ref) g = a.fetch(o);else {
                g = o;
                o = a.getNewTemporaryRef();
                s.set("ParentTree", o);
              }
              g = g.clone();
              n.put(o, g);
              c = g.getRaw("Nums"), C = null;
              if (c instanceof Ref) {
                C = c;
                c = a.fetch(C);
              }
              c = c.slice();
              C || g.set("Nums", c);
              _context39.next = 13;
              return _classPrivateFieldLooseBase(StructTreeRoot, _v)[_v]({
                newAnnotationsByPage: e,
                structTreeRootRef: r,
                structTreeRoot: this,
                kids: null,
                nums: c,
                xref: a,
                pdfManager: t,
                newRefs: i,
                cache: n
              });
            case 13:
              h = _context39.sent;
              if (!(-1 === h)) {
                _context39.next = 16;
                break;
              }
              return _context39.abrupt("return");
            case 16:
              s.set("ParentTreeNextKey", h);
              C && n.put(C, c);
              l = [];
              _iterator99 = _createForOfIteratorHelper(n.items());
              _context39.prev = 20;
              _iterator99.s();
            case 22:
              if ((_step99 = _iterator99.n()).done) {
                _context39.next = 33;
                break;
              }
              _ref104 = _step99.value;
              _ref105 = _slicedToArray(_ref104, 2);
              _e423 = _ref105[0];
              _t308 = _ref105[1];
              l.length = 0;
              _context39.next = 30;
              return writeObject(_e423, _t308, l, a);
            case 30:
              i.push({
                ref: _e423,
                data: l.join("")
              });
            case 31:
              _context39.next = 22;
              break;
            case 33:
              _context39.next = 38;
              break;
            case 35:
              _context39.prev = 35;
              _context39.t0 = _context39["catch"](20);
              _iterator99.e(_context39.t0);
            case 38:
              _context39.prev = 38;
              _iterator99.f();
              return _context39.finish(38);
            case 41:
            case "end":
              return _context39.stop();
          }
        }, _callee37, this, [[20, 35, 38, 41]]);
      }));
      function updateStructureTree(_x82) {
        return _updateStructureTree.apply(this, arguments);
      }
      return updateStructureTree;
    }()
  }], [{
    key: "canCreateStructureTree",
    value: function () {
      var _canCreateStructureTree = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee38(_ref106) {
        var e, t, i, a, s, _iterator100, _step100, _ref107, _ref108, _e425, _r122, _yield$t$getPage, _i275, _iterator103, _step103, _e426$accessibilityDa, _e426, _iterator101, _step101, _e424, _iterator102, _step102, _t309;
        return _regeneratorRuntime().wrap(function _callee38$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              e = _ref106.catalogRef, t = _ref106.pdfManager, i = _ref106.newAnnotationsByPage;
              if (e instanceof Ref) {
                _context40.next = 4;
                break;
              }
              warn("Cannot save the struct tree: no catalog reference.");
              return _context40.abrupt("return", !1);
            case 4:
              a = 0, s = !0;
              _iterator100 = _createForOfIteratorHelper(i);
              _context40.prev = 6;
              _iterator100.s();
            case 8:
              if ((_step100 = _iterator100.n()).done) {
                _context40.next = 25;
                break;
              }
              _ref107 = _step100.value;
              _ref108 = _slicedToArray(_ref107, 2);
              _e425 = _ref108[0];
              _r122 = _ref108[1];
              _context40.next = 15;
              return t.getPage(_e425);
            case 15:
              _yield$t$getPage = _context40.sent;
              _i275 = _yield$t$getPage.ref;
              if (_i275 instanceof Ref) {
                _context40.next = 21;
                break;
              }
              warn("Cannot save the struct tree: page ".concat(_e425, " has no ref."));
              s = !0;
              return _context40.abrupt("break", 25);
            case 21:
              _iterator103 = _createForOfIteratorHelper(_r122);
              try {
                for (_iterator103.s(); !(_step103 = _iterator103.n()).done;) {
                  _e426 = _step103.value;
                  if ((_e426$accessibilityDa = _e426.accessibilityData) !== null && _e426$accessibilityDa !== void 0 && _e426$accessibilityDa.type) {
                    _e426.parentTreeId = a++;
                    s = !1;
                  }
                }
              } catch (err) {
                _iterator103.e(err);
              } finally {
                _iterator103.f();
              }
            case 23:
              _context40.next = 8;
              break;
            case 25:
              _context40.next = 30;
              break;
            case 27:
              _context40.prev = 27;
              _context40.t0 = _context40["catch"](6);
              _iterator100.e(_context40.t0);
            case 30:
              _context40.prev = 30;
              _iterator100.f();
              return _context40.finish(30);
            case 33:
              if (!s) {
                _context40.next = 37;
                break;
              }
              _iterator101 = _createForOfIteratorHelper(i.values());
              try {
                for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
                  _e424 = _step101.value;
                  _iterator102 = _createForOfIteratorHelper(_e424);
                  try {
                    for (_iterator102.s(); !(_step102 = _iterator102.n()).done;) {
                      _t309 = _step102.value;
                      delete _t309.parentTreeId;
                    }
                  } catch (err) {
                    _iterator102.e(err);
                  } finally {
                    _iterator102.f();
                  }
                }
              } catch (err) {
                _iterator101.e(err);
              } finally {
                _iterator101.f();
              }
              return _context40.abrupt("return", !1);
            case 37:
              return _context40.abrupt("return", !0);
            case 38:
            case "end":
              return _context40.stop();
          }
        }, _callee38, null, [[6, 27, 30, 33]]);
      }));
      function canCreateStructureTree(_x83) {
        return _canCreateStructureTree.apply(this, arguments);
      }
      return canCreateStructureTree;
    }()
  }, {
    key: "createStructureTree",
    value: function () {
      var _createStructureTree = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee39(_ref109) {
        var e, t, i, a, s, r, n, g, o, c, C, h, l, Q, E, _iterator104, _step104, _ref110, _ref111, _e427, _i276;
        return _regeneratorRuntime().wrap(function _callee39$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              e = _ref109.newAnnotationsByPage, t = _ref109.xref, i = _ref109.catalogRef, a = _ref109.pdfManager, s = _ref109.newRefs;
              r = a.catalog.cloneDict(), n = new RefSetCache();
              n.put(i, r);
              g = t.getNewTemporaryRef();
              r.set("StructTreeRoot", g);
              o = new Dict(t);
              o.set("Type", Name.get("StructTreeRoot"));
              c = t.getNewTemporaryRef();
              o.set("ParentTree", c);
              C = [];
              o.set("K", C);
              n.put(g, o);
              h = new Dict(t), l = [];
              h.set("Nums", l);
              _context41.next = 16;
              return _classPrivateFieldLooseBase(this, _v)[_v]({
                newAnnotationsByPage: e,
                structTreeRootRef: g,
                structTreeRoot: null,
                kids: C,
                nums: l,
                xref: t,
                pdfManager: a,
                newRefs: s,
                cache: n
              });
            case 16:
              Q = _context41.sent;
              o.set("ParentTreeNextKey", Q);
              n.put(c, h);
              E = [];
              _iterator104 = _createForOfIteratorHelper(n.items());
              _context41.prev = 21;
              _iterator104.s();
            case 23:
              if ((_step104 = _iterator104.n()).done) {
                _context41.next = 34;
                break;
              }
              _ref110 = _step104.value;
              _ref111 = _slicedToArray(_ref110, 2);
              _e427 = _ref111[0];
              _i276 = _ref111[1];
              E.length = 0;
              _context41.next = 31;
              return writeObject(_e427, _i276, E, t);
            case 31:
              s.push({
                ref: _e427,
                data: E.join("")
              });
            case 32:
              _context41.next = 23;
              break;
            case 34:
              _context41.next = 39;
              break;
            case 36:
              _context41.prev = 36;
              _context41.t0 = _context41["catch"](21);
              _iterator104.e(_context41.t0);
            case 39:
              _context41.prev = 39;
              _iterator104.f();
              return _context41.finish(39);
            case 42:
            case "end":
              return _context41.stop();
          }
        }, _callee39, this, [[21, 36, 39, 42]]);
      }));
      function createStructureTree(_x84) {
        return _createStructureTree.apply(this, arguments);
      }
      return createStructureTree;
    }()
  }]);
}();
_StructTreeRoot = StructTreeRoot;
function _Y3(e, t, i) {
  if (!(e instanceof Ref) || t < 0) return;
  this.structParentIds || (this.structParentIds = new RefSetCache());
  var a = this.structParentIds.get(e);
  if (!a) {
    a = [];
    this.structParentIds.put(e, a);
  }
  a.push([t, i]);
}
function _v2(_x222) {
  return _v3.apply(this, arguments);
}
function _v3() {
  _v3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee118(_ref238) {
    var e, t, i, a, s, r, n, g, o, c, C, h, l, _iterator250, _step250, _ref245, _ref246, _Q22, E, _e684, _u14, _d9, _iterator251, _step251, _ref247, _n111, _f11, _p8, _m8, _E15, _t504, _t503, _a338, _e685, _y7, _w5, _D5;
    return _regeneratorRuntime().wrap(function _callee118$(_context130) {
      while (1) switch (_context130.prev = _context130.next) {
        case 0:
          e = _ref238.newAnnotationsByPage, t = _ref238.structTreeRootRef, i = _ref238.structTreeRoot, a = _ref238.kids, s = _ref238.nums, r = _ref238.xref, n = _ref238.pdfManager, g = _ref238.newRefs, o = _ref238.cache;
          c = Name.get("OBJR");
          h = -1;
          l = [];
          _iterator250 = _createForOfIteratorHelper(e);
          _context130.prev = 5;
          _iterator250.s();
        case 7:
          if ((_step250 = _iterator250.n()).done) {
            _context130.next = 65;
            break;
          }
          _ref245 = _step250.value;
          _ref246 = _slicedToArray(_ref245, 2);
          _Q22 = _ref246[0];
          E = _ref246[1];
          _context130.next = 14;
          return n.getPage(_Q22);
        case 14:
          _e684 = _context130.sent;
          _u14 = _e684.ref;
          _d9 = _u14 instanceof Ref;
          _iterator251 = _createForOfIteratorHelper(E);
          _context130.prev = 18;
          _iterator251.s();
        case 20:
          if ((_step251 = _iterator251.n()).done) {
            _context130.next = 55;
            break;
          }
          _ref247 = _step251.value;
          _n111 = _ref247.accessibilityData;
          _f11 = _ref247.ref;
          _p8 = _ref247.parentTreeId;
          _m8 = _ref247.structTreeParent;
          if (_n111 !== null && _n111 !== void 0 && _n111.type) {
            _context130.next = 28;
            break;
          }
          return _context130.abrupt("continue", 53);
        case 28:
          _E15 = _n111.structParent;
          if (!(i && Number.isInteger(_E15) && _E15 >= 0)) {
            _context130.next = 41;
            break;
          }
          _t503 = (C || (C = new Map())).get(_Q22);
          if (void 0 === _t503) {
            _t503 = new StructTreePage(i, _e684.pageDict).collectObjects(_u14);
            C.set(_Q22, _t503);
          }
          _a338 = (_t504 = _t503) === null || _t504 === void 0 ? void 0 : _t504.get(_E15);
          if (!_a338) {
            _context130.next = 41;
            break;
          }
          _e685 = r.fetch(_a338).clone();
          _classPrivateFieldLooseBase(_StructTreeRoot, _T)[_T](_e685, _n111);
          l.length = 0;
          _context130.next = 39;
          return writeObject(_a338, _e685, l, r);
        case 39:
          g.push({
            ref: _a338,
            data: l.join("")
          });
          return _context130.abrupt("continue", 53);
        case 41:
          h = Math.max(h, _p8);
          _y7 = r.getNewTemporaryRef(), _w5 = new Dict(r);
          _classPrivateFieldLooseBase(_StructTreeRoot, _T)[_T](_w5, _n111);
          _context130.next = 46;
          return _classPrivateFieldLooseBase(this, _q)[_q]({
            structTreeParent: _m8,
            tagDict: _w5,
            newTagRef: _y7,
            structTreeRootRef: t,
            fallbackKids: a,
            xref: r,
            cache: o
          });
        case 46:
          _D5 = new Dict(r);
          _w5.set("K", _D5);
          _D5.set("Type", c);
          _d9 && _D5.set("Pg", _u14);
          _D5.set("Obj", _f11);
          o.put(_y7, _w5);
          s.push(_p8, _y7);
        case 53:
          _context130.next = 20;
          break;
        case 55:
          _context130.next = 60;
          break;
        case 57:
          _context130.prev = 57;
          _context130.t0 = _context130["catch"](18);
          _iterator251.e(_context130.t0);
        case 60:
          _context130.prev = 60;
          _iterator251.f();
          return _context130.finish(60);
        case 63:
          _context130.next = 7;
          break;
        case 65:
          _context130.next = 70;
          break;
        case 67:
          _context130.prev = 67;
          _context130.t1 = _context130["catch"](5);
          _iterator250.e(_context130.t1);
        case 70:
          _context130.prev = 70;
          _iterator250.f();
          return _context130.finish(70);
        case 73:
          return _context130.abrupt("return", h + 1);
        case 74:
        case "end":
          return _context130.stop();
      }
    }, _callee118, this, [[5, 67, 70, 73], [18, 57, 60, 63]]);
  }));
  return _v3.apply(this, arguments);
}
function _T2(e, _ref239) {
  var t = _ref239.type,
    i = _ref239.title,
    a = _ref239.lang,
    s = _ref239.alt,
    r = _ref239.expanded,
    n = _ref239.actualText;
  e.set("S", Name.get(t));
  i && e.set("T", stringToAsciiOrUTF16BE(i));
  a && e.set("Lang", stringToAsciiOrUTF16BE(a));
  s && e.set("Alt", stringToAsciiOrUTF16BE(s));
  r && e.set("E", stringToAsciiOrUTF16BE(r));
  n && e.set("ActualText", stringToAsciiOrUTF16BE(n));
}
function _K2(_ref240) {
  var e = _ref240.elements,
    t = _ref240.xref,
    i = _ref240.pageDict,
    a = _ref240.numberTree;
  var s = new Map();
  var _iterator241 = _createForOfIteratorHelper(e),
    _step241;
  try {
    for (_iterator241.s(); !(_step241 = _iterator241.n()).done;) {
      var _t501 = _step241.value;
      if (_t501.structTreeParentId) {
        var _e677 = parseInt(_t501.structTreeParentId.split("_mc")[1], 10);
        var _i440 = s.get(_e677);
        if (!_i440) {
          _i440 = [];
          s.set(_e677, _i440);
        }
        _i440.push(_t501);
      }
    }
  } catch (err) {
    _iterator241.e(err);
  } finally {
    _iterator241.f();
  }
  var r = i.get("StructParents");
  if (!Number.isInteger(r)) return;
  var n = a.get(r),
    updateElement = function updateElement(e, i, a) {
      var r = s.get(e);
      if (r) {
        var _e675 = i.getRaw("P"),
          _s222 = t.fetchIfRef(_e675);
        if (_e675 instanceof Ref && _s222 instanceof Dict) {
          var _e676 = {
            ref: a,
            dict: i
          };
          var _iterator242 = _createForOfIteratorHelper(r),
            _step242;
          try {
            for (_iterator242.s(); !(_step242 = _iterator242.n()).done;) {
              var _t500 = _step242.value;
              _t500.structTreeParent = _e676;
            }
          } catch (err) {
            _iterator242.e(err);
          } finally {
            _iterator242.f();
          }
        }
        return !0;
      }
      return !1;
    };
  var _iterator243 = _createForOfIteratorHelper(n),
    _step243;
  try {
    for (_iterator243.s(); !(_step243 = _iterator243.n()).done;) {
      var _e678 = _step243.value;
      if (!(_e678 instanceof Ref)) continue;
      var _i441 = t.fetch(_e678),
        _a333 = _i441.get("K");
      if (Number.isInteger(_a333)) updateElement(_a333, _i441, _e678);else if (Array.isArray(_a333)) {
        var _iterator244 = _createForOfIteratorHelper(_a333),
          _step244;
        try {
          for (_iterator244.s(); !(_step244 = _iterator244.n()).done;) {
            var _s223 = _step244.value;
            _s223 = t.fetchIfRef(_s223);
            if (Number.isInteger(_s223) && updateElement(_s223, _i441, _e678)) break;
            if (!(_s223 instanceof Dict)) continue;
            if (!isName(_s223.get("Type"), "MCR")) break;
            var _a334 = _s223.get("MCID");
            if (Number.isInteger(_a334) && updateElement(_a334, _i441, _e678)) break;
          }
        } catch (err) {
          _iterator244.e(err);
        } finally {
          _iterator244.f();
        }
      }
    }
  } catch (err) {
    _iterator243.e(err);
  } finally {
    _iterator243.f();
  }
}
function _q2(_x223) {
  return _q3.apply(this, arguments);
}
function _q3() {
  _q3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee119(_ref241) {
    var e, t, i, a, s, r, n, g, o, c, C, h, l, _e686, Q;
    return _regeneratorRuntime().wrap(function _callee119$(_context131) {
      while (1) switch (_context131.prev = _context131.next) {
        case 0:
          e = _ref241.structTreeParent, t = _ref241.tagDict, i = _ref241.newTagRef, a = _ref241.structTreeRootRef, s = _ref241.fallbackKids, r = _ref241.xref, n = _ref241.cache;
          o = null;
          if (e) {
            o = e.ref;
            g = e.dict.getRaw("P") || a;
          } else g = a;
          t.set("P", g);
          c = r.fetchIfRef(g);
          if (c) {
            _context131.next = 8;
            break;
          }
          s.push(i);
          return _context131.abrupt("return");
        case 8:
          C = n.get(g);
          if (!C) {
            C = c.clone();
            n.put(g, C);
          }
          h = C.getRaw("K");
          l = h instanceof Ref ? n.get(h) : null;
          if (!l) {
            l = r.fetchIfRef(h);
            l = Array.isArray(l) ? l.slice() : [h];
            _e686 = r.getNewTemporaryRef();
            C.set("K", _e686);
            n.put(_e686, l);
          }
          Q = l.indexOf(o);
          l.splice(Q >= 0 ? Q + 1 : l.length, 0, i);
        case 15:
        case "end":
          return _context131.stop();
      }
    }, _callee119);
  }));
  return _q3.apply(this, arguments);
}
Object.defineProperty(StructTreeRoot, _q, {
  value: _q2
});
Object.defineProperty(StructTreeRoot, _K, {
  value: _K2
});
Object.defineProperty(StructTreeRoot, _T, {
  value: _T2
});
Object.defineProperty(StructTreeRoot, _v, {
  value: _v2
});
var StructElementNode = /*#__PURE__*/function () {
  function StructElementNode(e, t) {
    _classCallCheck(this, StructElementNode);
    this.tree = e;
    this.dict = t;
    this.kids = [];
    this.parseKids();
  }
  return _createClass(StructElementNode, [{
    key: "role",
    get: function get() {
      var e = this.dict.get("S"),
        t = e instanceof Name ? e.name : "",
        i = this.tree.root;
      return i.roleMap.has(t) ? i.roleMap.get(t) : t;
    }
  }, {
    key: "parseKids",
    value: function parseKids() {
      var e = null;
      var t = this.dict.getRaw("Pg");
      t instanceof Ref && (e = t.toString());
      var i = this.dict.get("K");
      if (Array.isArray(i)) {
        var _iterator105 = _createForOfIteratorHelper(i),
          _step105;
        try {
          for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
            var _t310 = _step105.value;
            var _i277 = this.parseKid(e, _t310);
            _i277 && this.kids.push(_i277);
          }
        } catch (err) {
          _iterator105.e(err);
        } finally {
          _iterator105.f();
        }
      } else {
        var _t311 = this.parseKid(e, i);
        _t311 && this.kids.push(_t311);
      }
    }
  }, {
    key: "parseKid",
    value: function parseKid(e, t) {
      if (Number.isInteger(t)) return this.tree.pageDict.objId !== e ? null : new StructElement({
        type: qs,
        mcid: t,
        pageObjId: e
      });
      var i = null;
      t instanceof Ref ? i = this.dict.xref.fetch(t) : t instanceof Dict && (i = t);
      if (!i) return null;
      var a = i.getRaw("Pg");
      a instanceof Ref && (e = a.toString());
      var s = i.get("Type") instanceof Name ? i.get("Type").name : null;
      if ("MCR" === s) {
        if (this.tree.pageDict.objId !== e) return null;
        var _t312 = i.getRaw("Stm");
        return new StructElement({
          type: Os,
          refObjId: _t312 instanceof Ref ? _t312.toString() : null,
          pageObjId: e,
          mcid: i.get("MCID")
        });
      }
      if ("OBJR" === s) {
        if (this.tree.pageDict.objId !== e) return null;
        var _t313 = i.getRaw("Obj");
        return new StructElement({
          type: Ws,
          refObjId: _t313 instanceof Ref ? _t313.toString() : null,
          pageObjId: e
        });
      }
      return new StructElement({
        type: Xs,
        dict: i
      });
    }
  }]);
}();
var StructElement = /*#__PURE__*/_createClass(function StructElement(_ref112) {
  var e = _ref112.type,
    _ref112$dict = _ref112.dict,
    t = _ref112$dict === void 0 ? null : _ref112$dict,
    _ref112$mcid = _ref112.mcid,
    i = _ref112$mcid === void 0 ? null : _ref112$mcid,
    _ref112$pageObjId = _ref112.pageObjId,
    a = _ref112$pageObjId === void 0 ? null : _ref112$pageObjId,
    _ref112$refObjId = _ref112.refObjId,
    s = _ref112$refObjId === void 0 ? null : _ref112$refObjId;
  _classCallCheck(this, StructElement);
  this.type = e;
  this.dict = t;
  this.mcid = i;
  this.pageObjId = a;
  this.refObjId = s;
  this.parentNode = null;
});
var StructTreePage = /*#__PURE__*/function () {
  function StructTreePage(e, t) {
    _classCallCheck(this, StructTreePage);
    this.root = e;
    this.rootDict = e ? e.dict : null;
    this.pageDict = t;
    this.nodes = [];
  }
  return _createClass(StructTreePage, [{
    key: "collectObjects",
    value: function collectObjects(e) {
      var _this$root$structPare;
      if (!(this.root && this.rootDict && e instanceof Ref)) return null;
      var t = this.rootDict.get("ParentTree");
      if (!t) return null;
      var i = (_this$root$structPare = this.root.structParentIds) === null || _this$root$structPare === void 0 ? void 0 : _this$root$structPare.get(e);
      if (!i) return null;
      var a = new Map(),
        s = new NumberTree(t, this.rootDict.xref);
      var _iterator106 = _createForOfIteratorHelper(i),
        _step106;
      try {
        for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
          var _ref113 = _step106.value;
          var _ref114 = _slicedToArray(_ref113, 1);
          var _e428 = _ref114[0];
          {
            var _t314 = s.getRaw(_e428);
            _t314 instanceof Ref && a.set(_e428, _t314);
          }
        }
      } catch (err) {
        _iterator106.e(err);
      } finally {
        _iterator106.f();
      }
      return a;
    }
  }, {
    key: "parse",
    value: function parse(e) {
      var _this$root$structPare2;
      if (!(this.root && this.rootDict && e instanceof Ref)) return;
      var t = this.rootDict.get("ParentTree");
      if (!t) return;
      var i = this.pageDict.get("StructParents"),
        a = (_this$root$structPare2 = this.root.structParentIds) === null || _this$root$structPare2 === void 0 ? void 0 : _this$root$structPare2.get(e);
      if (!Number.isInteger(i) && !a) return;
      var s = new Map(),
        r = new NumberTree(t, this.rootDict.xref);
      if (Number.isInteger(i)) {
        var _e429 = r.get(i);
        if (Array.isArray(_e429)) {
          var _iterator107 = _createForOfIteratorHelper(_e429),
            _step107;
          try {
            for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
              var _t315 = _step107.value;
              _t315 instanceof Ref && this.addNode(this.rootDict.xref.fetch(_t315), s);
            }
          } catch (err) {
            _iterator107.e(err);
          } finally {
            _iterator107.f();
          }
        }
      }
      if (a) {
        var _iterator108 = _createForOfIteratorHelper(a),
          _step108;
        try {
          for (_iterator108.s(); !(_step108 = _iterator108.n()).done;) {
            var _ref115 = _step108.value;
            var _ref116 = _slicedToArray(_ref115, 2);
            var _e430 = _ref116[0];
            var _t316 = _ref116[1];
            {
              var _i278 = r.get(_e430);
              if (_i278) {
                var _e431$kids;
                var _e431 = this.addNode(this.rootDict.xref.fetchIfRef(_i278), s);
                1 === (_e431 === null || _e431 === void 0 || (_e431$kids = _e431.kids) === null || _e431$kids === void 0 ? void 0 : _e431$kids.length) && _e431.kids[0].type === Ws && (_e431.kids[0].type = _t316);
              }
            }
          }
        } catch (err) {
          _iterator108.e(err);
        } finally {
          _iterator108.f();
        }
      }
    }
  }, {
    key: "addNode",
    value: function addNode(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      if (i > 40) {
        warn("StructTree MAX_DEPTH reached.");
        return null;
      }
      if (!(e instanceof Dict)) return null;
      if (t.has(e)) return t.get(e);
      var a = new StructElementNode(this, e);
      t.set(e, a);
      var s = e.get("P");
      if (!s || isName(s.get("Type"), "StructTreeRoot")) {
        this.addTopLevelNode(e, a) || t.delete(e);
        return a;
      }
      var r = this.addNode(s, t, i + 1);
      if (!r) return a;
      var n = !1;
      var _iterator109 = _createForOfIteratorHelper(r.kids),
        _step109;
      try {
        for (_iterator109.s(); !(_step109 = _iterator109.n()).done;) {
          var _t317 = _step109.value;
          if (_t317.type === Xs && _t317.dict === e) {
            _t317.parentNode = a;
            n = !0;
          }
        }
      } catch (err) {
        _iterator109.e(err);
      } finally {
        _iterator109.f();
      }
      n || t.delete(e);
      return a;
    }
  }, {
    key: "addTopLevelNode",
    value: function addTopLevelNode(e, t) {
      var i = this.rootDict.get("K");
      if (!i) return !1;
      if (i instanceof Dict) {
        if (i.objId !== e.objId) return !1;
        this.nodes[0] = t;
        return !0;
      }
      if (!Array.isArray(i)) return !0;
      var a = !1;
      for (var _s166 = 0; _s166 < i.length; _s166++) {
        var _r123 = i[_s166];
        if ((_r123 === null || _r123 === void 0 ? void 0 : _r123.toString()) === e.objId) {
          this.nodes[_s166] = t;
          a = !0;
        }
      }
      return a;
    }
  }, {
    key: "serializable",
    get: function get() {
      function nodeToSerializable(e, t) {
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        if (i > 40) {
          warn("StructTree too deep to be fully serialized.");
          return;
        }
        var a = Object.create(null);
        a.role = e.role;
        a.children = [];
        t.children.push(a);
        var s = e.dict.get("Alt");
        "string" != typeof s && (s = e.dict.get("ActualText"));
        "string" == typeof s && (a.alt = stringToPDFString(s));
        var r = e.dict.get("A");
        if (r instanceof Dict) {
          var _e432 = lookupNormalRect(r.getArray("BBox"), null);
          if (_e432) a.bbox = _e432;else {
            var _e433 = r.get("Width"),
              _t318 = r.get("Height");
            "number" == typeof _e433 && _e433 > 0 && "number" == typeof _t318 && _t318 > 0 && (a.bbox = [0, 0, _e433, _t318]);
          }
        }
        var n = e.dict.get("Lang");
        "string" == typeof n && (a.lang = stringToPDFString(n));
        var _iterator110 = _createForOfIteratorHelper(e.kids),
          _step110;
        try {
          for (_iterator110.s(); !(_step110 = _iterator110.n()).done;) {
            var _t319 = _step110.value;
            var _e434 = _t319.type === Xs ? _t319.parentNode : null;
            _e434 ? nodeToSerializable(_e434, a, i + 1) : _t319.type === qs || _t319.type === Os ? a.children.push({
              type: "content",
              id: "p".concat(_t319.pageObjId, "_mc").concat(_t319.mcid)
            }) : _t319.type === Ws ? a.children.push({
              type: "object",
              id: _t319.refObjId
            }) : _t319.type === js && a.children.push({
              type: "annotation",
              id: "pdfjs_internal_id_".concat(_t319.refObjId)
            });
          }
        } catch (err) {
          _iterator110.e(err);
        } finally {
          _iterator110.f();
        }
      }
      var e = Object.create(null);
      e.children = [];
      e.role = "Root";
      var _iterator111 = _createForOfIteratorHelper(this.nodes),
        _step111;
      try {
        for (_iterator111.s(); !(_step111 = _iterator111.n()).done;) {
          var t = _step111.value;
          t && nodeToSerializable(t, e);
        }
      } catch (err) {
        _iterator111.e(err);
      } finally {
        _iterator111.f();
      }
      return e;
    }
  }]);
}();
function isValidExplicitDest(e) {
  if (!Array.isArray(e) || e.length < 2) return !1;
  var _e435 = _toArray(e),
    t = _e435[0],
    i = _e435[1],
    a = _e435.slice(2);
  if (!(t instanceof Ref || Number.isInteger(t))) return !1;
  if (!(i instanceof Name)) return !1;
  var s = a.length;
  var r = !0;
  switch (i.name) {
    case "XYZ":
      if (s < 2 || s > 3) return !1;
      break;
    case "Fit":
    case "FitB":
      return 0 === s;
    case "FitH":
    case "FitBH":
    case "FitV":
    case "FitBV":
      if (s > 1) return !1;
      break;
    case "FitR":
      if (4 !== s) return !1;
      r = !1;
      break;
    default:
      return !1;
  }
  var _iterator112 = _createForOfIteratorHelper(a),
    _step112;
  try {
    for (_iterator112.s(); !(_step112 = _iterator112.n()).done;) {
      var _e436 = _step112.value;
      if (!("number" == typeof _e436 || r && null === _e436)) return !1;
    }
  } catch (err) {
    _iterator112.e(err);
  } finally {
    _iterator112.f();
  }
  return !0;
}
function fetchDest(e) {
  e instanceof Dict && (e = e.get("D"));
  return isValidExplicitDest(e) ? e : null;
}
function fetchRemoteDest(e) {
  var t = e.get("D");
  if (t) {
    t instanceof Name && (t = t.name);
    if ("string" == typeof t) return stringToPDFString(t);
    if (isValidExplicitDest(t)) return JSON.stringify(t);
  }
  return null;
}
var _O = /*#__PURE__*/_classPrivateFieldLooseKey("O");
var _P = /*#__PURE__*/_classPrivateFieldLooseKey("P");
var Catalog = /*#__PURE__*/function () {
  function Catalog(_e437, _t320) {
    _classCallCheck(this, Catalog);
    Object.defineProperty(this, _P, {
      value: _P2
    });
    Object.defineProperty(this, _O, {
      value: _O2
    });
    this.pdfManager = _e437;
    this.xref = _t320;
    this._catDict = _t320.getCatalogObj();
    if (!(this._catDict instanceof Dict)) throw new FormatError("Catalog object is not a dictionary.");
    this.toplevelPagesDict;
    this._actualNumPages = null;
    this.fontCache = new RefSetCache();
    this.builtInCMapCache = new Map();
    this.standardFontDataCache = new Map();
    this.globalImageCache = new GlobalImageCache();
    this.pageKidsCountCache = new RefSetCache();
    this.pageIndexCache = new RefSetCache();
    this.pageDictCache = new RefSetCache();
    this.nonBlendModesSet = new RefSet();
    this.systemFontCache = new Map();
  }
  return _createClass(Catalog, [{
    key: "cloneDict",
    value: function cloneDict() {
      return this._catDict.clone();
    }
  }, {
    key: "version",
    get: function get() {
      var e = this._catDict.get("Version");
      if (e instanceof Name) {
        if (St.test(e.name)) return shadow(this, "version", e.name);
        warn("Invalid PDF catalog version: ".concat(e.name));
      }
      return shadow(this, "version", null);
    }
  }, {
    key: "lang",
    get: function get() {
      var e = this._catDict.get("Lang");
      return shadow(this, "lang", e && "string" == typeof e ? stringToPDFString(e) : null);
    }
  }, {
    key: "needsRendering",
    get: function get() {
      var e = this._catDict.get("NeedsRendering");
      return shadow(this, "needsRendering", "boolean" == typeof e && e);
    }
  }, {
    key: "collection",
    get: function get() {
      var e = null;
      try {
        var t = this._catDict.get("Collection");
        t instanceof Dict && t.size > 0 && (e = t);
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        info("Cannot fetch Collection entry; assuming no collection is present.");
      }
      return shadow(this, "collection", e);
    }
  }, {
    key: "acroForm",
    get: function get() {
      var e = null;
      try {
        var t = this._catDict.get("AcroForm");
        t instanceof Dict && t.size > 0 && (e = t);
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        info("Cannot fetch AcroForm entry; assuming no forms are present.");
      }
      return shadow(this, "acroForm", e);
    }
  }, {
    key: "acroFormRef",
    get: function get() {
      var e = this._catDict.getRaw("AcroForm");
      return shadow(this, "acroFormRef", e instanceof Ref ? e : null);
    }
  }, {
    key: "metadata",
    get: function get() {
      var e = this._catDict.getRaw("Metadata");
      if (!(e instanceof Ref)) return shadow(this, "metadata", null);
      var t = null;
      try {
        var _this$xref$encrypt;
        var _i279 = this.xref.fetch(e, !((_this$xref$encrypt = this.xref.encrypt) !== null && _this$xref$encrypt !== void 0 && _this$xref$encrypt.encryptMetadata));
        if (_i279 instanceof BaseStream && _i279.dict instanceof Dict) {
          var _e438 = _i279.dict.get("Type"),
            _a229 = _i279.dict.get("Subtype");
          if (isName(_e438, "Metadata") && isName(_a229, "XML")) {
            var _e439 = stringToUTF8String(_i279.getString());
            _e439 && (t = new MetadataParser(_e439).serializable);
          }
        }
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        info("Skipping invalid Metadata: \"".concat(e, "\"."));
      }
      return shadow(this, "metadata", t);
    }
  }, {
    key: "markInfo",
    get: function get() {
      var e = null;
      try {
        e = this._readMarkInfo();
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        warn("Unable to read mark info.");
      }
      return shadow(this, "markInfo", e);
    }
  }, {
    key: "_readMarkInfo",
    value: function _readMarkInfo() {
      var e = this._catDict.get("MarkInfo");
      if (!(e instanceof Dict)) return null;
      var t = {
        Marked: !1,
        UserProperties: !1,
        Suspects: !1
      };
      for (var _i280 in t) {
        var _a230 = e.get(_i280);
        "boolean" == typeof _a230 && (t[_i280] = _a230);
      }
      return t;
    }
  }, {
    key: "structTreeRoot",
    get: function get() {
      var e = null;
      try {
        e = this._readStructTreeRoot();
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        warn("Unable read to structTreeRoot info.");
      }
      return shadow(this, "structTreeRoot", e);
    }
  }, {
    key: "_readStructTreeRoot",
    value: function _readStructTreeRoot() {
      var e = this._catDict.getRaw("StructTreeRoot"),
        t = this.xref.fetchIfRef(e);
      if (!(t instanceof Dict)) return null;
      var i = new StructTreeRoot(t, e);
      i.init();
      return i;
    }
  }, {
    key: "toplevelPagesDict",
    get: function get() {
      var e = this._catDict.get("Pages");
      if (!(e instanceof Dict)) throw new FormatError("Invalid top-level pages dictionary.");
      return shadow(this, "toplevelPagesDict", e);
    }
  }, {
    key: "documentOutline",
    get: function get() {
      var e = null;
      try {
        e = this._readDocumentOutline();
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        warn("Unable to read document outline.");
      }
      return shadow(this, "documentOutline", e);
    }
  }, {
    key: "_readDocumentOutline",
    value: function _readDocumentOutline() {
      var e = this._catDict.get("Outlines");
      if (!(e instanceof Dict)) return null;
      e = e.getRaw("First");
      if (!(e instanceof Ref)) return null;
      var t = {
          items: []
        },
        i = [{
          obj: e,
          parent: t
        }],
        a = new RefSet();
      a.put(e);
      var s = this.xref,
        r = new Uint8ClampedArray(3);
      for (; i.length > 0;) {
        var _t321 = i.shift(),
          _n88 = s.fetchIfRef(_t321.obj);
        if (null === _n88) continue;
        _n88.has("Title") || warn("Invalid outline item encountered.");
        var g = {
          url: null,
          dest: null,
          action: null
        };
        Catalog.parseDestDictionary({
          destDict: _n88,
          resultObj: g,
          docBaseUrl: this.baseUrl,
          docAttachments: this.attachments
        });
        var o = _n88.get("Title"),
          c = _n88.get("F") || 0,
          C = _n88.getArray("C"),
          h = _n88.get("Count");
        var l = r;
        !isNumberArray(C, 3) || 0 === C[0] && 0 === C[1] && 0 === C[2] || (l = ColorSpace.singletons.rgb.getRgb(C, 0));
        var Q = {
          action: g.action,
          attachment: g.attachment,
          dest: g.dest,
          url: g.url,
          unsafeUrl: g.unsafeUrl,
          newWindow: g.newWindow,
          setOCGState: g.setOCGState,
          title: "string" == typeof o ? stringToPDFString(o) : "",
          color: l,
          count: Number.isInteger(h) ? h : void 0,
          bold: !!(2 & c),
          italic: !!(1 & c),
          items: []
        };
        _t321.parent.items.push(Q);
        e = _n88.getRaw("First");
        if (e instanceof Ref && !a.has(e)) {
          i.push({
            obj: e,
            parent: Q
          });
          a.put(e);
        }
        e = _n88.getRaw("Next");
        if (e instanceof Ref && !a.has(e)) {
          i.push({
            obj: e,
            parent: _t321.parent
          });
          a.put(e);
        }
      }
      return t.items.length > 0 ? t.items : null;
    }
  }, {
    key: "permissions",
    get: function get() {
      var e = null;
      try {
        e = this._readPermissions();
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        warn("Unable to read permissions.");
      }
      return shadow(this, "permissions", e);
    }
  }, {
    key: "_readPermissions",
    value: function _readPermissions() {
      var e = this.xref.trailer.get("Encrypt");
      if (!(e instanceof Dict)) return null;
      var t = e.get("P");
      if ("number" != typeof t) return null;
      t += Math.pow(2, 32);
      var i = [];
      for (var _e440 in y) {
        var _a231 = y[_e440];
        t & _a231 && i.push(_a231);
      }
      return i;
    }
  }, {
    key: "optionalContentConfig",
    get: function get() {
      var e = null;
      try {
        var t = this._catDict.get("OCProperties");
        if (!t) return shadow(this, "optionalContentConfig", null);
        var _i281 = t.get("D");
        if (!_i281) return shadow(this, "optionalContentConfig", null);
        var _a232 = t.get("OCGs");
        if (!Array.isArray(_a232)) return shadow(this, "optionalContentConfig", null);
        var _s167 = new RefSetCache();
        var _iterator113 = _createForOfIteratorHelper(_a232),
          _step113;
        try {
          for (_iterator113.s(); !(_step113 = _iterator113.n()).done;) {
            var _e441 = _step113.value;
            _e441 instanceof Ref && !_s167.has(_e441) && _s167.put(_e441, _classPrivateFieldLooseBase(this, _O)[_O](_e441));
          }
        } catch (err) {
          _iterator113.e(err);
        } finally {
          _iterator113.f();
        }
        e = _classPrivateFieldLooseBase(this, _P)[_P](_i281, _s167);
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        warn("Unable to read optional content config: ".concat(e));
      }
      return shadow(this, "optionalContentConfig", e);
    }
  }, {
    key: "setActualNumPages",
    value: function setActualNumPages() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this._actualNumPages = e;
    }
  }, {
    key: "hasActualNumPages",
    get: function get() {
      return null !== this._actualNumPages;
    }
  }, {
    key: "_pagesCount",
    get: function get() {
      var e = this.toplevelPagesDict.get("Count");
      if (!Number.isInteger(e)) throw new FormatError("Page count in top-level pages dictionary is not an integer.");
      return shadow(this, "_pagesCount", e);
    }
  }, {
    key: "numPages",
    get: function get() {
      return this.hasActualNumPages ? this._actualNumPages : this._pagesCount;
    }
  }, {
    key: "destinations",
    get: function get() {
      var e = this._readDests(),
        t = Object.create(null);
      if (e instanceof NameTree) {
        var _iterator114 = _createForOfIteratorHelper(e.getAll()),
          _step114;
        try {
          for (_iterator114.s(); !(_step114 = _iterator114.n()).done;) {
            var _ref117 = _step114.value;
            var _ref118 = _slicedToArray(_ref117, 2);
            var _i282 = _ref118[0];
            var _a233 = _ref118[1];
            {
              var _e442 = fetchDest(_a233);
              _e442 && (t[stringToPDFString(_i282)] = _e442);
            }
          }
        } catch (err) {
          _iterator114.e(err);
        } finally {
          _iterator114.f();
        }
      } else e instanceof Dict && e.forEach(function (e, i) {
        var a = fetchDest(i);
        a && (t[e] = a);
      });
      return shadow(this, "destinations", t);
    }
  }, {
    key: "getDestination",
    value: function getDestination(e) {
      var t = this._readDests();
      if (t instanceof NameTree) {
        var _i283 = fetchDest(t.get(e));
        if (_i283) return _i283;
        var _a234 = this.destinations[e];
        if (_a234) {
          warn("Found \"".concat(e, "\" at an incorrect position in the NameTree."));
          return _a234;
        }
      } else if (t instanceof Dict) {
        var _i284 = fetchDest(t.get(e));
        if (_i284) return _i284;
      }
      return null;
    }
  }, {
    key: "_readDests",
    value: function _readDests() {
      var e = this._catDict.get("Names");
      return e !== null && e !== void 0 && e.has("Dests") ? new NameTree(e.getRaw("Dests"), this.xref) : this._catDict.has("Dests") ? this._catDict.get("Dests") : void 0;
    }
  }, {
    key: "pageLabels",
    get: function get() {
      var e = null;
      try {
        e = this._readPageLabels();
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        warn("Unable to read page labels.");
      }
      return shadow(this, "pageLabels", e);
    }
  }, {
    key: "_readPageLabels",
    value: function _readPageLabels() {
      var e = this._catDict.getRaw("PageLabels");
      if (!e) return null;
      var t = new Array(this.numPages);
      var i = null,
        a = "";
      var s = new NumberTree(e, this.xref).getAll();
      var r = "",
        n = 1;
      for (var _e443 = 0, g = this.numPages; _e443 < g; _e443++) {
        var _g54 = s.get(_e443);
        if (void 0 !== _g54) {
          if (!(_g54 instanceof Dict)) throw new FormatError("PageLabel is not a dictionary.");
          if (_g54.has("Type") && !isName(_g54.get("Type"), "PageLabel")) throw new FormatError("Invalid type in PageLabel dictionary.");
          if (_g54.has("S")) {
            var _e444 = _g54.get("S");
            if (!(_e444 instanceof Name)) throw new FormatError("Invalid style in PageLabel dictionary.");
            i = _e444.name;
          } else i = null;
          if (_g54.has("P")) {
            var _e445 = _g54.get("P");
            if ("string" != typeof _e445) throw new FormatError("Invalid prefix in PageLabel dictionary.");
            a = stringToPDFString(_e445);
          } else a = "";
          if (_g54.has("St")) {
            var _e446 = _g54.get("St");
            if (!(Number.isInteger(_e446) && _e446 >= 1)) throw new FormatError("Invalid start in PageLabel dictionary.");
            n = _e446;
          } else n = 1;
        }
        switch (i) {
          case "D":
            r = n;
            break;
          case "R":
          case "r":
            r = toRomanNumerals(n, "r" === i);
            break;
          case "A":
          case "a":
            var _e447 = 26,
              _t322 = "a" === i ? 97 : 65,
              _a235 = n - 1;
            r = String.fromCharCode(_t322 + _a235 % _e447).repeat(Math.floor(_a235 / _e447) + 1);
            break;
          default:
            if (i) throw new FormatError("Invalid style \"".concat(i, "\" in PageLabel dictionary."));
            r = "";
        }
        t[_e443] = a + r;
        n++;
      }
      return t;
    }
  }, {
    key: "pageLayout",
    get: function get() {
      var e = this._catDict.get("PageLayout");
      var t = "";
      if (e instanceof Name) switch (e.name) {
        case "SinglePage":
        case "OneColumn":
        case "TwoColumnLeft":
        case "TwoColumnRight":
        case "TwoPageLeft":
        case "TwoPageRight":
          t = e.name;
      }
      return shadow(this, "pageLayout", t);
    }
  }, {
    key: "pageMode",
    get: function get() {
      var e = this._catDict.get("PageMode");
      var t = "UseNone";
      if (e instanceof Name) switch (e.name) {
        case "UseNone":
        case "UseOutlines":
        case "UseThumbs":
        case "FullScreen":
        case "UseOC":
        case "UseAttachments":
          t = e.name;
      }
      return shadow(this, "pageMode", t);
    }
  }, {
    key: "viewerPreferences",
    get: function get() {
      var _this61 = this;
      var e = this._catDict.get("ViewerPreferences");
      if (!(e instanceof Dict)) return shadow(this, "viewerPreferences", null);
      var t = null;
      var _iterator115 = _createForOfIteratorHelper(e.getKeys()),
        _step115;
      try {
        for (_iterator115.s(); !(_step115 = _iterator115.n()).done;) {
          var _i285 = _step115.value;
          var _a236 = e.get(_i285);
          var _s168 = void 0;
          switch (_i285) {
            case "HideToolbar":
            case "HideMenubar":
            case "HideWindowUI":
            case "FitWindow":
            case "CenterWindow":
            case "DisplayDocTitle":
            case "PickTrayByPDFSize":
              "boolean" == typeof _a236 && (_s168 = _a236);
              break;
            case "NonFullScreenPageMode":
              if (_a236 instanceof Name) switch (_a236.name) {
                case "UseNone":
                case "UseOutlines":
                case "UseThumbs":
                case "UseOC":
                  _s168 = _a236.name;
                  break;
                default:
                  _s168 = "UseNone";
              }
              break;
            case "Direction":
              if (_a236 instanceof Name) switch (_a236.name) {
                case "L2R":
                case "R2L":
                  _s168 = _a236.name;
                  break;
                default:
                  _s168 = "L2R";
              }
              break;
            case "ViewArea":
            case "ViewClip":
            case "PrintArea":
            case "PrintClip":
              if (_a236 instanceof Name) switch (_a236.name) {
                case "MediaBox":
                case "CropBox":
                case "BleedBox":
                case "TrimBox":
                case "ArtBox":
                  _s168 = _a236.name;
                  break;
                default:
                  _s168 = "CropBox";
              }
              break;
            case "PrintScaling":
              if (_a236 instanceof Name) switch (_a236.name) {
                case "None":
                case "AppDefault":
                  _s168 = _a236.name;
                  break;
                default:
                  _s168 = "AppDefault";
              }
              break;
            case "Duplex":
              if (_a236 instanceof Name) switch (_a236.name) {
                case "Simplex":
                case "DuplexFlipShortEdge":
                case "DuplexFlipLongEdge":
                  _s168 = _a236.name;
                  break;
                default:
                  _s168 = "None";
              }
              break;
            case "PrintPageRange":
              if (Array.isArray(_a236) && _a236.length % 2 == 0) {
                _a236.every(function (e, t, i) {
                  return Number.isInteger(e) && e > 0 && (0 === t || e >= i[t - 1]) && e <= _this61.numPages;
                }) && (_s168 = _a236);
              }
              break;
            case "NumCopies":
              Number.isInteger(_a236) && _a236 > 0 && (_s168 = _a236);
              break;
            default:
              warn("Ignoring non-standard key in ViewerPreferences: ".concat(_i285, "."));
              continue;
          }
          if (void 0 !== _s168) {
            t || (t = Object.create(null));
            t[_i285] = _s168;
          } else warn("Bad value, for key \"".concat(_i285, "\", in ViewerPreferences: ").concat(_a236, "."));
        }
      } catch (err) {
        _iterator115.e(err);
      } finally {
        _iterator115.f();
      }
      return shadow(this, "viewerPreferences", t);
    }
  }, {
    key: "openAction",
    get: function get() {
      var e = this._catDict.get("OpenAction"),
        t = Object.create(null);
      if (e instanceof Dict) {
        var _i286 = new Dict(this.xref);
        _i286.set("A", e);
        var _a237 = {
          url: null,
          dest: null,
          action: null
        };
        Catalog.parseDestDictionary({
          destDict: _i286,
          resultObj: _a237
        });
        Array.isArray(_a237.dest) ? t.dest = _a237.dest : _a237.action && (t.action = _a237.action);
      } else Array.isArray(e) && (t.dest = e);
      return shadow(this, "openAction", objectSize(t) > 0 ? t : null);
    }
  }, {
    key: "attachments",
    get: function get() {
      var e = this._catDict.get("Names");
      var t = null;
      if (e instanceof Dict && e.has("EmbeddedFiles")) {
        var _i287 = new NameTree(e.getRaw("EmbeddedFiles"), this.xref);
        var _iterator116 = _createForOfIteratorHelper(_i287.getAll()),
          _step116;
        try {
          for (_iterator116.s(); !(_step116 = _iterator116.n()).done;) {
            var _ref119 = _step116.value;
            var _ref120 = _slicedToArray(_ref119, 2);
            var _e448 = _ref120[0];
            var _a238 = _ref120[1];
            var _i288 = new FileSpec(_a238, this.xref);
            t || (t = Object.create(null));
            t[stringToPDFString(_e448)] = _i288.serializable;
          }
        } catch (err) {
          _iterator116.e(err);
        } finally {
          _iterator116.f();
        }
      }
      return shadow(this, "attachments", t);
    }
  }, {
    key: "xfaImages",
    get: function get() {
      var e = this._catDict.get("Names");
      var t = null;
      if (e instanceof Dict && e.has("XFAImages")) {
        var _i289 = new NameTree(e.getRaw("XFAImages"), this.xref);
        var _iterator117 = _createForOfIteratorHelper(_i289.getAll()),
          _step117;
        try {
          for (_iterator117.s(); !(_step117 = _iterator117.n()).done;) {
            var _ref121 = _step117.value;
            var _ref122 = _slicedToArray(_ref121, 2);
            var _e449 = _ref122[0];
            var _a239 = _ref122[1];
            t || (t = new Dict(this.xref));
            t.set(stringToPDFString(_e449), _a239);
          }
        } catch (err) {
          _iterator117.e(err);
        } finally {
          _iterator117.f();
        }
      }
      return shadow(this, "xfaImages", t);
    }
  }, {
    key: "_collectJavaScript",
    value: function _collectJavaScript() {
      var e = this._catDict.get("Names");
      var t = null;
      function appendIfJavaScriptDict(e, i) {
        if (!(i instanceof Dict)) return;
        if (!isName(i.get("S"), "JavaScript")) return;
        var a = i.get("JS");
        if (a instanceof BaseStream) a = a.getString();else if ("string" != typeof a) return;
        a = stringToPDFString(a).replaceAll("\0", "");
        a && (t || (t = new Map())).set(e, a);
      }
      if (e instanceof Dict && e.has("JavaScript")) {
        var _t323 = new NameTree(e.getRaw("JavaScript"), this.xref);
        var _iterator118 = _createForOfIteratorHelper(_t323.getAll()),
          _step118;
        try {
          for (_iterator118.s(); !(_step118 = _iterator118.n()).done;) {
            var _ref123 = _step118.value;
            var _ref124 = _slicedToArray(_ref123, 2);
            var _e450 = _ref124[0];
            var _i290 = _ref124[1];
            appendIfJavaScriptDict(stringToPDFString(_e450), _i290);
          }
        } catch (err) {
          _iterator118.e(err);
        } finally {
          _iterator118.f();
        }
      }
      var i = this._catDict.get("OpenAction");
      i && appendIfJavaScriptDict("OpenAction", i);
      return t;
    }
  }, {
    key: "jsActions",
    get: function get() {
      var e = this._collectJavaScript();
      var t = collectActions(this.xref, this._catDict, fA);
      if (e) {
        t || (t = Object.create(null));
        var _iterator119 = _createForOfIteratorHelper(e),
          _step119;
        try {
          for (_iterator119.s(); !(_step119 = _iterator119.n()).done;) {
            var _ref125 = _step119.value;
            var _ref126 = _slicedToArray(_ref125, 2);
            var _i291 = _ref126[0];
            var _a240 = _ref126[1];
            _i291 in t ? t[_i291].push(_a240) : t[_i291] = [_a240];
          }
        } catch (err) {
          _iterator119.e(err);
        } finally {
          _iterator119.f();
        }
      }
      return shadow(this, "jsActions", t);
    }
  }, {
    key: "fontFallback",
    value: function () {
      var _fontFallback = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee40(e, t) {
        var i, _iterator120, _step120, _a241;
        return _regeneratorRuntime().wrap(function _callee40$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              _context42.next = 2;
              return Promise.all(this.fontCache);
            case 2:
              i = _context42.sent;
              _iterator120 = _createForOfIteratorHelper(i);
              _context42.prev = 4;
              _iterator120.s();
            case 6:
              if ((_step120 = _iterator120.n()).done) {
                _context42.next = 13;
                break;
              }
              _a241 = _step120.value;
              if (!(_a241.loadedName === e)) {
                _context42.next = 11;
                break;
              }
              _a241.fallback(t);
              return _context42.abrupt("return");
            case 11:
              _context42.next = 6;
              break;
            case 13:
              _context42.next = 18;
              break;
            case 15:
              _context42.prev = 15;
              _context42.t0 = _context42["catch"](4);
              _iterator120.e(_context42.t0);
            case 18:
              _context42.prev = 18;
              _iterator120.f();
              return _context42.finish(18);
            case 21:
            case "end":
              return _context42.stop();
          }
        }, _callee40, this, [[4, 15, 18, 21]]);
      }));
      function fontFallback(_x85, _x86) {
        return _fontFallback.apply(this, arguments);
      }
      return fontFallback;
    }()
  }, {
    key: "cleanup",
    value: function () {
      var _cleanup = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
        var e,
          t,
          _iterator121,
          _step121,
          _ref127,
          _e451,
          _args43 = arguments;
        return _regeneratorRuntime().wrap(function _callee41$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              e = _args43.length > 0 && _args43[0] !== undefined ? _args43[0] : !1;
              clearGlobalCaches();
              this.globalImageCache.clear(e);
              this.pageKidsCountCache.clear();
              this.pageIndexCache.clear();
              this.pageDictCache.clear();
              this.nonBlendModesSet.clear();
              _context43.next = 9;
              return Promise.all(this.fontCache);
            case 9:
              t = _context43.sent;
              _iterator121 = _createForOfIteratorHelper(t);
              try {
                for (_iterator121.s(); !(_step121 = _iterator121.n()).done;) {
                  _ref127 = _step121.value;
                  _e451 = _ref127.dict;
                  delete _e451.cacheKey;
                }
              } catch (err) {
                _iterator121.e(err);
              } finally {
                _iterator121.f();
              }
              this.fontCache.clear();
              this.builtInCMapCache.clear();
              this.standardFontDataCache.clear();
              this.systemFontCache.clear();
            case 16:
            case "end":
              return _context43.stop();
          }
        }, _callee41, this);
      }));
      function cleanup() {
        return _cleanup.apply(this, arguments);
      }
      return cleanup;
    }()
  }, {
    key: "getPageDict",
    value: function () {
      var _getPageDict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee42(e) {
        var t, i, a, s, r, n, g, o, _a242, _c30, _C20, _t324, c, C, h, _t325, _e452, _i292;
        return _regeneratorRuntime().wrap(function _callee42$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              t = [this.toplevelPagesDict], i = new RefSet(), a = this._catDict.getRaw("Pages");
              a instanceof Ref && i.put(a);
              s = this.xref, r = this.pageKidsCountCache, n = this.pageIndexCache, g = this.pageDictCache;
              o = 0;
            case 4:
              if (!t.length) {
                _context44.next = 69;
                break;
              }
              _a242 = t.pop();
              if (!(_a242 instanceof Ref)) {
                _context44.next = 33;
                break;
              }
              _c30 = r.get(_a242);
              if (!(_c30 >= 0 && o + _c30 <= e)) {
                _context44.next = 11;
                break;
              }
              o += _c30;
              return _context44.abrupt("continue", 67);
            case 11:
              if (!i.has(_a242)) {
                _context44.next = 13;
                break;
              }
              throw new FormatError("Pages tree contains circular reference.");
            case 13:
              i.put(_a242);
              _context44.next = 16;
              return g.get(_a242) || s.fetchAsync(_a242);
            case 16:
              _C20 = _context44.sent;
              if (!(_C20 instanceof Dict)) {
                _context44.next = 31;
                break;
              }
              _t324 = _C20.getRaw("Type");
              _context44.t0 = _t324 instanceof Ref;
              if (!_context44.t0) {
                _context44.next = 24;
                break;
              }
              _context44.next = 23;
              return s.fetchAsync(_t324);
            case 23:
              _t324 = _context44.sent;
            case 24:
              if (!(isName(_t324, "Page") || !_C20.has("Kids"))) {
                _context44.next = 31;
                break;
              }
              r.has(_a242) || r.put(_a242, 1);
              n.has(_a242) || n.put(_a242, o);
              if (!(o === e)) {
                _context44.next = 29;
                break;
              }
              return _context44.abrupt("return", [_C20, _a242]);
            case 29:
              o++;
              return _context44.abrupt("continue", 67);
            case 31:
              t.push(_C20);
              return _context44.abrupt("continue", 67);
            case 33:
              if (_a242 instanceof Dict) {
                _context44.next = 35;
                break;
              }
              throw new FormatError("Page dictionary kid reference points to wrong type of object.");
            case 35:
              c = _a242.objId;
              C = _a242.getRaw("Count");
              _context44.t1 = C instanceof Ref;
              if (!_context44.t1) {
                _context44.next = 42;
                break;
              }
              _context44.next = 41;
              return s.fetchAsync(C);
            case 41:
              C = _context44.sent;
            case 42:
              if (!(Number.isInteger(C) && C >= 0)) {
                _context44.next = 47;
                break;
              }
              c && !r.has(c) && r.put(c, C);
              if (!(o + C <= e)) {
                _context44.next = 47;
                break;
              }
              o += C;
              return _context44.abrupt("continue", 67);
            case 47:
              h = _a242.getRaw("Kids");
              _context44.t2 = h instanceof Ref;
              if (!_context44.t2) {
                _context44.next = 53;
                break;
              }
              _context44.next = 52;
              return s.fetchAsync(h);
            case 52:
              h = _context44.sent;
            case 53:
              if (Array.isArray(h)) {
                _context44.next = 66;
                break;
              }
              _t325 = _a242.getRaw("Type");
              _context44.t3 = _t325 instanceof Ref;
              if (!_context44.t3) {
                _context44.next = 60;
                break;
              }
              _context44.next = 59;
              return s.fetchAsync(_t325);
            case 59:
              _t325 = _context44.sent;
            case 60:
              if (!(isName(_t325, "Page") || !_a242.has("Kids"))) {
                _context44.next = 65;
                break;
              }
              if (!(o === e)) {
                _context44.next = 63;
                break;
              }
              return _context44.abrupt("return", [_a242, null]);
            case 63:
              o++;
              return _context44.abrupt("continue", 67);
            case 65:
              throw new FormatError("Page dictionary kids object is not an array.");
            case 66:
              for (_e452 = h.length - 1; _e452 >= 0; _e452--) {
                _i292 = h[_e452];
                t.push(_i292);
                _a242 === this.toplevelPagesDict && _i292 instanceof Ref && !g.has(_i292) && g.put(_i292, s.fetchAsync(_i292));
              }
            case 67:
              _context44.next = 4;
              break;
            case 69:
              throw new Error("Page index ".concat(e, " not found."));
            case 70:
            case "end":
              return _context44.stop();
          }
        }, _callee42, this);
      }));
      function getPageDict(_x87) {
        return _getPageDict.apply(this, arguments);
      }
      return getPageDict;
    }()
  }, {
    key: "getAllPageDicts",
    value: function () {
      var _getAllPageDicts = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
        var e,
          t,
          i,
          a,
          s,
          r,
          n,
          g,
          o,
          addPageDict,
          addPageError,
          _e453,
          _t326,
          _s169,
          _r124,
          _g55,
          _o39,
          c,
          _args45 = arguments;
        return _regeneratorRuntime().wrap(function _callee43$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              addPageError = function _addPageError(i) {
                if (i instanceof XRefEntryException && !e) throw i;
                if (e && t && 0 === o) {
                  warn("getAllPageDicts - Skipping invalid first page: \"".concat(i, "\"."));
                  i = Dict.empty;
                }
                r.set(o++, [i, null]);
              };
              addPageDict = function _addPageDict(e, t) {
                t && !g.has(t) && g.put(t, o);
                r.set(o++, [e, t]);
              };
              e = _args45.length > 0 && _args45[0] !== undefined ? _args45[0] : !1;
              t = this.pdfManager.evaluatorOptions.ignoreErrors, i = [{
                currentNode: this.toplevelPagesDict,
                posInKids: 0
              }], a = new RefSet(), s = this._catDict.getRaw("Pages");
              s instanceof Ref && a.put(s);
              r = new Map(), n = this.xref, g = this.pageIndexCache;
              o = 0;
            case 7:
              if (!(i.length > 0)) {
                _context45.next = 66;
                break;
              }
              _e453 = i.at(-1), _t326 = _e453.currentNode, _s169 = _e453.posInKids;
              _r124 = _t326.getRaw("Kids");
              if (!(_r124 instanceof Ref)) {
                _context45.next = 21;
                break;
              }
              _context45.prev = 11;
              _context45.next = 14;
              return n.fetchAsync(_r124);
            case 14:
              _r124 = _context45.sent;
              _context45.next = 21;
              break;
            case 17:
              _context45.prev = 17;
              _context45.t0 = _context45["catch"](11);
              addPageError(_context45.t0);
              return _context45.abrupt("break", 66);
            case 21:
              if (Array.isArray(_r124)) {
                _context45.next = 24;
                break;
              }
              addPageError(new FormatError("Page dictionary kids object is not an array."));
              return _context45.abrupt("break", 66);
            case 24:
              if (!(_s169 >= _r124.length)) {
                _context45.next = 27;
                break;
              }
              i.pop();
              return _context45.abrupt("continue", 64);
            case 27:
              _g55 = _r124[_s169];
              _o39 = void 0;
              if (!(_g55 instanceof Ref)) {
                _context45.next = 46;
                break;
              }
              if (!a.has(_g55)) {
                _context45.next = 33;
                break;
              }
              addPageError(new FormatError("Pages tree contains circular reference."));
              return _context45.abrupt("break", 66);
            case 33:
              a.put(_g55);
              _context45.prev = 34;
              _context45.next = 37;
              return n.fetchAsync(_g55);
            case 37:
              _o39 = _context45.sent;
              _context45.next = 44;
              break;
            case 40:
              _context45.prev = 40;
              _context45.t1 = _context45["catch"](34);
              addPageError(_context45.t1);
              return _context45.abrupt("break", 66);
            case 44:
              _context45.next = 47;
              break;
            case 46:
              _o39 = _g55;
            case 47:
              if (_o39 instanceof Dict) {
                _context45.next = 50;
                break;
              }
              addPageError(new FormatError("Page dictionary kid reference points to wrong type of object."));
              return _context45.abrupt("break", 66);
            case 50:
              c = _o39.getRaw("Type");
              if (!(c instanceof Ref)) {
                _context45.next = 62;
                break;
              }
              _context45.prev = 52;
              _context45.next = 55;
              return n.fetchAsync(c);
            case 55:
              c = _context45.sent;
              _context45.next = 62;
              break;
            case 58:
              _context45.prev = 58;
              _context45.t2 = _context45["catch"](52);
              addPageError(_context45.t2);
              return _context45.abrupt("break", 66);
            case 62:
              isName(c, "Page") || !_o39.has("Kids") ? addPageDict(_o39, _g55 instanceof Ref ? _g55 : null) : i.push({
                currentNode: _o39,
                posInKids: 0
              });
              _e453.posInKids++;
            case 64:
              _context45.next = 7;
              break;
            case 66:
              return _context45.abrupt("return", r);
            case 67:
            case "end":
              return _context45.stop();
          }
        }, _callee43, this, [[11, 17], [34, 40], [52, 58]]);
      }));
      function getAllPageDicts() {
        return _getAllPageDicts.apply(this, arguments);
      }
      return getAllPageDicts;
    }()
  }, {
    key: "getPageIndex",
    value: function getPageIndex(e) {
      var _this62 = this;
      var t = this.pageIndexCache.get(e);
      if (void 0 !== t) return Promise.resolve(t);
      var i = this.xref;
      var a = 0;
      var _next2 = function next(t) {
        return function pagesBeforeRef(t) {
          var a,
            s = 0;
          return i.fetchAsync(t).then(function (i) {
            if (isRefsEqual(t, e) && !isDict(i, "Page") && !(i instanceof Dict && !i.has("Type") && i.has("Contents"))) throw new FormatError("The reference does not point to a /Page dictionary.");
            if (!i) return null;
            if (!(i instanceof Dict)) throw new FormatError("Node must be a dictionary.");
            a = i.getRaw("Parent");
            return i.getAsync("Parent");
          }).then(function (e) {
            if (!e) return null;
            if (!(e instanceof Dict)) throw new FormatError("Parent must be a dictionary.");
            return e.getAsync("Kids");
          }).then(function (e) {
            if (!e) return null;
            var r = [];
            var n = !1;
            var _iterator122 = _createForOfIteratorHelper(e),
              _step122;
            try {
              for (_iterator122.s(); !(_step122 = _iterator122.n()).done;) {
                var _a243 = _step122.value;
                if (!(_a243 instanceof Ref)) throw new FormatError("Kid must be a reference.");
                if (isRefsEqual(_a243, t)) {
                  n = !0;
                  break;
                }
                r.push(i.fetchAsync(_a243).then(function (e) {
                  if (!(e instanceof Dict)) throw new FormatError("Kid node must be a dictionary.");
                  e.has("Count") ? s += e.get("Count") : s++;
                }));
              }
            } catch (err) {
              _iterator122.e(err);
            } finally {
              _iterator122.f();
            }
            if (!n) throw new FormatError("Kid reference not found in parent's kids.");
            return Promise.all(r).then(function () {
              return [s, a];
            });
          });
        }(t).then(function (t) {
          if (!t) {
            _this62.pageIndexCache.put(e, a);
            return a;
          }
          var _t327 = _slicedToArray(t, 2),
            i = _t327[0],
            s = _t327[1];
          a += i;
          return _next2(s);
        });
      };
      return _next2(e);
    }
  }, {
    key: "baseUrl",
    get: function get() {
      var e = this._catDict.get("URI");
      if (e instanceof Dict) {
        var _t328 = e.get("Base");
        if ("string" == typeof _t328) {
          var _e454 = createValidAbsoluteUrl(_t328, null, {
            tryConvertEncoding: !0
          });
          if (_e454) return shadow(this, "baseUrl", _e454.href);
        }
      }
      return shadow(this, "baseUrl", this.pdfManager.docBaseUrl);
    }
  }], [{
    key: "parseDestDictionary",
    value: function parseDestDictionary(_ref128) {
      var e = _ref128.destDict,
        t = _ref128.resultObj,
        _ref128$docBaseUrl = _ref128.docBaseUrl,
        i = _ref128$docBaseUrl === void 0 ? null : _ref128$docBaseUrl,
        _ref128$docAttachment = _ref128.docAttachments,
        a = _ref128$docAttachment === void 0 ? null : _ref128$docAttachment;
      if (!(e instanceof Dict)) {
        warn("parseDestDictionary: `destDict` must be a dictionary.");
        return;
      }
      var s,
        r,
        n = e.get("A");
      if (!(n instanceof Dict)) if (e.has("Dest")) n = e.get("Dest");else {
        n = e.get("AA");
        n instanceof Dict && (n.has("D") ? n = n.get("D") : n.has("U") && (n = n.get("U")));
      }
      if (n instanceof Dict) {
        var _e455 = n.get("S");
        if (!(_e455 instanceof Name)) {
          warn("parseDestDictionary: Invalid type in Action dictionary.");
          return;
        }
        var _i293 = _e455.name;
        switch (_i293) {
          case "ResetForm":
            var _e456 = n.get("Flags"),
              _g56 = 0 == (1 & ("number" == typeof _e456 ? _e456 : 0)),
              _o40 = [],
              c = [];
            var _iterator123 = _createForOfIteratorHelper(n.get("Fields") || []),
              _step123;
            try {
              for (_iterator123.s(); !(_step123 = _iterator123.n()).done;) {
                var _e457 = _step123.value;
                _e457 instanceof Ref ? c.push(_e457.toString()) : "string" == typeof _e457 && _o40.push(stringToPDFString(_e457));
              }
            } catch (err) {
              _iterator123.e(err);
            } finally {
              _iterator123.f();
            }
            t.resetForm = {
              fields: _o40,
              refs: c,
              include: _g56
            };
            break;
          case "URI":
            s = n.get("URI");
            s instanceof Name && (s = "/" + s.name);
            break;
          case "GoTo":
            r = n.get("D");
            break;
          case "Launch":
          case "GoToR":
            var C = n.get("F");
            if (C instanceof Dict) {
              var _e458 = new FileSpec(C, null, !0),
                _t329 = _e458.serializable.rawFilename;
              s = _t329;
            } else "string" == typeof C && (s = C);
            var h = fetchRemoteDest(n);
            h && "string" == typeof s && (s = s.split("#", 1)[0] + "#" + h);
            var l = n.get("NewWindow");
            "boolean" == typeof l && (t.newWindow = l);
            break;
          case "GoToE":
            var Q = n.get("T");
            var E;
            if (a && Q instanceof Dict) {
              var _e459 = Q.get("R"),
                _t330 = Q.get("N");
              isName(_e459, "C") && "string" == typeof _t330 && (E = a[stringToPDFString(_t330)]);
            }
            if (E) {
              t.attachment = E;
              var _e460 = fetchRemoteDest(n);
              _e460 && (t.attachmentDest = _e460);
            } else warn('parseDestDictionary - unimplemented "GoToE" action.');
            break;
          case "Named":
            var u = n.get("N");
            u instanceof Name && (t.action = u.name);
            break;
          case "SetOCGState":
            var d = n.get("State"),
              f = n.get("PreserveRB");
            if (!Array.isArray(d) || 0 === d.length) break;
            var p = [];
            var _iterator124 = _createForOfIteratorHelper(d),
              _step124;
            try {
              for (_iterator124.s(); !(_step124 = _iterator124.n()).done;) {
                var _e461 = _step124.value;
                if (_e461 instanceof Name) switch (_e461.name) {
                  case "ON":
                  case "OFF":
                  case "Toggle":
                    p.push(_e461.name);
                } else _e461 instanceof Ref && p.push(_e461.toString());
              }
            } catch (err) {
              _iterator124.e(err);
            } finally {
              _iterator124.f();
            }
            if (p.length !== d.length) break;
            t.setOCGState = {
              state: p,
              preserveRB: "boolean" != typeof f || f
            };
            break;
          case "JavaScript":
            var m = n.get("JS");
            var _y6;
            m instanceof BaseStream ? _y6 = m.getString() : "string" == typeof m && (_y6 = m);
            var _w4 = _y6 && recoverJsURL(stringToPDFString(_y6));
            if (_w4) {
              s = _w4.url;
              t.newWindow = _w4.newWindow;
              break;
            }
          default:
            if ("JavaScript" === _i293 || "SubmitForm" === _i293) break;
            warn("parseDestDictionary - unsupported action: \"".concat(_i293, "\"."));
        }
      } else e.has("Dest") && (r = e.get("Dest"));
      if ("string" == typeof s) {
        var _e462 = createValidAbsoluteUrl(s, i, {
          addDefaultProtocol: !0,
          tryConvertEncoding: !0
        });
        _e462 && (t.url = _e462.href);
        t.unsafeUrl = s;
      }
      if (r) {
        r instanceof Name && (r = r.name);
        "string" == typeof r ? t.dest = stringToPDFString(r) : isValidExplicitDest(r) && (t.dest = r);
      }
    }
  }]);
}();
function _O2(e) {
  var t = this.xref.fetch(e),
    i = {
      id: e.toString(),
      name: null,
      intent: null,
      usage: {
        print: null,
        view: null
      },
      rbGroups: []
    },
    a = t.get("Name");
  "string" == typeof a && (i.name = stringToPDFString(a));
  var s = t.getArray("Intent");
  Array.isArray(s) || (s = [s]);
  s.every(function (e) {
    return e instanceof Name;
  }) && (i.intent = s.map(function (e) {
    return e.name;
  }));
  var r = t.get("Usage");
  if (!(r instanceof Dict)) return i;
  var n = i.usage,
    g = r.get("Print");
  if (g instanceof Dict) {
    var _e679 = g.get("PrintState");
    if (_e679 instanceof Name) switch (_e679.name) {
      case "ON":
      case "OFF":
        n.print = {
          printState: _e679.name
        };
    }
  }
  var o = r.get("View");
  if (o instanceof Dict) {
    var _e680 = o.get("ViewState");
    if (_e680 instanceof Name) switch (_e680.name) {
      case "ON":
      case "OFF":
        n.view = {
          viewState: _e680.name
        };
    }
  }
  return i;
}
function _P2(e, t) {
  function parseOnOff(e) {
    var i = [];
    if (Array.isArray(e)) {
      var _iterator245 = _createForOfIteratorHelper(e),
        _step245;
      try {
        for (_iterator245.s(); !(_step245 = _iterator245.n()).done;) {
          var _a335 = _step245.value;
          _a335 instanceof Ref && t.has(_a335) && i.push(_a335.toString());
        }
      } catch (err) {
        _iterator245.e(err);
      } finally {
        _iterator245.f();
      }
    }
    return i;
  }
  function parseOrder(e) {
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (!Array.isArray(e)) return null;
    var s = [];
    var _iterator246 = _createForOfIteratorHelper(e),
      _step246;
    try {
      for (_iterator246.s(); !(_step246 = _iterator246.n()).done;) {
        var _r171 = _step246.value;
        if (_r171 instanceof Ref && t.has(_r171)) {
          a.put(_r171);
          s.push(_r171.toString());
          continue;
        }
        var _e681 = parseNestedOrder(_r171, i);
        _e681 && s.push(_e681);
      }
    } catch (err) {
      _iterator246.e(err);
    } finally {
      _iterator246.f();
    }
    if (i > 0) return s;
    var r = [];
    var _iterator247 = _createForOfIteratorHelper(t.items()),
      _step247;
    try {
      for (_iterator247.s(); !(_step247 = _iterator247.n()).done;) {
        var _ref242 = _step247.value;
        var _ref243 = _slicedToArray(_ref242, 1);
        var _e682 = _ref243[0];
        a.has(_e682) || r.push(_e682.toString());
      }
    } catch (err) {
      _iterator247.e(err);
    } finally {
      _iterator247.f();
    }
    r.length && s.push({
      name: null,
      order: r
    });
    return s;
  }
  function parseNestedOrder(e, t) {
    if (++t > s) {
      warn("parseNestedOrder - reached MAX_NESTED_LEVELS.");
      return null;
    }
    var a = i.fetchIfRef(e);
    if (!Array.isArray(a)) return null;
    var r = i.fetchIfRef(a[0]);
    if ("string" != typeof r) return null;
    var n = parseOrder(a.slice(1), t);
    return n && n.length ? {
      name: stringToPDFString(r),
      order: n
    } : null;
  }
  var i = this.xref,
    a = new RefSet(),
    s = 10;
  !function parseRBGroups(e) {
    if (Array.isArray(e)) {
      var _iterator248 = _createForOfIteratorHelper(e),
        _step248;
      try {
        for (_iterator248.s(); !(_step248 = _iterator248.n()).done;) {
          var _a336 = _step248.value;
          var _e683 = i.fetchIfRef(_a336);
          if (!Array.isArray(_e683) || !_e683.length) continue;
          var _s224 = new Set();
          var _iterator249 = _createForOfIteratorHelper(_e683),
            _step249;
          try {
            for (_iterator249.s(); !(_step249 = _iterator249.n()).done;) {
              var _i442 = _step249.value;
              if (_i442 instanceof Ref && t.has(_i442) && !_s224.has(_i442.toString())) {
                _s224.add(_i442.toString());
                t.get(_i442).rbGroups.push(_s224);
              }
            }
          } catch (err) {
            _iterator249.e(err);
          } finally {
            _iterator249.f();
          }
        }
      } catch (err) {
        _iterator248.e(err);
      } finally {
        _iterator248.f();
      }
    }
  }(e.get("RBGroups"));
  return {
    name: "string" == typeof e.get("Name") ? stringToPDFString(e.get("Name")) : null,
    creator: "string" == typeof e.get("Creator") ? stringToPDFString(e.get("Creator")) : null,
    baseState: e.get("BaseState") instanceof Name ? e.get("BaseState").name : null,
    on: parseOnOff(e.get("ON")),
    off: parseOnOff(e.get("OFF")),
    order: parseOrder(e.get("Order")),
    groups: _toConsumableArray(t)
  };
}
function addChildren(e, t) {
  if (e instanceof Dict) e = e.getRawValues();else if (e instanceof BaseStream) e = e.dict.getRawValues();else if (!Array.isArray(e)) return;
  var _iterator125 = _createForOfIteratorHelper(e),
    _step125;
  try {
    for (_iterator125.s(); !(_step125 = _iterator125.n()).done;) {
      var _a244 = _step125.value;
      ((i = _a244) instanceof Ref || i instanceof Dict || i instanceof BaseStream || Array.isArray(i)) && t.push(_a244);
    }
  } catch (err) {
    _iterator125.e(err);
  } finally {
    _iterator125.f();
  }
  var i;
}
var ObjectLoader = /*#__PURE__*/function () {
  function ObjectLoader(e, t, i) {
    _classCallCheck(this, ObjectLoader);
    this.dict = e;
    this.keys = t;
    this.xref = i;
    this.refSet = null;
  }
  return _createClass(ObjectLoader, [{
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
        var e, t, i, _iterator126, _step126, _a245, _e463;
        return _regeneratorRuntime().wrap(function _callee44$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              if (!this.xref.stream.isDataLoaded) {
                _context46.next = 2;
                break;
              }
              return _context46.abrupt("return");
            case 2:
              e = this.keys, t = this.dict;
              this.refSet = new RefSet();
              i = [];
              _iterator126 = _createForOfIteratorHelper(e);
              try {
                for (_iterator126.s(); !(_step126 = _iterator126.n()).done;) {
                  _a245 = _step126.value;
                  _e463 = t.getRaw(_a245);
                  void 0 !== _e463 && i.push(_e463);
                }
              } catch (err) {
                _iterator126.e(err);
              } finally {
                _iterator126.f();
              }
              return _context46.abrupt("return", this._walk(i));
            case 8:
            case "end":
              return _context46.stop();
          }
        }, _callee44, this);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "_walk",
    value: function () {
      var _walk2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee45(e) {
        var t, i, _a246, _t331, _e464, _s170, _iterator127, _step127, _t332, _iterator128, _step128, _e465;
        return _regeneratorRuntime().wrap(function _callee45$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              t = [], i = [];
            case 1:
              if (!e.length) {
                _context47.next = 24;
                break;
              }
              _a246 = e.pop();
              if (!(_a246 instanceof Ref)) {
                _context47.next = 20;
                break;
              }
              if (!this.refSet.has(_a246)) {
                _context47.next = 6;
                break;
              }
              return _context47.abrupt("continue", 22);
            case 6:
              _context47.prev = 6;
              this.refSet.put(_a246);
              _a246 = this.xref.fetch(_a246);
              _context47.next = 20;
              break;
            case 11:
              _context47.prev = 11;
              _context47.t0 = _context47["catch"](6);
              if (_context47.t0 instanceof MissingDataException) {
                _context47.next = 18;
                break;
              }
              warn("ObjectLoader._walk - requesting all data: \"".concat(_context47.t0, "\"."));
              this.refSet = null;
              _t331 = this.xref.stream.manager;
              return _context47.abrupt("return", _t331.requestAllChunks());
            case 18:
              t.push(_a246);
              i.push({
                begin: _context47.t0.begin,
                end: _context47.t0.end
              });
            case 20:
              if (_a246 instanceof BaseStream) {
                _e464 = _a246.getBaseStreams();
                if (_e464) {
                  _s170 = !1;
                  _iterator127 = _createForOfIteratorHelper(_e464);
                  try {
                    for (_iterator127.s(); !(_step127 = _iterator127.n()).done;) {
                      _t332 = _step127.value;
                      if (!_t332.isDataLoaded) {
                        _s170 = !0;
                        i.push({
                          begin: _t332.start,
                          end: _t332.end
                        });
                      }
                    }
                  } catch (err) {
                    _iterator127.e(err);
                  } finally {
                    _iterator127.f();
                  }
                  _s170 && t.push(_a246);
                }
              }
              addChildren(_a246, e);
            case 22:
              _context47.next = 1;
              break;
            case 24:
              if (!i.length) {
                _context47.next = 30;
                break;
              }
              _context47.next = 27;
              return this.xref.stream.manager.requestRanges(i);
            case 27:
              _iterator128 = _createForOfIteratorHelper(t);
              try {
                for (_iterator128.s(); !(_step128 = _iterator128.n()).done;) {
                  _e465 = _step128.value;
                  _e465 instanceof Ref && this.refSet.remove(_e465);
                }
              } catch (err) {
                _iterator128.e(err);
              } finally {
                _iterator128.f();
              }
              return _context47.abrupt("return", this._walk(t));
            case 30:
              this.refSet = null;
            case 31:
            case "end":
              return _context47.stop();
          }
        }, _callee45, this, [[6, 11]]);
      }));
      function _walk(_x88) {
        return _walk2.apply(this, arguments);
      }
      return _walk;
    }()
  }]);
}();
var Zs = Symbol(),
  Vs = Symbol(),
  zs = Symbol(),
  _s = Symbol(),
  $s = Symbol(),
  Ar = Symbol(),
  er = Symbol(),
  tr = Symbol(),
  ir = Symbol(),
  ar = Symbol("content"),
  sr = Symbol("data"),
  rr = Symbol(),
  nr = Symbol("extra"),
  gr = Symbol(),
  or = Symbol(),
  Ir = Symbol(),
  cr = Symbol(),
  Cr = Symbol(),
  hr = Symbol(),
  lr = Symbol(),
  Qr = Symbol(),
  Er = Symbol(),
  ur = Symbol(),
  dr = Symbol(),
  fr = Symbol(),
  pr = Symbol(),
  mr = Symbol(),
  yr = Symbol(),
  wr = Symbol(),
  Dr = Symbol(),
  br = Symbol(),
  Fr = Symbol(),
  Sr = Symbol(),
  kr = Symbol(),
  Rr = Symbol(),
  Nr = Symbol(),
  Gr = Symbol(),
  xr = Symbol(),
  Ur = Symbol(),
  Mr = Symbol(),
  Lr = Symbol(),
  Hr = Symbol(),
  Jr = Symbol(),
  Yr = Symbol(),
  vr = Symbol(),
  Kr = Symbol("namespaceId"),
  Tr = Symbol("nodeName"),
  qr = Symbol(),
  Or = Symbol(),
  Pr = Symbol(),
  Wr = Symbol(),
  jr = Symbol(),
  Xr = Symbol(),
  Zr = Symbol(),
  Vr = Symbol(),
  zr = Symbol("root"),
  _r = Symbol(),
  $r = Symbol(),
  An = Symbol(),
  en = Symbol(),
  tn = Symbol(),
  an = Symbol(),
  sn = Symbol(),
  rn = Symbol(),
  nn = Symbol(),
  gn = Symbol(),
  on = Symbol(),
  In = Symbol("uid"),
  cn = Symbol(),
  Cn = {
    config: {
      id: 0,
      check: function check(e) {
        return e.startsWith("http://www.xfa.org/schema/xci/");
      }
    },
    connectionSet: {
      id: 1,
      check: function check(e) {
        return e.startsWith("http://www.xfa.org/schema/xfa-connection-set/");
      }
    },
    datasets: {
      id: 2,
      check: function check(e) {
        return e.startsWith("http://www.xfa.org/schema/xfa-data/");
      }
    },
    form: {
      id: 3,
      check: function check(e) {
        return e.startsWith("http://www.xfa.org/schema/xfa-form/");
      }
    },
    localeSet: {
      id: 4,
      check: function check(e) {
        return e.startsWith("http://www.xfa.org/schema/xfa-locale-set/");
      }
    },
    pdf: {
      id: 5,
      check: function check(e) {
        return "http://ns.adobe.com/xdp/pdf/" === e;
      }
    },
    signature: {
      id: 6,
      check: function check(e) {
        return "http://www.w3.org/2000/09/xmldsig#" === e;
      }
    },
    sourceSet: {
      id: 7,
      check: function check(e) {
        return e.startsWith("http://www.xfa.org/schema/xfa-source-set/");
      }
    },
    stylesheet: {
      id: 8,
      check: function check(e) {
        return "http://www.w3.org/1999/XSL/Transform" === e;
      }
    },
    template: {
      id: 9,
      check: function check(e) {
        return e.startsWith("http://www.xfa.org/schema/xfa-template/");
      }
    },
    xdc: {
      id: 10,
      check: function check(e) {
        return e.startsWith("http://www.xfa.org/schema/xdc/");
      }
    },
    xdp: {
      id: 11,
      check: function check(e) {
        return "http://ns.adobe.com/xdp/" === e;
      }
    },
    xfdf: {
      id: 12,
      check: function check(e) {
        return "http://ns.adobe.com/xfdf/" === e;
      }
    },
    xhtml: {
      id: 13,
      check: function check(e) {
        return "http://www.w3.org/1999/xhtml" === e;
      }
    },
    xmpmeta: {
      id: 14,
      check: function check(e) {
        return "http://ns.adobe.com/xmpmeta/" === e;
      }
    }
  },
  hn = {
    pt: function pt(e) {
      return e;
    },
    cm: function cm(e) {
      return e / 2.54 * 72;
    },
    mm: function mm(e) {
      return e / 25.4 * 72;
    },
    in: function _in(e) {
      return 72 * e;
    },
    px: function px(e) {
      return e;
    }
  },
  ln = /([+-]?\d+\.?\d*)(.*)/;
function stripQuotes(e) {
  return e.startsWith("'") || e.startsWith('"') ? e.slice(1, -1) : e;
}
function getInteger(_ref129) {
  var e = _ref129.data,
    t = _ref129.defaultValue,
    i = _ref129.validate;
  if (!e) return t;
  e = e.trim();
  var a = parseInt(e, 10);
  return !isNaN(a) && i(a) ? a : t;
}
function getFloat(_ref130) {
  var e = _ref130.data,
    t = _ref130.defaultValue,
    i = _ref130.validate;
  if (!e) return t;
  e = e.trim();
  var a = parseFloat(e);
  return !isNaN(a) && i(a) ? a : t;
}
function getKeyword(_ref131) {
  var e = _ref131.data,
    t = _ref131.defaultValue,
    i = _ref131.validate;
  return e && i(e = e.trim()) ? e : t;
}
function getStringOption(e, t) {
  return getKeyword({
    data: e,
    defaultValue: t[0],
    validate: function validate(e) {
      return t.includes(e);
    }
  });
}
function getMeasurement(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "0";
  t || (t = "0");
  if (!e) return getMeasurement(t);
  var i = e.trim().match(ln);
  if (!i) return getMeasurement(t);
  var _i294 = _slicedToArray(i, 3),
    a = _i294[1],
    s = _i294[2],
    r = parseFloat(a);
  if (isNaN(r)) return getMeasurement(t);
  if (0 === r) return 0;
  var n = hn[s];
  return n ? n(r) : r;
}
function getRatio(e) {
  if (!e) return {
    num: 1,
    den: 1
  };
  var t = e.trim().split(/\s*:\s*/).map(function (e) {
    return parseFloat(e);
  }).filter(function (e) {
    return !isNaN(e);
  });
  1 === t.length && t.push(1);
  if (0 === t.length) return {
    num: 1,
    den: 1
  };
  var _t333 = _slicedToArray(t, 2),
    i = _t333[0],
    a = _t333[1];
  return {
    num: i,
    den: a
  };
}
function getRelevant(e) {
  return e ? e.trim().split(/\s+/).map(function (e) {
    return {
      excluded: "-" === e[0],
      viewname: e.substring(1)
    };
  }) : [];
}
var HTMLResult = /*#__PURE__*/function () {
  function HTMLResult(e, t, i, a) {
    _classCallCheck(this, HTMLResult);
    this.success = e;
    this.html = t;
    this.bbox = i;
    this.breakNode = a;
  }
  return _createClass(HTMLResult, [{
    key: "isBreak",
    value: function isBreak() {
      return !!this.breakNode;
    }
  }], [{
    key: "FAILURE",
    get: function get() {
      return shadow(this, "FAILURE", new HTMLResult(!1, null, null, null));
    }
  }, {
    key: "EMPTY",
    get: function get() {
      return shadow(this, "EMPTY", new HTMLResult(!0, null, null, null));
    }
  }, {
    key: "breakNode",
    value: function breakNode(e) {
      return new HTMLResult(!1, null, null, e);
    }
  }, {
    key: "success",
    value: function success(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return new HTMLResult(!0, e, t, null);
    }
  }]);
}();
var FontFinder = /*#__PURE__*/function () {
  function FontFinder(e) {
    _classCallCheck(this, FontFinder);
    this.fonts = new Map();
    this.cache = new Map();
    this.warned = new Set();
    this.defaultFont = null;
    this.add(e);
  }
  return _createClass(FontFinder, [{
    key: "add",
    value: function add(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var _iterator129 = _createForOfIteratorHelper(e),
        _step129;
      try {
        for (_iterator129.s(); !(_step129 = _iterator129.n()).done;) {
          var _t334 = _step129.value;
          this.addPdfFont(_t334);
        }
      } catch (err) {
        _iterator129.e(err);
      } finally {
        _iterator129.f();
      }
      var _iterator130 = _createForOfIteratorHelper(this.fonts.values()),
        _step130;
      try {
        for (_iterator130.s(); !(_step130 = _iterator130.n()).done;) {
          var _e466 = _step130.value;
          _e466.regular || (_e466.regular = _e466.italic || _e466.bold || _e466.bolditalic);
        }
      } catch (err) {
        _iterator130.e(err);
      } finally {
        _iterator130.f();
      }
      if (!t || 0 === t.size) return;
      var i = this.fonts.get("PdfJS-Fallback-PdfJS-XFA");
      var _iterator131 = _createForOfIteratorHelper(t),
        _step131;
      try {
        for (_iterator131.s(); !(_step131 = _iterator131.n()).done;) {
          var _e467 = _step131.value;
          this.fonts.set(_e467, i);
        }
      } catch (err) {
        _iterator131.e(err);
      } finally {
        _iterator131.f();
      }
    }
  }, {
    key: "addPdfFont",
    value: function addPdfFont(e) {
      var t = e.cssFontInfo,
        i = t.fontFamily;
      var a = this.fonts.get(i);
      if (!a) {
        a = Object.create(null);
        this.fonts.set(i, a);
        this.defaultFont || (this.defaultFont = a);
      }
      var s = "";
      var r = parseFloat(t.fontWeight);
      0 !== parseFloat(t.italicAngle) ? s = r >= 700 ? "bolditalic" : "italic" : r >= 700 && (s = "bold");
      if (!s) {
        var _e$psName, _e$psName2, _e$psName3;
        (e.name.includes("Bold") || ((_e$psName = e.psName) === null || _e$psName === void 0 ? void 0 : _e$psName.includes("Bold"))) && (s = "bold");
        (e.name.includes("Italic") || e.name.endsWith("It") || ((_e$psName2 = e.psName) === null || _e$psName2 === void 0 ? void 0 : _e$psName2.includes("Italic")) || ((_e$psName3 = e.psName) === null || _e$psName3 === void 0 ? void 0 : _e$psName3.endsWith("It"))) && (s += "italic");
      }
      s || (s = "regular");
      a[s] = e;
    }
  }, {
    key: "getDefault",
    value: function getDefault() {
      return this.defaultFont;
    }
  }, {
    key: "find",
    value: function find(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var i = this.fonts.get(e) || this.cache.get(e);
      if (i) return i;
      var a = /,|-|_| |bolditalic|bold|italic|regular|it/gi;
      var s = e.replaceAll(a, "");
      i = this.fonts.get(s);
      if (i) {
        this.cache.set(e, i);
        return i;
      }
      s = s.toLowerCase();
      var r = [];
      var _iterator132 = _createForOfIteratorHelper(this.fonts.entries()),
        _step132;
      try {
        for (_iterator132.s(); !(_step132 = _iterator132.n()).done;) {
          var _ref132 = _step132.value;
          var _ref133 = _slicedToArray(_ref132, 2);
          var _e471 = _ref133[0];
          var _t336 = _ref133[1];
          _e471.replaceAll(a, "").toLowerCase().startsWith(s) && r.push(_t336);
        }
      } catch (err) {
        _iterator132.e(err);
      } finally {
        _iterator132.f();
      }
      if (0 === r.length) {
        var _iterator133 = _createForOfIteratorHelper(this.fonts.entries()),
          _step133;
        try {
          for (_iterator133.s(); !(_step133 = _iterator133.n()).done;) {
            var _e468$regular$name;
            var _ref134 = _step133.value;
            var _ref135 = _slicedToArray(_ref134, 2);
            var _e468 = _ref135[1];
            ((_e468$regular$name = _e468.regular.name) === null || _e468$regular$name === void 0 ? void 0 : _e468$regular$name.replaceAll(a, "").toLowerCase().startsWith(s)) && r.push(_e468);
          }
        } catch (err) {
          _iterator133.e(err);
        } finally {
          _iterator133.f();
        }
      }
      if (0 === r.length) {
        s = s.replaceAll(/psmt|mt/gi, "");
        var _iterator134 = _createForOfIteratorHelper(this.fonts.entries()),
          _step134;
        try {
          for (_iterator134.s(); !(_step134 = _iterator134.n()).done;) {
            var _ref136 = _step134.value;
            var _ref137 = _slicedToArray(_ref136, 2);
            var _e469 = _ref137[0];
            var _t335 = _ref137[1];
            _e469.replaceAll(a, "").toLowerCase().startsWith(s) && r.push(_t335);
          }
        } catch (err) {
          _iterator134.e(err);
        } finally {
          _iterator134.f();
        }
      }
      if (0 === r.length) {
        var _iterator135 = _createForOfIteratorHelper(this.fonts.values()),
          _step135;
        try {
          for (_iterator135.s(); !(_step135 = _iterator135.n()).done;) {
            var _e470$regular$name;
            var _e470 = _step135.value;
            ((_e470$regular$name = _e470.regular.name) === null || _e470$regular$name === void 0 ? void 0 : _e470$regular$name.replaceAll(a, "").toLowerCase().startsWith(s)) && r.push(_e470);
          }
        } catch (err) {
          _iterator135.e(err);
        } finally {
          _iterator135.f();
        }
      }
      if (r.length >= 1) {
        1 !== r.length && t && warn("XFA - Too many choices to guess the correct font: ".concat(e));
        this.cache.set(e, r[0]);
        return r[0];
      }
      if (t && !this.warned.has(e)) {
        this.warned.add(e);
        warn("XFA - Cannot find the font: ".concat(e));
      }
      return null;
    }
  }]);
}();
function selectFont(e, t) {
  return "italic" === e.posture ? "bold" === e.weight ? t.bolditalic : t.italic : "bold" === e.weight ? t.bold : t.regular;
}
var FontInfo = /*#__PURE__*/function () {
  function FontInfo(e, t, i, a) {
    _classCallCheck(this, FontInfo);
    this.lineHeight = i;
    this.paraMargin = t || {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
    if (!e) {
      var _this$defaultFont = this.defaultFont(a);
      var _this$defaultFont2 = _slicedToArray(_this$defaultFont, 2);
      this.pdfFont = _this$defaultFont2[0];
      this.xfaFont = _this$defaultFont2[1];
      return;
    }
    this.xfaFont = {
      typeface: e.typeface,
      posture: e.posture,
      weight: e.weight,
      size: e.size,
      letterSpacing: e.letterSpacing
    };
    var s = a.find(e.typeface);
    if (s) {
      var _this$defaultFont3, _this$defaultFont4;
      this.pdfFont = selectFont(e, s);
      this.pdfFont || (_this$defaultFont3 = this.defaultFont(a), _this$defaultFont4 = _slicedToArray(_this$defaultFont3, 2), this.pdfFont = _this$defaultFont4[0], this.xfaFont = _this$defaultFont4[1], _this$defaultFont3);
    } else {
      var _this$defaultFont5 = this.defaultFont(a);
      var _this$defaultFont6 = _slicedToArray(_this$defaultFont5, 2);
      this.pdfFont = _this$defaultFont6[0];
      this.xfaFont = _this$defaultFont6[1];
    }
  }
  return _createClass(FontInfo, [{
    key: "defaultFont",
    value: function defaultFont(e) {
      var t = e.find("Helvetica", !1) || e.find("Myriad Pro", !1) || e.find("Arial", !1) || e.getDefault();
      if (t !== null && t !== void 0 && t.regular) {
        var _e472 = t.regular;
        return [_e472, {
          typeface: _e472.cssFontInfo.fontFamily,
          posture: "normal",
          weight: "normal",
          size: 10,
          letterSpacing: 0
        }];
      }
      return [null, {
        typeface: "Courier",
        posture: "normal",
        weight: "normal",
        size: 10,
        letterSpacing: 0
      }];
    }
  }]);
}();
var FontSelector = /*#__PURE__*/function () {
  function FontSelector(e, t, i, a) {
    _classCallCheck(this, FontSelector);
    this.fontFinder = a;
    this.stack = [new FontInfo(e, t, i, a)];
  }
  return _createClass(FontSelector, [{
    key: "pushData",
    value: function pushData(e, t, i) {
      var a = this.stack.at(-1);
      for (var _i295 = 0, _arr = ["typeface", "posture", "weight", "size", "letterSpacing"]; _i295 < _arr.length; _i295++) {
        var _t337 = _arr[_i295];
        e[_t337] || (e[_t337] = a.xfaFont[_t337]);
      }
      for (var _i296 = 0, _arr2 = ["top", "bottom", "left", "right"]; _i296 < _arr2.length; _i296++) {
        var _e473 = _arr2[_i296];
        isNaN(t[_e473]) && (t[_e473] = a.paraMargin[_e473]);
      }
      var s = new FontInfo(e, t, i || a.lineHeight, this.fontFinder);
      s.pdfFont || (s.pdfFont = a.pdfFont);
      this.stack.push(s);
    }
  }, {
    key: "popFont",
    value: function popFont() {
      this.stack.pop();
    }
  }, {
    key: "topFont",
    value: function topFont() {
      return this.stack.at(-1);
    }
  }]);
}();
var TextMeasure = /*#__PURE__*/function () {
  function TextMeasure(e, t, i, a) {
    _classCallCheck(this, TextMeasure);
    this.glyphs = [];
    this.fontSelector = new FontSelector(e, t, i, a);
    this.extraHeight = 0;
  }
  return _createClass(TextMeasure, [{
    key: "pushData",
    value: function pushData(e, t, i) {
      this.fontSelector.pushData(e, t, i);
    }
  }, {
    key: "popFont",
    value: function popFont(e) {
      return this.fontSelector.popFont();
    }
  }, {
    key: "addPara",
    value: function addPara() {
      var e = this.fontSelector.topFont();
      this.extraHeight += e.paraMargin.top + e.paraMargin.bottom;
    }
  }, {
    key: "addString",
    value: function addString(e) {
      if (!e) return;
      var t = this.fontSelector.topFont(),
        i = t.xfaFont.size;
      if (t.pdfFont) {
        var _a247 = t.xfaFont.letterSpacing,
          _s171 = t.pdfFont,
          _r125 = _s171.lineHeight || 1.2,
          _n89 = t.lineHeight || Math.max(1.2, _r125) * i,
          _g57 = _r125 - (void 0 === _s171.lineGap ? .2 : _s171.lineGap),
          _o41 = Math.max(1, _g57) * i,
          c = i / 1e3,
          C = _s171.defaultWidth || _s171.charsToGlyphs(" ")[0].width;
        var _iterator136 = _createForOfIteratorHelper(e.split(/[\u2029\n]/)),
          _step136;
        try {
          for (_iterator136.s(); !(_step136 = _iterator136.n()).done;) {
            var _t338 = _step136.value;
            var _e474 = _s171.encodeString(_t338).join(""),
              _i297 = _s171.charsToGlyphs(_e474);
            var _iterator137 = _createForOfIteratorHelper(_i297),
              _step137;
            try {
              for (_iterator137.s(); !(_step137 = _iterator137.n()).done;) {
                var _e475 = _step137.value;
                var _t339 = _e475.width || C;
                this.glyphs.push([_t339 * c + _a247, _n89, _o41, _e475.unicode, !1]);
              }
            } catch (err) {
              _iterator137.e(err);
            } finally {
              _iterator137.f();
            }
            this.glyphs.push([0, 0, 0, "\n", !0]);
          }
        } catch (err) {
          _iterator136.e(err);
        } finally {
          _iterator136.f();
        }
        this.glyphs.pop();
      } else {
        var _iterator138 = _createForOfIteratorHelper(e.split(/[\u2029\n]/)),
          _step138;
        try {
          for (_iterator138.s(); !(_step138 = _iterator138.n()).done;) {
            var _t340 = _step138.value;
            var _iterator139 = _createForOfIteratorHelper(_t340.split("")),
              _step139;
            try {
              for (_iterator139.s(); !(_step139 = _iterator139.n()).done;) {
                var _e476 = _step139.value;
                this.glyphs.push([i, 1.2 * i, i, _e476, !1]);
              }
            } catch (err) {
              _iterator139.e(err);
            } finally {
              _iterator139.f();
            }
            this.glyphs.push([0, 0, 0, "\n", !0]);
          }
        } catch (err) {
          _iterator138.e(err);
        } finally {
          _iterator138.f();
        }
        this.glyphs.pop();
      }
    }
  }, {
    key: "compute",
    value: function compute(e) {
      var t = -1,
        i = 0,
        a = 0,
        s = 0,
        r = 0,
        n = 0,
        g = !1,
        o = !0;
      for (var c = 0, C = this.glyphs.length; c < C; c++) {
        var _this$glyphs$c = _slicedToArray(this.glyphs[c], 5),
          _C21 = _this$glyphs$c[0],
          h = _this$glyphs$c[1],
          l = _this$glyphs$c[2],
          Q = _this$glyphs$c[3],
          E = _this$glyphs$c[4],
          u = " " === Q,
          d = o ? l : h;
        if (E) {
          a = Math.max(a, r);
          r = 0;
          s += n;
          n = d;
          t = -1;
          i = 0;
          o = !1;
        } else if (u) {
          if (r + _C21 > e) {
            a = Math.max(a, r);
            r = 0;
            s += n;
            n = d;
            t = -1;
            i = 0;
            g = !0;
            o = !1;
          } else {
            n = Math.max(d, n);
            i = r;
            r += _C21;
            t = c;
          }
        } else if (r + _C21 > e) {
          s += n;
          n = d;
          if (-1 !== t) {
            c = t;
            a = Math.max(a, i);
            r = 0;
            t = -1;
            i = 0;
          } else {
            a = Math.max(a, r);
            r = _C21;
          }
          g = !0;
          o = !1;
        } else {
          r += _C21;
          n = Math.max(d, n);
        }
      }
      a = Math.max(a, r);
      s += n + this.extraHeight;
      return {
        width: 1.02 * a,
        height: s,
        isBroken: g
      };
    }
  }]);
}();
var Bn = /^[^.[]+/,
  Qn = /^[^\]]+/,
  En = {
    dot: 0,
    dotDot: 1,
    dotHash: 2,
    dotBracket: 3,
    dotParen: 4
  },
  un = new Map([["$data", function (e, t) {
    return e.datasets ? e.datasets.data : e;
  }], ["$record", function (e, t) {
    return (e.datasets ? e.datasets.data : e)[fr]()[0];
  }], ["$template", function (e, t) {
    return e.template;
  }], ["$connectionSet", function (e, t) {
    return e.connectionSet;
  }], ["$form", function (e, t) {
    return e.form;
  }], ["$layout", function (e, t) {
    return e.layout;
  }], ["$host", function (e, t) {
    return e.host;
  }], ["$dataWindow", function (e, t) {
    return e.dataWindow;
  }], ["$event", function (e, t) {
    return e.event;
  }], ["!", function (e, t) {
    return e.datasets;
  }], ["$xfa", function (e, t) {
    return e;
  }], ["xfa", function (e, t) {
    return e;
  }], ["$", function (e, t) {
    return t;
  }]]),
  dn = new WeakMap();
function parseExpression(e, t) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
  var a = e.match(Bn);
  if (!a) return null;
  var _a248 = a,
    _a249 = _slicedToArray(_a248, 1),
    s = _a249[0];
  var r = [{
    name: s,
    cacheName: "." + s,
    index: 0,
    js: null,
    formCalc: null,
    operator: En.dot
  }];
  var n = s.length;
  for (; n < e.length;) {
    var _o42 = n;
    if ("[" === e.charAt(n++)) {
      a = e.slice(n).match(Qn);
      if (!a) {
        warn("XFA - Invalid index in SOM expression");
        return null;
      }
      r.at(-1).index = "*" === (g = (g = a[0]).trim()) ? 1 / 0 : parseInt(g, 10) || 0;
      n += a[0].length + 1;
      continue;
    }
    var c = void 0;
    switch (e.charAt(n)) {
      case ".":
        if (!t) return null;
        n++;
        c = En.dotDot;
        break;
      case "#":
        n++;
        c = En.dotHash;
        break;
      case "[":
        if (i) {
          warn("XFA - SOM expression contains a FormCalc subexpression which is not supported for now.");
          return null;
        }
        c = En.dotBracket;
        break;
      case "(":
        if (i) {
          warn("XFA - SOM expression contains a JavaScript subexpression which is not supported for now.");
          return null;
        }
        c = En.dotParen;
        break;
      default:
        c = En.dot;
    }
    a = e.slice(n).match(Bn);
    if (!a) break;
    var _a250 = a;
    var _a251 = _slicedToArray(_a250, 1);
    s = _a251[0];
    n += s.length;
    r.push({
      name: s,
      cacheName: e.slice(_o42, n),
      operator: c,
      index: 0,
      js: null,
      formCalc: null
    });
  }
  var g;
  return r;
}
function searchNode(e, t, i) {
  var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
  var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
  var r = parseExpression(i, a);
  if (!r) return null;
  var n = un.get(r[0].name);
  var g,
    o = 0;
  if (n) {
    g = !0;
    e = [n(e, t)];
    o = 1;
  } else {
    g = null === t;
    e = [t || e];
  }
  var _loop3 = function _loop3() {
      var _r$o = r[o],
        i = _r$o.name,
        a = _r$o.cacheName,
        n = _r$o.operator,
        c = _r$o.index,
        C = [];
      var _iterator140 = _createForOfIteratorHelper(e),
        _step140;
      try {
        for (_iterator140.s(); !(_step140 = _iterator140.n()).done;) {
          var _t341 = _step140.value;
          if (!_t341.isXFAObject) continue;
          var _e477 = void 0,
            _r126 = void 0;
          if (s) {
            _r126 = dn.get(_t341);
            if (!_r126) {
              _r126 = new Map();
              dn.set(_t341, _r126);
            }
            _e477 = _r126.get(a);
          }
          if (!_e477) {
            switch (n) {
              case En.dot:
                _e477 = _t341[lr](i, !1);
                break;
              case En.dotDot:
                _e477 = _t341[lr](i, !0);
                break;
              case En.dotHash:
                _e477 = _t341[hr](i);
                _e477 = _e477.isXFAObjectArray ? _e477.children : [_e477];
            }
            s && _r126.set(a, _e477);
          }
          _e477.length > 0 && C.push(_e477);
        }
      } catch (err) {
        _iterator140.e(err);
      } finally {
        _iterator140.f();
      }
      if (0 !== C.length || g || 0 !== o) e = isFinite(c) ? C.filter(function (e) {
        return c < e.length;
      }).map(function (e) {
        return e[c];
      }) : C.flat();else {
        var _i299 = t[wr]();
        if (!(t = _i299)) return {
          v: null
        };
        o = -1;
        e = [t];
      }
    },
    _ret;
  for (var _i298 = r.length; o < _i298; o++) {
    _ret = _loop3();
    if (_ret) return _ret.v;
  }
  return 0 === e.length ? null : e;
}
function createDataNode(e, t, i) {
  var a = parseExpression(i);
  if (!a) return null;
  if (a.some(function (e) {
    return e.operator === En.dotDot;
  })) return null;
  var s = un.get(a[0].name);
  var r = 0;
  if (s) {
    e = s(e, t);
    r = 1;
  } else e = t || e;
  for (var _t342 = a.length; r < _t342; r++) {
    var _a$r = a[r],
      _t343 = _a$r.name,
      _i300 = _a$r.operator,
      _s172 = _a$r.index;
    if (!isFinite(_s172)) {
      a[r].index = 0;
      return e.createNodes(a.slice(r));
    }
    var _n90 = void 0;
    switch (_i300) {
      case En.dot:
        _n90 = e[lr](_t343, !1);
        break;
      case En.dotDot:
        _n90 = e[lr](_t343, !0);
        break;
      case En.dotHash:
        _n90 = e[hr](_t343);
        _n90 = _n90.isXFAObjectArray ? _n90.children : [_n90];
    }
    if (0 === _n90.length) return e.createNodes(a.slice(r));
    if (!(_s172 < _n90.length)) {
      a[r].index = _s172 - _n90.length;
      return e.createNodes(a.slice(r));
    }
    {
      var _t344 = _n90[_s172];
      if (!_t344.isXFAObject) {
        warn("XFA - Cannot create a node.");
        return null;
      }
      e = _t344;
    }
  }
  return null;
}
var fn = Symbol(),
  pn = Symbol(),
  mn = Symbol(),
  yn = Symbol("_children"),
  wn = Symbol(),
  Dn = Symbol(),
  bn = Symbol(),
  Fn = Symbol(),
  Sn = Symbol(),
  kn = Symbol(),
  Rn = Symbol(),
  Nn = Symbol(),
  Gn = Symbol(),
  xn = Symbol("parent"),
  Un = Symbol(),
  Mn = Symbol(),
  Ln = Symbol();
var Hn = 0;
var Jn = Cn.datasets.id;
var XFAObject = /*#__PURE__*/function () {
  function XFAObject(e, t) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    _classCallCheck(this, XFAObject);
    this[Kr] = e;
    this[Tr] = t;
    this[Rn] = i;
    this[xn] = null;
    this[yn] = [];
    this[In] = "".concat(t).concat(Hn++);
    this[br] = null;
  }
  return _createClass(XFAObject, [{
    key: "isXFAObject",
    get: function get() {
      return !0;
    }
  }, {
    key: "isXFAObjectArray",
    get: function get() {
      return !1;
    }
  }, {
    key: "createNodes",
    value: function createNodes(e) {
      var t = this,
        i = null;
      var _iterator141 = _createForOfIteratorHelper(e),
        _step141;
      try {
        for (_iterator141.s(); !(_step141 = _iterator141.n()).done;) {
          var _ref138 = _step141.value;
          var _a252 = _ref138.name;
          var _s173 = _ref138.index;
          for (var _e478 = 0, _r127 = isFinite(_s173) ? _s173 : 0; _e478 <= _r127; _e478++) {
            var _e479 = t[Kr] === Jn ? -1 : t[Kr];
            i = new XmlObject(_e479, _a252);
            t[zs](i);
          }
          t = i;
        }
      } catch (err) {
        _iterator141.e(err);
      } finally {
        _iterator141.f();
      }
      return i;
    }
  }, {
    key: Or,
    value: function value(e) {
      if (!this[Rn] || !this[Pr](e)) return !1;
      var t = e[Tr],
        i = this[t];
      if (!(i instanceof XFAObjectArray)) {
        null !== i && this[Vr](i);
        this[t] = e;
        this[zs](e);
        return !0;
      }
      if (i.push(e)) {
        this[zs](e);
        return !0;
      }
      var a = "";
      this.id ? a = " (id: ".concat(this.id, ")") : this.name && (a = " (name: ".concat(this.name, " ").concat(this.h.value, ")"));
      warn("XFA - node \"".concat(this[Tr], "\"").concat(a, " has already enough \"").concat(t, "\"!"));
      return !1;
    }
  }, {
    key: Pr,
    value: function value(e) {
      return this.hasOwnProperty(e[Tr]) && e[Kr] === this[Kr];
    }
  }, {
    key: Mr,
    value: function value() {
      return !1;
    }
  }, {
    key: Zs,
    value: function value() {
      return !1;
    }
  }, {
    key: Nr,
    value: function value() {
      return !1;
    }
  }, {
    key: Gr,
    value: function value() {
      return !1;
    }
  }, {
    key: Xr,
    value: function value() {
      this.para && this[Dr]()[nr].paraStack.pop();
    }
  }, {
    key: Zr,
    value: function value() {
      this[Dr]()[nr].paraStack.push(this.para);
    }
  }, {
    key: An,
    value: function value(e) {
      this.id && this[Kr] === Cn.template.id && e.set(this.id, this);
    }
  }, {
    key: Dr,
    value: function value() {
      return this[br].template;
    }
  }, {
    key: Lr,
    value: function value() {
      return !1;
    }
  }, {
    key: Hr,
    value: function value() {
      return !1;
    }
  }, {
    key: zs,
    value: function value(e) {
      e[xn] = this;
      this[yn].push(e);
      !e[br] && this[br] && (e[br] = this[br]);
    }
  }, {
    key: Vr,
    value: function value(e) {
      var t = this[yn].indexOf(e);
      this[yn].splice(t, 1);
    }
  }, {
    key: Fr,
    value: function value() {
      return this.hasOwnProperty("value");
    }
  }, {
    key: tn,
    value: function value(e) {}
  }, {
    key: Wr,
    value: function value(e) {}
  }, {
    key: gr,
    value: function value() {}
  }, {
    key: $s,
    value: function value(e) {
      delete this[Rn];
      if (this[er]) {
        e.clean(this[er]);
        delete this[er];
      }
    }
  }, {
    key: kr,
    value: function value(e) {
      return this[yn].indexOf(e);
    }
  }, {
    key: Rr,
    value: function value(e, t) {
      t[xn] = this;
      this[yn].splice(e, 0, t);
      !t[br] && this[br] && (t[br] = this[br]);
    }
  }, {
    key: Jr,
    value: function value() {
      return !this.name;
    }
  }, {
    key: vr,
    value: function value() {
      return "";
    }
  }, {
    key: sn,
    value: function value() {
      return 0 === this[yn].length ? this[ar] : this[yn].map(function (e) {
        return e[sn]();
      }).join("");
    }
  }, {
    key: mn,
    get: function get() {
      var e = Object.getPrototypeOf(this);
      if (!e._attributes) {
        var _t345 = e._attributes = new Set();
        var _iterator142 = _createForOfIteratorHelper(Object.getOwnPropertyNames(this)),
          _step142;
        try {
          for (_iterator142.s(); !(_step142 = _iterator142.n()).done;) {
            var _e480 = _step142.value;
            if (null === this[_e480] || this[_e480] instanceof XFAObject || this[_e480] instanceof XFAObjectArray) break;
            _t345.add(_e480);
          }
        } catch (err) {
          _iterator142.e(err);
        } finally {
          _iterator142.f();
        }
      }
      return shadow(this, mn, e._attributes);
    }
  }, {
    key: Ur,
    value: function value(e) {
      var t = this;
      for (; t;) {
        if (t === e) return !0;
        t = t[wr]();
      }
      return !1;
    }
  }, {
    key: wr,
    value: function value() {
      return this[xn];
    }
  }, {
    key: yr,
    value: function value() {
      return this[wr]();
    }
  }, {
    key: fr,
    value: function value() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return e ? this[e] : this[yn];
    }
  }, {
    key: rr,
    value: function value() {
      var e = Object.create(null);
      this[ar] && (e.$content = this[ar]);
      var _iterator143 = _createForOfIteratorHelper(Object.getOwnPropertyNames(this)),
        _step143;
      try {
        for (_iterator143.s(); !(_step143 = _iterator143.n()).done;) {
          var _t346 = _step143.value;
          var _i301 = this[_t346];
          null !== _i301 && (_i301 instanceof XFAObject ? e[_t346] = _i301[rr]() : _i301 instanceof XFAObjectArray ? _i301.isEmpty() || (e[_t346] = _i301.dump()) : e[_t346] = _i301);
        }
      } catch (err) {
        _iterator143.e(err);
      } finally {
        _iterator143.f();
      }
      return e;
    }
  }, {
    key: on,
    value: function value() {
      return null;
    }
  }, {
    key: nn,
    value: function value() {
      return HTMLResult.EMPTY;
    }
  }, {
    key: pr,
    value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
      var _iterator144, _step144, _e481;
      return _regeneratorRuntime().wrap(function value$(_context48) {
        while (1) switch (_context48.prev = _context48.next) {
          case 0:
            _iterator144 = _createForOfIteratorHelper(this[fr]());
            _context48.prev = 1;
            _iterator144.s();
          case 3:
            if ((_step144 = _iterator144.n()).done) {
              _context48.next = 9;
              break;
            }
            _e481 = _step144.value;
            _context48.next = 7;
            return _e481;
          case 7:
            _context48.next = 3;
            break;
          case 9:
            _context48.next = 14;
            break;
          case 11:
            _context48.prev = 11;
            _context48.t0 = _context48["catch"](1);
            _iterator144.e(_context48.t0);
          case 14:
            _context48.prev = 14;
            _iterator144.f();
            return _context48.finish(14);
          case 17:
          case "end":
            return _context48.stop();
        }
      }, value, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: Fn,
    value: /*#__PURE__*/_regeneratorRuntime().mark(function value(e, t) {
      var _iterator145, _step145, _i302, _e482, _t347;
      return _regeneratorRuntime().wrap(function value$(_context49) {
        while (1) switch (_context49.prev = _context49.next) {
          case 0:
            _iterator145 = _createForOfIteratorHelper(this[pr]());
            _context49.prev = 1;
            _iterator145.s();
          case 3:
            if ((_step145 = _iterator145.n()).done) {
              _context49.next = 12;
              break;
            }
            _i302 = _step145.value;
            if (!(!e || t === e.has(_i302[Tr]))) {
              _context49.next = 10;
              break;
            }
            _e482 = this[Cr](), _t347 = _i302[nn](_e482);
            _t347.success || (this[nr].failingNode = _i302);
            _context49.next = 10;
            return _t347;
          case 10:
            _context49.next = 3;
            break;
          case 12:
            _context49.next = 17;
            break;
          case 14:
            _context49.prev = 14;
            _context49.t0 = _context49["catch"](1);
            _iterator145.e(_context49.t0);
          case 17:
            _context49.prev = 17;
            _iterator145.f();
            return _context49.finish(17);
          case 20:
          case "end":
            return _context49.stop();
        }
      }, value, this, [[1, 14, 17, 20]]);
    })
  }, {
    key: or,
    value: function value() {
      return null;
    }
  }, {
    key: Vs,
    value: function value(e, t) {
      this[nr].children.push(e);
    }
  }, {
    key: Cr,
    value: function value() {}
  }, {
    key: _s,
    value: function value(_ref139) {
      var _ref139$filter = _ref139.filter,
        e = _ref139$filter === void 0 ? null : _ref139$filter,
        _ref139$include = _ref139.include,
        t = _ref139$include === void 0 ? !0 : _ref139$include;
      if (this[nr].generator) {
        var _e483 = this[Cr](),
          _t348 = this[nr].failingNode[nn](_e483);
        if (!_t348.success) return _t348;
        _t348.html && this[Vs](_t348.html, _t348.bbox);
        delete this[nr].failingNode;
      } else this[nr].generator = this[Fn](e, t);
      for (;;) {
        var _e484 = this[nr].generator.next();
        if (_e484.done) break;
        var _t349 = _e484.value;
        if (!_t349.success) return _t349;
        _t349.html && this[Vs](_t349.html, _t349.bbox);
      }
      this[nr].generator = null;
      return HTMLResult.EMPTY;
    }
  }, {
    key: en,
    value: function value(e) {
      this[Mn] = new Set(Object.keys(e));
    }
  }, {
    key: kn,
    value: function value(e) {
      var t = this[mn],
        i = this[Mn];
      return _toConsumableArray(e).filter(function (e) {
        return t.has(e) && !i.has(e);
      });
    }
  }, {
    key: _r,
    value: function value(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
      var _iterator146 = _createForOfIteratorHelper(this[yn]),
        _step146;
      try {
        for (_iterator146.s(); !(_step146 = _iterator146.n()).done;) {
          var _i303 = _step146.value;
          _i303[Un](e, t);
        }
      } catch (err) {
        _iterator146.e(err);
      } finally {
        _iterator146.f();
      }
    }
  }, {
    key: Un,
    value: function value(e, t) {
      var i = this[Sn](e, t);
      i ? this[fn](i, e, t) : this[_r](e, t);
    }
  }, {
    key: Sn,
    value: function value(e, t) {
      var i = this.use,
        a = this.usehref;
      if (!i && !a) return null;
      var s = null,
        r = null,
        n = null,
        g = i;
      if (a) {
        g = a;
        a.startsWith("#som(") && a.endsWith(")") ? r = a.slice(5, -1) : a.startsWith(".#som(") && a.endsWith(")") ? r = a.slice(6, -1) : a.startsWith("#") ? n = a.slice(1) : a.startsWith(".#") && (n = a.slice(2));
      } else i.startsWith("#") ? n = i.slice(1) : r = i;
      this.use = this.usehref = "";
      if (n) s = e.get(n);else {
        s = searchNode(e.get(zr), this, r, !0, !1);
        s && (s = s[0]);
      }
      if (!s) {
        warn("XFA - Invalid prototype reference: ".concat(g, "."));
        return null;
      }
      if (s[Tr] !== this[Tr]) {
        warn("XFA - Incompatible prototype: ".concat(s[Tr], " !== ").concat(this[Tr], "."));
        return null;
      }
      if (t.has(s)) {
        warn("XFA - Cycle detected in prototypes use.");
        return null;
      }
      t.add(s);
      var o = s[Sn](e, t);
      o && s[fn](o, e, t);
      s[_r](e, t);
      t.delete(s);
      return s;
    }
  }, {
    key: fn,
    value: function value(e, t, i) {
      if (i.has(e)) {
        warn("XFA - Cycle detected in prototypes use.");
        return;
      }
      !this[ar] && e[ar] && (this[ar] = e[ar]);
      new Set(i).add(e);
      var _iterator147 = _createForOfIteratorHelper(this[kn](e[Mn])),
        _step147;
      try {
        for (_iterator147.s(); !(_step147 = _iterator147.n()).done;) {
          var _t350 = _step147.value;
          this[_t350] = e[_t350];
          this[Mn] && this[Mn].add(_t350);
        }
      } catch (err) {
        _iterator147.e(err);
      } finally {
        _iterator147.f();
      }
      var _iterator148 = _createForOfIteratorHelper(Object.getOwnPropertyNames(this)),
        _step148;
      try {
        for (_iterator148.s(); !(_step148 = _iterator148.n()).done;) {
          var _a253 = _step148.value;
          if (this[mn].has(_a253)) continue;
          var _s174 = this[_a253],
            _r128 = e[_a253];
          if (_s174 instanceof XFAObjectArray) {
            var _iterator149 = _createForOfIteratorHelper(_s174[yn]),
              _step149;
            try {
              for (_iterator149.s(); !(_step149 = _iterator149.n()).done;) {
                var _e485 = _step149.value;
                _e485[Un](t, i);
              }
            } catch (err) {
              _iterator149.e(err);
            } finally {
              _iterator149.f();
            }
            for (var _a254 = _s174[yn].length, _n91 = _r128[yn].length; _a254 < _n91; _a254++) {
              var _r129 = e[yn][_a254][tr]();
              if (!_s174.push(_r129)) break;
              _r129[xn] = this;
              this[yn].push(_r129);
              _r129[Un](t, i);
            }
          } else if (null === _s174) {
            if (null !== _r128) {
              var _e486 = _r128[tr]();
              _e486[xn] = this;
              this[_a253] = _e486;
              this[yn].push(_e486);
              _e486[Un](t, i);
            }
          } else {
            _s174[_r](t, i);
            _r128 && _s174[fn](_r128, t, i);
          }
        }
      } catch (err) {
        _iterator148.e(err);
      } finally {
        _iterator148.f();
      }
    }
  }, {
    key: tr,
    value: function value() {
      var e = Object.create(Object.getPrototypeOf(this));
      var _iterator150 = _createForOfIteratorHelper(Object.getOwnPropertySymbols(this)),
        _step150;
      try {
        for (_iterator150.s(); !(_step150 = _iterator150.n()).done;) {
          var _t351 = _step150.value;
          try {
            e[_t351] = this[_t351];
          } catch (_unused13) {
            shadow(e, _t351, this[_t351]);
          }
        }
      } catch (err) {
        _iterator150.e(err);
      } finally {
        _iterator150.f();
      }
      e[In] = "".concat(e[Tr]).concat(Hn++);
      e[yn] = [];
      var _iterator151 = _createForOfIteratorHelper(Object.getOwnPropertyNames(this)),
        _step151;
      try {
        for (_iterator151.s(); !(_step151 = _iterator151.n()).done;) {
          var _t352 = _step151.value;
          if (this[mn].has(_t352)) {
            e[_t352] = XFAObject[wn](this[_t352]);
            continue;
          }
          var _i304 = this[_t352];
          e[_t352] = _i304 instanceof XFAObjectArray ? new XFAObjectArray(_i304[Nn]) : null;
        }
      } catch (err) {
        _iterator151.e(err);
      } finally {
        _iterator151.f();
      }
      var _iterator152 = _createForOfIteratorHelper(this[yn]),
        _step152;
      try {
        for (_iterator152.s(); !(_step152 = _iterator152.n()).done;) {
          var _t353 = _step152.value;
          var _i305 = _t353[Tr],
            _a255 = _t353[tr]();
          e[yn].push(_a255);
          _a255[xn] = e;
          null === e[_i305] ? e[_i305] = _a255 : e[_i305][yn].push(_a255);
        }
      } catch (err) {
        _iterator152.e(err);
      } finally {
        _iterator152.f();
      }
      return e;
    }
  }, {
    key: fr,
    value: function value() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return e ? this[yn].filter(function (t) {
        return t[Tr] === e;
      }) : this[yn];
    }
  }, {
    key: hr,
    value: function value(e) {
      return this[e];
    }
  }, {
    key: lr,
    value: function value(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      return Array.from(this[Qr](e, t, i));
    }
  }, {
    key: Qr,
    value: function value(e, t) {
      var _this63 = this;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
        var _iterator153, _step153, _i306;
        return _regeneratorRuntime().wrap(function _callee46$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              if (!("parent" !== e)) {
                _context50.next = 33;
                break;
              }
              _iterator153 = _createForOfIteratorHelper(_this63[yn]);
              _context50.prev = 2;
              _iterator153.s();
            case 4:
              if ((_step153 = _iterator153.n()).done) {
                _context50.next = 19;
                break;
              }
              _i306 = _step153.value;
              _context50.t0 = _i306[Tr] === e;
              if (!_context50.t0) {
                _context50.next = 10;
                break;
              }
              _context50.next = 10;
              return _i306;
            case 10:
              _context50.t1 = _i306.name === e;
              if (!_context50.t1) {
                _context50.next = 14;
                break;
              }
              _context50.next = 14;
              return _i306;
            case 14:
              _context50.t2 = t || _i306[Jr]();
              if (!_context50.t2) {
                _context50.next = 17;
                break;
              }
              return _context50.delegateYield(_i306[Qr](e, t, !1), "t3", 17);
            case 17:
              _context50.next = 4;
              break;
            case 19:
              _context50.next = 24;
              break;
            case 21:
              _context50.prev = 21;
              _context50.t4 = _context50["catch"](2);
              _iterator153.e(_context50.t4);
            case 24:
              _context50.prev = 24;
              _iterator153.f();
              return _context50.finish(24);
            case 27:
              _context50.t5 = i && _this63[mn].has(e);
              if (!_context50.t5) {
                _context50.next = 31;
                break;
              }
              _context50.next = 31;
              return new XFAAttribute(_this63, e, _this63[e]);
            case 31:
              _context50.next = 35;
              break;
            case 33:
              _context50.next = 35;
              return _this63[xn];
            case 35:
            case "end":
              return _context50.stop();
          }
        }, _callee46, null, [[2, 21, 24, 27]]);
      })();
    }
  }], [{
    key: wn,
    value: function value(e) {
      return Array.isArray(e) ? e.map(function (e) {
        return XFAObject[wn](e);
      }) : "object" == _typeof(e) && null !== e ? Object.assign({}, e) : e;
    }
  }]);
}();
var XFAObjectArray = /*#__PURE__*/function () {
  function XFAObjectArray() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1 / 0;
    _classCallCheck(this, XFAObjectArray);
    this[Nn] = e;
    this[yn] = [];
  }
  return _createClass(XFAObjectArray, [{
    key: "isXFAObject",
    get: function get() {
      return !1;
    }
  }, {
    key: "isXFAObjectArray",
    get: function get() {
      return !0;
    }
  }, {
    key: "push",
    value: function push(e) {
      if (this[yn].length <= this[Nn]) {
        this[yn].push(e);
        return !0;
      }
      warn("XFA - node \"".concat(e[Tr], "\" accepts no more than ").concat(this[Nn], " children"));
      return !1;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return 0 === this[yn].length;
    }
  }, {
    key: "dump",
    value: function dump() {
      return 1 === this[yn].length ? this[yn][0][rr]() : this[yn].map(function (e) {
        return e[rr]();
      });
    }
  }, {
    key: tr,
    value: function value() {
      var e = new XFAObjectArray(this[Nn]);
      e[yn] = this[yn].map(function (e) {
        return e[tr]();
      });
      return e;
    }
  }, {
    key: "children",
    get: function get() {
      return this[yn];
    }
  }, {
    key: "clear",
    value: function clear() {
      this[yn].length = 0;
    }
  }]);
}();
var XFAAttribute = /*#__PURE__*/function () {
  function XFAAttribute(e, t, i) {
    _classCallCheck(this, XFAAttribute);
    this[xn] = e;
    this[Tr] = t;
    this[ar] = i;
    this[ir] = !1;
    this[In] = "attribute" + Hn++;
  }
  return _createClass(XFAAttribute, [{
    key: wr,
    value: function value() {
      return this[xn];
    }
  }, {
    key: xr,
    value: function value() {
      return !0;
    }
  }, {
    key: Er,
    value: function value() {
      return this[ar].trim();
    }
  }, {
    key: tn,
    value: function value(e) {
      e = e.value || "";
      this[ar] = e.toString();
    }
  }, {
    key: sn,
    value: function value() {
      return this[ar];
    }
  }, {
    key: Ur,
    value: function value(e) {
      return this[xn] === e || this[xn][Ur](e);
    }
  }]);
}();
var XmlObject = /*#__PURE__*/function (_XFAObject) {
  function XmlObject(e, t) {
    var _this64;
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, XmlObject);
    _this64 = _callSuper(this, XmlObject, [e, t]);
    _this64[ar] = "";
    _this64[Dn] = null;
    if ("#text" !== t) {
      var _e487 = new Map();
      _this64[pn] = _e487;
      for (var _i307 = 0, _Object$entries3 = Object.entries(i); _i307 < _Object$entries3.length; _i307++) {
        var _ref140 = _Object$entries3[_i307];
        var _ref141 = _slicedToArray(_ref140, 2);
        var _t354 = _ref141[0];
        var _a256 = _ref141[1];
        _e487.set(_t354, new XFAAttribute(_this64, _t354, _a256));
      }
      if (i.hasOwnProperty(qr)) {
        var _e488 = i[qr].xfa.dataNode;
        void 0 !== _e488 && ("dataGroup" === _e488 ? _this64[Dn] = !1 : "dataValue" === _e488 && (_this64[Dn] = !0));
      }
    }
    _this64[ir] = !1;
    return _this64;
  }
  _inherits(XmlObject, _XFAObject);
  return _createClass(XmlObject, [{
    key: gn,
    value: function value(e) {
      var t = this[Tr];
      if ("#text" === t) {
        e.push(encodeToXmlString(this[ar]));
        return;
      }
      var i = utf8StringToString(t),
        a = this[Kr] === Jn ? "xfa:" : "";
      e.push("<".concat(a).concat(i));
      var _iterator154 = _createForOfIteratorHelper(this[pn].entries()),
        _step154;
      try {
        for (_iterator154.s(); !(_step154 = _iterator154.n()).done;) {
          var _ref142 = _step154.value;
          var _ref143 = _slicedToArray(_ref142, 2);
          var _t356 = _ref143[0];
          var _i308 = _ref143[1];
          {
            var _a257 = utf8StringToString(_t356);
            e.push(" ".concat(_a257, "=\"").concat(encodeToXmlString(_i308[ar]), "\""));
          }
        }
      } catch (err) {
        _iterator154.e(err);
      } finally {
        _iterator154.f();
      }
      null !== this[Dn] && (this[Dn] ? e.push(' xfa:dataNode="dataValue"') : e.push(' xfa:dataNode="dataGroup"'));
      if (this[ar] || 0 !== this[yn].length) {
        e.push(">");
        if (this[ar]) "string" == typeof this[ar] ? e.push(encodeToXmlString(this[ar])) : this[ar][gn](e);else {
          var _iterator155 = _createForOfIteratorHelper(this[yn]),
            _step155;
          try {
            for (_iterator155.s(); !(_step155 = _iterator155.n()).done;) {
              var _t355 = _step155.value;
              _t355[gn](e);
            }
          } catch (err) {
            _iterator155.e(err);
          } finally {
            _iterator155.f();
          }
        }
        e.push("</".concat(a).concat(i, ">"));
      } else e.push("/>");
    }
  }, {
    key: Or,
    value: function value(e) {
      if (this[ar]) {
        var _e489 = new XmlObject(this[Kr], "#text");
        this[zs](_e489);
        _e489[ar] = this[ar];
        this[ar] = "";
      }
      this[zs](e);
      return !0;
    }
  }, {
    key: Wr,
    value: function value(e) {
      this[ar] += e;
    }
  }, {
    key: gr,
    value: function value() {
      if (this[ar] && this[yn].length > 0) {
        var _e490 = new XmlObject(this[Kr], "#text");
        this[zs](_e490);
        _e490[ar] = this[ar];
        delete this[ar];
      }
    }
  }, {
    key: nn,
    value: function value() {
      return "#text" === this[Tr] ? HTMLResult.success({
        name: "#text",
        value: this[ar]
      }) : HTMLResult.EMPTY;
    }
  }, {
    key: fr,
    value: function value() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return e ? this[yn].filter(function (t) {
        return t[Tr] === e;
      }) : this[yn];
    }
  }, {
    key: cr,
    value: function value() {
      return this[pn];
    }
  }, {
    key: hr,
    value: function value(e) {
      var t = this[pn].get(e);
      return void 0 !== t ? t : this[fr](e);
    }
  }, {
    key: Qr,
    value: /*#__PURE__*/_regeneratorRuntime().mark(function value(e, t) {
      var i, _iterator156, _step156, _i309;
      return _regeneratorRuntime().wrap(function value$(_context51) {
        while (1) switch (_context51.prev = _context51.next) {
          case 0:
            i = this[pn].get(e);
            _context51.t0 = i;
            if (!_context51.t0) {
              _context51.next = 5;
              break;
            }
            _context51.next = 5;
            return i;
          case 5:
            _iterator156 = _createForOfIteratorHelper(this[yn]);
            _context51.prev = 6;
            _iterator156.s();
          case 8:
            if ((_step156 = _iterator156.n()).done) {
              _context51.next = 19;
              break;
            }
            _i309 = _step156.value;
            _context51.t1 = _i309[Tr] === e;
            if (!_context51.t1) {
              _context51.next = 14;
              break;
            }
            _context51.next = 14;
            return _i309;
          case 14:
            _context51.t2 = t;
            if (!_context51.t2) {
              _context51.next = 17;
              break;
            }
            return _context51.delegateYield(_i309[Qr](e, t), "t3", 17);
          case 17:
            _context51.next = 8;
            break;
          case 19:
            _context51.next = 24;
            break;
          case 21:
            _context51.prev = 21;
            _context51.t4 = _context51["catch"](6);
            _iterator156.e(_context51.t4);
          case 24:
            _context51.prev = 24;
            _iterator156.f();
            return _context51.finish(24);
          case 27:
          case "end":
            return _context51.stop();
        }
      }, value, this, [[6, 21, 24, 27]]);
    })
  }, {
    key: Ir,
    value: /*#__PURE__*/_regeneratorRuntime().mark(function value(e, t) {
      var i, _iterator157, _step157, _i310;
      return _regeneratorRuntime().wrap(function value$(_context52) {
        while (1) switch (_context52.prev = _context52.next) {
          case 0:
            i = this[pn].get(e);
            _context52.t0 = !i || t && i[ir];
            if (_context52.t0) {
              _context52.next = 5;
              break;
            }
            _context52.next = 5;
            return i;
          case 5:
            _iterator157 = _createForOfIteratorHelper(this[yn]);
            _context52.prev = 6;
            _iterator157.s();
          case 8:
            if ((_step157 = _iterator157.n()).done) {
              _context52.next = 13;
              break;
            }
            _i310 = _step157.value;
            return _context52.delegateYield(_i310[Ir](e, t), "t1", 11);
          case 11:
            _context52.next = 8;
            break;
          case 13:
            _context52.next = 18;
            break;
          case 15:
            _context52.prev = 15;
            _context52.t2 = _context52["catch"](6);
            _iterator157.e(_context52.t2);
          case 18:
            _context52.prev = 18;
            _iterator157.f();
            return _context52.finish(18);
          case 21:
          case "end":
            return _context52.stop();
        }
      }, value, this, [[6, 15, 18, 21]]);
    })
  }, {
    key: dr,
    value: /*#__PURE__*/_regeneratorRuntime().mark(function value(e, t, i) {
      var _iterator158, _step158, _a258;
      return _regeneratorRuntime().wrap(function value$(_context53) {
        while (1) switch (_context53.prev = _context53.next) {
          case 0:
            _iterator158 = _createForOfIteratorHelper(this[yn]);
            _context53.prev = 1;
            _iterator158.s();
          case 3:
            if ((_step158 = _iterator158.n()).done) {
              _context53.next = 14;
              break;
            }
            _a258 = _step158.value;
            _context53.t0 = _a258[Tr] !== e || i && _a258[ir];
            if (_context53.t0) {
              _context53.next = 9;
              break;
            }
            _context53.next = 9;
            return _a258;
          case 9:
            _context53.t1 = t;
            if (!_context53.t1) {
              _context53.next = 12;
              break;
            }
            return _context53.delegateYield(_a258[dr](e, t, i), "t2", 12);
          case 12:
            _context53.next = 3;
            break;
          case 14:
            _context53.next = 19;
            break;
          case 16:
            _context53.prev = 16;
            _context53.t3 = _context53["catch"](1);
            _iterator158.e(_context53.t3);
          case 19:
            _context53.prev = 19;
            _iterator158.f();
            return _context53.finish(19);
          case 22:
          case "end":
            return _context53.stop();
        }
      }, value, this, [[1, 16, 19, 22]]);
    })
  }, {
    key: xr,
    value: function value() {
      return null === this[Dn] ? 0 === this[yn].length || this[yn][0][Kr] === Cn.xhtml.id : this[Dn];
    }
  }, {
    key: Er,
    value: function value() {
      return null === this[Dn] ? 0 === this[yn].length ? this[ar].trim() : this[yn][0][Kr] === Cn.xhtml.id ? this[yn][0][sn]().trim() : null : this[ar].trim();
    }
  }, {
    key: tn,
    value: function value(e) {
      e = e.value || "";
      this[ar] = e.toString();
    }
  }, {
    key: rr,
    value: function value() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = Object.create(null);
      e && (t.$ns = this[Kr]);
      this[ar] && (t.$content = this[ar]);
      t.$name = this[Tr];
      t.children = [];
      var _iterator159 = _createForOfIteratorHelper(this[yn]),
        _step159;
      try {
        for (_iterator159.s(); !(_step159 = _iterator159.n()).done;) {
          var _i311 = _step159.value;
          t.children.push(_i311[rr](e));
        }
      } catch (err) {
        _iterator159.e(err);
      } finally {
        _iterator159.f();
      }
      t.attributes = Object.create(null);
      var _iterator160 = _createForOfIteratorHelper(this[pn]),
        _step160;
      try {
        for (_iterator160.s(); !(_step160 = _iterator160.n()).done;) {
          var _ref144 = _step160.value;
          var _ref145 = _slicedToArray(_ref144, 2);
          var _e491 = _ref145[0];
          var _i312 = _ref145[1];
          t.attributes[_e491] = _i312[ar];
        }
      } catch (err) {
        _iterator160.e(err);
      } finally {
        _iterator160.f();
      }
      return t;
    }
  }]);
}(XFAObject);
var ContentObject = /*#__PURE__*/function (_XFAObject2) {
  function ContentObject(e, t) {
    var _this65;
    _classCallCheck(this, ContentObject);
    _this65 = _callSuper(this, ContentObject, [e, t]);
    _this65[ar] = "";
    return _this65;
  }
  _inherits(ContentObject, _XFAObject2);
  return _createClass(ContentObject, [{
    key: Wr,
    value: function value(e) {
      this[ar] += e;
    }
  }, {
    key: gr,
    value: function value() {}
  }]);
}(XFAObject);
var OptionObject = /*#__PURE__*/function (_ContentObject) {
  function OptionObject(e, t, i) {
    var _this66;
    _classCallCheck(this, OptionObject);
    _this66 = _callSuper(this, OptionObject, [e, t]);
    _this66[Gn] = i;
    return _this66;
  }
  _inherits(OptionObject, _ContentObject);
  return _createClass(OptionObject, [{
    key: gr,
    value: function value() {
      var _this67 = this;
      this[ar] = getKeyword({
        data: this[ar],
        defaultValue: this[Gn][0],
        validate: function validate(e) {
          return _this67[Gn].includes(e);
        }
      });
    }
  }, {
    key: $s,
    value: function value(e) {
      _superPropGet(OptionObject, $s, this, 3)([e]);
      delete this[Gn];
    }
  }]);
}(ContentObject);
var StringObject = /*#__PURE__*/function (_ContentObject2) {
  function StringObject() {
    _classCallCheck(this, StringObject);
    return _callSuper(this, StringObject, arguments);
  }
  _inherits(StringObject, _ContentObject2);
  return _createClass(StringObject, [{
    key: gr,
    value: function value() {
      this[ar] = this[ar].trim();
    }
  }]);
}(ContentObject);
var IntegerObject = /*#__PURE__*/function (_ContentObject3) {
  function IntegerObject(e, t, i, a) {
    var _this68;
    _classCallCheck(this, IntegerObject);
    _this68 = _callSuper(this, IntegerObject, [e, t]);
    _this68[bn] = i;
    _this68[Ln] = a;
    return _this68;
  }
  _inherits(IntegerObject, _ContentObject3);
  return _createClass(IntegerObject, [{
    key: gr,
    value: function value() {
      this[ar] = getInteger({
        data: this[ar],
        defaultValue: this[bn],
        validate: this[Ln]
      });
    }
  }, {
    key: $s,
    value: function value(e) {
      _superPropGet(IntegerObject, $s, this, 3)([e]);
      delete this[bn];
      delete this[Ln];
    }
  }]);
}(ContentObject);
var Option01 = /*#__PURE__*/function (_IntegerObject) {
  function Option01(e, t) {
    _classCallCheck(this, Option01);
    return _callSuper(this, Option01, [e, t, 0, function (e) {
      return 1 === e;
    }]);
  }
  _inherits(Option01, _IntegerObject);
  return _createClass(Option01);
}(IntegerObject);
var Option10 = /*#__PURE__*/function (_IntegerObject2) {
  function Option10(e, t) {
    _classCallCheck(this, Option10);
    return _callSuper(this, Option10, [e, t, 1, function (e) {
      return 0 === e;
    }]);
  }
  _inherits(Option10, _IntegerObject2);
  return _createClass(Option10);
}(IntegerObject);
function measureToString(e) {
  return "string" == typeof e ? "0px" : Number.isInteger(e) ? "".concat(e, "px") : "".concat(e.toFixed(2), "px");
}
var Yn = {
  anchorType: function anchorType(e, t) {
    var i = e[yr]();
    if (i && (!i.layout || "position" === i.layout)) {
      "transform" in t || (t.transform = "");
      switch (e.anchorType) {
        case "bottomCenter":
          t.transform += "translate(-50%, -100%)";
          break;
        case "bottomLeft":
          t.transform += "translate(0,-100%)";
          break;
        case "bottomRight":
          t.transform += "translate(-100%,-100%)";
          break;
        case "middleCenter":
          t.transform += "translate(-50%,-50%)";
          break;
        case "middleLeft":
          t.transform += "translate(0,-50%)";
          break;
        case "middleRight":
          t.transform += "translate(-100%,-50%)";
          break;
        case "topCenter":
          t.transform += "translate(-50%,0)";
          break;
        case "topRight":
          t.transform += "translate(-100%,0)";
      }
    }
  },
  dimensions: function dimensions(e, t) {
    var _i$layout;
    var i = e[yr]();
    var a = e.w;
    var s = e.h;
    if ((_i$layout = i.layout) !== null && _i$layout !== void 0 && _i$layout.includes("row")) {
      var _t357 = i[nr],
        _s175 = e.colSpan;
      var _r130;
      if (-1 === _s175) {
        _r130 = _t357.columnWidths.slice(_t357.currentColumn).reduce(function (e, t) {
          return e + t;
        }, 0);
        _t357.currentColumn = 0;
      } else {
        _r130 = _t357.columnWidths.slice(_t357.currentColumn, _t357.currentColumn + _s175).reduce(function (e, t) {
          return e + t;
        }, 0);
        _t357.currentColumn = (_t357.currentColumn + e.colSpan) % _t357.columnWidths.length;
      }
      isNaN(_r130) || (a = e.w = _r130);
    }
    t.width = "" !== a ? measureToString(a) : "auto";
    t.height = "" !== s ? measureToString(s) : "auto";
  },
  position: function position(e, t) {
    var i = e[yr]();
    if (!(i !== null && i !== void 0 && i.layout) || "position" === i.layout) {
      t.position = "absolute";
      t.left = measureToString(e.x);
      t.top = measureToString(e.y);
    }
  },
  rotate: function rotate(e, t) {
    if (e.rotate) {
      "transform" in t || (t.transform = "");
      t.transform += "rotate(-".concat(e.rotate, "deg)");
      t.transformOrigin = "top left";
    }
  },
  presence: function presence(e, t) {
    switch (e.presence) {
      case "invisible":
        t.visibility = "hidden";
        break;
      case "hidden":
      case "inactive":
        t.display = "none";
    }
  },
  hAlign: function hAlign(e, t) {
    if ("para" === e[Tr]) switch (e.hAlign) {
      case "justifyAll":
        t.textAlign = "justify-all";
        break;
      case "radix":
        t.textAlign = "left";
        break;
      default:
        t.textAlign = e.hAlign;
    } else switch (e.hAlign) {
      case "left":
        t.alignSelf = "start";
        break;
      case "center":
        t.alignSelf = "center";
        break;
      case "right":
        t.alignSelf = "end";
    }
  },
  margin: function margin(e, t) {
    e.margin && (t.margin = e.margin[on]().margin);
  }
};
function setMinMaxDimensions(e, t) {
  if ("position" === e[yr]().layout) {
    e.minW > 0 && (t.minWidth = measureToString(e.minW));
    e.maxW > 0 && (t.maxWidth = measureToString(e.maxW));
    e.minH > 0 && (t.minHeight = measureToString(e.minH));
    e.maxH > 0 && (t.maxHeight = measureToString(e.maxH));
  }
}
function layoutText(e, t, i, a, s, r) {
  var n = new TextMeasure(t, i, a, s);
  "string" == typeof e ? n.addString(e) : e[jr](n);
  return n.compute(r);
}
function layoutNode(e, t) {
  var i = null,
    a = null,
    s = !1;
  if ((!e.w || !e.h) && e.value) {
    var _r131 = 0,
      _n92 = 0;
    if (e.margin) {
      _r131 = e.margin.leftInset + e.margin.rightInset;
      _n92 = e.margin.topInset + e.margin.bottomInset;
    }
    var _g58 = null,
      _o43 = null;
    if (e.para) {
      _o43 = Object.create(null);
      _g58 = "" === e.para.lineHeight ? null : e.para.lineHeight;
      _o43.top = "" === e.para.spaceAbove ? 0 : e.para.spaceAbove;
      _o43.bottom = "" === e.para.spaceBelow ? 0 : e.para.spaceBelow;
      _o43.left = "" === e.para.marginLeft ? 0 : e.para.marginLeft;
      _o43.right = "" === e.para.marginRight ? 0 : e.para.marginRight;
    }
    var c = e.font;
    if (!c) {
      var _t358 = e[Dr]();
      var _i313 = e[wr]();
      for (; _i313 && _i313 !== _t358;) {
        if (_i313.font) {
          c = _i313.font;
          break;
        }
        _i313 = _i313[wr]();
      }
    }
    var C = (e.w || t.width) - _r131,
      h = e[br].fontFinder;
    if (e.value.exData && e.value.exData[ar] && "text/html" === e.value.exData.contentType) {
      var _t359 = layoutText(e.value.exData[ar], c, _o43, _g58, h, C);
      a = _t359.width;
      i = _t359.height;
      s = _t359.isBroken;
    } else {
      var _t360 = e.value[sn]();
      if (_t360) {
        var _e492 = layoutText(_t360, c, _o43, _g58, h, C);
        a = _e492.width;
        i = _e492.height;
        s = _e492.isBroken;
      }
    }
    null === a || e.w || (a += _r131);
    null === i || e.h || (i += _n92);
  }
  return {
    w: a,
    h: i,
    isBroken: s
  };
}
function computeBbox(e, t, i) {
  var a;
  if ("" !== e.w && "" !== e.h) a = [e.x, e.y, e.w, e.h];else {
    if (!i) return null;
    var _s176 = e.w;
    if ("" === _s176) {
      if (0 === e.maxW) {
        var _t361 = e[yr]();
        _s176 = "position" === _t361.layout && "" !== _t361.w ? 0 : e.minW;
      } else _s176 = Math.min(e.maxW, i.width);
      t.attributes.style.width = measureToString(_s176);
    }
    var _r132 = e.h;
    if ("" === _r132) {
      if (0 === e.maxH) {
        var _t362 = e[yr]();
        _r132 = "position" === _t362.layout && "" !== _t362.h ? 0 : e.minH;
      } else _r132 = Math.min(e.maxH, i.height);
      t.attributes.style.height = measureToString(_r132);
    }
    a = [e.x, e.y, _s176, _r132];
  }
  return a;
}
function fixDimensions(e) {
  var _t$layout;
  var t = e[yr]();
  if ((_t$layout = t.layout) !== null && _t$layout !== void 0 && _t$layout.includes("row")) {
    var _i314 = t[nr],
      _a259 = e.colSpan;
    var _s177;
    _s177 = -1 === _a259 ? _i314.columnWidths.slice(_i314.currentColumn).reduce(function (e, t) {
      return e + t;
    }, 0) : _i314.columnWidths.slice(_i314.currentColumn, _i314.currentColumn + _a259).reduce(function (e, t) {
      return e + t;
    }, 0);
    isNaN(_s177) || (e.w = _s177);
  }
  t.layout && "position" !== t.layout && (e.x = e.y = 0);
  "table" === e.layout && "" === e.w && Array.isArray(e.columnWidths) && (e.w = e.columnWidths.reduce(function (e, t) {
    return e + t;
  }, 0));
}
function layoutClass(e) {
  switch (e.layout) {
    case "position":
    default:
      return "xfaPosition";
    case "lr-tb":
      return "xfaLrTb";
    case "rl-row":
      return "xfaRlRow";
    case "rl-tb":
      return "xfaRlTb";
    case "row":
      return "xfaRow";
    case "table":
      return "xfaTable";
    case "tb":
      return "xfaTb";
  }
}
function toStyle(e) {
  var i = Object.create(null);
  for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    t[_key - 1] = arguments[_key];
  }
  for (var _i315 = 0, _t363 = t; _i315 < _t363.length; _i315++) {
    var _a260 = _t363[_i315];
    var _t364 = e[_a260];
    if (null !== _t364) if (Yn.hasOwnProperty(_a260)) Yn[_a260](e, i);else if (_t364 instanceof XFAObject) {
      var _e493 = _t364[on]();
      _e493 ? Object.assign(i, _e493) : warn("(DEBUG) - XFA - style for ".concat(_a260, " not implemented yet"));
    }
  }
  return i;
}
function createWrapper(e, t) {
  var i = t.attributes,
    a = i.style,
    s = {
      name: "div",
      attributes: {
        class: ["xfaWrapper"],
        style: Object.create(null)
      },
      children: []
    };
  i.class.push("xfaWrapped");
  if (e.border) {
    var _e$border$nr = e.border[nr],
      _i316 = _e$border$nr.widths,
      _r133 = _e$border$nr.insets;
    var _n93,
      _g59,
      _o44 = _r133[0],
      c = _r133[3];
    var C = _r133[0] + _r133[2],
      h = _r133[1] + _r133[3];
    switch (e.border.hand) {
      case "even":
        _o44 -= _i316[0] / 2;
        c -= _i316[3] / 2;
        _n93 = "calc(100% + ".concat((_i316[1] + _i316[3]) / 2 - h, "px)");
        _g59 = "calc(100% + ".concat((_i316[0] + _i316[2]) / 2 - C, "px)");
        break;
      case "left":
        _o44 -= _i316[0];
        c -= _i316[3];
        _n93 = "calc(100% + ".concat(_i316[1] + _i316[3] - h, "px)");
        _g59 = "calc(100% + ".concat(_i316[0] + _i316[2] - C, "px)");
        break;
      case "right":
        _n93 = h ? "calc(100% - ".concat(h, "px)") : "100%";
        _g59 = C ? "calc(100% - ".concat(C, "px)") : "100%";
    }
    var l = ["xfaBorder"];
    isPrintOnly(e.border) && l.push("xfaPrintOnly");
    var Q = {
      name: "div",
      attributes: {
        class: l,
        style: {
          top: "".concat(_o44, "px"),
          left: "".concat(c, "px"),
          width: _n93,
          height: _g59
        }
      },
      children: []
    };
    for (var _i317 = 0, _arr3 = ["border", "borderWidth", "borderColor", "borderRadius", "borderStyle"]; _i317 < _arr3.length; _i317++) {
      var _e494 = _arr3[_i317];
      if (void 0 !== a[_e494]) {
        Q.attributes.style[_e494] = a[_e494];
        delete a[_e494];
      }
    }
    s.children.push(Q, t);
  } else s.children.push(t);
  for (var _i318 = 0, _arr4 = ["background", "backgroundClip", "top", "left", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "transform", "transformOrigin", "visibility"]; _i318 < _arr4.length; _i318++) {
    var _e495 = _arr4[_i318];
    if (void 0 !== a[_e495]) {
      s.attributes.style[_e495] = a[_e495];
      delete a[_e495];
    }
  }
  s.attributes.style.position = "absolute" === a.position ? "absolute" : "relative";
  delete a.position;
  if (a.alignSelf) {
    s.attributes.style.alignSelf = a.alignSelf;
    delete a.alignSelf;
  }
  return s;
}
function fixTextIndent(e) {
  var t = getMeasurement(e.textIndent, "0px");
  if (t >= 0) return;
  var i = "padding" + ("left" === ("right" === e.textAlign ? "right" : "left") ? "Left" : "Right"),
    a = getMeasurement(e[i], "0px");
  e[i] = a - t + "px";
}
function setAccess(e, t) {
  switch (e.access) {
    case "nonInteractive":
      t.push("xfaNonInteractive");
      break;
    case "readOnly":
      t.push("xfaReadOnly");
      break;
    case "protected":
      t.push("xfaDisabled");
  }
}
function isPrintOnly(e) {
  return e.relevant.length > 0 && !e.relevant[0].excluded && "print" === e.relevant[0].viewname;
}
function getCurrentPara(e) {
  var t = e[Dr]()[nr].paraStack;
  return t.length ? t.at(-1) : null;
}
function setPara(e, t, i) {
  var _i$attributes$class;
  if ((_i$attributes$class = i.attributes.class) !== null && _i$attributes$class !== void 0 && _i$attributes$class.includes("xfaRich")) {
    if (t) {
      "" === e.h && (t.height = "auto");
      "" === e.w && (t.width = "auto");
    }
    var _a261 = getCurrentPara(e);
    if (_a261) {
      var _e496 = i.attributes.style;
      _e496.display = "flex";
      _e496.flexDirection = "column";
      switch (_a261.vAlign) {
        case "top":
          _e496.justifyContent = "start";
          break;
        case "bottom":
          _e496.justifyContent = "end";
          break;
        case "middle":
          _e496.justifyContent = "center";
      }
      var _t365 = _a261[on]();
      for (var _i319 = 0, _Object$entries4 = Object.entries(_t365); _i319 < _Object$entries4.length; _i319++) {
        var _ref146 = _Object$entries4[_i319];
        var _ref147 = _slicedToArray(_ref146, 2);
        var _i320 = _ref147[0];
        var _a262 = _ref147[1];
        _i320 in _e496 || (_e496[_i320] = _a262);
      }
    }
  }
}
function setFontFamily(e, t, i, a) {
  if (!i) {
    delete a.fontFamily;
    return;
  }
  var s = stripQuotes(e.typeface);
  a.fontFamily = "\"".concat(s, "\"");
  var r = i.find(s);
  if (r) {
    var _i321 = r.regular.cssFontInfo.fontFamily;
    _i321 !== s && (a.fontFamily = "\"".concat(_i321, "\""));
    var _n94 = getCurrentPara(t);
    if (_n94 && "" !== _n94.lineHeight) return;
    if (a.lineHeight) return;
    var _g60 = selectFont(e, r);
    _g60 && (a.lineHeight = Math.max(1.2, _g60.lineHeight));
  }
}
function fixURL(e) {
  var t = createValidAbsoluteUrl(e, null, {
    addDefaultProtocol: !0,
    tryConvertEncoding: !0
  });
  return t ? t.href : null;
}
function createLine(e, t) {
  return {
    name: "div",
    attributes: {
      class: ["lr-tb" === e.layout ? "xfaLr" : "xfaRl"]
    },
    children: t
  };
}
function flushHTML(e) {
  if (!e[nr]) return null;
  var t = {
    name: "div",
    attributes: e[nr].attributes,
    children: e[nr].children
  };
  if (e[nr].failingNode) {
    var _i322 = e[nr].failingNode[or]();
    _i322 && (e.layout.endsWith("-tb") ? t.children.push(createLine(e, [_i322])) : t.children.push(_i322));
  }
  return 0 === t.children.length ? null : t;
}
function addHTML(e, t, i) {
  var a = e[nr],
    s = a.availableSpace,
    _i323 = _slicedToArray(i, 4),
    r = _i323[0],
    n = _i323[1],
    g = _i323[2],
    o = _i323[3];
  switch (e.layout) {
    case "position":
      a.width = Math.max(a.width, r + g);
      a.height = Math.max(a.height, n + o);
      a.children.push(t);
      break;
    case "lr-tb":
    case "rl-tb":
      if (!a.line || 1 === a.attempt) {
        a.line = createLine(e, []);
        a.children.push(a.line);
        a.numberInLine = 0;
      }
      a.numberInLine += 1;
      a.line.children.push(t);
      if (0 === a.attempt) {
        a.currentWidth += g;
        a.height = Math.max(a.height, a.prevHeight + o);
      } else {
        a.currentWidth = g;
        a.prevHeight = a.height;
        a.height += o;
        a.attempt = 0;
      }
      a.width = Math.max(a.width, a.currentWidth);
      break;
    case "rl-row":
    case "row":
      {
        a.children.push(t);
        a.width += g;
        a.height = Math.max(a.height, o);
        var _e497 = measureToString(a.height);
        var _iterator161 = _createForOfIteratorHelper(a.children),
          _step161;
        try {
          for (_iterator161.s(); !(_step161 = _iterator161.n()).done;) {
            var _t366 = _step161.value;
            _t366.attributes.style.height = _e497;
          }
        } catch (err) {
          _iterator161.e(err);
        } finally {
          _iterator161.f();
        }
        break;
      }
    case "table":
    case "tb":
      a.width = Math.min(s.width, Math.max(a.width, g));
      a.height += o;
      a.children.push(t);
  }
}
function getAvailableSpace(e) {
  var t = e[nr].availableSpace,
    i = e.margin ? e.margin.topInset + e.margin.bottomInset : 0,
    a = e.margin ? e.margin.leftInset + e.margin.rightInset : 0;
  switch (e.layout) {
    case "lr-tb":
    case "rl-tb":
      return 0 === e[nr].attempt ? {
        width: t.width - a - e[nr].currentWidth,
        height: t.height - i - e[nr].prevHeight
      } : {
        width: t.width - a,
        height: t.height - i - e[nr].height
      };
    case "rl-row":
    case "row":
      return {
        width: e[nr].columnWidths.slice(e[nr].currentColumn).reduce(function (e, t) {
          return e + t;
        }),
        height: t.height - a
      };
    case "table":
    case "tb":
      return {
        width: t.width - a,
        height: t.height - i - e[nr].height
      };
    default:
      return t;
  }
}
function checkDimensions(e, t) {
  var _i$nr;
  if (null === e[Dr]()[nr].firstUnsplittable) return !0;
  if (0 === e.w || 0 === e.h) return !0;
  var i = e[yr](),
    a = ((_i$nr = i[nr]) === null || _i$nr === void 0 ? void 0 : _i$nr.attempt) || 0,
    _getTransformedBBox = function getTransformedBBox(e) {
      var t,
        i,
        a = "" === e.w ? NaN : e.w,
        s = "" === e.h ? NaN : e.h,
        r = 0,
        n = 0;
      switch (e.anchorType || "") {
        case "bottomCenter":
          r = a / 2;
          n = s;
          break;
        case "bottomLeft":
          r = 0;
          n = s;
          break;
        case "bottomRight":
          r = a;
          n = s;
          break;
        case "middleCenter":
          r = a / 2;
          n = s / 2;
          break;
        case "middleLeft":
          r = 0;
          n = s / 2;
          break;
        case "middleRight":
          r = a;
          n = s / 2;
          break;
        case "topCenter":
          r = a / 2;
          n = 0;
          break;
        case "topRight":
          r = a;
          n = 0;
      }
      switch (e.rotate || 0) {
        case 0:
          t = -r;
          i = -n;
          break;
        case 90:
          t = -n;
          i = r;
          var _ref148 = [s, -a];
          a = _ref148[0];
          s = _ref148[1];
          break;
        case 180:
          t = r;
          i = n;
          var _ref149 = [-a, -s];
          a = _ref149[0];
          s = _ref149[1];
          break;
        case 270:
          t = n;
          i = -r;
          var _ref150 = [-s, a];
          a = _ref150[0];
          s = _ref150[1];
      }
      return [e.x + t + Math.min(0, a), e.y + i + Math.min(0, s), Math.abs(a), Math.abs(s)];
    }(e),
    _getTransformedBBox2 = _slicedToArray(_getTransformedBBox, 4),
    s = _getTransformedBBox2[1],
    r = _getTransformedBBox2[2],
    n = _getTransformedBBox2[3];
  switch (i.layout) {
    case "lr-tb":
    case "rl-tb":
      return 0 === a ? e[Dr]()[nr].noLayoutFailure ? "" !== e.w ? Math.round(r - t.width) <= 2 : t.width > 2 : !("" !== e.h && Math.round(n - t.height) > 2) && ("" !== e.w ? Math.round(r - t.width) <= 2 || 0 === i[nr].numberInLine && t.height > 2 : t.width > 2) : !!e[Dr]()[nr].noLayoutFailure || !("" !== e.h && Math.round(n - t.height) > 2) && ("" === e.w || Math.round(r - t.width) <= 2 || !i[Hr]()) && t.height > 2;
    case "table":
    case "tb":
      return !!e[Dr]()[nr].noLayoutFailure || ("" === e.h || e[Lr]() ? ("" === e.w || Math.round(r - t.width) <= 2 || !i[Hr]()) && t.height > 2 : Math.round(n - t.height) <= 2);
    case "position":
      if (e[Dr]()[nr].noLayoutFailure) return !0;
      if ("" === e.h || Math.round(n + s - t.height) <= 2) return !0;
      return n + s > e[Dr]()[nr].currentContentArea.h;
    case "rl-row":
    case "row":
      return !!e[Dr]()[nr].noLayoutFailure || "" === e.h || Math.round(n - t.height) <= 2;
    default:
      return !0;
  }
}
var vn = Cn.template.id,
  Kn = "http://www.w3.org/2000/svg",
  Tn = /^H(\d+)$/,
  qn = new Set(["image/gif", "image/jpeg", "image/jpg", "image/pjpeg", "image/png", "image/apng", "image/x-png", "image/bmp", "image/x-ms-bmp", "image/tiff", "image/tif", "application/octet-stream"]),
  On = [[[66, 77], "image/bmp"], [[255, 216, 255], "image/jpeg"], [[73, 73, 42, 0], "image/tiff"], [[77, 77, 0, 42], "image/tiff"], [[71, 73, 70, 56, 57, 97], "image/gif"], [[137, 80, 78, 71, 13, 10, 26, 10], "image/png"]];
function getBorderDims(e) {
  if (!e || !e.border) return {
    w: 0,
    h: 0
  };
  var t = e.border[ur]();
  return t ? {
    w: t.widths[0] + t.widths[2] + t.insets[0] + t.insets[2],
    h: t.widths[1] + t.widths[3] + t.insets[1] + t.insets[3]
  } : {
    w: 0,
    h: 0
  };
}
function hasMargin(e) {
  return e.margin && (e.margin.topInset || e.margin.rightInset || e.margin.bottomInset || e.margin.leftInset);
}
function _setValue(e, t) {
  if (!e.value) {
    var _t367 = new Value({});
    e[zs](_t367);
    e.value = _t367;
  }
  e.value[tn](t);
}
function getContainedChildren(e) {
  var _iterator162, _step162, _t368;
  return _regeneratorRuntime().wrap(function getContainedChildren$(_context54) {
    while (1) switch (_context54.prev = _context54.next) {
      case 0:
        _iterator162 = _createForOfIteratorHelper(e[fr]());
        _context54.prev = 1;
        _iterator162.s();
      case 3:
        if ((_step162 = _iterator162.n()).done) {
          _context54.next = 13;
          break;
        }
        _t368 = _step162.value;
        if (!(_t368 instanceof SubformSet)) {
          _context54.next = 9;
          break;
        }
        return _context54.delegateYield(_t368[pr](), "t0", 7);
      case 7:
        _context54.next = 11;
        break;
      case 9:
        _context54.next = 11;
        return _t368;
      case 11:
        _context54.next = 3;
        break;
      case 13:
        _context54.next = 18;
        break;
      case 15:
        _context54.prev = 15;
        _context54.t1 = _context54["catch"](1);
        _iterator162.e(_context54.t1);
      case 18:
        _context54.prev = 18;
        _iterator162.f();
        return _context54.finish(18);
      case 21:
      case "end":
        return _context54.stop();
    }
  }, _marked2, null, [[1, 15, 18, 21]]);
}
function isRequired(e) {
  var _e$validate;
  return "error" === ((_e$validate = e.validate) === null || _e$validate === void 0 ? void 0 : _e$validate.nullTest);
}
function setTabIndex(e) {
  for (; e;) {
    if (!e.traversal) {
      e[an] = e[wr]()[an];
      return;
    }
    if (e[an]) return;
    var _t369 = null;
    var _iterator163 = _createForOfIteratorHelper(e.traversal[fr]()),
      _step163;
    try {
      for (_iterator163.s(); !(_step163 = _iterator163.n()).done;) {
        var _i325 = _step163.value;
        if ("next" === _i325.operation) {
          _t369 = _i325;
          break;
        }
      }
    } catch (err) {
      _iterator163.e(err);
    } finally {
      _iterator163.f();
    }
    if (!_t369 || !_t369.ref) {
      e[an] = e[wr]()[an];
      return;
    }
    var _i324 = e[Dr]();
    e[an] = ++_i324[an];
    var _a263 = _i324[$r](_t369.ref, e);
    if (!_a263) return;
    e = _a263[0];
  }
}
function applyAssist(e, t) {
  var i = e.assist;
  if (i) {
    var _e498 = i[nn]();
    _e498 && (t.title = _e498);
    var _a264 = i.role.match(Tn);
    if (_a264) {
      var _e499 = "heading",
        _i326 = _a264[1];
      t.role = _e499;
      t["aria-level"] = _i326;
    }
  }
  if ("table" === e.layout) t.role = "table";else if ("row" === e.layout) t.role = "row";else {
    var _i327$assist;
    var _i327 = e[wr]();
    "row" === _i327.layout && (t.role = "TH" === ((_i327$assist = _i327.assist) === null || _i327$assist === void 0 ? void 0 : _i327$assist.role) ? "columnheader" : "cell");
  }
}
function ariaLabel(e) {
  if (!e.assist) return null;
  var t = e.assist;
  return t.speak && "" !== t.speak[ar] ? t.speak[ar] : t.toolTip ? t.toolTip[ar] : null;
}
function valueToHtml(e) {
  return HTMLResult.success({
    name: "div",
    attributes: {
      class: ["xfaRich"],
      style: Object.create(null)
    },
    children: [{
      name: "span",
      attributes: {
        style: Object.create(null)
      },
      value: e
    }]
  });
}
function setFirstUnsplittable(e) {
  var t = e[Dr]();
  if (null === t[nr].firstUnsplittable) {
    t[nr].firstUnsplittable = e;
    t[nr].noLayoutFailure = !0;
  }
}
function unsetFirstUnsplittable(e) {
  var t = e[Dr]();
  t[nr].firstUnsplittable === e && (t[nr].noLayoutFailure = !1);
}
function handleBreak(e) {
  if (e[nr]) return !1;
  e[nr] = Object.create(null);
  if ("auto" === e.targetType) return !1;
  var t = e[Dr]();
  var i = null;
  if (e.target) {
    i = t[$r](e.target, e[wr]());
    if (!i) return !1;
    i = i[0];
  }
  var _t$nr = t[nr],
    a = _t$nr.currentPageArea,
    s = _t$nr.currentContentArea;
  if ("pageArea" === e.targetType) {
    i instanceof PageArea || (i = null);
    if (e.startNew) {
      e[nr].target = i || a;
      return !0;
    }
    if (i && i !== a) {
      e[nr].target = i;
      return !0;
    }
    return !1;
  }
  i instanceof ContentArea || (i = null);
  var r = i && i[wr]();
  var n,
    g = r;
  if (e.startNew) {
    if (i) {
      var _e500 = r.contentArea.children,
        _t370 = _e500.indexOf(s),
        _a265 = _e500.indexOf(i);
      -1 !== _t370 && _t370 < _a265 && (g = null);
      n = _a265 - 1;
    } else n = a.contentArea.children.indexOf(s);
  } else {
    if (!i || i === s) return !1;
    n = r.contentArea.children.indexOf(i) - 1;
    g = r === a ? null : r;
  }
  e[nr].target = g;
  e[nr].index = n;
  return !0;
}
function handleOverflow(e, t, i) {
  var a = e[Dr](),
    s = a[nr].noLayoutFailure,
    r = t[yr];
  t[yr] = function () {
    return e;
  };
  a[nr].noLayoutFailure = !0;
  var n = t[nn](i);
  e[Vs](n.html, n.bbox);
  a[nr].noLayoutFailure = s;
  t[yr] = r;
}
var AppearanceFilter = /*#__PURE__*/function (_StringObject) {
  function AppearanceFilter(e) {
    var _this69;
    _classCallCheck(this, AppearanceFilter);
    _this69 = _callSuper(this, AppearanceFilter, [vn, "appearanceFilter"]);
    _this69.id = e.id || "";
    _this69.type = getStringOption(e.type, ["optional", "required"]);
    _this69.use = e.use || "";
    _this69.usehref = e.usehref || "";
    return _this69;
  }
  _inherits(AppearanceFilter, _StringObject);
  return _createClass(AppearanceFilter);
}(StringObject);
var Arc = /*#__PURE__*/function (_XFAObject3) {
  function Arc(e) {
    var _this70;
    _classCallCheck(this, Arc);
    _this70 = _callSuper(this, Arc, [vn, "arc", !0]);
    _this70.circular = getInteger({
      data: e.circular,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this70.hand = getStringOption(e.hand, ["even", "left", "right"]);
    _this70.id = e.id || "";
    _this70.startAngle = getFloat({
      data: e.startAngle,
      defaultValue: 0,
      validate: function validate(e) {
        return !0;
      }
    });
    _this70.sweepAngle = getFloat({
      data: e.sweepAngle,
      defaultValue: 360,
      validate: function validate(e) {
        return !0;
      }
    });
    _this70.use = e.use || "";
    _this70.usehref = e.usehref || "";
    _this70.edge = null;
    _this70.fill = null;
    return _this70;
  }
  _inherits(Arc, _XFAObject3);
  return _createClass(Arc, [{
    key: nn,
    value: function value() {
      var _this$fill;
      var e = this.edge || new Edge({}),
        t = e[on](),
        i = Object.create(null);
      "visible" === ((_this$fill = this.fill) === null || _this$fill === void 0 ? void 0 : _this$fill.presence) ? Object.assign(i, this.fill[on]()) : i.fill = "transparent";
      i.strokeWidth = measureToString("visible" === e.presence ? e.thickness : 0);
      i.stroke = t.color;
      var a;
      var s = {
        xmlns: Kn,
        style: {
          width: "100%",
          height: "100%",
          overflow: "visible"
        }
      };
      if (360 === this.sweepAngle) a = {
        name: "ellipse",
        attributes: {
          xmlns: Kn,
          cx: "50%",
          cy: "50%",
          rx: "50%",
          ry: "50%",
          style: i
        }
      };else {
        var _e501 = this.startAngle * Math.PI / 180,
          _t371 = this.sweepAngle * Math.PI / 180,
          _r134 = this.sweepAngle > 180 ? 1 : 0,
          _n95 = 50 * (1 + Math.cos(_e501)),
          _g61 = 50 * (1 - Math.sin(_e501)),
          _o45 = 50 * (1 + Math.cos(_e501 + _t371)),
          c = 50 * (1 - Math.sin(_e501 + _t371));
        a = {
          name: "path",
          attributes: {
            xmlns: Kn,
            d: "M ".concat(_n95, " ").concat(_g61, " A 50 50 0 ").concat(_r134, " 0 ").concat(_o45, " ").concat(c),
            vectorEffect: "non-scaling-stroke",
            style: i
          }
        };
        Object.assign(s, {
          viewBox: "0 0 100 100",
          preserveAspectRatio: "none"
        });
      }
      var r = {
        name: "svg",
        children: [a],
        attributes: s
      };
      if (hasMargin(this[wr]()[wr]())) return HTMLResult.success({
        name: "div",
        attributes: {
          style: {
            display: "inline",
            width: "100%",
            height: "100%"
          }
        },
        children: [r]
      });
      r.attributes.style.position = "absolute";
      return HTMLResult.success(r);
    }
  }]);
}(XFAObject);
var Area = /*#__PURE__*/function (_XFAObject4) {
  function Area(e) {
    var _this71;
    _classCallCheck(this, Area);
    _this71 = _callSuper(this, Area, [vn, "area", !0]);
    _this71.colSpan = getInteger({
      data: e.colSpan,
      defaultValue: 1,
      validate: function validate(e) {
        return e >= 1 || -1 === e;
      }
    });
    _this71.id = e.id || "";
    _this71.name = e.name || "";
    _this71.relevant = getRelevant(e.relevant);
    _this71.use = e.use || "";
    _this71.usehref = e.usehref || "";
    _this71.x = getMeasurement(e.x, "0pt");
    _this71.y = getMeasurement(e.y, "0pt");
    _this71.desc = null;
    _this71.extras = null;
    _this71.area = new XFAObjectArray();
    _this71.draw = new XFAObjectArray();
    _this71.exObject = new XFAObjectArray();
    _this71.exclGroup = new XFAObjectArray();
    _this71.field = new XFAObjectArray();
    _this71.subform = new XFAObjectArray();
    _this71.subformSet = new XFAObjectArray();
    return _this71;
  }
  _inherits(Area, _XFAObject4);
  return _createClass(Area, [{
    key: pr,
    value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
      return _regeneratorRuntime().wrap(function value$(_context55) {
        while (1) switch (_context55.prev = _context55.next) {
          case 0:
            return _context55.delegateYield(getContainedChildren(this), "t0", 1);
          case 1:
          case "end":
            return _context55.stop();
        }
      }, value, this);
    })
  }, {
    key: Jr,
    value: function value() {
      return !0;
    }
  }, {
    key: Gr,
    value: function value() {
      return !0;
    }
  }, {
    key: Vs,
    value: function value(e, t) {
      var _t372 = _slicedToArray(t, 4),
        i = _t372[0],
        a = _t372[1],
        s = _t372[2],
        r = _t372[3];
      this[nr].width = Math.max(this[nr].width, i + s);
      this[nr].height = Math.max(this[nr].height, a + r);
      this[nr].children.push(e);
    }
  }, {
    key: Cr,
    value: function value() {
      return this[nr].availableSpace;
    }
  }, {
    key: nn,
    value: function value(e) {
      var t = toStyle(this, "position"),
        i = {
          style: t,
          id: this[In],
          class: ["xfaArea"]
        };
      isPrintOnly(this) && i.class.push("xfaPrintOnly");
      this.name && (i.xfaName = this.name);
      var a = [];
      this[nr] = {
        children: a,
        width: 0,
        height: 0,
        availableSpace: e
      };
      var s = this[_s]({
        filter: new Set(["area", "draw", "field", "exclGroup", "subform", "subformSet"]),
        include: !0
      });
      if (!s.success) {
        if (s.isBreak()) return s;
        delete this[nr];
        return HTMLResult.FAILURE;
      }
      t.width = measureToString(this[nr].width);
      t.height = measureToString(this[nr].height);
      var r = {
          name: "div",
          attributes: i,
          children: a
        },
        n = [this.x, this.y, this[nr].width, this[nr].height];
      delete this[nr];
      return HTMLResult.success(r, n);
    }
  }]);
}(XFAObject);
var Assist = /*#__PURE__*/function (_XFAObject5) {
  function Assist(e) {
    var _this72;
    _classCallCheck(this, Assist);
    _this72 = _callSuper(this, Assist, [vn, "assist", !0]);
    _this72.id = e.id || "";
    _this72.role = e.role || "";
    _this72.use = e.use || "";
    _this72.usehref = e.usehref || "";
    _this72.speak = null;
    _this72.toolTip = null;
    return _this72;
  }
  _inherits(Assist, _XFAObject5);
  return _createClass(Assist, [{
    key: nn,
    value: function value() {
      var _this$toolTip;
      return ((_this$toolTip = this.toolTip) === null || _this$toolTip === void 0 ? void 0 : _this$toolTip[ar]) || null;
    }
  }]);
}(XFAObject);
var Barcode = /*#__PURE__*/function (_XFAObject6) {
  function Barcode(e) {
    var _this73;
    _classCallCheck(this, Barcode);
    _this73 = _callSuper(this, Barcode, [vn, "barcode", !0]);
    _this73.charEncoding = getKeyword({
      data: e.charEncoding ? e.charEncoding.toLowerCase() : "",
      defaultValue: "",
      validate: function validate(e) {
        return ["utf-8", "big-five", "fontspecific", "gbk", "gb-18030", "gb-2312", "ksc-5601", "none", "shift-jis", "ucs-2", "utf-16"].includes(e) || e.match(/iso-8859-\d{2}/);
      }
    });
    _this73.checksum = getStringOption(e.checksum, ["none", "1mod10", "1mod10_1mod11", "2mod10", "auto"]);
    _this73.dataColumnCount = getInteger({
      data: e.dataColumnCount,
      defaultValue: -1,
      validate: function validate(e) {
        return e >= 0;
      }
    });
    _this73.dataLength = getInteger({
      data: e.dataLength,
      defaultValue: -1,
      validate: function validate(e) {
        return e >= 0;
      }
    });
    _this73.dataPrep = getStringOption(e.dataPrep, ["none", "flateCompress"]);
    _this73.dataRowCount = getInteger({
      data: e.dataRowCount,
      defaultValue: -1,
      validate: function validate(e) {
        return e >= 0;
      }
    });
    _this73.endChar = e.endChar || "";
    _this73.errorCorrectionLevel = getInteger({
      data: e.errorCorrectionLevel,
      defaultValue: -1,
      validate: function validate(e) {
        return e >= 0 && e <= 8;
      }
    });
    _this73.id = e.id || "";
    _this73.moduleHeight = getMeasurement(e.moduleHeight, "5mm");
    _this73.moduleWidth = getMeasurement(e.moduleWidth, "0.25mm");
    _this73.printCheckDigit = getInteger({
      data: e.printCheckDigit,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this73.rowColumnRatio = getRatio(e.rowColumnRatio);
    _this73.startChar = e.startChar || "";
    _this73.textLocation = getStringOption(e.textLocation, ["below", "above", "aboveEmbedded", "belowEmbedded", "none"]);
    _this73.truncate = getInteger({
      data: e.truncate,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this73.type = getStringOption(e.type ? e.type.toLowerCase() : "", ["aztec", "codabar", "code2of5industrial", "code2of5interleaved", "code2of5matrix", "code2of5standard", "code3of9", "code3of9extended", "code11", "code49", "code93", "code128", "code128a", "code128b", "code128c", "code128sscc", "datamatrix", "ean8", "ean8add2", "ean8add5", "ean13", "ean13add2", "ean13add5", "ean13pwcd", "fim", "logmars", "maxicode", "msi", "pdf417", "pdf417macro", "plessey", "postauscust2", "postauscust3", "postausreplypaid", "postausstandard", "postukrm4scc", "postusdpbc", "postusimb", "postusstandard", "postus5zip", "qrcode", "rfid", "rss14", "rss14expanded", "rss14limited", "rss14stacked", "rss14stackedomni", "rss14truncated", "telepen", "ucc128", "ucc128random", "ucc128sscc", "upca", "upcaadd2", "upcaadd5", "upcapwcd", "upce", "upceadd2", "upceadd5", "upcean2", "upcean5", "upsmaxicode"]);
    _this73.upsMode = getStringOption(e.upsMode, ["usCarrier", "internationalCarrier", "secureSymbol", "standardSymbol"]);
    _this73.use = e.use || "";
    _this73.usehref = e.usehref || "";
    _this73.wideNarrowRatio = getRatio(e.wideNarrowRatio);
    _this73.encrypt = null;
    _this73.extras = null;
    return _this73;
  }
  _inherits(Barcode, _XFAObject6);
  return _createClass(Barcode);
}(XFAObject);
var Bind = /*#__PURE__*/function (_XFAObject7) {
  function Bind(e) {
    var _this74;
    _classCallCheck(this, Bind);
    _this74 = _callSuper(this, Bind, [vn, "bind", !0]);
    _this74.match = getStringOption(e.match, ["once", "dataRef", "global", "none"]);
    _this74.ref = e.ref || "";
    _this74.picture = null;
    return _this74;
  }
  _inherits(Bind, _XFAObject7);
  return _createClass(Bind);
}(XFAObject);
var BindItems = /*#__PURE__*/function (_XFAObject8) {
  function BindItems(e) {
    var _this75;
    _classCallCheck(this, BindItems);
    _this75 = _callSuper(this, BindItems, [vn, "bindItems"]);
    _this75.connection = e.connection || "";
    _this75.labelRef = e.labelRef || "";
    _this75.ref = e.ref || "";
    _this75.valueRef = e.valueRef || "";
    return _this75;
  }
  _inherits(BindItems, _XFAObject8);
  return _createClass(BindItems);
}(XFAObject);
var Bookend = /*#__PURE__*/function (_XFAObject9) {
  function Bookend(e) {
    var _this76;
    _classCallCheck(this, Bookend);
    _this76 = _callSuper(this, Bookend, [vn, "bookend"]);
    _this76.id = e.id || "";
    _this76.leader = e.leader || "";
    _this76.trailer = e.trailer || "";
    _this76.use = e.use || "";
    _this76.usehref = e.usehref || "";
    return _this76;
  }
  _inherits(Bookend, _XFAObject9);
  return _createClass(Bookend);
}(XFAObject);
var BooleanElement = /*#__PURE__*/function (_Option) {
  function BooleanElement(e) {
    var _this77;
    _classCallCheck(this, BooleanElement);
    _this77 = _callSuper(this, BooleanElement, [vn, "boolean"]);
    _this77.id = e.id || "";
    _this77.name = e.name || "";
    _this77.use = e.use || "";
    _this77.usehref = e.usehref || "";
    return _this77;
  }
  _inherits(BooleanElement, _Option);
  return _createClass(BooleanElement, [{
    key: nn,
    value: function value(e) {
      return valueToHtml(1 === this[ar] ? "1" : "0");
    }
  }]);
}(Option01);
var Border = /*#__PURE__*/function (_XFAObject10) {
  function Border(e) {
    var _this78;
    _classCallCheck(this, Border);
    _this78 = _callSuper(this, Border, [vn, "border", !0]);
    _this78.break = getStringOption(e.break, ["close", "open"]);
    _this78.hand = getStringOption(e.hand, ["even", "left", "right"]);
    _this78.id = e.id || "";
    _this78.presence = getStringOption(e.presence, ["visible", "hidden", "inactive", "invisible"]);
    _this78.relevant = getRelevant(e.relevant);
    _this78.use = e.use || "";
    _this78.usehref = e.usehref || "";
    _this78.corner = new XFAObjectArray(4);
    _this78.edge = new XFAObjectArray(4);
    _this78.extras = null;
    _this78.fill = null;
    _this78.margin = null;
    return _this78;
  }
  _inherits(Border, _XFAObject10);
  return _createClass(Border, [{
    key: ur,
    value: function value() {
      if (!this[nr]) {
        var _e502 = this.edge.children.slice();
        if (_e502.length < 4) {
          var _t373 = _e502.at(-1) || new Edge({});
          for (var _i328 = _e502.length; _i328 < 4; _i328++) _e502.push(_t373);
        }
        var _t374 = _e502.map(function (e) {
            return e.thickness;
          }),
          _i329 = [0, 0, 0, 0];
        if (this.margin) {
          _i329[0] = this.margin.topInset;
          _i329[1] = this.margin.rightInset;
          _i329[2] = this.margin.bottomInset;
          _i329[3] = this.margin.leftInset;
        }
        this[nr] = {
          widths: _t374,
          insets: _i329,
          edges: _e502
        };
      }
      return this[nr];
    }
  }, {
    key: on,
    value: function value() {
      var _this$fill2;
      var _this$ur = this[ur](),
        e = _this$ur.edges,
        t = e.map(function (e) {
          var t = e[on]();
          t.color || (t.color = "#000000");
          return t;
        }),
        i = Object.create(null);
      this.margin && Object.assign(i, this.margin[on]());
      "visible" === ((_this$fill2 = this.fill) === null || _this$fill2 === void 0 ? void 0 : _this$fill2.presence) && Object.assign(i, this.fill[on]());
      if (this.corner.children.some(function (e) {
        return 0 !== e.radius;
      })) {
        var _e503 = this.corner.children.map(function (e) {
          return e[on]();
        });
        if (2 === _e503.length || 3 === _e503.length) {
          var _t375 = _e503.at(-1);
          for (var _i330 = _e503.length; _i330 < 4; _i330++) _e503.push(_t375);
        }
        i.borderRadius = _e503.map(function (e) {
          return e.radius;
        }).join(" ");
      }
      switch (this.presence) {
        case "invisible":
        case "hidden":
          i.borderStyle = "";
          break;
        case "inactive":
          i.borderStyle = "none";
          break;
        default:
          i.borderStyle = t.map(function (e) {
            return e.style;
          }).join(" ");
      }
      i.borderWidth = t.map(function (e) {
        return e.width;
      }).join(" ");
      i.borderColor = t.map(function (e) {
        return e.color;
      }).join(" ");
      return i;
    }
  }]);
}(XFAObject);
var Break = /*#__PURE__*/function (_XFAObject11) {
  function Break(e) {
    var _this79;
    _classCallCheck(this, Break);
    _this79 = _callSuper(this, Break, [vn, "break", !0]);
    _this79.after = getStringOption(e.after, ["auto", "contentArea", "pageArea", "pageEven", "pageOdd"]);
    _this79.afterTarget = e.afterTarget || "";
    _this79.before = getStringOption(e.before, ["auto", "contentArea", "pageArea", "pageEven", "pageOdd"]);
    _this79.beforeTarget = e.beforeTarget || "";
    _this79.bookendLeader = e.bookendLeader || "";
    _this79.bookendTrailer = e.bookendTrailer || "";
    _this79.id = e.id || "";
    _this79.overflowLeader = e.overflowLeader || "";
    _this79.overflowTarget = e.overflowTarget || "";
    _this79.overflowTrailer = e.overflowTrailer || "";
    _this79.startNew = getInteger({
      data: e.startNew,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this79.use = e.use || "";
    _this79.usehref = e.usehref || "";
    _this79.extras = null;
    return _this79;
  }
  _inherits(Break, _XFAObject11);
  return _createClass(Break);
}(XFAObject);
var BreakAfter = /*#__PURE__*/function (_XFAObject12) {
  function BreakAfter(e) {
    var _this80;
    _classCallCheck(this, BreakAfter);
    _this80 = _callSuper(this, BreakAfter, [vn, "breakAfter", !0]);
    _this80.id = e.id || "";
    _this80.leader = e.leader || "";
    _this80.startNew = getInteger({
      data: e.startNew,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this80.target = e.target || "";
    _this80.targetType = getStringOption(e.targetType, ["auto", "contentArea", "pageArea"]);
    _this80.trailer = e.trailer || "";
    _this80.use = e.use || "";
    _this80.usehref = e.usehref || "";
    _this80.script = null;
    return _this80;
  }
  _inherits(BreakAfter, _XFAObject12);
  return _createClass(BreakAfter);
}(XFAObject);
var BreakBefore = /*#__PURE__*/function (_XFAObject13) {
  function BreakBefore(e) {
    var _this81;
    _classCallCheck(this, BreakBefore);
    _this81 = _callSuper(this, BreakBefore, [vn, "breakBefore", !0]);
    _this81.id = e.id || "";
    _this81.leader = e.leader || "";
    _this81.startNew = getInteger({
      data: e.startNew,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this81.target = e.target || "";
    _this81.targetType = getStringOption(e.targetType, ["auto", "contentArea", "pageArea"]);
    _this81.trailer = e.trailer || "";
    _this81.use = e.use || "";
    _this81.usehref = e.usehref || "";
    _this81.script = null;
    return _this81;
  }
  _inherits(BreakBefore, _XFAObject13);
  return _createClass(BreakBefore, [{
    key: nn,
    value: function value(e) {
      this[nr] = {};
      return HTMLResult.FAILURE;
    }
  }]);
}(XFAObject);
var Button = /*#__PURE__*/function (_XFAObject14) {
  function Button(e) {
    var _this82;
    _classCallCheck(this, Button);
    _this82 = _callSuper(this, Button, [vn, "button", !0]);
    _this82.highlight = getStringOption(e.highlight, ["inverted", "none", "outline", "push"]);
    _this82.id = e.id || "";
    _this82.use = e.use || "";
    _this82.usehref = e.usehref || "";
    _this82.extras = null;
    return _this82;
  }
  _inherits(Button, _XFAObject14);
  return _createClass(Button, [{
    key: nn,
    value: function value(e) {
      var t = this[wr]()[wr](),
        i = {
          name: "button",
          attributes: {
            id: this[In],
            class: ["xfaButton"],
            style: {}
          },
          children: []
        };
      var _iterator164 = _createForOfIteratorHelper(t.event.children),
        _step164;
      try {
        for (_iterator164.s(); !(_step164 = _iterator164.n()).done;) {
          var _e504 = _step164.value;
          if ("click" !== _e504.activity || !_e504.script) continue;
          var _t376 = recoverJsURL(_e504.script[ar]);
          if (!_t376) continue;
          var _a266 = fixURL(_t376.url);
          _a266 && i.children.push({
            name: "a",
            attributes: {
              id: "link" + this[In],
              href: _a266,
              newWindow: _t376.newWindow,
              class: ["xfaLink"],
              style: {}
            },
            children: []
          });
        }
      } catch (err) {
        _iterator164.e(err);
      } finally {
        _iterator164.f();
      }
      return HTMLResult.success(i);
    }
  }]);
}(XFAObject);
var Calculate = /*#__PURE__*/function (_XFAObject15) {
  function Calculate(e) {
    var _this83;
    _classCallCheck(this, Calculate);
    _this83 = _callSuper(this, Calculate, [vn, "calculate", !0]);
    _this83.id = e.id || "";
    _this83.override = getStringOption(e.override, ["disabled", "error", "ignore", "warning"]);
    _this83.use = e.use || "";
    _this83.usehref = e.usehref || "";
    _this83.extras = null;
    _this83.message = null;
    _this83.script = null;
    return _this83;
  }
  _inherits(Calculate, _XFAObject15);
  return _createClass(Calculate);
}(XFAObject);
var Caption = /*#__PURE__*/function (_XFAObject16) {
  function Caption(e) {
    var _this84;
    _classCallCheck(this, Caption);
    _this84 = _callSuper(this, Caption, [vn, "caption", !0]);
    _this84.id = e.id || "";
    _this84.placement = getStringOption(e.placement, ["left", "bottom", "inline", "right", "top"]);
    _this84.presence = getStringOption(e.presence, ["visible", "hidden", "inactive", "invisible"]);
    _this84.reserve = Math.ceil(getMeasurement(e.reserve));
    _this84.use = e.use || "";
    _this84.usehref = e.usehref || "";
    _this84.extras = null;
    _this84.font = null;
    _this84.margin = null;
    _this84.para = null;
    _this84.value = null;
    return _this84;
  }
  _inherits(Caption, _XFAObject16);
  return _createClass(Caption, [{
    key: tn,
    value: function value(e) {
      _setValue(this, e);
    }
  }, {
    key: ur,
    value: function value(e) {
      if (!this[nr]) {
        var _t377 = e.width,
          _i331 = e.height;
        switch (this.placement) {
          case "left":
          case "right":
          case "inline":
            _t377 = this.reserve <= 0 ? _t377 : this.reserve;
            break;
          case "top":
          case "bottom":
            _i331 = this.reserve <= 0 ? _i331 : this.reserve;
        }
        this[nr] = layoutNode(this, {
          width: _t377,
          height: _i331
        });
      }
      return this[nr];
    }
  }, {
    key: nn,
    value: function value(e) {
      if (!this.value) return HTMLResult.EMPTY;
      this[Zr]();
      var t = this.value[nn](e).html;
      if (!t) {
        this[Xr]();
        return HTMLResult.EMPTY;
      }
      var i = this.reserve;
      if (this.reserve <= 0) {
        var _this$ur2 = this[ur](e),
          _t378 = _this$ur2.w,
          _i332 = _this$ur2.h;
        switch (this.placement) {
          case "left":
          case "right":
          case "inline":
            this.reserve = _t378;
            break;
          case "top":
          case "bottom":
            this.reserve = _i332;
        }
      }
      var a = [];
      "string" == typeof t ? a.push({
        name: "#text",
        value: t
      }) : a.push(t);
      var s = toStyle(this, "font", "margin", "visibility");
      switch (this.placement) {
        case "left":
        case "right":
          this.reserve > 0 && (s.width = measureToString(this.reserve));
          break;
        case "top":
        case "bottom":
          this.reserve > 0 && (s.height = measureToString(this.reserve));
      }
      setPara(this, null, t);
      this[Xr]();
      this.reserve = i;
      return HTMLResult.success({
        name: "div",
        attributes: {
          style: s,
          class: ["xfaCaption"]
        },
        children: a
      });
    }
  }]);
}(XFAObject);
var Certificate = /*#__PURE__*/function (_StringObject2) {
  function Certificate(e) {
    var _this85;
    _classCallCheck(this, Certificate);
    _this85 = _callSuper(this, Certificate, [vn, "certificate"]);
    _this85.id = e.id || "";
    _this85.name = e.name || "";
    _this85.use = e.use || "";
    _this85.usehref = e.usehref || "";
    return _this85;
  }
  _inherits(Certificate, _StringObject2);
  return _createClass(Certificate);
}(StringObject);
var Certificates = /*#__PURE__*/function (_XFAObject17) {
  function Certificates(e) {
    var _this86;
    _classCallCheck(this, Certificates);
    _this86 = _callSuper(this, Certificates, [vn, "certificates", !0]);
    _this86.credentialServerPolicy = getStringOption(e.credentialServerPolicy, ["optional", "required"]);
    _this86.id = e.id || "";
    _this86.url = e.url || "";
    _this86.urlPolicy = e.urlPolicy || "";
    _this86.use = e.use || "";
    _this86.usehref = e.usehref || "";
    _this86.encryption = null;
    _this86.issuers = null;
    _this86.keyUsage = null;
    _this86.oids = null;
    _this86.signing = null;
    _this86.subjectDNs = null;
    return _this86;
  }
  _inherits(Certificates, _XFAObject17);
  return _createClass(Certificates);
}(XFAObject);
var CheckButton = /*#__PURE__*/function (_XFAObject18) {
  function CheckButton(e) {
    var _this87;
    _classCallCheck(this, CheckButton);
    _this87 = _callSuper(this, CheckButton, [vn, "checkButton", !0]);
    _this87.id = e.id || "";
    _this87.mark = getStringOption(e.mark, ["default", "check", "circle", "cross", "diamond", "square", "star"]);
    _this87.shape = getStringOption(e.shape, ["square", "round"]);
    _this87.size = getMeasurement(e.size, "10pt");
    _this87.use = e.use || "";
    _this87.usehref = e.usehref || "";
    _this87.border = null;
    _this87.extras = null;
    _this87.margin = null;
    return _this87;
  }
  _inherits(CheckButton, _XFAObject18);
  return _createClass(CheckButton, [{
    key: nn,
    value: function value(e) {
      var _n$value;
      var t = toStyle("margin"),
        i = measureToString(this.size);
      t.width = t.height = i;
      var a, s, r;
      var n = this[wr]()[wr](),
        g = n.items.children.length && n.items.children[0][nn]().html || [],
        o = {
          on: (void 0 !== g[0] ? g[0] : "on").toString(),
          off: (void 0 !== g[1] ? g[1] : "off").toString()
        },
        c = (((_n$value = n.value) === null || _n$value === void 0 ? void 0 : _n$value[sn]()) || "off") === o.on || void 0,
        C = n[yr](),
        h = n[In];
      var l;
      if (C instanceof ExclGroup) {
        var _C$sr;
        r = C[In];
        a = "radio";
        s = "xfaRadio";
        l = ((_C$sr = C[sr]) === null || _C$sr === void 0 ? void 0 : _C$sr[In]) || C[In];
      } else {
        var _n$sr;
        a = "checkbox";
        s = "xfaCheckbox";
        l = ((_n$sr = n[sr]) === null || _n$sr === void 0 ? void 0 : _n$sr[In]) || n[In];
      }
      var Q = {
        name: "input",
        attributes: {
          class: [s],
          style: t,
          fieldId: h,
          dataId: l,
          type: a,
          checked: c,
          xfaOn: o.on,
          xfaOff: o.off,
          "aria-label": ariaLabel(n),
          "aria-required": !1
        }
      };
      r && (Q.attributes.name = r);
      if (isRequired(n)) {
        Q.attributes["aria-required"] = !0;
        Q.attributes.required = !0;
      }
      return HTMLResult.success({
        name: "label",
        attributes: {
          class: ["xfaLabel"]
        },
        children: [Q]
      });
    }
  }]);
}(XFAObject);
var ChoiceList = /*#__PURE__*/function (_XFAObject19) {
  function ChoiceList(e) {
    var _this88;
    _classCallCheck(this, ChoiceList);
    _this88 = _callSuper(this, ChoiceList, [vn, "choiceList", !0]);
    _this88.commitOn = getStringOption(e.commitOn, ["select", "exit"]);
    _this88.id = e.id || "";
    _this88.open = getStringOption(e.open, ["userControl", "always", "multiSelect", "onEntry"]);
    _this88.textEntry = getInteger({
      data: e.textEntry,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this88.use = e.use || "";
    _this88.usehref = e.usehref || "";
    _this88.border = null;
    _this88.extras = null;
    _this88.margin = null;
    return _this88;
  }
  _inherits(ChoiceList, _XFAObject19);
  return _createClass(ChoiceList, [{
    key: nn,
    value: function value(e) {
      var _i$font, _i$sr;
      var t = toStyle(this, "border", "margin"),
        i = this[wr]()[wr](),
        a = {
          fontSize: "calc(".concat(((_i$font = i.font) === null || _i$font === void 0 ? void 0 : _i$font.size) || 10, "px * var(--scale-factor))")
        },
        s = [];
      if (i.items.children.length > 0) {
        var _i$value;
        var _e505 = i.items;
        var _t379 = 0,
          _r135 = 0;
        if (2 === _e505.children.length) {
          _t379 = _e505.children[0].save;
          _r135 = 1 - _t379;
        }
        var _n96 = _e505.children[_t379][nn]().html,
          _g62 = _e505.children[_r135][nn]().html;
        var _o46 = !1;
        var c = ((_i$value = i.value) === null || _i$value === void 0 ? void 0 : _i$value[sn]()) || "";
        for (var _e506 = 0, _t380 = _n96.length; _e506 < _t380; _e506++) {
          var _t381 = {
            name: "option",
            attributes: {
              value: _g62[_e506] || _n96[_e506],
              style: a
            },
            value: _n96[_e506]
          };
          _g62[_e506] === c && (_t381.attributes.selected = _o46 = !0);
          s.push(_t381);
        }
        _o46 || s.splice(0, 0, {
          name: "option",
          attributes: {
            hidden: !0,
            selected: !0
          },
          value: " "
        });
      }
      var r = {
        class: ["xfaSelect"],
        fieldId: i[In],
        dataId: ((_i$sr = i[sr]) === null || _i$sr === void 0 ? void 0 : _i$sr[In]) || i[In],
        style: t,
        "aria-label": ariaLabel(i),
        "aria-required": !1
      };
      if (isRequired(i)) {
        r["aria-required"] = !0;
        r.required = !0;
      }
      "multiSelect" === this.open && (r.multiple = !0);
      return HTMLResult.success({
        name: "label",
        attributes: {
          class: ["xfaLabel"]
        },
        children: [{
          name: "select",
          children: s,
          attributes: r
        }]
      });
    }
  }]);
}(XFAObject);
var Color = /*#__PURE__*/function (_XFAObject20) {
  function Color(e) {
    var _this89;
    _classCallCheck(this, Color);
    _this89 = _callSuper(this, Color, [vn, "color", !0]);
    _this89.cSpace = getStringOption(e.cSpace, ["SRGB"]);
    _this89.id = e.id || "";
    _this89.use = e.use || "";
    _this89.usehref = e.usehref || "";
    _this89.value = e.value ? function getColor(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0, 0, 0];
      var _t382 = _slicedToArray(t, 3),
        i = _t382[0],
        a = _t382[1],
        s = _t382[2];
      if (!e) return {
        r: i,
        g: a,
        b: s
      };
      var r = e.trim().split(/\s*,\s*/).map(function (e) {
        return Math.min(Math.max(0, parseInt(e.trim(), 10)), 255);
      }).map(function (e) {
        return isNaN(e) ? 0 : e;
      });
      if (r.length < 3) return {
        r: i,
        g: a,
        b: s
      };
      var _r136 = _slicedToArray(r, 3);
      i = _r136[0];
      a = _r136[1];
      s = _r136[2];
      return {
        r: i,
        g: a,
        b: s
      };
    }(e.value) : "";
    _this89.extras = null;
    return _this89;
  }
  _inherits(Color, _XFAObject20);
  return _createClass(Color, [{
    key: Fr,
    value: function value() {
      return !1;
    }
  }, {
    key: on,
    value: function value() {
      return this.value ? Util.makeHexColor(this.value.r, this.value.g, this.value.b) : null;
    }
  }]);
}(XFAObject);
var Comb = /*#__PURE__*/function (_XFAObject21) {
  function Comb(e) {
    var _this90;
    _classCallCheck(this, Comb);
    _this90 = _callSuper(this, Comb, [vn, "comb"]);
    _this90.id = e.id || "";
    _this90.numberOfCells = getInteger({
      data: e.numberOfCells,
      defaultValue: 0,
      validate: function validate(e) {
        return e >= 0;
      }
    });
    _this90.use = e.use || "";
    _this90.usehref = e.usehref || "";
    return _this90;
  }
  _inherits(Comb, _XFAObject21);
  return _createClass(Comb);
}(XFAObject);
var Connect = /*#__PURE__*/function (_XFAObject22) {
  function Connect(e) {
    var _this91;
    _classCallCheck(this, Connect);
    _this91 = _callSuper(this, Connect, [vn, "connect", !0]);
    _this91.connection = e.connection || "";
    _this91.id = e.id || "";
    _this91.ref = e.ref || "";
    _this91.usage = getStringOption(e.usage, ["exportAndImport", "exportOnly", "importOnly"]);
    _this91.use = e.use || "";
    _this91.usehref = e.usehref || "";
    _this91.picture = null;
    return _this91;
  }
  _inherits(Connect, _XFAObject22);
  return _createClass(Connect);
}(XFAObject);
var ContentArea = /*#__PURE__*/function (_XFAObject23) {
  function ContentArea(e) {
    var _this92;
    _classCallCheck(this, ContentArea);
    _this92 = _callSuper(this, ContentArea, [vn, "contentArea", !0]);
    _this92.h = getMeasurement(e.h);
    _this92.id = e.id || "";
    _this92.name = e.name || "";
    _this92.relevant = getRelevant(e.relevant);
    _this92.use = e.use || "";
    _this92.usehref = e.usehref || "";
    _this92.w = getMeasurement(e.w);
    _this92.x = getMeasurement(e.x, "0pt");
    _this92.y = getMeasurement(e.y, "0pt");
    _this92.desc = null;
    _this92.extras = null;
    return _this92;
  }
  _inherits(ContentArea, _XFAObject23);
  return _createClass(ContentArea, [{
    key: nn,
    value: function value(e) {
      var t = {
          left: measureToString(this.x),
          top: measureToString(this.y),
          width: measureToString(this.w),
          height: measureToString(this.h)
        },
        i = ["xfaContentarea"];
      isPrintOnly(this) && i.push("xfaPrintOnly");
      return HTMLResult.success({
        name: "div",
        children: [],
        attributes: {
          style: t,
          class: i,
          id: this[In]
        }
      });
    }
  }]);
}(XFAObject);
var Corner = /*#__PURE__*/function (_XFAObject24) {
  function Corner(e) {
    var _this93;
    _classCallCheck(this, Corner);
    _this93 = _callSuper(this, Corner, [vn, "corner", !0]);
    _this93.id = e.id || "";
    _this93.inverted = getInteger({
      data: e.inverted,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this93.join = getStringOption(e.join, ["square", "round"]);
    _this93.presence = getStringOption(e.presence, ["visible", "hidden", "inactive", "invisible"]);
    _this93.radius = getMeasurement(e.radius);
    _this93.stroke = getStringOption(e.stroke, ["solid", "dashDot", "dashDotDot", "dashed", "dotted", "embossed", "etched", "lowered", "raised"]);
    _this93.thickness = getMeasurement(e.thickness, "0.5pt");
    _this93.use = e.use || "";
    _this93.usehref = e.usehref || "";
    _this93.color = null;
    _this93.extras = null;
    return _this93;
  }
  _inherits(Corner, _XFAObject24);
  return _createClass(Corner, [{
    key: on,
    value: function value() {
      var e = toStyle(this, "visibility");
      e.radius = measureToString("square" === this.join ? 0 : this.radius);
      return e;
    }
  }]);
}(XFAObject);
var DateElement = /*#__PURE__*/function (_ContentObject4) {
  function DateElement(e) {
    var _this94;
    _classCallCheck(this, DateElement);
    _this94 = _callSuper(this, DateElement, [vn, "date"]);
    _this94.id = e.id || "";
    _this94.name = e.name || "";
    _this94.use = e.use || "";
    _this94.usehref = e.usehref || "";
    return _this94;
  }
  _inherits(DateElement, _ContentObject4);
  return _createClass(DateElement, [{
    key: gr,
    value: function value() {
      var e = this[ar].trim();
      this[ar] = e ? new Date(e) : null;
    }
  }, {
    key: nn,
    value: function value(e) {
      return valueToHtml(this[ar] ? this[ar].toString() : "");
    }
  }]);
}(ContentObject);
var DateTime = /*#__PURE__*/function (_ContentObject5) {
  function DateTime(e) {
    var _this95;
    _classCallCheck(this, DateTime);
    _this95 = _callSuper(this, DateTime, [vn, "dateTime"]);
    _this95.id = e.id || "";
    _this95.name = e.name || "";
    _this95.use = e.use || "";
    _this95.usehref = e.usehref || "";
    return _this95;
  }
  _inherits(DateTime, _ContentObject5);
  return _createClass(DateTime, [{
    key: gr,
    value: function value() {
      var e = this[ar].trim();
      this[ar] = e ? new Date(e) : null;
    }
  }, {
    key: nn,
    value: function value(e) {
      return valueToHtml(this[ar] ? this[ar].toString() : "");
    }
  }]);
}(ContentObject);
var DateTimeEdit = /*#__PURE__*/function (_XFAObject25) {
  function DateTimeEdit(e) {
    var _this96;
    _classCallCheck(this, DateTimeEdit);
    _this96 = _callSuper(this, DateTimeEdit, [vn, "dateTimeEdit", !0]);
    _this96.hScrollPolicy = getStringOption(e.hScrollPolicy, ["auto", "off", "on"]);
    _this96.id = e.id || "";
    _this96.picker = getStringOption(e.picker, ["host", "none"]);
    _this96.use = e.use || "";
    _this96.usehref = e.usehref || "";
    _this96.border = null;
    _this96.comb = null;
    _this96.extras = null;
    _this96.margin = null;
    return _this96;
  }
  _inherits(DateTimeEdit, _XFAObject25);
  return _createClass(DateTimeEdit, [{
    key: nn,
    value: function value(e) {
      var _i$sr2;
      var t = toStyle(this, "border", "font", "margin"),
        i = this[wr]()[wr](),
        a = {
          name: "input",
          attributes: {
            type: "text",
            fieldId: i[In],
            dataId: ((_i$sr2 = i[sr]) === null || _i$sr2 === void 0 ? void 0 : _i$sr2[In]) || i[In],
            class: ["xfaTextfield"],
            style: t,
            "aria-label": ariaLabel(i),
            "aria-required": !1
          }
        };
      if (isRequired(i)) {
        a.attributes["aria-required"] = !0;
        a.attributes.required = !0;
      }
      return HTMLResult.success({
        name: "label",
        attributes: {
          class: ["xfaLabel"]
        },
        children: [a]
      });
    }
  }]);
}(XFAObject);
var Decimal = /*#__PURE__*/function (_ContentObject6) {
  function Decimal(e) {
    var _this97;
    _classCallCheck(this, Decimal);
    _this97 = _callSuper(this, Decimal, [vn, "decimal"]);
    _this97.fracDigits = getInteger({
      data: e.fracDigits,
      defaultValue: 2,
      validate: function validate(e) {
        return !0;
      }
    });
    _this97.id = e.id || "";
    _this97.leadDigits = getInteger({
      data: e.leadDigits,
      defaultValue: -1,
      validate: function validate(e) {
        return !0;
      }
    });
    _this97.name = e.name || "";
    _this97.use = e.use || "";
    _this97.usehref = e.usehref || "";
    return _this97;
  }
  _inherits(Decimal, _ContentObject6);
  return _createClass(Decimal, [{
    key: gr,
    value: function value() {
      var e = parseFloat(this[ar].trim());
      this[ar] = isNaN(e) ? null : e;
    }
  }, {
    key: nn,
    value: function value(e) {
      return valueToHtml(null !== this[ar] ? this[ar].toString() : "");
    }
  }]);
}(ContentObject);
var DefaultUi = /*#__PURE__*/function (_XFAObject26) {
  function DefaultUi(e) {
    var _this98;
    _classCallCheck(this, DefaultUi);
    _this98 = _callSuper(this, DefaultUi, [vn, "defaultUi", !0]);
    _this98.id = e.id || "";
    _this98.use = e.use || "";
    _this98.usehref = e.usehref || "";
    _this98.extras = null;
    return _this98;
  }
  _inherits(DefaultUi, _XFAObject26);
  return _createClass(DefaultUi);
}(XFAObject);
var Desc = /*#__PURE__*/function (_XFAObject27) {
  function Desc(e) {
    var _this99;
    _classCallCheck(this, Desc);
    _this99 = _callSuper(this, Desc, [vn, "desc", !0]);
    _this99.id = e.id || "";
    _this99.use = e.use || "";
    _this99.usehref = e.usehref || "";
    _this99.boolean = new XFAObjectArray();
    _this99.date = new XFAObjectArray();
    _this99.dateTime = new XFAObjectArray();
    _this99.decimal = new XFAObjectArray();
    _this99.exData = new XFAObjectArray();
    _this99.float = new XFAObjectArray();
    _this99.image = new XFAObjectArray();
    _this99.integer = new XFAObjectArray();
    _this99.text = new XFAObjectArray();
    _this99.time = new XFAObjectArray();
    return _this99;
  }
  _inherits(Desc, _XFAObject27);
  return _createClass(Desc);
}(XFAObject);
var DigestMethod = /*#__PURE__*/function (_OptionObject) {
  function DigestMethod(e) {
    var _this100;
    _classCallCheck(this, DigestMethod);
    _this100 = _callSuper(this, DigestMethod, [vn, "digestMethod", ["", "SHA1", "SHA256", "SHA512", "RIPEMD160"]]);
    _this100.id = e.id || "";
    _this100.use = e.use || "";
    _this100.usehref = e.usehref || "";
    return _this100;
  }
  _inherits(DigestMethod, _OptionObject);
  return _createClass(DigestMethod);
}(OptionObject);
var DigestMethods = /*#__PURE__*/function (_XFAObject28) {
  function DigestMethods(e) {
    var _this101;
    _classCallCheck(this, DigestMethods);
    _this101 = _callSuper(this, DigestMethods, [vn, "digestMethods", !0]);
    _this101.id = e.id || "";
    _this101.type = getStringOption(e.type, ["optional", "required"]);
    _this101.use = e.use || "";
    _this101.usehref = e.usehref || "";
    _this101.digestMethod = new XFAObjectArray();
    return _this101;
  }
  _inherits(DigestMethods, _XFAObject28);
  return _createClass(DigestMethods);
}(XFAObject);
var Draw = /*#__PURE__*/function (_XFAObject29) {
  function Draw(e) {
    var _this102;
    _classCallCheck(this, Draw);
    _this102 = _callSuper(this, Draw, [vn, "draw", !0]);
    _this102.anchorType = getStringOption(e.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]);
    _this102.colSpan = getInteger({
      data: e.colSpan,
      defaultValue: 1,
      validate: function validate(e) {
        return e >= 1 || -1 === e;
      }
    });
    _this102.h = e.h ? getMeasurement(e.h) : "";
    _this102.hAlign = getStringOption(e.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]);
    _this102.id = e.id || "";
    _this102.locale = e.locale || "";
    _this102.maxH = getMeasurement(e.maxH, "0pt");
    _this102.maxW = getMeasurement(e.maxW, "0pt");
    _this102.minH = getMeasurement(e.minH, "0pt");
    _this102.minW = getMeasurement(e.minW, "0pt");
    _this102.name = e.name || "";
    _this102.presence = getStringOption(e.presence, ["visible", "hidden", "inactive", "invisible"]);
    _this102.relevant = getRelevant(e.relevant);
    _this102.rotate = getInteger({
      data: e.rotate,
      defaultValue: 0,
      validate: function validate(e) {
        return e % 90 == 0;
      }
    });
    _this102.use = e.use || "";
    _this102.usehref = e.usehref || "";
    _this102.w = e.w ? getMeasurement(e.w) : "";
    _this102.x = getMeasurement(e.x, "0pt");
    _this102.y = getMeasurement(e.y, "0pt");
    _this102.assist = null;
    _this102.border = null;
    _this102.caption = null;
    _this102.desc = null;
    _this102.extras = null;
    _this102.font = null;
    _this102.keep = null;
    _this102.margin = null;
    _this102.para = null;
    _this102.traversal = null;
    _this102.ui = null;
    _this102.value = null;
    _this102.setProperty = new XFAObjectArray();
    return _this102;
  }
  _inherits(Draw, _XFAObject29);
  return _createClass(Draw, [{
    key: tn,
    value: function value(e) {
      _setValue(this, e);
    }
  }, {
    key: nn,
    value: function value(e) {
      setTabIndex(this);
      if ("hidden" === this.presence || "inactive" === this.presence) return HTMLResult.EMPTY;
      fixDimensions(this);
      this[Zr]();
      var t = this.w,
        i = this.h,
        _layoutNode = layoutNode(this, e),
        a = _layoutNode.w,
        s = _layoutNode.h,
        r = _layoutNode.isBroken;
      if (a && "" === this.w) {
        if (r && this[yr]()[Hr]()) {
          this[Xr]();
          return HTMLResult.FAILURE;
        }
        this.w = a;
      }
      s && "" === this.h && (this.h = s);
      setFirstUnsplittable(this);
      if (!checkDimensions(this, e)) {
        this.w = t;
        this.h = i;
        this[Xr]();
        return HTMLResult.FAILURE;
      }
      unsetFirstUnsplittable(this);
      var n = toStyle(this, "font", "hAlign", "dimensions", "position", "presence", "rotate", "anchorType", "border", "margin");
      setMinMaxDimensions(this, n);
      if (n.margin) {
        n.padding = n.margin;
        delete n.margin;
      }
      var g = ["xfaDraw"];
      this.font && g.push("xfaFont");
      isPrintOnly(this) && g.push("xfaPrintOnly");
      var o = {
        style: n,
        id: this[In],
        class: g
      };
      this.name && (o.xfaName = this.name);
      var c = {
        name: "div",
        attributes: o,
        children: []
      };
      applyAssist(this, o);
      var C = computeBbox(this, c, e),
        h = this.value ? this.value[nn](e).html : null;
      if (null === h) {
        this.w = t;
        this.h = i;
        this[Xr]();
        return HTMLResult.success(createWrapper(this, c), C);
      }
      c.children.push(h);
      setPara(this, n, h);
      this.w = t;
      this.h = i;
      this[Xr]();
      return HTMLResult.success(createWrapper(this, c), C);
    }
  }]);
}(XFAObject);
var Edge = /*#__PURE__*/function (_XFAObject30) {
  function Edge(e) {
    var _this103;
    _classCallCheck(this, Edge);
    _this103 = _callSuper(this, Edge, [vn, "edge", !0]);
    _this103.cap = getStringOption(e.cap, ["square", "butt", "round"]);
    _this103.id = e.id || "";
    _this103.presence = getStringOption(e.presence, ["visible", "hidden", "inactive", "invisible"]);
    _this103.stroke = getStringOption(e.stroke, ["solid", "dashDot", "dashDotDot", "dashed", "dotted", "embossed", "etched", "lowered", "raised"]);
    _this103.thickness = getMeasurement(e.thickness, "0.5pt");
    _this103.use = e.use || "";
    _this103.usehref = e.usehref || "";
    _this103.color = null;
    _this103.extras = null;
    return _this103;
  }
  _inherits(Edge, _XFAObject30);
  return _createClass(Edge, [{
    key: on,
    value: function value() {
      var e = toStyle(this, "visibility");
      Object.assign(e, {
        linecap: this.cap,
        width: measureToString(this.thickness),
        color: this.color ? this.color[on]() : "#000000",
        style: ""
      });
      if ("visible" !== this.presence) e.style = "none";else switch (this.stroke) {
        case "solid":
          e.style = "solid";
          break;
        case "dashDot":
        case "dashDotDot":
        case "dashed":
          e.style = "dashed";
          break;
        case "dotted":
          e.style = "dotted";
          break;
        case "embossed":
          e.style = "ridge";
          break;
        case "etched":
          e.style = "groove";
          break;
        case "lowered":
          e.style = "inset";
          break;
        case "raised":
          e.style = "outset";
      }
      return e;
    }
  }]);
}(XFAObject);
var Encoding = /*#__PURE__*/function (_OptionObject2) {
  function Encoding(e) {
    var _this104;
    _classCallCheck(this, Encoding);
    _this104 = _callSuper(this, Encoding, [vn, "encoding", ["adbe.x509.rsa_sha1", "adbe.pkcs7.detached", "adbe.pkcs7.sha1"]]);
    _this104.id = e.id || "";
    _this104.use = e.use || "";
    _this104.usehref = e.usehref || "";
    return _this104;
  }
  _inherits(Encoding, _OptionObject2);
  return _createClass(Encoding);
}(OptionObject);
var Encodings = /*#__PURE__*/function (_XFAObject31) {
  function Encodings(e) {
    var _this105;
    _classCallCheck(this, Encodings);
    _this105 = _callSuper(this, Encodings, [vn, "encodings", !0]);
    _this105.id = e.id || "";
    _this105.type = getStringOption(e.type, ["optional", "required"]);
    _this105.use = e.use || "";
    _this105.usehref = e.usehref || "";
    _this105.encoding = new XFAObjectArray();
    return _this105;
  }
  _inherits(Encodings, _XFAObject31);
  return _createClass(Encodings);
}(XFAObject);
var Encrypt = /*#__PURE__*/function (_XFAObject32) {
  function Encrypt(e) {
    var _this106;
    _classCallCheck(this, Encrypt);
    _this106 = _callSuper(this, Encrypt, [vn, "encrypt", !0]);
    _this106.id = e.id || "";
    _this106.use = e.use || "";
    _this106.usehref = e.usehref || "";
    _this106.certificate = null;
    return _this106;
  }
  _inherits(Encrypt, _XFAObject32);
  return _createClass(Encrypt);
}(XFAObject);
var EncryptData = /*#__PURE__*/function (_XFAObject33) {
  function EncryptData(e) {
    var _this107;
    _classCallCheck(this, EncryptData);
    _this107 = _callSuper(this, EncryptData, [vn, "encryptData", !0]);
    _this107.id = e.id || "";
    _this107.operation = getStringOption(e.operation, ["encrypt", "decrypt"]);
    _this107.target = e.target || "";
    _this107.use = e.use || "";
    _this107.usehref = e.usehref || "";
    _this107.filter = null;
    _this107.manifest = null;
    return _this107;
  }
  _inherits(EncryptData, _XFAObject33);
  return _createClass(EncryptData);
}(XFAObject);
var Encryption = /*#__PURE__*/function (_XFAObject34) {
  function Encryption(e) {
    var _this108;
    _classCallCheck(this, Encryption);
    _this108 = _callSuper(this, Encryption, [vn, "encryption", !0]);
    _this108.id = e.id || "";
    _this108.type = getStringOption(e.type, ["optional", "required"]);
    _this108.use = e.use || "";
    _this108.usehref = e.usehref || "";
    _this108.certificate = new XFAObjectArray();
    return _this108;
  }
  _inherits(Encryption, _XFAObject34);
  return _createClass(Encryption);
}(XFAObject);
var EncryptionMethod = /*#__PURE__*/function (_OptionObject3) {
  function EncryptionMethod(e) {
    var _this109;
    _classCallCheck(this, EncryptionMethod);
    _this109 = _callSuper(this, EncryptionMethod, [vn, "encryptionMethod", ["", "AES256-CBC", "TRIPLEDES-CBC", "AES128-CBC", "AES192-CBC"]]);
    _this109.id = e.id || "";
    _this109.use = e.use || "";
    _this109.usehref = e.usehref || "";
    return _this109;
  }
  _inherits(EncryptionMethod, _OptionObject3);
  return _createClass(EncryptionMethod);
}(OptionObject);
var EncryptionMethods = /*#__PURE__*/function (_XFAObject35) {
  function EncryptionMethods(e) {
    var _this110;
    _classCallCheck(this, EncryptionMethods);
    _this110 = _callSuper(this, EncryptionMethods, [vn, "encryptionMethods", !0]);
    _this110.id = e.id || "";
    _this110.type = getStringOption(e.type, ["optional", "required"]);
    _this110.use = e.use || "";
    _this110.usehref = e.usehref || "";
    _this110.encryptionMethod = new XFAObjectArray();
    return _this110;
  }
  _inherits(EncryptionMethods, _XFAObject35);
  return _createClass(EncryptionMethods);
}(XFAObject);
var Event = /*#__PURE__*/function (_XFAObject36) {
  function Event(e) {
    var _this111;
    _classCallCheck(this, Event);
    _this111 = _callSuper(this, Event, [vn, "event", !0]);
    _this111.activity = getStringOption(e.activity, ["click", "change", "docClose", "docReady", "enter", "exit", "full", "indexChange", "initialize", "mouseDown", "mouseEnter", "mouseExit", "mouseUp", "postExecute", "postOpen", "postPrint", "postSave", "postSign", "postSubmit", "preExecute", "preOpen", "prePrint", "preSave", "preSign", "preSubmit", "ready", "validationState"]);
    _this111.id = e.id || "";
    _this111.listen = getStringOption(e.listen, ["refOnly", "refAndDescendents"]);
    _this111.name = e.name || "";
    _this111.ref = e.ref || "";
    _this111.use = e.use || "";
    _this111.usehref = e.usehref || "";
    _this111.extras = null;
    _this111.encryptData = null;
    _this111.execute = null;
    _this111.script = null;
    _this111.signData = null;
    _this111.submit = null;
    return _this111;
  }
  _inherits(Event, _XFAObject36);
  return _createClass(Event);
}(XFAObject);
var ExData = /*#__PURE__*/function (_ContentObject7) {
  function ExData(e) {
    var _this112;
    _classCallCheck(this, ExData);
    _this112 = _callSuper(this, ExData, [vn, "exData"]);
    _this112.contentType = e.contentType || "";
    _this112.href = e.href || "";
    _this112.id = e.id || "";
    _this112.maxLength = getInteger({
      data: e.maxLength,
      defaultValue: -1,
      validate: function validate(e) {
        return e >= -1;
      }
    });
    _this112.name = e.name || "";
    _this112.rid = e.rid || "";
    _this112.transferEncoding = getStringOption(e.transferEncoding, ["none", "base64", "package"]);
    _this112.use = e.use || "";
    _this112.usehref = e.usehref || "";
    return _this112;
  }
  _inherits(ExData, _ContentObject7);
  return _createClass(ExData, [{
    key: Nr,
    value: function value() {
      return "text/html" === this.contentType;
    }
  }, {
    key: Or,
    value: function value(e) {
      if ("text/html" === this.contentType && e[Kr] === Cn.xhtml.id) {
        this[ar] = e;
        return !0;
      }
      if ("text/xml" === this.contentType) {
        this[ar] = e;
        return !0;
      }
      return !1;
    }
  }, {
    key: nn,
    value: function value(e) {
      return "text/html" === this.contentType && this[ar] ? this[ar][nn](e) : HTMLResult.EMPTY;
    }
  }]);
}(ContentObject);
var ExObject = /*#__PURE__*/function (_XFAObject37) {
  function ExObject(e) {
    var _this113;
    _classCallCheck(this, ExObject);
    _this113 = _callSuper(this, ExObject, [vn, "exObject", !0]);
    _this113.archive = e.archive || "";
    _this113.classId = e.classId || "";
    _this113.codeBase = e.codeBase || "";
    _this113.codeType = e.codeType || "";
    _this113.id = e.id || "";
    _this113.name = e.name || "";
    _this113.use = e.use || "";
    _this113.usehref = e.usehref || "";
    _this113.extras = null;
    _this113.boolean = new XFAObjectArray();
    _this113.date = new XFAObjectArray();
    _this113.dateTime = new XFAObjectArray();
    _this113.decimal = new XFAObjectArray();
    _this113.exData = new XFAObjectArray();
    _this113.exObject = new XFAObjectArray();
    _this113.float = new XFAObjectArray();
    _this113.image = new XFAObjectArray();
    _this113.integer = new XFAObjectArray();
    _this113.text = new XFAObjectArray();
    _this113.time = new XFAObjectArray();
    return _this113;
  }
  _inherits(ExObject, _XFAObject37);
  return _createClass(ExObject);
}(XFAObject);
var ExclGroup = /*#__PURE__*/function (_XFAObject38) {
  function ExclGroup(e) {
    var _this114;
    _classCallCheck(this, ExclGroup);
    _this114 = _callSuper(this, ExclGroup, [vn, "exclGroup", !0]);
    _this114.access = getStringOption(e.access, ["open", "nonInteractive", "protected", "readOnly"]);
    _this114.accessKey = e.accessKey || "";
    _this114.anchorType = getStringOption(e.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]);
    _this114.colSpan = getInteger({
      data: e.colSpan,
      defaultValue: 1,
      validate: function validate(e) {
        return e >= 1 || -1 === e;
      }
    });
    _this114.h = e.h ? getMeasurement(e.h) : "";
    _this114.hAlign = getStringOption(e.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]);
    _this114.id = e.id || "";
    _this114.layout = getStringOption(e.layout, ["position", "lr-tb", "rl-row", "rl-tb", "row", "table", "tb"]);
    _this114.maxH = getMeasurement(e.maxH, "0pt");
    _this114.maxW = getMeasurement(e.maxW, "0pt");
    _this114.minH = getMeasurement(e.minH, "0pt");
    _this114.minW = getMeasurement(e.minW, "0pt");
    _this114.name = e.name || "";
    _this114.presence = getStringOption(e.presence, ["visible", "hidden", "inactive", "invisible"]);
    _this114.relevant = getRelevant(e.relevant);
    _this114.use = e.use || "";
    _this114.usehref = e.usehref || "";
    _this114.w = e.w ? getMeasurement(e.w) : "";
    _this114.x = getMeasurement(e.x, "0pt");
    _this114.y = getMeasurement(e.y, "0pt");
    _this114.assist = null;
    _this114.bind = null;
    _this114.border = null;
    _this114.calculate = null;
    _this114.caption = null;
    _this114.desc = null;
    _this114.extras = null;
    _this114.margin = null;
    _this114.para = null;
    _this114.traversal = null;
    _this114.validate = null;
    _this114.connect = new XFAObjectArray();
    _this114.event = new XFAObjectArray();
    _this114.field = new XFAObjectArray();
    _this114.setProperty = new XFAObjectArray();
    return _this114;
  }
  _inherits(ExclGroup, _XFAObject38);
  return _createClass(ExclGroup, [{
    key: Gr,
    value: function value() {
      return !0;
    }
  }, {
    key: Fr,
    value: function value() {
      return !0;
    }
  }, {
    key: tn,
    value: function value(e) {
      var _iterator165 = _createForOfIteratorHelper(this.field.children),
        _step165;
      try {
        for (_iterator165.s(); !(_step165 = _iterator165.n()).done;) {
          var _t383 = _step165.value;
          if (!_t383.value) {
            var _e507 = new Value({});
            _t383[zs](_e507);
            _t383.value = _e507;
          }
          _t383.value[tn](e);
        }
      } catch (err) {
        _iterator165.e(err);
      } finally {
        _iterator165.f();
      }
    }
  }, {
    key: Hr,
    value: function value() {
      return this.layout.endsWith("-tb") && 0 === this[nr].attempt && this[nr].numberInLine > 0 || this[wr]()[Hr]();
    }
  }, {
    key: Lr,
    value: function value() {
      var _e$layout;
      var e = this[yr]();
      if (!e[Lr]()) return !1;
      if (void 0 !== this[nr]._isSplittable) return this[nr]._isSplittable;
      if ("position" === this.layout || this.layout.includes("row")) {
        this[nr]._isSplittable = !1;
        return !1;
      }
      if ((_e$layout = e.layout) !== null && _e$layout !== void 0 && _e$layout.endsWith("-tb") && 0 !== e[nr].numberInLine) return !1;
      this[nr]._isSplittable = !0;
      return !0;
    }
  }, {
    key: or,
    value: function value() {
      return flushHTML(this);
    }
  }, {
    key: Vs,
    value: function value(e, t) {
      addHTML(this, e, t);
    }
  }, {
    key: Cr,
    value: function value() {
      return getAvailableSpace(this);
    }
  }, {
    key: nn,
    value: function value(e) {
      setTabIndex(this);
      if ("hidden" === this.presence || "inactive" === this.presence || 0 === this.h || 0 === this.w) return HTMLResult.EMPTY;
      fixDimensions(this);
      var t = [],
        i = {
          id: this[In],
          class: []
        };
      setAccess(this, i.class);
      this[nr] || (this[nr] = Object.create(null));
      Object.assign(this[nr], {
        children: t,
        attributes: i,
        attempt: 0,
        line: null,
        numberInLine: 0,
        availableSpace: {
          width: Math.min(this.w || 1 / 0, e.width),
          height: Math.min(this.h || 1 / 0, e.height)
        },
        width: 0,
        height: 0,
        prevHeight: 0,
        currentWidth: 0
      });
      var a = this[Lr]();
      a || setFirstUnsplittable(this);
      if (!checkDimensions(this, e)) return HTMLResult.FAILURE;
      var s = new Set(["field"]);
      if (this.layout.includes("row")) {
        var _e508 = this[yr]().columnWidths;
        if (Array.isArray(_e508) && _e508.length > 0) {
          this[nr].columnWidths = _e508;
          this[nr].currentColumn = 0;
        }
      }
      var r = toStyle(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign"),
        n = ["xfaExclgroup"],
        g = layoutClass(this);
      g && n.push(g);
      isPrintOnly(this) && n.push("xfaPrintOnly");
      i.style = r;
      i.class = n;
      this.name && (i.xfaName = this.name);
      this[Zr]();
      var o = "lr-tb" === this.layout || "rl-tb" === this.layout,
        c = o ? 2 : 1;
      for (; this[nr].attempt < c; this[nr].attempt++) {
        o && 1 === this[nr].attempt && (this[nr].numberInLine = 0);
        var _e509 = this[_s]({
          filter: s,
          include: !0
        });
        if (_e509.success) break;
        if (_e509.isBreak()) {
          this[Xr]();
          return _e509;
        }
        if (o && 0 === this[nr].attempt && 0 === this[nr].numberInLine && !this[Dr]()[nr].noLayoutFailure) {
          this[nr].attempt = c;
          break;
        }
      }
      this[Xr]();
      a || unsetFirstUnsplittable(this);
      if (this[nr].attempt === c) {
        a || delete this[nr];
        return HTMLResult.FAILURE;
      }
      var C = 0,
        h = 0;
      if (this.margin) {
        C = this.margin.leftInset + this.margin.rightInset;
        h = this.margin.topInset + this.margin.bottomInset;
      }
      var l = Math.max(this[nr].width + C, this.w || 0),
        Q = Math.max(this[nr].height + h, this.h || 0),
        E = [this.x, this.y, l, Q];
      "" === this.w && (r.width = measureToString(l));
      "" === this.h && (r.height = measureToString(Q));
      var u = {
        name: "div",
        attributes: i,
        children: t
      };
      applyAssist(this, i);
      delete this[nr];
      return HTMLResult.success(createWrapper(this, u), E);
    }
  }]);
}(XFAObject);
var Execute = /*#__PURE__*/function (_XFAObject39) {
  function Execute(e) {
    var _this115;
    _classCallCheck(this, Execute);
    _this115 = _callSuper(this, Execute, [vn, "execute"]);
    _this115.connection = e.connection || "";
    _this115.executeType = getStringOption(e.executeType, ["import", "remerge"]);
    _this115.id = e.id || "";
    _this115.runAt = getStringOption(e.runAt, ["client", "both", "server"]);
    _this115.use = e.use || "";
    _this115.usehref = e.usehref || "";
    return _this115;
  }
  _inherits(Execute, _XFAObject39);
  return _createClass(Execute);
}(XFAObject);
var Extras = /*#__PURE__*/function (_XFAObject40) {
  function Extras(e) {
    var _this116;
    _classCallCheck(this, Extras);
    _this116 = _callSuper(this, Extras, [vn, "extras", !0]);
    _this116.id = e.id || "";
    _this116.name = e.name || "";
    _this116.use = e.use || "";
    _this116.usehref = e.usehref || "";
    _this116.boolean = new XFAObjectArray();
    _this116.date = new XFAObjectArray();
    _this116.dateTime = new XFAObjectArray();
    _this116.decimal = new XFAObjectArray();
    _this116.exData = new XFAObjectArray();
    _this116.extras = new XFAObjectArray();
    _this116.float = new XFAObjectArray();
    _this116.image = new XFAObjectArray();
    _this116.integer = new XFAObjectArray();
    _this116.text = new XFAObjectArray();
    _this116.time = new XFAObjectArray();
    return _this116;
  }
  _inherits(Extras, _XFAObject40);
  return _createClass(Extras);
}(XFAObject);
var Field = /*#__PURE__*/function (_XFAObject41) {
  function Field(e) {
    var _this117;
    _classCallCheck(this, Field);
    _this117 = _callSuper(this, Field, [vn, "field", !0]);
    _this117.access = getStringOption(e.access, ["open", "nonInteractive", "protected", "readOnly"]);
    _this117.accessKey = e.accessKey || "";
    _this117.anchorType = getStringOption(e.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]);
    _this117.colSpan = getInteger({
      data: e.colSpan,
      defaultValue: 1,
      validate: function validate(e) {
        return e >= 1 || -1 === e;
      }
    });
    _this117.h = e.h ? getMeasurement(e.h) : "";
    _this117.hAlign = getStringOption(e.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]);
    _this117.id = e.id || "";
    _this117.locale = e.locale || "";
    _this117.maxH = getMeasurement(e.maxH, "0pt");
    _this117.maxW = getMeasurement(e.maxW, "0pt");
    _this117.minH = getMeasurement(e.minH, "0pt");
    _this117.minW = getMeasurement(e.minW, "0pt");
    _this117.name = e.name || "";
    _this117.presence = getStringOption(e.presence, ["visible", "hidden", "inactive", "invisible"]);
    _this117.relevant = getRelevant(e.relevant);
    _this117.rotate = getInteger({
      data: e.rotate,
      defaultValue: 0,
      validate: function validate(e) {
        return e % 90 == 0;
      }
    });
    _this117.use = e.use || "";
    _this117.usehref = e.usehref || "";
    _this117.w = e.w ? getMeasurement(e.w) : "";
    _this117.x = getMeasurement(e.x, "0pt");
    _this117.y = getMeasurement(e.y, "0pt");
    _this117.assist = null;
    _this117.bind = null;
    _this117.border = null;
    _this117.calculate = null;
    _this117.caption = null;
    _this117.desc = null;
    _this117.extras = null;
    _this117.font = null;
    _this117.format = null;
    _this117.items = new XFAObjectArray(2);
    _this117.keep = null;
    _this117.margin = null;
    _this117.para = null;
    _this117.traversal = null;
    _this117.ui = null;
    _this117.validate = null;
    _this117.value = null;
    _this117.bindItems = new XFAObjectArray();
    _this117.connect = new XFAObjectArray();
    _this117.event = new XFAObjectArray();
    _this117.setProperty = new XFAObjectArray();
    return _this117;
  }
  _inherits(Field, _XFAObject41);
  return _createClass(Field, [{
    key: Gr,
    value: function value() {
      return !0;
    }
  }, {
    key: tn,
    value: function value(e) {
      _setValue(this, e);
    }
  }, {
    key: nn,
    value: function value(e) {
      var _E$children, _E$children2;
      setTabIndex(this);
      if (!this.ui) {
        this.ui = new Ui({});
        this.ui[br] = this[br];
        this[zs](this.ui);
        var _e510;
        switch (this.items.children.length) {
          case 0:
            _e510 = new TextEdit({});
            this.ui.textEdit = _e510;
            break;
          case 1:
            _e510 = new CheckButton({});
            this.ui.checkButton = _e510;
            break;
          case 2:
            _e510 = new ChoiceList({});
            this.ui.choiceList = _e510;
        }
        this.ui[zs](_e510);
      }
      if (!this.ui || "hidden" === this.presence || "inactive" === this.presence || 0 === this.h || 0 === this.w) return HTMLResult.EMPTY;
      this.caption && delete this.caption[nr];
      this[Zr]();
      var t = this.caption ? this.caption[nn](e).html : null,
        i = this.w,
        a = this.h;
      var s = 0,
        r = 0;
      if (this.margin) {
        s = this.margin.leftInset + this.margin.rightInset;
        r = this.margin.topInset + this.margin.bottomInset;
      }
      var n = null;
      if ("" === this.w || "" === this.h) {
        var _t384 = null,
          _i333 = null,
          _a267 = 0,
          _g63 = 0;
        if (this.ui.checkButton) _a267 = _g63 = this.ui.checkButton.size;else {
          var _layoutNode2 = layoutNode(this, e),
            _t385 = _layoutNode2.w,
            _i334 = _layoutNode2.h;
          if (null !== _t385) {
            _a267 = _t385;
            _g63 = _i334;
          } else _g63 = function fonts_getMetrics(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            var i = null;
            if (e) {
              var _t386 = stripQuotes(e.typeface),
                _a268 = e[br].fontFinder.find(_t386);
              i = selectFont(e, _a268);
            }
            if (!i) return {
              lineHeight: 12,
              lineGap: 2,
              lineNoGap: 10
            };
            var a = e.size || 10,
              s = i.lineHeight ? Math.max(t ? 0 : 1.2, i.lineHeight) : 1.2,
              r = void 0 === i.lineGap ? .2 : i.lineGap;
            return {
              lineHeight: s * a,
              lineGap: r * a,
              lineNoGap: Math.max(1, s - r) * a
            };
          }(this.font, !0).lineNoGap;
        }
        n = getBorderDims(this.ui[ur]());
        _a267 += n.w;
        _g63 += n.h;
        if (this.caption) {
          var _this$caption$ur = this.caption[ur](e),
            _s178 = _this$caption$ur.w,
            _r137 = _this$caption$ur.h,
            _n97 = _this$caption$ur.isBroken;
          if (_n97 && this[yr]()[Hr]()) {
            this[Xr]();
            return HTMLResult.FAILURE;
          }
          _t384 = _s178;
          _i333 = _r137;
          switch (this.caption.placement) {
            case "left":
            case "right":
            case "inline":
              _t384 += _a267;
              break;
            case "top":
            case "bottom":
              _i333 += _g63;
          }
        } else {
          _t384 = _a267;
          _i333 = _g63;
        }
        if (_t384 && "" === this.w) {
          _t384 += s;
          this.w = Math.min(this.maxW <= 0 ? 1 / 0 : this.maxW, this.minW + 1 < _t384 ? _t384 : this.minW);
        }
        if (_i333 && "" === this.h) {
          _i333 += r;
          this.h = Math.min(this.maxH <= 0 ? 1 / 0 : this.maxH, this.minH + 1 < _i333 ? _i333 : this.minH);
        }
      }
      this[Xr]();
      fixDimensions(this);
      setFirstUnsplittable(this);
      if (!checkDimensions(this, e)) {
        this.w = i;
        this.h = a;
        this[Xr]();
        return HTMLResult.FAILURE;
      }
      unsetFirstUnsplittable(this);
      var g = toStyle(this, "font", "dimensions", "position", "rotate", "anchorType", "presence", "margin", "hAlign");
      setMinMaxDimensions(this, g);
      var o = ["xfaField"];
      this.font && o.push("xfaFont");
      isPrintOnly(this) && o.push("xfaPrintOnly");
      var c = {
        style: g,
        id: this[In],
        class: o
      };
      if (g.margin) {
        g.padding = g.margin;
        delete g.margin;
      }
      setAccess(this, o);
      this.name && (c.xfaName = this.name);
      var C = [],
        h = {
          name: "div",
          attributes: c,
          children: C
        };
      applyAssist(this, c);
      var l = this.border ? this.border[on]() : null,
        Q = computeBbox(this, h, e),
        E = this.ui[nn]().html;
      if (!E) {
        Object.assign(g, l);
        return HTMLResult.success(createWrapper(this, h), Q);
      }
      this[an] && ((_E$children = E.children) !== null && _E$children !== void 0 && _E$children[0] ? E.children[0].attributes.tabindex = this[an] : E.attributes.tabindex = this[an]);
      E.attributes.style || (E.attributes.style = Object.create(null));
      var u = null;
      if (this.ui.button) {
        var _E$children$splice, _E$children$splice2;
        1 === E.children.length && (_E$children$splice = E.children.splice(0, 1), _E$children$splice2 = _slicedToArray(_E$children$splice, 1), u = _E$children$splice2[0], _E$children$splice);
        Object.assign(E.attributes.style, l);
      } else Object.assign(g, l);
      C.push(E);
      if (this.value) if (this.ui.imageEdit) E.children.push(this.value[nn]().html);else if (!this.ui.button) {
        var _this$value$text;
        var _e511 = "";
        if (this.value.exData) _e511 = this.value.exData[sn]();else if (this.value.text) _e511 = this.value.text[ur]();else {
          var _t387 = this.value[nn]().html;
          null !== _t387 && (_e511 = _t387.children[0].value);
        }
        this.ui.textEdit && ((_this$value$text = this.value.text) === null || _this$value$text === void 0 ? void 0 : _this$value$text.maxChars) && (E.children[0].attributes.maxLength = this.value.text.maxChars);
        if (_e511) {
          if (this.ui.numericEdit) {
            _e511 = parseFloat(_e511);
            _e511 = isNaN(_e511) ? "" : _e511.toString();
          }
          "textarea" === E.children[0].name ? E.children[0].attributes.textContent = _e511 : E.children[0].attributes.value = _e511;
        }
      }
      if (!this.ui.imageEdit && (_E$children2 = E.children) !== null && _E$children2 !== void 0 && _E$children2[0] && this.h) {
        n = n || getBorderDims(this.ui[ur]());
        var _t388 = 0;
        if (this.caption && ["top", "bottom"].includes(this.caption.placement)) {
          _t388 = this.caption.reserve;
          _t388 <= 0 && (_t388 = this.caption[ur](e).h);
          var _i335 = this.h - _t388 - r - n.h;
          E.children[0].attributes.style.height = measureToString(_i335);
        } else E.children[0].attributes.style.height = "100%";
      }
      u && E.children.push(u);
      if (!t) {
        E.attributes.class && E.attributes.class.push("xfaLeft");
        this.w = i;
        this.h = a;
        return HTMLResult.success(createWrapper(this, h), Q);
      }
      if (this.ui.button) {
        g.padding && delete g.padding;
        "div" === t.name && (t.name = "span");
        E.children.push(t);
        return HTMLResult.success(h, Q);
      }
      this.ui.checkButton && (t.attributes.class[0] = "xfaCaptionForCheckButton");
      E.attributes.class || (E.attributes.class = []);
      E.children.splice(0, 0, t);
      switch (this.caption.placement) {
        case "left":
        case "inline":
          E.attributes.class.push("xfaLeft");
          break;
        case "right":
          E.attributes.class.push("xfaRight");
          break;
        case "top":
          E.attributes.class.push("xfaTop");
          break;
        case "bottom":
          E.attributes.class.push("xfaBottom");
      }
      this.w = i;
      this.h = a;
      return HTMLResult.success(createWrapper(this, h), Q);
    }
  }]);
}(XFAObject);
var Fill = /*#__PURE__*/function (_XFAObject42) {
  function Fill(e) {
    var _this118;
    _classCallCheck(this, Fill);
    _this118 = _callSuper(this, Fill, [vn, "fill", !0]);
    _this118.id = e.id || "";
    _this118.presence = getStringOption(e.presence, ["visible", "hidden", "inactive", "invisible"]);
    _this118.use = e.use || "";
    _this118.usehref = e.usehref || "";
    _this118.color = null;
    _this118.extras = null;
    _this118.linear = null;
    _this118.pattern = null;
    _this118.radial = null;
    _this118.solid = null;
    _this118.stipple = null;
    return _this118;
  }
  _inherits(Fill, _XFAObject42);
  return _createClass(Fill, [{
    key: on,
    value: function value() {
      var _this$color;
      var e = this[wr](),
        t = e[wr]()[wr](),
        i = Object.create(null);
      var a = "color",
        s = a;
      if (e instanceof Border) {
        a = "background-color";
        s = "background";
        t instanceof Ui && (i.backgroundColor = "white");
      }
      if (e instanceof Rectangle || e instanceof Arc) {
        a = s = "fill";
        i.fill = "white";
      }
      var _iterator166 = _createForOfIteratorHelper(Object.getOwnPropertyNames(this)),
        _step166;
      try {
        for (_iterator166.s(); !(_step166 = _iterator166.n()).done;) {
          var _e513 = _step166.value;
          if ("extras" === _e513 || "color" === _e513) continue;
          var _t389 = this[_e513];
          if (!(_t389 instanceof XFAObject)) continue;
          var _r138 = _t389[on](this.color);
          _r138 && (i[_r138.startsWith("#") ? a : s] = _r138);
          return i;
        }
      } catch (err) {
        _iterator166.e(err);
      } finally {
        _iterator166.f();
      }
      if ((_this$color = this.color) !== null && _this$color !== void 0 && _this$color.value) {
        var _e512 = this.color[on]();
        i[_e512.startsWith("#") ? a : s] = _e512;
      }
      return i;
    }
  }]);
}(XFAObject);
var Filter = /*#__PURE__*/function (_XFAObject43) {
  function Filter(e) {
    var _this119;
    _classCallCheck(this, Filter);
    _this119 = _callSuper(this, Filter, [vn, "filter", !0]);
    _this119.addRevocationInfo = getStringOption(e.addRevocationInfo, ["", "required", "optional", "none"]);
    _this119.id = e.id || "";
    _this119.name = e.name || "";
    _this119.use = e.use || "";
    _this119.usehref = e.usehref || "";
    _this119.version = getInteger({
      data: _this119.version,
      defaultValue: 5,
      validate: function validate(e) {
        return e >= 1 && e <= 5;
      }
    });
    _this119.appearanceFilter = null;
    _this119.certificates = null;
    _this119.digestMethods = null;
    _this119.encodings = null;
    _this119.encryptionMethods = null;
    _this119.handler = null;
    _this119.lockDocument = null;
    _this119.mdp = null;
    _this119.reasons = null;
    _this119.timeStamp = null;
    return _this119;
  }
  _inherits(Filter, _XFAObject43);
  return _createClass(Filter);
}(XFAObject);
var Float = /*#__PURE__*/function (_ContentObject8) {
  function Float(e) {
    var _this120;
    _classCallCheck(this, Float);
    _this120 = _callSuper(this, Float, [vn, "float"]);
    _this120.id = e.id || "";
    _this120.name = e.name || "";
    _this120.use = e.use || "";
    _this120.usehref = e.usehref || "";
    return _this120;
  }
  _inherits(Float, _ContentObject8);
  return _createClass(Float, [{
    key: gr,
    value: function value() {
      var e = parseFloat(this[ar].trim());
      this[ar] = isNaN(e) ? null : e;
    }
  }, {
    key: nn,
    value: function value(e) {
      return valueToHtml(null !== this[ar] ? this[ar].toString() : "");
    }
  }]);
}(ContentObject);
var template_Font = /*#__PURE__*/function (_XFAObject44) {
  function template_Font(e) {
    var _this121;
    _classCallCheck(this, template_Font);
    _this121 = _callSuper(this, template_Font, [vn, "font", !0]);
    _this121.baselineShift = getMeasurement(e.baselineShift);
    _this121.fontHorizontalScale = getFloat({
      data: e.fontHorizontalScale,
      defaultValue: 100,
      validate: function validate(e) {
        return e >= 0;
      }
    });
    _this121.fontVerticalScale = getFloat({
      data: e.fontVerticalScale,
      defaultValue: 100,
      validate: function validate(e) {
        return e >= 0;
      }
    });
    _this121.id = e.id || "";
    _this121.kerningMode = getStringOption(e.kerningMode, ["none", "pair"]);
    _this121.letterSpacing = getMeasurement(e.letterSpacing, "0");
    _this121.lineThrough = getInteger({
      data: e.lineThrough,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e || 2 === e;
      }
    });
    _this121.lineThroughPeriod = getStringOption(e.lineThroughPeriod, ["all", "word"]);
    _this121.overline = getInteger({
      data: e.overline,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e || 2 === e;
      }
    });
    _this121.overlinePeriod = getStringOption(e.overlinePeriod, ["all", "word"]);
    _this121.posture = getStringOption(e.posture, ["normal", "italic"]);
    _this121.size = getMeasurement(e.size, "10pt");
    _this121.typeface = e.typeface || "Courier";
    _this121.underline = getInteger({
      data: e.underline,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e || 2 === e;
      }
    });
    _this121.underlinePeriod = getStringOption(e.underlinePeriod, ["all", "word"]);
    _this121.use = e.use || "";
    _this121.usehref = e.usehref || "";
    _this121.weight = getStringOption(e.weight, ["normal", "bold"]);
    _this121.extras = null;
    _this121.fill = null;
    return _this121;
  }
  _inherits(template_Font, _XFAObject44);
  return _createClass(template_Font, [{
    key: $s,
    value: function value(e) {
      _superPropGet(template_Font, $s, this, 3)([e]);
      this[br].usedTypefaces.add(this.typeface);
    }
  }, {
    key: on,
    value: function value() {
      var e = toStyle(this, "fill"),
        t = e.color;
      if (t) if ("#000000" === t) delete e.color;else if (!t.startsWith("#")) {
        e.background = t;
        e.backgroundClip = "text";
        e.color = "transparent";
      }
      this.baselineShift && (e.verticalAlign = measureToString(this.baselineShift));
      e.fontKerning = "none" === this.kerningMode ? "none" : "normal";
      e.letterSpacing = measureToString(this.letterSpacing);
      if (0 !== this.lineThrough) {
        e.textDecoration = "line-through";
        2 === this.lineThrough && (e.textDecorationStyle = "double");
      }
      if (0 !== this.overline) {
        e.textDecoration = "overline";
        2 === this.overline && (e.textDecorationStyle = "double");
      }
      e.fontStyle = this.posture;
      e.fontSize = measureToString(.99 * this.size);
      setFontFamily(this, this, this[br].fontFinder, e);
      if (0 !== this.underline) {
        e.textDecoration = "underline";
        2 === this.underline && (e.textDecorationStyle = "double");
      }
      e.fontWeight = this.weight;
      return e;
    }
  }]);
}(XFAObject);
var Format = /*#__PURE__*/function (_XFAObject45) {
  function Format(e) {
    var _this122;
    _classCallCheck(this, Format);
    _this122 = _callSuper(this, Format, [vn, "format", !0]);
    _this122.id = e.id || "";
    _this122.use = e.use || "";
    _this122.usehref = e.usehref || "";
    _this122.extras = null;
    _this122.picture = null;
    return _this122;
  }
  _inherits(Format, _XFAObject45);
  return _createClass(Format);
}(XFAObject);
var Handler = /*#__PURE__*/function (_StringObject3) {
  function Handler(e) {
    var _this123;
    _classCallCheck(this, Handler);
    _this123 = _callSuper(this, Handler, [vn, "handler"]);
    _this123.id = e.id || "";
    _this123.type = getStringOption(e.type, ["optional", "required"]);
    _this123.use = e.use || "";
    _this123.usehref = e.usehref || "";
    return _this123;
  }
  _inherits(Handler, _StringObject3);
  return _createClass(Handler);
}(StringObject);
var Hyphenation = /*#__PURE__*/function (_XFAObject46) {
  function Hyphenation(e) {
    var _this124;
    _classCallCheck(this, Hyphenation);
    _this124 = _callSuper(this, Hyphenation, [vn, "hyphenation"]);
    _this124.excludeAllCaps = getInteger({
      data: e.excludeAllCaps,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this124.excludeInitialCap = getInteger({
      data: e.excludeInitialCap,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this124.hyphenate = getInteger({
      data: e.hyphenate,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this124.id = e.id || "";
    _this124.pushCharacterCount = getInteger({
      data: e.pushCharacterCount,
      defaultValue: 3,
      validate: function validate(e) {
        return e >= 0;
      }
    });
    _this124.remainCharacterCount = getInteger({
      data: e.remainCharacterCount,
      defaultValue: 3,
      validate: function validate(e) {
        return e >= 0;
      }
    });
    _this124.use = e.use || "";
    _this124.usehref = e.usehref || "";
    _this124.wordCharacterCount = getInteger({
      data: e.wordCharacterCount,
      defaultValue: 7,
      validate: function validate(e) {
        return e >= 0;
      }
    });
    return _this124;
  }
  _inherits(Hyphenation, _XFAObject46);
  return _createClass(Hyphenation);
}(XFAObject);
var Image = /*#__PURE__*/function (_StringObject4) {
  function Image(e) {
    var _this125;
    _classCallCheck(this, Image);
    _this125 = _callSuper(this, Image, [vn, "image"]);
    _this125.aspect = getStringOption(e.aspect, ["fit", "actual", "height", "none", "width"]);
    _this125.contentType = e.contentType || "";
    _this125.href = e.href || "";
    _this125.id = e.id || "";
    _this125.name = e.name || "";
    _this125.transferEncoding = getStringOption(e.transferEncoding, ["base64", "none", "package"]);
    _this125.use = e.use || "";
    _this125.usehref = e.usehref || "";
    return _this125;
  }
  _inherits(Image, _StringObject4);
  return _createClass(Image, [{
    key: nn,
    value: function value() {
      if (this.contentType && !qn.has(this.contentType.toLowerCase())) return HTMLResult.EMPTY;
      var e = this[br].images && this[br].images.get(this.href);
      if (!e && (this.href || !this[ar])) return HTMLResult.EMPTY;
      e || "base64" !== this.transferEncoding || (e = function fromBase64Util(e) {
        return Uint8Array.fromBase64 ? Uint8Array.fromBase64(e) : stringToBytes(atob(e));
      }(this[ar]));
      if (!e) return HTMLResult.EMPTY;
      if (!this.contentType) {
        for (var _i336 = 0, _On = On; _i336 < _On.length; _i336++) {
          var _ref151 = _On[_i336];
          var _ref152 = _slicedToArray(_ref151, 2);
          var _t390 = _ref152[0];
          var _i337 = _ref152[1];
          if (e.length > _t390.length && _t390.every(function (t, i) {
            return t === e[i];
          })) {
            this.contentType = _i337;
            break;
          }
        }
        if (!this.contentType) return HTMLResult.EMPTY;
      }
      var t = new Blob([e], {
        type: this.contentType
      });
      var i;
      switch (this.aspect) {
        case "fit":
        case "actual":
          break;
        case "height":
          i = {
            height: "100%",
            objectFit: "fill"
          };
          break;
        case "none":
          i = {
            width: "100%",
            height: "100%",
            objectFit: "fill"
          };
          break;
        case "width":
          i = {
            width: "100%",
            objectFit: "fill"
          };
      }
      var a = this[wr]();
      return HTMLResult.success({
        name: "img",
        attributes: {
          class: ["xfaImage"],
          style: i,
          src: URL.createObjectURL(t),
          alt: a ? ariaLabel(a[wr]()) : null
        }
      });
    }
  }]);
}(StringObject);
var ImageEdit = /*#__PURE__*/function (_XFAObject47) {
  function ImageEdit(e) {
    var _this126;
    _classCallCheck(this, ImageEdit);
    _this126 = _callSuper(this, ImageEdit, [vn, "imageEdit", !0]);
    _this126.data = getStringOption(e.data, ["link", "embed"]);
    _this126.id = e.id || "";
    _this126.use = e.use || "";
    _this126.usehref = e.usehref || "";
    _this126.border = null;
    _this126.extras = null;
    _this126.margin = null;
    return _this126;
  }
  _inherits(ImageEdit, _XFAObject47);
  return _createClass(ImageEdit, [{
    key: nn,
    value: function value(e) {
      return "embed" === this.data ? HTMLResult.success({
        name: "div",
        children: [],
        attributes: {}
      }) : HTMLResult.EMPTY;
    }
  }]);
}(XFAObject);
var Integer = /*#__PURE__*/function (_ContentObject9) {
  function Integer(e) {
    var _this127;
    _classCallCheck(this, Integer);
    _this127 = _callSuper(this, Integer, [vn, "integer"]);
    _this127.id = e.id || "";
    _this127.name = e.name || "";
    _this127.use = e.use || "";
    _this127.usehref = e.usehref || "";
    return _this127;
  }
  _inherits(Integer, _ContentObject9);
  return _createClass(Integer, [{
    key: gr,
    value: function value() {
      var e = parseInt(this[ar].trim(), 10);
      this[ar] = isNaN(e) ? null : e;
    }
  }, {
    key: nn,
    value: function value(e) {
      return valueToHtml(null !== this[ar] ? this[ar].toString() : "");
    }
  }]);
}(ContentObject);
var Issuers = /*#__PURE__*/function (_XFAObject48) {
  function Issuers(e) {
    var _this128;
    _classCallCheck(this, Issuers);
    _this128 = _callSuper(this, Issuers, [vn, "issuers", !0]);
    _this128.id = e.id || "";
    _this128.type = getStringOption(e.type, ["optional", "required"]);
    _this128.use = e.use || "";
    _this128.usehref = e.usehref || "";
    _this128.certificate = new XFAObjectArray();
    return _this128;
  }
  _inherits(Issuers, _XFAObject48);
  return _createClass(Issuers);
}(XFAObject);
var Items = /*#__PURE__*/function (_XFAObject49) {
  function Items(e) {
    var _this129;
    _classCallCheck(this, Items);
    _this129 = _callSuper(this, Items, [vn, "items", !0]);
    _this129.id = e.id || "";
    _this129.name = e.name || "";
    _this129.presence = getStringOption(e.presence, ["visible", "hidden", "inactive", "invisible"]);
    _this129.ref = e.ref || "";
    _this129.save = getInteger({
      data: e.save,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this129.use = e.use || "";
    _this129.usehref = e.usehref || "";
    _this129.boolean = new XFAObjectArray();
    _this129.date = new XFAObjectArray();
    _this129.dateTime = new XFAObjectArray();
    _this129.decimal = new XFAObjectArray();
    _this129.exData = new XFAObjectArray();
    _this129.float = new XFAObjectArray();
    _this129.image = new XFAObjectArray();
    _this129.integer = new XFAObjectArray();
    _this129.text = new XFAObjectArray();
    _this129.time = new XFAObjectArray();
    return _this129;
  }
  _inherits(Items, _XFAObject49);
  return _createClass(Items, [{
    key: nn,
    value: function value() {
      var e = [];
      var _iterator167 = _createForOfIteratorHelper(this[fr]()),
        _step167;
      try {
        for (_iterator167.s(); !(_step167 = _iterator167.n()).done;) {
          var _t391 = _step167.value;
          e.push(_t391[sn]());
        }
      } catch (err) {
        _iterator167.e(err);
      } finally {
        _iterator167.f();
      }
      return HTMLResult.success(e);
    }
  }]);
}(XFAObject);
var Keep = /*#__PURE__*/function (_XFAObject50) {
  function Keep(e) {
    var _this130;
    _classCallCheck(this, Keep);
    _this130 = _callSuper(this, Keep, [vn, "keep", !0]);
    _this130.id = e.id || "";
    var t = ["none", "contentArea", "pageArea"];
    _this130.intact = getStringOption(e.intact, t);
    _this130.next = getStringOption(e.next, t);
    _this130.previous = getStringOption(e.previous, t);
    _this130.use = e.use || "";
    _this130.usehref = e.usehref || "";
    _this130.extras = null;
    return _this130;
  }
  _inherits(Keep, _XFAObject50);
  return _createClass(Keep);
}(XFAObject);
var KeyUsage = /*#__PURE__*/function (_XFAObject51) {
  function KeyUsage(e) {
    var _this131;
    _classCallCheck(this, KeyUsage);
    _this131 = _callSuper(this, KeyUsage, [vn, "keyUsage"]);
    var t = ["", "yes", "no"];
    _this131.crlSign = getStringOption(e.crlSign, t);
    _this131.dataEncipherment = getStringOption(e.dataEncipherment, t);
    _this131.decipherOnly = getStringOption(e.decipherOnly, t);
    _this131.digitalSignature = getStringOption(e.digitalSignature, t);
    _this131.encipherOnly = getStringOption(e.encipherOnly, t);
    _this131.id = e.id || "";
    _this131.keyAgreement = getStringOption(e.keyAgreement, t);
    _this131.keyCertSign = getStringOption(e.keyCertSign, t);
    _this131.keyEncipherment = getStringOption(e.keyEncipherment, t);
    _this131.nonRepudiation = getStringOption(e.nonRepudiation, t);
    _this131.type = getStringOption(e.type, ["optional", "required"]);
    _this131.use = e.use || "";
    _this131.usehref = e.usehref || "";
    return _this131;
  }
  _inherits(KeyUsage, _XFAObject51);
  return _createClass(KeyUsage);
}(XFAObject);
var Line = /*#__PURE__*/function (_XFAObject52) {
  function Line(e) {
    var _this132;
    _classCallCheck(this, Line);
    _this132 = _callSuper(this, Line, [vn, "line", !0]);
    _this132.hand = getStringOption(e.hand, ["even", "left", "right"]);
    _this132.id = e.id || "";
    _this132.slope = getStringOption(e.slope, ["\\", "/"]);
    _this132.use = e.use || "";
    _this132.usehref = e.usehref || "";
    _this132.edge = null;
    return _this132;
  }
  _inherits(Line, _XFAObject52);
  return _createClass(Line, [{
    key: nn,
    value: function value() {
      var _ref153, _ref154;
      var e = this[wr]()[wr](),
        t = this.edge || new Edge({}),
        i = t[on](),
        a = Object.create(null),
        s = "visible" === t.presence ? t.thickness : 0;
      a.strokeWidth = measureToString(s);
      a.stroke = i.color;
      var r,
        n,
        g,
        o,
        c = "100%",
        C = "100%";
      if (e.w <= s) {
        r = "50%";
        n = 0;
        g = "50%";
        o = "100%";
        c = a.strokeWidth;
      } else if (e.h <= s) {
        r = 0;
        n = "50%";
        g = "100%";
        o = "50%";
        C = a.strokeWidth;
      } else "\\" === this.slope ? (_ref153 = [0, 0, "100%", "100%"], r = _ref153[0], n = _ref153[1], g = _ref153[2], o = _ref153[3], _ref153) : (_ref154 = [0, "100%", "100%", 0], r = _ref154[0], n = _ref154[1], g = _ref154[2], o = _ref154[3], _ref154);
      var h = {
        name: "svg",
        children: [{
          name: "line",
          attributes: {
            xmlns: Kn,
            x1: r,
            y1: n,
            x2: g,
            y2: o,
            style: a
          }
        }],
        attributes: {
          xmlns: Kn,
          width: c,
          height: C,
          style: {
            overflow: "visible"
          }
        }
      };
      if (hasMargin(e)) return HTMLResult.success({
        name: "div",
        attributes: {
          style: {
            display: "inline",
            width: "100%",
            height: "100%"
          }
        },
        children: [h]
      });
      h.attributes.style.position = "absolute";
      return HTMLResult.success(h);
    }
  }]);
}(XFAObject);
var Linear = /*#__PURE__*/function (_XFAObject53) {
  function Linear(e) {
    var _this133;
    _classCallCheck(this, Linear);
    _this133 = _callSuper(this, Linear, [vn, "linear", !0]);
    _this133.id = e.id || "";
    _this133.type = getStringOption(e.type, ["toRight", "toBottom", "toLeft", "toTop"]);
    _this133.use = e.use || "";
    _this133.usehref = e.usehref || "";
    _this133.color = null;
    _this133.extras = null;
    return _this133;
  }
  _inherits(Linear, _XFAObject53);
  return _createClass(Linear, [{
    key: on,
    value: function value(e) {
      e = e ? e[on]() : "#FFFFFF";
      return "linear-gradient(".concat(this.type.replace(/([RBLT])/, " $1").toLowerCase(), ", ").concat(e, ", ").concat(this.color ? this.color[on]() : "#000000", ")");
    }
  }]);
}(XFAObject);
var LockDocument = /*#__PURE__*/function (_ContentObject10) {
  function LockDocument(e) {
    var _this134;
    _classCallCheck(this, LockDocument);
    _this134 = _callSuper(this, LockDocument, [vn, "lockDocument"]);
    _this134.id = e.id || "";
    _this134.type = getStringOption(e.type, ["optional", "required"]);
    _this134.use = e.use || "";
    _this134.usehref = e.usehref || "";
    return _this134;
  }
  _inherits(LockDocument, _ContentObject10);
  return _createClass(LockDocument, [{
    key: gr,
    value: function value() {
      this[ar] = getStringOption(this[ar], ["auto", "0", "1"]);
    }
  }]);
}(ContentObject);
var Manifest = /*#__PURE__*/function (_XFAObject54) {
  function Manifest(e) {
    var _this135;
    _classCallCheck(this, Manifest);
    _this135 = _callSuper(this, Manifest, [vn, "manifest", !0]);
    _this135.action = getStringOption(e.action, ["include", "all", "exclude"]);
    _this135.id = e.id || "";
    _this135.name = e.name || "";
    _this135.use = e.use || "";
    _this135.usehref = e.usehref || "";
    _this135.extras = null;
    _this135.ref = new XFAObjectArray();
    return _this135;
  }
  _inherits(Manifest, _XFAObject54);
  return _createClass(Manifest);
}(XFAObject);
var Margin = /*#__PURE__*/function (_XFAObject55) {
  function Margin(e) {
    var _this136;
    _classCallCheck(this, Margin);
    _this136 = _callSuper(this, Margin, [vn, "margin", !0]);
    _this136.bottomInset = getMeasurement(e.bottomInset, "0");
    _this136.id = e.id || "";
    _this136.leftInset = getMeasurement(e.leftInset, "0");
    _this136.rightInset = getMeasurement(e.rightInset, "0");
    _this136.topInset = getMeasurement(e.topInset, "0");
    _this136.use = e.use || "";
    _this136.usehref = e.usehref || "";
    _this136.extras = null;
    return _this136;
  }
  _inherits(Margin, _XFAObject55);
  return _createClass(Margin, [{
    key: on,
    value: function value() {
      return {
        margin: measureToString(this.topInset) + " " + measureToString(this.rightInset) + " " + measureToString(this.bottomInset) + " " + measureToString(this.leftInset)
      };
    }
  }]);
}(XFAObject);
var Mdp = /*#__PURE__*/function (_XFAObject56) {
  function Mdp(e) {
    var _this137;
    _classCallCheck(this, Mdp);
    _this137 = _callSuper(this, Mdp, [vn, "mdp"]);
    _this137.id = e.id || "";
    _this137.permissions = getInteger({
      data: e.permissions,
      defaultValue: 2,
      validate: function validate(e) {
        return 1 === e || 3 === e;
      }
    });
    _this137.signatureType = getStringOption(e.signatureType, ["filler", "author"]);
    _this137.use = e.use || "";
    _this137.usehref = e.usehref || "";
    return _this137;
  }
  _inherits(Mdp, _XFAObject56);
  return _createClass(Mdp);
}(XFAObject);
var Medium = /*#__PURE__*/function (_XFAObject57) {
  function Medium(e) {
    var _this138;
    _classCallCheck(this, Medium);
    _this138 = _callSuper(this, Medium, [vn, "medium"]);
    _this138.id = e.id || "";
    _this138.imagingBBox = function getBBox(e) {
      var t = -1;
      if (!e) return {
        x: t,
        y: t,
        width: t,
        height: t
      };
      var i = e.trim().split(/\s*,\s*/).map(function (e) {
        return getMeasurement(e, "-1");
      });
      if (i.length < 4 || i[2] < 0 || i[3] < 0) return {
        x: t,
        y: t,
        width: t,
        height: t
      };
      var _i338 = _slicedToArray(i, 4),
        a = _i338[0],
        s = _i338[1],
        r = _i338[2],
        n = _i338[3];
      return {
        x: a,
        y: s,
        width: r,
        height: n
      };
    }(e.imagingBBox);
    _this138.long = getMeasurement(e.long);
    _this138.orientation = getStringOption(e.orientation, ["portrait", "landscape"]);
    _this138.short = getMeasurement(e.short);
    _this138.stock = e.stock || "";
    _this138.trayIn = getStringOption(e.trayIn, ["auto", "delegate", "pageFront"]);
    _this138.trayOut = getStringOption(e.trayOut, ["auto", "delegate"]);
    _this138.use = e.use || "";
    _this138.usehref = e.usehref || "";
    return _this138;
  }
  _inherits(Medium, _XFAObject57);
  return _createClass(Medium);
}(XFAObject);
var Message = /*#__PURE__*/function (_XFAObject58) {
  function Message(e) {
    var _this139;
    _classCallCheck(this, Message);
    _this139 = _callSuper(this, Message, [vn, "message", !0]);
    _this139.id = e.id || "";
    _this139.use = e.use || "";
    _this139.usehref = e.usehref || "";
    _this139.text = new XFAObjectArray();
    return _this139;
  }
  _inherits(Message, _XFAObject58);
  return _createClass(Message);
}(XFAObject);
var NumericEdit = /*#__PURE__*/function (_XFAObject59) {
  function NumericEdit(e) {
    var _this140;
    _classCallCheck(this, NumericEdit);
    _this140 = _callSuper(this, NumericEdit, [vn, "numericEdit", !0]);
    _this140.hScrollPolicy = getStringOption(e.hScrollPolicy, ["auto", "off", "on"]);
    _this140.id = e.id || "";
    _this140.use = e.use || "";
    _this140.usehref = e.usehref || "";
    _this140.border = null;
    _this140.comb = null;
    _this140.extras = null;
    _this140.margin = null;
    return _this140;
  }
  _inherits(NumericEdit, _XFAObject59);
  return _createClass(NumericEdit, [{
    key: nn,
    value: function value(e) {
      var _i$sr3;
      var t = toStyle(this, "border", "font", "margin"),
        i = this[wr]()[wr](),
        a = {
          name: "input",
          attributes: {
            type: "text",
            fieldId: i[In],
            dataId: ((_i$sr3 = i[sr]) === null || _i$sr3 === void 0 ? void 0 : _i$sr3[In]) || i[In],
            class: ["xfaTextfield"],
            style: t,
            "aria-label": ariaLabel(i),
            "aria-required": !1
          }
        };
      if (isRequired(i)) {
        a.attributes["aria-required"] = !0;
        a.attributes.required = !0;
      }
      return HTMLResult.success({
        name: "label",
        attributes: {
          class: ["xfaLabel"]
        },
        children: [a]
      });
    }
  }]);
}(XFAObject);
var Occur = /*#__PURE__*/function (_XFAObject60) {
  function Occur(e) {
    var _this141;
    _classCallCheck(this, Occur);
    _this141 = _callSuper(this, Occur, [vn, "occur", !0]);
    _this141.id = e.id || "";
    _this141.initial = "" !== e.initial ? getInteger({
      data: e.initial,
      defaultValue: "",
      validate: function validate(e) {
        return !0;
      }
    }) : "";
    _this141.max = "" !== e.max ? getInteger({
      data: e.max,
      defaultValue: 1,
      validate: function validate(e) {
        return !0;
      }
    }) : "";
    _this141.min = "" !== e.min ? getInteger({
      data: e.min,
      defaultValue: 1,
      validate: function validate(e) {
        return !0;
      }
    }) : "";
    _this141.use = e.use || "";
    _this141.usehref = e.usehref || "";
    _this141.extras = null;
    return _this141;
  }
  _inherits(Occur, _XFAObject60);
  return _createClass(Occur, [{
    key: $s,
    value: function value() {
      var e = this[wr](),
        t = this.min;
      "" === this.min && (this.min = e instanceof PageArea || e instanceof PageSet ? 0 : 1);
      "" === this.max && (this.max = "" === t ? e instanceof PageArea || e instanceof PageSet ? -1 : 1 : this.min);
      -1 !== this.max && this.max < this.min && (this.max = this.min);
      "" === this.initial && (this.initial = e instanceof Template ? 1 : this.min);
    }
  }]);
}(XFAObject);
var Oid = /*#__PURE__*/function (_StringObject5) {
  function Oid(e) {
    var _this142;
    _classCallCheck(this, Oid);
    _this142 = _callSuper(this, Oid, [vn, "oid"]);
    _this142.id = e.id || "";
    _this142.name = e.name || "";
    _this142.use = e.use || "";
    _this142.usehref = e.usehref || "";
    return _this142;
  }
  _inherits(Oid, _StringObject5);
  return _createClass(Oid);
}(StringObject);
var Oids = /*#__PURE__*/function (_XFAObject61) {
  function Oids(e) {
    var _this143;
    _classCallCheck(this, Oids);
    _this143 = _callSuper(this, Oids, [vn, "oids", !0]);
    _this143.id = e.id || "";
    _this143.type = getStringOption(e.type, ["optional", "required"]);
    _this143.use = e.use || "";
    _this143.usehref = e.usehref || "";
    _this143.oid = new XFAObjectArray();
    return _this143;
  }
  _inherits(Oids, _XFAObject61);
  return _createClass(Oids);
}(XFAObject);
var Overflow = /*#__PURE__*/function (_XFAObject62) {
  function Overflow(e) {
    var _this144;
    _classCallCheck(this, Overflow);
    _this144 = _callSuper(this, Overflow, [vn, "overflow"]);
    _this144.id = e.id || "";
    _this144.leader = e.leader || "";
    _this144.target = e.target || "";
    _this144.trailer = e.trailer || "";
    _this144.use = e.use || "";
    _this144.usehref = e.usehref || "";
    return _this144;
  }
  _inherits(Overflow, _XFAObject62);
  return _createClass(Overflow, [{
    key: ur,
    value: function value() {
      if (!this[nr]) {
        var _e514 = this[wr](),
          _t392 = this[Dr](),
          _i339 = _t392[$r](this.target, _e514),
          _a269 = _t392[$r](this.leader, _e514),
          _s179 = _t392[$r](this.trailer, _e514);
        this[nr] = {
          target: (_i339 === null || _i339 === void 0 ? void 0 : _i339[0]) || null,
          leader: (_a269 === null || _a269 === void 0 ? void 0 : _a269[0]) || null,
          trailer: (_s179 === null || _s179 === void 0 ? void 0 : _s179[0]) || null,
          addLeader: !1,
          addTrailer: !1
        };
      }
      return this[nr];
    }
  }]);
}(XFAObject);
var PageArea = /*#__PURE__*/function (_XFAObject63) {
  function PageArea(e) {
    var _this145;
    _classCallCheck(this, PageArea);
    _this145 = _callSuper(this, PageArea, [vn, "pageArea", !0]);
    _this145.blankOrNotBlank = getStringOption(e.blankOrNotBlank, ["any", "blank", "notBlank"]);
    _this145.id = e.id || "";
    _this145.initialNumber = getInteger({
      data: e.initialNumber,
      defaultValue: 1,
      validate: function validate(e) {
        return !0;
      }
    });
    _this145.name = e.name || "";
    _this145.numbered = getInteger({
      data: e.numbered,
      defaultValue: 1,
      validate: function validate(e) {
        return !0;
      }
    });
    _this145.oddOrEven = getStringOption(e.oddOrEven, ["any", "even", "odd"]);
    _this145.pagePosition = getStringOption(e.pagePosition, ["any", "first", "last", "only", "rest"]);
    _this145.relevant = getRelevant(e.relevant);
    _this145.use = e.use || "";
    _this145.usehref = e.usehref || "";
    _this145.desc = null;
    _this145.extras = null;
    _this145.medium = null;
    _this145.occur = null;
    _this145.area = new XFAObjectArray();
    _this145.contentArea = new XFAObjectArray();
    _this145.draw = new XFAObjectArray();
    _this145.exclGroup = new XFAObjectArray();
    _this145.field = new XFAObjectArray();
    _this145.subform = new XFAObjectArray();
    return _this145;
  }
  _inherits(PageArea, _XFAObject63);
  return _createClass(PageArea, [{
    key: Yr,
    value: function value() {
      if (!this[nr]) {
        this[nr] = {
          numberOfUse: 0
        };
        return !0;
      }
      return !this.occur || -1 === this.occur.max || this[nr].numberOfUse < this.occur.max;
    }
  }, {
    key: Ar,
    value: function value() {
      delete this[nr];
    }
  }, {
    key: mr,
    value: function value() {
      this[nr] || (this[nr] = {
        numberOfUse: 0
      });
      var e = this[wr]();
      if ("orderedOccurrence" === e.relation && this[Yr]()) {
        this[nr].numberOfUse += 1;
        return this;
      }
      return e[mr]();
    }
  }, {
    key: Cr,
    value: function value() {
      return this[nr].space || {
        width: 0,
        height: 0
      };
    }
  }, {
    key: nn,
    value: function value() {
      this[nr] || (this[nr] = {
        numberOfUse: 1
      });
      var e = [];
      this[nr].children = e;
      var t = Object.create(null);
      if (this.medium && this.medium.short && this.medium.long) {
        t.width = measureToString(this.medium.short);
        t.height = measureToString(this.medium.long);
        this[nr].space = {
          width: this.medium.short,
          height: this.medium.long
        };
        if ("landscape" === this.medium.orientation) {
          var _e515 = t.width;
          t.width = t.height;
          t.height = _e515;
          this[nr].space = {
            width: this.medium.long,
            height: this.medium.short
          };
        }
      } else warn("XFA - No medium specified in pageArea: please file a bug.");
      this[_s]({
        filter: new Set(["area", "draw", "field", "subform"]),
        include: !0
      });
      this[_s]({
        filter: new Set(["contentArea"]),
        include: !0
      });
      return HTMLResult.success({
        name: "div",
        children: e,
        attributes: {
          class: ["xfaPage"],
          id: this[In],
          style: t,
          xfaName: this.name
        }
      });
    }
  }]);
}(XFAObject);
var PageSet = /*#__PURE__*/function (_XFAObject64) {
  function PageSet(e) {
    var _this146;
    _classCallCheck(this, PageSet);
    _this146 = _callSuper(this, PageSet, [vn, "pageSet", !0]);
    _this146.duplexImposition = getStringOption(e.duplexImposition, ["longEdge", "shortEdge"]);
    _this146.id = e.id || "";
    _this146.name = e.name || "";
    _this146.relation = getStringOption(e.relation, ["orderedOccurrence", "duplexPaginated", "simplexPaginated"]);
    _this146.relevant = getRelevant(e.relevant);
    _this146.use = e.use || "";
    _this146.usehref = e.usehref || "";
    _this146.extras = null;
    _this146.occur = null;
    _this146.pageArea = new XFAObjectArray();
    _this146.pageSet = new XFAObjectArray();
    return _this146;
  }
  _inherits(PageSet, _XFAObject64);
  return _createClass(PageSet, [{
    key: Ar,
    value: function value() {
      var _iterator168 = _createForOfIteratorHelper(this.pageArea.children),
        _step168;
      try {
        for (_iterator168.s(); !(_step168 = _iterator168.n()).done;) {
          var _e516 = _step168.value;
          _e516[Ar]();
        }
      } catch (err) {
        _iterator168.e(err);
      } finally {
        _iterator168.f();
      }
      var _iterator169 = _createForOfIteratorHelper(this.pageSet.children),
        _step169;
      try {
        for (_iterator169.s(); !(_step169 = _iterator169.n()).done;) {
          var _e517 = _step169.value;
          _e517[Ar]();
        }
      } catch (err) {
        _iterator169.e(err);
      } finally {
        _iterator169.f();
      }
    }
  }, {
    key: Yr,
    value: function value() {
      return !this.occur || -1 === this.occur.max || this[nr].numberOfUse < this.occur.max;
    }
  }, {
    key: mr,
    value: function value() {
      this[nr] || (this[nr] = {
        numberOfUse: 1,
        pageIndex: -1,
        pageSetIndex: -1
      });
      if ("orderedOccurrence" === this.relation) {
        if (this[nr].pageIndex + 1 < this.pageArea.children.length) {
          this[nr].pageIndex += 1;
          return this.pageArea.children[this[nr].pageIndex][mr]();
        }
        if (this[nr].pageSetIndex + 1 < this.pageSet.children.length) {
          this[nr].pageSetIndex += 1;
          return this.pageSet.children[this[nr].pageSetIndex][mr]();
        }
        if (this[Yr]()) {
          this[nr].numberOfUse += 1;
          this[nr].pageIndex = -1;
          this[nr].pageSetIndex = -1;
          return this[mr]();
        }
        var _e518 = this[wr]();
        if (_e518 instanceof PageSet) return _e518[mr]();
        this[Ar]();
        return this[mr]();
      }
      var e = this[Dr]()[nr].pageNumber,
        t = e % 2 == 0 ? "even" : "odd",
        i = 0 === e ? "first" : "rest";
      var a = this.pageArea.children.find(function (e) {
        return e.oddOrEven === t && e.pagePosition === i;
      });
      if (a) return a;
      a = this.pageArea.children.find(function (e) {
        return "any" === e.oddOrEven && e.pagePosition === i;
      });
      if (a) return a;
      a = this.pageArea.children.find(function (e) {
        return "any" === e.oddOrEven && "any" === e.pagePosition;
      });
      return a || this.pageArea.children[0];
    }
  }]);
}(XFAObject);
var Para = /*#__PURE__*/function (_XFAObject65) {
  function Para(e) {
    var _this147;
    _classCallCheck(this, Para);
    _this147 = _callSuper(this, Para, [vn, "para", !0]);
    _this147.hAlign = getStringOption(e.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]);
    _this147.id = e.id || "";
    _this147.lineHeight = e.lineHeight ? getMeasurement(e.lineHeight, "0pt") : "";
    _this147.marginLeft = e.marginLeft ? getMeasurement(e.marginLeft, "0pt") : "";
    _this147.marginRight = e.marginRight ? getMeasurement(e.marginRight, "0pt") : "";
    _this147.orphans = getInteger({
      data: e.orphans,
      defaultValue: 0,
      validate: function validate(e) {
        return e >= 0;
      }
    });
    _this147.preserve = e.preserve || "";
    _this147.radixOffset = e.radixOffset ? getMeasurement(e.radixOffset, "0pt") : "";
    _this147.spaceAbove = e.spaceAbove ? getMeasurement(e.spaceAbove, "0pt") : "";
    _this147.spaceBelow = e.spaceBelow ? getMeasurement(e.spaceBelow, "0pt") : "";
    _this147.tabDefault = e.tabDefault ? getMeasurement(_this147.tabDefault) : "";
    _this147.tabStops = (e.tabStops || "").trim().split(/\s+/).map(function (e, t) {
      return t % 2 == 1 ? getMeasurement(e) : e;
    });
    _this147.textIndent = e.textIndent ? getMeasurement(e.textIndent, "0pt") : "";
    _this147.use = e.use || "";
    _this147.usehref = e.usehref || "";
    _this147.vAlign = getStringOption(e.vAlign, ["top", "bottom", "middle"]);
    _this147.widows = getInteger({
      data: e.widows,
      defaultValue: 0,
      validate: function validate(e) {
        return e >= 0;
      }
    });
    _this147.hyphenation = null;
    return _this147;
  }
  _inherits(Para, _XFAObject65);
  return _createClass(Para, [{
    key: on,
    value: function value() {
      var e = toStyle(this, "hAlign");
      "" !== this.marginLeft && (e.paddingLeft = measureToString(this.marginLeft));
      "" !== this.marginRight && (e.paddingight = measureToString(this.marginRight));
      "" !== this.spaceAbove && (e.paddingTop = measureToString(this.spaceAbove));
      "" !== this.spaceBelow && (e.paddingBottom = measureToString(this.spaceBelow));
      if ("" !== this.textIndent) {
        e.textIndent = measureToString(this.textIndent);
        fixTextIndent(e);
      }
      this.lineHeight > 0 && (e.lineHeight = measureToString(this.lineHeight));
      "" !== this.tabDefault && (e.tabSize = measureToString(this.tabDefault));
      this.tabStops.length;
      this.hyphenatation && Object.assign(e, this.hyphenatation[on]());
      return e;
    }
  }]);
}(XFAObject);
var PasswordEdit = /*#__PURE__*/function (_XFAObject66) {
  function PasswordEdit(e) {
    var _this148;
    _classCallCheck(this, PasswordEdit);
    _this148 = _callSuper(this, PasswordEdit, [vn, "passwordEdit", !0]);
    _this148.hScrollPolicy = getStringOption(e.hScrollPolicy, ["auto", "off", "on"]);
    _this148.id = e.id || "";
    _this148.passwordChar = e.passwordChar || "*";
    _this148.use = e.use || "";
    _this148.usehref = e.usehref || "";
    _this148.border = null;
    _this148.extras = null;
    _this148.margin = null;
    return _this148;
  }
  _inherits(PasswordEdit, _XFAObject66);
  return _createClass(PasswordEdit);
}(XFAObject);
var template_Pattern = /*#__PURE__*/function (_XFAObject67) {
  function template_Pattern(e) {
    var _this149;
    _classCallCheck(this, template_Pattern);
    _this149 = _callSuper(this, template_Pattern, [vn, "pattern", !0]);
    _this149.id = e.id || "";
    _this149.type = getStringOption(e.type, ["crossHatch", "crossDiagonal", "diagonalLeft", "diagonalRight", "horizontal", "vertical"]);
    _this149.use = e.use || "";
    _this149.usehref = e.usehref || "";
    _this149.color = null;
    _this149.extras = null;
    return _this149;
  }
  _inherits(template_Pattern, _XFAObject67);
  return _createClass(template_Pattern, [{
    key: on,
    value: function value(e) {
      e = e ? e[on]() : "#FFFFFF";
      var t = this.color ? this.color[on]() : "#000000",
        i = "repeating-linear-gradient",
        a = "".concat(e, ",").concat(e, " 5px,").concat(t, " 5px,").concat(t, " 10px");
      switch (this.type) {
        case "crossHatch":
          return "".concat(i, "(to top,").concat(a, ") ").concat(i, "(to right,").concat(a, ")");
        case "crossDiagonal":
          return "".concat(i, "(45deg,").concat(a, ") ").concat(i, "(-45deg,").concat(a, ")");
        case "diagonalLeft":
          return "".concat(i, "(45deg,").concat(a, ")");
        case "diagonalRight":
          return "".concat(i, "(-45deg,").concat(a, ")");
        case "horizontal":
          return "".concat(i, "(to top,").concat(a, ")");
        case "vertical":
          return "".concat(i, "(to right,").concat(a, ")");
      }
      return "";
    }
  }]);
}(XFAObject);
var Picture = /*#__PURE__*/function (_StringObject6) {
  function Picture(e) {
    var _this150;
    _classCallCheck(this, Picture);
    _this150 = _callSuper(this, Picture, [vn, "picture"]);
    _this150.id = e.id || "";
    _this150.use = e.use || "";
    _this150.usehref = e.usehref || "";
    return _this150;
  }
  _inherits(Picture, _StringObject6);
  return _createClass(Picture);
}(StringObject);
var Proto = /*#__PURE__*/function (_XFAObject68) {
  function Proto(e) {
    var _this151;
    _classCallCheck(this, Proto);
    _this151 = _callSuper(this, Proto, [vn, "proto", !0]);
    _this151.appearanceFilter = new XFAObjectArray();
    _this151.arc = new XFAObjectArray();
    _this151.area = new XFAObjectArray();
    _this151.assist = new XFAObjectArray();
    _this151.barcode = new XFAObjectArray();
    _this151.bindItems = new XFAObjectArray();
    _this151.bookend = new XFAObjectArray();
    _this151.boolean = new XFAObjectArray();
    _this151.border = new XFAObjectArray();
    _this151.break = new XFAObjectArray();
    _this151.breakAfter = new XFAObjectArray();
    _this151.breakBefore = new XFAObjectArray();
    _this151.button = new XFAObjectArray();
    _this151.calculate = new XFAObjectArray();
    _this151.caption = new XFAObjectArray();
    _this151.certificate = new XFAObjectArray();
    _this151.certificates = new XFAObjectArray();
    _this151.checkButton = new XFAObjectArray();
    _this151.choiceList = new XFAObjectArray();
    _this151.color = new XFAObjectArray();
    _this151.comb = new XFAObjectArray();
    _this151.connect = new XFAObjectArray();
    _this151.contentArea = new XFAObjectArray();
    _this151.corner = new XFAObjectArray();
    _this151.date = new XFAObjectArray();
    _this151.dateTime = new XFAObjectArray();
    _this151.dateTimeEdit = new XFAObjectArray();
    _this151.decimal = new XFAObjectArray();
    _this151.defaultUi = new XFAObjectArray();
    _this151.desc = new XFAObjectArray();
    _this151.digestMethod = new XFAObjectArray();
    _this151.digestMethods = new XFAObjectArray();
    _this151.draw = new XFAObjectArray();
    _this151.edge = new XFAObjectArray();
    _this151.encoding = new XFAObjectArray();
    _this151.encodings = new XFAObjectArray();
    _this151.encrypt = new XFAObjectArray();
    _this151.encryptData = new XFAObjectArray();
    _this151.encryption = new XFAObjectArray();
    _this151.encryptionMethod = new XFAObjectArray();
    _this151.encryptionMethods = new XFAObjectArray();
    _this151.event = new XFAObjectArray();
    _this151.exData = new XFAObjectArray();
    _this151.exObject = new XFAObjectArray();
    _this151.exclGroup = new XFAObjectArray();
    _this151.execute = new XFAObjectArray();
    _this151.extras = new XFAObjectArray();
    _this151.field = new XFAObjectArray();
    _this151.fill = new XFAObjectArray();
    _this151.filter = new XFAObjectArray();
    _this151.float = new XFAObjectArray();
    _this151.font = new XFAObjectArray();
    _this151.format = new XFAObjectArray();
    _this151.handler = new XFAObjectArray();
    _this151.hyphenation = new XFAObjectArray();
    _this151.image = new XFAObjectArray();
    _this151.imageEdit = new XFAObjectArray();
    _this151.integer = new XFAObjectArray();
    _this151.issuers = new XFAObjectArray();
    _this151.items = new XFAObjectArray();
    _this151.keep = new XFAObjectArray();
    _this151.keyUsage = new XFAObjectArray();
    _this151.line = new XFAObjectArray();
    _this151.linear = new XFAObjectArray();
    _this151.lockDocument = new XFAObjectArray();
    _this151.manifest = new XFAObjectArray();
    _this151.margin = new XFAObjectArray();
    _this151.mdp = new XFAObjectArray();
    _this151.medium = new XFAObjectArray();
    _this151.message = new XFAObjectArray();
    _this151.numericEdit = new XFAObjectArray();
    _this151.occur = new XFAObjectArray();
    _this151.oid = new XFAObjectArray();
    _this151.oids = new XFAObjectArray();
    _this151.overflow = new XFAObjectArray();
    _this151.pageArea = new XFAObjectArray();
    _this151.pageSet = new XFAObjectArray();
    _this151.para = new XFAObjectArray();
    _this151.passwordEdit = new XFAObjectArray();
    _this151.pattern = new XFAObjectArray();
    _this151.picture = new XFAObjectArray();
    _this151.radial = new XFAObjectArray();
    _this151.reason = new XFAObjectArray();
    _this151.reasons = new XFAObjectArray();
    _this151.rectangle = new XFAObjectArray();
    _this151.ref = new XFAObjectArray();
    _this151.script = new XFAObjectArray();
    _this151.setProperty = new XFAObjectArray();
    _this151.signData = new XFAObjectArray();
    _this151.signature = new XFAObjectArray();
    _this151.signing = new XFAObjectArray();
    _this151.solid = new XFAObjectArray();
    _this151.speak = new XFAObjectArray();
    _this151.stipple = new XFAObjectArray();
    _this151.subform = new XFAObjectArray();
    _this151.subformSet = new XFAObjectArray();
    _this151.subjectDN = new XFAObjectArray();
    _this151.subjectDNs = new XFAObjectArray();
    _this151.submit = new XFAObjectArray();
    _this151.text = new XFAObjectArray();
    _this151.textEdit = new XFAObjectArray();
    _this151.time = new XFAObjectArray();
    _this151.timeStamp = new XFAObjectArray();
    _this151.toolTip = new XFAObjectArray();
    _this151.traversal = new XFAObjectArray();
    _this151.traverse = new XFAObjectArray();
    _this151.ui = new XFAObjectArray();
    _this151.validate = new XFAObjectArray();
    _this151.value = new XFAObjectArray();
    _this151.variables = new XFAObjectArray();
    return _this151;
  }
  _inherits(Proto, _XFAObject68);
  return _createClass(Proto);
}(XFAObject);
var Radial = /*#__PURE__*/function (_XFAObject69) {
  function Radial(e) {
    var _this152;
    _classCallCheck(this, Radial);
    _this152 = _callSuper(this, Radial, [vn, "radial", !0]);
    _this152.id = e.id || "";
    _this152.type = getStringOption(e.type, ["toEdge", "toCenter"]);
    _this152.use = e.use || "";
    _this152.usehref = e.usehref || "";
    _this152.color = null;
    _this152.extras = null;
    return _this152;
  }
  _inherits(Radial, _XFAObject69);
  return _createClass(Radial, [{
    key: on,
    value: function value(e) {
      e = e ? e[on]() : "#FFFFFF";
      var t = this.color ? this.color[on]() : "#000000";
      return "radial-gradient(circle at center, ".concat("toEdge" === this.type ? "".concat(e, ",").concat(t) : "".concat(t, ",").concat(e), ")");
    }
  }]);
}(XFAObject);
var Reason = /*#__PURE__*/function (_StringObject7) {
  function Reason(e) {
    var _this153;
    _classCallCheck(this, Reason);
    _this153 = _callSuper(this, Reason, [vn, "reason"]);
    _this153.id = e.id || "";
    _this153.name = e.name || "";
    _this153.use = e.use || "";
    _this153.usehref = e.usehref || "";
    return _this153;
  }
  _inherits(Reason, _StringObject7);
  return _createClass(Reason);
}(StringObject);
var Reasons = /*#__PURE__*/function (_XFAObject70) {
  function Reasons(e) {
    var _this154;
    _classCallCheck(this, Reasons);
    _this154 = _callSuper(this, Reasons, [vn, "reasons", !0]);
    _this154.id = e.id || "";
    _this154.type = getStringOption(e.type, ["optional", "required"]);
    _this154.use = e.use || "";
    _this154.usehref = e.usehref || "";
    _this154.reason = new XFAObjectArray();
    return _this154;
  }
  _inherits(Reasons, _XFAObject70);
  return _createClass(Reasons);
}(XFAObject);
var Rectangle = /*#__PURE__*/function (_XFAObject71) {
  function Rectangle(e) {
    var _this155;
    _classCallCheck(this, Rectangle);
    _this155 = _callSuper(this, Rectangle, [vn, "rectangle", !0]);
    _this155.hand = getStringOption(e.hand, ["even", "left", "right"]);
    _this155.id = e.id || "";
    _this155.use = e.use || "";
    _this155.usehref = e.usehref || "";
    _this155.corner = new XFAObjectArray(4);
    _this155.edge = new XFAObjectArray(4);
    _this155.fill = null;
    return _this155;
  }
  _inherits(Rectangle, _XFAObject71);
  return _createClass(Rectangle, [{
    key: nn,
    value: function value() {
      var _this$fill3;
      var e = this.edge.children.length ? this.edge.children[0] : new Edge({}),
        t = e[on](),
        i = Object.create(null);
      "visible" === ((_this$fill3 = this.fill) === null || _this$fill3 === void 0 ? void 0 : _this$fill3.presence) ? Object.assign(i, this.fill[on]()) : i.fill = "transparent";
      i.strokeWidth = measureToString("visible" === e.presence ? e.thickness : 0);
      i.stroke = t.color;
      var a = (this.corner.children.length ? this.corner.children[0] : new Corner({}))[on](),
        s = {
          name: "svg",
          children: [{
            name: "rect",
            attributes: {
              xmlns: Kn,
              width: "100%",
              height: "100%",
              x: 0,
              y: 0,
              rx: a.radius,
              ry: a.radius,
              style: i
            }
          }],
          attributes: {
            xmlns: Kn,
            style: {
              overflow: "visible"
            },
            width: "100%",
            height: "100%"
          }
        };
      if (hasMargin(this[wr]()[wr]())) return HTMLResult.success({
        name: "div",
        attributes: {
          style: {
            display: "inline",
            width: "100%",
            height: "100%"
          }
        },
        children: [s]
      });
      s.attributes.style.position = "absolute";
      return HTMLResult.success(s);
    }
  }]);
}(XFAObject);
var RefElement = /*#__PURE__*/function (_StringObject8) {
  function RefElement(e) {
    var _this156;
    _classCallCheck(this, RefElement);
    _this156 = _callSuper(this, RefElement, [vn, "ref"]);
    _this156.id = e.id || "";
    _this156.use = e.use || "";
    _this156.usehref = e.usehref || "";
    return _this156;
  }
  _inherits(RefElement, _StringObject8);
  return _createClass(RefElement);
}(StringObject);
var Script = /*#__PURE__*/function (_StringObject9) {
  function Script(e) {
    var _this157;
    _classCallCheck(this, Script);
    _this157 = _callSuper(this, Script, [vn, "script"]);
    _this157.binding = e.binding || "";
    _this157.contentType = e.contentType || "";
    _this157.id = e.id || "";
    _this157.name = e.name || "";
    _this157.runAt = getStringOption(e.runAt, ["client", "both", "server"]);
    _this157.use = e.use || "";
    _this157.usehref = e.usehref || "";
    return _this157;
  }
  _inherits(Script, _StringObject9);
  return _createClass(Script);
}(StringObject);
var SetProperty = /*#__PURE__*/function (_XFAObject72) {
  function SetProperty(e) {
    var _this158;
    _classCallCheck(this, SetProperty);
    _this158 = _callSuper(this, SetProperty, [vn, "setProperty"]);
    _this158.connection = e.connection || "";
    _this158.ref = e.ref || "";
    _this158.target = e.target || "";
    return _this158;
  }
  _inherits(SetProperty, _XFAObject72);
  return _createClass(SetProperty);
}(XFAObject);
var SignData = /*#__PURE__*/function (_XFAObject73) {
  function SignData(e) {
    var _this159;
    _classCallCheck(this, SignData);
    _this159 = _callSuper(this, SignData, [vn, "signData", !0]);
    _this159.id = e.id || "";
    _this159.operation = getStringOption(e.operation, ["sign", "clear", "verify"]);
    _this159.ref = e.ref || "";
    _this159.target = e.target || "";
    _this159.use = e.use || "";
    _this159.usehref = e.usehref || "";
    _this159.filter = null;
    _this159.manifest = null;
    return _this159;
  }
  _inherits(SignData, _XFAObject73);
  return _createClass(SignData);
}(XFAObject);
var Signature = /*#__PURE__*/function (_XFAObject74) {
  function Signature(e) {
    var _this160;
    _classCallCheck(this, Signature);
    _this160 = _callSuper(this, Signature, [vn, "signature", !0]);
    _this160.id = e.id || "";
    _this160.type = getStringOption(e.type, ["PDF1.3", "PDF1.6"]);
    _this160.use = e.use || "";
    _this160.usehref = e.usehref || "";
    _this160.border = null;
    _this160.extras = null;
    _this160.filter = null;
    _this160.manifest = null;
    _this160.margin = null;
    return _this160;
  }
  _inherits(Signature, _XFAObject74);
  return _createClass(Signature);
}(XFAObject);
var Signing = /*#__PURE__*/function (_XFAObject75) {
  function Signing(e) {
    var _this161;
    _classCallCheck(this, Signing);
    _this161 = _callSuper(this, Signing, [vn, "signing", !0]);
    _this161.id = e.id || "";
    _this161.type = getStringOption(e.type, ["optional", "required"]);
    _this161.use = e.use || "";
    _this161.usehref = e.usehref || "";
    _this161.certificate = new XFAObjectArray();
    return _this161;
  }
  _inherits(Signing, _XFAObject75);
  return _createClass(Signing);
}(XFAObject);
var Solid = /*#__PURE__*/function (_XFAObject76) {
  function Solid(e) {
    var _this162;
    _classCallCheck(this, Solid);
    _this162 = _callSuper(this, Solid, [vn, "solid", !0]);
    _this162.id = e.id || "";
    _this162.use = e.use || "";
    _this162.usehref = e.usehref || "";
    _this162.extras = null;
    return _this162;
  }
  _inherits(Solid, _XFAObject76);
  return _createClass(Solid, [{
    key: on,
    value: function value(e) {
      return e ? e[on]() : "#FFFFFF";
    }
  }]);
}(XFAObject);
var Speak = /*#__PURE__*/function (_StringObject10) {
  function Speak(e) {
    var _this163;
    _classCallCheck(this, Speak);
    _this163 = _callSuper(this, Speak, [vn, "speak"]);
    _this163.disable = getInteger({
      data: e.disable,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this163.id = e.id || "";
    _this163.priority = getStringOption(e.priority, ["custom", "caption", "name", "toolTip"]);
    _this163.rid = e.rid || "";
    _this163.use = e.use || "";
    _this163.usehref = e.usehref || "";
    return _this163;
  }
  _inherits(Speak, _StringObject10);
  return _createClass(Speak);
}(StringObject);
var Stipple = /*#__PURE__*/function (_XFAObject77) {
  function Stipple(e) {
    var _this164;
    _classCallCheck(this, Stipple);
    _this164 = _callSuper(this, Stipple, [vn, "stipple", !0]);
    _this164.id = e.id || "";
    _this164.rate = getInteger({
      data: e.rate,
      defaultValue: 50,
      validate: function validate(e) {
        return e >= 0 && e <= 100;
      }
    });
    _this164.use = e.use || "";
    _this164.usehref = e.usehref || "";
    _this164.color = null;
    _this164.extras = null;
    return _this164;
  }
  _inherits(Stipple, _XFAObject77);
  return _createClass(Stipple, [{
    key: on,
    value: function value(e) {
      var t = this.rate / 100;
      return Util.makeHexColor(Math.round(e.value.r * (1 - t) + this.value.r * t), Math.round(e.value.g * (1 - t) + this.value.g * t), Math.round(e.value.b * (1 - t) + this.value.b * t));
    }
  }]);
}(XFAObject);
var Subform = /*#__PURE__*/function (_XFAObject78) {
  function Subform(e) {
    var _this165;
    _classCallCheck(this, Subform);
    _this165 = _callSuper(this, Subform, [vn, "subform", !0]);
    _this165.access = getStringOption(e.access, ["open", "nonInteractive", "protected", "readOnly"]);
    _this165.allowMacro = getInteger({
      data: e.allowMacro,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this165.anchorType = getStringOption(e.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]);
    _this165.colSpan = getInteger({
      data: e.colSpan,
      defaultValue: 1,
      validate: function validate(e) {
        return e >= 1 || -1 === e;
      }
    });
    _this165.columnWidths = (e.columnWidths || "").trim().split(/\s+/).map(function (e) {
      return "-1" === e ? -1 : getMeasurement(e);
    });
    _this165.h = e.h ? getMeasurement(e.h) : "";
    _this165.hAlign = getStringOption(e.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]);
    _this165.id = e.id || "";
    _this165.layout = getStringOption(e.layout, ["position", "lr-tb", "rl-row", "rl-tb", "row", "table", "tb"]);
    _this165.locale = e.locale || "";
    _this165.maxH = getMeasurement(e.maxH, "0pt");
    _this165.maxW = getMeasurement(e.maxW, "0pt");
    _this165.mergeMode = getStringOption(e.mergeMode, ["consumeData", "matchTemplate"]);
    _this165.minH = getMeasurement(e.minH, "0pt");
    _this165.minW = getMeasurement(e.minW, "0pt");
    _this165.name = e.name || "";
    _this165.presence = getStringOption(e.presence, ["visible", "hidden", "inactive", "invisible"]);
    _this165.relevant = getRelevant(e.relevant);
    _this165.restoreState = getStringOption(e.restoreState, ["manual", "auto"]);
    _this165.scope = getStringOption(e.scope, ["name", "none"]);
    _this165.use = e.use || "";
    _this165.usehref = e.usehref || "";
    _this165.w = e.w ? getMeasurement(e.w) : "";
    _this165.x = getMeasurement(e.x, "0pt");
    _this165.y = getMeasurement(e.y, "0pt");
    _this165.assist = null;
    _this165.bind = null;
    _this165.bookend = null;
    _this165.border = null;
    _this165.break = null;
    _this165.calculate = null;
    _this165.desc = null;
    _this165.extras = null;
    _this165.keep = null;
    _this165.margin = null;
    _this165.occur = null;
    _this165.overflow = null;
    _this165.pageSet = null;
    _this165.para = null;
    _this165.traversal = null;
    _this165.validate = null;
    _this165.variables = null;
    _this165.area = new XFAObjectArray();
    _this165.breakAfter = new XFAObjectArray();
    _this165.breakBefore = new XFAObjectArray();
    _this165.connect = new XFAObjectArray();
    _this165.draw = new XFAObjectArray();
    _this165.event = new XFAObjectArray();
    _this165.exObject = new XFAObjectArray();
    _this165.exclGroup = new XFAObjectArray();
    _this165.field = new XFAObjectArray();
    _this165.proto = new XFAObjectArray();
    _this165.setProperty = new XFAObjectArray();
    _this165.subform = new XFAObjectArray();
    _this165.subformSet = new XFAObjectArray();
    return _this165;
  }
  _inherits(Subform, _XFAObject78);
  return _createClass(Subform, [{
    key: yr,
    value: function value() {
      var e = this[wr]();
      return e instanceof SubformSet ? e[yr]() : e;
    }
  }, {
    key: Gr,
    value: function value() {
      return !0;
    }
  }, {
    key: Hr,
    value: function value() {
      return this.layout.endsWith("-tb") && 0 === this[nr].attempt && this[nr].numberInLine > 0 || this[wr]()[Hr]();
    }
  }, {
    key: pr,
    value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
      return _regeneratorRuntime().wrap(function value$(_context56) {
        while (1) switch (_context56.prev = _context56.next) {
          case 0:
            return _context56.delegateYield(getContainedChildren(this), "t0", 1);
          case 1:
          case "end":
            return _context56.stop();
        }
      }, value, this);
    })
  }, {
    key: or,
    value: function value() {
      return flushHTML(this);
    }
  }, {
    key: Vs,
    value: function value(e, t) {
      addHTML(this, e, t);
    }
  }, {
    key: Cr,
    value: function value() {
      return getAvailableSpace(this);
    }
  }, {
    key: Lr,
    value: function value() {
      var _e$layout2;
      var e = this[yr]();
      if (!e[Lr]()) return !1;
      if (void 0 !== this[nr]._isSplittable) return this[nr]._isSplittable;
      if ("position" === this.layout || this.layout.includes("row")) {
        this[nr]._isSplittable = !1;
        return !1;
      }
      if (this.keep && "none" !== this.keep.intact) {
        this[nr]._isSplittable = !1;
        return !1;
      }
      if ((_e$layout2 = e.layout) !== null && _e$layout2 !== void 0 && _e$layout2.endsWith("-tb") && 0 !== e[nr].numberInLine) return !1;
      this[nr]._isSplittable = !0;
      return !0;
    }
  }, {
    key: nn,
    value: function value(e) {
      var _this$nr;
      setTabIndex(this);
      if (this.break) {
        if ("auto" !== this.break.after || "" !== this.break.afterTarget) {
          var _e519 = new BreakAfter({
            targetType: this.break.after,
            target: this.break.afterTarget,
            startNew: this.break.startNew.toString()
          });
          _e519[br] = this[br];
          this[zs](_e519);
          this.breakAfter.push(_e519);
        }
        if ("auto" !== this.break.before || "" !== this.break.beforeTarget) {
          var _e520 = new BreakBefore({
            targetType: this.break.before,
            target: this.break.beforeTarget,
            startNew: this.break.startNew.toString()
          });
          _e520[br] = this[br];
          this[zs](_e520);
          this.breakBefore.push(_e520);
        }
        if ("" !== this.break.overflowTarget) {
          var _e521 = new Overflow({
            target: this.break.overflowTarget,
            leader: this.break.overflowLeader,
            trailer: this.break.overflowTrailer
          });
          _e521[br] = this[br];
          this[zs](_e521);
          this.overflow.push(_e521);
        }
        this[Vr](this.break);
        this.break = null;
      }
      if ("hidden" === this.presence || "inactive" === this.presence) return HTMLResult.EMPTY;
      (this.breakBefore.children.length > 1 || this.breakAfter.children.length > 1) && warn("XFA - Several breakBefore or breakAfter in subforms: please file a bug.");
      if (this.breakBefore.children.length >= 1) {
        var _e522 = this.breakBefore.children[0];
        if (handleBreak(_e522)) return HTMLResult.breakNode(_e522);
      }
      if ((_this$nr = this[nr]) !== null && _this$nr !== void 0 && _this$nr.afterBreakAfter) return HTMLResult.EMPTY;
      fixDimensions(this);
      var t = [],
        i = {
          id: this[In],
          class: []
        };
      setAccess(this, i.class);
      this[nr] || (this[nr] = Object.create(null));
      Object.assign(this[nr], {
        children: t,
        line: null,
        attributes: i,
        attempt: 0,
        numberInLine: 0,
        availableSpace: {
          width: Math.min(this.w || 1 / 0, e.width),
          height: Math.min(this.h || 1 / 0, e.height)
        },
        width: 0,
        height: 0,
        prevHeight: 0,
        currentWidth: 0
      });
      var a = this[Dr](),
        s = a[nr].noLayoutFailure,
        r = this[Lr]();
      r || setFirstUnsplittable(this);
      if (!checkDimensions(this, e)) return HTMLResult.FAILURE;
      var n = new Set(["area", "draw", "exclGroup", "field", "subform", "subformSet"]);
      if (this.layout.includes("row")) {
        var _e523 = this[yr]().columnWidths;
        if (Array.isArray(_e523) && _e523.length > 0) {
          this[nr].columnWidths = _e523;
          this[nr].currentColumn = 0;
        }
      }
      var g = toStyle(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign"),
        o = ["xfaSubform"],
        c = layoutClass(this);
      c && o.push(c);
      i.style = g;
      i.class = o;
      this.name && (i.xfaName = this.name);
      if (this.overflow) {
        var _t393 = this.overflow[ur]();
        if (_t393.addLeader) {
          _t393.addLeader = !1;
          handleOverflow(this, _t393.leader, e);
        }
      }
      this[Zr]();
      var C = "lr-tb" === this.layout || "rl-tb" === this.layout,
        h = C ? 2 : 1;
      for (; this[nr].attempt < h; this[nr].attempt++) {
        C && 1 === this[nr].attempt && (this[nr].numberInLine = 0);
        var _e524 = this[_s]({
          filter: n,
          include: !0
        });
        if (_e524.success) break;
        if (_e524.isBreak()) {
          this[Xr]();
          return _e524;
        }
        if (C && 0 === this[nr].attempt && 0 === this[nr].numberInLine && !a[nr].noLayoutFailure) {
          this[nr].attempt = h;
          break;
        }
      }
      this[Xr]();
      r || unsetFirstUnsplittable(this);
      a[nr].noLayoutFailure = s;
      if (this[nr].attempt === h) {
        this.overflow && (this[Dr]()[nr].overflowNode = this.overflow);
        r || delete this[nr];
        return HTMLResult.FAILURE;
      }
      if (this.overflow) {
        var _t394 = this.overflow[ur]();
        if (_t394.addTrailer) {
          _t394.addTrailer = !1;
          handleOverflow(this, _t394.trailer, e);
        }
      }
      var l = 0,
        Q = 0;
      if (this.margin) {
        l = this.margin.leftInset + this.margin.rightInset;
        Q = this.margin.topInset + this.margin.bottomInset;
      }
      var E = Math.max(this[nr].width + l, this.w || 0),
        u = Math.max(this[nr].height + Q, this.h || 0),
        d = [this.x, this.y, E, u];
      "" === this.w && (g.width = measureToString(E));
      "" === this.h && (g.height = measureToString(u));
      if (("0px" === g.width || "0px" === g.height) && 0 === t.length) return HTMLResult.EMPTY;
      var f = {
        name: "div",
        attributes: i,
        children: t
      };
      applyAssist(this, i);
      var p = HTMLResult.success(createWrapper(this, f), d);
      if (this.breakAfter.children.length >= 1) {
        var _e525 = this.breakAfter.children[0];
        if (handleBreak(_e525)) {
          this[nr].afterBreakAfter = p;
          return HTMLResult.breakNode(_e525);
        }
      }
      delete this[nr];
      return p;
    }
  }]);
}(XFAObject);
var SubformSet = /*#__PURE__*/function (_XFAObject79) {
  function SubformSet(e) {
    var _this166;
    _classCallCheck(this, SubformSet);
    _this166 = _callSuper(this, SubformSet, [vn, "subformSet", !0]);
    _this166.id = e.id || "";
    _this166.name = e.name || "";
    _this166.relation = getStringOption(e.relation, ["ordered", "choice", "unordered"]);
    _this166.relevant = getRelevant(e.relevant);
    _this166.use = e.use || "";
    _this166.usehref = e.usehref || "";
    _this166.bookend = null;
    _this166.break = null;
    _this166.desc = null;
    _this166.extras = null;
    _this166.occur = null;
    _this166.overflow = null;
    _this166.breakAfter = new XFAObjectArray();
    _this166.breakBefore = new XFAObjectArray();
    _this166.subform = new XFAObjectArray();
    _this166.subformSet = new XFAObjectArray();
    return _this166;
  }
  _inherits(SubformSet, _XFAObject79);
  return _createClass(SubformSet, [{
    key: pr,
    value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
      return _regeneratorRuntime().wrap(function value$(_context57) {
        while (1) switch (_context57.prev = _context57.next) {
          case 0:
            return _context57.delegateYield(getContainedChildren(this), "t0", 1);
          case 1:
          case "end":
            return _context57.stop();
        }
      }, value, this);
    })
  }, {
    key: yr,
    value: function value() {
      var e = this[wr]();
      for (; !(e instanceof Subform);) e = e[wr]();
      return e;
    }
  }, {
    key: Gr,
    value: function value() {
      return !0;
    }
  }]);
}(XFAObject);
var SubjectDN = /*#__PURE__*/function (_ContentObject11) {
  function SubjectDN(e) {
    var _this167;
    _classCallCheck(this, SubjectDN);
    _this167 = _callSuper(this, SubjectDN, [vn, "subjectDN"]);
    _this167.delimiter = e.delimiter || ",";
    _this167.id = e.id || "";
    _this167.name = e.name || "";
    _this167.use = e.use || "";
    _this167.usehref = e.usehref || "";
    return _this167;
  }
  _inherits(SubjectDN, _ContentObject11);
  return _createClass(SubjectDN, [{
    key: gr,
    value: function value() {
      this[ar] = new Map(this[ar].split(this.delimiter).map(function (e) {
        (e = e.split("=", 2))[0] = e[0].trim();
        return e;
      }));
    }
  }]);
}(ContentObject);
var SubjectDNs = /*#__PURE__*/function (_XFAObject80) {
  function SubjectDNs(e) {
    var _this168;
    _classCallCheck(this, SubjectDNs);
    _this168 = _callSuper(this, SubjectDNs, [vn, "subjectDNs", !0]);
    _this168.id = e.id || "";
    _this168.type = getStringOption(e.type, ["optional", "required"]);
    _this168.use = e.use || "";
    _this168.usehref = e.usehref || "";
    _this168.subjectDN = new XFAObjectArray();
    return _this168;
  }
  _inherits(SubjectDNs, _XFAObject80);
  return _createClass(SubjectDNs);
}(XFAObject);
var Submit = /*#__PURE__*/function (_XFAObject81) {
  function Submit(e) {
    var _this169;
    _classCallCheck(this, Submit);
    _this169 = _callSuper(this, Submit, [vn, "submit", !0]);
    _this169.embedPDF = getInteger({
      data: e.embedPDF,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this169.format = getStringOption(e.format, ["xdp", "formdata", "pdf", "urlencoded", "xfd", "xml"]);
    _this169.id = e.id || "";
    _this169.target = e.target || "";
    _this169.textEncoding = getKeyword({
      data: e.textEncoding ? e.textEncoding.toLowerCase() : "",
      defaultValue: "",
      validate: function validate(e) {
        return ["utf-8", "big-five", "fontspecific", "gbk", "gb-18030", "gb-2312", "ksc-5601", "none", "shift-jis", "ucs-2", "utf-16"].includes(e) || e.match(/iso-8859-\d{2}/);
      }
    });
    _this169.use = e.use || "";
    _this169.usehref = e.usehref || "";
    _this169.xdpContent = e.xdpContent || "";
    _this169.encrypt = null;
    _this169.encryptData = new XFAObjectArray();
    _this169.signData = new XFAObjectArray();
    return _this169;
  }
  _inherits(Submit, _XFAObject81);
  return _createClass(Submit);
}(XFAObject);
var Template = /*#__PURE__*/function (_XFAObject82) {
  function Template(e) {
    var _this170;
    _classCallCheck(this, Template);
    _this170 = _callSuper(this, Template, [vn, "template", !0]);
    _this170.baseProfile = getStringOption(e.baseProfile, ["full", "interactiveForms"]);
    _this170.extras = null;
    _this170.subform = new XFAObjectArray();
    return _this170;
  }
  _inherits(Template, _XFAObject82);
  return _createClass(Template, [{
    key: gr,
    value: function value() {
      0 === this.subform.children.length && warn("XFA - No subforms in template node.");
      this.subform.children.length >= 2 && warn("XFA - Several subforms in template node: please file a bug.");
      this[an] = 5e3;
    }
  }, {
    key: Lr,
    value: function value() {
      return !0;
    }
  }, {
    key: $r,
    value: function value(e, t) {
      return e.startsWith("#") ? [this[Sr].get(e.slice(1))] : searchNode(this, t, e, !0, !0);
    }
  }, {
    key: rn,
    value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
      var _e$break,
        _e$subform$children$,
        _this171 = this;
      var e, t, i, a, s, r, _e526, n, g, o, c, C, h, l, _loop4, _ret2;
      return _regeneratorRuntime().wrap(function value$(_context59) {
        while (1) switch (_context59.prev = _context59.next) {
          case 0:
            if (this.subform.children.length) {
              _context59.next = 2;
              break;
            }
            return _context59.abrupt("return", HTMLResult.success({
              name: "div",
              children: []
            }));
          case 2:
            this[nr] = {
              overflowNode: null,
              firstUnsplittable: null,
              currentContentArea: null,
              currentPageArea: null,
              noLayoutFailure: !1,
              pageNumber: 1,
              pagePosition: "first",
              oddOrEven: "odd",
              blankOrNotBlank: "nonBlank",
              paraStack: []
            };
            e = this.subform.children[0];
            e.pageSet[Ar]();
            t = e.pageSet.pageArea.children, i = {
              name: "div",
              children: []
            };
            a = null, s = null, r = null;
            if (e.breakBefore.children.length >= 1) {
              s = e.breakBefore.children[0];
              r = s.target;
            } else if (e.subform.children.length >= 1 && e.subform.children[0].breakBefore.children.length >= 1) {
              s = e.subform.children[0].breakBefore.children[0];
              r = s.target;
            } else if ((_e$break = e.break) !== null && _e$break !== void 0 && _e$break.beforeTarget) {
              s = e.break;
              r = s.beforeTarget;
            } else if (e.subform.children.length >= 1 && (_e$subform$children$ = e.subform.children[0].break) !== null && _e$subform$children$ !== void 0 && _e$subform$children$.beforeTarget) {
              s = e.subform.children[0].break;
              r = s.beforeTarget;
            }
            if (s) {
              _e526 = this[$r](r, s[wr]());
              if (_e526 instanceof PageArea) {
                a = _e526;
                s[nr] = {};
              }
            }
            a || (a = t[0]);
            a[nr] = {
              numberOfUse: 1
            };
            n = a[wr]();
            n[nr] = {
              numberOfUse: 1,
              pageIndex: n.pageArea.children.indexOf(a),
              pageSetIndex: 0
            };
            o = null, c = null, C = !0, h = 0, l = 0;
            _loop4 = /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
              var t, s, r, flush, _t395, _a270, _a271, _n98, _h14, _h14$html$children, _e527, _e528, _i340, _a272, _r139, _e529;
              return _regeneratorRuntime().wrap(function _callee47$(_context58) {
                while (1) switch (_context58.prev = _context58.next) {
                  case 0:
                    if (!C) {
                      _context58.next = 4;
                      break;
                    }
                    h = 0;
                    _context58.next = 8;
                    break;
                  case 4:
                    i.children.pop();
                    if (!(3 == ++h)) {
                      _context58.next = 8;
                      break;
                    }
                    warn("XFA - Something goes wrong: please file a bug.");
                    return _context58.abrupt("return", {
                      v: i
                    });
                  case 8:
                    g = null;
                    _this171[nr].currentPageArea = a;
                    t = a[nn]().html;
                    i.children.push(t);
                    if (o) {
                      _this171[nr].noLayoutFailure = !0;
                      t.children.push(o[nn](a[nr].space).html);
                      o = null;
                    }
                    if (c) {
                      _this171[nr].noLayoutFailure = !0;
                      t.children.push(c[nn](a[nr].space).html);
                      c = null;
                    }
                    s = a.contentArea.children, r = t.children.filter(function (e) {
                      return e.attributes.class.includes("xfaContentarea");
                    });
                    C = !1;
                    _this171[nr].firstUnsplittable = null;
                    _this171[nr].noLayoutFailure = !1;
                    flush = function flush(t) {
                      var i = e[or]();
                      if (i) {
                        var _i$children;
                        C || (C = ((_i$children = i.children) === null || _i$children === void 0 ? void 0 : _i$children.length) > 0);
                        r[t].children.push(i);
                      }
                    };
                    _t395 = l, _a270 = s.length;
                  case 20:
                    if (!(_t395 < _a270)) {
                      _context58.next = 43;
                      break;
                    }
                    _a271 = _this171[nr].currentContentArea = s[_t395], _n98 = {
                      width: _a271.w,
                      height: _a271.h
                    };
                    l = 0;
                    if (o) {
                      r[_t395].children.push(o[nn](_n98).html);
                      o = null;
                    }
                    if (c) {
                      r[_t395].children.push(c[nn](_n98).html);
                      c = null;
                    }
                    _h14 = e[nn](_n98);
                    if (!_h14.success) {
                      _context58.next = 29;
                      break;
                    }
                    if (_h14.html) {
                      C || (C = ((_h14$html$children = _h14.html.children) === null || _h14$html$children === void 0 ? void 0 : _h14$html$children.length) > 0);
                      r[_t395].children.push(_h14.html);
                    } else !C && i.children.length > 1 && i.children.pop();
                    return _context58.abrupt("return", {
                      v: i
                    });
                  case 29:
                    if (!_h14.isBreak()) {
                      _context58.next = 39;
                      break;
                    }
                    _e527 = _h14.breakNode;
                    flush(_t395);
                    if (!("auto" === _e527.targetType)) {
                      _context58.next = 34;
                      break;
                    }
                    return _context58.abrupt("continue", 40);
                  case 34:
                    if (_e527.leader) {
                      o = _this171[$r](_e527.leader, _e527[wr]());
                      o = o ? o[0] : null;
                    }
                    if (_e527.trailer) {
                      c = _this171[$r](_e527.trailer, _e527[wr]());
                      c = c ? c[0] : null;
                    }
                    if ("pageArea" === _e527.targetType) {
                      g = _e527[nr].target;
                      _t395 = 1 / 0;
                    } else if (_e527[nr].target) {
                      g = _e527[nr].target;
                      l = _e527[nr].index + 1;
                      _t395 = 1 / 0;
                    } else _t395 = _e527[nr].index;
                    _context58.next = 40;
                    break;
                  case 39:
                    if (_this171[nr].overflowNode) {
                      _e528 = _this171[nr].overflowNode;
                      _this171[nr].overflowNode = null;
                      _i340 = _e528[ur](), _a272 = _i340.target;
                      _i340.addLeader = null !== _i340.leader;
                      _i340.addTrailer = null !== _i340.trailer;
                      flush(_t395);
                      _r139 = _t395;
                      _t395 = 1 / 0;
                      if (_a272 instanceof PageArea) g = _a272;else if (_a272 instanceof ContentArea) {
                        _e529 = s.indexOf(_a272);
                        if (-1 !== _e529) _e529 > _r139 ? _t395 = _e529 - 1 : l = _e529;else {
                          g = _a272[wr]();
                          l = g.contentArea.children.indexOf(_a272);
                        }
                      }
                    } else flush(_t395);
                  case 40:
                    _t395++;
                    _context58.next = 20;
                    break;
                  case 43:
                    _this171[nr].pageNumber += 1;
                    g && (g[Yr]() ? g[nr].numberOfUse += 1 : g = null);
                    a = g || a[mr]();
                    _context58.next = 48;
                    return null;
                  case 48:
                  case "end":
                    return _context58.stop();
                }
              }, _callee47);
            });
          case 15:
            return _context59.delegateYield(_loop4(), "t0", 16);
          case 16:
            _ret2 = _context59.t0;
            if (!_ret2) {
              _context59.next = 19;
              break;
            }
            return _context59.abrupt("return", _ret2.v);
          case 19:
            _context59.next = 15;
            break;
          case 21:
          case "end":
            return _context59.stop();
        }
      }, value, this);
    })
  }]);
}(XFAObject);
var Text = /*#__PURE__*/function (_ContentObject12) {
  function Text(e) {
    var _this172;
    _classCallCheck(this, Text);
    _this172 = _callSuper(this, Text, [vn, "text"]);
    _this172.id = e.id || "";
    _this172.maxChars = getInteger({
      data: e.maxChars,
      defaultValue: 0,
      validate: function validate(e) {
        return e >= 0;
      }
    });
    _this172.name = e.name || "";
    _this172.rid = e.rid || "";
    _this172.use = e.use || "";
    _this172.usehref = e.usehref || "";
    return _this172;
  }
  _inherits(Text, _ContentObject12);
  return _createClass(Text, [{
    key: Zs,
    value: function value() {
      return !0;
    }
  }, {
    key: Or,
    value: function value(e) {
      if (e[Kr] === Cn.xhtml.id) {
        this[ar] = e;
        return !0;
      }
      warn("XFA - Invalid content in Text: ".concat(e[Tr], "."));
      return !1;
    }
  }, {
    key: Wr,
    value: function value(e) {
      this[ar] instanceof XFAObject || _superPropGet(Text, Wr, this, 3)([e]);
    }
  }, {
    key: gr,
    value: function value() {
      "string" == typeof this[ar] && (this[ar] = this[ar].replaceAll("\r\n", "\n"));
    }
  }, {
    key: ur,
    value: function value() {
      return "string" == typeof this[ar] ? this[ar].split(/[\u2029\u2028\n]/).reduce(function (e, t) {
        t && e.push(t);
        return e;
      }, []).join("\n") : this[ar][sn]();
    }
  }, {
    key: nn,
    value: function value(e) {
      if ("string" == typeof this[ar]) {
        var _e530 = valueToHtml(this[ar]).html;
        if (this[ar].includes("\u2029")) {
          _e530.name = "div";
          _e530.children = [];
          this[ar].split("\u2029").map(function (e) {
            return e.split(/[\u2028\n]/).reduce(function (e, t) {
              e.push({
                name: "span",
                value: t
              }, {
                name: "br"
              });
              return e;
            }, []);
          }).forEach(function (t) {
            _e530.children.push({
              name: "p",
              children: t
            });
          });
        } else if (/[\u2028\n]/.test(this[ar])) {
          _e530.name = "div";
          _e530.children = [];
          this[ar].split(/[\u2028\n]/).forEach(function (t) {
            _e530.children.push({
              name: "span",
              value: t
            }, {
              name: "br"
            });
          });
        }
        return HTMLResult.success(_e530);
      }
      return this[ar][nn](e);
    }
  }]);
}(ContentObject);
var TextEdit = /*#__PURE__*/function (_XFAObject83) {
  function TextEdit(e) {
    var _this173;
    _classCallCheck(this, TextEdit);
    _this173 = _callSuper(this, TextEdit, [vn, "textEdit", !0]);
    _this173.allowRichText = getInteger({
      data: e.allowRichText,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this173.hScrollPolicy = getStringOption(e.hScrollPolicy, ["auto", "off", "on"]);
    _this173.id = e.id || "";
    _this173.multiLine = getInteger({
      data: e.multiLine,
      defaultValue: "",
      validate: function validate(e) {
        return 0 === e || 1 === e;
      }
    });
    _this173.use = e.use || "";
    _this173.usehref = e.usehref || "";
    _this173.vScrollPolicy = getStringOption(e.vScrollPolicy, ["auto", "off", "on"]);
    _this173.border = null;
    _this173.comb = null;
    _this173.extras = null;
    _this173.margin = null;
    return _this173;
  }
  _inherits(TextEdit, _XFAObject83);
  return _createClass(TextEdit, [{
    key: nn,
    value: function value(e) {
      var _a$sr, _a$sr2;
      var t = toStyle(this, "border", "font", "margin");
      var i;
      var a = this[wr]()[wr]();
      "" === this.multiLine && (this.multiLine = a instanceof Draw ? 1 : 0);
      i = 1 === this.multiLine ? {
        name: "textarea",
        attributes: {
          dataId: ((_a$sr = a[sr]) === null || _a$sr === void 0 ? void 0 : _a$sr[In]) || a[In],
          fieldId: a[In],
          class: ["xfaTextfield"],
          style: t,
          "aria-label": ariaLabel(a),
          "aria-required": !1
        }
      } : {
        name: "input",
        attributes: {
          type: "text",
          dataId: ((_a$sr2 = a[sr]) === null || _a$sr2 === void 0 ? void 0 : _a$sr2[In]) || a[In],
          fieldId: a[In],
          class: ["xfaTextfield"],
          style: t,
          "aria-label": ariaLabel(a),
          "aria-required": !1
        }
      };
      if (isRequired(a)) {
        i.attributes["aria-required"] = !0;
        i.attributes.required = !0;
      }
      return HTMLResult.success({
        name: "label",
        attributes: {
          class: ["xfaLabel"]
        },
        children: [i]
      });
    }
  }]);
}(XFAObject);
var Time = /*#__PURE__*/function (_StringObject11) {
  function Time(e) {
    var _this174;
    _classCallCheck(this, Time);
    _this174 = _callSuper(this, Time, [vn, "time"]);
    _this174.id = e.id || "";
    _this174.name = e.name || "";
    _this174.use = e.use || "";
    _this174.usehref = e.usehref || "";
    return _this174;
  }
  _inherits(Time, _StringObject11);
  return _createClass(Time, [{
    key: gr,
    value: function value() {
      var e = this[ar].trim();
      this[ar] = e ? new Date(e) : null;
    }
  }, {
    key: nn,
    value: function value(e) {
      return valueToHtml(this[ar] ? this[ar].toString() : "");
    }
  }]);
}(StringObject);
var TimeStamp = /*#__PURE__*/function (_XFAObject84) {
  function TimeStamp(e) {
    var _this175;
    _classCallCheck(this, TimeStamp);
    _this175 = _callSuper(this, TimeStamp, [vn, "timeStamp"]);
    _this175.id = e.id || "";
    _this175.server = e.server || "";
    _this175.type = getStringOption(e.type, ["optional", "required"]);
    _this175.use = e.use || "";
    _this175.usehref = e.usehref || "";
    return _this175;
  }
  _inherits(TimeStamp, _XFAObject84);
  return _createClass(TimeStamp);
}(XFAObject);
var ToolTip = /*#__PURE__*/function (_StringObject12) {
  function ToolTip(e) {
    var _this176;
    _classCallCheck(this, ToolTip);
    _this176 = _callSuper(this, ToolTip, [vn, "toolTip"]);
    _this176.id = e.id || "";
    _this176.rid = e.rid || "";
    _this176.use = e.use || "";
    _this176.usehref = e.usehref || "";
    return _this176;
  }
  _inherits(ToolTip, _StringObject12);
  return _createClass(ToolTip);
}(StringObject);
var Traversal = /*#__PURE__*/function (_XFAObject85) {
  function Traversal(e) {
    var _this177;
    _classCallCheck(this, Traversal);
    _this177 = _callSuper(this, Traversal, [vn, "traversal", !0]);
    _this177.id = e.id || "";
    _this177.use = e.use || "";
    _this177.usehref = e.usehref || "";
    _this177.extras = null;
    _this177.traverse = new XFAObjectArray();
    return _this177;
  }
  _inherits(Traversal, _XFAObject85);
  return _createClass(Traversal);
}(XFAObject);
var Traverse = /*#__PURE__*/function (_XFAObject86) {
  function Traverse(e) {
    var _this178;
    _classCallCheck(this, Traverse);
    _this178 = _callSuper(this, Traverse, [vn, "traverse", !0]);
    _this178.id = e.id || "";
    _this178.operation = getStringOption(e.operation, ["next", "back", "down", "first", "left", "right", "up"]);
    _this178.ref = e.ref || "";
    _this178.use = e.use || "";
    _this178.usehref = e.usehref || "";
    _this178.extras = null;
    _this178.script = null;
    return _this178;
  }
  _inherits(Traverse, _XFAObject86);
  return _createClass(Traverse, [{
    key: "name",
    get: function get() {
      return this.operation;
    }
  }, {
    key: Jr,
    value: function value() {
      return !1;
    }
  }]);
}(XFAObject);
var Ui = /*#__PURE__*/function (_XFAObject87) {
  function Ui(e) {
    var _this179;
    _classCallCheck(this, Ui);
    _this179 = _callSuper(this, Ui, [vn, "ui", !0]);
    _this179.id = e.id || "";
    _this179.use = e.use || "";
    _this179.usehref = e.usehref || "";
    _this179.extras = null;
    _this179.picture = null;
    _this179.barcode = null;
    _this179.button = null;
    _this179.checkButton = null;
    _this179.choiceList = null;
    _this179.dateTimeEdit = null;
    _this179.defaultUi = null;
    _this179.imageEdit = null;
    _this179.numericEdit = null;
    _this179.passwordEdit = null;
    _this179.signature = null;
    _this179.textEdit = null;
    return _this179;
  }
  _inherits(Ui, _XFAObject87);
  return _createClass(Ui, [{
    key: ur,
    value: function value() {
      if (void 0 === this[nr]) {
        var _iterator170 = _createForOfIteratorHelper(Object.getOwnPropertyNames(this)),
          _step170;
        try {
          for (_iterator170.s(); !(_step170 = _iterator170.n()).done;) {
            var _e531 = _step170.value;
            if ("extras" === _e531 || "picture" === _e531) continue;
            var _t396 = this[_e531];
            if (_t396 instanceof XFAObject) {
              this[nr] = _t396;
              return _t396;
            }
          }
        } catch (err) {
          _iterator170.e(err);
        } finally {
          _iterator170.f();
        }
        this[nr] = null;
      }
      return this[nr];
    }
  }, {
    key: nn,
    value: function value(e) {
      var t = this[ur]();
      return t ? t[nn](e) : HTMLResult.EMPTY;
    }
  }]);
}(XFAObject);
var Validate = /*#__PURE__*/function (_XFAObject88) {
  function Validate(e) {
    var _this180;
    _classCallCheck(this, Validate);
    _this180 = _callSuper(this, Validate, [vn, "validate", !0]);
    _this180.formatTest = getStringOption(e.formatTest, ["warning", "disabled", "error"]);
    _this180.id = e.id || "";
    _this180.nullTest = getStringOption(e.nullTest, ["disabled", "error", "warning"]);
    _this180.scriptTest = getStringOption(e.scriptTest, ["error", "disabled", "warning"]);
    _this180.use = e.use || "";
    _this180.usehref = e.usehref || "";
    _this180.extras = null;
    _this180.message = null;
    _this180.picture = null;
    _this180.script = null;
    return _this180;
  }
  _inherits(Validate, _XFAObject88);
  return _createClass(Validate);
}(XFAObject);
var Value = /*#__PURE__*/function (_XFAObject89) {
  function Value(e) {
    var _this181;
    _classCallCheck(this, Value);
    _this181 = _callSuper(this, Value, [vn, "value", !0]);
    _this181.id = e.id || "";
    _this181.override = getInteger({
      data: e.override,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this181.relevant = getRelevant(e.relevant);
    _this181.use = e.use || "";
    _this181.usehref = e.usehref || "";
    _this181.arc = null;
    _this181.boolean = null;
    _this181.date = null;
    _this181.dateTime = null;
    _this181.decimal = null;
    _this181.exData = null;
    _this181.float = null;
    _this181.image = null;
    _this181.integer = null;
    _this181.line = null;
    _this181.rectangle = null;
    _this181.text = null;
    _this181.time = null;
    return _this181;
  }
  _inherits(Value, _XFAObject89);
  return _createClass(Value, [{
    key: tn,
    value: function value(e) {
      var _t$ui;
      var t = this[wr]();
      if (t instanceof Field && (_t$ui = t.ui) !== null && _t$ui !== void 0 && _t$ui.imageEdit) {
        if (!this.image) {
          this.image = new Image({});
          this[zs](this.image);
        }
        this.image[ar] = e[ar];
        return;
      }
      var i = e[Tr];
      if (null === this[i]) {
        var _iterator171 = _createForOfIteratorHelper(Object.getOwnPropertyNames(this)),
          _step171;
        try {
          for (_iterator171.s(); !(_step171 = _iterator171.n()).done;) {
            var _e532 = _step171.value;
            var _t397 = this[_e532];
            if (_t397 instanceof XFAObject) {
              this[_e532] = null;
              this[Vr](_t397);
            }
          }
        } catch (err) {
          _iterator171.e(err);
        } finally {
          _iterator171.f();
        }
        this[e[Tr]] = e;
        this[zs](e);
      } else this[i][ar] = e[ar];
    }
  }, {
    key: sn,
    value: function value() {
      if (this.exData) return "string" == typeof this.exData[ar] ? this.exData[ar].trim() : this.exData[ar][sn]().trim();
      var _iterator172 = _createForOfIteratorHelper(Object.getOwnPropertyNames(this)),
        _step172;
      try {
        for (_iterator172.s(); !(_step172 = _iterator172.n()).done;) {
          var _e533 = _step172.value;
          if ("image" === _e533) continue;
          var _t398 = this[_e533];
          if (_t398 instanceof XFAObject) return (_t398[ar] || "").toString().trim();
        }
      } catch (err) {
        _iterator172.e(err);
      } finally {
        _iterator172.f();
      }
      return null;
    }
  }, {
    key: nn,
    value: function value(e) {
      var _iterator173 = _createForOfIteratorHelper(Object.getOwnPropertyNames(this)),
        _step173;
      try {
        for (_iterator173.s(); !(_step173 = _iterator173.n()).done;) {
          var _t399 = _step173.value;
          var _i341 = this[_t399];
          if (_i341 instanceof XFAObject) return _i341[nn](e);
        }
      } catch (err) {
        _iterator173.e(err);
      } finally {
        _iterator173.f();
      }
      return HTMLResult.EMPTY;
    }
  }]);
}(XFAObject);
var Variables = /*#__PURE__*/function (_XFAObject90) {
  function Variables(e) {
    var _this182;
    _classCallCheck(this, Variables);
    _this182 = _callSuper(this, Variables, [vn, "variables", !0]);
    _this182.id = e.id || "";
    _this182.use = e.use || "";
    _this182.usehref = e.usehref || "";
    _this182.boolean = new XFAObjectArray();
    _this182.date = new XFAObjectArray();
    _this182.dateTime = new XFAObjectArray();
    _this182.decimal = new XFAObjectArray();
    _this182.exData = new XFAObjectArray();
    _this182.float = new XFAObjectArray();
    _this182.image = new XFAObjectArray();
    _this182.integer = new XFAObjectArray();
    _this182.manifest = new XFAObjectArray();
    _this182.script = new XFAObjectArray();
    _this182.text = new XFAObjectArray();
    _this182.time = new XFAObjectArray();
    return _this182;
  }
  _inherits(Variables, _XFAObject90);
  return _createClass(Variables, [{
    key: Jr,
    value: function value() {
      return !0;
    }
  }]);
}(XFAObject);
var TemplateNamespace = /*#__PURE__*/function () {
  function TemplateNamespace() {
    _classCallCheck(this, TemplateNamespace);
  }
  return _createClass(TemplateNamespace, null, [{
    key: cn,
    value: function value(e, t) {
      if (TemplateNamespace.hasOwnProperty(e)) {
        var _i342 = TemplateNamespace[e](t);
        _i342[en](t);
        return _i342;
      }
    }
  }, {
    key: "appearanceFilter",
    value: function appearanceFilter(e) {
      return new AppearanceFilter(e);
    }
  }, {
    key: "arc",
    value: function arc(e) {
      return new Arc(e);
    }
  }, {
    key: "area",
    value: function area(e) {
      return new Area(e);
    }
  }, {
    key: "assist",
    value: function assist(e) {
      return new Assist(e);
    }
  }, {
    key: "barcode",
    value: function barcode(e) {
      return new Barcode(e);
    }
  }, {
    key: "bind",
    value: function bind(e) {
      return new Bind(e);
    }
  }, {
    key: "bindItems",
    value: function bindItems(e) {
      return new BindItems(e);
    }
  }, {
    key: "bookend",
    value: function bookend(e) {
      return new Bookend(e);
    }
  }, {
    key: "boolean",
    value: function boolean(e) {
      return new BooleanElement(e);
    }
  }, {
    key: "border",
    value: function border(e) {
      return new Border(e);
    }
  }, {
    key: "break",
    value: function _break(e) {
      return new Break(e);
    }
  }, {
    key: "breakAfter",
    value: function breakAfter(e) {
      return new BreakAfter(e);
    }
  }, {
    key: "breakBefore",
    value: function breakBefore(e) {
      return new BreakBefore(e);
    }
  }, {
    key: "button",
    value: function button(e) {
      return new Button(e);
    }
  }, {
    key: "calculate",
    value: function calculate(e) {
      return new Calculate(e);
    }
  }, {
    key: "caption",
    value: function caption(e) {
      return new Caption(e);
    }
  }, {
    key: "certificate",
    value: function certificate(e) {
      return new Certificate(e);
    }
  }, {
    key: "certificates",
    value: function certificates(e) {
      return new Certificates(e);
    }
  }, {
    key: "checkButton",
    value: function checkButton(e) {
      return new CheckButton(e);
    }
  }, {
    key: "choiceList",
    value: function choiceList(e) {
      return new ChoiceList(e);
    }
  }, {
    key: "color",
    value: function color(e) {
      return new Color(e);
    }
  }, {
    key: "comb",
    value: function comb(e) {
      return new Comb(e);
    }
  }, {
    key: "connect",
    value: function connect(e) {
      return new Connect(e);
    }
  }, {
    key: "contentArea",
    value: function contentArea(e) {
      return new ContentArea(e);
    }
  }, {
    key: "corner",
    value: function corner(e) {
      return new Corner(e);
    }
  }, {
    key: "date",
    value: function date(e) {
      return new DateElement(e);
    }
  }, {
    key: "dateTime",
    value: function dateTime(e) {
      return new DateTime(e);
    }
  }, {
    key: "dateTimeEdit",
    value: function dateTimeEdit(e) {
      return new DateTimeEdit(e);
    }
  }, {
    key: "decimal",
    value: function decimal(e) {
      return new Decimal(e);
    }
  }, {
    key: "defaultUi",
    value: function defaultUi(e) {
      return new DefaultUi(e);
    }
  }, {
    key: "desc",
    value: function desc(e) {
      return new Desc(e);
    }
  }, {
    key: "digestMethod",
    value: function digestMethod(e) {
      return new DigestMethod(e);
    }
  }, {
    key: "digestMethods",
    value: function digestMethods(e) {
      return new DigestMethods(e);
    }
  }, {
    key: "draw",
    value: function draw(e) {
      return new Draw(e);
    }
  }, {
    key: "edge",
    value: function edge(e) {
      return new Edge(e);
    }
  }, {
    key: "encoding",
    value: function encoding(e) {
      return new Encoding(e);
    }
  }, {
    key: "encodings",
    value: function encodings(e) {
      return new Encodings(e);
    }
  }, {
    key: "encrypt",
    value: function encrypt(e) {
      return new Encrypt(e);
    }
  }, {
    key: "encryptData",
    value: function encryptData(e) {
      return new EncryptData(e);
    }
  }, {
    key: "encryption",
    value: function encryption(e) {
      return new Encryption(e);
    }
  }, {
    key: "encryptionMethod",
    value: function encryptionMethod(e) {
      return new EncryptionMethod(e);
    }
  }, {
    key: "encryptionMethods",
    value: function encryptionMethods(e) {
      return new EncryptionMethods(e);
    }
  }, {
    key: "event",
    value: function event(e) {
      return new Event(e);
    }
  }, {
    key: "exData",
    value: function exData(e) {
      return new ExData(e);
    }
  }, {
    key: "exObject",
    value: function exObject(e) {
      return new ExObject(e);
    }
  }, {
    key: "exclGroup",
    value: function exclGroup(e) {
      return new ExclGroup(e);
    }
  }, {
    key: "execute",
    value: function execute(e) {
      return new Execute(e);
    }
  }, {
    key: "extras",
    value: function extras(e) {
      return new Extras(e);
    }
  }, {
    key: "field",
    value: function field(e) {
      return new Field(e);
    }
  }, {
    key: "fill",
    value: function fill(e) {
      return new Fill(e);
    }
  }, {
    key: "filter",
    value: function filter(e) {
      return new Filter(e);
    }
  }, {
    key: "float",
    value: function float(e) {
      return new Float(e);
    }
  }, {
    key: "font",
    value: function font(e) {
      return new template_Font(e);
    }
  }, {
    key: "format",
    value: function format(e) {
      return new Format(e);
    }
  }, {
    key: "handler",
    value: function handler(e) {
      return new Handler(e);
    }
  }, {
    key: "hyphenation",
    value: function hyphenation(e) {
      return new Hyphenation(e);
    }
  }, {
    key: "image",
    value: function image(e) {
      return new Image(e);
    }
  }, {
    key: "imageEdit",
    value: function imageEdit(e) {
      return new ImageEdit(e);
    }
  }, {
    key: "integer",
    value: function integer(e) {
      return new Integer(e);
    }
  }, {
    key: "issuers",
    value: function issuers(e) {
      return new Issuers(e);
    }
  }, {
    key: "items",
    value: function items(e) {
      return new Items(e);
    }
  }, {
    key: "keep",
    value: function keep(e) {
      return new Keep(e);
    }
  }, {
    key: "keyUsage",
    value: function keyUsage(e) {
      return new KeyUsage(e);
    }
  }, {
    key: "line",
    value: function line(e) {
      return new Line(e);
    }
  }, {
    key: "linear",
    value: function linear(e) {
      return new Linear(e);
    }
  }, {
    key: "lockDocument",
    value: function lockDocument(e) {
      return new LockDocument(e);
    }
  }, {
    key: "manifest",
    value: function manifest(e) {
      return new Manifest(e);
    }
  }, {
    key: "margin",
    value: function margin(e) {
      return new Margin(e);
    }
  }, {
    key: "mdp",
    value: function mdp(e) {
      return new Mdp(e);
    }
  }, {
    key: "medium",
    value: function medium(e) {
      return new Medium(e);
    }
  }, {
    key: "message",
    value: function message(e) {
      return new Message(e);
    }
  }, {
    key: "numericEdit",
    value: function numericEdit(e) {
      return new NumericEdit(e);
    }
  }, {
    key: "occur",
    value: function occur(e) {
      return new Occur(e);
    }
  }, {
    key: "oid",
    value: function oid(e) {
      return new Oid(e);
    }
  }, {
    key: "oids",
    value: function oids(e) {
      return new Oids(e);
    }
  }, {
    key: "overflow",
    value: function overflow(e) {
      return new Overflow(e);
    }
  }, {
    key: "pageArea",
    value: function pageArea(e) {
      return new PageArea(e);
    }
  }, {
    key: "pageSet",
    value: function pageSet(e) {
      return new PageSet(e);
    }
  }, {
    key: "para",
    value: function para(e) {
      return new Para(e);
    }
  }, {
    key: "passwordEdit",
    value: function passwordEdit(e) {
      return new PasswordEdit(e);
    }
  }, {
    key: "pattern",
    value: function pattern(e) {
      return new template_Pattern(e);
    }
  }, {
    key: "picture",
    value: function picture(e) {
      return new Picture(e);
    }
  }, {
    key: "proto",
    value: function proto(e) {
      return new Proto(e);
    }
  }, {
    key: "radial",
    value: function radial(e) {
      return new Radial(e);
    }
  }, {
    key: "reason",
    value: function reason(e) {
      return new Reason(e);
    }
  }, {
    key: "reasons",
    value: function reasons(e) {
      return new Reasons(e);
    }
  }, {
    key: "rectangle",
    value: function rectangle(e) {
      return new Rectangle(e);
    }
  }, {
    key: "ref",
    value: function ref(e) {
      return new RefElement(e);
    }
  }, {
    key: "script",
    value: function script(e) {
      return new Script(e);
    }
  }, {
    key: "setProperty",
    value: function setProperty(e) {
      return new SetProperty(e);
    }
  }, {
    key: "signData",
    value: function signData(e) {
      return new SignData(e);
    }
  }, {
    key: "signature",
    value: function signature(e) {
      return new Signature(e);
    }
  }, {
    key: "signing",
    value: function signing(e) {
      return new Signing(e);
    }
  }, {
    key: "solid",
    value: function solid(e) {
      return new Solid(e);
    }
  }, {
    key: "speak",
    value: function speak(e) {
      return new Speak(e);
    }
  }, {
    key: "stipple",
    value: function stipple(e) {
      return new Stipple(e);
    }
  }, {
    key: "subform",
    value: function subform(e) {
      return new Subform(e);
    }
  }, {
    key: "subformSet",
    value: function subformSet(e) {
      return new SubformSet(e);
    }
  }, {
    key: "subjectDN",
    value: function subjectDN(e) {
      return new SubjectDN(e);
    }
  }, {
    key: "subjectDNs",
    value: function subjectDNs(e) {
      return new SubjectDNs(e);
    }
  }, {
    key: "submit",
    value: function submit(e) {
      return new Submit(e);
    }
  }, {
    key: "template",
    value: function template(e) {
      return new Template(e);
    }
  }, {
    key: "text",
    value: function text(e) {
      return new Text(e);
    }
  }, {
    key: "textEdit",
    value: function textEdit(e) {
      return new TextEdit(e);
    }
  }, {
    key: "time",
    value: function time(e) {
      return new Time(e);
    }
  }, {
    key: "timeStamp",
    value: function timeStamp(e) {
      return new TimeStamp(e);
    }
  }, {
    key: "toolTip",
    value: function toolTip(e) {
      return new ToolTip(e);
    }
  }, {
    key: "traversal",
    value: function traversal(e) {
      return new Traversal(e);
    }
  }, {
    key: "traverse",
    value: function traverse(e) {
      return new Traverse(e);
    }
  }, {
    key: "ui",
    value: function ui(e) {
      return new Ui(e);
    }
  }, {
    key: "validate",
    value: function validate(e) {
      return new Validate(e);
    }
  }, {
    key: "value",
    value: function value(e) {
      return new Value(e);
    }
  }, {
    key: "variables",
    value: function variables(e) {
      return new Variables(e);
    }
  }]);
}();
var Pn = Cn.datasets.id;
function createText(e) {
  var t = new Text({});
  t[ar] = e;
  return t;
}
var Binder = /*#__PURE__*/function () {
  function Binder(e) {
    var _e$datasets;
    _classCallCheck(this, Binder);
    this.root = e;
    this.datasets = e.datasets;
    this.data = ((_e$datasets = e.datasets) === null || _e$datasets === void 0 ? void 0 : _e$datasets.data) || new XmlObject(Cn.datasets.id, "data");
    this.emptyMerge = 0 === this.data[fr]().length;
    this.root.form = this.form = e.template[tr]();
  }
  return _createClass(Binder, [{
    key: "_isConsumeData",
    value: function _isConsumeData() {
      return !this.emptyMerge && this._mergeMode;
    }
  }, {
    key: "_isMatchTemplate",
    value: function _isMatchTemplate() {
      return !this._isConsumeData();
    }
  }, {
    key: "bind",
    value: function bind() {
      this._bindElement(this.form, this.data);
      return this.form;
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }, {
    key: "_bindValue",
    value: function _bindValue(e, t, i) {
      var _e$ui;
      e[sr] = t;
      if (e[Fr]()) {
        if (t[xr]()) {
          var _i343 = t[Er]();
          e[tn](createText(_i343));
        } else if (e instanceof Field && "multiSelect" === ((_e$ui = e.ui) === null || _e$ui === void 0 || (_e$ui = _e$ui.choiceList) === null || _e$ui === void 0 ? void 0 : _e$ui.open)) {
          var _i344 = t[fr]().map(function (e) {
            return e[ar].trim();
          }).join("\n");
          e[tn](createText(_i344));
        } else this._isConsumeData() && warn("XFA - Nodes haven't the same type.");
      } else !t[xr]() || this._isMatchTemplate() ? this._bindElement(e, t) : warn("XFA - Nodes haven't the same type.");
    }
  }, {
    key: "_findDataByNameToConsume",
    value: function _findDataByNameToConsume(e, t, i, a) {
      var _r140;
      if (!e) return null;
      var s, r;
      for (var _a273 = 0; _a273 < 3; _a273++) {
        s = i[dr](e, !1, !0);
        for (;;) {
          r = s.next().value;
          if (!r) break;
          if (t === r[xr]()) return r;
        }
        if (i[Kr] === Cn.datasets.id && "data" === i[Tr]) break;
        i = i[wr]();
      }
      if (!a) return null;
      s = this.data[dr](e, !0, !1);
      r = s.next().value;
      if (r) return r;
      s = this.data[Ir](e, !0);
      r = s.next().value;
      return (_r140 = r) !== null && _r140 !== void 0 && _r140[xr]() ? r : null;
    }
  }, {
    key: "_setProperties",
    value: function _setProperties(e, t) {
      if (e.hasOwnProperty("setProperty")) {
        var _iterator174 = _createForOfIteratorHelper(e.setProperty.children),
          _step174;
        try {
          for (_iterator174.s(); !(_step174 = _iterator174.n()).done;) {
            var _ref155 = _step174.value;
            var _i345 = _ref155.ref;
            var _a274 = _ref155.target;
            var _s180 = _ref155.connection;
            {
              if (_s180) continue;
              if (!_i345) continue;
              var _r141 = searchNode(this.root, t, _i345, !1, !1);
              if (!_r141) {
                warn("XFA - Invalid reference: ".concat(_i345, "."));
                continue;
              }
              var _r142 = _slicedToArray(_r141, 1),
                _n99 = _r142[0];
              if (!_n99[Ur](this.data)) {
                warn("XFA - Invalid node: must be a data node.");
                continue;
              }
              var _g64 = searchNode(this.root, e, _a274, !1, !1);
              if (!_g64) {
                warn("XFA - Invalid target: ".concat(_a274, "."));
                continue;
              }
              var _g65 = _slicedToArray(_g64, 1),
                _o47 = _g65[0];
              if (!_o47[Ur](e)) {
                warn("XFA - Invalid target: must be a property or subproperty.");
                continue;
              }
              var c = _o47[wr]();
              if (_o47 instanceof SetProperty || c instanceof SetProperty) {
                warn("XFA - Invalid target: cannot be a setProperty or one of its properties.");
                continue;
              }
              if (_o47 instanceof BindItems || c instanceof BindItems) {
                warn("XFA - Invalid target: cannot be a bindItems or one of its properties.");
                continue;
              }
              var C = _n99[sn](),
                h = _o47[Tr];
              if (_o47 instanceof XFAAttribute) {
                var _e534 = Object.create(null);
                _e534[h] = C;
                var _t400 = Reflect.construct(Object.getPrototypeOf(c).constructor, [_e534]);
                c[h] = _t400[h];
              } else if (_o47.hasOwnProperty(ar)) {
                _o47[sr] = _n99;
                _o47[ar] = C;
                _o47[gr]();
              } else warn("XFA - Invalid node to use in setProperty");
            }
          }
        } catch (err) {
          _iterator174.e(err);
        } finally {
          _iterator174.f();
        }
      }
    }
  }, {
    key: "_bindItems",
    value: function _bindItems(e, t) {
      if (!e.hasOwnProperty("items") || !e.hasOwnProperty("bindItems") || e.bindItems.isEmpty()) return;
      var _iterator175 = _createForOfIteratorHelper(e.items.children),
        _step175;
      try {
        for (_iterator175.s(); !(_step175 = _iterator175.n()).done;) {
          var _t401 = _step175.value;
          e[Vr](_t401);
        }
      } catch (err) {
        _iterator175.e(err);
      } finally {
        _iterator175.f();
      }
      e.items.clear();
      var i = new Items({}),
        a = new Items({});
      e[zs](i);
      e.items.push(i);
      e[zs](a);
      e.items.push(a);
      var _iterator176 = _createForOfIteratorHelper(e.bindItems.children),
        _step176;
      try {
        for (_iterator176.s(); !(_step176 = _iterator176.n()).done;) {
          var _ref156 = _step176.value;
          var _s181 = _ref156.ref;
          var _r143 = _ref156.labelRef;
          var _n100 = _ref156.valueRef;
          var _g66 = _ref156.connection;
          {
            if (_g66) continue;
            if (!_s181) continue;
            var _e535 = searchNode(this.root, t, _s181, !1, !1);
            if (_e535) {
              var _iterator177 = _createForOfIteratorHelper(_e535),
                _step177;
              try {
                for (_iterator177.s(); !(_step177 = _iterator177.n()).done;) {
                  var _t402 = _step177.value;
                  if (!_t402[Ur](this.datasets)) {
                    warn("XFA - Invalid ref (".concat(_s181, "): must be a datasets child."));
                    continue;
                  }
                  var _e536 = searchNode(this.root, _t402, _r143, !0, !1);
                  if (!_e536) {
                    warn("XFA - Invalid label: ".concat(_r143, "."));
                    continue;
                  }
                  var _e537 = _slicedToArray(_e536, 1),
                    _g67 = _e537[0];
                  if (!_g67[Ur](this.datasets)) {
                    warn("XFA - Invalid label: must be a datasets child.");
                    continue;
                  }
                  var _o48 = searchNode(this.root, _t402, _n100, !0, !1);
                  if (!_o48) {
                    warn("XFA - Invalid value: ".concat(_n100, "."));
                    continue;
                  }
                  var _o49 = _slicedToArray(_o48, 1),
                    c = _o49[0];
                  if (!c[Ur](this.datasets)) {
                    warn("XFA - Invalid value: must be a datasets child.");
                    continue;
                  }
                  var C = createText(_g67[sn]()),
                    h = createText(c[sn]());
                  i[zs](C);
                  i.text.push(C);
                  a[zs](h);
                  a.text.push(h);
                }
              } catch (err) {
                _iterator177.e(err);
              } finally {
                _iterator177.f();
              }
            } else warn("XFA - Invalid reference: ".concat(_s181, "."));
          }
        }
      } catch (err) {
        _iterator176.e(err);
      } finally {
        _iterator176.f();
      }
    }
  }, {
    key: "_bindOccurrences",
    value: function _bindOccurrences(e, t, i) {
      var a;
      if (t.length > 1) {
        a = e[tr]();
        a[Vr](a.occur);
        a.occur = null;
      }
      this._bindValue(e, t[0], i);
      this._setProperties(e, t[0]);
      this._bindItems(e, t[0]);
      if (1 === t.length) return;
      var s = e[wr](),
        r = e[Tr],
        n = s[kr](e);
      for (var _e538 = 1, _g68 = t.length; _e538 < _g68; _e538++) {
        var _g69 = t[_e538],
          _o50 = a[tr]();
        s[r].push(_o50);
        s[Rr](n + _e538, _o50);
        this._bindValue(_o50, _g69, i);
        this._setProperties(_o50, _g69);
        this._bindItems(_o50, _g69);
      }
    }
  }, {
    key: "_createOccurrences",
    value: function _createOccurrences(e) {
      if (!this.emptyMerge) return;
      var t = e.occur;
      if (!t || t.initial <= 1) return;
      var i = e[wr](),
        a = e[Tr];
      if (!(i[a] instanceof XFAObjectArray)) return;
      var s;
      s = e.name ? i[a].children.filter(function (t) {
        return t.name === e.name;
      }).length : i[a].children.length;
      var r = i[kr](e) + 1,
        n = t.initial - s;
      if (n) {
        var _t403 = e[tr]();
        _t403[Vr](_t403.occur);
        _t403.occur = null;
        i[a].push(_t403);
        i[Rr](r, _t403);
        for (var _e539 = 1; _e539 < n; _e539++) {
          var _s182 = _t403[tr]();
          i[a].push(_s182);
          i[Rr](r + _e539, _s182);
        }
      }
    }
  }, {
    key: "_getOccurInfo",
    value: function _getOccurInfo(e) {
      var t = e.name,
        i = e.occur;
      if (!i || !t) return [1, 1];
      var a = -1 === i.max ? 1 / 0 : i.max;
      return [i.min, a];
    }
  }, {
    key: "_setAndBind",
    value: function _setAndBind(e, t) {
      this._setProperties(e, t);
      this._bindItems(e, t);
      this._bindElement(e, t);
    }
  }, {
    key: "_bindElement",
    value: function _bindElement(e, t) {
      var i = [];
      this._createOccurrences(e);
      var _iterator178 = _createForOfIteratorHelper(e[fr]()),
        _step178;
      try {
        for (_iterator178.s(); !(_step178 = _iterator178.n()).done;) {
          var _a275 = _step178.value;
          if (_a275[sr]) continue;
          if (void 0 === this._mergeMode && "subform" === _a275[Tr]) {
            this._mergeMode = "consumeData" === _a275.mergeMode;
            var _e540 = t[fr]();
            if (_e540.length > 0) this._bindOccurrences(_a275, [_e540[0]], null);else if (this.emptyMerge) {
              var _e541 = t[Kr] === Pn ? -1 : t[Kr],
                _i346 = _a275[sr] = new XmlObject(_e541, _a275.name || "root");
              t[zs](_i346);
              this._bindElement(_a275, _i346);
            }
            continue;
          }
          if (!_a275[Gr]()) continue;
          var _e542 = !1,
            _s183 = null,
            _r144 = null,
            _n101 = null;
          if (_a275.bind) {
            switch (_a275.bind.match) {
              case "none":
                this._setAndBind(_a275, t);
                continue;
              case "global":
                _e542 = !0;
                break;
              case "dataRef":
                if (!_a275.bind.ref) {
                  warn("XFA - ref is empty in node ".concat(_a275[Tr], "."));
                  this._setAndBind(_a275, t);
                  continue;
                }
                _r144 = _a275.bind.ref;
            }
            _a275.bind.picture && (_s183 = _a275.bind.picture[ar]);
          }
          var _this$_getOccurInfo = this._getOccurInfo(_a275),
            _this$_getOccurInfo2 = _slicedToArray(_this$_getOccurInfo, 2),
            _g70 = _this$_getOccurInfo2[0],
            _o51 = _this$_getOccurInfo2[1];
          if (_r144) {
            _n101 = searchNode(this.root, t, _r144, !0, !1);
            if (null === _n101) {
              _n101 = createDataNode(this.data, t, _r144);
              if (!_n101) continue;
              this._isConsumeData() && (_n101[ir] = !0);
              this._setAndBind(_a275, _n101);
              continue;
            }
            this._isConsumeData() && (_n101 = _n101.filter(function (e) {
              return !e[ir];
            }));
            _n101.length > _o51 ? _n101 = _n101.slice(0, _o51) : 0 === _n101.length && (_n101 = null);
            _n101 && this._isConsumeData() && _n101.forEach(function (e) {
              e[ir] = !0;
            });
          } else {
            if (!_a275.name) {
              this._setAndBind(_a275, t);
              continue;
            }
            if (this._isConsumeData()) {
              var _i347 = [];
              for (; _i347.length < _o51;) {
                var _s184 = this._findDataByNameToConsume(_a275.name, _a275[Fr](), t, _e542);
                if (!_s184) break;
                _s184[ir] = !0;
                _i347.push(_s184);
              }
              _n101 = _i347.length > 0 ? _i347 : null;
            } else {
              _n101 = t[dr](_a275.name, !1, this.emptyMerge).next().value;
              if (!_n101) {
                if (0 === _g70) {
                  i.push(_a275);
                  continue;
                }
                var _e543 = t[Kr] === Pn ? -1 : t[Kr];
                _n101 = _a275[sr] = new XmlObject(_e543, _a275.name);
                this.emptyMerge && (_n101[ir] = !0);
                t[zs](_n101);
                this._setAndBind(_a275, _n101);
                continue;
              }
              this.emptyMerge && (_n101[ir] = !0);
              _n101 = [_n101];
            }
          }
          _n101 ? this._bindOccurrences(_a275, _n101, _s183) : _g70 > 0 ? this._setAndBind(_a275, t) : i.push(_a275);
        }
      } catch (err) {
        _iterator178.e(err);
      } finally {
        _iterator178.f();
      }
      i.forEach(function (e) {
        return e[wr]()[Vr](e);
      });
    }
  }]);
}();
var DataHandler = /*#__PURE__*/function () {
  function DataHandler(e, t) {
    _classCallCheck(this, DataHandler);
    this.data = t;
    this.dataset = e.datasets || null;
  }
  return _createClass(DataHandler, [{
    key: "serialize",
    value: function serialize(e) {
      var t = [[-1, this.data[fr]()]];
      for (; t.length > 0;) {
        var _i349 = t.at(-1),
          _i348 = _slicedToArray(_i349, 2),
          _a276 = _i348[0],
          _s185 = _i348[1];
        if (_a276 + 1 === _s185.length) {
          t.pop();
          continue;
        }
        var _r145 = _s185[++_i349[0]],
          _n102 = e.get(_r145[In]);
        if (_n102) _r145[tn](_n102);else {
          var _t404 = _r145[cr]();
          var _iterator179 = _createForOfIteratorHelper(_t404.values()),
            _step179;
          try {
            for (_iterator179.s(); !(_step179 = _iterator179.n()).done;) {
              var _i350 = _step179.value;
              var _t405 = e.get(_i350[In]);
              if (_t405) {
                _i350[tn](_t405);
                break;
              }
            }
          } catch (err) {
            _iterator179.e(err);
          } finally {
            _iterator179.f();
          }
        }
        var _g71 = _r145[fr]();
        _g71.length > 0 && t.push([-1, _g71]);
      }
      var i = ['<xfa:datasets xmlns:xfa="http://www.xfa.org/schema/xfa-data/1.0/">'];
      if (this.dataset) {
        var _iterator180 = _createForOfIteratorHelper(this.dataset[fr]()),
          _step180;
        try {
          for (_iterator180.s(); !(_step180 = _iterator180.n()).done;) {
            var _e544 = _step180.value;
            "data" !== _e544[Tr] && _e544[gn](i);
          }
        } catch (err) {
          _iterator180.e(err);
        } finally {
          _iterator180.f();
        }
      }
      this.data[gn](i);
      i.push("</xfa:datasets>");
      return i.join("");
    }
  }]);
}();
var Wn = Cn.config.id;
var Acrobat = /*#__PURE__*/function (_XFAObject91) {
  function Acrobat(e) {
    var _this183;
    _classCallCheck(this, Acrobat);
    _this183 = _callSuper(this, Acrobat, [Wn, "acrobat", !0]);
    _this183.acrobat7 = null;
    _this183.autoSave = null;
    _this183.common = null;
    _this183.validate = null;
    _this183.validateApprovalSignatures = null;
    _this183.submitUrl = new XFAObjectArray();
    return _this183;
  }
  _inherits(Acrobat, _XFAObject91);
  return _createClass(Acrobat);
}(XFAObject);
var Acrobat7 = /*#__PURE__*/function (_XFAObject92) {
  function Acrobat7(e) {
    var _this184;
    _classCallCheck(this, Acrobat7);
    _this184 = _callSuper(this, Acrobat7, [Wn, "acrobat7", !0]);
    _this184.dynamicRender = null;
    return _this184;
  }
  _inherits(Acrobat7, _XFAObject92);
  return _createClass(Acrobat7);
}(XFAObject);
var _ADBE_JSConsole = /*#__PURE__*/function (_OptionObject4) {
  function ADBE_JSConsole(e) {
    _classCallCheck(this, ADBE_JSConsole);
    return _callSuper(this, ADBE_JSConsole, [Wn, "ADBE_JSConsole", ["delegate", "Enable", "Disable"]]);
  }
  _inherits(ADBE_JSConsole, _OptionObject4);
  return _createClass(ADBE_JSConsole);
}(OptionObject);
var _ADBE_JSDebugger = /*#__PURE__*/function (_OptionObject5) {
  function ADBE_JSDebugger(e) {
    _classCallCheck(this, ADBE_JSDebugger);
    return _callSuper(this, ADBE_JSDebugger, [Wn, "ADBE_JSDebugger", ["delegate", "Enable", "Disable"]]);
  }
  _inherits(ADBE_JSDebugger, _OptionObject5);
  return _createClass(ADBE_JSDebugger);
}(OptionObject);
var AddSilentPrint = /*#__PURE__*/function (_Option2) {
  function AddSilentPrint(e) {
    _classCallCheck(this, AddSilentPrint);
    return _callSuper(this, AddSilentPrint, [Wn, "addSilentPrint"]);
  }
  _inherits(AddSilentPrint, _Option2);
  return _createClass(AddSilentPrint);
}(Option01);
var AddViewerPreferences = /*#__PURE__*/function (_Option3) {
  function AddViewerPreferences(e) {
    _classCallCheck(this, AddViewerPreferences);
    return _callSuper(this, AddViewerPreferences, [Wn, "addViewerPreferences"]);
  }
  _inherits(AddViewerPreferences, _Option3);
  return _createClass(AddViewerPreferences);
}(Option01);
var AdjustData = /*#__PURE__*/function (_Option4) {
  function AdjustData(e) {
    _classCallCheck(this, AdjustData);
    return _callSuper(this, AdjustData, [Wn, "adjustData"]);
  }
  _inherits(AdjustData, _Option4);
  return _createClass(AdjustData);
}(Option10);
var AdobeExtensionLevel = /*#__PURE__*/function (_IntegerObject3) {
  function AdobeExtensionLevel(e) {
    _classCallCheck(this, AdobeExtensionLevel);
    return _callSuper(this, AdobeExtensionLevel, [Wn, "adobeExtensionLevel", 0, function (e) {
      return e >= 1 && e <= 8;
    }]);
  }
  _inherits(AdobeExtensionLevel, _IntegerObject3);
  return _createClass(AdobeExtensionLevel);
}(IntegerObject);
var Agent = /*#__PURE__*/function (_XFAObject93) {
  function Agent(e) {
    var _this185;
    _classCallCheck(this, Agent);
    _this185 = _callSuper(this, Agent, [Wn, "agent", !0]);
    _this185.name = e.name ? e.name.trim() : "";
    _this185.common = new XFAObjectArray();
    return _this185;
  }
  _inherits(Agent, _XFAObject93);
  return _createClass(Agent);
}(XFAObject);
var AlwaysEmbed = /*#__PURE__*/function (_ContentObject13) {
  function AlwaysEmbed(e) {
    _classCallCheck(this, AlwaysEmbed);
    return _callSuper(this, AlwaysEmbed, [Wn, "alwaysEmbed"]);
  }
  _inherits(AlwaysEmbed, _ContentObject13);
  return _createClass(AlwaysEmbed);
}(ContentObject);
var Amd = /*#__PURE__*/function (_StringObject13) {
  function Amd(e) {
    _classCallCheck(this, Amd);
    return _callSuper(this, Amd, [Wn, "amd"]);
  }
  _inherits(Amd, _StringObject13);
  return _createClass(Amd);
}(StringObject);
var config_Area = /*#__PURE__*/function (_XFAObject94) {
  function config_Area(e) {
    var _this186;
    _classCallCheck(this, config_Area);
    _this186 = _callSuper(this, config_Area, [Wn, "area"]);
    _this186.level = getInteger({
      data: e.level,
      defaultValue: 0,
      validate: function validate(e) {
        return e >= 1 && e <= 3;
      }
    });
    _this186.name = getStringOption(e.name, ["", "barcode", "coreinit", "deviceDriver", "font", "general", "layout", "merge", "script", "signature", "sourceSet", "templateCache"]);
    return _this186;
  }
  _inherits(config_Area, _XFAObject94);
  return _createClass(config_Area);
}(XFAObject);
var Attributes = /*#__PURE__*/function (_OptionObject6) {
  function Attributes(e) {
    _classCallCheck(this, Attributes);
    return _callSuper(this, Attributes, [Wn, "attributes", ["preserve", "delegate", "ignore"]]);
  }
  _inherits(Attributes, _OptionObject6);
  return _createClass(Attributes);
}(OptionObject);
var AutoSave = /*#__PURE__*/function (_OptionObject7) {
  function AutoSave(e) {
    _classCallCheck(this, AutoSave);
    return _callSuper(this, AutoSave, [Wn, "autoSave", ["disabled", "enabled"]]);
  }
  _inherits(AutoSave, _OptionObject7);
  return _createClass(AutoSave);
}(OptionObject);
var Base = /*#__PURE__*/function (_StringObject14) {
  function Base(e) {
    _classCallCheck(this, Base);
    return _callSuper(this, Base, [Wn, "base"]);
  }
  _inherits(Base, _StringObject14);
  return _createClass(Base);
}(StringObject);
var BatchOutput = /*#__PURE__*/function (_XFAObject95) {
  function BatchOutput(e) {
    var _this187;
    _classCallCheck(this, BatchOutput);
    _this187 = _callSuper(this, BatchOutput, [Wn, "batchOutput"]);
    _this187.format = getStringOption(e.format, ["none", "concat", "zip", "zipCompress"]);
    return _this187;
  }
  _inherits(BatchOutput, _XFAObject95);
  return _createClass(BatchOutput);
}(XFAObject);
var BehaviorOverride = /*#__PURE__*/function (_ContentObject14) {
  function BehaviorOverride(e) {
    _classCallCheck(this, BehaviorOverride);
    return _callSuper(this, BehaviorOverride, [Wn, "behaviorOverride"]);
  }
  _inherits(BehaviorOverride, _ContentObject14);
  return _createClass(BehaviorOverride, [{
    key: gr,
    value: function value() {
      this[ar] = new Map(this[ar].trim().split(/\s+/).filter(function (e) {
        return e.includes(":");
      }).map(function (e) {
        return e.split(":", 2);
      }));
    }
  }]);
}(ContentObject);
var Cache = /*#__PURE__*/function (_XFAObject96) {
  function Cache(e) {
    var _this188;
    _classCallCheck(this, Cache);
    _this188 = _callSuper(this, Cache, [Wn, "cache", !0]);
    _this188.templateCache = null;
    return _this188;
  }
  _inherits(Cache, _XFAObject96);
  return _createClass(Cache);
}(XFAObject);
var Change = /*#__PURE__*/function (_Option5) {
  function Change(e) {
    _classCallCheck(this, Change);
    return _callSuper(this, Change, [Wn, "change"]);
  }
  _inherits(Change, _Option5);
  return _createClass(Change);
}(Option01);
var Common = /*#__PURE__*/function (_XFAObject97) {
  function Common(e) {
    var _this189;
    _classCallCheck(this, Common);
    _this189 = _callSuper(this, Common, [Wn, "common", !0]);
    _this189.data = null;
    _this189.locale = null;
    _this189.localeSet = null;
    _this189.messaging = null;
    _this189.suppressBanner = null;
    _this189.template = null;
    _this189.validationMessaging = null;
    _this189.versionControl = null;
    _this189.log = new XFAObjectArray();
    return _this189;
  }
  _inherits(Common, _XFAObject97);
  return _createClass(Common);
}(XFAObject);
var Compress = /*#__PURE__*/function (_XFAObject98) {
  function Compress(e) {
    var _this190;
    _classCallCheck(this, Compress);
    _this190 = _callSuper(this, Compress, [Wn, "compress"]);
    _this190.scope = getStringOption(e.scope, ["imageOnly", "document"]);
    return _this190;
  }
  _inherits(Compress, _XFAObject98);
  return _createClass(Compress);
}(XFAObject);
var CompressLogicalStructure = /*#__PURE__*/function (_Option6) {
  function CompressLogicalStructure(e) {
    _classCallCheck(this, CompressLogicalStructure);
    return _callSuper(this, CompressLogicalStructure, [Wn, "compressLogicalStructure"]);
  }
  _inherits(CompressLogicalStructure, _Option6);
  return _createClass(CompressLogicalStructure);
}(Option01);
var CompressObjectStream = /*#__PURE__*/function (_Option7) {
  function CompressObjectStream(e) {
    _classCallCheck(this, CompressObjectStream);
    return _callSuper(this, CompressObjectStream, [Wn, "compressObjectStream"]);
  }
  _inherits(CompressObjectStream, _Option7);
  return _createClass(CompressObjectStream);
}(Option10);
var Compression = /*#__PURE__*/function (_XFAObject99) {
  function Compression(e) {
    var _this191;
    _classCallCheck(this, Compression);
    _this191 = _callSuper(this, Compression, [Wn, "compression", !0]);
    _this191.compressLogicalStructure = null;
    _this191.compressObjectStream = null;
    _this191.level = null;
    _this191.type = null;
    return _this191;
  }
  _inherits(Compression, _XFAObject99);
  return _createClass(Compression);
}(XFAObject);
var Config = /*#__PURE__*/function (_XFAObject100) {
  function Config(e) {
    var _this192;
    _classCallCheck(this, Config);
    _this192 = _callSuper(this, Config, [Wn, "config", !0]);
    _this192.acrobat = null;
    _this192.present = null;
    _this192.trace = null;
    _this192.agent = new XFAObjectArray();
    return _this192;
  }
  _inherits(Config, _XFAObject100);
  return _createClass(Config);
}(XFAObject);
var Conformance = /*#__PURE__*/function (_OptionObject8) {
  function Conformance(e) {
    _classCallCheck(this, Conformance);
    return _callSuper(this, Conformance, [Wn, "conformance", ["A", "B"]]);
  }
  _inherits(Conformance, _OptionObject8);
  return _createClass(Conformance);
}(OptionObject);
var ContentCopy = /*#__PURE__*/function (_Option8) {
  function ContentCopy(e) {
    _classCallCheck(this, ContentCopy);
    return _callSuper(this, ContentCopy, [Wn, "contentCopy"]);
  }
  _inherits(ContentCopy, _Option8);
  return _createClass(ContentCopy);
}(Option01);
var Copies = /*#__PURE__*/function (_IntegerObject4) {
  function Copies(e) {
    _classCallCheck(this, Copies);
    return _callSuper(this, Copies, [Wn, "copies", 1, function (e) {
      return e >= 1;
    }]);
  }
  _inherits(Copies, _IntegerObject4);
  return _createClass(Copies);
}(IntegerObject);
var Creator = /*#__PURE__*/function (_StringObject15) {
  function Creator(e) {
    _classCallCheck(this, Creator);
    return _callSuper(this, Creator, [Wn, "creator"]);
  }
  _inherits(Creator, _StringObject15);
  return _createClass(Creator);
}(StringObject);
var CurrentPage = /*#__PURE__*/function (_IntegerObject5) {
  function CurrentPage(e) {
    _classCallCheck(this, CurrentPage);
    return _callSuper(this, CurrentPage, [Wn, "currentPage", 0, function (e) {
      return e >= 0;
    }]);
  }
  _inherits(CurrentPage, _IntegerObject5);
  return _createClass(CurrentPage);
}(IntegerObject);
var Data = /*#__PURE__*/function (_XFAObject101) {
  function Data(e) {
    var _this193;
    _classCallCheck(this, Data);
    _this193 = _callSuper(this, Data, [Wn, "data", !0]);
    _this193.adjustData = null;
    _this193.attributes = null;
    _this193.incrementalLoad = null;
    _this193.outputXSL = null;
    _this193.range = null;
    _this193.record = null;
    _this193.startNode = null;
    _this193.uri = null;
    _this193.window = null;
    _this193.xsl = null;
    _this193.excludeNS = new XFAObjectArray();
    _this193.transform = new XFAObjectArray();
    return _this193;
  }
  _inherits(Data, _XFAObject101);
  return _createClass(Data);
}(XFAObject);
var Debug = /*#__PURE__*/function (_XFAObject102) {
  function Debug(e) {
    var _this194;
    _classCallCheck(this, Debug);
    _this194 = _callSuper(this, Debug, [Wn, "debug", !0]);
    _this194.uri = null;
    return _this194;
  }
  _inherits(Debug, _XFAObject102);
  return _createClass(Debug);
}(XFAObject);
var DefaultTypeface = /*#__PURE__*/function (_ContentObject15) {
  function DefaultTypeface(e) {
    var _this195;
    _classCallCheck(this, DefaultTypeface);
    _this195 = _callSuper(this, DefaultTypeface, [Wn, "defaultTypeface"]);
    _this195.writingScript = getStringOption(e.writingScript, ["*", "Arabic", "Cyrillic", "EastEuropeanRoman", "Greek", "Hebrew", "Japanese", "Korean", "Roman", "SimplifiedChinese", "Thai", "TraditionalChinese", "Vietnamese"]);
    return _this195;
  }
  _inherits(DefaultTypeface, _ContentObject15);
  return _createClass(DefaultTypeface);
}(ContentObject);
var Destination = /*#__PURE__*/function (_OptionObject9) {
  function Destination(e) {
    _classCallCheck(this, Destination);
    return _callSuper(this, Destination, [Wn, "destination", ["pdf", "pcl", "ps", "webClient", "zpl"]]);
  }
  _inherits(Destination, _OptionObject9);
  return _createClass(Destination);
}(OptionObject);
var DocumentAssembly = /*#__PURE__*/function (_Option9) {
  function DocumentAssembly(e) {
    _classCallCheck(this, DocumentAssembly);
    return _callSuper(this, DocumentAssembly, [Wn, "documentAssembly"]);
  }
  _inherits(DocumentAssembly, _Option9);
  return _createClass(DocumentAssembly);
}(Option01);
var Driver = /*#__PURE__*/function (_XFAObject103) {
  function Driver(e) {
    var _this196;
    _classCallCheck(this, Driver);
    _this196 = _callSuper(this, Driver, [Wn, "driver", !0]);
    _this196.name = e.name ? e.name.trim() : "";
    _this196.fontInfo = null;
    _this196.xdc = null;
    return _this196;
  }
  _inherits(Driver, _XFAObject103);
  return _createClass(Driver);
}(XFAObject);
var DuplexOption = /*#__PURE__*/function (_OptionObject10) {
  function DuplexOption(e) {
    _classCallCheck(this, DuplexOption);
    return _callSuper(this, DuplexOption, [Wn, "duplexOption", ["simplex", "duplexFlipLongEdge", "duplexFlipShortEdge"]]);
  }
  _inherits(DuplexOption, _OptionObject10);
  return _createClass(DuplexOption);
}(OptionObject);
var DynamicRender = /*#__PURE__*/function (_OptionObject11) {
  function DynamicRender(e) {
    _classCallCheck(this, DynamicRender);
    return _callSuper(this, DynamicRender, [Wn, "dynamicRender", ["forbidden", "required"]]);
  }
  _inherits(DynamicRender, _OptionObject11);
  return _createClass(DynamicRender);
}(OptionObject);
var Embed = /*#__PURE__*/function (_Option10) {
  function Embed(e) {
    _classCallCheck(this, Embed);
    return _callSuper(this, Embed, [Wn, "embed"]);
  }
  _inherits(Embed, _Option10);
  return _createClass(Embed);
}(Option01);
var config_Encrypt = /*#__PURE__*/function (_Option11) {
  function config_Encrypt(e) {
    _classCallCheck(this, config_Encrypt);
    return _callSuper(this, config_Encrypt, [Wn, "encrypt"]);
  }
  _inherits(config_Encrypt, _Option11);
  return _createClass(config_Encrypt);
}(Option01);
var config_Encryption = /*#__PURE__*/function (_XFAObject104) {
  function config_Encryption(e) {
    var _this197;
    _classCallCheck(this, config_Encryption);
    _this197 = _callSuper(this, config_Encryption, [Wn, "encryption", !0]);
    _this197.encrypt = null;
    _this197.encryptionLevel = null;
    _this197.permissions = null;
    return _this197;
  }
  _inherits(config_Encryption, _XFAObject104);
  return _createClass(config_Encryption);
}(XFAObject);
var EncryptionLevel = /*#__PURE__*/function (_OptionObject12) {
  function EncryptionLevel(e) {
    _classCallCheck(this, EncryptionLevel);
    return _callSuper(this, EncryptionLevel, [Wn, "encryptionLevel", ["40bit", "128bit"]]);
  }
  _inherits(EncryptionLevel, _OptionObject12);
  return _createClass(EncryptionLevel);
}(OptionObject);
var Enforce = /*#__PURE__*/function (_StringObject16) {
  function Enforce(e) {
    _classCallCheck(this, Enforce);
    return _callSuper(this, Enforce, [Wn, "enforce"]);
  }
  _inherits(Enforce, _StringObject16);
  return _createClass(Enforce);
}(StringObject);
var Equate = /*#__PURE__*/function (_XFAObject105) {
  function Equate(e) {
    var _this198;
    _classCallCheck(this, Equate);
    _this198 = _callSuper(this, Equate, [Wn, "equate"]);
    _this198.force = getInteger({
      data: e.force,
      defaultValue: 1,
      validate: function validate(e) {
        return 0 === e;
      }
    });
    _this198.from = e.from || "";
    _this198.to = e.to || "";
    return _this198;
  }
  _inherits(Equate, _XFAObject105);
  return _createClass(Equate);
}(XFAObject);
var EquateRange = /*#__PURE__*/function (_XFAObject106) {
  function EquateRange(e) {
    var _this199;
    _classCallCheck(this, EquateRange);
    _this199 = _callSuper(this, EquateRange, [Wn, "equateRange"]);
    _this199.from = e.from || "";
    _this199.to = e.to || "";
    _this199._unicodeRange = e.unicodeRange || "";
    return _this199;
  }
  _inherits(EquateRange, _XFAObject106);
  return _createClass(EquateRange, [{
    key: "unicodeRange",
    get: function get() {
      var e = [],
        t = /U\+([0-9a-fA-F]+)/,
        i = this._unicodeRange;
      var _iterator181 = _createForOfIteratorHelper(i.split(",").map(function (e) {
          return e.trim();
        }).filter(function (e) {
          return !!e;
        })),
        _step181;
      try {
        for (_iterator181.s(); !(_step181 = _iterator181.n()).done;) {
          var _a277 = _step181.value;
          _a277 = _a277.split("-", 2).map(function (e) {
            var i = e.match(t);
            return i ? parseInt(i[1], 16) : 0;
          });
          1 === _a277.length && _a277.push(_a277[0]);
          e.push(_a277);
        }
      } catch (err) {
        _iterator181.e(err);
      } finally {
        _iterator181.f();
      }
      return shadow(this, "unicodeRange", e);
    }
  }]);
}(XFAObject);
var Exclude = /*#__PURE__*/function (_ContentObject16) {
  function Exclude(e) {
    _classCallCheck(this, Exclude);
    return _callSuper(this, Exclude, [Wn, "exclude"]);
  }
  _inherits(Exclude, _ContentObject16);
  return _createClass(Exclude, [{
    key: gr,
    value: function value() {
      this[ar] = this[ar].trim().split(/\s+/).filter(function (e) {
        return e && ["calculate", "close", "enter", "exit", "initialize", "ready", "validate"].includes(e);
      });
    }
  }]);
}(ContentObject);
var ExcludeNS = /*#__PURE__*/function (_StringObject17) {
  function ExcludeNS(e) {
    _classCallCheck(this, ExcludeNS);
    return _callSuper(this, ExcludeNS, [Wn, "excludeNS"]);
  }
  _inherits(ExcludeNS, _StringObject17);
  return _createClass(ExcludeNS);
}(StringObject);
var FlipLabel = /*#__PURE__*/function (_OptionObject13) {
  function FlipLabel(e) {
    _classCallCheck(this, FlipLabel);
    return _callSuper(this, FlipLabel, [Wn, "flipLabel", ["usePrinterSetting", "on", "off"]]);
  }
  _inherits(FlipLabel, _OptionObject13);
  return _createClass(FlipLabel);
}(OptionObject);
var config_FontInfo = /*#__PURE__*/function (_XFAObject107) {
  function config_FontInfo(e) {
    var _this200;
    _classCallCheck(this, config_FontInfo);
    _this200 = _callSuper(this, config_FontInfo, [Wn, "fontInfo", !0]);
    _this200.embed = null;
    _this200.map = null;
    _this200.subsetBelow = null;
    _this200.alwaysEmbed = new XFAObjectArray();
    _this200.defaultTypeface = new XFAObjectArray();
    _this200.neverEmbed = new XFAObjectArray();
    return _this200;
  }
  _inherits(config_FontInfo, _XFAObject107);
  return _createClass(config_FontInfo);
}(XFAObject);
var FormFieldFilling = /*#__PURE__*/function (_Option12) {
  function FormFieldFilling(e) {
    _classCallCheck(this, FormFieldFilling);
    return _callSuper(this, FormFieldFilling, [Wn, "formFieldFilling"]);
  }
  _inherits(FormFieldFilling, _Option12);
  return _createClass(FormFieldFilling);
}(Option01);
var GroupParent = /*#__PURE__*/function (_StringObject18) {
  function GroupParent(e) {
    _classCallCheck(this, GroupParent);
    return _callSuper(this, GroupParent, [Wn, "groupParent"]);
  }
  _inherits(GroupParent, _StringObject18);
  return _createClass(GroupParent);
}(StringObject);
var IfEmpty = /*#__PURE__*/function (_OptionObject14) {
  function IfEmpty(e) {
    _classCallCheck(this, IfEmpty);
    return _callSuper(this, IfEmpty, [Wn, "ifEmpty", ["dataValue", "dataGroup", "ignore", "remove"]]);
  }
  _inherits(IfEmpty, _OptionObject14);
  return _createClass(IfEmpty);
}(OptionObject);
var IncludeXDPContent = /*#__PURE__*/function (_StringObject19) {
  function IncludeXDPContent(e) {
    _classCallCheck(this, IncludeXDPContent);
    return _callSuper(this, IncludeXDPContent, [Wn, "includeXDPContent"]);
  }
  _inherits(IncludeXDPContent, _StringObject19);
  return _createClass(IncludeXDPContent);
}(StringObject);
var IncrementalLoad = /*#__PURE__*/function (_OptionObject15) {
  function IncrementalLoad(e) {
    _classCallCheck(this, IncrementalLoad);
    return _callSuper(this, IncrementalLoad, [Wn, "incrementalLoad", ["none", "forwardOnly"]]);
  }
  _inherits(IncrementalLoad, _OptionObject15);
  return _createClass(IncrementalLoad);
}(OptionObject);
var IncrementalMerge = /*#__PURE__*/function (_Option13) {
  function IncrementalMerge(e) {
    _classCallCheck(this, IncrementalMerge);
    return _callSuper(this, IncrementalMerge, [Wn, "incrementalMerge"]);
  }
  _inherits(IncrementalMerge, _Option13);
  return _createClass(IncrementalMerge);
}(Option01);
var Interactive = /*#__PURE__*/function (_Option14) {
  function Interactive(e) {
    _classCallCheck(this, Interactive);
    return _callSuper(this, Interactive, [Wn, "interactive"]);
  }
  _inherits(Interactive, _Option14);
  return _createClass(Interactive);
}(Option01);
var Jog = /*#__PURE__*/function (_OptionObject16) {
  function Jog(e) {
    _classCallCheck(this, Jog);
    return _callSuper(this, Jog, [Wn, "jog", ["usePrinterSetting", "none", "pageSet"]]);
  }
  _inherits(Jog, _OptionObject16);
  return _createClass(Jog);
}(OptionObject);
var LabelPrinter = /*#__PURE__*/function (_XFAObject108) {
  function LabelPrinter(e) {
    var _this201;
    _classCallCheck(this, LabelPrinter);
    _this201 = _callSuper(this, LabelPrinter, [Wn, "labelPrinter", !0]);
    _this201.name = getStringOption(e.name, ["zpl", "dpl", "ipl", "tcpl"]);
    _this201.batchOutput = null;
    _this201.flipLabel = null;
    _this201.fontInfo = null;
    _this201.xdc = null;
    return _this201;
  }
  _inherits(LabelPrinter, _XFAObject108);
  return _createClass(LabelPrinter);
}(XFAObject);
var Layout = /*#__PURE__*/function (_OptionObject17) {
  function Layout(e) {
    _classCallCheck(this, Layout);
    return _callSuper(this, Layout, [Wn, "layout", ["paginate", "panel"]]);
  }
  _inherits(Layout, _OptionObject17);
  return _createClass(Layout);
}(OptionObject);
var Level = /*#__PURE__*/function (_IntegerObject6) {
  function Level(e) {
    _classCallCheck(this, Level);
    return _callSuper(this, Level, [Wn, "level", 0, function (e) {
      return e > 0;
    }]);
  }
  _inherits(Level, _IntegerObject6);
  return _createClass(Level);
}(IntegerObject);
var Linearized = /*#__PURE__*/function (_Option15) {
  function Linearized(e) {
    _classCallCheck(this, Linearized);
    return _callSuper(this, Linearized, [Wn, "linearized"]);
  }
  _inherits(Linearized, _Option15);
  return _createClass(Linearized);
}(Option01);
var Locale = /*#__PURE__*/function (_StringObject20) {
  function Locale(e) {
    _classCallCheck(this, Locale);
    return _callSuper(this, Locale, [Wn, "locale"]);
  }
  _inherits(Locale, _StringObject20);
  return _createClass(Locale);
}(StringObject);
var LocaleSet = /*#__PURE__*/function (_StringObject21) {
  function LocaleSet(e) {
    _classCallCheck(this, LocaleSet);
    return _callSuper(this, LocaleSet, [Wn, "localeSet"]);
  }
  _inherits(LocaleSet, _StringObject21);
  return _createClass(LocaleSet);
}(StringObject);
var Log = /*#__PURE__*/function (_XFAObject109) {
  function Log(e) {
    var _this202;
    _classCallCheck(this, Log);
    _this202 = _callSuper(this, Log, [Wn, "log", !0]);
    _this202.mode = null;
    _this202.threshold = null;
    _this202.to = null;
    _this202.uri = null;
    return _this202;
  }
  _inherits(Log, _XFAObject109);
  return _createClass(Log);
}(XFAObject);
var MapElement = /*#__PURE__*/function (_XFAObject110) {
  function MapElement(e) {
    var _this203;
    _classCallCheck(this, MapElement);
    _this203 = _callSuper(this, MapElement, [Wn, "map", !0]);
    _this203.equate = new XFAObjectArray();
    _this203.equateRange = new XFAObjectArray();
    return _this203;
  }
  _inherits(MapElement, _XFAObject110);
  return _createClass(MapElement);
}(XFAObject);
var MediumInfo = /*#__PURE__*/function (_XFAObject111) {
  function MediumInfo(e) {
    var _this204;
    _classCallCheck(this, MediumInfo);
    _this204 = _callSuper(this, MediumInfo, [Wn, "mediumInfo", !0]);
    _this204.map = null;
    return _this204;
  }
  _inherits(MediumInfo, _XFAObject111);
  return _createClass(MediumInfo);
}(XFAObject);
var config_Message = /*#__PURE__*/function (_XFAObject112) {
  function config_Message(e) {
    var _this205;
    _classCallCheck(this, config_Message);
    _this205 = _callSuper(this, config_Message, [Wn, "message", !0]);
    _this205.msgId = null;
    _this205.severity = null;
    return _this205;
  }
  _inherits(config_Message, _XFAObject112);
  return _createClass(config_Message);
}(XFAObject);
var Messaging = /*#__PURE__*/function (_XFAObject113) {
  function Messaging(e) {
    var _this206;
    _classCallCheck(this, Messaging);
    _this206 = _callSuper(this, Messaging, [Wn, "messaging", !0]);
    _this206.message = new XFAObjectArray();
    return _this206;
  }
  _inherits(Messaging, _XFAObject113);
  return _createClass(Messaging);
}(XFAObject);
var Mode = /*#__PURE__*/function (_OptionObject18) {
  function Mode(e) {
    _classCallCheck(this, Mode);
    return _callSuper(this, Mode, [Wn, "mode", ["append", "overwrite"]]);
  }
  _inherits(Mode, _OptionObject18);
  return _createClass(Mode);
}(OptionObject);
var ModifyAnnots = /*#__PURE__*/function (_Option16) {
  function ModifyAnnots(e) {
    _classCallCheck(this, ModifyAnnots);
    return _callSuper(this, ModifyAnnots, [Wn, "modifyAnnots"]);
  }
  _inherits(ModifyAnnots, _Option16);
  return _createClass(ModifyAnnots);
}(Option01);
var MsgId = /*#__PURE__*/function (_IntegerObject7) {
  function MsgId(e) {
    _classCallCheck(this, MsgId);
    return _callSuper(this, MsgId, [Wn, "msgId", 1, function (e) {
      return e >= 1;
    }]);
  }
  _inherits(MsgId, _IntegerObject7);
  return _createClass(MsgId);
}(IntegerObject);
var NameAttr = /*#__PURE__*/function (_StringObject22) {
  function NameAttr(e) {
    _classCallCheck(this, NameAttr);
    return _callSuper(this, NameAttr, [Wn, "nameAttr"]);
  }
  _inherits(NameAttr, _StringObject22);
  return _createClass(NameAttr);
}(StringObject);
var NeverEmbed = /*#__PURE__*/function (_ContentObject17) {
  function NeverEmbed(e) {
    _classCallCheck(this, NeverEmbed);
    return _callSuper(this, NeverEmbed, [Wn, "neverEmbed"]);
  }
  _inherits(NeverEmbed, _ContentObject17);
  return _createClass(NeverEmbed);
}(ContentObject);
var NumberOfCopies = /*#__PURE__*/function (_IntegerObject8) {
  function NumberOfCopies(e) {
    _classCallCheck(this, NumberOfCopies);
    return _callSuper(this, NumberOfCopies, [Wn, "numberOfCopies", null, function (e) {
      return e >= 2 && e <= 5;
    }]);
  }
  _inherits(NumberOfCopies, _IntegerObject8);
  return _createClass(NumberOfCopies);
}(IntegerObject);
var OpenAction = /*#__PURE__*/function (_XFAObject114) {
  function OpenAction(e) {
    var _this207;
    _classCallCheck(this, OpenAction);
    _this207 = _callSuper(this, OpenAction, [Wn, "openAction", !0]);
    _this207.destination = null;
    return _this207;
  }
  _inherits(OpenAction, _XFAObject114);
  return _createClass(OpenAction);
}(XFAObject);
var Output = /*#__PURE__*/function (_XFAObject115) {
  function Output(e) {
    var _this208;
    _classCallCheck(this, Output);
    _this208 = _callSuper(this, Output, [Wn, "output", !0]);
    _this208.to = null;
    _this208.type = null;
    _this208.uri = null;
    return _this208;
  }
  _inherits(Output, _XFAObject115);
  return _createClass(Output);
}(XFAObject);
var OutputBin = /*#__PURE__*/function (_StringObject23) {
  function OutputBin(e) {
    _classCallCheck(this, OutputBin);
    return _callSuper(this, OutputBin, [Wn, "outputBin"]);
  }
  _inherits(OutputBin, _StringObject23);
  return _createClass(OutputBin);
}(StringObject);
var OutputXSL = /*#__PURE__*/function (_XFAObject116) {
  function OutputXSL(e) {
    var _this209;
    _classCallCheck(this, OutputXSL);
    _this209 = _callSuper(this, OutputXSL, [Wn, "outputXSL", !0]);
    _this209.uri = null;
    return _this209;
  }
  _inherits(OutputXSL, _XFAObject116);
  return _createClass(OutputXSL);
}(XFAObject);
var Overprint = /*#__PURE__*/function (_OptionObject19) {
  function Overprint(e) {
    _classCallCheck(this, Overprint);
    return _callSuper(this, Overprint, [Wn, "overprint", ["none", "both", "draw", "field"]]);
  }
  _inherits(Overprint, _OptionObject19);
  return _createClass(Overprint);
}(OptionObject);
var Packets = /*#__PURE__*/function (_StringObject24) {
  function Packets(e) {
    _classCallCheck(this, Packets);
    return _callSuper(this, Packets, [Wn, "packets"]);
  }
  _inherits(Packets, _StringObject24);
  return _createClass(Packets, [{
    key: gr,
    value: function value() {
      "*" !== this[ar] && (this[ar] = this[ar].trim().split(/\s+/).filter(function (e) {
        return ["config", "datasets", "template", "xfdf", "xslt"].includes(e);
      }));
    }
  }]);
}(StringObject);
var PageOffset = /*#__PURE__*/function (_XFAObject117) {
  function PageOffset(e) {
    var _this210;
    _classCallCheck(this, PageOffset);
    _this210 = _callSuper(this, PageOffset, [Wn, "pageOffset"]);
    _this210.x = getInteger({
      data: e.x,
      defaultValue: "useXDCSetting",
      validate: function validate(e) {
        return !0;
      }
    });
    _this210.y = getInteger({
      data: e.y,
      defaultValue: "useXDCSetting",
      validate: function validate(e) {
        return !0;
      }
    });
    return _this210;
  }
  _inherits(PageOffset, _XFAObject117);
  return _createClass(PageOffset);
}(XFAObject);
var PageRange = /*#__PURE__*/function (_StringObject25) {
  function PageRange(e) {
    _classCallCheck(this, PageRange);
    return _callSuper(this, PageRange, [Wn, "pageRange"]);
  }
  _inherits(PageRange, _StringObject25);
  return _createClass(PageRange, [{
    key: gr,
    value: function value() {
      var e = this[ar].trim().split(/\s+/).map(function (e) {
          return parseInt(e, 10);
        }),
        t = [];
      for (var _i351 = 0, _a278 = e.length; _i351 < _a278; _i351 += 2) t.push(e.slice(_i351, _i351 + 2));
      this[ar] = t;
    }
  }]);
}(StringObject);
var Pagination = /*#__PURE__*/function (_OptionObject20) {
  function Pagination(e) {
    _classCallCheck(this, Pagination);
    return _callSuper(this, Pagination, [Wn, "pagination", ["simplex", "duplexShortEdge", "duplexLongEdge"]]);
  }
  _inherits(Pagination, _OptionObject20);
  return _createClass(Pagination);
}(OptionObject);
var PaginationOverride = /*#__PURE__*/function (_OptionObject21) {
  function PaginationOverride(e) {
    _classCallCheck(this, PaginationOverride);
    return _callSuper(this, PaginationOverride, [Wn, "paginationOverride", ["none", "forceDuplex", "forceDuplexLongEdge", "forceDuplexShortEdge", "forceSimplex"]]);
  }
  _inherits(PaginationOverride, _OptionObject21);
  return _createClass(PaginationOverride);
}(OptionObject);
var Part = /*#__PURE__*/function (_IntegerObject9) {
  function Part(e) {
    _classCallCheck(this, Part);
    return _callSuper(this, Part, [Wn, "part", 1, function (e) {
      return !1;
    }]);
  }
  _inherits(Part, _IntegerObject9);
  return _createClass(Part);
}(IntegerObject);
var Pcl = /*#__PURE__*/function (_XFAObject118) {
  function Pcl(e) {
    var _this211;
    _classCallCheck(this, Pcl);
    _this211 = _callSuper(this, Pcl, [Wn, "pcl", !0]);
    _this211.name = e.name || "";
    _this211.batchOutput = null;
    _this211.fontInfo = null;
    _this211.jog = null;
    _this211.mediumInfo = null;
    _this211.outputBin = null;
    _this211.pageOffset = null;
    _this211.staple = null;
    _this211.xdc = null;
    return _this211;
  }
  _inherits(Pcl, _XFAObject118);
  return _createClass(Pcl);
}(XFAObject);
var Pdf = /*#__PURE__*/function (_XFAObject119) {
  function Pdf(e) {
    var _this212;
    _classCallCheck(this, Pdf);
    _this212 = _callSuper(this, Pdf, [Wn, "pdf", !0]);
    _this212.name = e.name || "";
    _this212.adobeExtensionLevel = null;
    _this212.batchOutput = null;
    _this212.compression = null;
    _this212.creator = null;
    _this212.encryption = null;
    _this212.fontInfo = null;
    _this212.interactive = null;
    _this212.linearized = null;
    _this212.openAction = null;
    _this212.pdfa = null;
    _this212.producer = null;
    _this212.renderPolicy = null;
    _this212.scriptModel = null;
    _this212.silentPrint = null;
    _this212.submitFormat = null;
    _this212.tagged = null;
    _this212.version = null;
    _this212.viewerPreferences = null;
    _this212.xdc = null;
    return _this212;
  }
  _inherits(Pdf, _XFAObject119);
  return _createClass(Pdf);
}(XFAObject);
var Pdfa = /*#__PURE__*/function (_XFAObject120) {
  function Pdfa(e) {
    var _this213;
    _classCallCheck(this, Pdfa);
    _this213 = _callSuper(this, Pdfa, [Wn, "pdfa", !0]);
    _this213.amd = null;
    _this213.conformance = null;
    _this213.includeXDPContent = null;
    _this213.part = null;
    return _this213;
  }
  _inherits(Pdfa, _XFAObject120);
  return _createClass(Pdfa);
}(XFAObject);
var Permissions = /*#__PURE__*/function (_XFAObject121) {
  function Permissions(e) {
    var _this214;
    _classCallCheck(this, Permissions);
    _this214 = _callSuper(this, Permissions, [Wn, "permissions", !0]);
    _this214.accessibleContent = null;
    _this214.change = null;
    _this214.contentCopy = null;
    _this214.documentAssembly = null;
    _this214.formFieldFilling = null;
    _this214.modifyAnnots = null;
    _this214.plaintextMetadata = null;
    _this214.print = null;
    _this214.printHighQuality = null;
    return _this214;
  }
  _inherits(Permissions, _XFAObject121);
  return _createClass(Permissions);
}(XFAObject);
var PickTrayByPDFSize = /*#__PURE__*/function (_Option17) {
  function PickTrayByPDFSize(e) {
    _classCallCheck(this, PickTrayByPDFSize);
    return _callSuper(this, PickTrayByPDFSize, [Wn, "pickTrayByPDFSize"]);
  }
  _inherits(PickTrayByPDFSize, _Option17);
  return _createClass(PickTrayByPDFSize);
}(Option01);
var config_Picture = /*#__PURE__*/function (_StringObject26) {
  function config_Picture(e) {
    _classCallCheck(this, config_Picture);
    return _callSuper(this, config_Picture, [Wn, "picture"]);
  }
  _inherits(config_Picture, _StringObject26);
  return _createClass(config_Picture);
}(StringObject);
var PlaintextMetadata = /*#__PURE__*/function (_Option18) {
  function PlaintextMetadata(e) {
    _classCallCheck(this, PlaintextMetadata);
    return _callSuper(this, PlaintextMetadata, [Wn, "plaintextMetadata"]);
  }
  _inherits(PlaintextMetadata, _Option18);
  return _createClass(PlaintextMetadata);
}(Option01);
var Presence = /*#__PURE__*/function (_OptionObject22) {
  function Presence(e) {
    _classCallCheck(this, Presence);
    return _callSuper(this, Presence, [Wn, "presence", ["preserve", "dissolve", "dissolveStructure", "ignore", "remove"]]);
  }
  _inherits(Presence, _OptionObject22);
  return _createClass(Presence);
}(OptionObject);
var Present = /*#__PURE__*/function (_XFAObject122) {
  function Present(e) {
    var _this215;
    _classCallCheck(this, Present);
    _this215 = _callSuper(this, Present, [Wn, "present", !0]);
    _this215.behaviorOverride = null;
    _this215.cache = null;
    _this215.common = null;
    _this215.copies = null;
    _this215.destination = null;
    _this215.incrementalMerge = null;
    _this215.layout = null;
    _this215.output = null;
    _this215.overprint = null;
    _this215.pagination = null;
    _this215.paginationOverride = null;
    _this215.script = null;
    _this215.validate = null;
    _this215.xdp = null;
    _this215.driver = new XFAObjectArray();
    _this215.labelPrinter = new XFAObjectArray();
    _this215.pcl = new XFAObjectArray();
    _this215.pdf = new XFAObjectArray();
    _this215.ps = new XFAObjectArray();
    _this215.submitUrl = new XFAObjectArray();
    _this215.webClient = new XFAObjectArray();
    _this215.zpl = new XFAObjectArray();
    return _this215;
  }
  _inherits(Present, _XFAObject122);
  return _createClass(Present);
}(XFAObject);
var Print = /*#__PURE__*/function (_Option19) {
  function Print(e) {
    _classCallCheck(this, Print);
    return _callSuper(this, Print, [Wn, "print"]);
  }
  _inherits(Print, _Option19);
  return _createClass(Print);
}(Option01);
var PrintHighQuality = /*#__PURE__*/function (_Option20) {
  function PrintHighQuality(e) {
    _classCallCheck(this, PrintHighQuality);
    return _callSuper(this, PrintHighQuality, [Wn, "printHighQuality"]);
  }
  _inherits(PrintHighQuality, _Option20);
  return _createClass(PrintHighQuality);
}(Option01);
var PrintScaling = /*#__PURE__*/function (_OptionObject23) {
  function PrintScaling(e) {
    _classCallCheck(this, PrintScaling);
    return _callSuper(this, PrintScaling, [Wn, "printScaling", ["appdefault", "noScaling"]]);
  }
  _inherits(PrintScaling, _OptionObject23);
  return _createClass(PrintScaling);
}(OptionObject);
var PrinterName = /*#__PURE__*/function (_StringObject27) {
  function PrinterName(e) {
    _classCallCheck(this, PrinterName);
    return _callSuper(this, PrinterName, [Wn, "printerName"]);
  }
  _inherits(PrinterName, _StringObject27);
  return _createClass(PrinterName);
}(StringObject);
var Producer = /*#__PURE__*/function (_StringObject28) {
  function Producer(e) {
    _classCallCheck(this, Producer);
    return _callSuper(this, Producer, [Wn, "producer"]);
  }
  _inherits(Producer, _StringObject28);
  return _createClass(Producer);
}(StringObject);
var Ps = /*#__PURE__*/function (_XFAObject123) {
  function Ps(e) {
    var _this216;
    _classCallCheck(this, Ps);
    _this216 = _callSuper(this, Ps, [Wn, "ps", !0]);
    _this216.name = e.name || "";
    _this216.batchOutput = null;
    _this216.fontInfo = null;
    _this216.jog = null;
    _this216.mediumInfo = null;
    _this216.outputBin = null;
    _this216.staple = null;
    _this216.xdc = null;
    return _this216;
  }
  _inherits(Ps, _XFAObject123);
  return _createClass(Ps);
}(XFAObject);
var Range = /*#__PURE__*/function (_ContentObject18) {
  function Range(e) {
    _classCallCheck(this, Range);
    return _callSuper(this, Range, [Wn, "range"]);
  }
  _inherits(Range, _ContentObject18);
  return _createClass(Range, [{
    key: gr,
    value: function value() {
      this[ar] = this[ar].trim().split(/\s*,\s*/, 2).map(function (e) {
        return e.split("-").map(function (e) {
          return parseInt(e.trim(), 10);
        });
      }).filter(function (e) {
        return e.every(function (e) {
          return !isNaN(e);
        });
      }).map(function (e) {
        1 === e.length && e.push(e[0]);
        return e;
      });
    }
  }]);
}(ContentObject);
var Record = /*#__PURE__*/function (_ContentObject19) {
  function Record(e) {
    _classCallCheck(this, Record);
    return _callSuper(this, Record, [Wn, "record"]);
  }
  _inherits(Record, _ContentObject19);
  return _createClass(Record, [{
    key: gr,
    value: function value() {
      this[ar] = this[ar].trim();
      var e = parseInt(this[ar], 10);
      !isNaN(e) && e >= 0 && (this[ar] = e);
    }
  }]);
}(ContentObject);
var Relevant = /*#__PURE__*/function (_ContentObject20) {
  function Relevant(e) {
    _classCallCheck(this, Relevant);
    return _callSuper(this, Relevant, [Wn, "relevant"]);
  }
  _inherits(Relevant, _ContentObject20);
  return _createClass(Relevant, [{
    key: gr,
    value: function value() {
      this[ar] = this[ar].trim().split(/\s+/);
    }
  }]);
}(ContentObject);
var Rename = /*#__PURE__*/function (_ContentObject21) {
  function Rename(e) {
    _classCallCheck(this, Rename);
    return _callSuper(this, Rename, [Wn, "rename"]);
  }
  _inherits(Rename, _ContentObject21);
  return _createClass(Rename, [{
    key: gr,
    value: function value() {
      this[ar] = this[ar].trim();
      (this[ar].toLowerCase().startsWith("xml") || new RegExp("[\\p{L}_][\\p{L}\\d._\\p{M}-]*", "u").test(this[ar])) && warn("XFA - Rename: invalid XFA name");
    }
  }]);
}(ContentObject);
var RenderPolicy = /*#__PURE__*/function (_OptionObject24) {
  function RenderPolicy(e) {
    _classCallCheck(this, RenderPolicy);
    return _callSuper(this, RenderPolicy, [Wn, "renderPolicy", ["server", "client"]]);
  }
  _inherits(RenderPolicy, _OptionObject24);
  return _createClass(RenderPolicy);
}(OptionObject);
var RunScripts = /*#__PURE__*/function (_OptionObject25) {
  function RunScripts(e) {
    _classCallCheck(this, RunScripts);
    return _callSuper(this, RunScripts, [Wn, "runScripts", ["both", "client", "none", "server"]]);
  }
  _inherits(RunScripts, _OptionObject25);
  return _createClass(RunScripts);
}(OptionObject);
var config_Script = /*#__PURE__*/function (_XFAObject124) {
  function config_Script(e) {
    var _this217;
    _classCallCheck(this, config_Script);
    _this217 = _callSuper(this, config_Script, [Wn, "script", !0]);
    _this217.currentPage = null;
    _this217.exclude = null;
    _this217.runScripts = null;
    return _this217;
  }
  _inherits(config_Script, _XFAObject124);
  return _createClass(config_Script);
}(XFAObject);
var ScriptModel = /*#__PURE__*/function (_OptionObject26) {
  function ScriptModel(e) {
    _classCallCheck(this, ScriptModel);
    return _callSuper(this, ScriptModel, [Wn, "scriptModel", ["XFA", "none"]]);
  }
  _inherits(ScriptModel, _OptionObject26);
  return _createClass(ScriptModel);
}(OptionObject);
var Severity = /*#__PURE__*/function (_OptionObject27) {
  function Severity(e) {
    _classCallCheck(this, Severity);
    return _callSuper(this, Severity, [Wn, "severity", ["ignore", "error", "information", "trace", "warning"]]);
  }
  _inherits(Severity, _OptionObject27);
  return _createClass(Severity);
}(OptionObject);
var SilentPrint = /*#__PURE__*/function (_XFAObject125) {
  function SilentPrint(e) {
    var _this218;
    _classCallCheck(this, SilentPrint);
    _this218 = _callSuper(this, SilentPrint, [Wn, "silentPrint", !0]);
    _this218.addSilentPrint = null;
    _this218.printerName = null;
    return _this218;
  }
  _inherits(SilentPrint, _XFAObject125);
  return _createClass(SilentPrint);
}(XFAObject);
var Staple = /*#__PURE__*/function (_XFAObject126) {
  function Staple(e) {
    var _this219;
    _classCallCheck(this, Staple);
    _this219 = _callSuper(this, Staple, [Wn, "staple"]);
    _this219.mode = getStringOption(e.mode, ["usePrinterSetting", "on", "off"]);
    return _this219;
  }
  _inherits(Staple, _XFAObject126);
  return _createClass(Staple);
}(XFAObject);
var StartNode = /*#__PURE__*/function (_StringObject29) {
  function StartNode(e) {
    _classCallCheck(this, StartNode);
    return _callSuper(this, StartNode, [Wn, "startNode"]);
  }
  _inherits(StartNode, _StringObject29);
  return _createClass(StartNode);
}(StringObject);
var StartPage = /*#__PURE__*/function (_IntegerObject10) {
  function StartPage(e) {
    _classCallCheck(this, StartPage);
    return _callSuper(this, StartPage, [Wn, "startPage", 0, function (e) {
      return !0;
    }]);
  }
  _inherits(StartPage, _IntegerObject10);
  return _createClass(StartPage);
}(IntegerObject);
var SubmitFormat = /*#__PURE__*/function (_OptionObject28) {
  function SubmitFormat(e) {
    _classCallCheck(this, SubmitFormat);
    return _callSuper(this, SubmitFormat, [Wn, "submitFormat", ["html", "delegate", "fdf", "xml", "pdf"]]);
  }
  _inherits(SubmitFormat, _OptionObject28);
  return _createClass(SubmitFormat);
}(OptionObject);
var SubmitUrl = /*#__PURE__*/function (_StringObject30) {
  function SubmitUrl(e) {
    _classCallCheck(this, SubmitUrl);
    return _callSuper(this, SubmitUrl, [Wn, "submitUrl"]);
  }
  _inherits(SubmitUrl, _StringObject30);
  return _createClass(SubmitUrl);
}(StringObject);
var SubsetBelow = /*#__PURE__*/function (_IntegerObject11) {
  function SubsetBelow(e) {
    _classCallCheck(this, SubsetBelow);
    return _callSuper(this, SubsetBelow, [Wn, "subsetBelow", 100, function (e) {
      return e >= 0 && e <= 100;
    }]);
  }
  _inherits(SubsetBelow, _IntegerObject11);
  return _createClass(SubsetBelow);
}(IntegerObject);
var SuppressBanner = /*#__PURE__*/function (_Option21) {
  function SuppressBanner(e) {
    _classCallCheck(this, SuppressBanner);
    return _callSuper(this, SuppressBanner, [Wn, "suppressBanner"]);
  }
  _inherits(SuppressBanner, _Option21);
  return _createClass(SuppressBanner);
}(Option01);
var Tagged = /*#__PURE__*/function (_Option22) {
  function Tagged(e) {
    _classCallCheck(this, Tagged);
    return _callSuper(this, Tagged, [Wn, "tagged"]);
  }
  _inherits(Tagged, _Option22);
  return _createClass(Tagged);
}(Option01);
var config_Template = /*#__PURE__*/function (_XFAObject127) {
  function config_Template(e) {
    var _this220;
    _classCallCheck(this, config_Template);
    _this220 = _callSuper(this, config_Template, [Wn, "template", !0]);
    _this220.base = null;
    _this220.relevant = null;
    _this220.startPage = null;
    _this220.uri = null;
    _this220.xsl = null;
    return _this220;
  }
  _inherits(config_Template, _XFAObject127);
  return _createClass(config_Template);
}(XFAObject);
var Threshold = /*#__PURE__*/function (_OptionObject29) {
  function Threshold(e) {
    _classCallCheck(this, Threshold);
    return _callSuper(this, Threshold, [Wn, "threshold", ["trace", "error", "information", "warning"]]);
  }
  _inherits(Threshold, _OptionObject29);
  return _createClass(Threshold);
}(OptionObject);
var To = /*#__PURE__*/function (_OptionObject30) {
  function To(e) {
    _classCallCheck(this, To);
    return _callSuper(this, To, [Wn, "to", ["null", "memory", "stderr", "stdout", "system", "uri"]]);
  }
  _inherits(To, _OptionObject30);
  return _createClass(To);
}(OptionObject);
var TemplateCache = /*#__PURE__*/function (_XFAObject128) {
  function TemplateCache(e) {
    var _this221;
    _classCallCheck(this, TemplateCache);
    _this221 = _callSuper(this, TemplateCache, [Wn, "templateCache"]);
    _this221.maxEntries = getInteger({
      data: e.maxEntries,
      defaultValue: 5,
      validate: function validate(e) {
        return e >= 0;
      }
    });
    return _this221;
  }
  _inherits(TemplateCache, _XFAObject128);
  return _createClass(TemplateCache);
}(XFAObject);
var Trace = /*#__PURE__*/function (_XFAObject129) {
  function Trace(e) {
    var _this222;
    _classCallCheck(this, Trace);
    _this222 = _callSuper(this, Trace, [Wn, "trace", !0]);
    _this222.area = new XFAObjectArray();
    return _this222;
  }
  _inherits(Trace, _XFAObject129);
  return _createClass(Trace);
}(XFAObject);
var Transform = /*#__PURE__*/function (_XFAObject130) {
  function Transform(e) {
    var _this223;
    _classCallCheck(this, Transform);
    _this223 = _callSuper(this, Transform, [Wn, "transform", !0]);
    _this223.groupParent = null;
    _this223.ifEmpty = null;
    _this223.nameAttr = null;
    _this223.picture = null;
    _this223.presence = null;
    _this223.rename = null;
    _this223.whitespace = null;
    return _this223;
  }
  _inherits(Transform, _XFAObject130);
  return _createClass(Transform);
}(XFAObject);
var Type = /*#__PURE__*/function (_OptionObject31) {
  function Type(e) {
    _classCallCheck(this, Type);
    return _callSuper(this, Type, [Wn, "type", ["none", "ascii85", "asciiHex", "ccittfax", "flate", "lzw", "runLength", "native", "xdp", "mergedXDP"]]);
  }
  _inherits(Type, _OptionObject31);
  return _createClass(Type);
}(OptionObject);
var Uri = /*#__PURE__*/function (_StringObject31) {
  function Uri(e) {
    _classCallCheck(this, Uri);
    return _callSuper(this, Uri, [Wn, "uri"]);
  }
  _inherits(Uri, _StringObject31);
  return _createClass(Uri);
}(StringObject);
var config_Validate = /*#__PURE__*/function (_OptionObject32) {
  function config_Validate(e) {
    _classCallCheck(this, config_Validate);
    return _callSuper(this, config_Validate, [Wn, "validate", ["preSubmit", "prePrint", "preExecute", "preSave"]]);
  }
  _inherits(config_Validate, _OptionObject32);
  return _createClass(config_Validate);
}(OptionObject);
var ValidateApprovalSignatures = /*#__PURE__*/function (_ContentObject22) {
  function ValidateApprovalSignatures(e) {
    _classCallCheck(this, ValidateApprovalSignatures);
    return _callSuper(this, ValidateApprovalSignatures, [Wn, "validateApprovalSignatures"]);
  }
  _inherits(ValidateApprovalSignatures, _ContentObject22);
  return _createClass(ValidateApprovalSignatures, [{
    key: gr,
    value: function value() {
      this[ar] = this[ar].trim().split(/\s+/).filter(function (e) {
        return ["docReady", "postSign"].includes(e);
      });
    }
  }]);
}(ContentObject);
var ValidationMessaging = /*#__PURE__*/function (_OptionObject33) {
  function ValidationMessaging(e) {
    _classCallCheck(this, ValidationMessaging);
    return _callSuper(this, ValidationMessaging, [Wn, "validationMessaging", ["allMessagesIndividually", "allMessagesTogether", "firstMessageOnly", "noMessages"]]);
  }
  _inherits(ValidationMessaging, _OptionObject33);
  return _createClass(ValidationMessaging);
}(OptionObject);
var Version = /*#__PURE__*/function (_OptionObject34) {
  function Version(e) {
    _classCallCheck(this, Version);
    return _callSuper(this, Version, [Wn, "version", ["1.7", "1.6", "1.5", "1.4", "1.3", "1.2"]]);
  }
  _inherits(Version, _OptionObject34);
  return _createClass(Version);
}(OptionObject);
var VersionControl = /*#__PURE__*/function (_XFAObject131) {
  function VersionControl(e) {
    var _this224;
    _classCallCheck(this, VersionControl);
    _this224 = _callSuper(this, VersionControl, [Wn, "VersionControl"]);
    _this224.outputBelow = getStringOption(e.outputBelow, ["warn", "error", "update"]);
    _this224.sourceAbove = getStringOption(e.sourceAbove, ["warn", "error"]);
    _this224.sourceBelow = getStringOption(e.sourceBelow, ["update", "maintain"]);
    return _this224;
  }
  _inherits(VersionControl, _XFAObject131);
  return _createClass(VersionControl);
}(XFAObject);
var ViewerPreferences = /*#__PURE__*/function (_XFAObject132) {
  function ViewerPreferences(e) {
    var _this225;
    _classCallCheck(this, ViewerPreferences);
    _this225 = _callSuper(this, ViewerPreferences, [Wn, "viewerPreferences", !0]);
    _this225.ADBE_JSConsole = null;
    _this225.ADBE_JSDebugger = null;
    _this225.addViewerPreferences = null;
    _this225.duplexOption = null;
    _this225.enforce = null;
    _this225.numberOfCopies = null;
    _this225.pageRange = null;
    _this225.pickTrayByPDFSize = null;
    _this225.printScaling = null;
    return _this225;
  }
  _inherits(ViewerPreferences, _XFAObject132);
  return _createClass(ViewerPreferences);
}(XFAObject);
var WebClient = /*#__PURE__*/function (_XFAObject133) {
  function WebClient(e) {
    var _this226;
    _classCallCheck(this, WebClient);
    _this226 = _callSuper(this, WebClient, [Wn, "webClient", !0]);
    _this226.name = e.name ? e.name.trim() : "";
    _this226.fontInfo = null;
    _this226.xdc = null;
    return _this226;
  }
  _inherits(WebClient, _XFAObject133);
  return _createClass(WebClient);
}(XFAObject);
var Whitespace = /*#__PURE__*/function (_OptionObject35) {
  function Whitespace(e) {
    _classCallCheck(this, Whitespace);
    return _callSuper(this, Whitespace, [Wn, "whitespace", ["preserve", "ltrim", "normalize", "rtrim", "trim"]]);
  }
  _inherits(Whitespace, _OptionObject35);
  return _createClass(Whitespace);
}(OptionObject);
var Window = /*#__PURE__*/function (_ContentObject23) {
  function Window(e) {
    _classCallCheck(this, Window);
    return _callSuper(this, Window, [Wn, "window"]);
  }
  _inherits(Window, _ContentObject23);
  return _createClass(Window, [{
    key: gr,
    value: function value() {
      var e = this[ar].trim().split(/\s*,\s*/, 2).map(function (e) {
        return parseInt(e, 10);
      });
      if (e.some(function (e) {
        return isNaN(e);
      })) this[ar] = [0, 0];else {
        1 === e.length && e.push(e[0]);
        this[ar] = e;
      }
    }
  }]);
}(ContentObject);
var Xdc = /*#__PURE__*/function (_XFAObject134) {
  function Xdc(e) {
    var _this227;
    _classCallCheck(this, Xdc);
    _this227 = _callSuper(this, Xdc, [Wn, "xdc", !0]);
    _this227.uri = new XFAObjectArray();
    _this227.xsl = new XFAObjectArray();
    return _this227;
  }
  _inherits(Xdc, _XFAObject134);
  return _createClass(Xdc);
}(XFAObject);
var Xdp = /*#__PURE__*/function (_XFAObject135) {
  function Xdp(e) {
    var _this228;
    _classCallCheck(this, Xdp);
    _this228 = _callSuper(this, Xdp, [Wn, "xdp", !0]);
    _this228.packets = null;
    return _this228;
  }
  _inherits(Xdp, _XFAObject135);
  return _createClass(Xdp);
}(XFAObject);
var Xsl = /*#__PURE__*/function (_XFAObject136) {
  function Xsl(e) {
    var _this229;
    _classCallCheck(this, Xsl);
    _this229 = _callSuper(this, Xsl, [Wn, "xsl", !0]);
    _this229.debug = null;
    _this229.uri = null;
    return _this229;
  }
  _inherits(Xsl, _XFAObject136);
  return _createClass(Xsl);
}(XFAObject);
var Zpl = /*#__PURE__*/function (_XFAObject137) {
  function Zpl(e) {
    var _this230;
    _classCallCheck(this, Zpl);
    _this230 = _callSuper(this, Zpl, [Wn, "zpl", !0]);
    _this230.name = e.name ? e.name.trim() : "";
    _this230.batchOutput = null;
    _this230.flipLabel = null;
    _this230.fontInfo = null;
    _this230.xdc = null;
    return _this230;
  }
  _inherits(Zpl, _XFAObject137);
  return _createClass(Zpl);
}(XFAObject);
var ConfigNamespace = /*#__PURE__*/function () {
  function ConfigNamespace() {
    _classCallCheck(this, ConfigNamespace);
  }
  return _createClass(ConfigNamespace, null, [{
    key: cn,
    value: function value(e, t) {
      if (ConfigNamespace.hasOwnProperty(e)) return ConfigNamespace[e](t);
    }
  }, {
    key: "acrobat",
    value: function acrobat(e) {
      return new Acrobat(e);
    }
  }, {
    key: "acrobat7",
    value: function acrobat7(e) {
      return new Acrobat7(e);
    }
  }, {
    key: "ADBE_JSConsole",
    value: function ADBE_JSConsole(e) {
      return new _ADBE_JSConsole(e);
    }
  }, {
    key: "ADBE_JSDebugger",
    value: function ADBE_JSDebugger(e) {
      return new _ADBE_JSDebugger(e);
    }
  }, {
    key: "addSilentPrint",
    value: function addSilentPrint(e) {
      return new AddSilentPrint(e);
    }
  }, {
    key: "addViewerPreferences",
    value: function addViewerPreferences(e) {
      return new AddViewerPreferences(e);
    }
  }, {
    key: "adjustData",
    value: function adjustData(e) {
      return new AdjustData(e);
    }
  }, {
    key: "adobeExtensionLevel",
    value: function adobeExtensionLevel(e) {
      return new AdobeExtensionLevel(e);
    }
  }, {
    key: "agent",
    value: function agent(e) {
      return new Agent(e);
    }
  }, {
    key: "alwaysEmbed",
    value: function alwaysEmbed(e) {
      return new AlwaysEmbed(e);
    }
  }, {
    key: "amd",
    value: function amd(e) {
      return new Amd(e);
    }
  }, {
    key: "area",
    value: function area(e) {
      return new config_Area(e);
    }
  }, {
    key: "attributes",
    value: function attributes(e) {
      return new Attributes(e);
    }
  }, {
    key: "autoSave",
    value: function autoSave(e) {
      return new AutoSave(e);
    }
  }, {
    key: "base",
    value: function base(e) {
      return new Base(e);
    }
  }, {
    key: "batchOutput",
    value: function batchOutput(e) {
      return new BatchOutput(e);
    }
  }, {
    key: "behaviorOverride",
    value: function behaviorOverride(e) {
      return new BehaviorOverride(e);
    }
  }, {
    key: "cache",
    value: function cache(e) {
      return new Cache(e);
    }
  }, {
    key: "change",
    value: function change(e) {
      return new Change(e);
    }
  }, {
    key: "common",
    value: function common(e) {
      return new Common(e);
    }
  }, {
    key: "compress",
    value: function compress(e) {
      return new Compress(e);
    }
  }, {
    key: "compressLogicalStructure",
    value: function compressLogicalStructure(e) {
      return new CompressLogicalStructure(e);
    }
  }, {
    key: "compressObjectStream",
    value: function compressObjectStream(e) {
      return new CompressObjectStream(e);
    }
  }, {
    key: "compression",
    value: function compression(e) {
      return new Compression(e);
    }
  }, {
    key: "config",
    value: function config(e) {
      return new Config(e);
    }
  }, {
    key: "conformance",
    value: function conformance(e) {
      return new Conformance(e);
    }
  }, {
    key: "contentCopy",
    value: function contentCopy(e) {
      return new ContentCopy(e);
    }
  }, {
    key: "copies",
    value: function copies(e) {
      return new Copies(e);
    }
  }, {
    key: "creator",
    value: function creator(e) {
      return new Creator(e);
    }
  }, {
    key: "currentPage",
    value: function currentPage(e) {
      return new CurrentPage(e);
    }
  }, {
    key: "data",
    value: function data(e) {
      return new Data(e);
    }
  }, {
    key: "debug",
    value: function debug(e) {
      return new Debug(e);
    }
  }, {
    key: "defaultTypeface",
    value: function defaultTypeface(e) {
      return new DefaultTypeface(e);
    }
  }, {
    key: "destination",
    value: function destination(e) {
      return new Destination(e);
    }
  }, {
    key: "documentAssembly",
    value: function documentAssembly(e) {
      return new DocumentAssembly(e);
    }
  }, {
    key: "driver",
    value: function driver(e) {
      return new Driver(e);
    }
  }, {
    key: "duplexOption",
    value: function duplexOption(e) {
      return new DuplexOption(e);
    }
  }, {
    key: "dynamicRender",
    value: function dynamicRender(e) {
      return new DynamicRender(e);
    }
  }, {
    key: "embed",
    value: function embed(e) {
      return new Embed(e);
    }
  }, {
    key: "encrypt",
    value: function encrypt(e) {
      return new config_Encrypt(e);
    }
  }, {
    key: "encryption",
    value: function encryption(e) {
      return new config_Encryption(e);
    }
  }, {
    key: "encryptionLevel",
    value: function encryptionLevel(e) {
      return new EncryptionLevel(e);
    }
  }, {
    key: "enforce",
    value: function enforce(e) {
      return new Enforce(e);
    }
  }, {
    key: "equate",
    value: function equate(e) {
      return new Equate(e);
    }
  }, {
    key: "equateRange",
    value: function equateRange(e) {
      return new EquateRange(e);
    }
  }, {
    key: "exclude",
    value: function exclude(e) {
      return new Exclude(e);
    }
  }, {
    key: "excludeNS",
    value: function excludeNS(e) {
      return new ExcludeNS(e);
    }
  }, {
    key: "flipLabel",
    value: function flipLabel(e) {
      return new FlipLabel(e);
    }
  }, {
    key: "fontInfo",
    value: function fontInfo(e) {
      return new config_FontInfo(e);
    }
  }, {
    key: "formFieldFilling",
    value: function formFieldFilling(e) {
      return new FormFieldFilling(e);
    }
  }, {
    key: "groupParent",
    value: function groupParent(e) {
      return new GroupParent(e);
    }
  }, {
    key: "ifEmpty",
    value: function ifEmpty(e) {
      return new IfEmpty(e);
    }
  }, {
    key: "includeXDPContent",
    value: function includeXDPContent(e) {
      return new IncludeXDPContent(e);
    }
  }, {
    key: "incrementalLoad",
    value: function incrementalLoad(e) {
      return new IncrementalLoad(e);
    }
  }, {
    key: "incrementalMerge",
    value: function incrementalMerge(e) {
      return new IncrementalMerge(e);
    }
  }, {
    key: "interactive",
    value: function interactive(e) {
      return new Interactive(e);
    }
  }, {
    key: "jog",
    value: function jog(e) {
      return new Jog(e);
    }
  }, {
    key: "labelPrinter",
    value: function labelPrinter(e) {
      return new LabelPrinter(e);
    }
  }, {
    key: "layout",
    value: function layout(e) {
      return new Layout(e);
    }
  }, {
    key: "level",
    value: function level(e) {
      return new Level(e);
    }
  }, {
    key: "linearized",
    value: function linearized(e) {
      return new Linearized(e);
    }
  }, {
    key: "locale",
    value: function locale(e) {
      return new Locale(e);
    }
  }, {
    key: "localeSet",
    value: function localeSet(e) {
      return new LocaleSet(e);
    }
  }, {
    key: "log",
    value: function log(e) {
      return new Log(e);
    }
  }, {
    key: "map",
    value: function map(e) {
      return new MapElement(e);
    }
  }, {
    key: "mediumInfo",
    value: function mediumInfo(e) {
      return new MediumInfo(e);
    }
  }, {
    key: "message",
    value: function message(e) {
      return new config_Message(e);
    }
  }, {
    key: "messaging",
    value: function messaging(e) {
      return new Messaging(e);
    }
  }, {
    key: "mode",
    value: function mode(e) {
      return new Mode(e);
    }
  }, {
    key: "modifyAnnots",
    value: function modifyAnnots(e) {
      return new ModifyAnnots(e);
    }
  }, {
    key: "msgId",
    value: function msgId(e) {
      return new MsgId(e);
    }
  }, {
    key: "nameAttr",
    value: function nameAttr(e) {
      return new NameAttr(e);
    }
  }, {
    key: "neverEmbed",
    value: function neverEmbed(e) {
      return new NeverEmbed(e);
    }
  }, {
    key: "numberOfCopies",
    value: function numberOfCopies(e) {
      return new NumberOfCopies(e);
    }
  }, {
    key: "openAction",
    value: function openAction(e) {
      return new OpenAction(e);
    }
  }, {
    key: "output",
    value: function output(e) {
      return new Output(e);
    }
  }, {
    key: "outputBin",
    value: function outputBin(e) {
      return new OutputBin(e);
    }
  }, {
    key: "outputXSL",
    value: function outputXSL(e) {
      return new OutputXSL(e);
    }
  }, {
    key: "overprint",
    value: function overprint(e) {
      return new Overprint(e);
    }
  }, {
    key: "packets",
    value: function packets(e) {
      return new Packets(e);
    }
  }, {
    key: "pageOffset",
    value: function pageOffset(e) {
      return new PageOffset(e);
    }
  }, {
    key: "pageRange",
    value: function pageRange(e) {
      return new PageRange(e);
    }
  }, {
    key: "pagination",
    value: function pagination(e) {
      return new Pagination(e);
    }
  }, {
    key: "paginationOverride",
    value: function paginationOverride(e) {
      return new PaginationOverride(e);
    }
  }, {
    key: "part",
    value: function part(e) {
      return new Part(e);
    }
  }, {
    key: "pcl",
    value: function pcl(e) {
      return new Pcl(e);
    }
  }, {
    key: "pdf",
    value: function pdf(e) {
      return new Pdf(e);
    }
  }, {
    key: "pdfa",
    value: function pdfa(e) {
      return new Pdfa(e);
    }
  }, {
    key: "permissions",
    value: function permissions(e) {
      return new Permissions(e);
    }
  }, {
    key: "pickTrayByPDFSize",
    value: function pickTrayByPDFSize(e) {
      return new PickTrayByPDFSize(e);
    }
  }, {
    key: "picture",
    value: function picture(e) {
      return new config_Picture(e);
    }
  }, {
    key: "plaintextMetadata",
    value: function plaintextMetadata(e) {
      return new PlaintextMetadata(e);
    }
  }, {
    key: "presence",
    value: function presence(e) {
      return new Presence(e);
    }
  }, {
    key: "present",
    value: function present(e) {
      return new Present(e);
    }
  }, {
    key: "print",
    value: function print(e) {
      return new Print(e);
    }
  }, {
    key: "printHighQuality",
    value: function printHighQuality(e) {
      return new PrintHighQuality(e);
    }
  }, {
    key: "printScaling",
    value: function printScaling(e) {
      return new PrintScaling(e);
    }
  }, {
    key: "printerName",
    value: function printerName(e) {
      return new PrinterName(e);
    }
  }, {
    key: "producer",
    value: function producer(e) {
      return new Producer(e);
    }
  }, {
    key: "ps",
    value: function ps(e) {
      return new Ps(e);
    }
  }, {
    key: "range",
    value: function range(e) {
      return new Range(e);
    }
  }, {
    key: "record",
    value: function record(e) {
      return new Record(e);
    }
  }, {
    key: "relevant",
    value: function relevant(e) {
      return new Relevant(e);
    }
  }, {
    key: "rename",
    value: function rename(e) {
      return new Rename(e);
    }
  }, {
    key: "renderPolicy",
    value: function renderPolicy(e) {
      return new RenderPolicy(e);
    }
  }, {
    key: "runScripts",
    value: function runScripts(e) {
      return new RunScripts(e);
    }
  }, {
    key: "script",
    value: function script(e) {
      return new config_Script(e);
    }
  }, {
    key: "scriptModel",
    value: function scriptModel(e) {
      return new ScriptModel(e);
    }
  }, {
    key: "severity",
    value: function severity(e) {
      return new Severity(e);
    }
  }, {
    key: "silentPrint",
    value: function silentPrint(e) {
      return new SilentPrint(e);
    }
  }, {
    key: "staple",
    value: function staple(e) {
      return new Staple(e);
    }
  }, {
    key: "startNode",
    value: function startNode(e) {
      return new StartNode(e);
    }
  }, {
    key: "startPage",
    value: function startPage(e) {
      return new StartPage(e);
    }
  }, {
    key: "submitFormat",
    value: function submitFormat(e) {
      return new SubmitFormat(e);
    }
  }, {
    key: "submitUrl",
    value: function submitUrl(e) {
      return new SubmitUrl(e);
    }
  }, {
    key: "subsetBelow",
    value: function subsetBelow(e) {
      return new SubsetBelow(e);
    }
  }, {
    key: "suppressBanner",
    value: function suppressBanner(e) {
      return new SuppressBanner(e);
    }
  }, {
    key: "tagged",
    value: function tagged(e) {
      return new Tagged(e);
    }
  }, {
    key: "template",
    value: function template(e) {
      return new config_Template(e);
    }
  }, {
    key: "templateCache",
    value: function templateCache(e) {
      return new TemplateCache(e);
    }
  }, {
    key: "threshold",
    value: function threshold(e) {
      return new Threshold(e);
    }
  }, {
    key: "to",
    value: function to(e) {
      return new To(e);
    }
  }, {
    key: "trace",
    value: function trace(e) {
      return new Trace(e);
    }
  }, {
    key: "transform",
    value: function transform(e) {
      return new Transform(e);
    }
  }, {
    key: "type",
    value: function type(e) {
      return new Type(e);
    }
  }, {
    key: "uri",
    value: function uri(e) {
      return new Uri(e);
    }
  }, {
    key: "validate",
    value: function validate(e) {
      return new config_Validate(e);
    }
  }, {
    key: "validateApprovalSignatures",
    value: function validateApprovalSignatures(e) {
      return new ValidateApprovalSignatures(e);
    }
  }, {
    key: "validationMessaging",
    value: function validationMessaging(e) {
      return new ValidationMessaging(e);
    }
  }, {
    key: "version",
    value: function version(e) {
      return new Version(e);
    }
  }, {
    key: "versionControl",
    value: function versionControl(e) {
      return new VersionControl(e);
    }
  }, {
    key: "viewerPreferences",
    value: function viewerPreferences(e) {
      return new ViewerPreferences(e);
    }
  }, {
    key: "webClient",
    value: function webClient(e) {
      return new WebClient(e);
    }
  }, {
    key: "whitespace",
    value: function whitespace(e) {
      return new Whitespace(e);
    }
  }, {
    key: "window",
    value: function window(e) {
      return new Window(e);
    }
  }, {
    key: "xdc",
    value: function xdc(e) {
      return new Xdc(e);
    }
  }, {
    key: "xdp",
    value: function xdp(e) {
      return new Xdp(e);
    }
  }, {
    key: "xsl",
    value: function xsl(e) {
      return new Xsl(e);
    }
  }, {
    key: "zpl",
    value: function zpl(e) {
      return new Zpl(e);
    }
  }]);
}();
var jn = Cn.connectionSet.id;
var ConnectionSet = /*#__PURE__*/function (_XFAObject138) {
  function ConnectionSet(e) {
    var _this231;
    _classCallCheck(this, ConnectionSet);
    _this231 = _callSuper(this, ConnectionSet, [jn, "connectionSet", !0]);
    _this231.wsdlConnection = new XFAObjectArray();
    _this231.xmlConnection = new XFAObjectArray();
    _this231.xsdConnection = new XFAObjectArray();
    return _this231;
  }
  _inherits(ConnectionSet, _XFAObject138);
  return _createClass(ConnectionSet);
}(XFAObject);
var EffectiveInputPolicy = /*#__PURE__*/function (_XFAObject139) {
  function EffectiveInputPolicy(e) {
    var _this232;
    _classCallCheck(this, EffectiveInputPolicy);
    _this232 = _callSuper(this, EffectiveInputPolicy, [jn, "effectiveInputPolicy"]);
    _this232.id = e.id || "";
    _this232.name = e.name || "";
    _this232.use = e.use || "";
    _this232.usehref = e.usehref || "";
    return _this232;
  }
  _inherits(EffectiveInputPolicy, _XFAObject139);
  return _createClass(EffectiveInputPolicy);
}(XFAObject);
var EffectiveOutputPolicy = /*#__PURE__*/function (_XFAObject140) {
  function EffectiveOutputPolicy(e) {
    var _this233;
    _classCallCheck(this, EffectiveOutputPolicy);
    _this233 = _callSuper(this, EffectiveOutputPolicy, [jn, "effectiveOutputPolicy"]);
    _this233.id = e.id || "";
    _this233.name = e.name || "";
    _this233.use = e.use || "";
    _this233.usehref = e.usehref || "";
    return _this233;
  }
  _inherits(EffectiveOutputPolicy, _XFAObject140);
  return _createClass(EffectiveOutputPolicy);
}(XFAObject);
var Operation = /*#__PURE__*/function (_StringObject32) {
  function Operation(e) {
    var _this234;
    _classCallCheck(this, Operation);
    _this234 = _callSuper(this, Operation, [jn, "operation"]);
    _this234.id = e.id || "";
    _this234.input = e.input || "";
    _this234.name = e.name || "";
    _this234.output = e.output || "";
    _this234.use = e.use || "";
    _this234.usehref = e.usehref || "";
    return _this234;
  }
  _inherits(Operation, _StringObject32);
  return _createClass(Operation);
}(StringObject);
var RootElement = /*#__PURE__*/function (_StringObject33) {
  function RootElement(e) {
    var _this235;
    _classCallCheck(this, RootElement);
    _this235 = _callSuper(this, RootElement, [jn, "rootElement"]);
    _this235.id = e.id || "";
    _this235.name = e.name || "";
    _this235.use = e.use || "";
    _this235.usehref = e.usehref || "";
    return _this235;
  }
  _inherits(RootElement, _StringObject33);
  return _createClass(RootElement);
}(StringObject);
var SoapAction = /*#__PURE__*/function (_StringObject34) {
  function SoapAction(e) {
    var _this236;
    _classCallCheck(this, SoapAction);
    _this236 = _callSuper(this, SoapAction, [jn, "soapAction"]);
    _this236.id = e.id || "";
    _this236.name = e.name || "";
    _this236.use = e.use || "";
    _this236.usehref = e.usehref || "";
    return _this236;
  }
  _inherits(SoapAction, _StringObject34);
  return _createClass(SoapAction);
}(StringObject);
var SoapAddress = /*#__PURE__*/function (_StringObject35) {
  function SoapAddress(e) {
    var _this237;
    _classCallCheck(this, SoapAddress);
    _this237 = _callSuper(this, SoapAddress, [jn, "soapAddress"]);
    _this237.id = e.id || "";
    _this237.name = e.name || "";
    _this237.use = e.use || "";
    _this237.usehref = e.usehref || "";
    return _this237;
  }
  _inherits(SoapAddress, _StringObject35);
  return _createClass(SoapAddress);
}(StringObject);
var connection_set_Uri = /*#__PURE__*/function (_StringObject36) {
  function connection_set_Uri(e) {
    var _this238;
    _classCallCheck(this, connection_set_Uri);
    _this238 = _callSuper(this, connection_set_Uri, [jn, "uri"]);
    _this238.id = e.id || "";
    _this238.name = e.name || "";
    _this238.use = e.use || "";
    _this238.usehref = e.usehref || "";
    return _this238;
  }
  _inherits(connection_set_Uri, _StringObject36);
  return _createClass(connection_set_Uri);
}(StringObject);
var WsdlAddress = /*#__PURE__*/function (_StringObject37) {
  function WsdlAddress(e) {
    var _this239;
    _classCallCheck(this, WsdlAddress);
    _this239 = _callSuper(this, WsdlAddress, [jn, "wsdlAddress"]);
    _this239.id = e.id || "";
    _this239.name = e.name || "";
    _this239.use = e.use || "";
    _this239.usehref = e.usehref || "";
    return _this239;
  }
  _inherits(WsdlAddress, _StringObject37);
  return _createClass(WsdlAddress);
}(StringObject);
var WsdlConnection = /*#__PURE__*/function (_XFAObject141) {
  function WsdlConnection(e) {
    var _this240;
    _classCallCheck(this, WsdlConnection);
    _this240 = _callSuper(this, WsdlConnection, [jn, "wsdlConnection", !0]);
    _this240.dataDescription = e.dataDescription || "";
    _this240.name = e.name || "";
    _this240.effectiveInputPolicy = null;
    _this240.effectiveOutputPolicy = null;
    _this240.operation = null;
    _this240.soapAction = null;
    _this240.soapAddress = null;
    _this240.wsdlAddress = null;
    return _this240;
  }
  _inherits(WsdlConnection, _XFAObject141);
  return _createClass(WsdlConnection);
}(XFAObject);
var XmlConnection = /*#__PURE__*/function (_XFAObject142) {
  function XmlConnection(e) {
    var _this241;
    _classCallCheck(this, XmlConnection);
    _this241 = _callSuper(this, XmlConnection, [jn, "xmlConnection", !0]);
    _this241.dataDescription = e.dataDescription || "";
    _this241.name = e.name || "";
    _this241.uri = null;
    return _this241;
  }
  _inherits(XmlConnection, _XFAObject142);
  return _createClass(XmlConnection);
}(XFAObject);
var XsdConnection = /*#__PURE__*/function (_XFAObject143) {
  function XsdConnection(e) {
    var _this242;
    _classCallCheck(this, XsdConnection);
    _this242 = _callSuper(this, XsdConnection, [jn, "xsdConnection", !0]);
    _this242.dataDescription = e.dataDescription || "";
    _this242.name = e.name || "";
    _this242.rootElement = null;
    _this242.uri = null;
    return _this242;
  }
  _inherits(XsdConnection, _XFAObject143);
  return _createClass(XsdConnection);
}(XFAObject);
var ConnectionSetNamespace = /*#__PURE__*/function () {
  function ConnectionSetNamespace() {
    _classCallCheck(this, ConnectionSetNamespace);
  }
  return _createClass(ConnectionSetNamespace, null, [{
    key: cn,
    value: function value(e, t) {
      if (ConnectionSetNamespace.hasOwnProperty(e)) return ConnectionSetNamespace[e](t);
    }
  }, {
    key: "connectionSet",
    value: function connectionSet(e) {
      return new ConnectionSet(e);
    }
  }, {
    key: "effectiveInputPolicy",
    value: function effectiveInputPolicy(e) {
      return new EffectiveInputPolicy(e);
    }
  }, {
    key: "effectiveOutputPolicy",
    value: function effectiveOutputPolicy(e) {
      return new EffectiveOutputPolicy(e);
    }
  }, {
    key: "operation",
    value: function operation(e) {
      return new Operation(e);
    }
  }, {
    key: "rootElement",
    value: function rootElement(e) {
      return new RootElement(e);
    }
  }, {
    key: "soapAction",
    value: function soapAction(e) {
      return new SoapAction(e);
    }
  }, {
    key: "soapAddress",
    value: function soapAddress(e) {
      return new SoapAddress(e);
    }
  }, {
    key: "uri",
    value: function uri(e) {
      return new connection_set_Uri(e);
    }
  }, {
    key: "wsdlAddress",
    value: function wsdlAddress(e) {
      return new WsdlAddress(e);
    }
  }, {
    key: "wsdlConnection",
    value: function wsdlConnection(e) {
      return new WsdlConnection(e);
    }
  }, {
    key: "xmlConnection",
    value: function xmlConnection(e) {
      return new XmlConnection(e);
    }
  }, {
    key: "xsdConnection",
    value: function xsdConnection(e) {
      return new XsdConnection(e);
    }
  }]);
}();
var Xn = Cn.datasets.id;
var datasets_Data = /*#__PURE__*/function (_XmlObject) {
  function datasets_Data(e) {
    _classCallCheck(this, datasets_Data);
    return _callSuper(this, datasets_Data, [Xn, "data", e]);
  }
  _inherits(datasets_Data, _XmlObject);
  return _createClass(datasets_Data, [{
    key: Mr,
    value: function value() {
      return !0;
    }
  }]);
}(XmlObject);
var Datasets = /*#__PURE__*/function (_XFAObject144) {
  function Datasets(e) {
    var _this243;
    _classCallCheck(this, Datasets);
    _this243 = _callSuper(this, Datasets, [Xn, "datasets", !0]);
    _this243.data = null;
    _this243.Signature = null;
    return _this243;
  }
  _inherits(Datasets, _XFAObject144);
  return _createClass(Datasets, [{
    key: Or,
    value: function value(e) {
      var t = e[Tr];
      ("data" === t && e[Kr] === Xn || "Signature" === t && e[Kr] === Cn.signature.id) && (this[t] = e);
      this[zs](e);
    }
  }]);
}(XFAObject);
var DatasetsNamespace = /*#__PURE__*/function () {
  function DatasetsNamespace() {
    _classCallCheck(this, DatasetsNamespace);
  }
  return _createClass(DatasetsNamespace, null, [{
    key: cn,
    value: function value(e, t) {
      if (DatasetsNamespace.hasOwnProperty(e)) return DatasetsNamespace[e](t);
    }
  }, {
    key: "datasets",
    value: function datasets(e) {
      return new Datasets(e);
    }
  }, {
    key: "data",
    value: function data(e) {
      return new datasets_Data(e);
    }
  }]);
}();
var Zn = Cn.localeSet.id;
var CalendarSymbols = /*#__PURE__*/function (_XFAObject145) {
  function CalendarSymbols(e) {
    var _this244;
    _classCallCheck(this, CalendarSymbols);
    _this244 = _callSuper(this, CalendarSymbols, [Zn, "calendarSymbols", !0]);
    _this244.name = "gregorian";
    _this244.dayNames = new XFAObjectArray(2);
    _this244.eraNames = null;
    _this244.meridiemNames = null;
    _this244.monthNames = new XFAObjectArray(2);
    return _this244;
  }
  _inherits(CalendarSymbols, _XFAObject145);
  return _createClass(CalendarSymbols);
}(XFAObject);
var CurrencySymbol = /*#__PURE__*/function (_StringObject38) {
  function CurrencySymbol(e) {
    var _this245;
    _classCallCheck(this, CurrencySymbol);
    _this245 = _callSuper(this, CurrencySymbol, [Zn, "currencySymbol"]);
    _this245.name = getStringOption(e.name, ["symbol", "isoname", "decimal"]);
    return _this245;
  }
  _inherits(CurrencySymbol, _StringObject38);
  return _createClass(CurrencySymbol);
}(StringObject);
var CurrencySymbols = /*#__PURE__*/function (_XFAObject146) {
  function CurrencySymbols(e) {
    var _this246;
    _classCallCheck(this, CurrencySymbols);
    _this246 = _callSuper(this, CurrencySymbols, [Zn, "currencySymbols", !0]);
    _this246.currencySymbol = new XFAObjectArray(3);
    return _this246;
  }
  _inherits(CurrencySymbols, _XFAObject146);
  return _createClass(CurrencySymbols);
}(XFAObject);
var DatePattern = /*#__PURE__*/function (_StringObject39) {
  function DatePattern(e) {
    var _this247;
    _classCallCheck(this, DatePattern);
    _this247 = _callSuper(this, DatePattern, [Zn, "datePattern"]);
    _this247.name = getStringOption(e.name, ["full", "long", "med", "short"]);
    return _this247;
  }
  _inherits(DatePattern, _StringObject39);
  return _createClass(DatePattern);
}(StringObject);
var DatePatterns = /*#__PURE__*/function (_XFAObject147) {
  function DatePatterns(e) {
    var _this248;
    _classCallCheck(this, DatePatterns);
    _this248 = _callSuper(this, DatePatterns, [Zn, "datePatterns", !0]);
    _this248.datePattern = new XFAObjectArray(4);
    return _this248;
  }
  _inherits(DatePatterns, _XFAObject147);
  return _createClass(DatePatterns);
}(XFAObject);
var DateTimeSymbols = /*#__PURE__*/function (_ContentObject24) {
  function DateTimeSymbols(e) {
    _classCallCheck(this, DateTimeSymbols);
    return _callSuper(this, DateTimeSymbols, [Zn, "dateTimeSymbols"]);
  }
  _inherits(DateTimeSymbols, _ContentObject24);
  return _createClass(DateTimeSymbols);
}(ContentObject);
var Day = /*#__PURE__*/function (_StringObject40) {
  function Day(e) {
    _classCallCheck(this, Day);
    return _callSuper(this, Day, [Zn, "day"]);
  }
  _inherits(Day, _StringObject40);
  return _createClass(Day);
}(StringObject);
var DayNames = /*#__PURE__*/function (_XFAObject148) {
  function DayNames(e) {
    var _this249;
    _classCallCheck(this, DayNames);
    _this249 = _callSuper(this, DayNames, [Zn, "dayNames", !0]);
    _this249.abbr = getInteger({
      data: e.abbr,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this249.day = new XFAObjectArray(7);
    return _this249;
  }
  _inherits(DayNames, _XFAObject148);
  return _createClass(DayNames);
}(XFAObject);
var Era = /*#__PURE__*/function (_StringObject41) {
  function Era(e) {
    _classCallCheck(this, Era);
    return _callSuper(this, Era, [Zn, "era"]);
  }
  _inherits(Era, _StringObject41);
  return _createClass(Era);
}(StringObject);
var EraNames = /*#__PURE__*/function (_XFAObject149) {
  function EraNames(e) {
    var _this250;
    _classCallCheck(this, EraNames);
    _this250 = _callSuper(this, EraNames, [Zn, "eraNames", !0]);
    _this250.era = new XFAObjectArray(2);
    return _this250;
  }
  _inherits(EraNames, _XFAObject149);
  return _createClass(EraNames);
}(XFAObject);
var locale_set_Locale = /*#__PURE__*/function (_XFAObject150) {
  function locale_set_Locale(e) {
    var _this251;
    _classCallCheck(this, locale_set_Locale);
    _this251 = _callSuper(this, locale_set_Locale, [Zn, "locale", !0]);
    _this251.desc = e.desc || "";
    _this251.name = "isoname";
    _this251.calendarSymbols = null;
    _this251.currencySymbols = null;
    _this251.datePatterns = null;
    _this251.dateTimeSymbols = null;
    _this251.numberPatterns = null;
    _this251.numberSymbols = null;
    _this251.timePatterns = null;
    _this251.typeFaces = null;
    return _this251;
  }
  _inherits(locale_set_Locale, _XFAObject150);
  return _createClass(locale_set_Locale);
}(XFAObject);
var locale_set_LocaleSet = /*#__PURE__*/function (_XFAObject151) {
  function locale_set_LocaleSet(e) {
    var _this252;
    _classCallCheck(this, locale_set_LocaleSet);
    _this252 = _callSuper(this, locale_set_LocaleSet, [Zn, "localeSet", !0]);
    _this252.locale = new XFAObjectArray();
    return _this252;
  }
  _inherits(locale_set_LocaleSet, _XFAObject151);
  return _createClass(locale_set_LocaleSet);
}(XFAObject);
var Meridiem = /*#__PURE__*/function (_StringObject42) {
  function Meridiem(e) {
    _classCallCheck(this, Meridiem);
    return _callSuper(this, Meridiem, [Zn, "meridiem"]);
  }
  _inherits(Meridiem, _StringObject42);
  return _createClass(Meridiem);
}(StringObject);
var MeridiemNames = /*#__PURE__*/function (_XFAObject152) {
  function MeridiemNames(e) {
    var _this253;
    _classCallCheck(this, MeridiemNames);
    _this253 = _callSuper(this, MeridiemNames, [Zn, "meridiemNames", !0]);
    _this253.meridiem = new XFAObjectArray(2);
    return _this253;
  }
  _inherits(MeridiemNames, _XFAObject152);
  return _createClass(MeridiemNames);
}(XFAObject);
var Month = /*#__PURE__*/function (_StringObject43) {
  function Month(e) {
    _classCallCheck(this, Month);
    return _callSuper(this, Month, [Zn, "month"]);
  }
  _inherits(Month, _StringObject43);
  return _createClass(Month);
}(StringObject);
var MonthNames = /*#__PURE__*/function (_XFAObject153) {
  function MonthNames(e) {
    var _this254;
    _classCallCheck(this, MonthNames);
    _this254 = _callSuper(this, MonthNames, [Zn, "monthNames", !0]);
    _this254.abbr = getInteger({
      data: e.abbr,
      defaultValue: 0,
      validate: function validate(e) {
        return 1 === e;
      }
    });
    _this254.month = new XFAObjectArray(12);
    return _this254;
  }
  _inherits(MonthNames, _XFAObject153);
  return _createClass(MonthNames);
}(XFAObject);
var NumberPattern = /*#__PURE__*/function (_StringObject44) {
  function NumberPattern(e) {
    var _this255;
    _classCallCheck(this, NumberPattern);
    _this255 = _callSuper(this, NumberPattern, [Zn, "numberPattern"]);
    _this255.name = getStringOption(e.name, ["full", "long", "med", "short"]);
    return _this255;
  }
  _inherits(NumberPattern, _StringObject44);
  return _createClass(NumberPattern);
}(StringObject);
var NumberPatterns = /*#__PURE__*/function (_XFAObject154) {
  function NumberPatterns(e) {
    var _this256;
    _classCallCheck(this, NumberPatterns);
    _this256 = _callSuper(this, NumberPatterns, [Zn, "numberPatterns", !0]);
    _this256.numberPattern = new XFAObjectArray(4);
    return _this256;
  }
  _inherits(NumberPatterns, _XFAObject154);
  return _createClass(NumberPatterns);
}(XFAObject);
var NumberSymbol = /*#__PURE__*/function (_StringObject45) {
  function NumberSymbol(e) {
    var _this257;
    _classCallCheck(this, NumberSymbol);
    _this257 = _callSuper(this, NumberSymbol, [Zn, "numberSymbol"]);
    _this257.name = getStringOption(e.name, ["decimal", "grouping", "percent", "minus", "zero"]);
    return _this257;
  }
  _inherits(NumberSymbol, _StringObject45);
  return _createClass(NumberSymbol);
}(StringObject);
var NumberSymbols = /*#__PURE__*/function (_XFAObject155) {
  function NumberSymbols(e) {
    var _this258;
    _classCallCheck(this, NumberSymbols);
    _this258 = _callSuper(this, NumberSymbols, [Zn, "numberSymbols", !0]);
    _this258.numberSymbol = new XFAObjectArray(5);
    return _this258;
  }
  _inherits(NumberSymbols, _XFAObject155);
  return _createClass(NumberSymbols);
}(XFAObject);
var TimePattern = /*#__PURE__*/function (_StringObject46) {
  function TimePattern(e) {
    var _this259;
    _classCallCheck(this, TimePattern);
    _this259 = _callSuper(this, TimePattern, [Zn, "timePattern"]);
    _this259.name = getStringOption(e.name, ["full", "long", "med", "short"]);
    return _this259;
  }
  _inherits(TimePattern, _StringObject46);
  return _createClass(TimePattern);
}(StringObject);
var TimePatterns = /*#__PURE__*/function (_XFAObject156) {
  function TimePatterns(e) {
    var _this260;
    _classCallCheck(this, TimePatterns);
    _this260 = _callSuper(this, TimePatterns, [Zn, "timePatterns", !0]);
    _this260.timePattern = new XFAObjectArray(4);
    return _this260;
  }
  _inherits(TimePatterns, _XFAObject156);
  return _createClass(TimePatterns);
}(XFAObject);
var TypeFace = /*#__PURE__*/function (_XFAObject157) {
  function TypeFace(e) {
    var _this261;
    _classCallCheck(this, TypeFace);
    _this261 = _callSuper(this, TypeFace, [Zn, "typeFace", !0]);
    _this261.name = "" | e.name;
    return _this261;
  }
  _inherits(TypeFace, _XFAObject157);
  return _createClass(TypeFace);
}(XFAObject);
var TypeFaces = /*#__PURE__*/function (_XFAObject158) {
  function TypeFaces(e) {
    var _this262;
    _classCallCheck(this, TypeFaces);
    _this262 = _callSuper(this, TypeFaces, [Zn, "typeFaces", !0]);
    _this262.typeFace = new XFAObjectArray();
    return _this262;
  }
  _inherits(TypeFaces, _XFAObject158);
  return _createClass(TypeFaces);
}(XFAObject);
var LocaleSetNamespace = /*#__PURE__*/function () {
  function LocaleSetNamespace() {
    _classCallCheck(this, LocaleSetNamespace);
  }
  return _createClass(LocaleSetNamespace, null, [{
    key: cn,
    value: function value(e, t) {
      if (LocaleSetNamespace.hasOwnProperty(e)) return LocaleSetNamespace[e](t);
    }
  }, {
    key: "calendarSymbols",
    value: function calendarSymbols(e) {
      return new CalendarSymbols(e);
    }
  }, {
    key: "currencySymbol",
    value: function currencySymbol(e) {
      return new CurrencySymbol(e);
    }
  }, {
    key: "currencySymbols",
    value: function currencySymbols(e) {
      return new CurrencySymbols(e);
    }
  }, {
    key: "datePattern",
    value: function datePattern(e) {
      return new DatePattern(e);
    }
  }, {
    key: "datePatterns",
    value: function datePatterns(e) {
      return new DatePatterns(e);
    }
  }, {
    key: "dateTimeSymbols",
    value: function dateTimeSymbols(e) {
      return new DateTimeSymbols(e);
    }
  }, {
    key: "day",
    value: function day(e) {
      return new Day(e);
    }
  }, {
    key: "dayNames",
    value: function dayNames(e) {
      return new DayNames(e);
    }
  }, {
    key: "era",
    value: function era(e) {
      return new Era(e);
    }
  }, {
    key: "eraNames",
    value: function eraNames(e) {
      return new EraNames(e);
    }
  }, {
    key: "locale",
    value: function locale(e) {
      return new locale_set_Locale(e);
    }
  }, {
    key: "localeSet",
    value: function localeSet(e) {
      return new locale_set_LocaleSet(e);
    }
  }, {
    key: "meridiem",
    value: function meridiem(e) {
      return new Meridiem(e);
    }
  }, {
    key: "meridiemNames",
    value: function meridiemNames(e) {
      return new MeridiemNames(e);
    }
  }, {
    key: "month",
    value: function month(e) {
      return new Month(e);
    }
  }, {
    key: "monthNames",
    value: function monthNames(e) {
      return new MonthNames(e);
    }
  }, {
    key: "numberPattern",
    value: function numberPattern(e) {
      return new NumberPattern(e);
    }
  }, {
    key: "numberPatterns",
    value: function numberPatterns(e) {
      return new NumberPatterns(e);
    }
  }, {
    key: "numberSymbol",
    value: function numberSymbol(e) {
      return new NumberSymbol(e);
    }
  }, {
    key: "numberSymbols",
    value: function numberSymbols(e) {
      return new NumberSymbols(e);
    }
  }, {
    key: "timePattern",
    value: function timePattern(e) {
      return new TimePattern(e);
    }
  }, {
    key: "timePatterns",
    value: function timePatterns(e) {
      return new TimePatterns(e);
    }
  }, {
    key: "typeFace",
    value: function typeFace(e) {
      return new TypeFace(e);
    }
  }, {
    key: "typeFaces",
    value: function typeFaces(e) {
      return new TypeFaces(e);
    }
  }]);
}();
var Vn = Cn.signature.id;
var signature_Signature = /*#__PURE__*/function (_XFAObject159) {
  function signature_Signature(e) {
    _classCallCheck(this, signature_Signature);
    return _callSuper(this, signature_Signature, [Vn, "signature", !0]);
  }
  _inherits(signature_Signature, _XFAObject159);
  return _createClass(signature_Signature);
}(XFAObject);
var SignatureNamespace = /*#__PURE__*/function () {
  function SignatureNamespace() {
    _classCallCheck(this, SignatureNamespace);
  }
  return _createClass(SignatureNamespace, null, [{
    key: cn,
    value: function value(e, t) {
      if (SignatureNamespace.hasOwnProperty(e)) return SignatureNamespace[e](t);
    }
  }, {
    key: "signature",
    value: function signature(e) {
      return new signature_Signature(e);
    }
  }]);
}();
var zn = Cn.stylesheet.id;
var Stylesheet = /*#__PURE__*/function (_XFAObject160) {
  function Stylesheet(e) {
    _classCallCheck(this, Stylesheet);
    return _callSuper(this, Stylesheet, [zn, "stylesheet", !0]);
  }
  _inherits(Stylesheet, _XFAObject160);
  return _createClass(Stylesheet);
}(XFAObject);
var StylesheetNamespace = /*#__PURE__*/function () {
  function StylesheetNamespace() {
    _classCallCheck(this, StylesheetNamespace);
  }
  return _createClass(StylesheetNamespace, null, [{
    key: cn,
    value: function value(e, t) {
      if (StylesheetNamespace.hasOwnProperty(e)) return StylesheetNamespace[e](t);
    }
  }, {
    key: "stylesheet",
    value: function stylesheet(e) {
      return new Stylesheet(e);
    }
  }]);
}();
var _n = Cn.xdp.id;
var xdp_Xdp = /*#__PURE__*/function (_XFAObject161) {
  function xdp_Xdp(e) {
    var _this263;
    _classCallCheck(this, xdp_Xdp);
    _this263 = _callSuper(this, xdp_Xdp, [_n, "xdp", !0]);
    _this263.uuid = e.uuid || "";
    _this263.timeStamp = e.timeStamp || "";
    _this263.config = null;
    _this263.connectionSet = null;
    _this263.datasets = null;
    _this263.localeSet = null;
    _this263.stylesheet = new XFAObjectArray();
    _this263.template = null;
    return _this263;
  }
  _inherits(xdp_Xdp, _XFAObject161);
  return _createClass(xdp_Xdp, [{
    key: Pr,
    value: function value(e) {
      var t = Cn[e[Tr]];
      return t && e[Kr] === t.id;
    }
  }]);
}(XFAObject);
var XdpNamespace = /*#__PURE__*/function () {
  function XdpNamespace() {
    _classCallCheck(this, XdpNamespace);
  }
  return _createClass(XdpNamespace, null, [{
    key: cn,
    value: function value(e, t) {
      if (XdpNamespace.hasOwnProperty(e)) return XdpNamespace[e](t);
    }
  }, {
    key: "xdp",
    value: function xdp(e) {
      return new xdp_Xdp(e);
    }
  }]);
}();
var $n = Cn.xhtml.id,
  Ag = Symbol(),
  eg = new Set(["color", "font", "font-family", "font-size", "font-stretch", "font-style", "font-weight", "margin", "margin-bottom", "margin-left", "margin-right", "margin-top", "letter-spacing", "line-height", "orphans", "page-break-after", "page-break-before", "page-break-inside", "tab-interval", "tab-stop", "text-align", "text-decoration", "text-indent", "vertical-align", "widows", "kerning-mode", "xfa-font-horizontal-scale", "xfa-font-vertical-scale", "xfa-spacerun", "xfa-tab-stops"]),
  tg = new Map([["page-break-after", "breakAfter"], ["page-break-before", "breakBefore"], ["page-break-inside", "breakInside"], ["kerning-mode", function (e) {
    return "none" === e ? "none" : "normal";
  }], ["xfa-font-horizontal-scale", function (e) {
    return "scaleX(".concat(Math.max(0, Math.min(parseInt(e) / 100)).toFixed(2), ")");
  }], ["xfa-font-vertical-scale", function (e) {
    return "scaleY(".concat(Math.max(0, Math.min(parseInt(e) / 100)).toFixed(2), ")");
  }], ["xfa-spacerun", ""], ["xfa-tab-stops", ""], ["font-size", function (e, t) {
    return measureToString(.99 * (e = t.fontSize = getMeasurement(e)));
  }], ["letter-spacing", function (e) {
    return measureToString(getMeasurement(e));
  }], ["line-height", function (e) {
    return measureToString(getMeasurement(e));
  }], ["margin", function (e) {
    return measureToString(getMeasurement(e));
  }], ["margin-bottom", function (e) {
    return measureToString(getMeasurement(e));
  }], ["margin-left", function (e) {
    return measureToString(getMeasurement(e));
  }], ["margin-right", function (e) {
    return measureToString(getMeasurement(e));
  }], ["margin-top", function (e) {
    return measureToString(getMeasurement(e));
  }], ["text-indent", function (e) {
    return measureToString(getMeasurement(e));
  }], ["font-family", function (e) {
    return e;
  }], ["vertical-align", function (e) {
    return measureToString(getMeasurement(e));
  }]]),
  ig = /\s+/g,
  ag = /[\r\n]+/g,
  sg = /\r\n?/g;
function mapStyle(e, t, i) {
  var a = Object.create(null);
  if (!e) return a;
  var s = Object.create(null);
  var _iterator182 = _createForOfIteratorHelper(e.split(";").map(function (e) {
      return e.split(":", 2);
    })),
    _step182;
  try {
    for (_iterator182.s(); !(_step182 = _iterator182.n()).done;) {
      var _ref157 = _step182.value;
      var _ref158 = _slicedToArray(_ref157, 2);
      var _t407 = _ref158[0];
      var _i353 = _ref158[1];
      {
        var _e546 = tg.get(_t407);
        if ("" === _e546) continue;
        var _r146 = _i353;
        _e546 && (_r146 = "string" == typeof _e546 ? _e546 : _e546(_i353, s));
        _t407.endsWith("scale") ? a.transform = a.transform ? "".concat(a[_t407], " ").concat(_r146) : _r146 : a[_t407.replaceAll(/-([a-zA-Z])/g, function (e, t) {
          return t.toUpperCase();
        })] = _r146;
      }
    }
  } catch (err) {
    _iterator182.e(err);
  } finally {
    _iterator182.f();
  }
  a.fontFamily && setFontFamily({
    typeface: a.fontFamily,
    weight: a.fontWeight || "normal",
    posture: a.fontStyle || "normal",
    size: s.fontSize || 0
  }, t, t[br].fontFinder, a);
  if (i && a.verticalAlign && "0px" !== a.verticalAlign && a.fontSize) {
    var _e545 = .583,
      _t406 = .333,
      _i352 = getMeasurement(a.fontSize);
    a.fontSize = measureToString(_i352 * _e545);
    a.verticalAlign = measureToString(Math.sign(getMeasurement(a.verticalAlign)) * _i352 * _t406);
  }
  i && a.fontSize && (a.fontSize = "calc(".concat(a.fontSize, " * var(--scale-factor))"));
  fixTextIndent(a);
  return a;
}
var rg = new Set(["body", "html"]);
var XhtmlObject = /*#__PURE__*/function (_XmlObject2) {
  function XhtmlObject(e, t) {
    var _this264;
    _classCallCheck(this, XhtmlObject);
    _this264 = _callSuper(this, XhtmlObject, [$n, t]);
    _this264[Ag] = !1;
    _this264.style = e.style || "";
    return _this264;
  }
  _inherits(XhtmlObject, _XmlObject2);
  return _createClass(XhtmlObject, [{
    key: $s,
    value: function value(e) {
      _superPropGet(XhtmlObject, $s, this, 3)([e]);
      this.style = function checkStyle(e) {
        return e.style ? e.style.trim().split(/\s*;\s*/).filter(function (e) {
          return !!e;
        }).map(function (e) {
          return e.split(/\s*:\s*/, 2);
        }).filter(function (_ref159) {
          var _ref160 = _slicedToArray(_ref159, 2),
            t = _ref160[0],
            i = _ref160[1];
          "font-family" === t && e[br].usedTypefaces.add(i);
          return eg.has(t);
        }).map(function (e) {
          return e.join(":");
        }).join(";") : "";
      }(this);
    }
  }, {
    key: Zs,
    value: function value() {
      return !rg.has(this[Tr]);
    }
  }, {
    key: Wr,
    value: function value(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      if (t) this[Ag] = !0;else {
        e = e.replaceAll(ag, "");
        this.style.includes("xfa-spacerun:yes") || (e = e.replaceAll(ig, " "));
      }
      e && (this[ar] += e);
    }
  }, {
    key: jr,
    value: function value(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var i = Object.create(null),
        a = {
          top: NaN,
          bottom: NaN,
          left: NaN,
          right: NaN
        };
      var s = null;
      var _iterator183 = _createForOfIteratorHelper(this.style.split(";").map(function (e) {
          return e.split(":", 2);
        })),
        _step183;
      try {
        for (_iterator183.s(); !(_step183 = _iterator183.n()).done;) {
          var _ref161 = _step183.value;
          var _ref162 = _slicedToArray(_ref161, 2);
          var _e547 = _ref162[0];
          var _t409 = _ref162[1];
          switch (e) {
            case "font-family":
              i.typeface = stripQuotes(_t409);
              break;
            case "font-size":
              i.size = getMeasurement(_t409);
              break;
            case "font-weight":
              i.weight = _t409;
              break;
            case "font-style":
              i.posture = _t409;
              break;
            case "letter-spacing":
              i.letterSpacing = getMeasurement(_t409);
              break;
            case "margin":
              var _e548 = _t409.split(/ \t/).map(function (e) {
                return getMeasurement(e);
              });
              switch (_e548.length) {
                case 1:
                  a.top = a.bottom = a.left = a.right = _e548[0];
                  break;
                case 2:
                  a.top = a.bottom = _e548[0];
                  a.left = a.right = _e548[1];
                  break;
                case 3:
                  a.top = _e548[0];
                  a.bottom = _e548[2];
                  a.left = a.right = _e548[1];
                  break;
                case 4:
                  a.top = _e548[0];
                  a.left = _e548[1];
                  a.bottom = _e548[2];
                  a.right = _e548[3];
              }
              break;
            case "margin-top":
              a.top = getMeasurement(_t409);
              break;
            case "margin-bottom":
              a.bottom = getMeasurement(_t409);
              break;
            case "margin-left":
              a.left = getMeasurement(_t409);
              break;
            case "margin-right":
              a.right = getMeasurement(_t409);
              break;
            case "line-height":
              s = getMeasurement(_t409);
          }
        }
      } catch (err) {
        _iterator183.e(err);
      } finally {
        _iterator183.f();
      }
      e.pushData(i, a, s);
      if (this[ar]) e.addString(this[ar]);else {
        var _iterator184 = _createForOfIteratorHelper(this[fr]()),
          _step184;
        try {
          for (_iterator184.s(); !(_step184 = _iterator184.n()).done;) {
            var _t408 = _step184.value;
            "#text" !== _t408[Tr] ? _t408[jr](e) : e.addString(_t408[ar]);
          }
        } catch (err) {
          _iterator184.e(err);
        } finally {
          _iterator184.f();
        }
      }
      t && e.popFont();
    }
  }, {
    key: nn,
    value: function value(e) {
      var t = [];
      this[nr] = {
        children: t
      };
      this[_s]({});
      if (0 === t.length && !this[ar]) return HTMLResult.EMPTY;
      var i;
      i = this[Ag] ? this[ar] ? this[ar].replaceAll(sg, "\n") : void 0 : this[ar] || void 0;
      return HTMLResult.success({
        name: this[Tr],
        attributes: {
          href: this.href,
          style: mapStyle(this.style, this, this[Ag])
        },
        children: t,
        value: i
      });
    }
  }]);
}(XmlObject);
var A = /*#__PURE__*/function (_XhtmlObject) {
  function A(e) {
    var _this265;
    _classCallCheck(this, A);
    _this265 = _callSuper(this, A, [e, "a"]);
    _this265.href = fixURL(e.href) || "";
    return _this265;
  }
  _inherits(A, _XhtmlObject);
  return _createClass(A);
}(XhtmlObject);
var B = /*#__PURE__*/function (_XhtmlObject2) {
  function B(e) {
    _classCallCheck(this, B);
    return _callSuper(this, B, [e, "b"]);
  }
  _inherits(B, _XhtmlObject2);
  return _createClass(B, [{
    key: jr,
    value: function value(e) {
      e.pushFont({
        weight: "bold"
      });
      _superPropGet(B, jr, this, 3)([e]);
      e.popFont();
    }
  }]);
}(XhtmlObject);
var Body = /*#__PURE__*/function (_XhtmlObject3) {
  function Body(e) {
    _classCallCheck(this, Body);
    return _callSuper(this, Body, [e, "body"]);
  }
  _inherits(Body, _XhtmlObject3);
  return _createClass(Body, [{
    key: nn,
    value: function value(e) {
      var t = _superPropGet(Body, nn, this, 3)([e]),
        i = t.html;
      if (!i) return HTMLResult.EMPTY;
      i.name = "div";
      i.attributes.class = ["xfaRich"];
      return t;
    }
  }]);
}(XhtmlObject);
var Br = /*#__PURE__*/function (_XhtmlObject4) {
  function Br(e) {
    _classCallCheck(this, Br);
    return _callSuper(this, Br, [e, "br"]);
  }
  _inherits(Br, _XhtmlObject4);
  return _createClass(Br, [{
    key: sn,
    value: function value() {
      return "\n";
    }
  }, {
    key: jr,
    value: function value(e) {
      e.addString("\n");
    }
  }, {
    key: nn,
    value: function value(e) {
      return HTMLResult.success({
        name: "br"
      });
    }
  }]);
}(XhtmlObject);
var Html = /*#__PURE__*/function (_XhtmlObject5) {
  function Html(e) {
    _classCallCheck(this, Html);
    return _callSuper(this, Html, [e, "html"]);
  }
  _inherits(Html, _XhtmlObject5);
  return _createClass(Html, [{
    key: nn,
    value: function value(e) {
      var t = [];
      this[nr] = {
        children: t
      };
      this[_s]({});
      if (0 === t.length) return HTMLResult.success({
        name: "div",
        attributes: {
          class: ["xfaRich"],
          style: {}
        },
        value: this[ar] || ""
      });
      if (1 === t.length) {
        var _e549$attributes;
        var _e549 = t[0];
        if ((_e549$attributes = _e549.attributes) !== null && _e549$attributes !== void 0 && _e549$attributes.class.includes("xfaRich")) return HTMLResult.success(_e549);
      }
      return HTMLResult.success({
        name: "div",
        attributes: {
          class: ["xfaRich"],
          style: {}
        },
        children: t
      });
    }
  }]);
}(XhtmlObject);
var I = /*#__PURE__*/function (_XhtmlObject6) {
  function I(e) {
    _classCallCheck(this, I);
    return _callSuper(this, I, [e, "i"]);
  }
  _inherits(I, _XhtmlObject6);
  return _createClass(I, [{
    key: jr,
    value: function value(e) {
      e.pushFont({
        posture: "italic"
      });
      _superPropGet(I, jr, this, 3)([e]);
      e.popFont();
    }
  }]);
}(XhtmlObject);
var Li = /*#__PURE__*/function (_XhtmlObject7) {
  function Li(e) {
    _classCallCheck(this, Li);
    return _callSuper(this, Li, [e, "li"]);
  }
  _inherits(Li, _XhtmlObject7);
  return _createClass(Li);
}(XhtmlObject);
var Ol = /*#__PURE__*/function (_XhtmlObject8) {
  function Ol(e) {
    _classCallCheck(this, Ol);
    return _callSuper(this, Ol, [e, "ol"]);
  }
  _inherits(Ol, _XhtmlObject8);
  return _createClass(Ol);
}(XhtmlObject);
var P = /*#__PURE__*/function (_XhtmlObject9) {
  function P(e) {
    _classCallCheck(this, P);
    return _callSuper(this, P, [e, "p"]);
  }
  _inherits(P, _XhtmlObject9);
  return _createClass(P, [{
    key: jr,
    value: function value(e) {
      _superPropGet(P, jr, this, 3)([e, !1]);
      e.addString("\n");
      e.addPara();
      e.popFont();
    }
  }, {
    key: sn,
    value: function value() {
      return this[wr]()[fr]().at(-1) === this ? _superPropGet(P, sn, this, 3)([]) : _superPropGet(P, sn, this, 3)([]) + "\n";
    }
  }]);
}(XhtmlObject);
var Span = /*#__PURE__*/function (_XhtmlObject10) {
  function Span(e) {
    _classCallCheck(this, Span);
    return _callSuper(this, Span, [e, "span"]);
  }
  _inherits(Span, _XhtmlObject10);
  return _createClass(Span);
}(XhtmlObject);
var Sub = /*#__PURE__*/function (_XhtmlObject11) {
  function Sub(e) {
    _classCallCheck(this, Sub);
    return _callSuper(this, Sub, [e, "sub"]);
  }
  _inherits(Sub, _XhtmlObject11);
  return _createClass(Sub);
}(XhtmlObject);
var Sup = /*#__PURE__*/function (_XhtmlObject12) {
  function Sup(e) {
    _classCallCheck(this, Sup);
    return _callSuper(this, Sup, [e, "sup"]);
  }
  _inherits(Sup, _XhtmlObject12);
  return _createClass(Sup);
}(XhtmlObject);
var Ul = /*#__PURE__*/function (_XhtmlObject13) {
  function Ul(e) {
    _classCallCheck(this, Ul);
    return _callSuper(this, Ul, [e, "ul"]);
  }
  _inherits(Ul, _XhtmlObject13);
  return _createClass(Ul);
}(XhtmlObject);
var XhtmlNamespace = /*#__PURE__*/function () {
  function XhtmlNamespace() {
    _classCallCheck(this, XhtmlNamespace);
  }
  return _createClass(XhtmlNamespace, null, [{
    key: cn,
    value: function value(e, t) {
      if (XhtmlNamespace.hasOwnProperty(e)) return XhtmlNamespace[e](t);
    }
  }, {
    key: "a",
    value: function a(e) {
      return new A(e);
    }
  }, {
    key: "b",
    value: function b(e) {
      return new B(e);
    }
  }, {
    key: "body",
    value: function body(e) {
      return new Body(e);
    }
  }, {
    key: "br",
    value: function br(e) {
      return new Br(e);
    }
  }, {
    key: "html",
    value: function html(e) {
      return new Html(e);
    }
  }, {
    key: "i",
    value: function i(e) {
      return new I(e);
    }
  }, {
    key: "li",
    value: function li(e) {
      return new Li(e);
    }
  }, {
    key: "ol",
    value: function ol(e) {
      return new Ol(e);
    }
  }, {
    key: "p",
    value: function p(e) {
      return new P(e);
    }
  }, {
    key: "span",
    value: function span(e) {
      return new Span(e);
    }
  }, {
    key: "sub",
    value: function sub(e) {
      return new Sub(e);
    }
  }, {
    key: "sup",
    value: function sup(e) {
      return new Sup(e);
    }
  }, {
    key: "ul",
    value: function ul(e) {
      return new Ul(e);
    }
  }]);
}();
var ng = {
  config: ConfigNamespace,
  connection: ConnectionSetNamespace,
  datasets: DatasetsNamespace,
  localeSet: LocaleSetNamespace,
  signature: SignatureNamespace,
  stylesheet: StylesheetNamespace,
  template: TemplateNamespace,
  xdp: XdpNamespace,
  xhtml: XhtmlNamespace
};
var UnknownNamespace = /*#__PURE__*/function () {
  function UnknownNamespace(e) {
    _classCallCheck(this, UnknownNamespace);
    this.namespaceId = e;
  }
  return _createClass(UnknownNamespace, [{
    key: cn,
    value: function value(e, t) {
      return new XmlObject(this.namespaceId, e, t);
    }
  }]);
}();
var Root = /*#__PURE__*/function (_XFAObject162) {
  function Root(e) {
    var _this266;
    _classCallCheck(this, Root);
    _this266 = _callSuper(this, Root, [-1, "root", Object.create(null)]);
    _this266.element = null;
    _this266[Sr] = e;
    return _this266;
  }
  _inherits(Root, _XFAObject162);
  return _createClass(Root, [{
    key: Or,
    value: function value(e) {
      this.element = e;
      return !0;
    }
  }, {
    key: gr,
    value: function value() {
      _superPropGet(Root, gr, this, 3)([]);
      if (this.element.template instanceof Template) {
        this[Sr].set(zr, this.element);
        this.element.template[_r](this[Sr]);
        this.element.template[Sr] = this[Sr];
      }
    }
  }]);
}(XFAObject);
var Empty = /*#__PURE__*/function (_XFAObject163) {
  function Empty() {
    _classCallCheck(this, Empty);
    return _callSuper(this, Empty, [-1, "", Object.create(null)]);
  }
  _inherits(Empty, _XFAObject163);
  return _createClass(Empty, [{
    key: Or,
    value: function value(e) {
      return !1;
    }
  }]);
}(XFAObject);
var Builder = /*#__PURE__*/function () {
  function Builder() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    _classCallCheck(this, Builder);
    this._namespaceStack = [];
    this._nsAgnosticLevel = 0;
    this._namespacePrefixes = new Map();
    this._namespaces = new Map();
    this._nextNsId = Math.max.apply(Math, _toConsumableArray(Object.values(Cn).map(function (_ref163) {
      var e = _ref163.id;
      return e;
    })));
    this._currentNamespace = e || new UnknownNamespace(++this._nextNsId);
  }
  return _createClass(Builder, [{
    key: "buildRoot",
    value: function buildRoot(e) {
      return new Root(e);
    }
  }, {
    key: "build",
    value: function build(_ref164) {
      var e = _ref164.nsPrefix,
        t = _ref164.name,
        i = _ref164.attributes,
        a = _ref164.namespace,
        s = _ref164.prefixes;
      var r = null !== a;
      if (r) {
        this._namespaceStack.push(this._currentNamespace);
        this._currentNamespace = this._searchNamespace(a);
      }
      s && this._addNamespacePrefix(s);
      if (i.hasOwnProperty(qr)) {
        var _e550 = ng.datasets,
          _t410 = i[qr];
        var _a279 = null;
        for (var _i354 = 0, _Object$entries5 = Object.entries(_t410); _i354 < _Object$entries5.length; _i354++) {
          var _ref165 = _Object$entries5[_i354];
          var _ref166 = _slicedToArray(_ref165, 2);
          var _i355 = _ref166[0];
          var _s186 = _ref166[1];
          if (this._getNamespaceToUse(_i355) === _e550) {
            _a279 = {
              xfa: _s186
            };
            break;
          }
        }
        _a279 ? i[qr] = _a279 : delete i[qr];
      }
      var n = this._getNamespaceToUse(e),
        g = (n === null || n === void 0 ? void 0 : n[cn](t, i)) || new Empty();
      g[Mr]() && this._nsAgnosticLevel++;
      (r || s || g[Mr]()) && (g[er] = {
        hasNamespace: r,
        prefixes: s,
        nsAgnostic: g[Mr]()
      });
      return g;
    }
  }, {
    key: "isNsAgnostic",
    value: function isNsAgnostic() {
      return this._nsAgnosticLevel > 0;
    }
  }, {
    key: "_searchNamespace",
    value: function _searchNamespace(e) {
      var t = this._namespaces.get(e);
      if (t) return t;
      for (var _i356 = 0, _Object$entries6 = Object.entries(Cn); _i356 < _Object$entries6.length; _i356++) {
        var _ref167 = _Object$entries6[_i356];
        var _ref168 = _slicedToArray(_ref167, 2);
        var _i357 = _ref168[0];
        var _a280 = _ref168[1].check;
        if (_a280(e)) {
          t = ng[_i357];
          if (t) {
            this._namespaces.set(e, t);
            return t;
          }
          break;
        }
      }
      t = new UnknownNamespace(++this._nextNsId);
      this._namespaces.set(e, t);
      return t;
    }
  }, {
    key: "_addNamespacePrefix",
    value: function _addNamespacePrefix(e) {
      var _iterator185 = _createForOfIteratorHelper(e),
        _step185;
      try {
        for (_iterator185.s(); !(_step185 = _iterator185.n()).done;) {
          var _ref169 = _step185.value;
          var _t411 = _ref169.prefix;
          var _i358 = _ref169.value;
          {
            var _e551 = this._searchNamespace(_i358);
            var _a281 = this._namespacePrefixes.get(_t411);
            if (!_a281) {
              _a281 = [];
              this._namespacePrefixes.set(_t411, _a281);
            }
            _a281.push(_e551);
          }
        }
      } catch (err) {
        _iterator185.e(err);
      } finally {
        _iterator185.f();
      }
    }
  }, {
    key: "_getNamespaceToUse",
    value: function _getNamespaceToUse(e) {
      if (!e) return this._currentNamespace;
      var t = this._namespacePrefixes.get(e);
      if ((t === null || t === void 0 ? void 0 : t.length) > 0) return t.at(-1);
      warn("Unknown namespace prefix: ".concat(e, "."));
      return null;
    }
  }, {
    key: "clean",
    value: function clean(e) {
      var _this267 = this;
      var t = e.hasNamespace,
        i = e.prefixes,
        a = e.nsAgnostic;
      t && (this._currentNamespace = this._namespaceStack.pop());
      i && i.forEach(function (_ref170) {
        var e = _ref170.prefix;
        _this267._namespacePrefixes.get(e).pop();
      });
      a && this._nsAgnosticLevel--;
    }
  }]);
}();
var XFAParser = /*#__PURE__*/function (_XMLParserBase2) {
  function XFAParser() {
    var _this268;
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    _classCallCheck(this, XFAParser);
    _this268 = _callSuper(this, XFAParser);
    _this268._builder = new Builder(e);
    _this268._stack = [];
    _this268._globalData = {
      usedTypefaces: new Set()
    };
    _this268._ids = new Map();
    _this268._current = _this268._builder.buildRoot(_this268._ids);
    _this268._errorCode = xs;
    _this268._whiteRegex = /^\s+$/;
    _this268._nbsps = /\xa0+/g;
    _this268._richText = t;
    return _this268;
  }
  _inherits(XFAParser, _XMLParserBase2);
  return _createClass(XFAParser, [{
    key: "parse",
    value: function parse(e) {
      this.parseXml(e);
      if (this._errorCode === xs) {
        this._current[gr]();
        return this._current.element;
      }
    }
  }, {
    key: "onText",
    value: function onText(e) {
      e = e.replace(this._nbsps, function (e) {
        return e.slice(1) + " ";
      });
      this._richText || this._current[Zs]() ? this._current[Wr](e, this._richText) : this._whiteRegex.test(e) || this._current[Wr](e.trim());
    }
  }, {
    key: "onCdata",
    value: function onCdata(e) {
      this._current[Wr](e);
    }
  }, {
    key: "_mkAttributes",
    value: function _mkAttributes(e, t) {
      var i = null,
        a = null;
      var s = Object.create({});
      var _iterator186 = _createForOfIteratorHelper(e),
        _step186;
      try {
        for (_iterator186.s(); !(_step186 = _iterator186.n()).done;) {
          var _ref171 = _step186.value;
          var _r147 = _ref171.name;
          var _n103 = _ref171.value;
          if ("xmlns" === _r147) i ? warn("XFA - multiple namespace definition in <".concat(t, ">")) : i = _n103;else if (_r147.startsWith("xmlns:")) {
            var _e552 = _r147.substring(6);
            a || (a = []);
            a.push({
              prefix: _e552,
              value: _n103
            });
          } else {
            var _e553 = _r147.indexOf(":");
            if (-1 === _e553) s[_r147] = _n103;else {
              var _t413;
              var _t412 = s[qr];
              _t412 || (_t412 = s[qr] = Object.create(null));
              var _ref172 = [_r147.slice(0, _e553), _r147.slice(_e553 + 1)],
                _i359 = _ref172[0],
                _a282 = _ref172[1];
              ((_t413 = _t412)[_i359] || (_t413[_i359] = Object.create(null)))[_a282] = _n103;
            }
          }
        }
      } catch (err) {
        _iterator186.e(err);
      } finally {
        _iterator186.f();
      }
      return [i, a, s];
    }
  }, {
    key: "_getNameAndPrefix",
    value: function _getNameAndPrefix(e, t) {
      var i = e.indexOf(":");
      return -1 === i ? [e, null] : [e.substring(i + 1), t ? "" : e.substring(0, i)];
    }
  }, {
    key: "onBeginElement",
    value: function onBeginElement(e, t, i) {
      var _this$_mkAttributes = this._mkAttributes(t, e),
        _this$_mkAttributes2 = _slicedToArray(_this$_mkAttributes, 3),
        a = _this$_mkAttributes2[0],
        s = _this$_mkAttributes2[1],
        r = _this$_mkAttributes2[2],
        _this$_getNameAndPref = this._getNameAndPrefix(e, this._builder.isNsAgnostic()),
        _this$_getNameAndPref2 = _slicedToArray(_this$_getNameAndPref, 2),
        n = _this$_getNameAndPref2[0],
        g = _this$_getNameAndPref2[1],
        o = this._builder.build({
          nsPrefix: g,
          name: n,
          attributes: r,
          namespace: a,
          prefixes: s
        });
      o[br] = this._globalData;
      if (i) {
        o[gr]();
        this._current[Or](o) && o[An](this._ids);
        o[$s](this._builder);
      } else {
        this._stack.push(this._current);
        this._current = o;
      }
    }
  }, {
    key: "onEndElement",
    value: function onEndElement(e) {
      var t = this._current;
      if (t[Nr]() && "string" == typeof t[ar]) {
        var _e554 = new XFAParser();
        _e554._globalData = this._globalData;
        var _i360 = _e554.parse(t[ar]);
        t[ar] = null;
        t[Or](_i360);
      }
      t[gr]();
      this._current = this._stack.pop();
      this._current[Or](t) && t[An](this._ids);
      t[$s](this._builder);
    }
  }, {
    key: "onError",
    value: function onError(e) {
      this._errorCode = e;
    }
  }]);
}(XMLParserBase);
var XFAFactory = /*#__PURE__*/function () {
  function XFAFactory(e) {
    _classCallCheck(this, XFAFactory);
    try {
      this.root = new XFAParser().parse(XFAFactory._createDocument(e));
      var _t414 = new Binder(this.root);
      this.form = _t414.bind();
      this.dataHandler = new DataHandler(this.root, _t414.getData());
      this.form[br].template = this.form;
    } catch (e) {
      warn("XFA - an error occurred during parsing and binding: ".concat(e));
    }
  }
  return _createClass(XFAFactory, [{
    key: "isValid",
    value: function isValid() {
      return this.root && this.form;
    }
  }, {
    key: "_createPagesHelper",
    value: function _createPagesHelper() {
      var e = this.form[rn]();
      return new Promise(function (t, i) {
        var _nextIteration = function nextIteration() {
          try {
            var _i361 = e.next();
            _i361.done ? t(_i361.value) : setTimeout(_nextIteration, 0);
          } catch (e) {
            i(e);
          }
        };
        setTimeout(_nextIteration, 0);
      });
    }
  }, {
    key: "_createPages",
    value: function () {
      var _createPages2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
        return _regeneratorRuntime().wrap(function _callee48$(_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              _context60.prev = 0;
              _context60.next = 3;
              return this._createPagesHelper();
            case 3:
              this.pages = _context60.sent;
              this.dims = this.pages.children.map(function (e) {
                var _e$attributes$style = e.attributes.style,
                  t = _e$attributes$style.width,
                  i = _e$attributes$style.height;
                return [0, 0, parseInt(t), parseInt(i)];
              });
              _context60.next = 10;
              break;
            case 7:
              _context60.prev = 7;
              _context60.t0 = _context60["catch"](0);
              warn("XFA - an error occurred during layout: ".concat(_context60.t0));
            case 10:
            case "end":
              return _context60.stop();
          }
        }, _callee48, this, [[0, 7]]);
      }));
      function _createPages() {
        return _createPages2.apply(this, arguments);
      }
      return _createPages;
    }()
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox(e) {
      return this.dims[e];
    }
  }, {
    key: "getNumPages",
    value: function () {
      var _getNumPages = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee49() {
        return _regeneratorRuntime().wrap(function _callee49$(_context61) {
          while (1) switch (_context61.prev = _context61.next) {
            case 0:
              _context61.t0 = this.pages;
              if (_context61.t0) {
                _context61.next = 4;
                break;
              }
              _context61.next = 4;
              return this._createPages();
            case 4:
              return _context61.abrupt("return", this.dims.length);
            case 5:
            case "end":
              return _context61.stop();
          }
        }, _callee49, this);
      }));
      function getNumPages() {
        return _getNumPages.apply(this, arguments);
      }
      return getNumPages;
    }()
  }, {
    key: "setImages",
    value: function setImages(e) {
      this.form[br].images = e;
    }
  }, {
    key: "setFonts",
    value: function setFonts(e) {
      this.form[br].fontFinder = new FontFinder(e);
      var t = [];
      var _iterator187 = _createForOfIteratorHelper(this.form[br].usedTypefaces),
        _step187;
      try {
        for (_iterator187.s(); !(_step187 = _iterator187.n()).done;) {
          var _e555 = _step187.value;
          _e555 = stripQuotes(_e555);
          this.form[br].fontFinder.find(_e555) || t.push(_e555);
        }
      } catch (err) {
        _iterator187.e(err);
      } finally {
        _iterator187.f();
      }
      return t.length > 0 ? t : null;
    }
  }, {
    key: "appendFonts",
    value: function appendFonts(e, t) {
      this.form[br].fontFinder.add(e, t);
    }
  }, {
    key: "getPages",
    value: function () {
      var _getPages = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee50() {
        var e;
        return _regeneratorRuntime().wrap(function _callee50$(_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              _context62.t0 = this.pages;
              if (_context62.t0) {
                _context62.next = 4;
                break;
              }
              _context62.next = 4;
              return this._createPages();
            case 4:
              e = this.pages;
              this.pages = null;
              return _context62.abrupt("return", e);
            case 7:
            case "end":
              return _context62.stop();
          }
        }, _callee50, this);
      }));
      function getPages() {
        return _getPages.apply(this, arguments);
      }
      return getPages;
    }()
  }, {
    key: "serializeData",
    value: function serializeData(e) {
      return this.dataHandler.serialize(e);
    }
  }], [{
    key: "_createDocument",
    value: function _createDocument(e) {
      return e["/xdp:xdp"] ? Object.values(e).join("") : e["xdp:xdp"];
    }
  }, {
    key: "getRichTextAsHtml",
    value: function getRichTextAsHtml(e) {
      if (!e || "string" != typeof e) return null;
      try {
        var _t415 = new XFAParser(XhtmlNamespace, !0).parse(e);
        if (!["body", "xhtml"].includes(_t415[Tr])) {
          var _e556 = XhtmlNamespace.body({});
          _e556[zs](_t415);
          _t415 = _e556;
        }
        var _i362 = _t415[nn]();
        if (!_i362.success) return null;
        var _a283 = _i362.html,
          _s187 = _a283.attributes;
        if (_s187) {
          _s187.class && (_s187.class = _s187.class.filter(function (e) {
            return !e.startsWith("xfa");
          }));
          _s187.dir = "auto";
        }
        return {
          html: _a283,
          str: _t415[sn]()
        };
      } catch (e) {
        warn("XFA - an error occurred during parsing of rich text: ".concat(e));
      }
      return null;
    }
  }]);
}();
var AnnotationFactory = /*#__PURE__*/function () {
  function AnnotationFactory() {
    _classCallCheck(this, AnnotationFactory);
  }
  return _createClass(AnnotationFactory, null, [{
    key: "createGlobals",
    value: function createGlobals(e) {
      return Promise.all([e.ensureCatalog("acroForm"), e.ensureDoc("xfaDatasets"), e.ensureCatalog("structTreeRoot"), e.ensureCatalog("baseUrl"), e.ensureCatalog("attachments")]).then(function (_ref173) {
        var _ref174 = _slicedToArray(_ref173, 5),
          t = _ref174[0],
          i = _ref174[1],
          a = _ref174[2],
          s = _ref174[3],
          r = _ref174[4];
        return {
          pdfManager: e,
          acroForm: t instanceof Dict ? t : Dict.empty,
          xfaDatasets: i,
          structTreeRoot: a,
          baseUrl: s,
          attachments: r
        };
      }, function (e) {
        warn("createGlobals: \"".concat(e, "\"."));
        return null;
      });
    }
  }, {
    key: "create",
    value: function () {
      var _create2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee51(e, t, i, a, s, r, n) {
        var g;
        return _regeneratorRuntime().wrap(function _callee51$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              if (!s) {
                _context63.next = 6;
                break;
              }
              _context63.next = 3;
              return this._getPageIndex(e, t, i.pdfManager);
            case 3:
              _context63.t0 = _context63.sent;
              _context63.next = 7;
              break;
            case 6:
              _context63.t0 = null;
            case 7:
              g = _context63.t0;
              return _context63.abrupt("return", i.pdfManager.ensure(this, "_create", [e, t, i, a, s, r, g, n]));
            case 9:
            case "end":
              return _context63.stop();
          }
        }, _callee51, this);
      }));
      function create(_x89, _x90, _x91, _x92, _x93, _x94, _x95) {
        return _create2.apply(this, arguments);
      }
      return create;
    }()
  }, {
    key: "_create",
    value: function _create(e, t, i, a) {
      var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
      var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      var n = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
      var g = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
      var o = e.fetchIfRef(t);
      if (!(o instanceof Dict)) return;
      var c = i.acroForm,
        C = i.pdfManager,
        h = t instanceof Ref ? t.toString() : "annot_".concat(a.createObjId());
      var l = o.get("Subtype");
      l = l instanceof Name ? l.name : null;
      var Q = {
        xref: e,
        ref: t,
        dict: o,
        subtype: l,
        id: h,
        annotationGlobals: i,
        collectFields: s,
        orphanFields: r,
        needAppearances: !s && !0 === c.get("NeedAppearances"),
        pageIndex: n,
        evaluatorOptions: C.evaluatorOptions,
        pageRef: g
      };
      switch (l) {
        case "Link":
          return new LinkAnnotation(Q);
        case "Text":
          return new TextAnnotation(Q);
        case "Widget":
          var _e557 = getInheritableProperty({
            dict: o,
            key: "FT"
          });
          _e557 = _e557 instanceof Name ? _e557.name : null;
          switch (_e557) {
            case "Tx":
              return new TextWidgetAnnotation(Q);
            case "Btn":
              return new ButtonWidgetAnnotation(Q);
            case "Ch":
              return new ChoiceWidgetAnnotation(Q);
            case "Sig":
              return new SignatureWidgetAnnotation(Q);
          }
          warn("Unimplemented widget field type \"".concat(_e557, "\", falling back to base field type."));
          return new WidgetAnnotation(Q);
        case "Popup":
          return new PopupAnnotation(Q);
        case "FreeText":
          return new FreeTextAnnotation(Q);
        case "Line":
          return new LineAnnotation(Q);
        case "Square":
          return new SquareAnnotation(Q);
        case "Circle":
          return new CircleAnnotation(Q);
        case "PolyLine":
          return new PolylineAnnotation(Q);
        case "Polygon":
          return new PolygonAnnotation(Q);
        case "Caret":
          return new CaretAnnotation(Q);
        case "Ink":
          return new InkAnnotation(Q);
        case "Highlight":
          return new HighlightAnnotation(Q);
        case "Underline":
          return new UnderlineAnnotation(Q);
        case "Squiggly":
          return new SquigglyAnnotation(Q);
        case "StrikeOut":
          return new StrikeOutAnnotation(Q);
        case "Stamp":
          return new StampAnnotation(Q);
        case "FileAttachment":
          return new FileAttachmentAnnotation(Q);
        default:
          s || warn(l ? "Unimplemented annotation type \"".concat(l, "\", falling back to base annotation.") : "Annotation is missing the required /Subtype.");
          return new Annotation(Q);
      }
    }
  }, {
    key: "_getPageIndex",
    value: function () {
      var _getPageIndex2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee52(e, t, i) {
        var _a284, _s188, _r148, _e558, _a285, _s189, _iterator188, _step188, _i363;
        return _regeneratorRuntime().wrap(function _callee52$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              _context64.prev = 0;
              _context64.next = 3;
              return e.fetchIfRefAsync(t);
            case 3:
              _a284 = _context64.sent;
              if (_a284 instanceof Dict) {
                _context64.next = 6;
                break;
              }
              return _context64.abrupt("return", -1);
            case 6:
              _s188 = _a284.getRaw("P");
              if (!(_s188 instanceof Ref)) {
                _context64.next = 17;
                break;
              }
              _context64.prev = 8;
              _context64.next = 11;
              return i.ensureCatalog("getPageIndex", [_s188]);
            case 11:
              return _context64.abrupt("return", _context64.sent);
            case 14:
              _context64.prev = 14;
              _context64.t0 = _context64["catch"](8);
              info("_getPageIndex -- not a valid page reference: \"".concat(_context64.t0, "\"."));
            case 17:
              if (!_a284.has("Kids")) {
                _context64.next = 19;
                break;
              }
              return _context64.abrupt("return", -1);
            case 19:
              _context64.next = 21;
              return i.ensureDoc("numPages");
            case 21:
              _r148 = _context64.sent;
              _e558 = 0;
            case 23:
              if (!(_e558 < _r148)) {
                _context64.next = 50;
                break;
              }
              _context64.next = 26;
              return i.getPage(_e558);
            case 26:
              _a285 = _context64.sent;
              _context64.next = 29;
              return i.ensure(_a285, "annotations");
            case 29:
              _s189 = _context64.sent;
              _iterator188 = _createForOfIteratorHelper(_s189);
              _context64.prev = 31;
              _iterator188.s();
            case 33:
              if ((_step188 = _iterator188.n()).done) {
                _context64.next = 39;
                break;
              }
              _i363 = _step188.value;
              if (!(_i363 instanceof Ref && isRefsEqual(_i363, t))) {
                _context64.next = 37;
                break;
              }
              return _context64.abrupt("return", _e558);
            case 37:
              _context64.next = 33;
              break;
            case 39:
              _context64.next = 44;
              break;
            case 41:
              _context64.prev = 41;
              _context64.t1 = _context64["catch"](31);
              _iterator188.e(_context64.t1);
            case 44:
              _context64.prev = 44;
              _iterator188.f();
              return _context64.finish(44);
            case 47:
              _e558++;
              _context64.next = 23;
              break;
            case 50:
              _context64.next = 55;
              break;
            case 52:
              _context64.prev = 52;
              _context64.t2 = _context64["catch"](0);
              warn("_getPageIndex: \"".concat(_context64.t2, "\"."));
            case 55:
              return _context64.abrupt("return", -1);
            case 56:
            case "end":
              return _context64.stop();
          }
        }, _callee52, null, [[0, 52], [8, 14], [31, 41, 44, 47]]);
      }));
      function _getPageIndex(_x96, _x97, _x98) {
        return _getPageIndex2.apply(this, arguments);
      }
      return _getPageIndex;
    }()
  }, {
    key: "generateImages",
    value: function generateImages(e, t, i) {
      if (!i) {
        warn("generateImages: OffscreenCanvas is not supported, cannot save or print some annotations with images.");
        return null;
      }
      var a;
      var _iterator189 = _createForOfIteratorHelper(e),
        _step189;
      try {
        for (_iterator189.s(); !(_step189 = _iterator189.n()).done;) {
          var _ref175 = _step189.value;
          var _i364 = _ref175.bitmapId;
          var _s190 = _ref175.bitmap;
          if (_s190) {
            a || (a = new Map());
            a.set(_i364, StampAnnotation.createImage(_s190, t));
          }
        }
      } catch (err) {
        _iterator189.e(err);
      } finally {
        _iterator189.f();
      }
      return a;
    }
  }, {
    key: "saveNewAnnotations",
    value: function () {
      var _saveNewAnnotations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee53(e, t, i, a) {
        var s, r, n, g, o, _iterator190, _step190, c, _e559, _t416, _i365, _e560, _t417, _a286, _i366, _r149;
        return _regeneratorRuntime().wrap(function _callee53$(_context65) {
          while (1) switch (_context65.prev = _context65.next) {
            case 0:
              s = e.xref;
              n = [], g = [], o = e.options.isOffscreenCanvasSupported;
              _iterator190 = _createForOfIteratorHelper(i);
              _context65.prev = 3;
              _iterator190.s();
            case 5:
              if ((_step190 = _iterator190.n()).done) {
                _context65.next = 53;
                break;
              }
              c = _step190.value;
              if (c.deleted) {
                _context65.next = 51;
                break;
              }
              _context65.t0 = c.annotationType;
              _context65.next = _context65.t0 === d ? 11 : _context65.t0 === f ? 24 : _context65.t0 === m ? 26 : _context65.t0 === p ? 28 : 51;
              break;
            case 11:
              if (r) {
                _context65.next = 22;
                break;
              }
              _e559 = new Dict(s);
              _e559.set("BaseFont", Name.get("Helvetica"));
              _e559.set("Type", Name.get("Font"));
              _e559.set("Subtype", Name.get("Type1"));
              _e559.set("Encoding", Name.get("WinAnsiEncoding"));
              _t416 = [];
              r = s.getNewTemporaryRef();
              _context65.next = 21;
              return writeObject(r, _e559, _t416, s);
            case 21:
              n.push({
                ref: r,
                data: _t416.join("")
              });
            case 22:
              g.push(FreeTextAnnotation.createNewAnnotation(s, c, n, {
                evaluator: e,
                task: t,
                baseFontRef: r
              }));
              return _context65.abrupt("break", 51);
            case 24:
              c.quadPoints ? g.push(HighlightAnnotation.createNewAnnotation(s, c, n)) : g.push(InkAnnotation.createNewAnnotation(s, c, n));
              return _context65.abrupt("break", 51);
            case 26:
              g.push(InkAnnotation.createNewAnnotation(s, c, n));
              return _context65.abrupt("break", 51);
            case 28:
              if (!o) {
                _context65.next = 34;
                break;
              }
              _context65.next = 31;
              return a === null || a === void 0 ? void 0 : a.get(c.bitmapId);
            case 31:
              _context65.t1 = _context65.sent;
              _context65.next = 35;
              break;
            case 34:
              _context65.t1 = null;
            case 35:
              _i365 = _context65.t1;
              if (!(_i365 !== null && _i365 !== void 0 && _i365.imageStream)) {
                _context65.next = 50;
                break;
              }
              _e560 = _i365.imageStream, _t417 = _i365.smaskStream, _a286 = [];
              if (!_t417) {
                _context65.next = 45;
                break;
              }
              _i366 = s.getNewTemporaryRef();
              _context65.next = 42;
              return writeObject(_i366, _t417, _a286, s);
            case 42:
              n.push({
                ref: _i366,
                data: _a286.join("")
              });
              _e560.dict.set("SMask", _i366);
              _a286.length = 0;
            case 45:
              _r149 = _i365.imageRef = s.getNewTemporaryRef();
              _context65.next = 48;
              return writeObject(_r149, _e560, _a286, s);
            case 48:
              n.push({
                ref: _r149,
                data: _a286.join("")
              });
              _i365.imageStream = _i365.smaskStream = null;
            case 50:
              g.push(StampAnnotation.createNewAnnotation(s, c, n, {
                image: _i365
              }));
            case 51:
              _context65.next = 5;
              break;
            case 53:
              _context65.next = 58;
              break;
            case 55:
              _context65.prev = 55;
              _context65.t2 = _context65["catch"](3);
              _iterator190.e(_context65.t2);
            case 58:
              _context65.prev = 58;
              _iterator190.f();
              return _context65.finish(58);
            case 61:
              _context65.next = 63;
              return Promise.all(g);
            case 63:
              _context65.t3 = _context65.sent;
              _context65.t4 = n;
              return _context65.abrupt("return", {
                annotations: _context65.t3,
                dependencies: _context65.t4
              });
            case 66:
            case "end":
              return _context65.stop();
          }
        }, _callee53, null, [[3, 55, 58, 61]]);
      }));
      function saveNewAnnotations(_x99, _x100, _x101, _x102) {
        return _saveNewAnnotations.apply(this, arguments);
      }
      return saveNewAnnotations;
    }()
  }, {
    key: "printNewAnnotations",
    value: function () {
      var _printNewAnnotations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee54(e, t, i, a, s) {
        var r, n, g, _iterator191, _step191, _o52, _a287, _e561, _t418;
        return _regeneratorRuntime().wrap(function _callee54$(_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              if (a) {
                _context66.next = 2;
                break;
              }
              return _context66.abrupt("return", null);
            case 2:
              r = t.options, n = t.xref, g = [];
              _iterator191 = _createForOfIteratorHelper(a);
              _context66.prev = 4;
              _iterator191.s();
            case 6:
              if ((_step191 = _iterator191.n()).done) {
                _context66.next = 30;
                break;
              }
              _o52 = _step191.value;
              if (_o52.deleted) {
                _context66.next = 28;
                break;
              }
              _context66.t0 = _o52.annotationType;
              _context66.next = _context66.t0 === d ? 12 : _context66.t0 === f ? 14 : _context66.t0 === m ? 16 : _context66.t0 === p ? 18 : 28;
              break;
            case 12:
              g.push(FreeTextAnnotation.createNewPrintAnnotation(e, n, _o52, {
                evaluator: t,
                task: i,
                evaluatorOptions: r
              }));
              return _context66.abrupt("break", 28);
            case 14:
              _o52.quadPoints ? g.push(HighlightAnnotation.createNewPrintAnnotation(e, n, _o52, {
                evaluatorOptions: r
              })) : g.push(InkAnnotation.createNewPrintAnnotation(e, n, _o52, {
                evaluatorOptions: r
              }));
              return _context66.abrupt("break", 28);
            case 16:
              g.push(InkAnnotation.createNewPrintAnnotation(e, n, _o52, {
                evaluatorOptions: r
              }));
              return _context66.abrupt("break", 28);
            case 18:
              if (!r.isOffscreenCanvasSupported) {
                _context66.next = 24;
                break;
              }
              _context66.next = 21;
              return s === null || s === void 0 ? void 0 : s.get(_o52.bitmapId);
            case 21:
              _context66.t1 = _context66.sent;
              _context66.next = 25;
              break;
            case 24:
              _context66.t1 = null;
            case 25:
              _a287 = _context66.t1;
              if (_a287 !== null && _a287 !== void 0 && _a287.imageStream) {
                _e561 = _a287.imageStream, _t418 = _a287.smaskStream;
                _t418 && _e561.dict.set("SMask", _t418);
                _a287.imageRef = new JpegStream(_e561, _e561.length);
                _a287.imageStream = _a287.smaskStream = null;
              }
              g.push(StampAnnotation.createNewPrintAnnotation(e, n, _o52, {
                image: _a287,
                evaluatorOptions: r
              }));
            case 28:
              _context66.next = 6;
              break;
            case 30:
              _context66.next = 35;
              break;
            case 32:
              _context66.prev = 32;
              _context66.t2 = _context66["catch"](4);
              _iterator191.e(_context66.t2);
            case 35:
              _context66.prev = 35;
              _iterator191.f();
              return _context66.finish(35);
            case 38:
              return _context66.abrupt("return", Promise.all(g));
            case 39:
            case "end":
              return _context66.stop();
          }
        }, _callee54, null, [[4, 32, 35, 38]]);
      }));
      function printNewAnnotations(_x103, _x104, _x105, _x106, _x107) {
        return _printNewAnnotations.apply(this, arguments);
      }
      return printNewAnnotations;
    }()
  }]);
}();
function getRgbColor(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Uint8ClampedArray(3);
  if (!Array.isArray(e)) return t;
  var i = t || new Uint8ClampedArray(3);
  switch (e.length) {
    case 0:
      return null;
    case 1:
      ColorSpace.singletons.gray.getRgbItem(e, 0, i, 0);
      return i;
    case 3:
      ColorSpace.singletons.rgb.getRgbItem(e, 0, i, 0);
      return i;
    case 4:
      ColorSpace.singletons.cmyk.getRgbItem(e, 0, i, 0);
      return i;
    default:
      return t;
  }
}
function getPdfColorArray(e) {
  return Array.from(e, function (e) {
    return e / 255;
  });
}
function getQuadPoints(e, t) {
  var i = e.getArray("QuadPoints");
  if (!isNumberArray(i, null) || 0 === i.length || i.length % 8 > 0) return null;
  var a = new Float32Array(i.length);
  for (var _e562 = 0, _s191 = i.length; _e562 < _s191; _e562 += 8) {
    var _i$slice = i.slice(_e562, _e562 + 8),
      _i$slice2 = _slicedToArray(_i$slice, 8),
      _s192 = _i$slice2[0],
      r = _i$slice2[1],
      _n104 = _i$slice2[2],
      _g72 = _i$slice2[3],
      _o53 = _i$slice2[4],
      c = _i$slice2[5],
      C = _i$slice2[6],
      h = _i$slice2[7],
      l = Math.min(_s192, _n104, _o53, C),
      Q = Math.max(_s192, _n104, _o53, C),
      E = Math.min(r, _g72, c, h),
      u = Math.max(r, _g72, c, h);
    if (null !== t && (l < t[0] || Q > t[2] || E < t[1] || u > t[3])) return null;
    a.set([l, u, Q, u, l, E, Q, E], _e562);
  }
  return a;
}
function getTransformMatrix(e, t, i) {
  var _Util$getAxialAligned = Util.getAxialAlignedBoundingBox(t, i),
    _Util$getAxialAligned2 = _slicedToArray(_Util$getAxialAligned, 4),
    a = _Util$getAxialAligned2[0],
    s = _Util$getAxialAligned2[1],
    r = _Util$getAxialAligned2[2],
    n = _Util$getAxialAligned2[3];
  if (a === r || s === n) return [1, 0, 0, 1, e[0], e[1]];
  var g = (e[2] - e[0]) / (r - a),
    o = (e[3] - e[1]) / (n - s);
  return [g, 0, 0, o, e[0] - a * g, e[1] - s * o];
}
var Annotation = /*#__PURE__*/function () {
  function Annotation(e) {
    _classCallCheck(this, Annotation);
    var t = e.dict,
      i = e.xref,
      a = e.annotationGlobals,
      s = e.ref,
      r = e.orphanFields,
      n = r === null || r === void 0 ? void 0 : r.get(s);
    n && t.set("Parent", n);
    this.setTitle(t.get("T"));
    this.setContents(t.get("Contents"));
    this.setModificationDate(t.get("M"));
    this.setFlags(t.get("F"));
    this.setRectangle(t.getArray("Rect"));
    this.setColor(t.getArray("C"));
    this.setBorderStyle(t);
    this.setAppearance(t);
    this.setOptionalContent(t);
    var g = t.get("MK");
    this.setBorderAndBackgroundColors(g);
    this.setRotation(g, t);
    this.ref = e.ref instanceof Ref ? e.ref : null;
    this._streams = [];
    this.appearance && this._streams.push(this.appearance);
    var o = !!(this.flags & eA),
      c = !!(this.flags & tA);
    this.data = {
      annotationFlags: this.flags,
      borderStyle: this.borderStyle,
      color: this.color,
      backgroundColor: this.backgroundColor,
      borderColor: this.borderColor,
      rotation: this.rotation,
      contentsObj: this._contents,
      hasAppearance: !!this.appearance,
      id: e.id,
      modificationDate: this.modificationDate,
      rect: this.rectangle,
      subtype: e.subtype,
      hasOwnCanvas: !1,
      noRotate: !!(this.flags & $),
      noHTML: o && c,
      isEditable: !1,
      structParent: -1
    };
    if (a.structTreeRoot) {
      var _i367 = t.get("StructParent");
      this.data.structParent = _i367 = Number.isInteger(_i367) && _i367 >= 0 ? _i367 : -1;
      a.structTreeRoot.addAnnotationIdToPage(e.pageRef, _i367);
    }
    if (e.collectFields) {
      var _a288 = t.get("Kids");
      if (Array.isArray(_a288)) {
        var _e563 = [];
        var _iterator192 = _createForOfIteratorHelper(_a288),
          _step192;
        try {
          for (_iterator192.s(); !(_step192 = _iterator192.n()).done;) {
            var _t419 = _step192.value;
            _t419 instanceof Ref && _e563.push(_t419.toString());
          }
        } catch (err) {
          _iterator192.e(err);
        } finally {
          _iterator192.f();
        }
        0 !== _e563.length && (this.data.kidIds = _e563);
      }
      this.data.actions = collectActions(i, t, dA);
      this.data.fieldName = this._constructFieldName(t);
      this.data.pageIndex = e.pageIndex;
    }
    var C = t.get("IT");
    C instanceof Name && (this.data.it = C.name);
    this._isOffscreenCanvasSupported = e.evaluatorOptions.isOffscreenCanvasSupported;
    this._fallbackFontDict = null;
    this._needAppearances = !1;
  }
  return _createClass(Annotation, [{
    key: "_hasFlag",
    value: function _hasFlag(e, t) {
      return !!(e & t);
    }
  }, {
    key: "_buildFlags",
    value: function _buildFlags(e, t) {
      var i = this.flags;
      if (void 0 === e) {
        if (void 0 === t) return;
        return t ? i & ~_ : i & ~z | _;
      }
      if (e) {
        i |= _;
        return t ? i & ~AA | z : i & ~z | AA;
      }
      i &= ~(z | AA);
      return t ? i & ~_ : i | _;
    }
  }, {
    key: "_isViewable",
    value: function _isViewable(e) {
      return !this._hasFlag(e, V) && !this._hasFlag(e, AA);
    }
  }, {
    key: "_isPrintable",
    value: function _isPrintable(e) {
      return this._hasFlag(e, _) && !this._hasFlag(e, z) && !this._hasFlag(e, V);
    }
  }, {
    key: "mustBeViewed",
    value: function mustBeViewed(e, t) {
      var _e$get;
      var i = e === null || e === void 0 || (_e$get = e.get(this.data.id)) === null || _e$get === void 0 ? void 0 : _e$get.noView;
      return void 0 !== i ? !i : this.viewable && !this._hasFlag(this.flags, z);
    }
  }, {
    key: "mustBePrinted",
    value: function mustBePrinted(e) {
      var _e$get2;
      var t = e === null || e === void 0 || (_e$get2 = e.get(this.data.id)) === null || _e$get2 === void 0 ? void 0 : _e$get2.noPrint;
      return void 0 !== t ? !t : this.printable;
    }
  }, {
    key: "mustBeViewedWhenEditing",
    value: function mustBeViewedWhenEditing(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return e ? !this.data.isEditable : !(t !== null && t !== void 0 && t.has(this.data.id));
    }
  }, {
    key: "viewable",
    get: function get() {
      return null !== this.data.quadPoints && (0 === this.flags || this._isViewable(this.flags));
    }
  }, {
    key: "printable",
    get: function get() {
      return null !== this.data.quadPoints && 0 !== this.flags && this._isPrintable(this.flags);
    }
  }, {
    key: "_parseStringHelper",
    value: function _parseStringHelper(e) {
      var t = "string" == typeof e ? stringToPDFString(e) : "";
      return {
        str: t,
        dir: t && "rtl" === bidi(t).dir ? "rtl" : "ltr"
      };
    }
  }, {
    key: "setDefaultAppearance",
    value: function setDefaultAppearance(e) {
      var t = e.dict,
        i = e.annotationGlobals,
        a = getInheritableProperty({
          dict: t,
          key: "DA"
        }) || i.acroForm.get("DA");
      this._defaultAppearance = "string" == typeof a ? a : "";
      this.data.defaultAppearanceData = parseDefaultAppearance(this._defaultAppearance);
    }
  }, {
    key: "setTitle",
    value: function setTitle(e) {
      this._title = this._parseStringHelper(e);
    }
  }, {
    key: "setContents",
    value: function setContents(e) {
      this._contents = this._parseStringHelper(e);
    }
  }, {
    key: "setModificationDate",
    value: function setModificationDate(e) {
      this.modificationDate = "string" == typeof e ? e : null;
    }
  }, {
    key: "setFlags",
    value: function setFlags(e) {
      this.flags = Number.isInteger(e) && e > 0 ? e : 0;
      this.flags & V && "Annotation" !== this.constructor.name && (this.flags ^= V);
    }
  }, {
    key: "hasFlag",
    value: function hasFlag(e) {
      return this._hasFlag(this.flags, e);
    }
  }, {
    key: "setRectangle",
    value: function setRectangle(e) {
      this.rectangle = lookupNormalRect(e, [0, 0, 0, 0]);
    }
  }, {
    key: "setColor",
    value: function setColor(e) {
      this.color = getRgbColor(e);
    }
  }, {
    key: "setLineEndings",
    value: function setLineEndings(e) {
      this.lineEndings = ["None", "None"];
      if (Array.isArray(e) && 2 === e.length) for (var _t420 = 0; _t420 < 2; _t420++) {
        var _i368 = e[_t420];
        if (_i368 instanceof Name) switch (_i368.name) {
          case "None":
            continue;
          case "Square":
          case "Circle":
          case "Diamond":
          case "OpenArrow":
          case "ClosedArrow":
          case "Butt":
          case "ROpenArrow":
          case "RClosedArrow":
          case "Slash":
            this.lineEndings[_t420] = _i368.name;
            continue;
        }
        warn("Ignoring invalid lineEnding: ".concat(_i368));
      }
    }
  }, {
    key: "setRotation",
    value: function setRotation(e, t) {
      this.rotation = 0;
      var i = e instanceof Dict ? e.get("R") || 0 : t.get("Rotate") || 0;
      if (Number.isInteger(i) && 0 !== i) {
        i %= 360;
        i < 0 && (i += 360);
        i % 90 == 0 && (this.rotation = i);
      }
    }
  }, {
    key: "setBorderAndBackgroundColors",
    value: function setBorderAndBackgroundColors(e) {
      if (e instanceof Dict) {
        this.borderColor = getRgbColor(e.getArray("BC"), null);
        this.backgroundColor = getRgbColor(e.getArray("BG"), null);
      } else this.borderColor = this.backgroundColor = null;
    }
  }, {
    key: "setBorderStyle",
    value: function setBorderStyle(e) {
      this.borderStyle = new AnnotationBorderStyle();
      if (e instanceof Dict) if (e.has("BS")) {
        var _t421 = e.get("BS");
        if (_t421 instanceof Dict) {
          var _e564 = _t421.get("Type");
          if (!_e564 || isName(_e564, "Border")) {
            this.borderStyle.setWidth(_t421.get("W"), this.rectangle);
            this.borderStyle.setStyle(_t421.get("S"));
            this.borderStyle.setDashArray(_t421.getArray("D"));
          }
        }
      } else if (e.has("Border")) {
        var _t422 = e.getArray("Border");
        if (Array.isArray(_t422) && _t422.length >= 3) {
          this.borderStyle.setHorizontalCornerRadius(_t422[0]);
          this.borderStyle.setVerticalCornerRadius(_t422[1]);
          this.borderStyle.setWidth(_t422[2], this.rectangle);
          4 === _t422.length && this.borderStyle.setDashArray(_t422[3], !0);
        }
      } else this.borderStyle.setWidth(0);
    }
  }, {
    key: "setAppearance",
    value: function setAppearance(e) {
      this.appearance = null;
      var t = e.get("AP");
      if (!(t instanceof Dict)) return;
      var i = t.get("N");
      if (i instanceof BaseStream) {
        this.appearance = i;
        return;
      }
      if (!(i instanceof Dict)) return;
      var a = e.get("AS");
      if (!(a instanceof Name && i.has(a.name))) return;
      var s = i.get(a.name);
      s instanceof BaseStream && (this.appearance = s);
    }
  }, {
    key: "setOptionalContent",
    value: function setOptionalContent(e) {
      this.oc = null;
      var t = e.get("OC");
      t instanceof Name ? warn("setOptionalContent: Support for /Name-entry is not implemented.") : t instanceof Dict && (this.oc = t);
    }
  }, {
    key: "loadResources",
    value: function loadResources(e, t) {
      return t.dict.getAsync("Resources").then(function (t) {
        if (!t) return;
        return new ObjectLoader(t, e, t.xref).load().then(function () {
          return t;
        });
      });
    }
  }, {
    key: "getOperatorList",
    value: function () {
      var _getOperatorList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee55(e, t, a, s) {
        var _this$data2, r, n, g, c, C, h, l, Q, E, u, d, f;
        return _regeneratorRuntime().wrap(function _callee55$(_context67) {
          while (1) switch (_context67.prev = _context67.next) {
            case 0:
              _this$data2 = this.data, r = _this$data2.hasOwnCanvas, n = _this$data2.id, g = _this$data2.rect;
              c = this.appearance;
              C = !!(r && a & o);
              if (!(C && (g[0] === g[2] || g[1] === g[3]))) {
                _context67.next = 6;
                break;
              }
              this.data.hasOwnCanvas = !1;
              return _context67.abrupt("return", {
                opList: new OperatorList(),
                separateForm: !1,
                separateCanvas: !1
              });
            case 6:
              if (c) {
                _context67.next = 11;
                break;
              }
              if (C) {
                _context67.next = 9;
                break;
              }
              return _context67.abrupt("return", {
                opList: new OperatorList(),
                separateForm: !1,
                separateCanvas: !1
              });
            case 9:
              c = new StringStream("");
              c.dict = new Dict();
            case 11:
              h = c.dict;
              _context67.next = 14;
              return this.loadResources(["ExtGState", "ColorSpace", "Pattern", "Shading", "XObject", "Font"], c);
            case 14:
              l = _context67.sent;
              Q = lookupRect(h.getArray("BBox"), [0, 0, 1, 1]);
              E = lookupMatrix(h.getArray("Matrix"), i);
              u = getTransformMatrix(g, Q, E);
              d = new OperatorList();
              _context67.t0 = this.oc;
              if (!_context67.t0) {
                _context67.next = 24;
                break;
              }
              _context67.next = 23;
              return e.parseMarkedContentProps(this.oc, null);
            case 23:
              f = _context67.sent;
            case 24:
              void 0 !== f && d.addOp(Je, ["OC", f]);
              d.addOp(We, [n, g, u, E, C]);
              _context67.next = 28;
              return e.getOperatorList({
                stream: c,
                task: t,
                resources: l,
                operatorList: d,
                fallbackFontDict: this._fallbackFontDict
              });
            case 28:
              d.addOp(je, []);
              void 0 !== f && d.addOp(Ye, []);
              this.reset();
              return _context67.abrupt("return", {
                opList: d,
                separateForm: !1,
                separateCanvas: C
              });
            case 32:
            case "end":
              return _context67.stop();
          }
        }, _callee55, this);
      }));
      function getOperatorList(_x108, _x109, _x110, _x111) {
        return _getOperatorList.apply(this, arguments);
      }
      return getOperatorList;
    }()
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee56(e, t, i) {
        return _regeneratorRuntime().wrap(function _callee56$(_context68) {
          while (1) switch (_context68.prev = _context68.next) {
            case 0:
              return _context68.abrupt("return", null);
            case 1:
            case "end":
              return _context68.stop();
          }
        }, _callee56);
      }));
      function save(_x112, _x113, _x114) {
        return _save.apply(this, arguments);
      }
      return save;
    }()
  }, {
    key: "hasTextContent",
    get: function get() {
      return !1;
    }
  }, {
    key: "extractTextContent",
    value: function () {
      var _extractTextContent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee57(e, t, i) {
        var a, s, r, n, g, _e565, _t424, _i369;
        return _regeneratorRuntime().wrap(function _callee57$(_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              if (this.appearance) {
                _context69.next = 2;
                break;
              }
              return _context69.abrupt("return");
            case 2:
              _context69.next = 4;
              return this.loadResources(["ExtGState", "Font", "Properties", "XObject"], this.appearance);
            case 4:
              a = _context69.sent;
              s = [];
              r = [];
              n = null;
              g = {
                desiredSize: Math.Infinity,
                ready: !0,
                enqueue: function enqueue(e, t) {
                  var _iterator193 = _createForOfIteratorHelper(e.items),
                    _step193;
                  try {
                    for (_iterator193.s(); !(_step193 = _iterator193.n()).done;) {
                      var _t423 = _step193.value;
                      if (void 0 !== _t423.str) {
                        n || (n = _t423.transform.slice(-2));
                        r.push(_t423.str);
                        if (_t423.hasEOL) {
                          s.push(r.join("").trimEnd());
                          r.length = 0;
                        }
                      }
                    }
                  } catch (err) {
                    _iterator193.e(err);
                  } finally {
                    _iterator193.f();
                  }
                }
              };
              _context69.next = 11;
              return e.getTextContent({
                stream: this.appearance,
                task: t,
                resources: a,
                includeMarkedContent: !0,
                keepWhiteSpace: !0,
                sink: g,
                viewBox: i
              });
            case 11:
              this.reset();
              r.length && s.push(r.join("").trimEnd());
              if (s.length > 1 || s[0]) {
                _e565 = this.appearance.dict, _t424 = lookupRect(_e565.getArray("BBox"), null), _i369 = lookupMatrix(_e565.getArray("Matrix"), null);
                this.data.textPosition = this._transformPoint(n, _t424, _i369);
                this.data.textContent = s;
              }
            case 14:
            case "end":
              return _context69.stop();
          }
        }, _callee57, this);
      }));
      function extractTextContent(_x115, _x116, _x117) {
        return _extractTextContent.apply(this, arguments);
      }
      return extractTextContent;
    }()
  }, {
    key: "_transformPoint",
    value: function _transformPoint(e, t, i) {
      var a = this.data.rect;
      t || (t = [0, 0, 1, 1]);
      i || (i = [1, 0, 0, 1, 0, 0]);
      var s = getTransformMatrix(a, t, i);
      s[4] -= a[0];
      s[5] -= a[1];
      e = Util.applyTransform(e, s);
      return Util.applyTransform(e, i);
    }
  }, {
    key: "getFieldObject",
    value: function getFieldObject() {
      return this.data.kidIds ? {
        id: this.data.id,
        actions: this.data.actions,
        name: this.data.fieldName,
        strokeColor: this.data.borderColor,
        fillColor: this.data.backgroundColor,
        type: "",
        kidIds: this.data.kidIds,
        page: this.data.pageIndex,
        rotation: this.rotation
      } : null;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _iterator194 = _createForOfIteratorHelper(this._streams),
        _step194;
      try {
        for (_iterator194.s(); !(_step194 = _iterator194.n()).done;) {
          var _e566 = _step194.value;
          _e566.reset();
        }
      } catch (err) {
        _iterator194.e(err);
      } finally {
        _iterator194.f();
      }
    }
  }, {
    key: "_constructFieldName",
    value: function _constructFieldName(e) {
      if (!e.has("T") && !e.has("Parent")) {
        warn("Unknown field name, falling back to empty field name.");
        return "";
      }
      if (!e.has("Parent")) return stringToPDFString(e.get("T"));
      var t = [];
      e.has("T") && t.unshift(stringToPDFString(e.get("T")));
      var i = e;
      var a = new RefSet();
      e.objId && a.put(e.objId);
      for (; i.has("Parent");) {
        i = i.get("Parent");
        if (!(i instanceof Dict) || i.objId && a.has(i.objId)) break;
        i.objId && a.put(i.objId);
        i.has("T") && t.unshift(stringToPDFString(i.get("T")));
      }
      return t.join(".");
    }
  }]);
}();
var AnnotationBorderStyle = /*#__PURE__*/function () {
  function AnnotationBorderStyle() {
    _classCallCheck(this, AnnotationBorderStyle);
    this.width = 1;
    this.rawWidth = 1;
    this.style = lA;
    this.dashArray = [3];
    this.horizontalCornerRadius = 0;
    this.verticalCornerRadius = 0;
  }
  return _createClass(AnnotationBorderStyle, [{
    key: "setWidth",
    value: function setWidth(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0, 0, 0, 0];
      if (e instanceof Name) this.width = 0;else if ("number" == typeof e) {
        if (e > 0) {
          this.rawWidth = e;
          var _i370 = (t[2] - t[0]) / 2,
            _a289 = (t[3] - t[1]) / 2;
          if (_i370 > 0 && _a289 > 0 && (e > _i370 || e > _a289)) {
            warn("AnnotationBorderStyle.setWidth - ignoring width: ".concat(e));
            e = 1;
          }
        }
        this.width = e;
      }
    }
  }, {
    key: "setStyle",
    value: function setStyle(e) {
      if (e instanceof Name) switch (e.name) {
        case "S":
          this.style = lA;
          break;
        case "D":
          this.style = BA;
          break;
        case "B":
          this.style = QA;
          break;
        case "I":
          this.style = EA;
          break;
        case "U":
          this.style = uA;
      }
    }
  }, {
    key: "setDashArray",
    value: function setDashArray(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      if (Array.isArray(e)) {
        var _i371 = !0,
          _a290 = !0;
        var _iterator195 = _createForOfIteratorHelper(e),
          _step195;
        try {
          for (_iterator195.s(); !(_step195 = _iterator195.n()).done;) {
            var _t425 = _step195.value;
            if (!(+_t425 >= 0)) {
              _i371 = !1;
              break;
            }
            _t425 > 0 && (_a290 = !1);
          }
        } catch (err) {
          _iterator195.e(err);
        } finally {
          _iterator195.f();
        }
        if (0 === e.length || _i371 && !_a290) {
          this.dashArray = e;
          t && this.setStyle(Name.get("D"));
        } else this.width = 0;
      } else e && (this.width = 0);
    }
  }, {
    key: "setHorizontalCornerRadius",
    value: function setHorizontalCornerRadius(e) {
      Number.isInteger(e) && (this.horizontalCornerRadius = e);
    }
  }, {
    key: "setVerticalCornerRadius",
    value: function setVerticalCornerRadius(e) {
      Number.isInteger(e) && (this.verticalCornerRadius = e);
    }
  }]);
}();
var MarkupAnnotation = /*#__PURE__*/function (_Annotation) {
  function MarkupAnnotation(e) {
    var _this269;
    _classCallCheck(this, MarkupAnnotation);
    _this269 = _callSuper(this, MarkupAnnotation, [e]);
    var t = e.dict;
    if (t.has("IRT")) {
      var _e567 = t.getRaw("IRT");
      _this269.data.inReplyTo = _e567 instanceof Ref ? _e567.toString() : null;
      var _i372 = t.get("RT");
      _this269.data.replyType = _i372 instanceof Name ? _i372.name : Z;
    }
    var i = null;
    if (_this269.data.replyType === X) {
      var _e568 = t.get("IRT");
      _this269.setTitle(_e568.get("T"));
      _this269.data.titleObj = _this269._title;
      _this269.setContents(_e568.get("Contents"));
      _this269.data.contentsObj = _this269._contents;
      if (_e568.has("CreationDate")) {
        _this269.setCreationDate(_e568.get("CreationDate"));
        _this269.data.creationDate = _this269.creationDate;
      } else _this269.data.creationDate = null;
      if (_e568.has("M")) {
        _this269.setModificationDate(_e568.get("M"));
        _this269.data.modificationDate = _this269.modificationDate;
      } else _this269.data.modificationDate = null;
      i = _e568.getRaw("Popup");
      if (_e568.has("C")) {
        _this269.setColor(_e568.getArray("C"));
        _this269.data.color = _this269.color;
      } else _this269.data.color = null;
    } else {
      _this269.data.titleObj = _this269._title;
      _this269.setCreationDate(t.get("CreationDate"));
      _this269.data.creationDate = _this269.creationDate;
      i = t.getRaw("Popup");
      t.has("C") || (_this269.data.color = null);
    }
    _this269.data.popupRef = i instanceof Ref ? i.toString() : null;
    t.has("RC") && (_this269.data.richText = XFAFactory.getRichTextAsHtml(t.get("RC")));
    return _this269;
  }
  _inherits(MarkupAnnotation, _Annotation);
  return _createClass(MarkupAnnotation, [{
    key: "setCreationDate",
    value: function setCreationDate(e) {
      this.creationDate = "string" == typeof e ? e : null;
    }
  }, {
    key: "_setDefaultAppearance",
    value: function _setDefaultAppearance(_ref176) {
      var e = _ref176.xref,
        t = _ref176.extra,
        i = _ref176.strokeColor,
        a = _ref176.fillColor,
        s = _ref176.blendMode,
        r = _ref176.strokeAlpha,
        n = _ref176.fillAlpha,
        g = _ref176.pointsCallback;
      var o = Number.MAX_VALUE,
        c = Number.MAX_VALUE,
        C = Number.MIN_VALUE,
        h = Number.MIN_VALUE;
      var l = ["q"];
      t && l.push(t);
      i && l.push("".concat(i[0], " ").concat(i[1], " ").concat(i[2], " RG"));
      a && l.push("".concat(a[0], " ").concat(a[1], " ").concat(a[2], " rg"));
      var Q = this.data.quadPoints;
      Q || (Q = Float32Array.from([this.rectangle[0], this.rectangle[3], this.rectangle[2], this.rectangle[3], this.rectangle[0], this.rectangle[1], this.rectangle[2], this.rectangle[1]]));
      for (var _e569 = 0, _t426 = Q.length; _e569 < _t426; _e569 += 8) {
        var _g73 = g(l, Q.subarray(_e569, _e569 + 8)),
          _g74 = _slicedToArray(_g73, 4),
          _t427 = _g74[0],
          _i373 = _g74[1],
          _a291 = _g74[2],
          _s193 = _g74[3];
        o = Math.min(o, _t427);
        C = Math.max(C, _i373);
        c = Math.min(c, _a291);
        h = Math.max(h, _s193);
      }
      l.push("Q");
      var E = new Dict(e),
        u = new Dict(e);
      u.set("Subtype", Name.get("Form"));
      var d = new StringStream(l.join(" "));
      d.dict = u;
      E.set("Fm0", d);
      var f = new Dict(e);
      s && f.set("BM", Name.get(s));
      "number" == typeof r && f.set("CA", r);
      "number" == typeof n && f.set("ca", n);
      var p = new Dict(e);
      p.set("GS0", f);
      var m = new Dict(e);
      m.set("ExtGState", p);
      m.set("XObject", E);
      var y = new Dict(e);
      y.set("Resources", m);
      var w = this.data.rect = [o, c, C, h];
      y.set("BBox", w);
      this.appearance = new StringStream("/GS0 gs /Fm0 Do");
      this.appearance.dict = y;
      this._streams.push(this.appearance, d);
    }
  }], [{
    key: "createNewAnnotation",
    value: function () {
      var _createNewAnnotation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee58(e, t, i, a) {
        var s, r, n, g, _a292;
        return _regeneratorRuntime().wrap(function _callee58$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              t.ref || (t.ref = e.getNewTemporaryRef());
              s = t.ref;
              _context70.next = 4;
              return this.createNewAppearanceStream(t, e, a);
            case 4:
              r = _context70.sent;
              n = [];
              if (!r) {
                _context70.next = 14;
                break;
              }
              _a292 = e.getNewTemporaryRef();
              g = this.createNewDict(t, e, {
                apRef: _a292
              });
              _context70.next = 11;
              return writeObject(_a292, r, n, e);
            case 11:
              i.push({
                ref: _a292,
                data: n.join("")
              });
              _context70.next = 15;
              break;
            case 14:
              g = this.createNewDict(t, e, {});
            case 15:
              Number.isInteger(t.parentTreeId) && g.set("StructParent", t.parentTreeId);
              n.length = 0;
              _context70.next = 19;
              return writeObject(s, g, n, e);
            case 19:
              return _context70.abrupt("return", {
                ref: s,
                data: n.join("")
              });
            case 20:
            case "end":
              return _context70.stop();
          }
        }, _callee58, this);
      }));
      function createNewAnnotation(_x118, _x119, _x120, _x121) {
        return _createNewAnnotation.apply(this, arguments);
      }
      return createNewAnnotation;
    }()
  }, {
    key: "createNewPrintAnnotation",
    value: function () {
      var _createNewPrintAnnotation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee59(e, t, i, a) {
        var s, r, n;
        return _regeneratorRuntime().wrap(function _callee59$(_context71) {
          while (1) switch (_context71.prev = _context71.next) {
            case 0:
              _context71.next = 2;
              return this.createNewAppearanceStream(i, t, a);
            case 2:
              s = _context71.sent;
              r = this.createNewDict(i, t, s ? {
                ap: s
              } : {});
              n = new this.prototype.constructor({
                dict: r,
                xref: t,
                annotationGlobals: e,
                evaluatorOptions: a.evaluatorOptions
              });
              i.ref && (n.ref = n.refToReplace = i.ref);
              return _context71.abrupt("return", n);
            case 7:
            case "end":
              return _context71.stop();
          }
        }, _callee59, this);
      }));
      function createNewPrintAnnotation(_x122, _x123, _x124, _x125) {
        return _createNewPrintAnnotation.apply(this, arguments);
      }
      return createNewPrintAnnotation;
    }()
  }]);
}(Annotation);
var WidgetAnnotation = /*#__PURE__*/function (_Annotation2) {
  function WidgetAnnotation(e) {
    var _this270$appearance;
    var _this270;
    _classCallCheck(this, WidgetAnnotation);
    _this270 = _callSuper(this, WidgetAnnotation, [e]);
    var t = e.dict,
      i = e.xref,
      a = e.annotationGlobals,
      s = _this270.data;
    _this270._needAppearances = e.needAppearances;
    s.annotationType = j;
    void 0 === s.fieldName && (s.fieldName = _this270._constructFieldName(t));
    void 0 === s.actions && (s.actions = collectActions(i, t, dA));
    var r = getInheritableProperty({
      dict: t,
      key: "V",
      getArray: !0
    });
    s.fieldValue = _this270._decodeFormValue(r);
    var n = getInheritableProperty({
      dict: t,
      key: "DV",
      getArray: !0
    });
    s.defaultFieldValue = _this270._decodeFormValue(n);
    if (void 0 === r && a.xfaDatasets) {
      var _e570 = _this270._title.str;
      if (_e570) {
        _this270._hasValueFromXFA = !0;
        s.fieldValue = r = a.xfaDatasets.getValue(_e570);
      }
    }
    void 0 === r && null !== s.defaultFieldValue && (s.fieldValue = s.defaultFieldValue);
    s.alternativeText = stringToPDFString(t.get("TU") || "");
    _this270.setDefaultAppearance(e);
    s.hasAppearance || (s.hasAppearance = _this270._needAppearances && void 0 !== s.fieldValue && null !== s.fieldValue);
    var g = getInheritableProperty({
      dict: t,
      key: "FT"
    });
    s.fieldType = g instanceof Name ? g.name : null;
    var o = getInheritableProperty({
        dict: t,
        key: "DR"
      }),
      c = a.acroForm.get("DR"),
      C = (_this270$appearance = _this270.appearance) === null || _this270$appearance === void 0 ? void 0 : _this270$appearance.dict.get("Resources");
    _this270._fieldResources = {
      localResources: o,
      acroFormResources: c,
      appearanceResources: C,
      mergedResources: Dict.merge({
        xref: i,
        dictArray: [o, C, c],
        mergeSubDicts: !0
      })
    };
    s.fieldFlags = getInheritableProperty({
      dict: t,
      key: "Ff"
    });
    (!Number.isInteger(s.fieldFlags) || s.fieldFlags < 0) && (s.fieldFlags = 0);
    s.readOnly = _this270.hasFieldFlag(iA);
    s.required = _this270.hasFieldFlag(aA);
    s.hidden = _this270._hasFlag(s.annotationFlags, z) || _this270._hasFlag(s.annotationFlags, AA);
    return _this270;
  }
  _inherits(WidgetAnnotation, _Annotation2);
  return _createClass(WidgetAnnotation, [{
    key: "_decodeFormValue",
    value: function _decodeFormValue(e) {
      return Array.isArray(e) ? e.filter(function (e) {
        return "string" == typeof e;
      }).map(function (e) {
        return stringToPDFString(e);
      }) : e instanceof Name ? stringToPDFString(e.name) : "string" == typeof e ? stringToPDFString(e) : null;
    }
  }, {
    key: "hasFieldFlag",
    value: function hasFieldFlag(e) {
      return !!(this.data.fieldFlags & e);
    }
  }, {
    key: "_isViewable",
    value: function _isViewable(e) {
      return !0;
    }
  }, {
    key: "mustBeViewed",
    value: function mustBeViewed(e, t) {
      return t ? this.viewable : _superPropGet(WidgetAnnotation, "mustBeViewed", this, 3)([e, t]) && !this._hasFlag(this.flags, AA);
    }
  }, {
    key: "getRotationMatrix",
    value: function getRotationMatrix(e) {
      var _e$get3;
      var t = e === null || e === void 0 || (_e$get3 = e.get(this.data.id)) === null || _e$get3 === void 0 ? void 0 : _e$get3.rotation;
      void 0 === t && (t = this.rotation);
      if (0 === t) return i;
      return _getRotationMatrix(t, this.data.rect[2] - this.data.rect[0], this.data.rect[3] - this.data.rect[1]);
    }
  }, {
    key: "getBorderAndBackgroundAppearances",
    value: function getBorderAndBackgroundAppearances(e) {
      var _e$get4;
      var t = e === null || e === void 0 || (_e$get4 = e.get(this.data.id)) === null || _e$get4 === void 0 ? void 0 : _e$get4.rotation;
      void 0 === t && (t = this.rotation);
      if (!this.backgroundColor && !this.borderColor) return "";
      var i = this.data.rect[2] - this.data.rect[0],
        a = this.data.rect[3] - this.data.rect[1],
        s = 0 === t || 180 === t ? "0 0 ".concat(i, " ").concat(a, " re") : "0 0 ".concat(a, " ").concat(i, " re");
      var r = "";
      this.backgroundColor && (r = "".concat(getPdfColor(this.backgroundColor, !0), " ").concat(s, " f "));
      if (this.borderColor) {
        r += "".concat(this.borderStyle.width || 1, " w ").concat(getPdfColor(this.borderColor, !1), " ").concat(s, " S ");
      }
      return r;
    }
  }, {
    key: "getOperatorList",
    value: function () {
      var _getOperatorList2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee60(e, t, i, a) {
        var s, r, n, g, c, C, l;
        return _regeneratorRuntime().wrap(function _callee60$(_context72) {
          while (1) switch (_context72.prev = _context72.next) {
            case 0:
              if (!(i & h && !(this instanceof SignatureWidgetAnnotation) && !this.data.noHTML && !this.data.hasOwnCanvas)) {
                _context72.next = 2;
                break;
              }
              return _context72.abrupt("return", {
                opList: new OperatorList(),
                separateForm: !0,
                separateCanvas: !1
              });
            case 2:
              if (this._hasText) {
                _context72.next = 4;
                break;
              }
              return _context72.abrupt("return", _superPropGet(WidgetAnnotation, "getOperatorList", this, 3)([e, t, i, a]));
            case 4:
              _context72.next = 6;
              return this._getAppearance(e, t, i, a);
            case 6:
              s = _context72.sent;
              if (!(this.appearance && null === s)) {
                _context72.next = 9;
                break;
              }
              return _context72.abrupt("return", _superPropGet(WidgetAnnotation, "getOperatorList", this, 3)([e, t, i, a]));
            case 9:
              r = new OperatorList();
              if (!(!this._defaultAppearance || null === s)) {
                _context72.next = 12;
                break;
              }
              return _context72.abrupt("return", {
                opList: r,
                separateForm: !1,
                separateCanvas: !1
              });
            case 12:
              n = !!(this.data.hasOwnCanvas && i & o), g = [0, 0, this.data.rect[2] - this.data.rect[0], this.data.rect[3] - this.data.rect[1]], c = getTransformMatrix(this.data.rect, g, [1, 0, 0, 1, 0, 0]);
              _context72.t0 = this.oc;
              if (!_context72.t0) {
                _context72.next = 18;
                break;
              }
              _context72.next = 17;
              return e.parseMarkedContentProps(this.oc, null);
            case 17:
              C = _context72.sent;
            case 18:
              void 0 !== C && r.addOp(Je, ["OC", C]);
              r.addOp(We, [this.data.id, this.data.rect, c, this.getRotationMatrix(a), n]);
              l = new StringStream(s);
              _context72.next = 23;
              return e.getOperatorList({
                stream: l,
                task: t,
                resources: this._fieldResources.mergedResources,
                operatorList: r
              });
            case 23:
              r.addOp(je, []);
              void 0 !== C && r.addOp(Ye, []);
              return _context72.abrupt("return", {
                opList: r,
                separateForm: !1,
                separateCanvas: n
              });
            case 26:
            case "end":
              return _context72.stop();
          }
        }, _callee60, this);
      }));
      function getOperatorList(_x126, _x127, _x128, _x129) {
        return _getOperatorList2.apply(this, arguments);
      }
      return getOperatorList;
    }()
  }, {
    key: "_getMKDict",
    value: function _getMKDict(e) {
      var t = new Dict(null);
      e && t.set("R", e);
      this.borderColor && t.set("BC", getPdfColorArray(this.borderColor));
      this.backgroundColor && t.set("BG", getPdfColorArray(this.backgroundColor));
      return t.size > 0 ? t : null;
    }
  }, {
    key: "amendSavedDict",
    value: function amendSavedDict(e, t) {}
  }, {
    key: "save",
    value: function () {
      var _save2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee61(e, t, a) {
        var _o54;
        var s, r, n, g, o, c, h, l, Q, _iterator196, _step196, _e573, _e571, E, u, d, f, _e572, _t428, _s194, _r150, _n105, _g75;
        return _regeneratorRuntime().wrap(function _callee61$(_context73) {
          while (1) switch (_context73.prev = _context73.next) {
            case 0:
              s = a === null || a === void 0 ? void 0 : a.get(this.data.id), r = this._buildFlags(s === null || s === void 0 ? void 0 : s.noView, s === null || s === void 0 ? void 0 : s.noPrint);
              n = s === null || s === void 0 ? void 0 : s.value, g = s === null || s === void 0 ? void 0 : s.rotation;
              if (!(n === this.data.fieldValue || void 0 === n)) {
                _context73.next = 6;
                break;
              }
              if (!(!this._hasValueFromXFA && void 0 === g && void 0 === r)) {
                _context73.next = 5;
                break;
              }
              return _context73.abrupt("return", null);
            case 5:
              n || (n = this.data.fieldValue);
            case 6:
              if (!(void 0 === g && !this._hasValueFromXFA && Array.isArray(n) && Array.isArray(this.data.fieldValue) && isArrayEqual(n, this.data.fieldValue) && void 0 === r)) {
                _context73.next = 8;
                break;
              }
              return _context73.abrupt("return", null);
            case 8:
              void 0 === g && (g = this.rotation);
              o = null;
              if (this._needAppearances) {
                _context73.next = 16;
                break;
              }
              _context73.next = 13;
              return this._getAppearance(e, t, C, a);
            case 13:
              o = _context73.sent;
              if (!(null === o && void 0 === r)) {
                _context73.next = 16;
                break;
              }
              return _context73.abrupt("return", null);
            case 16:
              c = !1;
              if ((_o54 = o) !== null && _o54 !== void 0 && _o54.needAppearances) {
                c = !0;
                o = null;
              }
              h = e.xref, l = h.fetchIfRef(this.ref);
              if (l instanceof Dict) {
                _context73.next = 21;
                break;
              }
              return _context73.abrupt("return", null);
            case 21:
              Q = new Dict(h);
              _iterator196 = _createForOfIteratorHelper(l.getKeys());
              try {
                for (_iterator196.s(); !(_step196 = _iterator196.n()).done;) {
                  _e573 = _step196.value;
                  "AP" !== _e573 && Q.set(_e573, l.getRaw(_e573));
                }
              } catch (err) {
                _iterator196.e(err);
              } finally {
                _iterator196.f();
              }
              if (void 0 !== r) {
                Q.set("F", r);
                if (null === o && !c) {
                  _e571 = l.getRaw("AP");
                  _e571 && Q.set("AP", _e571);
                }
              }
              E = {
                path: this.data.fieldName,
                value: n
              };
              Q.set("V", Array.isArray(n) ? n.map(stringToAsciiOrUTF16BE) : stringToAsciiOrUTF16BE(n));
              this.amendSavedDict(a, Q);
              u = this._getMKDict(g);
              u && Q.set("MK", u);
              d = [], f = [{
                ref: this.ref,
                data: "",
                xfa: E,
                needAppearances: c
              }];
              if (!(null !== o)) {
                _context73.next = 45;
                break;
              }
              _e572 = h.getNewTemporaryRef(), _t428 = new Dict(h);
              Q.set("AP", _t428);
              _t428.set("N", _e572);
              _s194 = this._getSaveFieldResources(h), _r150 = new StringStream(o), _n105 = _r150.dict = new Dict(h);
              _n105.set("Subtype", Name.get("Form"));
              _n105.set("Resources", _s194);
              _n105.set("BBox", [0, 0, this.data.rect[2] - this.data.rect[0], this.data.rect[3] - this.data.rect[1]]);
              _g75 = this.getRotationMatrix(a);
              _g75 !== i && _n105.set("Matrix", _g75);
              _context73.next = 43;
              return writeObject(_e572, _r150, d, h);
            case 43:
              f.push({
                ref: _e572,
                data: d.join(""),
                xfa: null,
                needAppearances: !1
              });
              d.length = 0;
            case 45:
              Q.set("M", "D:".concat(getModificationDate()));
              _context73.next = 48;
              return writeObject(this.ref, Q, d, h);
            case 48:
              f[0].data = d.join("");
              return _context73.abrupt("return", f);
            case 50:
            case "end":
              return _context73.stop();
          }
        }, _callee61, this);
      }));
      function save(_x130, _x131, _x132) {
        return _save2.apply(this, arguments);
      }
      return save;
    }()
  }, {
    key: "_getAppearance",
    value: function () {
      var _getAppearance2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee62(e, t, i, a) {
        var _ref178;
        var s, r, g, o, _e574, c, h, l, Q, E, u, d, f, p, m, _iterator197, _step197, _e577, _t431, _i374, _a293, _s195, _n106, _e575, _iterator198, _step198, _t429, _g76, _e576, _t430, _o55, _this$_computeFontSiz, _this$_computeFontSiz2, _this$_computeFontSiz3, _this$_computeFontSiz4, y, w, D, b;
        return _regeneratorRuntime().wrap(function _callee62$(_context74) {
          while (1) switch (_context74.prev = _context74.next) {
            case 0:
              if (!this.hasFieldFlag(rA)) {
                _context74.next = 2;
                break;
              }
              return _context74.abrupt("return", null);
            case 2:
              s = a === null || a === void 0 ? void 0 : a.get(this.data.id);
              if (s) {
                r = s.formattedValue || s.value;
                g = s.rotation;
              }
              if (!(void 0 === g && void 0 === r && !this._needAppearances && (!this._hasValueFromXFA || this.appearance))) {
                _context74.next = 6;
                break;
              }
              return _context74.abrupt("return", null);
            case 6:
              o = this.getBorderAndBackgroundAppearances(a);
              if (!(void 0 === r)) {
                _context74.next = 11;
                break;
              }
              r = this.data.fieldValue;
              if (r) {
                _context74.next = 11;
                break;
              }
              return _context74.abrupt("return", "/Tx BMC q ".concat(o, "Q EMC"));
            case 11:
              Array.isArray(r) && 1 === r.length && (r = r[0]);
              assert("string" == typeof r, "Expected `value` to be a string.");
              r = r.trimEnd();
              if (this.data.combo) {
                _e574 = this.data.options.find(function (_ref177) {
                  var e = _ref177.exportValue;
                  return r === e;
                });
                r = (_e574 === null || _e574 === void 0 ? void 0 : _e574.displayValue) || r;
              }
              if (!("" === r)) {
                _context74.next = 17;
                break;
              }
              return _context74.abrupt("return", "/Tx BMC q ".concat(o, "Q EMC"));
            case 17:
              void 0 === g && (g = this.rotation);
              h = -1;
              if (this.data.multiLine) {
                c = r.split(/\r\n?|\n/).map(function (e) {
                  return e.normalize("NFC");
                });
                h = c.length;
              } else c = [r.replace(/\r\n?|\n/, "").normalize("NFC")];
              l = this.data.rect[3] - this.data.rect[1], Q = this.data.rect[2] - this.data.rect[0];
              90 !== g && 270 !== g || (_ref178 = [l, Q], Q = _ref178[0], l = _ref178[1], _ref178);
              this._defaultAppearance || (this.data.defaultAppearanceData = parseDefaultAppearance(this._defaultAppearance = "/Helvetica 0 Tf 0 g"));
              _context74.next = 25;
              return WidgetAnnotation._getFontData(e, t, this.data.defaultAppearanceData, this._fieldResources.mergedResources);
            case 25:
              f = _context74.sent;
              p = [];
              m = !1;
              _iterator197 = _createForOfIteratorHelper(c);
              try {
                for (_iterator197.s(); !(_step197 = _iterator197.n()).done;) {
                  _e577 = _step197.value;
                  _t431 = f.encodeString(_e577);
                  _t431.length > 1 && (m = !0);
                  p.push(_t431.join(""));
                }
              } catch (err) {
                _iterator197.e(err);
              } finally {
                _iterator197.f();
              }
              if (!(m && i & C)) {
                _context74.next = 32;
                break;
              }
              return _context74.abrupt("return", {
                needAppearances: !0
              });
            case 32:
              if (!(m && this._isOffscreenCanvasSupported)) {
                _context74.next = 51;
                break;
              }
              _i374 = this.data.comb ? "monospace" : "sans-serif", _a293 = new FakeUnicodeFont(e.xref, _i374), _s195 = _a293.createFontResources(c.join("")), _n106 = _s195.getRaw("Font");
              if (this._fieldResources.mergedResources.has("Font")) {
                _e575 = this._fieldResources.mergedResources.get("Font");
                _iterator198 = _createForOfIteratorHelper(_n106.getKeys());
                try {
                  for (_iterator198.s(); !(_step198 = _iterator198.n()).done;) {
                    _t429 = _step198.value;
                    _e575.set(_t429, _n106.getRaw(_t429));
                  }
                } catch (err) {
                  _iterator198.e(err);
                } finally {
                  _iterator198.f();
                }
              } else this._fieldResources.mergedResources.set("Font", _n106);
              _g76 = _a293.fontName.name;
              _context74.next = 38;
              return WidgetAnnotation._getFontData(e, t, {
                fontName: _g76,
                fontSize: 0
              }, _s195);
            case 38:
              f = _context74.sent;
              for (_e576 = 0, _t430 = p.length; _e576 < _t430; _e576++) p[_e576] = stringToUTF16String(c[_e576]);
              _o55 = Object.assign(Object.create(null), this.data.defaultAppearanceData);
              this.data.defaultAppearanceData.fontSize = 0;
              this.data.defaultAppearanceData.fontName = _g76;
              _this$_computeFontSiz = this._computeFontSize(l - 2, Q - 4, r, f, h);
              _this$_computeFontSiz2 = _slicedToArray(_this$_computeFontSiz, 3);
              E = _this$_computeFontSiz2[0];
              u = _this$_computeFontSiz2[1];
              d = _this$_computeFontSiz2[2];
              this.data.defaultAppearanceData = _o55;
              _context74.next = 57;
              break;
            case 51:
              this._isOffscreenCanvasSupported || warn("_getAppearance: OffscreenCanvas is not supported, annotation may not render correctly.");
              _this$_computeFontSiz3 = this._computeFontSize(l - 2, Q - 4, r, f, h);
              _this$_computeFontSiz4 = _slicedToArray(_this$_computeFontSiz3, 3);
              E = _this$_computeFontSiz4[0];
              u = _this$_computeFontSiz4[1];
              d = _this$_computeFontSiz4[2];
            case 57:
              y = f.descent;
              y = isNaN(y) ? n * d : Math.max(n * d, Math.abs(y) * u);
              w = Math.min(Math.floor((l - u) / 2), 1), D = this.data.textAlignment;
              if (!this.data.multiLine) {
                _context74.next = 62;
                break;
              }
              return _context74.abrupt("return", this._getMultilineAppearance(E, p, f, u, Q, l, D, 2, w, y, d, a));
            case 62:
              if (!this.data.comb) {
                _context74.next = 64;
                break;
              }
              return _context74.abrupt("return", this._getCombAppearance(E, f, p[0], u, Q, l, 2, w, y, d, a));
            case 64:
              b = w + y;
              if (!(0 === D || D > 2)) {
                _context74.next = 67;
                break;
              }
              return _context74.abrupt("return", "/Tx BMC q ".concat(o, "BT ") + E + " 1 0 0 1 ".concat(numberToString(2), " ").concat(numberToString(b), " Tm (").concat(escapeString(p[0]), ") Tj ET Q EMC"));
            case 67:
              return _context74.abrupt("return", "/Tx BMC q ".concat(o, "BT ") + E + " 1 0 0 1 0 0 Tm ".concat(this._renderText(p[0], f, u, Q, D, {
                shift: 0
              }, 2, b), " ET Q EMC"));
            case 68:
            case "end":
              return _context74.stop();
          }
        }, _callee62, this);
      }));
      function _getAppearance(_x133, _x134, _x135, _x136) {
        return _getAppearance2.apply(this, arguments);
      }
      return _getAppearance;
    }()
  }, {
    key: "_getTextWidth",
    value: function _getTextWidth(e, t) {
      return t.charsToGlyphs(e).reduce(function (e, t) {
        return e + t.width;
      }, 0) / 1e3;
    }
  }, {
    key: "_computeFontSize",
    value: function _computeFontSize(e, t, i, a, r) {
      var _this271 = this;
      var n = this.data.defaultAppearanceData.fontSize,
        g = (n || 12) * s,
        o = Math.round(e / g);
      if (!n) {
        var roundWithTwoDigits = function roundWithTwoDigits(e) {
          return Math.floor(100 * e) / 100;
        };
        if (-1 === r) {
          var _r151 = this._getTextWidth(i, a);
          n = roundWithTwoDigits(Math.min(e / s, t / _r151));
          o = 1;
        } else {
          var _c31 = i.split(/\r\n?|\n/),
            _C22 = [];
          var _iterator199 = _createForOfIteratorHelper(_c31),
            _step199;
          try {
            for (_iterator199.s(); !(_step199 = _iterator199.n()).done;) {
              var _e578 = _step199.value;
              var _t432 = a.encodeString(_e578).join(""),
                _i376 = a.charsToGlyphs(_t432),
                _s196 = a.getCharPositions(_t432);
              _C22.push({
                line: _t432,
                glyphs: _i376,
                positions: _s196
              });
            }
          } catch (err) {
            _iterator199.e(err);
          } finally {
            _iterator199.f();
          }
          var isTooBig = function isTooBig(i) {
            var s = 0;
            for (var _i375 = 0, _C23 = _C22; _i375 < _C23.length; _i375++) {
              var _r152 = _C23[_i375];
              s += _this271._splitLine(null, a, i, t, _r152).length * i;
              if (s > e) return !0;
            }
            return !1;
          };
          o = Math.max(o, r);
          for (;;) {
            g = e / o;
            n = roundWithTwoDigits(g / s);
            if (!isTooBig(n)) break;
            o++;
          }
        }
        var _this$data$defaultApp = this.data.defaultAppearanceData,
          c = _this$data$defaultApp.fontName,
          _C24 = _this$data$defaultApp.fontColor;
        this._defaultAppearance = function createDefaultAppearance(_ref179) {
          var e = _ref179.fontSize,
            t = _ref179.fontName,
            i = _ref179.fontColor;
          return "/".concat(escapePDFName(t), " ").concat(e, " Tf ").concat(getPdfColor(i, !0));
        }({
          fontSize: n,
          fontName: c,
          fontColor: _C24
        });
      }
      return [this._defaultAppearance, n, e / o];
    }
  }, {
    key: "_renderText",
    value: function _renderText(e, t, i, a, s, r, n, g) {
      var o;
      if (1 === s) {
        o = (a - this._getTextWidth(e, t) * i) / 2;
      } else if (2 === s) {
        o = a - this._getTextWidth(e, t) * i - n;
      } else o = n;
      var c = numberToString(o - r.shift);
      r.shift = o;
      return "".concat(c, " ").concat(g = numberToString(g), " Td (").concat(escapeString(e), ") Tj");
    }
  }, {
    key: "_getSaveFieldResources",
    value: function _getSaveFieldResources(e) {
      var _this$data$defaultApp2;
      var _this$_fieldResources = this._fieldResources,
        t = _this$_fieldResources.localResources,
        i = _this$_fieldResources.appearanceResources,
        a = _this$_fieldResources.acroFormResources,
        s = (_this$data$defaultApp2 = this.data.defaultAppearanceData) === null || _this$data$defaultApp2 === void 0 ? void 0 : _this$data$defaultApp2.fontName;
      if (!s) return t || Dict.empty;
      for (var _i377 = 0, _arr5 = [t, i]; _i377 < _arr5.length; _i377++) {
        var _e579 = _arr5[_i377];
        if (_e579 instanceof Dict) {
          var _t433 = _e579.get("Font");
          if (_t433 instanceof Dict && _t433.has(s)) return _e579;
        }
      }
      if (a instanceof Dict) {
        var _i378 = a.get("Font");
        if (_i378 instanceof Dict && _i378.has(s)) {
          var _a294 = new Dict(e);
          _a294.set(s, _i378.getRaw(s));
          var r = new Dict(e);
          r.set("Font", _a294);
          return Dict.merge({
            xref: e,
            dictArray: [r, t],
            mergeSubDicts: !0
          });
        }
      }
      return t || Dict.empty;
    }
  }, {
    key: "getFieldObject",
    value: function getFieldObject() {
      return null;
    }
  }], [{
    key: "_getFontData",
    value: function () {
      var _getFontData2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee63(e, t, i, a) {
        var s, r, n, g;
        return _regeneratorRuntime().wrap(function _callee63$(_context75) {
          while (1) switch (_context75.prev = _context75.next) {
            case 0:
              s = new OperatorList(), r = {
                font: null,
                clone: function clone() {
                  return this;
                }
              }, n = i.fontName, g = i.fontSize;
              _context75.next = 3;
              return e.handleSetFont(a, [n && Name.get(n), g], null, s, t, r, null);
            case 3:
              return _context75.abrupt("return", r.font);
            case 4:
            case "end":
              return _context75.stop();
          }
        }, _callee63);
      }));
      function _getFontData(_x137, _x138, _x139, _x140) {
        return _getFontData2.apply(this, arguments);
      }
      return _getFontData;
    }()
  }]);
}(Annotation);
var TextWidgetAnnotation = /*#__PURE__*/function (_WidgetAnnotation) {
  function TextWidgetAnnotation(e) {
    var _this272;
    _classCallCheck(this, TextWidgetAnnotation);
    _this272 = _callSuper(this, TextWidgetAnnotation, [e]);
    var t = e.dict;
    if (t.has("PMD")) {
      _this272.flags |= z;
      _this272.data.hidden = !0;
      warn("Barcodes are not supported");
    }
    _this272.data.hasOwnCanvas = _this272.data.readOnly && !_this272.data.noHTML;
    _this272._hasText = !0;
    "string" != typeof _this272.data.fieldValue && (_this272.data.fieldValue = "");
    var i = getInheritableProperty({
      dict: t,
      key: "Q"
    });
    (!Number.isInteger(i) || i < 0 || i > 2) && (i = null);
    _this272.data.textAlignment = i;
    var a = getInheritableProperty({
      dict: t,
      key: "MaxLen"
    });
    (!Number.isInteger(a) || a < 0) && (a = 0);
    _this272.data.maxLen = a;
    _this272.data.multiLine = _this272.hasFieldFlag(sA);
    _this272.data.comb = _this272.hasFieldFlag(hA) && !_this272.hasFieldFlag(sA) && !_this272.hasFieldFlag(rA) && !_this272.hasFieldFlag(IA) && 0 !== _this272.data.maxLen;
    _this272.data.doNotScroll = _this272.hasFieldFlag(CA);
    return _this272;
  }
  _inherits(TextWidgetAnnotation, _WidgetAnnotation);
  return _createClass(TextWidgetAnnotation, [{
    key: "hasTextContent",
    get: function get() {
      return !!this.appearance && !this._needAppearances;
    }
  }, {
    key: "_getCombAppearance",
    value: function _getCombAppearance(e, t, i, a, s, r, n, g, o, c, C) {
      var h = s / this.data.maxLen,
        l = this.getBorderAndBackgroundAppearances(C),
        Q = [],
        E = t.getCharPositions(i);
      var _iterator200 = _createForOfIteratorHelper(E),
        _step200;
      try {
        for (_iterator200.s(); !(_step200 = _iterator200.n()).done;) {
          var _ref180 = _step200.value;
          var _ref181 = _slicedToArray(_ref180, 2);
          var _e580 = _ref181[0];
          var _t434 = _ref181[1];
          Q.push("(".concat(escapeString(i.substring(_e580, _t434)), ") Tj"));
        }
      } catch (err) {
        _iterator200.e(err);
      } finally {
        _iterator200.f();
      }
      var u = Q.join(" ".concat(numberToString(h), " 0 Td "));
      return "/Tx BMC q ".concat(l, "BT ") + e + " 1 0 0 1 ".concat(numberToString(n), " ").concat(numberToString(g + o), " Tm ").concat(u, " ET Q EMC");
    }
  }, {
    key: "_getMultilineAppearance",
    value: function _getMultilineAppearance(e, t, i, a, s, r, n, g, o, c, C, h) {
      var l = [],
        Q = s - 2 * g,
        E = {
          shift: 0
        };
      for (var _e581 = 0, _r153 = t.length; _e581 < _r153; _e581++) {
        var _r154 = t[_e581],
          _h15 = this._splitLine(_r154, i, a, Q);
        for (var _t435 = 0, _r155 = _h15.length; _t435 < _r155; _t435++) {
          var _r156 = _h15[_t435],
            _Q19 = 0 === _e581 && 0 === _t435 ? -o - (C - c) : -C;
          l.push(this._renderText(_r156, i, a, s, n, E, g, _Q19));
        }
      }
      var u = this.getBorderAndBackgroundAppearances(h),
        d = l.join("\n");
      return "/Tx BMC q ".concat(u, "BT ") + e + " 1 0 0 1 0 ".concat(numberToString(r), " Tm ").concat(d, " ET Q EMC");
    }
  }, {
    key: "_splitLine",
    value: function _splitLine(e, t, i, a) {
      var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      e = s.line || e;
      var r = s.glyphs || t.charsToGlyphs(e);
      if (r.length <= 1) return [e];
      var n = s.positions || t.getCharPositions(e),
        g = i / 1e3,
        o = [];
      var c = -1,
        C = -1,
        h = -1,
        l = 0,
        Q = 0;
      for (var _t436 = 0, _i379 = r.length; _t436 < _i379; _t436++) {
        var _n$_t = _slicedToArray(n[_t436], 2),
          _i380 = _n$_t[0],
          _s197 = _n$_t[1],
          E = r[_t436],
          u = E.width * g;
        if (" " === E.unicode) {
          if (Q + u > a) {
            o.push(e.substring(l, _i380));
            l = _i380;
            Q = u;
            c = -1;
            h = -1;
          } else {
            Q += u;
            c = _i380;
            C = _s197;
            h = _t436;
          }
        } else if (Q + u > a) {
          if (-1 !== c) {
            o.push(e.substring(l, C));
            l = C;
            _t436 = h + 1;
            c = -1;
            Q = 0;
          } else {
            o.push(e.substring(l, _i380));
            l = _i380;
            Q = u;
          }
        } else Q += u;
      }
      l < e.length && o.push(e.substring(l, e.length));
      return o;
    }
  }, {
    key: "extractTextContent",
    value: function () {
      var _extractTextContent2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee64(e, t, i) {
        var a, s, r;
        return _regeneratorRuntime().wrap(function _callee64$(_context76) {
          while (1) switch (_context76.prev = _context76.next) {
            case 0:
              _context76.next = 2;
              return _superPropGet(TextWidgetAnnotation, "extractTextContent", this, 3)([e, t, i]);
            case 2:
              a = this.data.textContent;
              if (a) {
                _context76.next = 5;
                break;
              }
              return _context76.abrupt("return");
            case 5:
              s = a.join("\n");
              if (!(s === this.data.fieldValue)) {
                _context76.next = 8;
                break;
              }
              return _context76.abrupt("return");
            case 8:
              r = s.replaceAll(/([.*+?^${}()|[\]\\])|(\s+)/g, function (e, t) {
                return t ? "\\".concat(t) : "\\s+";
              });
              new RegExp("^\\s*".concat(r, "\\s*$")).test(this.data.fieldValue) && (this.data.textContent = this.data.fieldValue.split("\n"));
            case 10:
            case "end":
              return _context76.stop();
          }
        }, _callee64, this);
      }));
      function extractTextContent(_x141, _x142, _x143) {
        return _extractTextContent2.apply(this, arguments);
      }
      return extractTextContent;
    }()
  }, {
    key: "getFieldObject",
    value: function getFieldObject() {
      return {
        id: this.data.id,
        value: this.data.fieldValue,
        defaultValue: this.data.defaultFieldValue || "",
        multiline: this.data.multiLine,
        password: this.hasFieldFlag(rA),
        charLimit: this.data.maxLen,
        comb: this.data.comb,
        editable: !this.data.readOnly,
        hidden: this.data.hidden,
        name: this.data.fieldName,
        rect: this.data.rect,
        actions: this.data.actions,
        page: this.data.pageIndex,
        strokeColor: this.data.borderColor,
        fillColor: this.data.backgroundColor,
        rotation: this.rotation,
        type: "text"
      };
    }
  }]);
}(WidgetAnnotation);
var ButtonWidgetAnnotation = /*#__PURE__*/function (_WidgetAnnotation2) {
  function ButtonWidgetAnnotation(e) {
    var _this273;
    _classCallCheck(this, ButtonWidgetAnnotation);
    _this273 = _callSuper(this, ButtonWidgetAnnotation, [e]);
    _this273.checkedAppearance = null;
    _this273.uncheckedAppearance = null;
    _this273.data.checkBox = !_this273.hasFieldFlag(nA) && !_this273.hasFieldFlag(gA);
    _this273.data.radioButton = _this273.hasFieldFlag(nA) && !_this273.hasFieldFlag(gA);
    _this273.data.pushButton = _this273.hasFieldFlag(gA);
    _this273.data.isTooltipOnly = !1;
    if (_this273.data.checkBox) _this273._processCheckBox(e);else if (_this273.data.radioButton) _this273._processRadioButton(e);else if (_this273.data.pushButton) {
      _this273.data.hasOwnCanvas = !0;
      _this273.data.noHTML = !1;
      _this273._processPushButton(e);
    } else warn("Invalid field flags for button widget annotation");
    return _this273;
  }
  _inherits(ButtonWidgetAnnotation, _WidgetAnnotation2);
  return _createClass(ButtonWidgetAnnotation, [{
    key: "getOperatorList",
    value: function () {
      var _getOperatorList3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee65(e, t, a, s) {
        var r, n, _e582, g, _r157, _o56, c;
        return _regeneratorRuntime().wrap(function _callee65$(_context77) {
          while (1) switch (_context77.prev = _context77.next) {
            case 0:
              if (!this.data.pushButton) {
                _context77.next = 2;
                break;
              }
              return _context77.abrupt("return", _superPropGet(ButtonWidgetAnnotation, "getOperatorList", this, 3)([e, t, a, !1, s]));
            case 2:
              r = null, n = null;
              if (s) {
                _e582 = s.get(this.data.id);
                r = _e582 ? _e582.value : null;
                n = _e582 ? _e582.rotation : null;
              }
              if (!(null === r && this.appearance)) {
                _context77.next = 6;
                break;
              }
              return _context77.abrupt("return", _superPropGet(ButtonWidgetAnnotation, "getOperatorList", this, 3)([e, t, a, s]));
            case 6:
              null == r && (r = this.data.checkBox ? this.data.fieldValue === this.data.exportValue : this.data.fieldValue === this.data.buttonValue);
              g = r ? this.checkedAppearance : this.uncheckedAppearance;
              if (!g) {
                _context77.next = 16;
                break;
              }
              _r157 = this.appearance, _o56 = lookupMatrix(g.dict.getArray("Matrix"), i);
              n && g.dict.set("Matrix", this.getRotationMatrix(s));
              this.appearance = g;
              c = _superPropGet(ButtonWidgetAnnotation, "getOperatorList", this, 3)([e, t, a, s]);
              this.appearance = _r157;
              g.dict.set("Matrix", _o56);
              return _context77.abrupt("return", c);
            case 16:
              return _context77.abrupt("return", {
                opList: new OperatorList(),
                separateForm: !1,
                separateCanvas: !1
              });
            case 17:
            case "end":
              return _context77.stop();
          }
        }, _callee65, this);
      }));
      function getOperatorList(_x144, _x145, _x146, _x147) {
        return _getOperatorList3.apply(this, arguments);
      }
      return getOperatorList;
    }()
  }, {
    key: "save",
    value: function () {
      var _save3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee66(e, t, i) {
        return _regeneratorRuntime().wrap(function _callee66$(_context78) {
          while (1) switch (_context78.prev = _context78.next) {
            case 0:
              return _context78.abrupt("return", this.data.checkBox ? this._saveCheckbox(e, t, i) : this.data.radioButton ? this._saveRadioButton(e, t, i) : null);
            case 1:
            case "end":
              return _context78.stop();
          }
        }, _callee66, this);
      }));
      function save(_x148, _x149, _x150) {
        return _save3.apply(this, arguments);
      }
      return save;
    }()
  }, {
    key: "_saveCheckbox",
    value: function () {
      var _saveCheckbox2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee67(e, t, i) {
        var a, s, r, n, g, o, c, C, h;
        return _regeneratorRuntime().wrap(function _callee67$(_context79) {
          while (1) switch (_context79.prev = _context79.next) {
            case 0:
              if (i) {
                _context79.next = 2;
                break;
              }
              return _context79.abrupt("return", null);
            case 2:
              a = i.get(this.data.id), s = this._buildFlags(a === null || a === void 0 ? void 0 : a.noView, a === null || a === void 0 ? void 0 : a.noPrint);
              r = a === null || a === void 0 ? void 0 : a.rotation, n = a === null || a === void 0 ? void 0 : a.value;
              if (!(void 0 === r && void 0 === s)) {
                _context79.next = 9;
                break;
              }
              if (!(void 0 === n)) {
                _context79.next = 7;
                break;
              }
              return _context79.abrupt("return", null);
            case 7:
              if (!(this.data.fieldValue === this.data.exportValue === n)) {
                _context79.next = 9;
                break;
              }
              return _context79.abrupt("return", null);
            case 9:
              g = e.xref.fetchIfRef(this.ref);
              if (g instanceof Dict) {
                _context79.next = 12;
                break;
              }
              return _context79.abrupt("return", null);
            case 12:
              g = g.clone();
              void 0 === r && (r = this.rotation);
              void 0 === n && (n = this.data.fieldValue === this.data.exportValue);
              o = {
                path: this.data.fieldName,
                value: n ? this.data.exportValue : ""
              }, c = Name.get(n ? this.data.exportValue : "Off");
              g.set("V", c);
              g.set("AS", c);
              g.set("M", "D:".concat(getModificationDate()));
              void 0 !== s && g.set("F", s);
              C = this._getMKDict(r);
              C && g.set("MK", C);
              h = [];
              _context79.next = 25;
              return writeObject(this.ref, g, h, e.xref);
            case 25:
              return _context79.abrupt("return", [{
                ref: this.ref,
                data: h.join(""),
                xfa: o
              }]);
            case 26:
            case "end":
              return _context79.stop();
          }
        }, _callee67, this);
      }));
      function _saveCheckbox(_x151, _x152, _x153) {
        return _saveCheckbox2.apply(this, arguments);
      }
      return _saveCheckbox;
    }()
  }, {
    key: "_saveRadioButton",
    value: function () {
      var _saveRadioButton2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee68(e, t, i) {
        var a, s, r, n, g, o, c, C, h, _t437, l, Q;
        return _regeneratorRuntime().wrap(function _callee68$(_context80) {
          while (1) switch (_context80.prev = _context80.next) {
            case 0:
              if (i) {
                _context80.next = 2;
                break;
              }
              return _context80.abrupt("return", null);
            case 2:
              a = i.get(this.data.id), s = this._buildFlags(a === null || a === void 0 ? void 0 : a.noView, a === null || a === void 0 ? void 0 : a.noPrint);
              r = a === null || a === void 0 ? void 0 : a.rotation, n = a === null || a === void 0 ? void 0 : a.value;
              if (!(void 0 === r && void 0 === s)) {
                _context80.next = 9;
                break;
              }
              if (!(void 0 === n)) {
                _context80.next = 7;
                break;
              }
              return _context80.abrupt("return", null);
            case 7:
              if (!(this.data.fieldValue === this.data.buttonValue === n)) {
                _context80.next = 9;
                break;
              }
              return _context80.abrupt("return", null);
            case 9:
              g = e.xref.fetchIfRef(this.ref);
              if (g instanceof Dict) {
                _context80.next = 12;
                break;
              }
              return _context80.abrupt("return", null);
            case 12:
              g = g.clone();
              void 0 === n && (n = this.data.fieldValue === this.data.buttonValue);
              void 0 === r && (r = this.rotation);
              o = {
                path: this.data.fieldName,
                value: n ? this.data.buttonValue : ""
              }, c = Name.get(n ? this.data.buttonValue : "Off"), C = [];
              h = null;
              if (!n) {
                _context80.next = 28;
                break;
              }
              if (!(this.parent instanceof Ref)) {
                _context80.next = 27;
                break;
              }
              _t437 = e.xref.fetch(this.parent);
              _t437.set("V", c);
              _context80.next = 23;
              return writeObject(this.parent, _t437, C, e.xref);
            case 23:
              h = C.join("");
              C.length = 0;
              _context80.next = 28;
              break;
            case 27:
              this.parent instanceof Dict && this.parent.set("V", c);
            case 28:
              this.parent || g.set("V", c);
              g.set("AS", c);
              g.set("M", "D:".concat(getModificationDate()));
              void 0 !== s && g.set("F", s);
              l = this._getMKDict(r);
              l && g.set("MK", l);
              _context80.next = 36;
              return writeObject(this.ref, g, C, e.xref);
            case 36:
              Q = [{
                ref: this.ref,
                data: C.join(""),
                xfa: o
              }];
              h && Q.push({
                ref: this.parent,
                data: h,
                xfa: null
              });
              return _context80.abrupt("return", Q);
            case 39:
            case "end":
              return _context80.stop();
          }
        }, _callee68, this);
      }));
      function _saveRadioButton(_x154, _x155, _x156) {
        return _saveRadioButton2.apply(this, arguments);
      }
      return _saveRadioButton;
    }()
  }, {
    key: "_getDefaultCheckedAppearance",
    value: function _getDefaultCheckedAppearance(e, t) {
      var i = this.data.rect[2] - this.data.rect[0],
        a = this.data.rect[3] - this.data.rect[1],
        s = [0, 0, i, a],
        r = .8 * Math.min(i, a);
      var n, g;
      if ("check" === t) {
        n = {
          width: .755 * r,
          height: .705 * r
        };
        g = "3";
      } else if ("disc" === t) {
        n = {
          width: .791 * r,
          height: .705 * r
        };
        g = "l";
      } else unreachable("_getDefaultCheckedAppearance - unsupported type: ".concat(t));
      var o = "q BT /PdfJsZaDb ".concat(r, " Tf 0 g ").concat(numberToString((i - n.width) / 2), " ").concat(numberToString((a - n.height) / 2), " Td (").concat(g, ") Tj ET Q"),
        c = new Dict(e.xref);
      c.set("FormType", 1);
      c.set("Subtype", Name.get("Form"));
      c.set("Type", Name.get("XObject"));
      c.set("BBox", s);
      c.set("Matrix", [1, 0, 0, 1, 0, 0]);
      c.set("Length", o.length);
      var C = new Dict(e.xref),
        h = new Dict(e.xref);
      h.set("PdfJsZaDb", this.fallbackFontDict);
      C.set("Font", h);
      c.set("Resources", C);
      this.checkedAppearance = new StringStream(o);
      this.checkedAppearance.dict = c;
      this._streams.push(this.checkedAppearance);
    }
  }, {
    key: "_processCheckBox",
    value: function _processCheckBox(e) {
      var t = e.dict.get("AP");
      if (!(t instanceof Dict)) return;
      var i = t.get("N");
      if (!(i instanceof Dict)) return;
      var a = this._decodeFormValue(e.dict.get("AS"));
      "string" == typeof a && (this.data.fieldValue = a);
      var s = null !== this.data.fieldValue && "Off" !== this.data.fieldValue ? this.data.fieldValue : "Yes",
        r = i.getKeys();
      if (0 === r.length) r.push("Off", s);else if (1 === r.length) "Off" === r[0] ? r.push(s) : r.unshift("Off");else if (r.includes(s)) {
        r.length = 0;
        r.push("Off", s);
      } else {
        var _e583 = r.find(function (e) {
          return "Off" !== e;
        });
        r.length = 0;
        r.push("Off", _e583);
      }
      r.includes(this.data.fieldValue) || (this.data.fieldValue = "Off");
      this.data.exportValue = r[1];
      var n = i.get(this.data.exportValue);
      this.checkedAppearance = n instanceof BaseStream ? n : null;
      var g = i.get("Off");
      this.uncheckedAppearance = g instanceof BaseStream ? g : null;
      this.checkedAppearance ? this._streams.push(this.checkedAppearance) : this._getDefaultCheckedAppearance(e, "check");
      this.uncheckedAppearance && this._streams.push(this.uncheckedAppearance);
      this._fallbackFontDict = this.fallbackFontDict;
      null === this.data.defaultFieldValue && (this.data.defaultFieldValue = "Off");
    }
  }, {
    key: "_processRadioButton",
    value: function _processRadioButton(e) {
      this.data.buttonValue = null;
      var t = e.dict.get("Parent");
      if (t instanceof Dict) {
        this.parent = e.dict.getRaw("Parent");
        var _i381 = t.get("V");
        _i381 instanceof Name && (this.data.fieldValue = this._decodeFormValue(_i381));
      }
      var i = e.dict.get("AP");
      if (!(i instanceof Dict)) return;
      var a = i.get("N");
      if (!(a instanceof Dict)) return;
      var _iterator201 = _createForOfIteratorHelper(a.getKeys()),
        _step201;
      try {
        for (_iterator201.s(); !(_step201 = _iterator201.n()).done;) {
          var _e584 = _step201.value;
          if ("Off" !== _e584) {
            this.data.buttonValue = this._decodeFormValue(_e584);
            break;
          }
        }
      } catch (err) {
        _iterator201.e(err);
      } finally {
        _iterator201.f();
      }
      var s = a.get(this.data.buttonValue);
      this.checkedAppearance = s instanceof BaseStream ? s : null;
      var r = a.get("Off");
      this.uncheckedAppearance = r instanceof BaseStream ? r : null;
      this.checkedAppearance ? this._streams.push(this.checkedAppearance) : this._getDefaultCheckedAppearance(e, "disc");
      this.uncheckedAppearance && this._streams.push(this.uncheckedAppearance);
      this._fallbackFontDict = this.fallbackFontDict;
      null === this.data.defaultFieldValue && (this.data.defaultFieldValue = "Off");
    }
  }, {
    key: "_processPushButton",
    value: function _processPushButton(e) {
      var t = e.dict,
        i = e.annotationGlobals;
      if (t.has("A") || t.has("AA") || this.data.alternativeText) {
        this.data.isTooltipOnly = !t.has("A") && !t.has("AA");
        Catalog.parseDestDictionary({
          destDict: t,
          resultObj: this.data,
          docBaseUrl: i.baseUrl,
          docAttachments: i.attachments
        });
      } else warn("Push buttons without action dictionaries are not supported");
    }
  }, {
    key: "getFieldObject",
    value: function getFieldObject() {
      var e,
        t = "button";
      if (this.data.checkBox) {
        t = "checkbox";
        e = this.data.exportValue;
      } else if (this.data.radioButton) {
        t = "radiobutton";
        e = this.data.buttonValue;
      }
      return {
        id: this.data.id,
        value: this.data.fieldValue || "Off",
        defaultValue: this.data.defaultFieldValue,
        exportValues: e,
        editable: !this.data.readOnly,
        name: this.data.fieldName,
        rect: this.data.rect,
        hidden: this.data.hidden,
        actions: this.data.actions,
        page: this.data.pageIndex,
        strokeColor: this.data.borderColor,
        fillColor: this.data.backgroundColor,
        rotation: this.rotation,
        type: t
      };
    }
  }, {
    key: "fallbackFontDict",
    get: function get() {
      var e = new Dict();
      e.set("BaseFont", Name.get("ZapfDingbats"));
      e.set("Type", Name.get("FallbackType"));
      e.set("Subtype", Name.get("FallbackType"));
      e.set("Encoding", Name.get("ZapfDingbatsEncoding"));
      return shadow(this, "fallbackFontDict", e);
    }
  }]);
}(WidgetAnnotation);
var ChoiceWidgetAnnotation = /*#__PURE__*/function (_WidgetAnnotation3) {
  function ChoiceWidgetAnnotation(e) {
    var _this274;
    _classCallCheck(this, ChoiceWidgetAnnotation);
    _this274 = _callSuper(this, ChoiceWidgetAnnotation, [e]);
    var t = e.dict,
      i = e.xref;
    _this274.indices = t.getArray("I");
    _this274.hasIndices = Array.isArray(_this274.indices) && _this274.indices.length > 0;
    _this274.data.options = [];
    var a = getInheritableProperty({
      dict: t,
      key: "Opt"
    });
    if (Array.isArray(a)) for (var _e585 = 0, _t438 = a.length; _e585 < _t438; _e585++) {
      var _t439 = i.fetchIfRef(a[_e585]),
        _s198 = Array.isArray(_t439);
      _this274.data.options[_e585] = {
        exportValue: _this274._decodeFormValue(_s198 ? i.fetchIfRef(_t439[0]) : _t439),
        displayValue: _this274._decodeFormValue(_s198 ? i.fetchIfRef(_t439[1]) : _t439)
      };
    }
    if (_this274.hasIndices) {
      _this274.data.fieldValue = [];
      var _e586 = _this274.data.options.length;
      var _iterator202 = _createForOfIteratorHelper(_this274.indices),
        _step202;
      try {
        for (_iterator202.s(); !(_step202 = _iterator202.n()).done;) {
          var _t440 = _step202.value;
          Number.isInteger(_t440) && _t440 >= 0 && _t440 < _e586 && _this274.data.fieldValue.push(_this274.data.options[_t440].exportValue);
        }
      } catch (err) {
        _iterator202.e(err);
      } finally {
        _iterator202.f();
      }
    } else "string" == typeof _this274.data.fieldValue ? _this274.data.fieldValue = [_this274.data.fieldValue] : _this274.data.fieldValue || (_this274.data.fieldValue = []);
    _this274.data.combo = _this274.hasFieldFlag(oA);
    _this274.data.multiSelect = _this274.hasFieldFlag(cA);
    _this274._hasText = !0;
    return _this274;
  }
  _inherits(ChoiceWidgetAnnotation, _WidgetAnnotation3);
  return _createClass(ChoiceWidgetAnnotation, [{
    key: "getFieldObject",
    value: function getFieldObject() {
      var e = this.data.combo ? "combobox" : "listbox",
        t = this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : null;
      return {
        id: this.data.id,
        value: t,
        defaultValue: this.data.defaultFieldValue,
        editable: !this.data.readOnly,
        name: this.data.fieldName,
        rect: this.data.rect,
        numItems: this.data.fieldValue.length,
        multipleSelection: this.data.multiSelect,
        hidden: this.data.hidden,
        actions: this.data.actions,
        items: this.data.options,
        page: this.data.pageIndex,
        strokeColor: this.data.borderColor,
        fillColor: this.data.backgroundColor,
        rotation: this.rotation,
        type: e
      };
    }
  }, {
    key: "amendSavedDict",
    value: function amendSavedDict(e, t) {
      var _e$get5;
      if (!this.hasIndices) return;
      var i = e === null || e === void 0 || (_e$get5 = e.get(this.data.id)) === null || _e$get5 === void 0 ? void 0 : _e$get5.value;
      Array.isArray(i) || (i = [i]);
      var a = [],
        s = this.data.options;
      for (var _e587 = 0, _t441 = 0, r = s.length; _e587 < r; _e587++) if (s[_e587].exportValue === i[_t441]) {
        a.push(_e587);
        _t441 += 1;
      }
      t.set("I", a);
    }
  }, {
    key: "_getAppearance",
    value: function () {
      var _getAppearance3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee69(e, t, i, a) {
        var _ref182;
        var r, n, g, o, c, C, h, _e588, _t442, l, Q, E, _e589, _t443, _i382, _iterator203, _step203, _ref183, _e590, _a295, _this$_computeFontSiz5, _this$_computeFontSiz6, u, d, f, p, _e591, _t444, m, y, _iterator204, _step204, _e592, w, _e593, _t445, _i383;
        return _regeneratorRuntime().wrap(function _callee69$(_context81) {
          while (1) switch (_context81.prev = _context81.next) {
            case 0:
              if (!this.data.combo) {
                _context81.next = 2;
                break;
              }
              return _context81.abrupt("return", _superPropGet(ChoiceWidgetAnnotation, "_getAppearance", this, 3)([e, t, i, a]));
            case 2:
              g = a === null || a === void 0 ? void 0 : a.get(this.data.id);
              if (g) {
                n = g.rotation;
                r = g.value;
              }
              if (!(void 0 === n && void 0 === r && !this._needAppearances)) {
                _context81.next = 6;
                break;
              }
              return _context81.abrupt("return", null);
            case 6:
              void 0 === r ? r = this.data.fieldValue : Array.isArray(r) || (r = [r]);
              o = this.data.rect[3] - this.data.rect[1], c = this.data.rect[2] - this.data.rect[0];
              90 !== n && 270 !== n || (_ref182 = [o, c], c = _ref182[0], o = _ref182[1], _ref182);
              C = this.data.options.length, h = [];
              for (_e588 = 0; _e588 < C; _e588++) {
                _t442 = this.data.options[_e588].exportValue;
                r.includes(_t442) && h.push(_e588);
              }
              this._defaultAppearance || (this.data.defaultAppearanceData = parseDefaultAppearance(this._defaultAppearance = "/Helvetica 0 Tf 0 g"));
              _context81.next = 14;
              return WidgetAnnotation._getFontData(e, t, this.data.defaultAppearanceData, this._fieldResources.mergedResources);
            case 14:
              l = _context81.sent;
              E = this.data.defaultAppearanceData.fontSize;
              if (E) Q = this._defaultAppearance;else {
                _e589 = (o - 1) / C;
                _i382 = -1;
                _iterator203 = _createForOfIteratorHelper(this.data.options);
                try {
                  for (_iterator203.s(); !(_step203 = _iterator203.n()).done;) {
                    _ref183 = _step203.value;
                    _e590 = _ref183.displayValue;
                    {
                      _a295 = this._getTextWidth(_e590, l);
                      if (_a295 > _i382) {
                        _i382 = _a295;
                        _t443 = _e590;
                      }
                    }
                  }
                } catch (err) {
                  _iterator203.e(err);
                } finally {
                  _iterator203.f();
                }
                _this$_computeFontSiz5 = this._computeFontSize(_e589, c - 4, _t443, l, -1);
                _this$_computeFontSiz6 = _slicedToArray(_this$_computeFontSiz5, 2);
                Q = _this$_computeFontSiz6[0];
                E = _this$_computeFontSiz6[1];
              }
              u = E * s, d = (u - E) / 2, f = Math.floor(o / u);
              p = 0;
              if (h.length > 0) {
                _e591 = Math.min.apply(Math, h), _t444 = Math.max.apply(Math, h);
                p = Math.max(0, _t444 - f + 1);
                p > _e591 && (p = _e591);
              }
              m = Math.min(p + f + 1, C), y = ["/Tx BMC q", "1 1 ".concat(c, " ").concat(o, " re W n")];
              if (h.length) {
                y.push("0.600006 0.756866 0.854904 rg");
                _iterator204 = _createForOfIteratorHelper(h);
                try {
                  for (_iterator204.s(); !(_step204 = _iterator204.n()).done;) {
                    _e592 = _step204.value;
                    p <= _e592 && _e592 < m && y.push("1 ".concat(o - (_e592 - p + 1) * u, " ").concat(c, " ").concat(u, " re f"));
                  }
                } catch (err) {
                  _iterator204.e(err);
                } finally {
                  _iterator204.f();
                }
              }
              y.push("BT", Q, "1 0 0 1 0 ".concat(o, " Tm"));
              w = {
                shift: 0
              };
              for (_e593 = p; _e593 < m; _e593++) {
                _t445 = this.data.options[_e593].displayValue, _i383 = _e593 === p ? d : 0;
                y.push(this._renderText(_t445, l, E, c, 0, w, 2, -u + _i383));
              }
              y.push("ET Q EMC");
              return _context81.abrupt("return", y.join("\n"));
            case 27:
            case "end":
              return _context81.stop();
          }
        }, _callee69, this);
      }));
      function _getAppearance(_x157, _x158, _x159, _x160) {
        return _getAppearance3.apply(this, arguments);
      }
      return _getAppearance;
    }()
  }]);
}(WidgetAnnotation);
var SignatureWidgetAnnotation = /*#__PURE__*/function (_WidgetAnnotation4) {
  function SignatureWidgetAnnotation(e) {
    var _this275;
    _classCallCheck(this, SignatureWidgetAnnotation);
    _this275 = _callSuper(this, SignatureWidgetAnnotation, [e]);
    _this275.data.fieldValue = null;
    _this275.data.hasOwnCanvas = _this275.data.noRotate;
    _this275.data.noHTML = !_this275.data.hasOwnCanvas;
    return _this275;
  }
  _inherits(SignatureWidgetAnnotation, _WidgetAnnotation4);
  return _createClass(SignatureWidgetAnnotation, [{
    key: "getFieldObject",
    value: function getFieldObject() {
      return {
        id: this.data.id,
        value: null,
        page: this.data.pageIndex,
        type: "signature"
      };
    }
  }]);
}(WidgetAnnotation);
var TextAnnotation = /*#__PURE__*/function (_MarkupAnnotation) {
  function TextAnnotation(e) {
    var _this276;
    _classCallCheck(this, TextAnnotation);
    _this276 = _callSuper(this, TextAnnotation, [e]);
    _this276.data.noRotate = !0;
    _this276.data.hasOwnCanvas = _this276.data.noRotate;
    _this276.data.noHTML = !1;
    var t = e.dict;
    _this276.data.annotationType = k;
    if (_this276.data.hasAppearance) _this276.data.name = "NoIcon";else {
      _this276.data.rect[1] = _this276.data.rect[3] - 22;
      _this276.data.rect[2] = _this276.data.rect[0] + 22;
      _this276.data.name = t.has("Name") ? t.get("Name").name : "Note";
    }
    if (t.has("State")) {
      _this276.data.state = t.get("State") || null;
      _this276.data.stateModel = t.get("StateModel") || null;
    } else {
      _this276.data.state = null;
      _this276.data.stateModel = null;
    }
    return _this276;
  }
  _inherits(TextAnnotation, _MarkupAnnotation);
  return _createClass(TextAnnotation);
}(MarkupAnnotation);
var LinkAnnotation = /*#__PURE__*/function (_Annotation3) {
  function LinkAnnotation(e) {
    var _this277$data;
    var _this277;
    _classCallCheck(this, LinkAnnotation);
    _this277 = _callSuper(this, LinkAnnotation, [e]);
    var t = e.dict,
      i = e.annotationGlobals;
    _this277.data.annotationType = R;
    _this277.data.noHTML = !1;
    var a = getQuadPoints(t, _this277.rectangle);
    a && (_this277.data.quadPoints = a);
    (_this277$data = _this277.data).borderColor || (_this277$data.borderColor = _this277.data.color);
    Catalog.parseDestDictionary({
      destDict: t,
      resultObj: _this277.data,
      docBaseUrl: i.baseUrl,
      docAttachments: i.attachments
    });
    return _this277;
  }
  _inherits(LinkAnnotation, _Annotation3);
  return _createClass(LinkAnnotation);
}(Annotation);
var PopupAnnotation = /*#__PURE__*/function (_Annotation4) {
  function PopupAnnotation(e) {
    var _this278;
    _classCallCheck(this, PopupAnnotation);
    _this278 = _callSuper(this, PopupAnnotation, [e]);
    var t = e.dict;
    _this278.data.annotationType = O;
    _this278.data.noHTML = !1;
    _this278.data.rect[0] !== _this278.data.rect[2] && _this278.data.rect[1] !== _this278.data.rect[3] || (_this278.data.rect = null);
    var i = t.get("Parent");
    if (!i) {
      warn("Popup annotation has a missing or invalid parent annotation.");
      return _possibleConstructorReturn(_this278);
    }
    _this278.data.parentRect = lookupNormalRect(i.getArray("Rect"), null);
    isName(i.get("RT"), X) && (i = i.get("IRT"));
    if (i.has("M")) {
      _this278.setModificationDate(i.get("M"));
      _this278.data.modificationDate = _this278.modificationDate;
    } else _this278.data.modificationDate = null;
    if (i.has("C")) {
      _this278.setColor(i.getArray("C"));
      _this278.data.color = _this278.color;
    } else _this278.data.color = null;
    if (!_this278.viewable) {
      var _e594 = i.get("F");
      _this278._isViewable(_e594) && _this278.setFlags(_e594);
    }
    _this278.setTitle(i.get("T"));
    _this278.data.titleObj = _this278._title;
    _this278.setContents(i.get("Contents"));
    _this278.data.contentsObj = _this278._contents;
    i.has("RC") && (_this278.data.richText = XFAFactory.getRichTextAsHtml(i.get("RC")));
    _this278.data.open = !!t.get("Open");
    return _this278;
  }
  _inherits(PopupAnnotation, _Annotation4);
  return _createClass(PopupAnnotation);
}(Annotation);
var FreeTextAnnotation = /*#__PURE__*/function (_MarkupAnnotation2) {
  function FreeTextAnnotation(e) {
    var _this279;
    _classCallCheck(this, FreeTextAnnotation);
    _this279 = _callSuper(this, FreeTextAnnotation, [e]);
    _this279.data.hasOwnCanvas = _this279.data.noRotate;
    _this279.data.isEditable = !_this279.data.noHTML;
    _this279.data.noHTML = !1;
    var t = e.evaluatorOptions,
      i = e.xref;
    _this279.data.annotationType = N;
    _this279.setDefaultAppearance(e);
    _this279._hasAppearance = !!_this279.appearance;
    if (_this279._hasAppearance) {
      var _parseAppearanceStrea = function parseAppearanceStream(e, t, i) {
          return new AppearanceStreamEvaluator(e, t, i).parse();
        }(_this279.appearance, t, i),
        _e595 = _parseAppearanceStrea.fontColor,
        _a296 = _parseAppearanceStrea.fontSize;
      _this279.data.defaultAppearanceData.fontColor = _e595;
      _this279.data.defaultAppearanceData.fontSize = _a296 || 10;
    } else {
      var _this279$data$default;
      (_this279$data$default = _this279.data.defaultAppearanceData).fontSize || (_this279$data$default.fontSize = 10);
      var _this279$data$default2 = _this279.data.defaultAppearanceData,
        _t446 = _this279$data$default2.fontColor,
        _a297 = _this279$data$default2.fontSize;
      if (_this279._contents.str) {
        _this279.data.textContent = _this279._contents.str.split(/\r\n?|\n/).map(function (e) {
          return e.trimEnd();
        });
        var _FakeUnicodeFont$getF = FakeUnicodeFont.getFirstPositionInfo(_this279.rectangle, _this279.rotation, _a297),
          _e596 = _FakeUnicodeFont$getF.coords,
          _t447 = _FakeUnicodeFont$getF.bbox,
          _i384 = _FakeUnicodeFont$getF.matrix;
        _this279.data.textPosition = _this279._transformPoint(_e596, _t447, _i384);
      }
      if (_this279._isOffscreenCanvasSupported) {
        var _s199 = e.dict.get("CA"),
          r = new FakeUnicodeFont(i, "sans-serif");
        _this279.appearance = r.createAppearance(_this279._contents.str, _this279.rectangle, _this279.rotation, _a297, _t446, _s199);
        _this279._streams.push(_this279.appearance);
      } else warn("FreeTextAnnotation: OffscreenCanvas is not supported, annotation may not render correctly.");
    }
    return _this279;
  }
  _inherits(FreeTextAnnotation, _MarkupAnnotation2);
  return _createClass(FreeTextAnnotation, [{
    key: "hasTextContent",
    get: function get() {
      return this._hasAppearance;
    }
  }], [{
    key: "createNewDict",
    value: function createNewDict(e, t, _ref184) {
      var i = _ref184.apRef,
        a = _ref184.ap;
      var s = e.color,
        r = e.fontSize,
        n = e.oldAnnotation,
        g = e.rect,
        o = e.rotation,
        c = e.user,
        C = e.value,
        h = n || new Dict(t);
      h.set("Type", Name.get("Annot"));
      h.set("Subtype", Name.get("FreeText"));
      if (n) {
        h.set("M", "D:".concat(getModificationDate()));
        h.delete("RC");
      } else h.set("CreationDate", "D:".concat(getModificationDate()));
      h.set("Rect", g);
      var l = "/Helv ".concat(r, " Tf ").concat(getPdfColor(s, !0));
      h.set("DA", l);
      h.set("Contents", stringToAsciiOrUTF16BE(C));
      h.set("F", 4);
      h.set("Border", [0, 0, 0]);
      h.set("Rotate", o);
      c && h.set("T", stringToAsciiOrUTF16BE(c));
      if (i || a) {
        var _e597 = new Dict(t);
        h.set("AP", _e597);
        i ? _e597.set("N", i) : _e597.set("N", a);
      }
      return h;
    }
  }, {
    key: "createNewAppearanceStream",
    value: function () {
      var _createNewAppearanceStream = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee70(e, t, i) {
        var _ref185;
        var a, r, n, g, o, c, C, h, l, Q, _e598, E, _c32, u, d, f, p, m, y, w, D, b, F, _iterator205, _step205, _e600, _t450, _i385, _a298, _iterator206, _step206, _e601, S, k, R, N, G, x, U, M, L, H, J, _e599, _t448, _t449, Y, v, K;
        return _regeneratorRuntime().wrap(function _callee70$(_context82) {
          while (1) switch (_context82.prev = _context82.next) {
            case 0:
              a = i.baseFontRef, r = i.evaluator, n = i.task, g = e.color, o = e.fontSize, c = e.rect, C = e.rotation, h = e.value, l = new Dict(t), Q = new Dict(t);
              if (a) Q.set("Helv", a);else {
                _e598 = new Dict(t);
                _e598.set("BaseFont", Name.get("Helvetica"));
                _e598.set("Type", Name.get("Font"));
                _e598.set("Subtype", Name.get("Type1"));
                _e598.set("Encoding", Name.get("WinAnsiEncoding"));
                Q.set("Helv", _e598);
              }
              l.set("Font", Q);
              _context82.next = 5;
              return WidgetAnnotation._getFontData(r, n, {
                fontName: "Helv",
                fontSize: o
              }, l);
            case 5:
              E = _context82.sent;
              _c32 = _slicedToArray(c, 4);
              u = _c32[0];
              d = _c32[1];
              f = _c32[2];
              p = _c32[3];
              m = f - u, y = p - d;
              C % 180 != 0 && (_ref185 = [y, m], m = _ref185[0], y = _ref185[1], _ref185);
              w = h.split("\n"), D = o / 1e3;
              b = -1 / 0;
              F = [];
              _iterator205 = _createForOfIteratorHelper(w);
              _context82.prev = 17;
              _iterator205.s();
            case 19:
              if ((_step205 = _iterator205.n()).done) {
                _context82.next = 33;
                break;
              }
              _e600 = _step205.value;
              _t450 = E.encodeString(_e600);
              if (!(_t450.length > 1)) {
                _context82.next = 24;
                break;
              }
              return _context82.abrupt("return", null);
            case 24:
              _e600 = _t450.join("");
              F.push(_e600);
              _i385 = 0;
              _a298 = E.charsToGlyphs(_e600);
              _iterator206 = _createForOfIteratorHelper(_a298);
              try {
                for (_iterator206.s(); !(_step206 = _iterator206.n()).done;) {
                  _e601 = _step206.value;
                  _i385 += _e601.width * D;
                }
              } catch (err) {
                _iterator206.e(err);
              } finally {
                _iterator206.f();
              }
              b = Math.max(b, _i385);
            case 31:
              _context82.next = 19;
              break;
            case 33:
              _context82.next = 38;
              break;
            case 35:
              _context82.prev = 35;
              _context82.t0 = _context82["catch"](17);
              _iterator205.e(_context82.t0);
            case 38:
              _context82.prev = 38;
              _iterator205.f();
              return _context82.finish(38);
            case 41:
              S = 1;
              b > m && (S = m / b);
              k = 1;
              R = s * o, N = 1 * o, G = R * w.length;
              G > y && (k = y / G);
              x = o * Math.min(S, k);
              _context82.t1 = C;
              _context82.next = _context82.t1 === 0 ? 50 : _context82.t1 === 90 ? 54 : _context82.t1 === 180 ? 58 : _context82.t1 === 270 ? 62 : 65;
              break;
            case 50:
              L = [1, 0, 0, 1];
              M = [c[0], c[1], m, y];
              U = [c[0], c[3] - N];
              return _context82.abrupt("break", 65);
            case 54:
              L = [0, 1, -1, 0];
              M = [c[1], -c[2], m, y];
              U = [c[1], -c[0] - N];
              return _context82.abrupt("break", 65);
            case 58:
              L = [-1, 0, 0, -1];
              M = [-c[2], -c[3], m, y];
              U = [-c[2], -c[1] - N];
              return _context82.abrupt("break", 65);
            case 62:
              L = [0, -1, 1, 0];
              M = [-c[3], c[0], m, y];
              U = [-c[3], c[2] - N];
            case 65:
              H = ["q", "".concat(L.join(" "), " 0 0 cm"), "".concat(M.join(" "), " re W n"), "BT", "".concat(getPdfColor(g, !0)), "0 Tc /Helv ".concat(numberToString(x), " Tf")];
              H.push("".concat(U.join(" "), " Td (").concat(escapeString(F[0]), ") Tj"));
              J = numberToString(R);
              for (_e599 = 1, _t448 = F.length; _e599 < _t448; _e599++) {
                _t449 = F[_e599];
                H.push("0 -".concat(J, " Td (").concat(escapeString(_t449), ") Tj"));
              }
              H.push("ET", "Q");
              Y = H.join("\n"), v = new Dict(t);
              v.set("FormType", 1);
              v.set("Subtype", Name.get("Form"));
              v.set("Type", Name.get("XObject"));
              v.set("BBox", c);
              v.set("Resources", l);
              v.set("Matrix", [1, 0, 0, 1, -c[0], -c[1]]);
              K = new StringStream(Y);
              K.dict = v;
              return _context82.abrupt("return", K);
            case 80:
            case "end":
              return _context82.stop();
          }
        }, _callee70, null, [[17, 35, 38, 41]]);
      }));
      function createNewAppearanceStream(_x161, _x162, _x163) {
        return _createNewAppearanceStream.apply(this, arguments);
      }
      return createNewAppearanceStream;
    }()
  }]);
}(MarkupAnnotation);
var LineAnnotation = /*#__PURE__*/function (_MarkupAnnotation3) {
  function LineAnnotation(e) {
    var _this280;
    _classCallCheck(this, LineAnnotation);
    _this280 = _callSuper(this, LineAnnotation, [e]);
    var t = e.dict,
      i = e.xref;
    _this280.data.annotationType = G;
    _this280.data.hasOwnCanvas = _this280.data.noRotate;
    _this280.data.noHTML = !1;
    var a = lookupRect(t.getArray("L"), [0, 0, 0, 0]);
    _this280.data.lineCoordinates = Util.normalizeRect(a);
    _this280.setLineEndings(t.getArray("LE"));
    _this280.data.lineEndings = _this280.lineEndings;
    if (!_this280.appearance) {
      var _e602 = _this280.color ? getPdfColorArray(_this280.color) : [0, 0, 0],
        _s200 = t.get("CA"),
        r = getRgbColor(t.getArray("IC"), null),
        n = r ? getPdfColorArray(r) : null,
        _g77 = n ? _s200 : null,
        _o57 = _this280.borderStyle.width || 1,
        c = 2 * _o57,
        _C25 = [_this280.data.lineCoordinates[0] - c, _this280.data.lineCoordinates[1] - c, _this280.data.lineCoordinates[2] + c, _this280.data.lineCoordinates[3] + c];
      Util.intersect(_this280.rectangle, _C25) || (_this280.rectangle = _C25);
      _this280._setDefaultAppearance({
        xref: i,
        extra: "".concat(_o57, " w"),
        strokeColor: _e602,
        fillColor: n,
        strokeAlpha: _s200,
        fillAlpha: _g77,
        pointsCallback: function pointsCallback(e, t) {
          e.push("".concat(a[0], " ").concat(a[1], " m"), "".concat(a[2], " ").concat(a[3], " l"), "S");
          return [t[0] - _o57, t[2] + _o57, t[7] - _o57, t[3] + _o57];
        }
      });
    }
    return _this280;
  }
  _inherits(LineAnnotation, _MarkupAnnotation3);
  return _createClass(LineAnnotation);
}(MarkupAnnotation);
var SquareAnnotation = /*#__PURE__*/function (_MarkupAnnotation4) {
  function SquareAnnotation(e) {
    var _this281;
    _classCallCheck(this, SquareAnnotation);
    _this281 = _callSuper(this, SquareAnnotation, [e]);
    var t = e.dict,
      i = e.xref;
    _this281.data.annotationType = x;
    _this281.data.hasOwnCanvas = _this281.data.noRotate;
    _this281.data.noHTML = !1;
    if (!_this281.appearance) {
      var _e603 = _this281.color ? getPdfColorArray(_this281.color) : [0, 0, 0],
        _a299 = t.get("CA"),
        _s201 = getRgbColor(t.getArray("IC"), null),
        r = _s201 ? getPdfColorArray(_s201) : null,
        n = r ? _a299 : null;
      if (0 === _this281.borderStyle.width && !r) return _possibleConstructorReturn(_this281);
      _this281._setDefaultAppearance({
        xref: i,
        extra: "".concat(_this281.borderStyle.width, " w"),
        strokeColor: _e603,
        fillColor: r,
        strokeAlpha: _a299,
        fillAlpha: n,
        pointsCallback: function pointsCallback(e, t) {
          var i = t[4] + _this281.borderStyle.width / 2,
            a = t[5] + _this281.borderStyle.width / 2,
            s = t[6] - t[4] - _this281.borderStyle.width,
            n = t[3] - t[7] - _this281.borderStyle.width;
          e.push("".concat(i, " ").concat(a, " ").concat(s, " ").concat(n, " re"));
          r ? e.push("B") : e.push("S");
          return [t[0], t[2], t[7], t[3]];
        }
      });
    }
    return _this281;
  }
  _inherits(SquareAnnotation, _MarkupAnnotation4);
  return _createClass(SquareAnnotation);
}(MarkupAnnotation);
var CircleAnnotation = /*#__PURE__*/function (_MarkupAnnotation5) {
  function CircleAnnotation(e) {
    var _this282;
    _classCallCheck(this, CircleAnnotation);
    _this282 = _callSuper(this, CircleAnnotation, [e]);
    var t = e.dict,
      i = e.xref;
    _this282.data.annotationType = U;
    if (!_this282.appearance) {
      var _e604 = _this282.color ? getPdfColorArray(_this282.color) : [0, 0, 0],
        _a300 = t.get("CA"),
        _s202 = getRgbColor(t.getArray("IC"), null),
        r = _s202 ? getPdfColorArray(_s202) : null,
        n = r ? _a300 : null;
      if (0 === _this282.borderStyle.width && !r) return _possibleConstructorReturn(_this282);
      var _g78 = 4 / 3 * Math.tan(Math.PI / 8);
      _this282._setDefaultAppearance({
        xref: i,
        extra: "".concat(_this282.borderStyle.width, " w"),
        strokeColor: _e604,
        fillColor: r,
        strokeAlpha: _a300,
        fillAlpha: n,
        pointsCallback: function pointsCallback(e, t) {
          var i = t[0] + _this282.borderStyle.width / 2,
            a = t[1] - _this282.borderStyle.width / 2,
            s = t[6] - _this282.borderStyle.width / 2,
            n = t[7] + _this282.borderStyle.width / 2,
            o = i + (s - i) / 2,
            c = a + (n - a) / 2,
            C = (s - i) / 2 * _g78,
            h = (n - a) / 2 * _g78;
          e.push("".concat(o, " ").concat(n, " m"), "".concat(o + C, " ").concat(n, " ").concat(s, " ").concat(c + h, " ").concat(s, " ").concat(c, " c"), "".concat(s, " ").concat(c - h, " ").concat(o + C, " ").concat(a, " ").concat(o, " ").concat(a, " c"), "".concat(o - C, " ").concat(a, " ").concat(i, " ").concat(c - h, " ").concat(i, " ").concat(c, " c"), "".concat(i, " ").concat(c + h, " ").concat(o - C, " ").concat(n, " ").concat(o, " ").concat(n, " c"), "h");
          r ? e.push("B") : e.push("S");
          return [t[0], t[2], t[7], t[3]];
        }
      });
    }
    return _this282;
  }
  _inherits(CircleAnnotation, _MarkupAnnotation5);
  return _createClass(CircleAnnotation);
}(MarkupAnnotation);
var PolylineAnnotation = /*#__PURE__*/function (_MarkupAnnotation6) {
  function PolylineAnnotation(e) {
    var _this283;
    _classCallCheck(this, PolylineAnnotation);
    _this283 = _callSuper(this, PolylineAnnotation, [e]);
    var t = e.dict,
      i = e.xref;
    _this283.data.annotationType = L;
    _this283.data.hasOwnCanvas = _this283.data.noRotate;
    _this283.data.noHTML = !1;
    _this283.data.vertices = null;
    if (!(_this283 instanceof PolygonAnnotation)) {
      _this283.setLineEndings(t.getArray("LE"));
      _this283.data.lineEndings = _this283.lineEndings;
    }
    var a = t.getArray("Vertices");
    if (!isNumberArray(a, null)) return _possibleConstructorReturn(_this283);
    var s = _this283.data.vertices = Float32Array.from(a);
    if (!_this283.appearance) {
      var _e605 = _this283.color ? getPdfColorArray(_this283.color) : [0, 0, 0],
        _a301 = t.get("CA"),
        r = _this283.borderStyle.width || 1,
        n = 2 * r,
        _g79 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
      for (var _e606 = 0, _t451 = s.length; _e606 < _t451; _e606 += 2) {
        _g79[0] = Math.min(_g79[0], s[_e606] - n);
        _g79[1] = Math.min(_g79[1], s[_e606 + 1] - n);
        _g79[2] = Math.max(_g79[2], s[_e606] + n);
        _g79[3] = Math.max(_g79[3], s[_e606 + 1] + n);
      }
      Util.intersect(_this283.rectangle, _g79) || (_this283.rectangle = _g79);
      _this283._setDefaultAppearance({
        xref: i,
        extra: "".concat(r, " w"),
        strokeColor: _e605,
        strokeAlpha: _a301,
        pointsCallback: function pointsCallback(e, t) {
          for (var _t452 = 0, _i386 = s.length; _t452 < _i386; _t452 += 2) e.push("".concat(s[_t452], " ").concat(s[_t452 + 1], " ").concat(0 === _t452 ? "m" : "l"));
          e.push("S");
          return [t[0], t[2], t[7], t[3]];
        }
      });
    }
    return _this283;
  }
  _inherits(PolylineAnnotation, _MarkupAnnotation6);
  return _createClass(PolylineAnnotation);
}(MarkupAnnotation);
var PolygonAnnotation = /*#__PURE__*/function (_PolylineAnnotation) {
  function PolygonAnnotation(e) {
    var _this284;
    _classCallCheck(this, PolygonAnnotation);
    _this284 = _callSuper(this, PolygonAnnotation, [e]);
    _this284.data.annotationType = M;
    return _this284;
  }
  _inherits(PolygonAnnotation, _PolylineAnnotation);
  return _createClass(PolygonAnnotation);
}(PolylineAnnotation);
var CaretAnnotation = /*#__PURE__*/function (_MarkupAnnotation7) {
  function CaretAnnotation(e) {
    var _this285;
    _classCallCheck(this, CaretAnnotation);
    _this285 = _callSuper(this, CaretAnnotation, [e]);
    _this285.data.annotationType = T;
    return _this285;
  }
  _inherits(CaretAnnotation, _MarkupAnnotation7);
  return _createClass(CaretAnnotation);
}(MarkupAnnotation);
var InkAnnotation = /*#__PURE__*/function (_MarkupAnnotation8) {
  function InkAnnotation(e) {
    var _this286;
    _classCallCheck(this, InkAnnotation);
    _this286 = _callSuper(this, InkAnnotation, [e]);
    _this286.data.hasOwnCanvas = _this286.data.noRotate;
    _this286.data.noHTML = !1;
    var t = e.dict,
      i = e.xref;
    _this286.data.annotationType = q;
    _this286.data.inkLists = [];
    _this286.data.isEditable = !_this286.data.noHTML && "InkHighlight" === _this286.data.it;
    _this286.data.noHTML = !1;
    _this286.data.opacity = t.get("CA") || 1;
    var a = t.getArray("InkList");
    if (Array.isArray(a)) {
      for (var _e607 = 0, _t453 = a.length; _e607 < _t453; ++_e607) {
        if (!Array.isArray(a[_e607])) continue;
        var _t454 = new Float32Array(a[_e607].length);
        _this286.data.inkLists.push(_t454);
        for (var _s203 = 0, r = a[_e607].length; _s203 < r; _s203 += 2) {
          var _r158 = i.fetchIfRef(a[_e607][_s203]),
            n = i.fetchIfRef(a[_e607][_s203 + 1]);
          if ("number" == typeof _r158 && "number" == typeof n) {
            _t454[_s203] = _r158;
            _t454[_s203 + 1] = n;
          }
        }
      }
      if (!_this286.appearance) {
        var _e608 = _this286.color ? getPdfColorArray(_this286.color) : [0, 0, 0],
          _a302 = t.get("CA"),
          _s204 = _this286.borderStyle.width || 1,
          _r159 = 2 * _s204,
          _n107 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
        var _iterator207 = _createForOfIteratorHelper(_this286.data.inkLists),
          _step207;
        try {
          for (_iterator207.s(); !(_step207 = _iterator207.n()).done;) {
            var _e609 = _step207.value;
            for (var _t456 = 0, _i388 = _e609.length; _t456 < _i388; _t456 += 2) {
              _n107[0] = Math.min(_n107[0], _e609[_t456] - _r159);
              _n107[1] = Math.min(_n107[1], _e609[_t456 + 1] - _r159);
              _n107[2] = Math.max(_n107[2], _e609[_t456] + _r159);
              _n107[3] = Math.max(_n107[3], _e609[_t456 + 1] + _r159);
            }
          }
        } catch (err) {
          _iterator207.e(err);
        } finally {
          _iterator207.f();
        }
        Util.intersect(_this286.rectangle, _n107) || (_this286.rectangle = _n107);
        _this286._setDefaultAppearance({
          xref: i,
          extra: "".concat(_s204, " w"),
          strokeColor: _e608,
          strokeAlpha: _a302,
          pointsCallback: function pointsCallback(e, t) {
            var _iterator208 = _createForOfIteratorHelper(_this286.data.inkLists),
              _step208;
            try {
              for (_iterator208.s(); !(_step208 = _iterator208.n()).done;) {
                var _t455 = _step208.value;
                for (var _i387 = 0, _a303 = _t455.length; _i387 < _a303; _i387 += 2) e.push("".concat(_t455[_i387], " ").concat(_t455[_i387 + 1], " ").concat(0 === _i387 ? "m" : "l"));
                e.push("S");
              }
            } catch (err) {
              _iterator208.e(err);
            } finally {
              _iterator208.f();
            }
            return [t[0], t[2], t[7], t[3]];
          }
        });
      }
    }
    return _this286;
  }
  _inherits(InkAnnotation, _MarkupAnnotation8);
  return _createClass(InkAnnotation, null, [{
    key: "createNewDict",
    value: function createNewDict(e, t, _ref186) {
      var i = _ref186.apRef,
        a = _ref186.ap;
      var s = e.color,
        r = e.opacity,
        n = e.paths,
        g = e.outlines,
        o = e.rect,
        c = e.rotation,
        C = e.thickness,
        h = new Dict(t);
      h.set("Type", Name.get("Annot"));
      h.set("Subtype", Name.get("Ink"));
      h.set("CreationDate", "D:".concat(getModificationDate()));
      h.set("Rect", o);
      h.set("InkList", (g === null || g === void 0 ? void 0 : g.points) || n.map(function (e) {
        return e.points;
      }));
      h.set("F", 4);
      h.set("Rotate", c);
      g && h.set("IT", Name.get("InkHighlight"));
      var l = new Dict(t);
      h.set("BS", l);
      l.set("W", C);
      h.set("C", Array.from(s, function (e) {
        return e / 255;
      }));
      h.set("CA", r);
      var Q = new Dict(t);
      h.set("AP", Q);
      i ? Q.set("N", i) : Q.set("N", a);
      return h;
    }
  }, {
    key: "createNewAppearanceStream",
    value: function () {
      var _createNewAppearanceStream2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee71(e, t, i) {
        var a, s, r, n, g, o, c, _iterator209, _step209, _ref187, _e611, _t457, _i390, _i391, C, h, _e610, _i389, _a304, l;
        return _regeneratorRuntime().wrap(function _callee71$(_context83) {
          while (1) switch (_context83.prev = _context83.next) {
            case 0:
              if (!e.outlines) {
                _context83.next = 2;
                break;
              }
              return _context83.abrupt("return", this.createNewAppearanceStreamForHighlight(e, t, i));
            case 2:
              a = e.color, s = e.rect, r = e.paths, n = e.thickness, g = e.opacity, o = ["".concat(n, " w 1 J 1 j"), "".concat(getPdfColor(a, !1))];
              1 !== g && o.push("/R0 gs");
              c = [];
              _iterator209 = _createForOfIteratorHelper(r);
              try {
                for (_iterator209.s(); !(_step209 = _iterator209.n()).done;) {
                  _ref187 = _step209.value;
                  _e611 = _ref187.bezier;
                  c.length = 0;
                  c.push("".concat(numberToString(_e611[0]), " ").concat(numberToString(_e611[1]), " m"));
                  if (2 === _e611.length) c.push("".concat(numberToString(_e611[0]), " ").concat(numberToString(_e611[1]), " l S"));else {
                    for (_t457 = 2, _i390 = _e611.length; _t457 < _i390; _t457 += 6) {
                      _i391 = _e611.slice(_t457, _t457 + 6).map(numberToString).join(" ");
                      c.push("".concat(_i391, " c"));
                    }
                    c.push("S");
                  }
                  o.push(c.join("\n"));
                }
              } catch (err) {
                _iterator209.e(err);
              } finally {
                _iterator209.f();
              }
              C = o.join("\n"), h = new Dict(t);
              h.set("FormType", 1);
              h.set("Subtype", Name.get("Form"));
              h.set("Type", Name.get("XObject"));
              h.set("BBox", s);
              h.set("Length", C.length);
              if (1 !== g) {
                _e610 = new Dict(t), _i389 = new Dict(t), _a304 = new Dict(t);
                _a304.set("CA", g);
                _a304.set("Type", Name.get("ExtGState"));
                _i389.set("R0", _a304);
                _e610.set("ExtGState", _i389);
                h.set("Resources", _e610);
              }
              l = new StringStream(C);
              l.dict = h;
              return _context83.abrupt("return", l);
            case 17:
            case "end":
              return _context83.stop();
          }
        }, _callee71, this);
      }));
      function createNewAppearanceStream(_x164, _x165, _x166) {
        return _createNewAppearanceStream2.apply(this, arguments);
      }
      return createNewAppearanceStream;
    }()
  }, {
    key: "createNewAppearanceStreamForHighlight",
    value: function () {
      var _createNewAppearanceStreamForHighlight = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee72(e, t, i) {
        var a, s, r, n, g, _e612, _t458, _t459, o, c, C, h, l, Q;
        return _regeneratorRuntime().wrap(function _callee72$(_context84) {
          while (1) switch (_context84.prev = _context84.next) {
            case 0:
              a = e.color, s = e.rect, r = e.outlines.outline, n = e.opacity, g = ["".concat(getPdfColor(a, !0)), "/R0 gs"];
              g.push("".concat(numberToString(r[4]), " ").concat(numberToString(r[5]), " m"));
              for (_e612 = 6, _t458 = r.length; _e612 < _t458; _e612 += 6) if (isNaN(r[_e612]) || null === r[_e612]) g.push("".concat(numberToString(r[_e612 + 4]), " ").concat(numberToString(r[_e612 + 5]), " l"));else {
                _t459 = r.slice(_e612, _e612 + 6).map(numberToString).join(" ");
                g.push("".concat(_t459, " c"));
              }
              g.push("h f");
              o = g.join("\n"), c = new Dict(t);
              c.set("FormType", 1);
              c.set("Subtype", Name.get("Form"));
              c.set("Type", Name.get("XObject"));
              c.set("BBox", s);
              c.set("Length", o.length);
              C = new Dict(t), h = new Dict(t);
              C.set("ExtGState", h);
              c.set("Resources", C);
              l = new Dict(t);
              h.set("R0", l);
              l.set("BM", Name.get("Multiply"));
              if (1 !== n) {
                l.set("ca", n);
                l.set("Type", Name.get("ExtGState"));
              }
              Q = new StringStream(o);
              Q.dict = c;
              return _context84.abrupt("return", Q);
            case 20:
            case "end":
              return _context84.stop();
          }
        }, _callee72);
      }));
      function createNewAppearanceStreamForHighlight(_x167, _x168, _x169) {
        return _createNewAppearanceStreamForHighlight.apply(this, arguments);
      }
      return createNewAppearanceStreamForHighlight;
    }()
  }]);
}(MarkupAnnotation);
var HighlightAnnotation = /*#__PURE__*/function (_MarkupAnnotation9) {
  function HighlightAnnotation(e) {
    var _this287;
    _classCallCheck(this, HighlightAnnotation);
    _this287 = _callSuper(this, HighlightAnnotation, [e]);
    var t = e.dict,
      i = e.xref;
    _this287.data.annotationType = H;
    _this287.data.isEditable = !_this287.data.noHTML;
    _this287.data.noHTML = !1;
    _this287.data.opacity = t.get("CA") || 1;
    if (_this287.data.quadPoints = getQuadPoints(t, null)) {
      var _this287$appearance;
      var _e613 = (_this287$appearance = _this287.appearance) === null || _this287$appearance === void 0 ? void 0 : _this287$appearance.dict.get("Resources");
      if (!_this287.appearance || !(_e613 !== null && _e613 !== void 0 && _e613.has("ExtGState"))) {
        _this287.appearance && warn("HighlightAnnotation - ignoring built-in appearance stream.");
        var _e614 = _this287.color ? getPdfColorArray(_this287.color) : [1, 1, 0],
          _a305 = t.get("CA");
        _this287._setDefaultAppearance({
          xref: i,
          fillColor: _e614,
          blendMode: "Multiply",
          fillAlpha: _a305,
          pointsCallback: function pointsCallback(e, t) {
            e.push("".concat(t[0], " ").concat(t[1], " m"), "".concat(t[2], " ").concat(t[3], " l"), "".concat(t[6], " ").concat(t[7], " l"), "".concat(t[4], " ").concat(t[5], " l"), "f");
            return [t[0], t[2], t[7], t[3]];
          }
        });
      }
    } else _this287.data.popupRef = null;
    return _this287;
  }
  _inherits(HighlightAnnotation, _MarkupAnnotation9);
  return _createClass(HighlightAnnotation, null, [{
    key: "createNewDict",
    value: function createNewDict(e, t, _ref188) {
      var i = _ref188.apRef,
        a = _ref188.ap;
      var s = e.color,
        r = e.oldAnnotation,
        n = e.opacity,
        g = e.rect,
        o = e.rotation,
        c = e.user,
        C = e.quadPoints,
        h = r || new Dict(t);
      h.set("Type", Name.get("Annot"));
      h.set("Subtype", Name.get("Highlight"));
      h.set(r ? "M" : "CreationDate", "D:".concat(getModificationDate()));
      h.set("CreationDate", "D:".concat(getModificationDate()));
      h.set("Rect", g);
      h.set("F", 4);
      h.set("Border", [0, 0, 0]);
      h.set("Rotate", o);
      h.set("QuadPoints", C);
      h.set("C", Array.from(s, function (e) {
        return e / 255;
      }));
      h.set("CA", n);
      c && h.set("T", stringToAsciiOrUTF16BE(c));
      if (i || a) {
        var _e615 = new Dict(t);
        h.set("AP", _e615);
        _e615.set("N", i || a);
      }
      return h;
    }
  }, {
    key: "createNewAppearanceStream",
    value: function () {
      var _createNewAppearanceStream3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee73(e, t, i) {
        var a, s, r, n, g, o, _iterator210, _step210, _e616, _t460, _i392, c, C, h, l, Q, E;
        return _regeneratorRuntime().wrap(function _callee73$(_context85) {
          while (1) switch (_context85.prev = _context85.next) {
            case 0:
              a = e.color, s = e.rect, r = e.outlines, n = e.opacity, g = ["".concat(getPdfColor(a, !0)), "/R0 gs"], o = [];
              _iterator210 = _createForOfIteratorHelper(r);
              try {
                for (_iterator210.s(); !(_step210 = _iterator210.n()).done;) {
                  _e616 = _step210.value;
                  o.length = 0;
                  o.push("".concat(numberToString(_e616[0]), " ").concat(numberToString(_e616[1]), " m"));
                  for (_t460 = 2, _i392 = _e616.length; _t460 < _i392; _t460 += 2) o.push("".concat(numberToString(_e616[_t460]), " ").concat(numberToString(_e616[_t460 + 1]), " l"));
                  o.push("h");
                  g.push(o.join("\n"));
                }
              } catch (err) {
                _iterator210.e(err);
              } finally {
                _iterator210.f();
              }
              g.push("f*");
              c = g.join("\n"), C = new Dict(t);
              C.set("FormType", 1);
              C.set("Subtype", Name.get("Form"));
              C.set("Type", Name.get("XObject"));
              C.set("BBox", s);
              C.set("Length", c.length);
              h = new Dict(t), l = new Dict(t);
              h.set("ExtGState", l);
              C.set("Resources", h);
              Q = new Dict(t);
              l.set("R0", Q);
              Q.set("BM", Name.get("Multiply"));
              if (1 !== n) {
                Q.set("ca", n);
                Q.set("Type", Name.get("ExtGState"));
              }
              E = new StringStream(c);
              E.dict = C;
              return _context85.abrupt("return", E);
            case 20:
            case "end":
              return _context85.stop();
          }
        }, _callee73);
      }));
      function createNewAppearanceStream(_x170, _x171, _x172) {
        return _createNewAppearanceStream3.apply(this, arguments);
      }
      return createNewAppearanceStream;
    }()
  }]);
}(MarkupAnnotation);
var UnderlineAnnotation = /*#__PURE__*/function (_MarkupAnnotation10) {
  function UnderlineAnnotation(e) {
    var _this288;
    _classCallCheck(this, UnderlineAnnotation);
    _this288 = _callSuper(this, UnderlineAnnotation, [e]);
    var t = e.dict,
      i = e.xref;
    _this288.data.annotationType = J;
    if (_this288.data.quadPoints = getQuadPoints(t, null)) {
      if (!_this288.appearance) {
        var _e617 = _this288.color ? getPdfColorArray(_this288.color) : [0, 0, 0],
          _a306 = t.get("CA");
        _this288._setDefaultAppearance({
          xref: i,
          extra: "[] 0 d 0.571 w",
          strokeColor: _e617,
          strokeAlpha: _a306,
          pointsCallback: function pointsCallback(e, t) {
            e.push("".concat(t[4], " ").concat(t[5] + 1.3, " m"), "".concat(t[6], " ").concat(t[7] + 1.3, " l"), "S");
            return [t[0], t[2], t[7], t[3]];
          }
        });
      }
    } else _this288.data.popupRef = null;
    return _this288;
  }
  _inherits(UnderlineAnnotation, _MarkupAnnotation10);
  return _createClass(UnderlineAnnotation);
}(MarkupAnnotation);
var SquigglyAnnotation = /*#__PURE__*/function (_MarkupAnnotation11) {
  function SquigglyAnnotation(e) {
    var _this289;
    _classCallCheck(this, SquigglyAnnotation);
    _this289 = _callSuper(this, SquigglyAnnotation, [e]);
    var t = e.dict,
      i = e.xref;
    _this289.data.annotationType = Y;
    if (_this289.data.quadPoints = getQuadPoints(t, null)) {
      if (!_this289.appearance) {
        var _e618 = _this289.color ? getPdfColorArray(_this289.color) : [0, 0, 0],
          _a307 = t.get("CA");
        _this289._setDefaultAppearance({
          xref: i,
          extra: "[] 0 d 1 w",
          strokeColor: _e618,
          strokeAlpha: _a307,
          pointsCallback: function pointsCallback(e, t) {
            var i = (t[1] - t[5]) / 6;
            var a = i,
              s = t[4];
            var r = t[5],
              n = t[6];
            e.push("".concat(s, " ").concat(r + a, " m"));
            do {
              s += 2;
              a = 0 === a ? i : 0;
              e.push("".concat(s, " ").concat(r + a, " l"));
            } while (s < n);
            e.push("S");
            return [t[4], n, r - 2 * i, r + 2 * i];
          }
        });
      }
    } else _this289.data.popupRef = null;
    return _this289;
  }
  _inherits(SquigglyAnnotation, _MarkupAnnotation11);
  return _createClass(SquigglyAnnotation);
}(MarkupAnnotation);
var StrikeOutAnnotation = /*#__PURE__*/function (_MarkupAnnotation12) {
  function StrikeOutAnnotation(e) {
    var _this290;
    _classCallCheck(this, StrikeOutAnnotation);
    _this290 = _callSuper(this, StrikeOutAnnotation, [e]);
    var t = e.dict,
      i = e.xref;
    _this290.data.annotationType = v;
    if (_this290.data.quadPoints = getQuadPoints(t, null)) {
      if (!_this290.appearance) {
        var _e619 = _this290.color ? getPdfColorArray(_this290.color) : [0, 0, 0],
          _a308 = t.get("CA");
        _this290._setDefaultAppearance({
          xref: i,
          extra: "[] 0 d 1 w",
          strokeColor: _e619,
          strokeAlpha: _a308,
          pointsCallback: function pointsCallback(e, t) {
            e.push((t[0] + t[4]) / 2 + " " + (t[1] + t[5]) / 2 + " m", (t[2] + t[6]) / 2 + " " + (t[3] + t[7]) / 2 + " l", "S");
            return [t[0], t[2], t[7], t[3]];
          }
        });
      }
    } else _this290.data.popupRef = null;
    return _this290;
  }
  _inherits(StrikeOutAnnotation, _MarkupAnnotation12);
  return _createClass(StrikeOutAnnotation);
}(MarkupAnnotation);
var _W = /*#__PURE__*/_classPrivateFieldLooseKey("W");
var StampAnnotation = /*#__PURE__*/function (_MarkupAnnotation13) {
  function StampAnnotation(e) {
    var _this291;
    _classCallCheck(this, StampAnnotation);
    _this291 = _callSuper(this, StampAnnotation, [e]);
    Object.defineProperty(_this291, _W, {
      writable: true,
      value: void 0
    });
    _this291.data.annotationType = K;
    _classPrivateFieldLooseBase(_this291, _W)[_W] = _this291.data.hasOwnCanvas = _this291.data.noRotate;
    _this291.data.isEditable = !_this291.data.noHTML;
    _this291.data.noHTML = !1;
    return _this291;
  }
  _inherits(StampAnnotation, _MarkupAnnotation13);
  return _createClass(StampAnnotation, [{
    key: "mustBeViewedWhenEditing",
    value: function mustBeViewedWhenEditing(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (e) {
        if (!this.data.isEditable) return !1;
        _classPrivateFieldLooseBase(this, _W)[_W] = this.data.hasOwnCanvas;
        this.data.hasOwnCanvas = !0;
        return !0;
      }
      this.data.hasOwnCanvas = _classPrivateFieldLooseBase(this, _W)[_W];
      return !(t !== null && t !== void 0 && t.has(this.data.id));
    }
  }], [{
    key: "createImage",
    value: function () {
      var _createImage4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee74(e, t) {
        var i, a, s, r, n, g, o, c, C, h, l, Q, _e620, _t461, _i393, _t462, _i394, _s205;
        return _regeneratorRuntime().wrap(function _callee74$(_context86) {
          while (1) switch (_context86.prev = _context86.next) {
            case 0:
              i = e.width, a = e.height, s = new OffscreenCanvas(i, a), r = s.getContext("2d", {
                alpha: !0
              });
              r.drawImage(e, 0, 0);
              n = r.getImageData(0, 0, i, a).data, g = new Uint32Array(n.buffer), o = g.some(FeatureTest.isLittleEndian ? function (e) {
                return e >>> 24 != 255;
              } : function (e) {
                return 255 != (255 & e);
              });
              if (o) {
                r.fillStyle = "white";
                r.fillRect(0, 0, i, a);
                r.drawImage(e, 0, 0);
              }
              c = s.convertToBlob({
                type: "image/jpeg",
                quality: 1
              }).then(function (e) {
                return e.arrayBuffer();
              }), C = Name.get("XObject"), h = Name.get("Image"), l = new Dict(t);
              l.set("Type", C);
              l.set("Subtype", h);
              l.set("BitsPerComponent", 8);
              l.set("ColorSpace", Name.get("DeviceRGB"));
              l.set("Filter", Name.get("DCTDecode"));
              l.set("BBox", [0, 0, i, a]);
              l.set("Width", i);
              l.set("Height", a);
              Q = null;
              if (o) {
                _e620 = new Uint8Array(g.length);
                if (FeatureTest.isLittleEndian) for (_t461 = 0, _i393 = g.length; _t461 < _i393; _t461++) _e620[_t461] = g[_t461] >>> 24;else for (_t462 = 0, _i394 = g.length; _t462 < _i394; _t462++) _e620[_t462] = 255 & g[_t462];
                _s205 = new Dict(t);
                _s205.set("Type", C);
                _s205.set("Subtype", h);
                _s205.set("BitsPerComponent", 8);
                _s205.set("ColorSpace", Name.get("DeviceGray"));
                _s205.set("Width", i);
                _s205.set("Height", a);
                Q = new Stream(_e620, 0, 0, _s205);
              }
              _context86.t0 = Stream;
              _context86.next = 18;
              return c;
            case 18:
              _context86.t1 = _context86.sent;
              _context86.t2 = l;
              _context86.t3 = new _context86.t0(_context86.t1, 0, 0, _context86.t2);
              _context86.t4 = Q;
              _context86.t5 = i;
              _context86.t6 = a;
              return _context86.abrupt("return", {
                imageStream: _context86.t3,
                smaskStream: _context86.t4,
                width: _context86.t5,
                height: _context86.t6
              });
            case 25:
            case "end":
              return _context86.stop();
          }
        }, _callee74);
      }));
      function createImage(_x173, _x174) {
        return _createImage4.apply(this, arguments);
      }
      return createImage;
    }()
  }, {
    key: "createNewDict",
    value: function createNewDict(e, t, _ref189) {
      var i = _ref189.apRef,
        a = _ref189.ap;
      var s = e.oldAnnotation,
        r = e.rect,
        n = e.rotation,
        g = e.user,
        o = s || new Dict(t);
      o.set("Type", Name.get("Annot"));
      o.set("Subtype", Name.get("Stamp"));
      o.set(s ? "M" : "CreationDate", "D:".concat(getModificationDate()));
      o.set("CreationDate", "D:".concat(getModificationDate()));
      o.set("Rect", r);
      o.set("F", 4);
      o.set("Border", [0, 0, 0]);
      o.set("Rotate", n);
      g && o.set("T", stringToAsciiOrUTF16BE(g));
      if (i || a) {
        var _e621 = new Dict(t);
        o.set("AP", _e621);
        i ? _e621.set("N", i) : _e621.set("N", a);
      }
      return o;
    }
  }, {
    key: "createNewAppearanceStream",
    value: function () {
      var _createNewAppearanceStream4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee75(e, t, i) {
        var a, _i$image, s, r, n, g, o, c, C, _e622, h;
        return _regeneratorRuntime().wrap(function _callee75$(_context87) {
          while (1) switch (_context87.prev = _context87.next) {
            case 0:
              if (!e.oldAnnotation) {
                _context87.next = 2;
                break;
              }
              return _context87.abrupt("return", null);
            case 2:
              a = e.rotation, _i$image = i.image, s = _i$image.imageRef, r = _i$image.width, n = _i$image.height, g = new Dict(t), o = new Dict(t);
              g.set("XObject", o);
              o.set("Im0", s);
              c = "q ".concat(r, " 0 0 ").concat(n, " 0 0 cm /Im0 Do Q"), C = new Dict(t);
              C.set("FormType", 1);
              C.set("Subtype", Name.get("Form"));
              C.set("Type", Name.get("XObject"));
              C.set("BBox", [0, 0, r, n]);
              C.set("Resources", g);
              if (a) {
                _e622 = _getRotationMatrix(a, r, n);
                C.set("Matrix", _e622);
              }
              h = new StringStream(c);
              h.dict = C;
              return _context87.abrupt("return", h);
            case 15:
            case "end":
              return _context87.stop();
          }
        }, _callee75);
      }));
      function createNewAppearanceStream(_x175, _x176, _x177) {
        return _createNewAppearanceStream4.apply(this, arguments);
      }
      return createNewAppearanceStream;
    }()
  }]);
}(MarkupAnnotation);
var FileAttachmentAnnotation = /*#__PURE__*/function (_MarkupAnnotation14) {
  function FileAttachmentAnnotation(e) {
    var _this292;
    _classCallCheck(this, FileAttachmentAnnotation);
    _this292 = _callSuper(this, FileAttachmentAnnotation, [e]);
    var t = e.dict,
      i = e.xref,
      a = new FileSpec(t.get("FS"), i);
    _this292.data.annotationType = W;
    _this292.data.hasOwnCanvas = _this292.data.noRotate;
    _this292.data.noHTML = !1;
    _this292.data.file = a.serializable;
    var s = t.get("Name");
    _this292.data.name = s instanceof Name ? stringToPDFString(s.name) : "PushPin";
    var r = t.get("ca");
    _this292.data.fillAlpha = "number" == typeof r && r >= 0 && r <= 1 ? r : null;
    return _this292;
  }
  _inherits(FileAttachmentAnnotation, _MarkupAnnotation14);
  return _createClass(FileAttachmentAnnotation);
}(MarkupAnnotation);
function decodeString(e) {
  try {
    return stringToUTF8String(e);
  } catch (t) {
    warn("UTF-8 decoding failed: \"".concat(t, "\"."));
    return e;
  }
}
var DatasetXMLParser = /*#__PURE__*/function (_SimpleXMLParser) {
  function DatasetXMLParser(e) {
    var _this293;
    _classCallCheck(this, DatasetXMLParser);
    _this293 = _callSuper(this, DatasetXMLParser, [e]);
    _this293.node = null;
    return _this293;
  }
  _inherits(DatasetXMLParser, _SimpleXMLParser);
  return _createClass(DatasetXMLParser, [{
    key: "onEndElement",
    value: function onEndElement(e) {
      var t = _superPropGet(DatasetXMLParser, "onEndElement", this, 3)([e]);
      if (t && "xfa:datasets" === e) {
        this.node = t;
        throw new Error("Aborting DatasetXMLParser.");
      }
    }
  }]);
}(SimpleXMLParser);
var DatasetReader = /*#__PURE__*/function () {
  function DatasetReader(e) {
    _classCallCheck(this, DatasetReader);
    if (e.datasets) this.node = new SimpleXMLParser({
      hasAttributes: !0
    }).parseFromString(e.datasets).documentElement;else {
      var _t463 = new DatasetXMLParser({
        hasAttributes: !0
      });
      try {
        _t463.parseFromString(e["xdp:xdp"]);
      } catch (_unused14) {}
      this.node = _t463.node;
    }
  }
  return _createClass(DatasetReader, [{
    key: "getValue",
    value: function getValue(e) {
      if (!this.node || !e) return "";
      var t = this.node.searchNode(parseXFAPath(e), 0);
      if (!t) return "";
      var i = t.firstChild;
      return "value" === (i === null || i === void 0 ? void 0 : i.nodeName) ? t.children.map(function (e) {
        return decodeString(e.textContent);
      }) : decodeString(t.textContent);
    }
  }]);
}();
var _j = /*#__PURE__*/_classPrivateFieldLooseKey("j");
var XRef = /*#__PURE__*/function () {
  function XRef(e, t) {
    _classCallCheck(this, XRef);
    Object.defineProperty(this, _j, {
      writable: true,
      value: null
    });
    this.stream = e;
    this.pdfManager = t;
    this.entries = [];
    this._xrefStms = new Set();
    this._cacheMap = new Map();
    this._pendingRefs = new RefSet();
    this._newPersistentRefNum = null;
    this._newTemporaryRefNum = null;
    this._persistentRefsCache = null;
  }
  return _createClass(XRef, [{
    key: "getNewPersistentRef",
    value: function getNewPersistentRef(e) {
      null === this._newPersistentRefNum && (this._newPersistentRefNum = this.entries.length || 1);
      var t = this._newPersistentRefNum++;
      this._cacheMap.set(t, e);
      return Ref.get(t, 0);
    }
  }, {
    key: "getNewTemporaryRef",
    value: function getNewTemporaryRef() {
      if (null === this._newTemporaryRefNum) {
        this._newTemporaryRefNum = this.entries.length || 1;
        if (this._newPersistentRefNum) {
          this._persistentRefsCache = new Map();
          for (var _e623 = this._newTemporaryRefNum; _e623 < this._newPersistentRefNum; _e623++) {
            this._persistentRefsCache.set(_e623, this._cacheMap.get(_e623));
            this._cacheMap.delete(_e623);
          }
        }
      }
      return Ref.get(this._newTemporaryRefNum++, 0);
    }
  }, {
    key: "resetNewTemporaryRef",
    value: function resetNewTemporaryRef() {
      this._newTemporaryRefNum = null;
      if (this._persistentRefsCache) {
        var _iterator211 = _createForOfIteratorHelper(this._persistentRefsCache),
          _step211;
        try {
          for (_iterator211.s(); !(_step211 = _iterator211.n()).done;) {
            var _ref190 = _step211.value;
            var _ref191 = _slicedToArray(_ref190, 2);
            var _e624 = _ref191[0];
            var _t464 = _ref191[1];
            this._cacheMap.set(_e624, _t464);
          }
        } catch (err) {
          _iterator211.e(err);
        } finally {
          _iterator211.f();
        }
      }
      this._persistentRefsCache = null;
    }
  }, {
    key: "setStartXRef",
    value: function setStartXRef(e) {
      this.startXRefQueue = [e];
    }
  }, {
    key: "parse",
    value: function parse() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t, i, a;
      if (e) {
        warn("Indexing all PDF objects");
        t = this.indexObjects();
      } else t = this.readXRef();
      t.assignXref(this);
      this.trailer = t;
      try {
        i = t.get("Encrypt");
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        warn("XRef.parse - Invalid \"Encrypt\" reference: \"".concat(e, "\"."));
      }
      if (i instanceof Dict) {
        var _e625 = t.get("ID"),
          _a309 = _e625 !== null && _e625 !== void 0 && _e625.length ? _e625[0] : "";
        i.suppressEncryption = !0;
        this.encrypt = new CipherTransformFactory(i, _a309, this.pdfManager.password);
      }
      try {
        a = t.get("Root");
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        warn("XRef.parse - Invalid \"Root\" reference: \"".concat(e, "\"."));
      }
      if (a instanceof Dict) try {
        if (a.get("Pages") instanceof Dict) {
          this.root = a;
          return;
        }
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        warn("XRef.parse - Invalid \"Pages\" reference: \"".concat(e, "\"."));
      }
      if (!e) throw new XRefParseException();
      throw new InvalidPDFException("Invalid Root reference.");
    }
  }, {
    key: "processXRefTable",
    value: function processXRefTable(e) {
      "tableState" in this || (this.tableState = {
        entryNum: 0,
        streamPos: e.lexer.stream.pos,
        parserBuf1: e.buf1,
        parserBuf2: e.buf2
      });
      if (!isCmd(this.readXRefTable(e), "trailer")) throw new FormatError("Invalid XRef table: could not find trailer dictionary");
      var t = e.getObj();
      t instanceof Dict || !t.dict || (t = t.dict);
      if (!(t instanceof Dict)) throw new FormatError("Invalid XRef table: could not parse trailer dictionary");
      delete this.tableState;
      return t;
    }
  }, {
    key: "readXRefTable",
    value: function readXRefTable(e) {
      var t = e.lexer.stream,
        i = this.tableState;
      t.pos = i.streamPos;
      e.buf1 = i.parserBuf1;
      e.buf2 = i.parserBuf2;
      var a;
      for (;;) {
        if (!("firstEntryNum" in i) || !("entryCount" in i)) {
          if (isCmd(a = e.getObj(), "trailer")) break;
          i.firstEntryNum = a;
          i.entryCount = e.getObj();
        }
        var _s206 = i.firstEntryNum;
        var r = i.entryCount;
        if (!Number.isInteger(_s206) || !Number.isInteger(r)) throw new FormatError("Invalid XRef table: wrong types in subsection header");
        for (var _a310 = i.entryNum; _a310 < r; _a310++) {
          i.streamPos = t.pos;
          i.entryNum = _a310;
          i.parserBuf1 = e.buf1;
          i.parserBuf2 = e.buf2;
          var n = {};
          n.offset = e.getObj();
          n.gen = e.getObj();
          var _g80 = e.getObj();
          if (_g80 instanceof Cmd) switch (_g80.cmd) {
            case "f":
              n.free = !0;
              break;
            case "n":
              n.uncompressed = !0;
          }
          if (!Number.isInteger(n.offset) || !Number.isInteger(n.gen) || !n.free && !n.uncompressed) throw new FormatError("Invalid entry in XRef subsection: ".concat(_s206, ", ").concat(r));
          0 === _a310 && n.free && 1 === _s206 && (_s206 = 0);
          this.entries[_a310 + _s206] || (this.entries[_a310 + _s206] = n);
        }
        i.entryNum = 0;
        i.streamPos = t.pos;
        i.parserBuf1 = e.buf1;
        i.parserBuf2 = e.buf2;
        delete i.firstEntryNum;
        delete i.entryCount;
      }
      if (this.entries[0] && !this.entries[0].free) throw new FormatError("Invalid XRef table: unexpected first object");
      return a;
    }
  }, {
    key: "processXRefStream",
    value: function processXRefStream(e) {
      if (!("streamState" in this)) {
        var _t465 = e.dict,
          _i395 = _t465.get("W");
        var _a311 = _t465.get("Index");
        _a311 || (_a311 = [0, _t465.get("Size")]);
        this.streamState = {
          entryRanges: _a311,
          byteWidths: _i395,
          entryNum: 0,
          streamPos: e.pos
        };
      }
      this.readXRefStream(e);
      delete this.streamState;
      return e.dict;
    }
  }, {
    key: "readXRefStream",
    value: function readXRefStream(e) {
      var t = this.streamState;
      e.pos = t.streamPos;
      var _t$byteWidths = _slicedToArray(t.byteWidths, 3),
        i = _t$byteWidths[0],
        a = _t$byteWidths[1],
        s = _t$byteWidths[2],
        r = t.entryRanges;
      for (; r.length > 0;) {
        var _r160 = _slicedToArray(r, 2),
          n = _r160[0],
          _g81 = _r160[1];
        if (!Number.isInteger(n) || !Number.isInteger(_g81)) throw new FormatError("Invalid XRef range fields: ".concat(n, ", ").concat(_g81));
        if (!Number.isInteger(i) || !Number.isInteger(a) || !Number.isInteger(s)) throw new FormatError("Invalid XRef entry fields length: ".concat(n, ", ").concat(_g81));
        for (var _r161 = t.entryNum; _r161 < _g81; ++_r161) {
          t.entryNum = _r161;
          t.streamPos = e.pos;
          var _g82 = 0,
            _o58 = 0,
            c = 0;
          for (var _t466 = 0; _t466 < i; ++_t466) {
            var _t467 = e.getByte();
            if (-1 === _t467) throw new FormatError("Invalid XRef byteWidths 'type'.");
            _g82 = _g82 << 8 | _t467;
          }
          0 === i && (_g82 = 1);
          for (var _t468 = 0; _t468 < a; ++_t468) {
            var _t469 = e.getByte();
            if (-1 === _t469) throw new FormatError("Invalid XRef byteWidths 'offset'.");
            _o58 = _o58 << 8 | _t469;
          }
          for (var _t470 = 0; _t470 < s; ++_t470) {
            var _t471 = e.getByte();
            if (-1 === _t471) throw new FormatError("Invalid XRef byteWidths 'generation'.");
            c = c << 8 | _t471;
          }
          var _C26 = {};
          _C26.offset = _o58;
          _C26.gen = c;
          switch (_g82) {
            case 0:
              _C26.free = !0;
              break;
            case 1:
              _C26.uncompressed = !0;
              break;
            case 2:
              break;
            default:
              throw new FormatError("Invalid XRef entry type: ".concat(_g82));
          }
          this.entries[n + _r161] || (this.entries[n + _r161] = _C26);
        }
        t.entryNum = 0;
        t.streamPos = e.pos;
        r.splice(0, 2);
      }
    }
  }, {
    key: "indexObjects",
    value: function indexObjects() {
      function readToken(e, t) {
        var i = "",
          a = e[t];
        for (; 10 !== a && 13 !== a && 60 !== a && !(++t >= e.length);) {
          i += String.fromCharCode(a);
          a = e[t];
        }
        return i;
      }
      function skipUntil(e, t, i) {
        var a = i.length,
          s = e.length;
        var r = 0;
        for (; t < s;) {
          var _s207 = 0;
          for (; _s207 < a && e[t + _s207] === i[_s207];) ++_s207;
          if (_s207 >= a) break;
          t++;
          r++;
        }
        return r;
      }
      var e = /\b(endobj|\d+\s+\d+\s+obj|xref|trailer\s*<<)\b/g,
        t = /\b(startxref|\d+\s+\d+\s+obj)\b/g,
        i = /^(\d+)\s+(\d+)\s+obj\b/,
        a = new Uint8Array([116, 114, 97, 105, 108, 101, 114]),
        s = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]),
        r = new Uint8Array([47, 88, 82, 101, 102]);
      this.entries.length = 0;
      this._cacheMap.clear();
      var n = this.stream;
      n.pos = 0;
      var g = n.getBytes(),
        o = bytesToString(g),
        c = g.length;
      var C = n.start;
      var h = [],
        l = [];
      for (; C < c;) {
        var _Q20 = g[C];
        if (9 === _Q20 || 10 === _Q20 || 13 === _Q20 || 32 === _Q20) {
          ++C;
          continue;
        }
        if (37 === _Q20) {
          do {
            ++C;
            if (C >= c) break;
            _Q20 = g[C];
          } while (10 !== _Q20 && 13 !== _Q20);
          continue;
        }
        var _E14 = readToken(g, C);
        var _u12 = void 0;
        if (_E14.startsWith("xref") && (4 === _E14.length || /\s/.test(_E14[4]))) {
          C += skipUntil(g, C, a);
          h.push(C);
          C += skipUntil(g, C, s);
        } else if (_u12 = i.exec(_E14)) {
          var _t472 = 0 | _u12[1],
            _i396 = 0 | _u12[2],
            _a312 = C + _E14.length;
          var _s208 = void 0,
            _h16 = !1;
          if (this.entries[_t472]) {
            if (this.entries[_t472].gen === _i396) try {
              new Parser({
                lexer: new Lexer(n.makeSubStream(_a312))
              }).getObj();
              _h16 = !0;
            } catch (e) {
              e instanceof ParserEOFException ? warn("indexObjects -- checking object (".concat(_E14, "): \"").concat(e, "\".")) : _h16 = !0;
            }
          } else _h16 = !0;
          _h16 && (this.entries[_t472] = {
            offset: C - n.start,
            gen: _i396,
            uncompressed: !0
          });
          e.lastIndex = _a312;
          var _Q21 = e.exec(o);
          if (_Q21) {
            _s208 = e.lastIndex + 1 - C;
            if ("endobj" !== _Q21[1]) {
              warn("indexObjects: Found \"".concat(_Q21[1], "\" inside of another \"obj\", caused by missing \"endobj\" -- trying to recover."));
              _s208 -= _Q21[1].length + 1;
            }
          } else _s208 = c - C;
          var _d8 = g.subarray(C, C + _s208),
            _f10 = skipUntil(_d8, 0, r);
          if (_f10 < _s208 && _d8[_f10 + 5] < 64) {
            l.push(C - n.start);
            this._xrefStms.add(C - n.start);
          }
          C += _s208;
        } else if (_E14.startsWith("trailer") && (7 === _E14.length || /\s/.test(_E14[7]))) {
          h.push(C);
          var _e626 = C + _E14.length;
          var _i397 = void 0;
          t.lastIndex = _e626;
          var _a313 = t.exec(o);
          if (_a313) {
            _i397 = t.lastIndex + 1 - C;
            if ("startxref" !== _a313[1]) {
              warn("indexObjects: Found \"".concat(_a313[1], "\" after \"trailer\", caused by missing \"startxref\" -- trying to recover."));
              _i397 -= _a313[1].length + 1;
            }
          } else _i397 = c - C;
          C += _i397;
        } else C += _E14.length + 1;
      }
      for (var _i398 = 0, _l15 = l; _i398 < _l15.length; _i398++) {
        var _e627 = _l15[_i398];
        this.startXRefQueue.push(_e627);
        this.readXRef(!0);
      }
      var Q = [];
      var E,
        u,
        d = !1;
      for (var _i399 = 0, _h17 = h; _i399 < _h17.length; _i399++) {
        var _e628 = _h17[_i399];
        n.pos = _e628;
        var _t473 = new Parser({
          lexer: new Lexer(n),
          xref: this,
          allowStreams: !0,
          recoveryMode: !0
        });
        if (!isCmd(_t473.getObj(), "trailer")) continue;
        var _i400 = _t473.getObj();
        if (_i400 instanceof Dict) {
          Q.push(_i400);
          _i400.has("Encrypt") && (d = !0);
        }
      }
      for (var _i401 = 0, _arr6 = [].concat(Q, ["genFallback"], Q); _i401 < _arr6.length; _i401++) {
        var _e629 = _arr6[_i401];
        if ("genFallback" === _e629) {
          if (!u) break;
          this._generationFallback = !0;
          continue;
        }
        var _t474 = !1;
        try {
          var _i402 = _e629.get("Root");
          if (!(_i402 instanceof Dict)) continue;
          var _a314 = _i402.get("Pages");
          if (!(_a314 instanceof Dict)) continue;
          var _s209 = _a314.get("Count");
          Number.isInteger(_s209) && (_t474 = !0);
        } catch (e) {
          u = e;
          continue;
        }
        if (_t474 && (!d || _e629.has("Encrypt")) && _e629.has("ID")) return _e629;
        E = _e629;
      }
      if (E) return E;
      if (this.topDict) return this.topDict;
      throw new InvalidPDFException("Invalid PDF structure.");
    }
  }, {
    key: "readXRef",
    value: function readXRef() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = this.stream,
        i = new Set();
      for (; this.startXRefQueue.length;) {
        try {
          var _e630 = this.startXRefQueue[0];
          if (i.has(_e630)) {
            warn("readXRef - skipping XRef table since it was already parsed.");
            this.startXRefQueue.shift();
            continue;
          }
          i.add(_e630);
          t.pos = _e630 + t.start;
          var _a315 = new Parser({
            lexer: new Lexer(t),
            xref: this,
            allowStreams: !0
          });
          var _s210 = void 0,
            r = _a315.getObj();
          if (isCmd(r, "xref")) {
            _s210 = this.processXRefTable(_a315);
            this.topDict || (this.topDict = _s210);
            r = _s210.get("XRefStm");
            if (Number.isInteger(r) && !this._xrefStms.has(r)) {
              var _classPrivateFieldLoo2, _classPrivateFieldLoo3;
              this._xrefStms.add(r);
              this.startXRefQueue.push(r);
              (_classPrivateFieldLoo3 = (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase(this, _j))[_j]) !== null && _classPrivateFieldLoo3 !== void 0 ? _classPrivateFieldLoo3 : _classPrivateFieldLoo2[_j] = r;
            }
          } else {
            if (!Number.isInteger(r)) throw new FormatError("Invalid XRef stream header");
            if (!(Number.isInteger(_a315.getObj()) && isCmd(_a315.getObj(), "obj") && (r = _a315.getObj()) instanceof BaseStream)) throw new FormatError("Invalid XRef stream");
            _s210 = this.processXRefStream(r);
            this.topDict || (this.topDict = _s210);
            if (!_s210) throw new FormatError("Failed to read XRef stream");
          }
          r = _s210.get("Prev");
          Number.isInteger(r) ? this.startXRefQueue.push(r) : r instanceof Ref && this.startXRefQueue.push(r.num);
        } catch (e) {
          if (e instanceof MissingDataException) throw e;
          info("(while reading XRef): " + e);
        }
        this.startXRefQueue.shift();
      }
      if (this.topDict) return this.topDict;
      if (!e) throw new XRefParseException();
    }
  }, {
    key: "lastXRefStreamPos",
    get: function get() {
      var _classPrivateFieldLoo4;
      return (_classPrivateFieldLoo4 = _classPrivateFieldLooseBase(this, _j)[_j]) !== null && _classPrivateFieldLoo4 !== void 0 ? _classPrivateFieldLoo4 : this._xrefStms.size > 0 ? Math.max.apply(Math, _toConsumableArray(this._xrefStms)) : null;
    }
  }, {
    key: "getEntry",
    value: function getEntry(e) {
      var t = this.entries[e];
      return t && !t.free && t.offset ? t : null;
    }
  }, {
    key: "fetchIfRef",
    value: function fetchIfRef(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return e instanceof Ref ? this.fetch(e, t) : e;
    }
  }, {
    key: "fetch",
    value: function fetch(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      if (!(e instanceof Ref)) throw new Error("ref object is not a reference");
      var i = e.num,
        a = this._cacheMap.get(i);
      if (void 0 !== a) {
        a instanceof Dict && !a.objId && (a.objId = e.toString());
        return a;
      }
      var s = this.getEntry(i);
      if (null === s) {
        this._cacheMap.set(i, s);
        return s;
      }
      if (this._pendingRefs.has(e)) {
        this._pendingRefs.remove(e);
        warn("Ignoring circular reference: ".concat(e, "."));
        return mt;
      }
      this._pendingRefs.put(e);
      try {
        s = s.uncompressed ? this.fetchUncompressed(e, s, t) : this.fetchCompressed(e, s, t);
        this._pendingRefs.remove(e);
      } catch (t) {
        this._pendingRefs.remove(e);
        throw t;
      }
      s instanceof Dict ? s.objId = e.toString() : s instanceof BaseStream && (s.dict.objId = e.toString());
      return s;
    }
  }, {
    key: "fetchUncompressed",
    value: function fetchUncompressed(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var a = e.gen;
      var s = e.num;
      if (t.gen !== a) {
        var _r162 = "Inconsistent generation in XRef: ".concat(e);
        if (this._generationFallback && t.gen < a) {
          warn(_r162);
          return this.fetchUncompressed(Ref.get(s, t.gen), t, i);
        }
        throw new XRefEntryException(_r162);
      }
      var r = this.stream.makeSubStream(t.offset + this.stream.start),
        n = new Parser({
          lexer: new Lexer(r),
          xref: this,
          allowStreams: !0
        }),
        g = n.getObj(),
        o = n.getObj(),
        c = n.getObj();
      if (g !== s || o !== a || !(c instanceof Cmd)) throw new XRefEntryException("Bad (uncompressed) XRef entry: ".concat(e));
      if ("obj" !== c.cmd) {
        if (c.cmd.startsWith("obj")) {
          s = parseInt(c.cmd.substring(3), 10);
          if (!Number.isNaN(s)) return s;
        }
        throw new XRefEntryException("Bad (uncompressed) XRef entry: ".concat(e));
      }
      (t = this.encrypt && !i ? n.getObj(this.encrypt.createCipherTransform(s, a)) : n.getObj()) instanceof BaseStream || this._cacheMap.set(s, t);
      return t;
    }
  }, {
    key: "fetchCompressed",
    value: function fetchCompressed(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var a = t.offset,
        s = this.fetch(Ref.get(a, 0));
      if (!(s instanceof BaseStream)) throw new FormatError("bad ObjStm stream");
      var r = s.dict.get("First"),
        n = s.dict.get("N");
      if (!Number.isInteger(r) || !Number.isInteger(n)) throw new FormatError("invalid first and n parameters for ObjStm stream");
      var g = new Parser({
        lexer: new Lexer(s),
        xref: this,
        allowStreams: !0
      });
      var o = new Array(n),
        c = new Array(n);
      for (var _e631 = 0; _e631 < n; ++_e631) {
        var _t475 = g.getObj();
        if (!Number.isInteger(_t475)) throw new FormatError("invalid object number in the ObjStm stream: ".concat(_t475));
        var _i403 = g.getObj();
        if (!Number.isInteger(_i403)) throw new FormatError("invalid object offset in the ObjStm stream: ".concat(_i403));
        o[_e631] = _t475;
        c[_e631] = _i403;
      }
      var C = (s.start || 0) + r,
        h = new Array(n);
      for (var _e632 = 0; _e632 < n; ++_e632) {
        var _t476 = _e632 < n - 1 ? c[_e632 + 1] - c[_e632] : void 0;
        if (_t476 < 0) throw new FormatError("Invalid offset in the ObjStm stream.");
        g = new Parser({
          lexer: new Lexer(s.makeSubStream(C + c[_e632], _t476, s.dict)),
          xref: this,
          allowStreams: !0
        });
        var _i404 = g.getObj();
        h[_e632] = _i404;
        if (_i404 instanceof BaseStream) continue;
        var _r163 = o[_e632],
          l = this.entries[_r163];
        l && l.offset === a && l.gen === _e632 && this._cacheMap.set(_r163, _i404);
      }
      if (void 0 === (t = h[t.gen])) throw new XRefEntryException("Bad (compressed) XRef entry: ".concat(e));
      return t;
    }
  }, {
    key: "fetchIfRefAsync",
    value: function () {
      var _fetchIfRefAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee76(e, t) {
        return _regeneratorRuntime().wrap(function _callee76$(_context88) {
          while (1) switch (_context88.prev = _context88.next) {
            case 0:
              return _context88.abrupt("return", e instanceof Ref ? this.fetchAsync(e, t) : e);
            case 1:
            case "end":
              return _context88.stop();
          }
        }, _callee76, this);
      }));
      function fetchIfRefAsync(_x178, _x179) {
        return _fetchIfRefAsync.apply(this, arguments);
      }
      return fetchIfRefAsync;
    }()
  }, {
    key: "fetchAsync",
    value: function () {
      var _fetchAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee77(e, t) {
        return _regeneratorRuntime().wrap(function _callee77$(_context89) {
          while (1) switch (_context89.prev = _context89.next) {
            case 0:
              _context89.prev = 0;
              return _context89.abrupt("return", this.fetch(e, t));
            case 4:
              _context89.prev = 4;
              _context89.t0 = _context89["catch"](0);
              if (_context89.t0 instanceof MissingDataException) {
                _context89.next = 8;
                break;
              }
              throw _context89.t0;
            case 8:
              _context89.next = 10;
              return this.pdfManager.requestRange(_context89.t0.begin, _context89.t0.end);
            case 10:
              return _context89.abrupt("return", this.fetchAsync(e, t));
            case 11:
            case "end":
              return _context89.stop();
          }
        }, _callee77, this, [[0, 4]]);
      }));
      function fetchAsync(_x180, _x181) {
        return _fetchAsync.apply(this, arguments);
      }
      return fetchAsync;
    }()
  }, {
    key: "getCatalogObj",
    value: function getCatalogObj() {
      return this.root;
    }
  }]);
}();
var gg = [0, 0, 612, 792];
var _X = /*#__PURE__*/_classPrivateFieldLooseKey("X");
var Page = /*#__PURE__*/function () {
  function Page(_ref192) {
    var _e633 = _ref192.pdfManager,
      _t477 = _ref192.xref,
      _i405 = _ref192.pageIndex,
      _a316 = _ref192.pageDict,
      _s211 = _ref192.ref,
      r = _ref192.globalIdFactory,
      n = _ref192.fontCache,
      g = _ref192.builtInCMapCache,
      o = _ref192.standardFontDataCache,
      c = _ref192.globalImageCache,
      C = _ref192.systemFontCache,
      h = _ref192.nonBlendModesSet,
      l = _ref192.xfaFactory;
    _classCallCheck(this, Page);
    Object.defineProperty(this, _X, {
      value: _X2
    });
    this.pdfManager = _e633;
    this.pageIndex = _i405;
    this.pageDict = _a316;
    this.xref = _t477;
    this.ref = _s211;
    this.fontCache = n;
    this.builtInCMapCache = g;
    this.standardFontDataCache = o;
    this.globalImageCache = c;
    this.systemFontCache = C;
    this.nonBlendModesSet = h;
    this.evaluatorOptions = _e633.evaluatorOptions;
    this.resourcesPromise = null;
    this.xfaFactory = l;
    var Q = {
      obj: 0
    };
    this._localIdFactory = /*#__PURE__*/function (_r164) {
      function _class() {
        _classCallCheck(this, _class);
        return _callSuper(this, _class, arguments);
      }
      _inherits(_class, _r164);
      return _createClass(_class, null, [{
        key: "createObjId",
        value: function createObjId() {
          return "p".concat(_i405, "_").concat(++Q.obj);
        }
      }, {
        key: "getPageObjId",
        value: function getPageObjId() {
          return "p".concat(_s211.toString());
        }
      }]);
    }(r);
  }
  return _createClass(Page, [{
    key: "_getInheritableProperty",
    value: function _getInheritableProperty(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = getInheritableProperty({
        dict: this.pageDict,
        key: e,
        getArray: t,
        stopWhenFound: !1
      });
      return Array.isArray(i) ? 1 !== i.length && i[0] instanceof Dict ? Dict.merge({
        xref: this.xref,
        dictArray: i
      }) : i[0] : i;
    }
  }, {
    key: "content",
    get: function get() {
      return this.pageDict.getArray("Contents");
    }
  }, {
    key: "resources",
    get: function get() {
      var e = this._getInheritableProperty("Resources");
      return shadow(this, "resources", e instanceof Dict ? e : Dict.empty);
    }
  }, {
    key: "_getBoundingBox",
    value: function _getBoundingBox(e) {
      if (this.xfaData) return this.xfaData.bbox;
      var t = lookupNormalRect(this._getInheritableProperty(e, !0), null);
      if (t) {
        if (t[2] - t[0] > 0 && t[3] - t[1] > 0) return t;
        warn("Empty, or invalid, /".concat(e, " entry."));
      }
      return null;
    }
  }, {
    key: "mediaBox",
    get: function get() {
      return shadow(this, "mediaBox", this._getBoundingBox("MediaBox") || gg);
    }
  }, {
    key: "cropBox",
    get: function get() {
      return shadow(this, "cropBox", this._getBoundingBox("CropBox") || this.mediaBox);
    }
  }, {
    key: "userUnit",
    get: function get() {
      var e = this.pageDict.get("UserUnit");
      ("number" != typeof e || e <= 0) && (e = 1);
      return shadow(this, "userUnit", e);
    }
  }, {
    key: "view",
    get: function get() {
      var e = this.cropBox,
        t = this.mediaBox;
      if (e !== t && !isArrayEqual(e, t)) {
        var _i406 = Util.intersect(e, t);
        if (_i406 && _i406[2] - _i406[0] > 0 && _i406[3] - _i406[1] > 0) return shadow(this, "view", _i406);
        warn("Empty /CropBox and /MediaBox intersection.");
      }
      return shadow(this, "view", t);
    }
  }, {
    key: "rotate",
    get: function get() {
      var e = this._getInheritableProperty("Rotate") || 0;
      e % 90 != 0 ? e = 0 : e >= 360 ? e %= 360 : e < 0 && (e = (e % 360 + 360) % 360);
      return shadow(this, "rotate", e);
    }
  }, {
    key: "_onSubStreamError",
    value: function _onSubStreamError(e, t) {
      if (!this.evaluatorOptions.ignoreErrors) throw e;
      warn("getContentStream - ignoring sub-stream (".concat(t, "): \"").concat(e, "\"."));
    }
  }, {
    key: "getContentStream",
    value: function getContentStream() {
      var _this294 = this;
      return this.pdfManager.ensure(this, "content").then(function (e) {
        return e instanceof BaseStream ? e : Array.isArray(e) ? new StreamsSequenceStream(e, _this294._onSubStreamError.bind(_this294)) : new NullStream();
      });
    }
  }, {
    key: "xfaData",
    get: function get() {
      return shadow(this, "xfaData", this.xfaFactory ? {
        bbox: this.xfaFactory.getBoundingBox(this.pageIndex)
      } : null);
    }
  }, {
    key: "saveNewAnnotations",
    value: function () {
      var _saveNewAnnotations2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee78(e, t, i, a) {
        var s, r, n, g, o, c, _iterator212, _step212, _ref193, _e634, C, h, l, _iterator213, _step213, _e635;
        return _regeneratorRuntime().wrap(function _callee78$(_context90) {
          while (1) switch (_context90.prev = _context90.next) {
            case 0:
              if (!this.xfaFactory) {
                _context90.next = 2;
                break;
              }
              throw new Error("XFA: Cannot save new annotations.");
            case 2:
              s = new PartialEvaluator({
                xref: this.xref,
                handler: e,
                pageIndex: this.pageIndex,
                idFactory: this._localIdFactory,
                fontCache: this.fontCache,
                builtInCMapCache: this.builtInCMapCache,
                standardFontDataCache: this.standardFontDataCache,
                globalImageCache: this.globalImageCache,
                systemFontCache: this.systemFontCache,
                options: this.evaluatorOptions
              }), r = new RefSetCache(), n = new RefSet();
              _context90.next = 5;
              return _classPrivateFieldLooseBase(this, _X)[_X](i, r, n);
            case 5:
              g = this.pageDict;
              o = this.annotations.filter(function (e) {
                return !(e instanceof Ref && r.has(e));
              });
              _context90.next = 9;
              return AnnotationFactory.saveNewAnnotations(s, t, i, a);
            case 9:
              c = _context90.sent;
              _iterator212 = _createForOfIteratorHelper(c.annotations);
              try {
                for (_iterator212.s(); !(_step212 = _iterator212.n()).done;) {
                  _ref193 = _step212.value;
                  _e634 = _ref193.ref;
                  _e634 instanceof Ref && !n.has(_e634) && o.push(_e634);
                }
              } catch (err) {
                _iterator212.e(err);
              } finally {
                _iterator212.f();
              }
              C = g.get("Annots");
              g.set("Annots", o);
              h = [];
              _context90.next = 17;
              return writeObject(this.ref, g, h, this.xref);
            case 17:
              C && g.set("Annots", C);
              l = c.dependencies;
              l.push.apply(l, [{
                ref: this.ref,
                data: h.join("")
              }].concat(_toConsumableArray(c.annotations)));
              _iterator213 = _createForOfIteratorHelper(r);
              try {
                for (_iterator213.s(); !(_step213 = _iterator213.n()).done;) {
                  _e635 = _step213.value;
                  l.push({
                    ref: _e635,
                    data: null
                  });
                }
              } catch (err) {
                _iterator213.e(err);
              } finally {
                _iterator213.f();
              }
              return _context90.abrupt("return", l);
            case 23:
            case "end":
              return _context90.stop();
          }
        }, _callee78, this);
      }));
      function saveNewAnnotations(_x182, _x183, _x184, _x185) {
        return _saveNewAnnotations2.apply(this, arguments);
      }
      return saveNewAnnotations;
    }()
  }, {
    key: "save",
    value: function save(e, t, i) {
      var a = new PartialEvaluator({
        xref: this.xref,
        handler: e,
        pageIndex: this.pageIndex,
        idFactory: this._localIdFactory,
        fontCache: this.fontCache,
        builtInCMapCache: this.builtInCMapCache,
        standardFontDataCache: this.standardFontDataCache,
        globalImageCache: this.globalImageCache,
        systemFontCache: this.systemFontCache,
        options: this.evaluatorOptions
      });
      return this._parsedAnnotations.then(function (e) {
        var s = [];
        var _iterator214 = _createForOfIteratorHelper(e),
          _step214;
        try {
          for (_iterator214.s(); !(_step214 = _iterator214.n()).done;) {
            var r = _step214.value;
            s.push(r.save(a, t, i).catch(function (e) {
              warn("save - ignoring annotation data during \"".concat(t.name, "\" task: \"").concat(e, "\"."));
              return null;
            }));
          }
        } catch (err) {
          _iterator214.e(err);
        } finally {
          _iterator214.f();
        }
        return Promise.all(s).then(function (e) {
          return e.filter(function (e) {
            return !!e;
          });
        });
      });
    }
  }, {
    key: "loadResources",
    value: function loadResources(e) {
      var _this295 = this;
      this.resourcesPromise || (this.resourcesPromise = this.pdfManager.ensure(this, "resources"));
      return this.resourcesPromise.then(function () {
        return new ObjectLoader(_this295.resources, e, _this295.xref).load();
      });
    }
  }, {
    key: "getOperatorList",
    value: function getOperatorList(_ref194) {
      var _this296 = this;
      var e = _ref194.handler,
        t = _ref194.sink,
        i = _ref194.task,
        a = _ref194.intent,
        s = _ref194.cacheKey,
        _ref194$annotationSto = _ref194.annotationStorage,
        r = _ref194$annotationSto === void 0 ? null : _ref194$annotationSto,
        _ref194$modifiedIds = _ref194.modifiedIds,
        n = _ref194$modifiedIds === void 0 ? null : _ref194$modifiedIds;
      var C = this.getContentStream(),
        E = this.loadResources(["ColorSpace", "ExtGState", "Font", "Pattern", "Properties", "Shading", "XObject"]),
        d = new PartialEvaluator({
          xref: this.xref,
          handler: e,
          pageIndex: this.pageIndex,
          idFactory: this._localIdFactory,
          fontCache: this.fontCache,
          builtInCMapCache: this.builtInCMapCache,
          standardFontDataCache: this.standardFontDataCache,
          globalImageCache: this.globalImageCache,
          systemFontCache: this.systemFontCache,
          options: this.evaluatorOptions
        }),
        f = this.xfaFactory ? null : getNewAnnotationsMap(r),
        p = f === null || f === void 0 ? void 0 : f.get(this.pageIndex);
      var m = Promise.resolve(null),
        y = null;
      if (p) {
        var _e636 = this.pdfManager.ensureDoc("annotationGlobals");
        var _t478;
        var _a317 = new Set();
        var _iterator215 = _createForOfIteratorHelper(p),
          _step215;
        try {
          for (_iterator215.s(); !(_step215 = _iterator215.n()).done;) {
            var _ref195 = _step215.value;
            var _e638 = _ref195.bitmapId;
            var _t480 = _ref195.bitmap;
            !_e638 || _t480 || _a317.has(_e638) || _a317.add(_e638);
          }
        } catch (err) {
          _iterator215.e(err);
        } finally {
          _iterator215.f();
        }
        var _s212 = this.evaluatorOptions.isOffscreenCanvasSupported;
        if (_a317.size > 0) {
          var _e637 = p.slice();
          var _iterator216 = _createForOfIteratorHelper(r),
            _step216;
          try {
            for (_iterator216.s(); !(_step216 = _iterator216.n()).done;) {
              var _ref196 = _step216.value;
              var _ref197 = _slicedToArray(_ref196, 2);
              var _t479 = _ref197[0];
              var _i407 = _ref197[1];
              _t479.startsWith(u) && _i407.bitmap && _a317.has(_i407.bitmapId) && _e637.push(_i407);
            }
          } catch (err) {
            _iterator216.e(err);
          } finally {
            _iterator216.f();
          }
          _t478 = AnnotationFactory.generateImages(_e637, this.xref, _s212);
        } else _t478 = AnnotationFactory.generateImages(p, this.xref, _s212);
        y = new RefSet();
        m = Promise.all([_e636, _classPrivateFieldLooseBase(this, _X)[_X](p, y, null)]).then(function (_ref198) {
          var _ref199 = _slicedToArray(_ref198, 1),
            e = _ref199[0];
          return e ? AnnotationFactory.printNewAnnotations(e, d, i, p, _t478) : null;
        });
      }
      var w = Promise.all([C, E]).then(function (_ref200) {
        var _ref201 = _slicedToArray(_ref200, 1),
          r = _ref201[0];
        var n = new OperatorList(a, t);
        e.send("StartRenderPage", {
          transparency: d.hasBlendModes(_this296.resources, _this296.nonBlendModesSet),
          pageIndex: _this296.pageIndex,
          cacheKey: s
        });
        return d.getOperatorList({
          stream: r,
          task: i,
          resources: _this296.resources,
          operatorList: n
        }).then(function () {
          return n;
        });
      });
      return Promise.all([w, this._parsedAnnotations, m]).then(function (_ref202) {
        var _ref203 = _slicedToArray(_ref202, 3),
          e = _ref203[0],
          t = _ref203[1],
          s = _ref203[2];
        if (s) {
          t = t.filter(function (e) {
            return !(e.ref && y.has(e.ref));
          });
          var _loop5 = function _loop5(_e640, _i409) {
            var a = s[_e640];
            if (a.refToReplace) {
              var _r165 = t.findIndex(function (e) {
                return e.ref && isRefsEqual(e.ref, a.refToReplace);
              });
              if (_r165 >= 0) {
                t.splice(_r165, 1, a);
                s.splice(_e640--, 1);
                _i409--;
              }
            }
            _e639 = _e640, _i408 = _i409;
          };
          for (var _e639 = 0, _i408 = s.length; _e639 < _i408; _e639++) {
            _loop5(_e639, _i408);
          }
          t = t.concat(s);
        }
        if (0 === t.length || a & l) {
          e.flush(!0);
          return {
            length: e.totalLength
          };
        }
        var C = !!(a & h),
          E = !!(a & Q),
          u = !!(a & g),
          f = !!(a & o),
          p = !!(a & c),
          m = [];
        var _iterator217 = _createForOfIteratorHelper(t),
          _step217;
        try {
          for (_iterator217.s(); !(_step217 = _iterator217.n()).done;) {
            var _e641 = _step217.value;
            (u || f && _e641.mustBeViewed(r, C) && _e641.mustBeViewedWhenEditing(E, n) || p && _e641.mustBePrinted(r)) && m.push(_e641.getOperatorList(d, i, a, r).catch(function (e) {
              warn("getOperatorList - ignoring annotation data during \"".concat(i.name, "\" task: \"").concat(e, "\"."));
              return {
                opList: null,
                separateForm: !1,
                separateCanvas: !1
              };
            }));
          }
        } catch (err) {
          _iterator217.e(err);
        } finally {
          _iterator217.f();
        }
        return Promise.all(m).then(function (t) {
          var i = !1,
            a = !1;
          var _iterator218 = _createForOfIteratorHelper(t),
            _step218;
          try {
            for (_iterator218.s(); !(_step218 = _iterator218.n()).done;) {
              var _ref204 = _step218.value;
              var _s213 = _ref204.opList;
              var _r166 = _ref204.separateForm;
              var _n108 = _ref204.separateCanvas;
              e.addOpList(_s213);
              i || (i = _r166);
              a || (a = _n108);
            }
          } catch (err) {
            _iterator218.e(err);
          } finally {
            _iterator218.f();
          }
          e.flush(!0, {
            form: i,
            canvas: a
          });
          return {
            length: e.totalLength
          };
        });
      });
    }
  }, {
    key: "extractTextContent",
    value: function () {
      var _extractTextContent3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee79(_ref205) {
        var e, t, i, a, s, r, n, g, _yield$Promise$all, _yield$Promise$all2, o, c;
        return _regeneratorRuntime().wrap(function _callee79$(_context91) {
          while (1) switch (_context91.prev = _context91.next) {
            case 0:
              e = _ref205.handler, t = _ref205.task, i = _ref205.includeMarkedContent, a = _ref205.disableNormalization, s = _ref205.sink;
              r = this.getContentStream();
              n = this.loadResources(["ExtGState", "Font", "Properties", "XObject"]);
              g = this.pdfManager.ensureCatalog("lang");
              _context91.next = 6;
              return Promise.all([r, n, g]);
            case 6:
              _yield$Promise$all = _context91.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
              o = _yield$Promise$all2[0];
              c = _yield$Promise$all2[2];
              return _context91.abrupt("return", new PartialEvaluator({
                xref: this.xref,
                handler: e,
                pageIndex: this.pageIndex,
                idFactory: this._localIdFactory,
                fontCache: this.fontCache,
                builtInCMapCache: this.builtInCMapCache,
                standardFontDataCache: this.standardFontDataCache,
                globalImageCache: this.globalImageCache,
                systemFontCache: this.systemFontCache,
                options: this.evaluatorOptions
              }).getTextContent({
                stream: o,
                task: t,
                resources: this.resources,
                includeMarkedContent: i,
                disableNormalization: a,
                sink: s,
                viewBox: this.view,
                lang: c
              }));
            case 11:
            case "end":
              return _context91.stop();
          }
        }, _callee79, this);
      }));
      function extractTextContent(_x186) {
        return _extractTextContent3.apply(this, arguments);
      }
      return extractTextContent;
    }()
  }, {
    key: "getStructTree",
    value: function () {
      var _getStructTree = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee80() {
        var e, t;
        return _regeneratorRuntime().wrap(function _callee80$(_context92) {
          while (1) switch (_context92.prev = _context92.next) {
            case 0:
              _context92.next = 2;
              return this.pdfManager.ensureCatalog("structTreeRoot");
            case 2:
              e = _context92.sent;
              if (e) {
                _context92.next = 5;
                break;
              }
              return _context92.abrupt("return", null);
            case 5:
              _context92.next = 7;
              return this._parsedAnnotations;
            case 7:
              _context92.next = 9;
              return this.pdfManager.ensure(this, "_parseStructTree", [e]);
            case 9:
              t = _context92.sent;
              return _context92.abrupt("return", this.pdfManager.ensure(t, "serializable"));
            case 11:
            case "end":
              return _context92.stop();
          }
        }, _callee80, this);
      }));
      function getStructTree() {
        return _getStructTree.apply(this, arguments);
      }
      return getStructTree;
    }()
  }, {
    key: "_parseStructTree",
    value: function _parseStructTree(e) {
      var t = new StructTreePage(e, this.pageDict);
      t.parse(this.ref);
      return t;
    }
  }, {
    key: "getAnnotationsData",
    value: function () {
      var _getAnnotationsData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee81(e, t, i) {
        var a, s, r, n, C, h, l, _iterator219, _step219, _i410, _a318;
        return _regeneratorRuntime().wrap(function _callee81$(_context93) {
          while (1) switch (_context93.prev = _context93.next) {
            case 0:
              _context93.next = 2;
              return this._parsedAnnotations;
            case 2:
              a = _context93.sent;
              if (!(0 === a.length)) {
                _context93.next = 5;
                break;
              }
              return _context93.abrupt("return", a);
            case 5:
              s = [], r = [];
              C = !!(i & g), h = !!(i & o), l = !!(i & c);
              _iterator219 = _createForOfIteratorHelper(a);
              try {
                for (_iterator219.s(); !(_step219 = _iterator219.n()).done;) {
                  _i410 = _step219.value;
                  _a318 = C || h && _i410.viewable;
                  (_a318 || l && _i410.printable) && s.push(_i410.data);
                  if (_i410.hasTextContent && _a318) {
                    n || (n = new PartialEvaluator({
                      xref: this.xref,
                      handler: e,
                      pageIndex: this.pageIndex,
                      idFactory: this._localIdFactory,
                      fontCache: this.fontCache,
                      builtInCMapCache: this.builtInCMapCache,
                      standardFontDataCache: this.standardFontDataCache,
                      globalImageCache: this.globalImageCache,
                      systemFontCache: this.systemFontCache,
                      options: this.evaluatorOptions
                    }));
                    r.push(_i410.extractTextContent(n, t, [-1 / 0, -1 / 0, 1 / 0, 1 / 0]).catch(function (e) {
                      warn("getAnnotationsData - ignoring textContent during \"".concat(t.name, "\" task: \"").concat(e, "\"."));
                    }));
                  }
                }
              } catch (err) {
                _iterator219.e(err);
              } finally {
                _iterator219.f();
              }
              _context93.next = 11;
              return Promise.all(r);
            case 11:
              return _context93.abrupt("return", s);
            case 12:
            case "end":
              return _context93.stop();
          }
        }, _callee81, this);
      }));
      function getAnnotationsData(_x187, _x188, _x189) {
        return _getAnnotationsData.apply(this, arguments);
      }
      return getAnnotationsData;
    }()
  }, {
    key: "annotations",
    get: function get() {
      var e = this._getInheritableProperty("Annots");
      return shadow(this, "annotations", Array.isArray(e) ? e : []);
    }
  }, {
    key: "_parsedAnnotations",
    get: function get() {
      var _this297 = this;
      return shadow(this, "_parsedAnnotations", this.pdfManager.ensure(this, "annotations").then(/*#__PURE__*/function () {
        var _ref206 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee82(e) {
          var _yield$Promise$all3, _yield$Promise$all4, t, i, a, s, _iterator220, _step220, _i411, r, n, g, _iterator221, _step221, _e642;
          return _regeneratorRuntime().wrap(function _callee82$(_context94) {
            while (1) switch (_context94.prev = _context94.next) {
              case 0:
                if (!(0 === e.length)) {
                  _context94.next = 2;
                  break;
                }
                return _context94.abrupt("return", e);
              case 2:
                _context94.next = 4;
                return Promise.all([_this297.pdfManager.ensureDoc("annotationGlobals"), _this297.pdfManager.ensureDoc("fieldObjects")]);
              case 4:
                _yield$Promise$all3 = _context94.sent;
                _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
                t = _yield$Promise$all4[0];
                i = _yield$Promise$all4[1];
                if (t) {
                  _context94.next = 10;
                  break;
                }
                return _context94.abrupt("return", []);
              case 10:
                a = i === null || i === void 0 ? void 0 : i.orphanFields, s = [];
                _iterator220 = _createForOfIteratorHelper(e);
                try {
                  for (_iterator220.s(); !(_step220 = _iterator220.n()).done;) {
                    _i411 = _step220.value;
                    s.push(AnnotationFactory.create(_this297.xref, _i411, t, _this297._localIdFactory, !1, a, _this297.ref).catch(function (e) {
                      warn("_parsedAnnotations: \"".concat(e, "\"."));
                      return null;
                    }));
                  }
                } catch (err) {
                  _iterator220.e(err);
                } finally {
                  _iterator220.f();
                }
                r = [];
                _context94.t0 = _createForOfIteratorHelper;
                _context94.next = 17;
                return Promise.all(s);
              case 17:
                _context94.t1 = _context94.sent;
                _iterator221 = (0, _context94.t0)(_context94.t1);
                try {
                  for (_iterator221.s(); !(_step221 = _iterator221.n()).done;) {
                    _e642 = _step221.value;
                    _e642 && (_e642 instanceof WidgetAnnotation ? (g || (g = [])).push(_e642) : _e642 instanceof PopupAnnotation ? (n || (n = [])).push(_e642) : r.push(_e642));
                  }
                } catch (err) {
                  _iterator221.e(err);
                } finally {
                  _iterator221.f();
                }
                g && r.push.apply(r, _toConsumableArray(g));
                n && r.push.apply(r, _toConsumableArray(n));
                return _context94.abrupt("return", r);
              case 23:
              case "end":
                return _context94.stop();
            }
          }, _callee82);
        }));
        return function (_x190) {
          return _ref206.apply(this, arguments);
        };
      }()));
    }
  }, {
    key: "jsActions",
    get: function get() {
      return shadow(this, "jsActions", collectActions(this.xref, this.pageDict, pA));
    }
  }]);
}();
function _X2(_x224, _x225, _x226) {
  return _X3.apply(this, arguments);
}
function _X3() {
  _X3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee121(e, t, i) {
    var _this305 = this;
    var a, _iterator252, _step252, _loop9, _ret3;
    return _regeneratorRuntime().wrap(function _callee121$(_context133) {
      while (1) switch (_context133.prev = _context133.next) {
        case 0:
          a = [];
          _iterator252 = _createForOfIteratorHelper(e);
          _context133.prev = 2;
          _loop9 = /*#__PURE__*/_regeneratorRuntime().mark(function _callee120() {
            var s, _e687, _e688;
            return _regeneratorRuntime().wrap(function _callee120$(_context132) {
              while (1) switch (_context132.prev = _context132.next) {
                case 0:
                  s = _step252.value;
                  if (!s.id) {
                    _context132.next = 14;
                    break;
                  }
                  _e687 = Ref.fromString(s.id);
                  if (_e687) {
                    _context132.next = 6;
                    break;
                  }
                  warn("A non-linked annotation cannot be modified: ".concat(s.id));
                  return _context132.abrupt("return", 0);
                case 6:
                  if (!s.deleted) {
                    _context132.next = 10;
                    break;
                  }
                  t.put(_e687, _e687);
                  if (s.popupRef) {
                    _e688 = Ref.fromString(s.popupRef);
                    _e688 && t.put(_e688, _e688);
                  }
                  return _context132.abrupt("return", 0);
                case 10:
                  i === null || i === void 0 || i.put(_e687);
                  s.ref = _e687;
                  a.push(_this305.xref.fetchAsync(_e687).then(function (e) {
                    e instanceof Dict && (s.oldAnnotation = e.clone());
                  }, function () {
                    warn("Cannot fetch `oldAnnotation` for: ".concat(_e687, "."));
                  }));
                  delete s.id;
                case 14:
                case "end":
                  return _context132.stop();
              }
            }, _callee120);
          });
          _iterator252.s();
        case 5:
          if ((_step252 = _iterator252.n()).done) {
            _context133.next = 12;
            break;
          }
          return _context133.delegateYield(_loop9(), "t0", 7);
        case 7:
          _ret3 = _context133.t0;
          if (!(_ret3 === 0)) {
            _context133.next = 10;
            break;
          }
          return _context133.abrupt("continue", 10);
        case 10:
          _context133.next = 5;
          break;
        case 12:
          _context133.next = 17;
          break;
        case 14:
          _context133.prev = 14;
          _context133.t1 = _context133["catch"](2);
          _iterator252.e(_context133.t1);
        case 17:
          _context133.prev = 17;
          _iterator252.f();
          return _context133.finish(17);
        case 20:
          _context133.next = 22;
          return Promise.all(a);
        case 22:
        case "end":
          return _context133.stop();
      }
    }, _callee121, null, [[2, 14, 17, 20]]);
  }));
  return _X3.apply(this, arguments);
}
var og = new Uint8Array([37, 80, 68, 70, 45]),
  Ig = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]),
  cg = new Uint8Array([101, 110, 100, 111, 98, 106]);
function find(e, t) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1024;
  var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  var s = t.length,
    r = e.peekBytes(i),
    n = r.length - s;
  if (n <= 0) return !1;
  if (a) {
    var _i412 = s - 1;
    var _a319 = r.length - 1;
    for (; _a319 >= _i412;) {
      var _n109 = 0;
      for (; _n109 < s && r[_a319 - _n109] === t[_i412 - _n109];) _n109++;
      if (_n109 >= s) {
        e.pos += _a319 - _i412;
        return !0;
      }
      _a319--;
    }
  } else {
    var _i413 = 0;
    for (; _i413 <= n;) {
      var _a320 = 0;
      for (; _a320 < s && r[_i413 + _a320] === t[_a320];) _a320++;
      if (_a320 >= s) {
        e.pos += _i413;
        return !0;
      }
      _i413++;
    }
  }
  return !1;
}
var _Z = /*#__PURE__*/_classPrivateFieldLooseKey("Z");
var PDFDocument = /*#__PURE__*/function () {
  function PDFDocument(_e643, _t481) {
    _classCallCheck(this, PDFDocument);
    Object.defineProperty(this, _Z, {
      value: _Z2
    });
    if (_t481.length <= 0) throw new InvalidPDFException("The PDF file is empty, i.e. its size is zero bytes.");
    this.pdfManager = _e643;
    this.stream = _t481;
    this.xref = new XRef(_t481, _e643);
    this._pagePromises = new Map();
    this._version = null;
    var _i414 = {
      font: 0
    };
    this._globalIdFactory = /*#__PURE__*/function () {
      function _class2() {
        _classCallCheck(this, _class2);
      }
      return _createClass(_class2, null, [{
        key: "getDocId",
        value: function getDocId() {
          return "g_".concat(_e643.docId);
        }
      }, {
        key: "createFontId",
        value: function createFontId() {
          return "f" + ++_i414.font;
        }
      }, {
        key: "createObjId",
        value: function createObjId() {
          unreachable("Abstract method `createObjId` called.");
        }
      }, {
        key: "getPageObjId",
        value: function getPageObjId() {
          unreachable("Abstract method `getPageObjId` called.");
        }
      }]);
    }();
  }
  return _createClass(PDFDocument, [{
    key: "parse",
    value: function parse(e) {
      this.xref.parse(e);
      this.catalog = new Catalog(this.pdfManager, this.xref);
    }
  }, {
    key: "linearization",
    get: function get() {
      var e = null;
      try {
        e = Linearization.create(this.stream);
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        info(e);
      }
      return shadow(this, "linearization", e);
    }
  }, {
    key: "startXRef",
    get: function get() {
      var e = this.stream;
      var t = 0;
      if (this.linearization) {
        e.reset();
        if (find(e, cg)) {
          e.skip(6);
          var _i415 = e.peekByte();
          for (; isWhiteSpace(_i415);) {
            e.pos++;
            _i415 = e.peekByte();
          }
          t = e.pos - e.start;
        }
      } else {
        var _i416 = 1024,
          _a321 = Ig.length;
        var _s214 = !1,
          r = e.end;
        for (; !_s214 && r > 0;) {
          r -= _i416 - _a321;
          r < 0 && (r = 0);
          e.pos = r;
          _s214 = find(e, Ig, _i416, !0);
        }
        if (_s214) {
          e.skip(9);
          var _i417;
          do {
            _i417 = e.getByte();
          } while (isWhiteSpace(_i417));
          var _a322 = "";
          for (; _i417 >= 32 && _i417 <= 57;) {
            _a322 += String.fromCharCode(_i417);
            _i417 = e.getByte();
          }
          t = parseInt(_a322, 10);
          isNaN(t) && (t = 0);
        }
      }
      return shadow(this, "startXRef", t);
    }
  }, {
    key: "checkHeader",
    value: function checkHeader() {
      var e = this.stream;
      e.reset();
      if (!find(e, og)) return;
      e.moveStart();
      e.skip(og.length);
      var t,
        i = "";
      for (; (t = e.getByte()) > 32 && i.length < 7;) i += String.fromCharCode(t);
      St.test(i) ? this._version = i : warn("Invalid PDF header version: ".concat(i));
    }
  }, {
    key: "parseStartXRef",
    value: function parseStartXRef() {
      this.xref.setStartXRef(this.startXRef);
    }
  }, {
    key: "numPages",
    get: function get() {
      var e = 0;
      e = this.catalog.hasActualNumPages ? this.catalog.numPages : this.xfaFactory ? this.xfaFactory.getNumPages() : this.linearization ? this.linearization.numPages : this.catalog.numPages;
      return shadow(this, "numPages", e);
    }
  }, {
    key: "_hasOnlyDocumentSignatures",
    value: function _hasOnlyDocumentSignatures(e) {
      var _this298 = this;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return !!Array.isArray(e) && e.every(function (e) {
        if (!((e = _this298.xref.fetchIfRef(e)) instanceof Dict)) return !1;
        if (e.has("Kids")) {
          if (++t > 10) {
            warn("_hasOnlyDocumentSignatures: maximum recursion depth reached");
            return !1;
          }
          return _this298._hasOnlyDocumentSignatures(e.get("Kids"), t);
        }
        var i = isName(e.get("FT"), "Sig"),
          a = e.get("Rect"),
          s = Array.isArray(a) && a.every(function (e) {
            return 0 === e;
          });
        return i && s;
      });
    }
  }, {
    key: "_xfaStreams",
    get: function get() {
      var e = this.catalog.acroForm;
      if (!e) return null;
      var t = e.get("XFA"),
        i = {
          "xdp:xdp": "",
          template: "",
          datasets: "",
          config: "",
          connectionSet: "",
          localeSet: "",
          stylesheet: "",
          "/xdp:xdp": ""
        };
      if (t instanceof BaseStream && !t.isEmpty) {
        i["xdp:xdp"] = t;
        return i;
      }
      if (!Array.isArray(t) || 0 === t.length) return null;
      for (var _e644 = 0, _a323 = t.length; _e644 < _a323; _e644 += 2) {
        var _s215 = void 0;
        _s215 = 0 === _e644 ? "xdp:xdp" : _e644 === _a323 - 2 ? "/xdp:xdp" : t[_e644];
        if (!i.hasOwnProperty(_s215)) continue;
        var r = this.xref.fetchIfRef(t[_e644 + 1]);
        r instanceof BaseStream && !r.isEmpty && (i[_s215] = r);
      }
      return i;
    }
  }, {
    key: "xfaDatasets",
    get: function get() {
      var e = this._xfaStreams;
      if (!e) return shadow(this, "xfaDatasets", null);
      for (var _i418 = 0, _arr7 = ["datasets", "xdp:xdp"]; _i418 < _arr7.length; _i418++) {
        var _t482 = _arr7[_i418];
        var _i419 = e[_t482];
        if (_i419) try {
          var _e645 = stringToUTF8String(_i419.getString());
          return shadow(this, "xfaDatasets", new DatasetReader(_defineProperty({}, _t482, _e645)));
        } catch (_unused15) {
          warn("XFA - Invalid utf-8 string.");
          break;
        }
      }
      return shadow(this, "xfaDatasets", null);
    }
  }, {
    key: "xfaData",
    get: function get() {
      var e = this._xfaStreams;
      if (!e) return null;
      var t = Object.create(null);
      for (var _i420 = 0, _Object$entries7 = Object.entries(e); _i420 < _Object$entries7.length; _i420++) {
        var _ref207 = _Object$entries7[_i420];
        var _ref208 = _slicedToArray(_ref207, 2);
        var _i421 = _ref208[0];
        var _a324 = _ref208[1];
        if (_a324) try {
          t[_i421] = stringToUTF8String(_a324.getString());
        } catch (_unused16) {
          warn("XFA - Invalid utf-8 string.");
          return null;
        }
      }
      return t;
    }
  }, {
    key: "xfaFactory",
    get: function get() {
      var e;
      this.pdfManager.enableXfa && this.catalog.needsRendering && this.formInfo.hasXfa && !this.formInfo.hasAcroForm && (e = this.xfaData);
      return shadow(this, "xfaFactory", e ? new XFAFactory(e) : null);
    }
  }, {
    key: "isPureXfa",
    get: function get() {
      return !!this.xfaFactory && this.xfaFactory.isValid();
    }
  }, {
    key: "htmlForXfa",
    get: function get() {
      return this.xfaFactory ? this.xfaFactory.getPages() : null;
    }
  }, {
    key: "loadXfaImages",
    value: function () {
      var _loadXfaImages = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee83() {
        var e, t, i, a, _iterator222, _step222, _i422, _t483;
        return _regeneratorRuntime().wrap(function _callee83$(_context95) {
          while (1) switch (_context95.prev = _context95.next) {
            case 0:
              _context95.next = 2;
              return this.pdfManager.ensureCatalog("xfaImages");
            case 2:
              e = _context95.sent;
              if (e) {
                _context95.next = 5;
                break;
              }
              return _context95.abrupt("return");
            case 5:
              t = e.getKeys(), i = new ObjectLoader(e, t, this.xref);
              _context95.next = 8;
              return i.load();
            case 8:
              a = new Map();
              _iterator222 = _createForOfIteratorHelper(t);
              try {
                for (_iterator222.s(); !(_step222 = _iterator222.n()).done;) {
                  _i422 = _step222.value;
                  _t483 = e.get(_i422);
                  _t483 instanceof BaseStream && a.set(_i422, _t483.getBytes());
                }
              } catch (err) {
                _iterator222.e(err);
              } finally {
                _iterator222.f();
              }
              this.xfaFactory.setImages(a);
            case 12:
            case "end":
              return _context95.stop();
          }
        }, _callee83, this);
      }));
      function loadXfaImages() {
        return _loadXfaImages.apply(this, arguments);
      }
      return loadXfaImages;
    }()
  }, {
    key: "loadXfaFonts",
    value: function () {
      var _loadXfaFonts = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee84(e, t) {
        var i, a, s, r, n, g, o, c, C, h, l, _iterator223, _step223, _ref209, _ref210, _e646, _i423, _s216, _r167, _n110, Q, E, _iterator224, _step224, _e647, _iterator225, _step225, _e648, _i424, _arr8, _i425, _s217, _r168;
        return _regeneratorRuntime().wrap(function _callee84$(_context96) {
          while (1) switch (_context96.prev = _context96.next) {
            case 0:
              _context96.next = 2;
              return this.pdfManager.ensureCatalog("acroForm");
            case 2:
              i = _context96.sent;
              if (i) {
                _context96.next = 5;
                break;
              }
              return _context96.abrupt("return");
            case 5:
              _context96.next = 7;
              return i.getAsync("DR");
            case 7:
              a = _context96.sent;
              if (a instanceof Dict) {
                _context96.next = 10;
                break;
              }
              return _context96.abrupt("return");
            case 10:
              s = new ObjectLoader(a, ["Font"], this.xref);
              _context96.next = 13;
              return s.load();
            case 13:
              r = a.get("Font");
              if (r instanceof Dict) {
                _context96.next = 16;
                break;
              }
              return _context96.abrupt("return");
            case 16:
              n = Object.assign(Object.create(null), this.pdfManager.evaluatorOptions);
              n.useSystemFonts = !1;
              g = new PartialEvaluator({
                xref: this.xref,
                handler: e,
                pageIndex: -1,
                idFactory: this._globalIdFactory,
                fontCache: this.catalog.fontCache,
                builtInCMapCache: this.catalog.builtInCMapCache,
                standardFontDataCache: this.catalog.standardFontDataCache,
                options: n
              });
              o = new OperatorList();
              c = [];
              _context96.t0 = function clone() {
                return this;
              };
              C = {
                get font() {
                  return c.at(-1);
                },
                set font(e) {
                  c.push(e);
                },
                clone: _context96.t0
              };
              h = new Map();
              r.forEach(function (e, t) {
                h.set(e, t);
              });
              l = [];
              _iterator223 = _createForOfIteratorHelper(h);
              _context96.prev = 27;
              _iterator223.s();
            case 29:
              if ((_step223 = _iterator223.n()).done) {
                _context96.next = 43;
                break;
              }
              _ref209 = _step223.value;
              _ref210 = _slicedToArray(_ref209, 2);
              _e646 = _ref210[0];
              _i423 = _ref210[1];
              _s216 = _i423.get("FontDescriptor");
              if (_s216 instanceof Dict) {
                _context96.next = 37;
                break;
              }
              return _context96.abrupt("continue", 41);
            case 37:
              _r167 = _s216.get("FontFamily");
              _r167 = _r167.replaceAll(/[ ]+(\d)/g, "$1");
              _n110 = {
                fontFamily: _r167,
                fontWeight: _s216.get("FontWeight"),
                italicAngle: -_s216.get("ItalicAngle")
              };
              validateCSSFont(_n110) && l.push(g.handleSetFont(a, [Name.get(_e646), 1], null, o, t, C, null, _n110).catch(function (e) {
                warn("loadXfaFonts: \"".concat(e, "\"."));
                return null;
              }));
            case 41:
              _context96.next = 29;
              break;
            case 43:
              _context96.next = 48;
              break;
            case 45:
              _context96.prev = 45;
              _context96.t1 = _context96["catch"](27);
              _iterator223.e(_context96.t1);
            case 48:
              _context96.prev = 48;
              _iterator223.f();
              return _context96.finish(48);
            case 51:
              _context96.next = 53;
              return Promise.all(l);
            case 53:
              Q = this.xfaFactory.setFonts(c);
              if (Q) {
                _context96.next = 56;
                break;
              }
              return _context96.abrupt("return");
            case 56:
              n.ignoreErrors = !0;
              l.length = 0;
              c.length = 0;
              E = new Set();
              _iterator224 = _createForOfIteratorHelper(Q);
              try {
                for (_iterator224.s(); !(_step224 = _iterator224.n()).done;) {
                  _e647 = _step224.value;
                  getXfaFontName("".concat(_e647, "-Regular")) || E.add(_e647);
                }
              } catch (err) {
                _iterator224.e(err);
              } finally {
                _iterator224.f();
              }
              E.size && Q.push("PdfJS-Fallback");
              _iterator225 = _createForOfIteratorHelper(Q);
              try {
                for (_iterator225.s(); !(_step225 = _iterator225.n()).done;) {
                  _e648 = _step225.value;
                  if (!E.has(_e648)) for (_i424 = 0, _arr8 = [{
                    name: "Regular",
                    fontWeight: 400,
                    italicAngle: 0
                  }, {
                    name: "Bold",
                    fontWeight: 700,
                    italicAngle: 0
                  }, {
                    name: "Italic",
                    fontWeight: 400,
                    italicAngle: 12
                  }, {
                    name: "BoldItalic",
                    fontWeight: 700,
                    italicAngle: 12
                  }]; _i424 < _arr8.length; _i424++) {
                    _i425 = _arr8[_i424];
                    _s217 = "".concat(_e648, "-").concat(_i425.name), _r168 = getXfaFontDict(_s217);
                    l.push(g.handleSetFont(a, [Name.get(_s217), 1], null, o, t, C, _r168, {
                      fontFamily: _e648,
                      fontWeight: _i425.fontWeight,
                      italicAngle: _i425.italicAngle
                    }).catch(function (e) {
                      warn("loadXfaFonts: \"".concat(e, "\"."));
                      return null;
                    }));
                  }
                }
              } catch (err) {
                _iterator225.e(err);
              } finally {
                _iterator225.f();
              }
              _context96.next = 67;
              return Promise.all(l);
            case 67:
              this.xfaFactory.appendFonts(c, E);
            case 68:
            case "end":
              return _context96.stop();
          }
        }, _callee84, this, [[27, 45, 48, 51]]);
      }));
      function loadXfaFonts(_x191, _x192) {
        return _loadXfaFonts.apply(this, arguments);
      }
      return loadXfaFonts;
    }()
  }, {
    key: "serializeXfaData",
    value: function () {
      var _serializeXfaData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee85(e) {
        return _regeneratorRuntime().wrap(function _callee85$(_context97) {
          while (1) switch (_context97.prev = _context97.next) {
            case 0:
              return _context97.abrupt("return", this.xfaFactory ? this.xfaFactory.serializeData(e) : null);
            case 1:
            case "end":
              return _context97.stop();
          }
        }, _callee85, this);
      }));
      function serializeXfaData(_x193) {
        return _serializeXfaData.apply(this, arguments);
      }
      return serializeXfaData;
    }()
  }, {
    key: "version",
    get: function get() {
      return this.catalog.version || this._version;
    }
  }, {
    key: "formInfo",
    get: function get() {
      var e = {
          hasFields: !1,
          hasAcroForm: !1,
          hasXfa: !1,
          hasSignatures: !1
        },
        t = this.catalog.acroForm;
      if (!t) return shadow(this, "formInfo", e);
      try {
        var _i426 = t.get("Fields"),
          _a325 = Array.isArray(_i426) && _i426.length > 0;
        e.hasFields = _a325;
        var _s218 = t.get("XFA");
        e.hasXfa = Array.isArray(_s218) && _s218.length > 0 || _s218 instanceof BaseStream && !_s218.isEmpty;
        var r = !!(1 & t.get("SigFlags")),
          n = r && this._hasOnlyDocumentSignatures(_i426);
        e.hasAcroForm = _a325 && !n;
        e.hasSignatures = r;
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        warn("Cannot fetch form information: \"".concat(e, "\"."));
      }
      return shadow(this, "formInfo", e);
    }
  }, {
    key: "documentInfo",
    get: function get() {
      var e = {
        PDFFormatVersion: this.version,
        Language: this.catalog.lang,
        EncryptFilterName: this.xref.encrypt ? this.xref.encrypt.filterName : null,
        IsLinearized: !!this.linearization,
        IsAcroFormPresent: this.formInfo.hasAcroForm,
        IsXFAPresent: this.formInfo.hasXfa,
        IsCollectionPresent: !!this.catalog.collection,
        IsSignaturesPresent: this.formInfo.hasSignatures
      };
      var t;
      try {
        t = this.xref.trailer.get("Info");
      } catch (e) {
        if (e instanceof MissingDataException) throw e;
        info("The document information dictionary is invalid.");
      }
      if (!(t instanceof Dict)) return shadow(this, "documentInfo", e);
      var _iterator226 = _createForOfIteratorHelper(t.getKeys()),
        _step226;
      try {
        for (_iterator226.s(); !(_step226 = _iterator226.n()).done;) {
          var _i427 = _step226.value;
          var _a326 = t.get(_i427);
          switch (_i427) {
            case "Title":
            case "Author":
            case "Subject":
            case "Keywords":
            case "Creator":
            case "Producer":
            case "CreationDate":
            case "ModDate":
              if ("string" == typeof _a326) {
                e[_i427] = stringToPDFString(_a326);
                continue;
              }
              break;
            case "Trapped":
              if (_a326 instanceof Name) {
                e[_i427] = _a326;
                continue;
              }
              break;
            default:
              var _t484 = void 0;
              switch (_typeof(_a326)) {
                case "string":
                  _t484 = stringToPDFString(_a326);
                  break;
                case "number":
                case "boolean":
                  _t484 = _a326;
                  break;
                default:
                  _a326 instanceof Name && (_t484 = _a326);
              }
              if (void 0 === _t484) {
                warn("Bad value, for custom key \"".concat(_i427, "\", in Info: ").concat(_a326, "."));
                continue;
              }
              e.Custom || (e.Custom = Object.create(null));
              e.Custom[_i427] = _t484;
              continue;
          }
          warn("Bad value, for key \"".concat(_i427, "\", in Info: ").concat(_a326, "."));
        }
      } catch (err) {
        _iterator226.e(err);
      } finally {
        _iterator226.f();
      }
      return shadow(this, "documentInfo", e);
    }
  }, {
    key: "fingerprints",
    get: function get() {
      var e = "\0".repeat(16);
      function validate(t) {
        return "string" == typeof t && 16 === t.length && t !== e;
      }
      var t = this.xref.trailer.get("ID");
      var i, a;
      if (Array.isArray(t) && validate(t[0])) {
        i = stringToBytes(t[0]);
        t[1] !== t[0] && validate(t[1]) && (a = stringToBytes(t[1]));
      } else i = vs(this.stream.getByteRange(0, 1024), 0, 1024);
      return shadow(this, "fingerprints", [toHexUtil(i), a ? toHexUtil(a) : null]);
    }
  }, {
    key: "_getLinearizationPage",
    value: function () {
      var _getLinearizationPage2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee86(e) {
        var t, i, a, s, _e649, _i428;
        return _regeneratorRuntime().wrap(function _callee86$(_context98) {
          while (1) switch (_context98.prev = _context98.next) {
            case 0:
              t = this.catalog, i = this.linearization, a = this.xref, s = Ref.get(i.objectNumberFirst, 0);
              _context98.prev = 1;
              _context98.next = 4;
              return a.fetchAsync(s);
            case 4:
              _e649 = _context98.sent;
              if (!(_e649 instanceof Dict)) {
                _context98.next = 16;
                break;
              }
              _i428 = _e649.getRaw("Type");
              _context98.t0 = _i428 instanceof Ref;
              if (!_context98.t0) {
                _context98.next = 12;
                break;
              }
              _context98.next = 11;
              return a.fetchAsync(_i428);
            case 11:
              _i428 = _context98.sent;
            case 12:
              if (!(isName(_i428, "Page") || !_e649.has("Type") && !_e649.has("Kids") && _e649.has("Contents"))) {
                _context98.next = 16;
                break;
              }
              t.pageKidsCountCache.has(s) || t.pageKidsCountCache.put(s, 1);
              t.pageIndexCache.has(s) || t.pageIndexCache.put(s, 0);
              return _context98.abrupt("return", [_e649, s]);
            case 16:
              throw new FormatError("The Linearization dictionary doesn't point to a valid Page dictionary.");
            case 19:
              _context98.prev = 19;
              _context98.t1 = _context98["catch"](1);
              warn("_getLinearizationPage: \"".concat(_context98.t1.message, "\"."));
              return _context98.abrupt("return", t.getPageDict(e));
            case 23:
            case "end":
              return _context98.stop();
          }
        }, _callee86, this, [[1, 19]]);
      }));
      function _getLinearizationPage(_x194) {
        return _getLinearizationPage2.apply(this, arguments);
      }
      return _getLinearizationPage;
    }()
  }, {
    key: "getPage",
    value: function getPage(e) {
      var _this299 = this;
      var t = this._pagePromises.get(e);
      if (t) return t;
      var i = this.catalog,
        a = this.linearization,
        s = this.xfaFactory;
      var r;
      r = s ? Promise.resolve([Dict.empty, null]) : (a === null || a === void 0 ? void 0 : a.pageFirst) === e ? this._getLinearizationPage(e) : i.getPageDict(e);
      r = r.then(function (_ref211) {
        var _ref212 = _slicedToArray(_ref211, 2),
          t = _ref212[0],
          a = _ref212[1];
        return new Page({
          pdfManager: _this299.pdfManager,
          xref: _this299.xref,
          pageIndex: e,
          pageDict: t,
          ref: a,
          globalIdFactory: _this299._globalIdFactory,
          fontCache: i.fontCache,
          builtInCMapCache: i.builtInCMapCache,
          standardFontDataCache: i.standardFontDataCache,
          globalImageCache: i.globalImageCache,
          systemFontCache: i.systemFontCache,
          nonBlendModesSet: i.nonBlendModesSet,
          xfaFactory: s
        });
      });
      this._pagePromises.set(e, r);
      return r;
    }
  }, {
    key: "checkFirstPage",
    value: function () {
      var _checkFirstPage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee87() {
        var e,
          _args99 = arguments;
        return _regeneratorRuntime().wrap(function _callee87$(_context99) {
          while (1) switch (_context99.prev = _context99.next) {
            case 0:
              e = _args99.length > 0 && _args99[0] !== undefined ? _args99[0] : !1;
              if (e) {
                _context99.next = 14;
                break;
              }
              _context99.prev = 2;
              _context99.next = 5;
              return this.getPage(0);
            case 5:
              _context99.next = 14;
              break;
            case 7:
              _context99.prev = 7;
              _context99.t0 = _context99["catch"](2);
              if (!(_context99.t0 instanceof XRefEntryException)) {
                _context99.next = 14;
                break;
              }
              this._pagePromises.delete(0);
              _context99.next = 13;
              return this.cleanup();
            case 13:
              throw new XRefParseException();
            case 14:
            case "end":
              return _context99.stop();
          }
        }, _callee87, this, [[2, 7]]);
      }));
      function checkFirstPage() {
        return _checkFirstPage.apply(this, arguments);
      }
      return checkFirstPage;
    }()
  }, {
    key: "checkLastPage",
    value: function () {
      var _checkLastPage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee88() {
        var e,
          t,
          i,
          a,
          r,
          _iterator227,
          _step227,
          _ref213,
          _ref214,
          _e650,
          _ref214$,
          _a327,
          _s219,
          _r169,
          _args100 = arguments;
        return _regeneratorRuntime().wrap(function _callee88$(_context100) {
          while (1) switch (_context100.prev = _context100.next) {
            case 0:
              e = _args100.length > 0 && _args100[0] !== undefined ? _args100[0] : !1;
              t = this.catalog, i = this.pdfManager;
              t.setActualNumPages();
              _context100.prev = 3;
              _context100.next = 6;
              return Promise.all([i.ensureDoc("xfaFactory"), i.ensureDoc("linearization"), i.ensureCatalog("numPages")]);
            case 6:
              if (!this.xfaFactory) {
                _context100.next = 8;
                break;
              }
              return _context100.abrupt("return");
            case 8:
              a = this.linearization ? this.linearization.numPages : t.numPages;
              if (Number.isInteger(a)) {
                _context100.next = 11;
                break;
              }
              throw new FormatError("Page count is not an integer.");
            case 11:
              if (!(a <= 1)) {
                _context100.next = 13;
                break;
              }
              return _context100.abrupt("return");
            case 13:
              _context100.next = 15;
              return this.getPage(a - 1);
            case 15:
              _context100.next = 40;
              break;
            case 17:
              _context100.prev = 17;
              _context100.t0 = _context100["catch"](3);
              this._pagePromises.delete(a - 1);
              _context100.next = 22;
              return this.cleanup();
            case 22:
              if (!(_context100.t0 instanceof XRefEntryException && !e)) {
                _context100.next = 24;
                break;
              }
              throw new XRefParseException();
            case 24:
              warn("checkLastPage - invalid /Pages tree /Count: ".concat(a, "."));
              _context100.prev = 25;
              _context100.next = 28;
              return t.getAllPageDicts(e);
            case 28:
              r = _context100.sent;
              _context100.next = 37;
              break;
            case 31:
              _context100.prev = 31;
              _context100.t1 = _context100["catch"](25);
              if (!(_context100.t1 instanceof XRefEntryException && !e)) {
                _context100.next = 35;
                break;
              }
              throw new XRefParseException();
            case 35:
              t.setActualNumPages(1);
              return _context100.abrupt("return");
            case 37:
              _iterator227 = _createForOfIteratorHelper(r);
              try {
                for (_iterator227.s(); !(_step227 = _iterator227.n()).done;) {
                  _ref213 = _step227.value;
                  _ref214 = _slicedToArray(_ref213, 2);
                  _e650 = _ref214[0];
                  _ref214$ = _slicedToArray(_ref214[1], 2);
                  _a327 = _ref214$[0];
                  _s219 = _ref214$[1];
                  {
                    _r169 = void 0;
                    if (_a327 instanceof Error) {
                      _r169 = Promise.reject(_a327);
                      _r169.catch(function () {});
                    } else _r169 = Promise.resolve(new Page({
                      pdfManager: i,
                      xref: this.xref,
                      pageIndex: _e650,
                      pageDict: _a327,
                      ref: _s219,
                      globalIdFactory: this._globalIdFactory,
                      fontCache: t.fontCache,
                      builtInCMapCache: t.builtInCMapCache,
                      standardFontDataCache: t.standardFontDataCache,
                      globalImageCache: t.globalImageCache,
                      systemFontCache: t.systemFontCache,
                      nonBlendModesSet: t.nonBlendModesSet,
                      xfaFactory: null
                    }));
                    this._pagePromises.set(_e650, _r169);
                  }
                }
              } catch (err) {
                _iterator227.e(err);
              } finally {
                _iterator227.f();
              }
              t.setActualNumPages(r.size);
            case 40:
            case "end":
              return _context100.stop();
          }
        }, _callee88, this, [[3, 17], [25, 31]]);
      }));
      function checkLastPage() {
        return _checkLastPage.apply(this, arguments);
      }
      return checkLastPage;
    }()
  }, {
    key: "fontFallback",
    value: function fontFallback(e, t) {
      return this.catalog.fontFallback(e, t);
    }
  }, {
    key: "cleanup",
    value: function () {
      var _cleanup2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee89() {
        var e,
          _args101 = arguments;
        return _regeneratorRuntime().wrap(function _callee89$(_context101) {
          while (1) switch (_context101.prev = _context101.next) {
            case 0:
              e = _args101.length > 0 && _args101[0] !== undefined ? _args101[0] : !1;
              return _context101.abrupt("return", this.catalog ? this.catalog.cleanup(e) : clearGlobalCaches());
            case 2:
            case "end":
              return _context101.stop();
          }
        }, _callee89, this);
      }));
      function cleanup() {
        return _cleanup2.apply(this, arguments);
      }
      return cleanup;
    }()
  }, {
    key: "fieldObjects",
    get: function get() {
      var _this300 = this;
      return shadow(this, "fieldObjects", this.pdfManager.ensureDoc("formInfo").then(/*#__PURE__*/function () {
        var _ref215 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee91(e) {
          var _yield$Promise$all5, _yield$Promise$all6, t, i, a, s, r, n, _iterator228, _step228, _e651, g, _iterator229, _step229, _loop6, _ref217;
          return _regeneratorRuntime().wrap(function _callee91$(_context103) {
            while (1) switch (_context103.prev = _context103.next) {
              case 0:
                if (e.hasFields) {
                  _context103.next = 2;
                  break;
                }
                return _context103.abrupt("return", null);
              case 2:
                _context103.next = 4;
                return Promise.all([_this300.pdfManager.ensureDoc("annotationGlobals"), _this300.pdfManager.ensureCatalog("acroForm")]);
              case 4:
                _yield$Promise$all5 = _context103.sent;
                _yield$Promise$all6 = _slicedToArray(_yield$Promise$all5, 2);
                t = _yield$Promise$all6[0];
                i = _yield$Promise$all6[1];
                if (t) {
                  _context103.next = 10;
                  break;
                }
                return _context103.abrupt("return", null);
              case 10:
                a = new RefSet(), s = Object.create(null), r = new Map(), n = new RefSetCache();
                _context103.t0 = _createForOfIteratorHelper;
                _context103.next = 14;
                return i.getAsync("Fields");
              case 14:
                _context103.t1 = _context103.sent;
                _iterator228 = (0, _context103.t0)(_context103.t1);
                _context103.prev = 16;
                _iterator228.s();
              case 18:
                if ((_step228 = _iterator228.n()).done) {
                  _context103.next = 24;
                  break;
                }
                _e651 = _step228.value;
                _context103.next = 22;
                return _classPrivateFieldLooseBase(_this300, _Z)[_Z]("", null, _e651, r, t, a, n);
              case 22:
                _context103.next = 18;
                break;
              case 24:
                _context103.next = 29;
                break;
              case 26:
                _context103.prev = 26;
                _context103.t2 = _context103["catch"](16);
                _iterator228.e(_context103.t2);
              case 29:
                _context103.prev = 29;
                _iterator228.f();
                return _context103.finish(29);
              case 32:
                g = [];
                _iterator229 = _createForOfIteratorHelper(r);
                _context103.prev = 34;
                _loop6 = /*#__PURE__*/_regeneratorRuntime().mark(function _callee90() {
                  var _ref216, e, t;
                  return _regeneratorRuntime().wrap(function _callee90$(_context102) {
                    while (1) switch (_context102.prev = _context102.next) {
                      case 0:
                        _ref216 = _step229.value;
                        _ref217 = _slicedToArray(_ref216, 2);
                        e = _ref217[0];
                        t = _ref217[1];
                        g.push(Promise.all(t).then(function (t) {
                          (t = t.filter(function (e) {
                            return !!e;
                          })).length > 0 && (s[e] = t);
                        }));
                      case 5:
                      case "end":
                        return _context102.stop();
                    }
                  }, _callee90);
                });
                _iterator229.s();
              case 37:
                if ((_step229 = _iterator229.n()).done) {
                  _context103.next = 41;
                  break;
                }
                return _context103.delegateYield(_loop6(), "t3", 39);
              case 39:
                _context103.next = 37;
                break;
              case 41:
                _context103.next = 46;
                break;
              case 43:
                _context103.prev = 43;
                _context103.t4 = _context103["catch"](34);
                _iterator229.e(_context103.t4);
              case 46:
                _context103.prev = 46;
                _iterator229.f();
                return _context103.finish(46);
              case 49:
                _context103.next = 51;
                return Promise.all(g);
              case 51:
                return _context103.abrupt("return", {
                  allFields: s,
                  orphanFields: n
                });
              case 52:
              case "end":
                return _context103.stop();
            }
          }, _callee91, null, [[16, 26, 29, 32], [34, 43, 46, 49]]);
        }));
        return function (_x195) {
          return _ref215.apply(this, arguments);
        };
      }()));
    }
  }, {
    key: "hasJSActions",
    get: function get() {
      return shadow(this, "hasJSActions", this.pdfManager.ensureDoc("_parseHasJSActions"));
    }
  }, {
    key: "_parseHasJSActions",
    value: function () {
      var _parseHasJSActions2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee92() {
        var _yield$Promise$all7, _yield$Promise$all8, e, t;
        return _regeneratorRuntime().wrap(function _callee92$(_context104) {
          while (1) switch (_context104.prev = _context104.next) {
            case 0:
              _context104.next = 2;
              return Promise.all([this.pdfManager.ensureCatalog("jsActions"), this.pdfManager.ensureDoc("fieldObjects")]);
            case 2:
              _yield$Promise$all7 = _context104.sent;
              _yield$Promise$all8 = _slicedToArray(_yield$Promise$all7, 2);
              e = _yield$Promise$all8[0];
              t = _yield$Promise$all8[1];
              return _context104.abrupt("return", !!e || !!t && Object.values(t.allFields).some(function (e) {
                return e.some(function (e) {
                  return null !== e.actions;
                });
              }));
            case 7:
            case "end":
              return _context104.stop();
          }
        }, _callee92, this);
      }));
      function _parseHasJSActions() {
        return _parseHasJSActions2.apply(this, arguments);
      }
      return _parseHasJSActions;
    }()
  }, {
    key: "calculationOrderIds",
    get: function get() {
      var _this$catalog$acroFor;
      var e = (_this$catalog$acroFor = this.catalog.acroForm) === null || _this$catalog$acroFor === void 0 ? void 0 : _this$catalog$acroFor.get("CO");
      if (!Array.isArray(e) || 0 === e.length) return shadow(this, "calculationOrderIds", null);
      var t = [];
      var _iterator230 = _createForOfIteratorHelper(e),
        _step230;
      try {
        for (_iterator230.s(); !(_step230 = _iterator230.n()).done;) {
          var _i429 = _step230.value;
          _i429 instanceof Ref && t.push(_i429.toString());
        }
      } catch (err) {
        _iterator230.e(err);
      } finally {
        _iterator230.f();
      }
      return shadow(this, "calculationOrderIds", t.length ? t : null);
    }
  }, {
    key: "annotationGlobals",
    get: function get() {
      return shadow(this, "annotationGlobals", AnnotationFactory.createGlobals(this.pdfManager));
    }
  }]);
}();
function _Z2(_x227, _x228, _x229, _x230, _x231, _x232, _x233) {
  return _Z3.apply(this, arguments);
}
function _Z3() {
  _Z3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee122(e, t, i, a, s, r, n) {
    var g, o, _t505, _i445, _t506, c, _iterator253, _step253, _t507;
    return _regeneratorRuntime().wrap(function _callee122$(_context134) {
      while (1) switch (_context134.prev = _context134.next) {
        case 0:
          g = this.xref;
          if (!(!(i instanceof Ref) || r.has(i))) {
            _context134.next = 3;
            break;
          }
          return _context134.abrupt("return");
        case 3:
          r.put(i);
          _context134.next = 6;
          return g.fetchAsync(i);
        case 6:
          o = _context134.sent;
          if (o instanceof Dict) {
            _context134.next = 9;
            break;
          }
          return _context134.abrupt("return");
        case 9:
          if (!o.has("T")) {
            _context134.next = 18;
            break;
          }
          _context134.t0 = stringToPDFString;
          _context134.next = 13;
          return o.getAsync("T");
        case 13:
          _context134.t1 = _context134.sent;
          _t505 = (0, _context134.t0)(_context134.t1);
          e = "" === e ? _t505 : "".concat(e, ".").concat(_t505);
          _context134.next = 38;
          break;
        case 18:
          _i445 = o;
        case 19:
          _i445 = _i445.getRaw("Parent") || t;
          if (!(_i445 instanceof Ref)) {
            _context134.next = 26;
            break;
          }
          if (!r.has(_i445)) {
            _context134.next = 23;
            break;
          }
          return _context134.abrupt("break", 38);
        case 23:
          _context134.next = 25;
          return g.fetchAsync(_i445);
        case 25:
          _i445 = _context134.sent;
        case 26:
          if (_i445 instanceof Dict) {
            _context134.next = 28;
            break;
          }
          return _context134.abrupt("break", 38);
        case 28:
          if (!_i445.has("T")) {
            _context134.next = 36;
            break;
          }
          _context134.t2 = stringToPDFString;
          _context134.next = 32;
          return _i445.getAsync("T");
        case 32:
          _context134.t3 = _context134.sent;
          _t506 = (0, _context134.t2)(_context134.t3);
          e = "" === e ? _t506 : "".concat(e, ".").concat(_t506);
          return _context134.abrupt("break", 38);
        case 36:
          _context134.next = 19;
          break;
        case 38:
          t && !o.has("Parent") && isName(o.get("Subtype"), "Widget") && n.put(i, t);
          a.has(e) || a.set(e, []);
          a.get(e).push(AnnotationFactory.create(g, i, s, null, !0, n, null).then(function (e) {
            return e === null || e === void 0 ? void 0 : e.getFieldObject();
          }).catch(function (e) {
            warn("#collectFieldObjects: \"".concat(e, "\"."));
            return null;
          }));
          if (o.has("Kids")) {
            _context134.next = 43;
            break;
          }
          return _context134.abrupt("return");
        case 43:
          _context134.next = 45;
          return o.getAsync("Kids");
        case 45:
          c = _context134.sent;
          if (!Array.isArray(c)) {
            _context134.next = 64;
            break;
          }
          _iterator253 = _createForOfIteratorHelper(c);
          _context134.prev = 48;
          _iterator253.s();
        case 50:
          if ((_step253 = _iterator253.n()).done) {
            _context134.next = 56;
            break;
          }
          _t507 = _step253.value;
          _context134.next = 54;
          return _classPrivateFieldLooseBase(this, _Z)[_Z](e, i, _t507, a, s, r, n);
        case 54:
          _context134.next = 50;
          break;
        case 56:
          _context134.next = 61;
          break;
        case 58:
          _context134.prev = 58;
          _context134.t4 = _context134["catch"](48);
          _iterator253.e(_context134.t4);
        case 61:
          _context134.prev = 61;
          _iterator253.f();
          return _context134.finish(61);
        case 64:
        case "end":
          return _context134.stop();
      }
    }, _callee122, this, [[48, 58, 61, 64]]);
  }));
  return _Z3.apply(this, arguments);
}
var BasePdfManager = /*#__PURE__*/function () {
  function BasePdfManager(e) {
    var _e$evaluatorOptions;
    _classCallCheck(this, BasePdfManager);
    this._docBaseUrl = function parseDocBaseUrl(e) {
      if (e) {
        var _t485 = createValidAbsoluteUrl(e);
        if (_t485) return _t485.href;
        warn("Invalid absolute docBaseUrl: \"".concat(e, "\"."));
      }
      return null;
    }(e.docBaseUrl);
    this._docId = e.docId;
    this._password = e.password;
    this.enableXfa = e.enableXfa;
    (_e$evaluatorOptions = e.evaluatorOptions).isOffscreenCanvasSupported && (_e$evaluatorOptions.isOffscreenCanvasSupported = FeatureTest.isOffscreenCanvasSupported);
    this.evaluatorOptions = Object.freeze(e.evaluatorOptions);
  }
  return _createClass(BasePdfManager, [{
    key: "docId",
    get: function get() {
      return this._docId;
    }
  }, {
    key: "password",
    get: function get() {
      return this._password;
    }
  }, {
    key: "docBaseUrl",
    get: function get() {
      return this._docBaseUrl;
    }
  }, {
    key: "catalog",
    get: function get() {
      return this.pdfDocument.catalog;
    }
  }, {
    key: "ensureDoc",
    value: function ensureDoc(e, t) {
      return this.ensure(this.pdfDocument, e, t);
    }
  }, {
    key: "ensureXRef",
    value: function ensureXRef(e, t) {
      return this.ensure(this.pdfDocument.xref, e, t);
    }
  }, {
    key: "ensureCatalog",
    value: function ensureCatalog(e, t) {
      return this.ensure(this.pdfDocument.catalog, e, t);
    }
  }, {
    key: "getPage",
    value: function getPage(e) {
      return this.pdfDocument.getPage(e);
    }
  }, {
    key: "fontFallback",
    value: function fontFallback(e, t) {
      return this.pdfDocument.fontFallback(e, t);
    }
  }, {
    key: "loadXfaFonts",
    value: function loadXfaFonts(e, t) {
      return this.pdfDocument.loadXfaFonts(e, t);
    }
  }, {
    key: "loadXfaImages",
    value: function loadXfaImages() {
      return this.pdfDocument.loadXfaImages();
    }
  }, {
    key: "serializeXfaData",
    value: function serializeXfaData(e) {
      return this.pdfDocument.serializeXfaData(e);
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return this.pdfDocument.cleanup(e);
    }
  }, {
    key: "ensure",
    value: function () {
      var _ensure = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee93(e, t, i) {
        return _regeneratorRuntime().wrap(function _callee93$(_context105) {
          while (1) switch (_context105.prev = _context105.next) {
            case 0:
              unreachable("Abstract method `ensure` called");
            case 1:
            case "end":
              return _context105.stop();
          }
        }, _callee93);
      }));
      function ensure(_x196, _x197, _x198) {
        return _ensure.apply(this, arguments);
      }
      return ensure;
    }()
  }, {
    key: "requestRange",
    value: function requestRange(e, t) {
      unreachable("Abstract method `requestRange` called");
    }
  }, {
    key: "requestLoadedStream",
    value: function requestLoadedStream() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      unreachable("Abstract method `requestLoadedStream` called");
    }
  }, {
    key: "sendProgressiveData",
    value: function sendProgressiveData(e) {
      unreachable("Abstract method `sendProgressiveData` called");
    }
  }, {
    key: "updatePassword",
    value: function updatePassword(e) {
      this._password = e;
    }
  }, {
    key: "terminate",
    value: function terminate(e) {
      unreachable("Abstract method `terminate` called");
    }
  }]);
}();
var LocalPdfManager = /*#__PURE__*/function (_BasePdfManager) {
  function LocalPdfManager(e) {
    var _this301;
    _classCallCheck(this, LocalPdfManager);
    _this301 = _callSuper(this, LocalPdfManager, [e]);
    var t = new Stream(e.source);
    _this301.pdfDocument = new PDFDocument(_this301, t);
    _this301._loadedStreamPromise = Promise.resolve(t);
    return _this301;
  }
  _inherits(LocalPdfManager, _BasePdfManager);
  return _createClass(LocalPdfManager, [{
    key: "ensure",
    value: function () {
      var _ensure2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee94(e, t, i) {
        var a;
        return _regeneratorRuntime().wrap(function _callee94$(_context106) {
          while (1) switch (_context106.prev = _context106.next) {
            case 0:
              a = e[t];
              return _context106.abrupt("return", "function" == typeof a ? a.apply(e, i) : a);
            case 2:
            case "end":
              return _context106.stop();
          }
        }, _callee94);
      }));
      function ensure(_x199, _x200, _x201) {
        return _ensure2.apply(this, arguments);
      }
      return ensure;
    }()
  }, {
    key: "requestRange",
    value: function requestRange(e, t) {
      return Promise.resolve();
    }
  }, {
    key: "requestLoadedStream",
    value: function requestLoadedStream() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return this._loadedStreamPromise;
    }
  }, {
    key: "terminate",
    value: function terminate(e) {}
  }]);
}(BasePdfManager);
var NetworkPdfManager = /*#__PURE__*/function (_BasePdfManager2) {
  function NetworkPdfManager(e) {
    var _this302;
    _classCallCheck(this, NetworkPdfManager);
    _this302 = _callSuper(this, NetworkPdfManager, [e]);
    _this302.streamManager = new ChunkedStreamManager(e.source, {
      msgHandler: e.handler,
      length: e.length,
      disableAutoFetch: e.disableAutoFetch,
      rangeChunkSize: e.rangeChunkSize
    });
    _this302.pdfDocument = new PDFDocument(_this302, _this302.streamManager.getStream());
    return _this302;
  }
  _inherits(NetworkPdfManager, _BasePdfManager2);
  return _createClass(NetworkPdfManager, [{
    key: "ensure",
    value: function () {
      var _ensure3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee95(e, t, i) {
        var _a328;
        return _regeneratorRuntime().wrap(function _callee95$(_context107) {
          while (1) switch (_context107.prev = _context107.next) {
            case 0:
              _context107.prev = 0;
              _a328 = e[t];
              return _context107.abrupt("return", "function" == typeof _a328 ? _a328.apply(e, i) : _a328);
            case 5:
              _context107.prev = 5;
              _context107.t0 = _context107["catch"](0);
              if (_context107.t0 instanceof MissingDataException) {
                _context107.next = 9;
                break;
              }
              throw _context107.t0;
            case 9:
              _context107.next = 11;
              return this.requestRange(_context107.t0.begin, _context107.t0.end);
            case 11:
              return _context107.abrupt("return", this.ensure(e, t, i));
            case 12:
            case "end":
              return _context107.stop();
          }
        }, _callee95, this, [[0, 5]]);
      }));
      function ensure(_x202, _x203, _x204) {
        return _ensure3.apply(this, arguments);
      }
      return ensure;
    }()
  }, {
    key: "requestRange",
    value: function requestRange(e, t) {
      return this.streamManager.requestRange(e, t);
    }
  }, {
    key: "requestLoadedStream",
    value: function requestLoadedStream() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return this.streamManager.requestAllChunks(e);
    }
  }, {
    key: "sendProgressiveData",
    value: function sendProgressiveData(e) {
      this.streamManager.onReceiveData({
        chunk: e
      });
    }
  }, {
    key: "terminate",
    value: function terminate(e) {
      this.streamManager.abort(e);
    }
  }]);
}(BasePdfManager);
var Cg = 1,
  hg = 2,
  lg = 1,
  Bg = 2,
  Qg = 3,
  Eg = 4,
  ug = 5,
  dg = 6,
  fg = 7,
  pg = 8;
function wrapReason(e) {
  e instanceof Error || "object" == _typeof(e) && null !== e || unreachable('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
  switch (e.name) {
    case "AbortException":
      return new AbortException(e.message);
    case "MissingPDFException":
      return new MissingPDFException(e.message);
    case "PasswordException":
      return new PasswordException(e.message, e.code);
    case "UnexpectedResponseException":
      return new UnexpectedResponseException(e.message, e.status);
    case "UnknownErrorException":
      return new UnknownErrorException(e.message, e.details);
    default:
      return new UnknownErrorException(e.message, e.toString());
  }
}
var _V = /*#__PURE__*/_classPrivateFieldLooseKey("V");
var _z = /*#__PURE__*/_classPrivateFieldLooseKey("z");
var _$ = /*#__PURE__*/_classPrivateFieldLooseKey("$");
var _2 = /*#__PURE__*/_classPrivateFieldLooseKey("_");
var _AA = /*#__PURE__*/_classPrivateFieldLooseKey("AA");
var MessageHandler = /*#__PURE__*/function () {
  function MessageHandler(_e652, _t486, _i430) {
    _classCallCheck(this, MessageHandler);
    Object.defineProperty(this, _AA, {
      value: _AA2
    });
    Object.defineProperty(this, _2, {
      value: _3
    });
    Object.defineProperty(this, _$, {
      value: _$2
    });
    Object.defineProperty(this, _z, {
      value: _z2
    });
    Object.defineProperty(this, _V, {
      writable: true,
      value: new AbortController()
    });
    this.sourceName = _e652;
    this.targetName = _t486;
    this.comObj = _i430;
    this.callbackId = 1;
    this.streamId = 1;
    this.streamSinks = Object.create(null);
    this.streamControllers = Object.create(null);
    this.callbackCapabilities = Object.create(null);
    this.actionHandler = Object.create(null);
    _i430.addEventListener("message", _classPrivateFieldLooseBase(this, _z)[_z].bind(this), {
      signal: _classPrivateFieldLooseBase(this, _V)[_V].signal
    });
  }
  return _createClass(MessageHandler, [{
    key: "on",
    value: function on(e, t) {
      var i = this.actionHandler;
      if (i[e]) throw new Error("There is already an actionName called \"".concat(e, "\""));
      i[e] = t;
    }
  }, {
    key: "send",
    value: function send(e, t, i) {
      this.comObj.postMessage({
        sourceName: this.sourceName,
        targetName: this.targetName,
        action: e,
        data: t
      }, i);
    }
  }, {
    key: "sendWithPromise",
    value: function sendWithPromise(e, t, i) {
      var a = this.callbackId++,
        s = Promise.withResolvers();
      this.callbackCapabilities[a] = s;
      try {
        this.comObj.postMessage({
          sourceName: this.sourceName,
          targetName: this.targetName,
          action: e,
          callbackId: a,
          data: t
        }, i);
      } catch (e) {
        s.reject(e);
      }
      return s.promise;
    }
  }, {
    key: "sendWithStream",
    value: function sendWithStream(e, t, i, a) {
      var _this303 = this;
      var s = this.streamId++,
        r = this.sourceName,
        n = this.targetName,
        g = this.comObj;
      return new ReadableStream({
        start: function start(i) {
          var o = Promise.withResolvers();
          _this303.streamControllers[s] = {
            controller: i,
            startCall: o,
            pullCall: null,
            cancelCall: null,
            isClosed: !1
          };
          g.postMessage({
            sourceName: r,
            targetName: n,
            action: e,
            streamId: s,
            data: t,
            desiredSize: i.desiredSize
          }, a);
          return o.promise;
        },
        pull: function pull(e) {
          var t = Promise.withResolvers();
          _this303.streamControllers[s].pullCall = t;
          g.postMessage({
            sourceName: r,
            targetName: n,
            stream: dg,
            streamId: s,
            desiredSize: e.desiredSize
          });
          return t.promise;
        },
        cancel: function cancel(e) {
          assert(e instanceof Error, "cancel must have a valid reason");
          var t = Promise.withResolvers();
          _this303.streamControllers[s].cancelCall = t;
          _this303.streamControllers[s].isClosed = !0;
          g.postMessage({
            sourceName: r,
            targetName: n,
            stream: lg,
            streamId: s,
            reason: wrapReason(e)
          });
          return t.promise;
        }
      }, i);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _classPrivateFieldLoo5;
      (_classPrivateFieldLoo5 = _classPrivateFieldLooseBase(this, _V)[_V]) === null || _classPrivateFieldLoo5 === void 0 || _classPrivateFieldLoo5.abort();
      _classPrivateFieldLooseBase(this, _V)[_V] = null;
    }
  }]);
}();
function _z2(_ref244) {
  var e = _ref244.data;
  if (e.targetName !== this.sourceName) return;
  if (e.stream) {
    _classPrivateFieldLooseBase(this, _2)[_2](e);
    return;
  }
  if (e.callback) {
    var _t502 = e.callbackId,
      _i443 = this.callbackCapabilities[_t502];
    if (!_i443) throw new Error("Cannot resolve callback ".concat(_t502));
    delete this.callbackCapabilities[_t502];
    if (e.callback === Cg) _i443.resolve(e.data);else {
      if (e.callback !== hg) throw new Error("Unexpected callback case");
      _i443.reject(wrapReason(e.reason));
    }
    return;
  }
  var t = this.actionHandler[e.action];
  if (!t) throw new Error("Unknown action from worker: ".concat(e.action));
  if (e.callbackId) {
    var _i444 = this.sourceName,
      _a337 = e.sourceName,
      s = this.comObj;
    new Promise(function (i) {
      i(t(e.data));
    }).then(function (t) {
      s.postMessage({
        sourceName: _i444,
        targetName: _a337,
        callback: Cg,
        callbackId: e.callbackId,
        data: t
      });
    }, function (t) {
      s.postMessage({
        sourceName: _i444,
        targetName: _a337,
        callback: hg,
        callbackId: e.callbackId,
        reason: wrapReason(t)
      });
    });
  } else e.streamId ? _classPrivateFieldLooseBase(this, _$)[_$](e) : t(e.data);
}
function _$2(e) {
  var t = e.streamId,
    i = this.sourceName,
    a = e.sourceName,
    s = this.comObj,
    r = this,
    n = this.actionHandler[e.action],
    g = {
      enqueue: function enqueue(e) {
        var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var n = arguments.length > 2 ? arguments[2] : undefined;
        if (this.isCancelled) return;
        var g = this.desiredSize;
        this.desiredSize -= r;
        if (g > 0 && this.desiredSize <= 0) {
          this.sinkCapability = Promise.withResolvers();
          this.ready = this.sinkCapability.promise;
        }
        s.postMessage({
          sourceName: i,
          targetName: a,
          stream: Eg,
          streamId: t,
          chunk: e
        }, n);
      },
      close: function close() {
        if (!this.isCancelled) {
          this.isCancelled = !0;
          s.postMessage({
            sourceName: i,
            targetName: a,
            stream: Qg,
            streamId: t
          });
          delete r.streamSinks[t];
        }
      },
      error: function error(e) {
        assert(e instanceof Error, "error must have a valid reason");
        if (!this.isCancelled) {
          this.isCancelled = !0;
          s.postMessage({
            sourceName: i,
            targetName: a,
            stream: ug,
            streamId: t,
            reason: wrapReason(e)
          });
        }
      },
      sinkCapability: Promise.withResolvers(),
      onPull: null,
      onCancel: null,
      isCancelled: !1,
      desiredSize: e.desiredSize,
      ready: null
    };
  g.sinkCapability.resolve();
  g.ready = g.sinkCapability.promise;
  this.streamSinks[t] = g;
  new Promise(function (t) {
    t(n(e.data, g));
  }).then(function () {
    s.postMessage({
      sourceName: i,
      targetName: a,
      stream: pg,
      streamId: t,
      success: !0
    });
  }, function (e) {
    s.postMessage({
      sourceName: i,
      targetName: a,
      stream: pg,
      streamId: t,
      reason: wrapReason(e)
    });
  });
}
function _3(e) {
  var t = e.streamId,
    i = this.sourceName,
    a = e.sourceName,
    s = this.comObj,
    r = this.streamControllers[t],
    n = this.streamSinks[t];
  switch (e.stream) {
    case pg:
      e.success ? r.startCall.resolve() : r.startCall.reject(wrapReason(e.reason));
      break;
    case fg:
      e.success ? r.pullCall.resolve() : r.pullCall.reject(wrapReason(e.reason));
      break;
    case dg:
      if (!n) {
        s.postMessage({
          sourceName: i,
          targetName: a,
          stream: fg,
          streamId: t,
          success: !0
        });
        break;
      }
      n.desiredSize <= 0 && e.desiredSize > 0 && n.sinkCapability.resolve();
      n.desiredSize = e.desiredSize;
      new Promise(function (e) {
        var _n$onPull;
        e((_n$onPull = n.onPull) === null || _n$onPull === void 0 ? void 0 : _n$onPull.call(n));
      }).then(function () {
        s.postMessage({
          sourceName: i,
          targetName: a,
          stream: fg,
          streamId: t,
          success: !0
        });
      }, function (e) {
        s.postMessage({
          sourceName: i,
          targetName: a,
          stream: fg,
          streamId: t,
          reason: wrapReason(e)
        });
      });
      break;
    case Eg:
      assert(r, "enqueue should have stream controller");
      if (r.isClosed) break;
      r.controller.enqueue(e.chunk);
      break;
    case Qg:
      assert(r, "close should have stream controller");
      if (r.isClosed) break;
      r.isClosed = !0;
      r.controller.close();
      _classPrivateFieldLooseBase(this, _AA)[_AA](r, t);
      break;
    case ug:
      assert(r, "error should have stream controller");
      r.controller.error(wrapReason(e.reason));
      _classPrivateFieldLooseBase(this, _AA)[_AA](r, t);
      break;
    case Bg:
      e.success ? r.cancelCall.resolve() : r.cancelCall.reject(wrapReason(e.reason));
      _classPrivateFieldLooseBase(this, _AA)[_AA](r, t);
      break;
    case lg:
      if (!n) break;
      new Promise(function (t) {
        var _n$onCancel;
        t((_n$onCancel = n.onCancel) === null || _n$onCancel === void 0 ? void 0 : _n$onCancel.call(n, wrapReason(e.reason)));
      }).then(function () {
        s.postMessage({
          sourceName: i,
          targetName: a,
          stream: Bg,
          streamId: t,
          success: !0
        });
      }, function (e) {
        s.postMessage({
          sourceName: i,
          targetName: a,
          stream: Bg,
          streamId: t,
          reason: wrapReason(e)
        });
      });
      n.sinkCapability.reject(wrapReason(e.reason));
      n.isCancelled = !0;
      delete this.streamSinks[t];
      break;
    default:
      throw new Error("Unexpected stream case");
  }
}
function _AA2(_x234, _x235) {
  return _AA3.apply(this, arguments);
}
function _AA3() {
  _AA3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee123(e, t) {
    var _e$startCall, _e$pullCall, _e$cancelCall;
    return _regeneratorRuntime().wrap(function _callee123$(_context135) {
      while (1) switch (_context135.prev = _context135.next) {
        case 0:
          _context135.next = 2;
          return Promise.allSettled([(_e$startCall = e.startCall) === null || _e$startCall === void 0 ? void 0 : _e$startCall.promise, (_e$pullCall = e.pullCall) === null || _e$pullCall === void 0 ? void 0 : _e$pullCall.promise, (_e$cancelCall = e.cancelCall) === null || _e$cancelCall === void 0 ? void 0 : _e$cancelCall.promise]);
        case 2:
          delete this.streamControllers[t];
        case 3:
        case "end":
          return _context135.stop();
      }
    }, _callee123, this);
  }));
  return _AA3.apply(this, arguments);
}
var PDFWorkerStream = /*#__PURE__*/function () {
  function PDFWorkerStream(e) {
    _classCallCheck(this, PDFWorkerStream);
    this._msgHandler = e;
    this._contentLength = null;
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }
  return _createClass(PDFWorkerStream, [{
    key: "getFullReader",
    value: function getFullReader() {
      assert(!this._fullRequestReader, "PDFWorkerStream.getFullReader can only be called once.");
      this._fullRequestReader = new PDFWorkerStreamReader(this._msgHandler);
      return this._fullRequestReader;
    }
  }, {
    key: "getRangeReader",
    value: function getRangeReader(e, t) {
      var i = new PDFWorkerStreamRangeReader(e, t, this._msgHandler);
      this._rangeRequestReaders.push(i);
      return i;
    }
  }, {
    key: "cancelAllRequests",
    value: function cancelAllRequests(e) {
      var _this$_fullRequestRea;
      (_this$_fullRequestRea = this._fullRequestReader) === null || _this$_fullRequestRea === void 0 || _this$_fullRequestRea.cancel(e);
      var _iterator231 = _createForOfIteratorHelper(this._rangeRequestReaders.slice(0)),
        _step231;
      try {
        for (_iterator231.s(); !(_step231 = _iterator231.n()).done;) {
          var _t487 = _step231.value;
          _t487.cancel(e);
        }
      } catch (err) {
        _iterator231.e(err);
      } finally {
        _iterator231.f();
      }
    }
  }]);
}();
var PDFWorkerStreamReader = /*#__PURE__*/function () {
  function PDFWorkerStreamReader(e) {
    var _this304 = this;
    _classCallCheck(this, PDFWorkerStreamReader);
    this._msgHandler = e;
    this.onProgress = null;
    this._contentLength = null;
    this._isRangeSupported = !1;
    this._isStreamingSupported = !1;
    var t = this._msgHandler.sendWithStream("GetReader");
    this._reader = t.getReader();
    this._headersReady = this._msgHandler.sendWithPromise("ReaderHeadersReady").then(function (e) {
      _this304._isStreamingSupported = e.isStreamingSupported;
      _this304._isRangeSupported = e.isRangeSupported;
      _this304._contentLength = e.contentLength;
    });
  }
  return _createClass(PDFWorkerStreamReader, [{
    key: "headersReady",
    get: function get() {
      return this._headersReady;
    }
  }, {
    key: "contentLength",
    get: function get() {
      return this._contentLength;
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._isStreamingSupported;
    }
  }, {
    key: "isRangeSupported",
    get: function get() {
      return this._isRangeSupported;
    }
  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee96() {
        var _yield$this$_reader$r, e, t;
        return _regeneratorRuntime().wrap(function _callee96$(_context108) {
          while (1) switch (_context108.prev = _context108.next) {
            case 0:
              _context108.next = 2;
              return this._reader.read();
            case 2:
              _yield$this$_reader$r = _context108.sent;
              e = _yield$this$_reader$r.value;
              t = _yield$this$_reader$r.done;
              return _context108.abrupt("return", t ? {
                value: void 0,
                done: !0
              } : {
                value: e.buffer,
                done: !1
              });
            case 6:
            case "end":
              return _context108.stop();
          }
        }, _callee96, this);
      }));
      function read() {
        return _read.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(e) {
      this._reader.cancel(e);
    }
  }]);
}();
var PDFWorkerStreamRangeReader = /*#__PURE__*/function () {
  function PDFWorkerStreamRangeReader(e, t, i) {
    _classCallCheck(this, PDFWorkerStreamRangeReader);
    this._msgHandler = i;
    this.onProgress = null;
    var a = this._msgHandler.sendWithStream("GetRangeReader", {
      begin: e,
      end: t
    });
    this._reader = a.getReader();
  }
  return _createClass(PDFWorkerStreamRangeReader, [{
    key: "isStreamingSupported",
    get: function get() {
      return !1;
    }
  }, {
    key: "read",
    value: function () {
      var _read2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee97() {
        var _yield$this$_reader$r2, e, t;
        return _regeneratorRuntime().wrap(function _callee97$(_context109) {
          while (1) switch (_context109.prev = _context109.next) {
            case 0:
              _context109.next = 2;
              return this._reader.read();
            case 2:
              _yield$this$_reader$r2 = _context109.sent;
              e = _yield$this$_reader$r2.value;
              t = _yield$this$_reader$r2.done;
              return _context109.abrupt("return", t ? {
                value: void 0,
                done: !0
              } : {
                value: e.buffer,
                done: !1
              });
            case 6:
            case "end":
              return _context109.stop();
          }
        }, _callee97, this);
      }));
      function read() {
        return _read2.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(e) {
      this._reader.cancel(e);
    }
  }]);
}();
var WorkerTask = /*#__PURE__*/function () {
  function WorkerTask(e) {
    _classCallCheck(this, WorkerTask);
    this.name = e;
    this.terminated = !1;
    this._capability = Promise.withResolvers();
  }
  return _createClass(WorkerTask, [{
    key: "finished",
    get: function get() {
      return this._capability.promise;
    }
  }, {
    key: "finish",
    value: function finish() {
      this._capability.resolve();
    }
  }, {
    key: "terminate",
    value: function terminate() {
      this.terminated = !0;
    }
  }, {
    key: "ensureNotTerminated",
    value: function ensureNotTerminated() {
      if (this.terminated) throw new Error("Worker task was terminated");
    }
  }]);
}();
var _WorkerMessageHandler = /*#__PURE__*/function () {
  function _WorkerMessageHandler() {
    _classCallCheck(this, _WorkerMessageHandler);
  }
  return _createClass(_WorkerMessageHandler, null, [{
    key: "setup",
    value: function setup(e, t) {
      var i = !1;
      e.on("test", function (t) {
        if (!i) {
          i = !0;
          e.send("test", t instanceof Uint8Array);
        }
      });
      e.on("configure", function (e) {
        !function setVerbosityLevel(e) {
          Number.isInteger(e) && (nt = e);
        }(e.verbosity);
      });
      e.on("GetDocRequest", function (e) {
        return _WorkerMessageHandler.createDocumentHandler(e, t);
      });
    }
  }, {
    key: "createDocumentHandler",
    value: function createDocumentHandler(e, t) {
      var i,
        a = !1,
        s = null;
      var r = new Set(),
        n = getVerbosityLevel(),
        _e653 = e,
        g = _e653.docId,
        o = _e653.apiVersion,
        c = "4.8.69";
      if (o !== c) throw new Error("The API version \"".concat(o, "\" does not match the Worker version \"").concat(c, "\"."));
      var C = [];
      for (var _e654 in []) C.push(_e654);
      if (C.length) throw new Error("The `Array.prototype` contains unexpected enumerable properties: " + C.join(", ") + "; thus breaking e.g. `for...in` iteration of `Array`s.");
      var h = g + "_worker";
      var l = new MessageHandler(h, g, t);
      function ensureNotTerminated() {
        if (a) throw new Error("Worker was terminated");
      }
      function startWorkerTask(e) {
        r.add(e);
      }
      function finishWorkerTask(e) {
        e.finish();
        r.delete(e);
      }
      function loadDocument(_x205) {
        return _loadDocument.apply(this, arguments);
      }
      function _loadDocument() {
        _loadDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee103(e) {
          var t, _e663, _yield$Promise$all11, _yield$Promise$all12, a, s;
          return _regeneratorRuntime().wrap(function _callee103$(_context115) {
            while (1) switch (_context115.prev = _context115.next) {
              case 0:
                _context115.next = 2;
                return i.ensureDoc("checkHeader");
              case 2:
                _context115.next = 4;
                return i.ensureDoc("parseStartXRef");
              case 4:
                _context115.next = 6;
                return i.ensureDoc("parse", [e]);
              case 6:
                _context115.next = 8;
                return i.ensureDoc("checkFirstPage", [e]);
              case 8:
                _context115.next = 10;
                return i.ensureDoc("checkLastPage", [e]);
              case 10:
                _context115.next = 12;
                return i.ensureDoc("isPureXfa");
              case 12:
                t = _context115.sent;
                if (!t) {
                  _context115.next = 18;
                  break;
                }
                _e663 = new WorkerTask("loadXfaFonts");
                startWorkerTask(_e663);
                _context115.next = 18;
                return Promise.all([i.loadXfaFonts(l, _e663).catch(function (e) {}).then(function () {
                  return finishWorkerTask(_e663);
                }), i.loadXfaImages()]);
              case 18:
                _context115.next = 20;
                return Promise.all([i.ensureDoc("numPages"), i.ensureDoc("fingerprints")]);
              case 20:
                _yield$Promise$all11 = _context115.sent;
                _yield$Promise$all12 = _slicedToArray(_yield$Promise$all11, 2);
                a = _yield$Promise$all12[0];
                s = _yield$Promise$all12[1];
                _context115.t0 = a;
                _context115.t1 = s;
                if (!t) {
                  _context115.next = 32;
                  break;
                }
                _context115.next = 29;
                return i.ensureDoc("htmlForXfa");
              case 29:
                _context115.t2 = _context115.sent;
                _context115.next = 33;
                break;
              case 32:
                _context115.t2 = null;
              case 33:
                _context115.t3 = _context115.t2;
                return _context115.abrupt("return", {
                  numPages: _context115.t0,
                  fingerprints: _context115.t1,
                  htmlForXfa: _context115.t3
                });
              case 35:
              case "end":
                return _context115.stop();
            }
          }, _callee103);
        }));
        return _loadDocument.apply(this, arguments);
      }
      function setupDoc(e) {
        function onSuccess(e) {
          ensureNotTerminated();
          l.send("GetDoc", {
            pdfInfo: e
          });
        }
        function onFailure(e) {
          ensureNotTerminated();
          if (e instanceof PasswordException) {
            var _t488 = new WorkerTask("PasswordException: response ".concat(e.code));
            startWorkerTask(_t488);
            l.sendWithPromise("PasswordRequest", e).then(function (_ref218) {
              var e = _ref218.password;
              finishWorkerTask(_t488);
              i.updatePassword(e);
              pdfManagerReady();
            }).catch(function () {
              finishWorkerTask(_t488);
              l.send("DocException", e);
            });
          } else e instanceof InvalidPDFException || e instanceof MissingPDFException || e instanceof UnexpectedResponseException || e instanceof UnknownErrorException ? l.send("DocException", e) : l.send("DocException", new UnknownErrorException(e.message, e.toString()));
        }
        function pdfManagerReady() {
          ensureNotTerminated();
          loadDocument(!1).then(onSuccess, function (e) {
            ensureNotTerminated();
            e instanceof XRefParseException ? i.requestLoadedStream().then(function () {
              ensureNotTerminated();
              loadDocument(!0).then(onSuccess, onFailure);
            }) : onFailure(e);
          });
        }
        ensureNotTerminated();
        (function getPdfManager(_ref219) {
          var e = _ref219.data,
            t = _ref219.password,
            i = _ref219.disableAutoFetch,
            a = _ref219.rangeChunkSize,
            r = _ref219.length,
            n = _ref219.docBaseUrl,
            o = _ref219.enableXfa,
            c = _ref219.evaluatorOptions;
          var C = {
              source: null,
              disableAutoFetch: i,
              docBaseUrl: n,
              docId: g,
              enableXfa: o,
              evaluatorOptions: c,
              handler: l,
              length: r,
              password: t,
              rangeChunkSize: a
            },
            h = Promise.withResolvers();
          var Q;
          if (e) {
            try {
              C.source = e;
              Q = new LocalPdfManager(C);
              h.resolve(Q);
            } catch (e) {
              h.reject(e);
            }
            return h.promise;
          }
          var E,
            u = [],
            d = 0;
          try {
            E = new PDFWorkerStream(l);
          } catch (e) {
            h.reject(e);
            return h.promise;
          }
          var f = E.getFullReader();
          f.headersReady.then(function () {
            if (f.isRangeSupported) {
              C.source = E;
              C.length = f.contentLength;
              C.disableAutoFetch || (C.disableAutoFetch = f.isStreamingSupported);
              Q = new NetworkPdfManager(C);
              for (var _i431 = 0, _u13 = u; _i431 < _u13.length; _i431++) {
                var _e655 = _u13[_i431];
                Q.sendProgressiveData(_e655);
              }
              u = [];
              h.resolve(Q);
              s = null;
            }
          }).catch(function (e) {
            h.reject(e);
            s = null;
          });
          new Promise(function (e, t) {
            var _readChunk2 = function readChunk(_ref220) {
              var e = _ref220.value,
                i = _ref220.done;
              try {
                ensureNotTerminated();
                if (i) {
                  if (!Q) {
                    var _e656 = arrayBuffersToBytes(u);
                    u = [];
                    r && _e656.length !== r && warn("reported HTTP length is different from actual");
                    C.source = _e656;
                    Q = new LocalPdfManager(C);
                    h.resolve(Q);
                  }
                  s = null;
                  return;
                }
                d += e.byteLength;
                f.isStreamingSupported || l.send("DocProgress", {
                  loaded: d,
                  total: Math.max(d, f.contentLength || 0)
                });
                Q ? Q.sendProgressiveData(e) : u.push(e);
                f.read().then(_readChunk2, t);
              } catch (e) {
                t(e);
              }
            };
            f.read().then(_readChunk2, t);
          }).catch(function (e) {
            h.reject(e);
            s = null;
          });
          s = function s(e) {
            E.cancelAllRequests(e);
          };
          return h.promise;
        })(e).then(function (e) {
          if (a) {
            e.terminate(new AbortException("Worker was terminated."));
            throw new Error("Worker was terminated");
          }
          i = e;
          i.requestLoadedStream(!0).then(function (e) {
            l.send("DataLoaded", {
              length: e.bytes.byteLength
            });
          });
        }).then(pdfManagerReady, onFailure);
      }
      l.on("GetPage", function (e) {
        return i.getPage(e.pageIndex).then(function (e) {
          return Promise.all([i.ensure(e, "rotate"), i.ensure(e, "ref"), i.ensure(e, "userUnit"), i.ensure(e, "view")]).then(function (_ref221) {
            var _t$toString;
            var _ref222 = _slicedToArray(_ref221, 4),
              e = _ref222[0],
              t = _ref222[1],
              i = _ref222[2],
              a = _ref222[3];
            return {
              rotate: e,
              ref: t,
              refStr: (_t$toString = t === null || t === void 0 ? void 0 : t.toString()) !== null && _t$toString !== void 0 ? _t$toString : null,
              userUnit: i,
              view: a
            };
          });
        });
      });
      l.on("GetPageIndex", function (e) {
        var t = Ref.get(e.num, e.gen);
        return i.ensureCatalog("getPageIndex", [t]);
      });
      l.on("GetDestinations", function (e) {
        return i.ensureCatalog("destinations");
      });
      l.on("GetDestination", function (e) {
        return i.ensureCatalog("getDestination", [e.id]);
      });
      l.on("GetPageLabels", function (e) {
        return i.ensureCatalog("pageLabels");
      });
      l.on("GetPageLayout", function (e) {
        return i.ensureCatalog("pageLayout");
      });
      l.on("GetPageMode", function (e) {
        return i.ensureCatalog("pageMode");
      });
      l.on("GetViewerPreferences", function (e) {
        return i.ensureCatalog("viewerPreferences");
      });
      l.on("GetOpenAction", function (e) {
        return i.ensureCatalog("openAction");
      });
      l.on("GetAttachments", function (e) {
        return i.ensureCatalog("attachments");
      });
      l.on("GetDocJSActions", function (e) {
        return i.ensureCatalog("jsActions");
      });
      l.on("GetPageJSActions", function (_ref223) {
        var e = _ref223.pageIndex;
        return i.getPage(e).then(function (e) {
          return i.ensure(e, "jsActions");
        });
      });
      l.on("GetOutline", function (e) {
        return i.ensureCatalog("documentOutline");
      });
      l.on("GetOptionalContentConfig", function (e) {
        return i.ensureCatalog("optionalContentConfig");
      });
      l.on("GetPermissions", function (e) {
        return i.ensureCatalog("permissions");
      });
      l.on("GetMetadata", function (e) {
        return Promise.all([i.ensureDoc("documentInfo"), i.ensureCatalog("metadata")]);
      });
      l.on("GetMarkInfo", function (e) {
        return i.ensureCatalog("markInfo");
      });
      l.on("GetData", function (e) {
        return i.requestLoadedStream().then(function (e) {
          return e.bytes;
        });
      });
      l.on("GetAnnotations", function (_ref224) {
        var e = _ref224.pageIndex,
          t = _ref224.intent;
        return i.getPage(e).then(function (i) {
          var a = new WorkerTask("GetAnnotations: page ".concat(e));
          startWorkerTask(a);
          return i.getAnnotationsData(l, a, t).then(function (e) {
            finishWorkerTask(a);
            return e;
          }, function (e) {
            finishWorkerTask(a);
            throw e;
          });
        });
      });
      l.on("GetFieldObjects", function (e) {
        return i.ensureDoc("fieldObjects").then(function (e) {
          return (e === null || e === void 0 ? void 0 : e.allFields) || null;
        });
      });
      l.on("HasJSActions", function (e) {
        return i.ensureDoc("hasJSActions");
      });
      l.on("GetCalculationOrderIds", function (e) {
        return i.ensureDoc("calculationOrderIds");
      });
      l.on("SaveDocument", /*#__PURE__*/function () {
        var _ref226 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee102(_ref225) {
          var e, t, a, s, r, n, g, _yield$Promise$all9, _yield$Promise$all10, o, c, C, h, Q, E, u, d, f, _e657, _t489, _iterator232, _step232, _loop7, _ref228, _loop8, _e658, p, m, y, w, D, b, F, _e659, _t490, S, _Q$lastXRefStreamPos, _e660, _t491;
          return _regeneratorRuntime().wrap(function _callee102$(_context114) {
            while (1) switch (_context114.prev = _context114.next) {
              case 0:
                e = _ref225.isPureXfa, t = _ref225.numPages, a = _ref225.annotationStorage, s = _ref225.filename;
                r = [i.requestLoadedStream(), i.ensureCatalog("acroForm"), i.ensureCatalog("acroFormRef"), i.ensureDoc("startXRef"), i.ensureDoc("xref"), i.ensureDoc("linearization"), i.ensureCatalog("structTreeRoot")];
                n = [];
                g = e ? null : getNewAnnotationsMap(a);
                _context114.next = 6;
                return Promise.all(r);
              case 6:
                _yield$Promise$all9 = _context114.sent;
                _yield$Promise$all10 = _slicedToArray(_yield$Promise$all9, 7);
                o = _yield$Promise$all10[0];
                c = _yield$Promise$all10[1];
                C = _yield$Promise$all10[2];
                h = _yield$Promise$all10[3];
                Q = _yield$Promise$all10[4];
                E = _yield$Promise$all10[5];
                u = _yield$Promise$all10[6];
                d = Q.trailer.getRaw("Root") || null;
                if (!g) {
                  _context114.next = 48;
                  break;
                }
                if (!u) {
                  _context114.next = 25;
                  break;
                }
                _context114.next = 20;
                return u.canUpdateStructTree({
                  pdfManager: i,
                  xref: Q,
                  newAnnotationsByPage: g
                });
              case 20:
                _context114.t0 = _context114.sent;
                if (!_context114.t0) {
                  _context114.next = 23;
                  break;
                }
                f = u;
              case 23:
                _context114.next = 30;
                break;
              case 25:
                _context114.next = 27;
                return StructTreeRoot.canCreateStructureTree({
                  catalogRef: d,
                  pdfManager: i,
                  newAnnotationsByPage: g
                });
              case 27:
                _context114.t1 = _context114.sent;
                if (!_context114.t1) {
                  _context114.next = 30;
                  break;
                }
                f = null;
              case 30:
                _e657 = AnnotationFactory.generateImages(a.values(), Q, i.evaluatorOptions.isOffscreenCanvasSupported), _t489 = void 0 === f ? n : [];
                _iterator232 = _createForOfIteratorHelper(g);
                _context114.prev = 32;
                _loop7 = /*#__PURE__*/_regeneratorRuntime().mark(function _callee100() {
                  var _ref227, a, s;
                  return _regeneratorRuntime().wrap(function _callee100$(_context112) {
                    while (1) switch (_context112.prev = _context112.next) {
                      case 0:
                        _ref227 = _step232.value;
                        _ref228 = _slicedToArray(_ref227, 2);
                        a = _ref228[0];
                        s = _ref228[1];
                        _t489.push(i.getPage(a).then(function (t) {
                          var i = new WorkerTask("Save (editor): page ".concat(a));
                          return t.saveNewAnnotations(l, i, s, _e657).finally(function () {
                            finishWorkerTask(i);
                          });
                        }));
                      case 5:
                      case "end":
                        return _context112.stop();
                    }
                  }, _callee100);
                });
                _iterator232.s();
              case 35:
                if ((_step232 = _iterator232.n()).done) {
                  _context114.next = 39;
                  break;
                }
                return _context114.delegateYield(_loop7(), "t2", 37);
              case 37:
                _context114.next = 35;
                break;
              case 39:
                _context114.next = 44;
                break;
              case 41:
                _context114.prev = 41;
                _context114.t3 = _context114["catch"](32);
                _iterator232.e(_context114.t3);
              case 44:
                _context114.prev = 44;
                _iterator232.f();
                return _context114.finish(44);
              case 47:
                null === f ? n.push(Promise.all(_t489).then(/*#__PURE__*/function () {
                  var _ref229 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee98(e) {
                    return _regeneratorRuntime().wrap(function _callee98$(_context110) {
                      while (1) switch (_context110.prev = _context110.next) {
                        case 0:
                          _context110.next = 2;
                          return StructTreeRoot.createStructureTree({
                            newAnnotationsByPage: g,
                            xref: Q,
                            catalogRef: d,
                            pdfManager: i,
                            newRefs: e
                          });
                        case 2:
                          return _context110.abrupt("return", e);
                        case 3:
                        case "end":
                          return _context110.stop();
                      }
                    }, _callee98);
                  }));
                  return function (_x207) {
                    return _ref229.apply(this, arguments);
                  };
                }())) : f && n.push(Promise.all(_t489).then(/*#__PURE__*/function () {
                  var _ref230 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee99(e) {
                    return _regeneratorRuntime().wrap(function _callee99$(_context111) {
                      while (1) switch (_context111.prev = _context111.next) {
                        case 0:
                          _context111.next = 2;
                          return f.updateStructureTree({
                            newAnnotationsByPage: g,
                            pdfManager: i,
                            newRefs: e
                          });
                        case 2:
                          return _context111.abrupt("return", e);
                        case 3:
                        case "end":
                          return _context111.stop();
                      }
                    }, _callee99);
                  }));
                  return function (_x208) {
                    return _ref230.apply(this, arguments);
                  };
                }()));
              case 48:
                if (!e) {
                  _context114.next = 52;
                  break;
                }
                n.push(i.serializeXfaData(a));
                _context114.next = 59;
                break;
              case 52:
                _loop8 = /*#__PURE__*/_regeneratorRuntime().mark(function _callee101(_e658) {
                  return _regeneratorRuntime().wrap(function _callee101$(_context113) {
                    while (1) switch (_context113.prev = _context113.next) {
                      case 0:
                        n.push(i.getPage(_e658).then(function (t) {
                          var i = new WorkerTask("Save: page ".concat(_e658));
                          return t.save(l, i, a).finally(function () {
                            finishWorkerTask(i);
                          });
                        }));
                      case 1:
                      case "end":
                        return _context113.stop();
                    }
                  }, _callee101);
                });
                _e658 = 0;
              case 54:
                if (!(_e658 < t)) {
                  _context114.next = 59;
                  break;
                }
                return _context114.delegateYield(_loop8(_e658), "t4", 56);
              case 56:
                _e658++;
                _context114.next = 54;
                break;
              case 59:
                _context114.next = 61;
                return Promise.all(n);
              case 61:
                p = _context114.sent;
                m = [], y = null;
                if (!e) {
                  _context114.next = 69;
                  break;
                }
                y = p[0];
                if (y) {
                  _context114.next = 67;
                  break;
                }
                return _context114.abrupt("return", o.bytes);
              case 67:
                _context114.next = 72;
                break;
              case 69:
                m = p.flat(2);
                if (!(0 === m.length)) {
                  _context114.next = 72;
                  break;
                }
                return _context114.abrupt("return", o.bytes);
              case 72:
                w = C && c instanceof Dict && m.some(function (e) {
                  return e.needAppearances;
                }), D = c instanceof Dict && c.get("XFA") || null;
                b = null, F = !1;
                if (Array.isArray(D)) {
                  for (_e659 = 0, _t490 = D.length; _e659 < _t490; _e659 += 2) if ("datasets" === D[_e659]) {
                    b = D[_e659 + 1];
                    F = !0;
                  }
                  null === b && (b = Q.getNewTemporaryRef());
                } else D && warn("Unsupported XFA type.");
                S = Object.create(null);
                if (Q.trailer) {
                  _e660 = Object.create(null), _t491 = Q.trailer.get("Info") || null;
                  _t491 instanceof Dict && _t491.forEach(function (t, i) {
                    "string" == typeof i && (_e660[t] = stringToPDFString(i));
                  });
                  S = {
                    rootRef: d,
                    encryptRef: Q.trailer.getRaw("Encrypt") || null,
                    newRef: Q.getNewTemporaryRef(),
                    infoRef: Q.trailer.getRaw("Info") || null,
                    info: _e660,
                    fileIds: Q.trailer.get("ID") || null,
                    startXRef: E ? h : (_Q$lastXRefStreamPos = Q.lastXRefStreamPos) !== null && _Q$lastXRefStreamPos !== void 0 ? _Q$lastXRefStreamPos : h,
                    filename: s
                  };
                }
                return _context114.abrupt("return", incrementalUpdate({
                  originalData: o.bytes,
                  xrefInfo: S,
                  newRefs: m,
                  xref: Q,
                  hasXfa: !!D,
                  xfaDatasetsRef: b,
                  hasXfaDatasetsEntry: F,
                  needAppearances: w,
                  acroFormRef: C,
                  acroForm: c,
                  xfaData: y,
                  useXrefStream: isDict(Q.topDict, "XRef")
                }).finally(function () {
                  Q.resetNewTemporaryRef();
                }));
              case 78:
              case "end":
                return _context114.stop();
            }
          }, _callee102, null, [[32, 41, 44, 47]]);
        }));
        return function (_x206) {
          return _ref226.apply(this, arguments);
        };
      }());
      l.on("GetOperatorList", function (e, t) {
        var a = e.pageIndex;
        i.getPage(a).then(function (i) {
          var s = new WorkerTask("GetOperatorList: page ".concat(a));
          startWorkerTask(s);
          var r = n >= mA.INFOS ? Date.now() : 0;
          i.getOperatorList({
            handler: l,
            sink: t,
            task: s,
            intent: e.intent,
            cacheKey: e.cacheKey,
            annotationStorage: e.annotationStorage,
            modifiedIds: e.modifiedIds
          }).then(function (e) {
            finishWorkerTask(s);
            r && info("page=".concat(a + 1, " - getOperatorList: time=").concat(Date.now() - r, "ms, len=").concat(e.length));
            t.close();
          }, function (e) {
            finishWorkerTask(s);
            s.terminated || t.error(e);
          });
        });
      });
      l.on("GetTextContent", function (e, t) {
        var a = e.pageIndex,
          s = e.includeMarkedContent,
          r = e.disableNormalization;
        i.getPage(a).then(function (e) {
          var i = new WorkerTask("GetTextContent: page " + a);
          startWorkerTask(i);
          var g = n >= mA.INFOS ? Date.now() : 0;
          e.extractTextContent({
            handler: l,
            task: i,
            sink: t,
            includeMarkedContent: s,
            disableNormalization: r
          }).then(function () {
            finishWorkerTask(i);
            g && info("page=".concat(a + 1, " - getTextContent: time=") + (Date.now() - g) + "ms");
            t.close();
          }, function (e) {
            finishWorkerTask(i);
            i.terminated || t.error(e);
          });
        });
      });
      l.on("GetStructTree", function (e) {
        return i.getPage(e.pageIndex).then(function (e) {
          return i.ensure(e, "getStructTree");
        });
      });
      l.on("FontFallback", function (e) {
        return i.fontFallback(e.id, l);
      });
      l.on("Cleanup", function (e) {
        return i.cleanup(!0);
      });
      l.on("Terminate", function (e) {
        var _s220;
        a = !0;
        var t = [];
        if (i) {
          i.terminate(new AbortException("Worker was terminated."));
          var _e661 = i.cleanup();
          t.push(_e661);
          i = null;
        } else clearGlobalCaches();
        (_s220 = s) === null || _s220 === void 0 || _s220(new AbortException("Worker was terminated."));
        var _iterator233 = _createForOfIteratorHelper(r),
          _step233;
        try {
          for (_iterator233.s(); !(_step233 = _iterator233.n()).done;) {
            var _e662 = _step233.value;
            t.push(_e662.finished);
            _e662.terminate();
          }
        } catch (err) {
          _iterator233.e(err);
        } finally {
          _iterator233.f();
        }
        return Promise.all(t).then(function () {
          l.destroy();
          l = null;
        });
      });
      l.on("Ready", function (t) {
        setupDoc(e);
        e = null;
      });
      return h;
    }
  }, {
    key: "initializeFromPort",
    value: function initializeFromPort(e) {
      var t = new MessageHandler("worker", "main", e);
      _WorkerMessageHandler.setup(t, e);
      t.send("ready", null);
    }
  }]);
}();
"undefined" == typeof window && !t && "undefined" != typeof self && function isMessagePort(e) {
  return "function" == typeof e.postMessage && "onmessage" in e;
}(self) && _WorkerMessageHandler.initializeFromPort(self);
var mg = __webpack_exports__.WorkerMessageHandler;
export { mg as WorkerMessageHandler };